//! moment.js locale configuration
/* eslint-disable */
;(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined'
		&& typeof require === 'function' ? factory(require('../moment')) :
	typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	factory(global.moment);
 }(this, (function (moment) { 'use strict';


	function plural(word, num) {
		var forms = word.split('_');
		return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
		var format = {
			'ss': withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
			'mm': withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
			'hh': withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
			'dd': 'день_дні_днів',
			'MM': 'місяць_місяці_місяців',
			'yy': 'рік_роки_років'
		};
		if (key === 'm') {
			return withoutSuffix ? 'хвилина' : 'хвилину';
		}
		else if (key === 'h') {
			return withoutSuffix ? 'година' : 'годину';
		}
		else {
			return number + ' ' + plural(format[key], +number);
		}
	}
	function weekdaysCaseReplace(m, format) {
		var weekdays = {
			'nominative': 'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split('_'),
			'accusative': 'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split('_'),
			'genitive': 'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split('_')
		};

		if (!m) {
			return weekdays['nominative'];
		}

		var nounCase = (/(\[[ВвУу]\]) ?dddd/).test(format) ?
			'accusative' :
			((/\[?(?:минулої|наступної)? ?\] ?dddd/).test(format) ?
				'genitive' :
				'nominative');
		return weekdays[nounCase][m.day()];
	}
	function processHoursFunction(str) {
		return function () {
			return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
		};
	}

	var uk = moment.defineLocale('uk', {
		months : {
			'format': 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split('_'),
			'standalone': 'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split('_')
		},
		monthsShort : 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split('_'),
		weekdays : weekdaysCaseReplace,
		weekdaysShort : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
		weekdaysMin : 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
		longDateFormat : {
			LT : 'HH:mm',
			LTS : 'HH:mm:ss',
			L : 'DD.MM.YYYY',
			LL : 'D MMMM YYYY р.',
			LLL : 'D MMMM YYYY р., HH:mm',
			LLLL : 'dddd, D MMMM YYYY р., HH:mm'
		},
		calendar : {
			sameDay: processHoursFunction('[Сьогодні '),
			nextDay: processHoursFunction('[Завтра '),
			lastDay: processHoursFunction('[Вчора '),
			nextWeek: processHoursFunction('[У] dddd ['),
			lastWeek: function () {
				switch (this.day()) {
					case 0:
					case 3:
					case 5:
					case 6:
						return processHoursFunction('[Минулої] dddd [').call(this);
					case 1:
					case 2:
					case 4:
						return processHoursFunction('[Минулого] dddd [').call(this);
				}
			},
			sameElse: 'L'
		},
		relativeTime : {
			future : 'за %s',
			past : '%s тому',
			s : 'декілька секунд',
			ss : relativeTimeWithPlural,
			m : relativeTimeWithPlural,
			mm : relativeTimeWithPlural,
			h : 'годину',
			hh : relativeTimeWithPlural,
			d : 'день',
			dd : relativeTimeWithPlural,
			M : 'місяць',
			MM : relativeTimeWithPlural,
			y : 'рік',
			yy : relativeTimeWithPlural
		},
		// M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
		meridiemParse: /ночі|ранку|дня|вечора/,
		isPM: function (input) {
			return /^(дня|вечора)$/.test(input);
		},
		meridiem : function (hour, minute, isLower) {
			if (hour < 4) {
				return 'ночі';
			} else if (hour < 12) {
				return 'ранку';
			} else if (hour < 17) {
				return 'дня';
			} else {
				return 'вечора';
			}
		},
		dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
		ordinal: function (number, period) {
			switch (period) {
				case 'M':
				case 'd':
				case 'DDD':
				case 'w':
				case 'W':
					return number + '-й';
				case 'D':
					return number + '-го';
				default:
					return number;
			}
		},
		week : {
			dow : 1, // Monday is the first day of the week.
			doy : 7  // The week that contains Jan 1st is the first week of the year.
		}
	});

	return uk;

 })));
/* eslint-enable */
//! moment.js locale configuration
/* eslint-disable */
;(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
  && typeof require === 'function' ? factory(require('../moment')) :
    typeof define === 'function' && define.amd ? define(['../moment'], factory) :
      factory(global.moment);
}(this, (function (moment) { 'use strict';

  var zh_tw = moment.defineLocale('tw', {
    months : '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split('_'),
    monthsShort : '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
    weekdays : '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
    weekdaysShort : '週日_週一_週二_週三_週四_週五_週六'.split('_'),
    weekdaysMin : '日_一_二_三_四_五_六'.split('_'),
    longDateFormat : {
      LT : 'HH:mm',
      LTS : 'HH:mm:ss',
      L : 'YYYY/MM/DD',
      LL : 'YYYY年MM月DD日',
      LLL : 'YYYY年MM月DD日 HH:mm',
      LLLL : 'YYYY年MM月DD日 dddd HH:mm'
    },
    meridiemParse: /早上|上午|中午|下午|晚上/,
    meridiemHour: function (hour, meridiem) {
      if (hour === 12) {
        hour = 0;
      }
      if (meridiem === '早上' || meridiem === '上午') {
        return hour;
      } if (meridiem === '中午') {
        return hour >= 11 ? hour : hour + 12;
      } if (meridiem === '下午' || meridiem === '晚上') {
        return hour + 12;
      }
      return hour;
    },
    meridiem : function (hour, minute, isLower) {
      var hm = hour * 100 + minute;
      if (hm < 900) {
        return '早上';
      } else if (hm < 1130) {
        return '上午';
      } else if (hm < 1230) {
        return '中午';
      } else if (hm < 1800) {
        return '下午';
      } else {
        return '晚上';
      }
    },
    calendar : {
      sameDay : '[今天] LT',
      nextDay : '[明天] LT',
      nextWeek : '[下]dddd LT',
      lastDay : '[昨天] LT',
      lastWeek : '[上]dddd LT',
      sameElse : 'L'
    },
    relativeTime : {
      future : '%s內',
      past : '%s前',
      s : '幾秒',
      ss : '%d秒',
      m : '1分鐘',
      mm : '%d分鐘',
      h : '1小時',
      hh : '%d小時',
      d : '1天',
      dd : '%d天',
      M : '1個月',
      MM : '%d個月',
      y : '1年',
      yy : '%d年'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
    ordinal : function (number, period) {
      switch (period) {
        case 'd':
        case 'D':
        case 'DDD':
          return number + '日';
        case 'M':
          return number + '月';
        case 'w':
        case 'W':
          return number + '週';
        default:
          return number;
      }
    },
    week : {
      dow : 0,  // Sunday is the first day of the week.
      doy : 6   // The week that contains Jan 1st is the first week of the year.
    }
  });
  return zh_tw;
})));
/* eslint-enable */

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus
/* eslint-disable */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
  && typeof require === 'function' ? factory(require('../moment')) :
    typeof define === 'function' && define.amd ? define(['../moment'], factory) :
      factory(global.moment)
}(this, (function (moment) { 'use strict';

  //! moment.js locale configuration

  var sv = moment.defineLocale('sv', {
    months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
      '_'
    ),
    monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
    weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
    weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
    weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
    longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'YYYY-MM-DD',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY [kl.] HH:mm',
      LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
      lll: 'D MMM YYYY HH:mm',
      llll: 'ddd D MMM YYYY HH:mm',
    },
    calendar: {
      sameDay: '[Idag] LT',
      nextDay: '[Imorgon] LT',
      lastDay: '[Igår] LT',
      nextWeek: '[På] dddd LT',
      lastWeek: '[I] dddd[s] LT',
      sameElse: 'L',
    },
    relativeTime: {
      future: 'om %s',
      past: 'för %s sedan',
      s: 'några sekunder',
      ss: '%d sekunder',
      m: 'en minut',
      mm: '%d minuter',
      h: 'en timme',
      hh: '%d timmar',
      d: 'en dag',
      dd: '%d dagar',
      M: 'en månad',
      MM: '%d månader',
      y: 'ett år',
      yy: '%d år',
    },
    dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
    ordinal: function (number) {
      var b = number % 10,
        output =
          ~~((number % 100) / 10) === 1
            ? ':e'
            : b === 1
            ? ':a'
            : b === 2
              ? ':a'
              : b === 3
                ? ':e'
                : ':e';
      return number + output;
    },
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  });

  return sv;
  /* eslint-enable */
})));

//! moment.js locale configuration
//! locale : Serbian-latin (sr)
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
/* eslint-disable */

(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    var translator = {
        words: { //Different grammatical cases
            m: ['jedan minut', 'jedne minute'],
            mm: ['minut', 'minute', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mesec', 'meseca', 'meseci'],
            yy: ['godina', 'godine', 'godina']
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1 ? wordKey[0] : (number >= 2 && number <= 4 ? wordKey[1] : wordKey[2]);
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return number + ' ' + translator.correctGrammaticalCase(number, wordKey);
            }
        }
    };

    var sr = moment.defineLocale('sr', {
        months: ['januar', 'februar', 'mart', 'april', 'maj', 'jun', 'jul', 'avgust', 'septembar', 'oktobar', 'novembar', 'decembar'],
        monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun', 'jul', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
        weekdays: ['nedelja', 'ponedeljak', 'utorak', 'sreda', 'četvrtak', 'petak', 'subota'],
        weekdaysShort: ['ned.', 'pon.', 'uto.', 'sre.', 'čet.', 'pet.', 'sub.'],
        weekdaysMin: ['ne', 'po', 'ut', 'sr', 'če', 'pe', 'su'],
        longDateFormat: {
            LT: 'H:mm',
            LTS : 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm'
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                case 0:
                    return '[u] [nedelju] [u] LT';
                case 3:
                    return '[u] [sredu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[juče u] LT',
            lastWeek : function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT'
                ];
                return lastWeekDays[this.day()];
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'pre %s',
            s      : 'nekoliko sekundi',
            m      : translator.translate,
            mm     : translator.translate,
            h      : translator.translate,
            hh     : translator.translate,
            d      : 'dan',
            dd     : translator.translate,
            M      : 'mesec',
            MM     : translator.translate,
            y      : 'godinu',
            yy     : translator.translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return sr;
    /* eslint-enable */
}));
//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek
/* eslint-disable */
;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
        && typeof require === 'function' ? factory(require('../moment')) :
    typeof define === 'function' && define.amd ? define(['../moment'], factory) :
    factory(global.moment)
 }(this, (function (moment) { 'use strict';
 
 
 function processRelativeTime(number, withoutSuffix, key, isFuture) {
     var result = number + ' ';
     switch (key) {
         case 's':
             return withoutSuffix || isFuture ? 'nekaj sekund' : 'nekaj sekundami';
         case 'm':
             return withoutSuffix ? 'ena minuta' : 'eno minuto';
         case 'mm':
             if (number === 1) {
                 result += withoutSuffix ? 'minuta' : 'minuto';
             } else if (number === 2) {
                 result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
             } else if (number < 5) {
                 result += withoutSuffix || isFuture ? 'minute' : 'minutami';
             } else {
                 result += withoutSuffix || isFuture ? 'minut' : 'minutami';
             }
             return result;
         case 'h':
             return withoutSuffix ? 'ena ura' : 'eno uro';
         case 'hh':
             if (number === 1) {
                 result += withoutSuffix ? 'ura' : 'uro';
             } else if (number === 2) {
                 result += withoutSuffix || isFuture ? 'uri' : 'urama';
             } else if (number < 5) {
                 result += withoutSuffix || isFuture ? 'ure' : 'urami';
             } else {
                 result += withoutSuffix || isFuture ? 'ur' : 'urami';
             }
             return result;
         case 'd':
             return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
         case 'dd':
             if (number === 1) {
                 result += withoutSuffix || isFuture ? 'dan' : 'dnem';
             } else if (number === 2) {
                 result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
             } else {
                 result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
             }
             return result;
         case 'M':
             return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
         case 'MM':
             if (number === 1) {
                 result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
             } else if (number === 2) {
                 result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
             } else if (number < 5) {
                 result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
             } else {
                 result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
             }
             return result;
         case 'y':
             return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
         case 'yy':
             if (number === 1) {
                 result += withoutSuffix || isFuture ? 'leto' : 'letom';
             } else if (number === 2) {
                 result += withoutSuffix || isFuture ? 'leti' : 'letoma';
             } else if (number < 5) {
                 result += withoutSuffix || isFuture ? 'leta' : 'leti';
             } else {
                 result += withoutSuffix || isFuture ? 'let' : 'leti';
             }
             return result;
     }
 }
 
 var sl = moment.defineLocale('sl', {
     months : 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split('_'),
     monthsShort : 'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split('_'),
     monthsParseExact: true,
     weekdays : 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
     weekdaysShort : 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
     weekdaysMin : 'ne_po_to_sr_če_pe_so'.split('_'),
     weekdaysParseExact : true,
     longDateFormat : {
         LT : 'H:mm',
         LTS : 'H:mm:ss',
         L : 'DD.MM.YYYY',
         LL : 'D. MMMM YYYY',
         LLL : 'D. MMMM YYYY H:mm',
         LLLL : 'dddd, D. MMMM YYYY H:mm'
     },
     calendar : {
         sameDay  : '[danes ob] LT',
         nextDay  : '[jutri ob] LT',
 
         nextWeek : function () {
             switch (this.day()) {
                 case 0:
                     return '[v] [nedeljo] [ob] LT';
                 case 3:
                     return '[v] [sredo] [ob] LT';
                 case 6:
                     return '[v] [soboto] [ob] LT';
                 case 1:
                 case 2:
                 case 4:
                 case 5:
                     return '[v] dddd [ob] LT';
             }
         },
         lastDay  : '[včeraj ob] LT',
         lastWeek : function () {
             switch (this.day()) {
                 case 0:
                     return '[prejšnjo] [nedeljo] [ob] LT';
                 case 3:
                     return '[prejšnjo] [sredo] [ob] LT';
                 case 6:
                     return '[prejšnjo] [soboto] [ob] LT';
                 case 1:
                 case 2:
                 case 4:
                 case 5:
                     return '[prejšnji] dddd [ob] LT';
             }
         },
         sameElse : 'L'
     },
     relativeTime : {
         future : 'čez %s',
         past   : 'pred %s',
         s      : processRelativeTime,
         m      : processRelativeTime,
         mm     : processRelativeTime,
         h      : processRelativeTime,
         hh     : processRelativeTime,
         d      : processRelativeTime,
         dd     : processRelativeTime,
         M      : processRelativeTime,
         MM     : processRelativeTime,
         y      : processRelativeTime,
         yy     : processRelativeTime
     },
     dayOfMonthOrdinalParse: /\d{1,2}\./,
     ordinal : '%d.',
     week : {
         dow : 1, // Monday is the first day of the week.
         doy : 7  // The week that contains Jan 1st is the first week of the year.
     }
 });
 
 return sl;
 /* eslint-enable */
 })));
//! moment.js locale configuration
//! locale : slovak (sk)
/* eslint-disable */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
    ? factory(require('../moment'))
    : typeof define === 'function' && define.amd
    ? define(['moment'], factory)
    : factory(global.moment);
})(this, function (moment) {
  'use strict';

  function processRelativeTime(number, withoutSuffix, key, isFuture) {
    var format = {
      m: ['jedna minúta', 'jednej minúty'],
      h: ['jedna hodina', 'jednej hodiny'],
      d: ['jeden deň', 'jedného dňa'],
      dd: [number + ' dni', number + ' dní'],
      M: ['jeden mesiac', 'jedného mesiaca'],
      MM: [number + ' mesiace', number + ' mesiacov'],
      y: ['jeden rok', 'jedného roku'],
      yy: [number + ' roky', number + ' rokov']
    };
    return withoutSuffix ? format[key][0] : format[key][1];
  }

  var sk = moment.defineLocale('sk', {
    months:
      'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
        '_'
      ),
    monthsShort: 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_'),
    weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
    weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
    weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
    longDateFormat: {
      LT: 'H:mm',
      LTS: 'H:mm:ss',
      L: 'DD.MM.YYYY',
      LL: 'D. MMMM YYYY',
      LLL: 'D. MMMM YYYY H:mm',
      LLLL: 'dddd D. MMMM YYYY H:mm'
    },
    calendar: {
      sameDay: '[dnes o] LT',
      nextDay: '[zajtra o] LT',
      nextWeek: 'dddd [o] LT',
      lastDay: '[včera o] LT',
      lastWeek: '[minulý] dddd [o] LT',
      sameElse: 'L'
    },
    relativeTime: {
      future: 'za %s',
      past: 'pred %s',
      s: 'pár sekúnd',
      m: processRelativeTime,
      mm: '%d minút',
      h: processRelativeTime,
      hh: '%d hodín',
      d: processRelativeTime,
      dd: processRelativeTime,
      M: processRelativeTime,
      MM: processRelativeTime,
      y: processRelativeTime,
      yy: processRelativeTime
    },
    ordinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
      dow: 1, // Monday is the first day of the week
      doy: 4 // The week that contains Jan 4th is the first week of the year
    }
  });

  return sk;
  /* eslint-enable */
});

//! moment.js locale configuration
/* eslint-disable */
;(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined'
		&& typeof require === 'function' ? factory(require('../moment')) :
	typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	factory(global.moment);
 }(this, (function (moment) { 'use strict';


	function plural(word, num) {
		var forms = word.split('_');
		return num % 10 === 1 && num % 100 !== 11 ? forms[0] : (num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20) ? forms[1] : forms[2]);
	}
	function relativeTimeWithPlural(number, withoutSuffix, key) {
		var format = {
			'ss': withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
			'mm': withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
			'hh': 'час_часа_часов',
			'dd': 'день_дня_дней',
			'MM': 'месяц_месяца_месяцев',
			'yy': 'год_года_лет'
		};
		if (key === 'm') {
			return withoutSuffix ? 'минута' : 'минуту';
		}
		else {
			return number + ' ' + plural(format[key], +number);
		}
	}
	var monthsParse = [/^янв/i, /^фев/i, /^мар/i, /^апр/i, /^ма[йя]/i, /^июн/i, /^июл/i, /^авг/i, /^сен/i, /^окт/i, /^ноя/i, /^дек/i];

	// http://new.gramota.ru/spravka/rules/139-prop : § 103
	// Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	// CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	var ru = moment.defineLocale('ru', {
		months : {
			format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split('_'),
			standalone: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split('_')
		},
		monthsShort : {
			// по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку ?
			format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split('_'),
			standalone: 'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split('_')
		},
		weekdays : {
			standalone: 'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split('_'),
			format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split('_'),
			isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?\] ?dddd/
		},
		weekdaysShort : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
		weekdaysMin : 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
		monthsParse : monthsParse,
		longMonthsParse : monthsParse,
		shortMonthsParse : monthsParse,

		// полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
		monthsRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

		// копия предыдущего
		monthsShortRegex: /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

		// полные названия с падежами
		monthsStrictRegex: /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

		// Выражение, которое соотвествует только сокращённым формам
		monthsShortStrictRegex: /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
		longDateFormat : {
			LT : 'H:mm',
			LTS : 'H:mm:ss',
			L : 'DD.MM.YYYY',
			LL : 'D MMMM YYYY г.',
			LLL : 'D MMMM YYYY г., H:mm',
			LLLL : 'dddd, D MMMM YYYY г., H:mm'
		},
		calendar : {
			sameDay: '[Сегодня, в] LT',
			nextDay: '[Завтра, в] LT',
			lastDay: '[Вчера, в] LT',
			nextWeek: function (now) {
				if (now.week() !== this.week()) {
					switch (this.day()) {
						case 0:
							return '[В следующее] dddd, [в] LT';
						case 1:
						case 2:
						case 4:
							return '[В следующий] dddd, [в] LT';
						case 3:
						case 5:
						case 6:
							return '[В следующую] dddd, [в] LT';
					}
				} else {
					if (this.day() === 2) {
						return '[Во] dddd, [в] LT';
					} else {
						return '[В] dddd, [в] LT';
					}
				}
			},
			lastWeek: function (now) {
				if (now.week() !== this.week()) {
					switch (this.day()) {
						case 0:
							return '[В прошлое] dddd, [в] LT';
						case 1:
						case 2:
						case 4:
							return '[В прошлый] dddd, [в] LT';
						case 3:
						case 5:
						case 6:
							return '[В прошлую] dddd, [в] LT';
					}
				} else {
					if (this.day() === 2) {
						return '[Во] dddd, [в] LT';
					} else {
						return '[В] dddd, [в] LT';
					}
				}
			},
			sameElse: 'L'
		},
		relativeTime : {
			future : 'через %s',
			past : '%s назад',
			s : 'несколько секунд',
			ss : relativeTimeWithPlural,
			m : relativeTimeWithPlural,
			mm : relativeTimeWithPlural,
			h : 'час',
			hh : relativeTimeWithPlural,
			d : 'день',
			dd : relativeTimeWithPlural,
			M : 'месяц',
			MM : relativeTimeWithPlural,
			y : 'год',
			yy : relativeTimeWithPlural
		},
		meridiemParse: /ночи|утра|дня|вечера/i,
		isPM : function (input) {
			return /^(дня|вечера)$/.test(input);
		},
		meridiem : function (hour, minute, isLower) {
			if (hour < 4) {
				return 'ночи';
			} else if (hour < 12) {
				return 'утра';
			} else if (hour < 17) {
				return 'дня';
			} else {
				return 'вечера';
			}
		},
		dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
		ordinal: function (number, period) {
			switch (period) {
				case 'M':
				case 'd':
				case 'DDD':
					return number + '-й';
				case 'D':
					return number + '-го';
				case 'w':
				case 'W':
					return number + '-я';
				default:
					return number;
			}
		},
		week : {
			dow : 1, // Monday is the first day of the week.
			doy : 4  // The week that contains Jan 4th is the first week of the year.
		}
	});

	return ru;
	/* eslint-enable */
 })));

//! moment.js locale configuration
/* eslint-disable */
;(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined'
	&& typeof require === 'function' ? factory(require('../moment')) :
		typeof define === 'function' && define.amd ? define(['../moment'], factory) :
			factory(global.moment)
}(this, (function (moment) { 'use strict';


	function relativeTimeWithPlural(number, withoutSuffix, key) {
		var format = {
				'ss': 'secunde',
				'mm': 'minute',
				'hh': 'ore',
				'dd': 'zile',
				'MM': 'luni',
				'yy': 'ani'
			},
			separator = ' ';
		if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
			separator = ' de ';
		}
		return number + separator + format[key];
	}

	var ro = moment.defineLocale('ro', {
		months : 'Ianuarie_Februarie_Martie_Aprilie_Mai_Iunie_Iulie_August_Septembrie_Octombrie_Noiembrie_Decembrie'.split('_'),
		monthsShort : 'Ian._Febr._Mart._Apr._Mai_Iun._Iul._Aug._Sept._Oct._Nov._Dec.'.split('_'),
		monthsParseExact: true,
		weekdays : 'Duminică_Luni_Marți_Miercuri_Joi_Vineri_Sâmbătă'.split('_'),
		weekdaysShort : 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
		weekdaysMin : 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
		longDateFormat : {
			LT : 'H:mm',
			LTS : 'H:mm:ss',
			L : 'DD.MM.YYYY',
			LL : 'D MMMM YYYY',
			LLL : 'D MMMM YYYY H:mm',
			LLLL : 'dddd, D MMMM YYYY H:mm'
		},
		calendar : {
			sameDay: '[azi la] LT',
			nextDay: '[mâine la] LT',
			nextWeek: 'dddd [la] LT',
			lastDay: '[ieri la] LT',
			lastWeek: '[fosta] dddd [la] LT',
			sameElse: 'L'
		},
		relativeTime : {
			future : 'peste %s',
			past : '%s în urmă',
			s : 'câteva secunde',
			ss : relativeTimeWithPlural,
			m : 'un minut',
			mm : relativeTimeWithPlural,
			h : 'o oră',
			hh : relativeTimeWithPlural,
			d : 'o zi',
			dd : relativeTimeWithPlural,
			M : 'o lună',
			MM : relativeTimeWithPlural,
			y : 'un an',
			yy : relativeTimeWithPlural
		},
		week : {
			dow : 1, // Monday is the first day of the week.
			doy : 7  // The week that contains Jan 7th is the first week of the year.
		}
	});

	return ro;

})));
/* eslint-enable */
//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL
/* eslint-disable */
;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
        && typeof require === 'function' ? factory(require('../moment')) :
    typeof define === 'function' && define.amd ? define(['../moment'], factory) :
    factory(global.moment)
 }(this, (function (moment) { 'use strict';
 
 
 var monthsNominative = 'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split('_');
 var monthsSubjective = 'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split('_');
 function plural(n) {
     return (n % 10 < 5) && (n % 10 > 1) && ((~~(n / 10) % 10) !== 1);
 }
 function translate(number, withoutSuffix, key) {
     var result = number + ' ';
     switch (key) {
         case 'm':
             return withoutSuffix ? 'minuta' : 'minutę';
         case 'mm':
             return result + (plural(number) ? 'minuty' : 'minut');
         case 'h':
             return withoutSuffix  ? 'godzina'  : 'godzinę';
         case 'hh':
             return result + (plural(number) ? 'godziny' : 'godzin');
         case 'MM':
             return result + (plural(number) ? 'miesiące' : 'miesięcy');
         case 'yy':
             return result + (plural(number) ? 'lata' : 'lat');
     }
 }
 
 var pl = moment.defineLocale('pl', {
     months : function (momentToFormat, format) {
         if (!momentToFormat) {
             return monthsNominative;
         } else if (format === '') {
             // Hack: if format empty we know this is used to generate
             // RegExp by moment. Give then back both valid forms of months
             // in RegExp ready format.
             return '(' + monthsSubjective[momentToFormat.month()] + '|' + monthsNominative[momentToFormat.month()] + ')';
         } else if (/D MMMM/.test(format)) {
             return monthsSubjective[momentToFormat.month()];
         } else {
             return monthsNominative[momentToFormat.month()];
         }
     },
     monthsShort : 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
     weekdays : 'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
     weekdaysShort : 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
     weekdaysMin : 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
     longDateFormat : {
         LT : 'HH:mm',
         LTS : 'HH:mm:ss',
         L : 'DD.MM.YYYY',
         LL : 'D MMMM YYYY',
         LLL : 'D MMMM YYYY HH:mm',
         LLLL : 'dddd, D MMMM YYYY HH:mm'
     },
     calendar : {
         sameDay: '[Dziś o] LT',
         nextDay: '[Jutro o] LT',
         nextWeek: '[W] dddd [o] LT',
         lastDay: '[Wczoraj o] LT',
         lastWeek: function () {
             switch (this.day()) {
                 case 0:
                     return '[W zeszłą niedzielę o] LT';
                 case 3:
                     return '[W zeszłą środę o] LT';
                 case 6:
                     return '[W zeszłą sobotę o] LT';
                 default:
                     return '[W zeszły] dddd [o] LT';
             }
         },
         sameElse: 'L'
     },
     relativeTime : {
         future : 'za %s',
         past : '%s temu',
         s : 'kilka sekund',
         m : translate,
         mm : translate,
         h : translate,
         hh : translate,
         d : '1 dzień',
         dd : '%d dni',
         M : 'miesiąc',
         MM : translate,
         y : 'rok',
         yy : translate
     },
     dayOfMonthOrdinalParse: /\d{1,2}\./,
     ordinal : '%d.',
     week : {
         dow : 1, // Monday is the first day of the week.
         doy : 4  // The week that contains Jan 4th is the first week of the year.
     }
 });
 
 return pl;
 /* eslint-enable */
 })));
//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj
/* eslint-disable */

(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
  && typeof require === 'function' ? factory(require('../moment')) :
    typeof define === 'function' && define.amd ? define(['../moment'], factory) :
      factory(global.moment)
}(this, (function (moment) { 'use strict';

  //! moment.js locale configuration

  var monthsShortWithDots = 'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split(
    '_'
    ),
    monthsShortWithoutDots = 'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split(
      '_'
    ),
    monthsParse = [
      /^jan/i,
      /^feb/i,
      /^maart|mrt.?$/i,
      /^apr/i,
      /^mei$/i,
      /^jun[i.]?$/i,
      /^jul[i.]?$/i,
      /^aug/i,
      /^sep/i,
      /^okt/i,
      /^nov/i,
      /^dec/i,
    ],
    monthsRegex = /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

  var nl = moment.defineLocale('nl', {
    months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
      '_'
    ),
    monthsShort: function (m, format) {
      if (!m) {
        return monthsShortWithDots;
      } else if (/-MMM-/.test(format)) {
        return monthsShortWithoutDots[m.month()];
      } else {
        return monthsShortWithDots[m.month()];
      }
    },

    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex: /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
    monthsShortStrictRegex: /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,

    weekdays: 'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split(
      '_'
    ),
    weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
    weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: 'HH:mm',
      LTS: 'HH:mm:ss',
      L: 'DD-MM-YYYY',
      LL: 'D MMMM YYYY',
      LLL: 'D MMMM YYYY HH:mm',
      LLLL: 'dddd D MMMM YYYY HH:mm',
    },
    calendar: {
      sameDay: '[vandaag om] LT',
      nextDay: '[morgen om] LT',
      nextWeek: 'dddd [om] LT',
      lastDay: '[gisteren om] LT',
      lastWeek: '[afgelopen] dddd [om] LT',
      sameElse: 'L',
    },
    relativeTime: {
      future: 'over %s',
      past: '%s geleden',
      s: 'een paar seconden',
      ss: '%d seconden',
      m: 'één minuut',
      mm: '%d minuten',
      h: 'één uur',
      hh: '%d uur',
      d: 'één dag',
      dd: '%d dagen',
      w: 'één week',
      ww: '%d weken',
      M: 'één maand',
      MM: '%d maanden',
      y: 'één jaar',
      yy: '%d jaar',
    },
    dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
    ordinal: function (number) {
      return (
        number +
        (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
      );
    },
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  });

  return nl;
  /* eslint-enable */
})));

//! moment.js locale configuration
/* eslint-disable */
; (function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined'
		&& typeof require === 'function' ? factory(require('../moment')) :
		typeof define === 'function' && define.amd ? define(['../moment'], factory) :
			factory(global.moment)
}(this, (function (moment) {
	'use strict';


	var weekEndings = 'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	function translate(number, withoutSuffix, key, isFuture) {
		var num = number;
		switch (key) {
			case 's':
				return (isFuture || withoutSuffix) ? 'néhány másodperc' : 'néhány másodperce';
			case 'ss':
				return num + (isFuture || withoutSuffix) ? ' másodperc' : ' másodperce';
			case 'm':
				return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
			case 'mm':
				return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
			case 'h':
				return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
			case 'hh':
				return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
			case 'd':
				return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
			case 'dd':
				return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
			case 'M':
				return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
			case 'MM':
				return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
			case 'y':
				return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
			case 'yy':
				return num + (isFuture || withoutSuffix ? ' év' : ' éve');
		}
		return '';
	}
	function week(isFuture) {
		return (isFuture ? '' : '[múlt] ') + '[' + weekEndings[this.day()] + '] LT[-kor]';
	}

	var hu = moment.defineLocale('hu', {
		months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split('_'),
		monthsShort: 'jan_feb_márc_ápr_máj_jún_júl_aug_szept_okt_nov_dec'.split('_'),
		weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
		weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
		weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
		longDateFormat: {
			LT: 'H:mm',
			LTS: 'H:mm:ss',
			L: 'YYYY.MM.DD.',
			LL: 'YYYY. MMMM D.',
			LLL: 'YYYY. MMMM D. H:mm',
			LLLL: 'YYYY. MMMM D., dddd H:mm'
		},
		meridiemParse: /de|du/i,
		isPM: function (input) {
			return input.charAt(1).toLowerCase() === 'u';
		},
		meridiem: function (hours, minutes, isLower) {
			if (hours < 12) {
				return isLower === true ? 'de' : 'DE';
			} else {
				return isLower === true ? 'du' : 'DU';
			}
		},
		calendar: {
			sameDay: '[ma] LT[-kor]',
			nextDay: '[holnap] LT[-kor]',
			nextWeek: function () {
				return week.call(this, true);
			},
			lastDay: '[tegnap] LT[-kor]',
			lastWeek: function () {
				return week.call(this, false);
			},
			sameElse: 'L'
		},
		relativeTime: {
			future: '%s múlva',
			past: '%s',
			s: translate,
			ss: translate,
			m: translate,
			mm: translate,
			h: translate,
			hh: translate,
			d: translate,
			dd: translate,
			M: translate,
			MM: translate,
			y: translate,
			yy: translate
		},
		dayOfMonthOrdinalParse: /\d{1,2}\./,
		ordinal: '%d.',
		week: {
			dow: 1, // Monday is the first day of the week.
			doy: 4  // The week that contains Jan 4th is the first week of the year.
		}
	});

	return hu;
	/* eslint-enable */
})));
//! moment.js locale configuration
//! locale : hrvatski (hr)
//! author : Bojan Marković : https://github.com/bmarkovic
/* eslint-disable */
(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
        case 'm':
            return withoutSuffix ? 'jedna minuta' : 'jedne minute';
        case 'mm':
            if (number === 1) {
                result += 'minuta';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'minute';
            } else {
                result += 'minuta';
            }
            return result;
        case 'h':
            return withoutSuffix ? 'jedan sat' : 'jednog sata';
        case 'hh':
            if (number === 1) {
                result += 'sat';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'sata';
            } else {
                result += 'sati';
            }
            return result;
        case 'dd':
            if (number === 1) {
                result += 'dan';
            } else {
                result += 'dana';
            }
            return result;
        case 'MM':
            if (number === 1) {
                result += 'mjesec';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'mjeseca';
            } else {
                result += 'mjeseci';
            }
            return result;
        case 'yy':
            if (number === 1) {
                result += 'godina';
            } else if (number === 2 || number === 3 || number === 4) {
                result += 'godine';
            } else {
                result += 'godina';
            }
            return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months : 'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split('_'),
        monthsShort : 'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split('_'),
        weekdays : 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split('_'),
        weekdaysShort : 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin : 'ne_po_ut_sr_če_pe_su'.split('_'),
        longDateFormat : {
            LT : 'H:mm',
            LTS : 'H:mm:ss',
            L : 'DD. MM. YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY H:mm',
            LLLL : 'dddd, D. MMMM YYYY H:mm'
        },
        calendar : {
            sameDay  : '[danas u] LT',
            nextDay  : '[sutra u] LT',
            nextWeek : function () {
                switch (this.day()) {
                case 0:
                    return '[u] [nedjelju] [u] LT';
                case 3:
                    return '[u] [srijedu] [u] LT';
                case 6:
                    return '[u] [subotu] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[u] dddd [u] LT';
                }
            },
            lastDay  : '[jučer u] LT',
            lastWeek : function () {
                switch (this.day()) {
                case 0:
                case 3:
                    return '[prošlu] dddd [u] LT';
                case 6:
                    return '[prošle] [subote] [u] LT';
                case 1:
                case 2:
                case 4:
                case 5:
                    return '[prošli] dddd [u] LT';
                }
            },
            sameElse : 'L'
        },
        relativeTime : {
            future : 'za %s',
            past   : 'prije %s',
            s      : 'par sekundi',
            m      : translate,
            mm     : translate,
            h      : translate,
            hh     : translate,
            d      : 'dan',
            dd     : translate,
            M      : 'mjesec',
            MM     : translate,
            y      : 'godinu',
            yy     : translate
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 7  // The week that contains Jan 1st is the first week of the year.
        }
    });

    return hr;
    /* eslint-enable */
}));
//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice
/* eslint-disable */
;(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined'
       && typeof require === 'function' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
   factory(global.moment)
}(this, (function (moment) { 'use strict';


var fr = moment.defineLocale('fr', {
    months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
    monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
    monthsParseExact : true,
    weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
    weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
    weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
    weekdaysParseExact : true,
    longDateFormat : {
        LT : 'HH:mm',
        LTS : 'HH:mm:ss',
        L : 'DD/MM/YYYY',
        LL : 'D MMMM YYYY',
        LLL : 'D MMMM YYYY HH:mm',
        LLLL : 'dddd D MMMM YYYY HH:mm'
    },
    calendar : {
        sameDay : '[Aujourd’hui à] LT',
        nextDay : '[Demain à] LT',
        nextWeek : 'dddd [à] LT',
        lastDay : '[Hier à] LT',
        lastWeek : 'dddd [dernier à] LT',
        sameElse : 'L'
    },
    relativeTime : {
        future : 'dans %s',
        past : 'il y a %s',
        s : 'quelques secondes',
        m : 'une minute',
        mm : '%d minutes',
        h : 'une heure',
        hh : '%d heures',
        d : 'un jour',
        dd : '%d jours',
        M : 'un mois',
        MM : '%d mois',
        y : 'un an',
        yy : '%d ans'
    },
    dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
    ordinal : function (number, period) {
        switch (period) {
            // TODO: Return 'e' when day of month > 1. Move this case inside
            // block for masculine words below.
            // See https://github.com/moment/moment/issues/3375
            case 'D':
                return number + (number === 1 ? 'er' : '');

            // Words with masculine grammatical gender: mois, trimestre, jour
            default:
            case 'M':
            case 'Q':
            case 'DDD':
            case 'd':
                return number + (number === 1 ? 'er' : 'e');

            // Words with feminine grammatical gender: semaine
            case 'w':
            case 'W':
                return number + (number === 1 ? 're' : 'e');
        }
    },
    week : {
        dow : 1, // Monday is the first day of the week.
        doy : 4  // The week that contains Jan 4th is the first week of the year.
    }
});

return fr;
/* eslint-enable */
})));
//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof
/* eslint-disable */
;(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined'
  && typeof require === 'function' ? factory(require('../moment')) :
    typeof define === 'function' && define.amd ? define(['../moment'], factory) :
      factory(global.moment)
}(this, (function (moment) { 'use strict';

  //! moment.js locale configuration

  var numbersPast =
      'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
        ' '
      ),
    numbersFuture = [
      'nolla',
      'yhden',
      'kahden',
      'kolmen',
      'neljän',
      'viiden',
      'kuuden',
      numbersPast[7],
      numbersPast[8],
      numbersPast[9],
    ];
  function translate(number, withoutSuffix, key, isFuture) {
    var result = '';
    switch (key) {
      case 's':
        return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
      case 'ss':
        result = isFuture ? 'sekunnin' : 'sekuntia';
        break;
      case 'm':
        return isFuture ? 'minuutin' : 'minuutti';
      case 'mm':
        result = isFuture ? 'minuutin' : 'minuuttia';
        break;
      case 'h':
        return isFuture ? 'tunnin' : 'tunti';
      case 'hh':
        result = isFuture ? 'tunnin' : 'tuntia';
        break;
      case 'd':
        return isFuture ? 'päivän' : 'päivä';
      case 'dd':
        result = isFuture ? 'päivän' : 'päivää';
        break;
      case 'M':
        return isFuture ? 'kuukauden' : 'kuukausi';
      case 'MM':
        result = isFuture ? 'kuukauden' : 'kuukautta';
        break;
      case 'y':
        return isFuture ? 'vuoden' : 'vuosi';
      case 'yy':
        result = isFuture ? 'vuoden' : 'vuotta';
        break;
    }
    result = verbalNumber(number, isFuture) + ' ' + result;
    return result;
  }
  function verbalNumber(number, isFuture) {
    return number < 10
      ? isFuture
        ? numbersFuture[number]
        : numbersPast[number]
      : number;
  }

  var fi = moment.defineLocale('fi', {
    months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
      '_'
    ),
    monthsShort:
      'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
        '_'
      ),
    weekdays:
      'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
        '_'
      ),
    weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
    weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
    longDateFormat: {
      LT: 'HH.mm',
      LTS: 'HH.mm.ss',
      L: 'DD.MM.YYYY',
      LL: 'Do MMMM[ta] YYYY',
      LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
      LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
      l: 'D.M.YYYY',
      ll: 'Do MMM YYYY',
      lll: 'Do MMM YYYY, [klo] HH.mm',
      llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
    },
    calendar: {
      sameDay: '[tänään] [klo] LT',
      nextDay: '[huomenna] [klo] LT',
      nextWeek: 'dddd [klo] LT',
      lastDay: '[eilen] [klo] LT',
      lastWeek: '[viime] dddd[na] [klo] LT',
      sameElse: 'L',
    },
    relativeTime: {
      future: '%s päästä',
      past: '%s sitten',
      s: translate,
      ss: translate,
      m: translate,
      mm: translate,
      h: translate,
      hh: translate,
      d: translate,
      dd: translate,
      M: translate,
      MM: translate,
      y: translate,
      yy: translate,
    },
    dayOfMonthOrdinalParse: /\d{1,2}\./,
    ordinal: '%d.',
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
  });

  return fi;
  /* eslint-enable */
})));

//! moment.js locale configuration
//! locale : german (de)
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
/* eslint-disable */
(function (global, factory) {
   typeof exports === 'object' && typeof module !== 'undefined' ? factory(require('../moment')) :
   typeof define === 'function' && define.amd ? define(['moment'], factory) :
   factory(global.moment)
}(this, function (moment) { 'use strict';


    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            'm': ['eine Minute', 'einer Minute'],
            'h': ['eine Stunde', 'einer Stunde'],
            'd': ['ein Tag', 'einem Tag'],
            'dd': [number + ' Tage', number + ' Tagen'],
            'M': ['ein Monat', 'einem Monat'],
            'MM': [number + ' Monate', number + ' Monaten'],
            'y': ['ein Jahr', 'einem Jahr'],
            'yy': [number + ' Jahre', number + ' Jahren']
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months : 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split('_'),
        monthsShort : 'Jan._Febr._Mrz._Apr._Mai_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split('_'),
        weekdays : 'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split('_'),
        weekdaysShort : 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin : 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        longDateFormat : {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L : 'DD.MM.YYYY',
            LL : 'D. MMMM YYYY',
            LLL : 'D. MMMM YYYY HH:mm',
            LLLL : 'dddd, D. MMMM YYYY HH:mm'
        },
        calendar : {
            sameDay: '[Heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[Morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[Gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]'
        },
        relativeTime : {
            future : 'in %s',
            past : 'vor %s',
            s : 'ein paar Sekunden',
            m : processRelativeTime,
            mm : '%d Minuten',
            h : processRelativeTime,
            hh : '%d Stunden',
            d : processRelativeTime,
            dd : processRelativeTime,
            M : processRelativeTime,
            MM : processRelativeTime,
            y : processRelativeTime,
            yy : processRelativeTime
        },
        ordinalParse: /\d{1,2}\./,
        ordinal : '%d.',
        week : {
            dow : 1, // Monday is the first day of the week.
            doy : 4  // The week that contains Jan 4th is the first week of the year.
        }
    });

    return de;
    /* eslint-enable */
}));
//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela
/* eslint-disable */
;(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined'
        && typeof require === 'function' ? factory(require('../moment')) :
    typeof define === 'function' && define.amd ? define(['../moment'], factory) :
    factory(global.moment)
 }(this, (function (moment) { 'use strict';
 
 
 var months = 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split('_');
 var monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_');
 function plural(n) {
     return (n > 1) && (n < 5) && (~~(n / 10) !== 1);
 }
 function translate(number, withoutSuffix, key, isFuture) {
     var result = number + ' ';
     switch (key) {
         case 's':  // a few seconds / in a few seconds / a few seconds ago
             return (withoutSuffix || isFuture) ? 'pár sekund' : 'pár sekundami';
         case 'm':  // a minute / in a minute / a minute ago
             return withoutSuffix ? 'minuta' : (isFuture ? 'minutu' : 'minutou');
         case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
             if (withoutSuffix || isFuture) {
                 return result + (plural(number) ? 'minuty' : 'minut');
             } else {
                 return result + 'minutami';
             }
             break;
         case 'h':  // an hour / in an hour / an hour ago
             return withoutSuffix ? 'hodina' : (isFuture ? 'hodinu' : 'hodinou');
         case 'hh': // 9 hours / in 9 hours / 9 hours ago
             if (withoutSuffix || isFuture) {
                 return result + (plural(number) ? 'hodiny' : 'hodin');
             } else {
                 return result + 'hodinami';
             }
             break;
         case 'd':  // a day / in a day / a day ago
             return (withoutSuffix || isFuture) ? 'den' : 'dnem';
         case 'dd': // 9 days / in 9 days / 9 days ago
             if (withoutSuffix || isFuture) {
                 return result + (plural(number) ? 'dny' : 'dní');
             } else {
                 return result + 'dny';
             }
             break;
         case 'M':  // a month / in a month / a month ago
             return (withoutSuffix || isFuture) ? 'měsíc' : 'měsícem';
         case 'MM': // 9 months / in 9 months / 9 months ago
             if (withoutSuffix || isFuture) {
                 return result + (plural(number) ? 'měsíce' : 'měsíců');
             } else {
                 return result + 'měsíci';
             }
             break;
         case 'y':  // a year / in a year / a year ago
             return (withoutSuffix || isFuture) ? 'rok' : 'rokem';
         case 'yy': // 9 years / in 9 years / 9 years ago
             if (withoutSuffix || isFuture) {
                 return result + (plural(number) ? 'roky' : 'let');
             } else {
                 return result + 'lety';
             }
             break;
     }
 }
 
 var cs = moment.defineLocale('cs', {
     months : months,
     monthsShort : monthsShort,
     monthsParse : (function (months, monthsShort) {
         var i, _monthsParse = [];
         for (i = 0; i < 12; i++) {
             // use custom parser to solve problem with July (červenec)
             _monthsParse[i] = new RegExp('^' + months[i] + '$|^' + monthsShort[i] + '$', 'i');
         }
         return _monthsParse;
     }(months, monthsShort)),
     shortMonthsParse : (function (monthsShort) {
         var i, _shortMonthsParse = [];
         for (i = 0; i < 12; i++) {
             _shortMonthsParse[i] = new RegExp('^' + monthsShort[i] + '$', 'i');
         }
         return _shortMonthsParse;
     }(monthsShort)),
     longMonthsParse : (function (months) {
         var i, _longMonthsParse = [];
         for (i = 0; i < 12; i++) {
             _longMonthsParse[i] = new RegExp('^' + months[i] + '$', 'i');
         }
         return _longMonthsParse;
     }(months)),
     weekdays : 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
     weekdaysShort : 'ne_po_út_st_čt_pá_so'.split('_'),
     weekdaysMin : 'ne_po_út_st_čt_pá_so'.split('_'),
     longDateFormat : {
         LT: 'H:mm',
         LTS : 'H:mm:ss',
         L : 'DD.MM.YYYY',
         LL : 'D. MMMM YYYY',
         LLL : 'D. MMMM YYYY H:mm',
         LLLL : 'dddd D. MMMM YYYY H:mm',
         l : 'D. M. YYYY'
     },
     calendar : {
         sameDay: '[dnes v] LT',
         nextDay: '[zítra v] LT',
         nextWeek: function () {
             switch (this.day()) {
                 case 0:
                     return '[v neděli v] LT';
                 case 1:
                 case 2:
                     return '[v] dddd [v] LT';
                 case 3:
                     return '[ve středu v] LT';
                 case 4:
                     return '[ve čtvrtek v] LT';
                 case 5:
                     return '[v pátek v] LT';
                 case 6:
                     return '[v sobotu v] LT';
             }
         },
         lastDay: '[včera v] LT',
         lastWeek: function () {
             switch (this.day()) {
                 case 0:
                     return '[minulou neděli v] LT';
                 case 1:
                 case 2:
                     return '[minulé] dddd [v] LT';
                 case 3:
                     return '[minulou středu v] LT';
                 case 4:
                 case 5:
                     return '[minulý] dddd [v] LT';
                 case 6:
                     return '[minulou sobotu v] LT';
             }
         },
         sameElse: 'L'
     },
     relativeTime : {
         future : 'za %s',
         past : 'před %s',
         s : translate,
         m : translate,
         mm : translate,
         h : translate,
         hh : translate,
         d : translate,
         dd : translate,
         M : translate,
         MM : translate,
         y : translate,
         yy : translate
     },
     dayOfMonthOrdinalParse : /\d{1,2}\./,
     ordinal : '%d.',
     week : {
         dow : 1, // Monday is the first day of the week.
         doy : 4  // The week that contains Jan 4th is the first week of the year.
     }
 });
 
 return cs;
 /* eslint-enable */
 })));
(function () {
  "use strict";

  angular.module("sempraWebapp", [
    "ngAnimate",
    "ngCookies",
    "ngSanitize",
    "ngMessages",
    "ngAria",
    "ui.router",
    "ngMaterial",
    "toastr",
    "eventBus",
    "app.config",
    "angularUtils.directives.uiBreadcrumbs",
    "md.data.table",
    "pascalprecht.translate",
    "datePicker",
    "ui.bootstrap",
    "ngLocale",
    "angular-jwt",
    "appVersion",
    "ngFileUpload",
    "ja.qr"
  ]);
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('userRolesEnum', userRolesFactory);

  function userRolesFactory () {
    return Object.freeze({
      CONSUMER: 'CONSUMER',
      SUBSCRIBER: 'SUBSCRIBER',
      SYSTEM_ADMIN: 'SYSTEM_ADMIN',
      MERCHANT_ADMIN: 'MERCHANT_ADMIN',
      COMPANY_ADMIN: 'COMPANY_ADMIN',
      FACILITY_ADMIN: 'FACILITY_ADMIN',
      CONTROLLER: 'CONTROLLER',
      TECHNICAL_SUPPORT: 'TECHNICAL_SUPPORT',
      ADMINISTRATOR: 'ADMINISTRATOR'
    });
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").factory("LanguagesEnum", languagesEnumFactory);

  /** @ngInject */
  function languagesEnumFactory() {
    return Object.freeze([
      {
        locale: "en",
        name: "English",
        englishName: "ENGLISH"
      },
      {
        locale: "sr",
        name: "Srpski",
        englishName: "SERBIAN"
      },
      {
        locale: "hr",
        name: "Hrvatski",
        englishName: "CROATIAN"
      },
      {
        locale: "fr",
        name: "Français",
        englishName: "FRENCH"
      },
      {
        locale: "cs",
        name: "Čeština",
        englishName: "CZECH"
      },
      {
        locale: "sl",
        name: "Slovenščina",
        englishName: "SLOVENIAN"
      },
      {
        locale: "uk",
        name: "Український",
        englishName: "UKRAINIAN"
      },
      {
        locale: "ru",
        name: "Pусский",
        englishName: "RUSSIAN"
      },
      {
        locale: "de",
        name: "Deutsche",
        englishName: "GERMAN"
      },
      {
        locale: "hu",
        name: "Magyar",
        englishName: "HUNGARIAN"
      },
      {
        locale: "ro",
        name: "Română",
        englishName: "ROMANIAN"
      },
      {
        locale: "nl",
        name: "Nederland",
        englishName: "DUTCH"
      },
      {
        locale: "sv",
        name: "Svenska",
        englishName: "SWEDISH"
      }
    ]);
  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('invoiceNamingEnumFactory', invoiceNamingEnumFactory);

    /** @ngInject */
    function invoiceNamingEnumFactory($translate, sessionData) {

        return namingCheck();

        function namingCheck() {
          var countryCode = localStorage.getItem(sessionData.Keys.COUNTRY_CODE);
          var data;
          switch (countryCode) {
            case 'RS':
              data = {
                name:  $translate.instant('INVOICE'),
                forInvoicing: $translate.instant('FOR_INVOICING'),
                paymentsOnHold: $translate.instant('PAYMENTS_ON_HOLD'),
                invoiceNumber: $translate.instant('INVOICE_NUMBER'),
                invoiceState: $translate.instant('INVOICE_STATE')
              }
              break;

            default:
              data = {
                name: $translate.instant('PAYMENT_REQUEST'),
                forInvoicing: $translate.instant('FOR_PAYMENT_REQUEST'),
                paymentsOnHold: $translate.instant('PAYMENT_REQUEST_ON_HOLD'),
                invoiceNumber: $translate.instant('PAYMENT_REQUEST_NUMBER'),
                invoiceState: $translate.instant('PAYMENT_REQUEST_STATE')
              }
              break;
          }
          return data;
        }

    }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('TrendEnum', trendEnumFactory);

  function trendEnumFactory () {
    return Object.freeze({
      RISING: 'RISING',
      STEADY: 'STEADY',
      FALLING: 'FALLING'
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ReportTypeEnum', reportTypeEnumFactory);

  function reportTypeEnumFactory () {
    return Object.freeze({
      MONEY_BY_DATE_REPORT: 'MONEY_BY_DATE_REPORT',
      R2W_BY_DATE_REPORT: 'R2W_BY_DATE_REPORT',
      COINS_BY_DATE_REPORT: 'COINS_BY_DATE_REPORT',
      AVG_MONEY_BY_HOUR_REPORT: 'AVG_MONEY_BY_HOUR_REPORT',
      AVG_MONEY_BY_DAY_OF_WEEK_REPORT: 'AVG_MONEY_BY_DAY_OF_WEEK_REPORT',
      AVG_MONEY_BY_BOX_REPORT: 'AVG_MONEY_BY_BOX_REPORT',
      COMPARE_PERIODS_REPORT: 'COMPARE_PERIODS_REPORT',
      TOTAL_USERS_BY_GROUP: 'TOTAL_USERS_BY_GROUP',
      VISITS_COUNT_REPORT: 'VISITS_COUNT_REPORT',
      LOYALTY_PER_DAY_REPORT: 'LOYALTY_PER_DAY_REPORT',
      TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY: 'TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY',
      TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY: 'TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY',
      TOTAL_SPENT_LOCAL_TOKENS_PER_DAY: 'TOTAL_SPENT_LOCAL_TOKENS_PER_DAY',
      EUROKEY_BY_DATE_REPORT: 'EUROKEY_BY_DATE_REPORT',
      CHANGER_INCOME: 'CHANGER_INCOME',
      POS_INCOME: 'POS_INCOME'
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ReadingTypeEnum', readingTypeEnumFactory);

  /** @ngInject */
  function readingTypeEnumFactory () {
    return Object.freeze({
      FLAG: 'FLAG',
      RANGE: 'RANGE',
      COUNTER: 'COUNTER',
      T: 'T',
      HEXTIME: 'HEXTIME',
      TIME: 'TIME',
      TEMPERATURE: 'TEMPERATURE',
      properties: {
        'FLAG': {
          parse: function (value) {
            return parseInt(value, 10) === 1;
          }
        },
        'STRING': {
          parse: function (value) {
            return value;
          }
        },
        'RANGE': {
          parse: function (value) {
            return value;
          }
        },
        'COUNTER': {
          parse: function (value) {
            return value;
          }
        },
        'T': {
          parse: function (value) {
            return parseFloat(value);
          }
        },
        'HEXTIME': {
          parse: function (value) {
            return value;
          }
        },
        'TIME': {
          parse: function (value) {
            return value;
          }
        },
        'TEMPERATURE' : {
          parse: function (value) {
            return value;
          }
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('PointTypeEnum', pointTypeEnumFactory);

  function pointTypeEnumFactory () {
    return Object.freeze({
      WASH_BOX: 'WASH_BOX',
      VACUUM: 'VACUUM',
      WASH_FACILITY: 'WASH_FACILITY',
      SUBSYSTEM: 'SUBSYSTEM',
      KARCHER_WASH_BOX: "G",
      KARCHER_VACUUM: "U",
      properties: {
        NAMES: {
          TAP_WATER: 'Subsystem6',
          DEMI_WATER: 'Subsystem8',
          REVERSE_OSMOSIS: 'Subsystem9',
          SOFTENED_WATER: 'Subsystem7',
          DOSER: 'Subsystem11'
        }
      }
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ModBusTypeEnum', modbusTypeEnumFactory);

  function modbusTypeEnumFactory () {
    return Object.freeze({
      SERIAL: 'SERIAL',
      ETHERNET: 'ETHERNET',
      ETHERNET_241: 'ETHERNET_241'
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('MessageTypeEnum', messageTypeEnumFactory);

  /** @ngInject */
  function messageTypeEnumFactory () {
    return Object.freeze({
      ALARM: 'alarm',
      INFO: 'info',
      WARNING: 'warning'
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('loyaltyCampaignEnum', loyaltyCampaignEnumFactory);

  /** @ngInject */
  function loyaltyCampaignEnumFactory () {
    return Object.freeze({
      FINISHED : 'FINISHED',
      RUNNING : 'RUNNING',
      UPCOMING : 'UPCOMING',
      DEPRECATED : 'DEPRECATED'
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('InvoiceStatusEnum', invoiceStatusEnumFactory);

  /** @ngInject */
  function invoiceStatusEnumFactory () {
    return Object.freeze({
      NEW : 'NEW',
      PENDING: 'PENDING',
      CANCELED : 'CANCELED'
    });

  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("InterceptorEnum", interceptorEnumFactory);

  function interceptorEnumFactory() {
    var disallowedStrings = Object.freeze({
      LOGIN: "/emailSignIn",
      PASSWORD_RESET: "/passwordReset",
      REFRESH_TOKEN: "/refreshToken"
    });

    var allowedStrings = Object.freeze({
      API: "/api/"
    });

    function isStringValid(urlString) {
      var disallowedArray = Object.keys(disallowedStrings);

      for (var i = 0; i < disallowedArray.length; i++) {
        var string = disallowedStrings[disallowedArray[i]];
        if (urlString.indexOf(string) !== -1) {
          return false;
        }
      }
      return true;
    }

    function isApiCall(urlString) {
      if (urlString.indexOf(allowedStrings.API) !== -1) {
        return true;
      } else {
        return false;
      }
    }

    return {
      isStringValid: isStringValid,
      isApiCall: isApiCall
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('DeviceStateEnum', deviceStateEnumFactory);

  function deviceStateEnumFactory () {
    return Object.freeze({
      CONNECTED: 'CONNECTED',
      OFFLINE: 'OFFLINE',
      DEACTIVATED: 'DEACTIVATED'
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CampaignTemplateEnum', campaignTemplateFactory);

  function campaignTemplateFactory () {
    return Object.freeze({
      NUM_OF_VISITS: 'NUM_OF_VISITS',
      MONEY_SPENT: 'MONEY_SPENT',
      DAILY_TEMPORAL: 'DAILY_TEMPORAL'
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('AlarmStateEnum', alarmStateEnumFactory);

  function alarmStateEnumFactory () {
    return Object.freeze({
      NORMAL: 'NORMAL',
      HIGH: 'HIGH',
      LOW: 'LOW'
    });
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ActuatorTypeEnum', actuatorTypeEnumFactory);

  /** @ngInject */
  function actuatorTypeEnumFactory () {
    return Object.freeze({
      SW: 'SW',
      RANGE: 'RANGE',
      properties: {
        SW: {
          parseValue: function (value) {
            return parseInt(value, 10) > 0 ? true : false;
          },
          parseRange: function (rangeValue) {
            return rangeValue;
          }
        },
        RANGE: {
          parseValue: function (value) {
            return parseFloat(value);
          },
          parseRange: function (rangeValue) {
            return rangeValue
          }
        }
      }
    });
  }
})();

(function () {
    "use strict";

    angular.module("sempraWebapp").factory("ByBoxrViewModel", byBoxViewModelFactory);

    /** @ngInject */
    function byBoxViewModelFactory() {
        function byBoxrViewModel() {}

        byBoxrViewModel.prototype.createChartData = function (data) {
            data.regionCurrency = this.createData(data.regionCurrency, 'MONEY');
            data.tokens = this.createData(data.tokens, 'PIECES_TITLE');
            return data;
        };

        byBoxrViewModel.prototype.createBasicData = function() {
            return {
                groupNames: [],
                groupTotal: [],
                groupsData: [],
                isChartVisible: false
            }
        }

        byBoxrViewModel.prototype.createData = function(data, title) {
            if(data) {
                data.isChartVisible = true;
                data.title = title;
                data.groupsData.map(function(item){
                    switch (true) {
                        case item.groupValue.includes('ONLINE'):
                            return item.groupValue = 'R2W';
                        case item.groupValue.includes('TOKEN'):
                            return item.groupValue = 'METAL TOKEN';
                        case item.groupValue.includes('R2W_'):
                            return item.groupValue = 'LOCAL';
                        default:
                            return item.groupValue
                    }
                });
                data.groupsData = data.groupsData;
            } else {
                data = this.createBasicData();
            }
            return data;
        }

        return byBoxrViewModel;
    }
})();

(function () {
    "use strict";

    angular.module("sempraWebapp").component("reportByBox", {
        templateUrl: "app/reports/avgByBoxReport/byBoxComponent/byBox.html",
        controller: reportByBoxController,
        bindings: {
            data: "<"
        },
        controllerAs: "vm"
    });

    function reportByBoxController($translate, reportExportUtil, exportToCsv) {
        var vm = this;
        vm.report = vm.data;
        vm.exportToCsv = exportCsv;

        function exportCsv() {
            var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
                $translate.instant('BOXES'),
                vm.report.data,
                reportExportUtil.ValueFormattersEnum.DEFAULT,
                reportExportUtil.ValueFormattersEnum.NUMBER);

            exportToCsv.export(jsonArrayForExport,
                $translate.instant(vm.data.data.title),
                true);
        }


    }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('topLeftSchema',  topLeftSchemaInject);

  /** @ngInject */
  function topLeftSchemaInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'assets/schema/tapWaterSubSystem-resized.svg',
      controller: TopLeftSchemaController,
      controllerAs: 'vm',
      scope: {
        value: '='
      }
    };

    return directive;

    /** @ngInject */
    function TopLeftSchemaController($scope, schemaUtils) {
      var vm = this;

      $scope.$watchGroup(['value.vent', 'value.highFloat', 'value.lowFloat', 'value.pressure', 'value.motorError', 'value.motor'], function (newValue) {
        vm.vent = newValue[0] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;
        vm.highFloat = newValue[1] ?  schemaUtils.COLORS.highFloatWorking : schemaUtils.COLORS.highFloatNotWorking;
        vm.lowFloat = newValue[2]  ? schemaUtils.COLORS.error : schemaUtils.COLORS.working;
        vm.pressure = newValue[3] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;

        if (newValue[4]) {
          vm.motor = schemaUtils.COLORS.error;
        } else {
          vm.motor = newValue[5] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('bottomRightSchema', bottomRightSchemaInject);

  /** @ngInject */
  function bottomRightSchemaInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'assets/schema/doserSubSystem-resized.svg',
      controller: BottomRightSchemaController,
      controllerAs: 'vm',
      scope: {
        value: '='
      }
    };

    return directive;

    /** @ngInject */
    function BottomRightSchemaController($scope, schemaUtils) {
      var vm = this;

      $scope.$watchGroup(['value.vent', 'vent.highFloat', 'vent.lowFloat', 'value.pressure',
        'value.motor', 'value.motorError', 'value.motorVibroError',
        'value.motorDoser', 'value.motorDoserError'], function (newValue) {
        vm.vent = newValue[0] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;
        vm.highFloat = newValue[1] ? schemaUtils.COLORS.highFloatWorking : schemaUtils.COLORS.highFloatNotWorking;
        vm.lowFloat = newValue[2] ? schemaUtils.COLORS.error : schemaUtils.COLORS.working;
        vm.pressure = newValue[3] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;

        if (newValue[5]) {
          vm.motor = schemaUtils.COLORS.error;
        } else {
          vm.motor = newValue[4] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }

        if (newValue[6]) {
          vm.motorVibro = schemaUtils.COLORS.error;
        } else {
          vm.motorVibro = schemaUtils.COLORS.notWorking;
        }

        if (newValue[8]) {
          vm.motorDoser = schemaUtils.COLORS.error;
        } else {
          vm.motorDoser = newValue[7] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('topRightSchema',  topRightSchemaInject);

  /** @ngInject */
  function topRightSchemaInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'assets/schema/reverseOsmasisSubSystem-resized.svg',
      controller: TopRightSchemaController,
      controllerAs: 'vm',
      scope: {
        ro: '=',
        demi: '='
      }
    };

    return directive;

    /** @ngInject */
    function TopRightSchemaController($scope, schemaUtils) {
      var vm = this;

      $scope.$watchGroup(['ro.lps', 'ro.fwy', 'ro.motor', 'ro.motorError'], function (newValue) {
        vm.lps = newValue[0] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;
        vm.fwy = newValue[1] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;

        if (newValue[3]) {
          vm.motorRo = schemaUtils.COLORS.error;
        } else {
          vm.motorRo = newValue[2] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });

      $scope.$watchGroup(['demi.highFloat', 'demi.lowFloat', 'demi.motorError', 'demi.motor'], function (newValue) {
        vm.highFloat = newValue[0] ? schemaUtils.COLORS.highFloatWorking : schemaUtils.COLORS.highFloatNotWorking;
        vm.lowFloat = newValue[1]  ? schemaUtils.COLORS.error : schemaUtils.COLORS.working;

        if (newValue[2]) {
          vm.motorDemi = schemaUtils.COLORS.error;
        } else {
          vm.motorDemi = newValue[3] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });


    }
  }

})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('bottomLeftSchema',  bottomLeftSchemaInject);

  /** @ngInject */
  function bottomLeftSchemaInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'assets/schema/softWaterSubSystem-resized.svg',
      controller: BottomLeftSchemaController,
      controllerAs: 'vm',
      scope: {
        value: '='
      }
    };

    return directive;

    /** @ngInject */
    function BottomLeftSchemaController($scope, schemaUtils) {
      var vm = this;

      $scope.$watchGroup(['value.vent', 'value.highFloat', 'value.lowFloat', 'value.pressure', 'value.motor', 'value.motorError'], function (newValue) {
        vm.vent = newValue[0] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;
        vm.highFloat = newValue[1] ? schemaUtils.COLORS.highFloatWorking : schemaUtils.COLORS.highFloatNotWorking;
        vm.lowFloat = newValue[2] ? schemaUtils.COLORS.error : schemaUtils.COLORS.working;
        vm.pressure = newValue[3] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;

        if (newValue[5]) {
          vm.motor = schemaUtils.COLORS.error;
        } else {
          vm.motor = newValue[4] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });
    }
  }

})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("workingSchedules", {
    templateUrl:
      "app/workingSchedulesAndHolidays/workingSchedules/workingSchedules.html",
    controller: workingSchedules,
    bindings: {
      workingSchedulesData: "<",
      allDayCheckBoxData: "<",
      siteId: "<",
      refresh: "&"
    },
    controllerAs: "vm"
  });

  function workingSchedules(workingSchedulesActions, $filter) {
    var vm = this;

    vm.scheduleList = [];

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      if (changes.workingSchedulesData) {
        vm.scheduleList = changes.workingSchedulesData.currentValue;
        if(changes.workingSchedulesData.currentValue.length !== 0) {
          vm.scheduleList.forEach(function(item) {
            item.dayString = $filter('codeToDayName')(item.day);
          });
        }
      } else if (changes.siteId) {
        vm.siteId = changes.siteId.currentValue;
      }
    };

    vm.updateSchedules = function () {
      var data = {
        days: vm.scheduleList,
        state24h: vm.allDayCheckBoxData
      }
      workingSchedulesActions
        .updateWorkingSchedules(vm.siteId, data)
        .then(function () {});
    };

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').component('siteDetails', {
    templateUrl: 'app/workingSchedulesAndHolidays/siteDetails/siteDetails.html',
    controller: siteDetails,
    bindings: {
      siteId: '<',
      refresh: '&'
    },
    controllerAs: 'vm'
  });

  function siteDetails(
    workingSchedulesActions,
    hostProtocol,
    hostDomain,
    Upload,
    $log,
    $scope,
    $mdToast,
    $translate
  ) {
    var vm = this;

    vm.$onInit = function () {};
    vm.$onChanges = function (changes) {
      if (changes.siteId.currentValue) {
        vm.imageLink =
          hostProtocol +
          '://' +
          hostDomain +
          '/api/washFacilities/' +
          changes.siteId.currentValue +
          '/image';
        workingSchedulesActions
          .getSiteDetailsById(changes.siteId.currentValue)
          .then(function (response) {
            vm.companyId = response.companyId;
            vm.name = response.name;
            vm.siteLocationLat = response.location.latitude;
            vm.siteLocationLong = response.location.longitude;
            vm.siteAddress = response.address;
            vm.sitePhone1 = response.phone1;
            vm.sitePhone2 = response.phone2;
            vm.siteWebsite = response.website;
            vm.hasChanger = response.changerAvailable;
            vm.offlineAlarmsStatus = response.offlineDeviceAlarmsDisabled;
            vm.siteDescription = response.info;
            vm.siteWorkingHours = response.workingHours;
          });
      } else if (changes.siteId.currentValue === '') {
        vm.companyId = null;
        vm.name = '';
        vm.siteLocationLat = '';
        vm.siteLocationLong = '';
        vm.siteAddress = '';
        vm.sitePhone1 = '';
        vm.sitePhone2 = '';
        vm.siteWebsite = '';
        vm.hasChanger = false;
        vm.offlineAlarmsStatus = false;
        vm.siteDescription = '';
        vm.siteWorkingHours = '';
        vm.imageLink = '/assets/images/noun_59149_cc.svg';
        vm.file = null;
      }
    };

    vm.siteSaveDetails = function () {
      workingSchedulesActions
        .updateSiteDetails(vm.siteId, {
          pointId: vm.siteId,
          location: {
            latitude: vm.siteLocationLat,
            longitude: vm.siteLocationLong
          },
          address: vm.siteAddress,
          phone1: vm.sitePhone1,
          website: vm.siteWebsite,
          info: vm.siteDescription
        })
        .then(function () {});
    };

    vm.submitImage = function () {
      if (vm.file) {
        uploadImage(vm.file);
      }
    };

    function uploadImage(file) {
      Upload.upload({
        url:
          hostProtocol +
          '://' +
          hostDomain +
          '/api/washFacilities/' +
          vm.siteId +
          '/image',
        data: { file: file }
      }).then(
        function (resp) {
          $log.info(
            'Success ' +
              resp.config.data.file.name +
              'uploaded. Response: ' +
              resp.data
          );
          vm.file = null;

          $mdToast.show(
            $mdToast
              .simple()
              .textContent(
                $translate.instant('FACILITY_UPLOAD_IMAGE_NOTIFICATION')
              )
              .position('bottom right')
              .hideDelay(3000)
          );
        },
        function (resp) {
          $log.info('Error status: ' + resp.status);
        },
        function (evt) {
          var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
          $log.info(
            'progress: ' + progressPercentage + '% ' + evt.config.data.file.name
          );
        }
      );
    }
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("holidays", {
    templateUrl: "app/workingSchedulesAndHolidays/holidays/holidays.html",
    controller: holidays,
    bindings: {
      holidaysData: "<",
      siteId: "<",
      activeForm: "<",
      refresh: "&"
    },
    controllerAs: "vm"
  });

  function holidays(
    $mdDialog,
    $translate,
    layoutActions,
    workingSchedulesActions,
    $scope
  ) {
    var vm = this,
      editMode = false,
      holidayId = null;

    vm.holidayList = [];

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      if (changes.holidaysData) {
        vm.holidayList = changes.holidaysData.currentValue;
      } else if (changes.siteId) {
        vm.siteId = changes.siteId.currentValue;
      }
    };

    vm.updateHoliday = function (holiday) {
      editMode = true;
      holidayId = holiday.id;
      vm.holidatDate = holiday.date;
      vm.holidayDescription = holiday.description;
      vm.holidayFixed = holiday.fixed;
      vm.holidayYear = holiday.year;
    };

    vm.resetHolidayInputs = function (form) {
      clearAllHolidaysInputs(form);
    };

    vm.resetYearInput = function() {
      vm.holidayYear = '';
    }

    vm.deleteHoliday = function (ev, holiday) {
      var confirm = $mdDialog
        .confirm()
        .title(
          $translate.instant("DELETE_HOLIDAY") +
            $translate.instant("FOR_DATE") +
            holiday.date +
            $translate.instant("WITH_ID") +
            holiday.id
        )
        .textContent($translate.instant("ARE_YOU_SURE"))
        .ariaLabel("Delete holiday")
        .targetEvent(ev)
        .ok($translate.instant("YES"))
        .cancel($translate.instant("CANCEL"));

      $mdDialog.show(confirm).then(
        function () {
          layoutActions.showLoader();
          workingSchedulesActions
            .deleteHoliday(vm.siteId, holiday.id)
            .then(function () {
              vm.refresh();
              // refreshHolidayList();
            });
        },
        function () {}
      );
    };

    vm.saveHolidays = function () {
      var dataToSave = {
        siteHolidayDtoList: [
          {
            id: editMode ? holidayId : null,
            date: vm.holidatDate,
            description: vm.holidayDescription,
            fixed: vm.holidayFixed,
            year: vm.holidayYear ? vm.holidayYear : "",
            yearPresent: true
          }
        ]
      };

      if (editMode) {
        workingSchedulesActions
          .updateSiteHolidays(vm.siteId, dataToSave)
          .then(function () {
            vm.refresh();
          });
      } else {
        workingSchedulesActions
          .createSiteHolidays(vm.siteId, dataToSave)
          .then(function () {
            vm.refresh();
            // refreshHolidayList();
            clearAllHolidaysInputs($scope.siteHolidaysForm);
          });
      }
    };

    vm.deleteAllHolidays = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant("DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE"))
        .textContent($translate.instant("ARE_YOU_SURE"))
        .ariaLabel("Delete all holidays")
        .targetEvent(ev)
        .ok($translate.instant("YES"))
        .cancel($translate.instant("CANCEL"));

      $mdDialog.show(confirm).then(
        function () {
          layoutActions.showLoader();
          workingSchedulesActions
            .deleteSiteHolidays(vm.siteId)
            .then(function () {
              vm.refresh();
              clearAllHolidaysInputs($scope.siteHolidaysForm);
              layoutActions.hideLoader();
            });
        },
        function () {}
      );
    };

    function clearAllHolidaysInputs(form) {
      editMode = false;
      vm.holidatDate = "";
      vm.holidayDescription = "";
      vm.holidayFixed = "";
      vm.holidayYear = "";
      form.$setPristine();
      form.$setUntouched();
    }
  }
})();

(function() {
    "use strict";

    angular.module("sempraWebapp").component("topupsTransactions", {
        templateUrl: "app/transactions/topups/topupsTransactions.html",
        controller: topupsTransactionsController,
        bindings: {
            email: "<"
        },
        controllerAs: "vm"
    });

    function topupsTransactionsController(transactionsActions, $translate, $timeout) {
        var vm = this;

        vm.$onInit = function() {
            refreshTopups();
        };

        vm.$onChanges = function() {
            $timeout(function() {
                refreshTopups();
            }, 750);
        }

        // DEFAULT DATE
        var currentYear = new Date().getFullYear();
        vm.topupsFrom = new Date(currentYear, 0, 1, 0, 0, 0, 0);
        vm.topupsTo = new Date();

        // GRID CONFIIG
        vm.topupsTransactionOrderBy = "companyName";
        vm.topupsTransactionOrder = "desc";
        vm.topupsTransactionPage = 1;
        vm.topupsTransactionTotal = 0;
        vm.topupsTransactionPageSize = 10;
        vm.topupsTransactionPageOptions = [10, 20];
        vm.selectedtopupsTransaction = [];
        vm.pagerTranslations = {
            page: $translate.instant("GRID_PAGER_PAGE"),
            rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
            of: $translate.instant("GRID_PAGER_PAGE_OF")
        };

        vm.sortChanged = function(order) {
            var orderQuery = getOrderObject(order);
            vm.topupsTransactionOrderBy = orderQuery.orderBy;
            vm.topupsTransactionOrder = orderQuery.order;
            refreshTopups();
        };

        vm.pageChanged = function(page, limit) {
            vm.topupsTransactionPage = page;
            vm.topupsTransactionPageSize = limit;
            vm.sortChanged(vm.topupsTransactionOrderBy);
        };

        vm.search = function() {
            vm.topupsTransactionPage = 1;
            refreshTopups();
        };

        function refreshTopups() {
            var encodeEmail = encodeURIComponent(vm.email);
            vm.promise = transactionsActions
                .getTransactionsTopUps(
                    encodeEmail,
                    vm.topupsFrom.getTime(),
                    vm.topupsTo.getTime(),
                    vm.topupsTransactionPage - 1,
                    vm.topupsTransactionPageSize,
                    vm.topupsTransactionOrderBy,
                    vm.topupsTransactionOrder
                )
                .then(function(data) {
                    vm.topups = (data.content.length === 0) ? [{companyName: $translate.instant("NOTHING_TO_DISPLAY")}] : data.content;
                    vm.topupsTransactionTotal = data.totalElements;
                });
        }

        function getOrderObject(order) {
            var result = {
                order: "asc",
                orderBy: order
            };

            if (order.indexOf("-") > -1) {
                result.order = "desc";
                result.orderBy = order.substring(1);
            }
            return result;
        }
    }
})();

(function() {
    "use strict";

    angular.module("sempraWebapp").component("expensesTransactions", {
        templateUrl: "app/transactions/expenses/expensesTransactions.html",
        controller: expensesTransactionsController,
        bindings: {
            email: "<"
        },
        controllerAs: "vm"
    });

    function expensesTransactionsController(transactionsActions, $translate, $timeout) {
        var vm = this;

        vm.$onInit = function() {
            refreshExpenses();
        };

        vm.$onChanges = function() {
            $timeout(function() {
                refreshExpenses();
            }, 750);
        };

        // DEFAULT DATE
        var currentYear = new Date().getFullYear();
        vm.expensesFrom = new Date(currentYear, 0, 1, 0, 0, 0, 0);
        vm.expensesTo = new Date();

        // GRID CONFIIG
        vm.expensesTransactionOrderBy = "companyName";
        vm.expensesTransactionOrder = "desc";
        vm.expensesTransactionPage = 1;
        vm.expensesTransactionTotal = 0;
        vm.expensesTransactionPageSize = 10;
        vm.expensesTransactionPageOptions = [10, 20];
        vm.selectedexpensesTransaction = [];
        vm.pagerTranslations = {
            page: $translate.instant("GRID_PAGER_PAGE"),
            rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
            of: $translate.instant("GRID_PAGER_PAGE_OF")
        };

        vm.sortChanged = function(order) {
            var orderQuery = getOrderObject(order);
            vm.expensesTransactionOrderBy = orderQuery.orderBy;
            vm.expensesTransactionOrder = orderQuery.order;
            refreshExpenses();
        };

        vm.pageChanged = function(page, limit) {
            vm.expensesTransactionPage = page;
            vm.expensesTransactionPageSize = limit;
            vm.sortChanged(vm.expensesTransactionOrderBy);
        };

        vm.search = function() {
            vm.expensesTransactionPage = 1;
            refreshExpenses();
        };

        function refreshExpenses() {
            var encodeEmail = encodeURIComponent(vm.email);
            vm.promise = transactionsActions
                .getTransactionsExpenses(
                    encodeEmail,
                    vm.expensesFrom.getTime(),
                    vm.expensesTo.getTime(),
                    vm.expensesTransactionPage - 1,
                    vm.expensesTransactionPageSize,
                    vm.expensesTransactionOrderBy,
                    vm.expensesTransactionOrder
                )
                .then(function(data) {
                    vm.expenses = (data.content.length === 0) ? [{companyName: $translate.instant("NOTHING_TO_DISPLAY")}] : data.content;
                    vm.expensesTransactionTotal = data.totalElements;
                });
        }

        function getOrderObject(order) {
            var result = {
                order: "asc",
                orderBy: order
            };

            if (order.indexOf("-") > -1) {
                result.order = "desc";
                result.orderBy = order.substring(1);
            }
            return result;
        }
    }
})();

(function () {

  'use strict';

  angular.module('sempraWebapp').service('webSocketMock', webSocketMock);

  /** @ngInject */
  function webSocketMock() {

    this.initWebSockets = function () {
    };

    this.unsubscribeSocket = function () {
    };

    this.suspendMessages = function () {
    };

    this.isSuspended = function () {
    };

    this.isConnected = function () {
    };

    this.subscribeToTopic = function () {
    };
  }
})();


(function () {
  'use strict';

  angular.module('sempraWebapp').service('webSocketService', webSocketService);

  /** @ngInject */
  function webSocketService(
    $log,
    webSocketActions,
    $timeout,
    api,
    jwtHelper,
    sessionData,
    mqttBrokerIp,
    mqttBrokerPort,
    useMqttBrokerSsl,
    checkUserRole
  ) {
    var that = this,
      isInitialized = false,
      webSocket = {},
      ip = '',
      port = 0,
      isConnected = false,
      isSuspended = false,
      reconnectAttempt = 0,
      subscriptionTopics = [],
      options = {
        timeout: 10,
        onSuccess: onConnectSuccess,
        onFailure: onConnectFail,
        useSSL: true
      },
      MESSAGES = {
        BROKER_CLIENT_ID_PREFIX: 'SempraWebApp_',
        MSG_CONNECTION_CONNECTION_ESTABLISHED: 'Connected to WebSocket',
        MSG_CONNECTION_CONNECTION_LOST: 'Connection lost ',
        MSG_CONNECTION_CONNECTION_ERROR: 'Error connecting to websocket',
        MSG_CONNECTION_RECONNECTING: 'Reconnecting to WebSocket...',
        MSG_CONNECTION_MESSAGE_ARRIVED: 'Updating topic ',
        MSG_SUBSCRIBED_TO_TOPIC: 'Subscribed to ',
        MSG_UNSUBSCRIBED_FROM_TOPIC: 'Unsubscribed from '
      };

    var TOPICS = Object.freeze({
      DEVICE: '',
      FEEDS: '/FEED',
      ACTUATORS: '/ACTUATOR',
      MESSAGES: '/MESSAGE',
      FINANCES: '/FINANCES',
      EVENT: '/EVENT',
      NOTICE: 'NOTICE'
    });

    this.TOPICS = TOPICS;

    this.initWebSockets = function () {
      if (!isInitialized && checkUserRole.userRoleExist()) {
        api.getWebSocketsToken().then(
          function (response) {
            // Set topic list to local storage from token
            var decodedToken = jwtHelper.decodeToken(response.websocketToken);
            sessionData.setValue(
              sessionData.Keys.TOPICS_LIST,
              decodedToken.topics
            );
            ip = mqttBrokerIp ? mqttBrokerIp : ip;
            port = mqttBrokerPort ? mqttBrokerPort : port;
            options.useSSL = useMqttBrokerSsl ? useMqttBrokerSsl : options.useSSL;
            webSocket.socket = new Paho.MQTT.Client(
              ip,
              port,
              getMqttBrokerClientId()
            );
            webSocket.socket.onConnectionLost = onConnectFail;
            webSocket.socket.onMessageArrived = onMessageArrived;
            webSocket.socket.connect({
              timeout: options.timeout,
              onSuccess: onConnectSuccess,
              onFailure: onConnectFail,
              reconnect: true,
              useSSL: options.useSSL,
              userName: response.websocketToken,
              password: '12345'
            });
          },
          function () {
            onConnectFail();
          }
        );
      }
    };

    this.unsubscribeSocket = function () {
      reconnectAttempt = 10;
      if (webSocket.socket) {
        subscriptionTopics.forEach(function (topic) {
          webSocket.socket.unsubscribe(topic);
          $log.info(MESSAGES.MSG_UNSUBSCRIBED_FROM_TOPIC + topic);
        });
        subscriptionTopics = [];
      }
      $log.info('Socket unsubscribed');
    };

    this.disconnectSockets = function () {
      webSocket.socket.disconnect();
      webSocket.socket = null;
      webSocket = {};
      isInitialized = false;
      isConnected = false;
      $log.info('Socket disconnected');
    };

    this.suspendMessages = function (suspended) {
      isSuspended = suspended;
    };

    this.isSuspended = function () {
      return isSuspended;
    };

    this.isConnected = function () {
      return isConnected;
    };

    this.subscribeToTopic = function (deviceSerialArray, topicEnumValue) {
      if (isConnected) {
        if (deviceSerialArray) {
          deviceSerialArray.forEach(function (deviceSerial) {
            var topic = deviceSerial + topicEnumValue;
            webSocket.socket.subscribe(topic, { qos: 1 });
            subscriptionTopics.push(topic);
            $log.info(MESSAGES.MSG_SUBSCRIBED_TO_TOPIC + topic);
          });
        }
      }
    };

    this.subscribeToNoticeTopic = function (topicEnumValue) {
      if (isConnected) {
        webSocket.socket.subscribe(topicEnumValue, { qos: 1 });
        subscriptionTopics.push(topicEnumValue);
        $log.info(MESSAGES.MSG_SUBSCRIBED_TO_TOPIC + topicEnumValue);
      }
    };

    this.subscribeToDeviceChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.DEVICE);
    };

    this.subscribeToFinanceChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.FINANCES);
    };

    this.subscribeToMessageChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.MESSAGES);
    };

    this.subscribeToActuatorChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.ACTUATORS);
    };

    this.subscribeToFeedChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.FEEDS);
    };

    this.subscribeToEventChanges = function (deviceSerialArray) {
      this.subscribeToTopic(deviceSerialArray, TOPICS.EVENT);
    };

    this.subscribeToNoticeChanges = function () {
      this.subscribeToNoticeTopic(TOPICS.NOTICE);
    };

    function getMqttBrokerClientId() {
      return (
        MESSAGES.BROKER_CLIENT_ID_PREFIX + parseInt(Math.random() * 100, 10)
      );
    }

    function onConnectSuccess() {
      isInitialized = true;
      isConnected = true;
      reconnectAttempt = 0;
      webSocketActions.notifyConnectionChange(true);
      $log.info(MESSAGES.MSG_CONNECTION_CONNECTION_ESTABLISHED);
    }

    function onConnectFail() {
      isConnected = false;
      isInitialized = false;
      $log.error(MESSAGES.MSG_CONNECTION_CONNECTION_LOST);
      if (reconnectAttempt < 6) {
        $timeout(reconnect, 10000);
      } else {
        webSocketActions.notifyConnectionChange(false);
      }
    }

    function onMessageArrived(message) {
      if (!isSuspended) {
        $log.info(
          MESSAGES.MSG_CONNECTION_MESSAGE_ARRIVED + message.payloadString
        );
        if (message.destinationName.indexOf(TOPICS.FEEDS) >= 0) {
          webSocketActions.notifyDeviceFeedChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.ACTUATORS) >= 0) {
          webSocketActions.notifyDeviceActuatorChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.MESSAGES) >= 0) {
          webSocketActions.notifyMessagesChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.FINANCES) >= 0) {
          webSocketActions.notifyFinancesChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.NOTICE) >= 0) {
          webSocketActions.notifyNoticeChange(
            getPayload(message.payloadString)
          );
        } else if (message.destinationName.indexOf(TOPICS.EVENT) >= 0) {
          webSocketActions.notifyDeviceEventChange(
            getPayload(message.payloadString)
          );
        } else {
          webSocketActions.notifyDeviceChange(
            getPayload(message.payloadString)
          );
        }
      }
    }

    function getPayload(message) {
      /* eslint-disable */
      var messageJson = JSON.parse(message);
      /* eslint-enable */
      return messageJson;
    }

    function reconnect() {
      if (!isConnected) {
        $log.info(MESSAGES.MSG_CONNECTION_RECONNECTING);
        reconnectAttempt++;
        that.initWebSockets();
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').provider('broker', webSocketProvider);

  /** @ngInject */
  function webSocketProvider () {
    this.$get = ['webSocketService', 'webSocketMock', 'useMqttBroker', function (webSocketService, webSocketMock, useMqttBroker) {
      if (useMqttBroker) {
        return webSocketService;
      } else {
        return webSocketMock;
      }
    }];
  }
})();

/* eslint-disable */
/*******************************************************************************
 * Copyright (c) 2013 IBM Corp.
 *
 * All rights reserved. This program and the accompanying materials
 * are made available under the terms of the Eclipse Public License v1.0
 * and Eclipse Distribution License v1.0 which accompany this distribution.
 *
 * The Eclipse Public License is available at
 *    http://www.eclipse.org/legal/epl-v10.html
 * and the Eclipse Distribution License is available at
 *   http://www.eclipse.org/org/documents/edl-v10.php.
 *
 * Contributors:
 *    Andrew Banks - initial API and implementation and initial documentation
 *******************************************************************************/
// Only expose a single object name in the global namespace.
// Everything must go through this module. Global Paho.MQTT module
// only has a single public function, client, which returns
// a Paho.MQTT client object given connection details.
/**
 * Send and receive messages using web browsers.
 * <p>
 * This programming interface lets a JavaScript client application use the MQTT V3.1 or
 * V3.1.1 protocol to connect to an MQTT-supporting messaging server.
 *
 * The function supported includes:
 * <ol>
 * <li>Connecting to and disconnecting from a server. The server is identified by its host name and port number.
 * <li>Specifying options that relate to the communications link with the server,
 * for example the frequency of keep-alive heartbeats, and whether SSL/TLS is required.
 * <li>Subscribing to and receiving messages from MQTT Topics.
 * <li>Publishing messages to MQTT Topics.
 * </ol>
 * <p>
 * The API consists of two main objects:
 * <dl>
 * <dt><b>{@link Paho.MQTT.Client}</b></dt>
 * <dd>This contains methods that provide the functionality of the API,
 * including provision of callbacks that notify the application when a message
 * arrives from or is delivered to the messaging server,
 * or when the status of its connection to the messaging server changes.</dd>
 * <dt><b>{@link Paho.MQTT.Message}</b></dt>
 * <dd>This encapsulates the payload of the message along with various attributes
 * associated with its delivery, in particular the destination to which it has
 * been (or is about to be) sent.</dd>
 * </dl>
 * <p>
 * The programming interface validates parameters passed to it, and will throw
 * an Error containing an error message intended for developer use, if it detects
 * an error with any parameter.
 * <p>
 * Example:
 *
 * <code><pre>
 client = new Paho.MQTT.Client(location.hostname, Number(location.port), "clientId");
 client.onConnectionLost = onConnectionLost;
 client.onMessageArrived = onMessageArrived;
 client.connect({onSuccess:onConnect});
 function onConnect() {
 // Once a connection has been made, make a subscription and send a message.
 console.log("onConnect");
 client.subscribe("/World");
 message = new Paho.MQTT.Message("Hello");
 message.destinationName = "/World";
 client.send(message);
 };
 function onConnectionLost(responseObject) {
 if (responseObject.errorCode !== 0)
 console.log("onConnectionLost:"+responseObject.errorMessage);
 };
 function onMessageArrived(message) {
 console.log("onMessageArrived:"+message.payloadString);
 client.disconnect();
 };
 * </pre></code>
 * @namespace Paho.MQTT
 */
/* jshint shadow:true */
(function ExportLibrary(root, factory) {
  if(typeof exports === 'object' && typeof module === 'object'){
    module.exports = factory();
  } else if (typeof define === 'function' && define.amd){
    define(factory);
  } else if (typeof exports === 'object'){
    exports = factory();
  } else {
    if (typeof root.Paho === 'undefined'){
      root.Paho = {};
    }
    root.Paho.MQTT = factory();
  }
})(this, function LibraryFactory(){
  var PahoMQTT = (function (global) {
    // Private variables below, these are only visible inside the function closure
    // which is used to define the module.
    var version = "@VERSION@";
    var buildLevel = "@BUILDLEVEL@";
    /**
     * Unique message type identifiers, with associated
     * associated integer values.
     * @private
     */
    var MESSAGE_TYPE = {
      CONNECT: 1,
      CONNACK: 2,
      PUBLISH: 3,
      PUBACK: 4,
      PUBREC: 5,
      PUBREL: 6,
      PUBCOMP: 7,
      SUBSCRIBE: 8,
      SUBACK: 9,
      UNSUBSCRIBE: 10,
      UNSUBACK: 11,
      PINGREQ: 12,
      PINGRESP: 13,
      DISCONNECT: 14
    };
    // Collection of utility methods used to simplify module code
    // and promote the DRY pattern.
    /**
     * Validate an object's parameter names to ensure they
     * match a list of expected variables name for this option
     * type. Used to ensure option object passed into the API don't
     * contain erroneous parameters.
     * @param {Object} obj - User options object
     * @param {Object} keys - valid keys and types that may exist in obj.
     * @throws {Error} Invalid option parameter found.
     * @private
     */
    var validate = function(obj, keys) {
      for (var key in obj) {
        if (obj.hasOwnProperty(key)) {
          if (keys.hasOwnProperty(key)) {
            if (typeof obj[key] !== keys[key])
              throw new Error(format(ERROR.INVALID_TYPE, [typeof obj[key], key]));
          } else {
            var errorStr = "Unknown property, " + key + ". Valid properties are:";
            for (var validKey in keys)
              if (keys.hasOwnProperty(validKey))
                errorStr = errorStr+" "+validKey;
            throw new Error(errorStr);
          }
        }
      }
    };
    /**
     * Return a new function which runs the user function bound
     * to a fixed scope.
     * @param {function} User function
     * @param {object} Function scope
     * @return {function} User function bound to another scope
     * @private
     */
    var scope = function (f, scope) {
      return function () {
        return f.apply(scope, arguments);
      };
    };
    /**
     * Unique message type identifiers, with associated
     * associated integer values.
     * @private
     */
    var ERROR = {
      OK: {code:0, text:"AMQJSC0000I OK."},
      CONNECT_TIMEOUT: {code:1, text:"AMQJSC0001E Connect timed out."},
      SUBSCRIBE_TIMEOUT: {code:2, text:"AMQJS0002E Subscribe timed out."},
      UNSUBSCRIBE_TIMEOUT: {code:3, text:"AMQJS0003E Unsubscribe timed out."},
      PING_TIMEOUT: {code:4, text:"AMQJS0004E Ping timed out."},
      INTERNAL_ERROR: {code:5, text:"AMQJS0005E Internal error. Error Message: {0}, Stack trace: {1}"},
      CONNACK_RETURNCODE: {code:6, text:"AMQJS0006E Bad Connack return code:{0} {1}."},
      SOCKET_ERROR: {code:7, text:"AMQJS0007E Socket error:{0}."},
      SOCKET_CLOSE: {code:8, text:"AMQJS0008I Socket closed."},
      MALFORMED_UTF: {code:9, text:"AMQJS0009E Malformed UTF data:{0} {1} {2}."},
      UNSUPPORTED: {code:10, text:"AMQJS0010E {0} is not supported by this browser."},
      INVALID_STATE: {code:11, text:"AMQJS0011E Invalid state {0}."},
      INVALID_TYPE: {code:12, text:"AMQJS0012E Invalid type {0} for {1}."},
      INVALID_ARGUMENT: {code:13, text:"AMQJS0013E Invalid argument {0} for {1}."},
      UNSUPPORTED_OPERATION: {code:14, text:"AMQJS0014E Unsupported operation."},
      INVALID_STORED_DATA: {code:15, text:"AMQJS0015E Invalid data in local storage key={0} value={1}."},
      INVALID_MQTT_MESSAGE_TYPE: {code:16, text:"AMQJS0016E Invalid MQTT message type {0}."},
      MALFORMED_UNICODE: {code:17, text:"AMQJS0017E Malformed Unicode string:{0} {1}."},
      BUFFER_FULL: {code:18, text:"AMQJS0018E Message buffer is full, maximum buffer size: {0}."},
    };
    /** CONNACK RC Meaning. */
    var CONNACK_RC = {
      0:"Connection Accepted",
      1:"Connection Refused: unacceptable protocol version",
      2:"Connection Refused: identifier rejected",
      3:"Connection Refused: server unavailable",
      4:"Connection Refused: bad user name or password",
      5:"Connection Refused: not authorized"
    };
    /**
     * Format an error message text.
     * @private
     * @param {error} ERROR.KEY value above.
     * @param {substitutions} [array] substituted into the text.
     * @return the text with the substitutions made.
     */
    var format = function(error, substitutions) {
      var text = error.text;
      if (substitutions) {
        var field,start;
        for (var i=0; i<substitutions.length; i++) {
          field = "{"+i+"}";
          start = text.indexOf(field);
          if(start > 0) {
            var part1 = text.substring(0,start);
            var part2 = text.substring(start+field.length);
            text = part1+substitutions[i]+part2;
          }
        }
      }
      return text;
    };
    //MQTT protocol and version          6    M    Q    I    s    d    p    3
    var MqttProtoIdentifierv3 = [0x00,0x06,0x4d,0x51,0x49,0x73,0x64,0x70,0x03];
    //MQTT proto/version for 311         4    M    Q    T    T    4
    var MqttProtoIdentifierv4 = [0x00,0x04,0x4d,0x51,0x54,0x54,0x04];
    /**
     * Construct an MQTT wire protocol message.
     * @param type MQTT packet type.
     * @param options optional wire message attributes.
     *
     * Optional properties
     *
     * messageIdentifier: message ID in the range [0..65535]
     * payloadMessage:	Application Message - PUBLISH only
     * connectStrings:	array of 0 or more Strings to be put into the CONNECT payload
     * topics:			array of strings (SUBSCRIBE, UNSUBSCRIBE)
     * requestQoS:		array of QoS values [0..2]
     *
     * "Flag" properties
     * cleanSession:	true if present / false if absent (CONNECT)
     * willMessage:  	true if present / false if absent (CONNECT)
     * isRetained:		true if present / false if absent (CONNECT)
     * userName:		true if present / false if absent (CONNECT)
     * password:		true if present / false if absent (CONNECT)
     * keepAliveInterval:	integer [0..65535]  (CONNECT)
     *
     * @private
     * @ignore
     */
    var WireMessage = function (type, options) {
      this.type = type;
      for (var name in options) {
        if (options.hasOwnProperty(name)) {
          this[name] = options[name];
        }
      }
    };
    WireMessage.prototype.encode = function() {
      // Compute the first byte of the fixed header
      var first = ((this.type & 0x0f) << 4);
      /*
       * Now calculate the length of the variable header + payload by adding up the lengths
       * of all the component parts
       */
      var remLength = 0;
      var topicStrLength = [];
      var destinationNameLength = 0;
      var willMessagePayloadBytes;
      // if the message contains a messageIdentifier then we need two bytes for that
      if (this.messageIdentifier !== undefined)
        remLength += 2;
      switch(this.type) {
          // If this a Connect then we need to include 12 bytes for its header
        case MESSAGE_TYPE.CONNECT:
          switch(this.mqttVersion) {
            case 3:
              remLength += MqttProtoIdentifierv3.length + 3;
              break;
            case 4:
              remLength += MqttProtoIdentifierv4.length + 3;
              break;
          }
          remLength += UTF8Length(this.clientId) + 2;
          if (this.willMessage !== undefined) {
            remLength += UTF8Length(this.willMessage.destinationName) + 2;
            // Will message is always a string, sent as UTF-8 characters with a preceding length.
            willMessagePayloadBytes = this.willMessage.payloadBytes;
            if (!(willMessagePayloadBytes instanceof Uint8Array))
              willMessagePayloadBytes = new Uint8Array(payloadBytes);
            remLength += willMessagePayloadBytes.byteLength +2;
          }
          if (this.userName !== undefined)
            remLength += UTF8Length(this.userName) + 2;
          if (this.password !== undefined)
            remLength += UTF8Length(this.password) + 2;
          break;
          // Subscribe, Unsubscribe can both contain topic strings
        case MESSAGE_TYPE.SUBSCRIBE:
          first |= 0x02; // Qos = 1;
          for ( var i = 0; i < this.topics.length; i++) {
            topicStrLength[i] = UTF8Length(this.topics[i]);
            remLength += topicStrLength[i] + 2;
          }
          remLength += this.requestedQos.length; // 1 byte for each topic's Qos
          // QoS on Subscribe only
          break;
        case MESSAGE_TYPE.UNSUBSCRIBE:
          first |= 0x02; // Qos = 1;
          for ( var i = 0; i < this.topics.length; i++) {
            topicStrLength[i] = UTF8Length(this.topics[i]);
            remLength += topicStrLength[i] + 2;
          }
          break;
        case MESSAGE_TYPE.PUBREL:
          first |= 0x02; // Qos = 1;
          break;
        case MESSAGE_TYPE.PUBLISH:
          if (this.payloadMessage.duplicate) first |= 0x08;
          first  = first |= (this.payloadMessage.qos << 1);
          if (this.payloadMessage.retained) first |= 0x01;
          destinationNameLength = UTF8Length(this.payloadMessage.destinationName);
          remLength += destinationNameLength + 2;
          var payloadBytes = this.payloadMessage.payloadBytes;
          remLength += payloadBytes.byteLength;
          if (payloadBytes instanceof ArrayBuffer)
            payloadBytes = new Uint8Array(payloadBytes);
          else if (!(payloadBytes instanceof Uint8Array))
            payloadBytes = new Uint8Array(payloadBytes.buffer);
          break;
        case MESSAGE_TYPE.DISCONNECT:
          break;
        default:
          break;
      }
      // Now we can allocate a buffer for the message
      var mbi = encodeMBI(remLength);  // Convert the length to MQTT MBI format
      var pos = mbi.length + 1;        // Offset of start of variable header
      var buffer = new ArrayBuffer(remLength + pos);
      var byteStream = new Uint8Array(buffer);    // view it as a sequence of bytes
      //Write the fixed header into the buffer
      byteStream[0] = first;
      byteStream.set(mbi,1);
      // If this is a PUBLISH then the variable header starts with a topic
      if (this.type == MESSAGE_TYPE.PUBLISH)
        pos = writeString(this.payloadMessage.destinationName, destinationNameLength, byteStream, pos);
      // If this is a CONNECT then the variable header contains the protocol name/version, flags and keepalive time
      else if (this.type == MESSAGE_TYPE.CONNECT) {
        switch (this.mqttVersion) {
          case 3:
            byteStream.set(MqttProtoIdentifierv3, pos);
            pos += MqttProtoIdentifierv3.length;
            break;
          case 4:
            byteStream.set(MqttProtoIdentifierv4, pos);
            pos += MqttProtoIdentifierv4.length;
            break;
        }
        var connectFlags = 0;
        if (this.cleanSession)
          connectFlags = 0x02;
        if (this.willMessage !== undefined ) {
          connectFlags |= 0x04;
          connectFlags |= (this.willMessage.qos<<3);
          if (this.willMessage.retained) {
            connectFlags |= 0x20;
          }
        }
        if (this.userName !== undefined)
          connectFlags |= 0x80;
        if (this.password !== undefined)
          connectFlags |= 0x40;
        byteStream[pos++] = connectFlags;
        pos = writeUint16 (this.keepAliveInterval, byteStream, pos);
      }
      // Output the messageIdentifier - if there is one
      if (this.messageIdentifier !== undefined)
        pos = writeUint16 (this.messageIdentifier, byteStream, pos);
      switch(this.type) {
        case MESSAGE_TYPE.CONNECT:
          pos = writeString(this.clientId, UTF8Length(this.clientId), byteStream, pos);
          if (this.willMessage !== undefined) {
            pos = writeString(this.willMessage.destinationName, UTF8Length(this.willMessage.destinationName), byteStream, pos);
            pos = writeUint16(willMessagePayloadBytes.byteLength, byteStream, pos);
            byteStream.set(willMessagePayloadBytes, pos);
            pos += willMessagePayloadBytes.byteLength;
          }
          if (this.userName !== undefined)
            pos = writeString(this.userName, UTF8Length(this.userName), byteStream, pos);
          if (this.password !== undefined)
            pos = writeString(this.password, UTF8Length(this.password), byteStream, pos);
          break;
        case MESSAGE_TYPE.PUBLISH:
          // PUBLISH has a text or binary payload, if text do not add a 2 byte length field, just the UTF characters.
          byteStream.set(payloadBytes, pos);
          break;
//    	    case MESSAGE_TYPE.PUBREC:
//    	    case MESSAGE_TYPE.PUBREL:
//    	    case MESSAGE_TYPE.PUBCOMP:
//    	    	break;
        case MESSAGE_TYPE.SUBSCRIBE:
          // SUBSCRIBE has a list of topic strings and request QoS
          for (var i=0; i<this.topics.length; i++) {
            pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
            byteStream[pos++] = this.requestedQos[i];
          }
          break;
        case MESSAGE_TYPE.UNSUBSCRIBE:
          // UNSUBSCRIBE has a list of topic strings
          for (var i=0; i<this.topics.length; i++)
            pos = writeString(this.topics[i], topicStrLength[i], byteStream, pos);
          break;
        default:
          // Do nothing.
      }
      return buffer;
    };
    function decodeMessage(input,pos) {
      var startingPos = pos;
      var first = input[pos];
      var type = first >> 4;
      var messageInfo = first &= 0x0f;
      pos += 1;
      // Decode the remaining length (MBI format)
      var digit;
      var remLength = 0;
      var multiplier = 1;
      do {
        if (pos == input.length) {
          return [null,startingPos];
        }
        digit = input[pos++];
        remLength += ((digit & 0x7F) * multiplier);
        multiplier *= 128;
      } while ((digit & 0x80) !== 0);
      var endPos = pos+remLength;
      if (endPos > input.length) {
        return [null,startingPos];
      }
      var wireMessage = new WireMessage(type);
      switch(type) {
        case MESSAGE_TYPE.CONNACK:
          var connectAcknowledgeFlags = input[pos++];
          if (connectAcknowledgeFlags & 0x01)
            wireMessage.sessionPresent = true;
          wireMessage.returnCode = input[pos++];
          break;
        case MESSAGE_TYPE.PUBLISH:
          var qos = (messageInfo >> 1) & 0x03;
          var len = readUint16(input, pos);
          pos += 2;
          var topicName = parseUTF8(input, pos, len);
          pos += len;
          // If QoS 1 or 2 there will be a messageIdentifier
          if (qos > 0) {
            wireMessage.messageIdentifier = readUint16(input, pos);
            pos += 2;
          }
          var message = new Paho.MQTT.Message(input.subarray(pos, endPos));
          if ((messageInfo & 0x01) == 0x01)
            message.retained = true;
          if ((messageInfo & 0x08) == 0x08)
            message.duplicate =  true;
          message.qos = qos;
          message.destinationName = topicName;
          wireMessage.payloadMessage = message;
          break;
        case  MESSAGE_TYPE.PUBACK:
        case  MESSAGE_TYPE.PUBREC:
        case  MESSAGE_TYPE.PUBREL:
        case  MESSAGE_TYPE.PUBCOMP:
        case  MESSAGE_TYPE.UNSUBACK:
          wireMessage.messageIdentifier = readUint16(input, pos);
          break;
        case  MESSAGE_TYPE.SUBACK:
          wireMessage.messageIdentifier = readUint16(input, pos);
          pos += 2;
          wireMessage.returnCode = input.subarray(pos, endPos);
          break;
        default:
          break;
      }
      return [wireMessage,endPos];
    }
    function writeUint16(input, buffer, offset) {
      buffer[offset++] = input >> 8;      //MSB
      buffer[offset++] = input % 256;     //LSB
      return offset;
    }
    function writeString(input, utf8Length, buffer, offset) {
      offset = writeUint16(utf8Length, buffer, offset);
      stringToUTF8(input, buffer, offset);
      return offset + utf8Length;
    }
    function readUint16(buffer, offset) {
      return 256*buffer[offset] + buffer[offset+1];
    }
    /**
     * Encodes an MQTT Multi-Byte Integer
     * @private
     */
    function encodeMBI(number) {
      var output = new Array(1);
      var numBytes = 0;
      do {
        var digit = number % 128;
        number = number >> 7;
        if (number > 0) {
          digit |= 0x80;
        }
        output[numBytes++] = digit;
      } while ( (number > 0) && (numBytes<4) );
      return output;
    }
    /**
     * Takes a String and calculates its length in bytes when encoded in UTF8.
     * @private
     */
    function UTF8Length(input) {
      var output = 0;
      for (var i = 0; i<input.length; i++)
      {
        var charCode = input.charCodeAt(i);
        if (charCode > 0x7FF)
        {
          // Surrogate pair means its a 4 byte character
          if (0xD800 <= charCode && charCode <= 0xDBFF)
          {
            i++;
            output++;
          }
          output +=3;
        }
        else if (charCode > 0x7F)
          output +=2;
        else
          output++;
      }
      return output;
    }
    /**
     * Takes a String and writes it into an array as UTF8 encoded bytes.
     * @private
     */
    function stringToUTF8(input, output, start) {
      var pos = start;
      for (var i = 0; i<input.length; i++) {
        var charCode = input.charCodeAt(i);
        // Check for a surrogate pair.
        if (0xD800 <= charCode && charCode <= 0xDBFF) {
          var lowCharCode = input.charCodeAt(++i);
          if (isNaN(lowCharCode)) {
            throw new Error(format(ERROR.MALFORMED_UNICODE, [charCode, lowCharCode]));
          }
          charCode = ((charCode - 0xD800)<<10) + (lowCharCode - 0xDC00) + 0x10000;
        }
        if (charCode <= 0x7F) {
          output[pos++] = charCode;
        } else if (charCode <= 0x7FF) {
          output[pos++] = charCode>>6  & 0x1F | 0xC0;
          output[pos++] = charCode     & 0x3F | 0x80;
        } else if (charCode <= 0xFFFF) {
          output[pos++] = charCode>>12 & 0x0F | 0xE0;
          output[pos++] = charCode>>6  & 0x3F | 0x80;
          output[pos++] = charCode     & 0x3F | 0x80;
        } else {
          output[pos++] = charCode>>18 & 0x07 | 0xF0;
          output[pos++] = charCode>>12 & 0x3F | 0x80;
          output[pos++] = charCode>>6  & 0x3F | 0x80;
          output[pos++] = charCode     & 0x3F | 0x80;
        }
      }
      return output;
    }
    function parseUTF8(input, offset, length) {
      var output = "";
      var utf16;
      var pos = offset;
      while (pos < offset+length)
      {
        var byte1 = input[pos++];
        if (byte1 < 128)
          utf16 = byte1;
        else
        {
          var byte2 = input[pos++]-128;
          if (byte2 < 0)
            throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16),""]));
          if (byte1 < 0xE0)             // 2 byte character
            utf16 = 64*(byte1-0xC0) + byte2;
          else
          {
            var byte3 = input[pos++]-128;
            if (byte3 < 0)
              throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16)]));
            if (byte1 < 0xF0)        // 3 byte character
              utf16 = 4096*(byte1-0xE0) + 64*byte2 + byte3;
            else
            {
              var byte4 = input[pos++]-128;
              if (byte4 < 0)
                throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16), byte4.toString(16)]));
              if (byte1 < 0xF8)        // 4 byte character
                utf16 = 262144*(byte1-0xF0) + 4096*byte2 + 64*byte3 + byte4;
              else                     // longer encodings are not supported
                throw new Error(format(ERROR.MALFORMED_UTF, [byte1.toString(16), byte2.toString(16), byte3.toString(16), byte4.toString(16)]));
            }
          }
        }
        if (utf16 > 0xFFFF)   // 4 byte character - express as a surrogate pair
        {
          utf16 -= 0x10000;
          output += String.fromCharCode(0xD800 + (utf16 >> 10)); // lead character
          utf16 = 0xDC00 + (utf16 & 0x3FF);  // trail character
        }
        output += String.fromCharCode(utf16);
      }
      return output;
    }
    /**
     * Repeat keepalive requests, monitor responses.
     * @ignore
     */
    var Pinger = function(client, window, keepAliveInterval) {
      this._client = client;
      this._window = window;
      this._keepAliveInterval = keepAliveInterval*1000;
      this.isReset = false;
      var pingReq = new WireMessage(MESSAGE_TYPE.PINGREQ).encode();
      var doTimeout = function (pinger) {
        return function () {
          return doPing.apply(pinger);
        };
      };
      /** @ignore */
      var doPing = function() {
        if (!this.isReset) {
          this._client._trace("Pinger.doPing", "Timed out");
          this._client._disconnected( ERROR.PING_TIMEOUT.code , format(ERROR.PING_TIMEOUT));
        } else {
          this.isReset = false;
          this._client._trace("Pinger.doPing", "send PINGREQ");
          this._client.socket.send(pingReq);
          this.timeout = this._window.setTimeout(doTimeout(this), this._keepAliveInterval);
        }
      };
      this.reset = function() {
        this.isReset = true;
        this._window.clearTimeout(this.timeout);
        if (this._keepAliveInterval > 0)
          this.timeout = setTimeout(doTimeout(this), this._keepAliveInterval);
      };
      this.cancel = function() {
        this._window.clearTimeout(this.timeout);
      };
    };
    /**
     * Monitor request completion.
     * @ignore
     */
    var Timeout = function(client, window, timeoutSeconds, action, args) {
      this._window = window;
      if (!timeoutSeconds)
        timeoutSeconds = 30;
      var doTimeout = function (action, client, args) {
        return function () {
          return action.apply(client, args);
        };
      };
      this.timeout = setTimeout(doTimeout(action, client, args), timeoutSeconds * 1000);
      this.cancel = function() {
        this._window.clearTimeout(this.timeout);
      };
    };
    /*
     * Internal implementation of the Websockets MQTT V3.1 client.
     *
     * @name Paho.MQTT.ClientImpl @constructor
     * @param {String} host the DNS nameof the webSocket host.
     * @param {Number} port the port number for that host.
     * @param {String} clientId the MQ client identifier.
     */
    var ClientImpl = function (uri, host, port, path, clientId) {
      // Check dependencies are satisfied in this browser.
      if (!("WebSocket" in global && global.WebSocket !== null)) {
        throw new Error(format(ERROR.UNSUPPORTED, ["WebSocket"]));
      }
      if (!("localStorage" in global && global.localStorage !== null)) {
        throw new Error(format(ERROR.UNSUPPORTED, ["localStorage"]));
      }
      if (!("ArrayBuffer" in global && global.ArrayBuffer !== null)) {
        throw new Error(format(ERROR.UNSUPPORTED, ["ArrayBuffer"]));
      }
      this._trace("Paho.MQTT.Client", uri, host, port, path, clientId);
      this.host = host;
      this.port = port;
      this.path = path;
      this.uri = uri;
      this.clientId = clientId;
      this._wsuri = null;
      // Local storagekeys are qualified with the following string.
      // The conditional inclusion of path in the key is for backward
      // compatibility to when the path was not configurable and assumed to
      // be /mqtt
      this._localKey=host+":"+port+(path!="/mqtt"?":"+path:"")+":"+clientId+":";
      // Create private instance-only message queue
      // Internal queue of messages to be sent, in sending order.
      this._msg_queue = [];
      this._buffered_msg_queue = [];
      // Messages we have sent and are expecting a response for, indexed by their respective message ids.
      this._sentMessages = {};
      // Messages we have received and acknowleged and are expecting a confirm message for
      // indexed by their respective message ids.
      this._receivedMessages = {};
      // Internal list of callbacks to be executed when messages
      // have been successfully sent over web socket, e.g. disconnect
      // when it doesn't have to wait for ACK, just message is dispatched.
      this._notify_msg_sent = {};
      // Unique identifier for SEND messages, incrementing
      // counter as messages are sent.
      this._message_identifier = 1;
      // Used to determine the transmission sequence of stored sent messages.
      this._sequence = 0;
      // Load the local state, if any, from the saved version, only restore state relevant to this client.
      for (var key in localStorage)
        if (   key.indexOf("Sent:"+this._localKey) === 0 || key.indexOf("Received:"+this._localKey) === 0)
          this.restore(key);
    };
    // Messaging Client public instance members.
    ClientImpl.prototype.host = null;
    ClientImpl.prototype.port = null;
    ClientImpl.prototype.path = null;
    ClientImpl.prototype.uri = null;
    ClientImpl.prototype.clientId = null;
    // Messaging Client private instance members.
    ClientImpl.prototype.socket = null;
    /* true once we have received an acknowledgement to a CONNECT packet. */
    ClientImpl.prototype.connected = false;
    /* The largest message identifier allowed, may not be larger than 2**16 but
     * if set smaller reduces the maximum number of outbound messages allowed.
     */
    ClientImpl.prototype.maxMessageIdentifier = 65536;
    ClientImpl.prototype.connectOptions = null;
    ClientImpl.prototype.hostIndex = null;
    ClientImpl.prototype.onConnected = null;
    ClientImpl.prototype.onConnectionLost = null;
    ClientImpl.prototype.onMessageDelivered = null;
    ClientImpl.prototype.onMessageArrived = null;
    ClientImpl.prototype.traceFunction = null;
    ClientImpl.prototype._msg_queue = null;
    ClientImpl.prototype._buffered_msg_queue = null;
    ClientImpl.prototype._connectTimeout = null;
    /* The sendPinger monitors how long we allow before we send data to prove to the server that we are alive. */
    ClientImpl.prototype.sendPinger = null;
    /* The receivePinger monitors how long we allow before we require evidence that the server is alive. */
    ClientImpl.prototype.receivePinger = null;
    ClientImpl.prototype._reconnectInterval = 1; // Reconnect Delay, starts at 1 second
    ClientImpl.prototype._reconnecting = false;
    ClientImpl.prototype._reconnectTimeout = null;
    ClientImpl.prototype.disconnectedPublishing = false;
    ClientImpl.prototype.disconnectedBufferSize = 5000;
    ClientImpl.prototype.receiveBuffer = null;
    ClientImpl.prototype._traceBuffer = null;
    ClientImpl.prototype._MAX_TRACE_ENTRIES = 100;
    ClientImpl.prototype.connect = function (connectOptions) {
      var connectOptionsMasked = this._traceMask(connectOptions, "password");
      this._trace("Client.connect", connectOptionsMasked, this.socket, this.connected);
      if (this.connected)
        throw new Error(format(ERROR.INVALID_STATE, ["already connected"]));
      if (this.socket)
        throw new Error(format(ERROR.INVALID_STATE, ["already connected"]));
      if (this._reconnecting) {
        // connect() function is called while reconnect is in progress.
        // Terminate the auto reconnect process to use new connect options.
        this._reconnectTimeout.cancel();
        this._reconnectTimeout = null;
        this._reconnecting = false;
      }
      this.connectOptions = connectOptions;
      this._reconnectInterval = 1;
      this._reconnecting = false;
      if (connectOptions.uris) {
        this.hostIndex = 0;
        this._doConnect(connectOptions.uris[0]);
      } else {
        this._doConnect(this.uri);
      }
    };
    ClientImpl.prototype.subscribe = function (filter, subscribeOptions) {
      this._trace("Client.subscribe", filter, subscribeOptions);
      if (!this.connected)
        throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));
      var wireMessage = new WireMessage(MESSAGE_TYPE.SUBSCRIBE);
      wireMessage.topics=[filter];
      if (subscribeOptions.qos !== undefined)
        wireMessage.requestedQos = [subscribeOptions.qos];
      else
        wireMessage.requestedQos = [0];
      if (subscribeOptions.onSuccess) {
        wireMessage.onSuccess = function(grantedQos) {subscribeOptions.onSuccess({invocationContext:subscribeOptions.invocationContext,grantedQos:grantedQos});};
      }
      if (subscribeOptions.onFailure) {
        wireMessage.onFailure = function(errorCode) {subscribeOptions.onFailure({invocationContext:subscribeOptions.invocationContext,errorCode:errorCode, errorMessage:format(errorCode)});};
      }
      if (subscribeOptions.timeout) {
        wireMessage.timeOut = new Timeout(this, window, subscribeOptions.timeout, subscribeOptions.onFailure,
            [{invocationContext:subscribeOptions.invocationContext,
              errorCode:ERROR.SUBSCRIBE_TIMEOUT.code,
              errorMessage:format(ERROR.SUBSCRIBE_TIMEOUT)}]);
      }
      // All subscriptions return a SUBACK.
      this._requires_ack(wireMessage);
      this._schedule_message(wireMessage);
    };
    /** @ignore */
    ClientImpl.prototype.unsubscribe = function(filter, unsubscribeOptions) {
      this._trace("Client.unsubscribe", filter, unsubscribeOptions);
      if (!this.connected)
        throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));
      var wireMessage = new WireMessage(MESSAGE_TYPE.UNSUBSCRIBE);
      wireMessage.topics = [filter];
      if (unsubscribeOptions.onSuccess) {
        wireMessage.callback = function() {unsubscribeOptions.onSuccess({invocationContext:unsubscribeOptions.invocationContext});};
      }
      if (unsubscribeOptions.timeout) {
        wireMessage.timeOut = new Timeout(this, window, unsubscribeOptions.timeout, unsubscribeOptions.onFailure,
            [{invocationContext:unsubscribeOptions.invocationContext,
              errorCode:ERROR.UNSUBSCRIBE_TIMEOUT.code,
              errorMessage:format(ERROR.UNSUBSCRIBE_TIMEOUT)}]);
      }
      // All unsubscribes return a SUBACK.
      this._requires_ack(wireMessage);
      this._schedule_message(wireMessage);
    };
    ClientImpl.prototype.send = function (message) {
      this._trace("Client.send", message);
      wireMessage = new WireMessage(MESSAGE_TYPE.PUBLISH);
      wireMessage.payloadMessage = message;
      if (this.connected) {
        // Mark qos 1 & 2 message as "ACK required"
        // For qos 0 message, invoke onMessageDelivered callback if there is one.
        // Then schedule the message.
        if (message.qos > 0) {
          this._requires_ack(wireMessage);
        } else if (this.onMessageDelivered) {
          this._notify_msg_sent[wireMessage] = this.onMessageDelivered(wireMessage.payloadMessage);
        }
        this._schedule_message(wireMessage);
      } else {
        // Currently disconnected, will not schedule this message
        // Check if reconnecting is in progress and disconnected publish is enabled.
        if (this._reconnecting && this.disconnectedPublishing) {
          // Check the limit which include the "required ACK" messages
          var messageCount = Object.keys(this._sentMessages).length + this._buffered_msg_queue.length;
          if (messageCount > this.disconnectedBufferSize) {
            throw new Error(format(ERROR.BUFFER_FULL, [this.disconnectedBufferSize]));
          } else {
            if (message.qos > 0) {
              // Mark this message as "ACK required"
              this._requires_ack(wireMessage);
            } else {
              wireMessage.sequence = ++this._sequence;
              this._buffered_msg_queue.push(wireMessage);
            }
          }
        } else {
          throw new Error(format(ERROR.INVALID_STATE, ["not connected"]));
        }
      }
    };
    ClientImpl.prototype.disconnect = function () {
      this._trace("Client.disconnect");
      if (this._reconnecting) {
        // disconnect() function is called while reconnect is in progress.
        // Terminate the auto reconnect process.
        this._reconnectTimeout.cancel();
        this._reconnectTimeout = null;
        this._reconnecting = false;
      }
      if (!this.socket)
        throw new Error(format(ERROR.INVALID_STATE, ["not connecting or connected"]));
      wireMessage = new WireMessage(MESSAGE_TYPE.DISCONNECT);
      // Run the disconnected call back as soon as the message has been sent,
      // in case of a failure later on in the disconnect processing.
      // as a consequence, the _disconected call back may be run several times.
      this._notify_msg_sent[wireMessage] = scope(this._disconnected, this);
      this._schedule_message(wireMessage);
    };
    ClientImpl.prototype.getTraceLog = function () {
      if ( this._traceBuffer !== null ) {
        this._trace("Client.getTraceLog", new Date());
        this._trace("Client.getTraceLog in flight messages", this._sentMessages.length);
        for (var key in this._sentMessages)
          this._trace("_sentMessages ",key, this._sentMessages[key]);
        for (var key in this._receivedMessages)
          this._trace("_receivedMessages ",key, this._receivedMessages[key]);
        return this._traceBuffer;
      }
    };
    ClientImpl.prototype.startTrace = function () {
      if ( this._traceBuffer === null ) {
        this._traceBuffer = [];
      }
      this._trace("Client.startTrace", new Date(), version);
    };
    ClientImpl.prototype.stopTrace = function () {
      delete this._traceBuffer;
    };
    ClientImpl.prototype._doConnect = function (wsurl) {
      // When the socket is open, this client will send the CONNECT WireMessage using the saved parameters.
      if (this.connectOptions.useSSL) {
        var uriParts = wsurl.split(":");
        uriParts[0] = "wss";
        wsurl = uriParts.join(":");
      }
      this._wsuri = wsurl;
      this.connected = false;
      if (this.connectOptions.mqttVersion < 4) {
        this.socket = new WebSocket(wsurl, ["mqttv3.1"]);
      } else {
        this.socket = new WebSocket(wsurl, ["mqtt"]);
      }
      this.socket.binaryType = 'arraybuffer';
      this.socket.onopen = scope(this._on_socket_open, this);
      this.socket.onmessage = scope(this._on_socket_message, this);
      this.socket.onerror = scope(this._on_socket_error, this);
      this.socket.onclose = scope(this._on_socket_close, this);
      this.sendPinger = new Pinger(this, window, this.connectOptions.keepAliveInterval);
      this.receivePinger = new Pinger(this, window, this.connectOptions.keepAliveInterval);
      if (this._connectTimeout) {
        this._connectTimeout.cancel();
        this._connectTimeout = null;
      }
      this._connectTimeout = new Timeout(this, window, this.connectOptions.timeout, this._disconnected,  [ERROR.CONNECT_TIMEOUT.code, format(ERROR.CONNECT_TIMEOUT)]);
    };
    // Schedule a new message to be sent over the WebSockets
    // connection. CONNECT messages cause WebSocket connection
    // to be started. All other messages are queued internally
    // until this has happened. When WS connection starts, process
    // all outstanding messages.
    ClientImpl.prototype._schedule_message = function (message) {
      this._msg_queue.push(message);
      // Process outstanding messages in the queue if we have an  open socket, and have received CONNACK.
      if (this.connected) {
        this._process_queue();
      }
    };
    ClientImpl.prototype.store = function(prefix, wireMessage) {
      var storedMessage = {type:wireMessage.type, messageIdentifier:wireMessage.messageIdentifier, version:1};
      switch(wireMessage.type) {
        case MESSAGE_TYPE.PUBLISH:
          if(wireMessage.pubRecReceived)
            storedMessage.pubRecReceived = true;
          // Convert the payload to a hex string.
          storedMessage.payloadMessage = {};
          var hex = "";
          var messageBytes = wireMessage.payloadMessage.payloadBytes;
          for (var i=0; i<messageBytes.length; i++) {
            if (messageBytes[i] <= 0xF)
              hex = hex+"0"+messageBytes[i].toString(16);
            else
              hex = hex+messageBytes[i].toString(16);
          }
          storedMessage.payloadMessage.payloadHex = hex;
          storedMessage.payloadMessage.qos = wireMessage.payloadMessage.qos;
          storedMessage.payloadMessage.destinationName = wireMessage.payloadMessage.destinationName;
          if (wireMessage.payloadMessage.duplicate)
            storedMessage.payloadMessage.duplicate = true;
          if (wireMessage.payloadMessage.retained)
            storedMessage.payloadMessage.retained = true;
          // Add a sequence number to sent messages.
          if ( prefix.indexOf("Sent:") === 0 ) {
            if ( wireMessage.sequence === undefined )
              wireMessage.sequence = ++this._sequence;
            storedMessage.sequence = wireMessage.sequence;
          }
          break;
        default:
          throw Error(format(ERROR.INVALID_STORED_DATA, [key, storedMessage]));
      }
      localStorage.setItem(prefix+this._localKey+wireMessage.messageIdentifier, JSON.stringify(storedMessage));
    };
    ClientImpl.prototype.restore = function(key) {
      var value = localStorage.getItem(key);
      var storedMessage = JSON.parse(value);
      var wireMessage = new WireMessage(storedMessage.type, storedMessage);
      switch(storedMessage.type) {
        case MESSAGE_TYPE.PUBLISH:
          // Replace the payload message with a Message object.
          var hex = storedMessage.payloadMessage.payloadHex;
          var buffer = new ArrayBuffer((hex.length)/2);
          var byteStream = new Uint8Array(buffer);
          var i = 0;
          while (hex.length >= 2) {
            var x = parseInt(hex.substring(0, 2), 16);
            hex = hex.substring(2, hex.length);
            byteStream[i++] = x;
          }
          var payloadMessage = new Paho.MQTT.Message(byteStream);
          payloadMessage.qos = storedMessage.payloadMessage.qos;
          payloadMessage.destinationName = storedMessage.payloadMessage.destinationName;
          if (storedMessage.payloadMessage.duplicate)
            payloadMessage.duplicate = true;
          if (storedMessage.payloadMessage.retained)
            payloadMessage.retained = true;
          wireMessage.payloadMessage = payloadMessage;
          break;
        default:
          throw Error(format(ERROR.INVALID_STORED_DATA, [key, value]));
      }
      if (key.indexOf("Sent:"+this._localKey) === 0) {
        wireMessage.payloadMessage.duplicate = true;
        this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
      } else if (key.indexOf("Received:"+this._localKey) === 0) {
        this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
      }
    };
    ClientImpl.prototype._process_queue = function () {
      var message = null;
      // Process messages in order they were added
      var fifo = this._msg_queue.reverse();
      // Send all queued messages down socket connection
      while ((message = fifo.pop())) {
        this._socket_send(message);
        // Notify listeners that message was successfully sent
        if (this._notify_msg_sent[message]) {
          this._notify_msg_sent[message]();
          delete this._notify_msg_sent[message];
        }
      }
    };
    /**
     * Expect an ACK response for this message. Add message to the set of in progress
     * messages and set an unused identifier in this message.
     * @ignore
     */
    ClientImpl.prototype._requires_ack = function (wireMessage) {
      var messageCount = Object.keys(this._sentMessages).length;
      if (messageCount > this.maxMessageIdentifier)
        throw Error ("Too many messages:"+messageCount);
      while(this._sentMessages[this._message_identifier] !== undefined) {
        this._message_identifier++;
      }
      wireMessage.messageIdentifier = this._message_identifier;
      this._sentMessages[wireMessage.messageIdentifier] = wireMessage;
      if (wireMessage.type === MESSAGE_TYPE.PUBLISH) {
        this.store("Sent:", wireMessage);
      }
      if (this._message_identifier === this.maxMessageIdentifier) {
        this._message_identifier = 1;
      }
    };
    /**
     * Called when the underlying websocket has been opened.
     * @ignore
     */
    ClientImpl.prototype._on_socket_open = function () {
      // Create the CONNECT message object.
      var wireMessage = new WireMessage(MESSAGE_TYPE.CONNECT, this.connectOptions);
      wireMessage.clientId = this.clientId;
      this._socket_send(wireMessage);
    };
    /**
     * Called when the underlying websocket has received a complete packet.
     * @ignore
     */
    ClientImpl.prototype._on_socket_message = function (event) {
      this._trace("Client._on_socket_message", event.data);
      var messages = this._deframeMessages(event.data);
      for (var i = 0; i < messages.length; i+=1) {
        this._handleMessage(messages[i]);
      }
    };
    ClientImpl.prototype._deframeMessages = function(data) {
      var byteArray = new Uint8Array(data);
      var messages = [];
      if (this.receiveBuffer) {
        var newData = new Uint8Array(this.receiveBuffer.length+byteArray.length);
        newData.set(this.receiveBuffer);
        newData.set(byteArray,this.receiveBuffer.length);
        byteArray = newData;
        delete this.receiveBuffer;
      }
      try {
        var offset = 0;
        while(offset < byteArray.length) {
          var result = decodeMessage(byteArray,offset);
          var wireMessage = result[0];
          offset = result[1];
          if (wireMessage !== null) {
            messages.push(wireMessage);
          } else {
            break;
          }
        }
        if (offset < byteArray.length) {
          this.receiveBuffer = byteArray.subarray(offset);
        }
      } catch (error) {
        var errorStack = ((error.hasOwnProperty('stack') == 'undefined') ? error.stack.toString() : "No Error Stack Available");
        this._disconnected(ERROR.INTERNAL_ERROR.code , format(ERROR.INTERNAL_ERROR, [error.message,errorStack]));
        return;
      }
      return messages;
    };
    ClientImpl.prototype._handleMessage = function(wireMessage) {
      this._trace("Client._handleMessage", wireMessage);
      try {
        switch(wireMessage.type) {
          case MESSAGE_TYPE.CONNACK:
            this._connectTimeout.cancel();
            if (this._reconnectTimeout)
              this._reconnectTimeout.cancel();
            // If we have started using clean session then clear up the local state.
            if (this.connectOptions.cleanSession) {
              for (var key in this._sentMessages) {
                var sentMessage = this._sentMessages[key];
                localStorage.removeItem("Sent:"+this._localKey+sentMessage.messageIdentifier);
              }
              this._sentMessages = {};
              for (var key in this._receivedMessages) {
                var receivedMessage = this._receivedMessages[key];
                localStorage.removeItem("Received:"+this._localKey+receivedMessage.messageIdentifier);
              }
              this._receivedMessages = {};
            }
            // Client connected and ready for business.
            if (wireMessage.returnCode === 0) {
              this.connected = true;
              // Jump to the end of the list of uris and stop looking for a good host.
              if (this.connectOptions.uris)
                this.hostIndex = this.connectOptions.uris.length;
            } else {
              this._disconnected(ERROR.CONNACK_RETURNCODE.code , format(ERROR.CONNACK_RETURNCODE, [wireMessage.returnCode, CONNACK_RC[wireMessage.returnCode]]));
              break;
            }
            // Resend messages.
            var sequencedMessages = [];
            for (var msgId in this._sentMessages) {
              if (this._sentMessages.hasOwnProperty(msgId))
                sequencedMessages.push(this._sentMessages[msgId]);
            }
            // Also schedule qos 0 buffered messages if any
            if (this._buffered_msg_queue.length > 0) {
              var msg = null;
              var fifo = this._buffered_msg_queue.reverse();
              while ((msg = fifo.pop())) {
                sequencedMessages.push(msg);
                if (this.onMessageDelivered)
                  this._notify_msg_sent[msg] = this.onMessageDelivered(msg.payloadMessage);
              }
            }
            // Sort sentMessages into the original sent order.
            var sequencedMessages = sequencedMessages.sort(function(a,b) {return a.sequence - b.sequence;} );
            for (var i=0, len=sequencedMessages.length; i<len; i++) {
              var sentMessage = sequencedMessages[i];
              if (sentMessage.type == MESSAGE_TYPE.PUBLISH && sentMessage.pubRecReceived) {
                var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {messageIdentifier:sentMessage.messageIdentifier});
                this._schedule_message(pubRelMessage);
              } else {
                this._schedule_message(sentMessage);
              }
            }
            // Execute the connectOptions.onSuccess callback if there is one.
            // Will also now return if this connection was the result of an automatic
            // reconnect and which URI was successfully connected to.
            if (this.connectOptions.onSuccess) {
              this.connectOptions.onSuccess({invocationContext:this.connectOptions.invocationContext});
            }
            var reconnected = false;
            if (this._reconnecting) {
              reconnected = true;
              this._reconnectInterval = 1;
              this._reconnecting = false;
            }
            // Execute the onConnected callback if there is one.
            this._connected(reconnected, this._wsuri);
            // Process all queued messages now that the connection is established.
            this._process_queue();
            break;
          case MESSAGE_TYPE.PUBLISH:
            this._receivePublish(wireMessage);
            break;
          case MESSAGE_TYPE.PUBACK:
            var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
            // If this is a re flow of a PUBACK after we have restarted receivedMessage will not exist.
            if (sentMessage) {
              delete this._sentMessages[wireMessage.messageIdentifier];
              localStorage.removeItem("Sent:"+this._localKey+wireMessage.messageIdentifier);
              if (this.onMessageDelivered)
                this.onMessageDelivered(sentMessage.payloadMessage);
            }
            break;
          case MESSAGE_TYPE.PUBREC:
            var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
            // If this is a re flow of a PUBREC after we have restarted receivedMessage will not exist.
            if (sentMessage) {
              sentMessage.pubRecReceived = true;
              var pubRelMessage = new WireMessage(MESSAGE_TYPE.PUBREL, {messageIdentifier:wireMessage.messageIdentifier});
              this.store("Sent:", sentMessage);
              this._schedule_message(pubRelMessage);
            }
            break;
          case MESSAGE_TYPE.PUBREL:
            var receivedMessage = this._receivedMessages[wireMessage.messageIdentifier];
            localStorage.removeItem("Received:"+this._localKey+wireMessage.messageIdentifier);
            // If this is a re flow of a PUBREL after we have restarted receivedMessage will not exist.
            if (receivedMessage) {
              this._receiveMessage(receivedMessage);
              delete this._receivedMessages[wireMessage.messageIdentifier];
            }
            // Always flow PubComp, we may have previously flowed PubComp but the server lost it and restarted.
            var pubCompMessage = new WireMessage(MESSAGE_TYPE.PUBCOMP, {messageIdentifier:wireMessage.messageIdentifier});
            this._schedule_message(pubCompMessage);
            break;
          case MESSAGE_TYPE.PUBCOMP:
            var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
            delete this._sentMessages[wireMessage.messageIdentifier];
            localStorage.removeItem("Sent:"+this._localKey+wireMessage.messageIdentifier);
            if (this.onMessageDelivered)
              this.onMessageDelivered(sentMessage.payloadMessage);
            break;
          case MESSAGE_TYPE.SUBACK:
            var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
            if (sentMessage) {
              if(sentMessage.timeOut)
                sentMessage.timeOut.cancel();
              // This will need to be fixed when we add multiple topic support
              if (wireMessage.returnCode[0] === 0x80) {
                if (sentMessage.onFailure) {
                  sentMessage.onFailure(wireMessage.returnCode);
                }
              } else if (sentMessage.onSuccess) {
                sentMessage.onSuccess(wireMessage.returnCode);
              }
              delete this._sentMessages[wireMessage.messageIdentifier];
            }
            break;
          case MESSAGE_TYPE.UNSUBACK:
            var sentMessage = this._sentMessages[wireMessage.messageIdentifier];
            if (sentMessage) {
              if (sentMessage.timeOut)
                sentMessage.timeOut.cancel();
              if (sentMessage.callback) {
                sentMessage.callback();
              }
              delete this._sentMessages[wireMessage.messageIdentifier];
            }
            break;
          case MESSAGE_TYPE.PINGRESP:
            /* The sendPinger or receivePinger may have sent a ping, the receivePinger has already been reset. */
            this.sendPinger.reset();
            break;
          case MESSAGE_TYPE.DISCONNECT:
            // Clients do not expect to receive disconnect packets.
            this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code , format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [wireMessage.type]));
            break;
          default:
            this._disconnected(ERROR.INVALID_MQTT_MESSAGE_TYPE.code , format(ERROR.INVALID_MQTT_MESSAGE_TYPE, [wireMessage.type]));
        }
      } catch (error) {
        var errorStack = ((error.hasOwnProperty('stack') == 'undefined') ? error.stack.toString() : "No Error Stack Available");
        this._disconnected(ERROR.INTERNAL_ERROR.code , format(ERROR.INTERNAL_ERROR, [error.message,errorStack]));
        return;
      }
    };
    /** @ignore */
    ClientImpl.prototype._on_socket_error = function (error) {
      if (!this._reconnecting) {
        this._disconnected(ERROR.SOCKET_ERROR.code , format(ERROR.SOCKET_ERROR, [error.data]));
      }
    };
    /** @ignore */
    ClientImpl.prototype._on_socket_close = function () {
      if (!this._reconnecting) {
        this._disconnected(ERROR.SOCKET_CLOSE.code , format(ERROR.SOCKET_CLOSE));
      }
    };
    /** @ignore */
    ClientImpl.prototype._socket_send = function (wireMessage) {
      if (wireMessage.type == 1) {
        var wireMessageMasked = this._traceMask(wireMessage, "password");
        this._trace("Client._socket_send", wireMessageMasked);
      }
      else this._trace("Client._socket_send", wireMessage);
      this.socket.send(wireMessage.encode());
      /* We have proved to the server we are alive. */
      this.sendPinger.reset();
    };
    /** @ignore */
    ClientImpl.prototype._receivePublish = function (wireMessage) {
      switch(wireMessage.payloadMessage.qos) {
        case "undefined":
        case 0:
          this._receiveMessage(wireMessage);
          break;
        case 1:
          var pubAckMessage = new WireMessage(MESSAGE_TYPE.PUBACK, {messageIdentifier:wireMessage.messageIdentifier});
          this._schedule_message(pubAckMessage);
          this._receiveMessage(wireMessage);
          break;
        case 2:
          this._receivedMessages[wireMessage.messageIdentifier] = wireMessage;
          this.store("Received:", wireMessage);
          var pubRecMessage = new WireMessage(MESSAGE_TYPE.PUBREC, {messageIdentifier:wireMessage.messageIdentifier});
          this._schedule_message(pubRecMessage);
          break;
        default:
          throw Error("Invaild qos="+wireMmessage.payloadMessage.qos);
      }
    };
    /** @ignore */
    ClientImpl.prototype._receiveMessage = function (wireMessage) {
      if (this.onMessageArrived) {
        this.onMessageArrived(wireMessage.payloadMessage);
      }
    };
    /**
     * Client has connected.
     * @param {reconnect} [boolean] indicate if this was a result of reconnect operation.
     * @param {uri} [string] fully qualified WebSocket URI of the server.
     */
    ClientImpl.prototype._connected = function (reconnect, uri) {
      // Execute the onConnected callback if there is one.
      if (this.onConnected)
        this.onConnected(reconnect, uri);
    };
    /**
     * Attempts to reconnect the client to the server.
     * For each reconnect attempt, will double the reconnect interval
     * up to 128 seconds.
     */
    ClientImpl.prototype._reconnect = function () {
      this._trace("Client._reconnect");
      if (!this.connected) {
        this._reconnecting = true;
        this.sendPinger.cancel();
        this.receivePinger.cancel();
        if (this._reconnectInterval < 128)
          this._reconnectInterval = this._reconnectInterval * 2;
        if (this.connectOptions.uris) {
          this.hostIndex = 0;
          this._doConnect(this.connectOptions.uris[0]);
        } else {
          this._doConnect(this.uri);
        }
      }
    };
    /**
     * Client has disconnected either at its own request or because the server
     * or network disconnected it. Remove all non-durable state.
     * @param {errorCode} [number] the error number.
     * @param {errorText} [string] the error text.
     * @ignore
     */
    ClientImpl.prototype._disconnected = function (errorCode, errorText) {
      this._trace("Client._disconnected", errorCode, errorText);
      if (errorCode !== undefined && this._reconnecting) {
        //Continue automatic reconnect process
        this._reconnectTimeout = new Timeout(this, window, this._reconnectInterval, this._reconnect);
        return;
      }
      this.sendPinger.cancel();
      this.receivePinger.cancel();
      if (this._connectTimeout) {
        this._connectTimeout.cancel();
        this._connectTimeout = null;
      }
      // Clear message buffers.
      this._msg_queue = [];
      this._buffered_msg_queue = [];
      this._notify_msg_sent = {};
      if (this.socket) {
        // Cancel all socket callbacks so that they cannot be driven again by this socket.
        this.socket.onopen = null;
        this.socket.onmessage = null;
        this.socket.onerror = null;
        this.socket.onclose = null;
        if (this.socket.readyState === 1)
          this.socket.close();
        delete this.socket;
      }
      if (this.connectOptions.uris && this.hostIndex < this.connectOptions.uris.length-1) {
        // Try the next host.
        this.hostIndex++;
        this._doConnect(this.connectOptions.uris[this.hostIndex]);
      } else {
        if (errorCode === undefined) {
          errorCode = ERROR.OK.code;
          errorText = format(ERROR.OK);
        }
        // Run any application callbacks last as they may attempt to reconnect and hence create a new socket.
        if (this.connected) {
          this.connected = false;
          // Execute the connectionLostCallback if there is one, and we were connected.
          if (this.onConnectionLost) {
            this.onConnectionLost({errorCode:errorCode, errorMessage:errorText, reconnect:this.connectOptions.reconnect, uri:this._wsuri});
          }
          if (errorCode !== ERROR.OK.code && this.connectOptions.reconnect) {
            // Start automatic reconnect process for the very first time since last successful connect.
            this._reconnectInterval = 1;
            this._reconnect();
            return;
          }
        } else {
          // Otherwise we never had a connection, so indicate that the connect has failed.
          if (this.connectOptions.mqttVersion === 4 && this.connectOptions.mqttVersionExplicit === false) {
            this._trace("Failed to connect V4, dropping back to V3");
            this.connectOptions.mqttVersion = 3;
            if (this.connectOptions.uris) {
              this.hostIndex = 0;
              this._doConnect(this.connectOptions.uris[0]);
            } else {
              this._doConnect(this.uri);
            }
          } else if(this.connectOptions.onFailure) {
            this.connectOptions.onFailure({invocationContext:this.connectOptions.invocationContext, errorCode:errorCode, errorMessage:errorText});
          }
        }
      }
    };
    /** @ignore */
    ClientImpl.prototype._trace = function () {
      // Pass trace message back to client's callback function
      if (this.traceFunction) {
        for (var i in arguments)
        {
          if (typeof arguments[i] !== "undefined")
            arguments.splice(i, 1, JSON.stringify(arguments[i]));
        }
        var record = Array.prototype.slice.call(arguments).join("");
        this.traceFunction ({severity: "Debug", message: record	});
      }
      //buffer style trace
      if ( this._traceBuffer !== null ) {
        for (var i = 0, max = arguments.length; i < max; i++) {
          if ( this._traceBuffer.length == this._MAX_TRACE_ENTRIES ) {
            this._traceBuffer.shift();
          }
          if (i === 0) this._traceBuffer.push(arguments[i]);
          else if (typeof arguments[i] === "undefined" ) this._traceBuffer.push(arguments[i]);
          else this._traceBuffer.push("  "+JSON.stringify(arguments[i]));
        }
      }
    };
    /** @ignore */
    ClientImpl.prototype._traceMask = function (traceObject, masked) {
      var traceObjectMasked = {};
      for (var attr in traceObject) {
        if (traceObject.hasOwnProperty(attr)) {
          if (attr == masked)
            traceObjectMasked[attr] = "******";
          else
            traceObjectMasked[attr] = traceObject[attr];
        }
      }
      return traceObjectMasked;
    };
    // ------------------------------------------------------------------------
    // Public Programming interface.
    // ------------------------------------------------------------------------
    /**
     * The JavaScript application communicates to the server using a {@link Paho.MQTT.Client} object.
     * <p>
     * Most applications will create just one Client object and then call its connect() method,
     * however applications can create more than one Client object if they wish.
     * In this case the combination of host, port and clientId attributes must be different for each Client object.
     * <p>
     * The send, subscribe and unsubscribe methods are implemented as asynchronous JavaScript methods
     * (even though the underlying protocol exchange might be synchronous in nature).
     * This means they signal their completion by calling back to the application,
     * via Success or Failure callback functions provided by the application on the method in question.
     * Such callbacks are called at most once per method invocation and do not persist beyond the lifetime
     * of the script that made the invocation.
     * <p>
     * In contrast there are some callback functions, most notably <i>onMessageArrived</i>,
     * that are defined on the {@link Paho.MQTT.Client} object.
     * These may get called multiple times, and aren't directly related to specific method invocations made by the client.
     *
     * @name Paho.MQTT.Client
     *
     * @constructor
     *
     * @param {string} host - the address of the messaging server, as a fully qualified WebSocket URI, as a DNS name or dotted decimal IP address.
     * @param {number} port - the port number to connect to - only required if host is not a URI
     * @param {string} path - the path on the host to connect to - only used if host is not a URI. Default: '/mqtt'.
     * @param {string} clientId - the Messaging client identifier, between 1 and 23 characters in length.
     *
     * @property {string} host - <i>read only</i> the server's DNS hostname or dotted decimal IP address.
     * @property {number} port - <i>read only</i> the server's port.
     * @property {string} path - <i>read only</i> the server's path.
     * @property {string} clientId - <i>read only</i> used when connecting to the server.
     * @property {function} onConnectionLost - called when a connection has been lost.
     *                            after a connect() method has succeeded.
     *                            Establish the call back used when a connection has been lost. The connection may be
     *                            lost because the client initiates a disconnect or because the server or network
     *                            cause the client to be disconnected. The disconnect call back may be called without
     *                            the connectionComplete call back being invoked if, for example the client fails to
     *                            connect.
     *                            A single response object parameter is passed to the onConnectionLost callback containing the following fields:
     *                            <ol>
     *                            <li>errorCode
     *                            <li>errorMessage
     *                            </ol>
     * @property {function} onMessageDelivered - called when a message has been delivered.
     *                            All processing that this Client will ever do has been completed. So, for example,
     *                            in the case of a Qos=2 message sent by this client, the PubComp flow has been received from the server
     *                            and the message has been removed from persistent storage before this callback is invoked.
     *                            Parameters passed to the onMessageDelivered callback are:
     *                            <ol>
     *                            <li>{@link Paho.MQTT.Message} that was delivered.
     *                            </ol>
     * @property {function} onMessageArrived - called when a message has arrived in this Paho.MQTT.client.
     *                            Parameters passed to the onMessageArrived callback are:
     *                            <ol>
     *                            <li>{@link Paho.MQTT.Message} that has arrived.
     *                            </ol>
     * @property {function} onConnected - called when a connection is successfully made to the server.
     *                                  after a connect() method.
     *                                  Parameters passed to the onConnected callback are:
     *                                  <ol>
     *                                  <li>reconnect (boolean) - If true, the connection was the result of a reconnect.</li>
     *                                  <li>URI (string) - The URI used to connect to the server.</li>
     *                                  </ol>
     * @property {boolean} disconnectedPublishing - if set, will enable disconnected publishing in
     *                                            in the event that the connection to the server is lost.
     * @property {number} disconnectedBufferSize - Used to set the maximum number of messages that the disconnected
     *                                             buffer will hold before rejecting new messages. Default size: 5000 messages
     * @property {function} trace - called whenever trace is called. TODO
     */
    var Client = function (host, port, path, clientId) {
      var uri;
      if (typeof host !== "string")
        throw new Error(format(ERROR.INVALID_TYPE, [typeof host, "host"]));
      if (arguments.length == 2) {
        // host: must be full ws:// uri
        // port: clientId
        clientId = port;
        uri = host;
        var match = uri.match(/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/);
        if (match) {
          host = match[4]||match[2];
          port = parseInt(match[7]);
          path = match[8];
        } else {
          throw new Error(format(ERROR.INVALID_ARGUMENT,[host,"host"]));
        }
      } else {
        if (arguments.length == 3) {
          clientId = path;
          path = "/mqtt";
        }
        if (typeof port !== "number" || port < 0)
          throw new Error(format(ERROR.INVALID_TYPE, [typeof port, "port"]));
        if (typeof path !== "string")
          throw new Error(format(ERROR.INVALID_TYPE, [typeof path, "path"]));
        var ipv6AddSBracket = (host.indexOf(":") !== -1 && host.slice(0,1) !== "[" && host.slice(-1) !== "]");
        uri = "ws://"+(ipv6AddSBracket?"["+host+"]":host)+":"+port+path;
      }
      var clientIdLength = 0;
      for (var i = 0; i<clientId.length; i++) {
        var charCode = clientId.charCodeAt(i);
        if (0xD800 <= charCode && charCode <= 0xDBFF)  {
          i++; // Surrogate pair.
        }
        clientIdLength++;
      }
      if (typeof clientId !== "string" || clientIdLength > 65535)
        throw new Error(format(ERROR.INVALID_ARGUMENT, [clientId, "clientId"]));
      var client = new ClientImpl(uri, host, port, path, clientId);
      this._getHost =  function() { return host; };
      this._setHost = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };
      this._getPort = function() { return port; };
      this._setPort = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };
      this._getPath = function() { return path; };
      this._setPath = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };
      this._getURI = function() { return uri; };
      this._setURI = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };
      this._getClientId = function() { return client.clientId; };
      this._setClientId = function() { throw new Error(format(ERROR.UNSUPPORTED_OPERATION)); };
      this._getOnConnected = function() { return client.onConnected; };
      this._setOnConnected = function(newOnConnected) {
        if (typeof newOnConnected === "function")
          client.onConnected = newOnConnected;
        else
          throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnConnected, "onConnected"]));
      };
      this._getDisconnectedPublishing = function() { return client.disconnectedPublishing; };
      this._setDisconnectedPublishing = function(newDisconnectedPublishing) {
        client.disconnectedPublishing = newDisconnectedPublishing;
      };
      this._getDisconnectedBufferSize = function() { return client.disconnectedBufferSize; };
      this._setDisconnectedBufferSize = function(newDisconnectedBufferSize) {
        client.disconnectedBufferSize = newDisconnectedBufferSize;
      };
      this._getOnConnectionLost = function() { return client.onConnectionLost; };
      this._setOnConnectionLost = function(newOnConnectionLost) {
        if (typeof newOnConnectionLost === "function")
          client.onConnectionLost = newOnConnectionLost;
        else
          throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnConnectionLost, "onConnectionLost"]));
      };
      this._getOnMessageDelivered = function() { return client.onMessageDelivered; };
      this._setOnMessageDelivered = function(newOnMessageDelivered) {
        if (typeof newOnMessageDelivered === "function")
          client.onMessageDelivered = newOnMessageDelivered;
        else
          throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnMessageDelivered, "onMessageDelivered"]));
      };
      this._getOnMessageArrived = function() { return client.onMessageArrived; };
      this._setOnMessageArrived = function(newOnMessageArrived) {
        if (typeof newOnMessageArrived === "function")
          client.onMessageArrived = newOnMessageArrived;
        else
          throw new Error(format(ERROR.INVALID_TYPE, [typeof newOnMessageArrived, "onMessageArrived"]));
      };
      this._getTrace = function() { return client.traceFunction; };
      this._setTrace = function(trace) {
        if(typeof trace === "function"){
          client.traceFunction = trace;
        }else{
          throw new Error(format(ERROR.INVALID_TYPE, [typeof trace, "onTrace"]));
        }
      };
      /**
       * Connect this Messaging client to its server.
       *
       * @name Paho.MQTT.Client#connect
       * @function
       * @param {object} connectOptions - Attributes used with the connection.
       * @param {number} connectOptions.timeout - If the connect has not succeeded within this
       *                    number of seconds, it is deemed to have failed.
       *                    The default is 30 seconds.
       * @param {string} connectOptions.userName - Authentication username for this connection.
       * @param {string} connectOptions.password - Authentication password for this connection.
       * @param {Paho.MQTT.Message} connectOptions.willMessage - sent by the server when the client
       *                    disconnects abnormally.
       * @param {number} connectOptions.keepAliveInterval - the server disconnects this client if
       *                    there is no activity for this number of seconds.
       *                    The default value of 60 seconds is assumed if not set.
       * @param {boolean} connectOptions.cleanSession - if true(default) the client and server
       *                    persistent state is deleted on successful connect.
       * @param {boolean} connectOptions.useSSL - if present and true, use an SSL Websocket connection.
       * @param {object} connectOptions.invocationContext - passed to the onSuccess callback or onFailure callback.
       * @param {function} connectOptions.onSuccess - called when the connect acknowledgement
       *                    has been received from the server.
       * A single response object parameter is passed to the onSuccess callback containing the following fields:
       * <ol>
       * <li>invocationContext as passed in to the onSuccess method in the connectOptions.
       * </ol>
       * @param {function} connectOptions.onFailure - called when the connect request has failed or timed out.
       * A single response object parameter is passed to the onFailure callback containing the following fields:
       * <ol>
       * <li>invocationContext as passed in to the onFailure method in the connectOptions.
       * <li>errorCode a number indicating the nature of the error.
       * <li>errorMessage text describing the error.
       * </ol>
       * @param {array} connectOptions.hosts - If present this contains either a set of hostnames or fully qualified
       * WebSocket URIs (ws://mqtt.eclipseprojects.io:80/mqtt), that are tried in order in place
       * of the host and port paramater on the construtor. The hosts are tried one at at time in order until
       * one of then succeeds.
       * @param {array} connectOptions.ports - If present the set of ports matching the hosts. If hosts contains URIs, this property
       * is not used.
       * @param {boolean} connectOptions.reconnect - Sets whether the client will automatically attempt to reconnect
       * to the server if the connection is lost.
       *<ul>
       *<li>If set to false, the client will not attempt to automatically reconnect to the server in the event that the
       * connection is lost.</li>
       *<li>If set to true, in the event that the connection is lost, the client will attempt to reconnect to the server.
       * It will initially wait 1 second before it attempts to reconnect, for every failed reconnect attempt, the delay
       * will double until it is at 2 minutes at which point the delay will stay at 2 minutes.</li>
       *</ul>
       * @param {number} connectOptions.mqttVersion - The version of MQTT to use to connect to the MQTT Broker.
       *<ul>
       *<li>3 - MQTT V3.1</li>
       *<li>4 - MQTT V3.1.1</li>
       *</ul>
       * @param {boolean} connectOptions.mqttVersionExplicit - If set to true, will force the connection to use the
       * selected MQTT Version or will fail to connect.
       * @param {array} connectOptions.uris - If present, should contain a list of fully qualified WebSocket uris
       * (e.g. ws://mqtt.eclipseprojects.io:80/mqtt), that are tried in order in place of the host and port parameter of the construtor.
       * The uris are tried one at a time in order until one of them succeeds. Do not use this in conjunction with hosts as
       * the hosts array will be converted to uris and will overwrite this property.
       * @throws {InvalidState} If the client is not in disconnected state. The client must have received connectionLost
       * or disconnected before calling connect for a second or subsequent time.
       */
      this.connect = function (connectOptions) {
        connectOptions = connectOptions || {} ;
        validate(connectOptions,  {timeout:"number",
          userName:"string",
          password:"string",
          willMessage:"object",
          keepAliveInterval:"number",
          cleanSession:"boolean",
          useSSL:"boolean",
          invocationContext:"object",
          onSuccess:"function",
          onFailure:"function",
          hosts:"object",
          ports:"object",
          reconnect:"boolean",
          mqttVersion:"number",
          mqttVersionExplicit:"boolean",
          uris: "object"});
        // If no keep alive interval is set, assume 60 seconds.
        if (connectOptions.keepAliveInterval === undefined)
          connectOptions.keepAliveInterval = 60;
        if (connectOptions.mqttVersion > 4 || connectOptions.mqttVersion < 3) {
          throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.mqttVersion, "connectOptions.mqttVersion"]));
        }
        if (connectOptions.mqttVersion === undefined) {
          connectOptions.mqttVersionExplicit = false;
          connectOptions.mqttVersion = 4;
        } else {
          connectOptions.mqttVersionExplicit = true;
        }
        //Check that if password is set, so is username
        if (connectOptions.password !== undefined && connectOptions.userName === undefined)
          throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.password, "connectOptions.password"]));
        if (connectOptions.willMessage) {
          if (!(connectOptions.willMessage instanceof Message))
            throw new Error(format(ERROR.INVALID_TYPE, [connectOptions.willMessage, "connectOptions.willMessage"]));
          // The will message must have a payload that can be represented as a string.
          // Cause the willMessage to throw an exception if this is not the case.
          connectOptions.willMessage.stringPayload = null;
          if (typeof connectOptions.willMessage.destinationName === "undefined")
            throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.willMessage.destinationName, "connectOptions.willMessage.destinationName"]));
        }
        if (typeof connectOptions.cleanSession === "undefined")
          connectOptions.cleanSession = true;
        if (connectOptions.hosts) {
          if (!(connectOptions.hosts instanceof Array) )
            throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts, "connectOptions.hosts"]));
          if (connectOptions.hosts.length <1 )
            throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts, "connectOptions.hosts"]));
          var usingURIs = false;
          for (var i = 0; i<connectOptions.hosts.length; i++) {
            if (typeof connectOptions.hosts[i] !== "string")
              throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
            if (/^(wss?):\/\/((\[(.+)\])|([^\/]+?))(:(\d+))?(\/.*)$/.test(connectOptions.hosts[i])) {
              if (i === 0) {
                usingURIs = true;
              } else if (!usingURIs) {
                throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
              }
            } else if (usingURIs) {
              throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.hosts[i], "connectOptions.hosts["+i+"]"]));
            }
          }
          if (!usingURIs) {
            if (!connectOptions.ports)
              throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
            if (!(connectOptions.ports instanceof Array) )
              throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
            if (connectOptions.hosts.length !== connectOptions.ports.length)
              throw new Error(format(ERROR.INVALID_ARGUMENT, [connectOptions.ports, "connectOptions.ports"]));
            connectOptions.uris = [];
            for (var i = 0; i<connectOptions.hosts.length; i++) {
              if (typeof connectOptions.ports[i] !== "number" || connectOptions.ports[i] < 0)
                throw new Error(format(ERROR.INVALID_TYPE, [typeof connectOptions.ports[i], "connectOptions.ports["+i+"]"]));
              var host = connectOptions.hosts[i];
              var port = connectOptions.ports[i];
              var ipv6 = (host.indexOf(":") !== -1);
              uri = "ws://"+(ipv6?"["+host+"]":host)+":"+port+path;
              connectOptions.uris.push(uri);
            }
          } else {
            connectOptions.uris = connectOptions.hosts;
          }
        }
        client.connect(connectOptions);
      };
      /**
       * Subscribe for messages, request receipt of a copy of messages sent to the destinations described by the filter.
       *
       * @name Paho.MQTT.Client#subscribe
       * @function
       * @param {string} filter describing the destinations to receive messages from.
       * <br>
       * @param {object} subscribeOptions - used to control the subscription
       *
       * @param {number} subscribeOptions.qos - the maiximum qos of any publications sent
       *                                  as a result of making this subscription.
       * @param {object} subscribeOptions.invocationContext - passed to the onSuccess callback
       *                                  or onFailure callback.
       * @param {function} subscribeOptions.onSuccess - called when the subscribe acknowledgement
       *                                  has been received from the server.
       *                                  A single response object parameter is passed to the onSuccess callback containing the following fields:
       *                                  <ol>
       *                                  <li>invocationContext if set in the subscribeOptions.
       *                                  </ol>
       * @param {function} subscribeOptions.onFailure - called when the subscribe request has failed or timed out.
       *                                  A single response object parameter is passed to the onFailure callback containing the following fields:
       *                                  <ol>
       *                                  <li>invocationContext - if set in the subscribeOptions.
       *                                  <li>errorCode - a number indicating the nature of the error.
       *                                  <li>errorMessage - text describing the error.
       *                                  </ol>
       * @param {number} subscribeOptions.timeout - which, if present, determines the number of
       *                                  seconds after which the onFailure calback is called.
       *                                  The presence of a timeout does not prevent the onSuccess
       *                                  callback from being called when the subscribe completes.
       * @throws {InvalidState} if the client is not in connected state.
       */
      this.subscribe = function (filter, subscribeOptions) {
        if (typeof filter !== "string")
          throw new Error("Invalid argument:"+filter);
        subscribeOptions = subscribeOptions || {} ;
        validate(subscribeOptions,  {qos:"number",
          invocationContext:"object",
          onSuccess:"function",
          onFailure:"function",
          timeout:"number"
        });
        if (subscribeOptions.timeout && !subscribeOptions.onFailure)
          throw new Error("subscribeOptions.timeout specified with no onFailure callback.");
        if (typeof subscribeOptions.qos !== "undefined" && !(subscribeOptions.qos === 0 || subscribeOptions.qos === 1 || subscribeOptions.qos === 2 ))
          throw new Error(format(ERROR.INVALID_ARGUMENT, [subscribeOptions.qos, "subscribeOptions.qos"]));
        client.subscribe(filter, subscribeOptions);
      };
      /**
       * Unsubscribe for messages, stop receiving messages sent to destinations described by the filter.
       *
       * @name Paho.MQTT.Client#unsubscribe
       * @function
       * @param {string} filter - describing the destinations to receive messages from.
       * @param {object} unsubscribeOptions - used to control the subscription
       * @param {object} unsubscribeOptions.invocationContext - passed to the onSuccess callback
       or onFailure callback.
       * @param {function} unsubscribeOptions.onSuccess - called when the unsubscribe acknowledgement has been received from the server.
       *                                    A single response object parameter is passed to the
       *                                    onSuccess callback containing the following fields:
       *                                    <ol>
       *                                    <li>invocationContext - if set in the unsubscribeOptions.
       *                                    </ol>
       * @param {function} unsubscribeOptions.onFailure called when the unsubscribe request has failed or timed out.
       *                                    A single response object parameter is passed to the onFailure callback containing the following fields:
       *                                    <ol>
       *                                    <li>invocationContext - if set in the unsubscribeOptions.
       *                                    <li>errorCode - a number indicating the nature of the error.
       *                                    <li>errorMessage - text describing the error.
       *                                    </ol>
       * @param {number} unsubscribeOptions.timeout - which, if present, determines the number of seconds
       *                                    after which the onFailure callback is called. The presence of
       *                                    a timeout does not prevent the onSuccess callback from being
       *                                    called when the unsubscribe completes
       * @throws {InvalidState} if the client is not in connected state.
       */
      this.unsubscribe = function (filter, unsubscribeOptions) {
        if (typeof filter !== "string")
          throw new Error("Invalid argument:"+filter);
        unsubscribeOptions = unsubscribeOptions || {} ;
        validate(unsubscribeOptions,  {invocationContext:"object",
          onSuccess:"function",
          onFailure:"function",
          timeout:"number"
        });
        if (unsubscribeOptions.timeout && !unsubscribeOptions.onFailure)
          throw new Error("unsubscribeOptions.timeout specified with no onFailure callback.");
        client.unsubscribe(filter, unsubscribeOptions);
      };
      /**
       * Send a message to the consumers of the destination in the Message.
       *
       * @name Paho.MQTT.Client#send
       * @function
       * @param {string|Paho.MQTT.Message} topic - <b>mandatory</b> The name of the destination to which the message is to be sent.
       * 					   - If it is the only parameter, used as Paho.MQTT.Message object.
       * @param {String|ArrayBuffer} payload - The message data to be sent.
       * @param {number} qos The Quality of Service used to deliver the message.
       * 		<dl>
       * 			<dt>0 Best effort (default).
       *     			<dt>1 At least once.
       *     			<dt>2 Exactly once.
       * 		</dl>
       * @param {Boolean} retained If true, the message is to be retained by the server and delivered
       *                     to both current and future subscriptions.
       *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
       *                     A received message has the retained boolean set to true if the message was published
       *                     with the retained boolean set to true
       *                     and the subscrption was made after the message has been published.
       * @throws {InvalidState} if the client is not connected.
       */
      this.send = function (topic,payload,qos,retained) {
        var message ;
        if(arguments.length === 0){
          throw new Error("Invalid argument."+"length");
        }else if(arguments.length == 1) {
          if (!(topic instanceof Message) && (typeof topic !== "string"))
            throw new Error("Invalid argument:"+ typeof topic);
          message = topic;
          if (typeof message.destinationName === "undefined")
            throw new Error(format(ERROR.INVALID_ARGUMENT,[message.destinationName,"Message.destinationName"]));
          client.send(message);
        }else {
          //parameter checking in Message object
          message = new Message(payload);
          message.destinationName = topic;
          if(arguments.length >= 3)
            message.qos = qos;
          if(arguments.length >= 4)
            message.retained = retained;
          client.send(message);
        }
      };
      /**
       * Publish a message to the consumers of the destination in the Message.
       * Synonym for Paho.Mqtt.Client#send
       *
       * @name Paho.MQTT.Client#publish
       * @function
       * @param {string|Paho.MQTT.Message} topic - <b>mandatory</b> The name of the topic to which the message is to be published.
       * 					   - If it is the only parameter, used as Paho.MQTT.Message object.
       * @param {String|ArrayBuffer} payload - The message data to be published.
       * @param {number} qos The Quality of Service used to deliver the message.
       * 		<dl>
       * 			<dt>0 Best effort (default).
       *     			<dt>1 At least once.
       *     			<dt>2 Exactly once.
       * 		</dl>
       * @param {Boolean} retained If true, the message is to be retained by the server and delivered
       *                     to both current and future subscriptions.
       *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
       *                     A received message has the retained boolean set to true if the message was published
       *                     with the retained boolean set to true
       *                     and the subscrption was made after the message has been published.
       * @throws {InvalidState} if the client is not connected.
       */
      this.publish = function(topic,payload,qos,retained) {
        console.log("Publising message to: ", topic);
        var message ;
        if(arguments.length === 0){
          throw new Error("Invalid argument."+"length");
        }else if(arguments.length == 1) {
          if (!(topic instanceof Message) && (typeof topic !== "string"))
            throw new Error("Invalid argument:"+ typeof topic);
          message = topic;
          if (typeof message.destinationName === "undefined")
            throw new Error(format(ERROR.INVALID_ARGUMENT,[message.destinationName,"Message.destinationName"]));
          client.send(message);
        }else {
          //parameter checking in Message object
          message = new Message(payload);
          message.destinationName = topic;
          if(arguments.length >= 3)
            message.qos = qos;
          if(arguments.length >= 4)
            message.retained = retained;
          client.send(message);
        }
      };
      /**
       * Normal disconnect of this Messaging client from its server.
       *
       * @name Paho.MQTT.Client#disconnect
       * @function
       * @throws {InvalidState} if the client is already disconnected.
       */
      this.disconnect = function () {
        client.disconnect();
      };
      /**
       * Get the contents of the trace log.
       *
       * @name Paho.MQTT.Client#getTraceLog
       * @function
       * @return {Object[]} tracebuffer containing the time ordered trace records.
       */
      this.getTraceLog = function () {
        return client.getTraceLog();
      };
      /**
       * Start tracing.
       *
       * @name Paho.MQTT.Client#startTrace
       * @function
       */
      this.startTrace = function () {
        client.startTrace();
      };
      /**
       * Stop tracing.
       *
       * @name Paho.MQTT.Client#stopTrace
       * @function
       */
      this.stopTrace = function () {
        client.stopTrace();
      };
      this.isConnected = function() {
        return client.connected;
      };
    };
    Client.prototype = {
      get host() { return this._getHost(); },
      set host(newHost) { this._setHost(newHost); },
      get port() { return this._getPort(); },
      set port(newPort) { this._setPort(newPort); },
      get path() { return this._getPath(); },
      set path(newPath) { this._setPath(newPath); },
      get clientId() { return this._getClientId(); },
      set clientId(newClientId) { this._setClientId(newClientId); },
      get onConnected() { return this._getOnConnected(); },
      set onConnected(newOnConnected) { this._setOnConnected(newOnConnected); },
      get disconnectedPublishing() { return this._getDisconnectedPublishing(); },
      set disconnectedPublishing(newDisconnectedPublishing) { this._setDisconnectedPublishing(newDisconnectedPublishing); },
      get disconnectedBufferSize() { return this._getDisconnectedBufferSize(); },
      set disconnectedBufferSize(newDisconnectedBufferSize) { this._setDisconnectedBufferSize(newDisconnectedBufferSize); },
      get onConnectionLost() { return this._getOnConnectionLost(); },
      set onConnectionLost(newOnConnectionLost) { this._setOnConnectionLost(newOnConnectionLost); },
      get onMessageDelivered() { return this._getOnMessageDelivered(); },
      set onMessageDelivered(newOnMessageDelivered) { this._setOnMessageDelivered(newOnMessageDelivered); },
      get onMessageArrived() { return this._getOnMessageArrived(); },
      set onMessageArrived(newOnMessageArrived) { this._setOnMessageArrived(newOnMessageArrived); },
      get trace() { return this._getTrace(); },
      set trace(newTraceFunction) { this._setTrace(newTraceFunction); }
    };
    /**
     * An application message, sent or received.
     * <p>
     * All attributes may be null, which implies the default values.
     *
     * @name Paho.MQTT.Message
     * @constructor
     * @param {String|ArrayBuffer} payload The message data to be sent.
     * <p>
     * @property {string} payloadString <i>read only</i> The payload as a string if the payload consists of valid UTF-8 characters.
     * @property {ArrayBuffer} payloadBytes <i>read only</i> The payload as an ArrayBuffer.
     * <p>
     * @property {string} destinationName <b>mandatory</b> The name of the destination to which the message is to be sent
     *                    (for messages about to be sent) or the name of the destination from which the message has been received.
     *                    (for messages received by the onMessage function).
     * <p>
     * @property {number} qos The Quality of Service used to deliver the message.
     * <dl>
     *     <dt>0 Best effort (default).
     *     <dt>1 At least once.
     *     <dt>2 Exactly once.
     * </dl>
     * <p>
     * @property {Boolean} retained If true, the message is to be retained by the server and delivered
     *                     to both current and future subscriptions.
     *                     If false the server only delivers the message to current subscribers, this is the default for new Messages.
     *                     A received message has the retained boolean set to true if the message was published
     *                     with the retained boolean set to true
     *                     and the subscrption was made after the message has been published.
     * <p>
     * @property {Boolean} duplicate <i>read only</i> If true, this message might be a duplicate of one which has already been received.
     *                     This is only set on messages received from the server.
     *
     */
    var Message = function (newPayload) {
      var payload;
      if (   typeof newPayload === "string" ||
          newPayload instanceof ArrayBuffer ||
          newPayload instanceof Int8Array   ||
          newPayload instanceof Uint8Array  ||
          newPayload instanceof Int16Array  ||
          newPayload instanceof Uint16Array ||
          newPayload instanceof Int32Array  ||
          newPayload instanceof Uint32Array ||
          newPayload instanceof Float32Array ||
          newPayload instanceof Float64Array
      ) {
        payload = newPayload;
      } else {
        throw (format(ERROR.INVALID_ARGUMENT, [newPayload, "newPayload"]));
      }
      this._getPayloadString = function () {
        if (typeof payload === "string")
          return payload;
        else
          return parseUTF8(payload, 0, payload.length);
      };
      this._getPayloadBytes = function() {
        if (typeof payload === "string") {
          var buffer = new ArrayBuffer(UTF8Length(payload));
          var byteStream = new Uint8Array(buffer);
          stringToUTF8(payload, byteStream, 0);
          return byteStream;
        } else {
          return payload;
        }
      };
      var destinationName;
      this._getDestinationName = function() { return destinationName; };
      this._setDestinationName = function(newDestinationName) {
        if (typeof newDestinationName === "string")
          destinationName = newDestinationName;
        else
          throw new Error(format(ERROR.INVALID_ARGUMENT, [newDestinationName, "newDestinationName"]));
      };
      var qos = 0;
      this._getQos = function() { return qos; };
      this._setQos = function(newQos) {
        if (newQos === 0 || newQos === 1 || newQos === 2 )
          qos = newQos;
        else
          throw new Error("Invalid argument:"+newQos);
      };
      var retained = false;
      this._getRetained = function() { return retained; };
      this._setRetained = function(newRetained) {
        if (typeof newRetained === "boolean")
          retained = newRetained;
        else
          throw new Error(format(ERROR.INVALID_ARGUMENT, [newRetained, "newRetained"]));
      };
      var duplicate = false;
      this._getDuplicate = function() { return duplicate; };
      this._setDuplicate = function(newDuplicate) { duplicate = newDuplicate; };
    };
    Message.prototype = {
      get payloadString() { return this._getPayloadString(); },
      get payloadBytes() { return this._getPayloadBytes(); },
      get destinationName() { return this._getDestinationName(); },
      set destinationName(newDestinationName) { this._setDestinationName(newDestinationName); },
      get topic() { return this._getDestinationName(); },
      set topic(newTopic) { this._setDestinationName(newTopic); },
      get qos() { return this._getQos(); },
      set qos(newQos) { this._setQos(newQos); },
      get retained() { return this._getRetained(); },
      set retained(newRetained) { this._setRetained(newRetained); },
      get duplicate() { return this._getDuplicate(); },
      set duplicate(newDuplicate) { this._setDuplicate(newDuplicate); }
    };
    // Module contents.
    return {
      Client: Client,
      Message: Message
    };
  })(window);
  return PahoMQTT;
});

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("ukTranslations", {
    MESSAGE:"Повідомлення",
    ERROR_TITLE:"Помилка",
    ERROR_MESSAGE:"Виникла помилка при виконанні операції.",
    ERROR_LOGIN:"Під час входу в систему сталася помилка. Електронна адреса недійсна",
    ERROR_LOGIN_ROLE:"Роль для поточного бренду додатку не дійсна",
    OK:"ОК",
    CANCEL:"Відмінити",
    YES:"Так",
    NO:"Ні",
    FROM:"Від",
    TO:"До",
    DELETE:"Видалити",
    SIGN_OUT:"Вийти з аккаунта",
    NAME:"Ім'я",
    DATE:"Дата",
    PIECES:"частини",
    HOURS:"Години",
    DAYS:"Дні",
    MONTH:"Місяць",
    MONTHS:"Місяці",
    YEAR:"Рік",
    BOX:"Бокс",
    SEARCH:"Пошук",
    ALL_USERS:"Всі користувачі",
    ARE_YOU_SURE:"Ви впевнені?",
    BACK:"Назад",
    AMOUNT:"Сума",
    DESCRIPTION:"Опис",
    FORGOT_PASSWORD_ERROR_MSG:"Щось пішло не так. Будь ласка, перевірте свою адресу електронної пошти та повторіть спробу",
    REQUIRED_FIELD:"Поле обов'язкове",
    LOGOUT_TITLE:"Ви впевнені, що хочете вийти з системи?",
    LOGOUT_MSG:"Усі незбережені дані буде втрачено",
    ACTIVATION_ACCOUNT:"Ви успішно активували свій обліковий запис",
    UNKNOWN_ERRROR_NOTIFICATION:"Сталася невідома помилка",
    CONTINUE:"Продовжити",
    DATA_NOT_AVAILABLE:"Дані недоступні",
    SELECT:"Вибрати",
    SELECT_CURRENCY:"Виберіть валюту",
    UPLOAD:"Завантажити",
    PHONE:"Телефон",
    WEBSITE:"Веб-сайт",
    WORKING_HOURS:"Робочі години",
    INSERT:"Вставити",
    TEXT:"Текст",
    CREATED:"Створено",
    VALID_UNTIL:"Дійсний до",
    SAVE:"Зберегти",
    TOKENS:"Жетони",
    DELETE_COMPANY_HISTORY:"Видалити історію компанії?",
    DELETE_COMPANY_HISTORY_MESSAGE:"УВАГА: Після натискання цієї кнопки всі транзакції вашої автомийки будуть безповоротно видалені! Ці дані не можуть бути відновлені після видалення.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Ви впевнені, що хочете безповоротно видалити всі дані про транзакції?",
    HISTORY_SUCCESSFULY_DELETED:"Історія успішно видалена",
    HELP:"Допомога",
    VALUE:"Значення",
    ACTIVATING_ACCOUNT_ERROR:"Виникла проблема з активацією облікового запису R2W. Будь ласка, спробуйте ще раз, і якщо проблема не зникне, зверніться до нашої підтримки на support@ready2wash.com.",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Ласкаво просимо до автомийки Kärcher",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Ласкаво просимо до R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Будь ласка, введіть новий пароль і підтвердьте його, щоб активувати обліковий запис R2W. Після успішного завершення вам автоматично буде відкрито вхід",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Ви пізніше можете змінити свої налаштування користувача в додатку",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Автомийка Kärcher",
    RESET_PASSWORD_WELCOME_MSG:"Автомийка R2W",
    RESET_PASSWORD_WELCOME_MSG_2:"Будь ласка, введіть новий пароль і підтвердіть його, щоб скинути старий пароль. У разі успіху ви будете автоматично авторизовані в додатку",
    RESET_PASSWORD_WELCOME_MSG_3:"Ви можете змінити свої налаштування пізніше в додатку",
    ENTER_NEW_PASSWORD:"Введіть новий пароль",
    REPEAT_NEW_PASSWORD:"Повторіть новий пароль",
    PASSWORD_MIN_LENGTH:"Пароль має містити принаймні 8 символів",
    PASSWORD_MAX_LENGHT:"Пароль має бути не більше 32 символів",
    PASSWORD_PATTERN:"Пароль повинен містити принаймні одну велику літеру та одну літеру нижнього регістру",
    PASSWORD_MATCH:"Паролі не збігаються",
    ACTIVATE:"Активувати",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Ви успішно подали запит. Будь ласка, перевірте електронну пошту на підтвердження",
    VALIDATION_REQUIRED:"Обов'язкове поле",
    VALIDATION_EMAIL:"невірна адреса електронної пошти",
    VALIDATION_INTEGER_NUMBER:"Будь ласка, введіть ціле значення",
    VALIDATION_HOURS_VALUE:"Значення має бути від 0 до 23",
    VALIDATION_MINUTES_VALUE:"Значення має бути від 0 до 59",
    VALIDATION_NOT_A_DATE:"Значення не є датою",
    VALIDATION_FROM:"Від дати більшої, ніж до",
    VALIDATION_TO:"На сьогоднішній день менше, ніж з",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Цей запис вже існує в базі даних",
    PASSWORD_VALIDATION_PATTERN_NEW:"Там повинна бути принаймні одна цифра та одна велика літери. Пробіли не допускаються",
    VALIDATION_PERCENT_VALUE:"Значення має бути між 1-999",
    NUMBERS_ONLY_100:"Номер до 100",
    NUMBERS_ONLY_1000:"Номер до 1000",
    POSITIVE_NUMBERS_ONLY:"Тільки позитивне число",
    GRID_PAGER_PAGE:"Сторінка",
    GRID_PAGER_ROWS_PER_PAGE:"Рядки на сторінку",
    GRID_PAGER_PAGE_OF:"від",
    BREAD_CRUMBS_HOME:"Головна",
    BREAD_CRUMBS_DASHBOARD_TECH:"Технологія панелі управління",
    BREAD_CRUMBS_DETAILS:"Подробиці",
    BREAD_CRUMBS_SETTINGS:"Налаштування",
    BREAD_CRUMBS_WORKING_HOURS:"Графік роботи",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Загальна сума грошей за днями",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Середня грошова інформація за годину",
    BREAD_CRUMBS_NEW_USER_GROUP:"Створити групу користувачів",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Редагувати групу користувачів",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Створити шаблон кампанії",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Редагувати шаблон кампанії",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Створити кампанію",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Редагувати кампанію",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Періодичний результат",
    LOGIN:"Увійти",
    EMAIL:"Електронна пошта",
    PASSWORD:"Пароль",
    LANGUAGE:"Мова",
    FORGOT_PASSWORD:"Забули пароль?",
    SUBMIT:"Відправити",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Кількість очікуваних сигналів:",
    HEADER_VIEW_ALL_ALARMS:"Переглянути всі сповіщення ...",
    HEADER_MY_ACCOUNT:"Мій рахунок",
    HEADER_ACCOUNT_MANAGEMENT:"Управління рахунками",
    ACCOUNT_ALREADY_EXIST:"Адреса електронної пошти вже використовується",
    NEWSLETTER_CONFIRMATION:"Надіслати сповіщення електронною поштою про стан тривоги",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Ohlyad shchodennykh finansiv",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Технологія панелі управління",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Панель приладів",
    ASIDE_MENU_ALARMS:"Повідомлення",
    ASIDE_MENU_FACILITIES:"Об'єкти",
    ASIDE_MENU_REPORTS:"Звіти",
    ASIDE_MENU_REPORT:"Обраний звіт",
    ASIDE_MENU_LOYALTY:"Лояльність",
    ASIDE_MENU_USER_GROUPS:"Групи користувачів",
    ASIDE_MENU_PERIODIC_SUMMARY:"Періодичний результат",
    ASIDE_MENU_MANAGING_TOKENS:"Керування токенами",
    ASIDE_MENU_NEWS:"Новини",
    DAILY_FINANCES_TOTAL_MONEY:"Всього грошей",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Сума грошей на всіх об'єктах",
    DAILY_FINANCES_TOTAL_COINS:"Усього використано металевих жетонів",
    DAILY_FINANCES_DOWNLOAD_CSV:"Завантажити CSV",
    DAILY_FINANCES_ONLINE:"R2W (онлайн)",
    DAILY_FINANCES_OFFLINE:"Готівка",
    DAILY_FINANCES_CHANGER:"Готівка в чейнджері",
    DAILY_FINANCES_COINS:"Токени / Eurokey",
    REPORTS_FILTER:"Фільтрувати",
    REPORTS_TYPE_OF_REPORT:"Тип звіту",
    REPORTS_CHOOSE_FACILITY:"Виберіть об'єкт",
    REPORTS_PERIOD_1:"Період 1 -",
    REPORTS_PERIOD_2:"Період 2 -",
    MONEY_BY_DATE_REPORT:"Сукупний дохід за датою",
    R2W_BY_DATE_REPORT:"Загальна кількість витрачених жетонів R2W за датою",
    COINS_BY_DATE_REPORT:"Всього монет за датою",
    AVG_MONEY_BY_HOUR_REPORT:"Середній дохід за годину",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Середній дохід за днем ​​тижня",
    AVG_MONEY_BY_BOX_REPORT:"Витрати на пральну машину",
    COMPARE_PERIODS_REPORT:"Порівняльний звіт по об'єкту",
    TOTAL_USERS_BY_GROUP:"Всього користувачів програми R2W за день",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"користувачів",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"відвідування",
    VISITS_COUNT_REPORT:"Кількість користувачів додатка R2W за кожне відвідування",
    LOYALTY_PER_DAY_REPORT:"Кількість локальних жетонів, витрачених за день",
    LOYALTY_PER_PAYMENT_METHOD:"Враховуючи локальні жетони за кожним способом оплати",
    VISITS:"Відвідування",
    VISIT:"Візити",
    TOTAL_SPENT_MONEY:"Загальний дохід",
    MONEY:"Гроші",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Загальна кількість витрачених грошей за період",
    DOWNLOAD_CSV:"Завантажити CSV",
    TOTAL_SPENT_COINS:"Всього витрачено жетонів",
    TOTAL_USERS:"Всього користувачів",
    TOTAL_CREDIT_GIVEN:"Всього витрачено локальних віртуальних жетонів",
    EUROKEY_BY_DATE_REPORT:"Загальна сума платежів Eurokey за датою",
    TOTAL_SPENT_EUROKEY:"Усього витрачено",
    SELECT_TYPE_OF_REPORT:"Вам потрібно вибрати тип звіту :)",
    NUMBER_OF_VISITS_TITLE:"Кількість відвідувань",
    NUMBER_OF_USERS_TITLE:"Кількість користувачів",
    PIECES_TITLE:"Шматки",
    TOTAL_VISITS:"Всього відвідувань",
    TOKENS_TITLE:"жетон",
    SEARCH_USERS_NO_RESULTS:"Не знайдено жодного користувача за даним пошуковим терміном",
    SEARCH_USERS:"Пошук користувачів",
    SEARCH_TELEPHONES:"Пошук користувачів за мобільним номером",
    ADD_USER_TO_GROUP:"Додати користувача до групи",
    REMOVE_USER_FROM_GROUP:"Видалити користувача з групи",
    USER_GROUP_NAME_REQUIRED:"Ім'я групи користувачів обов'язкове",
    USER_GROUP_NAME:"Назва групи користувачів",
    USER_GROUPS_OVERVIEW:"Огляд груп користувачів",
    USER_COUNT:"Кількість користувачів",
    NEW_USER_GROUP:"Створити нову групу користувачів",
    DELETE_USER_GROUP:"Видалити групу користувачів",
    UPDATE_USER_GROUP:"Редагувати групу користувачів",
    DELETE_USER_GROUP_ERROR:"Під час видалення вибраної групи користувачів виникла помилка. Будь ласка, повторіть спробу або зв'яжіться зі службою підтримки",
    CONFIRM_DELETE_USER_GROUP:"Ви впевнені, що хочете видалити вибрану групу користувачів?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Дії лояльності, на які покладена видалена група, більше не застосовуватимуться.",
    GROUP_NAME_MAX_LENGTH:"Назва групи має містити не більше 255 символів",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Користувач вже знаходиться в цій групі",
    MISSING_USER:"Відсутній користувач",
    USER_NOT_ON_LIST:"Користувач не знаходиться в списку активних користувачів. Перевірте правильність електронної адреси та повторіть спробу.",
    UPLOAD_USER_GROUP:"Завантажте список груп користувачів із файлу * .csv",
    UKNOWN_USERS:"Список невідомих користувачів",
    CAMPAIGN_TEMPLATE_RULE:"Правило шаблону",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Під час спроби видалити шаблон кампанії сталася помилка. Будь ласка, повторіть спробу або зв'яжіться зі службою підтримки",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Ви впевнені, що хочете видалити вибраний шаблон кампанії",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Ви впевнені, що хочете видалити вибраний шаблон кампанії",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Огляд шаблонів кампанії",
    DELETE_CAMPAIGN_TEMPLATE:"Видалити шаблон кампанії",
    UPDATE_CAMPAIGN_TEMPLATE:"Редагувати шаблон кампанії",
    CREATE_CAMPAIGN_TEMPLATE:"Створіть новий шаблон кампанії",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Ім'я шаблону кампанії обов'язкове",
    CAMPAIGN_TEMPLATE_NAME:"Назва шаблону кампанії",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Обов'язкове поле",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"Дай",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"кредити",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Виберіть спочатку тип. Коробки для прання або Малі машини.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Видалити правило шаблону",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Від",
    CAMPAIGN_TEMPLATE_RULE_TO:"до",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"годин",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"хвилин",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Нове правило за кількістю візитів",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Нове правило за кількістю витрачених грошей",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Нове правило за днями тижня",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Додайте нове правило шаблону",
    CAMPAIGN_TEMPLATE_RULE_1:"Кожен",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Кожен",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"кредити, витрачені менш ніж на",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"відвідування менш ніж",
    CAMPAIGN_TEMPLATE_RULE_3:"дні",
    CAMPAIGN_TEMPLATE_RULE_4:"кредити",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Список правил порожній.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Дата не може бути в минулому",
    DELETE_CAMPAIGN_ERROR:"Під час спроби видалити кампанію сталася помилка. Будь ласка, повторіть спробу або зв'яжіться зі службою підтримки",
    CONFIRM_DELETE_CAMPAIGN:"Ви впевнені, що хочете видалити вибрану кампанію?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W не несе відповідальності за користувацький досвід, викликаний цією дією.",
    CAMPAIGNS_OVERVIEW:"Огляд кампаній",
    DELETE_CAMPAIGN:"Видалити кампанію",
    UPDATE_CAMPAIGN:"Редагувати кампанію",
    CREATE_CAMPAIGN:"Створити нову кампанію",
    CAMPAIGN_ACTIVE:"Активний",
    CAMPAIGN_TEMPLATE:"Шаблон",
    CAMPAIGN_GROUPS:"Групи",
    CAMPAIGN_ALL_USERS:"Всі користувачі",
    CAMPAIGN_NAME:"Назва кампанії",
    CAMPAIGN_NAME_REQUIRED:"Обов'язково",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Кількість користувачів переддень",
    MESSAGE_TO_USERS:"Повідомлення для відфільтрованих користувачів",
    SEND_MESSAGE:"Відправити повідомлення",
    THRESHOLD:"Переддень",
    TYPE:"Тип",
    TOTAL_MONEY_SPENT:"Загальні витрачені гроші в кампанії",
    NUMBER_OF_VISITS:"Кількість відвідувань у кампанії",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Повідомлення має містити щонайменше 10 символів",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Повідомлення має бути не більше 350 символів",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Текст повідомлення обов'язковий",
    TECHNOLOGY:"Технологія",
    TAP_WATER:"Вода вхiдна",
    REVERSE_OSMOSIS:"Зворотній осмос",
    SOFTENED_WATER:"Пом'якшена вода",
    DOSER:"Дозатор",
    STATUS:"Стан справ",
    LAST_SYNCHRONIZATION:"Остання синхронізація",
    NO_OF_CURRENT_ALARMS:"Кількість поточних сигналів тривоги",
    NO_OF_CURRENT_WARNINGS:"Кількість поточних попереджень",
    WEATHER:"Погода",
    BOXES_WORK_HOURS_COUNTERS:"Годинники робочого часу",
    BOX_TOTAL_HOURS:"Загальний час роботи",
    BOX_SERVICE_HOURS:"Загальний час роботи (сервіс)",
    BOX_COUNTER_HOURS:"годин",
    ALARMS_AND_WARNINGS:"Сигнали та попередження",
    FILTER_AND_BOILER:"Фільтр і котел",
    FILTER_TOTAL_DAYS:"Фільтр робочі дні",
    BOILER_TOTAL_DAYS:"Робочі дні котла",
    DAYS_UNIT:"дні",
    SOFTENER:"Пом'якшувач",
    MANUAL_COLD_DRAIN:"Ручний холодний стік",
    EL_COLD:"Ел. холодний",
    DRAIN:"стік",
    TAP:"торкніться",
    WASTE:"Відходи",
    OSMOSIS:"осмос",
    DEMI_WATER:"Демініралізована вода",
    EL_RINSE:"Ел м. полоскання",
    BOILER:"Бойлер/Котел",
    EL_WAX:"Ел м. віск",
    FLOOR_HEATING:"Підігрів підлоги",
    DOSER_TANK:"Дозатор бак",
    EL_WASH:"Ел м. миття",
    DETERGENT:"Мікро-порошок",
    VIBRATOR:"Вібратор",
    UPDATE_FACILITY_SETTINGS:"Оновити налаштування",
    GENERAL_SETTINGS:"Загальні налаштування",
    LIGHTS:"Світло",
    GROUPS:"Групи",
    ANTI_FREEZE:"Антизамороження",
    AUTO:"Автоматично",
    MANUAL:"Вручну",
    ON:"Включити",
    OFF:"Вимкнути",
    TEMPERATURE:"Температура",
    UPDATE_DEVICE:"Оновлення налаштувань об'єкта",
    BOX_CLEAN_HOURS:"Бокс чистий лічильник (години)",
    GROUP_COUNTERS:"Групові лічильники",
    RESET:"Скинути",
    CASH_COUNT:"Кількість монет",
    COINS_COUNT:"Кількість жетонів",
    EUROKEY_COUNT:"Кількість Еurokey",
    DOSER_WORK:"Робочий час дозатора (сек.)",
    DOSER_PAUSE:"Час паузи дозатора (сек.)",
    DELAY_BFV:"Затримка BFV (мс)",
    DELAY_6M1:"Затримка 6M1 (мс)",
    DELAY_LPS:"Затримка LPS (мс)",
    RESET_CASH_COUNT_ALL:"Скинути всі лічильники монет",
    RESET_COINS_COUNT_ALL:"Скинути всі лічильники жетонів",
    RESET_EUROKEY_COUNT_ALL:"Скинути всі лічильники Еurokey",
    FACILITY_DETAILS:"Деталі об'єкта",
    FACILITY_NAME:"Назва об'єкта",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Ви успішно завантажили зображення",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Ви успішно оновили дані",
    CONNECTED:"пов'язаний",
    DISCONNECTED:"Відключено",
    OFFLINE:"відключений",
    MESSAGES_FILTER:"Фільтрувати повідомлення",
    FACILITY:"Об'єкт",
    APPLY:"Застосувати",
    TIME:"Час",
    LOCATION:"Місцезнаходження",
    ACKNOWLEDGED:"Визнано",
    FILTERED_MESSAGES:"Відфільтровані повідомлення",
    ACK:"Визнано",
    NOT_ACK:"Не визнано",
    ALL:"Всі",
    ALL_FACILITIES:"Всі об'єкти",
    ENTER_DATE_PLACEHOLDER:"Введіть дату",
    OP_NESTANAK_NAPONA:"Відсутня напруга на фазовому індикаторі 3А5",
    OP_OTB_PUMPA_GRESKA_MZS:"Автоматичний вимикач високого тиску скинуто",
    OP_UPR_NAPON_24VAC_GRE:"Відсутній 24 VAC - автоматичний вимикач 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Бак для прісної води порожній",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Автоматичний вимикач мережевого насосу скинуто",
    OP_MIN_NIVO_OMEKS_VODE:"Бак для пом'якшенної води порожній",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Насос циркуляції пом'якшенної води скинуто",
    OP_MIN_NIVO_DEMIN_VODE:"Бак осмосованної води порожній",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Насос циркуляції осмасованої води скинуто",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Автоматичний вимикач насосу виробництва осмосу скинуто",
    OP_BOJLER_GRESKA_MZS:"Помилка водонагрівача",
    OP_CRPKA_PRASKA_GRE_MZS:"Автоматичний вимикач гарячого водопостачання скинуто",
    OP_DOZATOR_PRASKA_GRE_MZS:"Автоматичний вимикач порошкового дозатора скинуто",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Вимикач порошкового дозування вібратора скинуто",
    OP_MIN_PRASAK_TON_ALARM:"Бак для змішування мікропорошку порожній",
    OP_USIS_KOV_TURBINA_GRESKA:"Автоматичний вимикач вакуумної турбіна всмоктування моонет/жетонів скинуто",
    OP_FILTER_VODE_ZACEPLJEN:"Фільтр води заблоковано",
    OP_VISKTL_RESET_SATI_RADA:"Сервіс насосу високого тиску",
    OPW_VISKTL_RESET_SATI_RADA:"Сервіс насосу високого тиску",
    OP_FILTER_DANI_RADA:"Помилка фільтра води",
    OP_BOJLER_DANI_RADA:"Помилка водонагрівача",
    OPW_ALARM_VISOKOTL_PUMPA:"Сигналізація насосу високого тиску",
    OPW_ALARM_FILTER_SERVIS:"Сигнал необхідного сервісу фільтра",
    OPW_ALARM_BOJLER_SERVIS:"Сигнал необхідного сервісу бойлера",
    HAS_MEMBERS:"Вибрана група має членів і їх неможливо видалити. Учасників потрібно спочатку видалити.",
    PERIODIC_SUMMARY_FOR:"ПЕРІОДИЧНИЙ ЗВІТ ПО",
    PERIODIC_SUMMARY_REPORTS:"Періодичні підсумкові звіти",
    DATE_RANGE:"Проміжок часу",
    FINANCIAL_REPORT:"Фінансовий звіт",
    GROSS_INCOME:"Валовий дохід",
    GROSS_INCOME_SUM:"Сума валового доходу",
    COMMISSION_FEE:"Комісійний збір",
    NET_INCOME:"Чистий прибуток (для виставлення рахунку)",
    COMMISSION_FEE_DETAILS:"Комісійний збір включаючи плату банку / PayPal або платіж постачальників SMS-послуг.",
    LOYALTY_CREDITS_REPORT:"Звіти по локальним жетонам",
    LOYALTY_GIVEN:"Враховуючи локальні жетони",
    LOYALTY_USED:"Використовані локальні жетони",
    LOYALTY_SOLD:"Локальні жетони завантажені",
    LOYALTY_TOTAL:"Всього",
    LOYALTY_CURRENT_MONTH:"Поточний місяць",
    SOMETHING_WENT_WRONG:"Упс....",
    MISSING_PAGE:"Вибачте, ми не змогли знайти цю сторінку",
    TRY_AGAIN:"Спробуйте ще раз",
    DEFAULT_ERROR_NAME:"Невідома помилка",
    DEFAULT_ERROR_DESCRIPTION:"Будь ласка спробуйте ще раз",
    MY_ACCOUNT_DETAILS:"Дані мого облікового запису",
    SAVE_CHANGES:"Зберегти зміни",
    USERNAME:"Ім'я користувача",
    FIRST_NAME:"Ім'я",
    LAST_NAME:"Прізвище",
    USER_ROLE:"Роль користувача",
    OLD_PASSWORD:"Старий пароль",
    NEW_PASSWORD:"Новий пароль",
    OLD_PASSWORD_REQUIRED:"Потрібний старий пароль",
    NEW_PASSWORD_REQUIRED:"Новий пароль обов'язковий",
    NEW_PASSWORD_REPEAT:"Необхідно повторити новий пароль",
    NEW_PASSWORD_NOT_MATCH:"Старий і новий пароль не збігаються",
    PASSWORD_DIFFERENT_VALIDATION:"Новий пароль повинен відрізнятися від старого",
    PASSWORD_MIN_CHAR:"Ваш пароль має містити принаймні 8 символів",
    PASSWORD_MAX_CHAR:"Ваш пароль має містити не більше 32 символів",
    PASSWORD_PATTERN_VALIDATION:"Пароль повинен містити принаймні одне число",
    ACCOUNT_MANAGEMENT:"Управління рахунками",
    NOT_ACTIVE:"Не активний",
    ASSIGN_ROLE:"Призначити роль",
    UPDATE:"Оновити",
    ADD_NEW_ACCOUNT:"Додати новий акаунт",
    EMAIL_REQUIRED:"Електронна адреса обов'язкова",
    EMAIL_NOT_VALID:"Електронна адреса недійсна",
    ADD_NEW_USER_TEXT:"Електронний лист з активаційним посиланням буде надісланий на вказану адресу електронної пошти.",
    UPDATE_USER_NOTIFICATION:"Ви успішно оновили свою інформацію",
    CHANGED_PASSWORD_NOTIFICATION:"Ви успішно змінили свій пароль",
    UPDATE_USER_GROUP_NOTIFICATION:"Ви успішно оновили назву групи користувачів",
    CREATE_USER_GROUP_NOTIFICATION:"Ви успішно створили групу",
    DETELE_USER_GROUP_NOTIFICATION:"Ви успішно видалили групу",
    EMPTY_GROUP_LIST_MSG:"Немає створених груп. Почніть із створення",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Ви успішно видалили користувача з групи",
    ADD_USER_TO_GROUP_NOTIFICATION:"Ви успішно додали користувача до групи",
    ADD_USER_NOTIFICATION:"Ви успішно додали нового користувача",
    DELETE_USER_NOTIFICATION:"Ви успішно видалили користувача",
    RESEND_USER_VERIFICATION_EMAIL:"Ви успішно повторно надіслали електронний лист з підтвердженням",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Для створення групи користувачів",
    DELETE_USER:"Видалити користувача",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Ви впевнені, що хочете видалити користувача з групи користувачів?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Шановний користувач R2W",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Норма лояльності за кількістю візитів",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Норма лояльності на витрачену суму",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Норма лояльності на кожний день тижня",
    REMOVE_CAMPAIGN_RULE_TITLE:"Видалення правила кампанії",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Ви впевнені, що хочете видалити правило кампанії?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Ви успішно створили нову кампанію",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Ви успішно активували кампанію",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Немає створених кампаній. Почніть із створення",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Ви успішно надіслали повідомлення",
    COMPANY_ACCOUNTS:"Облікові записи компанії",
    BUSSINESS_INVOICES_LIST:"Мої рахунки-фактури на рахунку B2B",
    LOCALE_TOKEN:"Місцевий токен",
    R2W:"Глобальний токен",
    START_MONTH:"Початок місяця",
    END_MONTH:"Кінець місяця",
    TOKEN_TYPE:"Тип токена",
    TOKEN_NUMBER:"Номер токена",
    NOTHING_TO_DISPLAY:"* Нічого не відображати",
    CREATE_INVOICE:"Створити рахунок-фактуру",
    INVOICE:"Рахунок-фактура",
    INVOICES:"Рахунки-фактури",
    EDIT_INVOICE:"Редагувати рахунок-фактуру",
    UPDATE_INVOICE_NOTIFICATION:"Ви успішно оновили рахунок-фактуру в очікуваний статус",
    CURRENT_CHARGES:"Збори за поточний період",
    PAYMENTS_ON_HOLD:"Рахунки в обробці",
    FOR_INVOICING:"Для рахунків-фактур",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Ви збираєтеся скасувати рахунок-фактуру",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Ви впевнені, що хочете скасувати цей рахунок-фактуру?",
    INVOICING_NOTIFICATION_HEADER:"Ви збираєтеся робити виставлення рахунків",
    INVOICING_NOTIFICATION_TEXT:"Ви впевнені, що хочете надіслати рахунок-фактуру?",
    SENT_INVOICE_NOTIFICATION:"Ви успішно надіслали рахунок-фактуру",
    CANCELED_INVOICE_NOTIFICATION:"Ви успішно скасували рахунок-фактуру",
    INVOICE_DESCRIPTION_TEXT:"Рахунок для",
    INVOICE_STATE:"Стан рахунку-фактури",
    INVOICE_NUMBER:"Номер накладної",
    INVOICE_TOTAL:"Всього",
    SELECT_YEAR:"Виберіть рік",
    DOWNLOAD:"Завантажити PDF",
    INVOICE_NUMBER_HEADER:"Ви надішлете рахунок-фактуру з номером",
    INVOICE_PAYMENT_CONFIRMATION:"Ви хочете підтвердити оплату ",
    INSERT_INVOICE_NUMBER:"Введіть номер рахунку-фактури",
    INVOICED_WARNING:"Електронний лист не був надісланий. Будь ласка, зачекайте ...",
    SEND_INVOICE:"Відправити",
    INVOICE_ALL:"Все",
    INVOICE_FROM_R2W:"З R2W",
    INVOICE_TO_R2W:"До R2W",
    PAYMENT_REQUEST:"Запит на оплату",
    PAYMENT_REQUEST_STATE:"Стан запиту платежу",
    PAYMENT_REQUEST_NUMBER:"Номер заявки на оплату",
    FOR_PAYMENT_REQUEST:"Запит на оплату",
    PAYMENT_REQUEST_ON_HOLD:"Запит на оплату в процесі обробки",
    DOWNLOAD_INVOICE:"Завантажити рахунок-фактуру",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Натисніть для завантаження параметрів",
    B2B_SPEC:"B2B Специфікація",
    B2C_SPEC:"B2C Специфікація",
    DOWNLOAD_PAYMENT_REQUEST:"Завантажити платіжний запит",
    LOYALTY_PREVIEW:"Перевірка лояльності",
    ACTIVATED:"Активовано",
    RUNNING:"Хід",
    NOT_ACTIVATED:"Не активовано",
    FINISHED:"Готово",
    DEPRECATED:"Не призначено",
    UPCOMING:"Майбутні",
    NONE:"Ні",
    STARTED:"Початок",
    ENDS:"Закінчується",
    DEDICATED:"Присвячений",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Ви маєте активувати",
    CAMPAIGN:"кампанія",
    SEND_MESSAGE_NOTIFICATION:"Ви будете надсилати повідомлення вибраним групам користувачів",
    DIVISIBLE_TO_NUMBER:"Номер повинен бути ділиться на ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Тип пристрою",
    LISTENER:"Малі машини",
    BRIDGE:"Коробки для прання",
    WASH_BOXES:"Коробки для прання",
    VACUUMS:"Пилососи",
    SAVE_NEWS:"Зберегти новини",
    CREATE_NEW_NEWS:"Створити нові новини",
    HISTORY_OF_ALL_NEWS:"Історія всіх новин",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Введіть назву об'єкта",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Додати ще один об'єкт",
    NEWS_TEXT:"Текст новин",
    NEWS_TITLE:"Назва новин",
    DELETE_NEWS_CONFIRMATION:"Ви збираєтесь видаляти новини",
    NEWS_DELETE_NOTIFICATION:"Ви успішно видаляєте новини",
    NEWS_SAVE_NOTIFICATION:"Ви успішно зберегли новини",
    NEWS_CREATION_DATE:"Дата створення",
    NO_TITLE:"Немає заголовка",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Текст новин повинен містити не більше 255 символів",
    NEWS_TEXT_REQUIRED_VALIDATION:"Текст новин обов'язковий",
    NEWS_TITLE_REQUIRED_VALIDATION:"Заголовок новини обов'язковий",
    DEACTIVATE:"Деактивувати",
    ASIDE_MENU_LOCAL_TOKENS:"Локальні жетони",
    CREATE_NEW_LOCAL_TOKENS:"Випуск нових локальних жетонів",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Введіть адресу електронної пошти клієнта та кількість локальних жетонів, які ви хочете видати клієнту",
    CREATE_TOKENS:"Випуск жетонів",
    MINIMUM_ONE_TOKEN:"Значення має бути числом більше 0",
    CUSTOMER_EMAIL:"Електронна пошта клієнта",
    AMOUNT_OF_TOKENS:"Кількість жетонів",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Успішний випуск локальних жетонів на",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Виникла помилка при видачі локальних жетонів. Будь ласка, перевірте адресу електронної пошти клієнта та повторіть спробу.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Огляд випущених локальних жетонів",
    ISSUED_AT:"Виданий в",
    ISSUED_BY:"Випущено в",
    CODE:"Активувати код",
    REDEEMED_BY:"Викуплено",
    REDEEMED_AT:"Викуплено в",
    ASIDE_MENU_VOUCHERS:"Ваучери",
    PRINT:"Друк",
    VOUCHERS_OVERVIEW:"Огляд ваучерів",
    CREATE_NEW_VOUCHERS:"Створити нові ваучери",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Створіть нову викупну ваучерну партію, введіть кількість жетонів на ваучер",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Кількість жетонів на ваучер",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Ви можете призначити від 1 до 100 жетонів на ваучер",
    NUMBER_OF_NEW_VOUCHERS:"Кількість ваучерів, які потрібно створити",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Ви можете створювати від 1 до {{size}} ваучерів в одному пакеті",
    NEW_VOUCHERS_PREFIX:"Новий ваучер серійний код префікса",
    VALIDATION_VOUCHER_PREFIX:"Префікс коду повинен складати точно 4 символи (великими літерами та / або цифрами)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Виникла проблема з створенням нових ваучерів. Будь ласка, спробуйте ще раз або зверніться до нашої підтримки.",
    CREATE_VOUCHERS:"Створити ваучери",
    CREATING_VOUCHERS_SUCCESS:"Успішно створено нові ваучери",
    PRINT_NEW_VOUCHERS:"Друк ваучерів",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Введіть префікс коду ваучера, щоб надрукувати всю серію ваучерів. Альтернативно",
    PRINT_VOUCHERS_PREFIX:"Приставка ваучера (серії)",
    NO_VOUCHERS_FOR_PRINT:"Для друку не знайдено жодних ваучерів, що відповідають запропонованому префіксу коду",
    PRINT_VOUCHERS:"Друк ваучера (ів)",
    VALIDATION_VOUCHER_CODE_FILTER:"Пошуковий термін ваучер повинен складатися з великих літер та цифр",
    FILTER_VOUCHERS_BY_CODE:"Пошук ваучерів за викупним кодом",
    FILTER_VOUCHERS:"Пошукові ваучери",
    WASH_BOX:"Бокс мийки",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Усього використано цифрових токенів",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Загально придбані локальні жетони за день",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Загально витрачені локальні жетони за день",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Усього наданих локальних жетонів на день",
    LOCAL_TOKEN:"Локальний жетон",
    GIVEN_TOKEN:"Видані локальні жетони",
    SOLD_TOKEN:"Продано локальні жетони",
    SMALL_MACHINES:"Малі машини",
    R2W_Listener:"Слухач",
    HHANLE_DEVICE:"HHanle - Бокс мийки",
    CODE_PREFIX_EXIST:"Префікс коду вже існує",
    CODE_PREFIX_EXIST_TEXT:"Ви не можете створити новий ваучер з цим префіксом коду. Будь ласка, встановіть інший.",
    MIN_FOUR_VALIDATION:"Рівно 4 символи",
    ALL_INFORMATION_1:"Вся інформація про",
    ALL_INFORMATION_2:"буде втрачено",
    ASIDE_MENU_TRANSACTIONS:"Операції",
    EXPENSES:"Витрати",
    TOPUPS:"Придбані токени",
    EXPENSES_LIST:"Перелік витрат",
    USER_EMAIL:"Електронна пошта користувача",
    COMPANY_NAME:"Назва компанії",
    TOPUPS_LIST:"Список придбаних токенів",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Серійний номер",
    SETUP_UNIT_MATERIAL_NO:"Матеріальний номер",
    SETUP_UNIT_WEBAPI_VERSION:"Версія WebApi",
    TOTAL_TURNOVER:"Оборот автомийки",
    AVAILABILITY_ALL:"Доступність",
    AVAILIBILITY:"Доступність мийних боксів:",
    AVAILABILITY_VACUUMS:"Доступність пилососів:",
    WASH_BOX_INFO:"Інформація про мийні бокси",
    VACUUM_CLEANER_INFO:"Інформація про пилососи",
    BREAD_CRUMBS_SERVICE:"Послуга",
    HOLIDAYS:"Свята",
    HOLIDAY:"Свято",
    LIGHTS_ON:"Світло ввімкнено",
    LIGHTS_OFF:"Світло вимкнено",
    WASH_BOXES_ON:"Мийний бокс увімкнено",
    WASH_BOXES_OFF:"Мийний бокс вимкнено",
    VACUUMS_ON:"Пилососи увімкнено",
    VACUUMS_OFF:"Пилососи вимкнені",
    TURNOVER:"Оборот",
    TURNOVER_MANUAL_WASH_UNIT:"Інструкція з обороту",
    STATUS_BAY_RUN_TIME:"Загальний час роботи мийного боксу",
    STATUS_BAY_PROGRAM_NAME:"Назва програми",
    STATUS_BAY_CREDIT:"Кредит мийного боксу",
    CLOUD_KREDIT:"Кредит у хмарі",
    STATUS_VACUUM_RUN_TIME:"Загальний час роботи пилососа",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Послуги закладу, програма мийного боксу та інформація про поточні несправності",
    UNAVAILABLE:"Пристрій недоступний",
    SHOW_HIDE_TABLE:"Показати/сховати таблицю робочих годин",
    PROGRAM_NAME:"Назва програми",
    PROGRAM_COUNTER:"Лічильник програми",
    NO_NAME:"Посилання не має назви",
    COUNTER_SERVICE_DATA:"Дані про послугу",
    NEED_SERVICE:"Потрібне обслуговування",
    PROGRAM_DATA:"Дані про програму мийного боксу",
    CURRENT_FAULT_DATA:"Поточні дані про несправності",
    REFERENCE_DUE:"Зараз",
    REFERENCE_SECONDS:"Секунди",
    REFERENCE_NAME:"Назва частини",
    WASHBOX_NAME:"Назва мийки",
    FAULT_NAME:"Назва несправності",
    FAULT_NUMBER:"Номер несправності",
    CURRENT_FAULT_COUNT:"Активні несправності",
    DEVICE_NOT_INSTALLED:"Пристрій не встановлено",
    STATUS_READY:"Стан готовості",
    STATUS_ERROR:"Стан помилки",
    CONNECTION_ERROR:"Офлайн",
    UNKNOWN_RESET:"Помилка програмного забезпечення",
    SOFTWARE_RESET:"Помилка програмного забезпечення",
    EXTERNAL_PIN_RESET:"Помилка програмного забезпечення",
    RESTART_OR_BROWNOUT_OCCURRED:"Помилка програмного забезпечення",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Помилка апаратного забезпечення",
    COULD_NOT_SIMULATE_COIN:"Помилка апаратного забезпечення",
    ERROR_SETTING_INHIBIT_MODE:"Помилка апаратного забезпечення",
    OFFLINE_DEVICE:"Автомийка офлайн",
    TARIFFS:"Тарифи",
    DAY:"День",
    NIGHT:"Ніч",
    VOUCHER_CODE:"Код ваучера",
    DISMISS_ALARM:"Скинути сигнал тривоги?",
    ALARM_ACTIVE:"Активні сигнали тривоги",
    NO_ALARM_ACTIVE:"Немає активних сигналів тривоги",
    ALARM_HISTORY:"Історія сповіщень",
    MANAGING_TOKENS:"Управління локальними токенами",
    EXPIRATION_DATE:"Термін придатності",
    EXTEND_TOKEN_DATE:"Подовжити термін дії маркера на",
    DELETE_TOKENS_FOR:" Видалити токени для",
    PUMP_TYPE:"Тип насосу",
    TURN_OFF_DEVICE:"Статус пристрою",
    OPERATION_DATA:"Дані про операцію",
    PUMP_DATA:"Дані насосу",
    PUMP_NAME:"Назва насосу",
    POINT_NAME:"Назва точки",
    CHANGER_INCOME:"Загальний дохід змінювача за датою",
    SELECTED_OPEN:"Відкрито в обраний робочий час",
    ALWAYS_OPEN:"Завжди відкрито (24/7)",
    CLOSED:"Закритий",
    CLOSED_24:"Закрито 24 години",
    OPENED_24:"Відкрито 24 години",
    MON:"Понеділок ",
    TUE:"Вівторок ",
    WED:"Середа ",
    THU:"Четвер ",
    FRI:"П’ятниця ",
    SAT:"Субота ",
    SUN:"Неділя ",
    PRICING:"Ціноутворення",
    PRICE:"Ціна",
    VALIDITY:"Дійсність",
    TOKEN_PACKAGES:"Пакети жетонів",
    SINGLE_WASH:"Одноразове миття",
    FACILITY_WORKING_HOURS:"Встановіть графік роботи для обраного об'єкта",
    WORKING_HOURS_ALWAYS_OPEN:"Завжди відкрито",
    WORKING_HOURS_ALWAYS_CLOSE:"Закривається оператором",
    WORKING_HOURS_CUSTOM:"Встановити графік роботи",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Організація",
    CREATE_ORGANIZATION:"Створити організацію",
    CREATE_ORGANIZATION_AS:"Створити організацію як дочірню для",
    DELETE_ORGANIZATION:"Видалити організацію",
    EDIT_ORGANIZATION:"Редагувати організацію",
    SUPPORTED_ORG_NAME:"Підтримувані організації",
    SUPPORTED_ORG_TYPE:"Підтримуваний тип",
    ORG_NAME:"Назва",
    ORG_TYPE:"Тип",
    SET_ORG_TITLE:"Встановити дочірню організацію",
    SET_SUPPORTED_ORG_TITLE:"Встановити підтримувану дочірню організацію",
    SAVE_ORGANIZATION:"Зберегти організацію",
    SELECT_ORGANIZATION_TYPE:"Вибрати тип організації",
    SELECT_ORGANIZATION_SELECTOR:"Вибрати",
    SELECT_SUPPORTED_ORGANIZATION:"Вибрати підтримувану організацію",
    ORGANIZATION_DELETED:"Організацію успішно видалено",
    ORGANIZATION_SAVED:"Організацію успішно збережено",
    ORGANIZATION_UPDATED:"Організацію успішно оновлено",
    ALERTS:"Сповіщення",
    DEVICE_STATUS:"Стан пристрою",
    SITE_DETAILS:"Інформація про сайт",
    ALARM_STATUS:"Статус оповіщення",
    FILTER:"Фільтрувати по ...",
    FILTER_BY_ALERT_CENTER:"Фільтрувати за кодом, назвою або описом",
    TOTAL_ALARM:"Всього",
    LOW_ALARM:"Подія",
    MEDIUM_ALARM:"Несправність",
    HIGH_ALARM:"Критична несправність",
    NO_FACILITIES_NEARBY:"Поблизу немає об'єктів",
    GRAY_MAP:"Карта в сірому кольорі",
    READY:"Готово",
    WARNING:"Несправність",
    ERROR:"Помилка",
    SITE_NAME:"Назва сайту",
    ACCOUNTS_INFO:"Інформація про обліковий запис",
    USER_ORGANIZATION:"Організація користувача",
    ADD_USER_ORGANIZATION:"Додати нового користувача організації",
    EDIT_USER_ORGANIZATION:"Редагування користувачів організації",
    SELECT_ROLE:"Виберіть роль",
    SELECT_ORGANIZATION:"Виберіть організацію",
    SELECT_USER:"Виберіть користувача",
    USER_FOR_ORGANIZATION_CREATED:"Новий користувач успішно створений",
    SELECT_REGION:"Виберіть регіон",
    SELECT_LANGUAGE:"Оберіть мову",
    LOADING_DATA:"Завантажуються дані, будь ласка, зачекайте ...",
    ADMINISTRATOR:"Адміністратор",
    TECHNICAL_SUPPORT:"Технічна підтримка",
    CONTROLLER:"Контролер",
    EDIT_ORGANIZATION_USER:"Редагувати користувачів організації",
    DELETE_ORGANIZATION_USER:"Видалення користувачів організації",
    USER_UPDATED:"Користувача успішно оновлено",
    USER_CREATED:"Користувача успішно створено",
    ADDRESS:"Адреса",
    SUBSCRIPTIONS:"Підписки",
    RESOLVED_STATUS:"Вирішено",
    NOT_RESOLVED_STATUS:"Не вирішено",
    ALERT_NAME:"Назва оповіщення",
    ALERT_DESCRIPTION:"Опис тривоги",
    ALERT_CODE:"Код тривоги",
    ALERT_TYPE:"Тип оповіщення",
    UNSUBSCRIBE:"Сповіщення про відписку",
    SUBSCRIBE:"Підписатися на оповіщення",
    ALARM_SUBSCRIBED:"Успішно підписано",
    UNSUBSCRIBED_CONFIRM:"Відмовитися від підписки?",
    ALARM_UNSUBSCRIBED:"Успішно скасовано підписку",
    ASIDE_MENU_CASHLESS_SALES:"Безготівкові продажі",
    FILTERED_CASHLESS_PAYMENTS:"Відфільтровані безготівкові платежі",
    REFUND_DIALOG_TITLE:"Відшкодувати транзакцію?",
    REFUND_DIALOG_SUBTITLE:"Сума може бути меншою або дорівнювати сумі транзакції",
    REFUND:"Відшкодування",
    INPUT_NOT_VALID:"Введені дані невірні",
    REFUND_SUCCESSFULLY:"Відшкодування за обраним платежем успішно виконано",
    USER:"Користувач",
    TRANSACTION_ID:"Посилання на PSP",
    DEVICE_ID:"ID пристрою",
    NET_AMOUNT:"Сума нетто",
    REPORT_NAME:"Назва звіту",
    TIME_FRAME:"Період часу",
    SUB_POINT:"Виберіть підпункт",
    SUB_POINT_LIST_NOT_EXIST:"Список підпунктів не існує для вибраної мийки",
    FACILITY_TYPE:"Тип мийки",
    MACHINE_NAME:"Назва машини",
    WASH_FACILITY_DETAILS:"Інформація про мийку",
    WASH_BAY_DETAILS:"Інформація про мийну камеру",
    DEVICES_INFO:"Список пристроїв",
    OPERATION_TIME_INFO:"Час роботи",
    OPERATION_TIME_VACUUM_INFO:"Час роботи пилососів",
    OPERATION_TIME_ILLUMINATION_INFO:"Час роботи освітлення",
    AVAILABLE_TITLE:"Доступно",
    UNAVAILABLE_TITLE:"Недоступно",
    CURRENT_PROGRAM:"Поточна програма",
    CREDITS:"Кредити",
    DEVICE_NAME:"Назва пристрою",
    ACTIVE_ALARMS:"Активні оповіщення",
    ALL_DAY:"Цілий день",
    OPERATING_TIME_WASH_FACILITY:"Система самообслуговування для миття",
    OPERATING_TIME_VACUUMS:"Пилососи",
    OPERATING_TIME_ILLUMINATION:"Освітлення",
    OPERATION_COUNTERS:"Лічильники операцій",
    EDIT:"Редагувати",
    WASHING_PROGRAMS:"Програми миття",
    INFO:"Подія",
    STATISTIC:"Статистика",
    ROLLOVER_DOSING:"Дозування",
    ROLLOVER_SPEED:"Швидкості",
    ROLLOVER_RESETS:"Ролловер - Дистанційне перезавантаження",
    ROLLOVER_RESETS_INFO:"Віддалене скидання має відбуватися відповідно до місцевих правил. Важливо: Перед скиданням переконайтеся, що ролловер порожній.",
    RESET_ROLLOVER:" Reset rollover",
    OPEN_DOOR_ROLLOVER:" Open",
    ROLLOVER_OPEN_DOOR_INFO:"Open wash hall door. Be careful.",
    ROLLOVER_OPEN_DOOR:" Open the door",
    APPLY_DOSING_CHANGES:"Внести зміни дозування",
    APPLY_SPEED_CHANGES:"Застосувати зміни швидкості",
    ACTUATION_SUCCESS:"Запит надіслано",
    REMAINING_TIME:"Час, що залишився",
    OPEN_24H:"Відкрити 24 години",
    CLOSE_24H:"Закрити 24 години",
    VALIDATION_OPERATION_TIME:"Неправильний формат. Використовуйте hh:mm",
    ROLLOVER:" Rollover",
    UPDATE_WASHING_PROGRAM:"Оновити програму прання",
    UPDATE_ACTUATORS:"Update actuators",
    OPEN_ROLOVER_DOOR_TITLE:" Want to open rollover door?",
    OPEN_ROLOVER_DOOR_CONTENT:" Are you sure you want to open the door?",
    RESET_ROLOVER_TITLE:" Want to reset rollover?",
    RESET_ROLOVER_CONTENT:" Are you sure you want to reset rollover?",
    G0:"{{brand === 'r2w' ? 'Пост 0' : 'Пост 1'}}",
    G1:"{{brand === 'r2w' ? 'Пост 1' : 'Пост 2'}}",
    G2:"{{brand === 'r2w' ? 'Пост 2' : 'Пост 3'}}",
    G3:"{{brand === 'r2w' ? 'Пост 3' : 'Пост 4'}}",
    G4:"{{brand === 'r2w' ? 'Пост 4' : 'Пост 5'}}",
    G5:"{{brand === 'r2w' ? 'Пост 5' : 'Пост 6'}}",
    G6:"{{brand === 'r2w' ? 'Пост 6' : 'Пост 7'}}",
    G7:"{{brand === 'r2w' ? 'Пост 7' : 'Пост 8'}}",
    G8:"{{brand === 'r2w' ? 'Пост 8' : 'Пост 9'}}",
    G9:"{{brand === 'r2w' ? 'Пост 9' : 'Пост 10'}}",
    G10:"{{brand === 'r2w' ? 'Пост 10' : 'Пост 11'}}",
    U0:"{{brand === 'r2w' ? 'Пилосос 0' : 'Пилосос 1'}}",
    U1:"{{brand === 'r2w' ? 'Пилосос 1' : 'Пилосос 2'}}",
    U2:"{{brand === 'r2w' ? 'Пилосос 2' : 'Пилосос 3'}}",
    U3:"{{brand === 'r2w' ? 'Пилосос 3' : 'Пилосос 4'}}",
    U4:"{{brand === 'r2w' ? 'Пилосос 4' : 'Пилосос 5'}}",
    U5:"{{brand === 'r2w' ? 'Пилосос 5' : 'Пилосос 6'}}",
    U6:"{{brand === 'r2w' ? 'Пилосос 6' : 'Пилосос 7'}}",
    U7:"{{brand === 'r2w' ? 'Пилосос 7' : 'Пилосос 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Звіт центру оповіщення, створений за вибраним об'єктом з інформаційної панелі",
    ALERT_CENTER_TITLE_BY_FACILITY:"Звіт центру оповіщення, створений за вибраним об'єктом з інформаційної панелі",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Звіт центру оповіщення",
    ERROR_MESSAGE_403:"У вас немає привілеїв для використання цього виклику api. Код помилки: 403",
    LAST_ACTIVE_PROGRAM:"Активна програма / Остання активна програма",
    PROGRAM_ID:"Номер програми",
    PROGRAM_PRICE:"Ціна програми",
    NORMAL_CHEMICAL_LEVEL:"ОК",
    LOW_CHEMICAL_LEVEL:"Потрібно поповнити запас",
    EMPTY_CHEMICAL_LEVEL:"Порожньо",
    CHEMICAL_LEVEL:"Індикація рівня миючих засобів (%)",
    ROLLOVER_STATUS:"Статус перекидання",
    ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
    ROLLOVER_STATUS_CODE_1:" Outside operating time",
    ROLLOVER_STATUS_CODE_2:" Program entry allowed",
    ROLLOVER_STATUS_CODE_3:"Position your vehicle",
    ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
    ROLLOVER_STATUS_CODE_5:"Vehicle back",
    ROLLOVER_STATUS_CODE_6:"Vehicle stop",
    ROLLOVER_STATUS_CODE_7:"Wash active",
    ROLLOVER_STATUS_CODE_8:"Wash stopped",
    ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
    ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
    ROLLOVER_STATUS_CODE_11:"Emergency stop",
    ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
    ROLLOVER_STATUS_CODE_13:"Anti frost active",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
    ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Критична несправність",
    NO_ALARM:"Немає критичної несправності",
    SOFTWARE_VERSION:"Версія програмного забезпечення",
    SOFTWARE_DATE:"Дата програмного забезпечення",
    SITE_ADDRESS:"Адреса сайту",
    SECONDS:"Секунди",
    SERVICE_PART_NAME:"Назва послуги:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Лічильник експлуатації та обслуговування",
    OPERATION_COUNTER:"Лічильник операцій",
    SERVICE_COUNTER:"Лічильник обслуговування",
    FAULT_CODE:"Код тривоги",
    PRESSURE_TITLE:"Тиск повітря",
    TIME_TITLE:"Поточний час",
    COUNTRY_TITLE:"Країна",
    CITY_TITLE:"Місто",
    REGION_TITLE:"Область",
    SELECT_POINTS_TO_SEARCH:"Вибрати пункти ...",
    LOGS_HISTORY:"Історія зміни параметрів",
    ACTUATOR_REFERENCE:"Посилання на привід",
    ACTUATOR_VALUE:"Значення приводу",
    POINT_ID:"Ідентифікатор точки",
    VALIDATION_NOT_VALID_RANGE:"Неправильний діапазон",
    ENABLE_ROLLOVER_RESET:"Встановивши цей прапорець, ви підтверджуєте, що ознайомилися з інструкціями з техніки безпеки та погоджуєтеся з ними.",
    CHANGE_OF_PARAMETERS:"Зміна параметрів",
    SELECT_OPTIONS:"Виберіть параметри",
    AUTOMATIC:"Автоматично",
    DESALTING:"Функція видалення солі",
    SEASON_WASH:"Сезонні програми мийки",
    SPRING_PROGRAM:"Весняні програми мийки",
    SUMMER_PROGRAM:"Літні програми мийки",
    AUTUMN_PROGRAM:"Осінні програми мийки",
    WINTER_PROGRAM:"Зимові програми мийки",
    DOOR_CONTROL:"Door control",
    SUMMER_DOOR_CONTROL:" Summer, operated with the gate control in summer mode",
    WINTER_DOOR_CONTROL:" Winter, operated with the gate control in winter mode",
    APPLY_PARAMETERS_CHANGES:"Застосувати зміни параметрів",
    WORKING_SCHEDULES:"Графіки роботи",
    HOLIDAY_SCHEDULES:"Графік святкових днів",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Святкові дні на об'єкті успішно створено",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Вихідні на об'єкті успішно оновлено",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Святкові дні на об'єкті успішно видалено",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Робочі графіки успішно поширено",
    HOLIDAY_SUCCESSFULLY_DELETED:"Святковий день успішно видалено",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Засіб для сушіння з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_SHAMPOO:"Шампунь з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_FOAM:"Піна з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_WAX_1:"Віск з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_POLISH_1:"Поліроль з низьким рівнем наповнення",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Очищувач дисків з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_WAX_2:"Віск з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Блиск для шин з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Засіб для видалення комах з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_POLISH_2:"Поліроль з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_INTENSIVE:"Інтенсивний з низьким рівнем заповнення",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Пінний дощ з низьким рівнем заповнення",
    CHEM_LEVEL_DRYING_AGENT:"Засіб для сушіння з низьким рівнем заповнення",
    CHEM_LEVEL_SHAMPOO:"Шампунь з низьким рівнем наповнення",
    CHEM_LEVEL_FOAM:"Піна з низьким рівнем заповнення",
    CHEM_LEVEL_WAX_1:"Віск до рівня заповнення",
    CHEM_LEVEL_POLISH_1:"Поліроль для рівня заправки",
    CHEM_LEVEL_RIM_CLEANER:"Очищувач колісних дисків рівня заливки",
    CHEM_LEVEL_WAX_2:"Віск до рівня заправки",
    CHEM_LEVEL_TYRE_SHINE:"Блиск для шин на рівні заправки",
    CHEM_LEVEL_INSECT_REMOVER:"Засіб від комах на рівні заливної горловини",
    CHEM_LEVEL_POLISH_2:"Поліроль рівня заправки",
    CHEM_LEVEL_INTENSIVE:"Рівень заповнення інтенсивний",
    CHEM_LEVEL_FOAM_RAIN:"Рівень заправки пінний дощ",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Ремінь для підйому щітки для даху на сервісній стійці",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Ремінь для підйому сушарки на сервісній стійці",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Сервісний кабель моторної щітки для даху лічильника",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Сервісний лічильник обслуговування насоса свіжої води",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Сервісний лічильник насоса відпрацьованої води",
    DRYING_AGENT:"Сушильний агент",
    FOAM_DRYING_AGENT:"Піноутворювач для сушіння",
    SHAMPOO:"Шампунь",
    FOAM:"Піна",
    BRUSH_FOAM:"Піна для щіток",
    WAX_1:"Віск",
    FOAM_WAX_1:"Пінний віск",
    POLISH_1:"Поліроль",
    RIM_CLEANING:"Засіб для чищення дисків",
    WAX_2:"Віск",
    FOAM_WAX_2:"Пінний віск",
    TYRE_SHINE:"Блиск для шин",
    INSECT_REMOVER:"Засіб для видалення комах",
    POLISH_2:"Поліроль",
    INTENSIVE_BASIC:"Інтенсивна базова",
    INTENSIVE_SIDE:"Інтенсивний бічний",
    INTENSIVE_ROOF_SPRAY_BAR:"Інтенсивний розпилювач для даху",
    TAR_REMOVER:"Видалення гудрону",
    UNDER_CHASSIS_CONVERSATION:"Мийка шасі",
    STATIONARY_PRE_SPRAY_ARCH:"Стаціонарна дуга попереднього обприскування",
    FOAM_RAIN:"Пінний дощ",
    PRE_CLEANING:"Попереднє очищення",
    BRUSH:"Щітка",
    CARE:"Догляд",
    DRYING:"Сушка",
    DRYING_LOW_NOISE:"Сушка зі зниженим рівнем шуму",
    INTENSIVE_CLEANING:"Інтенсивне очищення",
    BRUSH_CLEANING:"Чистка щітки",
    EMPTY_RUN:"Порожній хід",
    DRYING_AID:"Засіб для сушіння",
    WAX:"Віск",
    FOAM_WASH:"Пінна мийка",
    POLISH:"Поліроль",
    FOAM_POLISH:"Поліроль з піни",
    WHEEL_CLEANING:"Очищення коліс",
    HIGH_PRESSURE_ROOF:"Високий тиск на даху",
    HIGH_PRESSURE_SIDE:"Боковий високий тиск",
    DRYER_FORWARD:"Сушарка вперед",
    DRYER_BACKWARD:"Сушарка назад",
    DELETE_ALL_HOLIDAYS:"Видалити всі свята для вибраного об'єкта",
    CREATE_NEW_HOLIDAY:"Створити новий",
    RESET_INPUTS:"Скинути всі входи святкових днів",
    TWENTY_FOUR_HOURS_OPEN:"Відкрито 24 години",
    EVERY_YEAR:"Щорічно",
    DELETE_HOLIDAY:"Видалити свято",
    ADD_NEW_HOLIDAY:"Додати нове свято",
    HOLIDAYS_LIST:"Список існуючих свят",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Видалити всі свята для вибраного сайту?",
    VALIDATION_HOLIDAY_DATE:"Неправильний формат. Використовуйте мм-дд",
    FOR_DATE:"За датою",
    WITH_ID:"З ідентифікатором",
    FROM_HOURS:"Від (год)",
    FROM_MINUTES:"Від (хв)",
    TO_HOURS:"До (год)",
    TO_MINUTES:"До (хв)",
    NOT_MATCH:"Не збігається",
    START:"Від",
    STOP:"До",
    DAILY_TIME:"Список на 24 години",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Індивідуальне налаштування часу",
    PROGRAM_NOT_STARTED:"Програма ще не запущена",
    JETWASH:"Система мийки самообслуговування",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"er: Кількість збоїв в електропостачанні",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Насос свіжої води",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Насос технічної води",
    OPERATION_COUNTER_HP_PUMP_1:"Насос високого тиску 1",
    OPERATION_COUNTER_HP_PUMP_2:"Насос високого тиску 2",
    RELEASE_NOTES:"Версії програми та примітки до випуску",
    BACKEND_RELEASE_NOTES:"Примітки до випуску платформи:",
    FRONTEND_RELEASE_NOTES:"Примітки до версії веб-додатку:",
    SELECTED_FACILITY_TIMEZONE:"Часовий пояс для вибраного об'єкта:",
    REFRESH_PAGE:"Оновити сторінку",
    REFRESH_MAPS:"Оновити мапи",
    PUMPS:"Насоси",
    RUN_TIME:"Час роботи",
    RUN_TIME1:"Час роботи 1",
    RUN_TIME2:"Час роботи 2",
    PROGRAM_RUNTIME_ACTUATOR:"Привід для часу роботи",
    PROGRAM_RUNTIME_ACTUATOR_1:"Привід для часу роботи 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Привід для часу роботи 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Мінімальне значення 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Максимальне значення 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Використовуйте формат ціни x.xx",
    ACTUATION_NOT_ALLOWED:"Активація заборонена для поточної ролі користувача",
    MAINTENANCE_DAYS:"Дні технічного обслуговування",
    MAINTENANCE_WASHES:"Технічне обслуговування мийки",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Загальний дохід POS",
    PROPAGATE:"Розповсюдити",
    ALL_DAY_HOURS_SELECTOR:"Селектор типу 24 години",
    GET_OPERATING_TIME_FROM_SITE:"Отримати час роботи поточного пристрою з розкладу роботи сайту",
    USER_NOT_VALID:"Користувач не дійсний. Спробуйте під іншим обліковим записом.",
    VERIFIED:"Підтверджено",
    RESEND_VERIFICATION_MAIL:"Повторно надіслати лист з підтвердженням",
    RETURN_TO_DASHBOARD:"Повернутися до інформаційної панелі",
    ERROR_PAGE_BAD_REQUEST:"400 Неправильний запит.",
    WASHES:"Кількість прань",
    TIME_TO_SERVICE:"Час до обслуговування",
    ACCOUNT_ALREADY_ACTIVATED:"Обліковий запис вже активовано",
    DEVICE_EVENTS:"Події пристрою",
    DEVICE_EVENTS_LOG_PULLED:"Витягнуто журнал подій для пристрою",
    EVENTS_PULL_DATE:"Час витягнення подій:",
    DEVICE_EVENTS_REFRESH:"Витягти нові дані подій",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Проблема з підключенням веб-сокетів. Спробуйте оновити сторінку.",
    INSTALLATION_DATE:"Дата встановлення машини",
    KARCHER_CUSTOM_PROGRAM_NAME_1:" Гарячий віск",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Миття під високим тиском",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Пінка для дисків",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Потужна пінка",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Зупинити",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Пінне миття HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Миття",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Преміум догляд",
    INFO_TITLE:"Інформація",
    FOAM_WAX1:"Пінний віск",
    POLISH1:"Поліроль",
    WAX1:"Віск",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Деталі сайту успішно оновлені",
    COMPANY:"Компанія",
    FACILITY_HAS_CHANGER:"Є змінювач?",
    DISABLE_OFFLINE_ALARM:"Вимкнути сигнали R2W",
    ASIDE_WORKING_SCHEDULES:"Деталі сайту додатку",
    TERMS_OF_SERVICE_R2W_TITLE:"Умови обслуговування Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Умови обслуговування Ready2Wash",
    DATA_PROCESSING_TITLE:"Дані оброблені",
    PRIVACY_POLICY_TITLE:"Політика конфіденційності",
    READY_TO_PAY_TERMS_OF_SERVICE:"Умови обслуговування Ready2Pay",
    TERMS_AND_SERVICES:"Умови та послуги",
    HOURLY: "Щогодини",
    DAILY: "Щодня",
    WEEKLY: "Щотижня",
    MONTHLY: "Щомісяця",
    YEARLY: "Щороку",
    DELETE_ITEM_SUCCESS:"Ви успішно видалили елемент",
    STATE: "Стан",
    AVAILABILITY_STATUS_1: "Пристрій відкрито",
    AVAILABILITY_STATUS_2: "Пристрій закрито (відпустка)",
    AVAILABILITY_STATUS_3: "Пристрій закрито (робочий час)",
    AVAILABILITY_STATUS_4: "Пристрій закрито (несправність)",
    AVAILABILITY_STATUS_5: "Пристрій закрито (інше)",
    AVAILABILITY_VACUUMS_STATUS_1: "Пилососи не встановлені",
    AVAILABILITY_VACUUMS_STATUS_2: "Пилососи відкриті",
    AVAILABILITY_VACUUMS_STATUS_3: "Пилососи закрито (відпустка)",
    AVAILABILITY_VACUUMS_STATUS_4: "Пилососи закрито (робочий час)",
    AVAILABILITY_VACUUMS_STATUS_5: "Пилососи закрито (несправність)",
    AVAILABILITY_VACUUMS_STATUS_6: "Пилососи закрито (інше)",
    ECOM_AMOUNT: "Загальний Ecom для всіх локацій",
    CAPTURED: "Зареєстровано",
    DELETE_COMPANY_HISTORY_INFO:"Ця дія видалить усі дані звітів вашої компанії. Цю дію неможливо скасувати.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Ви впевнені, що хочете назавжди видалити всі дані звітів?",
    VALUE_DATE: "Дата валютування",
    KARCHER_EVENT_NAME_1: "Основний теплообмінник регенеровано",
    KARCHER_EVENT_NAME_2: "Регенерацію основного теплообмінника завершено",
    KARCHER_EVENT_NAME_3: "Матеріал / серійний номер",
    KARCHER_EVENT_NAME_4: "Система продезінфікована",
    KARCHER_EVENT_NAME_5: "HP насос 1 продезінфіковано",
    KARCHER_EVENT_NAME_6: "HP насос 2 продезінфіковано",
    KARCHER_EVENT_NAME_7: "HP насос 3 продезінфіковано",
    KARCHER_EVENT_NAME_8: "HP насос 4 продезінфіковано",
    KARCHER_EVENT_NAME_9: "HP насос 5 продезінфіковано",
    KARCHER_EVENT_NAME_10: "Мийна станція 1 заблокована",
    KARCHER_EVENT_NAME_11: "Мийна станція 2 заблокована",
    KARCHER_EVENT_NAME_12: "Мийна станція 3 заблокована",
    KARCHER_EVENT_NAME_13: "Мийна станція 4 заблокована",
    KARCHER_EVENT_NAME_14: "Мийна станція 5 заблокована",
    KARCHER_EVENT_NAME_15: "Мийна станція 6 заблокована",
    KARCHER_EVENT_NAME_16: "Мийна станція 7 заблокована",
    KARCHER_EVENT_NAME_17: "Мийна станція 8 заблокована",
    KARCHER_EVENT_NAME_18: "Оновлення розпочато",
    KARCHER_EVENT_NAME_19: "Оновлення завершено",
    KARCHER_EVENT_NAME_20: "Початок реєстрації WS",
    KARCHER_EVENT_NAME_21: "Кінець реєстрації WS",
    KARCHER_EVENT_NAME_22: "Датчик WS 75%",
    KARCHER_EVENT_NAME_23: "Технічна помилка",
    KARCHER_EVENT_NAME_24: "Операційна помилка",
    KARCHER_EVENT_NAME_25: "Пристрій увімкнено",
    KARCHER_EVENT_NAME_26: "Пристрій вимкнено",
    KARCHER_EVENT_NAME_27: "Шафа 1 закрита",
    KARCHER_EVENT_NAME_28: "Шафа 2 закрита",
    KARCHER_EVENT_NAME_29: "Шафа 3 закрита",
    KARCHER_EVENT_NAME_30: "Шафа 4 закрита",
    KARCHER_EVENT_NAME_31: "Шафа 5 закрита",
    KARCHER_EVENT_NAME_32: "Шафа 6 закрита",
    KARCHER_EVENT_NAME_33: "Шафа 7 закрита",
    KARCHER_EVENT_NAME_34: "Шафа 8 закрита",
    KARCHER_EVENT_NAME_35: "Насосна станція HP 1",
    KARCHER_EVENT_NAME_36: "Насосна станція HP 2",
    KARCHER_EVENT_NAME_37: "Насосна станція HP 3",
    KARCHER_EVENT_NAME_38: "Насосна станція HP 4",
    KARCHER_EVENT_NAME_39: "Насосна станція HP 5",
    KARCHER_EVENT_NAME_40: "Насосна станція HP 6",
    KARCHER_EVENT_NAME_41: "Насосна станція HP 7",
    KARCHER_EVENT_NAME_42: "Насосна станція HP 8",
    KARCHER_EVENT_NAME_43: "Горілка",
    KARCHER_EVENT_NAME_44: "Вентилятор горілки",
    KARCHER_EVENT_NAME_45: "Насос для гарячої води",
    KARCHER_EVENT_NAME_46: "Насос для захисту від замерзання",
    KARCHER_EVENT_NAME_47: "Осмотичний насос",
    KARCHER_EVENT_NAME_48: "Підігрів підлоги",
    KARCHER_EVENT_NAME_49: "Підігрів шланга",
    KARCHER_EVENT_NAME_50: "Мікро/чистка колісних дисків",
    KARCHER_EVENT_NAME_51: "Насос для миття шасі",
    KARCHER_EVENT_NAME_52: "Насос для піноутворення Booster",
    KARCHER_EVENT_NAME_53: "Пилосос 1",
    KARCHER_EVENT_NAME_54: "Пилосос 2",
    KARCHER_EVENT_NAME_55: "Пилосос 3",
    KARCHER_EVENT_NAME_56: "Пилосос 4",
    KARCHER_EVENT_NAME_57: "Пилосос 5",
    KARCHER_EVENT_NAME_58: "Пилосос 6",
    KARCHER_EVENT_NAME_59: "Пилосос 7",
    KARCHER_EVENT_NAME_60: "Пилосос 8",
    KARCHER_EVENT_NAME_61: "Пилосос 9",
    KARCHER_EVENT_NAME_62: "Пилосос 10",
    KARCHER_EVENT_NAME_63: "Пилосос 11",
    KARCHER_EVENT_NAME_64: "Пилосос 12",
    KARCHER_EVENT_NAME_65: "Насос для очищення колісних дисків",
    KARCHER_EVENT_NAME_66: "Мікронасос",
    KARCHER_EVENT_NAME_67: "Інтенсивний насос",
    KARCHER_EVENT_NAME_68: "Турбіна пилососа 1",
    KARCHER_EVENT_NAME_69: "Фільтр пилососа 1",
    KARCHER_EVENT_NAME_70: "Турбіна пилососа 2",
    KARCHER_EVENT_NAME_71: "Фільтр пилососа 2",
    KARCHER_EVENT_NAME_72: "Турбіна пилососа 3",
    KARCHER_EVENT_NAME_73: "Фільтр пилососа 3",
    KARCHER_EVENT_NAME_74: "Турбіна пилососа 4",
    KARCHER_EVENT_NAME_75: "Фільтр пилососа 4",
    KARCHER_EVENT_NAME_76: "Турбіна пилососа 5",
    KARCHER_EVENT_NAME_77: "Фільтр пилососа 5",
    KARCHER_EVENT_NAME_78: "Турбіна пилососа 6",
    KARCHER_EVENT_NAME_79: "Фільтр пилососа 6",
    KARCHER_EVENT_NAME_80: "Турбіна пилососа 7",
    KARCHER_EVENT_NAME_81: "Фільтр пилососа 7",
    KARCHER_EVENT_NAME_82: "Турбіна пилососа 8",
    KARCHER_EVENT_NAME_83: "Фільтр пилососа 8",
    KARCHER_EVENT_NAME_84: "Турбіна пилососа 9",
    KARCHER_EVENT_NAME_85: "Фільтр пилососа 9",
    KARCHER_EVENT_NAME_86: "Турбіна пилососа 10",
    KARCHER_EVENT_NAME_87: "Фільтр пилососа 10",
    KARCHER_EVENT_NAME_88: "Турбіна пилососа 11",
    KARCHER_EVENT_NAME_89: "Фільтр пилососа 11",
    KARCHER_EVENT_NAME_90: "Турбіна пилососа 12",
    KARCHER_EVENT_NAME_91: "Фільтр пилососа 12",
    INSERT_TOKEN: "Введіть токен та запустіть сервіс",
    OPEN_SESSION: "Сесію успішно відкрито",
    IN_PROGRESS: "В процесі...",
    TOKEN_INSERTED: "Токен успішно введено",
    EXPIRED_SESSION: "Сесія завершилася",
    TWO_DIGIT_INTEGER_VALIDATION: "Використовуйте ціле число з максимум двома цифрами",
    KARCHER_OPERATION_COUNTER_1: "Мийна станція 1, високонапірний насос",
    KARCHER_OPERATION_COUNTER_2: "Мийна станція 1, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_3: "Мийна станція 1, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_4: "Мийна станція 1, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_5: "Мийна станція 1, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_6: "Мийна станція 2, високонапірний насос",
    KARCHER_OPERATION_COUNTER_7: "Мийна станція 2, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_8: "Мийна станція 2, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_9: "Мийна станція 2, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_10: "Мийна станція 2, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_11: "Мийна станція 3, високонапірний насос",
    KARCHER_OPERATION_COUNTER_12: "Мийна станція 3, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_13: "Мийна станція 3, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_14: "Мийна станція 3, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_15: "Мийна станція 3, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_16: "Мийна станція 4, високонапірний насос",
    KARCHER_OPERATION_COUNTER_17: "Мийна станція 4, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_18: "Мийна станція 4, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_19: "Мийна станція 4, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_20: "Мийна станція 4, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_21: "Мийна станція 5, високонапірний насос",
    KARCHER_OPERATION_COUNTER_22: "Мийна станція 5, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_23: "Мийна станція 5, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_24: "Мийна станція 5, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_25: "Мийна станція 5, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_26: "Мийна станція 6, високонапірний насос",
    KARCHER_OPERATION_COUNTER_27: "Мийна станція 6, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_28: "Мийна станція 6, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_29: "Мийна станція 6, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_30: "Мийна станція 6, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_31: "Мийна станція 7, високонапірний насос",
    KARCHER_OPERATION_COUNTER_32: "Мийна станція 7, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_33: "Мийна станція 7, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_34: "Мийна станція 7, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_35: "Мийна станція 7, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_36: "Мийна станція 8, високонапірний насос",
    KARCHER_OPERATION_COUNTER_37: "Мийна станція 8, хімічний насос 1",
    KARCHER_OPERATION_COUNTER_38: "Мийна станція 8, хімічний насос 2",
    KARCHER_OPERATION_COUNTER_39: "Мийна станція 8, хімічний насос 3",
    KARCHER_OPERATION_COUNTER_40: "Мийна станція 8, хімічний насос 4",
    KARCHER_OPERATION_COUNTER_41: "Осмосний насос",
    KARCHER_OPERATION_COUNTER_42: "Генератор гарячої води",
    KARCHER_OPERATION_COUNTER_43: "Насос захисту від замерзання",
    KARCHER_OPERATION_COUNTER_44: "Фільтри WSO",
    KARCHER_OPERATION_COUNTER_45: "Насос нагріву мийної станції",
    KARCHER_OPERATION_COUNTER_46: "Насос гарячої води",
    KARCHER_OPERATION_COUNTER_47: "Нагрівач для піни у шлангах",
    KARCHER_OPERATION_COUNTER_48: "Насос для миття коліс",
    KARCHER_OPERATION_COUNTER_49: "Мікроемульсійний насос",
    KARCHER_OPERATION_COUNTER_50: "Інтенсивний насос піни",
    KARCHER_OPERATION_COUNTER_51: "Пилосос 1 турбіна 1",
    KARCHER_OPERATION_COUNTER_52: "Пилосос 1 фільтр 1",
    KARCHER_OPERATION_COUNTER_53: "Пилосос 1 турбіна 2",
    KARCHER_OPERATION_COUNTER_54: "Пилосос 1 фільтр 2",
    KARCHER_OPERATION_COUNTER_55: "Пилосос 2 турбіна 1",
    KARCHER_OPERATION_COUNTER_56: "Пилосос 2 фільтр 1",
    KARCHER_OPERATION_COUNTER_57: "Пилосос 2 турбіна 2",
    KARCHER_OPERATION_COUNTER_58: "Пилосос 2 фільтр 2",
    KARCHER_OPERATION_COUNTER_59: "Пилосос 3 турбіна 1",
    KARCHER_OPERATION_COUNTER_60: "Пилосос 3 фільтр 1",
    KARCHER_OPERATION_COUNTER_61: "Пилосос 3 турбіна 2",
    KARCHER_OPERATION_COUNTER_62: "Пилосос 3 фільтр 2",
    KARCHER_OPERATION_COUNTER_63: "Пилосос 4 турбіна 1",
    KARCHER_OPERATION_COUNTER_64: "Пилосос 4 фільтр 1",
    KARCHER_OPERATION_COUNTER_65: "Пилосос 4 турбіна 2",
    KARCHER_OPERATION_COUNTER_66: "Пилосос 4 фільтр 2",
    KARCHER_OPERATION_COUNTER_67: "Пилосос 5 турбіна 1",
    KARCHER_OPERATION_COUNTER_68: "Пилосос 5 фільтр 1",
    KARCHER_OPERATION_COUNTER_69: "Пилосос 5 турбіна 2",
    KARCHER_OPERATION_COUNTER_70: "Пилосос 5 фільтр 2",
    KARCHER_OPERATION_COUNTER_71: "Пилосос 6 турбіна 1",
    KARCHER_OPERATION_COUNTER_72: "Пилосос 6 фільтр 1",
    KARCHER_OPERATION_COUNTER_73: "Пилосос 6 турбіна 2",
    KARCHER_OPERATION_COUNTER_74: "Пилосос 6 фільтр 2",
    KARCHER_OPERATION_COUNTER_75: "Злийте воду з конденсату компресора",
    KARCHER_OPERATION_COUNTER_76: "Перевірте систему захисту від замерзання",
    KARCHER_OPERATION_COUNTER_77: "Вентилятор пальника",
    KARCHER_OPERATION_COUNTER_78: "Підсилювальний насос для піни",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Список даних більше 10000 елементів",
    QR_CODE: "QR-код",
    ACCEPT_TERMS_AND_CONDITIONS: "Прийняти умови використання",
    CREATE_AND_PRINT_VOUCHERS: "Створити та роздрукувати купони",
    CODE_PREFIX_QUESTION: "Префікс коду не введено",
    CODE_PREFIX_QUESTION_TEXT: "Ви хочете продовжити без префікса коду?",
    ISSUED_DATE: "Дата видачі",
    VOUCHER_VALIDITY_DAYS: "Термін дії купона (дні)",
    VALIDATION_ONLY_NUMBERS: "Дозволені лише цифри",
    REPRINT_VOUCHERS: "Роздрукувати копію купонів",
    EXPIRY_DATE: "Дійсний до"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("twTranslations", {
    MESSAGE:"訊息",
    ERROR_TITLE:"錯誤",
    ERROR_MESSAGE:"執行操作時發生錯誤。",
    ERROR_LOGIN:"登入時發生錯誤。(E-mail或密碼無效)",
    ERROR_LOGIN_ROLE:"目前應用品牌的身分無效。",
    OK:"好的",
    CANCEL:"取消",
    YES:"是",
    NO:"否",
    FROM:"從",
    TO:"到",
    DELETE:"刪除",
    SIGN_OUT:"登出",
    NAME:"姓名",
    DATE:"日期",
    PIECES:"件",
    HOURS:"小時",
    DAYS:"天",
    MONTH:"月",
    MONTHS:"個月",
    YEAR:"年",
    BOX:"箱子",
    SEARCH:"搜尋",
    ALL_USERS:"所有使用者",
    ARE_YOU_SURE:"您確定嗎?",
    BACK:"返回",
    AMOUNT:"數量",
    DESCRIPTION:"敘述",
    FORGOT_PASSWORD_ERROR_MSG:"發生錯誤，請檢查您的電子信箱並重試。",
    REQUIRED_FIELD:"必填欄位",
    LOGOUT_TITLE:"您確定要登出嗎?",
    LOGOUT_MSG:"您所有未儲存的資料都將遺失",
    ACTIVATION_ACCOUNT:"您已成功啟動您的帳戶",
    UNKNOWN_ERRROR_NOTIFICATION:"發生未知錯誤",
    CONTINUE:"繼續",
    DATA_NOT_AVAILABLE:"數據無法使用",
    SELECT:"選擇",
    SELECT_CURRENCY:"選擇貨幣",
    UPLOAD:"上傳",
    PHONE:"電話",
    WEBSITE:"網站",
    WORKING_HOURS:"工作時間",
    INSERT:"插入",
    TEXT:"文字",
    CREATED:"已創建",
    VALID_UNTIL:"有效期限至",
    SAVE:"儲存",
    TOKENS:"代幣",
    DELETE_COMPANY_HISTORY:"是否刪除公司歷史記錄？",
    DELETE_COMPANY_HISTORY_MESSAGE:"警告：按下此按鈕後，您的所有洗車交易記錄將永久刪除！該資料刪除後無法恢復。",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"您確定要永久刪除所有交易資料嗎?",
    HISTORY_SUCCESSFULY_DELETED:"歷史記錄成功刪除",
    HELP:"幫助",
    VALUE:"值",
    ACTIVATING_ACCOUNT_ERROR:"您的 R2W 帳戶啟動時出現問題，請重試。如果問題持續無法解決，請聯繫客服：support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"歡迎來到Ca!sh 歐規高效自助洗車",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"歡迎來到R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"請輸入您的新密碼並確認以啟動 R2W 帳戶， 成功後您將被自動登入應用程式。",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"您可以稍後在應用程式中更改用戶設置",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Ca!sh 歐規高效自助洗車",
    RESET_PASSWORD_WELCOME_MSG:"R2W洗車",
    RESET_PASSWORD_WELCOME_MSG_2:"為了重置舊密碼，請輸入您的新密碼並確認，成功後您將被自動登入應用程式。",
    RESET_PASSWORD_WELCOME_MSG_3:"您可以稍後在應用程式中更改用戶設置",
    ENTER_NEW_PASSWORD:"輸入新密碼",
    REPEAT_NEW_PASSWORD:"請重複輸入新密碼",
    PASSWORD_MIN_LENGTH:"密碼長度必須至少為8個字元",
    PASSWORD_MAX_LENGHT:"密碼長度必須少於32個字元",
    PASSWORD_PATTERN:"密碼必須至少包含一個大寫字母和一個小寫字母",
    PASSWORD_MATCH:"密碼不匹配",
    ACTIVATE:"啟用",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"您已成功提交請求，請檢查您的電子郵件以獲取確認訊息。",
    VALIDATION_REQUIRED:"必填項目",
    VALIDATION_EMAIL:"無效的電子信箱地址",
    VALIDATION_INTEGER_NUMBER:"請輸入整數值",
    VALIDATION_HOURS_VALUE:"值必須介於 0-23 之間",
    VALIDATION_MINUTES_VALUE:"值必須介於 0-59 之間",
    VALIDATION_NOT_A_DATE:"值不是日期",
    VALIDATION_FROM:"起始日期晚於截止日期",
    VALIDATION_TO:"截止日期早於起始日期",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"該記錄已存在於資料庫中",
    PASSWORD_VALIDATION_PATTERN_NEW:"必須至少有一位數字、一個小寫字母和一個大寫字母，不允許有空格。",
    VALIDATION_PERCENT_VALUE:"值必須介於 1-999 之間",
    NUMBERS_ONLY_100:"計數最多到 100 ",
    NUMBERS_ONLY_1000:"計數最多到 1000",
    POSITIVE_NUMBERS_ONLY:"只計算數位",
    GRID_PAGER_PAGE:"頁",
    GRID_PAGER_ROWS_PER_PAGE:"每頁行數",
    GRID_PAGER_PAGE_OF:"的",
    BREAD_CRUMBS_HOME:"家",
    BREAD_CRUMBS_DASHBOARD_TECH:"儀表板技術",
    BREAD_CRUMBS_DETAILS:"細節",
    BREAD_CRUMBS_SETTINGS:"設定",
    BREAD_CRUMBS_WORKING_HOURS:"工作時間",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"天數總金額報告",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"每小時平均金額報告",
    BREAD_CRUMBS_NEW_USER_GROUP:"建立使用者群組",
    BREAD_CRUMBS_EDIT_USER_GROUP:"編輯使用者群組",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"建立活動模板",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"編輯活動模板",
    BREAD_CRUMBS_NEW_CAMPAIGN:"創建活動",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"編輯活動",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"定期總結",
    LOGIN:"登入",
    EMAIL:"電子信箱",
    PASSWORD:"密碼",
    LANGUAGE:"語言",
    FORGOT_PASSWORD:"忘記密碼?",
    SUBMIT:"提交",
    HEADER_NUMBER_OF_PENDING_ALARMS:"待處理警報數量：",
    HEADER_VIEW_ALL_ALARMS:"查看所有警報...",
    HEADER_MY_ACCOUNT:"我的帳戶",
    HEADER_ACCOUNT_MANAGEMENT:"帳戶管理",
    ACCOUNT_ALREADY_EXIST:"電子郵件地址已被使用",
    NEWSLETTER_CONFIRMATION:"發送警報狀態的​​電子郵件通知",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"每日財務概覽",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"儀表板技術",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"儀表板",
    ASIDE_MENU_ALARMS:"訊息",
    ASIDE_MENU_FACILITIES:"設施",
    ASIDE_MENU_REPORTS:"報告",
    ASIDE_MENU_REPORT:"選擇報告",
    ASIDE_MENU_LOYALTY:"忠誠",
    ASIDE_MENU_USER_GROUPS:"使用者群組",
    ASIDE_MENU_PERIODIC_SUMMARY:"定期總結",
    ASIDE_MENU_MANAGING_TOKENS:"管理代幣",
    ASIDE_MENU_NEWS:"消息",
    DAILY_FINANCES_TOTAL_MONEY:"總金額",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"所有設施的總金額",
    DAILY_FINANCES_TOTAL_COINS:"金屬代幣使用總數",
    DAILY_FINANCES_DOWNLOAD_CSV:"下載CSV",
    DAILY_FINANCES_ONLINE:"R2W(線上)",
    DAILY_FINANCES_OFFLINE:"現金",
    DAILY_FINANCES_CHANGER:"兌幣機現金",
    DAILY_FINANCES_COINS:"代幣/Eurokey",
    REPORTS_FILTER:"篩選",
    REPORTS_TYPE_OF_REPORT:"報告類型",
    REPORTS_CHOOSE_FACILITY:"選擇設施",
    REPORTS_PERIOD_1:"期間 1-",
    REPORTS_PERIOD_2:"期間 2-",
    MONEY_BY_DATE_REPORT:"按日期劃分的總收入",
    R2W_BY_DATE_REPORT:"按日期劃分的 R2W 代幣總收入",
    COINS_BY_DATE_REPORT:"按日期使用的代幣總數",
    AVG_MONEY_BY_HOUR_REPORT:"每小時平均收入",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"按星期幾的平均收入",
    AVG_MONEY_BY_BOX_REPORT:"依車格劃分的開支",
    COMPARE_PERIODS_REPORT:"設施比較報告",
    TOTAL_USERS_BY_GROUP:"每日 R2W app 總訪問量",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"使用者",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"訪問",
    VISITS_COUNT_REPORT:"每次造訪的 R2W app用戶數",
    LOYALTY_PER_DAY_REPORT:"每天花費的本地代幣數量",
    LOYALTY_PER_PAYMENT_METHOD:"每種支付方式給定的本地代幣",
    VISITS:"訪問",
    VISIT:"訪問",
    TOTAL_SPENT_MONEY:"總收入",
    MONEY:"錢",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"期間總收入金額",
    DOWNLOAD_CSV:"下載CSV",
    TOTAL_SPENT_COINS:"花費的代幣總計",
    TOTAL_USERS:"用戶總計",
    TOTAL_CREDIT_GIVEN:"本地虛擬代幣花費總額",
    EUROKEY_BY_DATE_REPORT:"按日期劃分的 Eurokey 付款總額",
    TOTAL_SPENT_EUROKEY:"總支出",
    SELECT_TYPE_OF_REPORT:"您需要選擇報告類型",
    NUMBER_OF_VISITS_TITLE:"訪問次數",
    NUMBER_OF_USERS_TITLE:"使用者數量",
    PIECES_TITLE:"件",
    TOTAL_VISITS:"總訪問量",
    TOKENS_TITLE:"代幣",
    SEARCH_USERS_NO_RESULTS:"未找到針對給定搜尋字詞的用戶",
    SEARCH_USERS:"搜尋用戶",
    SEARCH_TELEPHONES:"透過手機號碼搜尋用戶",
    ADD_USER_TO_GROUP:"將使用者新增至群組",
    REMOVE_USER_FROM_GROUP:"從群組中刪除用戶",
    USER_GROUP_NAME_REQUIRED:"使用者群組名稱為必填項",
    USER_GROUP_NAME:"使用者群組名",
    USER_GROUPS_OVERVIEW:"使用者群組概覽",
    USER_COUNT:"使用者數",
    NEW_USER_GROUP:"建立新使用者群組",
    DELETE_USER_GROUP:"刪除使用者群組",
    UPDATE_USER_GROUP:"編輯使用者群組",
    DELETE_USER_GROUP_ERROR:"刪除所選用戶群組時發生錯誤，請重試或聯絡支援人員...",
    CONFIRM_DELETE_USER_GROUP:"您確定要刪除選定的使用者群組嗎？",
    CONFIRM_DELETE_USER_GROUP_TEXT:"已刪除的群組所指派到的忠誠度操作將不再適用。",
    GROUP_NAME_MAX_LENGTH:" 群組名稱長度必須少於 255 個字",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:" 用戶已在該群組中",
    MISSING_USER:" 缺少使用者",
    USER_NOT_ON_LIST:" 使用者不在有效使用者清單中，檢查電子郵件地址是否有效，然後再試一次。",
    UPLOAD_USER_GROUP:"從 *.csv 檔案上傳使用者群組列表",
    UKNOWN_USERS:"未知使用者列表",
    CAMPAIGN_TEMPLATE_RULE:"活動範本規則",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:" 嘗試刪除行銷活動範本時發生錯誤，請重試或聯絡支援人員..",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:" 您確定要刪除選定的行銷活動範本嗎",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"您確定要刪除選定的行銷活動範本嗎",
    CAMPAIGN_TEMPLATES_OVERVIEW:" 行銷活動範本概觀",
    DELETE_CAMPAIGN_TEMPLATE:" 刪除活動範本",
    UPDATE_CAMPAIGN_TEMPLATE:" 編輯活動範本",
    CREATE_CAMPAIGN_TEMPLATE:" 建立新的活動範本",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:" 活動範本名稱為必填項",
    CAMPAIGN_TEMPLATE_NAME:" 活動範本名稱",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:" 必填項目",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"提供 %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"額外的時間",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"請先選擇類型，清洗車格或小型機器。",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:" 刪除範本規則",
    CAMPAIGN_TEMPLATE_RULE_FROM:"從",
    CAMPAIGN_TEMPLATE_RULE_TO:"到",
    CAMPAIGN_TEMPLATE_RULE_HOURS:" 小時",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"分鐘",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"按造訪次數的新規則",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"按花費代幣數量的新規則",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"按星期幾的新規範",
    CAMPAIGN_TEMPLATE_ADD_RULE:" 新增範本規則",
    CAMPAIGN_TEMPLATE_RULE_1:"每一個",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"每一個",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:" 花費的代幣少於",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:" 訪問時間少於",
    CAMPAIGN_TEMPLATE_RULE_3:" 天",
    CAMPAIGN_TEMPLATE_RULE_4:" 代幣",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:" 規則清單是空的",
    CAMPAIGN_FROM_DATE_TOO_EARLY:" 日期不能是過去的日期",
    DELETE_CAMPAIGN_ERROR:" 嘗試刪除活動時發生錯誤，請重試或聯絡支援人員...",
    CONFIRM_DELETE_CAMPAIGN:" 您確定要刪除選定的活動嗎？",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W 對由此操作引起的使用者體驗不負責。",
    CAMPAIGNS_OVERVIEW:" 活動概覽",
    DELETE_CAMPAIGN:"刪除活動",
    UPDATE_CAMPAIGN:" 編輯活動",
    CREATE_CAMPAIGN:" 建立新的活動",
    CAMPAIGN_ACTIVE:"活躍的",
    CAMPAIGN_TEMPLATE:" 範本",
    CAMPAIGN_GROUPS:" 團體",
    CAMPAIGN_ALL_USERS:" 全部用戶",
    CAMPAIGN_NAME:" 活動名稱",
    CAMPAIGN_NAME_REQUIRED:"必填",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"每日接近門檻的使用者數",
    MESSAGE_TO_USERS:"給已過濾用戶的訊息",
    SEND_MESSAGE:"發送訊息",
    THRESHOLD:"門檻",
    TYPE:" 類型",
    TOTAL_MONEY_SPENT:" 活動花費的總資金",
    NUMBER_OF_VISITS:" 活動中的訪問次數",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:" 訊息長度必須至少 10 個字元",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:" 訊息長度必須少於 350 個字元",
    SEND_MESSAGE_REQUIRED_VALIDATION:"留言內容為必填項",
    TECHNOLOGY:"科技",
    TAP_WATER:"自來水",
    REVERSE_OSMOSIS:"逆滲透",
    SOFTENED_WATER:"軟化水",
    DOSER:"計量器",
    STATUS:"狀態",
    LAST_SYNCHRONIZATION:"最後同步",
    NO_OF_CURRENT_ALARMS:"目前警報數量",
    NO_OF_CURRENT_WARNINGS:"目前警告數量",
    WEATHER:" 天氣",
    BOXES_WORK_HOURS_COUNTERS:"洗車格工作時間",
    BOX_TOTAL_HOURS:" 總工作時間",
    BOX_SERVICE_HOURS:" 總工作時間（服務）",
    BOX_COUNTER_HOURS:"小時",
    ALARMS_AND_WARNINGS:" 警報和警告",
    FILTER_AND_BOILER:"過濾器和鍋爐",
    FILTER_TOTAL_DAYS:"濾心工作天數",
    BOILER_TOTAL_DAYS:"鍋爐工作天數",
    DAYS_UNIT:" 天",
    SOFTENER:" 柔軟劑",
    MANUAL_COLD_DRAIN:"手動冷排水",
    EL_COLD:"El. cold",
    DRAIN:"排水",
    TAP:"輕敲",
    WASTE:"耗費",
    OSMOSIS:" 滲透",
    DEMI_WATER:"去離子水",
    EL_RINSE:"El. m. rinse",
    BOILER:" 鍋爐",
    EL_WAX:"El. m. wax",
    FLOOR_HEATING:"地暖",
    DOSER_TANK:"計量罐",
    EL_WASH:"El. m. wash",
    DETERGENT:" 洗劑",
    VIBRATOR:" 振動器",
    UPDATE_FACILITY_SETTINGS:" 更新設定",
    GENERAL_SETTINGS:" 一般設定",
    LIGHTS:"燈",
    GROUPS:" 群組",
    ANTI_FREEZE:"防凍",
    AUTO:"自動",
    MANUAL:" 手動的",
    ON:"開",
    OFF:" 關",
    TEMPERATURE:" 溫度",
    UPDATE_DEVICE:" 更新設施設定",
    BOX_CLEAN_HOURS:"洗車格清洗計數器(小時)",
    GROUP_COUNTERS:"群組計數器",
    RESET:" 重置",
    CASH_COUNT:" 硬幣計數",
    COINS_COUNT:" 代幣計數",
    EUROKEY_COUNT:" Eurokey計數",
    DOSER_WORK:" 計量器工作時間（秒）",
    DOSER_PAUSE:" 計量器暫停時間（秒）",
    DELAY_BFV:"BFV 延遲（毫秒）",
    DELAY_6M1:"6M1 延遲（毫秒）",
    DELAY_LPS:"LPS 延遲（毫秒）",
    RESET_CASH_COUNT_ALL:" 重置所有硬幣計數器",
    RESET_COINS_COUNT_ALL:" 重置所有代幣計數器",
    RESET_EUROKEY_COUNT_ALL:" 重置所有 Eurokey 計數器",
    FACILITY_DETAILS:" 設施詳情",
    FACILITY_NAME:" 設施名稱",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:" 您已成功上傳圖片",
    FACILITY_UPDATE_DATA_NOTIFICATION:" 您已成功更新數據",
    CONNECTED:" 已連接",
    DISCONNECTED:" 已斷線",
    OFFLINE:" 離線",
    MESSAGES_FILTER:" 訊息過濾器",
    FACILITY:" 設施",
    APPLY:" 申請",
    TIME:" 時間",
    LOCATION:"地點",
    ACKNOWLEDGED:" 已確認",
    FILTERED_MESSAGES:" 過濾的訊息",
    ACK:" 已確認",
    NOT_ACK:"未確認",
    ALL:" 全部",
    ALL_FACILITIES:"所有設施",
    ENTER_DATE_PLACEHOLDER:" 輸入日期",
    OP_NESTANAK_NAPONA:"相位指示器 3A5 缺乏電壓",
    OP_OTB_PUMPA_GRESKA_MZS:" 高壓幫浦斷路器斷線",
    OP_UPR_NAPON_24VAC_GRE:"缺少 24 VAC - 斷路器 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"乾淨水箱已空",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"主要水幫浦斷路器斷線",
    OP_MIN_NIVO_OMEKS_VODE:"軟化水箱已空",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:" 軟水幫浦斷路器斷線",
    OP_MIN_NIVO_DEMIN_VODE:"滲透水箱已空",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"滲透水幫浦斷路器斷線",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"滲透生產幫浦斷路器斷線",
    OP_BOJLER_GRESKA_MZS:"熱水器故障",
    OP_CRPKA_PRASKA_GRE_MZS:"熱水幫浦斷路器斷線",
    OP_DOZATOR_PRASKA_GRE_MZS:"粉末計量馬達斷路器斷線",
    OP_VIBRATOR_PRASKA_GRE_MZS:"粉末計量振動器斷路器斷線",
    OP_MIN_PRASAK_TON_ALARM:"粉末混合箱已空",
    OP_USIS_KOV_TURBINA_GRESKA:"硬幣真空渦輪斷路器斷線",
    OP_FILTER_VODE_ZACEPLJEN:"水過濾器堵塞",
    OP_VISKTL_RESET_SATI_RADA:"高壓幫浦服務",
    OPW_VISKTL_RESET_SATI_RADA:"高壓幫浦服務",
    OP_FILTER_DANI_RADA:"水過濾器故障",
    OP_BOJLER_DANI_RADA:"熱水器故障",
    OPW_ALARM_VISOKOTL_PUMPA:"高壓幫浦警報",
    OPW_ALARM_FILTER_SERVIS:" 過濾器服務警報",
    OPW_ALARM_BOJLER_SERVIS:" 鍋爐服務警報",
    HAS_MEMBERS:" 所選群組已有成員且無法刪除，請先刪除成員。",
    PERIODIC_SUMMARY_FOR:" 定期總結報告",
    PERIODIC_SUMMARY_REPORTS:"定期總結報告",
    DATE_RANGE:"日期範圍",
    FINANCIAL_REPORT:" 財務報告",
    GROSS_INCOME:"總收益",
    GROSS_INCOME_SUM:"總收益總和",
    COMMISSION_FEE:" 佣金費用",
    NET_INCOME:" 淨收入(用於計費)",
    COMMISSION_FEE_DETAILS:"佣金費用包括銀行/PayPal 條款或簡訊服務提供者費用。",
    LOYALTY_CREDITS_REPORT:"本地代幣報告",
    LOYALTY_GIVEN:"贈送的本地代幣",
    LOYALTY_USED:" 使用的本地代幣",
    LOYALTY_SOLD:"本地代幣已載入",
    LOYALTY_TOTAL:"總計",
    LOYALTY_CURRENT_MONTH:"本月",
    SOMETHING_WENT_WRONG:" 出了點問題",
    MISSING_PAGE:" 對不起，我們找不到該頁面。",
    TRY_AGAIN:" 請再試一次",
    DEFAULT_ERROR_NAME:" 發生未知錯誤",
    DEFAULT_ERROR_DESCRIPTION:" 請再試一次",
    MY_ACCOUNT_DETAILS:" 我的帳戶詳細細節",
    SAVE_CHANGES:" 儲存變更",
    USERNAME:" 使用者名稱",
    FIRST_NAME:" 名",
    LAST_NAME:" 姓",
    USER_ROLE:"用戶角色",
    OLD_PASSWORD:" 舊密碼",
    NEW_PASSWORD:" 新密碼",
    OLD_PASSWORD_REQUIRED:"需要舊密碼",
    NEW_PASSWORD_REQUIRED:"需要新密碼",
    NEW_PASSWORD_REPEAT:"需要重複輸入新密碼",
    NEW_PASSWORD_NOT_MATCH:" 新舊密碼不符",
    PASSWORD_DIFFERENT_VALIDATION:" 新密碼必須與舊密碼不同",
    PASSWORD_MIN_CHAR:" 密碼長度必須至少 8 個字元",
    PASSWORD_MAX_CHAR:"密碼長度不得超過 32 個字元",
    PASSWORD_PATTERN_VALIDATION:" 密碼必須至少包含一個數字",
    ACCOUNT_MANAGEMENT:" 帳號管理",
    NOT_ACTIVE:"不活躍",
    ASSIGN_ROLE:" 分配角色",
    UPDATE:" 更新",
    ADD_NEW_ACCOUNT:" 新增帳戶",
    EMAIL_REQUIRED:" 電子郵件地址為必填項",
    EMAIL_NOT_VALID:"電子郵件地址無效",
    ADD_NEW_USER_TEXT:" 啟用連結將發送到提供的電子郵件地址",
    UPDATE_USER_NOTIFICATION:" 您已成功更新您的資訊",
    CHANGED_PASSWORD_NOTIFICATION:" 您已成功更改密碼",
    UPDATE_USER_GROUP_NOTIFICATION:" 您已成功更新使用者群組名稱",
    CREATE_USER_GROUP_NOTIFICATION:"您已成功建立群組",
    DETELE_USER_GROUP_NOTIFICATION:" 您已成功刪除群組",
    EMPTY_GROUP_LIST_MSG:"沒有已建立的群組，開始建立一個。",
    DELETE_USER_FROM_GROUP_NOTIFICATION:" 您已成功從群組中刪除使用者",
    ADD_USER_TO_GROUP_NOTIFICATION:"您已成功將使用者新增至群組中",
    ADD_USER_NOTIFICATION:" 您已成功新增使用者",
    DELETE_USER_NOTIFICATION:" 您已成功刪除使用者",
    RESEND_USER_VERIFICATION_EMAIL:" 您已成功重新傳送驗證電子郵件",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:" 為了創建一個使用者群組",
    DELETE_USER:" 刪除使用者",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"您確定要從使用者群組中刪除使用者嗎？",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:" 尊敬的R2W用戶",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"依造訪次數的忠誠度規則",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"依花費代幣金額的忠誠度規則",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"依每週幾的忠誠度規則",
    REMOVE_CAMPAIGN_RULE_TITLE:"活動規則刪除",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"您確定要刪除活動規則嗎？",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:" 您已成功建立新的活動",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"您已成功啟動活動",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"沒有已建立的活動，開始建立一個。",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:" 您已成功發送訊息",
    COMPANY_ACCOUNTS:" 公司帳戶",
    BUSSINESS_INVOICES_LIST:" 我的 B2B 發票",
    LOCALE_TOKEN:" 本地代幣",
    R2W:"全球代幣",
    START_MONTH:"起始月份",
    END_MONTH:" 結束月份",
    TOKEN_TYPE:" 代幣類型",
    TOKEN_NUMBER:" 代幣數量",
    NOTHING_TO_DISPLAY:"* 無內容顯示",
    CREATE_INVOICE:" 建立發票",
    INVOICE:" 發票",
    INVOICES:" 發票",
    EDIT_INVOICE:" 編輯發票",
    UPDATE_INVOICE_NOTIFICATION:" 您已成功將發票更新為待處理狀態",
    CURRENT_CHARGES:" 當期費用",
    PAYMENTS_ON_HOLD:"處理中的發票",
    FOR_INVOICING:"用於開立發票",
    CANCEL_INVOICING_NOTIFICATION_HEADER:" 您即將取消發票",
    CANCEL_INVOICING_NOTIFICATION_TEXT:" 您確定要取消此發票嗎？",
    INVOICING_NOTIFICATION_HEADER:"您即將進行發票處理",
    INVOICING_NOTIFICATION_TEXT:"您確定要寄送發票嗎？",
    SENT_INVOICE_NOTIFICATION:"您已成功發送發票",
    CANCELED_INVOICE_NOTIFICATION:"您已成功取消發票",
    INVOICE_DESCRIPTION_TEXT:" 發票給予",
    INVOICE_STATE:" 發票狀態",
    INVOICE_NUMBER:" 發票號碼",
    INVOICE_TOTAL:"總計",
    SELECT_YEAR:" 選擇年份",
    DOWNLOAD:"下載PDF",
    INVOICE_NUMBER_HEADER:"您即將寄送編號的發票",
    INVOICE_PAYMENT_CONFIRMATION:"您即將確認付款",
    INSERT_INVOICE_NUMBER:"鍵入發票號碼",
    INVOICED_WARNING:"電子郵件未傳送，請稍後...",
    SEND_INVOICE:"傳送",
    INVOICE_ALL:" 全部",
    INVOICE_FROM_R2W:"來自 R2W",
    INVOICE_TO_R2W:" 至 R2W",
    PAYMENT_REQUEST:" 付款請求",
    PAYMENT_REQUEST_STATE:" 付款請求狀態",
    PAYMENT_REQUEST_NUMBER:" 付款請求編號",
    FOR_PAYMENT_REQUEST:"對於付款請求",
    PAYMENT_REQUEST_ON_HOLD:" 付款請求正在處理中",
    DOWNLOAD_INVOICE:" 下載發票",
    CLICK_FOR_DOWNLOAD_OPTIONS:"點擊以獲取下載選項",
    B2B_SPEC:" B2B規範",
    B2C_SPEC:" B2C規範",
    DOWNLOAD_PAYMENT_REQUEST:" 下載付款請求",
    LOYALTY_PREVIEW:" 忠誠度預覽",
    ACTIVATED:"啟動的",
    RUNNING:"運行",
    NOT_ACTIVATED:" 未啟用的",
    FINISHED:" 完成的",
    DEPRECATED:" 已棄用",
    UPCOMING:" 即將推出",
    NONE:" 個人",
    STARTED:" 已開始",
    ENDS:" 結束",
    DEDICATED:" 致力於",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:" 您即將啟動",
    CAMPAIGN:"活動",
    SEND_MESSAGE_NOTIFICATION:" 您即將向選定的用戶群組發送訊息",
    DIVISIBLE_TO_NUMBER:" 該數字應該可以整除",
    BRIDGE_PLC:"電橋 - PLC",
    DEVICE_TYPE:" 設備類型",
    LISTENER:" 小型機器",
    BRIDGE:"洗車格",
    WASH_BOXES:"洗車格",
    VACUUMS:" 吸塵器",
    SAVE_NEWS:"儲存消息",
    CREATE_NEW_NEWS:"建立新消息",
    HISTORY_OF_ALL_NEWS:"所有歷史消息",
    TYPE_FACILITY_NAME_PLACEHOLDER:"鍵入設施名稱",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:" 增加另一個設施",
    NEWS_TEXT:"消息內文",
    NEWS_TITLE:"消息標題",
    DELETE_NEWS_CONFIRMATION:"您即將刪除消息",
    NEWS_DELETE_NOTIFICATION:"您已成功刪除消息",
    NEWS_SAVE_NOTIFICATION:"您已成功儲存消息",
    NEWS_CREATION_DATE:"建立日期",
    NO_TITLE:"無標題",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"消息內文必須少於255個字元",
    NEWS_TEXT_REQUIRED_VALIDATION:"消息文字為必填項",
    NEWS_TITLE_REQUIRED_VALIDATION:"消息標題為必填項",
    DEACTIVATE:" 停用",
    ASIDE_MENU_LOCAL_TOKENS:" 本地代幣",
    CREATE_NEW_LOCAL_TOKENS:" 發出新的本地代幣",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:" 輸入客戶電子郵件以及您想要發出給客戶的本地代幣數量",
    CREATE_TOKENS:" 發出代幣",
    MINIMUM_ONE_TOKEN:"值必須是大於 0 的數字",
    CUSTOMER_EMAIL:"客戶電子郵件",
    AMOUNT_OF_TOKENS:"代幣數量",
    ISSUING_LOCAL_TOKENS_SUCCESS:" 成功發行本地代幣",
    PROBLEM_ISSUING_LOCAL_TOKENS:"發行本地代幣時發生錯誤，請檢查客戶電子郵件地址並重試。",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"已發出本地代幣概覽",
    ISSUED_AT:"發出於",
    ISSUED_BY:"發出者",
    CODE:" 兌換代碼",
    REDEEMED_BY:" 兌換者",
    REDEEMED_AT:" 兌換於",
    ASIDE_MENU_VOUCHERS:" 優惠券",
    PRINT:" 列印",
    VOUCHERS_OVERVIEW:" 優惠券概覽",
    CREATE_NEW_VOUCHERS:" 建立新優惠券",
    CREATE_NEW_VOUCHERS_DESCRIPTION:" 透過輸入每張優惠券的代幣數量以建立新的可兌換優惠券批次",
    AMOUNT_OF_TOKENS_PER_VOUCHER:" 每張優惠券的代幣數量",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"您可以為每張優惠券分配 1 到 100 個代幣",
    NUMBER_OF_NEW_VOUCHERS:" 待建立的優惠券數量",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"您可以在一個批次中建立 1 到 {{size}} 個優惠券",
    NEW_VOUCHERS_PREFIX:"新優惠券系列代碼字首",
    VALIDATION_VOUCHER_PREFIX:"代碼字首必須正好是 4 個字元（大寫字母和/或數字）",
    PROBLEM_CREATING_NEW_VOUCHERS:" 建立新優惠券時出現問題，請重試或聯絡我們的客服人員。",
    CREATE_VOUCHERS:"建立優惠券",
    CREATING_VOUCHERS_SUCCESS:" 新優惠券建立成功",
    PRINT_NEW_VOUCHERS:" 列印優惠券",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"輸入優惠券系列代碼字首以列印整個優惠券系列。或者",
    PRINT_VOUCHERS_PREFIX:" 優惠券（系列）代碼字首",
    NO_VOUCHERS_FOR_PRINT:" 找不到與提供的代碼字首相符的優惠券可供列印",
    PRINT_VOUCHERS:" 列印優惠券",
    VALIDATION_VOUCHER_CODE_FILTER:" 優惠券搜尋字詞必須由大寫字母和數字組成",
    FILTER_VOUCHERS_BY_CODE:" 透過兌換碼搜尋優惠券",
    FILTER_VOUCHERS:"搜尋優惠券",
    WASH_BOX:"洗車格",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"數位代幣使用總數",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:" 按日期列出的本地代幣銷售總量",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:" 按日期列出的本地代幣總支出",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:" 按日期列出的總給出本地代幣數量",
    LOCAL_TOKEN:"本地代幣",
    GIVEN_TOKEN:"給出的本地代幣",
    SOLD_TOKEN:" 售出的本地代幣",
    SMALL_MACHINES:" 小型機器",
    R2W_Listener:"監聽器",
    HHANLE_DEVICE:"HHanle wash box",
    CODE_PREFIX_EXIST:" 程式碼字首已存在",
    CODE_PREFIX_EXIST_TEXT:" 您無法使用此代碼字首建立新優惠券，請再設定一個。",
    MIN_FOUR_VALIDATION:" 正好 4 個字元",
    ALL_INFORMATION_1:"所有資訊關於",
    ALL_INFORMATION_2:"將遺失",
    ASIDE_MENU_TRANSACTIONS:" 交易",
    EXPENSES:" 花費",
    TOPUPS:"儲值",
    EXPENSES_LIST:" 費用清單",
    USER_EMAIL:" 使用者電子郵件",
    COMPANY_NAME:" 公司名稱",
    TOPUPS_LIST:" 儲值清單",
    CONSUMER:" 消費者",
    SYSTEM_ADMIN:" 系統管理員",
    MERCHANT_ADMIN:" 商家管理員",
    COMPANY_ADMIN:" 公司管理員",
    FACILITY_ADMIN:" 設施管理員",
    SUBSCRIBER:"訂閱戶",
    CONFIGURATOR:"配置器",
    SETUP_UNIT_SERIAL_NO:" 序號",
    SETUP_UNIT_MATERIAL_NO:" 物料號碼",
    SETUP_UNIT_WEBAPI_VERSION:" WebApi 版本",
    TOTAL_TURNOVER:"洗車設施營業額",
    AVAILABILITY_ALL:" 可用性",
    AVAILIBILITY:"洗車格可用性",
    AVAILABILITY_VACUUMS:"吸塵器可用性",
    WASH_BOX_INFO:"洗車格資訊",
    VACUUM_CLEANER_INFO:"吸塵器資訊",
    BREAD_CRUMBS_SERVICE:" 服務",
    HOLIDAYS:"假日",
    HOLIDAY:"假日",
    LIGHTS_ON:" 開燈",
    LIGHTS_OFF:" 關燈",
    WASH_BOXES_ON:"洗車格開啟",
    WASH_BOXES_OFF:"洗車格關閉",
    VACUUMS_ON:" 吸塵器開啟",
    VACUUMS_OFF:" 吸塵器關閉",
    TURNOVER:"營業額",
    TURNOVER_MANUAL_WASH_UNIT:"營業額手冊",
    STATUS_BAY_RUN_TIME:"洗車格工作時間總計",
    STATUS_BAY_PROGRAM_NAME:"程式名稱",
    STATUS_BAY_CREDIT:"洗車格信用/餘額",
    CLOUD_KREDIT:"雲端信用",
    STATUS_VACUUM_RUN_TIME:"吸塵器工作時間總計",
    SHOW_SERVICE_AND_PROGRAM_INFO:"設施服務、洗車格程序和當前故障資料訊息",
    UNAVAILABLE:" 單位不可用",
    SHOW_HIDE_TABLE:" 顯示/隱藏工作時間表",
    PROGRAM_NAME:"程式名稱",
    PROGRAM_COUNTER:"程式計數器",
    NO_NAME:" 參考資訊沒有名稱",
    COUNTER_SERVICE_DATA:"服務數據",
    NEED_SERVICE:"服務需求",
    PROGRAM_DATA:"洗車格程式數據",
    CURRENT_FAULT_DATA:"當前故障數據",
    REFERENCE_DUE:" 到期的",
    REFERENCE_SECONDS:" 秒數",
    REFERENCE_NAME:" 零件名稱",
    WASHBOX_NAME:"洗車格名稱",
    FAULT_NAME:" 故障名稱",
    FAULT_NUMBER:" 故障號碼",
    CURRENT_FAULT_COUNT:"目前故障",
    DEVICE_NOT_INSTALLED:" 裝置未安裝",
    STATUS_READY:"就緒狀態",
    STATUS_ERROR:"錯誤狀態",
    CONNECTION_ERROR:" 離線",
    UNKNOWN_RESET:" 軟體錯誤",
    SOFTWARE_RESET:" 軟體錯誤",
    EXTERNAL_PIN_RESET:" 軟體錯誤",
    RESTART_OR_BROWNOUT_OCCURRED:" 軟體錯誤",
    DEAD_RM5_CHANNEL_PIN_ERROR:"硬體錯誤",
    COULD_NOT_SIMULATE_COIN:"硬體錯誤",
    ERROR_SETTING_INHIBIT_MODE:"硬體錯誤",
    OFFLINE_DEVICE:"洗車廠離線",
    TARIFFS:"關稅",
    DAY:" 天/日",
    NIGHT:"晚上",
    VOUCHER_CODE:" 優惠券代碼",
    DISMISS_ALARM:" 重置鬧鐘？",
    ALARM_ACTIVE:"當前未解除警報",
    NO_ALARM_ACTIVE:"沒有未解除警報",
    ALARM_HISTORY:" 警報歷史記錄",
    MANAGING_TOKENS:" 管理代幣",
    EXPIRATION_DATE:" 截止日期",
    EXTEND_TOKEN_DATE:" 延長代幣有效期限給",
    DELETE_TOKENS_FOR:" 刪除代幣給",
    PUMP_TYPE:"幫浦類型",
    TURN_OFF_DEVICE:" 裝置狀態",
    OPERATION_DATA:"操作數據",
    PUMP_DATA:"幫浦數據",
    PUMP_NAME:"幫浦名稱",
    POINT_NAME:"存取點名稱",
    CHANGER_INCOME:"按日期劃分的總販售機收入",
    SELECTED_OPEN:" 在選定的工作時間開放",
    ALWAYS_OPEN:"全天候開放(24/7)",
    CLOSED:" 關閉",
    CLOSED_24:" 24小時休息",
    OPENED_24:" 24小時營業",
    MON:" 週一",
    TUE:" 週二",
    WED:" 週三",
    THU:" 週四",
    FRI:" 週五",
    SAT:" 週六",
    SUN:" 週日",
    PRICING:"定價",
    PRICE:" 價格",
    VALIDITY:" 有效性",
    TOKEN_PACKAGES:"代幣包裝/套",
    SINGLE_WASH:"單次清洗",
    FACILITY_WORKING_HOURS:"設置所選設施的工作時間",
    WORKING_HOURS_ALWAYS_OPEN:"全天候開啟",
    WORKING_HOURS_ALWAYS_CLOSE:"被操作者關閉",
    WORKING_HOURS_CUSTOM:" 設定工作時間",
    KARCHER_ERROR_CODE:" 警報錯誤代碼",
    KARCHER_ERROR_MESSAGE_1:"電子插座過載",
    KARCHER_ERROR_MESSAGE_2:" 必須清空油水分離器",
    KARCHER_ERROR_MESSAGE_4:"調光感測器故障",
    KARCHER_ERROR_MESSAGE_5:" 高壓幫浦上的保護馬達開關被觸發",
    KARCHER_ERROR_MESSAGE_6:"RDS 連接故障",
    KARCHER_ERROR_MESSAGE_7:"壓縮機上的空氣壓力開關沒有回報任何",
    KARCHER_ERROR_MESSAGE_8:" 原因：未連接到電子設備“MSWS”。",
    KARCHER_ERROR_MESSAGE_10:"清洗站1沒有連接到的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_11:"清洗站1的電子插座超載",
    KARCHER_ERROR_MESSAGE_12:" 清洗站1的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_13:" 清洗站1的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_14:"清洗站1高壓幫浦的觸點卡住",
    KARCHER_ERROR_MESSAGE_15:"清洗站1半載閥異常",
    KARCHER_ERROR_MESSAGE_16:"清洗站1高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_17:" 清洗站1高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_18:"清洗站1的電子設備有異常",
    KARCHER_ERROR_MESSAGE_19:"清洗站1的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_20:"未連接到清洗站 1 的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_21:" 清洗站1的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_22:" 清洗站1的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_30:"沒有連接到清洗站 2 的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_31:"清洗站2的電子插座超載",
    KARCHER_ERROR_MESSAGE_32:"清洗站2的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_33:"清洗站2的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_34:"清洗站2高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_35:"清洗站2半載閥異常",
    KARCHER_ERROR_MESSAGE_36:"清洗站2高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_37:"清洗站2高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_38:"清洗站2的電子設備有異常",
    KARCHER_ERROR_MESSAGE_39:"清洗站2高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_40:"清洗站2沒有連接到遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_41:"清洗站2的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_42:"清洗站2的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_50:"沒有連接到清洗站3的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_51:"清洗站3的電子插座超載",
    KARCHER_ERROR_MESSAGE_52:"清洗站3的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_53:"清洗站3的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_54:"清洗站3高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_55:"清洗站3半載閥異常",
    KARCHER_ERROR_MESSAGE_56:"清洗站3高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_57:"清洗站3高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_58:"清洗站3的電子設備有異常",
    KARCHER_ERROR_MESSAGE_59:"清洗站3高壓幫浦的馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_60:"清洗站3沒有連接到遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_61:"清洗站3的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_62:"清洗站3的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_70:"沒有連接到清洗站4的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_71:"清洗站4的電子插座超載",
    KARCHER_ERROR_MESSAGE_72:"清洗站4的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_73:"清洗站4的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_74:"清洗站4高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_75:"清洗站4半載閥異常",
    KARCHER_ERROR_MESSAGE_76:"清洗站4高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_77:"清洗站4高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_78:"清洗站4的電子設備有異常",
    KARCHER_ERROR_MESSAGE_79:"清洗站4的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_80:"清洗站4沒有連接到遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_81:"清洗站4的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_82:"清洗站4的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_90:"沒有連接到清洗站5的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_91:"清洗站5的電子插座超載",
    KARCHER_ERROR_MESSAGE_92:"清洗站5的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_93:"清洗站5的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_94:"清洗站5高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_95:"清洗站5半載閥異常",
    KARCHER_ERROR_MESSAGE_96:"清洗站5高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_97:"清洗站5高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_98:"清洗站5的電子設備有異常",
    KARCHER_ERROR_MESSAGE_99:"清洗站5的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_100:"沒有連接到清洗站5的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_101:"清洗站5的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_102:"清洗站5的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_110:"沒有連接到清洗站6的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_111:"清洗站6的電子插座超載",
    KARCHER_ERROR_MESSAGE_112:"清洗站6的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_113:"清洗站6的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_114:"清洗站6高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_115:"清洗站6半載閥異常",
    KARCHER_ERROR_MESSAGE_116:"清洗站6高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_117:"清洗站6高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_118:"清洗站6的電子設備有異常",
    KARCHER_ERROR_MESSAGE_119:"清洗站6高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_120:"沒有連接到清洗站6的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_121:"清洗站6的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_122:"清洗站6的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_130:"清洗站7沒有連接到的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_131:"清洗站7的電子插座超載",
    KARCHER_ERROR_MESSAGE_132:"清洗站7的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_133:"清洗站7的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_134:"清洗站7高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_135:"清洗站7半載閥異常",
    KARCHER_ERROR_MESSAGE_136:"清洗站7高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_137:"清洗站7高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_138:"清洗站7的電子設備有異常",
    KARCHER_ERROR_MESSAGE_139:"清洗站7的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_140:"沒有連接到清洗站7的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_141:"清洗站7的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_142:"清洗站7的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_150:"沒有連接到清洗站8的幫浦電子設備",
    KARCHER_ERROR_MESSAGE_151:"清洗站8的電子插座超載",
    KARCHER_ERROR_MESSAGE_152:"清洗站8的高壓幫浦電流過高",
    KARCHER_ERROR_MESSAGE_153:"清洗站8的高壓幫浦電流過低",
    KARCHER_ERROR_MESSAGE_154:"清洗站8高壓幫浦的接點卡住",
    KARCHER_ERROR_MESSAGE_155:"清洗站8半載閥異常",
    KARCHER_ERROR_MESSAGE_156:"清洗站8高壓幫浦的線圈保護接點",
    KARCHER_ERROR_MESSAGE_157:"清洗站8高壓幫浦油位過低",
    KARCHER_ERROR_MESSAGE_158:"清洗站8的電子設備有異常",
    KARCHER_ERROR_MESSAGE_159:"清洗站8的高壓幫浦馬達斷路器已跳脫",
    KARCHER_ERROR_MESSAGE_160:"沒有連接到清洗站8的遠端控制電子設備",
    KARCHER_ERROR_MESSAGE_161:"清洗站8的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_162:"清洗站8的硬幣接收器錯誤",
    KARCHER_ERROR_MESSAGE_170:" 未連接電子設備 A2",
    KARCHER_ERROR_MESSAGE_171:" 電子設備 A2 的輸出過載",
    KARCHER_ERROR_MESSAGE_172:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_173:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_174:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_175:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_176:"清潔劑容器已空",
    KARCHER_ERROR_MESSAGE_177:"底盤清洗的幫浦電流過高",
    KARCHER_ERROR_MESSAGE_178:"開啟車身底部清洗後無壓力",
    KARCHER_ERROR_MESSAGE_190:" 未連接電子設備 A3",
    KARCHER_ERROR_MESSAGE_191:" 電子設備 A3 的輸出過載",
    KARCHER_ERROR_MESSAGE_200:"WSO 的控制和電子設備之間沒有連接",
    KARCHER_ERROR_MESSAGE_201:"WSO 的控制輸出過載",
    KARCHER_ERROR_MESSAGE_202:"再生後硬度感測器顯示硬水",
    KARCHER_ERROR_MESSAGE_204:" 電子設備故障",
    KARCHER_ERROR_MESSAGE_210:"液位感測器緩衝罐淨空啟動",
    KARCHER_ERROR_MESSAGE_211:"液位感測器緩衝容器空和緩衝容器滿同時切換",
    KARCHER_ERROR_MESSAGE_212:"液位感測器RO幫浦開啟和緩衝容器滿開關同時進行",
    KARCHER_ERROR_MESSAGE_213:" 無水壓",
    KARCHER_ERROR_MESSAGE_214:"現場備水報告異常",
    KARCHER_ERROR_MESSAGE_220:" 缺水",
    KARCHER_ERROR_MESSAGE_221:" 排氣溫度過高",
    KARCHER_ERROR_MESSAGE_222:"溫水循環幫浦電流過高",
    KARCHER_ERROR_MESSAGE_223:" 燃燒器故障",
    KARCHER_ERROR_MESSAGE_224:" 燃燒器的安全恆溫器已觸發",
    KARCHER_ERROR_MESSAGE_225:" 燃燒器延遲啟動",
    KARCHER_ERROR_MESSAGE_226:"溫水循環幫浦關閉後5秒內流量指示器未開啟",
    KARCHER_ERROR_MESSAGE_227:" 溫水循環幫浦關閉後3秒內流量指示器未關閉",
    KARCHER_ERROR_MESSAGE_228:" 燃燒器關閉後熱水出口冷卻過慢",
    KARCHER_ERROR_MESSAGE_229:"溫水溫度感測器故障",
    KARCHER_ERROR_MESSAGE_230:" 燃燒器出口溫度感測器故障",
    KARCHER_ERROR_MESSAGE_231:" 溫水溫度感測器故障",
    KARCHER_ERROR_MESSAGE_232:" 燃燒器出口溫度感測器故障",
    KARCHER_ERROR_MESSAGE_233:" 外部供應溫水水溫高於60°C",
    KARCHER_ERROR_MESSAGE_234:"防軍團菌程序錯誤",
    KARCHER_ERROR_MESSAGE_235:"未達抗軍團菌溫水溫度",
    KARCHER_ERROR_MESSAGE_240:" 外部溫度感測器故障",
    KARCHER_ERROR_MESSAGE_241:" 外部溫度感測器故障",
    KARCHER_ERROR_MESSAGE_242:"防凍保護循環幫浦的電流過高",
    KARCHER_ERROR_MESSAGE_243:"清洗站加熱器循環幫浦的電流過高",
    KARCHER_ERROR_MESSAGE_244:"溫水溫度過低，清洗站加熱器已關閉。",
    KARCHER_ERROR_MESSAGE_245:" 泡沫軟管加熱器的電流消耗過高",
    KARCHER_ERROR_MESSAGE_247:" 電子設備故障",
    KARCHER_ERROR_MESSAGE_248:"電子設備故障",
    KARCHER_ERROR_MESSAGE_250:"特殊清洗程序的幫浦電流過高",
    KARCHER_ERROR_MESSAGE_255:" 電子設備故障",
    KARCHER_ERROR_MESSAGE_260:" 未連接電子設備 A5",
    KARCHER_ERROR_MESSAGE_261:" 電子設備 A5 的輸出過載",
    KARCHER_ERROR_MESSAGE_280:" 未連接電子設備 A6",
    KARCHER_ERROR_MESSAGE_281:" 電子設備 A6 的輸出過載",
    KARCHER_ERROR_MESSAGE_282:" 輪圈清潔的幫浦電流消耗過高",
    KARCHER_ERROR_MESSAGE_283:" 輪圈清潔的幫浦電流消耗太低",
    KARCHER_ERROR_MESSAGE_284:" 輪圈清潔幫浦接觸器卡住",
    KARCHER_ERROR_MESSAGE_300:" 未連接電子設備 A7",
    KARCHER_ERROR_MESSAGE_301:" 電子設備 A7 的輸出過載",
    KARCHER_ERROR_MESSAGE_320:"未連接電子設備 A8",
    KARCHER_ERROR_MESSAGE_321:"電子設備 A8 的輸出過載",
    KARCHER_ERROR_MESSAGE_322:"微乳化液幫浦電流消耗過高",
    KARCHER_ERROR_MESSAGE_323:" 微乳化液幫浦電流消耗過低",
    KARCHER_ERROR_MESSAGE_324:"微乳化液幫浦接觸器卡住",
    KARCHER_ERROR_MESSAGE_340:" 未連接電子設備 A9",
    KARCHER_ERROR_MESSAGE_341:"電子設備 A9 的輸出過載",
    KARCHER_ERROR_MESSAGE_342:" 強化清洗幫浦的電流消耗過高",
    KARCHER_ERROR_MESSAGE_343:" 強化清洗幫浦的電流消耗過低",
    KARCHER_ERROR_MESSAGE_344:"強化清洗幫浦接觸器卡住",
    KARCHER_ERROR_MESSAGE_400:" 溫水無壓力",
    KARCHER_ERROR_MESSAGE_401:"淡水無壓力",
    KARCHER_ERROR_MESSAGE_402:" 滲透無壓力",
    KARCHER_ERROR_MESSAGE_403:"4. 水類型無壓力",
    KARCHER_ERROR_MESSAGE_404:"4.水類型、溫度超過60°C或外部干擾。",
    KARCHER_ERROR_MESSAGE_405:"防凍無壓力",
    KARCHER_ERROR_MESSAGE_406:" 儘管防凍幫浦已關閉，但防凍保護仍有壓力。",
    KARCHER_ERROR_MESSAGE_410:" 24 小時內出現 4 次錯誤 F 400",
    KARCHER_ERROR_MESSAGE_411:"錯誤 F 401 已啟動 300 秒。",
    KARCHER_ERROR_MESSAGE_412:" 24 小時內出現 4 次錯誤 F 402",
    KARCHER_ERROR_MESSAGE_413:" 24 小時內出現 4 次錯誤 F 403",
    KARCHER_ERROR_MESSAGE_414:" 24 小時內出現 4 次錯誤 F 405",
    KARCHER_ERROR_MESSAGE_420:"錯誤代幣兌幣機 1",
    KARCHER_ERROR_MESSAGE_421:"錯誤代幣兌幣機 2",
    KARCHER_ERROR_MESSAGE_440:"未連接電子設備 A31",
    KARCHER_ERROR_MESSAGE_441:" 電子設備 A31 的輸出過載",
    KARCHER_ERROR_MESSAGE_500:"吸塵器電子設備的連接 1/2",
    KARCHER_ERROR_MESSAGE_501:"吸塵器1啟動按鈕永久觸點",
    KARCHER_ERROR_MESSAGE_502:"吸塵器2啟動按鈕永久觸點",
    KARCHER_ERROR_MESSAGE_510:"吸塵器電子設備的連接 3/4",
    KARCHER_ERROR_MESSAGE_511:"吸塵器3永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_512:"吸塵器4永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_520:" 吸塵器電子設備的連接 5/6",
    KARCHER_ERROR_MESSAGE_521:"吸塵器5永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_522:"吸塵器6永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_530:"吸塵器電子設備的連接 7/8",
    KARCHER_ERROR_MESSAGE_531:"吸塵器7永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_532:"吸塵器8永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_540:"吸塵器電子設備的連接 9/10",
    KARCHER_ERROR_MESSAGE_541:"吸塵器9永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_542:"吸塵器10永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_550:"吸塵器電子設備的連接 10/11",
    KARCHER_ERROR_MESSAGE_551:"吸塵器11永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_552:"吸塵器12永久觸點的啟動按鈕",
    KARCHER_ERROR_MESSAGE_800:"未連接電子設備 A30",
    KARCHER_ERROR_MESSAGE_801:" 電子設備 A30 的輸出過載",
    KARCHER_ERROR_MESSAGE_802:" 軟化裝置故障",
    KARCHER_ERROR_MESSAGE_803:"預壓幫浦 RO 保護馬達開關跳脫",
    KARCHER_INFO_MESSAGE_1:"基礎交換器再生開始",
    KARCHER_INFO_MESSAGE_2:"基礎交換器再生完成",
    KARCHER_INFO_MESSAGE_3:"基礎交換器耗盡 75%",
    KARCHER_INFO_MESSAGE_4:" 由於技術問題，單位無法使用。",
    KARCHER_INFO_MESSAGE_5:" 由於操作問題，單位無法使用。",
    KARCHER_INFO_MESSAGE_6:" 單位已開啟",
    KARCHER_INFO_MESSAGE_10:"即使是在營業時間內",
    KARCHER_INFO_MESSAGE_11:"Bay 1不可用",
    KARCHER_INFO_MESSAGE_12:"Bay 2不可用",
    KARCHER_INFO_MESSAGE_13:"Bay 3不可用",
    KARCHER_INFO_MESSAGE_14:"Bay 4不可用",
    KARCHER_INFO_MESSAGE_15:"Bay 5不可用",
    KARCHER_INFO_MESSAGE_16:"Bay 6不可用",
    KARCHER_INFO_MESSAGE_17:"Bay 7不可用",
    KARCHER_INFO_MESSAGE_18:"Bay 8不可用",
    KARCHER_INFO_MESSAGE_20:"抗軍團菌程式溫水箱",
    KARCHER_INFO_MESSAGE_21:"抗軍團菌程式HD幫浦1必要的",
    KARCHER_INFO_MESSAGE_22:"抗軍團菌程式HD幫浦2必要的",
    KARCHER_INFO_MESSAGE_23:"抗軍團菌程式HD幫浦3必要的",
    KARCHER_INFO_MESSAGE_24:"抗軍團菌程式HD幫浦4必要的",
    KARCHER_INFO_MESSAGE_25:"抗軍團菌程式HD幫浦5必要的",
    KARCHER_INFO_MESSAGE_26:"抗軍團菌程式HD幫浦6必要的",
    KARCHER_INFO_MESSAGE_27:"抗軍團菌程式HD幫浦7必要的",
    KARCHER_INFO_MESSAGE_28:"抗軍團菌程式HD幫浦8必要的",
    KARCHER_INFO_MESSAGE_29:" 抗軍團菌程序完成",
    KARCHER_INFO_MESSAGE_101:" 高壓幫浦 1 需要維修",
    KARCHER_INFO_MESSAGE_102:" 高壓幫浦 2 需要維修",
    KARCHER_INFO_MESSAGE_103:" 高壓幫浦 3 需要維修",
    KARCHER_INFO_MESSAGE_104:" 高壓幫浦 4 需要維修",
    KARCHER_INFO_MESSAGE_105:" 高壓幫浦 5 需要維修",
    KARCHER_INFO_MESSAGE_106:" 高壓幫浦 6 需要維修",
    KARCHER_INFO_MESSAGE_107:" 高壓幫浦 7 需要維修",
    KARCHER_INFO_MESSAGE_108:" 高壓幫浦 8 需要維修",
    KARCHER_INFO_MESSAGE_109:" 燃燒器需要維修",
    KARCHER_INFO_MESSAGE_110:"燃燒器風機需要維修",
    KARCHER_INFO_MESSAGE_111:" 溫水幫浦需要維修",
    KARCHER_INFO_MESSAGE_112:" 防凍幫浦需要維修",
    KARCHER_INFO_MESSAGE_113:" 滲透幫浦需要維修",
    KARCHER_INFO_MESSAGE_114:" 地暖幫浦需要維修",
    KARCHER_INFO_MESSAGE_115:"加熱管需要維修",
    KARCHER_INFO_MESSAGE_116:" 微化乳液/輪圈清潔劑幫浦需要維修",
    KARCHER_INFO_MESSAGE_117:"底盤清潔幫浦需要維修",
    KARCHER_INFO_MESSAGE_118:"系統壓力幫浦需要維修",
    KARCHER_INFO_MESSAGE_119:" 吸塵器 1 需要維修",
    KARCHER_INFO_MESSAGE_120:"吸塵器 2 需要維修",
    KARCHER_INFO_MESSAGE_121:"吸塵器 3 需要維修",
    KARCHER_INFO_MESSAGE_122:"吸塵器 4 需要維修",
    KARCHER_INFO_MESSAGE_123:"吸塵器 5 需要維修",
    KARCHER_INFO_MESSAGE_124:"吸塵器 6 需要維修",
    KARCHER_INFO_MESSAGE_125:"吸塵器 7 需要維修",
    KARCHER_INFO_MESSAGE_126:"吸塵器 8 需要維修",
    KARCHER_INFO_MESSAGE_127:"吸塵器 9 需要維修",
    KARCHER_INFO_MESSAGE_128:"吸塵器 10 需要維修",
    KARCHER_INFO_MESSAGE_129:"吸塵器 11 需要維修",
    KARCHER_INFO_MESSAGE_130:"吸塵器 12 需要維修",
    KARCHER_INFO_MESSAGE_131:"輪圈清潔劑幫浦需要維修",
    KARCHER_INFO_MESSAGE_132:"微乳化液幫浦需要維修",
    KARCHER_INFO_MESSAGE_133:"強力泡沫幫浦需要維修",
    KARCHER_INFO_MESSAGE_142:"吸塵器 1 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_143:"吸塵器 1 過濾器需要維修",
    KARCHER_INFO_MESSAGE_144:"吸塵器 2 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_145:"吸塵器 2 過濾器需要維修",
    KARCHER_INFO_MESSAGE_146:"吸塵器 3 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_147:" 吸塵器 3 過濾器需要維修",
    KARCHER_INFO_MESSAGE_148:"吸塵器 4 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_149:" 吸塵器 4 過濾器需要維修",
    KARCHER_INFO_MESSAGE_150:" 吸塵器 5 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_151:"吸塵器 5 過濾器需要維修",
    KARCHER_INFO_MESSAGE_152:"吸塵器 6 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_153:"吸塵器 6 過濾器需要維修",
    KARCHER_INFO_MESSAGE_154:"吸塵器 7 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_155:"吸塵器 7 過濾器需要維修",
    KARCHER_INFO_MESSAGE_156:"吸塵器 8 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_157:"吸塵器 8 過濾器需要維修",
    KARCHER_INFO_MESSAGE_158:"吸塵器 9 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_159:"吸塵器 9 過濾器需要維修",
    KARCHER_INFO_MESSAGE_160:"吸塵器 10 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_161:"吸塵器 10 過濾器需要維修",
    KARCHER_INFO_MESSAGE_162:"吸塵器 11 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_163:"吸塵器 11 過濾器需要維修",
    KARCHER_INFO_MESSAGE_164:"吸塵器 12 渦輪機需要維修",
    KARCHER_INFO_MESSAGE_165:" 吸塵器 12 過濾器需要維修",
    ORGANIZATION:"組織",
    CREATE_ORGANIZATION:"創建組織",
    CREATE_ORGANIZATION_AS:"建立組織作為子組織給",
    DELETE_ORGANIZATION:"刪除組織",
    EDIT_ORGANIZATION:"編輯組織",
    SUPPORTED_ORG_NAME:"支援組織",
    SUPPORTED_ORG_TYPE:" 支援類型",
    ORG_NAME:"名稱",
    ORG_TYPE:"類型",
    SET_ORG_TITLE:"設定子組織",
    SET_SUPPORTED_ORG_TITLE:"設定支援子組織",
    SAVE_ORGANIZATION:"保存組織",
    SELECT_ORGANIZATION_TYPE:"選擇組織類型",
    SELECT_ORGANIZATION_SELECTOR:"選擇",
    SELECT_SUPPORTED_ORGANIZATION:"選擇支援組織",
    ORGANIZATION_DELETED:"組織已成功刪除",
    ORGANIZATION_SAVED:"組織已成功保存",
    ORGANIZATION_UPDATED:"組織已成功更新",
    ALERTS:"警報",
    DEVICE_STATUS:"裝置狀態",
    SITE_DETAILS:"場地詳情",
    ALARM_STATUS:"警報狀態",
    FILTER:"過濾 ...",
    FILTER_BY_ALERT_CENTER:"按代碼、名稱或描述過濾",
    TOTAL_ALARM:"總計",
    LOW_ALARM:"事件",
    MEDIUM_ALARM:"故障",
    HIGH_ALARM:"嚴重錯誤",
    NO_FACILITIES_NEARBY:"附近沒有設備",
    GRAY_MAP:"灰色風格地圖",
    READY:"預備",
    WARNING:"故障",
    ERROR:"錯誤",
    SITE_NAME:"場域名稱",
    ACCOUNTS_INFO:"帳戶資訊",
    USER_ORGANIZATION:"使用者組織",
    ADD_USER_ORGANIZATION:" 新增新的組織用戶",
    EDIT_USER_ORGANIZATION:"編輯組織用戶",
    SELECT_ROLE:"選擇角色",
    SELECT_ORGANIZATION:"選擇組織",
    SELECT_USER:"選擇用戶",
    USER_FOR_ORGANIZATION_CREATED:"新用戶創建成功",
    SELECT_REGION:" 選擇地區",
    SELECT_LANGUAGE:"選擇語言",
    LOADING_DATA:" 正在載入資訊，請稍候...",
    ADMINISTRATOR:"管理人員",
    TECHNICAL_SUPPORT:"技術支援",
    CONTROLLER:"控制器",
    EDIT_ORGANIZATION_USER:"編輯組織用戶",
    DELETE_ORGANIZATION_USER:"刪除組織用戶",
    USER_UPDATED:"用戶更新成功",
    USER_CREATED:"使用者創建成功",
    ADDRESS:"地址",
    SUBSCRIPTIONS:" 訂閱",
    RESOLVED_STATUS:"解決",
    NOT_RESOLVED_STATUS:" 未解決",
    ALERT_NAME:"警報名稱",
    ALERT_DESCRIPTION:"警報說明",
    ALERT_CODE:"警報代碼",
    ALERT_TYPE:"警報類型",
    UNSUBSCRIBE:"取消訂閱警報",
    SUBSCRIBE:"訂閱警報",
    ALARM_SUBSCRIBED:"訂閱成功",
    UNSUBSCRIBED_CONFIRM:"取消訂閱？",
    ALARM_UNSUBSCRIBED:"取消訂閱成功",
    ASIDE_MENU_CASHLESS_SALES:"非現金銷售",
    FILTERED_CASHLESS_PAYMENTS:"過濾非現金支付",
    REFUND_DIALOG_TITLE:"交易退款？",
    REFUND_DIALOG_SUBTITLE:"金額可以小於或等於交易金額",
    REFUND:"退款",
    INPUT_NOT_VALID:"輸入無效",
    REFUND_SUCCESSFULLY:"所選付款的退款已成功完成",
    USER:"使用者",
    TRANSACTION_ID:"PSP 參考",
    DEVICE_ID:"裝置ID",
    NET_AMOUNT:"淨額",
    REPORT_NAME:"報告名稱",
    TIME_FRAME:"時間範圍",
    SUB_POINT:"選擇子點",
    SUB_POINT_LIST_NOT_EXIST:"所選清洗設施不存在子點列表",
    FACILITY_TYPE:"設施類型",
    MACHINE_NAME:"機器名稱",
    WASH_FACILITY_DETAILS:"清洗設施詳情",
    WASH_BAY_DETAILS:"洗車格詳情",
    DEVICES_INFO:"裝置列表",
    OPERATION_TIME_INFO:"運作時間",
    OPERATION_TIME_VACUUM_INFO:"吸塵器的運作時間",
    OPERATION_TIME_ILLUMINATION_INFO:"照明的運轉時間",
    AVAILABLE_TITLE:"可用的",
    UNAVAILABLE_TITLE:"不可用",
    CURRENT_PROGRAM:"目前程序",
    CREDITS:"帳面餘額",
    DEVICE_NAME:"裝置名稱",
    ACTIVE_ALARMS:"未解除警報",
    ALL_DAY:"全天",
    OPERATING_TIME_WASH_FACILITY:"自助洗系統",
    OPERATING_TIME_VACUUMS:"吸塵器",
    OPERATING_TIME_ILLUMINATION:"照明",
    OPERATION_COUNTERS:"操作櫃檯",
    EDIT:"編輯",
    WASHING_PROGRAMS:"清洗程序",
    INFO:" 事件",
    STATISTIC:"統計",
    ROLLOVER_DOSING:"劑量",
    ROLLOVER_SPEED:"速度",
    ROLLOVER_RESETS:"龍門遠端重置",
    ROLLOVER_RESETS_INFO:"遠端重置必須符合當地法規。重要提示：重置之前，請確保累計為空。",
    RESET_ROLLOVER:"重置龍門",
    OPEN_DOOR_ROLLOVER:"打開",
    ROLLOVER_OPEN_DOOR_INFO:"打開清潔室門。請小心",
    ROLLOVER_OPEN_DOOR:"開門",
    APPLY_DOSING_CHANGES:"運用劑量改變",
    APPLY_SPEED_CHANGES:"運用速度改變",
    ACTUATION_SUCCESS:"請求已發送",
    REMAINING_TIME:"剩餘時間",
    OPEN_24H:"24小時營業",
    CLOSE_24H:"24小時關閉",
    VALIDATION_OPERATION_TIME:"格式不正確。請用 hh:mm",
    ROLLOVER:"龍門洗車機",
    UPDATE_WASHING_PROGRAM:"更新洗滌程序",
    UPDATE_ACTUATORS:"更新促動器",
    OPEN_ROLOVER_DOOR_TITLE:"要打開龍門門口嗎?",
    OPEN_ROLOVER_DOOR_CONTENT:"您確定要開門嗎？",
    RESET_ROLOVER_TITLE:"想要重置龍門洗車機？",
    RESET_ROLOVER_CONTENT:"您確定想要重置龍門洗車機？",
    G0:"{{brand === 'r2w' ? '灣 0' : '灣 1'}}",
    G1:"{{brand === 'r2w' ? '灣 1' : '灣 2'}}",
    G2:"{{brand === 'r2w' ? '灣 2' : '灣 3'}}",
    G3:"{{brand === 'r2w' ? '灣 3' : '灣 4'}}",
    G4:"{{brand === 'r2w' ? '灣 4' : '灣 5'}}",
    G5:"{{brand === 'r2w' ? '灣 5' : '灣 6'}}",
    G6:"{{brand === 'r2w' ? '灣 6' : '灣 7'}}",
    G7:"{{brand === 'r2w' ? '灣 7' : '灣 8'}}",
    G8:"{{brand === 'r2w' ? '灣 8' : '灣 9'}}",
    G9:"{{brand === 'r2w' ? '灣 9' : '灣 10'}}",
    G10:"{{brand === 'r2w' ? '灣 10' : '灣 11'}}",
    U0:"{{brand === 'r2w' ? '吸塵器 0' : '吸塵器 1'}}",
    U1:"{{brand === 'r2w' ? '吸塵器 1' : '吸塵器 2'}}",
    U2:"{{brand === 'r2w' ? '吸塵器 2' : '吸塵器 3'}}",
    U3:"{{brand === 'r2w' ? '吸塵器 3' : '吸塵器 4'}}",
    U4:"{{brand === 'r2w' ? '吸塵器 4' : '吸塵器 5'}}",
    U5:"{{brand === 'r2w' ? '吸塵器 5' : '吸塵器 6'}}",
    U6:"{{brand === 'r2w' ? '吸塵器 6' : '吸塵器 7'}}",
    U7:"{{brand === 'r2w' ? '吸塵器 7' : '吸塵器 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"由儀表板中選定所在點建立的警報中心報告",
    ALERT_CENTER_TITLE_BY_FACILITY:"由儀表板中選定的設施所建立的警報中心報告",
    ALERT_CENTER_TITLE_BY_DEFAULT:"警報中心報告",
    ERROR_MESSAGE_403:"您無權使用此 api 要求。錯誤代碼：403",
    LAST_ACTIVE_PROGRAM:"有效程式/上次有效程式",
    PROGRAM_ID:"程式號碼",
    PROGRAM_PRICE:"程式價格",
    NORMAL_CHEMICAL_LEVEL:"好的",
    LOW_CHEMICAL_LEVEL:"需要補充",
    EMPTY_CHEMICAL_LEVEL:"空的",
    CHEMICAL_LEVEL:"清潔劑液位指示（%）",
    ROLLOVER_STATUS:"龍門洗車機狀態",
    ROLLOVER_STATUS_CODE_0:"目前清洗設備故障",
    ROLLOVER_STATUS_CODE_1:" 營業時間外",
    ROLLOVER_STATUS_CODE_2:"允許程式輸入",
    ROLLOVER_STATUS_CODE_3:" 定位您的車輛",
    ROLLOVER_STATUS_CODE_4:"車輛前進",
    ROLLOVER_STATUS_CODE_5:"車輛後退",
    ROLLOVER_STATUS_CODE_6:"車輛停止",
    ROLLOVER_STATUS_CODE_7:"清洗運行",
    ROLLOVER_STATUS_CODE_8:"清洗停止",
    ROLLOVER_STATUS_CODE_9:"清洗運行(tact)",
    ROLLOVER_STATUS_CODE_10:"向後退出車輛",
    ROLLOVER_STATUS_CODE_11:"緊急停止",
    ROLLOVER_STATUS_CODE_12:"向前退出車輛",
    ROLLOVER_STATUS_CODE_13:"抗凍運行中",
    ROLLOVER_STATUS_CODE_14:"安全開關正面啟動",
    ROLLOVER_STATUS_CODE_15:" 安全開關後方啟動",
    ROLLOVER_STATUS_CODE_16:" 安全開關左前側啟動",
    ROLLOVER_STATUS_CODE_17:" 安全開關右前側啟動",
    ROLLOVER_STATUS_CODE_18:"安全開關左後側啟動",
    ROLLOVER_STATUS_CODE_19:"安全開關右後側啟動",
    ROLLOVER_STATUS_CODE_20:"車輛位置太靠左側",
    ROLLOVER_STATUS_CODE_21:"車輛位置太靠右側",
    ROLLOVER_STATUS_CODE_22:"左門未關",
    ROLLOVER_STATUS_CODE_23:"右門未關",
    ROLLOVER_STATUS_CODE_24:"偵測到輸送機購，選擇了錯誤的清洗程序。",
    ROLLOVER_STATUS_CODE_25:" 喇叭感應器",
    ROLLOVER_STATUS_CODE_98:"手動/調節模式",
    ROLLOVER_STATUS_CODE_99:"狀態未知",
    ROLLOVER_STATUS_CODE_UNDEFINED:"狀態碼未定義",
    ALARM:"嚴重錯誤",
    NO_ALARM:"無嚴重錯誤",
    SOFTWARE_VERSION:"軟體版本",
    SOFTWARE_DATE:"軟體日期",
    SITE_ADDRESS:"站址",
    SECONDS:"秒數",
    SERVICE_PART_NAME:"服務名稱：",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"操作及服務計數器",
    OPERATION_COUNTER:"操作計數器",
    SERVICE_COUNTER:" 服務計數器",
    FAULT_CODE:"警報代碼",
    PRESSURE_TITLE:"空氣壓力",
    TIME_TITLE:"目前時間",
    COUNTRY_TITLE:"國家",
    CITY_TITLE:"城市",
    REGION_TITLE:"地區",
    SELECT_POINTS_TO_SEARCH:"選擇要點 ...",
    LOGS_HISTORY:"參數變更歷史",
    ACTUATOR_REFERENCE:"執行器參考",
    ACTUATOR_VALUE:"執行器數值",
    POINT_ID:"要點ID",
    VALIDATION_NOT_VALID_RANGE:"範圍不正確",
    ENABLE_ROLLOVER_RESET:"勾選此方塊即表示您確認已閱讀並同意安全說明。",
    CHANGE_OF_PARAMETERS:"參數變更",
    SELECT_OPTIONS:"選擇選項",
    AUTOMATIC:"自動的",
    DESALTING:"去鹽功能",
    SEASON_WASH:"季節清洗程序",
    SPRING_PROGRAM:"春季清洗程序",
    SUMMER_PROGRAM:" 夏季清洗程序",
    AUTUMN_PROGRAM:"秋季清洗程序",
    WINTER_PROGRAM:"冬季清洗程序",
    DOOR_CONTROL:"門控",
    SUMMER_DOOR_CONTROL:"夏季，在夏季模式下透過門控進行操作。",
    WINTER_DOOR_CONTROL:"冬季，在冬季模式下透過門控進行操作。",
    APPLY_PARAMETERS_CHANGES:"應用參數更改",
    WORKING_SCHEDULES:"工作時間表",
    HOLIDAY_SCHEDULES:"假日行程",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"場址假期創建成功",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"場址假期已成功更新",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"場址假期已成功刪除",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"工作計劃宣傳成功",
    HOLIDAY_SUCCESSFULLY_DELETED:"假期已成功刪除",
    SB_MU_MB_2_2_0:" SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"乾燥劑填充量低",
    CHEM_LEVEL_LOW_SHAMPOO:"洗劑填充量低",
    CHEM_LEVEL_LOW_FOAM:"泡沫填充量低",
    CHEM_LEVEL_LOW_WAX_1:"蠟填充量低",
    CHEM_LEVEL_LOW_POLISH_1:"拋光填充量低",
    CHEM_LEVEL_LOW_RIM_CLEANER:"輪圈清潔劑填充量低",
    CHEM_LEVEL_LOW_WAX_2:"蠟填充量低",
    CHEM_LEVEL_LOW_TYRE_SHINE:"輪胎亮光蠟填充量低",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"除蟲劑填充量低",
    CHEM_LEVEL_LOW_POLISH_2:"拋光劑填充量低",
    CHEM_LEVEL_LOW_INTENSIVE:"intensive 填充量低",
    CHEM_LEVEL_LOW_FOAM_RAIN:"泡沫雨填充量低",
    CHEM_LEVEL_DRYING_AGENT:"乾燥劑填充量",
    CHEM_LEVEL_SHAMPOO:"洗劑填充量",
    CHEM_LEVEL_FOAM:"泡沫填充量",
    CHEM_LEVEL_WAX_1:"蠟填充量",
    CHEM_LEVEL_POLISH_1:"拋光劑填充量",
    CHEM_LEVEL_RIM_CLEANER:"輪圈清潔劑填充量",
    CHEM_LEVEL_WAX_2:"蠟填充量",
    CHEM_LEVEL_TYRE_SHINE:"輪胎亮光蠟填充量",
    CHEM_LEVEL_INSECT_REMOVER:"除蟲劑填充量",
    CHEM_LEVEL_POLISH_2:"拋光劑填充量",
    CHEM_LEVEL_INTENSIVE:"Intensive 填充量",
    CHEM_LEVEL_FOAM_RAIN:"泡沫雨填充量",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"服務台頂刷提升帶",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"服務台烘乾機提升帶",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"服務台馬達電纜屋頂刷",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"服務台淡水幫浦服務",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"服務台幫浦廢水",
    DRYING_AGENT:" 乾燥劑",
    FOAM_DRYING_AGENT:"泡沫乾洗劑",
    SHAMPOO:"洗劑",
    FOAM:"泡沫",
    BRUSH_FOAM:"毛刷泡沫",
    WAX_1:" 蠟",
    FOAM_WAX_1:"泡沫蠟",
    POLISH_1:" 拋光",
    RIM_CLEANING:" 輪圈亮光劑",
    WAX_2:" 蠟",
    FOAM_WAX_2:"泡沫蠟",
    TYRE_SHINE:"輪胎亮光蠟",
    INSECT_REMOVER:"除蟲劑",
    POLISH_2:" 拋光",
    INTENSIVE_BASIC:"Intensive 基礎",
    INTENSIVE_SIDE:"Intensive 側邊",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensive 車頂噴桿",
    TAR_REMOVER:"柏油去除劑",
    UNDER_CHASSIS_CONVERSATION:"底盤對話",
    STATIONARY_PRE_SPRAY_ARCH:"固定式預噴拱",
    FOAM_RAIN:"泡沫雨",
    PRE_CLEANING:"預清洗",
    BRUSH:"毛刷",
    CARE:"照護",
    DRYING:"烘乾",
    DRYING_LOW_NOISE:"乾燥降低噪音",
    INTENSIVE_CLEANING:"Intensive 清洗",
    BRUSH_CLEANING:"毛刷清洗",
    EMPTY_RUN:"空轉",
    DRYING_AID:"乾燥輔助",
    WAX:"蠟",
    FOAM_WASH:" 泡沫清洗",
    POLISH:"拋光",
    FOAM_POLISH:"泡沫拋光劑",
    WHEEL_CLEANING:"車輪清潔",
    HIGH_PRESSURE_ROOF:" 車頂高壓",
    HIGH_PRESSURE_SIDE:"側邊高壓",
    DRYER_FORWARD:"烘乾機前進",
    DRYER_BACKWARD:" 烘乾機退後",
    DELETE_ALL_HOLIDAYS:"刪除所選網站的所有假期",
    CREATE_NEW_HOLIDAY:"創建新的",
    RESET_INPUTS:"重置所有假期輸入",
    TWENTY_FOUR_HOURS_OPEN:" 24小時營業",
    EVERY_YEAR:"每年",
    DELETE_HOLIDAY:" 刪除假期",
    ADD_NEW_HOLIDAY:"新增假期",
    HOLIDAYS_LIST:"現有假期列表",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"刪除所選場址的所有假期？",
    VALIDATION_HOLIDAY_DATE:"格式錯誤。使用 mm-dd",
    FOR_DATE:"對於日期",
    WITH_ID:"附上 ID",
    FROM_HOURS:"從(小時)",
    FROM_MINUTES:"從(分鐘)",
    TO_HOURS:"到(小時)",
    TO_MINUTES:"到(分鐘)",
    NOT_MATCH:"不匹配",
    START:"從",
    STOP:"到",
    DAILY_TIME:"24小時清單",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"個人時間設定",
    PROGRAM_NOT_STARTED:"程序尚未開始",
    JETWASH:"自助洗系統",
    KARCHER_REPORT_1:"龍門：依照程序以及總和的營業額指示",
    KARCHER_REPORT_2:"龍門：依照程序以及總和啟動的清洗",
    KARCHER_REPORT_3:"龍門：依照程序以及總和執行的清洗",
    KARCHER_REPORT_4:"龍門：依照每個程序透過支付終端以及總和開始的洗滌次數",
    KARCHER_REPORT_5:"龍門：依照程序以及總和手動啟動的清洗次數",
    KARCHER_REPORT_6:"龍門：依照程序以及總和的取消清洗次數",
    KARCHER_REPORT_7:"龍門：電源供應失敗次數",
    KARCHER_REPORT_8:"SB 單元：按車格篩選以及總計的每個洗滌程序的小時數",
    KARCHER_REPORT_9:"SB 單元：每個清洗區的營業額和總營業額指示",
    KARCHER_REPORT_10:"SB 單元：每個硬幣通道的代幣/硬幣計數器",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"淡水幫浦",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"製程用水幫浦",
    OPERATION_COUNTER_HP_PUMP_1:"高壓幫浦1",
    OPERATION_COUNTER_HP_PUMP_2:"高壓幫浦2",
    RELEASE_NOTES:"應用程式版本和發行說明",
    BACKEND_RELEASE_NOTES:"平台發行說明：",
    FRONTEND_RELEASE_NOTES:"Web 應用程式發行說明：",
    SELECTED_FACILITY_TIMEZONE:"所選設施的時區：",
    REFRESH_PAGE:"重新整理頁面",
    REFRESH_MAPS:"重新整理地圖",
    PUMPS:"幫浦",
    RUN_TIME:"運轉",
    RUN_TIME1:"運轉時間1",
    RUN_TIME2:"運轉時間2",
    PROGRAM_RUNTIME_ACTUATOR:"運轉時間執行器",
    PROGRAM_RUNTIME_ACTUATOR_1:"運轉時間執行器1",
    PROGRAM_RUNTIME_ACTUATOR_2:"運轉時間執行器2",
    PUMP_RUN_TIME_MIN_VALIDATION:"最小值為 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"最大值為 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"使用價格格式 x.xx",
    ACTUATION_NOT_ALLOWED:"目前使用者身分不允許啟動",
    MAINTENANCE_DAYS:" 保養天數",
    MAINTENANCE_WASHES:"保養清洗",
    DAILY_FINANCES_POS:"銷售點",
    POS_INCOME:"銷售點總收入",
    PROPAGATE:"宣傳",
    ALL_DAY_HOURS_SELECTOR:"24 小時類型選擇器",
    GET_OPERATING_TIME_FROM_SITE:"從站點工作時間表取得目前裝置的運行時間",
    USER_NOT_VALID:"用戶無效，嘗試使用其他帳戶憑證。",
    VERIFIED:"已驗證",
    RESEND_VERIFICATION_MAIL:"重新發送驗證郵件",
    RETURN_TO_DASHBOARD:" 返回儀表板",
    ERROR_PAGE_BAD_REQUEST:"400 錯誤請求",
    WASHES:"清洗次數",
    TIME_TO_SERVICE:" 服務時間",
    ACCOUNT_ALREADY_ACTIVATED:"已啟動帳戶",
    DEVICE_EVENTS:"Device events",
    DEVICE_EVENTS_LOG_PULLED:"Pulled event log for device ",
    EVENTS_PULL_DATE:"Pulled events time: ",
    DEVICE_EVENTS_REFRESH:"Pull new event data",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Web sockets connection problem. Try to refresh page.",
    INSTALLATION_DATE:"Installation date of machine",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Hot wax",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"High pressure washing",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Power rim foam",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Power foam",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Stop",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Foam wash HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Wash",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Top care",
    INFO_TITLE:"資訊",
    FOAM_WAX1:"泡沫洗車蠟",
    POLISH1:"拋光",
    WAX1:"蠟",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"場點詳情已成功更新",
    COMPANY:"公司",
    FACILITY_HAS_CHANGER:"有自動販售機嗎？",
    DISABLE_OFFLINE_ALARM:"停用R2W警報",
    ASIDE_WORKING_SCHEDULES:" App 網站詳情",
    TERMS_OF_SERVICE_R2W_TITLE:"Ready2Wash服務條款",
    TERMS_OF_SERVICE_R2W:"Ready2Wash服務條款",
    DATA_PROCESSING_TITLE:"資料已處理",
    PRIVACY_POLICY_TITLE:"隱私權政策",
    READY_TO_PAY_TERMS_OF_SERVICE:"Ready2Pay 服務條款",
    TERMS_AND_SERVICES:"條款與服務",
    HOURLY: "每小時",
    DAILY: "每日",
    WEEKLY: "每週",
    MONTHLY: "每月",
    YEARLY: "每年",
    DELETE_ITEM_SUCCESS:"您已成功刪除項目",
    STATE: "狀態",
    AVAILABILITY_STATUS_1: "單位開放",
    AVAILABILITY_STATUS_2: "單位關閉（假期）",
    AVAILABILITY_STATUS_3: "單位關閉（營業時間）",
    AVAILABILITY_STATUS_4: "單位關閉（故障）",
    AVAILABILITY_STATUS_5: "單位關閉（其他）",
    AVAILABILITY_VACUUMS_STATUS_1: "吸塵器未安裝",
    AVAILABILITY_VACUUMS_STATUS_2: "吸塵器開放",
    AVAILABILITY_VACUUMS_STATUS_3: "吸塵器關閉（假期）",
    AVAILABILITY_VACUUMS_STATUS_4: "吸塵器關閉（營業時間）",
    AVAILABILITY_VACUUMS_STATUS_5: "吸塵器關閉（故障）",
    AVAILABILITY_VACUUMS_STATUS_6: "吸塵器關閉（其他）",
    ECOM_AMOUNT: "所有地點的總 Ecom",
    CAPTURED: "已記錄",
    DELETE_COMPANY_HISTORY_INFO:"此操作將刪除您公司所有的報告數據。此操作無法撤銷。",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"您確定要永久刪除所有的報告數據嗎？",
    VALUE_DATE: "價值日期",
    KARCHER_EVENT_NAME_1: "主熱交換器已再生",
    KARCHER_EVENT_NAME_2: "主熱交換器再生完成",
    KARCHER_EVENT_NAME_3: "材料 / 序列號",
    KARCHER_EVENT_NAME_4: "系統已消毒",
    KARCHER_EVENT_NAME_5: "HP 泵 1 已消毒",
    KARCHER_EVENT_NAME_6: "HP 泵 2 已消毒",
    KARCHER_EVENT_NAME_7: "HP 泵 3 已消毒",
    KARCHER_EVENT_NAME_8: "HP 泵 4 已消毒",
    KARCHER_EVENT_NAME_9: "HP 泵 5 已消毒",
    KARCHER_EVENT_NAME_10: "洗車站 1 已鎖定",
    KARCHER_EVENT_NAME_11: "洗車站 2 已鎖定",
    KARCHER_EVENT_NAME_12: "洗車站 3 已鎖定",
    KARCHER_EVENT_NAME_13: "洗車站 4 已鎖定",
    KARCHER_EVENT_NAME_14: "洗車站 5 已鎖定",
    KARCHER_EVENT_NAME_15: "洗車站 6 已鎖定",
    KARCHER_EVENT_NAME_16: "洗車站 7 已鎖定",
    KARCHER_EVENT_NAME_17: "洗車站 8 已鎖定",
    KARCHER_EVENT_NAME_18: "更新已開始",
    KARCHER_EVENT_NAME_19: "更新完成",
    KARCHER_EVENT_NAME_20: "WS 註冊開始",
    KARCHER_EVENT_NAME_21: "WS 註冊結束",
    KARCHER_EVENT_NAME_22: "WS 感測器 75%",
    KARCHER_EVENT_NAME_23: "技術故障",
    KARCHER_EVENT_NAME_24: "操作故障",
    KARCHER_EVENT_NAME_25: "設備已啟動",
    KARCHER_EVENT_NAME_26: "設備已關閉",
    KARCHER_EVENT_NAME_27: "箱子 1 已關閉",
    KARCHER_EVENT_NAME_28: "箱子 2 已關閉",
    KARCHER_EVENT_NAME_29: "箱子 3 已關閉",
    KARCHER_EVENT_NAME_30: "箱子 4 已關閉",
    KARCHER_EVENT_NAME_31: "箱子 5 已關閉",
    KARCHER_EVENT_NAME_32: "箱子 6 已關閉",
    KARCHER_EVENT_NAME_33: "箱子 7 已關閉",
    KARCHER_EVENT_NAME_34: "箱子 8 已關閉",
    KARCHER_EVENT_NAME_35: "HP 泵站 1",
    KARCHER_EVENT_NAME_36: "HP 泵站 2",
    KARCHER_EVENT_NAME_37: "HP 泵站 3",
    KARCHER_EVENT_NAME_38: "HP 泵站 4",
    KARCHER_EVENT_NAME_39: "HP 泵站 5",
    KARCHER_EVENT_NAME_40: "HP 泵站 6",
    KARCHER_EVENT_NAME_41: "HP 泵站 7",
    KARCHER_EVENT_NAME_42: "HP 泵站 8",
    KARCHER_EVENT_NAME_43: "燃燒器",
    KARCHER_EVENT_NAME_44: "燃燒器風扇",
    KARCHER_EVENT_NAME_45: "熱水泵",
    KARCHER_EVENT_NAME_46: "防凍泵",
    KARCHER_EVENT_NAME_47: "滲透泵",
    KARCHER_EVENT_NAME_48: "地板加熱",
    KARCHER_EVENT_NAME_49: "管道加熱",
    KARCHER_EVENT_NAME_50: "微清洗 / 輪轂清洗",
    KARCHER_EVENT_NAME_51: "底盤清洗泵",
    KARCHER_EVENT_NAME_52: "泡沫增壓泵",
    KARCHER_EVENT_NAME_53: "吸塵機 1",
    KARCHER_EVENT_NAME_54: "吸塵機 2",
    KARCHER_EVENT_NAME_55: "吸塵機 3",
    KARCHER_EVENT_NAME_56: "吸塵機 4",
    KARCHER_EVENT_NAME_57: "吸塵機 5",
    KARCHER_EVENT_NAME_58: "吸塵機 6",
    KARCHER_EVENT_NAME_59: "吸塵機 7",
    KARCHER_EVENT_NAME_60: "吸塵機 8",
    KARCHER_EVENT_NAME_61: "吸塵機 9",
    KARCHER_EVENT_NAME_62: "吸塵機 10",
    KARCHER_EVENT_NAME_63: "吸塵機 11",
    KARCHER_EVENT_NAME_64: "吸塵機 12",
    KARCHER_EVENT_NAME_65: "輪轂清洗泵",
    KARCHER_EVENT_NAME_66: "微泵",
    KARCHER_EVENT_NAME_67: "高強度泵",
    KARCHER_EVENT_NAME_68: "吸塵機渦輪 1",
    KARCHER_EVENT_NAME_69: "吸塵機濾網 1",
    KARCHER_EVENT_NAME_70: "吸塵機渦輪 2",
    KARCHER_EVENT_NAME_71: "吸塵機濾網 2",
    KARCHER_EVENT_NAME_72: "吸塵機渦輪 3",
    KARCHER_EVENT_NAME_73: "吸塵機濾網 3",
    KARCHER_EVENT_NAME_74: "吸塵機渦輪 4",
    KARCHER_EVENT_NAME_75: "吸塵機濾網 4",
    KARCHER_EVENT_NAME_76: "吸塵機渦輪 5",
    KARCHER_EVENT_NAME_77: "吸塵機濾網 5",
    KARCHER_EVENT_NAME_78: "吸塵機渦輪 6",
    KARCHER_EVENT_NAME_79: "吸塵機濾網 6",
    KARCHER_EVENT_NAME_80: "吸塵機渦輪 7",
    KARCHER_EVENT_NAME_81: "吸塵機濾網 7",
    KARCHER_EVENT_NAME_82: "吸塵機渦輪 8",
    KARCHER_EVENT_NAME_83: "吸塵機濾網 8",
    KARCHER_EVENT_NAME_84: "吸塵機渦輪 9",
    KARCHER_EVENT_NAME_85: "吸塵機濾網 9",
    KARCHER_EVENT_NAME_86: "吸塵機渦輪 10",
    KARCHER_EVENT_NAME_87: "吸塵機濾網 10",
    KARCHER_EVENT_NAME_88: "吸塵機渦輪 11",
    KARCHER_EVENT_NAME_89: "吸塵機濾網 11",
    KARCHER_EVENT_NAME_90: "吸塵機渦輪 12",
    KARCHER_EVENT_NAME_91: "吸塵機濾網 12",
    INSERT_TOKEN: "輸入憑證代碼並啟動服務",
    OPEN_SESSION: "會話已成功開啟",
    IN_PROGRESS: "進行中...",
    TOKEN_INSERTED: "憑證代碼已成功輸入",
    EXPIRED_SESSION: "會話已過期",
    TWO_DIGIT_INTEGER_VALIDATION: "請輸入最多兩位數的整數",
    KARCHER_OPERATION_COUNTER_1: "洗車站 1 高壓泵",
    KARCHER_OPERATION_COUNTER_2: "洗車站 1 化學泵 1",
    KARCHER_OPERATION_COUNTER_3: "洗車站 1 化學泵 2",
    KARCHER_OPERATION_COUNTER_4: "洗車站 1 化學泵 3",
    KARCHER_OPERATION_COUNTER_5: "洗車站 1 化學泵 4",
    KARCHER_OPERATION_COUNTER_6: "洗車站 2 高壓泵",
    KARCHER_OPERATION_COUNTER_7: "洗車站 2 化學泵 1",
    KARCHER_OPERATION_COUNTER_8: "洗車站 2 化學泵 2",
    KARCHER_OPERATION_COUNTER_9: "洗車站 2 化學泵 3",
    KARCHER_OPERATION_COUNTER_10: "洗車站 2 化學泵 4",
    KARCHER_OPERATION_COUNTER_11: "洗車站 3 高壓泵",
    KARCHER_OPERATION_COUNTER_12: "洗車站 3 化學泵 1",
    KARCHER_OPERATION_COUNTER_13: "洗車站 3 化學泵 2",
    KARCHER_OPERATION_COUNTER_14: "洗車站 3 化學泵 3",
    KARCHER_OPERATION_COUNTER_15: "洗車站 3 化學泵 4",
    KARCHER_OPERATION_COUNTER_16: "洗車站 4 高壓泵",
    KARCHER_OPERATION_COUNTER_17: "洗車站 4 化學泵 1",
    KARCHER_OPERATION_COUNTER_18: "洗車站 4 化學泵 2",
    KARCHER_OPERATION_COUNTER_19: "洗車站 4 化學泵 3",
    KARCHER_OPERATION_COUNTER_20: "洗車站 4 化學泵 4",
    KARCHER_OPERATION_COUNTER_21: "洗車站 5 高壓泵",
    KARCHER_OPERATION_COUNTER_22: "洗車站 5 化學泵 1",
    KARCHER_OPERATION_COUNTER_23: "洗車站 5 化學泵 2",
    KARCHER_OPERATION_COUNTER_24: "洗車站 5 化學泵 3",
    KARCHER_OPERATION_COUNTER_25: "洗車站 5 化學泵 4",
    KARCHER_OPERATION_COUNTER_26: "洗車站 6 高壓泵",
    KARCHER_OPERATION_COUNTER_27: "洗車站 6 化學泵 1",
    KARCHER_OPERATION_COUNTER_28: "洗車站 6 化學泵 2",
    KARCHER_OPERATION_COUNTER_29: "洗車站 6 化學泵 3",
    KARCHER_OPERATION_COUNTER_30: "洗車站 6 化學泵 4",
    KARCHER_OPERATION_COUNTER_31: "洗車站 7 高壓泵",
    KARCHER_OPERATION_COUNTER_32: "洗車站 7 化學泵 1",
    KARCHER_OPERATION_COUNTER_33: "洗車站 7 化學泵 2",
    KARCHER_OPERATION_COUNTER_34: "洗車站 7 化學泵 3",
    KARCHER_OPERATION_COUNTER_35: "洗車站 7 化學泵 4",
    KARCHER_OPERATION_COUNTER_36: "洗車站 8 高壓泵",
    KARCHER_OPERATION_COUNTER_37: "洗車站 8 化學泵 1",
    KARCHER_OPERATION_COUNTER_38: "洗車站 8 化學泵 2",
    KARCHER_OPERATION_COUNTER_39: "洗車站 8 化學泵 3",
    KARCHER_OPERATION_COUNTER_40: "洗車站 8 化學泵 4",
    KARCHER_OPERATION_COUNTER_41: "滲透泵",
    KARCHER_OPERATION_COUNTER_42: "熱水發生器",
    KARCHER_OPERATION_COUNTER_43: "防凍泵",
    KARCHER_OPERATION_COUNTER_44: "WSO過濾器濾芯",
    KARCHER_OPERATION_COUNTER_45: "洗車站加熱泵",
    KARCHER_OPERATION_COUNTER_46: "熱水泵",
    KARCHER_OPERATION_COUNTER_47: "泡沫管加熱器",
    KARCHER_OPERATION_COUNTER_48: "輪胎清洗泵",
    KARCHER_OPERATION_COUNTER_49: "微乳化泵",
    KARCHER_OPERATION_COUNTER_50: "高效泡沫泵",
    KARCHER_OPERATION_COUNTER_51: "吸塵器 1 渦輪 1",
    KARCHER_OPERATION_COUNTER_52: "吸塵器 1 過濾器 1",
    KARCHER_OPERATION_COUNTER_53: "吸塵器 1 渦輪 2",
    KARCHER_OPERATION_COUNTER_54: "吸塵器 1 過濾器 2",
    KARCHER_OPERATION_COUNTER_55: "吸塵器 2 渦輪 1",
    KARCHER_OPERATION_COUNTER_56: "吸塵器 2 過濾器 1",
    KARCHER_OPERATION_COUNTER_57: "吸塵器 2 渦輪 2",
    KARCHER_OPERATION_COUNTER_58: "吸塵器 2 過濾器 2",
    KARCHER_OPERATION_COUNTER_59: "吸塵器 3 渦輪 1",
    KARCHER_OPERATION_COUNTER_60: "吸塵器 3 過濾器 1",
    KARCHER_OPERATION_COUNTER_61: "吸塵器 3 渦輪 2",
    KARCHER_OPERATION_COUNTER_62: "吸塵器 3 過濾器 2",
    KARCHER_OPERATION_COUNTER_63: "吸塵器 4 渦輪 1",
    KARCHER_OPERATION_COUNTER_64: "吸塵器 4 過濾器 1",
    KARCHER_OPERATION_COUNTER_65: "吸塵器 4 渦輪 2",
    KARCHER_OPERATION_COUNTER_66: "吸塵器 4 過濾器 2",
    KARCHER_OPERATION_COUNTER_67: "吸塵器 5 渦輪 1",
    KARCHER_OPERATION_COUNTER_68: "吸塵器 5 過濾器 1",
    KARCHER_OPERATION_COUNTER_69: "吸塵器 5 渦輪 2",
    KARCHER_OPERATION_COUNTER_70: "吸塵器 5 過濾器 2",
    KARCHER_OPERATION_COUNTER_71: "吸塵器 6 渦輪 1",
    KARCHER_OPERATION_COUNTER_72: "吸塵器 6 過濾器 1",
    KARCHER_OPERATION_COUNTER_73: "吸塵器 6 渦輪 2",
    KARCHER_OPERATION_COUNTER_74: "吸塵器 6 過濾器 2",
    KARCHER_OPERATION_COUNTER_75: "清除壓縮機中的冷凝水",
    KARCHER_OPERATION_COUNTER_76: "檢查防凍系統",
    KARCHER_OPERATION_COUNTER_77: "燃燒器風扇",
    KARCHER_OPERATION_COUNTER_78: "增壓泡沫泵",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "數據列表超過 10000 項",
    KARCHER_POINT_NAME_1: "假日",
    KARCHER_POINT_NAME_2: "星期一",
    KARCHER_POINT_NAME_3: "星期二",
    KARCHER_POINT_NAME_4: "星期三",
    KARCHER_POINT_NAME_5: "星期四",
    KARCHER_POINT_NAME_6: "星期五",
    KARCHER_POINT_NAME_7: "星期六",
    KARCHER_POINT_NAME_8: "星期日",
    KARCHER_POINT_NAME_9: "吸塵器 假日",
    KARCHER_POINT_NAME_10: "吸塵器 星期一",
    KARCHER_POINT_NAME_11: "吸塵器 星期二",
    KARCHER_POINT_NAME_12: "吸塵器 星期三",
    KARCHER_POINT_NAME_13: "吸塵器 星期四",
    KARCHER_POINT_NAME_14: "吸塵器 星期五",
    KARCHER_POINT_NAME_15: "吸塵器 星期六",
    KARCHER_POINT_NAME_16: "吸塵器 星期日",
    KARCHER_POINT_NAME_17: "照明 假日",
    KARCHER_POINT_NAME_18: "照明 星期一",
    KARCHER_POINT_NAME_19: "照明 星期二",
    KARCHER_POINT_NAME_20: "照明 星期三",
    KARCHER_POINT_NAME_21: "照明 星期四",
    KARCHER_POINT_NAME_22: "照明 星期五",
    KARCHER_POINT_NAME_23: "照明 星期六",
    KARCHER_POINT_NAME_24: "照明 星期日",
    KARCHER_POINT_NAME_25: "程式 0",
    KARCHER_POINT_NAME_26: "程式 1",
    KARCHER_POINT_NAME_27: "程式 2",
    KARCHER_POINT_NAME_28: "程式 3",
    KARCHER_POINT_NAME_29: "程式 4",
    KARCHER_POINT_NAME_30: "程式 5",
    KARCHER_POINT_NAME_31: "程式 6",
    KARCHER_POINT_NAME_32: "程式 7",
    KARCHER_POINT_NAME_33: "程式 8",
    KARCHER_POINT_NAME_34: "程式 9",
    KARCHER_POINT_NAME_35: "程式 10",
    KARCHER_POINT_NAME_36: "程式 11",
    KARCHER_POINT_NAME_37: "程式 12",
    KARCHER_POINT_NAME_38: "程式 13",
    KARCHER_POINT_NAME_39: "程式 14",
    KARCHER_POINT_NAME_40: "程式 15",
    KARCHER_POINT_NAME_41: "程式 16",
    KARCHER_POINT_NAME_42: "程式 17",
    KARCHER_POINT_NAME_43: "程式 18",
    KARCHER_POINT_NAME_44: "程式 19",
    KARCHER_POINT_NAME_45: "程式 20",
    KARCHER_POINT_NAME_46: "程式 21",
    KARCHER_POINT_NAME_47: "程式 22",
    KARCHER_POINT_NAME_48: "程式 23",
    KARCHER_POINT_NAME_49: "程式 24",
    KARCHER_POINT_NAME_50: "程式 25",
    KARCHER_POINT_NAME_51: "程式 26",
    KARCHER_POINT_NAME_52: "程式 27",
    KARCHER_POINT_NAME_53: "程式 28",
    KARCHER_POINT_NAME_54: "程式 29",
    KARCHER_POINT_NAME_55: "程式 30",
    KARCHER_POINT_NAME_56: "程式 31",
    KARCHER_POINT_NAME_57: "程式 32",
    QR_CODE: "QR 碼",
    ACCEPT_TERMS_AND_CONDITIONS: "接受條款和條件",
    CREATE_AND_PRINT_VOUCHERS: "建立和列印優惠券",
    CODE_PREFIX_QUESTION: "未輸入代碼字首",
    CODE_PREFIX_QUESTION_TEXT: "您想繼續而不使用代碼前綴嗎？",
    ISSUED_DATE: "發行日期",
    VOUCHER_VALIDITY_DAYS: "優惠券有效期（天）",
    VALIDATION_ONLY_NUMBERS: "僅允許數字",
    REPRINT_VOUCHERS: "列印優惠券副本",
    EXPIRY_DATE: "有效期至"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("svTranslations", {
    MESSAGE:"Meddelande ",
    ERROR_TITLE:"Fel",
    ERROR_MESSAGE:"Ett fel uppstod ",
    ERROR_LOGIN:"Ett fel uppstod under inloggning. E-postadressen är inte giltig ",
    OK:"OK",
    CANCEL:"Avbryt",
    YES:"Ja",
    NO:"Nej",
    FROM:"Från",
    TO:"Till",
    DELETE:"Radera",
    SIGN_OUT:"Logga ut",
    NAME:"Namn",
    DATE:"Datum",
    PIECES:"Bitar",
    HOURS:"Timmar",
    DAYS:"dagar",
    MONTH:"månad",
    MONTHS:"månader",
    YEAR:"år",
    BOX:"ruta",
    SEARCH:"sök",
    ALL_USERS:"alla användare ",
    ARE_YOU_SURE:"Är du säker?",
    BACK:"tillbaka",
    AMOUNT:"antal",
    DESCRIPTION:"beskrivning",
    FORGOT_PASSWORD_ERROR_MSG:"Något gick fel. Var vänlig kontrollera din e-postadress och försök igen ",
    REQUIRED_FIELD:"fältet är obligatoriskt ",
    LOGOUT_TITLE:"Är du säker på att du vill logga ut? ",
    LOGOUT_MSG:"All osparad information kommer försvinna ",
    ACTIVATION_ACCOUNT:"Du har aktiverat ditt konto ",
    UNKNOWN_ERRROR_NOTIFICATION:"Okänt fel uppstod ",
    CONTINUE:"fortsätt ",
    DATA_NOT_AVAILABLE:"Informationen är ej tillgänglig ",
    SELECT:"välj",
    UPLOAD:"ladda upp",
    PHONE:"mobil",
    WEBSITE:"webbsida",
    WORKING_HOURS:"arbetstimmar ",
    INSERT:"för in",
    TEXT:"text ",
    CREATED:"skapad",
    VALID_UNTIL:"giltig till",
    SAVE:"spara",
    TOKENS:"pollett",
    DELETE_COMPANY_HISTORY:"ta bort företagets historik? ",
    DELETE_COMPANY_HISTORY_MESSAGE:" WARNING: After pressing this button, all transactions of your car wash will be permanently deleted! This data cannot be restored after deletion.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Are you sure you want to permanently delete all transaction data?",
    HISTORY_SUCCESSFULY_DELETED:"historik har raderats ",
    HELP:"Hjälp",
    VALUE:"Värde ",
    ACTIVATING_ACCOUNT_ERROR:"Ett fel med aktiveringen av ditt R2W-konto uppstod. Försök igen och om problemet kvarstår, kontakta vår support på support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Välkommen till Kärcher Fordonstvätt",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Välkommen till R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Ange ditt nya lösenord och bekräfta det för att aktivera R2W-konto. Du kommer automatiskt att bli inloggad",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Du kan ändra dina användarinställningar senare i appen",
    ENTER_NEW_PASSWORD:"Ange nytt lösenord ",
    REPEAT_NEW_PASSWORD:"Upprepa nya lösenordet ",
    PASSWORD_MIN_LENGTH:"Lösenordet måste vara minst 8 tecken långt ",
    PASSWORD_MAX_LENGHT:"lösenordet måste vara mindre än 32 tecken långt ",
    PASSWORD_PATTERN:"Lösenordet måste innehålla minst en stor bokstav och en liten bokstav",
    PASSWORD_MATCH:"lösenorden är inte lika ",
    ACTIVATE:"aktivera ",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Din begäran har skickats. Kontrollera din e-post för bekräftelse",
    VALIDATION_REQUIRED:"Obligatoriskt fält ",
    VALIDATION_EMAIL:"Ogiltig e-postadress",
    VALIDATION_INTEGER_NUMBER:"Vänligen ange ett heltal ",
    VALIDATION_HOURS_VALUE:"värdet måste vara mellan 0-23",
    VALIDATION_MINUTES_VALUE:"värdet måste vara mellan 0-59",
    VALIDATION_NOT_A_DATE:"Värdet är inte ett datum",
    VALIDATION_FROM:"Från datum större än till",
    VALIDATION_TO:"till datum mindre än från",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Den informationen finns redan i databasen",
    PASSWORD_VALIDATION_PATTERN_NEW:"Det måste finnas minst en siffra, en liten bokstav och en stor bokstav. Mellanslag är inte tillåtna",
    VALIDATION_PERCENT_VALUE:"värdet måste vara mellan 1-999",
    NUMBERS_ONLY_100:"Räknar nummer upp till 100",
    NUMBERS_ONLY_1000:"Räknar nummer upp till 1000",
    POSITIVE_NUMBERS_ONLY:"Endast räknande nummer",
    GRID_PAGER_PAGE:"sida",
    GRID_PAGER_ROWS_PER_PAGE:"Rader per sida",
    GRID_PAGER_PAGE_OF:"av",
    BREAD_CRUMBS_HOME:"hem",
    BREAD_CRUMBS_DASHBOARD_TECH:"Hemsidan teknologi ",
    BREAD_CRUMBS_DETAILS:"Detaljer",
    BREAD_CRUMBS_SETTINGS:"Inställningar ",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Dagsrapport totalsumma",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Rapport per timme intäkter",
    BREAD_CRUMBS_NEW_USER_GROUP:"Skapa användargrupp",
    BREAD_CRUMBS_EDIT_USER_GROUP:"redigera användargrupp",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Skapa kampanjmall",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"redigera kampanjmall ",
    BREAD_CRUMBS_NEW_CAMPAIGN:"skapa kampanj ",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"redigera kampanj ",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Sammanfattning för en period",
    LOGIN:"logga in ",
    EMAIL:"e-post",
    PASSWORD:"lösenord ",
    LANGUAGE:"språk",
    FORGOT_PASSWORD:"glömt lösenord? ",
    SUBMIT:"skicka in ",
    HEADER_NUMBER_OF_PENDING_ALARMS:"antal väntande larm:",
    HEADER_VIEW_ALL_ALARMS:"visa alla larm ",
    HEADER_MY_ACCOUNT:"Mitt konto ",
    HEADER_ACCOUNT_MANAGEMENT:"Hantering konto",
    ACCOUNT_ALREADY_EXIST:"E-postadressen används redan",
    NEWSLETTER_CONFIRMATION:"Skicka e-postmeddelande för status larm",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Översikt över dagliga finanser",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Hemsidans teknologi",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Hemsida",
    ASIDE_MENU_ALARMS:"meddelanden ",
    ASIDE_MENU_FACILITIES:"anläggning ",
    ASIDE_MENU_REPORTS:"rapporter ",
    ASIDE_MENU_LOYALTY:"lojalitet ",
    ASIDE_MENU_USER_GROUPS:"användargrupper ",
    ASIDE_MENU_PERIODIC_SUMMARY:"periodisk sammanfattning ",
    ASIDE_MENU_NEWS:"nyheter ",
    DAILY_FINANCES_TOTAL_MONEY:"pengar totalt ",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"pengar totalt för alla anläggningar ",
    DAILY_FINANCES_TOTAL_COINS:"Totalt använda metallpolletter",
    DAILY_FINANCES_DOWNLOAD_CSV:"ladda ned CSV",
    DAILY_FINANCES_ONLINE:"R2W (online) ",
    DAILY_FINANCES_OFFLINE:"Kontanter",
    DAILY_FINANCES_CHANGER:"Kontanter i växlare",
    DAILY_FINANCES_COINS:"polletter/Eurokey",
    REPORTS_FILTER:"filter ",
    REPORTS_TYPE_OF_REPORT:"typ av rapport ",
    REPORTS_CHOOSE_FACILITY:"välj anläggning ",
    REPORTS_PERIOD_1:"period 1-",
    REPORTS_PERIOD_2:"period 2-",
    MONEY_BY_DATE_REPORT:"total inkomst per datum",
    R2W_BY_DATE_REPORT:"Total inkomst från R2W-polletter per datum",
    COINS_BY_DATE_REPORT:"totalt använda polletter per datum",
    AVG_MONEY_BY_HOUR_REPORT:"genomsnittlig inkomst per timme ",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"genomsnittlig inkomst per dag i veckan",
    AVG_MONEY_BY_BOX_REPORT:"utgifterna vid viken ",
    COMPARE_PERIODS_REPORT:"Rapport jämförbara anläggningar",
    TOTAL_USERS_BY_GROUP:"totala R2W-appbesök per dag ",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"användare ",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"besök",
    VISITS_COUNT_REPORT:"Antal R2W-appanvändare per besökantal",
    LOYALTY_PER_DAY_REPORT:"Antal Lokala polletter spenderade per dag ",
    LOYALTY_PER_PAYMENT_METHOD:"Polletter per betalningsmetod",
    VISITS:"besök",
    VISIT:"besök ",
    TOTAL_SPENT_MONEY:"total inkomst ",
    MONEY:"pengar ",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"total inkomst pengar för period ",
    DOWNLOAD_CSV:"ladda ned CVS",
    TOTAL_SPENT_COINS:"totala antal spenderade polletter ",
    TOTAL_USERS:"totala antal användare ",
    TOTAL_CREDIT_GIVEN:"Totala lokala virtuella polletter spenderade ",
    EUROKEY_BY_DATE_REPORT:"totala Eurokey betalningar per datum ",
    TOTAL_SPENT_EUROKEY:"totala köp",
    SELECT_TYPE_OF_REPORT:"Du måste välja rapporttyp :)",
    NUMBER_OF_VISITS_TITLE:"antal besök ",
    NUMBER_OF_USERS_TITLE:"antal användare ",
    PIECES_TITLE:"delar",
    TOTAL_VISITS:"totala besök ",
    TOKENS_TITLE:"polletter ",
    SEARCH_USERS_NO_RESULTS:"Inga användare hittades för det givna sökordet",
    SEARCH_USERS:"sök användare",
    SEARCH_TELEPHONES:"sök användare med mobilnummer ",
    ADD_USER_TO_GROUP:"lägg till användare till grupp",
    REMOVE_USER_FROM_GROUP:"ta bort användare från grupp ",
    USER_GROUP_NAME_REQUIRED:"gruppnamn krävs ",
    USER_GROUP_NAME:"gruppnamn",
    USER_GROUPS_OVERVIEW:"gruppöversikt ",
    USER_COUNT:"användarantal ",
    NEW_USER_GROUP:"skapa ny användargrupp ",
    DELETE_USER_GROUP:"radera användargrupp ",
    UPDATE_USER_GROUP:"redigera användargrupp ",
    DELETE_USER_GROUP_ERROR:"Det gick inte att ta bort vald användargrupp. Försök igen eller kontakta supporten...",
    CONFIRM_DELETE_USER_GROUP:"är du säker på att du vill radera vald användargrupp? ",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Lojalitetsåtgärder som den borttagna gruppen har tilldelats kommer inte längre att vara tillgängliga",
    GROUP_NAME_MAX_LENGTH:"gruppnamnet måste vara mindre än 255 tecken lång ",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"användaren är redan med i gruppen ",
    MISSING_USER:"användare saknas ",
    USER_NOT_ON_LIST:"Användaren finns inte i den aktiva användarlistan. Kontrollera om e-postadressen är giltig och försök igen.",
    UPLOAD_USER_GROUP:"Ladda upp användargruppslistan från * .csv-filen",
    UKNOWN_USERS:"lista på okända användare ",
    CAMPAIGN_TEMPLATE_RULE:"mallregel",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Det har uppstått ett fel vid försök att ta bort kampanjmallen. Vänligen försök igen eller kontakta support ...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"är du säker på att du vill radera vald kampanjmall",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"är du säker på att du vill radera vald kampanjmall",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Översikt över kampanjmallar",
    DELETE_CAMPAIGN_TEMPLATE:"radera kampanjmall ",
    UPDATE_CAMPAIGN_TEMPLATE:"redigera kampanjmall ",
    CREATE_CAMPAIGN_TEMPLATE:"skapa ny kampanjmall ",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"namn på kampanjmallen krävs ",
    CAMPAIGN_TEMPLATE_NAME:"kampanjmall namn ",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"obligatoriskt fält ",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"ge %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"extratid ",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Välj typ först. Tvättbås eller små maskiner",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Radera mallregel",
    CAMPAIGN_TEMPLATE_RULE_FROM:"från ",
    CAMPAIGN_TEMPLATE_RULE_TO:"till",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"timmar ",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuter ",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Ny regel efter antal besök",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"ny regel efter antal spenderade polletter ",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"ny regel efter dagar i veckan ",
    CAMPAIGN_TEMPLATE_ADD_RULE:"lägg till ny mallregel ",
    CAMPAIGN_TEMPLATE_RULE_1:"varje ",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"varje ",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"polletter använda på mindre än",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"besök på mindre än ",
    CAMPAIGN_TEMPLATE_RULE_3:"dagar ",
    CAMPAIGN_TEMPLATE_RULE_4:"polletter ",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"regellista är tom",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"datumet kan inte ha passerats",
    DELETE_CAMPAIGN_ERROR:"Det har uppstått ett fel vid försök att ta bort kampanjen. Vänligen försök igen eller kontakta support ...",
    CONFIRM_DELETE_CAMPAIGN:"är du säker på att du vill radera vald kampanj?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W ansvarar inte för användarupplevelsen som orsakas av denna åtgärd.",
    CAMPAIGNS_OVERVIEW:"översikt över kampanjer ",
    DELETE_CAMPAIGN:"radera kampanj ",
    UPDATE_CAMPAIGN:"redigera kampanj ",
    CREATE_CAMPAIGN:"skapa ny kampanj ",
    CAMPAIGN_ACTIVE:"aktiv ",
    CAMPAIGN_TEMPLATE:"mall",
    CAMPAIGN_GROUPS:"grupp",
    CAMPAIGN_ALL_USERS:"alla användare ",
    CAMPAIGN_NAME:"kampanjnamn ",
    CAMPAIGN_NAME_REQUIRED:"obligatoriskt ",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Antal användare nära max per dag",
    MESSAGE_TO_USERS:"Meddelande till filtrerade användare",
    SEND_MESSAGE:"skicka meddelande ",
    THRESHOLD:"nära max",
    TYPE:"typ",
    TOTAL_MONEY_SPENT:"total summa pengar använda på kampanj ",
    NUMBER_OF_VISITS:"antal besök på kampanj ",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"meddelandet måste vara minst 10 tecken långt ",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"meddelandet måste vara mindre än 350 tecken långt ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"text är obligatoriskt ",
    TECHNOLOGY:"teknologi ",
    TAP_WATER:"Färskvatten ",
    REVERSE_OSMOSIS:"omvänd osmos ",
    SOFTENED_WATER:"Färskvatten ",
    DOSER:"doserare ",
    STATUS:"status",
    LAST_SYNCHRONIZATION:"Sista synkroniseringen",
    NO_OF_CURRENT_ALARMS:"antal aktuella larm ",
    NO_OF_CURRENT_WARNINGS:"antal aktuella varningar ",
    WEATHER:"väder ",
    BOXES_WORK_HOURS_COUNTERS:"Tvättbåsens arbetstid",
    BOX_TOTAL_HOURS:"total arbetstid ",
    BOX_SERVICE_HOURS:"total arbetstid (service) ",
    BOX_COUNTER_HOURS:"timmar",
    ALARMS_AND_WARNINGS:"larm & varningar",
    FILTER_AND_BOILER:"filter & varmvattenberedare",
    FILTER_TOTAL_DAYS:"filter arbetsdagar ",
    BOILER_TOTAL_DAYS:"Varmvattenberedare arbetsdagar ",
    DAYS_UNIT:"dagar ",
    SOFTENER:"mjukmedel ",
    MANUAL_COLD_DRAIN:"instruktion dränering kallvatten",
    EL_COLD:"El. kall",
    DRAIN:"avlopp",
    TAP:"kran",
    WASTE:"Spill",
    OSMOSIS:"osmos ",
    DEMI_WATER:"Demi vatten ",
    EL_RINSE:"El. m. rensa",
    BOILER:"Varmvattenberedare",
    EL_WAX:"El. m. vax ",
    FLOOR_HEATING:"golvvärme ",
    DOSER_TANK:"doseringstank ",
    EL_WASH:"El. m. tvätt",
    DETERGENT:"tvättmedel ",
    VIBRATOR:"vibrator ",
    UPDATE_FACILITY_SETTINGS:"uppdatera inställningar ",
    GENERAL_SETTINGS:"allmänna inställningar ",
    LIGHTS:"lampor ",
    GROUPS:"grupper ",
    ANTI_FREEZE:"frostskydd",
    AUTO:"auto",
    MANUAL:"manuell ",
    ON:"på",
    OFF:"av",
    TEMPERATURE:"temperatur ",
    UPDATE_DEVICE:"uppdatera anläggningsinställningar ",
    BOX_CLEAN_HOURS:"Tvättbås räknare (timmar)",
    GROUP_COUNTERS:"gruppräknare",
    RESET:"återställ",
    CASH_COUNT:"mynt räknas ",
    COINS_COUNT:"polletter räknas ",
    EUROKEY_COUNT:"eurokey räknas ",
    DOSER_WORK:"Doserare arbetstimmar (sek)",
    DOSER_PAUSE:"Doserare pausad tid (sek)",
    DELAY_BFV:"BFV fördröjning (ms)",
    DELAY_6M1:"6M1 fördröjning (ms)",
    DELAY_LPS:"LPS fördröjning (ms)",
    RESET_CASH_COUNT_ALL:"Återställ alla mynträknare",
    RESET_COINS_COUNT_ALL:"Återställ alla polletträknare",
    RESET_EUROKEY_COUNT_ALL:"Återställ alla Eurokeyräknare",
    FACILITY_DETAILS:"Anläggningsdetaljer",
    FACILITY_NAME:"Anläggningens namn",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Bilden uppladdad",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Du har uppdaterat information ",
    CONNECTED:"Ansluten ",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Meddelandefilter ",
    FACILITY:"Anläggning ",
    APPLY:"Ansök",
    TIME:"Tid",
    LOCATION:"Plats",
    ACKNOWLEDGED:"Bekräftad ",
    FILTERED_MESSAGES:"Filtrerade meddelanden ",
    ACK:"Bekräftad ",
    NOT_ACK:"Ej bekräftad ",
    ALL:"Alla",
    ALL_FACILITIES:"Alla anläggningar ",
    ENTER_DATE_PLACEHOLDER:"Ange datum ",
    OP_NESTANAK_NAPONA:"Spänning saknas på fasindikator 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Brytare Högtryckspump har löst ut",
    OP_UPR_NAPON_24VAC_GRE:"Saknas 24 VAC - brytare 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Färskvattenbehållare tom",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Nätströmbrytaren avslagen",
    OP_MIN_NIVO_OMEKS_VODE:"mjukvattenbehållare tom",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Brytare för mjukvattenpump har löst ut",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosvattenbehållare tom",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Brytare för pump Osmosvatten har löst ut",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Osmosproduktionens pump har löst ut",
    OP_BOJLER_GRESKA_MZS:"Varmvattenelement ur funktion",
    OP_CRPKA_PRASKA_GRE_MZS:"Varmvattenpump har löst ut",
    OP_DOZATOR_PRASKA_GRE_MZS:"Motordrivningsbrytare för pulverdosering har löst ut",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Pulsdoseringsvibratorströmbrytaren har löst ut",
    OP_MIN_PRASAK_TON_ALARM:"Pulverblandningstank tom",
    OP_USIS_KOV_TURBINA_GRESKA:"Myntvakuumturbinalbrytare har löst ut",
    OP_FILTER_VODE_ZACEPLJEN:"vattenfiltret blockerat ",
    OP_VISKTL_RESET_SATI_RADA:"Service av Högtryckspump",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Vattenfilterfel",
    OP_BOJLER_DANI_RADA:"fel på vattenvärmare ",
    OPW_ALARM_VISOKOTL_PUMPA:"Högtryckspumplarm",
    OPW_ALARM_FILTER_SERVIS:"Filterlarm",
    OPW_ALARM_BOJLER_SERVIS:"värmare servicelarm ",
    HAS_MEMBERS:"Den valda gruppen har medlemmar och kan inte raderas. Medlemmar måste raderas först.",
    PERIODIC_SUMMARY_FOR:"PERIODISK SAMMANFATTNINGSRAPPORT FÖR",
    PERIODIC_SUMMARY_REPORTS:"periodiska sammanfattningsrapporter ",
    DATE_RANGE:"Intervall datum",
    FINANCIAL_REPORT:"finansiell rapport ",
    GROSS_INCOME:"Bruttoinkomst",
    GROSS_INCOME_SUM:"Bruttoinkomst summering",
    COMMISSION_FEE:"provisionskostnad",
    NET_INCOME:"Nettoinkomst (för fakturering)",
    COMMISSION_FEE_DETAILS:"Provisionsavgift inkluderar bank- / PayPal-tillhandahållande eller avgift för leverantörer av SMS-tjänster",
    LOYALTY_CREDITS_REPORT:"Rapport för lokala polletter",
    LOYALTY_GIVEN:"givna lokala polletter ",
    LOYALTY_USED:"använda lokala polletter ",
    LOYALTY_SOLD:"lokala polletter laddade ",
    LOYALTY_TOTAL:"totalt ",
    LOYALTY_CURRENT_MONTH:"nuvarande månad ",
    SOMETHING_WENT_WRONG:"oooooops",
    MISSING_PAGE:"förlåt. sidan hittades inte ",
    TRY_AGAIN:"försök igen ",
    DEFAULT_ERROR_NAME:"okänt fel har uppstått ",
    DEFAULT_ERROR_DESCRIPTION:"vänligen försök igen ",
    MY_ACCOUNT_DETAILS:"mitt konto detaljer ",
    SAVE_CHANGES:"spara ändringar ",
    USERNAME:"användarnamn ",
    FIRST_NAME:"namn ",
    LAST_NAME:"efternamn ",
    USER_ROLE:"användarroll ",
    OLD_PASSWORD:"gammalt lösenord ",
    NEW_PASSWORD:"nytt lösenord ",
    OLD_PASSWORD_REQUIRED:"gamla lösenordet krävs ",
    NEW_PASSWORD_REQUIRED:"nya lösenordet krävs ",
    NEW_PASSWORD_REPEAT:"upprepning av nya lösenordet krävs ",
    NEW_PASSWORD_NOT_MATCH:"det gamla och nya lösenordet matchar inte ",
    PASSWORD_DIFFERENT_VALIDATION:"det nya lösenordet måste vara annorlunda jämfört med det gamla ",
    PASSWORD_MIN_CHAR:"lösenordet måste vara minst 8 tecken långt ",
    PASSWORD_MAX_CHAR:"lösenordet får max vara 32 tecken långt ",
    PASSWORD_PATTERN_VALIDATION:"lösenordet måste innehålla minst en siffra ",
    ACCOUNT_MANAGEMENT:"kontoinställningar ",
    NOT_ACTIVE:"inte aktiv ",
    ASSIGN_ROLE:"tilldela roll ",
    UPDATE:"uppdatera ",
    ADD_NEW_ACCOUNT:"lägg till nytt konto ",
    EMAIL_REQUIRED:"e-postadress krävs ",
    EMAIL_NOT_VALID:"e-postadress är ej giltig ",
    ADD_NEW_USER_TEXT:"E-post med aktiveringslänk skickas till den angivna e-postadressen.",
    UPDATE_USER_NOTIFICATION:"informationen har uppdaterats ",
    CHANGED_PASSWORD_NOTIFICATION:"lösenordet har ändrats ",
    UPDATE_USER_GROUP_NOTIFICATION:"gruppnamnet har ändrats ",
    CREATE_USER_GROUP_NOTIFICATION:"grupp har skapats ",
    DETELE_USER_GROUP_NOTIFICATION:"grupp har raderats ",
    EMPTY_GROUP_LIST_MSG:"det finns inga skapade grupper. börja med att skapa en",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"användare togs bort från gruppen ",
    ADD_USER_TO_GROUP_NOTIFICATION:"användare har lagts till i gruppen ",
    ADD_USER_NOTIFICATION:"ny användare lades till i gruppen ",
    DELETE_USER_NOTIFICATION:"användare har raderats ",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"för att skapa en användargrupp ",
    DELETE_USER:"radera användare ",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"är du säker på att du vill radera användare från grupp? ",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Bäste Kärcherappanvändare ",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Lojalitetsregel per antal besök",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Lojalitetsregel per antal använda polletter ",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Lojalitetsregel per dag i veckan ",
    REMOVE_CAMPAIGN_RULE_TITLE:"Borttagning av kampanjregel ",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"är du säker på att du vill ta bort kampanjregel? ",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"ny kampanj har skapats ",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"kampanj har aktiverats ",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"det finns inga skapade kampanjer. börja med att skapa en ",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"meddelandet har skickats ",
    COMPANY_ACCOUNTS:"företagskonton ",
    BUSSINESS_INVOICES_LIST:"min B2B faktura ",
    LOCALE_TOKEN:"lokala polletter ",
    R2W:"globala polletter ",
    START_MONTH:"start på månad",
    END_MONTH:"slut på månad ",
    TOKEN_TYPE:"Pollettyp",
    TOKEN_NUMBER:"Pollettnummer",
    NOTHING_TO_DISPLAY:"* inget att visa",
    CREATE_INVOICE:"skapa faktura ",
    INVOICE:"faktura ",
    INVOICES:"fakturor ",
    EDIT_INVOICE:"redigera faktura ",
    UPDATE_INVOICE_NOTIFICATION:"Du har uppdaterat fakturan till väntande status",
    CURRENT_CHARGES:"Avgifter för den aktuella perioden",
    PAYMENTS_ON_HOLD:"Fakturan bearbetas ",
    FOR_INVOICING:"för fakturering ",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"du kommer avbryta fakturan ",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"är du säker på att du vill avbryta fakturan? ",
    INVOICING_NOTIFICATION_HEADER:"du kommer fakturera",
    INVOICING_NOTIFICATION_TEXT:"är du säker på att du vill skicka faktura? ",
    SENT_INVOICE_NOTIFICATION:"du har skickat fakturan ",
    CANCELED_INVOICE_NOTIFICATION:"du avbröt fakturan ",
    INVOICE_DESCRIPTION_TEXT:"faktura för ",
    INVOICE_STATE:"Status faktura",
    INVOICE_NUMBER:"fakturanummer ",
    INVOICE_TOTAL:"totalt ",
    SELECT_YEAR:"välj år ",
    DOWNLOAD:"ladda ned PDF",
    INVOICE_NUMBER_HEADER:"du kommer skicka faktura med nummer ",
    INVOICE_PAYMENT_CONFIRMATION:"du kommer bekräfta betalning för ",
    INSERT_INVOICE_NUMBER:"Lägg in fakturanummer ",
    INVOICED_WARNING:"Mailen skickades inte. vänligen vänta ",
    SEND_INVOICE:"skicka ",
    INVOICE_ALL:"alla ",
    INVOICE_FROM_R2W:"från R2W",
    INVOICE_TO_R2W:"till R2W",
    PAYMENT_REQUEST:"betalningsbegäran ",
    PAYMENT_REQUEST_STATE:"Status betalningsbegäran ",
    PAYMENT_REQUEST_NUMBER:"Nummer för betalningsbegäran ",
    FOR_PAYMENT_REQUEST:"för betalningsbegäran ",
    PAYMENT_REQUEST_ON_HOLD:"betalningsbegäran bearbetas ",
    DOWNLOAD_INVOICE:"ladda ned faktura ",
    CLICK_FOR_DOWNLOAD_OPTIONS:"klicka för nedladdningsalternativ ",
    B2B_SPEC:"B2B specifikation ",
    B2C_SPEC:"B2C specifikation ",
    DOWNLOAD_PAYMENT_REQUEST:"ladda ned betalningsbegäran ",
    LOYALTY_PREVIEW:"lojalitetsförhandsvisning",
    ACTIVATED:"aktiverad ",
    RUNNING:"pågående ",
    NOT_ACTIVATED:"ej aktiverad ",
    FINISHED:"avslutad ",
    DEPRECATED:"förringa ",
    UPCOMING:"kommande ",
    NONE:"ingen",
    STARTED:"påbörjad ",
    ENDS:"avslutas ",
    DEDICATED:"tillägnad till ",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"du kommer aktivera ",
    CAMPAIGN:"kampanj",
    SEND_MESSAGE_NOTIFICATION:"du kommer skicka meddelande till valda grupper ",
    DIVISIBLE_TO_NUMBER:"numret borde vara delbart med ",
    BRIDGE_PLC:"Bro-PLC",
    DEVICE_TYPE:"enhetstyp",
    LISTENER:"små maskiner ",
    BRIDGE:"Tvättbås",
    WASH_BOXES:"Tvättbås",
    VACUUMS:" Vacuums",
    SAVE_NEWS:"spara nyheter ",
    CREATE_NEW_NEWS:"skapa nya nyheter ",
    HISTORY_OF_ALL_NEWS:"historik över alla nyheter ",
    TYPE_FACILITY_NAME_PLACEHOLDER:"typ anläggningsnamn ",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"lägg till en annan anläggning ",
    NEWS_TEXT:"nyheter text",
    NEWS_TITLE:"nyhetstitel",
    DELETE_NEWS_CONFIRMATION:"du kommer radera nyheter ",
    NEWS_DELETE_NOTIFICATION:"nyheterna har raderats ",
    NEWS_SAVE_NOTIFICATION:"nyheterna har sparats ",
    NEWS_CREATION_DATE:"datum av skapande ",
    NO_TITLE:"ingen titel ",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"nyhetstexten måste vara mindre än 255 tecken lång ",
    NEWS_TEXT_REQUIRED_VALIDATION:"nyhetstext krävs inte ",
    NEWS_TITLE_REQUIRED_VALIDATION:"nyhetstitel krävs ",
    DEACTIVATE:"avaktiverad ",
    ASIDE_MENU_LOCAL_TOKENS:"lokala polletter ",
    CREATE_NEW_LOCAL_TOKENS:"ge ut nya lokala polletter ",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Ange kundens e-postadress och det antal polletter som du vill ge ut till kunden",
    CREATE_TOKENS:"Ge ut polletter ",
    MINIMUM_ONE_TOKEN:"värdet måste vara större än 0",
    CUSTOMER_EMAIL:"kund e-post",
    AMOUNT_OF_TOKENS:"antal polletter ",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Gick bra att ge ut lokala polletter till ",
    PROBLEM_ISSUING_LOCAL_TOKENS:"ett fel uppstod med att ge ut lokala polletter. vänligen kontrollera kundens e-postadress och försök igen",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"översikt av utgivna lokala polletter ",
    ISSUED_AT:"utgiven på",
    ISSUED_BY:"utgiven av ",
    CODE:"inlösningskod ",
    REDEEMED_BY:"löst in av ",
    REDEEMED_AT:"löst in på ",
    ASIDE_MENU_VOUCHERS:"kupong ",
    PRINT:"skriv ut ",
    VOUCHERS_OVERVIEW:"kupongöversikt ",
    CREATE_NEW_VOUCHERS:"skapa ny kupong ",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Skapa en ny inlösningsbar kupongpaket genom att ange antal polletter per kupong",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"antal polletter per kupong ",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Du kan tilldela mellan 1 och 100 polletter per kupong",
    NUMBER_OF_NEW_VOUCHERS:"antal kuponger som ska skapas  ",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Du kan skapa mellan 1 och {{antal}} kuponger i en enda omgång",
    NEW_VOUCHERS_PREFIX:"ny kupongseriekod prefix ",
    VALIDATION_VOUCHER_PREFIX:"kodprefixet måste vara exakt 4 tecken långt (stor bokstav och/eller siffror)",
    PROBLEM_CREATING_NEW_VOUCHERS:"ett problem uppstod med att skapa ny kupong. vänligen försök igen eller kontakta supporten. ",
    CREATE_VOUCHERS:"skapa kupong",
    CREATING_VOUCHERS_SUCCESS:"ny kupong har skapats ",
    PRINT_NEW_VOUCHERS:"skriv ut kupong ",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"ange en kupongseriekod prefix för att skriva ut hela kupongserien. alternativt ",
    PRINT_VOUCHERS_PREFIX:"kupong (serie) kod prefix",
    NO_VOUCHERS_FOR_PRINT:"ingen kupong hittades för att skriva ut som matchade den angivna kod prefixen",
    PRINT_VOUCHERS:"skriv ut kupong ",
    VALIDATION_VOUCHER_CODE_FILTER:"kupongers sökterm måste innehålla stor bokstav och siffror ",
    FILTER_VOUCHERS_BY_CODE:"Sök kuponger genom att lösa in koden",
    FILTER_VOUCHERS:"sök kuponger ",
    WASH_BOX:"Tvättbås",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Totalt använda digitala polletter",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Totalt sålda lokala polletter per datum",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"totalt använda lokala polletter per datum",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"totalt utgivna lokala polletter per datum ",
    LOCAL_TOKEN:"lokala polletter",
    GIVEN_TOKEN:"Utgivna lokala polletter ",
    SOLD_TOKEN:"sålda lokala polletter ",
    SMALL_MACHINES:"små maskiner ",
    R2W_Listener:"lyssnare ",
    HHANLE_DEVICE:"HHanle tvättbås",
    CODE_PREFIX_EXIST:"kodprefix finns redan ",
    CODE_PREFIX_EXIST_TEXT:"Du kan inte skapa en ny kupong med det här kodprefixet. Välj en annan.",
    MIN_FOUR_VALIDATION:"exakt 4 tecken",
    ALL_INFORMATION_1:"all information om",
    ALL_INFORMATION_2:"kommer förloras ",
    ASIDE_MENU_TRANSACTIONS:"transaktion ",
    EXPENSES:"utgifter ",
    TOPUPS:"Påfyllnad",
    EXPENSES_LIST:"utgifter lista ",
    USER_EMAIL:"användarens e-post",
    COMPANY_NAME:"företagsnamn ",
    TOPUPS_LIST:"Påfyllnadslista ",
    CONSUMER:"konsument",
    SYSTEM_ADMIN:"systemadministratör ",
    MERCHANT_ADMIN:"Handlaradministratör",
    COMPANY_ADMIN:"företagsadministratör ",
    FACILITY_ADMIN:"anläggningsadministratör",
    SUBSCRIBER:"prenumerant  ",
    CONFIGURATOR:" konfigurator",
    SETUP_UNIT_SERIAL_NO:"serienummer ",
    SETUP_UNIT_MATERIAL_NO:"Materialnummer",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi version ",
    TOTAL_TURNOVER:"Tvättanläggningens omsättning",
    AVAILABILITY_ALL:"tillgänglighet ",
    AVAILIBILITY:"Tvättbås tillgänglighet ",
    AVAILABILITY_VACUUMS:"Dammsugarnas tillgänglighet ",
    WASH_BOX_INFO:"Tvättbåsens information ",
    VACUUM_CLEANER_INFO:"dammsugare info",
    BREAD_CRUMBS_SERVICE:"tjänst ",
    HOLIDAYS:"semester ",
    LIGHTS_ON:"lampor/på",
    LIGHTS_OFF:"lampor/av",
    WASH_BOXES_ON:"tvättbås/på",
    WASH_BOXES_OFF:"tvättbås/av",
    VACUUMS_ON:"dammsugare/på",
    VACUUMS_OFF:"dammsugare/av",
    TURNOVER:"omsättning ",
    TURNOVER_MANUAL_WASH_UNIT:"omsättning manual ",
    STATUS_BAY_RUN_TIME:"tvättbås total arbetstid ",
    STATUS_BAY_PROGRAM_NAME:"programnamn",
    STATUS_BAY_CREDIT:"tvättbås poäng ",
    CLOUD_KREDIT:"moln poäng ",
    STATUS_VACUUM_RUN_TIME:"dammsugare total arbetstid ",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facilitetstjänster,  program Tvättbås och aktuell feldatainformation",
    UNAVAILABLE:"enhet är tillgänglig ",
    SHOW_HIDE_TABLE:"visa/dölj tabell för arbetstimmar",
    PROGRAM_NAME:"programnamn",
    PROGRAM_COUNTER:"programräknare ",
    NO_NAME:"referensen har inget namn ",
    COUNTER_SERVICE_DATA:"tjänstdata ",
    NEED_SERVICE:" Service needed",
    PROGRAM_DATA:"tvättmaskin programdata ",
    CURRENT_FAULT_DATA:"nuvarande fel data ",
    REFERENCE_DUE:"på grund av",
    REFERENCE_SECONDS:"sekunder",
    REFERENCE_NAME:"delnamn",
    WASHBOX_NAME:"Tvättbås namn ",
    FAULT_NAME:"fel namn ",
    FAULT_NUMBER:"fel nummer ",
    CURRENT_FAULT_COUNT:"aktiva fel ",
    DEVICE_NOT_INSTALLED:"enheten ej installerad",
    STATUS_READY:"Status redo",
    STATUS_ERROR:"fel status ",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Mjukvarufel",
    SOFTWARE_RESET:"Mjukvarufel",
    EXTERNAL_PIN_RESET:" Software error",
    RESTART_OR_BROWNOUT_OCCURRED:"Mjukvarufel",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hårdvarufel",
    COULD_NOT_SIMULATE_COIN:"Hårdvarufel",
    ERROR_SETTING_INHIBIT_MODE:"Hårdvarufel",
    OFFLINE_DEVICE:"Fordonstvätt Offline",
    TARIFFS:"Tariffer",
    DAY:"Dag ",
    NIGHT:"Natt",
    VOUCHER_CODE:" Voucher code",
    DISMISS_ALARM:" Reset alarm?",
    ALARM_ACTIVE:" Active alarms",
    NO_ALARM_ACTIVE:" There are no active alarms",
    ALARM_HISTORY:" Alert history",
    MANAGING_TOKENS:"Hantera tokens",
    EXPIRATION_DATE:"Utgångsdatum",
    EXTEND_TOKEN_DATE:"Förläng tokens utgångsdatum för",
    DELETE_TOKENS_FOR:"Ta bort tokens för",
    PUMP_TYPE:"Pump type",
    TURN_OFF_DEVICE:" Device status",
    OPERATION_DATA:" Operation data",
    PUMP_DATA:" Pump data",
    PUMP_NAME:" Pump name",
    POINT_NAME:" Point name",
    CHANGER_INCOME:" Total changer income by date",
    SELECTED_OPEN:"Öppet på valda arbetstider",
    ALWAYS_OPEN:"Alltid öppet (24/7)",
    CLOSED:"Stängd",
    MON:"Måndag",
    TUE:"Tisdag",
    WED:"Onsdag",
    THU:"Torsdag",
    FRI:"Fredag",
    SAT:"Lördag",
    SUN:"Söndag",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Elektroniska utgångar överbelastade",
    KARCHER_ERROR_MESSAGE_2:"oljeavskiljaren måste tömmas",
    KARCHER_ERROR_MESSAGE_4:"Dimningssensor defekt",
    KARCHER_ERROR_MESSAGE_5:"Den skyddande motoromkopplaren på högtryckspumpar startades",
    KARCHER_ERROR_MESSAGE_6:"kopplingen till RDS defekt ",
    KARCHER_ERROR_MESSAGE_7:"Tryckomkopplaren för luft på kompressorn rapporterar inget",
    KARCHER_ERROR_MESSAGE_8:"orsak: ingen koppling till elektroniken 'MSWS'",
    KARCHER_ERROR_MESSAGE_10:"Ingen anslutning till pumpelektronik på tvättstationen 1",
    KARCHER_ERROR_MESSAGE_11:"Elektroniska utgångar vid tvättstation 1 överbelastad",
    KARCHER_ERROR_MESSAGE_12:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 1 för hög",
    KARCHER_ERROR_MESSAGE_13:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 1 för låg",
    KARCHER_ERROR_MESSAGE_14:"Kontakt med högtryckspumpen vid tvättstationen 1 fast",
    KARCHER_ERROR_MESSAGE_15:"semiventil på tvättstationen 1 defekt",
    KARCHER_ERROR_MESSAGE_16:"skyddskontakt för tvättstationen för högtryckspump 1",
    KARCHER_ERROR_MESSAGE_17:"Högtryckspumpens oljenivå vid tvättstationen 1 för låg",
    KARCHER_ERROR_MESSAGE_18:"Elektroniken vid tvättstation 1 defekt",
    KARCHER_ERROR_MESSAGE_19:"Tvättstation 1 för högtryckspumpar motorskyddsbrytare har löst ut",
    KARCHER_ERROR_MESSAGE_20:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 1",
    KARCHER_ERROR_MESSAGE_21:"Fel vid myntacceptorn vid tvättstationen 1",
    KARCHER_ERROR_MESSAGE_22:"Fel vid myntacceptorn vid tvättstationen 1",
    KARCHER_ERROR_MESSAGE_30:"Ingen anslutning till pumpelektronik på tvättstation 2",
    KARCHER_ERROR_MESSAGE_31:"Elektroniska utgångar vid tvättstation 2 överbelastad",
    KARCHER_ERROR_MESSAGE_32:"Aktuell upphämtning av högtryckspumpen vid tvättstation 2 för hög",
    KARCHER_ERROR_MESSAGE_33:"Aktuell upphämtning av högtryckspumpen vid tvättstation 2 för låg",
    KARCHER_ERROR_MESSAGE_34:"Kontakt med högtryckspumpen vid tvättstationen 2 fastnat",
    KARCHER_ERROR_MESSAGE_35:"Semiventil på tvättstation 2 defekt",
    KARCHER_ERROR_MESSAGE_36:"skyddskontakt för tvättstationen för högtryckspump 2",
    KARCHER_ERROR_MESSAGE_37:"Högtryckspumpens oljenivå vid tvättstationen 2 för låg",
    KARCHER_ERROR_MESSAGE_38:"Elektroniken på tvättstationen 2 defekt",
    KARCHER_ERROR_MESSAGE_39:"Tvättstation 2 för motorströmbrytare för högtryckspump har löst ut",
    KARCHER_ERROR_MESSAGE_40:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 2",
    KARCHER_ERROR_MESSAGE_41:"Fel vid myntacceptorn vid tvättstationen 2",
    KARCHER_ERROR_MESSAGE_42:"Fel vid myntacceptorn vid tvättstationen 2",
    KARCHER_ERROR_MESSAGE_50:"Ingen anslutning till pumpelektronik på tvättstationen 3",
    KARCHER_ERROR_MESSAGE_51:"Elektroniska uttag vid tvättstation 3 överbelastad",
    KARCHER_ERROR_MESSAGE_52:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 3 för hög",
    KARCHER_ERROR_MESSAGE_53:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 3 för låg",
    KARCHER_ERROR_MESSAGE_54:"Kontakt med högtryckspumpen vid tvättstationen 3 fastnat",
    KARCHER_ERROR_MESSAGE_55:"Semiventil på tvättstationen 3 defekt",
    KARCHER_ERROR_MESSAGE_56:"skyddskontakt för tvättstation för högtryckspump 3",
    KARCHER_ERROR_MESSAGE_57:"Oljenivån för högtryckspumpen vid tvättstationen 3 för låg",
    KARCHER_ERROR_MESSAGE_58:"Elektroniken på tvättstationen 3 defekt",
    KARCHER_ERROR_MESSAGE_59:"Tvättstation 3 för motorströmbrytare för högtryckspump har utlösts",
    KARCHER_ERROR_MESSAGE_60:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 3",
    KARCHER_ERROR_MESSAGE_61:"Fel vid myntacceptorn vid tvättstationen 3",
    KARCHER_ERROR_MESSAGE_62:"Fel vid myntacceptorn vid tvättstationen 3",
    KARCHER_ERROR_MESSAGE_70:"Ingen anslutning till pumpelektronik på tvättstationen 4",
    KARCHER_ERROR_MESSAGE_71:"Elektroniska utgångar vid tvättstation 4 överbelastad",
    KARCHER_ERROR_MESSAGE_72:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 4 för hög",
    KARCHER_ERROR_MESSAGE_73:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 4 för låg",
    KARCHER_ERROR_MESSAGE_74:"Kontakt med högtryckspump vid tvättstationen 4 fastnat",
    KARCHER_ERROR_MESSAGE_75:"semiventil på tvättstationen 4 defekt",
    KARCHER_ERROR_MESSAGE_76:"skyddskontakt för tvättstation för högtryckspump 4",
    KARCHER_ERROR_MESSAGE_77:"Högtryckspumpens oljenivå vid tvättstationen 4 för låg",
    KARCHER_ERROR_MESSAGE_78:"Elektroniken på tvättstationen 4 defekt",
    KARCHER_ERROR_MESSAGE_79:"Tvättstation 4 för högtryckspumpar för motorströmbrytare har utlösts",
    KARCHER_ERROR_MESSAGE_80:"Ingen anslutning till pumpelektronik på tvättstationen 4",
    KARCHER_ERROR_MESSAGE_81:"Fel vid myntacceptorn vid tvättstationen 4",
    KARCHER_ERROR_MESSAGE_82:"Fel vid myntacceptorn vid tvättstationen 4",
    KARCHER_ERROR_MESSAGE_90:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 5",
    KARCHER_ERROR_MESSAGE_91:"Elektroniska utgångar vid tvättstation 5 överbelastad",
    KARCHER_ERROR_MESSAGE_92:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 5 för hög",
    KARCHER_ERROR_MESSAGE_93:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 5 för låg",
    KARCHER_ERROR_MESSAGE_94:"Kontakt med högtryckspumpen vid tvättstationen 5 fastnat",
    KARCHER_ERROR_MESSAGE_95:"Semiventil på tvättstationen 5 defekt",
    KARCHER_ERROR_MESSAGE_96:"skyddskontakt för tvättstationen för högtryckspump 5",
    KARCHER_ERROR_MESSAGE_97:"Högtryckspumpens oljenivå vid tvättstationen 5 för låg",
    KARCHER_ERROR_MESSAGE_98:"Elektroniken vid tvättstation 5 defekt",
    KARCHER_ERROR_MESSAGE_99:"Tvättstation 5 för högtryckspumpar för motorströmbrytare har utlösts",
    KARCHER_ERROR_MESSAGE_100:"Ingen anslutning till pumpelektronik på tvättstationen 5",
    KARCHER_ERROR_MESSAGE_101:"Fel vid myntacceptorn vid tvättstationen 5",
    KARCHER_ERROR_MESSAGE_102:"Fel vid myntacceptorn vid tvättstationen 5",
    KARCHER_ERROR_MESSAGE_110:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 6",
    KARCHER_ERROR_MESSAGE_111:"Elektroniska utgångar vid tvättstation 6 överbelastad",
    KARCHER_ERROR_MESSAGE_112:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 6 för hög",
    KARCHER_ERROR_MESSAGE_113:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 6 för låg",
    KARCHER_ERROR_MESSAGE_114:"Kontakt med högtryckspumpen vid tvättstationen 6 fastnat",
    KARCHER_ERROR_MESSAGE_115:"Semiventil på tvättstationen 6 defekt",
    KARCHER_ERROR_MESSAGE_116:"skyddskontakt för tvättstationen för högtryckspump 6",
    KARCHER_ERROR_MESSAGE_117:"Högtryckspumpens oljenivå vid tvättstationen 6 för låg",
    KARCHER_ERROR_MESSAGE_118:"Elektroniken vid tvättstation 6 defekt",
    KARCHER_ERROR_MESSAGE_119:"Tvättstation 6 för högtryckspumpar för motorströmbrytare har utlösts",
    KARCHER_ERROR_MESSAGE_120:"Ingen anslutning till pumpelektronik på tvättstationen 6",
    KARCHER_ERROR_MESSAGE_121:"Fel vid myntacceptorn vid tvättstationen 6",
    KARCHER_ERROR_MESSAGE_122:"Fel vid myntacceptorn vid tvättstationen 6",
    KARCHER_ERROR_MESSAGE_130:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 7",
    KARCHER_ERROR_MESSAGE_131:"Elektroniska utgångar vid tvättstation 7 överbelastad",
    KARCHER_ERROR_MESSAGE_132:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 7 för hög",
    KARCHER_ERROR_MESSAGE_133:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 7 för låg",
    KARCHER_ERROR_MESSAGE_134:"Kontakt med högtryckspumpen vid tvättstationen 7 fastnat",
    KARCHER_ERROR_MESSAGE_135:"Semiventil på tvättstationen 7 defekt",
    KARCHER_ERROR_MESSAGE_136:"skyddskontakt för tvättstationen för högtryckspump 7",
    KARCHER_ERROR_MESSAGE_137:"Högtryckspumpens oljenivå vid tvättstationen 7 för låg",
    KARCHER_ERROR_MESSAGE_138:"Elektroniken vid tvättstation 7 defekt",
    KARCHER_ERROR_MESSAGE_139:"Tvättstation 7 för högtryckspumpar för motorströmbrytare har utlösts",
    KARCHER_ERROR_MESSAGE_140:"Ingen anslutning till pumpelektronik på tvättstationen 7",
    KARCHER_ERROR_MESSAGE_141:"Fel vid myntacceptorn vid tvättstationen 7",
    KARCHER_ERROR_MESSAGE_142:"Fel vid myntacceptorn vid tvättstationen 7",
    KARCHER_ERROR_MESSAGE_150:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 8",
    KARCHER_ERROR_MESSAGE_151:"Elektroniska ugångar vid tvättstation 8 överbelastad",
    KARCHER_ERROR_MESSAGE_152:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 8 för hög",
    KARCHER_ERROR_MESSAGE_153:"Aktuell upphämtning av högtryckspumpen vid tvättstationen 8 för låg",
    KARCHER_ERROR_MESSAGE_154:"Kontakt med högtryckspumpen vid tvättstationen 8 fastnat",
    KARCHER_ERROR_MESSAGE_155:"Semiventil på tvättstationen 8 defekt",
    KARCHER_ERROR_MESSAGE_156:"skyddskontakt för tvättstationen för högtryckspump 8",
    KARCHER_ERROR_MESSAGE_157:"Oljenivån för högtryckspumpen vid tvättstationen 8 för låg",
    KARCHER_ERROR_MESSAGE_158:"Elektroniken på tvättstationen 8 defekt",
    KARCHER_ERROR_MESSAGE_159:"Tvättstationen 8 för motorströmbrytare för högtryckspump har utlösts",
    KARCHER_ERROR_MESSAGE_160:"Ingen anslutning till fjärrkontrollelektronik på tvättstationen 8",
    KARCHER_ERROR_MESSAGE_161:"Fel vid myntacceptor vid tvättstationen 8",
    KARCHER_ERROR_MESSAGE_162:"Fel vid myntacceptor vid tvättstationen 8",
    KARCHER_ERROR_MESSAGE_170:"ingen anslutning till elektroniken A2",
    KARCHER_ERROR_MESSAGE_171:"Utgångarna på elektroniken A2 överbelastad",
    KARCHER_ERROR_MESSAGE_172:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_173:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_174:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_175:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_176:"Tvättmedelsbehållare är tom",
    KARCHER_ERROR_MESSAGE_177:"Den aktuella uppsamlingen av pumpens undervattentvätt för hög",
    KARCHER_ERROR_MESSAGE_178:"Inget tryck efter påslagning av underspolningen",
    KARCHER_ERROR_MESSAGE_190:"ingen anslutning till elektroniken A3",
    KARCHER_ERROR_MESSAGE_191:"Elektronikens A3-utgångar överbelastade",
    KARCHER_ERROR_MESSAGE_200:"Ingen koppling mellan styrning och elektronik från WSO",
    KARCHER_ERROR_MESSAGE_201:"Utgångar WSO överbelastade  ",
    KARCHER_ERROR_MESSAGE_202:"Hårdhetssensorn visar hårt vatten efter regenerering",
    KARCHER_ERROR_MESSAGE_204:"Elektronikfel",
    KARCHER_ERROR_MESSAGE_210:"Nivåsensor BUFFERTTANK TOM aktiverad",
    KARCHER_ERROR_MESSAGE_211:"Nivåsensor BUFFERTTANK TOM och BUFFERTTANK FULL-påverkade samtidigt",
    KARCHER_ERROR_MESSAGE_212:"Nivåsensor RO PUMP ON och BUFFER CONTAINER FULL-påverkade samtidigt",
    KARCHER_ERROR_MESSAGE_213:"ingen vattentryck",
    KARCHER_ERROR_MESSAGE_214:"Vattenmatningen  rapporterar fel",
    KARCHER_ERROR_MESSAGE_220:"för lite vatten ",
    KARCHER_ERROR_MESSAGE_221:"Avgasstemperaturen är för hög",
    KARCHER_ERROR_MESSAGE_222:"Aktuell uppsamling av cirkulationspumpen för varmt vatten för högt",
    KARCHER_ERROR_MESSAGE_223:"fel på brännare ",
    KARCHER_ERROR_MESSAGE_224:"Säkerhetstermostat oljebrännare är påverkad",
    KARCHER_ERROR_MESSAGE_225:"Fördröjning brännare aktiv",
    KARCHER_ERROR_MESSAGE_226:"Flödesindikator öppnade ej inom 5 sek efter att cirkulationspumpen för varmvattnet stängde av",
    KARCHER_ERROR_MESSAGE_227:"Flödesindikator stängde ej inom 3 sek efter att cirkulationspumpen för varmvattnet stängdes av",
    KARCHER_ERROR_MESSAGE_228:"Utgång för Varmvatten kyls av för sakta efter att brännaren stängts av",
    KARCHER_ERROR_MESSAGE_229:"Felkod tempgivare varmvatten",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Förnyelse av basbyten avslutad",
    KARCHER_INFO_MESSAGE_3:"Basväxlaren tappade 75%",
    KARCHER_INFO_MESSAGE_4:"enheten inte tillgänglig på grund av tekniskt fel",
    KARCHER_INFO_MESSAGE_5:"Enheten inte tillgänglig på grund av driftsproblem",
    KARCHER_INFO_MESSAGE_6:"enhet på",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bås 1 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_12:"Bås 2 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_13:"Bås 3 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_14:"Bås 4 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_15:"Bås 5 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_16:"Bås 6 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_17:"Bås 7 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_18:"Bås 8 är inte tillgänglig",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella-program för varmt vatten",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella-program HD-pump 1 krävs",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella-program HD-pump 2 krävs",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella-program HD-pump 3 krävs",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella-program HD-pump 4 krävs",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella-program HD-pump 5 krävs",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella-program HD-pump 6 krävs",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella-program HD-pump 7 krävs",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella-program HD-pump 8 krävs",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella-program färdig ",
    KARCHER_INFO_MESSAGE_101:"Högtryckspump 1 dags för service ",
    KARCHER_INFO_MESSAGE_102:"Högtryckspump 2 dags för service ",
    KARCHER_INFO_MESSAGE_103:"Högtryckspump 3 dags för service ",
    KARCHER_INFO_MESSAGE_104:"Högtryckspump 4 dags för service ",
    KARCHER_INFO_MESSAGE_105:"Högtryckspump 5 dags för service ",
    KARCHER_INFO_MESSAGE_106:"Högtryckspump 6 dags för service ",
    KARCHER_INFO_MESSAGE_107:"Högtryckspump 7 dags för service ",
    KARCHER_INFO_MESSAGE_108:"Högtryckspump 8 dags för service ",
    KARCHER_INFO_MESSAGE_109:"brännare dags att dags för service ",
    KARCHER_INFO_MESSAGE_110:"brännarfläkt dags för service ",
    KARCHER_INFO_MESSAGE_111:"varmvattenpump dags för service ",
    KARCHER_INFO_MESSAGE_112:"frostskyddspump dags för service   ",
    KARCHER_INFO_MESSAGE_113:"osmospump dags för service ",
    KARCHER_INFO_MESSAGE_114:"golvvärmare dags för service ",
    KARCHER_INFO_MESSAGE_115:"rörvärmare dags för service  ",
    KARCHER_INFO_MESSAGE_116:"Pump för mikroemulsion / fälgstädning dags för service ",
    KARCHER_INFO_MESSAGE_117:"Rengöringspump för undervagn dags för service ",
    KARCHER_INFO_MESSAGE_118:"trycksystempump dags för service ",
    KARCHER_INFO_MESSAGE_119:"Dammsugare 1 dags för service ",
    KARCHER_INFO_MESSAGE_120:"Dammsugare 2 dags för service ",
    KARCHER_INFO_MESSAGE_121:"Dammsugare 3 dags för service ",
    KARCHER_INFO_MESSAGE_122:"Dammsugare 4 dags för service ",
    KARCHER_INFO_MESSAGE_123:"Dammsugare 5 dags för service ",
    KARCHER_INFO_MESSAGE_124:"Dammsugare 6 dags för service ",
    KARCHER_INFO_MESSAGE_125:"Dammsugare 7 dags för service ",
    KARCHER_INFO_MESSAGE_126:"Dammsugare 8 dags för service ",
    KARCHER_INFO_MESSAGE_127:"Dammsugare 9 dags för service ",
    KARCHER_INFO_MESSAGE_128:"Dammsugare 10 dags för service ",
    KARCHER_INFO_MESSAGE_129:"Dammsugare 11 dags för service ",
    KARCHER_INFO_MESSAGE_130:"Dammsugare 12 dags för service ",
    KARCHER_INFO_MESSAGE_131:"Rengöringsmedelspump dags för service ",
    KARCHER_INFO_MESSAGE_132:"Mikroemulsionspump dags för service ",
    KARCHER_INFO_MESSAGE_133:"Intensiv skumpump dags för service ",
    KARCHER_INFO_MESSAGE_142:"Dammsugare 1-turbin dags för service ",
    KARCHER_INFO_MESSAGE_143:"Dammsugare 1-filter dags för service ",
    KARCHER_INFO_MESSAGE_144:"Dammsugare 2-turbin dags för service ",
    KARCHER_INFO_MESSAGE_145:"Dammsugare 2-filter dags för service ",
    KARCHER_INFO_MESSAGE_146:"Dammsugare 3-turbin dags för service ",
    KARCHER_INFO_MESSAGE_147:"Dammsugare 3-filter dags för service ",
    KARCHER_INFO_MESSAGE_148:"Dammsugare 4-turbin dags för service ",
    KARCHER_INFO_MESSAGE_149:"Dammsugare 4-filter dags för service ",
    KARCHER_INFO_MESSAGE_150:"Dammsugare 5-turbin dags för service ",
    KARCHER_INFO_MESSAGE_151:"Dammsugare 5-filter dags för service ",
    KARCHER_INFO_MESSAGE_152:"Dammsugare 6-turbin dags för service ",
    KARCHER_INFO_MESSAGE_153:"Dammsugare 6-filter dags för service ",
    KARCHER_INFO_MESSAGE_154:"Dammsugare 7-turbin dags för service ",
    KARCHER_INFO_MESSAGE_155:"Dammsugare 7-filter dags för service ",
    KARCHER_INFO_MESSAGE_156:"Dammsugare 8-turbin dags för service ",
    KARCHER_INFO_MESSAGE_157:"Dammsugare 8-filter dags för service ",
    KARCHER_INFO_MESSAGE_158:"Dammsugare 9-turbin dags för service ",
    KARCHER_INFO_MESSAGE_159:"Dammsugare 9-filter dags för service ",
    KARCHER_INFO_MESSAGE_160:"Dammsugare 10-turbin dags för service ",
    KARCHER_INFO_MESSAGE_161:"Dammsugare 10-filter dags för service ",
    KARCHER_INFO_MESSAGE_162:"Dammsugare 11-turbin dags för service ",
    KARCHER_INFO_MESSAGE_163:"Dammsugare 11-filter dags för service ",
    KARCHER_INFO_MESSAGE_164:"Dammsugare 12-turbin dags för service ",
    KARCHER_INFO_MESSAGE_165:"Dammsugare 12-filter dags för service ",
    SITE_DETAILS_SUCCESSFULLY_UPDATED: "Site details successfully updated",
    COMPANY: "Company",
    FACILITY_HAS_CHANGER: "Have changer?",
    DISABLE_OFFLINE_ALARM: "Disable R2W alarms",
    ASIDE_WORKING_SCHEDULES: "App Site details",
    TERMS_OF_SERVICE_R2W_TITLE: "Ready2Wash terms of service",
    TERMS_OF_SERVICE_R2W: "Ready2Wash terms of service",
    DATA_PROCESSING_TITLE: "Data Processed",
    PRIVACY_POLICY_TITLE: "Privacy Policy",
    READY_TO_PAY_TERMS_OF_SERVICE: "Ready2Pay Terms of service",
    TERMS_AND_SERVICES: "Terms and services",
    INFO_TITLE: "Info",
    HOURLY: "Varje timme",
    DAILY: "Dagligen",
    WEEKLY: "Veckovis",
    MONTHLY: "Månadsvis",
    YEARLY: "Årligen",
    DELETE_ITEM_SUCCESS:"Du har framgångsrikt raderat objektet",
    STATE: "Status",
    AVAILABILITY_STATUS_1: "Enhet öppen",
    AVAILABILITY_STATUS_2: "Enhet stängd (semester)",
    AVAILABILITY_STATUS_3: "Enhet stängd (öppettider)",
    AVAILABILITY_STATUS_4: "Enhet stängd (fel)",
    AVAILABILITY_STATUS_5: "Enhet stängd (annat)",
    AVAILABILITY_VACUUMS_STATUS_1: "Dammsugare ej installerade",
    AVAILABILITY_VACUUMS_STATUS_2: "Dammsugare öppna",
    AVAILABILITY_VACUUMS_STATUS_3: "Dammsugare stängda (semester)",
    AVAILABILITY_VACUUMS_STATUS_4: "Dammsugare stängda (öppettider)",
    AVAILABILITY_VACUUMS_STATUS_5: "Dammsugare stängda (fel)",
    AVAILABILITY_VACUUMS_STATUS_6: "Dammsugare stängda (annat)",
    ECOM_AMOUNT: "Total Ecom för alla platser",
    CAPTURED: "Registrerad",
    G0:"{{brand === 'r2w' ? 'Bay 0' : 'Bay 1'}}",
    G1:"{{brand === 'r2w' ? 'Bay 1' : 'Bay 2'}}",
    G2:"{{brand === 'r2w' ? 'Bay 2' : 'Bay 3'}}",
    G3:"{{brand === 'r2w' ? 'Bay 3' : 'Bay 4'}}",
    G4:"{{brand === 'r2w' ? 'Bay 4' : 'Bay 5'}}",
    G5:"{{brand === 'r2w' ? 'Bay 5' : 'Bay 6'}}",
    G6:"{{brand === 'r2w' ? 'Bay 6' : 'Bay 7'}}",
    G7:"{{brand === 'r2w' ? 'Bay 7' : 'Bay 8'}}",
    G8:"{{brand === 'r2w' ? 'Bay 8' : 'Bay 9'}}",
    G9:"{{brand === 'r2w' ? 'Bay 9' : 'Bay 10'}}",
    G10:"{{brand === 'r2w' ? 'Bay 10' : 'Bay 11'}}",
    U0:"{{brand === 'r2w' ? 'Vacuum 0' : 'Vacuum 1'}}",
    U1:"{{brand === 'r2w' ? 'Vacuum 1' : 'Vacuum 2'}}",
    U2:"{{brand === 'r2w' ? 'Vacuum 2' : 'Vacuum 3'}}",
    U3:"{{brand === 'r2w' ? 'Vacuum 3' : 'Vacuum 4'}}",
    U4:"{{brand === 'r2w' ? 'Vacuum 4' : 'Vacuum 5'}}",
    U5:"{{brand === 'r2w' ? 'Vacuum 5' : 'Vacuum 6'}}",
    U6:"{{brand === 'r2w' ? 'Vacuum 6' : 'Vacuum 7'}}",
    U7:"{{brand === 'r2w' ? 'Vacuum 7' : 'Vacuum 8'}}",
    DELETE_COMPANY_HISTORY_INFO:"Denna åtgärd kommer att ta bort all rapportdata från ditt företag. Denna åtgärd kan inte ångras.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Är du säker på att du vill permanent radera all rapportdata?",
    VALUE_DATE: "Valutadag",
    KARCHER_EVENT_NAME_1: "Huvudvärmeväxlare regenererad",
    KARCHER_EVENT_NAME_2: "Regenerering av huvudvärmeväxlare slutförd",
    KARCHER_EVENT_NAME_3: "Material / serienummer",
    KARCHER_EVENT_NAME_4: "Systemet har desinficerats",
    KARCHER_EVENT_NAME_5: "HP-pump 1 desinficerad",
    KARCHER_EVENT_NAME_6: "HP-pump 2 desinficerad",
    KARCHER_EVENT_NAME_7: "HP-pump 3 desinficerad",
    KARCHER_EVENT_NAME_8: "HP-pump 4 desinficerad",
    KARCHER_EVENT_NAME_9: "HP-pump 5 desinficerad",
    KARCHER_EVENT_NAME_10: "Tvättstation 1 låst",
    KARCHER_EVENT_NAME_11: "Tvättstation 2 låst",
    KARCHER_EVENT_NAME_12: "Tvättstation 3 låst",
    KARCHER_EVENT_NAME_13: "Tvättstation 4 låst",
    KARCHER_EVENT_NAME_14: "Tvättstation 5 låst",
    KARCHER_EVENT_NAME_15: "Tvättstation 6 låst",
    KARCHER_EVENT_NAME_16: "Tvättstation 7 låst",
    KARCHER_EVENT_NAME_17: "Tvättstation 8 låst",
    KARCHER_EVENT_NAME_18: "Uppdatering startad",
    KARCHER_EVENT_NAME_19: "Uppdatering slutförd",
    KARCHER_EVENT_NAME_20: "Start av WS Reg",
    KARCHER_EVENT_NAME_21: "Avslutning av WS Reg",
    KARCHER_EVENT_NAME_22: "WS-sensor 75%",
    KARCHER_EVENT_NAME_23: "Tekniskt fel",
    KARCHER_EVENT_NAME_24: "Driftfel",
    KARCHER_EVENT_NAME_25: "Enhet aktiverad",
    KARCHER_EVENT_NAME_26: "Enhet avstängd",
    KARCHER_EVENT_NAME_27: "Box 1 stängd",
    KARCHER_EVENT_NAME_28: "Box 2 stängd",
    KARCHER_EVENT_NAME_29: "Box 3 stängd",
    KARCHER_EVENT_NAME_30: "Box 4 stängd",
    KARCHER_EVENT_NAME_31: "Box 5 stängd",
    KARCHER_EVENT_NAME_32: "Box 6 stängd",
    KARCHER_EVENT_NAME_33: "Box 7 stängd",
    KARCHER_EVENT_NAME_34: "Box 8 stängd",
    KARCHER_EVENT_NAME_35: "HP-pumpstation 1",
    KARCHER_EVENT_NAME_36: "HP-pumpstation 2",
    KARCHER_EVENT_NAME_37: "HP-pumpstation 3",
    KARCHER_EVENT_NAME_38: "HP-pumpstation 4",
    KARCHER_EVENT_NAME_39: "HP-pumpstation 5",
    KARCHER_EVENT_NAME_40: "HP-pumpstation 6",
    KARCHER_EVENT_NAME_41: "HP-pumpstation 7",
    KARCHER_EVENT_NAME_42: "HP-pumpstation 8",
    KARCHER_EVENT_NAME_43: "Brännare",
    KARCHER_EVENT_NAME_44: "Brännarfläkt",
    KARCHER_EVENT_NAME_45: "Varmvattenpump",
    KARCHER_EVENT_NAME_46: "Frostskyddspump",
    KARCHER_EVENT_NAME_47: "Osmospump",
    KARCHER_EVENT_NAME_48: "Golvvärme",
    KARCHER_EVENT_NAME_49: "Slangvärme",
    KARCHER_EVENT_NAME_50: "Mikro-/hjultvätt",
    KARCHER_EVENT_NAME_51: "Chassitvättpump",
    KARCHER_EVENT_NAME_52: "Booster-skumpump",
    KARCHER_EVENT_NAME_53: "Dammsugare 1",
    KARCHER_EVENT_NAME_54: "Dammsugare 2",
    KARCHER_EVENT_NAME_55: "Dammsugare 3",
    KARCHER_EVENT_NAME_56: "Dammsugare 4",
    KARCHER_EVENT_NAME_57: "Dammsugare 5",
    KARCHER_EVENT_NAME_58: "Dammsugare 6",
    KARCHER_EVENT_NAME_59: "Dammsugare 7",
    KARCHER_EVENT_NAME_60: "Dammsugare 8",
    KARCHER_EVENT_NAME_61: "Dammsugare 9",
    KARCHER_EVENT_NAME_62: "Dammsugare 10",
    KARCHER_EVENT_NAME_63: "Dammsugare 11",
    KARCHER_EVENT_NAME_64: "Dammsugare 12",
    KARCHER_EVENT_NAME_65: "Hjultvättpump",
    KARCHER_EVENT_NAME_66: "Mikropump",
    KARCHER_EVENT_NAME_67: "Intensivpump",
    KARCHER_EVENT_NAME_68: "Dammsugarturbin 1",
    KARCHER_EVENT_NAME_69: "Dammsugarfilter 1",
    KARCHER_EVENT_NAME_70: "Dammsugarturbin 2",
    KARCHER_EVENT_NAME_71: "Dammsugarfilter 2",
    KARCHER_EVENT_NAME_72: "Dammsugarturbin 3",
    KARCHER_EVENT_NAME_73: "Dammsugarfilter 3",
    KARCHER_EVENT_NAME_74: "Dammsugarturbin 4",
    KARCHER_EVENT_NAME_75: "Dammsugarfilter 4",
    KARCHER_EVENT_NAME_76: "Dammsugarturbin 5",
    KARCHER_EVENT_NAME_77: "Dammsugarfilter 5",
    KARCHER_EVENT_NAME_78: "Dammsugarturbin 6",
    KARCHER_EVENT_NAME_79: "Dammsugarfilter 6",
    KARCHER_EVENT_NAME_80: "Dammsugarturbin 7",
    KARCHER_EVENT_NAME_81: "Dammsugarfilter 7",
    KARCHER_EVENT_NAME_82: "Dammsugarturbin 8",
    KARCHER_EVENT_NAME_83: "Dammsugarfilter 8",
    KARCHER_EVENT_NAME_84: "Dammsugarturbin 9",
    KARCHER_EVENT_NAME_85: "Dammsugarfilter 9",
    KARCHER_EVENT_NAME_86: "Dammsugarturbin 10",
    KARCHER_EVENT_NAME_87: "Dammsugarfilter 10",
    KARCHER_EVENT_NAME_88: "Dammsugarturbin 11",
    KARCHER_EVENT_NAME_89: "Dammsugarfilter 11",
    KARCHER_EVENT_NAME_90: "Dammsugarturbin 12",
    KARCHER_EVENT_NAME_91: "Dammsugarfilter 12",
    INSERT_TOKEN: "Ange token och starta tjänsten",
    OPEN_SESSION: "Sessionen har öppnats framgångsrikt",
    IN_PROGRESS: "Pågår ...",
    TOKEN_INSERTED: "Token har lagts till framgångsrikt",
    EXPIRED_SESSION: "Sessionen har löpt ut",
    TWO_DIGIT_INTEGER_VALIDATION: "Använd ett heltal med högst två siffror",
    KARCHER_OPERATION_COUNTER_1: "Tvättstation 1 HP-pump",
    KARCHER_OPERATION_COUNTER_2: "Tvättstation 1 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_3: "Tvättstation 1 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_4: "Tvättstation 1 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_5: "Tvättstation 1 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_6: "Tvättstation 2 HP-pump",
    KARCHER_OPERATION_COUNTER_7: "Tvättstation 2 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_8: "Tvättstation 2 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_9: "Tvättstation 2 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_10: "Tvättstation 2 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_11: "Tvättstation 3 HP-pump",
    KARCHER_OPERATION_COUNTER_12: "Tvättstation 3 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_13: "Tvättstation 3 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_14: "Tvättstation 3 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_15: "Tvättstation 3 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_16: "Tvättstation 4 HP-pump",
    KARCHER_OPERATION_COUNTER_17: "Tvättstation 4 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_18: "Tvättstation 4 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_19: "Tvättstation 4 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_20: "Tvättstation 4 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_21: "Tvättstation 5 HP-pump",
    KARCHER_OPERATION_COUNTER_22: "Tvättstation 5 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_23: "Tvättstation 5 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_24: "Tvättstation 5 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_25: "Tvättstation 5 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_26: "Tvättstation 6 HP-pump",
    KARCHER_OPERATION_COUNTER_27: "Tvättstation 6 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_28: "Tvättstation 6 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_29: "Tvättstation 6 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_30: "Tvättstation 6 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_31: "Tvättstation 7 HP-pump",
    KARCHER_OPERATION_COUNTER_32: "Tvättstation 7 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_33: "Tvättstation 7 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_34: "Tvättstation 7 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_35: "Tvättstation 7 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_36: "Tvättstation 8 HP-pump",
    KARCHER_OPERATION_COUNTER_37: "Tvättstation 8 kemisk pump 1",
    KARCHER_OPERATION_COUNTER_38: "Tvättstation 8 kemisk pump 2",
    KARCHER_OPERATION_COUNTER_39: "Tvättstation 8 kemisk pump 3",
    KARCHER_OPERATION_COUNTER_40: "Tvättstation 8 kemisk pump 4",
    KARCHER_OPERATION_COUNTER_41: "Osmospump",
    KARCHER_OPERATION_COUNTER_42: "Varmvattenberedare",
    KARCHER_OPERATION_COUNTER_43: "Frostskyddspump",
    KARCHER_OPERATION_COUNTER_44: "WSO-filterpatroner",
    KARCHER_OPERATION_COUNTER_45: "Uppvärmningspump för tvättstation",
    KARCHER_OPERATION_COUNTER_46: "Varmvattenpump",
    KARCHER_OPERATION_COUNTER_47: "Skumslangvärmare",
    KARCHER_OPERATION_COUNTER_48: "Hjulpumpstvätt",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulsionspump",
    KARCHER_OPERATION_COUNTER_50: "Intensiv skumpump",
    KARCHER_OPERATION_COUNTER_51: "Dammsugare 1 turbin 1",
    KARCHER_OPERATION_COUNTER_52: "Dammsugare 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Dammsugare 1 turbin 2",
    KARCHER_OPERATION_COUNTER_54: "Dammsugare 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Dammsugare 2 turbin 1",
    KARCHER_OPERATION_COUNTER_56: "Dammsugare 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Dammsugare 2 turbin 2",
    KARCHER_OPERATION_COUNTER_58: "Dammsugare 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Dammsugare 3 turbin 1",
    KARCHER_OPERATION_COUNTER_60: "Dammsugare 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Dammsugare 3 turbin 2",
    KARCHER_OPERATION_COUNTER_62: "Dammsugare 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Dammsugare 4 turbin 1",
    KARCHER_OPERATION_COUNTER_64: "Dammsugare 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Dammsugare 4 turbin 2",
    KARCHER_OPERATION_COUNTER_66: "Dammsugare 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Dammsugare 5 turbin 1",
    KARCHER_OPERATION_COUNTER_68: "Dammsugare 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Dammsugare 5 turbin 2",
    KARCHER_OPERATION_COUNTER_70: "Dammsugare 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Dammsugare 6 turbin 1",
    KARCHER_OPERATION_COUNTER_72: "Dammsugare 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Dammsugare 6 turbin 2",
    KARCHER_OPERATION_COUNTER_74: "Dammsugare 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Töm kondensvattnet från kompressorn",
    KARCHER_OPERATION_COUNTER_76: "Kontrollera frostskyddssystemet",
    KARCHER_OPERATION_COUNTER_77: "Brännarfläkt",
    KARCHER_OPERATION_COUNTER_78: "Förstärkt skumpump",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Datalist är större än 10000 objekt",
    KARCHER_POINT_NAME_1: "Helgdag",
    KARCHER_POINT_NAME_2: "Måndag",
    KARCHER_POINT_NAME_3: "Tisdag",
    KARCHER_POINT_NAME_4: "Onsdag",
    KARCHER_POINT_NAME_5: "Torsdag",
    KARCHER_POINT_NAME_6: "Fredag",
    KARCHER_POINT_NAME_7: "Lördag",
    KARCHER_POINT_NAME_8: "Söndag",
    KARCHER_POINT_NAME_9: "Dammsugare Helgdag",
    KARCHER_POINT_NAME_10: "Dammsugare Måndag",
    KARCHER_POINT_NAME_11: "Dammsugare Tisdag",
    KARCHER_POINT_NAME_12: "Dammsugare Onsdag",
    KARCHER_POINT_NAME_13: "Dammsugare Torsdag",
    KARCHER_POINT_NAME_14: "Dammsugare Fredag",
    KARCHER_POINT_NAME_15: "Dammsugare Lördag",
    KARCHER_POINT_NAME_16: "Dammsugare Söndag",
    KARCHER_POINT_NAME_17: "Belysning Helgdag",
    KARCHER_POINT_NAME_18: "Belysning Måndag",
    KARCHER_POINT_NAME_19: "Belysning Tisdag",
    KARCHER_POINT_NAME_20: "Belysning Onsdag",
    KARCHER_POINT_NAME_21: "Belysning Torsdag",
    KARCHER_POINT_NAME_22: "Belysning Fredag",
    KARCHER_POINT_NAME_23: "Belysning Lördag",
    KARCHER_POINT_NAME_24: "Belysning Söndag",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR-kod",
    ACCEPT_TERMS_AND_CONDITIONS: "Godkänn användarvillkoren",
    CREATE_AND_PRINT_VOUCHERS: "Skapa och skriv ut kuponger",
    CODE_PREFIX_QUESTION: "Kodprefix är inte angivet",
    CODE_PREFIX_QUESTION_TEXT: "Vill du fortsätta utan kodprefix?",
    ISSUED_DATE: "Utgivningsdatum",
    VOUCHER_VALIDITY_DAYS: "Kuponggiltighe t (dagar)",
    VALIDATION_ONLY_NUMBERS: "Endast siffror är tillåtna",
    REPRINT_VOUCHERS: "Skriv ut kopia av kuponger",
    EXPIRY_DATE: "Giltig till"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("srTranslations", {
    MESSAGE:"Poruka",
    ERROR_TITLE:"Greška",
    ERROR_MESSAGE:"Desila se greška tokom izvršavanja operacije.",
    ERROR_LOGIN:"Greška prilikom prijavljivanja. Email adresa je nepoznata ili se lozika ne podudara. Molimo Vaš pokušajte ponovo.",
    ERROR_LOGIN_ROLE:"Uloga za trenutnu aplikaciju nije validna",
    OK:"OK",
    CANCEL:"Otkaži",
    YES:"Da",
    NO:"Ne",
    FROM:"Od",
    TO:"Do",
    DELETE:"Obriši",
    SIGN_OUT:"Odjavi se",
    NAME:"Ime",
    DATE:"Datum",
    PIECES:"komada",
    HOURS:"Sati",
    DAYS:"Dani",
    MONTH:"Mesec",
    MONTHS:"Meseci",
    YEAR:"Godina",
    BOX:"Box",
    SEARCH:"Pretraži",
    ALL_USERS:"Svi korisnici",
    ARE_YOU_SURE:"Sigurni ste?",
    BACK:"Nazad",
    AMOUNT:"Opis",
    DESCRIPTION:"Opis",
    FORGOT_PASSWORD_ERROR_MSG:"Da li ste sigurni",
    REQUIRED_FIELD:"Polje je obavezno",
    LOGOUT_TITLE:"Da li ste sigurni da želite da se odjavite",
    LOGOUT_MSG:"Sve nesačuvane promene će biti obrisane",
    ACTIVATION_ACCOUNT:"Uspešno ste aktivirali nalog, nastavite ka ekranu za prijavu",
    UNKNOWN_ERRROR_NOTIFICATION:"Nastavite",
    CONTINUE:"Desila se nepoznata greška",
    DATA_NOT_AVAILABLE:"Podaci nisu pronađeni",
    SELECT:"Izaberi",
    SELECT_CURRENCY:"Odaberite valutu",
    UPLOAD:"Pošalji",
    PHONE:"Telefon",
    WEBSITE:"Internet stranica",
    WORKING_HOURS:"Radno vreme",
    INSERT:"Unesi",
    TEXT:"Tekst",
    CREATED:"Kreirana",
    VALID_UNTIL:"Traje do",
    SAVE:"Sačuvaj",
    TOKENS:"Žetona",
    DELETE_COMPANY_HISTORY:"Obrisati istoriju kompanije?",
    DELETE_COMPANY_HISTORY_MESSAGE:"Upozorenje: Nakon pritiskanja ovog dugmeta, sve transakcije Vaše autoperionice će biti trajno obrisane! Ovi podaci ne mogu biti vraćeni nakon brisanja.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Da li ste sigurni da želite trajno obrisati sve podatke o transakcijama?",
    HISTORY_SUCCESSFULY_DELETED:"Istorija uspešno obrisana",
    HELP:"Pomoć",
    VALUE:"Vrednost",
    ACTIVATING_ACCOUNT_ERROR:"Desila se greška prilikom aktivacije vašeg R2W naloga.Molimo pokušajte ponovo i ako problem i dalje postoji kontaktirajte support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Dobrodošli u Karcher perionicu",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Dobrodošli na R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Molimo upišite i ponovite vašu lozinku da bi aktivirali vaš R2W nalog. Bićete automatski prijavljeni na sistem nakon uspešne verifikacije lozinke",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Vaše podatke možete menjati kasnije u aplikaciji",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Karcher autoperionica",
    RESET_PASSWORD_WELCOME_MSG:"R2W autoperionica",
    RESET_PASSWORD_WELCOME_MSG_2:"Molimo vas da unesete novu lozinku i potvrdite je kako biste resetovali staru lozinku. Bićete automatski prijavljeni u aplikaciju nakon uspešnog resetovanja",
    RESET_PASSWORD_WELCOME_MSG_3:"Možete kasnije promeniti svoje korisničke podešavanja u aplikaciji",
    ENTER_NEW_PASSWORD:"Unesite novu lozinku",
    REPEAT_NEW_PASSWORD:"Ponovite lozinku",
    PASSWORD_MIN_LENGTH:"Lozinka mora imati barem 8 karaktera",
    PASSWORD_MAX_LENGHT:"Lozinka nesme imati više od 32 karaktera",
    PASSWORD_PATTERN:"Lozinka mora sadržati barem jedno veliko i jedno malo slovo",
    PASSWORD_MATCH:"Lozinke nisu identične",
    ACTIVATE:"Aktiviraj",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Uspešno ste poslali zahtev. Molimo vas da provjerite e-mail za potvrdu",
    VALIDATION_REQUIRED:"Obavezno polje",
    VALIDATION_EMAIL:"Neispravna email adresa",
    VALIDATION_INTEGER_NUMBER:"Vrednost mora biti celobrojan broj",
    VALIDATION_HOURS_VALUE:"Vrednost mora biti između 0-23",
    VALIDATION_MINUTES_VALUE:"Vrednost mora biti između 0-59",
    VALIDATION_NOT_A_DATE:"Uneta vrednost nije datum",
    VALIDATION_FROM:"Datum veći od krajnjeg datuma",
    VALIDATION_TO:"Datum manji od početnog datuma",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Taj podatak već postoji u bazi podataka",
    PASSWORD_VALIDATION_PATTERN_NEW:"Lozinka mora sadržati barem jedno veliko i malo slovo i jedan broj. Prazna polja takođe nisu dozvoljena.",
    VALIDATION_PERCENT_VALUE:"Vrednost mora biti između 1-999",
    NUMBERS_ONLY_100:"Broj do 100",
    NUMBERS_ONLY_1000:"Broj do 1000",
    POSITIVE_NUMBERS_ONLY:"Samo pozitivan broj",
    GRID_PAGER_PAGE:"Stranica",
    GRID_PAGER_ROWS_PER_PAGE:"Redova po stranici",
    GRID_PAGER_PAGE_OF:"od",
    BREAD_CRUMBS_HOME:"Početna",
    BREAD_CRUMBS_DASHBOARD_TECH:"Pregled perionica",
    BREAD_CRUMBS_DETAILS:"Detalji",
    BREAD_CRUMBS_SETTINGS:"Podešavanja",
    BREAD_CRUMBS_WORKING_HOURS:"Radno vreme",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Ukupno novca po danima",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Prosečno novca po satima",
    BREAD_CRUMBS_NEW_USER_GROUP:"Kreiranje korisničke grupe",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Izmena korisničke grupe",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Kreiranje šablona kampanje",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Izmena šablona kampanje",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Kreiranje kampanje",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Izmena kampanje",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Pregled finansija za period",
    LOGIN:"Prijava",
    EMAIL:"E-mail",
    PASSWORD:"Lozinka",
    LANGUAGE:"Jezik",
    FORGOT_PASSWORD:"Zaboravljena lozinka?",
    SUBMIT:"Potvrdi",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Broj tekućih alarma:",
    HEADER_VIEW_ALL_ALARMS:"Svi alarmi...",
    HEADER_MY_ACCOUNT:"Moj nalog",
    HEADER_ACCOUNT_MANAGEMENT:"Upravljanje nalozima",
    ACCOUNT_ALREADY_EXIST:"Email adresa već postoji",
    NEWSLETTER_CONFIRMATION:"Pošaljite e-mail obaveštenje o stanju alarma",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Dnevni pregled finansija",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Pregled perionica",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Perionice",
    ASIDE_MENU_ALARMS:"Alarmi",
    ASIDE_MENU_FACILITIES:"Perionice",
    ASIDE_MENU_REPORTS:"Izveštaji",
    ASIDE_MENU_REPORT:"Izabrani izveštaj",
    ASIDE_MENU_LOYALTY:"Kampanje",
    ASIDE_MENU_USER_GROUPS:"Grupe korisnika",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodični pregled",
    ASIDE_MENU_MANAGING_TOKENS:"Upravljanje tokenima",
    ASIDE_MENU_NEWS:"Vesti",
    DAILY_FINANCES_TOTAL_MONEY:"Ukupno novca",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Ukupno novca za sve perionice",
    DAILY_FINANCES_TOTAL_COINS:"Ukupno korišćenih metalnih žetona",
    DAILY_FINANCES_DOWNLOAD_CSV:"Preuzmi CSV",
    DAILY_FINANCES_ONLINE:"Online",
    DAILY_FINANCES_OFFLINE:"Gotovina",
    DAILY_FINANCES_CHANGER:"Gotovina u menjaču",
    DAILY_FINANCES_COINS:"Žetoni",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Tip izveštaja",
    REPORTS_CHOOSE_FACILITY:"Odabir perionice",
    REPORTS_PERIOD_1:"Period 1 -",
    REPORTS_PERIOD_2:"Period 2 -",
    MONEY_BY_DATE_REPORT:"Ukupni prihod po danu",
    R2W_BY_DATE_REPORT:"Ukupno potrošenih R2W žetona po danu",
    COINS_BY_DATE_REPORT:"Ukupno kovanica po danu",
    AVG_MONEY_BY_HOUR_REPORT:"Prosečan prihod po satima",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Prosečan prihod po danima",
    AVG_MONEY_BY_BOX_REPORT:"Potrošnja po boksu",
    COMPARE_PERIODS_REPORT:"Uporedni prikaz po perionici",
    TOTAL_USERS_BY_GROUP:"Ukupno korisnika R2W aplikacije po danu",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"korisnika",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"poseta/e",
    VISITS_COUNT_REPORT:"Broj korisnika R2W aplikacije po dolascima",
    LOYALTY_PER_DAY_REPORT:"Broj potrošenih lokalnih žetona po danu",
    LOYALTY_PER_PAYMENT_METHOD:"Datih lokalnih žetona po načinu plaćanja",
    VISITS:"Posete",
    VISIT:"Poseta",
    TOTAL_SPENT_MONEY:"Ukupno prihoda",
    MONEY:"Novac",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Ukupno potrošenog novca za period",
    DOWNLOAD_CSV:"Preuzmi CSV",
    TOTAL_SPENT_COINS:"Ukupno potrošenih kovanica",
    TOTAL_USERS:"Ukupno korisnika",
    TOTAL_CREDIT_GIVEN:"Ukupno potrošenih lokalnih virtuelnih žetona",
    EUROKEY_BY_DATE_REPORT:"Ukupna plaćanja euro ključa",
    TOTAL_SPENT_EUROKEY:"Ukupno potrošeno",
    SELECT_TYPE_OF_REPORT:"Morate odabrati vrstu izveštaja :)",
    NUMBER_OF_VISITS_TITLE:"Broj poseta",
    NUMBER_OF_USERS_TITLE:"Broj korisnika",
    PIECES_TITLE:"Komada",
    TOTAL_VISITS:"Ukupno poseta",
    TOKENS_TITLE:"tokeni",
    SEARCH_USERS_NO_RESULTS:"Nema korisnika za zadati kriterijum pretrage",
    SEARCH_USERS:"Pretraga korisnika",
    SEARCH_TELEPHONES:"Pretraga po broju mob. telefona",
    ADD_USER_TO_GROUP:"Dodaj korisnika u grupu",
    REMOVE_USER_FROM_GROUP:"Obriši korisnika iz grupe",
    USER_GROUP_NAME_REQUIRED:"Ime grupe korisnika je obavezno polje.",
    USER_GROUP_NAME:"Ime grupe korisnika",
    USER_GROUPS_OVERVIEW:"Pregled grupa korisnika",
    USER_COUNT:"Broj korisnika",
    NEW_USER_GROUP:"Kreiraj novu grupu korisnika",
    DELETE_USER_GROUP:"Obriši grupu korisnika",
    UPDATE_USER_GROUP:"Izmeni grupu korisnika",
    DELETE_USER_GROUP_ERROR:"Došlo je do greške prilikom brisanja odabrane korisničke grupe. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_USER_GROUP:"Da li ste sigurni da želite obrisati odabranu grupu korisnika?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Akcije kojima je grupa bila dodeljena prestaće da važe za korisnike obrisane grupe.",
    GROUP_NAME_MAX_LENGTH:"Ime grupe mora biti manje od 255 karaktera",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Korisnik je već u ovoj grupi",
    MISSING_USER:"Nepoznat korisnik",
    USER_NOT_ON_LIST:"Korisnik nije u aktivnoj listi. Proverite da li je email ispravan i pokušajte ponovo.",
    UPLOAD_USER_GROUP:"Uvezi grupe iz *.csv-a",
    UKNOWN_USERS:"Lista nepoznatih korisnika",
    CAMPAIGN_TEMPLATE_RULE:"Pravilo kampanje",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Došlo je do greške prilikom brisanja odabranog šablona kampanje. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Da li ste sigurni da želite obrisati odabrani šablon kampanje?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Da li ste sigurni da želite obrisati odabrani šablon kampanje?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Pregled šablona kampanja",
    DELETE_CAMPAIGN_TEMPLATE:"Obriši šablon kampanje",
    UPDATE_CAMPAIGN_TEMPLATE:"Izmeni šablon kampanje",
    CREATE_CAMPAIGN_TEMPLATE:"Kreiraj novi šablon kampanje",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Ime šablona kampanje je obavezno polje.",
    CAMPAIGN_TEMPLATE_NAME:"Ime šablona kampanje",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Obavezno polje",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"pokloni %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"dodatnog vremena",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Izaberi prvo tip. Perionice ili male mašine.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Obriši pravilo",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"sati",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuta",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Novo pravilo po broju dolazaka",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Novo pravilo po količini potrošenih žetona",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Novo pravilo po danima u nedelji",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Dodaj novo pravilo",
    CAMPAIGN_TEMPLATE_RULE_1:"Svakih",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Svakih",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"žetona za manje od",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"dolazaka za manje od",
    CAMPAIGN_TEMPLATE_RULE_3:"dana, pokloni",
    CAMPAIGN_TEMPLATE_RULE_4:"žetona",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Lista pravila je prazna.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum ne može biti u prošlosti",
    DELETE_CAMPAIGN_ERROR:"Doslo je do greške prilikom brisanja odabrane kampanje. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_CAMPAIGN:"Da li ste sigurni da želite obrisati odabranu kampanju?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W nije odgovoran za korisničko iskustvo prouzrokovano ovom akcijom.",
    CAMPAIGNS_OVERVIEW:"Pregled kampanja",
    DELETE_CAMPAIGN:"Obriši kampanju",
    UPDATE_CAMPAIGN:"Izmeni kampanju",
    CREATE_CAMPAIGN:"Kreiraj novu kampanju",
    CAMPAIGN_ACTIVE:"Aktivna",
    CAMPAIGN_TEMPLATE:"Šablon",
    CAMPAIGN_GROUPS:"Grupe",
    CAMPAIGN_ALL_USERS:"Svi korisnici",
    CAMPAIGN_NAME:"Ime kampanje",
    CAMPAIGN_NAME_REQUIRED:"Ime kampanje je obavezno polje",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Korisnici blizu limita bonusa po danu",
    MESSAGE_TO_USERS:"Poruka pronađenim korisnicima",
    SEND_MESSAGE:"Pošalji poruku",
    THRESHOLD:"Limit",
    TYPE:"Tip",
    TOTAL_MONEY_SPENT:"Ukupno novca potrošenog u kampanji",
    NUMBER_OF_VISITS:"Ukupno poseta u kampanji",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Poruka mora imati barem 10 karaktera",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Poruka nesme imati više od 350 karaktera",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Tekst poruke je obavezan",
    TECHNOLOGY:"Tehnologija",
    TAP_WATER:"Gradska voda",
    REVERSE_OSMOSIS:"Reverzna osmoza",
    SOFTENED_WATER:"Omekšana voda",
    DOSER:"Dozer",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Poslednju sinhronizacija",
    NO_OF_CURRENT_ALARMS:"Vaš broj tekućih alarma",
    NO_OF_CURRENT_WARNINGS:"Broj tekućih upozorenja",
    WEATHER:"Vreme",
    BOXES_WORK_HOURS_COUNTERS:"Brojači sati rada bokseva",
    BOX_TOTAL_HOURS:"Ukupno rada",
    BOX_SERVICE_HOURS:"Ukupno rada (servis)",
    BOX_COUNTER_HOURS:"Sati",
    ALARMS_AND_WARNINGS:"Alarmi i upozorenja",
    FILTER_AND_BOILER:"Filter i bojler",
    FILTER_TOTAL_DAYS:"Dani rada filtera",
    BOILER_TOTAL_DAYS:"Dani rada bojlera",
    DAYS_UNIT:"dana",
    SOFTENER:"Omekšivač",
    MANUAL_COLD_DRAIN:"Ručni zimski ispust",
    EL_COLD:"El. zimski",
    DRAIN:"ispust",
    TAP:"slavina",
    WASTE:"Otpad",
    OSMOSIS:"osmoza",
    DEMI_WATER:"Demi voda",
    EL_RINSE:"El. m. ispiranja",
    BOILER:"Bojler",
    EL_WAX:"El. m. voska",
    FLOOR_HEATING:"Podno grejanje",
    DOSER_TANK:"Kadica dozatora",
    EL_WASH:"El. m. pranja",
    DETERGENT:"Prašak",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Izmena postavki perionice",
    GENERAL_SETTINGS:"Opšte postavke",
    LIGHTS:"Svetlo",
    GROUPS:"Grupe",
    ANTI_FREEZE:"Anti smrzavanje",
    AUTO:"Auto",
    MANUAL:"Ručno",
    ON:"Uključeno",
    OFF:"Isključeno",
    TEMPERATURE:"Temperatura",
    UPDATE_DEVICE:"Postavi podešavanja perionice",
    BOX_CLEAN_HOURS:"Brojač sati rada (čišćenje)",
    GROUP_COUNTERS:"Brojači grupa",
    RESET:"Reset",
    CASH_COUNT:"Brojač kovanica",
    COINS_COUNT:"Brojač žetona",
    EUROKEY_COUNT:"Brojač Eurokey",
    DOSER_WORK:"Vreme rada dozera (sec.)",
    DOSER_PAUSE:"Vreme pauze dozera (sec.)",
    DELAY_BFV:"BFV kašnjenje (ms)",
    DELAY_6M1:"6M1 kašnjenje (ms)",
    DELAY_LPS:"LPS kašnjenje (ms)",
    RESET_CASH_COUNT_ALL:"Reset svih brojača kovanica",
    RESET_COINS_COUNT_ALL:"Reset svih brojača žetona",
    RESET_EUROKEY_COUNT_ALL:"Reset svih brojača Eurokey-a",
    FACILITY_DETAILS:"Detalji perionice",
    FACILITY_NAME:"Ime perionice",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Uspešno ste poslali sliku",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Uspešno ste promenili podatke",
    CONNECTED:"Povezan",
    DISCONNECTED:" Disconnected",
    OFFLINE:"Isključen",
    MESSAGES_FILTER:"Filter poruka",
    FACILITY:"Perionica",
    APPLY:"Primeni",
    TIME:"Vreme",
    LOCATION:"Lokacija",
    ACKNOWLEDGED:"Primećena",
    FILTERED_MESSAGES:"Filtrirane poruke",
    ACK:"Primećena",
    NOT_ACK:"Neprimećena",
    ALL:"Svi",
    ALL_FACILITIES:"Sve perionice",
    ENTER_DATE_PLACEHOLDER:"Unesite datum",
    OP_NESTANAK_NAPONA:"Nestanak napona - 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Pumpa greška MZS",
    OP_UPR_NAPON_24VAC_GRE:"Upravljački napon 24VAC error -5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Zaštita na suvo spremnik pitke vode",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Pumpa pitke vode greška motorna zaštitna sklopka",
    OP_MIN_NIVO_OMEKS_VODE:"Zaštita na suvo spremnik omekšane vode",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Pumpa omekšane vode greška motorske zaštitne sklopke",
    OP_MIN_NIVO_DEMIN_VODE:"Zaštita na suvo spremnik demineralizovane  vode",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Pumpa demineralizovane vode greška motorske zaštitne sklopke",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Pumpa reverzna osmoza greška motorske zaštitne sklopke",
    OP_BOJLER_GRESKA_MZS:"Bojler greška",
    OP_CRPKA_PRASKA_GRE_MZS:"Pumpa praška greška motorske zaštitne sklopke",
    OP_DOZATOR_PRASKA_GRE_MZS:"Dozator praska greška",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Vibrator prska greška",
    OP_MIN_PRASAK_TON_ALARM:"Minimalni nivo spremnik praska",
    OP_USIS_KOV_TURBINA_GRESKA:"Usis kovanica turbina greška motorske zaštitne sklopke",
    OP_FILTER_VODE_ZACEPLJEN:"Filter vode začepljen",
    OP_VISKTL_RESET_SATI_RADA:"Pumpa visokog pritiska servis",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Filter servis",
    OP_BOJLER_DANI_RADA:"Bojler servis",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm pumpe visokog pritiska",
    OPW_ALARM_FILTER_SERVIS:"Filter servis alarm",
    OPW_ALARM_BOJLER_SERVIS:"Bojler servis alarm",
    HAS_MEMBERS:"Izabrana grupa ima članove i ne može biti izbrisana. Prvo morate izbrisati članove.",
    PERIODIC_SUMMARY_FOR:"PERIODIČNI SUMARNI IZVEŠTAJ ZA",
    PERIODIC_SUMMARY_REPORTS:"Periodični sumarni izveštaji",
    DATE_RANGE:"Vremenski period",
    FINANCIAL_REPORT:"Finansijski izveštaj",
    GROSS_INCOME:"Ukupan prihod",
    GROSS_INCOME_SUM:"Suma ukupnog prihoda",
    COMMISSION_FEE:"Provizije",
    NET_INCOME:"Neto prihod (za naplatu)",
    COMMISSION_FEE_DETAILS:"Uključuju bankovne / PayPal provizije na transakcije ili SMS servis provizije.",
    LOYALTY_CREDITS_REPORT:"Lokalni žetoni",
    LOYALTY_GIVEN:"Poklonjeni lokalni žetoni",
    LOYALTY_USED:"Iskorišteni lokalni žetoni",
    LOYALTY_SOLD:"Učitani lokalni žetoni",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Tekući mesec",
    SOMETHING_WENT_WRONG:"Uuuuuuuuuuups, desila se greška :-(",
    MISSING_PAGE:"Izvinite, nismo u mogućnosti da nađemo datu stranicu",
    TRY_AGAIN:"Pokušajte ponovo",
    DEFAULT_ERROR_NAME:"Nepoznata greška se desila",
    DEFAULT_ERROR_DESCRIPTION:"Molimo pokušajte ponovo, ako problem i dalje postoji kontaktirajte ovlašćeno lice",
    MY_ACCOUNT_DETAILS:"Detalji korisničkog naloga",
    SAVE_CHANGES:"Sačuvaj promene",
    USERNAME:"Korisničko ime",
    FIRST_NAME:"Ime",
    LAST_NAME:"Prezime",
    USER_ROLE:"Korisnička grupa",
    OLD_PASSWORD:"Stara sifra",
    NEW_PASSWORD:"Nova sifra",
    OLD_PASSWORD_REQUIRED:"Stara šifra polje je obavezno",
    NEW_PASSWORD_REQUIRED:"Nova šifra polje je obavezno",
    NEW_PASSWORD_REPEAT:"Ponoviti novu šifru polje je obavezno",
    NEW_PASSWORD_NOT_MATCH:"Stara i nova šifra nisu identične",
    PASSWORD_DIFFERENT_VALIDATION:"Nova lozinka mora biti drugačija od stare",
    PASSWORD_MIN_CHAR:"Vasa lozinka mora imati barem 8 karaktera",
    PASSWORD_MAX_CHAR:"Vasa lozinka mora imati do 32 karaktera",
    PASSWORD_PATTERN_VALIDATION:"Lozinka mora sadržati barem jedan broj, jedno malo i jedno veliko slovo",
    ACCOUNT_MANAGEMENT:"Upravljanje Korisnicima",
    NOT_ACTIVE:"Neaktivan",
    ASSIGN_ROLE:"Korisnička grupa",
    UPDATE:"Ažuriraj",
    ADD_NEW_ACCOUNT:"Dodavanje novog korisnika",
    EMAIL_REQUIRED:"E-mail adresa je obavezna",
    EMAIL_NOT_VALID:"E-mail adresa nije validna",
    ADD_NEW_USER_TEXT:"E-mail sa aktivacionim linkom biće poslat na upisanu adresu",
    UPDATE_USER_NOTIFICATION:"Uspešno ste ažurirali podatke",
    CHANGED_PASSWORD_NOTIFICATION:"Uspešno ste promenili lozinku",
    UPDATE_USER_GROUP_NOTIFICATION:"Uspešno ste promenili ime grupe",
    CREATE_USER_GROUP_NOTIFICATION:"Uspešno ste kreirali grupu",
    DETELE_USER_GROUP_NOTIFICATION:"Uspešno ste obrisali grupu",
    EMPTY_GROUP_LIST_MSG:"Nema kreiranih grupa. Za početak, napravite jednu",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Uspešno ste obrisali korisnika iz grupe",
    ADD_USER_TO_GROUP_NOTIFICATION:"Uspešno ste dodali korisnika u grupu",
    ADD_USER_NOTIFICATION:"Uspešno ste dodali novog korisnika",
    DELETE_USER_NOTIFICATION:"Uspešno ste obrisali korisnika",
    RESEND_USER_VERIFICATION_EMAIL:"Uspešno ste ponovo poslali verifikacioni email",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Da bi ste kreirali grupu korisnika, molimo Vas unesite naziv grupe.",
    DELETE_USER:"Brisanje korisnika",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Da li ste sigurni da želite obrisati korisnika iz grupe?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Poštovani, ukoliko nas posetite tokom akcije ovog meseca dobićete dodatni bonus na vaš račun.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Pravilo kampanje po broju dolazaka",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Pravilo kampanje po potrošenim žetonima",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Pravilo kampanje po danima u nedelji",
    REMOVE_CAMPAIGN_RULE_TITLE:"Brisanje pravila kampanje",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Da li ste sigurni da želite da obrišete pravilo kampanje?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Uspešno ste sačuvali novo pravilo kampanje",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Uspešno ste aktivirali kampanju",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Nema kreiranih kampanja. Za početak, napravite jednu",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Uspešno ste poslali poruku",
    COMPANY_ACCOUNTS:"Kompanijski nalozi",
    BUSSINESS_INVOICES_LIST:"Moje B2B fakture",
    LOCALE_TOKEN:"Lokalni token",
    R2W:"Globalni token",
    START_MONTH:"Početni mesec",
    END_MONTH:"Krajnji mesec",
    TOKEN_TYPE:"Tip tokena",
    TOKEN_NUMBER:"Broj tokena",
    NOTHING_TO_DISPLAY:"* Nema podataka za prikaz",
    CREATE_INVOICE:"Nova Faktura",
    INVOICE:"Faktura",
    INVOICES:"Fakture",
    EDIT_INVOICE:"Promeni Fakturu",
    UPDATE_INVOICE_NOTIFICATION:"Uspešno ste promenili status fakture u 'u izvršenju'",
    CURRENT_CHARGES:"Zaduženje za tekući period",
    PAYMENTS_ON_HOLD:"Poslati računi",
    FOR_INVOICING:"Nije fakturisano",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Pokušavate da poništite fakturu",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Da li ste sigurni da želite da poništite fakturu?",
    INVOICING_NOTIFICATION_HEADER:"Pokušavate da pošaljete fakturu",
    INVOICING_NOTIFICATION_TEXT:"Da li ste sigurni da želite da pošaljete fakturu?",
    SENT_INVOICE_NOTIFICATION:"Uspešno ste poslali fakturu",
    CANCELED_INVOICE_NOTIFICATION:"Uspešno ste poništili fakturu",
    INVOICE_DESCRIPTION_TEXT:"Faktura za mesec",
    INVOICE_STATE:"Status fakture",
    INVOICE_NUMBER:"Broj fakture",
    INVOICE_TOTAL:"Ukupno",
    SELECT_YEAR:"Izaberi godinu",
    DOWNLOAD:"Skini PDF",
    INVOICE_NUMBER_HEADER:"Nameravate da pošaljete fakturu sa brojem",
    INVOICE_PAYMENT_CONFIRMATION:"Nameravate da potvrdite plaćanje fakture sa brojem",
    INSERT_INVOICE_NUMBER:"Unesi broj fakture",
    INVOICED_WARNING:"Email nije poslat. Molim Vas sačekajte ...",
    SEND_INVOICE:"Pošalji",
    INVOICE_ALL:"Sve",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Za R2W",
    PAYMENT_REQUEST:"Zahtev za plaćanje",
    PAYMENT_REQUEST_STATE:"Zahtev za plaćanje",
    PAYMENT_REQUEST_NUMBER:"Broj zahteva za plaćanje",
    FOR_PAYMENT_REQUEST:"Za zahtev za plaćanje",
    PAYMENT_REQUEST_ON_HOLD:"Zahtev za plaćanje u obradi",
    DOWNLOAD_INVOICE:"Preuzimanje faktura",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknite na opcije za preuzimanje",
    B2B_SPEC:"B2B Specifikacija",
    B2C_SPEC:"B2C Specifikacija",
    DOWNLOAD_PAYMENT_REQUEST:"Preuzmi zahtev za plaćanje",
    LOYALTY_PREVIEW:"Pregled kampanje",
    ACTIVATED:"Aktivna",
    RUNNING:"Traje",
    NOT_ACTIVATED:"Nije aktivna",
    FINISHED:"Završena",
    DEPRECATED:"Zastarela",
    UPCOMING:"Nadolazeća",
    NONE:"Niko",
    STARTED:"Počela",
    ENDS:"Završava se",
    DEDICATED:"Dodeljena",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Pokušavate da aktivirate",
    CAMPAIGN:"kampanju",
    SEND_MESSAGE_NOTIFICATION:"Da želite da pošaljete poruku svim korisničkim grupama",
    DIVISIBLE_TO_NUMBER:"Broj bi trebao biti deljiv sa ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Tip uređaja",
    LISTENER:"Male mašine",
    BRIDGE:"Boks za pranje",
    WASH_BOXES:"Boks za pranje",
    VACUUMS:"Usisivači",
    SAVE_NEWS:"Sačuvaj vest",
    CREATE_NEW_NEWS:"Kreiraj novu vest",
    HISTORY_OF_ALL_NEWS:"Istorija svih vesti",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Upiši ime perionice",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Dodaj novu perionicu",
    NEWS_TEXT:"Tekst vesti",
    NEWS_TITLE:"Naslov vesti",
    DELETE_NEWS_CONFIRMATION:"želite da obrišete vest ?",
    NEWS_DELETE_NOTIFICATION:"Uspešno ste obrisali vest",
    NEWS_SAVE_NOTIFICATION:"Uspešno ste sačuvali vest",
    NEWS_CREATION_DATE:"Datum kreiranja",
    NO_TITLE:"Nema naslova",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Tekst vesti nesme biti duži od 255 karaktera",
    NEWS_TEXT_REQUIRED_VALIDATION:"Tekst vesti je obavezan",
    NEWS_TITLE_REQUIRED_VALIDATION:"Naslov vesti je obavezan",
    DEACTIVATE:"Deaktiviraj",
    ASIDE_MENU_LOCAL_TOKENS:"Lokalni žetoni",
    CREATE_NEW_LOCAL_TOKENS:"Izdavanje novih lokalnih žetona",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Unesite email adresu korisnika i broj žetona koje želite da mu izdate",
    CREATE_TOKENS:"Izdaj žetone",
    MINIMUM_ONE_TOKEN:"Vrednost mora biti veća od 0",
    CUSTOMER_EMAIL:"Korisnikova email adresa",
    AMOUNT_OF_TOKENS:"Broj žetona",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Uspešno ste izdali lokalne žetone na",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Desila se greška prilikom izdavanja žetone. Molimo Vas proverite korisnikovu email adresu i pokušajte ponovo.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Pregled izdatih lokalnih žetona",
    ISSUED_AT:"Vreme izdavanja",
    ISSUED_BY:"Izdato od",
    CODE:"Kod",
    REDEEMED_BY:"Iskorišćeno od",
    REDEEMED_AT:"Vreme",
    ASIDE_MENU_VOUCHERS:"Vaučeri",
    PRINT:"Štampa",
    VOUCHERS_OVERVIEW:"Pregled vaučera",
    CREATE_NEW_VOUCHERS:"Kreiranje novih vaučera",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Kreirajte novu seriju vaučera unošenjem broja žetona po vaučeru, količine vaučera u seriji i prefiks koda za seriju",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Broj žetona po vaučeru",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Dozvoljeno je dodeliti između 1 i 100 žetona po vaučeru",
    NUMBER_OF_NEW_VOUCHERS:"Količina vaučera u seriji",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Dozvoljeno je kreiranje između 1 i {{size}} vaučera u jednoj seriji",
    NEW_VOUCHERS_PREFIX:"Prefiks kod vaučera u seriji",
    VALIDATION_VOUCHER_PREFIX:"Prefiks kod mora sadržati tačno 4 karaktera (velika slova i / ili brojevi)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Desio se problem prilikom kreiranja novih vaučera. Molimo Vas pokušajte ponovo ili kotaktirajte sistemsku podršku.",
    CREATE_VOUCHERS:"Kreiraj seriju vaučera",
    CREATING_VOUCHERS_SUCCESS:"Nova serija vaučera kreirana uspešno",
    PRINT_NEW_VOUCHERS:"Štampaj vaučere",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Unesite broj serije vaučera, ceo kod ili deo koda vaučera, kako bi ste odštampali odgovarajuće vaučere.",
    PRINT_VOUCHERS_PREFIX:"Prefiks kod (serija) vaučera",
    NO_VOUCHERS_FOR_PRINT:"Nema vaučera za štampu sa unetim prefix kodom",
    PRINT_VOUCHERS:"Štampaj vaučere",
    VALIDATION_VOUCHER_CODE_FILTER:"Prefiks kod filter može sadržati između 1 i 16 karaktera, i podržava samo velika slova i brojeve.",
    FILTER_VOUCHERS_BY_CODE:"Filter vaučera po kodu",
    FILTER_VOUCHERS:"Filter",
    WASH_BOX:"Perionica",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Ukupno korišćenih digitalnih žetona",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Ukupno kupljenih lokalnih virtuelnih žetona po danima",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Ukupno potrošenih lokalnih virtuelnih žetona po danu",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Ukupno poklonjenih lokalnih virtuelnih žetona po danu",
    LOCAL_TOKEN:"Lokalni žeton ",
    GIVEN_TOKEN:"Poklonjeni žetoni",
    SOLD_TOKEN:"Prodati žetoni",
    SMALL_MACHINES:"Male mašine",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Perionica",
    CODE_PREFIX_EXIST:"Code prefix već postoji",
    CODE_PREFIX_EXIST_TEXT:"Ne možete kreirati novi voucher sa ovim code prefix-om. Definišite novi.",
    MIN_FOUR_VALIDATION:"Tačno 4 karaktera",
    ALL_INFORMATION_1:"Sve informacije o",
    ALL_INFORMATION_2:"će biti izgubljene",
    ASIDE_MENU_TRANSACTIONS:"Transakcije",
    EXPENSES:"Troškovi",
    TOPUPS:"Kupljeni tokeni",
    EXPENSES_LIST:"Lista troškova",
    USER_EMAIL:"Korisnički email",
    COMPANY_NAME:"Naziv kompanije",
    TOPUPS_LIST:"Lista kupljenih tokena",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serijski broj",
    SETUP_UNIT_MATERIAL_NO:"Materijalni broj",
    SETUP_UNIT_WEBAPI_VERSION:"Verzija WebApi - ja",
    TOTAL_TURNOVER:"Promet na perionici",
    AVAILABILITY_ALL:"Dostupnost",
    AVAILIBILITY:"Dostupnost boksova za pranje",
    AVAILABILITY_VACUUMS:"Dostupnost usisivača",
    WASH_BOX_INFO:"Info boksova za pranje",
    VACUUM_CLEANER_INFO:"Info usisivača",
    BREAD_CRUMBS_SERVICE:"Servis",
    HOLIDAYS:"Praznici",
    HOLIDAY:"Praznik",
    LIGHTS_ON:"Svetlo/uključi",
    LIGHTS_OFF:"Svetlo/isključi",
    WASH_BOXES_ON:"Boks za pranje/uključi",
    WASH_BOXES_OFF:"Boks za pranje/isključi",
    VACUUMS_ON:"Usisivač/uključi",
    VACUUMS_OFF:"Usisivač/isključi",
    TURNOVER:"Promet",
    TURNOVER_MANUAL_WASH_UNIT:"Promet priručnik",
    STATUS_BAY_RUN_TIME:"Ukupno vreme rada boksa za pranje",
    STATUS_BAY_PROGRAM_NAME:"Ime programa",
    STATUS_BAY_CREDIT:"Kredit boksa za pranje",
    CLOUD_KREDIT:"Kredit klauda",
    STATUS_VACUUM_RUN_TIME:"Ukupno vreme rada usisivača",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Servis perionice, programi boksova za pranje i informacije o trenutnim greškama",
    UNAVAILABLE:"Uređaj je nedostupan",
    SHOW_HIDE_TABLE:"Sakrij/prikaži tabelu radnih sati",
    PROGRAM_NAME:"Ime programa",
    PROGRAM_COUNTER:"Brojač programa",
    NO_NAME:"Referenca nema naziv",
    COUNTER_SERVICE_DATA:"Servisni podaci",
    NEED_SERVICE:"Potreban servis",
    PROGRAM_DATA:"Podaci o boksovima za pranje",
    CURRENT_FAULT_DATA:"Trenutne greške",
    REFERENCE_DUE:"Dospelo",
    REFERENCE_SECONDS:"Sekunde",
    REFERENCE_NAME:"Naziv dela",
    WASHBOX_NAME:"Ime boksa za pranje",
    FAULT_NAME:"Ime greške",
    FAULT_NUMBER:"Broj greške",
    CURRENT_FAULT_COUNT:"Aktivne greške",
    DEVICE_NOT_INSTALLED:"Uređaj nije instaliran",
    STATUS_READY:"Spreman",
    STATUS_ERROR:"Greška",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Softverska greška",
    SOFTWARE_RESET:"Softverska greška",
    EXTERNAL_PIN_RESET:"Softverska greška",
    RESTART_OR_BROWNOUT_OCCURRED:"Softverska greška",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardverska greška",
    COULD_NOT_SIMULATE_COIN:"Hardverska greška",
    ERROR_SETTING_INHIBIT_MODE:"Hardverska greška",
    OFFLINE_DEVICE:"Offline autoperionica",
    TARIFFS:"Tarife",
    DAY:"Dan",
    NIGHT:"Noć",
    VOUCHER_CODE:"Kod vaučera",
    DISMISS_ALARM:"Resetujte alarm?",
    ALARM_ACTIVE:"Aktivni alarmi",
    NO_ALARM_ACTIVE:"Nema aktivnih alarma",
    ALARM_HISTORY:"Istorija alarma",
    MANAGING_TOKENS:"Upravljanje lokalnim žetonima",
    EXPIRATION_DATE:"Datum isteka",
    EXTEND_TOKEN_DATE:"Produži datum isteka žetona za",
    DELETE_TOKENS_FOR:"Obriši lokalne digitalne žetone za",
    PUMP_TYPE:"Tip pumpe",
    TURN_OFF_DEVICE:"Status uređaja",
    OPERATION_DATA:"Operativni podaci",
    PUMP_DATA:"Podaci pumpe",
    PUMP_NAME:"Naziv pumpe",
    POINT_NAME:"Naziv tačke",
    CHANGER_INCOME:"Ukupan prihod menjača po datumu",
    SELECTED_OPEN:"Otvoreno u odabrano radno vreme",
    ALWAYS_OPEN:"Uvek otvoreno (24/7)",
    CLOSED:"Zatvoreno",
    CLOSED_24:"Zatvoreno 24h",
    OPENED_24:"Otvoreno 24h",
    MON:"Ponedeljak",
    TUE:"Utorak",
    WED:"Sreda",
    THU:"Četvrtak",
    FRI:"Petak",
    SAT:"Subota",
    SUN:"Nedelja",
    PRICING:"Cenovnik",
    PRICE:"Cena",
    VALIDITY:"Validnost",
    TOKEN_PACKAGES:"Paketi žetona",
    SINGLE_WASH:"Jedno pranje",
    FACILITY_WORKING_HOURS:"Postavite radno vreme za izabrani objekat",
    WORKING_HOURS_ALWAYS_OPEN:"Uvek otvoreno",
    WORKING_HOURS_ALWAYS_CLOSE:"Zatvoreno od strane operatera",
    WORKING_HOURS_CUSTOM:"Postavite radno vreme",
    KARCHER_ERROR_CODE:"Kod greške upozorenja",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizacija",
    CREATE_ORGANIZATION:"Kreiraj organizaciju",
    CREATE_ORGANIZATION_AS:"Kreiraj organizaciju kao podobjekat za",
    DELETE_ORGANIZATION:"Obriši organizaciju",
    EDIT_ORGANIZATION:"Uredi organizaciju",
    SUPPORTED_ORG_NAME:"Podržana organizacija",
    SUPPORTED_ORG_TYPE:"Podržani tip",
    ORG_NAME:"Ime",
    ORG_TYPE:"Tip",
    SET_ORG_TITLE:"Postavi podorganizaciju",
    SET_SUPPORTED_ORG_TITLE:"Postavi podržanu podorganizaciju",
    SAVE_ORGANIZATION:"Sačuvaj organizaciju",
    SELECT_ORGANIZATION_TYPE:"Izaberi tip organizacije",
    SELECT_ORGANIZATION_SELECTOR:"Izaberi",
    SELECT_SUPPORTED_ORGANIZATION:"Izaberi podržanu organizaciju",
    ORGANIZATION_DELETED:"Organizacija uspešno obrisana",
    ORGANIZATION_SAVED:"Organizacija uspešno sačuvana",
    ORGANIZATION_UPDATED:"Organizacija uspešno ažurirana",
    ALERTS:"Upozorenja",
    DEVICE_STATUS:"Status uređaja",
    SITE_DETAILS:"Detalji autoperionice",
    ALARM_STATUS:"Status upozorenja",
    FILTER:"Filtriraj po ...",
    FILTER_BY_ALERT_CENTER:"Filtriraj po kodu, imenu ili opisu",
    TOTAL_ALARM:"Ukupno",
    LOW_ALARM:"Događaj",
    MEDIUM_ALARM:"Kvar",
    HIGH_ALARM:"Kritična greška",
    NO_FACILITIES_NEARBY:"Nema obližnjih objekata",
    GRAY_MAP:"Siva mapa",
    READY:"Spreman",
    WARNING:"Kvar",
    ERROR:"Greška",
    SITE_NAME:"Ime autoperionice",
    ACCOUNTS_INFO:"Informacije o nalogu",
    USER_ORGANIZATION:"Organizacija korisnika",
    ADD_USER_ORGANIZATION:"Dodaj novog korisnika organizacije",
    EDIT_USER_ORGANIZATION:"Uredi korisnike organizacije",
    SELECT_ROLE:"Izaberi ulogu",
    SELECT_ORGANIZATION:"Izaberi organizaciju",
    SELECT_USER:"Izaberi  korisnika",
    USER_FOR_ORGANIZATION_CREATED:"Novi korisnik uspešno kreiran",
    SELECT_REGION:"Izaberi region",
    SELECT_LANGUAGE:"Izaberi jezik",
    LOADING_DATA:"Učitavanje podataka, molimo sačekajte...",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Tehnička podrška",
    CONTROLLER:"Kontroler",
    EDIT_ORGANIZATION_USER:"Uredi korisnike organizacije",
    DELETE_ORGANIZATION_USER:"Obriši korisnike organizacije",
    USER_UPDATED:"Korisnik uspešno ažuriran",
    USER_CREATED:"Korisnik uspešno kreiran",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"Pretplate",
    RESOLVED_STATUS:"Rešeno",
    NOT_RESOLVED_STATUS:"Nije rešeno",
    ALERT_NAME:"Naziv upozorenja",
    ALERT_DESCRIPTION:"Opis upozorenja",
    ALERT_CODE:"Kod upozorenja",
    ALERT_TYPE:"Tip upozorenja",
    UNSUBSCRIBE:"Odjavi se sa upozorenja",
    SUBSCRIBE:"Prijavi se na upozorenje",
    ALARM_SUBSCRIBED:"Uspešno prijavljeno",
    UNSUBSCRIBED_CONFIRM:"Odjavi se?",
    ALARM_UNSUBSCRIBED:"Uspešno odjavljeno",
    ASIDE_MENU_CASHLESS_SALES:"Bezgotovinska prodaja",
    FILTERED_CASHLESS_PAYMENTS:"Filtrirane bezgotovinske uplate",
    REFUND_DIALOG_TITLE:"Povrat transakcije?",
    REFUND_DIALOG_SUBTITLE:"Iznos može biti manji ili jednak iznosu transakcije",
    REFUND:"Povrat",
    INPUT_NOT_VALID:"Unos nije validan",
    REFUND_SUCCESSFULLY:"Povrat za izabranu uplatu uspešno izvršen",
    USER:"Korisnik",
    TRANSACTION_ID:"PSP referenca",
    DEVICE_ID:"ID uređaja",
    NET_AMOUNT:"Neto iznos",
    REPORT_NAME:"Naziv izveštaja",
    TIME_FRAME:"Vremenski okvir",
    SUB_POINT:"Izaberi pod-tačku",
    SUB_POINT_LIST_NOT_EXIST:"Spisak pod-tačaka ne postoji za izabrani objekat za pranje",
    FACILITY_TYPE:"Tip autoperionice",
    MACHINE_NAME:"Naziv mašine",
    WASH_FACILITY_DETAILS:"Detalji mašina na autoperionici",
    WASH_BAY_DETAILS:"Detalji bokseva za pranje",
    DEVICES_INFO:"Spisak uređaja",
    OPERATION_TIME_INFO:"Vreme rada",
    OPERATION_TIME_VACUUM_INFO:"Vreme rada usisivača",
    OPERATION_TIME_ILLUMINATION_INFO:"Vreme rada osvetljenja",
    AVAILABLE_TITLE:"Dostupno",
    UNAVAILABLE_TITLE:" Nedostupno",
    CURRENT_PROGRAM:"Trenutni program",
    CREDITS:"Krediti",
    DEVICE_NAME:"Naziv uređaja",
    ACTIVE_ALARMS:"Aktivna upozorenja",
    ALL_DAY:"Ceo dan",
    OPERATING_TIME_WASH_FACILITY:"Sistem za samouslužno pranje",
    OPERATING_TIME_VACUUMS:"Usisivači",
    OPERATING_TIME_ILLUMINATION:"Osvetljenje",
    OPERATION_COUNTERS:"Brojači operacija",
    EDIT:"Uredi",
    WASHING_PROGRAMS:"Programi pranja",
    INFO:"Događaj",
    STATISTIC:"Statistika",
    ROLLOVER_DOSING:"Doziranje",
    ROLLOVER_SPEED:"Brzine",
    ROLLOVER_RESETS:"Daljinsko resetovanje rollover-a",
    ROLLOVER_RESETS_INFO:"Daljinsko resetovanje mora biti u skladu sa lokalnim propisima. Važno: Pre resetovanja, uverite se da je rollover prazan.",
    RESET_ROLLOVER:"Resetuj rollover",
    OPEN_DOOR_ROLLOVER:"Otvori",
    ROLLOVER_OPEN_DOOR_INFO:"Otvori vrata za pranje. Budite oprezni.",
    ROLLOVER_OPEN_DOOR:"Otvori vrata",
    APPLY_DOSING_CHANGES:"Primeni promene doziranja",
    APPLY_SPEED_CHANGES:"Primeni promene brzina",
    ACTUATION_SUCCESS:"Zahtev poslat",
    REMAINING_TIME:"Preostalo vreme",
    OPEN_24H:"Otvoreno 24 sata",
    CLOSE_24H:"Zatvoreno 24 sata",
    VALIDATION_OPERATION_TIME:"Format nije tačan. Koristite hh",
    ROLLOVER:"Rollover",
    UPDATE_WASHING_PROGRAM:"Ažuriraj program pranja",
    UPDATE_ACTUATORS:"Ažuriraj aktuatore",
    OPEN_ROLOVER_DOOR_TITLE:"Želite li otvoriti vrata rollover-a?",
    OPEN_ROLOVER_DOOR_CONTENT:"Da li ste sigurni da želite otvoriti vrata?",
    RESET_ROLOVER_TITLE:"Želite li resetovati rollover?",
    RESET_ROLOVER_CONTENT:"Da li ste sigurni da želite resetovati rollover?Da li ste sigurni da želite resetovati rollover?",
    G0:"{{brand === 'r2w' ? 'Boks 0' : 'Boks 1'}}",
    G1:"{{brand === 'r2w' ? 'Boks 1' : 'Boks 2'}}",
    G2:"{{brand === 'r2w' ? 'Boks 2' : 'Boks 3'}}",
    G3:"{{brand === 'r2w' ? 'Boks 3' : 'Boks 4'}}",
    G4:"{{brand === 'r2w' ? 'Boks 4' : 'Boks 5'}}",
    G5:"{{brand === 'r2w' ? 'Boks 5' : 'Boks 6'}}",
    G6:"{{brand === 'r2w' ? 'Boks 6' : 'Boks 7'}}",
    G7:"{{brand === 'r2w' ? 'Boks 7' : 'Boks 8'}}",
    G8:"{{brand === 'r2w' ? 'Boks 8' : 'Boks 9'}}",
    G9:"{{brand === 'r2w' ? 'Boks 9' : 'Boks 10'}}",
    G10:"{{brand === 'r2w' ? 'Boks 10' : 'Boks 11'}}",
    U0:"{{brand === 'r2w' ? 'Usisivač 0' : 'Usisivač 1'}}",
    U1:"{{brand === 'r2w' ? 'Usisivač 1' : 'Usisivač 2'}}",
    U2:"{{brand === 'r2w' ? 'Usisivač 2' : 'Usisivač 3'}}",
    U3:"{{brand === 'r2w' ? 'Usisivač 3' : 'Usisivač 4'}}",
    U4:"{{brand === 'r2w' ? 'Usisivač 4' : 'Usisivač 5'}}",
    U5:"{{brand === 'r2w' ? 'Usisivač 5' : 'Usisivač 6'}}",
    U6:"{{brand === 'r2w' ? 'Usisivač 6' : 'Usisivač 7'}}",
    U7:"{{brand === 'r2w' ? 'Usisivač 7' : 'Usisivač 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Alert centar izveštaj kreiran odabrane lokacije sa kontrolne table",
    ALERT_CENTER_TITLE_BY_FACILITY:"Alert centar izveštaj kreiran odabrane objekta sa kontrolne table",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Alert centar izveštaj",
    ERROR_MESSAGE_403:"Nemate privilegiju da koristite ovaj API poziv. Greška kod: 403",
    LAST_ACTIVE_PROGRAM:"Aktivan program / Poslednji aktivan program",
    PROGRAM_ID:"Broj programa",
    PROGRAM_PRICE:"Cena programa",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Potrebno je dopuniti",
    EMPTY_CHEMICAL_LEVEL:"Prazno",
    CHEMICAL_LEVEL:"Indikacija nivoa deterdženata (%)",
    ROLLOVER_STATUS:"Status četki",
    ROLLOVER_STATUS_CODE_0:"Perionica trenutno van funkcije",
    ROLLOVER_STATUS_CODE_1:"Van radnog vremena",
    ROLLOVER_STATUS_CODE_2:"Dozvoljen ulazak u program",
    ROLLOVER_STATUS_CODE_3:"Pozicionirajte vozilo",
    ROLLOVER_STATUS_CODE_4:"Vozilo napred",
    ROLLOVER_STATUS_CODE_5:"Vozilo nazad",
    ROLLOVER_STATUS_CODE_6:"Vozilo stani",
    ROLLOVER_STATUS_CODE_7:"Pranje aktivno",
    ROLLOVER_STATUS_CODE_8:"Pranje zaustavljeno",
    ROLLOVER_STATUS_CODE_9:"Pranje aktivno (takt)",
    ROLLOVER_STATUS_CODE_10:"Izlazak vozila nazad",
    ROLLOVER_STATUS_CODE_11:"Hitno zaustavljanje",
    ROLLOVER_STATUS_CODE_12:"Izlazak vozila napred",
    ROLLOVER_STATUS_CODE_13:"Aktivno protiv smrzavanja",
    ROLLOVER_STATUS_CODE_14:"Aktiviran sigurnosni prekidač napred",
    ROLLOVER_STATUS_CODE_15:"Aktiviran sigurnosni prekidač nazad",
    ROLLOVER_STATUS_CODE_16:"Aktiviran sigurnosni prekidač levo napred",
    ROLLOVER_STATUS_CODE_17:"Aktiviran sigurnosni prekidač desno napred",
    ROLLOVER_STATUS_CODE_18:"Aktiviran sigurnosni prekidač levo nazad",
    ROLLOVER_STATUS_CODE_19:"Aktiviran sigurnosni prekidač desno nazad",
    ROLLOVER_STATUS_CODE_20:"Vozilo je previše levo",
    ROLLOVER_STATUS_CODE_21:"Vozilo je previše desno",
    ROLLOVER_STATUS_CODE_22:"Leva vrata nisu zatvorena",
    ROLLOVER_STATUS_CODE_23:"Desna vrata nisu zatvorena",
    ROLLOVER_STATUS_CODE_24:"Detektovan transporter, izabran je pogrešan program pranja",
    ROLLOVER_STATUS_CODE_25:"Senzor sirene",
    ROLLOVER_STATUS_CODE_98:"Ručni / podešavajući režim",
    ROLLOVER_STATUS_CODE_99:"Nepoznat status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Statusni kod nije definisan",
    ALARM:"Kritična greška",
    NO_ALARM:"Nema kritične greške",
    SOFTWARE_VERSION:"Verzija softvera",
    SOFTWARE_DATE:"Datum softvera",
    SITE_ADDRESS:"Adresa lokacije",
    SECONDS:"Sekunde",
    SERVICE_PART_NAME:"Naziv usluge:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Brojač operacija i servisiranja",
    OPERATION_COUNTER:"Brojač operacija",
    SERVICE_COUNTER:"Brojač servisiranja",
    FAULT_CODE:"Kod upozorenja",
    PRESSURE_TITLE:"Pritisak vazduha",
    TIME_TITLE:"Trenutno vreme",
    COUNTRY_TITLE:"Država",
    CITY_TITLE:"Grad",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Izaberi tačke ...",
    LOGS_HISTORY:"Istorija promena parametara",
    ACTUATOR_REFERENCE:"Referenca aktuatora",
    ACTUATOR_VALUE:"Vrednost aktuatora",
    POINT_ID:"ID tačke",
    VALIDATION_NOT_VALID_RANGE:"Pogrešan opseg",
    ENABLE_ROLLOVER_RESET:"Označavanjem ovog polja potvrđujete da ste pročitali i slažete se sa sigurnosnim uputstvima",
    CHANGE_OF_PARAMETERS:"Promena parametara",
    SELECT_OPTIONS:"Izaberi opcije",
    AUTOMATIC:"Automatski",
    DESALTING:"Funkcija odstranjivanja soli",
    SEASON_WASH:"Programi pranja po godišnjim dobima",
    SPRING_PROGRAM:"Programi pranja za proleće",
    SUMMER_PROGRAM:"Programi pranja za leto",
    AUTUMN_PROGRAM:"Programi pranja za jesen",
    WINTER_PROGRAM:"Programi pranja za zimu",
    DOOR_CONTROL:"Kontrola vrata",
    SUMMER_DOOR_CONTROL:"Leto, rad sa kontrolom vrata u letnjem režimu",
    WINTER_DOOR_CONTROL:"Zima, rad sa kontrolom vrata u zimskom režimu",
    APPLY_PARAMETERS_CHANGES:"Primeni promene parametara",
    WORKING_SCHEDULES:"Radno vreme",
    HOLIDAY_SCHEDULES:"Rasporedi praznika",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Praznici na lokaciji uspešno kreirani",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Praznici na lokaciji uspešno ažurirani",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Praznici na lokaciji uspešno obrisani",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Radna vremena uspešno propagirana",
    HOLIDAY_SUCCESSFULLY_DELETED:"Praznik uspešno obrisan",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Sredstvo za sušenje sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampon sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_FOAM:"Pena sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_WAX_1:"Vosak sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_POLISH_1:"Polir sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Sredstvo za čišćenje felni sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_WAX_2:"Vosak sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Sredstvo za sjaj guma sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Sredstvo za uklanjanje insekata sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_POLISH_2:"Polir sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_INTENSIVE:"Intenzivno sredstvo sa niskim nivoom punjenja",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pena za pranje sa niskim nivoom punjenja",
    CHEM_LEVEL_DRYING_AGENT:"Nivo punjenja sredstva za sušenje",
    CHEM_LEVEL_SHAMPOO:"Nivo punjenja šampona",
    CHEM_LEVEL_FOAM:"Nivo punjenja pene",
    CHEM_LEVEL_WAX_1:"Nivo punjenja voska",
    CHEM_LEVEL_POLISH_1:"Nivo punjenja polira",
    CHEM_LEVEL_RIM_CLEANER:"Nivo punjenja sredstva za čišćenje felni",
    CHEM_LEVEL_WAX_2:"Nivo punjenja voska",
    CHEM_LEVEL_TYRE_SHINE:"Nivo punjenja sredstva za sjaj guma",
    CHEM_LEVEL_INSECT_REMOVER:"Nivo punjenja sredstva za uklanjanje insekata",
    CHEM_LEVEL_POLISH_2:"Nivo punjenja polira",
    CHEM_LEVEL_INTENSIVE:"Nivo punjenja intenzivnog sredstva",
    CHEM_LEVEL_FOAM_RAIN:"Nivo punjenja pene za kišu",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Brojač servisa za podizanje kaiša za četku na krovu",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Brojač servisa za podizanje kaiša za sušenje",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Brojač servisa za motorne kablove kaiša za četku na krovu",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Brojač servisa za servisiranje sveže vode",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Brojač servisa za servisiranje korištene vode",
    DRYING_AGENT:"Sredstvo za sušenje",
    FOAM_DRYING_AGENT:"Pena za sušenje",
    SHAMPOO:"Šampon",
    FOAM:"Pena",
    BRUSH_FOAM:"Pena za četkanje",
    WAX_1:"Vosak",
    FOAM_WAX_1:"Pena za vosak",
    POLISH_1:"Polir",
    RIM_CLEANING:"Sredstvo za čišćenje felni",
    WAX_2:"Vosak",
    FOAM_WAX_2:"Pena za vosak",
    TYRE_SHINE:"Sredstvo za sjaj guma",
    INSECT_REMOVER:"Sredstvo za uklanjanje insekata",
    POLISH_2:"Polir",
    INTENSIVE_BASIC:"Intenzivno osnovno",
    INTENSIVE_SIDE:"Intenzivno bočno",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzivno sredstvo za prskanje krova",
    TAR_REMOVER:"Sredstvo za uklanjanje katrana",
    UNDER_CHASSIS_CONVERSATION:"Razgovor ispod šasije",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionarni pred-prskajući luk",
    FOAM_RAIN:"Pena za kišu",
    PRE_CLEANING:"Predčišćenje",
    BRUSH:"Četka",
    CARE:"Nega",
    DRYING:"Sušenje",
    DRYING_LOW_NOISE:"Smanjeno bučno sušenje",
    INTENSIVE_CLEANING:"Intenzivno čišćenje",
    BRUSH_CLEANING:"Čišćenje četkom",
    EMPTY_RUN:"Pranje bez punjenja",
    DRYING_AID:"Sredstvo za sušenje",
    WAX:"Vosak",
    FOAM_WASH:"Pena za pranje",
    POLISH:"Polir",
    FOAM_POLISH:"Pena za poliranje",
    WHEEL_CLEANING:"Čišćenje točkova",
    HIGH_PRESSURE_ROOF:"Visok pritisak na krovu",
    HIGH_PRESSURE_SIDE:"Visok pritisak sa strane",
    DRYER_FORWARD:"Sušilica napred",
    DRYER_BACKWARD:"Sušilica nazad",
    DELETE_ALL_HOLIDAYS:"Obriši sve praznike za izabranu lokaciju",
    CREATE_NEW_HOLIDAY:"Kreiraj novi",
    RESET_INPUTS:"Resetuj sve ulaze za praznike",
    TWENTY_FOUR_HOURS_OPEN:"Otvoreno 24 sata",
    EVERY_YEAR:"Godišnje",
    DELETE_HOLIDAY:"Obriši praznik",
    ADD_NEW_HOLIDAY:"Dodaj novi praznik",
    HOLIDAYS_LIST:"Spisak postojećih praznika",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Obriši sve praznike za izabranu lokaciju?",
    VALIDATION_HOLIDAY_DATE:"Format nije tačan. Koristite mm-dd",
    FOR_DATE:"Za datum",
    WITH_ID:"Sa ID",
    FROM_HOURS:"Od (h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:"Do (min)",
    NOT_MATCH:"Ne podudara se",
    START:"Od ",
    STOP:"Do",
    DAILY_TIME:"Spisak 24 satne liste",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individualno podešavanje vremena",
    PROGRAM_NOT_STARTED:"Program još nije započeo",
    JETWASH:"Sistem za samoposluživanje pranja",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Pumpa sveže vode",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Pumpa za procesnu vodu",
    OPERATION_COUNTER_HP_PUMP_1:"Pumpa visokog pritiska 1",
    OPERATION_COUNTER_HP_PUMP_2:"Pumpa visokog pritiska 2",
    RELEASE_NOTES:"Verzije aplikacije i beleške o izdanju",
    BACKEND_RELEASE_NOTES:"Beleške o izdanju platforme:",
    FRONTEND_RELEASE_NOTES:"Beleške o izdanju web aplikacije:",
    SELECTED_FACILITY_TIMEZONE:"Vremenska zona za izabrani objekat:",
    REFRESH_PAGE:"Osveži stranicu",
    REFRESH_MAPS:"Osveži mape",
    PUMPS:"Pumpe",
    RUN_TIME:"Vreme rada",
    RUN_TIME1:"Vreme rada 1",
    RUN_TIME2:"Vreme rada 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuator za vreme rada",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuator za vreme rada 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuator za vreme rada 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimalna vrednost je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maksimalna vrednost je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Koristi format cene x.xx",
    ACTUATION_NOT_ALLOWED:"Aktuacija nije dozvoljena za trenutnu ulogu korisnika",
    MAINTENANCE_DAYS:"Dani održavanja",
    MAINTENANCE_WASHES:"Održavanje pranja",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Ukupni prihod POS",
    PROPAGATE:"Propagirati",
    ALL_DAY_HOURS_SELECTOR:"Selektor tipa 24 sata",
    GET_OPERATING_TIME_FROM_SITE:"Dobijanje vremena rada za trenutni uređaj iz radnog rasporeda lokacije",
    USER_NOT_VALID:"Korisnik nije validan. Pokušajte sa drugim korisničkim podacima.",
    VERIFIED:"Verifikovan",
    RESEND_VERIFICATION_MAIL:"Ponovno slanje email verifikacije",
    RETURN_TO_DASHBOARD:"Povratak na kontrolnu tablu",
    ERROR_PAGE_BAD_REQUEST:"400 Loš zahtev.",
    WASHES:"Broj pranja",
    TIME_TO_SERVICE:"Vreme do servisa",
    ACCOUNT_ALREADY_ACTIVATED:"Nalog već postoji",
    DEVICE_EVENTS:"Događaji uređaja",
    DEVICE_EVENTS_LOG_PULLED:"Povučeni zapisnik događaja za uređaj",
    EVENTS_PULL_DATE:"Vreme povučenih događaja:",
    DEVICE_EVENTS_REFRESH:"Povuci nove podatke o događajima",
    WEB_SOCKETS_CONNECTION_PROBLEM:" Problem sa vezom preko veb soketa. Pokušajte da osvežite stranicu.",
    INSTALLATION_DATE:"Datum instalacije mašine",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Topli vosak",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Pranje pod visokim pritiskom",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Pena za felne",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Snažna pena",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Zaustavi",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Pena pranje HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Pranje",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Vrhunska nega",
    INFO_TITLE:"Informacije",
    FOAM_WAX1:"Pena za vosak",
    POLISH1:"Polir",
    WAX1:"Vosak",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Detalji lokacije uspešno ažurirani",
    COMPANY:"Kompanija",
    FACILITY_HAS_CHANGER:"Da li imate menjač?",
    DISABLE_OFFLINE_ALARM:"Onemogući R2W alarme",
    ASIDE_WORKING_SCHEDULES:" Detalji aplikacije o lokaciji",
    TERMS_OF_SERVICE_R2W_TITLE:"Uslovi korišćenja Ready2Wash-a",
    TERMS_OF_SERVICE_R2W:"Uslovi korišćenja Ready2Wash-a",
    DATA_PROCESSING_TITLE:"Obrađeni podaci",
    PRIVACY_POLICY_TITLE:"Politika privatnosti",
    READY_TO_PAY_TERMS_OF_SERVICE:"Uslovi korišćenja Ready2Pay-a",
    TERMS_AND_SERVICES:"Uslovi i usluge",
    HOURLY: "Svaki sat",
    DAILY: "Dnevno",
    WEEKLY: "Nedeljno",
    MONTHLY: "Mesečno",
    YEARLY: "Godišnje",
    DELETE_ITEM_SUCCESS:"Uspešno ste obrisali izabran element",
    STATE: "Stanje",
    AVAILABILITY_STATUS_1: "Jedinica otvorena",
    AVAILABILITY_STATUS_2: "Jedinica zatvorena (odmor)",
    AVAILABILITY_STATUS_3: "Jedinica zatvorena (radno vreme)",
    AVAILABILITY_STATUS_4: "Jedinica zatvorena (kvar)",
    AVAILABILITY_STATUS_5: "Jedinica zatvorena (ostalo)",
    AVAILABILITY_VACUUMS_STATUS_1: "Usisivači nisu instalirani",
    AVAILABILITY_VACUUMS_STATUS_2: "Usisivači otvoreni",
    AVAILABILITY_VACUUMS_STATUS_3: "Usisivači zatvoreni (odmor)",
    AVAILABILITY_VACUUMS_STATUS_4: "Usisivači zatvoreni (radno vreme)",
    AVAILABILITY_VACUUMS_STATUS_5: "Usisivači zatvoreni (kvar)",
    AVAILABILITY_VACUUMS_STATUS_6: "Usisivači zatvoreni (ostalo)",
    ECOM_AMOUNT: "Ukupan Ecom za sve lokacije",
    CAPTURED: "Zabeleženo",
    DELETE_COMPANY_HISTORY_INFO:"Ova akcija će izbrisati sve podatke o izveštajima vaše kompanije. Ova akcija se ne može poništiti.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Da li ste sigurni da želite trajno izbrisati sve podatke o izveštajima?",
    VALUE_DATE: "Datum valute",
    KARCHER_EVENT_NAME_1: "Osnovni izmenjivač toplote regenerisan",
    KARCHER_EVENT_NAME_2: "Regeneracija osnovnog izmenjivača toplote završena",
    KARCHER_EVENT_NAME_3: "Materijal / serijski broj",
    KARCHER_EVENT_NAME_4: "Sistem je dezinfikovan",
    KARCHER_EVENT_NAME_5: "HP pumpa 1 dezinfikovana",
    KARCHER_EVENT_NAME_6: "HP pumpa 2 dezinfikovana",
    KARCHER_EVENT_NAME_7: "HP pumpa 3 dezinfikovana",
    KARCHER_EVENT_NAME_8: "HP pumpa 4 dezinfikovana",
    KARCHER_EVENT_NAME_9: "HP pumpa 5 dezinfikovana",
    KARCHER_EVENT_NAME_10: "Peraonica 1 zaključana",
    KARCHER_EVENT_NAME_11: "Peraonica 2 zaključana",
    KARCHER_EVENT_NAME_12: "Peraonica 3 zaključana",
    KARCHER_EVENT_NAME_13: "Peraonica 4 zaključana",
    KARCHER_EVENT_NAME_14: "Peraonica 5 zaključana",
    KARCHER_EVENT_NAME_15: "Peraonica 6 zaključana",
    KARCHER_EVENT_NAME_16: "Peraonica 7 zaključana",
    KARCHER_EVENT_NAME_17: "Peraonica 8 zaključana",
    KARCHER_EVENT_NAME_18: "Ažuriranje započeto",
    KARCHER_EVENT_NAME_19: "Ažuriranje završeno",
    KARCHER_EVENT_NAME_20: "Početak WS Reg",
    KARCHER_EVENT_NAME_21: "Kraj WS Reg",
    KARCHER_EVENT_NAME_22: "WS senzor 75%",
    KARCHER_EVENT_NAME_23: "Tehnička greška",
    KARCHER_EVENT_NAME_24: "Operativna greška",
    KARCHER_EVENT_NAME_25: "Jedinica uključena",
    KARCHER_EVENT_NAME_26: "Jedinica isključena",
    KARCHER_EVENT_NAME_27: "Kutija 1 zatvorena",
    KARCHER_EVENT_NAME_28: "Kutija 2 zatvorena",
    KARCHER_EVENT_NAME_29: "Kutija 3 zatvorena",
    KARCHER_EVENT_NAME_30: "Kutija 4 zatvorena",
    KARCHER_EVENT_NAME_31: "Kutija 5 zatvorena",
    KARCHER_EVENT_NAME_32: "Kutija 6 zatvorena",
    KARCHER_EVENT_NAME_33: "Kutija 7 zatvorena",
    KARCHER_EVENT_NAME_34: "Kutija 8 zatvorena",
    KARCHER_EVENT_NAME_35: "Stanica HP pumpe 1",
    KARCHER_EVENT_NAME_36: "Stanica HP pumpe 2",
    KARCHER_EVENT_NAME_37: "Stanica HP pumpe 3",
    KARCHER_EVENT_NAME_38: "Stanica HP pumpe 4",
    KARCHER_EVENT_NAME_39: "Stanica HP pumpe 5",
    KARCHER_EVENT_NAME_40: "Stanica HP pumpe 6",
    KARCHER_EVENT_NAME_41: "Stanica HP pumpe 7",
    KARCHER_EVENT_NAME_42: "Stanica HP pumpe 8",
    KARCHER_EVENT_NAME_43: "Gorionik",
    KARCHER_EVENT_NAME_44: "Ventilator gorionika",
    KARCHER_EVENT_NAME_45: "Pumpa za toplu vodu",
    KARCHER_EVENT_NAME_46: "Pumpa protiv smrzavanja",
    KARCHER_EVENT_NAME_47: "Osmoza pumpa",
    KARCHER_EVENT_NAME_48: "Podno grejanje",
    KARCHER_EVENT_NAME_49: "Grejanje creva",
    KARCHER_EVENT_NAME_50: "Mikro/čišćenje felni",
    KARCHER_EVENT_NAME_51: "Pumpa za pranje šasije",
    KARCHER_EVENT_NAME_52: "Pumpa za penjenje Booster",
    KARCHER_EVENT_NAME_53: "Usisivač 1",
    KARCHER_EVENT_NAME_54: "Usisivač 2",
    KARCHER_EVENT_NAME_55: "Usisivač 3",
    KARCHER_EVENT_NAME_56: "Usisivač 4",
    KARCHER_EVENT_NAME_57: "Usisivač 5",
    KARCHER_EVENT_NAME_58: "Usisivač 6",
    KARCHER_EVENT_NAME_59: "Usisivač 7",
    KARCHER_EVENT_NAME_60: "Usisivač 8",
    KARCHER_EVENT_NAME_61: "Usisivač 9",
    KARCHER_EVENT_NAME_62: "Usisivač 10",
    KARCHER_EVENT_NAME_63: "Usisivač 11",
    KARCHER_EVENT_NAME_64: "Usisivač 12",
    KARCHER_EVENT_NAME_65: "Pumpa za čišćenje felni",
    KARCHER_EVENT_NAME_66: "Mikro pumpa",
    KARCHER_EVENT_NAME_67: "Intenzivna pumpa",
    KARCHER_EVENT_NAME_68: "Turbina usisivača 1",
    KARCHER_EVENT_NAME_69: "Filter usisivača 1",
    KARCHER_EVENT_NAME_70: "Turbina usisivača 2",
    KARCHER_EVENT_NAME_71: "Filter usisivača 2",
    KARCHER_EVENT_NAME_72: "Turbina usisivača 3",
    KARCHER_EVENT_NAME_73: "Filter usisivača 3",
    KARCHER_EVENT_NAME_74: "Turbina usisivača 4",
    KARCHER_EVENT_NAME_75: "Filter usisivača 4",
    KARCHER_EVENT_NAME_76: "Turbina usisivača 5",
    KARCHER_EVENT_NAME_77: "Filter usisivača 5",
    KARCHER_EVENT_NAME_78: "Turbina usisivača 6",
    KARCHER_EVENT_NAME_79: "Filter usisivača 6",
    KARCHER_EVENT_NAME_80: "Turbina usisivača 7",
    KARCHER_EVENT_NAME_81: "Filter usisivača 7",
    KARCHER_EVENT_NAME_82: "Turbina usisivača 8",
    KARCHER_EVENT_NAME_83: "Filter usisivača 8",
    KARCHER_EVENT_NAME_84: "Turbina usisivača 9",
    KARCHER_EVENT_NAME_85: "Filter usisivača 9",
    KARCHER_EVENT_NAME_86: "Turbina usisivača 10",
    KARCHER_EVENT_NAME_87: "Filter usisivača 10",
    KARCHER_EVENT_NAME_88: "Turbina usisivača 11",
    KARCHER_EVENT_NAME_89: "Filter usisivača 11",
    KARCHER_EVENT_NAME_90: "Turbina usisivača 12",
    KARCHER_EVENT_NAME_91: "Filter usisivača 12",
    INSERT_TOKEN: "Unesite tokene i pokrenite uslugu",
    OPEN_SESSION: "Sesija je uspešno otvorena",
    IN_PROGRESS: "U toku ...",
    TOKEN_INSERTED: "Tokeni su uspešno uneseni",
    EXPIRED_SESSION: "Sesija je istekla",
    TWO_DIGIT_INTEGER_VALIDATION: "Koristite najviše dvocifreni ceo broj",
    KARCHER_OPERATION_COUNTER_1: "Stanica za pranje 1 HP pumpa",
    KARCHER_OPERATION_COUNTER_2: "Stanica za pranje 1 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_3: "Stanica za pranje 1 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_4: "Stanica za pranje 1 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_5: "Stanica za pranje 1 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_6: "Stanica za pranje 2 HP pumpa",
    KARCHER_OPERATION_COUNTER_7: "Stanica za pranje 2 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_8: "Stanica za pranje 2 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_9: "Stanica za pranje 2 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_10: "Stanica za pranje 2 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_11: "Stanica za pranje 3 HP pumpa",
    KARCHER_OPERATION_COUNTER_12: "Stanica za pranje 3 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_13: "Stanica za pranje 3 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_14: "Stanica za pranje 3 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_15: "Stanica za pranje 3 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_16: "Stanica za pranje 4 HP pumpa",
    KARCHER_OPERATION_COUNTER_17: "Stanica za pranje 4 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_18: "Stanica za pranje 4 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_19: "Stanica za pranje 4 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_20: "Stanica za pranje 4 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_21: "Stanica za pranje 5 HP pumpa",
    KARCHER_OPERATION_COUNTER_22: "Stanica za pranje 5 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_23: "Stanica za pranje 5 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_24: "Stanica za pranje 5 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_25: "Stanica za pranje 5 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_26: "Stanica za pranje 6 HP pumpa",
    KARCHER_OPERATION_COUNTER_27: "Stanica za pranje 6 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_28: "Stanica za pranje 6 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_29: "Stanica za pranje 6 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_30: "Stanica za pranje 6 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_31: "Stanica za pranje 7 HP pumpa",
    KARCHER_OPERATION_COUNTER_32: "Stanica za pranje 7 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_33: "Stanica za pranje 7 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_34: "Stanica za pranje 7 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_35: "Stanica za pranje 7 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_36: "Stanica za pranje 8 HP pumpa",
    KARCHER_OPERATION_COUNTER_37: "Stanica za pranje 8 hemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_38: "Stanica za pranje 8 hemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_39: "Stanica za pranje 8 hemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_40: "Stanica za pranje 8 hemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_41: "Pumpa za osmozu",
    KARCHER_OPERATION_COUNTER_42: "Generator tople vode",
    KARCHER_OPERATION_COUNTER_43: "Pumpa za zaštitu od smrzavanja",
    KARCHER_OPERATION_COUNTER_44: "WSO filter patrone",
    KARCHER_OPERATION_COUNTER_45: "Pumpa za grejanje stanice za pranje",
    KARCHER_OPERATION_COUNTER_46: "Pumpa za toplu vodu",
    KARCHER_OPERATION_COUNTER_47: "Grejač za penu u crevima",
    KARCHER_OPERATION_COUNTER_48: "Pumpa za pranje točkova",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulziona pumpa",
    KARCHER_OPERATION_COUNTER_50: "Intenzivna pumpa za penu",
    KARCHER_OPERATION_COUNTER_51: "Usisivač 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Usisivač 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Usisivač 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Usisivač 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Usisivač 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Usisivač 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Usisivač 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Usisivač 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Usisivač 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Usisivač 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Usisivač 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Usisivač 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Usisivač 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Usisivač 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Usisivač 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Usisivač 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Usisivač 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Usisivač 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Usisivač 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Usisivač 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Usisivač 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Usisivač 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Usisivač 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Usisivač 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Ispustite vodu iz kondenzacije iz kompresora",
    KARCHER_OPERATION_COUNTER_76: "Proverite sistem protiv smrzavanja",
    KARCHER_OPERATION_COUNTER_77: "Ventilator gorionika",
    KARCHER_OPERATION_COUNTER_78: "Pumpa za pojačanje pene",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Lista podataka je veća od 10000 stavki",
    KARCHER_POINT_NAME_1: "Praznik",
    KARCHER_POINT_NAME_2: "Ponedeljak",
    KARCHER_POINT_NAME_3: "Utorak",
    KARCHER_POINT_NAME_4: "Sreda",
    KARCHER_POINT_NAME_5: "Četvrtak",
    KARCHER_POINT_NAME_6: "Petak",
    KARCHER_POINT_NAME_7: "Subota",
    KARCHER_POINT_NAME_8: "Nedelja",
    KARCHER_POINT_NAME_9: "Usisivači Praznik",
    KARCHER_POINT_NAME_10: "Usisivači Ponedeljak",
    KARCHER_POINT_NAME_11: "Usisivači Utorak",
    KARCHER_POINT_NAME_12: "Usisivači Sreda",
    KARCHER_POINT_NAME_13: "Usisivači Četvrtak",
    KARCHER_POINT_NAME_14: "Usisivači Petak",
    KARCHER_POINT_NAME_15: "Usisivači Subota",
    KARCHER_POINT_NAME_16: "Usisivači Nedelja",
    KARCHER_POINT_NAME_17: "Osvetljenje Praznik",
    KARCHER_POINT_NAME_18: "Osvetljenje Ponedeljak",
    KARCHER_POINT_NAME_19: "Osvetljenje Utorak",
    KARCHER_POINT_NAME_20: "Osvetljenje Sreda",
    KARCHER_POINT_NAME_21: "Osvetljenje Četvrtak",
    KARCHER_POINT_NAME_22: "Osvetljenje Petak",
    KARCHER_POINT_NAME_23: "Osvetljenje Subota",
    KARCHER_POINT_NAME_24: "Osvetljenje Nedelja",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR kod",
    ACCEPT_TERMS_AND_CONDITIONS: "Prihvati uslove korišćenja",
    CREATE_AND_PRINT_VOUCHERS: "Kreiraj i štampaj vaučere",
    CODE_PREFIX_QUESTION: "Prefiks kod nije unet",
    CODE_PREFIX_QUESTION_TEXT: "Želite li da nastavite bez prefiks koda?",
    ISSUED_DATE: "Datum izdavanja",
    DAYS_LABEL: "Rok važenja vaučera (u danima)",
    VOUCHER_VALIDITY_DAYS: "Rok važenja vaučera (dani)",
    VALIDATION_ONLY_NUMBERS: "Dozvoljen je unos samo brojeva",
    REPRINT_VOUCHERS: "Štampaj kopiju vaučera",
    EXPIRY_DATE: "Važi do",
    VOUCHER_EXPIRATION_DAYS_UPDATED: "Broj dana važenja vaučera je uspešno ažuriran"
  });
})();
(function() {
  "use strict";

  angular.module("sempraWebapp").constant("slTranslations", {
    MESSAGE:"Sporočilo",
    ERROR_TITLE:"Napaka",
    ERROR_MESSAGE:"Prišlo je do napake med izvajanjem operacije.",
    ERROR_LOGIN:"Napaka med prijavljanjem. Elektronski naslov ni veljaven ali se ne ujema z geslom. Prosimo, poskusite ponovno.",
    ERROR_LOGIN_ROLE:"Vloga za trenutno blagovno znamko aplikacije ni veljavna",
    OK:"OK",
    CANCEL:"Prekliči",
    YES:"Da",
    NO:"Ne",
    FROM:"Od",
    TO:"Do",
    DELETE:"Izbriši",
    SIGN_OUT:"Odjavi se",
    NAME:"Ime",
    DATE:"Datum",
    PIECES:"kom",
    HOURS:"Ure",
    DAYS:"Dnevi",
    MONTH:"Mesec",
    MONTHS:"Meseci",
    YEAR:"Leto",
    BOX:"Pralno mesto",
    SEARCH:"Išči",
    ALL_USERS:"Vsi uporabniki",
    ARE_YOU_SURE:"Ali ste prepričani?",
    BACK:"Nazaj",
    AMOUNT:"Znesek",
    DESCRIPTION:"Opis",
    FORGOT_PASSWORD_ERROR_MSG:"Prišlo je do napake. Preverite vaš elektronski naslov in poskusite ponovno.",
    REQUIRED_FIELD:"Polje je obvezno",
    LOGOUT_TITLE:"Ali ste prepričani, da se želite odjaviti?",
    LOGOUT_MSG:"Vse ne shranjene spremembe bodo izbrisane.",
    ACTIVATION_ACCOUNT:"Uspešno ste aktivirali račun",
    UNKNOWN_ERRROR_NOTIFICATION:"Prišlo je do neznane napake.",
    CONTINUE:"Nadaljujte",
    DATA_NOT_AVAILABLE:"Podatki niso najdeni.",
    SELECT:"Izberi",
    SELECT_CURRENCY:"Izberite valuto",
    UPLOAD:"Pošlji",
    PHONE:"Telefon",
    WEBSITE:"Spletna stran",
    WORKING_HOURS:"Delovni čas",
    INSERT:"Vnesi",
    TEXT:"Besedilo",
    CREATED:"Ustvarjeno",
    VALID_UNTIL:"Veljavno do",
    SAVE:"Shrani",
    TOKENS:"Žetoni",
    DELETE_COMPANY_HISTORY:"Trajno izbriši zgodovino podjetja?",
    DELETE_COMPANY_HISTORY_MESSAGE:"OPOZORILO: Po pritisku na ta gumb bodo vse transakcije iz vaše avtopralnice trajno izbrisane! Teh podatkov po brisanju ni mogoče obnoviti. ",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Ali ste prepričani, da želite trajno izbrisati vse podatke o transakcijah? ",
    HISTORY_SUCCESSFULY_DELETED:"Zgodovina je uspešno izbrisana",
    HELP:"Pomoč",
    VALUE:"Vrednost",
    ACTIVATING_ACCOUNT_ERROR:"Prišlo je do napake med aktiviranjem vašega računa R2W. Prosimo, poskusite ponovno in če bo težava še vedno prisotna, kontaktirajte support@ready2wash.com.",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Dobrodošli v avtopralnici Kärcher",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Dobrodošli na R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Prosimo, vpišite vaše novo geslo in ga potrdite za aktiviranje vašega računa R2W. Samodejno boste prijavljeni v sistem po uspešni verifikaciji gesla.",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Vaše uporabniške podatke lahko spremenite kasneje v aplikaciji.",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Avtopralnica Kärcher ",
    RESET_PASSWORD_WELCOME_MSG:"Avtopralnica R2W",
    RESET_PASSWORD_WELCOME_MSG_2:"Vnesite novo geslo in ga potrdite, da ponastavite staro geslo. Po uspehu boste samodejno prijavljeni v aplikacijo",
    RESET_PASSWORD_WELCOME_MSG_3:"Uporabniške nastavitve lahko pozneje spremenite v aplikaciji",
    ENTER_NEW_PASSWORD:"Vnesite novo geslo.",
    REPEAT_NEW_PASSWORD:"Ponovite geslo.",
    PASSWORD_MIN_LENGTH:"Geslo mora imeti vsaj 8 znakov.",
    PASSWORD_MAX_LENGHT:"Geslo ne sme imeti več kot 32 znakov.",
    PASSWORD_PATTERN:"Geslo mora vsebovati vsaj eno veliko in eno malo črko.",
    PASSWORD_MATCH:"Gesli nista enaki.",
    ACTIVATE:"Aktiviraj",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Uspešno ste poslali zahtevo. Prosimo, preverite e-pošto za potrditveno sporočilo",
    VALIDATION_REQUIRED:"Obvezno polje",
    VALIDATION_EMAIL:"Neveljaven elektronski naslov.",
    VALIDATION_INTEGER_NUMBER:"Vrednost mora biti celo število.",
    VALIDATION_HOURS_VALUE:"Vrednost mora biti med 0 in 23.",
    VALIDATION_MINUTES_VALUE:"Vrednost mora biti med 0 in 59.",
    VALIDATION_NOT_A_DATE:"Vnesena vrednost ni datum.",
    VALIDATION_FROM:"Od datuma, večjega od",
    VALIDATION_TO:"Do danes manj kot od",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Ta podatek že obstaja v bazi podatkov.",
    PASSWORD_VALIDATION_PATTERN_NEW:"Geslo mora vsebovati vsaj eno veliko črko in eno številko. Prazna polja niso dovoljena.",
    VALIDATION_PERCENT_VALUE:"Vrednost mora biti med 1 in 999.",
    NUMBERS_ONLY_100:"Štetje do 100 ",
    NUMBERS_ONLY_1000:"Štetje do 1000",
    POSITIVE_NUMBERS_ONLY:"Samo pozitivno število",
    GRID_PAGER_PAGE:"Stran",
    GRID_PAGER_ROWS_PER_PAGE:"Vrstic na stran",
    GRID_PAGER_PAGE_OF:"od",
    BREAD_CRUMBS_HOME:"Začetna stran",
    BREAD_CRUMBS_DASHBOARD_TECH:"Pregled pralnic",
    BREAD_CRUMBS_DETAILS:"Podrobnosti",
    BREAD_CRUMBS_SETTINGS:"Nastavitve",
    BREAD_CRUMBS_WORKING_HOURS:"Delovni čas",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Skupna vsota denarja po dnevih",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Povprečna vsota denarja po urah",
    BREAD_CRUMBS_NEW_USER_GROUP:"Ustvari uporabniško skupino",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Uredi uporabniško skupino",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Ustvari predlogo oglasa",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Uredi predlogo oglasa",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Ustvari oglas",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Uredi oglas",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Periodični pregled financ",
    LOGIN:"Prijava",
    EMAIL:"Elektronski naslov",
    PASSWORD:"Geslo",
    LANGUAGE:"Jezik",
    FORGOT_PASSWORD:"Pozabljeno geslo?",
    SUBMIT:"Potrdi",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Število alarmov v teku:",
    HEADER_VIEW_ALL_ALARMS:"Poglej vse alarme ... ",
    HEADER_MY_ACCOUNT:"Moj račun",
    HEADER_ACCOUNT_MANAGEMENT:"Urejanje računa",
    ACCOUNT_ALREADY_EXIST:"Elektronski naslov že obstaja.",
    NEWSLETTER_CONFIRMATION:"Pošlji obvestilo po e-pošti za stanje alarmov",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Dnevni pregled financ",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Pregled pralnic",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Nadzorna plošča",
    ASIDE_MENU_ALARMS:"Sporočila",
    ASIDE_MENU_FACILITIES:"Pralnice",
    ASIDE_MENU_REPORTS:"Poročila",
    ASIDE_MENU_REPORT:"Izbrano poročilo",
    ASIDE_MENU_LOYALTY:"Zvestoba",
    ASIDE_MENU_USER_GROUPS:"Uporabniške skupine",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodični pregled",
    ASIDE_MENU_MANAGING_TOKENS:"Upravljanje žetonov",
    ASIDE_MENU_NEWS:"Novosti",
    DAILY_FINANCES_TOTAL_MONEY:"Skupna vsota denarja",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Skupna vsota denarja za vse pralnice",
    DAILY_FINANCES_TOTAL_COINS:"Skupaj porabljenih kovinskih žetonov",
    DAILY_FINANCES_DOWNLOAD_CSV:"Prenos CSV",
    DAILY_FINANCES_ONLINE:"R2W (na spletu)",
    DAILY_FINANCES_OFFLINE:"Gotovina",
    DAILY_FINANCES_CHANGER:"Gotovina v menjalniku",
    DAILY_FINANCES_COINS:"Žetoni",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Vrsta poročila",
    REPORTS_CHOOSE_FACILITY:"Izberi pralnico",
    REPORTS_PERIOD_1:"Obdobje 1 -",
    REPORTS_PERIOD_2:"Obdobje 2 -",
    MONEY_BY_DATE_REPORT:"Skupna vsota denarja po dnevih",
    R2W_BY_DATE_REPORT:"Skupna vsota plačil R2W žetoni (na spletu) po dnevu",
    COINS_BY_DATE_REPORT:"Skupno število porabljenih žetonov po dnevih",
    AVG_MONEY_BY_HOUR_REPORT:"Povprečna vsota denarja po urah",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Povprečna vsota denarja po dnevih",
    AVG_MONEY_BY_BOX_REPORT:"Poraba po pralnih mestih",
    COMPARE_PERIODS_REPORT:"Vzporedni prikaz po pralnici",
    TOTAL_USERS_BY_GROUP:"Skupno število uporabnikov  R2W po dnevih",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"uporabnikov",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"obiski",
    VISITS_COUNT_REPORT:"Število uporabnikov aplikacije R2W na število obiskov ",
    LOYALTY_PER_DAY_REPORT:"Število porabljenih lokalnih žetonov na dan",
    LOYALTY_PER_PAYMENT_METHOD:"Dani lokalni žetoni glede na plačilno sredstvo",
    VISITS:"Obiski",
    VISIT:"Obisk",
    TOTAL_SPENT_MONEY:"Skupni dohodek",
    MONEY:"Denar",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Skupni dohodek za obdobje",
    DOWNLOAD_CSV:"Prenos CSV",
    TOTAL_SPENT_COINS:"Skupno število porabljenih žetonov",
    TOTAL_USERS:"Skupno število uporabnikov",
    TOTAL_CREDIT_GIVEN:"Skupni porabljeni lokalni žetoni",
    EUROKEY_BY_DATE_REPORT:"Skupni znesek plačil z evro ključem",
    TOTAL_SPENT_EUROKEY:"Skupno porabljeno",
    SELECT_TYPE_OF_REPORT:"Izbrati morate vrsto poročila :)",
    NUMBER_OF_VISITS_TITLE:"Število obiskov",
    NUMBER_OF_USERS_TITLE:"Število uporabnikov",
    PIECES_TITLE:"Kosi",
    TOTAL_VISITS:"Skupaj obiskov",
    TOKENS_TITLE:"žetone",
    SEARCH_USERS_NO_RESULTS:"Ni uporabnikov za iskalni pogoj",
    SEARCH_USERS:"Iskanje uporabnikov",
    SEARCH_TELEPHONES:"Iskanje uporabnikov po mobilni telefonski številki",
    ADD_USER_TO_GROUP:"Dodaj uporabnika v skupino",
    REMOVE_USER_FROM_GROUP:"Izbriši uporabnika iz skupine",
    USER_GROUP_NAME_REQUIRED:"Ime uporabniške skupine je obvezno polje.",
    USER_GROUP_NAME:"Ime uporabniške skupine",
    USER_GROUPS_OVERVIEW:"Pregled uporabniških skupin",
    USER_COUNT:"Število uporabnikov",
    NEW_USER_GROUP:"Ustvari novo uporabniško skupino",
    DELETE_USER_GROUP:"Izbriši uporabniško skupino",
    UPDATE_USER_GROUP:"Uredi uporabniško skupino",
    DELETE_USER_GROUP_ERROR:"Prišlo je do napake med brisanjem izbrane uporabniške skupine. Prosimo, poskusite ponovno ali kontaktirajte tehnično podporo ...",
    CONFIRM_DELETE_USER_GROUP:"Ali ste prepričani, da želite izbrisati izbrano uporabniško skupino?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Akcije zvestobe, h katerim je bila dodeljena skupina, ne bodo več veljavne za uporabnike iz izbrisane skupine.",
    GROUP_NAME_MAX_LENGTH:"Ime skupine mora biti krajše od 255 znakov.",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Uporabnik je že v tej skupini.",
    MISSING_USER:"Manjka uporabnik",
    USER_NOT_ON_LIST:"Uporabnik ni na seznamu aktivnih uporabnikov. Preverite, ali je e-poštni naslov veljaven in poskusite znova.",
    UPLOAD_USER_GROUP:"Naložite seznam uporabniških skupin iz datoteke *.csv",
    UKNOWN_USERS:"Seznam neznanih uporabnikov",
    CAMPAIGN_TEMPLATE_RULE:"Pravilo oglasa",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Prišlo je do napake pri brisanju izbrane predloge oglasa. Prosimo, poskusite ponovno ali kontaktirajte tehnično podporo ...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Ali ste prepričani, da želite izbrisati izbrano predlogo oglasa?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Ali ste prepričani, da želite izbrisati izbrano predlogo oglasa?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Pregled predlog oglasa",
    DELETE_CAMPAIGN_TEMPLATE:"Izbriši predlogo oglasa",
    UPDATE_CAMPAIGN_TEMPLATE:"Uredi predlogo oglasa",
    CREATE_CAMPAIGN_TEMPLATE:"Ustvari novo predlogo oglasa",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Ime predloge oglasa je obvezno polje.",
    CAMPAIGN_TEMPLATE_NAME:"Ime predloge oglasa",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Obvezno polje",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"Podari",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"Dodaten čas",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Najprej izberite tip. Pralna mesta ali Mali stroji.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Izbriši pravilo",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"ure",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minute",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Novo pravilo po številu obiskov",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Novo pravilo po količini porabljenih žetonov",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Novo pravilo po dnevih v tednu",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Dodaj novo pravilo",
    CAMPAIGN_TEMPLATE_RULE_1:"Vseh",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Vseh",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"žetonov, porabljenih v manj kot",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"obiskov v manj kot",
    CAMPAIGN_TEMPLATE_RULE_3:"dnevi",
    CAMPAIGN_TEMPLATE_RULE_4:"žetoni",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Seznam pravil je prazen.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum ne more biti v preteklosti",
    DELETE_CAMPAIGN_ERROR:"Prišlo je do napake pri brisanju izbranega oglasa. Prosimo, poskusite ponovno ali kontaktirajte tehnično podporo ...",
    CONFIRM_DELETE_CAMPAIGN:"Ali ste prepričani, da želite izbrisati izbran oglas?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W ni odgovoren za uporabniško izkušnjo, ki jo povzroči ta dejanje.",
    CAMPAIGNS_OVERVIEW:"Pregled oglasov",
    DELETE_CAMPAIGN:"Izbriši oglas",
    UPDATE_CAMPAIGN:"Uredi oglas",
    CREATE_CAMPAIGN:"Ustvari nov oglas",
    CAMPAIGN_ACTIVE:"Aktivna",
    CAMPAIGN_TEMPLATE:"Predloga",
    CAMPAIGN_GROUPS:"Skupine",
    CAMPAIGN_ALL_USERS:"Vsi uporabniki",
    CAMPAIGN_NAME:"Ime oglasa",
    CAMPAIGN_NAME_REQUIRED:"Ime oglasa je obvezno polje.",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Uporabniki blizu praga bonusa po dnevu",
    MESSAGE_TO_USERS:"Sporočilo filtriranim uporabnikom",
    SEND_MESSAGE:"Pošlji sporočilo",
    THRESHOLD:"Prag",
    TYPE:"Tip",
    TOTAL_MONEY_SPENT:"Skupna vsota porabljenega denarja v oglasu",
    NUMBER_OF_VISITS:"Skupno število obiskov v času oglasa",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Sporočilo mora imeti vsaj 10 znakov.",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Sporočilo ne sme imeti več kot 350 znakov.",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Besedilo sporočila je obvezno.",
    TECHNOLOGY:"Tehnologija",
    TAP_WATER:"Voda iz pipe",
    REVERSE_OSMOSIS:"Reverzna osmoza",
    SOFTENED_WATER:"Mehka voda",
    DOSER:"Dozirnik",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Zadnja sinhronizacija",
    NO_OF_CURRENT_ALARMS:"Število trenutnih alarmov",
    NO_OF_CURRENT_WARNINGS:"Število trenutnih opozoril",
    WEATHER:"Vreme",
    BOXES_WORK_HOURS_COUNTERS:"Delovne ure pralnih mest",
    BOX_TOTAL_HOURS:"Skupno število ur",
    BOX_SERVICE_HOURS:"Skupno število ur (servis)",
    BOX_COUNTER_HOURS:"ure",
    ALARMS_AND_WARNINGS:"Alarmi in opozorila",
    FILTER_AND_BOILER:"Filter in grelnik vode",
    FILTER_TOTAL_DAYS:"Delovni dnevi filterja",
    BOILER_TOTAL_DAYS:"Delovni dnevi grelnika vode",
    DAYS_UNIT:"dni",
    SOFTENER:"Mehčalec",
    MANUAL_COLD_DRAIN:"Ročni zimski izpust",
    EL_COLD:"El. zimski",
    DRAIN:"izpust",
    TAP:"pipa",
    WASTE:"Odpad",
    OSMOSIS:"osmoza",
    DEMI_WATER:"Demineralizirana voda",
    EL_RINSE:"El. m. izpiranja",
    BOILER:"Grelnik vode",
    EL_WAX:"El. m. voska",
    FLOOR_HEATING:"Talno gretje",
    DOSER_TANK:"Dozirna posoda",
    EL_WASH:"El. m. pranja",
    DETERGENT:"Detergent",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Posodobi nastavitve",
    GENERAL_SETTINGS:"Splošne nastavitve",
    LIGHTS:"Luči",
    GROUPS:"Skupine",
    ANTI_FREEZE:"Proti zmrzovanje",
    AUTO:"Automatsko",
    MANUAL:"Ročno",
    ON:"Vključeno",
    OFF:"Izključeno",
    TEMPERATURE:"Temperatura",
    UPDATE_DEVICE:"Posodobi nastavitve pralnice",
    BOX_CLEAN_HOURS:"Števec delovnih ur (čiščenje pr. mest)",
    GROUP_COUNTERS:"Števci skupin",
    RESET:"Ponastavi",
    CASH_COUNT:"Števec kovancev",
    COINS_COUNT:"Števec žetonov",
    EUROKEY_COUNT:"Števec evro ključa",
    DOSER_WORK:"Delovni čas dozirnika (sek.)",
    DOSER_PAUSE:"Čas pavze dozirnika (sek.)",
    DELAY_BFV:"Zamuda BFV (ms)",
    DELAY_6M1:"Zamuda 6M1 (ms)",
    DELAY_LPS:"Zamuda LPS (ms)",
    RESET_CASH_COUNT_ALL:"Ponastavitev vseh števcev kovancev",
    RESET_COINS_COUNT_ALL:"Ponastavitev vseh števcev žetonov",
    RESET_EUROKEY_COUNT_ALL:"Ponastavitev vseh števcev evro ključa",
    FACILITY_DETAILS:"Podrobnosti pralnice",
    FACILITY_NAME:"Ime pralnice",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Uspešno ste naložilii sliko.",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Uspešno ste spremenili podatke.",
    CONNECTED:"povezan",
    DISCONNECTED:"Prekinjena povezava",
    OFFLINE:"Brez povezave",
    MESSAGES_FILTER:"Filter sporočil",
    FACILITY:"Pralnica",
    APPLY:"Uporabi",
    TIME:"Čas",
    LOCATION:"Lokacija",
    ACKNOWLEDGED:"Sprejeto",
    FILTERED_MESSAGES:"Filtrirana sporočila",
    ACK:"Sprejeto",
    NOT_ACK:"Ni sprejeto",
    ALL:"Vsi",
    ALL_FACILITIES:"Vse pralnice",
    ENTER_DATE_PLACEHOLDER:"Vnesite datum",
    OP_NESTANAK_NAPONA:"Manjka napetost na indikatorju faze 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Napaka na črpalki MZS",
    OP_UPR_NAPON_24VAC_GRE:"Krmilna napetost 24VAC napaka -5F1.1'",
    OP_MIN_NIVO_PITKA_VODA:"Prazen rezervoar za pitno vodo.",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Črpalka pitne vode, napaka v motorskem zaščitnem stikalu.",
    OP_MIN_NIVO_OMEKS_VODE:"Prazen rezervoar za mehko vodo.",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Črpalka mehke vode, napaka v motorskem zaščitnem stikalu.",
    OP_MIN_NIVO_DEMIN_VODE:"Prazen rezervoar za demineralizirano vodo.",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Črpalka demineralizirane vode, napaka v motorskem zaščitnem stikalu.",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Črpalka za reverzno osmozo, napaka v motorskem zaščitnem stikalu.",
    OP_BOJLER_GRESKA_MZS:"Napaka na grelniku vode.",
    OP_CRPKA_PRASKA_GRE_MZS:"Črpalka za prašek, napaka v motorskem zaščitnem stikalu.",
    OP_DOZATOR_PRASKA_GRE_MZS:"Napaka na dozirniku praška.",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Napaka na vibratorju za doziranje praška.",
    OP_MIN_PRASAK_TON_ALARM:"Prazen rezervoar za prašek.",
    OP_USIS_KOV_TURBINA_GRESKA:"Turbina za izsesavanje kovancev, napaka v motorskem zaščitnem stikalu.",
    OP_FILTER_VODE_ZACEPLJEN:"Zamašen filter vode",
    OP_VISKTL_RESET_SATI_RADA:"Servis visokotlačne črpalke",
    OPW_VISKTL_RESET_SATI_RADA:"Servis visokotlačne črpalke",
    OP_FILTER_DANI_RADA:"Servis filtra",
    OP_BOJLER_DANI_RADA:"Servis grelnika vode",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm za visokotlačno pumpo",
    OPW_ALARM_FILTER_SERVIS:"Alarm za servis filtra",
    OPW_ALARM_BOJLER_SERVIS:"Alarm za servis grelnika vode",
    HAS_MEMBERS:"Izbrana skupina ima člane in jih ni mogoče izbrisati. Člane je treba najprej izbrisati.",
    PERIODIC_SUMMARY_FOR:"PERIODIČNO SKUPNO POROČILO ZA",
    PERIODIC_SUMMARY_REPORTS:"Periodična skupna poročila",
    DATE_RANGE:"Časovno obdobje",
    FINANCIAL_REPORT:"Finančno poročilo",
    GROSS_INCOME:"Bruto dohodek",
    GROSS_INCOME_SUM:"Vsota bruto dohodka",
    COMMISSION_FEE:"Provizija",
    NET_INCOME:"Neto dohodek (za plačilo)",
    COMMISSION_FEE_DETAILS:"Vključuje bančne/PayPal provizije za transakcije ali provizije za storitev SMS.",
    LOYALTY_CREDITS_REPORT:"Poročilo programa zvestobe",
    LOYALTY_GIVEN:"Dani lokalni žetoni",
    LOYALTY_USED:"Porabljen lokalni žetoni",
    LOYALTY_SOLD:"Lokalni žetoni naloženi",
    LOYALTY_TOTAL:"Skupno",
    LOYALTY_CURRENT_MONTH:"Tekoči mesec",
    SOMETHING_WENT_WRONG:"Ups, prišlo je do napake :-(",
    MISSING_PAGE:"Oprostite, nismo mogli najti te strani.",
    TRY_AGAIN:"Poskusite ponovno.",
    DEFAULT_ERROR_NAME:"Prišlo je do neznane napake.",
    DEFAULT_ERROR_DESCRIPTION:"Prosimo, poskusite ponovno.",
    MY_ACCOUNT_DETAILS:"Podrobnosti uporabniškega računa",
    SAVE_CHANGES:"Shrani spremembe",
    USERNAME:"Uporabniško ime",
    FIRST_NAME:"Ime",
    LAST_NAME:"Priimek",
    USER_ROLE:"Uporabniška vloga",
    OLD_PASSWORD:"Staro geslo",
    NEW_PASSWORD:"Novo geslo",
    OLD_PASSWORD_REQUIRED:"Polje za staro geslo je obvezno.",
    NEW_PASSWORD_REQUIRED:"Polje za novo geslo je obvezno.",
    NEW_PASSWORD_REPEAT:"Polje za ponovitev novega gesla je obvezno.",
    NEW_PASSWORD_NOT_MATCH:"Staro in novo geslo nista enaka.",
    PASSWORD_DIFFERENT_VALIDATION:"Novo geslo mora biti drugačno od starega.",
    PASSWORD_MIN_CHAR:"Vaše geslo mora imeti vsaj 8 znakov.",
    PASSWORD_MAX_CHAR:"Vaše geslo ne sme imeti več kot 32 znakov.",
    PASSWORD_PATTERN_VALIDATION:"Geslo mora vsebovati vsaj eno številko, eno malo in eno veliko črko.",
    ACCOUNT_MANAGEMENT:"Vodenje računa",
    NOT_ACTIVE:"Neaktiven",
    ASSIGN_ROLE:"Dodeli vlogo",
    UPDATE:"Posodobi",
    ADD_NEW_ACCOUNT:"Dodajanje novega računa",
    EMAIL_REQUIRED:"Elektronski naslov je obvezen.",
    EMAIL_NOT_VALID:"Elektronski naslov ni veljaven.",
    ADD_NEW_USER_TEXT:"Na vpisan elektronski naslov vam bomo poslali elektronsko sporočilo z bližnjico za aktiviranje.",
    UPDATE_USER_NOTIFICATION:"Uspešno ste posodobili podatke.",
    CHANGED_PASSWORD_NOTIFICATION:"Uspešno ste spremenili geslo.",
    UPDATE_USER_GROUP_NOTIFICATION:"Uspešno ste spremenili ime skupine.",
    CREATE_USER_GROUP_NOTIFICATION:"Uspešno ste ustvarili skupino.",
    DETELE_USER_GROUP_NOTIFICATION:"Uspešno ste izbrisali skupino.",
    EMPTY_GROUP_LIST_MSG:"Ni ustvarjenih skupin. Začnite z ustvarjanjem skupine",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Uspešno ste izbrisali uporabnika iz skupine.",
    ADD_USER_TO_GROUP_NOTIFICATION:"Uspešno ste dodali uporabnika v skupino.",
    ADD_USER_NOTIFICATION:"Uspešno ste dodali novega uporabnika.",
    DELETE_USER_NOTIFICATION:"Uspešno ste izbrisali uporabnika.",
    RESEND_USER_VERIFICATION_EMAIL:"Uspešno ste znova poslali potrditveno e-pošto",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Prosimo, da za ustvarjanje nove uporabniške skupine vnesete ime skupine.",
    DELETE_USER:"Brisanje uporabnika",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Ali ste prepričani, da želite izbrisati uporabnika iz skupine?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Spoštovani R2W uporabnik, če nas boste obiskali v času akcije tega meseca, boste na vaš račun prejeli dodatni bonus.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Pravilo oglasa glede na število obiskov",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Pravilo oglasa glede na porabljene žetone",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Pravilo oglasa glede na dneve v tednu",
    REMOVE_CAMPAIGN_RULE_TITLE:"Brisanje pravila oglasa.",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Ali ste prepričani, da želite izbrisati pravilo oglasa?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Uspešno ste ustvarili novo pravilo oglasa.",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Uspešno ste aktivirali oglas.",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Ni ustvarjenih oglasov. Začnite z ustvarjanjem oglasa",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Uspešno ste poslali sporočilo.",
    COMPANY_ACCOUNTS:"Računi podjetja",
    BUSSINESS_INVOICES_LIST:"Moji B2B računi",
    LOCALE_TOKEN:"Lokalni žeton",
    R2W:"Svetovni R2W žeton",
    START_MONTH:"Začetni mesec",
    END_MONTH:"Konec meseca",
    TOKEN_TYPE:"Vrsta žetonov",
    TOKEN_NUMBER:"Številka žetona",
    NOTHING_TO_DISPLAY:"* Nič za prikaz",
    CREATE_INVOICE:"Ustvari račun",
    INVOICE:"Račun",
    INVOICES:"Računi",
    EDIT_INVOICE:"Uredi račun",
    UPDATE_INVOICE_NOTIFICATION:"Uspešno ste spremenili status računa v 'v teku'",
    CURRENT_CHARGES:"Stroški za tekoče obdobje",
    PAYMENTS_ON_HOLD:"Računi v obdelavi",
    FOR_INVOICING:"Za izdajo",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Poskušate preklicati izdajo računa.",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Ali ste prepričani, da želite preklicati račun?",
    INVOICING_NOTIFICATION_HEADER:"Poskušate poslati račun.",
    INVOICING_NOTIFICATION_TEXT:"Ali ste prepričani, da želite poslati račun?",
    SENT_INVOICE_NOTIFICATION:"Uspešno ste poslali račun",
    CANCELED_INVOICE_NOTIFICATION:"Uspešno ste preklicali račun",
    INVOICE_DESCRIPTION_TEXT:"Račun za",
    INVOICE_STATE:"Status računa",
    INVOICE_NUMBER:"Številka računa",
    INVOICE_TOTAL:"Skupno",
    SELECT_YEAR:"Izberi leto",
    DOWNLOAD:"Prenesi PDF",
    INVOICE_NUMBER_HEADER:"Nameravate poslati račun s številko",
    INVOICE_PAYMENT_CONFIRMATION:"Nameravate potrditi plačilo računa s številko",
    INSERT_INVOICE_NUMBER:"-- Vnesi številko računa",
    INVOICED_WARNING:"Elektronsko sporočilo ni poslano. Prosimo, počakajte ...",
    SEND_INVOICE:"Pošlji",
    INVOICE_ALL:"Vsi",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Za R2W",
    PAYMENT_REQUEST:"Zahteva za plačilo",
    PAYMENT_REQUEST_STATE:"Stanje zahteve za plačilo",
    PAYMENT_REQUEST_NUMBER:"Številka zahtevka za plačilo",
    FOR_PAYMENT_REQUEST:"Za zahtevek za plačilo",
    PAYMENT_REQUEST_ON_HOLD:"Zahteva za plačilo v obdelavi",
    DOWNLOAD_INVOICE:"Prenesite račun",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknite za možnosti prenosa",
    B2B_SPEC:"B2B Specifikacija",
    B2C_SPEC:"B2C Specifikacija",
    DOWNLOAD_PAYMENT_REQUEST:"Prenesite zahtevo za plačilo",
    LOYALTY_PREVIEW:"Pregled oglasa",
    ACTIVATED:"Aktiven",
    RUNNING:"Traja",
    NOT_ACTIVATED:"Ni aktiven",
    FINISHED:"Končan",
    DEPRECATED:"Zastarel",
    UPCOMING:"Prihajajoč",
    NONE:"Manjka",
    STARTED:"Začet",
    ENDS:"Se končuje",
    DEDICATED:"Namenjen",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Poskušate aktivirati",
    CAMPAIGN:"oglas",
    SEND_MESSAGE_NOTIFICATION:"Ali želite poslati sporočilo vsem uporabniškim skupinam",
    DIVISIBLE_TO_NUMBER:"Številka mora biti deljiva s ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Vrsta naprave",
    LISTENER:"Majhni stroji",
    BRIDGE:"Pralna mesta",
    WASH_BOXES:"Pralna mesta",
    VACUUMS:"Sesalniki",
    SAVE_NEWS:"Shrani novico",
    CREATE_NEW_NEWS:"Ustvari novo novico",
    HISTORY_OF_ALL_NEWS:"Zgodovina vseh novic",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Vpiši ime pralnice.",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Dodaj novo pralnico.",
    NEWS_TEXT:"Besedilo novice",
    NEWS_TITLE:"Naslov novice",
    DELETE_NEWS_CONFIRMATION:"želite izbrisati novico?",
    NEWS_DELETE_NOTIFICATION:"Uspešno ste izbrisali novico.",
    NEWS_SAVE_NOTIFICATION:"Uspešno ste shranili novico.",
    NEWS_CREATION_DATE:"Datum nastanka",
    NO_TITLE:"Ni naslova",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Besedilo novice ne sme biti daljše od 255 znakov.",
    NEWS_TEXT_REQUIRED_VALIDATION:"Besedilo novice je obvezno.",
    NEWS_TITLE_REQUIRED_VALIDATION:"Naslov novice je obvezen.",
    DEACTIVATE:"Onemogoči",
    ASIDE_MENU_LOCAL_TOKENS:"Lokalni žetoni",
    CREATE_NEW_LOCAL_TOKENS:"Izdaja novih lokalnih žetonov",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Vnesite elektronski naslov uporabnika in število žetonov, ki mu jih želite izdati.",
    CREATE_TOKENS:"Izdaj žetone",
    MINIMUM_ONE_TOKEN:"Vrednost mora biti večja od 0.",
    CUSTOMER_EMAIL:"Uporabnikov elektronski naslov",
    AMOUNT_OF_TOKENS:"Število žetonov",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Uspešno ste izdali lokalne žetone:",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Prišlo je do napake pri izdaji žetonov. Prosimo, preverite uporabnikov elektronski naslov in poskusite ponovno.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Pregled izdanih lokalnih žetonov",
    ISSUED_AT:"Čas izdaje",
    ISSUED_BY:"Izdal",
    CODE:"Koda",
    REDEEMED_BY:"Izkoristil",
    REDEEMED_AT:"Čas",
    ASIDE_MENU_VOUCHERS:"Kuponi",
    PRINT:"Tiskanje",
    VOUCHERS_OVERVIEW:"Pregled kuponov",
    CREATE_NEW_VOUCHERS:"Ustvari nove kupone",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Ustvari novo serijo kuponov z vnosom števila žetonov na kupon, količine kuponov v seriji in predpone kode za serijo",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Število žetonov na kupon",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Dovoljeno je dodati med 1 in 100 žetoni na kupon.",
    NUMBER_OF_NEW_VOUCHERS:"Količina kuponov v seriji",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Dovoljeno je ustvariti med 1 in {{size}} kuponov v eni seriji.",
    NEW_VOUCHERS_PREFIX:"Predpona kode kuponov v seriji",
    VALIDATION_VOUCHER_PREFIX:"Predpona kode mora biti natanko 4 znake (velike črke in / ali številke)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Prišlo je do napake pri ustvarjanju novih kuponov. Prosimo, poskusite ponovno ali kontaktirajte tehnično pomoč.",
    CREATE_VOUCHERS:"Ustvari serijo kuponov",
    CREATING_VOUCHERS_SUCCESS:"Nova serija kuponov je uspešno ustvarjena",
    PRINT_NEW_VOUCHERS:"Natisni kupone",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Vnesite serijsko številko kupona, celo kodo ali del kode kupona za tisk ustreznih kuponov.",
    PRINT_VOUCHERS_PREFIX:"Predpona kode (serije) kuponov",
    NO_VOUCHERS_FOR_PRINT:"Ni kuponov za tisk z vneseno predpono kode.",
    PRINT_VOUCHERS:"Natisni kupone",
    VALIDATION_VOUCHER_CODE_FILTER:"Iskalni izraz za kupon mora biti sestavljen iz velikih črk in številk",
    FILTER_VOUCHERS_BY_CODE:"Filter kuponov po kodi",
    FILTER_VOUCHERS:"Išči kupone",
    WASH_BOX:"Boks za pranje",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Skupaj porabljenih digitalnih žetonov",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Skupaj prodanih lokalnih žetonov po datumu",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Skupaj porabljeni lokalni žetoni po datumu",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Skupaj danih lokalnih žetonov po datumu",
    LOCAL_TOKEN:"Lokalni žeton",
    GIVEN_TOKEN:"Dani na lokalni žetoni",
    SOLD_TOKEN:"Prodani lokalni žetoni",
    SMALL_MACHINES:"Majhni stroji",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Boks za pranje",
    CODE_PREFIX_EXIST:"Predpona kode že obstaja",
    CODE_PREFIX_EXIST_TEXT:"S to predpono kode ne morete ustvariti novega kupona. Izberite drugo.",
    MIN_FOUR_VALIDATION:"Natanko 4 znake",
    ALL_INFORMATION_1:"Vse informacije o",
    ALL_INFORMATION_2:"bodo izgubljeni",
    ASIDE_MENU_TRANSACTIONS:"Transakcije",
    EXPENSES:"Stroški",
    TOPUPS:"Nakup žetonov",
    EXPENSES_LIST:"Seznam stroškov",
    USER_EMAIL:"Uporabniški e-poštni naslov",
    COMPANY_NAME:"Ime podjetja",
    TOPUPS_LIST:"Seznam kupljenih žetonov",
    CONSUMER:"Stranka",
    SYSTEM_ADMIN:"Sistemski administrator",
    MERCHANT_ADMIN:"Skrbnik administrator",
    COMPANY_ADMIN:"Skrbnik podjetja",
    FACILITY_ADMIN:"Administator pralnice",
    SUBSCRIBER:"Naročnik",
    CONFIGURATOR:"Konfigurator",
    SETUP_UNIT_SERIAL_NO:"Serijska številka",
    SETUP_UNIT_MATERIAL_NO:"Št. materiala",
    SETUP_UNIT_WEBAPI_VERSION:"Različica WebApi",
    TOTAL_TURNOVER:"Promet pralnice",
    AVAILABILITY_ALL:"razpoložljivost",
    AVAILIBILITY:"Razpoložljivost pralnih mest:",
    AVAILABILITY_VACUUMS:"Razpoložljivost sesalcev:",
    WASH_BOX_INFO:"Informacije pralnega mesta",
    VACUUM_CLEANER_INFO:"Informacije sesalcev",
    BREAD_CRUMBS_SERVICE:"Servis",
    HOLIDAYS:"Počitnice",
    HOLIDAY:"Praznik",
    LIGHTS_ON:"Luči/on",
    LIGHTS_OFF:"Luči/off",
    WASH_BOXES_ON:"Pralno mesto/on",
    WASH_BOXES_OFF:"Pralno mesto/off",
    VACUUMS_ON:"Sesalec/on",
    VACUUMS_OFF:"Sesalec/off",
    TURNOVER:"Promet",
    TURNOVER_MANUAL_WASH_UNIT:"Promet ročno",
    STATUS_BAY_RUN_TIME:"Skupni delovni čas pralnega boksa",
    STATUS_BAY_PROGRAM_NAME:"Ime programa",
    STATUS_BAY_CREDIT:"Kredit pralni box",
    CLOUD_KREDIT:"Oblak kredit",
    STATUS_VACUUM_RUN_TIME:"Skupni delovni čas sesanja",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Avtopralnica servis, program pralnih mest in podatki o trenutnih podatkih o napakah",
    UNAVAILABLE:"Enota ni na voljo",
    SHOW_HIDE_TABLE:"Prikaži/skrij tabelo delovnih ur",
    PROGRAM_NAME:"Ime programa",
    PROGRAM_COUNTER:"Števec programa",
    NO_NAME:"Referenca nima imena",
    COUNTER_SERVICE_DATA:"Servisni podatki",
    NEED_SERVICE:"Potreben servis",
    PROGRAM_DATA:"Podatki o programu pralnih mest",
    CURRENT_FAULT_DATA:"Trenutni podatki o napakah",
    REFERENCE_DUE:"Rok",
    REFERENCE_SECONDS:"Sekunde",
    REFERENCE_NAME:"Ime dela",
    WASHBOX_NAME:"Ime pralnega mesta",
    FAULT_NAME:"Ime napake",
    FAULT_NUMBER:"Številka napake",
    CURRENT_FAULT_COUNT:"Aktivne napake",
    DEVICE_NOT_INSTALLED:"Naprava ni nameščena",
    STATUS_READY:"Stanje pripravljenosti",
    STATUS_ERROR:"Stanje napake",
    CONNECTION_ERROR:"Ni povezave",
    UNKNOWN_RESET:"Napaka programske opreme",
    SOFTWARE_RESET:"Napaka programske opreme",
    EXTERNAL_PIN_RESET:" Napaka programske opreme",
    RESTART_OR_BROWNOUT_OCCURRED:"Napaka programske opreme",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Napaka strojne opreme",
    COULD_NOT_SIMULATE_COIN:"Napaka strojne opreme",
    ERROR_SETTING_INHIBIT_MODE:"Napaka strojne opreme",
    OFFLINE_DEVICE:"Avtopralnica brez povezave",
    TARIFFS:"Tarife",
    DAY:"Dan",
    NIGHT:"Noč",
    VOUCHER_CODE:"Koda bona",
    DISMISS_ALARM:"Ponastaviti alarm?",
    ALARM_ACTIVE:"Aktivni alarmi",
    NO_ALARM_ACTIVE:"Ni aktivnih alarmov",
    ALARM_HISTORY:"Zgodovina alarmov",
    MANAGING_TOKENS:"Upravljanje žetonov",
    EXPIRATION_DATE:"Rok trajanja",
    EXTEND_TOKEN_DATE:"Podaljšajte datum poteka veljavnosti žetona za",
    DELETE_TOKENS_FOR:"Izbriši žetone za",
    PUMP_TYPE:"Vrsta črpalke",
    TURN_OFF_DEVICE:"Stanje naprave",
    OPERATION_DATA:"Podatki o delovanju",
    PUMP_DATA:"Podatki o črpalki",
    PUMP_NAME:"Ime črpalke",
    POINT_NAME:"Ime točke",
    CHANGER_INCOME:"Skupni dohodek menjalca po datumu",
    SELECTED_OPEN:"Odprto ob izbranem delovnem času",
    ALWAYS_OPEN:"Vedno odprto (24/7)",
    CLOSED:"Zaprto",
    CLOSED_24:"Zaprto 24 ur",
    OPENED_24:"Odprto 24 ur",
    MON:"Ponedeljek",
    TUE:"Torek",
    WED:"Sreda",
    THU:"Četrtek",
    FRI:"Petek",
    SAT:"Sobota ",
    SUN:"Nedelja",
    PRICING:"Cenitev",
    PRICE:"Cena",
    VALIDITY:"Veljavnost",
    TOKEN_PACKAGES:"Paketi žetonov",
    SINGLE_WASH:"Enkratno pranje",
    FACILITY_WORKING_HOURS:"Nastavite delovni čas za izbrani objekt",
    WORKING_HOURS_ALWAYS_OPEN:"Vedno odprto",
    WORKING_HOURS_ALWAYS_CLOSE:"Zaprl operater",
    WORKING_HOURS_CUSTOM:"Nastavite delovni čas",
    KARCHER_ERROR_CODE:"Opozorilna koda napake",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizacija",
    CREATE_ORGANIZATION:"Ustvari organizacijo",
    CREATE_ORGANIZATION_AS:"Ustvarite organizacijo kot otroka za",
    DELETE_ORGANIZATION:"Izbriši organizacijo",
    EDIT_ORGANIZATION:"Uredi organizacijo",
    SUPPORTED_ORG_NAME:"Podprta organizacija",
    SUPPORTED_ORG_TYPE:"Podprta vrsta",
    ORG_NAME:"Ime",
    ORG_TYPE:"Vrsta",
    SET_ORG_TITLE:"Nastavite otroško organizacijo",
    SET_SUPPORTED_ORG_TITLE:"Nastavite podprto podrejeno organizacijo",
    SAVE_ORGANIZATION:"Shranite organizacijo",
    SELECT_ORGANIZATION_TYPE:"Izberite vrsto organizacije",
    SELECT_ORGANIZATION_SELECTOR:"Izberite",
    SELECT_SUPPORTED_ORGANIZATION:"Izberite podprto organizacijo",
    ORGANIZATION_DELETED:"Organizacija je bila uspešno izbrisana",
    ORGANIZATION_SAVED:"Organizacija uspešno shranjena",
    ORGANIZATION_UPDATED:"Organizacija je bila uspešno posodobljena",
    ALERTS:"Opozorila",
    DEVICE_STATUS:"Stanje naprave",
    SITE_DETAILS:"Podrobnosti lokacije",
    ALARM_STATUS:"Stanje opozorila",
    FILTER:"Filtriraj po ...",
    FILTER_BY_ALERT_CENTER:"Filtrirajte po kodi, imenu ali opisu",
    TOTAL_ALARM:"Skupaj",
    LOW_ALARM:"Dogodek",
    MEDIUM_ALARM:"Motnja",
    HIGH_ALARM:"Kritična napaka",
    NO_FACILITIES_NEARBY:"V bližini ni objektov",
    GRAY_MAP:"Zemljevid v sivem slogu",
    READY:"Pripravljen",
    WARNING:"Motnja",
    ERROR:"Napaka",
    SITE_NAME:"Ime lokacije",
    ACCOUNTS_INFO:"Podatki o računu",
    USER_ORGANIZATION:"Organizacija uporabnikov",
    ADD_USER_ORGANIZATION:"Dodajte novega uporabnika organizacije",
    EDIT_USER_ORGANIZATION:"Uredite uporabnike organizacije",
    SELECT_ROLE:"Izberite vlogo",
    SELECT_ORGANIZATION:"Izberite organizacijo",
    SELECT_USER:"Izberite uporabnika",
    USER_FOR_ORGANIZATION_CREATED:"Nov uporabnik je bil uspešno ustvarjen",
    SELECT_REGION:"Izberite regijo",
    SELECT_LANGUAGE:"Izberi jezik",
    LOADING_DATA:"Nalaganje podatkov, počakajte ...",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Tehnična podpora",
    CONTROLLER:"Krmilnik",
    EDIT_ORGANIZATION_USER:"Uredite uporabnike organizacije",
    DELETE_ORGANIZATION_USER:"Izbrišite uporabnike organizacije",
    USER_UPDATED:"Uporabnik uspešno posodobljen",
    USER_CREATED:"Uporabnik uspešno ustvarjen",
    ADDRESS:"Naslov",
    SUBSCRIPTIONS:"Naročnine",
    RESOLVED_STATUS:"Rešeno",
    NOT_RESOLVED_STATUS:"Ni rešeno",
    ALERT_NAME:"Ime opozorila",
    ALERT_DESCRIPTION:"Opis opozorila",
    ALERT_CODE:"Opozorilna koda",
    ALERT_TYPE:"Vrsta opozorila",
    UNSUBSCRIBE:"Opozorilo o odjavi",
    SUBSCRIBE:"Opozorilo za naročanje",
    ALARM_SUBSCRIBED:"Uspešno naročen",
    UNSUBSCRIBED_CONFIRM:"Odjava?",
    ALARM_UNSUBSCRIBED:"Uspešno odjavljen",
    ASIDE_MENU_CASHLESS_SALES:"Brezgotovinska prodaja",
    FILTERED_CASHLESS_PAYMENTS:"Filtrirana brezgotovinska plačila",
    REFUND_DIALOG_TITLE:"Vračilo transakcije?",
    REFUND_DIALOG_SUBTITLE:"Znesek je lahko manjši ali enak znesku transakcije",
    REFUND:"Povračilo",
    INPUT_NOT_VALID:"Vnos ni veljaven",
    REFUND_SUCCESSFULLY:"Vračilo za izbrano plačilo je bilo uspešno izvedeno",
    USER:"Uporabnik",
    TRANSACTION_ID:"PSP referenca",
    DEVICE_ID:"ID naprave",
    NET_AMOUNT:"Neto znesek",
    REPORT_NAME:"Ime poročila",
    TIME_FRAME:"Časovni okvir",
    SUB_POINT:"Izberite podtočko",
    SUB_POINT_LIST_NOT_EXIST:"Seznam podtočk ne obstaja za izbrano pralnico",
    FACILITY_TYPE:"Vrsta objekta",
    MACHINE_NAME:"Ime stroja",
    WASH_FACILITY_DETAILS:"Podrobnosti o pralnici",
    WASH_BAY_DETAILS:"Podrobnosti o pralnem mestu",
    DEVICES_INFO:"Seznam naprav",
    OPERATION_TIME_INFO:"Čas delovanja",
    OPERATION_TIME_VACUUM_INFO:"Čas delovanja za sesalnike",
    OPERATION_TIME_ILLUMINATION_INFO:"Čas delovanja za osvetlitev",
    AVAILABLE_TITLE:"Na voljo",
    UNAVAILABLE_TITLE:"Ni na voljo",
    CURRENT_PROGRAM:"Trenutni program",
    CREDITS:"Krediti",
    DEVICE_NAME:"Ime naprave",
    ACTIVE_ALARMS:"Aktivna opozorila",
    ALL_DAY:"Ves dan",
    OPERATING_TIME_WASH_FACILITY:"Samopostrežni pralni sistem",
    OPERATING_TIME_VACUUMS:"Sesalniki",
    OPERATING_TIME_ILLUMINATION:"Osvetlitev",
    OPERATION_COUNTERS:"Števci operacij",
    EDIT:"Uredi",
    WASHING_PROGRAMS:"Programi pranja",
    INFO:"Dogodek",
    STATISTIC:"Statistika",
    ROLLOVER_DOSING:"Odmerjanje",
    ROLLOVER_SPEED:"Hitrosti",
    ROLLOVER_RESETS:"Daljinska ponastavitev pri Rollover",
    ROLLOVER_RESETS_INFO:"Ponastavitev na daljavo mora biti v skladu z lokalnimi predpisi. Pomembno: Pred ponastavitvijo se prepričajte, da je rollover prazen.",
    RESET_ROLLOVER:"Ponastavi Rollover",
    OPEN_DOOR_ROLLOVER:"Odprto",
    ROLLOVER_OPEN_DOOR_INFO:"Odprite vrata pralnice. Bodi previden.",
    ROLLOVER_OPEN_DOOR:"Odpri vrata",
    APPLY_DOSING_CHANGES:"Uporabite spremembe odmerjanja",
    APPLY_SPEED_CHANGES:"Uporabi spremembe hitrosti",
    ACTUATION_SUCCESS:"Prošnja poslana",
    REMAINING_TIME:"Preostali čas",
    OPEN_24H:"Odprto 24 ur",
    CLOSE_24H:"Zapro 24 ur",
    VALIDATION_OPERATION_TIME:"Oblika ni pravilna. Uporabite hh:mm",
    ROLLOVER:"Rollover",
    UPDATE_WASHING_PROGRAM:"Posodobite program pranja",
    UPDATE_ACTUATORS:"Posodobite aktuatorje",
    OPEN_ROLOVER_DOOR_TITLE:"Želite odpreti vrata Rollovera?",
    OPEN_ROLOVER_DOOR_CONTENT:"Ste prepričani, da želite odpreti vrata?",
    RESET_ROLOVER_TITLE:"Želite ponastaviti Rollover?",
    RESET_ROLOVER_CONTENT:"Ali ste prepričani, da želite ponastaviti Rollover?",
    G0:"{{brand === 'r2w' ? 'Pralno mesto 0' : 'Pralno mesto 1'}}",
    G1:"{{brand === 'r2w' ? 'Pralno mesto 1' : 'Pralno mesto 2'}}",
    G2:"{{brand === 'r2w' ? 'Pralno mesto 2' : 'Pralno mesto 3'}}",
    G3:"{{brand === 'r2w' ? 'Pralno mesto 3' : 'Pralno mesto 4'}}",
    G4:"{{brand === 'r2w' ? 'Pralno mesto 4' : 'Pralno mesto 5'}}",
    G5:"{{brand === 'r2w' ? 'Pralno mesto 5' : 'Pralno mesto 6'}}",
    G6:"{{brand === 'r2w' ? 'Pralno mesto 6' : 'Pralno mesto 7'}}",
    G7:"{{brand === 'r2w' ? 'Pralno mesto 7' : 'Pralno mesto 8'}}",
    G8:"{{brand === 'r2w' ? 'Pralno mesto 8' : 'Pralno mesto 9'}}",
    G9:"{{brand === 'r2w' ? 'Pralno mesto 9' : 'Pralno mesto 10'}}",
    G10:"{{brand === 'r2w' ? 'Pralno mesto 10' : 'Pralno mesto 11'}}",
    U0:"{{brand === 'r2w' ? 'Sesalnik 0' : 'Sesalnik 1'}}",
    U1:"{{brand === 'r2w' ? 'Sesalnik 1' : 'Sesalnik 2'}}",
    U2:"{{brand === 'r2w' ? 'Sesalnik 2' : 'Sesalnik 3'}}",
    U3:"{{brand === 'r2w' ? 'Sesalnik 3' : 'Sesalnik 4'}}",
    U4:"{{brand === 'r2w' ? 'Sesalnik 4' : 'Sesalnik 5'}}",
    U5:"{{brand === 'r2w' ? 'Sesalnik 5' : 'Sesalnik 6'}}",
    U6:"{{brand === 'r2w' ? 'Sesalnik 6' : 'Sesalnik 7'}}",
    U7:"{{brand === 'r2w' ? 'Sesalnik 7' : 'Sesalnik 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Poročilo centra za opozorila, ki ga je ustvarilo izbrana lokacija z nadzorne plošče",
    ALERT_CENTER_TITLE_BY_FACILITY:"Poročilo centra za obveščanje, ki ga je ustvaril izbrani objekt z nadzorne plošče",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Poročilo centra za obveščanje",
    ERROR_MESSAGE_403:"Nimate privilegija za uporabo tega klica API. Koda napake: 403",
    LAST_ACTIVE_PROGRAM:"Aktivni program / Zadnji aktivni program",
    PROGRAM_ID:"Številka programa",
    PROGRAM_PRICE:"Cena programa",
    NORMAL_CHEMICAL_LEVEL:"V redu",
    LOW_CHEMICAL_LEVEL:"Potrebno ponovno polnjenje",
    EMPTY_CHEMICAL_LEVEL:"Prazno",
    CHEMICAL_LEVEL:"Indikacija nivoja detergentov (%)",
    ROLLOVER_STATUS:"Stanje Rollowera",
    ROLLOVER_STATUS_CODE_0:"Pranje trenutno ne deluje",
    ROLLOVER_STATUS_CODE_1:"Izven delovnega časa",
    ROLLOVER_STATUS_CODE_2:"Dovoljen vstop v program",
    ROLLOVER_STATUS_CODE_3:"Postavite svoje vozilo",
    ROLLOVER_STATUS_CODE_4:"Vozilo naprej",
    ROLLOVER_STATUS_CODE_5:"Vozilo nazaj",
    ROLLOVER_STATUS_CODE_6:"Ustavitev vozila",
    ROLLOVER_STATUS_CODE_7:"Pranje aktivno",
    ROLLOVER_STATUS_CODE_8:"Pranje ustavljeno",
    ROLLOVER_STATUS_CODE_9:"Aktivno pranje (takt)",
    ROLLOVER_STATUS_CODE_10:"Izpeljite z vozilom vzvratno",
    ROLLOVER_STATUS_CODE_11:"Ustavitev v sili",
    ROLLOVER_STATUS_CODE_12:"Izpeljite z vozilom naprej",
    ROLLOVER_STATUS_CODE_13:"Proti zmrzovanju aktivno",
    ROLLOVER_STATUS_CODE_14:"Aktivirano sprednje varnostno stikalo",
    ROLLOVER_STATUS_CODE_15:"Aktivirano varnostno stikalo zadaj",
    ROLLOVER_STATUS_CODE_16:"Aktivirano je varnostno stikalo na sprednji levi strani",
    ROLLOVER_STATUS_CODE_17:"Aktivirano je varnostno stikalo na sprednji desni strani",
    ROLLOVER_STATUS_CODE_18:"Aktivirano je varnostno stikalo na zadnji levi strani",
    ROLLOVER_STATUS_CODE_19:"Aktivirano je varnostno stikalo na desni strani",
    ROLLOVER_STATUS_CODE_20:"Položaj vozila preveč levo",
    ROLLOVER_STATUS_CODE_21:"Položaj vozila preveč desno",
    ROLLOVER_STATUS_CODE_22:"Leva vrata niso zaprta",
    ROLLOVER_STATUS_CODE_23:"Desna vrata niso zaprta",
    ROLLOVER_STATUS_CODE_24:"Zaznan transporter, izbran napačen program pranja",
    ROLLOVER_STATUS_CODE_25:"Senzor hupe",
    ROLLOVER_STATUS_CODE_98:"Ročni / način prilagajanja",
    ROLLOVER_STATUS_CODE_99:"Neznano stanje",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Statusna koda nedefinirana",
    ALARM:"Kritična napaka",
    NO_ALARM:"Ni kritične napake",
    SOFTWARE_VERSION:"Različica programske opreme",
    SOFTWARE_DATE:"Datum programske opreme",
    SITE_ADDRESS:"Naslov lokacije",
    SECONDS:"sekund",
    SERVICE_PART_NAME:"Ime storitve:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Števec obratovanja in storitev",
    OPERATION_COUNTER:"Števec operacij",
    SERVICE_COUNTER:"Števec storitev",
    FAULT_CODE:"Opozorilna koda",
    PRESSURE_TITLE:"Zračni tlak",
    TIME_TITLE:"Trenutni čas",
    COUNTRY_TITLE:"Država",
    CITY_TITLE:"Mesto",
    REGION_TITLE:"Regija",
    SELECT_POINTS_TO_SEARCH:"Izberite točke ...",
    LOGS_HISTORY:"Zgodovina sprememb parametrov",
    ACTUATOR_REFERENCE:"Referenca aktuatorja",
    ACTUATOR_VALUE:"Vrednost aktuatorja",
    POINT_ID:"ID točke",
    VALIDATION_NOT_VALID_RANGE:"Napačen obseg",
    ENABLE_ROLLOVER_RESET:"Z odkljukanjem tega polja potrjujete, da ste prebrali varnostna navodila in se z njimi strinjate.",
    CHANGE_OF_PARAMETERS:"Sprememba parametrov",
    SELECT_OPTIONS:"Izberite možnosti",
    AUTOMATIC:"Samodejno",
    DESALTING:"Funkcija razsoljevanja",
    SEASON_WASH:"Programi sezonskega pranja",
    SPRING_PROGRAM:"Spomladanski programi pranja",
    SUMMER_PROGRAM:"Poletni programi pranja",
    AUTUMN_PROGRAM:"Jesenski programi pranja",
    WINTER_PROGRAM:"Zimski programi pranja",
    DOOR_CONTROL:"Nadzor vrat",
    SUMMER_DOOR_CONTROL:"Poletje, upravljanje s krmiljenjem vrat v poletnem načinu",
    WINTER_DOOR_CONTROL:"Zima, upravljanje s krmiljenjem vrat v zimskem načinu",
    APPLY_PARAMETERS_CHANGES:"Uporabi spremembe parametrov",
    WORKING_SCHEDULES:"Delovni urniki",
    HOLIDAY_SCHEDULES:"Razpored za praznike",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Prazniki na lokaciji so uspešno ustvarjeni",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Prazniki na lokaciji so uspešno posodobljeni",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Prazniki na lokaciji so uspešno izbrisani",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Delovni urniki se uspešno širijo",
    HOLIDAY_SUCCESSFULLY_DELETED:"Dopust je bil uspešno izbrisan",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Prev",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Prev",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Prev",
    SB_MU_2_2_0:"SB_MU_2_2_0_Prev",
    SB_MU_2_1_0:" SB_MU_2_1_0_Prev",
    SB_MU_2_0_0:" SB_MU_2_0_0_Prev",
    SB_MB_2_2_0:"SB_MB_2_2_0_Prev",
    SB_MB_2_1_0:"SB_MB_2_1_0_Prev",
    SB_MB_2_0_0:"SB_MB_2_0_0_Prev",
    SB_OB_2_2_0:"SB_OB_2_2_0_Prev",
    SB_OB_2_1_0:"SB_OB_2_1_0_Prev",
    SB_OB_2_0_0:"SB_OB_2_0_0_Prev",
    CB3_1_0_0:"CB3_1_0_0_Prev",
    CW35_3_0_0:"CW35_3_0_0_Prev",
    CW35_3_1_0:"CW35_3_1_0_Prev",
    CWB3_3_0_0:"CWB3_3_0_0_Prev",
    CWB3_3_1_0:" CWB3_3_1_0_Prev",
    CW1_3_0_0:" CW1_3_0_0_Prev",
    CW1_3_1_0:" CW1_3_1_0_Prev",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Sušilno sredstvo z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampon z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_FOAM:"Pena z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_WAX_1:"Vosek z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_POLISH_1:"Poliranje z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Čistilo za platišča z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_WAX_2:"Vosek z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Sijaj pnevmatik z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Odstranjevalec mrčesa z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_POLISH_2:"Poliranje z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_INTENSIVE:"Intenzivno z nizko stopnjo polnjenja",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Aktivna pena z nizko stopnjo polnjenja",
    CHEM_LEVEL_DRYING_AGENT:"Sušilno sredstvo nivo polnjenja",
    CHEM_LEVEL_SHAMPOO:"Šampon nivo polnjenja",
    CHEM_LEVEL_FOAM:"Aktivna pena nivo polnjenja",
    CHEM_LEVEL_WAX_1:"Vosek nivo polnjenja",
    CHEM_LEVEL_POLISH_1:"Poliranje nivo polnjenja",
    CHEM_LEVEL_RIM_CLEANER:"Čistilo za platišča nivo polnjenja",
    CHEM_LEVEL_WAX_2:"Vosek nivo polnjenja",
    CHEM_LEVEL_TYRE_SHINE:"Sijaj pnevmatik nivo polnjenja",
    CHEM_LEVEL_INSECT_REMOVER:"Odstranjevalec mrčesa nivo polnjenja",
    CHEM_LEVEL_POLISH_2:"Poliranje nivo polnjenja",
    CHEM_LEVEL_INTENSIVE:"Intenzivno nivo polnjenja",
    CHEM_LEVEL_FOAM_RAIN:"Aktivna pena nivo polnjenja",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servisni števec - dvižni pas za strešno krtačo",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servisni števec - dvižni pas za sušilni stroj",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servisni števec motornega kabla strešna krtača",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servisni števec servis črpalke sveže vode",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servisni števec servisne črpalke uporabljene vode",
    DRYING_AGENT:"Sredstvo za sušenje",
    FOAM_DRYING_AGENT:"Sredstvo za sušenje pene",
    SHAMPOO:"Šampon",
    FOAM:"Pena",
    BRUSH_FOAM:"Pena za krtačo",
    WAX_1:"Vosek",
    FOAM_WAX_1:"Aktivna pena",
    POLISH_1:"Poliranje",
    RIM_CLEANING:"Čistilo za platišča",
    WAX_2:"Vosek",
    FOAM_WAX_2:"Aktivna pena",
    TYRE_SHINE:"Sijaj pnevmatik",
    INSECT_REMOVER:"Odstranjevalec insektov",
    POLISH_2:"Poliranje",
    INTENSIVE_BASIC:"Intenzivno osnovna",
    INTENSIVE_SIDE:"Intenzivno stran",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzivno nosilec strešne škropilnice",
    TAR_REMOVER:"Odstranjevalec katrana",
    UNDER_CHASSIS_CONVERSATION:"Pogovor pod šasijo",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionarni lok pred pršenjem",
    FOAM_RAIN:"Aktivna pena",
    PRE_CLEANING:"Predčiščenje",
    BRUSH:"Krtača",
    CARE:"Skrb",
    DRYING:"Sušenje",
    DRYING_LOW_NOISE:"Zmanjšan hrup sušenja",
    INTENSIVE_CLEANING:"Intenzivno čiščenje",
    BRUSH_CLEANING:"Čiščenje s krtačo",
    EMPTY_RUN:"Prazen tek",
    DRYING_AID:"Pomoč pri sušenju",
    WAX:"Vosek",
    FOAM_WASH:"Pranje s aktivno peno",
    POLISH:"Poliranje",
    FOAM_POLISH:"Poliranje s peno",
    WHEEL_CLEANING:"Čiščenje koles",
    HIGH_PRESSURE_ROOF:"Streha visok pritisk",
    HIGH_PRESSURE_SIDE:"Stranski visok pritisk",
    DRYER_FORWARD:"Sušilec naprej",
    DRYER_BACKWARD:"Sušilnik nazaj",
    DELETE_ALL_HOLIDAYS:"Izbriši vse praznike za izbrano lokacijo",
    CREATE_NEW_HOLIDAY:"Ustvari novo",
    RESET_INPUTS:"Ponastavi vse vnose za praznike",
    TWENTY_FOUR_HOURS_OPEN:"Odprto 24 ur",
    EVERY_YEAR:"Letno",
    DELETE_HOLIDAY:"Izbriši dopust",
    ADD_NEW_HOLIDAY:"Dodajte nov dopust",
    HOLIDAYS_LIST:"Seznam obstoječih praznikov",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Želite izbrisati vse praznike za izbrano lokacijo?",
    VALIDATION_HOLIDAY_DATE:"Oblika ni pravilna. Uporabite mm-dd",
    FOR_DATE:"Za datum",
    WITH_ID:"Z osebnim dokumentom",
    FROM_HOURS:"Od (h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:"Do (min)",
    NOT_MATCH:"Se ne ujema",
    START:"Od",
    STOP:"Do",
    DAILY_TIME:"24-urni seznam",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individualna nastavitev časa",
    PROGRAM_NOT_STARTED:"Program se še ni začel",
    JETWASH:"Samopostrežni pralni sistem",
    KARCHER_REPORT_1:"Rollover: prikaz prometa na program in skupaj",
    KARCHER_REPORT_2:"Rollover: Začeta pranja na program in skupaj",
    KARCHER_REPORT_3:"Rollover: Opravljena pranja na program in skupaj",
    KARCHER_REPORT_4:"Rollover: Količina začetih pranj preko plačilnega terminala na program in skupaj",
    KARCHER_REPORT_5:"Rollover: število ročno začetih pranj na program in skupno",
    KARCHER_REPORT_6:"Rollover: Količina preklicanih pranj na program in skupaj",
    KARCHER_REPORT_7:"Rollover: Število izpadov napajanja",
    KARCHER_REPORT_8:"Enote SB: Število ur na program pranja, filtrirano po pralnih mestih in skupno",
    KARCHER_REPORT_9:"SB-enote: Prikaz prometa na pralno mesto in skupaj",
    KARCHER_REPORT_10:"SB-enote: števec žetonov/kovancev na kanal kovancev",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Črpalka za svežo vodo",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Črpalka za svežo vodo",
    OPERATION_COUNTER_HP_PUMP_1:"Visokotlačna črpalka 1",
    OPERATION_COUNTER_HP_PUMP_2:"Visokotlačna črpalka 2",
    RELEASE_NOTES:"Različice aplikacije in opombe ob izdaji",
    BACKEND_RELEASE_NOTES:"Opombe ob izdaji platforme:",
    FRONTEND_RELEASE_NOTES:"Opombe ob izdaji spletne aplikacije:",
    SELECTED_FACILITY_TIMEZONE:"Časovni pas za izbrani objekt:",
    REFRESH_PAGE:"Osveži stran",
    REFRESH_MAPS:"Osveži zemljevide",
    PUMPS:"Črpalke",
    RUN_TIME:"Čas delovanja",
    RUN_TIME1:"Čas delovanja 1",
    RUN_TIME2:"Čas delovanja 2",
    PROGRAM_RUNTIME_ACTUATOR:"Pogon za čas delovanja",
    PROGRAM_RUNTIME_ACTUATOR_1:"Pogon za čas delovanja 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Pogon za čas delovanja 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Najmanjša vrednost je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Največja vrednost je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Uporabite obliko cene x.xx",
    ACTUATION_NOT_ALLOWED:"Aktivacija ni dovoljena za trenutno vlogo uporabnika",
    MAINTENANCE_DAYS:"Dnevi vzdrževanja",
    MAINTENANCE_WASHES:"Vzdrževalna pranja",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Skupni dohodek POS",
    PROPAGATE:"Razmnožiti",
    ALL_DAY_HOURS_SELECTOR:"24-urni izbirnik vrste",
    GET_OPERATING_TIME_FROM_SITE:"Pridobite čas delovanja za trenutno napravo iz delovnih urnikov mesta",
    USER_NOT_VALID:"Uporabnik ni veljaven. Poskusite z drugimi poverilnicami računa.",
    VERIFIED:"Preverjeno",
    RESEND_VERIFICATION_MAIL:"Ponovno pošlji potrditveno e-poštno sporočilo",
    RETURN_TO_DASHBOARD:"Nazaj na nadzorno ploščo",
    ERROR_PAGE_BAD_REQUEST:"400 Slaba zahteva.",
    WASHES:"Število pranj",
    TIME_TO_SERVICE:"Čas za storitev",
    ACCOUNT_ALREADY_ACTIVATED:"Račun je že aktiviran",
    DEVICE_EVENTS:"Dogodki naprave",
    DEVICE_EVENTS_LOG_PULLED:"Prenesen dnevnik dogodkov za napravo",
    EVENTS_PULL_DATE:"Čas prenesenih dogodkov:",
    DEVICE_EVENTS_REFRESH:"Prenesi nove podatke o dogodkih",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Težava z povezavo spletnih vtičev. Poskusite osvežiti stran.",
    INSTALLATION_DATE:"Datum namestitve naprave",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Topli vosek",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Pranje pod visokim pritiskom",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Močna pena za platišča",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Močna pena",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Ustavi",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Pranje s peno HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Pranje",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Vrhunska nega",
    INFO_TITLE:"Info",
    FOAM_WAX1:"Aktivna pena",
    POLISH1:"Poliranje",
    WAX1:"Vosek",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Podrobnosti o mestu so bile uspešno posodobljene",
    COMPANY:"Podjetje",
    FACILITY_HAS_CHANGER:"Imate menjač?",
    DISABLE_OFFLINE_ALARM:"Onemogoči R2W alarme",
    ASIDE_WORKING_SCHEDULES:"Podrobnosti o mestu v aplikaciji",
    TERMS_OF_SERVICE_R2W_TITLE:"Pogoji uporabe Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Pogoji uporabe Ready2Wash",
    DATA_PROCESSING_TITLE:"Obdelani podatki",
    PRIVACY_POLICY_TITLE:"Politika zasebnosti",
    READY_TO_PAY_TERMS_OF_SERVICE:"Pogoji uporabe Ready2Pay",
    TERMS_AND_SERVICES:"Pogoji in storitve",
    HOURLY: "Vsako uro",
    DAILY: "Dnevno",
    WEEKLY: "Tedensko",
    MONTHLY: "Mesečno",
    YEARLY: "Letno",
    DELETE_ITEM_SUCCESS:"Uspešno ste izbrisali element",
    STATE: "Stanje",
    AVAILABILITY_STATUS_1: "Enota odprta",
    AVAILABILITY_STATUS_2: "Enota zaprta (prazniki)",
    AVAILABILITY_STATUS_3: "Enota zaprta (delovni čas)",
    AVAILABILITY_STATUS_4: "Enota zaprta (okvara)",
    AVAILABILITY_STATUS_5: "Enota zaprta (drugo)",
    AVAILABILITY_VACUUMS_STATUS_1: "Sesalniki niso nameščeni",
    AVAILABILITY_VACUUMS_STATUS_2: "Sesalniki odprti",
    AVAILABILITY_VACUUMS_STATUS_3: "Sesalniki zaprti (prazniki)",
    AVAILABILITY_VACUUMS_STATUS_4: "Sesalniki zaprti (delovni čas)",
    AVAILABILITY_VACUUMS_STATUS_5: "Sesalniki zaprti (okvara)",
    AVAILABILITY_VACUUMS_STATUS_6: "Sesalniki zaprti (drugo)",
    ECOM_AMOUNT: "Skupni Ecom za vse lokacije",
    CAPTURED: "Zajeto",
    DELETE_COMPANY_HISTORY_INFO:"Táto akcia vymaže všetky údaje správ vašej spoločnosti. Túto akciu nie je možné vrátiť späť.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Ste si istý, že chcete natrvalo vymazať všetky údaje správ?",
    VALUE_DATE: "Dátum hodnoty",
    KARCHER_EVENT_NAME_1: "Osnovni toplotni izmenjevalnik regeneriran",
    KARCHER_EVENT_NAME_2: "Regeneracija osnovnega toplotnega izmenjevalnika zaključena",
    KARCHER_EVENT_NAME_3: "Material / serijska številka",
    KARCHER_EVENT_NAME_4: "Sistem je razkužen",
    KARCHER_EVENT_NAME_5: "HP črpalka 1 razkužena",
    KARCHER_EVENT_NAME_6: "HP črpalka 2 razkužena",
    KARCHER_EVENT_NAME_7: "HP črpalka 3 razkužena",
    KARCHER_EVENT_NAME_8: "HP črpalka 4 razkužena",
    KARCHER_EVENT_NAME_9: "HP črpalka 5 razkužena",
    KARCHER_EVENT_NAME_10: "Pralno mesto 1 zaklenjeno",
    KARCHER_EVENT_NAME_11: "Pralno mesto 2 zaklenjeno",
    KARCHER_EVENT_NAME_12: "Pralno mesto 3 zaklenjeno",
    KARCHER_EVENT_NAME_13: "Pralno mesto 4 zaklenjeno",
    KARCHER_EVENT_NAME_14: "Pralno mesto 5 zaklenjeno",
    KARCHER_EVENT_NAME_15: "Pralno mesto 6 zaklenjeno",
    KARCHER_EVENT_NAME_16: "Pralno mesto 7 zaklenjeno",
    KARCHER_EVENT_NAME_17: "Pralno mesto 8 zaklenjeno",
    KARCHER_EVENT_NAME_18: "Posodobitev se je začela",
    KARCHER_EVENT_NAME_19: "Posodobitev zaključena",
    KARCHER_EVENT_NAME_20: "Začetek WS Reg",
    KARCHER_EVENT_NAME_21: "Konec WS Reg",
    KARCHER_EVENT_NAME_22: "WS 75%-senzor",
    KARCHER_EVENT_NAME_23: "Tehnična napaka",
    KARCHER_EVENT_NAME_24: "Operativna napaka",
    KARCHER_EVENT_NAME_25: "Enota vklopljena",
    KARCHER_EVENT_NAME_26: "Enota izklopljena",
    KARCHER_EVENT_NAME_27: "Omarica 1 zaprta",
    KARCHER_EVENT_NAME_28: "Omarica 2 zaprta",
    KARCHER_EVENT_NAME_29: "Omarica 3 zaprta",
    KARCHER_EVENT_NAME_30: "Omarica 4 zaprta",
    KARCHER_EVENT_NAME_31: "Omarica 5 zaprta",
    KARCHER_EVENT_NAME_32: "Omarica 6 zaprta",
    KARCHER_EVENT_NAME_33: "Omarica 7 zaprta",
    KARCHER_EVENT_NAME_34: "Omarica 8 zaprta",
    KARCHER_EVENT_NAME_35: "HP črpalka postaja 1",
    KARCHER_EVENT_NAME_36: "HP črpalka postaja 2",
    KARCHER_EVENT_NAME_37: "HP črpalka postaja 3",
    KARCHER_EVENT_NAME_38: "HP črpalka postaja 4",
    KARCHER_EVENT_NAME_39: "HP črpalka postaja 5",
    KARCHER_EVENT_NAME_40: "HP črpalka postaja 6",
    KARCHER_EVENT_NAME_41: "HP črpalka postaja 7",
    KARCHER_EVENT_NAME_42: "HP črpalka postaja 8",
    KARCHER_EVENT_NAME_43: "Gorilnik",
    KARCHER_EVENT_NAME_44: "Ventilator gorilnika",
    KARCHER_EVENT_NAME_45: "Črpalka za toplo vodo",
    KARCHER_EVENT_NAME_46: "Črpalka za zaščito pred zmrzaljo",
    KARCHER_EVENT_NAME_47: "Osmotska črpalka",
    KARCHER_EVENT_NAME_48: "Talno ogrevanje",
    KARCHER_EVENT_NAME_49: "Ogrevanje cevi",
    KARCHER_EVENT_NAME_50: "Mikro/čiščenje platišč",
    KARCHER_EVENT_NAME_51: "Črpalka za pranje podvozja",
    KARCHER_EVENT_NAME_52: "Penilna črpalka Booster",
    KARCHER_EVENT_NAME_53: "Sesalnik 1",
    KARCHER_EVENT_NAME_54: "Sesalnik 2",
    KARCHER_EVENT_NAME_55: "Sesalnik 3",
    KARCHER_EVENT_NAME_56: "Sesalnik 4",
    KARCHER_EVENT_NAME_57: "Sesalnik 5",
    KARCHER_EVENT_NAME_58: "Sesalnik 6",
    KARCHER_EVENT_NAME_59: "Sesalnik 7",
    KARCHER_EVENT_NAME_60: "Sesalnik 8",
    KARCHER_EVENT_NAME_61: "Sesalnik 9",
    KARCHER_EVENT_NAME_62: "Sesalnik 10",
    KARCHER_EVENT_NAME_63: "Sesalnik 11",
    KARCHER_EVENT_NAME_64: "Sesalnik 12",
    KARCHER_EVENT_NAME_65: "Črpalka za čiščenje platišč",
    KARCHER_EVENT_NAME_66: "Mikro črpalka",
    KARCHER_EVENT_NAME_67: "Intenzivna črpalka",
    KARCHER_EVENT_NAME_68: "Turbina sesalnika 1",
    KARCHER_EVENT_NAME_69: "Filter sesalnika 1",
    KARCHER_EVENT_NAME_70: "Turbina sesalnika 2",
    KARCHER_EVENT_NAME_71: "Filter sesalnika 2",
    KARCHER_EVENT_NAME_72: "Turbina sesalnika 3",
    KARCHER_EVENT_NAME_73: "Filter sesalnika 3",
    KARCHER_EVENT_NAME_74: "Turbina sesalnika 4",
    KARCHER_EVENT_NAME_75: "Filter sesalnika 4",
    KARCHER_EVENT_NAME_76: "Turbina sesalnika 5",
    KARCHER_EVENT_NAME_77: "Filter sesalnika 5",
    KARCHER_EVENT_NAME_78: "Turbina sesalnika 6",
    KARCHER_EVENT_NAME_79: "Filter sesalnika 6",
    KARCHER_EVENT_NAME_80: "Turbina sesalnika 7",
    KARCHER_EVENT_NAME_81: "Filter sesalnika 7",
    KARCHER_EVENT_NAME_82: "Turbina sesalnika 8",
    KARCHER_EVENT_NAME_83: "Filter sesalnika 8",
    KARCHER_EVENT_NAME_84: "Turbina sesalnika 9",
    KARCHER_EVENT_NAME_85: "Filter sesalnika 9",
    KARCHER_EVENT_NAME_86: "Turbina sesalnika 10",
    KARCHER_EVENT_NAME_87: "Filter sesalnika 10",
    KARCHER_EVENT_NAME_88: "Turbina sesalnika 11",
    KARCHER_EVENT_NAME_89: "Filter sesalnika 11",
    KARCHER_EVENT_NAME_90: "Turbina sesalnika 12",
    KARCHER_EVENT_NAME_91: "Filter sesalnika 12",
    INSERT_TOKEN: "Vnesite žetone in zaženite storitev",
    OPEN_SESSION: "Seja je uspešno odprta",
    IN_PROGRESS: "V teku ...",
    TOKEN_INSERTED: "Žetoni so bili uspešno vstavljeni",
    EXPIRED_SESSION: "Seja je potekla",
    TWO_DIGIT_INTEGER_VALIDATION: "Uporabite največ dvomestno celo število",
    KARCHER_OPERATION_COUNTER_1: "Pralna postaja 1 HP črpalka",
    KARCHER_OPERATION_COUNTER_2: "Pralna postaja 1 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_3: "Pralna postaja 1 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_4: "Pralna postaja 1 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_5: "Pralna postaja 1 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_6: "Pralna postaja 2 HP črpalka",
    KARCHER_OPERATION_COUNTER_7: "Pralna postaja 2 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_8: "Pralna postaja 2 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_9: "Pralna postaja 2 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_10: "Pralna postaja 2 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_11: "Pralna postaja 3 HP črpalka",
    KARCHER_OPERATION_COUNTER_12: "Pralna postaja 3 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_13: "Pralna postaja 3 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_14: "Pralna postaja 3 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_15: "Pralna postaja 3 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_16: "Pralna postaja 4 HP črpalka",
    KARCHER_OPERATION_COUNTER_17: "Pralna postaja 4 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_18: "Pralna postaja 4 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_19: "Pralna postaja 4 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_20: "Pralna postaja 4 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_21: "Pralna postaja 5 HP črpalka",
    KARCHER_OPERATION_COUNTER_22: "Pralna postaja 5 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_23: "Pralna postaja 5 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_24: "Pralna postaja 5 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_25: "Pralna postaja 5 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_26: "Pralna postaja 6 HP črpalka",
    KARCHER_OPERATION_COUNTER_27: "Pralna postaja 6 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_28: "Pralna postaja 6 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_29: "Pralna postaja 6 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_30: "Pralna postaja 6 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_31: "Pralna postaja 7 HP črpalka",
    KARCHER_OPERATION_COUNTER_32: "Pralna postaja 7 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_33: "Pralna postaja 7 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_34: "Pralna postaja 7 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_35: "Pralna postaja 7 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_36: "Pralna postaja 8 HP črpalka",
    KARCHER_OPERATION_COUNTER_37: "Pralna postaja 8 kemijska črpalka 1",
    KARCHER_OPERATION_COUNTER_38: "Pralna postaja 8 kemijska črpalka 2",
    KARCHER_OPERATION_COUNTER_39: "Pralna postaja 8 kemijska črpalka 3",
    KARCHER_OPERATION_COUNTER_40: "Pralna postaja 8 kemijska črpalka 4",
    KARCHER_OPERATION_COUNTER_41: "Črpalka za osmozo",
    KARCHER_OPERATION_COUNTER_42: "Generator tople vode",
    KARCHER_OPERATION_COUNTER_43: "Črpalka za zaščito proti zmrzovanju",
    KARCHER_OPERATION_COUNTER_44: "WSO filtrirne kartuše",
    KARCHER_OPERATION_COUNTER_45: "Ogrevalna črpalka za pralno postajo",
    KARCHER_OPERATION_COUNTER_46: "Črpalka za toplo vodo",
    KARCHER_OPERATION_COUNTER_47: "Grelnik za penaste cevi",
    KARCHER_OPERATION_COUNTER_48: "Črpalka za pranje koles",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulzijska črpalka",
    KARCHER_OPERATION_COUNTER_50: "Intenzivna črpalka za peno",
    KARCHER_OPERATION_COUNTER_51: "Sesalec 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Sesalec 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Sesalec 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Sesalec 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Sesalec 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Sesalec 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Sesalec 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Sesalec 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Sesalec 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Sesalec 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Sesalec 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Sesalec 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Sesalec 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Sesalec 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Sesalec 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Sesalec 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Sesalec 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Sesalec 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Sesalec 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Sesalec 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Sesalec 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Sesalec 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Sesalec 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Sesalec 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Odstranite kondenzatno vodo iz kompresorja",
    KARCHER_OPERATION_COUNTER_76: "Preverite sistem proti zmrzovanju",
    KARCHER_OPERATION_COUNTER_77: "Ventilator gorilnika",
    KARCHER_OPERATION_COUNTER_78: "Ojačitvena črpalka za peno",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Seznam podatkov je večji od 10000 elementov",
    KARCHER_POINT_NAME_1: "Praznik",
    KARCHER_POINT_NAME_2: "Ponedeljek",
    KARCHER_POINT_NAME_3: "Torek",
    KARCHER_POINT_NAME_4: "Sreda",
    KARCHER_POINT_NAME_5: "Četrtek",
    KARCHER_POINT_NAME_6: "Petek",
    KARCHER_POINT_NAME_7: "Sobota",
    KARCHER_POINT_NAME_8: "Nedelja",
    KARCHER_POINT_NAME_9: "Sesalniki Praznik",
    KARCHER_POINT_NAME_10: "Sesalniki Ponedeljek",
    KARCHER_POINT_NAME_11: "Sesalniki Torek",
    KARCHER_POINT_NAME_12: "Sesalniki Sreda",
    KARCHER_POINT_NAME_13: "Sesalniki Četrtek",
    KARCHER_POINT_NAME_14: "Sesalniki Petek",
    KARCHER_POINT_NAME_15: "Sesalniki Sobota",
    KARCHER_POINT_NAME_16: "Sesalniki Nedelja",
    KARCHER_POINT_NAME_17: "Razsvetljava Praznik",
    KARCHER_POINT_NAME_18: "Razsvetljava Ponedeljek",
    KARCHER_POINT_NAME_19: "Razsvetljava Torek",
    KARCHER_POINT_NAME_20: "Razsvetljava Sreda",
    KARCHER_POINT_NAME_21: "Razsvetljava Četrtek",
    KARCHER_POINT_NAME_22: "Razsvetljava Petek",
    KARCHER_POINT_NAME_23: "Razsvetljava Sobota",
    KARCHER_POINT_NAME_24: "Razsvetljava Nedelja",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR koda",
    ACCEPT_TERMS_AND_CONDITIONS: "Sprejmi pogoje uporabe",
    CREATE_AND_PRINT_VOUCHERS: "Ustvari in natisni kupone",
    CODE_PREFIX_QUESTION: "Predpona kode ni vnesena",
    CODE_PREFIX_QUESTION_TEXT: "Želite nadaljevati brez predpone kode?",
    ISSUED_DATE: "Datum izdaje",
    VOUCHER_VALIDITY_DAYS: "Veljavnost kupona (dnevi)",
    VALIDATION_ONLY_NUMBERS: "Dovoljene so samo številke",
    REPRINT_VOUCHERS: "Natisni kopijo kuponov",
    EXPIRY_DATE: "Velja do"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("skTranslations", {
    MESSAGE:"Správa",
    ERROR_TITLE:"Chyba",
    ERROR_MESSAGE:"Pri vykonávaní operácie došlo k chybe.",
    ERROR_LOGIN:"Počas prihlasovania došlo k chybe. E-mailová adresa alebo heslo nie sú platné",
    ERROR_LOGIN_ROLE:"Úloha pre aktuálnu značku aplikácie nie je platná",
    OK:"OK",
    CANCEL:"Zrušiť",
    YES:"Áno",
    NO:"Nie",
    FROM:"Od",
    TO:"Do",
    DELETE:"Odstrániť",
    SIGN_OUT:"Odhlásiť sa",
    NAME:"Názov",
    DATE:"Dátum",
    PIECES:"kusy",
    HOURS:"Hodiny",
    DAYS:"Dni",
    MONTH:"Mesiac",
    MONTHS:"Mesiace",
    YEAR:"Rok",
    BOX:"Box",
    SEARCH:"Vyhľadávanie",
    ALL_USERS:"Všetci používatelia",
    ARE_YOU_SURE:"Ste si istý?",
    BACK:"Späť",
    AMOUNT:"Suma",
    DESCRIPTION:"Popis",
    FORGOT_PASSWORD_ERROR_MSG:"Niečo sa pokazilo. Skontrolujte prosím svoju e-mailovú adresu a skúste to znova",
    REQUIRED_FIELD:"Pole je povinné",
    LOGOUT_TITLE:"Určite sa chcete odhlásiť?",
    LOGOUT_MSG:"Všetky neuložené údaje sa stratia",
    ACTIVATION_ACCOUNT:"Úspešne ste aktivovali svoj účet",
    UNKNOWN_ERRROR_NOTIFICATION:"Vyskytla sa neznáma chyba",
    CONTINUE:"Pokračovať",
    DATA_NOT_AVAILABLE:"Údaje nie sú k dispozícii",
    SELECT:"Vyberte",
    SELECT_CURRENCY:"Vyberte menu",
    UPLOAD:"Nahrať",
    PHONE:"Telefón",
    WEBSITE:"Webová stránka",
    WORKING_HOURS:"Pracovný čas",
    INSERT:"Vložte",
    TEXT:"Text",
    CREATED:"Vytvorené",
    VALID_UNTIL:"Platnosť do",
    SAVE:"Uložiť",
    TOKENS:"Žetóny",
    DELETE_COMPANY_HISTORY:"Vymazať históriu spoločnosti?",
    DELETE_COMPANY_HISTORY_INFO:"Táto akcia odstráni všetky údaje o správach pre vašu spoločnosť. Táto akcia sa nedá vrátiť späť.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Ste si istý, že chcete natrvalo odstrániť všetky údaje správ?",
    DELETE_COMPANY_HISTORY_MESSAGE:"VAROVANIE: Po stlačení tohto tlačidla sa všetky transakcie vašej umývačky natrvalo vymažú! Tieto údaje nie je možné po vymazaní obnoviť.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Ste si istí, že chcete natrvalo vymazať všetky údaje o transakciách?",
    HISTORY_SUCCESSFULY_DELETED:"História bola úspešne odstránená",
    HELP:"Pomoc",
    VALUE:"Hodnota",
    ACTIVATING_ACCOUNT_ERROR:"Pri aktivácii vášho konta R2W došlo k problému.Skúste to prosím znova a ak problém pretrváva, kontaktujte našu podporu na adrese support@ready2wash.com.",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Welcome to Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Vitajte v spoločnosti R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Na aktiváciu konta R2W zadajte a potvrďte svoje nové heslo. Po úspešnom prihlásení budete automaticky prihlásení do aplikácie",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Nastavenia používateľa môžete neskôr zmeniť v aplikácii",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Autoumyváreň Kärcher",
    RESET_PASSWORD_WELCOME_MSG:"Autoumyváreň R2W",
    RESET_PASSWORD_WELCOME_MSG_2:"Zadajte nové heslo a potvrďte ho, aby ste mohli obnoviť staré heslo. Po úspešnej zmene hesla sa automaticky prihlásite do aplikácie.",
    RESET_PASSWORD_WELCOME_MSG_3:"Nastavenia používateľa môžete neskôr zmeniť v aplikácii",
    ENTER_NEW_PASSWORD:"Zadajte nové heslo",
    REPEAT_NEW_PASSWORD:"Opakovanie nového hesla",
    PASSWORD_MIN_LENGTH:"Heslo musí mať aspoň 8 znakov",
    PASSWORD_MAX_LENGHT:"Heslo musí mať menej ako 32 znakov",
    PASSWORD_PATTERN:"Heslo musí obsahovať aspoň jedno veľké a jedno malé písmeno.",
    PASSWORD_MATCH:"Heslá sa nezhodujú",
    ACTIVATE:"Aktivujte",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Úspešne ste odoslali žiadosť. Prosím, skontrolujte si e-mail pre potvrdzujúcu správu",
    VALIDATION_REQUIRED:"Povinné pole",
    VALIDATION_EMAIL:"Neplatná e-mailová adresa",
    VALIDATION_INTEGER_NUMBER:"Zadajte celočíselnú hodnotu",
    VALIDATION_HOURS_VALUE:"Hodnota musí byť v rozmedzí 0-23",
    VALIDATION_MINUTES_VALUE:"Hodnota musí byť v rozmedzí 0-59",
    VALIDATION_NOT_A_DATE:"Hodnota nie je dátum",
    VALIDATION_FROM:"Od dátumu, ktorý je väčší ako do",
    VALIDATION_TO:"K dátumu menšiemu ako z",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Tento záznam už existuje v databáze",
    PASSWORD_VALIDATION_PATTERN_NEW:"Musí tam byť aspoň jedna číslica, jedno malé a jedno veľké písmeno. Biele medzery nie sú povolené",
    VALIDATION_PERCENT_VALUE:"Hodnota musí byť v rozsahu 1-999",
    NUMBERS_ONLY_100:"Počítanie do 100",
    NUMBERS_ONLY_1000:"Počítanie do 1000",
    POSITIVE_NUMBERS_ONLY:"Počítanie iba s číslom",
    GRID_PAGER_PAGE:"Strana",
    GRID_PAGER_ROWS_PER_PAGE:"Riadky na stránku",
    GRID_PAGER_PAGE_OF:"z",
    BREAD_CRUMBS_HOME:"Domov",
    BREAD_CRUMBS_DASHBOARD_TECH:"Technológia prístrojovej dosky",
    BREAD_CRUMBS_DETAILS:"Podrobnosti",
    BREAD_CRUMBS_SETTINGS:"Nastavenia",
    BREAD_CRUMBS_WORKING_HOURS:"Working hours",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Správa o celkovej sume peňazí za dni",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Správa o priemerných peniazoch za hodinu",
    BREAD_CRUMBS_NEW_USER_GROUP:"Vytvorenie skupiny používateľov",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Upraviť skupinu používateľov",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Vytvorenie šablóny kampane",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Úprava šablóny kampane",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Vytvorenie kampane",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Úprava kampane",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Pravidelné zhrnutie",
    LOGIN:"Prihlásiť sa",
    EMAIL:"E-mail",
    PASSWORD:"Heslo",
    LANGUAGE:"Jazyk",
    FORGOT_PASSWORD:"Zabudli ste heslo?",
    SUBMIT:"Odoslať",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Počet čakajúcich alarmov:",
    HEADER_VIEW_ALL_ALARMS:"Zobraziť všetky alarmy...",
    HEADER_MY_ACCOUNT:"Môj účet",
    HEADER_ACCOUNT_MANAGEMENT:"Správa účtu",
    ACCOUNT_ALREADY_EXIST:"E-mailová adresa sa už používa",
    NEWSLETTER_CONFIRMATION:"Odoslanie e-mailového oznámenia o stave alarmu",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Prehľad denných financií",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Technológia prístrojovej dosky",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Prístrojová doska",
    ASIDE_MENU_ALARMS:"Správy",
    ASIDE_MENU_FACILITIES:"Zariadenia",
    ASIDE_MENU_REPORTS:"Reporty",
    ASIDE_MENU_REPORT:"Vybraný report",
    ASIDE_MENU_LOYALTY:"Lojalita",
    ASIDE_MENU_USER_GROUPS:"Skupiny používateľov",
    ASIDE_MENU_PERIODIC_SUMMARY:"Pravidelné zhrnutie",
    ASIDE_MENU_MANAGING_TOKENS:"Správa žetónov",
    ASIDE_MENU_NEWS:"Novinky",
    DAILY_FINANCES_TOTAL_MONEY:"Celková suma peňazí",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Celková suma pre všetky zariadenia",
    DAILY_FINANCES_TOTAL_COINS:"Celkovo použitých kovových žetónov",
    DAILY_FINANCES_DOWNLOAD_CSV:"Stiahnuť CSV",
    DAILY_FINANCES_ONLINE:"R2W (online)",
    DAILY_FINANCES_OFFLINE:"Hotovosť",
    DAILY_FINANCES_CHANGER:"Hotovosť v meničke",
    DAILY_FINANCES_COINS:"Žetóny/Eurokey",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Typ reportu",
    REPORTS_CHOOSE_FACILITY:"Vyberte si zariadenie",
    REPORTS_PERIOD_1:"Obdobie 1 -",
    REPORTS_PERIOD_2:"Obdobie 2 -",
    MONEY_BY_DATE_REPORT:"Celkový príjem podľa dátumu",
    R2W_BY_DATE_REPORT:"Celkový príjem zo žetónov R2W podľa dátumu",
    COINS_BY_DATE_REPORT:"Celkový počet použitých žetónov podľa dátumu",
    AVG_MONEY_BY_HOUR_REPORT:"Priemerný hodinový príjem",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Priemerný príjem podľa dňa v týždni",
    AVG_MONEY_BY_BOX_REPORT:"Výdavky podľa umývacej stanice",
    COMPARE_PERIODS_REPORT:"Porovnávacia správa zariadenia",
    TOTAL_USERS_BY_GROUP:"Celkový počet návštev aplikácie R2W za deň",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"používatelia",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"návštevy",
    VISITS_COUNT_REPORT:"Počet používateľov aplikácie R2W na jednu návštevu",
    LOYALTY_PER_DAY_REPORT:"Počet miestnych žetónov využitých za deň",
    LOYALTY_PER_PAYMENT_METHOD:"Miestne žetóny priradené k platobnej metóde",
    VISITS:"Návštevy",
    VISIT:"Návšteva",
    TOTAL_SPENT_MONEY:"Celkový príjem",
    MONEY:"Peniaze",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Celkový príjem za obdobie",
    DOWNLOAD_CSV:"Stiahnuť CSV",
    TOTAL_SPENT_COINS:"Celkový počet použitých žetónov",
    TOTAL_USERS:"Celkový počet používateľov",
    TOTAL_CREDIT_GIVEN:"Celkový počet použitých miestnych virtuálnych žetónov",
    EUROKEY_BY_DATE_REPORT:"Celkové platby Eurokey podľa dátumu",
    TOTAL_SPENT_EUROKEY:"Celkové výdavky",
    SELECT_TYPE_OF_REPORT:"Musíte vybrať typ správy",
    NUMBER_OF_VISITS_TITLE:"Počet návštev",
    NUMBER_OF_USERS_TITLE:"Počet používateľov",
    PIECES_TITLE:"Kúsky",
    TOTAL_VISITS:"Celkový počet návštev",
    TOKENS_TITLE:"žetóny",
    SEARCH_USERS_NO_RESULTS:"Nenašli sa žiadni používatelia pre daný hľadaný výraz",
    SEARCH_USERS:"Vyhľadávanie používateľov",
    SEARCH_TELEPHONES:"Vyhľadávanie používateľov podľa telefónneho čísla.",
    ADD_USER_TO_GROUP:"Pridanie používateľa do skupiny",
    REMOVE_USER_FROM_GROUP:"Odstránenie používateľa zo skupiny",
    USER_GROUP_NAME_REQUIRED:"Vyžaduje sa názov skupiny používateľov",
    USER_GROUP_NAME:"Názov skupiny používateľov",
    USER_GROUPS_OVERVIEW:"Prehľad skupín používateľov",
    USER_COUNT:"Počet používateľov",
    NEW_USER_GROUP:"Vytvorenie novej skupiny používateľov",
    DELETE_USER_GROUP:"Odstránenie skupiny používateľov",
    UPDATE_USER_GROUP:"Upraviť skupinu používateľov",
    DELETE_USER_GROUP_ERROR:"Pri odstraňovaní vybranej skupiny používateľov došlo k chybe. Skúste to prosím znova alebo kontaktujte podporu...",
    CONFIRM_DELETE_USER_GROUP:"Ste si istí, že chcete odstrániť vybranú skupinu používateľov?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Vernostné akcie, ku ktorým bola vymazaná skupina priradená, sa už nebudú uplatňovať.",
    GROUP_NAME_MAX_LENGTH:"Názov skupiny musí mať menej ako 255 znakov",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Používateľ je už v tejto skupine",
    MISSING_USER:"Chýbajúci používateľ",
    USER_NOT_ON_LIST:"Používateľ nie je v zozname aktívnych používateľov. Skontrolujte, či je e-mailová adresa platná, a skúste to znova.",
    UPLOAD_USER_GROUP:"Nahrávanie zoznamu skupín používateľov zo súboru *.csv",
    UKNOWN_USERS:"Zoznam neznámych používateľov",
    CAMPAIGN_TEMPLATE_RULE:"Pravidlo šablóny",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Pri pokuse o odstránenie šablóny kampane došlo k chybe. Skúste to prosím znova alebo kontaktujte podporu...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Určite chcete odstrániť vybranú šablónu kampane",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Určite chcete odstrániť vybranú šablónu kampane",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Prehľad šablón kampaní",
    DELETE_CAMPAIGN_TEMPLATE:"Odstránenie šablóny kampane",
    UPDATE_CAMPAIGN_TEMPLATE:"Úprava šablóny kampane",
    CREATE_CAMPAIGN_TEMPLATE:"Vytvorenie novej šablóny kampane",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Vyžaduje sa názov šablóny kampane",
    CAMPAIGN_TEMPLATE_NAME:"Názov šablóny kampane",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Povinné pole",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"dať %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"predĺženie času",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Najskôr vyberte typ. Umývacie boxy alebo malé stroje.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Odstránenie pravidla šablóny",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"Do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"hodiny",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minúty",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nové pravidlo podľa počtu návštev",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nové pravidlo podľa množstva použitých žetónov",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nové pravidlo podľa dňa v týždni",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Pridanie nového pravidla šablóny",
    CAMPAIGN_TEMPLATE_RULE_1:"Každý",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Každý",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"žetóny minulé za menej ako",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"návštevy za menej ako",
    CAMPAIGN_TEMPLATE_RULE_3:"dni",
    CAMPAIGN_TEMPLATE_RULE_4:"žetóny",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Zoznam pravidiel je prázdny.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Dátum nemôže byť v minulosti",
    DELETE_CAMPAIGN_ERROR:"Pri pokuse o odstránenie kampane došlo k chybe. Skúste to prosím znova alebo kontaktujte podporu...",
    CONFIRM_DELETE_CAMPAIGN:"Ste si istí, že chcete odstrániť vybranú kampaň?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"Ste si istí, že chcete odstrániť vybraný text kampane?",
    CAMPAIGNS_OVERVIEW:"Prehľad kampaní",
    DELETE_CAMPAIGN:"Odstránenie kampane",
    UPDATE_CAMPAIGN:"Úprava kampane",
    CREATE_CAMPAIGN:"Vytvorenie novej kampane",
    CAMPAIGN_ACTIVE:"Aktívne",
    CAMPAIGN_TEMPLATE:"Šablóna",
    CAMPAIGN_GROUPS:"Skupiny",
    CAMPAIGN_ALL_USERS:"Všetci používatelia",
    CAMPAIGN_NAME:"Názov kampane",
    CAMPAIGN_NAME_REQUIRED:"Požadované",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Počet používateľov blízko limitu za deň",
    MESSAGE_TO_USERS:"Správa pre filtrovaných používateľov",
    SEND_MESSAGE:"Odoslať správu",
    THRESHOLD:"limit",
    TYPE:"Typ",
    TOTAL_MONEY_SPENT:"Celková suma vynaložená na kampaň",
    NUMBER_OF_VISITS:"Počet návštev v kampani",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Správa musí mať aspoň 10 znakov",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Správa musí mať menej ako 350 znakov",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Vyžaduje sa text správy",
    TECHNOLOGY:"Technológia",
    TAP_WATER:"Voda z vodovodu",
    REVERSE_OSMOSIS:"Reverzná osmóza",
    SOFTENED_WATER:"Zmäkčená voda",
    DOSER:"Doser",
    STATUS:"Stav",
    LAST_SYNCHRONIZATION:"Posledná synchronizácia",
    NO_OF_CURRENT_ALARMS:"Počet aktuálnych alarmov",
    NO_OF_CURRENT_WARNINGS:"Počet aktuálnych varovaní",
    WEATHER:"Počasie",
    BOXES_WORK_HOURS_COUNTERS:"Pracovný čas boxov",
    BOX_TOTAL_HOURS:"Celkový počet pracovných hodín",
    BOX_SERVICE_HOURS:"Celkový počet pracovných hodín (služba)",
    BOX_COUNTER_HOURS:"hodiny",
    ALARMS_AND_WARNINGS:"Alarmy a varovania",
    FILTER_AND_BOILER:"Filter a kotol",
    FILTER_TOTAL_DAYS:"Pracovné dni filtra",
    BOILER_TOTAL_DAYS:"Pracovné dni kotla",
    DAYS_UNIT:"dni",
    SOFTENER:"Zmäkčovač",
    MANUAL_COLD_DRAIN:"Manuálne vypúšťanie studenej vody",
    EL_COLD:"El. studený",
    DRAIN:"odtok",
    TAP:"kohútik",
    WASTE:"Odpad",
    OSMOSIS:"osmóza",
    DEMI_WATER:"Demi voda",
    EL_RINSE:"El. m. rinse",
    BOILER:"Kotol",
    EL_WAX:"El. m. vosk",
    FLOOR_HEATING:"Podlahové vykurovanie",
    DOSER_TANK:"Nádrž dávkovača",
    EL_WASH:"El. m. wash",
    DETERGENT:"Čistiaci prostriedok",
    VIBRATOR:"Vibrátor",
    UPDATE_FACILITY_SETTINGS:"Aktualizácia nastavení",
    GENERAL_SETTINGS:"Všeobecné nastavenia",
    LIGHTS:"Svetlá",
    GROUPS:"Skupiny",
    ANTI_FREEZE:"Ochrana proti zamrznutiu",
    AUTO:"Auto",
    MANUAL:"Manuál",
    ON:"Zapnuté",
    OFF:"Vypnuté",
    TEMPERATURE:"Teplota",
    UPDATE_DEVICE:"Aktualizácia nastavení zariadenia",
    BOX_CLEAN_HOURS:"Počítadlá na čistenie boxov (v hodinách)",
    GROUP_COUNTERS:"Počítadlá skupín",
    RESET:"Obnovenie",
    CASH_COUNT:"Počítadlo mincí",
    COINS_COUNT:"Počítadlo žetónov",
    EUROKEY_COUNT:"Počítadlo Eurokey",
    DOSER_WORK:"Pracovný čas dávkovača (sek.)",
    DOSER_PAUSE:"Čas pauzy dávkovača (s)",
    DELAY_BFV:"Oneskorenie BFV (ms)",
    DELAY_6M1:"Oneskorenie 6M1 (ms)",
    DELAY_LPS:"Oneskorenie LPS (ms)",
    RESET_CASH_COUNT_ALL:"Resetovanie všetkých počítadiel mincí",
    RESET_COINS_COUNT_ALL:"Resetovanie všetkých počítadiel žetónov",
    RESET_EUROKEY_COUNT_ALL:"Resetovanie všetkých počítadiel Eurokey",
    FACILITY_DETAILS:"Podrobnosti o zariadení",
    FACILITY_NAME:"Názov zariadenia",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Úspešne ste nahrali obrázok",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Úspešne ste aktualizovali údaje",
    CONNECTED:"Pripojené",
    DISCONNECTED:"Odpojené",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Filter správ",
    FACILITY:"Zariadenie",
    APPLY:"Aplikovať",
    TIME:"Čas",
    LOCATION:"Umiestnenie",
    ACKNOWLEDGED:"Potvrdené",
    FILTERED_MESSAGES:"Filtrované správy",
    ACK:"Potvrdené",
    NOT_ACK:"Neuznané",
    ALL:"Všetky",
    ALL_FACILITIES:"Všetky zariadenia",
    ENTER_DATE_PLACEHOLDER:"Zadajte dátum",
    OP_NESTANAK_NAPONA:"Chýbajúce napätie na indikátore fázy 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Vypadol istič vysokotlakového čerpadla",
    OP_UPR_NAPON_24VAC_GRE:"Chýba 24 VAC - istič 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Nádrž na čerstvú vodu je prázdna",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Vypadol istič sieťového vodného čerpadla",
    OP_MIN_NIVO_OMEKS_VODE:"Nádrž na zmäkčenú vodu je prázdna",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Vypadol istič čerpadla zmäkčenej vody",
    OP_MIN_NIVO_DEMIN_VODE:"Nádrž na vodu s osmózou je prázdna",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Vypadol istič vodného čerpadla osmózy",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Vypadol istič výrobného čerpadla osmózy",
    OP_BOJLER_GRESKA_MZS:"Chyba ohrievača vody",
    OP_CRPKA_PRASKA_GRE_MZS:"Vypadol istič čerpadla teplej vody",
    OP_DOZATOR_PRASKA_GRE_MZS:"Vypadol istič motora dávkovania prášku",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Práškový dávkovací vibračný istič klesol",
    OP_MIN_PRASAK_TON_ALARM:"Prázdna zmiešavacia nádrž na prášok",
    OP_USIS_KOV_TURBINA_GRESKA:"Vypadol istič vysávania mincí",
    OP_FILTER_VODE_ZACEPLJEN:"Zablokovaný vodný filter",
    OP_VISKTL_RESET_SATI_RADA:"Servis vysokotlakových čerpadiel",
    OPW_VISKTL_RESET_SATI_RADA:"Servis vysokotlakových čerpadiel",
    OP_FILTER_DANI_RADA:"Porucha vodného filtra",
    OP_BOJLER_DANI_RADA:"Porucha ohrievača vody",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm vysokotlakového čerpadla",
    OPW_ALARM_FILTER_SERVIS:"Servisný alarm filtra",
    OPW_ALARM_BOJLER_SERVIS:"Servisný alarm kotla",
    HAS_MEMBERS:"Vybraná skupina má členov a nemožno ju odstrániť. Členov je potrebné najprv odstrániť.",
    PERIODIC_SUMMARY_FOR:"Pravidelná súhrnná správa pre",
    PERIODIC_SUMMARY_REPORTS:"Pravidelné súhrnné správy",
    DATE_RANGE:"Rozsah dátumov",
    FINANCIAL_REPORT:"Finančná správa",
    GROSS_INCOME:"Hrubý príjem",
    GROSS_INCOME_SUM:"Celková suma hrubého príjmu",
    COMMISSION_FEE:"Poplatok za províziu",
    NET_INCOME:"Čistý príjem (na fakturáciu)",
    COMMISSION_FEE_DETAILS:"Provízia zahŕňa poplatok banky / PayPal alebo poskytovateľov služieb SMS.",
    LOYALTY_CREDITS_REPORT:"Správa o miestnych žetónoch",
    LOYALTY_GIVEN:"Dané lokálne žetóny",
    LOYALTY_USED:"Použité miestne žetóny",
    LOYALTY_SOLD:"Načítané miestne žetóny",
    LOYALTY_TOTAL:"Celkom",
    LOYALTY_CURRENT_MONTH:"Aktuálny mesiac",
    SOMETHING_WENT_WRONG:"Niečo sa pokazilo",
    MISSING_PAGE:"Prepáčte. Túto stránku sa nám nepodarilo nájsť",
    TRY_AGAIN:"Skúste to znova",
    DEFAULT_ERROR_NAME:"Vyskytla sa neznáma chyba",
    DEFAULT_ERROR_DESCRIPTION:"Skúste to prosím znova",
    MY_ACCOUNT_DETAILS:"Podrobnosti o mojom účte",
    SAVE_CHANGES:"Uloženie zmien",
    USERNAME:"Používateľské meno",
    FIRST_NAME:"Krstné meno",
    LAST_NAME:"Priezvisko",
    USER_ROLE:"Úloha používateľa",
    OLD_PASSWORD:"Staré heslo",
    NEW_PASSWORD:"Nové heslo",
    OLD_PASSWORD_REQUIRED:"Vyžaduje sa staré heslo",
    NEW_PASSWORD_REQUIRED:"Vyžaduje sa nové heslo",
    NEW_PASSWORD_REPEAT:"Vyžaduje sa opakovanie nového hesla",
    NEW_PASSWORD_NOT_MATCH:"Staré a nové heslo sa nezhodujú",
    PASSWORD_DIFFERENT_VALIDATION:"Nové heslo sa musí líšiť od starého",
    PASSWORD_MIN_CHAR:"Vaše heslo musí mať aspoň 8 znakov.",
    PASSWORD_MAX_CHAR:"Vaše heslo musí mať maximálne 32 znakov.",
    PASSWORD_PATTERN_VALIDATION:"Heslo musí obsahovať aspoň jedno číslo",
    ACCOUNT_MANAGEMENT:"Správa účtov",
    NOT_ACTIVE:"Nie je aktívny",
    ASSIGN_ROLE:"Priradenie úlohy",
    UPDATE:"Aktualizácia",
    ADD_NEW_ACCOUNT:"Pridať nové konto",
    EMAIL_REQUIRED:"Vyžaduje sa e-mailová adresa",
    EMAIL_NOT_VALID:"E-mailová adresa nie je platná",
    ADD_NEW_USER_TEXT:"Na zadanú e-mailovú adresu bude odoslaný e-mail s aktivačným prepojením.",
    UPDATE_USER_NOTIFICATION:"Úspešne ste aktualizovali svoje údaje",
    CHANGED_PASSWORD_NOTIFICATION:"Úspešne ste zmenili heslo",
    UPDATE_USER_GROUP_NOTIFICATION:"Úspešne ste aktualizovali názov skupiny používateľov",
    CREATE_USER_GROUP_NOTIFICATION:"Úspešne ste vytvorili skupinu",
    DETELE_USER_GROUP_NOTIFICATION:"Úspešne ste odstránili skupinu",
    EMPTY_GROUP_LIST_MSG:"Nie sú vytvorené žiadne skupiny. Začnite vytvorením jednej z nich",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Úspešne ste odstránili používateľa zo skupiny",
    ADD_USER_TO_GROUP_NOTIFICATION:"Úspešne ste pridali používateľa do skupiny",
    ADD_USER_NOTIFICATION:"Úspešne ste pridali nového používateľa",
    DELETE_USER_NOTIFICATION:"Úspešne ste odstránili používateľa",
    RESEND_USER_VERIFICATION_EMAIL:"Úspešne ste opätovne odoslali overovací e-mail",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Ak chcete vytvoriť skupinu používateľov",
    DELETE_USER:"Odstránenie používateľa",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Ste si istí, že chcete odstrániť používateľa zo skupiny používateľov?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Vážený používateľ R2W",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Pravidlo vernosti na počet návštev",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Pravidlo vernostného programu na množstvo využizývh žetónov",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Pravidlo vernosti na deň v týždni",
    REMOVE_CAMPAIGN_RULE_TITLE:"Odstránenie pravidiel kampane",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Ste si istí, že chcete odstrániť pravidlo kampane?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Úspešne ste vytvorili novú kampaň",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Úspešne ste aktivovali kampaň",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Neexistujú žiadne vytvorené kampane. Začnite vytvorením jednej",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Úspešne ste odoslali správu",
    COMPANY_ACCOUNTS:"Účty spoločnosti",
    BUSSINESS_INVOICES_LIST:"Moje faktúry B2B",
    LOCALE_TOKEN:"Miestny žetón",
    R2W:"Globálny žetón",
    START_MONTH:"Začiatok mesiaca",
    END_MONTH:"Koniec mesiaca",
    TOKEN_TYPE:"Typ žetónu",
    TOKEN_NUMBER:"Číslo žetónu",
    NOTHING_TO_DISPLAY:"* Nič na zobrazenie",
    CREATE_INVOICE:"Vytvoriť faktúru",
    INVOICE:"Faktúra",
    INVOICES:"Faktúry",
    EDIT_INVOICE:"Upraviť faktúru",
    UPDATE_INVOICE_NOTIFICATION:"Úspešne ste aktualizovali faktúru do stavu čakajúce na vybavenie",
    CURRENT_CHARGES:"Poplatky za súčastné obdobie",
    PAYMENTS_ON_HOLD:"Faktúry v procese spracovania",
    FOR_INVOICING:"Na fakturáciu",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Chystáte sa zrušiť faktúru",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Ste si istí, že chcete zrušiť túto faktúru ?",
    INVOICING_NOTIFICATION_HEADER:"Chystáte sa fakturovať",
    INVOICING_NOTIFICATION_TEXT:"Ste si istí, že chcete poslať faktúru?",
    SENT_INVOICE_NOTIFICATION:"Úspešne ste odoslali faktúru",
    CANCELED_INVOICE_NOTIFICATION:"Úspešne ste zrušili faktúru",
    INVOICE_DESCRIPTION_TEXT:"Faktúra za",
    INVOICE_STATE:"Stav faktúry",
    INVOICE_NUMBER:"Číslo faktúry",
    INVOICE_TOTAL:"Celkom",
    SELECT_YEAR:"Vyberte rok",
    DOWNLOAD:"Stiahnuť PDF",
    INVOICE_NUMBER_HEADER:"Chystáte sa odoslať faktúru s číslom",
    INVOICE_PAYMENT_CONFIRMATION:"Chystáte sa potvrdiť platbu za",
    INSERT_INVOICE_NUMBER:"Vložte číslo faktúry",
    INVOICED_WARNING:"E-mail nebol odoslaný. Počkajte prosím...",
    SEND_INVOICE:"Odoslať",
    INVOICE_ALL:"Všetky",
    INVOICE_FROM_R2W:"Od spoločnosti R2W",
    INVOICE_TO_R2W:"Na R2W",
    PAYMENT_REQUEST:"Žiadosť o platbu",
    PAYMENT_REQUEST_STATE:"Stav žiadosti o platbu",
    PAYMENT_REQUEST_NUMBER:"Číslo žiadosti o platbu",
    FOR_PAYMENT_REQUEST:"Pre žiadosti o platbu",
    PAYMENT_REQUEST_ON_HOLD:"Žiadosti o platbu v procese",
    DOWNLOAD_INVOICE:"Stiahnite si faktúru",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknite pre možnosti stiahnutia",
    B2B_SPEC:"Špecifikácia B2B",
    B2C_SPEC:"Špecifikácia B2C",
    DOWNLOAD_PAYMENT_REQUEST:"Stiahnuť žiadosť o platbu",
    LOYALTY_PREVIEW:"Ukážka vernostného programu",
    ACTIVATED:"Aktivované",
    RUNNING:"Prebieha",
    NOT_ACTIVATED:"Nie je aktivovaný",
    FINISHED:"Dokončené",
    DEPRECATED:"Vyradené",
    UPCOMING:"Nadchádzajúce",
    NONE:"Individuálne",
    STARTED:"Začal",
    ENDS:"Končí",
    DEDICATED:"Venované",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Chystáte sa aktivovať",
    CAMPAIGN:"Kampaň",
    SEND_MESSAGE_NOTIFICATION:"Chystáte sa odoslať správu vybraným skupinám používateľov",
    DIVISIBLE_TO_NUMBER:"Číslo by malo byť deliteľné s",
    BRIDGE_PLC:"Mostík - PLC",
    DEVICE_TYPE:"Typ zariadenia",
    LISTENER:"Malé stroje",
    BRIDGE:"Umývacie boxy",
    WASH_BOXES:"Umývacie boxy",
    VACUUMS:"Vysávače",
    SAVE_NEWS:"Uložiť novinky",
    CREATE_NEW_NEWS:"Vytvorenie novej správy",
    HISTORY_OF_ALL_NEWS:"História všetkých správ",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Zadajte názov zariadenia",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Pridanie ďalšieho zariadenia",
    NEWS_TEXT:"Text správy",
    NEWS_TITLE:"Názov správy",
    DELETE_NEWS_CONFIRMATION:"Chystáte sa vymazať správy",
    NEWS_DELETE_NOTIFICATION:"Úspešne ste vymazali správy",
    NEWS_SAVE_NOTIFICATION:"Úspešne ste uložili správy",
    NEWS_CREATION_DATE:"Dátum vytvorenia",
    NO_TITLE:"Žiadny názov",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Text správy musí mať menej ako 255 znakov",
    NEWS_TEXT_REQUIRED_VALIDATION:"Vyžaduje sa text správy",
    NEWS_TITLE_REQUIRED_VALIDATION:"Vyžaduje sa názov správy",
    DEACTIVATE:"Deaktivácia",
    ASIDE_MENU_LOCAL_TOKENS:"Miestne žetóny",
    CREATE_NEW_LOCAL_TOKENS:"Vydanie nových miestnych žetónov",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Zadajte e-mailovú adresu zákazníka a množstvo miestnych žetónov, ktoré chcete zákazníkovi vydať.",
    CREATE_TOKENS:"Vydávanie žetónov",
    MINIMUM_ONE_TOKEN:"Hodnota musí byť číslo väčšie ako 0",
    CUSTOMER_EMAIL:"E-mail zákazníka",
    AMOUNT_OF_TOKENS:"Množstvo žetónov",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Úspech pri vydávaní miestnych žetónov",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Pri vydávaní miestnych žetónov došlo k chybe. Skontrolujte prosím e-mailovú adresu zákazníka a skúste to znova.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Prehľad vydaných miestnych žetónov",
    ISSUED_AT:"Vydané v",
    ISSUED_BY:"Vydal",
    CODE:"Uplatniť kód",
    REDEEMED_BY:"Uplatnil(a)",
    REDEEMED_AT:"Uplatnené v",
    ASIDE_MENU_VOUCHERS:"Poukazy",
    PRINT:"Tlač",
    VOUCHERS_OVERVIEW:"Prehľad poukazov",
    CREATE_NEW_VOUCHERS:"Vytvorenie nových poukazov",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Vytvorte novú sériu poukazov na uplatnenie zadaním počtu žetónov na jeden poukaz.",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Množstvo žetónov na jeden poukaz",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Na jeden poukaz môžete priradiť 1 až 100 žetónov.",
    NUMBER_OF_NEW_VOUCHERS:"Počet poukazov, ktoré sa majú vytvoriť",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"V jednej sérii môžete vytvoriť 1 až {{size}} poukazov",
    NEW_VOUCHERS_PREFIX:"Predpona kódu novej série poukazov",
    VALIDATION_VOUCHER_PREFIX:"Predpona kódu musí mať presne 4 znaky (veľké písmená a/alebo číslice)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Vyskytol sa problém s vytváraním nových poukazov. Skúste to prosím znova alebo kontaktujte našu podporu.",
    CREATE_VOUCHERS:"Vytvorenie poukazov",
    CREATING_VOUCHERS_SUCCESS:"Úspešne vytvorené nové poukazy",
    PRINT_NEW_VOUCHERS:"Tlač poukazov",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Zadajte prefix kódu série poukazov, aby ste mohli vytlačiť celú sériu poukazov. Prípadne",
    PRINT_VOUCHERS_PREFIX:"Predpona kódu poukazu (série)",
    NO_VOUCHERS_FOR_PRINT:"Neboli nájdené žiadne poukazy zodpovedajúce zadanému kódu pre tlač",
    PRINT_VOUCHERS:"Vytlačiť poukaz(y)",
    VALIDATION_VOUCHER_CODE_FILTER:"Vyhľadávaný výraz poukazu musí pozostávať z veľkých písmen a číslic",
    FILTER_VOUCHERS_BY_CODE:"Vyhľadávanie poukazov podľa kódu uplatnenia",
    FILTER_VOUCHERS:"Vyhľadávanie poukazov",
    WASH_BOX:"Umývací box",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Celkovo použitých digitálnych tokenov",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Celkový počet predaných miestnych žetónov podľa dátumu",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Celkový počet použitých miestnych žetónov podľa dátumu",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Celkový počet daných miestnych žetónov podľa dátumu",
    LOCAL_TOKEN:"Miestny žetón",
    GIVEN_TOKEN:"Dané lokálne žetóny",
    SOLD_TOKEN:"Predané miestne žetóny",
    SMALL_MACHINES:"Malé stroje",
    R2W_Listener:"Poslucháč",
    HHANLE_DEVICE:"Umývací box HHanle",
    CODE_PREFIX_EXIST:"Predpona kódu už existuje",
    CODE_PREFIX_EXIST_TEXT:"Nemôžete vytvoriť nový poukaz s touto predvoľbou kódu. Prosím, nastavte iný.",
    MIN_FOUR_VALIDATION:"Presne 4 znaky",
    ALL_INFORMATION_1:"Všetky informácie o",
    ALL_INFORMATION_2:"sa stratia",
    ASIDE_MENU_TRANSACTIONS:"Transakcie",
    EXPENSES:"Výdavky",
    TOPUPS:"Doplnenia",
    EXPENSES_LIST:"Zoznam výdavkov",
    USER_EMAIL:"E-mail používateľa",
    COMPANY_NAME:"Názov spoločnosti",
    TOPUPS_LIST:"Zoznam doplnených položiek",
    CONSUMER:"Spotrebiteľ",
    SYSTEM_ADMIN:"Správca systému",
    MERCHANT_ADMIN:"Správca obchodníka",
    COMPANY_ADMIN:"Správca spoločnosti",
    FACILITY_ADMIN:"Správca zariadenia",
    SUBSCRIBER:"Predplatiteľ",
    CONFIGURATOR:"Konfigurátor",
    SETUP_UNIT_SERIAL_NO:"Sériové číslo",
    SETUP_UNIT_MATERIAL_NO:"Číslo materiálu",
    SETUP_UNIT_WEBAPI_VERSION:"Verzia WebApi",
    TOTAL_TURNOVER:"Obrat umývacieho zariadenia",
    AVAILABILITY_ALL:"Dostupnosť",
    AVAILIBILITY:"Dostupnosť umývacích boxov:",
    AVAILABILITY_VACUUMS:"Dostupnosť vysávačov:",
    WASH_BOX_INFO:"Informácie o umývacích boxoch",
    VACUUM_CLEANER_INFO:"Informácie o vysávačoch",
    BREAD_CRUMBS_SERVICE:"Služba",
    HOLIDAYS:"Dovolenky",
    HOLIDAY:"Dovolenka",
    LIGHTS_ON:"Zapnuté svetlá",
    LIGHTS_OFF:"Vypnuté svetlá",
    WASH_BOXES_ON:"Umývací box zapnutý",
    WASH_BOXES_OFF:"Umývací box vypnutý",
    VACUUMS_ON:"Vysávače zapnuté",
    VACUUMS_OFF:"Vysávače vypnuté",
    TURNOVER:"Obrat",
    TURNOVER_MANUAL_WASH_UNIT:"Manuál obratu",
    STATUS_BAY_RUN_TIME:"Celkový pracovný čas umývacieho boxu",
    STATUS_BAY_PROGRAM_NAME:"Názov programu",
    STATUS_BAY_CREDIT:"Kredit na umývací box",
    CLOUD_KREDIT:"Kredit na cloude",
    STATUS_VACUUM_RUN_TIME:"Celkový pracovný čas vysávača",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Informácie o službách zariadenia, programe umývacieho boxu a aktuálnych údajoch o poruchách",
    UNAVAILABLE:"Jednotka nie je k dispozícii",
    SHOW_HIDE_TABLE:"Zobraziť/skryť tabuľku pracovného času",
    PROGRAM_NAME:"Názov programu",
    PROGRAM_COUNTER:"Počítadlo programov",
    NO_NAME:"Odkaz nemá meno",
    COUNTER_SERVICE_DATA:"Údaje o službách",
    NEED_SERVICE:"Potrebná služba",
    PROGRAM_DATA:"Údaje o programe umývacieho boxu",
    CURRENT_FAULT_DATA:"Aktuálne údaje o poruche",
    REFERENCE_DUE:"Splatné",
    REFERENCE_SECONDS:"Sekundy",
    REFERENCE_NAME:"Názov časti",
    WASHBOX_NAME:"Názov umývacieho boxu",
    FAULT_NAME:"Názov poruchy",
    FAULT_NUMBER:"Číslo poruchy",
    CURRENT_FAULT_COUNT:"Aktívne poruchy",
    DEVICE_NOT_INSTALLED:"Zariadenie nie je nainštalované",
    STATUS_READY:"Stav pripravenosti",
    STATUS_ERROR:"Stav chyby",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Chyba softvéru",
    SOFTWARE_RESET:"Chyba softvéru",
    EXTERNAL_PIN_RESET:"Chyba softvéru",
    RESTART_OR_BROWNOUT_OCCURRED:"Chyba softvéru",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Chyba hardvéru",
    COULD_NOT_SIMULATE_COIN:"Chyba hardvéru",
    ERROR_SETTING_INHIBIT_MODE:"Chyba hardvéru",
    OFFLINE_DEVICE:"Umývačka áut vypnutá",
    TARIFFS:"Tarify",
    DAY:"Deň",
    NIGHT:"Noc",
    VOUCHER_CODE:"Kód kupónu",
    DISMISS_ALARM:"Resetovať alarm?",
    ALARM_ACTIVE:"Aktívne alarmy",
    NO_ALARM_ACTIVE:"Neexistujú žiadne aktívne alarmy",
    ALARM_HISTORY:"História alarmov",
    MANAGING_TOKENS:"Správa žetónov",
    EXPIRATION_DATE:"Dátum skončenia platnosti",
    EXTEND_TOKEN_DATE:"Predĺžiť platnosť žetónov pre",
    DELETE_TOKENS_FOR:"Odstránenie žetónov pre",
    PUMP_TYPE:"Typ čerpadla",
    TURN_OFF_DEVICE:"Stav zariadenia",
    OPERATION_DATA:"Prevádzkové údaje",
    PUMP_DATA:"Údaje o čerpadle",
    PUMP_NAME:"Názov čerpadla",
    POINT_NAME:"Názov bodu",
    CHANGER_INCOME:"Celkové príjmy z meničky podľa dátumu",
    SELECTED_OPEN:"Otvorené vo vybraných pracovných hodinách",
    ALWAYS_OPEN:"Vždy otvorené (24/7)",
    CLOSED:"Zatvorené",
    CLOSED_24:"Zatvorené 24 hodín denne",
    OPENED_24:"Otvorené 24 hodín denne",
    MON:"Pondelok",
    TUE:"Utorok",
    WED:"Streda",
    THU:"Štvrtok",
    FRI:"Piatok",
    SAT:"Sobota",
    SUN:"Nedeľa",
    PRICING:"Cenová ponuka",
    PRICE:"Cena",
    VALIDITY:"Platnosť",
    TOKEN_PACKAGES:"Balíky žetónov",
    SINGLE_WASH:"Jednorazové umývanie",
    FACILITY_WORKING_HOURS:"Nastavenie pracovného času pre vybrané zariadenie",
    WORKING_HOURS_ALWAYS_OPEN:"Vždy otvorené",
    WORKING_HOURS_ALWAYS_CLOSE:"Uzavreté operátorom",
    WORKING_HOURS_CUSTOM:"Nastavenie pracovného času",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor buffer tank empty activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor buffer container empty and buffer contianer full switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor ro pump on and buffer container full switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizácia",
    CREATE_ORGANIZATION:"Vytvoriť organizáciu",
    CREATE_ORGANIZATION_AS:"Vytvoriť organizáciu ako podradenú",
    DELETE_ORGANIZATION:"Odstrániť organizáciu",
    EDIT_ORGANIZATION:"Upraviť organizáciu",
    SUPPORTED_ORG_NAME:"Podporovaná organizácia",
    SUPPORTED_ORG_TYPE:"Podporovaný typ",
    ORG_NAME:"Názov",
    ORG_TYPE:"Typ",
    SET_ORG_TITLE:"Nastavenie organizácie detí",
    SET_SUPPORTED_ORG_TITLE:"Nastavenie podporovanej detskej organizácie",
    SAVE_ORGANIZATION:"Uložiť organizáciu",
    SELECT_ORGANIZATION_TYPE:"Vyberte typ organizácie",
    SELECT_ORGANIZATION_SELECTOR:"Vyberte",
    SELECT_SUPPORTED_ORGANIZATION:"Podporované",
    ORGANIZATION_DELETED:"Organizácia úspešne vymazaná",
    ORGANIZATION_SAVED:"Organizácia úspešne uložená",
    ORGANIZATION_UPDATED:"Organizácia úspešne aktualizovaná",
    ALERTS:"Upozornenia",
    DEVICE_STATUS:"Stav zariadenia",
    SITE_DETAILS:"Podrobnosti o lokalite",
    ALARM_STATUS:"Stav upozornenia",
    FILTER:"Filtrovanie podľa ...",
    FILTER_BY_ALERT_CENTER:"Filtrovanie podľa kódu, názvu alebo opisu",
    TOTAL_ALARM:"Celkom",
    LOW_ALARM:"Udalosť",
    MEDIUM_ALARM:"Porucha",
    HIGH_ALARM:"Kritická porucha",
    NO_FACILITIES_NEARBY:"V blízkosti sa nenachádzajú žiadne zariadenia",
    GRAY_MAP:"Mapa v sivom štýle",
    READY:"Pripravené",
    WARNING:"Porucha",
    ERROR:"Chyba",
    SITE_NAME:"Názov lokality",
    ACCOUNTS_INFO:"Informácie o účte",
    USER_ORGANIZATION:"Organizácia používateľov",
    ADD_USER_ORGANIZATION:"Pridanie nového používateľa organizácie",
    EDIT_USER_ORGANIZATION:"Úprava používateľov organizácie",
    SELECT_ROLE:"Vyberte rolu",
    SELECT_ORGANIZATION:"Vybrať organizáciu",
    SELECT_USER:"Vyberte používateľa",
    USER_FOR_ORGANIZATION_CREATED:"Úspešne vytvorený nový používateľ",
    SELECT_REGION:"Výber regiónu",
    SELECT_LANGUAGE:"Výber jazyka",
    LOADING_DATA:"Načítavanie údajov, počkajte, prosím...",
    ADMINISTRATOR:"Správca",
    TECHNICAL_SUPPORT:"Technická podpora",
    CONTROLLER:"Ovládač",
    EDIT_ORGANIZATION_USER:"Úprava používateľov organizácie",
    DELETE_ORGANIZATION_USER:"Odstránenie používateľov organizácie",
    USER_UPDATED:"Používateľ úspešne aktualizovaný",
    USER_CREATED:"Používateľ bol úspešne vytvorený",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"Predplatné",
    RESOLVED_STATUS:"Vyriešené",
    NOT_RESOLVED_STATUS:"Nie je vyriešené",
    ALERT_NAME:"Názov upozornenia",
    ALERT_DESCRIPTION:"Popis upozornenia",
    ALERT_CODE:"Kód upozornenia",
    ALERT_TYPE:"Typ upozornenia",
    UNSUBSCRIBE:"Upozornenie na zrušenie odberu",
    SUBSCRIBE:"Upozornenie na odber",
    ALARM_SUBSCRIBED:"Úspešne prihlásený k odberu",
    UNSUBSCRIBED_CONFIRM:"Odhlásiť sa z odberu?",
    ALARM_UNSUBSCRIBED:"Úspešne odhlásený z odberu",
    ASIDE_MENU_CASHLESS_SALES:"Bezhotovostný predaj",
    FILTERED_CASHLESS_PAYMENTS:"Filtrované bezhotovostné platby",
    REFUND_DIALOG_TITLE:"Transakcia vrátenia peňazí?",
    REFUND_DIALOG_SUBTITLE:"Suma môže byť nižšia alebo rovná sume transakcie",
    REFUND:"Vrátenie peňazí",
    INPUT_NOT_VALID:"Vstup nie je platný",
    REFUND_SUCCESSFULLY:"Refundácia vybranej platby bola úspešne vykonaná",
    USER:"Používateľ",
    TRANSACTION_ID:"Odkaz na systém PSP",
    DEVICE_ID:"ID zariadenia",
    NET_AMOUNT:"Čistá suma",
    REPORT_NAME:"Názov správy",
    TIME_FRAME:"Časový rámec",
    SUB_POINT:"Výber vedľajšieho bodu",
    SUB_POINT_LIST_NOT_EXIST:"Zoznam podbodov neexistuje pre vybrané umývacie zariadenie",
    FACILITY_TYPE:"Typ zariadenia",
    MACHINE_NAME:"Názov stroja",
    WASH_FACILITY_DETAILS:"Podrobnosti o umývacom zariadení",
    WASH_BAY_DETAILS:"Podrobnosti o umývacom priestore",
    DEVICES_INFO:"Zoznam zariadení",
    OPERATION_TIME_INFO:"Čas prevádzky",
    OPERATION_TIME_VACUUM_INFO:"Prevádzkový čas vysávačov",
    OPERATION_TIME_ILLUMINATION_INFO:"Prevádzkový čas osvetlenia",
    AVAILABLE_TITLE:"Dostupné",
    UNAVAILABLE_TITLE:"Nedostupné",
    CURRENT_PROGRAM:"Aktuálny program",
    CREDITS:"Kredity",
    DEVICE_NAME:"Názov zariadenia",
    ACTIVE_ALARMS:"Aktívne upozornenia",
    ALL_DAY:"Celý deň",
    OPERATING_TIME_WASH_FACILITY:"Samoobslužný umývací systém",
    OPERATING_TIME_VACUUMS:"Vysávače",
    OPERATING_TIME_ILLUMINATION:"Osvetlenie",
    OPERATION_COUNTERS:"Počítadlá operácií",
    EDIT:"Upraviť",
    WASHING_PROGRAMS:"Umývacie programy",
    INFO:"Udalosť",
    STATISTIC:"Štatistika",
    ROLLOVER_DOSING:"Dávkovanie",
    ROLLOVER_SPEED:"Rýchlosti",
    ROLLOVER_RESETS:"Diaľkové resetovanie pri Rollover",
    ROLLOVER_RESETS_INFO:"Diaľkový reset musí byť v súlade s miestnymi predpismi. Dôležité: Pred resetovaním sa uistite, že je rollover prázdny.",
    RESET_ROLLOVER:"Obnovenie rollover",
    OPEN_DOOR_ROLLOVER:"Otvoriť",
    ROLLOVER_OPEN_DOOR_INFO:"Otvorte dvere umývacej haly. Buďte opatrní.",
    ROLLOVER_OPEN_DOOR:"Otvorte dvere",
    APPLY_DOSING_CHANGES:"Aplikujte zmeny dávkovania",
    APPLY_SPEED_CHANGES:"Aplikovať zmeny rýchlosti",
    ACTUATION_SUCCESS:"Odoslanie žiadosti",
    REMAINING_TIME:"Zostávajúci čas",
    OPEN_24H:"Otvoriť 24 hodín",
    CLOSE_24H:"Zavrieť 24 hodín",
    VALIDATION_OPERATION_TIME:"Formát nie je správny. Použite hh:mm",
    ROLLOVER:"Rollover",
    UPDATE_WASHING_PROGRAM:"Aktualizácia pracieho programu",
    UPDATE_ACTUATORS:"Aktualizácia aktuátorov",
    OPEN_ROLOVER_DOOR_TITLE:"Chcete otvoriť rollover dvere?",
    OPEN_ROLOVER_DOOR_CONTENT:"Určite chcete otvoriť dvere?",
    RESET_ROLOVER_TITLE:"Chcete obnoviť rollover?",
    RESET_ROLOVER_CONTENT:"Ste si istí, že chcete obnoviť rollover?",
    G0:"Stanica 1",
    G1:"Stanica 2",
    G2:"Stanica 3",
    G3:"Stanica 4",
    G4:"Stanica 5",
    G5:"Stanica 6",
    G6:"Stanica 7",
    G7:"Stanica 8",
    G8:"Stanica 9",
    G9:"Stanica 10",
    G10:"Stanica 11",
    U0:"Vysávač 1",
    U1:"Vysávač 2",
    U2:"Vysávač 3",
    U3:"Vysávač 4",
    U4:"Vysávač 5",
    U5:"Vysávač 6",
    U6:"Vysávač 7",
    U7:"Vysávač 8",
    ALERT_CENTER_TITLE_BY_SITE:"Správa centra výstrah vytvorená vybraným miestom z prístrojového panela",
    ALERT_CENTER_TITLE_BY_FACILITY:"Správa centra výstrah vytvorená vybraným zariadením z prístrojového panela",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Správa centra varovania",
    ERROR_MESSAGE_403:"Na použitie tohto volania api nemáte oprávnenie. Kód chyby: 403",
    LAST_ACTIVE_PROGRAM:"Aktívny program / Posledný aktívny program",
    PROGRAM_ID:"Číslo programu",
    PROGRAM_PRICE:"Cena programu",
    PROGRAM_DESCRIPTION:"Popis programu",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Potrebné doplnenie",
    EMPTY_CHEMICAL_LEVEL:"Prázdne",
    CHEMICAL_LEVEL:"Úroveň indikácie detergentov (%)",
    ROLLOVER_STATUS:" Rollover status",
    ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
    ROLLOVER_STATUS_CODE_1:" Outside operating time",
    ROLLOVER_STATUS_CODE_2:" Program entry allowed",
    ROLLOVER_STATUS_CODE_3:"Position your vehicle",
    ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
    ROLLOVER_STATUS_CODE_5:"Vehicle back",
    ROLLOVER_STATUS_CODE_6:"Vehicle stop",
    ROLLOVER_STATUS_CODE_7:"Wash active",
    ROLLOVER_STATUS_CODE_8:"Wash stopped",
    ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
    ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
    ROLLOVER_STATUS_CODE_11:"Emergency stop",
    ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
    ROLLOVER_STATUS_CODE_13:"Anti frost active",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
    ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Kritická porucha",
    NO_ALARM:"Žiadna kritická porucha",
    SOFTWARE_VERSION:"Verzia softvéru",
    SOFTWARE_DATE:"Dátum softvéru",
    SITE_ADDRESS:"Adresa lokality",
    SECONDS:"Sekundy",
    SERVICE_PART_NAME:"Názov služby:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Prevádzkový a servisný pult",
    OPERATION_COUNTER:"Počítadlo operácií",
    SERVICE_COUNTER:"Servisný pult",
    FAULT_CODE:"Kód upozornenia",
    PRESSURE_TITLE:"Tlak vzduchu",
    TIME_TITLE:"Aktuálny čas",
    COUNTRY_TITLE:"Krajina",
    CITY_TITLE:"Mesto",
    REGION_TITLE:"Región",
    SELECT_POINTS_TO_SEARCH:"Vyberte body...",
    LOGS_HISTORY:"História zmien parametrov",
    ACTUATOR_REFERENCE:"Referencia na aktuátor",
    ACTUATOR_VALUE:"Hodnota aktuátora",
    POINT_ID:"Identifikátor bodu",
    VALIDATION_NOT_VALID_RANGE:"Nesprávny rozsah",
    ENABLE_ROLLOVER_RESET:"Zaškrtnutím tohto políčka potvrdzujete, že ste si prečítali bezpečnostné pokyny a súhlasíte s nimi.",
    CHANGE_OF_PARAMETERS:"Zmena parametrov",
    SELECT_OPTIONS:"Vyberte možnosti",
    AUTOMATIC:"Automatické",
    DESALTING:"Funkcia odsoľovania",
    SEASON_WASH:"Sezónne umývacie programy",
    SPRING_PROGRAM:"Jarné umývacie programy",
    SUMMER_PROGRAM:"Letné umývacie programy",
    AUTUMN_PROGRAM:"Jesenné umývacie programy",
    WINTER_PROGRAM:"Zimné umývacie programy",
    DOOR_CONTROL:"Ovládanie dverí",
    SUMMER_DOOR_CONTROL:"Letný režim, ovládané s riadením brány v letnom režime",
    WINTER_DOOR_CONTROL:"Zimný režim, ovládané s riadením brány v zimnom režime",
    APPLY_PARAMETERS_CHANGES:"Aplikovať zmeny parametrov",
    WORKING_SCHEDULES:"Pracovné harmonogramy",
    HOLIDAY_SCHEDULES:"Dovolenkové rozvrhy",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Dovolenka na mieste úspešne vytvorená",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Dovolenka na mieste úspešne aktualizovaná",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Dovolenka na stránke úspešne odstránená",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Pracovné plány boli úspešne aplikované.",
    HOLIDAY_SUCCESSFULLY_DELETED:"Dovolenka úspešne odstránená",
    SB_MU_MB_2_2_0:" SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:" SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:" SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:" SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:" SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:" SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:" SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:" SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:" SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:" CB3_1_0_0_Trans",
    CW35_3_0_0:" CW35_3_0_0_Trans",
    CW35_3_1_0:" CW35_3_1_0_Trans",
    CWB3_3_0_0:" CWB3_3_0_0_Trans",
    CWB3_3_1_0:" CWB3_3_1_0_Trans",
    CW1_3_0_0:" CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Sušiaci prostriedok s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampón s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_FOAM:"Pena s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_WAX_1:"Vosk s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_POLISH_1:"Leštenka s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Čistič diskov s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_WAX_2:"Vosk s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Lesk na pneumatiky s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Odstraňovač hmyzu s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_POLISH_2:"Leštenka s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_INTENSIVE:"Intenzívny prostriedok s nízkou hladinou náplne",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pena „dážď“ s nízkou hladinou náplne",
    CHEM_LEVEL_DRYING_AGENT:"Hladina náplne – sušiaci prostriedok",
    CHEM_LEVEL_SHAMPOO:"Hladina náplne – šampón",
    CHEM_LEVEL_FOAM:"Hladina náplne – pena",
    CHEM_LEVEL_WAX_1:"Hladina náplne – vosk",
    CHEM_LEVEL_POLISH_1:"Hladina náplne – leštenka",
    CHEM_LEVEL_RIM_CLEANER:"Hladina náplne – čistič diskov",
    CHEM_LEVEL_WAX_2:"Hladina náplne – vosk",
    CHEM_LEVEL_TYRE_SHINE:"Hladina náplne – lesk na pneumatiky",
    CHEM_LEVEL_INSECT_REMOVER:"Hladina náplne – odstraňovač hmyzu",
    CHEM_LEVEL_POLISH_2:"Hladina náplne – leštenka",
    CHEM_LEVEL_INTENSIVE:"Hladina náplne – intenzívny prostriedok",
    CHEM_LEVEL_FOAM_RAIN:"Hladina náplne – pena „dážď“",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servisný pult – zdvíhací pás strešnej kefy",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servisný pult – zdvíhací pás sušiča",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servisný pult – kábel motora strešnej kefy",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servisný pult – servis čerpadla čerstvej vody",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servisný pult – servis čerpadla použitej vody",
    DRYING_AGENT:"Sušiaci prostriedok",
    FOAM_DRYING_AGENT:"Pena na sušenie",
    SHAMPOO:"Šampón",
    FOAM:"Pena",
    BRUSH_FOAM:"Pena na kefy",
    WAX_1:"Vosk",
    FOAM_WAX_1:"Penový vosk",
    POLISH_1:"Lak",
    RIM_CLEANING:"Čistič ráfikov",
    WAX_2:"Vosk",
    FOAM_WAX_2:"Penový vosk",
    TYRE_SHINE:"Lesk pneumatík",
    INSECT_REMOVER:"Odstraňovač hmyzu",
    POLISH_2:"Lak",
    INTENSIVE_BASIC:"Intenzívne základné",
    INTENSIVE_SIDE:"Intenzívna strana",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzívny strešný postrekovač",
    TAR_REMOVER:"Odstraňovač dechtu",
    UNDER_CHASSIS_CONVERSATION:"Úprava podvozku",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionárny oblúk na predstriekanie",
    FOAM_RAIN:"Penový dážď",
    PRE_CLEANING:"Predbežné čistenie",
    BRUSH:"Kefa",
    CARE:"Starostlivosť",
    DRYING:"Sušenie",
    DRYING_LOW_NOISE:"Sušenie so zníženou hlučnosťou",
    INTENSIVE_CLEANING:"Intenzívne čistenie",
    BRUSH_CLEANING:"Čistenie kefou",
    EMPTY_RUN:"Beh na prázdno",
    DRYING_AID:"Prostriedok na sušenie",
    WAX:"Vosk",
    FOAM_WASH:"Umývacia pena",
    POLISH:"Lak",
    FOAM_POLISH:"Penový lak",
    WHEEL_CLEANING:"Čistenie kolies",
    HIGH_PRESSURE_ROOF:"Vysokotlakové čistenie strechy",
    HIGH_PRESSURE_SIDE:"Bočné vysokotlakové čistenie",
    DRYER_FORWARD:"Sušička dopredu",
    DRYER_BACKWARD:"Sušička dozadu",
    DELETE_ALL_HOLIDAYS:"Odstránenie všetkých sviatkov pre vybranú lokalitu",
    CREATE_NEW_HOLIDAY:"Vytvorenie nového",
    RESET_INPUTS:"Obnovenie všetkých nastavení dovolenky",
    TWENTY_FOUR_HOURS_OPEN:"Otvorené 24 hodín",
    EVERY_YEAR:"Ročný",
    DELETE_HOLIDAY:"Vymazať dovolenku",
    ADD_NEW_HOLIDAY:"Pridať novú dovolenku",
    HOLIDAYS_LIST:"Zoznam existujúcich sviatkov",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Odstrániť všetky sviatky pre vybranú lokalitu?",
    VALIDATION_HOLIDAY_DATE:"Formát nie je správny. Použite mm-dd",
    FOR_DATE:"Na dátum",
    WITH_ID:"S preukazom totožnosti",
    FROM_HOURS:"Od h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:"Do (min)",
    NOT_MATCH:"Nezodpovedá",
    START:"Štart",
    STOP:"Stop",
    DAILY_TIME:"Zoznam 24 hodín",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individuálne nastavenie času",
    PROGRAM_NOT_STARTED:"Program sa ešte nezačal",
    JETWASH:"Samoobslužný umývací systém",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Čerpadlo na čerstvú vodu",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Čerpadlo na procesnú vodu",
    OPERATION_COUNTER_HP_PUMP_1:"Vysokotlakové čerpadlo 1",
    OPERATION_COUNTER_HP_PUMP_2:"Vysokotlakové čerpadlo 2",
    RELEASE_NOTES:"Verzie aplikácií a poznámky k vydaniu",
    BACKEND_RELEASE_NOTES:"Poznámky k vydaniu platformy:",
    FRONTEND_RELEASE_NOTES:"Poznámky k vydaniu webovej aplikácie:",
    SELECTED_FACILITY_TIMEZONE:"Časové pásmo pre vybrané zariadenie:",
    REFRESH_PAGE:"Obnoviť stránku",
    REFRESH_MAPS:"Obnovenie máp",
    PUMPS:"Čerpadlá",
    RUN_TIME:"Čas prevádzky",
    RUN_TIME1:"Čas prevádzky 1 ",
    RUN_TIME2:"Čas prevádzky 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuátor pre čas chodu",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuátor pre čas chodu 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuátor pre čas chodu 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimálna hodnota je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maximálna hodnota je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Použite formát ceny x.xx",
    ACTUATION_NOT_ALLOWED:"Aktivácia nie je povolená pre aktuálnu rolu používateľa",
    MAINTENANCE_DAYS:"Dni údržby",
    MAINTENANCE_WASHES:"Umývanie na údržbu",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Celkový príjem POS",
    PROPAGATE:"Propagovať",
    ALL_DAY_HOURS_SELECTOR:"Výber typu 24 hodín",
    GET_OPERATING_TIME_FROM_SITE:"Získanie prevádzkového času pre aktuálne zariadenie z pracovných plánov pracoviska",
    USER_NOT_VALID:"Používateľ nie je platný. Skúste použiť iné prihlasovacie údaje k účtu.",
    VERIFIED:"Overené",
    RESEND_VERIFICATION_MAIL:"Opätovné odoslanie overovacieho e-mailu",
    RETURN_TO_DASHBOARD:"Návrat na prístrojovú dosku",
    ERROR_PAGE_BAD_REQUEST:"400 Zlá požiadavka.",
    WASHES:"Počet umyvaní",
    TIME_TO_SERVICE:"Čas do služby",
    ACCOUNT_ALREADY_ACTIVATED:"Účet je už aktivovaný",
    DEVICE_EVENTS:"Udalosti zariadenia",
    DEVICE_EVENTS_LOG_PULLED:"Vytiahnutý protokol udalostí pre zariadenie",
    EVENTS_PULL_DATE:"Čas vytiahnutých udalostí:",
    DEVICE_EVENTS_REFRESH:"Vytiahnutie nových údajov o udalostiach",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problém s pripojením k webovým soketom. Skúste obnoviť stránku.",
    INSTALLATION_DATE:"Dátum inštalácie stroja",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Hot wax",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"High pressure washing",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Power rim foam",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Power foam",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Stop",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Foam wash HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Wash",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Top care",
    INFO_TITLE:"Informácie",
    FOAM_WAX1:"Penový vosk",
    POLISH1:"Lak",
    WAX1:"Vosk",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Podrobnosti o lokalite boli úspešne aktualizované",
    COMPANY:"Spoločnosť",
    FACILITY_HAS_CHANGER:"Máte meničku?",
    DISABLE_OFFLINE_ALARM:"Zakázanie alarmov R2W",
    ASIDE_WORKING_SCHEDULES:"Podrobnosti o aplikácii",
    TERMS_OF_SERVICE_R2W_TITLE:"Podmienky služby Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Podmienky služby Ready2Wash",
    DATA_PROCESSING_TITLE:"Spracované údaje",
    PRIVACY_POLICY_TITLE:"Zásady ochrany osobných údajov",
    READY_TO_PAY_TERMS_OF_SERVICE:"Podmienky služby Ready2Pay",
    TERMS_AND_SERVICES:"Podmienky a služby",
    HOURLY:"Hodinovo",
    DAILY:"Denne",
    WEEKLY:"Týždenne",
    MONTHLY:"Mesačne",
    YEARLY:"Ročne",
    DELETE_ITEM_SUCCESS:"Položka bola úspešne odstránená",
    STATE:"Stav",
    AVAILABILITY_STATUS_1:"Jednotka otvorená",
    AVAILABILITY_STATUS_2:"Jednotka zatvorená (sviatok)",
    AVAILABILITY_STATUS_3:"Jednotka zatvorená (prevádzkový čas)",
    AVAILABILITY_STATUS_4:"Jednotka zatvorená (porucha)",
    AVAILABILITY_STATUS_5:"Jednotka zatvorená (iné)",
    AVAILABILITY_VACUUMS_STATUS_1:"Vysávače nie sú nainštalované",
    AVAILABILITY_VACUUMS_STATUS_2:"Vysávače otvorené",
    AVAILABILITY_VACUUMS_STATUS_3:"Vysávače zatvorené (sviatok)",
    AVAILABILITY_VACUUMS_STATUS_4:"Vysávače zatvorené (prevádzkový čas)",
    AVAILABILITY_VACUUMS_STATUS_5:"Vysávače zatvorené (porucha)",
    AVAILABILITY_VACUUMS_STATUS_6:"Vysávače zatvorené (iné)",
    ECOM_AMOUNT:"Celkové Ecom pre všetky lokality",
    CAPTURED:"Zachytené",
    VALUE_DATE:"Dátum zaúčtovania",
    VALIDATION_HOLIDAY_YEAR:"Formát nie je správny. Použite yyyy",
    KARCHER_EVENT_NAME_1:"Base exchanger regenerated",
    KARCHER_EVENT_NAME_2:"Base exchanger regeneration ended",
    KARCHER_EVENT_NAME_3:"Material / serial number",
    KARCHER_EVENT_NAME_4:"The system has been disinfected",
    KARCHER_EVENT_NAME_5:"HP pump 1 has been disinfected",
    KARCHER_EVENT_NAME_6:"HP pump 2 has been disinfected",
    KARCHER_EVENT_NAME_7:"HP pump 3 has been disinfected",
    KARCHER_EVENT_NAME_8:"HP pump 4 has been disinfected",
    KARCHER_EVENT_NAME_9:"HP pump 5 has been disinfected",
    KARCHER_EVENT_NAME_10:"Washing station 1 locked",
    KARCHER_EVENT_NAME_11:"Washing station 2 locked",
    KARCHER_EVENT_NAME_12:"Washing station 3 locked",
    KARCHER_EVENT_NAME_13:"Washing station 4 locked",
    KARCHER_EVENT_NAME_14:"Washing station 5 locked",
    KARCHER_EVENT_NAME_15:"Washing station 6 locked",
    KARCHER_EVENT_NAME_16:"Washing station 7 locked",
    KARCHER_EVENT_NAME_17:"Washing station 8 locked",
    KARCHER_EVENT_NAME_18:"Update started",
    KARCHER_EVENT_NAME_19:"Update finished",
    KARCHER_EVENT_NAME_20:"Start WS Reg",
    KARCHER_EVENT_NAME_21:"End WS Reg",
    KARCHER_EVENT_NAME_22:"WS 75% sensor",
    KARCHER_EVENT_NAME_23:"Tech. defect",
    KARCHER_EVENT_NAME_24:"Oper. defect",
    KARCHER_EVENT_NAME_25:"Unit on",
    KARCHER_EVENT_NAME_26:"Unit closed",
    KARCHER_EVENT_NAME_27:"Box 1 closed",
    KARCHER_EVENT_NAME_28:"Box 2 closed",
    KARCHER_EVENT_NAME_29:"Box 3 closed",
    KARCHER_EVENT_NAME_30:"Box 4 closed",
    KARCHER_EVENT_NAME_31:"Box 5 closed",
    KARCHER_EVENT_NAME_32:"Box 6 closed",
    KARCHER_EVENT_NAME_33:"Box 7 closed",
    KARCHER_EVENT_NAME_34:"Box 8 closed",
    KARCHER_EVENT_NAME_35:"HP pump bay 1",
    KARCHER_EVENT_NAME_36:"HP pump bay 2",
    KARCHER_EVENT_NAME_37:"HP pump bay 3",
    KARCHER_EVENT_NAME_38:"HP pump bay 4",
    KARCHER_EVENT_NAME_39:"HP pump bay 5",
    KARCHER_EVENT_NAME_40:"HP pump bay 6",
    KARCHER_EVENT_NAME_41:"HP pump bay 7",
    KARCHER_EVENT_NAME_42:"HP pump bay 8",
    KARCHER_EVENT_NAME_43:"Burner",
    KARCHER_EVENT_NAME_44:"Burner fan",
    KARCHER_EVENT_NAME_45:"Warm water pump",
    KARCHER_EVENT_NAME_46:"Freeze prot.pump",
    KARCHER_EVENT_NAME_47:"Osmosis pump",
    KARCHER_EVENT_NAME_48:"Floor heating",
    KARCHER_EVENT_NAME_49:"Hose heating",
    KARCHER_EVENT_NAME_50:"Microe/rim clean",
    KARCHER_EVENT_NAME_51:"Underc. pump",
    KARCHER_EVENT_NAME_52:"Booster pumpFoam",
    KARCHER_EVENT_NAME_53:"Vacuum clean. 1",
    KARCHER_EVENT_NAME_54:"Vacuum clean. 2",
    KARCHER_EVENT_NAME_55:"Vacuum clean. 3",
    KARCHER_EVENT_NAME_56:"Vacuum clean. 4",
    KARCHER_EVENT_NAME_57:"Vacuum clean. 5",
    KARCHER_EVENT_NAME_58:"Vacuum clean. 6",
    KARCHER_EVENT_NAME_59:"Vacuum clean. 7",
    KARCHER_EVENT_NAME_60:"Vacuum clean. 8",
    KARCHER_EVENT_NAME_61:"Vacuum clean. 9",
    KARCHER_EVENT_NAME_62:"Vacuum clean. 10",
    KARCHER_EVENT_NAME_63:"Vacuum clean. 11",
    KARCHER_EVENT_NAME_64:"Vacuum clean. 12",
    KARCHER_EVENT_NAME_65:"Pump rim clean",
    KARCHER_EVENT_NAME_66:"Pump Microe.",
    KARCHER_EVENT_NAME_67:"Pump Intensive",
    KARCHER_EVENT_NAME_68:"Vacuum1 turbine",
    KARCHER_EVENT_NAME_69:"Vacuum1 filter",
    KARCHER_EVENT_NAME_70:"Vacuum2 turbine",
    KARCHER_EVENT_NAME_71:"Vacuum2 filter",
    KARCHER_EVENT_NAME_72:"Vacuum3 turbine",
    KARCHER_EVENT_NAME_73:"Vacuum3 filter",
    KARCHER_EVENT_NAME_74:"Vacuum4 turbine",
    KARCHER_EVENT_NAME_75:"Vacuum4 filter",
    KARCHER_EVENT_NAME_76:"Vacuum5 turbine",
    KARCHER_EVENT_NAME_77:"Vacuum5 filter",
    KARCHER_EVENT_NAME_78:"Vacuum6 turbine",
    KARCHER_EVENT_NAME_79:"Vacuum6 filter",
    KARCHER_EVENT_NAME_80:"Vacuum7 turbine",
    KARCHER_EVENT_NAME_81:"Vacuum7 filter",
    KARCHER_EVENT_NAME_82:"Vacuum8 turbine",
    KARCHER_EVENT_NAME_83:"Vacuum8 filter",
    KARCHER_EVENT_NAME_84:"Vacuum9 turbine",
    KARCHER_EVENT_NAME_85:"Vacuum9 filter",
    KARCHER_EVENT_NAME_86:"Vacuum10 turbine",
    KARCHER_EVENT_NAME_87:"Vacuum10 filter",
    KARCHER_EVENT_NAME_88:"Vacuum11 turbine",
    KARCHER_EVENT_NAME_89:"Vacuum11 filter",
    KARCHER_EVENT_NAME_90:"Vacuum12 turbine",
    KARCHER_EVENT_NAME_91:"Vacuum12 filter",
    INSERT_TOKEN:"Vložte žetóny a spustite službu",
    OPEN_SESSION:"Relácia bola úspešne spustená",
    IN_PROGRESS:"Prebieha ...",
    TOKEN_INSERTED:"Žetóny boli úspešne vložené",
    EXPIRED_SESSION:"Relácia vypršala",
    TWO_DIGIT_INTEGER_VALIDATION:"Použite maximálne dvojciferné celé číslo",
    KARCHER_OPERATION_COUNTER_1:"Washing station 1 HP pump",
    KARCHER_OPERATION_COUNTER_2:"Washing station 1 chemical pump 1",
    KARCHER_OPERATION_COUNTER_3:"Washing station 1 chemical pump 2",
    KARCHER_OPERATION_COUNTER_4:"Washing station 1 chemical pump 3",
    KARCHER_OPERATION_COUNTER_5:"Washing station 1 chemical pump 4",
    KARCHER_OPERATION_COUNTER_6:"Washing station 2 HP pump",
    KARCHER_OPERATION_COUNTER_7:"Washing station 2 chemical pump 1",
    KARCHER_OPERATION_COUNTER_8:"Washing station 2 chemical pump 2",
    KARCHER_OPERATION_COUNTER_9:"Washing station 2 chemical pump 3",
    KARCHER_OPERATION_COUNTER_10:"Washing station 2 chemical pump 4",
    KARCHER_OPERATION_COUNTER_11:"Washing station 3 HP pump",
    KARCHER_OPERATION_COUNTER_12:"Washing station 3 chemical pump 1",
    KARCHER_OPERATION_COUNTER_13:"Washing station 3 chemical pump 2",
    KARCHER_OPERATION_COUNTER_14:"Washing station 3 chemical pump 3",
    KARCHER_OPERATION_COUNTER_15:"Washing station 3 chemical pump 4",
    KARCHER_OPERATION_COUNTER_16:"Washing station 4 HP pump",
    KARCHER_OPERATION_COUNTER_17:"Washing station 4 chemical pump 1",
    KARCHER_OPERATION_COUNTER_18:"Washing station 4 chemical pump 2",
    KARCHER_OPERATION_COUNTER_19:"Washing station 4 chemical pump 3",
    KARCHER_OPERATION_COUNTER_20:"Washing station 4 chemical pump 4",
    KARCHER_OPERATION_COUNTER_21:"Washing station 5 HP pump",
    KARCHER_OPERATION_COUNTER_22:"Washing station 5 chemical pump 1",
    KARCHER_OPERATION_COUNTER_23:"Washing station 5 chemical pump 2",
    KARCHER_OPERATION_COUNTER_24:"Washing station 5 chemical pump 3",
    KARCHER_OPERATION_COUNTER_25:"Washing station 5 chemical pump 4",
    KARCHER_OPERATION_COUNTER_26:"Washing station 6 HP pump",
    KARCHER_OPERATION_COUNTER_27:"Washing station 6 chemical pump 1",
    KARCHER_OPERATION_COUNTER_28:"Washing station 6 chemical pump 2",
    KARCHER_OPERATION_COUNTER_29:"Washing station 6 chemical pump 3",
    KARCHER_OPERATION_COUNTER_30:"Washing station 6 chemical pump 4",
    KARCHER_OPERATION_COUNTER_31:"Washing station 7 HP pump",
    KARCHER_OPERATION_COUNTER_32:"Washing station 7 chemical pump 1",
    KARCHER_OPERATION_COUNTER_33:"Washing station 7 chemical pump 2",
    KARCHER_OPERATION_COUNTER_34:"Washing station 7 chemical pump 3",
    KARCHER_OPERATION_COUNTER_35:"Washing station 7 chemical pump 4",
    KARCHER_OPERATION_COUNTER_36:"Washing station 8 HP pump",
    KARCHER_OPERATION_COUNTER_37:"Washing station 8 chemical pump 1",
    KARCHER_OPERATION_COUNTER_38:"Washing station 8 chemical pump 2",
    KARCHER_OPERATION_COUNTER_39:"Washing station 8 chemical pump 3",
    KARCHER_OPERATION_COUNTER_40:"Washing station 8 chemical pump 4",
    KARCHER_OPERATION_COUNTER_41:"Osmosis pump",
    KARCHER_OPERATION_COUNTER_42:"Hot water generator",
    KARCHER_OPERATION_COUNTER_43:"Frost protection pump",
    KARCHER_OPERATION_COUNTER_44:"WSO filter inlay",
    KARCHER_OPERATION_COUNTER_45:"Washing station heater pump",
    KARCHER_OPERATION_COUNTER_46:"Hot water pump",
    KARCHER_OPERATION_COUNTER_47:"Foam hose heating",
    KARCHER_OPERATION_COUNTER_48:"Wheel cleaning pump",
    KARCHER_OPERATION_COUNTER_49:"Micro-emulsion pump",
    KARCHER_OPERATION_COUNTER_50:"Intensive foam pump",
    KARCHER_OPERATION_COUNTER_51:"Vacuum cleaner 1 turbine 1",
    KARCHER_OPERATION_COUNTER_52:"Vacuum cleaner 1 filter 1",
    KARCHER_OPERATION_COUNTER_53:"Vacuum cleaner 1 turbine 2",
    KARCHER_OPERATION_COUNTER_54:"Vacuum cleaner 1 filter 2",
    KARCHER_OPERATION_COUNTER_55:"Vacuum cleaner 2 turbine 1",
    KARCHER_OPERATION_COUNTER_56:"Vacuum cleaner 2 filter 1",
    KARCHER_OPERATION_COUNTER_57:"Vacuum cleaner 2 turbine 2",
    KARCHER_OPERATION_COUNTER_58:"Vacuum cleaner 2 filter 2",
    KARCHER_OPERATION_COUNTER_59:"Vacuum cleaner 3 turbine 1",
    KARCHER_OPERATION_COUNTER_60:"Vacuum cleaner 3 filter 1",
    KARCHER_OPERATION_COUNTER_61:"Vacuum cleaner 3 turbine 2",
    KARCHER_OPERATION_COUNTER_62:"Vacuum cleaner 3 filter 2",
    KARCHER_OPERATION_COUNTER_63:"Vacuum cleaner 4 turbine 1",
    KARCHER_OPERATION_COUNTER_64:"Vacuum cleaner 4 filter 1",
    KARCHER_OPERATION_COUNTER_65:"Vacuum cleaner 4 turbine 2",
    KARCHER_OPERATION_COUNTER_66:"Vacuum cleaner 4 filter 2",
    KARCHER_OPERATION_COUNTER_67:"Vacuum cleaner 5 turbine 1",
    KARCHER_OPERATION_COUNTER_68:"Vacuum cleaner 5 filter 1",
    KARCHER_OPERATION_COUNTER_69:"Vacuum cleaner 5 turbine 2",
    KARCHER_OPERATION_COUNTER_70:"Vacuum cleaner 5 filter 2",
    KARCHER_OPERATION_COUNTER_71:"Vacuum cleaner 6 turbine 1",
    KARCHER_OPERATION_COUNTER_72:"Vacuum cleaner 6 filter 1",
    KARCHER_OPERATION_COUNTER_73:"Vacuum cleaner 6 turbine 2",
    KARCHER_OPERATION_COUNTER_74:"Vacuum cleaner 6 filter 2",
    KARCHER_OPERATION_COUNTER_75:"Drain condensation water from the compressor",
    KARCHER_OPERATION_COUNTER_76:"Check frost protection system",
    KARCHER_OPERATION_COUNTER_77:"Burner fan",
    KARCHER_OPERATION_COUNTER_78:"Booster pump foam",
    DOWNLOAD_CSV_LARGE_DATA_WARNING:"Zoznam údajov obsahuje viac ako 10 000 položiek",
    KARCHER_POINT_NAME_1: "Sviatok",
    KARCHER_POINT_NAME_2: "Pondelok",
    KARCHER_POINT_NAME_3: "Utorok",
    KARCHER_POINT_NAME_4: "Streda",
    KARCHER_POINT_NAME_5: "Štvrtok",
    KARCHER_POINT_NAME_6: "Piatok",
    KARCHER_POINT_NAME_7: "Sobota",
    KARCHER_POINT_NAME_8: "Nedeľa",
    KARCHER_POINT_NAME_9: "Vysávače Sviatok",
    KARCHER_POINT_NAME_10: "Vysávače Pondelok",
    KARCHER_POINT_NAME_11: "Vysávače Utorok",
    KARCHER_POINT_NAME_12: "Vysávače Streda",
    KARCHER_POINT_NAME_13: "Vysávače Štvrtok",
    KARCHER_POINT_NAME_14: "Vysávače Piatok",
    KARCHER_POINT_NAME_15: "Vysávače Sobota",
    KARCHER_POINT_NAME_16: "Vysávače Nedeľa",
    KARCHER_POINT_NAME_17: "Osvetlenie Sviatok",
    KARCHER_POINT_NAME_18: "Osvetlenie Pondelok",
    KARCHER_POINT_NAME_19: "Osvetlenie Utorok",
    KARCHER_POINT_NAME_20: "Osvetlenie Streda",
    KARCHER_POINT_NAME_21: "Osvetlenie Štvrtok",
    KARCHER_POINT_NAME_22: "Osvetlenie Piatok",
    KARCHER_POINT_NAME_23: "Osvetlenie Sobota",
    KARCHER_POINT_NAME_24: "Osvetlenie Nedeľa",
    KARCHER_POINT_NAME_25:"Program 0",
    KARCHER_POINT_NAME_26:"Program 1",
    KARCHER_POINT_NAME_27:"Program 2",
    KARCHER_POINT_NAME_28:"Program 3",
    KARCHER_POINT_NAME_29:"Program 4",
    KARCHER_POINT_NAME_30:"Program 5",
    KARCHER_POINT_NAME_31:"Program 6",
    KARCHER_POINT_NAME_32:"Program 7",
    KARCHER_POINT_NAME_33:"Program 8",
    KARCHER_POINT_NAME_34:"Program 9",
    KARCHER_POINT_NAME_35:"Program 10",
    KARCHER_POINT_NAME_36:"Program 11",
    KARCHER_POINT_NAME_37:"Program 12",
    KARCHER_POINT_NAME_38:"Program 13",
    KARCHER_POINT_NAME_39:"Program 14",
    KARCHER_POINT_NAME_40:"Program 15",
    KARCHER_POINT_NAME_41:"Program 16",
    KARCHER_POINT_NAME_42:"Program 17",
    KARCHER_POINT_NAME_43:"Program 18",
    KARCHER_POINT_NAME_44:"Program 19",
    KARCHER_POINT_NAME_45:"Program 20",
    KARCHER_POINT_NAME_46:"Program 21",
    KARCHER_POINT_NAME_47:"Program 22",
    KARCHER_POINT_NAME_48:"Program 23",
    KARCHER_POINT_NAME_49:"Program 24",
    KARCHER_POINT_NAME_50:"Program 25",
    KARCHER_POINT_NAME_51:"Program 26",
    KARCHER_POINT_NAME_52:"Program 27",
    KARCHER_POINT_NAME_53:"Program 28",
    KARCHER_POINT_NAME_54:"Program 29",
    KARCHER_POINT_NAME_55:"Program 30",
    KARCHER_POINT_NAME_56:"Program 31",
    KARCHER_POINT_NAME_57:"Program 32",
    QR_CODE: "QR kód",
    ACCEPT_TERMS_AND_CONDITIONS: "Prijať podmienky používania",
    CREATE_AND_PRINT_VOUCHERS: "Vytvorte a vytlačte poukazy",
    CODE_PREFIX_QUESTION: "Predpona kódu nie je zadaná",
    CODE_PREFIX_QUESTION_TEXT: "Chcete pokračovať bez predpony kódu?",
    ISSUED_DATE: "Dátum vydania",
    VOUCHER_VALIDITY_DAYS: "Platnosť poukazu (dni)",
    VALIDATION_ONLY_NUMBERS: "Povolené sú iba čísla",
    REPRINT_VOUCHERS: "Vytlačiť kópiu poukazov",
    EXPIRY_DATE: "Platné do"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("ruTranslations", {
      MESSAGE:"Сообщение",
      ERROR_TITLE:"Ошибка",
      ERROR_MESSAGE:"Возникла ошибка при выполнении операции.",
      ERROR_LOGIN:"При входе в систему произошла ошибка. Адрес недействительна",
      ERROR_LOGIN_ROLE:"Роль для текущего бренда приложения недействительна",
      OK:"ОК",
      CANCEL:"Отменить",
      YES:"Да",
      NO:"Нет",
      FROM:"От",
      TO:"К",
      DELETE:"Удалить",
      SIGN_OUT:"Выйти из аккаунта",
      NAME:"Имя",
      DATE:"Дата",
      PIECES:"Части",
      HOURS:"Часы",
      DAYS:"Дни",
      MONTH:"Месяц",
      MONTHS:"Месяца",
      YEAR:"Год",
      BOX:"Бокс",
      SEARCH:"Поиск",
      ALL_USERS:"Все пользователи",
      ARE_YOU_SURE:"Вы уверены?",
      BACK:"Назад",
      AMOUNT:"Сумма",
      DESCRIPTION:"Описание",
      FORGOT_PASSWORD_ERROR_MSG:"Что-то пошло не так. Пожалуйста, проверьте свой адрес электронной почты и повторите попытку",
      REQUIRED_FIELD:"Поле обязательное",
      LOGOUT_TITLE:"Вы уверены, что хотите выйти из системы?",
      LOGOUT_MSG:"Все несохраненные данные будут потеряны",
      ACTIVATION_ACCOUNT:"Вы успешно активировали свою учетную запись",
      UNKNOWN_ERRROR_NOTIFICATION:"Произошла неизвестная ошибка",
      CONTINUE:">> Далее",
      DATA_NOT_AVAILABLE:"Данные недоступны",
      SELECT:"Выбрать",
      SELECT_CURRENCY:"Выберите валюту",
      UPLOAD:"Скачать",
      PHONE:"Телефон",
      WEBSITE:"Сайт",
      WORKING_HOURS:"Время работы",
      INSERT:"Вставить",
      TEXT:"Текст",
      CREATED:"Создан",
      VALID_UNTIL:"Действителен до",
      SAVE:"Сохранить",
      TOKENS:"Жетоны",
      DELETE_COMPANY_HISTORY:"Удалить историю компании?",
      DELETE_COMPANY_HISTORY_INFO:"Это действие удалит все данные отчетов вашей компании. Это действие невозможно отменить.",
      DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Вы уверены, что хотите навсегда удалить все данные отчетов?",
      DELETE_COMPANY_HISTORY_MESSAGE:"ПРЕДУПРЕЖДЕНИЕ: После нажатия этой кнопки все транзакции вашей автомойки будут навсегда удалены! Эти данные невозможно восстановить.",
      DELETE_COMPANY_HISTORY_CONFIRMATION:"Вы уверены, что хотите навсегда удалить все данные о транзакциях?",
      HISTORY_SUCCESSFULY_DELETED:"История успешно удалена",
      HELP:"Помогите",
      VALUE:"Значение",
      ACTIVATING_ACCOUNT_ERROR:"Возникла проблема с активацией аккаунта R2W. Пожалуйста, попробуйте еще раз, и если проблема не исчезнет, ​​обратитесь к нашей поддержки на support@ready2wash.com.",
      ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Добро пожаловать в автомойку Kärcher",
      ACTIVATING_ACCOUNT_WELCOME_MSG:"Добро пожаловать в R2W",
      ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Пожалуйста, введите новый пароль и подтвердите его, чтобы активировать учетную запись R2W. После успешного завершения вам автоматически будет открыт вход",
      ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Вы позже можете изменить свои настройки пользователя в приложении",
      RESET_PASSWORD_WELCOME_KARCHER_MSG:"Автомойка Kärcher",
      RESET_PASSWORD_WELCOME_MSG:"Автомойка R2W",
      RESET_PASSWORD_WELCOME_MSG_2:"Введите новый пароль и подтвердите его, чтобы сбросить старый. После успешного выполнения вы будете автоматически авторизованы в приложении.",
      RESET_PASSWORD_WELCOME_MSG_3:"Вы сможете изменить свои пользовательские настройки позже в приложении.",
      ENTER_NEW_PASSWORD:"Введите пароль",
      REPEAT_NEW_PASSWORD:"Повторите новый пароль",
      PASSWORD_MIN_LENGTH:"Пароль должен состоять не менее 8 символов",
      PASSWORD_MAX_LENGHT:"Пароль должен быть не более 32 символов",
      PASSWORD_PATTERN:"Пароль должен содержать хотя бы одну заглавную букву и одну букву нижнего регистра",
      PASSWORD_MATCH:"Пароли не совпадают",
      ACTIVATE:"Активировать",
      SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Вы успешно отправили запрос. Пожалуйста, проверьте вашу электронную почту для подтверждения сообщения",
      VALIDATION_REQUIRED:"Обязательное поле",
      VALIDATION_EMAIL:"Неверный адрес электронной почты",
      VALIDATION_INTEGER_NUMBER:"Пожалуйста, введите целое значение",
      VALIDATION_HOURS_VALUE:"Значение должно быть от 0 до 23",
      VALIDATION_MINUTES_VALUE:"Значение должно быть от 0 до 59",
      VALIDATION_NOT_A_DATE:"Значения не является датой",
      VALIDATION_FROM:"От даты большей, чем в",
      VALIDATION_TO:"На сегодняшний день меньше, чем",
      ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Эта запись уже существует в базе данных",
      PASSWORD_VALIDATION_PATTERN_NEW:"Там должна быть по крайней мере одна цифра и одна большая буквы. Пробелы не допускаются",
      VALIDATION_PERCENT_VALUE:"Значение должно быть между 1-999",
      NUMBERS_ONLY_100:"Количество до 100",
      NUMBERS_ONLY_1000:"Число до 1000",
      POSITIVE_NUMBERS_ONLY:"Только положительное число",
      GRID_PAGER_PAGE:"Страница",
      GRID_PAGER_ROWS_PER_PAGE:"Строки на страницу",
      GRID_PAGER_PAGE_OF:"От",
      BREAD_CRUMBS_HOME:"Главная",
      BREAD_CRUMBS_DASHBOARD_TECH:"Технология панели управления",
      BREAD_CRUMBS_DETAILS:"Подробности",
      BREAD_CRUMBS_SETTINGS:"Настройка",
      BREAD_CRUMBS_WORKING_HOURS:"Часы работы",
      BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Общая сумма денег по дням",
      BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Средняя денежная информация в час",
      BREAD_CRUMBS_NEW_USER_GROUP:"Создать группу пользователей",
      BREAD_CRUMBS_EDIT_USER_GROUP:"Редактировать группу пользователей",
      BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Создать шаблон кампании",
      BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Редактировать шаблон кампании",
      BREAD_CRUMBS_NEW_CAMPAIGN:"Создать кампанию",
      BREAD_CRUMBS_EDIT_CAMPAIGN:"Редактировать кампанию",
      BREAD_CRUMBS_PERIODIC_SUMMARY:"Периодический результат",
      LOGIN:"Войти",
      EMAIL:"Электронная почта",
      PASSWORD:"Пароль",
      LANGUAGE:"Язык",
      FORGOT_PASSWORD:"Забыли пароль?",
      SUBMIT:"Отправить",
      HEADER_NUMBER_OF_PENDING_ALARMS:"Количество ожидаемых сигналов:",
      HEADER_VIEW_ALL_ALARMS:"Посмотреть все уведомления ...",
      HEADER_MY_ACCOUNT:"Мой счет",
      HEADER_ACCOUNT_MANAGEMENT:"Управление счетами",
      ACCOUNT_ALREADY_EXIST:"Адрес электронной почты уже используется",
      NEWSLETTER_CONFIRMATION:"Отправить уведомление по электронной почте для состояния тревоги",
      ASIDE_MENU_DASHBOARD_FINANCIAL:"Obzor yezhednevnykh finansov",
      ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Технология панели управления",
      ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Приборная доска",
      ASIDE_MENU_ALARMS:"Сообщение",
      ASIDE_MENU_FACILITIES:"Объекты",
      ASIDE_MENU_REPORTS:"Отчеты",
      ASIDE_MENU_REPORT:"Выбранный отчёт",
      ASIDE_MENU_LOYALTY:"Лояльность",
      ASIDE_MENU_USER_GROUPS:"Группы пользователей",
      ASIDE_MENU_PERIODIC_SUMMARY:"Периодический результат",
      ASIDE_MENU_MANAGING_TOKENS:"Управление токенами",
      ASIDE_MENU_NEWS:"Новости",
      DAILY_FINANCES_TOTAL_MONEY:"Всего денег",
      DAILY_FINANCES_TOTAL_MONEY_ALL:"Сумма денег на всех объектах",
      DAILY_FINANCES_TOTAL_COINS:"Всего жетонов",
      DAILY_FINANCES_DOWNLOAD_CSV:"Скачать CSV",
      DAILY_FINANCES_ONLINE:"R2W (онлайн)",
      DAILY_FINANCES_OFFLINE:"Монеты",
      DAILY_FINANCES_CHANGER:"Чейнджер",
      DAILY_FINANCES_COINS:"Токены / Eurokey",
      REPORTS_FILTER:"Фильтровать",
      REPORTS_TYPE_OF_REPORT:"Тип отчета",
      REPORTS_CHOOSE_FACILITY:"Выберите объект",
      REPORTS_PERIOD_1:"Период 1 -",
      REPORTS_PERIOD_2:"Период 2 -",
      MONEY_BY_DATE_REPORT:"Совокупный доход по дате",
      R2W_BY_DATE_REPORT:"Общее количество потраченных жетонов R2W по дате",
      COINS_BY_DATE_REPORT:"Всего монет по дате",
      AVG_MONEY_BY_HOUR_REPORT:"Средний доход в час",
      AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Средний доход за днем ​​недели",
      AVG_MONEY_BY_BOX_REPORT:"Расходы на мойку",
      COMPARE_PERIODS_REPORT:"Сравнительный отчет по объекту",
      TOTAL_USERS_BY_GROUP:"Всего пользователей программы R2W за день",
      TOTAL_USERS_BY_GROUP_USERS_UNIT:"пользователей",
      TOTAL_USERS_BY_GROUP_VISITS_UNIT:"посещения",
      VISITS_COUNT_REPORT:"Количество пользователей приложения R2W за каждое посещение",
      LOYALTY_PER_DAY_REPORT:"Количество локальных жетонов, потраченных за день",
      LOYALTY_PER_PAYMENT_METHOD:"Учитывая локальные жетоны за каждым способом оплаты",
      VISITS:"посещение",
      VISIT:"визиты",
      TOTAL_SPENT_MONEY:"Общий доход",
      MONEY:"Деньги",
      TOTAL_SPENT_MONEY_FOR_PERIOD:"Общее количество потраченных денег за период",
      DOWNLOAD_CSV:"Скачать CSV",
      TOTAL_SPENT_COINS:"Всего потрачено жетонов",
      TOTAL_USERS:"Всего пользователей",
      TOTAL_CREDIT_GIVEN:"Всего потрачено локальных виртуальных жетонов",
      EUROKEY_BY_DATE_REPORT:"Общая сумма платежей Eurokey по дате",
      TOTAL_SPENT_EUROKEY:"Всего потрачено",
      SELECT_TYPE_OF_REPORT:"Вам нужно выбрать тип отчета :)",
      NUMBER_OF_VISITS_TITLE:"Количество посещений",
      NUMBER_OF_USERS_TITLE:"Количество пользователей",
      PIECES_TITLE:"Куски",
      TOTAL_VISITS:"Всего посещений",
      TOKENS_TITLE:"жетоны",
      SEARCH_USERS_NO_RESULTS:"Не найдено ни одного пользователя по данному поисковым термином",
      SEARCH_USERS:"Поиск пользователей",
      SEARCH_TELEPHONES:"Поиск пользователей по мобильным номером",
      ADD_USER_TO_GROUP:"Добавить пользователя в группу",
      REMOVE_USER_FROM_GROUP:"Удалить пользователя из группы",
      USER_GROUP_NAME_REQUIRED:"Имя группы пользователей обязательное",
      USER_GROUP_NAME:"Название группы пользователей",
      USER_GROUPS_OVERVIEW:"Обзор групп пользователей",
      USER_COUNT:"количество пользователей",
      NEW_USER_GROUP:"Создать новую группу пользователей",
      DELETE_USER_GROUP:"Удалить группу пользователей",
      UPDATE_USER_GROUP:"Редактировать группу пользователей",
      DELETE_USER_GROUP_ERROR:"При удалении выбранной группы пользователей возникла ошибка. Пожалуйста, повторите попытку или свяжитесь со службой поддержки",
      CONFIRM_DELETE_USER_GROUP:"Вы уверены, что хотите удалить выбранную группу пользователей?",
      CONFIRM_DELETE_USER_GROUP_TEXT:"Действия лояльности, на которые возложена удалена группа, больше применяться не будут.",
      GROUP_NAME_MAX_LENGTH:"Название группы должен содержать не более 255 символов",
      USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Пользователь уже находится в этой группе",
      MISSING_USER:"Отсутствует пользователь",
      USER_NOT_ON_LIST:"Пользователь не находится в списке активных пользователей. Проверьте правильность адреса электронной почты и повторите попытку.",
      UPLOAD_USER_GROUP:"Загрузите список групп пользователей из файла * .csv",
      UKNOWN_USERS:"Список неизвестных пользователей",
      CAMPAIGN_TEMPLATE_RULE:"Правило шаблона",
      DELETE_CAMPAIGN_TEMPLATE_ERROR:"При попытке удалить шаблон кампании произошла ошибка. Пожалуйста, повторите попытку или свяжитесь со службой поддержки",
      CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Вы уверены, что хотите удалить выбранный шаблон кампании",
      CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Вы уверены, что хотите удалить выбранный шаблон кампании",
      CAMPAIGN_TEMPLATES_OVERVIEW:"Обзор шаблонов кампании",
      DELETE_CAMPAIGN_TEMPLATE:"Удалить шаблон кампании",
      UPDATE_CAMPAIGN_TEMPLATE:"Редактировать шаблон кампании",
      CREATE_CAMPAIGN_TEMPLATE:"Создайте новый шаблон кампании",
      CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Имя шаблона кампании обязательное",
      CAMPAIGN_TEMPLATE_NAME:"Название шаблона кампании",
      CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Обязательное поле",
      CAMPAIGN_TEMPLATE_RULE_GIVE:"Дать",
      CAMPAIGN_TEMPLATE_RULE_CREDITS:"Кредиты",
      CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:" Пожалуйста, сначала выберите тип. Мойка ящиков или небольших машин.",
      CAMPAIGN_TEMPLATE_REMOVE_RULE:"Удалить правило шаблона",
      CAMPAIGN_TEMPLATE_RULE_FROM:"от",
      CAMPAIGN_TEMPLATE_RULE_TO:"к",
      CAMPAIGN_TEMPLATE_RULE_HOURS:"Часов",
      CAMPAIGN_TEMPLATE_RULE_MINUTES:"Минут",
      CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Новое правило по количеству визитов",
      CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Новое правило по количеству потраченных денег",
      CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Новое правило по дням недели",
      CAMPAIGN_TEMPLATE_ADD_RULE:"Добавьте новое правило шаблона",
      CAMPAIGN_TEMPLATE_RULE_1:"Каждый",
      CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Каждый",
      CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"Кредиты, потраченные менее чем на",
      CAMPAIGN_TEMPLATE_RULE_2_VISITS:"Посещений меньше чем",
      CAMPAIGN_TEMPLATE_RULE_3:"Дни",
      CAMPAIGN_TEMPLATE_RULE_4:"Кредиты",
      CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Список правил пуст.",
      CAMPAIGN_FROM_DATE_TOO_EARLY:"Дата не может быть в прошлом",
      DELETE_CAMPAIGN_ERROR:"При попытке удалить кампанию произошла ошибка. Пожалуйста, повторите попытку или свяжитесь со службой поддержки",
      CONFIRM_DELETE_CAMPAIGN:"Вы уверены, что хотите удалить выбранную кампанию?",
      CONFIRM_DELETE_CAMPAIGN_TEXT:"Вы уверены, что хотите удалить выделенный текст кампании?",
      CAMPAIGNS_OVERVIEW:"обзор кампаний",
      DELETE_CAMPAIGN:"Удалить кампанию",
      UPDATE_CAMPAIGN:"Редактировать кампанию",
      CREATE_CAMPAIGN:"Создать новую кампанию",
      CAMPAIGN_ACTIVE:"Активный",
      CAMPAIGN_TEMPLATE:"Шаблон",
      CAMPAIGN_GROUPS:"Группы",
      CAMPAIGN_ALL_USERS:"Все пользователи",
      CAMPAIGN_NAME:"Название кампании",
      CAMPAIGN_NAME_REQUIRED:"Обязательно",
      CAMPAIGN_USERS_NEAR_TRESHOLD:"Количество пользователей накануне",
      MESSAGE_TO_USERS:"Сообщение для отфильтрованных пользователей",
      SEND_MESSAGE:"Отправить сообщение",
      THRESHOLD:"Предидущие",
      TYPE:"Тип",
      TOTAL_MONEY_SPENT:"Общие потраченные деньги в кампании",
      NUMBER_OF_VISITS:"Количество посещений в кампании",
      SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Сообщение должно содержать не менее 10 символов",
      SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Сообщение должно быть не более 350 символов",
      SEND_MESSAGE_REQUIRED_VALIDATION:"Текст сообщения обязательный",
      TECHNOLOGY:"Технология",
      TAP_WATER:"Вода входная",
      REVERSE_OSMOSIS:"Обратный осмос",
      SOFTENED_WATER:"Смягченная вода",
      DOSER:"Дозатор",
      STATUS:"Состояние дел",
      LAST_SYNCHRONIZATION:"Последняя синхронизация",
      NO_OF_CURRENT_ALARMS:"Количество текущих сигналов тревоги",
      NO_OF_CURRENT_WARNINGS:"Количество текущих предупреждений",
      WEATHER:"Погода",
      BOXES_WORK_HOURS_COUNTERS:"Часы рабочего времени",
      BOX_TOTAL_HOURS:"Общее время работы",
      BOX_SERVICE_HOURS:"Общее время работы (сервис)",
      BOX_COUNTER_HOURS:"Часов",
      ALARMS_AND_WARNINGS:"Предупреждения",
      FILTER_AND_BOILER:"Фильтр и котел",
      FILTER_TOTAL_DAYS:"Фильтр рабочие дни",
      BOILER_TOTAL_DAYS:"Рабочие дни котла",
      DAYS_UNIT:"Дни",
      SOFTENER:"Умягчения",
      MANUAL_COLD_DRAIN:"Ручной холодный сток",
      EL_COLD:"Эл. холодный",
      DRAIN:"Сток",
      TAP:"Коснитесь",
      WASTE:"Отходы",
      OSMOSIS:"Осмос",
      DEMI_WATER:"Деминирализована вода",
      EL_RINSE:"Эл м. Полоскания",
      BOILER:"Бойлер/Котел",
      EL_WAX:"Эл м. Воск",
      FLOOR_HEATING:"Подогрев пола",
      DOSER_TANK:"Дозатор бак",
      EL_WASH:"Эл м. Мытья",
      DETERGENT:"Микро-порошок",
      VIBRATOR:"Вибратор",
      UPDATE_FACILITY_SETTINGS:"Обновить настройки",
      GENERAL_SETTINGS:"Общие настройки",
      LIGHTS:"Свет",
      GROUPS:"Группы",
      ANTI_FREEZE:"Антизамерзание",
      AUTO:"Автоматически",
      MANUAL:"Вручную",
      ON:"Включить",
      OFF:"Отключить",
      TEMPERATURE:"Температура",
      UPDATE_DEVICE:"Обновления настроек объекта",
      BOX_CLEAN_HOURS:"Бокс чистый счетчик (часы)",
      GROUP_COUNTERS:"Групповые счетчики",
      RESET:"Сбросить",
      CASH_COUNT:"Количество монет",
      COINS_COUNT:"Количество жетонов",
      EUROKEY_COUNT:"Количество Еurokey",
      DOSER_WORK:"Рабочее время дозатора (сек.)",
      DOSER_PAUSE:"Время паузы дозатора (сек.)",
      DELAY_BFV:"Задержка BFV (мс)",
      DELAY_6M1:"Задержка 6M1 (мс)",
      DELAY_LPS:"Задержка LPS (мс)",
      RESET_CASH_COUNT_ALL:"Сбросить все счетчики монет",
      RESET_COINS_COUNT_ALL:"Сбросить все счетчики жетонов",
      RESET_EUROKEY_COUNT_ALL:"Сбросить все счетчики Еurokey",
      FACILITY_DETAILS:"Детали объекта",
      FACILITY_NAME:"Название объекта",
      FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Вы успешно загрузили изображение",
      FACILITY_UPDATE_DATA_NOTIFICATION:"Вы успешно обновили данные",
      CONNECTED:"связанный",
      DISCONNECTED:"Отключено",
      OFFLINE:"отсоединены",
      MESSAGES_FILTER:"фильтровать сообщения",
      FACILITY:"Объект",
      APPLY:"Применить",
      TIME:"Время",
      LOCATION:"Местонахождение",
      ACKNOWLEDGED:"Признано",
      FILTERED_MESSAGES:"Отфильтрованные сообщения",
      ACK:"Признано",
      NOT_ACK:"Не признана",
      ALL:"Все",
      ALL_FACILITIES:"все объекты",
      ENTER_DATE_PLACEHOLDER:"Введите дату",
      OP_NESTANAK_NAPONA:"Отсутствует напряжение на фазовом индикаторе 3А5",
      OP_OTB_PUMPA_GRESKA_MZS:"Автоматический выключатель высокого давления сброшено",
      OP_UPR_NAPON_24VAC_GRE:"Отсутствует 24 VAC - автоматический выключатель 5F1.1",
      OP_MIN_NIVO_PITKA_VODA:"Бак для пресной воды пустой",
      OP_CRPKA_PITKE_VODE_GRE_MZS:"Автоматический выключатель сетевого насоса сброшено",
      OP_MIN_NIVO_OMEKS_VODE:"Бак для смягчения воды пустой",
      OP_CRPKA_OMEKS_VODE_GRE_MZS:"Насос циркуляции смягчения воды сброшено",
      OP_MIN_NIVO_DEMIN_VODE:"Бак осмосированной воды пустой",
      OP_CRPKA_DEMIN_VODE_GRE_MZS:"Насос циркуляции осмасированной воды сброшено",
      OP_CRPKA_REV_OSMOZA_GRE_MZS:"Автоматический выключатель насоса производства осмоса сброшено",
      OP_BOJLER_GRESKA_MZS:"Ошибка водонагревателя",
      OP_CRPKA_PRASKA_GRE_MZS:"Автоматический выключатель горячего водоснабжения сброшено",
      OP_DOZATOR_PRASKA_GRE_MZS:"Автоматический выключатель порошкового дозатора сброшено",
      OP_VIBRATOR_PRASKA_GRE_MZS:"Выключатель порошкового дозирования вибратора сброшено",
      OP_MIN_PRASAK_TON_ALARM:"Бак для смешивания микропорошка пустой",
      OP_USIS_KOV_TURBINA_GRESKA:"Автоматический выключатель вакуумной турбина всасывания моонет / жетонов сброшено",
      OP_FILTER_VODE_ZACEPLJEN:"Фильтр воды заблокировано",
      OP_VISKTL_RESET_SATI_RADA:"Сервис насоса высокого давления",
      OPW_VISKTL_RESET_SATI_RADA:"Сервис насоса высокого давления",
      OP_FILTER_DANI_RADA:"Ошибка фильтра воды",
      OP_BOJLER_DANI_RADA:"Ошибка водонагревателя",
      OPW_ALARM_VISOKOTL_PUMPA:"Сигнализация насоса высокого давления",
      OPW_ALARM_FILTER_SERVIS:"Сигнал необходимого сервиса фильтра",
      OPW_ALARM_BOJLER_SERVIS:"Сигнал необходимого сервиса бойлера",
      HAS_MEMBERS:"Выбранная группа имеет участников и не может быть удалена. Члены должны быть удалены в первую очередь.",
      PERIODIC_SUMMARY_FOR:"Периодический отчет ПО",
      PERIODIC_SUMMARY_REPORTS:"Периодические итоговые отчеты",
      DATE_RANGE:"Промежуток времени",
      FINANCIAL_REPORT:"Финансовый отчет",
      GROSS_INCOME:"Валовый доход",
      GROSS_INCOME_SUM:"Сумма валового дохода",
      COMMISSION_FEE:"Комиссионный сбор",
      NET_INCOME:"Чистая прибыль (для выставления счета)",
      COMMISSION_FEE_DETAILS:"Комиссионный сбор включая плату банка / PayPal или платеж поставщиков SMS-услуг.",
      LOYALTY_CREDITS_REPORT:"Отчеты по локальным жетонам",
      LOYALTY_GIVEN:"Учитывая локальные жетоны",
      LOYALTY_USED:"Используемые локальные жетоны",
      LOYALTY_SOLD:"Локальные жетоны загружены",
      LOYALTY_TOTAL:"Всего",
      LOYALTY_CURRENT_MONTH:"Текущий месяц",
      SOMETHING_WENT_WRONG:"Упс ....",
      MISSING_PAGE:"Извините, мы не смогли найти эту страницу",
      TRY_AGAIN:"Попробуйте еще раз",
      DEFAULT_ERROR_NAME:"Неизвестная ошибка",
      DEFAULT_ERROR_DESCRIPTION:"Пожалуйста попробуйте еще раз",
      MY_ACCOUNT_DETAILS:"Данные моего аккаунта",
      SAVE_CHANGES:"Сохранить изменения",
      USERNAME:"Имя пользователя",
      FIRST_NAME:"Имя",
      LAST_NAME:"Фамилия",
      USER_ROLE:"Роль пользователя",
      OLD_PASSWORD:"Старый пароль",
      NEW_PASSWORD:"Новый пароль",
      OLD_PASSWORD_REQUIRED:"Нужен старый пароль",
      NEW_PASSWORD_REQUIRED:"Новый пароль обязательный",
      NEW_PASSWORD_REPEAT:"Необходимо повторить новый пароль",
      NEW_PASSWORD_NOT_MATCH:"Старый и новый пароль не совпадают",
      PASSWORD_DIFFERENT_VALIDATION:"Новый пароль должен отличаться от старого",
      PASSWORD_MIN_CHAR:"Пароль должен состоять не менее 8 символов",
      PASSWORD_MAX_CHAR:"Ваш пароль должен содержать не более 32 символов",
      PASSWORD_PATTERN_VALIDATION:"Пароль должен содержать хотя бы одно число",
      ACCOUNT_MANAGEMENT:"Управление счетами",
      NOT_ACTIVE:"Не активный",
      ASSIGN_ROLE:"Назначить роль",
      UPDATE:"Обновить",
      ADD_NEW_ACCOUNT:"Добавить учетную запись",
      EMAIL_REQUIRED:"E-mail обязательно",
      EMAIL_NOT_VALID:"Адрес недействительна",
      ADD_NEW_USER_TEXT:"Электронное письмо с активационным ссылкой будет отправлен на указанный адрес электронной почты.",
      UPDATE_USER_NOTIFICATION:"Вы успешно обновили свою информацию",
      CHANGED_PASSWORD_NOTIFICATION:"Вы успешно изменили пароль",
      UPDATE_USER_GROUP_NOTIFICATION:"Вы успешно обновили название группы пользователей",
      CREATE_USER_GROUP_NOTIFICATION:"Вы успешно создали группу",
      DETELE_USER_GROUP_NOTIFICATION:"Вы успешно удалили группу",
      EMPTY_GROUP_LIST_MSG:"Не было создано групп. Начните с создания",
      DELETE_USER_FROM_GROUP_NOTIFICATION:"Вы успешно удалили пользователя из группы",
      ADD_USER_TO_GROUP_NOTIFICATION:"Вы успешно добавили пользователя в группу",
      ADD_USER_NOTIFICATION:"Вы успешно добавили нового пользователя",
      DELETE_USER_NOTIFICATION:"Вы успешно удалили пользователя",
      RESEND_USER_VERIFICATION_EMAIL:"Вы успешно повторно отправили письмо с подтверждением",
      ENTER_USER_GROUP_NAME_TO_CONTINUE:"Для создания группы пользователей",
      DELETE_USER:"Удалить пользователя",
      DELETE_USER_FROM_USER_GROUP_QUESTION:"Вы уверены, что хотите удалить пользователя из группы пользователей?",
      CAMPAIGN_DEFAULT_SMS_MESSAGE:"Уважаемый пользователь R2W",
      CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Норма лояльности по количеству визитов",
      CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Норма лояльности на потраченную сумму",
      CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Норма лояльности на каждый день недели",
      REMOVE_CAMPAIGN_RULE_TITLE:"Удаление правила кампании",
      REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Вы уверены, что хотите удалить правило кампании?",
      LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Вы успешно создали новую кампанию",
      LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Вы успешно активировали кампанию",
      LOYALTY_EMPTY_LIST_NOTIFICATION:"Не было создано кампаний. Начните с создания",
      LOYALTY_SENT_MESSAGE_NOTIFICATION:"Вы успешно прислали сообщение",
      COMPANY_ACCOUNTS:"Учетные записи компании",
      BUSSINESS_INVOICES_LIST:"Мои B2B счета-фактуры",
      LOCALE_TOKEN:"Локальный токен",
      R2W:"Глобальный токен",
      START_MONTH:"Начало месяца",
      END_MONTH:"Конечный месяц",
      TOKEN_TYPE:"Тип токена",
      TOKEN_NUMBER:"Номер маркера",
      NOTHING_TO_DISPLAY:"* Нечего продемонстрировать",
      CREATE_INVOICE:"Создать счета-фактуры",
      INVOICE:"Счет-фактура",
      INVOICES:"Счета-фактуры",
      EDIT_INVOICE:"Редактировать счет-фактуру",
      UPDATE_INVOICE_NOTIFICATION:"Вы успешно обновили счет-фактуру в ожидаемый статус",
      CURRENT_CHARGES:"Сборы за текущий период",
      PAYMENTS_ON_HOLD:"Счета в обработке",
      FOR_INVOICING:"Для счетов-фактур",
      CANCEL_INVOICING_NOTIFICATION_HEADER:"Вы собираетесь отменить счет-фактуру",
      CANCEL_INVOICING_NOTIFICATION_TEXT:"Вы уверены, что хотите отменить этот счет-фактуру?",
      INVOICING_NOTIFICATION_HEADER:"Вы собираетесь делать выставления счетов",
      INVOICING_NOTIFICATION_TEXT:"Вы уверены, что хотите прислать счет-фактуру?",
      SENT_INVOICE_NOTIFICATION:"Вы успешно прислали счет-фактуру",
      CANCELED_INVOICE_NOTIFICATION:"Вы успешно отменили счет-фактуру",
      INVOICE_DESCRIPTION_TEXT:"Счет для",
      INVOICE_STATE:"Состояние счета-фактуры",
      INVOICE_NUMBER:"Номер накладной",
      INVOICE_TOTAL:"Всего",
      SELECT_YEAR:"Выберите год",
      DOWNLOAD:"Скачать PDF",
      INVOICE_NUMBER_HEADER:"Вы пришлете счет-фактуру с номером",
      INVOICE_PAYMENT_CONFIRMATION:"Вы хотите подтвердить оплату",
      INSERT_INVOICE_NUMBER:"Введите номер счета-фактуры",
      INVOICED_WARNING:"Электронное письмо не было отправлено. Пожалуйста, подождите ...",
      SEND_INVOICE:"Отправить",
      INVOICE_ALL:"Все",
      INVOICE_FROM_R2W:"С R2W",
      INVOICE_TO_R2W:"К R2W",
      PAYMENT_REQUEST:"Запрос на оплату",
      PAYMENT_REQUEST_STATE:"Состояние запроса платежа",
      PAYMENT_REQUEST_NUMBER:"Номер платежного поручения",
      FOR_PAYMENT_REQUEST:"Запрос платежа",
      PAYMENT_REQUEST_ON_HOLD:"Запрос платежа в обработке",
      DOWNLOAD_INVOICE:"Скачать счет-фактуру",
      CLICK_FOR_DOWNLOAD_OPTIONS:"Нажмите, чтобы скачать параметры",
      B2B_SPEC:"B2B Спецификация",
      B2C_SPEC:"B2C Спецификация",
      DOWNLOAD_PAYMENT_REQUEST:"Запрос платежа",
      LOYALTY_PREVIEW:"Проверка лояльности",
      ACTIVATED:"Включен",
      RUNNING:"Ход",
      NOT_ACTIVATED:"Не активирован",
      FINISHED:"Готово",
      DEPRECATED:"Не суждено",
      UPCOMING:"Будущие",
      NONE:"Нет",
      STARTED:"Начало",
      ENDS:"Заканчивается",
      DEDICATED:"Посвященный",
      ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Вы активировать",
      CAMPAIGN:"Кампания",
      SEND_MESSAGE_NOTIFICATION:"Вы будете присылать сообщения выбранным группам пользователей",
      DIVISIBLE_TO_NUMBER:"Число должно делиться на ",
      BRIDGE_PLC:"Bridge - PLC",
      DEVICE_TYPE:"Тип устройства",
      LISTENER:"Маленькие машины",
      BRIDGE:"Мыть ящики",
      WASH_BOXES:"Мыть ящики",
      VACUUMS:"Пылесосы",
      SAVE_NEWS:"Сохранить новости",
      CREATE_NEW_NEWS:"Создать новые новости",
      HISTORY_OF_ALL_NEWS:"История всех новостей",
      TYPE_FACILITY_NAME_PLACEHOLDER:"Введите название объекта",
      ADD_ANOTHER_FACILITY_PLACEHOLDER:"Добавить еще один объект",
      NEWS_TEXT:"Текст новостей",
      NEWS_TITLE:"Название новостей",
      DELETE_NEWS_CONFIRMATION:"Вы собираетесь удалять новости",
      NEWS_DELETE_NOTIFICATION:"Вы успешно удаляете новости",
      NEWS_SAVE_NOTIFICATION:"Вы успешно сохранили новости",
      NEWS_CREATION_DATE:"Дата создания",
      NO_TITLE:"Нет заглавия",
      NEWS_TEXT_MAX_CHAR_VALIDATION:"Текст новостей должен содержать не более 255 символов",
      NEWS_TEXT_REQUIRED_VALIDATION:"Текст новостей обязательный",
      NEWS_TITLE_REQUIRED_VALIDATION:"Заголовок новости обязательный",
      DEACTIVATE:"Деактивировать",
      ASIDE_MENU_LOCAL_TOKENS:"Локальные жетоны",
      CREATE_NEW_LOCAL_TOKENS:"Выпуск новых локальных жетонов",
      ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Введите адрес электронной почты клиента и количество локальных жетонов, которые вы хотите выдать клиенту",
      CREATE_TOKENS:"Выпуск жетонов",
      MINIMUM_ONE_TOKEN:"Значение должно быть числом больше 0",
      CUSTOMER_EMAIL:"Электронная почта клиента",
      AMOUNT_OF_TOKENS:"Количество жетонов",
      ISSUING_LOCAL_TOKENS_SUCCESS:"Успешный выпуск локальных жетонов на",
      PROBLEM_ISSUING_LOCAL_TOKENS:"Возникла ошибка при выдаче локальных жетонов. Пожалуйста, проверьте адрес электронной почты клиента и повторите попытку.",
      HISTORY_OF_ISSUED_LOCAL_TOKENS:"Обзор выпущенных локальных жетонов",
      ISSUED_AT:"Выданный в",
      ISSUED_BY:"Выпущено в",
      CODE:"Активировать код",
      REDEEMED_BY:"Выкуплено",
      REDEEMED_AT:"Выкуплено в",
      ASIDE_MENU_VOUCHERS:"Ваучеры",
      PRINT:"Печать",
      VOUCHERS_OVERVIEW:"Обзор ваучеров",
      CREATE_NEW_VOUCHERS:"Создать новые ваучеры",
      CREATE_NEW_VOUCHERS_DESCRIPTION:"Создайте новую выкупную ваучерную партию, введите количество жетонов на ваучер",
      AMOUNT_OF_TOKENS_PER_VOUCHER:"Количество жетонов на ваучер",
      VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Вы можете назначить от 1 до 100 жетонов на ваучер",
      NUMBER_OF_NEW_VOUCHERS:"Количество ваучеров, которые нужно создать",
      VALIDATION_MIN_MAX_NEW_VOUCHERS:"Вы можете создавать от 1 до {{size}} ваучеров в одном пакете",
      NEW_VOUCHERS_PREFIX:"Новый ваучер серийный код префикса",
      VALIDATION_VOUCHER_PREFIX:"Префикс кода должен быть ровно 4 символа (заглавные буквы и / или цифры)",
      PROBLEM_CREATING_NEW_VOUCHERS:"Возникла проблема с созданием новых ваучеров. Пожалуйста, попробуйте еще раз или обратитесь к нашей поддержки.",
      CREATE_VOUCHERS:"Создать ваучеры",
      CREATING_VOUCHERS_SUCCESS:"Успешно созданы новые ваучеры",
      PRINT_NEW_VOUCHERS:"Печать ваучеров",
      PRINT_NEW_VOUCHERS_DESCRIPTION:"Введите префикс кода ваучера, чтобы напечатать всю серию ваучеров. альтернативно",
      PRINT_VOUCHERS_PREFIX:"Приставка ваучера (серии)",
      NO_VOUCHERS_FOR_PRINT:"Для печать не найдено никаких ваучеров, соответствующих предложенному префикса кода",
      PRINT_VOUCHERS:"Печать ваучера (ов)",
      VALIDATION_VOUCHER_CODE_FILTER:"Поисковый срок ваучер должен состоять из заглавных букв и цифр",
      FILTER_VOUCHERS_BY_CODE:"Поиск ваучеров за выкупным кодом",
      FILTER_VOUCHERS:"Поисковые ваучеры",
      WASH_BOX:"Бокс мойки",
      DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Общее количество локальных жетонов",
      TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Общие приобретенные локальные жетоны за день",
      TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Общие потраченные локальные жетоны за день",
      TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Всего предоставленных локальных жетонов в день",
      LOCAL_TOKEN:"Локальный жетон",
      GIVEN_TOKEN:"Выданные локальные жетоны",
      SOLD_TOKEN:"Продано локальные жетоны",
      SMALL_MACHINES:"Малые машины",
      R2W_Listener:"Cлушатель",
      HHANLE_DEVICE:"HHanle - Бокс мойки",
      CODE_PREFIX_EXIST:"Префикс кода уже существует",
      CODE_PREFIX_EXIST_TEXT:"Вы не можете создать новый ваучер с этим префиксом кода. Пожалуйста, установите еще один.",
      MIN_FOUR_VALIDATION:"Всего 4 символа",
      ALL_INFORMATION_1:"Вся информация о",
      ALL_INFORMATION_2:"будут потеряны",
      ASIDE_MENU_TRANSACTIONS:"Oперации",
      EXPENSES:"Расходы",
      TOPUPS:"Купленные токены",
      EXPENSES_LIST:"Список расходов",
      USER_EMAIL:"Электронная почта пользователя",
      COMPANY_NAME:"Название компании",
      TOPUPS_LIST:"Список купленных токенов",
      CONSUMER:"Consumer",
      SYSTEM_ADMIN:"System administrator",
      MERCHANT_ADMIN:"Merchant administrator",
      COMPANY_ADMIN:"Company administrator",
      FACILITY_ADMIN:"Facility administator",
      SUBSCRIBER:"Subscriber",
      CONFIGURATOR:"Configurator",
      SETUP_UNIT_SERIAL_NO:"Серийный номер",
      SETUP_UNIT_MATERIAL_NO:"Номер материала",
      SETUP_UNIT_WEBAPI_VERSION:"Версия WebApi",
      TOTAL_TURNOVER:"Оборот автомойки",
      AVAILABILITY_ALL:"Доступность",
      AVAILIBILITY:"Доступность моечных постов:",
      AVAILABILITY_VACUUMS:"Доступность пылесосов:",
      WASH_BOX_INFO:"Информация о моечных постах",
      VACUUM_CLEANER_INFO:"Информация о пылесосах",
      BREAD_CRUMBS_SERVICE:"Обслуживание",
      HOLIDAYS:"Нерабочие дни",
      HOLIDAY:"Нерабочий день",
      LIGHTS_ON:"Включить свет",
      LIGHTS_OFF:"Выключить свет",
      WASH_BOXES_ON:"Включить моечный пост",
      WASH_BOXES_OFF:"Выключить моечный пост",
      VACUUMS_ON:"Включить пылесосы",
      VACUUMS_OFF:"Выключить пылесосы",
      TURNOVER:"Оборот",
      TURNOVER_MANUAL_WASH_UNIT:"Ручной ввод оборота",
      STATUS_BAY_RUN_TIME:"Общее время работы моечного поста",
      STATUS_BAY_PROGRAM_NAME:"Название программы",
      STATUS_BAY_CREDIT:"Баланс моечного поста",
      CLOUD_KREDIT:"Облачный баланс",
      STATUS_VACUUM_RUN_TIME:"Общее время работы пылесоса",
      SHOW_SERVICE_AND_PROGRAM_INFO:"Информация об услугах объекта, программах моечных постов и текущих неисправностях",
      UNAVAILABLE:"Устройство недоступно",
      SHOW_HIDE_TABLE:"Показать/скрыть таблицу рабочего времени",
      PROGRAM_NAME:"Название программы",
      PROGRAM_COUNTER:"Счётчик программы",
      NO_NAME:"Ссылка не имеет имени",
      COUNTER_SERVICE_DATA:"Данные обслуживания",
      NEED_SERVICE:"Требуется обслуживание",
      PROGRAM_DATA:"Данные программы моечного поста",
      CURRENT_FAULT_DATA:"Данные о текущих неисправностях",
      REFERENCE_DUE:"Крайний срок",
      REFERENCE_SECONDS:"Секунды",
      REFERENCE_NAME:"Название детали",
      WASHBOX_NAME:"Название моечного поста",
      FAULT_NAME:"Название неисправности",
      FAULT_NUMBER:"Номер неисправности",
      CURRENT_FAULT_COUNT:"Активные неисправности",
      DEVICE_NOT_INSTALLED:"Устройство не установлено",
      STATUS_READY:"Готовый статус",
      STATUS_ERROR:"Состояние ошибки",
      CONNECTION_ERROR:"Не в сети",
      UNKNOWN_RESET:"Ошибка программного обеспечения",
      SOFTWARE_RESET:"Ошибка программного обеспечения",
      EXTERNAL_PIN_RESET:"Ошибка программного обеспечения",
      RESTART_OR_BROWNOUT_OCCURRED:"Ошибка программного обеспечения",
      DEAD_RM5_CHANNEL_PIN_ERROR:"Ошибка оборудования",
      COULD_NOT_SIMULATE_COIN:"Ошибка оборудования",
      ERROR_SETTING_INHIBIT_MODE:"Ошибка оборудования",
      OFFLINE_DEVICE:"Автомойка не в сети",
      TARIFFS:"Тарифы",
      DAY:"День",
      NIGHT:"Ночь",
      VOUCHER_CODE:"Код ваучера",
      DISMISS_ALARM:"Сбросить сигнал тревоги?",
      ALARM_ACTIVE:"Активные тревоги",
      NO_ALARM_ACTIVE:"Активных тревог нет",
      ALARM_HISTORY:"История тревог",
      MANAGING_TOKENS:"Управление токенами",
      EXPIRATION_DATE:"Дата окончания срока",
      EXTEND_TOKEN_DATE:"Продлить срок действия токена для",
      DELETE_TOKENS_FOR:"Удалить токены для",
      PUMP_TYPE:"Тип насоса",
      TURN_OFF_DEVICE:"Состояние устройства",
      OPERATION_DATA:"Данные эксплуатации",
      PUMP_DATA:"Данные насоса",
      PUMP_NAME:"Название насоса",
      POINT_NAME:"Название точки",
      CHANGER_INCOME:"Общий доход разменного автомата по датам",
      SELECTED_OPEN:"Открыто в выбранное рабочее время",
      ALWAYS_OPEN:"Всегда открыты (24/7)",
      CLOSED:"Закрыто",
      CLOSED_24:"Закрыто 24 часа",
      OPENED_24:"Открыто 24 часа",
      MON:"Понедельник",
      TUE:"Вторник",
      WED:"Среда",
      THU:"Четверг",
      FRI:"Пятница",
      SAT:"Суббота",
      SUN:"Воскресенье",
      PRICING:"Цены",
      PRICE:"Цена",
      VALIDITY:"Срок действия",
      TOKEN_PACKAGES:"Пакеты токенов",
      SINGLE_WASH:"Разовая мойка",
      FACILITY_WORKING_HOURS:"Установить часы работы для выбранного объекта",
      WORKING_HOURS_ALWAYS_OPEN:"Всегда открыто",
      WORKING_HOURS_ALWAYS_CLOSE:"Закрыто оператором",
      WORKING_HOURS_CUSTOM:"Установить часы работы",
      KARCHER_ERROR_CODE:"Код ошибки тревоги",
      KARCHER_ERROR_MESSAGE_1:"Выходы электронной схемы перегружены",
      KARCHER_ERROR_MESSAGE_2:"Необходимо опорожнить маслоотделитель",
      KARCHER_ERROR_MESSAGE_4:"Сумеречный датчик неисправен.",
      KARCHER_ERROR_MESSAGE_5:"Сработало защитное реле мотора высоконапорного насоса",
      KARCHER_ERROR_MESSAGE_6:"Нарушено соединение с RDS",
      KARCHER_ERROR_MESSAGE_7:"Манометрический выключатель 'воздух' на компрессоре не сообщает о наличие давления",
      KARCHER_ERROR_MESSAGE_8:"Причина: нет соединения с электронной схемой 'MSWS'.",
      KARCHER_ERROR_MESSAGE_10:"Нет соединения с электронной схемой насоса на месте мойки 1",
      KARCHER_ERROR_MESSAGE_11:"Выходы электронной схемы на месте мойки 1 перегружены",
      KARCHER_ERROR_MESSAGE_12:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 1",
      KARCHER_ERROR_MESSAGE_13:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 1",
      KARCHER_ERROR_MESSAGE_14:"Закрепить реле высоконапорного насоса на месте мойки 1",
      KARCHER_ERROR_MESSAGE_15:"Клапан половины нагрузки моечной площадки 1 неисправен",
      KARCHER_ERROR_MESSAGE_16:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 1",
      KARCHER_ERROR_MESSAGE_17:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 1",
      KARCHER_ERROR_MESSAGE_18:"Неисправна электронная схема на месте мойки 1.",
      KARCHER_ERROR_MESSAGE_19:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 1",
      KARCHER_ERROR_MESSAGE_20:"Нет соединения с электронной схемой дистанционного управления места мойки 1",
      KARCHER_ERROR_MESSAGE_21:"Монетный аппарат на месте мойки 1 неисправен",
      KARCHER_ERROR_MESSAGE_22:"Монетный аппарат на месте мойки 1 неисправен",
      KARCHER_ERROR_MESSAGE_30:"Нет соединения с электронной схемой насоса на месте мойки 2",
      KARCHER_ERROR_MESSAGE_31:"Выходы электронной схемы на месте мойки 2 перегружены",
      KARCHER_ERROR_MESSAGE_32:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 2",
      KARCHER_ERROR_MESSAGE_33:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 2",
      KARCHER_ERROR_MESSAGE_34:"Закрепить реле высоконапорного насоса на месте мойки 2",
      KARCHER_ERROR_MESSAGE_35:"Клапан половины нагрузки моечной площадки 2 неисправен",
      KARCHER_ERROR_MESSAGE_36:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 2",
      KARCHER_ERROR_MESSAGE_37:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 2",
      KARCHER_ERROR_MESSAGE_38:"Неисправна электронная схема на месте мойки 2.",
      KARCHER_ERROR_MESSAGE_39:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 2",
      KARCHER_ERROR_MESSAGE_40:"Нет соединения с электронной схемой дистанционного управления места мойки 2",
      KARCHER_ERROR_MESSAGE_41:"Монетный аппарат на месте мойки 2 неисправен",
      KARCHER_ERROR_MESSAGE_42:"Монетный аппарат на месте мойки 2 неисправен",
      KARCHER_ERROR_MESSAGE_50:"Нет соединения с электронной схемой насоса на месте мойки 3",
      KARCHER_ERROR_MESSAGE_51:"Выходы электронной схемы на месте мойки 3 перегружены",
      KARCHER_ERROR_MESSAGE_52:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 3",
      KARCHER_ERROR_MESSAGE_53:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 3",
      KARCHER_ERROR_MESSAGE_54:"Закрепить реле высоконапорного насоса на месте мойки 3",
      KARCHER_ERROR_MESSAGE_55:"Клапан половины нагрузки моечной площадки 3 неисправен",
      KARCHER_ERROR_MESSAGE_56:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 3",
      KARCHER_ERROR_MESSAGE_57:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 3",
      KARCHER_ERROR_MESSAGE_58:"Неисправна электронная схема на месте мойки 3.",
      KARCHER_ERROR_MESSAGE_59:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 3",
      KARCHER_ERROR_MESSAGE_60:"Нет соединения с электронной схемой дистанционного управления места мойки 3",
      KARCHER_ERROR_MESSAGE_61:"Монетный аппарат на месте мойки 3 неисправен",
      KARCHER_ERROR_MESSAGE_62:"Монетный аппарат на месте мойки 3 неисправен",
      KARCHER_ERROR_MESSAGE_70:"Нет соединения с электронной схемой насоса на месте мойки 4",
      KARCHER_ERROR_MESSAGE_71:"Выходы электронной схемы на месте мойки 4 перегружены",
      KARCHER_ERROR_MESSAGE_72:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 4",
      KARCHER_ERROR_MESSAGE_73:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 4",
      KARCHER_ERROR_MESSAGE_74:"Закрепить реле высоконапорного насоса на месте мойки 4",
      KARCHER_ERROR_MESSAGE_75:"Клапан половины нагрузки моечной площадки 4 неисправен",
      KARCHER_ERROR_MESSAGE_76:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 4",
      KARCHER_ERROR_MESSAGE_77:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 4",
      KARCHER_ERROR_MESSAGE_78:"Неисправна электронная схема на месте мойки 4.",
      KARCHER_ERROR_MESSAGE_79:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 4",
      KARCHER_ERROR_MESSAGE_80:"Нет соединения с электронной схемой дистанционного управления места мойки 4",
      KARCHER_ERROR_MESSAGE_81:"Монетный аппарат на месте мойки 4 неисправен",
      KARCHER_ERROR_MESSAGE_82:"Монетный аппарат на месте мойки 4 неисправен",
      KARCHER_ERROR_MESSAGE_90:"Нет соединения с электронной схемой насоса на месте мойки 5",
      KARCHER_ERROR_MESSAGE_91:"Выходы электронной схемы на месте мойки 5 перегружены",
      KARCHER_ERROR_MESSAGE_92:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 5",
      KARCHER_ERROR_MESSAGE_93:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 5",
      KARCHER_ERROR_MESSAGE_94:"Закрепить реле высоконапорного насоса на месте мойки 5",
      KARCHER_ERROR_MESSAGE_95:"Клапан половины нагрузки моечной площадки 5 неисправен",
      KARCHER_ERROR_MESSAGE_96:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 5",
      KARCHER_ERROR_MESSAGE_97:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 5",
      KARCHER_ERROR_MESSAGE_98:"Неисправна электронная схема на месте мойки 5.",
      KARCHER_ERROR_MESSAGE_99:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 5",
      KARCHER_ERROR_MESSAGE_100:"Нет соединения с электронной схемой дистанционного управления места мойки 5",
      KARCHER_ERROR_MESSAGE_101:"Монетный аппарат на месте мойки 5 неисправен",
      KARCHER_ERROR_MESSAGE_102:"Монетный аппарат на месте мойки 5 неисправен",
      KARCHER_ERROR_MESSAGE_110:"Нет соединения с электронной схемой насоса на месте мойки 6",
      KARCHER_ERROR_MESSAGE_111:"Выходы электронной схемы на месте мойки 6 перегружены",
      KARCHER_ERROR_MESSAGE_112:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 6",
      KARCHER_ERROR_MESSAGE_113:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 6",
      KARCHER_ERROR_MESSAGE_114:"Закрепить реле высоконапорного насоса на месте мойки 6",
      KARCHER_ERROR_MESSAGE_115:"Клапан половины нагрузки моечной площадки 6 неисправен",
      KARCHER_ERROR_MESSAGE_116:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 6",
      KARCHER_ERROR_MESSAGE_117:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 6",
      KARCHER_ERROR_MESSAGE_118:"Неисправна электронная схема на месте мойки 6.",
      KARCHER_ERROR_MESSAGE_119:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 6",
      KARCHER_ERROR_MESSAGE_120:"Нет соединения с электронной схемой дистанционного управления места мойки 6",
      KARCHER_ERROR_MESSAGE_121:"Монетный аппарат на месте мойки 6 неисправен",
      KARCHER_ERROR_MESSAGE_122:"Монетный аппарат на месте мойки 6 неисправен",
      KARCHER_ERROR_MESSAGE_130:"Нет соединения с электронной схемой насоса на месте мойки 7",
      KARCHER_ERROR_MESSAGE_131:"Выходы электронной схемы на месте мойки 7 перегружены",
      KARCHER_ERROR_MESSAGE_132:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 7",
      KARCHER_ERROR_MESSAGE_133:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 7",
      KARCHER_ERROR_MESSAGE_134:"Закрепить реле высоконапорного насоса на месте мойки 7",
      KARCHER_ERROR_MESSAGE_135:"Клапан половины нагрузки моечной площадки 7 неисправен",
      KARCHER_ERROR_MESSAGE_136:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 7",
      KARCHER_ERROR_MESSAGE_137:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 7",
      KARCHER_ERROR_MESSAGE_138:"Неисправна электронная схема на месте мойки 7.",
      KARCHER_ERROR_MESSAGE_139:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 7",
      KARCHER_ERROR_MESSAGE_140:"Нет соединения с электронной схемой дистанционного управления места мойки 7",
      KARCHER_ERROR_MESSAGE_141:"Монетный аппарат на месте мойки 7 неисправен",
      KARCHER_ERROR_MESSAGE_142:"Монетный аппарат на месте мойки 7 неисправен",
      KARCHER_ERROR_MESSAGE_150:"Нет соединения с электронной схемой насоса на месте мойки 8",
      KARCHER_ERROR_MESSAGE_151:"Выходы электронной схемы на месте мойки 8 перегружены",
      KARCHER_ERROR_MESSAGE_152:"Слишком большое потребление электроэнергии высоконапорного насоса на месте мойки 8",
      KARCHER_ERROR_MESSAGE_153:"Слишком низкое потребление электроэнергии высоконапорного насоса на месте мойки 8",
      KARCHER_ERROR_MESSAGE_154:"Закрепить реле высоконапорного насоса на месте мойки 8",
      KARCHER_ERROR_MESSAGE_155:"Клапан половины нагрузки моечной площадки 8 неисправен",
      KARCHER_ERROR_MESSAGE_156:"Сработал защитный обмоточный контакт насоса высокого давления на месте мойки 8",
      KARCHER_ERROR_MESSAGE_157:"Слишком низкий уровень масла в высоконапорном насосе на месте мойки 8",
      KARCHER_ERROR_MESSAGE_158:"Неисправна электронная схема на месте мойки 8.",
      KARCHER_ERROR_MESSAGE_159:"Сработал выключатель защиты двигателя насоса высокого давления на месте мойки 8",
      KARCHER_ERROR_MESSAGE_160:"Нет соединения с электронной схемой дистанционного управления места мойки 8",
      KARCHER_ERROR_MESSAGE_161:"Монетный аппарат на месте мойки 8 неисправен",
      KARCHER_ERROR_MESSAGE_162:"Монетный аппарат на месте мойки 8 неисправен",
      KARCHER_ERROR_MESSAGE_170:"Отсутствует связь с электроникой А2",
      KARCHER_ERROR_MESSAGE_171:"Перегружены выходы электроники А2",
      KARCHER_ERROR_MESSAGE_172:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_173:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_174:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_175:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_176:"Бак для моющего средства пуст",
      KARCHER_ERROR_MESSAGE_177:"Слишком высокое потребление электроэнергии насоса для мойки основания пола",
      KARCHER_ERROR_MESSAGE_178:"Отсутствует давление после включения мойки днища",
      KARCHER_ERROR_MESSAGE_190:"Отсутствует связь с электроникой А3",
      KARCHER_ERROR_MESSAGE_191:"Перегружены выходы электроники А3",
      KARCHER_ERROR_MESSAGE_200:"Отсутствует связь между управлением и электроникой WSO",
      KARCHER_ERROR_MESSAGE_201:"Перегружены выходы управления к WSO",
      KARCHER_ERROR_MESSAGE_202:"Датчик жесткости воды указывает на проведение регенерации жесткой воды",
      KARCHER_ERROR_MESSAGE_204:"Неисправность электронной схемы",
      KARCHER_ERROR_MESSAGE_210:"Активирован выключатель уровня «ПРОМЕЖУТОЧНЫЙ РЕЗЕРВУАР ПУСТ»",
      KARCHER_ERROR_MESSAGE_211:"Выключатели уровня 'ПРОМЕЖУТОЧНЫЙ РЕЗЕРВУАР ПУСТ' и 'ПРОМЕЖУТОЧНЫЙ РВУАР ЗАПОЛНЕН' переключаются одновременно",
      KARCHER_ERROR_MESSAGE_212:"Выключатели уровня 'ОБРАТНООСМОТИЧЕСКИЙ НАСОС ВКЛЮЧЕН' и 'ПРОМЕЖУТОЧНЫЙ РЕЗЕРВУАР ЗАПОЛНЕН' переключаются одновременно",
      KARCHER_ERROR_MESSAGE_213:"Отсутствует давление воды",
      KARCHER_ERROR_MESSAGE_214:"Сообщение о неисправности заводской установки водоподготовки",
      KARCHER_ERROR_MESSAGE_220:"Недостаток воды",
      KARCHER_ERROR_MESSAGE_221:"Слишком высокая температура выхлопных газов",
      KARCHER_ERROR_MESSAGE_222:"Слишком высокое потребление электроэнергии циркуляционного насоса системы теплой воды",
      KARCHER_ERROR_MESSAGE_223:"Неисправность горелки",
      KARCHER_ERROR_MESSAGE_224:"Сработал автоматический предохранитель горелки",
      KARCHER_ERROR_MESSAGE_225:"Задержка горелки активна",
      KARCHER_ERROR_MESSAGE_226:"Индикатор потока открывает подачу воды после отключения циркуляционного насоса подачи теплой воды не более, чем на 5 секунд.",
      KARCHER_ERROR_MESSAGE_227:"Индикатор потока перекрывает подачу воды после включения циркуляционного насоса подачи теплой воды не более, чем на 3 секунд.",
      KARCHER_ERROR_MESSAGE_228:"Выход горячей воды слишком медленно охлаждается после отключения горелки",
      KARCHER_ERROR_MESSAGE_229:"Неисправность датчика температуры горячей воды",
      KARCHER_ERROR_MESSAGE_230:"Неисправность датчика температуры на выходе горелки",
      KARCHER_ERROR_MESSAGE_231:"Неисправность датчика температуры горячей воды",
      KARCHER_ERROR_MESSAGE_232:"Неисправность датчика температуры на выходе горелки",
      KARCHER_ERROR_MESSAGE_233:"Температура воды при внешней подаче теплой воды выше 60°C",
      KARCHER_ERROR_MESSAGE_234:"Ошибка в программе «антилегионелла»",
      KARCHER_ERROR_MESSAGE_235:"Температура горячей воды в режиме «антилегионелла» не достигнута",
      KARCHER_ERROR_MESSAGE_240:"Неисправность датчика наружной температуры",
      KARCHER_ERROR_MESSAGE_241:"Неисправность датчика наружной температуры",
      KARCHER_ERROR_MESSAGE_242:"Слишком высокое потребление электроэнергии циркуляционного насоса системы защиты от замерзания",
      KARCHER_ERROR_MESSAGE_243:"Слишком высокое потребление электроэнергии циркуляционного насоса системы обогрева места мойки",
      KARCHER_ERROR_MESSAGE_244:"Температура теплой воды слишком низкая, не выключать обогрев места мойки",
      KARCHER_ERROR_MESSAGE_245:"Потребление тока обогревом шланга подачи пены слишком высокое",
      KARCHER_ERROR_MESSAGE_247:"Неисправность электронной схемы",
      KARCHER_ERROR_MESSAGE_248:"Неисправность электронной схемы",
      KARCHER_ERROR_MESSAGE_250:"Слишком высокое потребление электроэнергии насоса при активации особых программ мойки",
      KARCHER_ERROR_MESSAGE_255:"Неисправность электронной схемы",
      KARCHER_ERROR_MESSAGE_260:"Отсутствует связь с электроникой А5",
      KARCHER_ERROR_MESSAGE_261:"Перегружены выходы электроники А5",
      KARCHER_ERROR_MESSAGE_280:"Отсутствует связь с электроникой А6",
      KARCHER_ERROR_MESSAGE_281:"Перегружены выходы электроники А6",
      KARCHER_ERROR_MESSAGE_282:"Потребление тока насоса устройства для мойки колесных дисков слишком высокое",
      KARCHER_ERROR_MESSAGE_283:"Потребление тока насоса устройства для мойки колесных дисков слишком низкое",
      KARCHER_ERROR_MESSAGE_284:"Реле насоса устройства для мойки колесных дисков заклинивает",
      KARCHER_ERROR_MESSAGE_300:"Отсутствует связь с электроникой А7",
      KARCHER_ERROR_MESSAGE_301:"Перегружены выходы электроники А7",
      KARCHER_ERROR_MESSAGE_320:"Отсутствует связь с электроникой А8",
      KARCHER_ERROR_MESSAGE_321:"Перегружены выходы электроники А8",
      KARCHER_ERROR_MESSAGE_322:"Потребление тока насосом микроэмульсии слишком высокое",
      KARCHER_ERROR_MESSAGE_323:"Потребление тока насосом микроэмульсии слишком низкое",
      KARCHER_ERROR_MESSAGE_324:"Реле насоса микроэмульсии закли нивает",
      KARCHER_ERROR_MESSAGE_340:"Отсутствует связь с электроникой А9",
      KARCHER_ERROR_MESSAGE_341:"Перегружены выходы электроники А9",
      KARCHER_ERROR_MESSAGE_342:"Слишком высокое потребление электроэнергии насосом для интенсивной очистки",
      KARCHER_ERROR_MESSAGE_343:"Слишком низкое потребление электроэнергии насосом для интенсивной очистки",
      KARCHER_ERROR_MESSAGE_344:"Реле насоса для интенсивной очистки заклинивает",
      KARCHER_ERROR_MESSAGE_400:"Отсутствует давление горячей воды",
      KARCHER_ERROR_MESSAGE_401:"Отсутствует давление свежей воды",
      KARCHER_ERROR_MESSAGE_402:"Отсутствует давление пермеата",
      KARCHER_ERROR_MESSAGE_403:"4. Отсутствует давление 4-го типа воды",
      KARCHER_ERROR_MESSAGE_404:"4. Тип воды, температура выше 60 °C или внешний сбой",
      KARCHER_ERROR_MESSAGE_405:"Защита от замерзания без давления",
      KARCHER_ERROR_MESSAGE_406:"Давление в системе защиты от замерзания несмотря на выключенный насос защиты от замерзания",
      KARCHER_ERROR_MESSAGE_410:"Ошибка F 400 возникла 4 раза в течение 24 часов",
      KARCHER_ERROR_MESSAGE_411:"Ошибка F 401 активна в течение 300 секунд",
      KARCHER_ERROR_MESSAGE_412:"Ошибка F 402 возникла 4 раза в течение 24 часов",
      KARCHER_ERROR_MESSAGE_413:"Ошибка F 403 возникла 4 раза в течение 24 часов",
      KARCHER_ERROR_MESSAGE_414:"Ошибка F 405 возникла 4 раза в течение 24 часов",
      KARCHER_ERROR_MESSAGE_420:"Неисправность переключателя стоимости монет 1",
      KARCHER_ERROR_MESSAGE_421:"Неисправность переключателя стоимости монет 2",
      KARCHER_ERROR_MESSAGE_440:"Отсутствует связь с электроникой А31",
      KARCHER_ERROR_MESSAGE_441:"Перегружены выходы электроники А31",
      KARCHER_ERROR_MESSAGE_500:"Соединение с электронными компонентами пылесоса 1/2",
      KARCHER_ERROR_MESSAGE_501:"Кнопка пуска пылесоса 1 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_502:"Кнопка пуска пылесоса 2 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_510:"Соединение с электронными компонентами пылесоса 3/4",
      KARCHER_ERROR_MESSAGE_511:"Кнопка пуска пылесоса 3 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_512:"Кнопка пуска пылесоса 4 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_520:"Соединение с электронными компонентами пылесоса 5/6",
      KARCHER_ERROR_MESSAGE_521:"Кнопка пуска пылесоса 5 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_522:"Кнопка пуска пылесоса 6 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_530:"Соединение с электронными компонентами пылесоса 7/8",
      KARCHER_ERROR_MESSAGE_531:"Кнопка пуска пылесоса 7 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_532:"Кнопка пуска пылесоса 8 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_540:"Соединение с электронными компонентами пылесоса 9/10",
      KARCHER_ERROR_MESSAGE_541:"Кнопка пуска пылесоса 9 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_542:"Кнопка пуска пылесоса 10 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_550:"Соединение с электронными компонентами пылесоса 10/11",
      KARCHER_ERROR_MESSAGE_551:"Кнопка пуска пылесоса 11 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_552:"Кнопка пуска пылесоса 12 непрерывный контакт",
      KARCHER_ERROR_MESSAGE_800:"Отсутствует связь с электроникой А30",
      KARCHER_ERROR_MESSAGE_801:"Перегружены выходы электроники А30",
      KARCHER_ERROR_MESSAGE_802:"Сбой устройства смягчения",
      KARCHER_ERROR_MESSAGE_803:"Выключатель защиты двигателя, насос предварительного давления ОО запущен",
      KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
      KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
      KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
      KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
      KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
      KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
      KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
      KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
      KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
      KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
      KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
      KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
      KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
      KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
      KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
      KARCHER_INFO_MESSAGE_20:"Программа «антилегионелла» бака для горячей воды",
      KARCHER_INFO_MESSAGE_21:"Программа «антилегионелла» насоса высокого давления 1 выполнена успешно",
      KARCHER_INFO_MESSAGE_22:"Программа «антилегионелла» насоса высокого давления 2 выполнена успешно",
      KARCHER_INFO_MESSAGE_23:"Программа «антилегионелла» насоса высокого давления 3 выполнена успешно",
      KARCHER_INFO_MESSAGE_24:"Программа «антилегионелла» насоса высокого давления 4 выполнена успешно",
      KARCHER_INFO_MESSAGE_25:"Программа «антилегионелла» насоса высокого давления 5 выполнена успешно",
      KARCHER_INFO_MESSAGE_26:"Программа «антилегионелла» насоса высокого давления 6 выполнена успешно",
      KARCHER_INFO_MESSAGE_27:"Программа «антилегионелла» насоса высокого давления 7 выполнена успешно",
      KARCHER_INFO_MESSAGE_28:"Программа «антилегионелла» насоса высокого давления 8 выполнена успешно",
      KARCHER_INFO_MESSAGE_29:"Программа «антилегионелла» завершена",
      KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
      KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
      KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
      KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
      KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
      KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
      KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
      KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
      KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
      KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
      KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
      KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
      KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
      KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
      KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
      KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
      KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
      KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
      KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
      KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
      KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
      KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
      KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
      KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
      KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
      KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
      KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
      KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
      KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
      KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
      KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
      KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
      KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
      KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
      KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
      KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
      KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
      KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
      KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
      KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
      KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
      KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
      KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
      KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
      KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
      KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
      ORGANIZATION:"Organizacija",
      CREATE_ORGANIZATION:"Создать организацию",
      CREATE_ORGANIZATION_AS:"Создать дочернюю организацию для",
      DELETE_ORGANIZATION:"Удалить организацию",
      EDIT_ORGANIZATION:"Редактировать организацию",
      SUPPORTED_ORG_NAME:"Поддерживаемая организация",
      SUPPORTED_ORG_TYPE:"Поддерживаемый тип",
      ORG_NAME:"Название",
      ORG_TYPE:"Тип",
      SET_ORG_TITLE:"Назначить дочернюю организацию",
      SET_SUPPORTED_ORG_TITLE:"Назначить поддерживаемую дочернюю организацию",
      SAVE_ORGANIZATION:"Сохранить организацию",
      SELECT_ORGANIZATION_TYPE:"Выберите тип организации",
      SELECT_ORGANIZATION_SELECTOR:"Выбрать",
      SELECT_SUPPORTED_ORGANIZATION:"Поддерживается",
      ORGANIZATION_DELETED:"Организация успешно удалена",
      ORGANIZATION_SAVED:"Организация успешно сохранена",
      ORGANIZATION_UPDATED:"Организация успешно обновлена",
      ALERTS:"Тревоги",
      DEVICE_STATUS:"Состояние устройства",
      SITE_DETAILS:"Сведения об объекте",
      ALARM_STATUS:"Статус тревоги",
      FILTER:"Фильтр по ...",
      FILTER_BY_ALERT_CENTER:"Фильтр по коду, названию или описанию",
      TOTAL_ALARM:"Всего",
      LOW_ALARM:"Событие",
      MEDIUM_ALARM:"Неисправность",
      HIGH_ALARM:"Критическая неисправность",
      NO_FACILITIES_NEARBY:"Поблизости нет объектов",
      GRAY_MAP:"Карта в серых тонах",
      READY:"Готово",
      WARNING:"Неисправность",
      ERROR:"Ошибка",
      SITE_NAME:"Название объекта",
      ACCOUNTS_INFO:"Информация об учетной записи",
      USER_ORGANIZATION:"Организация пользователя",
      ADD_USER_ORGANIZATION:"Добавить нового пользователя организации",
      EDIT_USER_ORGANIZATION:"Редактировать пользователей организации",
      SELECT_ROLE:"Выберите роль",
      SELECT_ORGANIZATION:"Выберите организацию",
      SELECT_USER:"Выберите пользователя",
      USER_FOR_ORGANIZATION_CREATED:"Новый пользователь успешно создан",
      SELECT_REGION:"Выберите регион",
      SELECT_LANGUAGE:"Выберите язык",
      LOADING_DATA:"Загрузка данных, пожалуйста, подождите ...",
      ADMINISTRATOR:"Администратор",
      TECHNICAL_SUPPORT:"Техническая поддержка",
      CONTROLLER:"Контролёр",
      EDIT_ORGANIZATION_USER:"Редактировать пользователей организации",
      DELETE_ORGANIZATION_USER:"Удалить пользователей организации",
      USER_UPDATED:"Пользователь успешно обновлён",
      USER_CREATED:"Пользователь успешно создан",
      ADDRESS:"Адрес",
      SUBSCRIPTIONS:"Подписки",
      RESOLVED_STATUS:"Решено",
      NOT_RESOLVED_STATUS:"Не решено",
      ALERT_NAME:"Название оповещения",
      ALERT_DESCRIPTION:"Описание оповещения",
      ALERT_CODE:"Код оповещения",
      ALERT_TYPE:"Тип оповещения",
      UNSUBSCRIBE:"Отписаться от оповещения",
      SUBSCRIBE:"Подписаться на оповещение",
      ALARM_SUBSCRIBED:"Подписка успешно оформлена",
      UNSUBSCRIBED_CONFIRM:"Отписаться?",
      ALARM_UNSUBSCRIBED:"Вы успешно отписались",
      ASIDE_MENU_CASHLESS_SALES:"Безналичные продажи",
      FILTERED_CASHLESS_PAYMENTS:"Отфильтрованные безналичные платежи",
      REFUND_DIALOG_TITLE:"Сделать возврат по транзакции?",
      REFUND_DIALOG_SUBTITLE:"Сумма может быть меньше либо равна сумме транзакции",
      REFUND:"Возврат",
      INPUT_NOT_VALID:"Некорректный ввод",
      REFUND_SUCCESSFULLY:"Возврат по выбранному платежу успешно выполнен",
      USER:"Пользователь",
      TRANSACTION_ID:"PSP-идентификатор",
      DEVICE_ID:"ID устройства",
      NET_AMOUNT:"Чистая сумма",
      REPORT_NAME:"Название отчёта",
      TIME_FRAME:"Период времени",
      SUB_POINT:"Выберите дочернюю точку",
      SUB_POINT_LIST_NOT_EXIST:"Список дочерних точек отсутствует для выбранного объекта автомойки",
      FACILITY_TYPE:"Тип объекта",
      MACHINE_NAME:"Название машины",
      WASH_FACILITY_DETAILS:"Сведения об объекте автомойки",
      WASH_BAY_DETAILS:"Сведения о моечном посту",
      DEVICES_INFO:"Список устройств",
      OPERATION_TIME_INFO:"Время работы",
      OPERATION_TIME_VACUUM_INFO:"Время работы пылесосов",
      OPERATION_TIME_ILLUMINATION_INFO:"Время работы освещения",
      AVAILABLE_TITLE:"Доступно",
      UNAVAILABLE_TITLE:"Недоступно",
      CURRENT_PROGRAM:"Текущая программа",
      CREDITS:"Баланс",
      DEVICE_NAME:"Название устройства",
      ACTIVE_ALARMS:"Активные тревоги",
      ALL_DAY:"Весь день",
      OPERATING_TIME_WASH_FACILITY:"Система самообслуживания мойки",
      OPERATING_TIME_VACUUMS:"Пылесосы",
      OPERATING_TIME_ILLUMINATION:"Освещение",
      OPERATION_COUNTERS:"Счётчики работы",
      EDIT:"Редактировать",
      WASHING_PROGRAMS:"Программы мойки",
      INFO:"Событие",
      STATISTIC:"Статистика",
      ROLLOVER_DOSING:"Dosing",
      ROLLOVER_SPEED:" Speeds",
      ROLLOVER_RESETS:" Rollover remote reset",
      ROLLOVER_RESETS_INFO:" The remote reset has to be in accordance with local regulations. Important: Before resetting make sure that rollover is empty.",
      RESET_ROLLOVER:" Reset rollover",
      OPEN_DOOR_ROLLOVER:" Open",
      ROLLOVER_OPEN_DOOR_INFO:"Open wash hall door. Be careful.",
      ROLLOVER_OPEN_DOOR:" Open the door",
      APPLY_DOSING_CHANGES:" Apply dosing changes",
      APPLY_SPEED_CHANGES:" Apply speed changes",
      ACTUATION_SUCCESS:"Request sent",
      REMAINING_TIME:" Remaining time",
      OPEN_24H:"Открыто 24 часа",
      CLOSE_24H:"Закрыто 24 часа",
      VALIDATION_OPERATION_TIME:" Format not correct. Use hh:mm",
      ROLLOVER:" Rollover",
      UPDATE_WASHING_PROGRAM:" Update washing program",
      UPDATE_ACTUATORS:"Update actuators",
      OPEN_ROLOVER_DOOR_TITLE:" Want to open rollover door?",
      OPEN_ROLOVER_DOOR_CONTENT:" Are you sure you want to open the door?",
      RESET_ROLOVER_TITLE:" Want to reset rollover?",
      RESET_ROLOVER_CONTENT:" Are you sure you want to reset rollover?",
      G0:"G0",
      G1:"G1",
      G2:"G2",
      G3:"G3",
      G4:"G4",
      G5:"G5",
      G6:"G6",
      G7:"G7",
      G8:"G8",
      G9:"G9",
      G10:"G10",
      U0:"U0",
      U1:"U1",
      U2:"U2",
      U3:"U3",
      U4:"U4",
      U5:"U5",
      U6:"U6",
      U7:"U7",
      ALERT_CENTER_TITLE_BY_SITE:" Alert center report created by selected site from dashboard",
      ALERT_CENTER_TITLE_BY_FACILITY:" Alert center report created by selected facility from dashboard",
      ALERT_CENTER_TITLE_BY_DEFAULT:" Alert center report",
      ERROR_MESSAGE_403:" You don't have privilege to use this api call. Error Code: 403",
      LAST_ACTIVE_PROGRAM:"Active program / Last active program",
      PROGRAM_ID:"Номер программы",
      PROGRAM_PRICE:"Цена программы",
      PROGRAM_DESCRIPTION:"Описание программы",
      NORMAL_CHEMICAL_LEVEL:"OK",
      LOW_CHEMICAL_LEVEL:"Refill required",
      EMPTY_CHEMICAL_LEVEL:"Empty",
      CHEMICAL_LEVEL:"Level indication detergents (%)",
      ROLLOVER_STATUS:" Rollover status",
      ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
      ROLLOVER_STATUS_CODE_1:" Outside operating time",
      ROLLOVER_STATUS_CODE_2:" Program entry allowed",
      ROLLOVER_STATUS_CODE_3:"Position your vehicle",
      ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
      ROLLOVER_STATUS_CODE_5:"Vehicle back",
      ROLLOVER_STATUS_CODE_6:"Vehicle stop",
      ROLLOVER_STATUS_CODE_7:"Wash active",
      ROLLOVER_STATUS_CODE_8:"Wash stopped",
      ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
      ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
      ROLLOVER_STATUS_CODE_11:"Emergency stop",
      ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
      ROLLOVER_STATUS_CODE_13:"Anti frost active",
      ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
      ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
      ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
      ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
      ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
      ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
      ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
      ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
      ROLLOVER_STATUS_CODE_22:"Left door not closed",
      ROLLOVER_STATUS_CODE_23:" Right door not closed",
      ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
      ROLLOVER_STATUS_CODE_25:" Horn sensor",
      ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
      ROLLOVER_STATUS_CODE_99:" Unknown status",
      ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
      ALARM:"Критическая неисправность",
      NO_ALARM:"Нет критических неисправностей",
      SOFTWARE_VERSION:"Версия ПО",
      SOFTWARE_DATE:"Дата версии ПО",
      SITE_ADDRESS:"Адрес объекта",
      SECONDS:"Секунды",
      SERVICE_PART_NAME:"Название обслуживания:",
      OPERATION_SERVICE_COUNTER_ROLLOVER:"Счётчик эксплуатации и обслуживания",
      OPERATION_COUNTER:"Счётчик эксплуатации",
      SERVICE_COUNTER:"Счётчик обслуживания",
      FAULT_CODE:"Код оповещения",
      PRESSURE_TITLE:"Давление воздуха",
      TIME_TITLE:"Текущее время",
      COUNTRY_TITLE:"Страна",
      CITY_TITLE:"Город",
      REGION_TITLE:"Регион",
      SELECT_POINTS_TO_SEARCH:"Выберите точки ...",
      LOGS_HISTORY:"История изменений параметров",
      ACTUATOR_REFERENCE:"Ссылка на исполнительный механизм",
      ACTUATOR_VALUE:"Значение исполнительного механизма",
      POINT_ID:"ID точки",
      VALIDATION_NOT_VALID_RANGE:"Недопустимый диапазон",
      ENABLE_ROLLOVER_RESET:"Отмечая этот флажок, вы подтверждаете, что прочитали и согласны с инструкциями по технике безопасности.",
      CHANGE_OF_PARAMETERS:"Изменение параметров",
      SELECT_OPTIONS:"Выберите параметры",
      AUTOMATIC:"Автоматический",
      DESALTING:"Функция удаления соли",
      SEASON_WASH:"Сезонные программы мойки",
      SPRING_PROGRAM:"Весенние программы мойки",
      SUMMER_PROGRAM:"Летние программы мойки",
      AUTUMN_PROGRAM:"Осенние программы мойки",
      WINTER_PROGRAM:"Зимние программы мойки",
      DOOR_CONTROL:"Управление воротами",
      SUMMER_DOOR_CONTROL:"Лето: управление воротами в летнем режиме",
      WINTER_DOOR_CONTROL:"Зима: управление воротами в зимнем режиме",
      APPLY_PARAMETERS_CHANGES:"Применить изменения параметров",
      WORKING_SCHEDULES:"Графики работы",
      HOLIDAY_SCHEDULES:"Расписания праздничных дней",
      SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Праздничные дни на объекте успешно созданы",
      SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Праздничные дни на объекте успешно обновлены",
      SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Праздничные дни на объекте успешно удалены",
      WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Рабочие расписания успешно применены",
      HOLIDAY_SUCCESSFULLY_DELETED:"Праздничный день успешно удалён",
      SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
      SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
      SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
      SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
      SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
      SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
      SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
      SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
      SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
      SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
      SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
      SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
      CB3_1_0_0:"CB3_1_0_0_Trans",
      CW35_3_0_0:"CW35_3_0_0_Trans",
      CW35_3_1_0:"CW35_3_1_0_Trans",
      CWB3_3_0_0:"CWB3_3_0_0_Trans",
      CWB3_3_1_0:"CWB3_3_1_0_Trans",
      CW1_3_0_0:"CW1_3_0_0_Trans",
      CW1_3_1_0:"CW1_3_1_0_Trans",
      CHEM_LEVEL_LOW_DRYING_AGENT:"Drying agent with low filling level",
      CHEM_LEVEL_LOW_SHAMPOO:"Shampoo with low filling level",
      CHEM_LEVEL_LOW_FOAM:"Foam with low filling level",
      CHEM_LEVEL_LOW_WAX_1:"Wax with low filling level",
      CHEM_LEVEL_LOW_POLISH_1:"Polish with low filling level",
      CHEM_LEVEL_LOW_RIM_CLEANER:"Rim cleaner with low filling level",
      CHEM_LEVEL_LOW_WAX_2:"Wax with low filling level",
      CHEM_LEVEL_LOW_TYRE_SHINE:"Tyre shine with low filling level",
      CHEM_LEVEL_LOW_INSECT_REMOVER:"Insect remover with low filling level",
      CHEM_LEVEL_LOW_POLISH_2:"Polish with low filling level",
      CHEM_LEVEL_LOW_INTENSIVE:"Intensive with low filling level",
      CHEM_LEVEL_LOW_FOAM_RAIN:"Foam rain with low filling level",
      CHEM_LEVEL_DRYING_AGENT:"Filling level drying agent",
      CHEM_LEVEL_SHAMPOO:"Filling level shampoo",
      CHEM_LEVEL_FOAM:"Filling level foam",
      CHEM_LEVEL_WAX_1:"Filling level wax",
      CHEM_LEVEL_POLISH_1:"Filling level polish",
      CHEM_LEVEL_RIM_CLEANER:"Filling level rim cleaner",
      CHEM_LEVEL_WAX_2:"Filling level wax",
      CHEM_LEVEL_TYRE_SHINE:"Filling level tyre shine",
      CHEM_LEVEL_INSECT_REMOVER:"Filling level insect remover",
      CHEM_LEVEL_POLISH_2:"Filling level polish",
      CHEM_LEVEL_INTENSIVE:"Filling level intensive ",
      CHEM_LEVEL_FOAM_RAIN:"Filling level foam rain",
      SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Service counter roof-brush lifting belt",
      SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Service counter dryer lifting belt",
      SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Service counter motor cable roof-brush",
      SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Service counter fresh water pump service",
      SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Service counter pump service used water",
      DRYING_AGENT:"Средство для сушки",
      FOAM_DRYING_AGENT:"Пенное средство для сушки",
      SHAMPOO:"Шампунь",
      FOAM:"Пена",
      BRUSH_FOAM:"Щеточная пена",
      WAX_1:"Воск",
      FOAM_WAX_1:"Пенный воск",
      POLISH_1:"Полировка",
      RIM_CLEANING:"Очиститель дисков",
      WAX_2:"Воск",
      FOAM_WAX_2:"Пенный воск",
      TYRE_SHINE:"Блеск шин",
      INSECT_REMOVER:"Удалитель насекомых",
      POLISH_2:"Полировка",
      INTENSIVE_BASIC:"Интенсивная базовая",
      INTENSIVE_SIDE:"Интенсивная базовая",
      INTENSIVE_ROOF_SPRAY_BAR:"Интенсивная верхняя мойка",
      TAR_REMOVER:"Удалитель смолы",
      UNDER_CHASSIS_CONVERSATION:"Консервация днища",
      STATIONARY_PRE_SPRAY_ARCH:"Стационарная арка предварительного распыления",
      FOAM_RAIN:"Пенный дождь",
      PRE_CLEANING:"Предварительная очистка",
      BRUSH:"Щётка",
      CARE:"Уход",
      DRYING:"Сушка",
      DRYING_LOW_NOISE:"Сушка (пониженный шум)",
      INTENSIVE_CLEANING:"Интенсивная очистка",
      BRUSH_CLEANING:"Мойка щёткой",
      EMPTY_RUN:"Холостой ход",
      DRYING_AID:"Средство для сушки",
      WAX:"Воск",
      FOAM_WASH:"Пенная мойка",
      POLISH:"Полировка",
      FOAM_POLISH:"Пенная полировка",
      WHEEL_CLEANING:"Очистка колёс",
      HIGH_PRESSURE_ROOF:"Верхняя мойка высоким давлением",
      HIGH_PRESSURE_SIDE:"Боковая мойка высоким давлением",
      DRYER_FORWARD:"Перемещение сушилки вперёд",
      DRYER_BACKWARD:"Перемещение сушилки назад",
      DELETE_ALL_HOLIDAYS:"Удалить все праздники для выбранного объекта",
      CREATE_NEW_HOLIDAY:"Создать новый",
      RESET_INPUTS:"Сбросить все поля праздников",
      TWENTY_FOUR_HOURS_OPEN:"Открыто 24 часа",
      EVERY_YEAR:"Ежегодно",
      DELETE_HOLIDAY:"Удалить праздник",
      ADD_NEW_HOLIDAY:"Добавить новый праздник",
      HOLIDAYS_LIST:"Список существующих праздников",
      DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Удалить все праздники для выбранного объекта?",
      VALIDATION_HOLIDAY_DATE:"Неверный формат. Используйте dd-mm",
      FOR_DATE:"Для даты",
      WITH_ID:"С идентификатором",
      FROM_HOURS:"С (ч)",
      FROM_MINUTES:"С (мин)",
      TO_HOURS:"До (ч)",
      TO_MINUTES:"До (мин)",
      NOT_MATCH:"Не совпадает",
      START:"Старт",
      STOP:"Стоп",
      DAILY_TIME:"24 hours list",
      INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individual time setting",
      PROGRAM_NOT_STARTED:"Program not started yet",
      JETWASH:"Self-service wash system",
      KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
      KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
      KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
      KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
      KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
      KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
      KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
      KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
      KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
      KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
      OPERATION_COUNTER_FRESH_WATER_PUMP:"Насос чистой воды",
      OPERATION_COUNTER_PROCESS_WATER_PUMP:"Насос оборотной воды",
      OPERATION_COUNTER_HP_PUMP_1:"Насос высокого давления 1",
      OPERATION_COUNTER_HP_PUMP_2:"Насос высокого давления 2",
      RELEASE_NOTES:"Версии приложения и примечания к выпуску",
      BACKEND_RELEASE_NOTES:"Примечания к выпуску платформы:",
      FRONTEND_RELEASE_NOTES:"Примечания к выпуску веб-приложения:",
      SELECTED_FACILITY_TIMEZONE:"Часовой пояс для выбранного объекта:",
      REFRESH_PAGE:"Обновить страницу",
      REFRESH_MAPS:"Refresh maps",
      PUMPS:"Pumps",
      RUN_TIME:"Run time",
      RUN_TIME1:"Run time 1",
      RUN_TIME2:"Run time 2",
      PROGRAM_RUNTIME_ACTUATOR:"Actuator for run time",
      PROGRAM_RUNTIME_ACTUATOR_1:"Actuator for run time 1",
      PROGRAM_RUNTIME_ACTUATOR_2:"Actuator for run time 2",
      PUMP_RUN_TIME_MIN_VALIDATION:"Min value is 1",
      PUMP_RUN_TIME_MAX_VALIDATION:"Max value is 255",
      WASH_PROGRAM_MIN_MAX_VALIDATION:"Use price format x.xx",
      ACTUATION_NOT_ALLOWED:" Actuation not allowed for current user role",
      MAINTENANCE_DAYS:"Maintenance days",
      MAINTENANCE_WASHES:"Maintenance washes",
      DAILY_FINANCES_POS:"POS",
      POS_INCOME:"Общий доход POS",
      PROPAGATE:"Распространить",
      ALL_DAY_HOURS_SELECTOR:"Переключатель режима «24 часа»",
      GET_OPERATING_TIME_FROM_SITE:"Получить время работы текущего устройства из графиков работы объекта",
      USER_NOT_VALID:"Пользователь недействителен. Попробуйте другие учетные данные.",
      VERIFIED:"Подтверждён",
      RESEND_VERIFICATION_MAIL:"Отправить письмо с подтверждением повторно",
      RETURN_TO_DASHBOARD:"Вернуться к панели управления",
      ERROR_PAGE_BAD_REQUEST:"400 Неверный запрос.",
      WASHES:"Количество моек",
      TIME_TO_SERVICE:"Время до обслуживания",
      ACCOUNT_ALREADY_ACTIVATED:"Учетная запись уже активирована",
      DEVICE_EVENTS:"События устройства",
      DEVICE_EVENTS_LOG_PULLED:"Получен журнал событий для устройства",
      EVENTS_PULL_DATE:"Время получения событий:",
      DEVICE_EVENTS_REFRESH:"Получить новые данные о событиях",
      WEB_SOCKETS_CONNECTION_PROBLEM:"Проблема с WebSocket-соединением. Попробуйте обновить страницу.",
      INSTALLATION_DATE:"Дата установки машины",
      KARCHER_CUSTOM_PROGRAM_NAME_1:"Hot wax",
      KARCHER_CUSTOM_PROGRAM_NAME_2:"High pressure washing",
      KARCHER_CUSTOM_PROGRAM_NAME_3:"Power rim foam",
      KARCHER_CUSTOM_PROGRAM_NAME_4:"Power foam",
      KARCHER_CUSTOM_PROGRAM_NAME_5:"Stop",
      KARCHER_CUSTOM_PROGRAM_NAME_6:"Foam wash HD",
      KARCHER_CUSTOM_PROGRAM_NAME_7:"Wash",
      KARCHER_CUSTOM_PROGRAM_NAME_8:"Top care",
      INFO_TITLE:"Info",
      FOAM_WAX1:"Foam wax",
      POLISH1:"Polish",
      WAX1:"Wax",
      SITE_DETAILS_SUCCESSFULLY_UPDATED:"Сведения об объекте успешно обновлены",
      COMPANY:"Компания",
      FACILITY_HAS_CHANGER:"Есть разменный автомат?",
      DISABLE_OFFLINE_ALARM:"Отключить тревоги R2W",
      ASIDE_WORKING_SCHEDULES:"Сведения об объекте в приложении",
      TERMS_OF_SERVICE_R2W_TITLE:"Условия использования Ready2Wash",
      TERMS_OF_SERVICE_R2W:"Условия использования Ready2Wash",
      DATA_PROCESSING_TITLE:"Обрабатываемые данные",
      PRIVACY_POLICY_TITLE:"Политика конфиденциальности",
      READY_TO_PAY_TERMS_OF_SERVICE:"Условия использования Ready2Pay",
      TERMS_AND_SERVICES:"Условия и услуги",
      HOURLY:"Ежечасно",
      DAILY:"Ежедневно",
      WEEKLY:"Еженедельно",
      MONTHLY:"Ежемесячно",
      YEARLY:"Ежегодно",
      DELETE_ITEM_SUCCESS:"Элемент успешно удалён",
      STATE:"Штат",
      AVAILABILITY_STATUS_1:"Unit open",
      AVAILABILITY_STATUS_2:"Unit closed (holiday)",
      AVAILABILITY_STATUS_3:"Unit closed (operating time)",
      AVAILABILITY_STATUS_4:"Unit closed (fault)",
      AVAILABILITY_STATUS_5:"Unit closed (other)",
      AVAILABILITY_VACUUMS_STATUS_1:"Vacuums not installed",
      AVAILABILITY_VACUUMS_STATUS_2:"Vacuums open",
      AVAILABILITY_VACUUMS_STATUS_3:"Vacuums closed (holiday)",
      AVAILABILITY_VACUUMS_STATUS_4:"Vacuums closed (operating time)",
      AVAILABILITY_VACUUMS_STATUS_5:"Vacuums closed (fault)",
      AVAILABILITY_VACUUMS_STATUS_6:"Vacuums closed (other)",
      ECOM_AMOUNT:"Итого ECOM по всем объектам",
      CAPTURED:"Захвачено",
      VALUE_DATE:"Дата валютирования",
      VALIDATION_HOLIDAY_YEAR:"Format not correct. Use yyyy",
      KARCHER_EVENT_NAME_1:"Base exchanger regenerated",
      KARCHER_EVENT_NAME_2:"Base exchanger regeneration ended",
      KARCHER_EVENT_NAME_3:"Material / serial number",
      KARCHER_EVENT_NAME_4:"The system has been disinfected",
      KARCHER_EVENT_NAME_5:"HP pump 1 has been disinfected",
      KARCHER_EVENT_NAME_6:"HP pump 2 has been disinfected",
      KARCHER_EVENT_NAME_7:"HP pump 3 has been disinfected",
      KARCHER_EVENT_NAME_8:"HP pump 4 has been disinfected",
      KARCHER_EVENT_NAME_9:"HP pump 5 has been disinfected",
      KARCHER_EVENT_NAME_10:"Washing station 1 locked",
      KARCHER_EVENT_NAME_11:"Washing station 2 locked",
      KARCHER_EVENT_NAME_12:"Washing station 3 locked",
      KARCHER_EVENT_NAME_13:"Washing station 4 locked",
      KARCHER_EVENT_NAME_14:"Washing station 5 locked",
      KARCHER_EVENT_NAME_15:"Washing station 6 locked",
      KARCHER_EVENT_NAME_16:"Washing station 7 locked",
      KARCHER_EVENT_NAME_17:"Washing station 8 locked",
      KARCHER_EVENT_NAME_18:"Update started",
      KARCHER_EVENT_NAME_19:"Update finished",
      KARCHER_EVENT_NAME_20:"Start WS Reg",
      KARCHER_EVENT_NAME_21:"End WS Reg",
      KARCHER_EVENT_NAME_22:"WS 75% sensor",
      KARCHER_EVENT_NAME_23:"Tech. defect",
      KARCHER_EVENT_NAME_24:"Oper. defect",
      KARCHER_EVENT_NAME_25:"Unit on",
      KARCHER_EVENT_NAME_26:"Unit closed",
      KARCHER_EVENT_NAME_27:"Box 1 closed",
      KARCHER_EVENT_NAME_28:"Box 2 closed",
      KARCHER_EVENT_NAME_29:"Box 3 closed",
      KARCHER_EVENT_NAME_30:"Box 4 closed",
      KARCHER_EVENT_NAME_31:"Box 5 closed",
      KARCHER_EVENT_NAME_32:"Box 6 closed",
      KARCHER_EVENT_NAME_33:"Box 7 closed",
      KARCHER_EVENT_NAME_34:"Box 8 closed",
      KARCHER_EVENT_NAME_35:"HP pump bay 1",
      KARCHER_EVENT_NAME_36:"HP pump bay 2",
      KARCHER_EVENT_NAME_37:"HP pump bay 3",
      KARCHER_EVENT_NAME_38:"HP pump bay 4",
      KARCHER_EVENT_NAME_39:"HP pump bay 5",
      KARCHER_EVENT_NAME_40:"HP pump bay 6",
      KARCHER_EVENT_NAME_41:"HP pump bay 7",
      KARCHER_EVENT_NAME_42:"HP pump bay 8",
      KARCHER_EVENT_NAME_43:"Burner",
      KARCHER_EVENT_NAME_44:"Burner fan",
      KARCHER_EVENT_NAME_45:"Warm water pump",
      KARCHER_EVENT_NAME_46:"Freeze prot.pump",
      KARCHER_EVENT_NAME_47:"Osmosis pump",
      KARCHER_EVENT_NAME_48:"Floor heating",
      KARCHER_EVENT_NAME_49:"Hose heating",
      KARCHER_EVENT_NAME_50:"Microe/rim clean",
      KARCHER_EVENT_NAME_51:"Underc. pump",
      KARCHER_EVENT_NAME_52:"Booster pumpFoam",
      KARCHER_EVENT_NAME_53:"Vacuum clean. 1",
      KARCHER_EVENT_NAME_54:"Vacuum clean. 2",
      KARCHER_EVENT_NAME_55:"Vacuum clean. 3",
      KARCHER_EVENT_NAME_56:"Vacuum clean. 4",
      KARCHER_EVENT_NAME_57:"Vacuum clean. 5",
      KARCHER_EVENT_NAME_58:"Vacuum clean. 6",
      KARCHER_EVENT_NAME_59:"Vacuum clean. 7",
      KARCHER_EVENT_NAME_60:"Vacuum clean. 8",
      KARCHER_EVENT_NAME_61:"Vacuum clean. 9",
      KARCHER_EVENT_NAME_62:"Vacuum clean. 10",
      KARCHER_EVENT_NAME_63:"Vacuum clean. 11",
      KARCHER_EVENT_NAME_64:"Vacuum clean. 12",
      KARCHER_EVENT_NAME_65:"Pump rim clean",
      KARCHER_EVENT_NAME_66:"Pump Microe.",
      KARCHER_EVENT_NAME_67:"Pump Intensive",
      KARCHER_EVENT_NAME_68:"Vacuum1 turbine",
      KARCHER_EVENT_NAME_69:"Vacuum1 filter",
      KARCHER_EVENT_NAME_70:"Vacuum2 turbine",
      KARCHER_EVENT_NAME_71:"Vacuum2 filter",
      KARCHER_EVENT_NAME_72:"Vacuum3 turbine",
      KARCHER_EVENT_NAME_73:"Vacuum3 filter",
      KARCHER_EVENT_NAME_74:"Vacuum4 turbine",
      KARCHER_EVENT_NAME_75:"Vacuum4 filter",
      KARCHER_EVENT_NAME_76:"Vacuum5 turbine",
      KARCHER_EVENT_NAME_77:"Vacuum5 filter",
      KARCHER_EVENT_NAME_78:"Vacuum6 turbine",
      KARCHER_EVENT_NAME_79:"Vacuum6 filter",
      KARCHER_EVENT_NAME_80:"Vacuum7 turbine",
      KARCHER_EVENT_NAME_81:"Vacuum7 filter",
      KARCHER_EVENT_NAME_82:"Vacuum8 turbine",
      KARCHER_EVENT_NAME_83:"Vacuum8 filter",
      KARCHER_EVENT_NAME_84:"Vacuum9 turbine",
      KARCHER_EVENT_NAME_85:"Vacuum9 filter",
      KARCHER_EVENT_NAME_86:"Vacuum10 turbine",
      KARCHER_EVENT_NAME_87:"Vacuum10 filter",
      KARCHER_EVENT_NAME_88:"Vacuum11 turbine",
      KARCHER_EVENT_NAME_89:"Vacuum11 filter",
      KARCHER_EVENT_NAME_90:"Vacuum12 turbine",
      KARCHER_EVENT_NAME_91:"Vacuum12 filter",
      INSERT_TOKEN:"Вставьте токены и запустите услугу",
      OPEN_SESSION:"Сеанс успешно открыт",
      IN_PROGRESS:"Выполняется ...",
      TOKEN_INSERTED:"Токены успешно вставлены",
      EXPIRED_SESSION:"Срок действия сеанса истёк",
      TWO_DIGIT_INTEGER_VALIDATION:"Use max two digit integer",
      KARCHER_OPERATION_COUNTER_1:"Washing station 1 HP pump",
      KARCHER_OPERATION_COUNTER_2:"Washing station 1 chemical pump 1",
      KARCHER_OPERATION_COUNTER_3:"Washing station 1 chemical pump 2",
      KARCHER_OPERATION_COUNTER_4:"Washing station 1 chemical pump 3",
      KARCHER_OPERATION_COUNTER_5:"Washing station 1 chemical pump 4",
      KARCHER_OPERATION_COUNTER_6:"Washing station 2 HP pump",
      KARCHER_OPERATION_COUNTER_7:"Washing station 2 chemical pump 1",
      KARCHER_OPERATION_COUNTER_8:"Washing station 2 chemical pump 2",
      KARCHER_OPERATION_COUNTER_9:"Washing station 2 chemical pump 3",
      KARCHER_OPERATION_COUNTER_10:"Washing station 2 chemical pump 4",
      KARCHER_OPERATION_COUNTER_11:"Washing station 3 HP pump",
      KARCHER_OPERATION_COUNTER_12:"Washing station 3 chemical pump 1",
      KARCHER_OPERATION_COUNTER_13:"Washing station 3 chemical pump 2",
      KARCHER_OPERATION_COUNTER_14:"Washing station 3 chemical pump 3",
      KARCHER_OPERATION_COUNTER_15:"Washing station 3 chemical pump 4",
      KARCHER_OPERATION_COUNTER_16:"Washing station 4 HP pump",
      KARCHER_OPERATION_COUNTER_17:"Washing station 4 chemical pump 1",
      KARCHER_OPERATION_COUNTER_18:"Washing station 4 chemical pump 2",
      KARCHER_OPERATION_COUNTER_19:"Washing station 4 chemical pump 3",
      KARCHER_OPERATION_COUNTER_20:"Washing station 4 chemical pump 4",
      KARCHER_OPERATION_COUNTER_21:"Washing station 5 HP pump",
      KARCHER_OPERATION_COUNTER_22:"Washing station 5 chemical pump 1",
      KARCHER_OPERATION_COUNTER_23:"Washing station 5 chemical pump 2",
      KARCHER_OPERATION_COUNTER_24:"Washing station 5 chemical pump 3",
      KARCHER_OPERATION_COUNTER_25:"Washing station 5 chemical pump 4",
      KARCHER_OPERATION_COUNTER_26:"Washing station 6 HP pump",
      KARCHER_OPERATION_COUNTER_27:"Washing station 6 chemical pump 1",
      KARCHER_OPERATION_COUNTER_28:"Washing station 6 chemical pump 2",
      KARCHER_OPERATION_COUNTER_29:"Washing station 6 chemical pump 3",
      KARCHER_OPERATION_COUNTER_30:"Washing station 6 chemical pump 4",
      KARCHER_OPERATION_COUNTER_31:"Washing station 7 HP pump",
      KARCHER_OPERATION_COUNTER_32:"Washing station 7 chemical pump 1",
      KARCHER_OPERATION_COUNTER_33:"Washing station 7 chemical pump 2",
      KARCHER_OPERATION_COUNTER_34:"Washing station 7 chemical pump 3",
      KARCHER_OPERATION_COUNTER_35:"Washing station 7 chemical pump 4",
      KARCHER_OPERATION_COUNTER_36:"Washing station 8 HP pump",
      KARCHER_OPERATION_COUNTER_37:"Washing station 8 chemical pump 1",
      KARCHER_OPERATION_COUNTER_38:"Washing station 8 chemical pump 2",
      KARCHER_OPERATION_COUNTER_39:"Washing station 8 chemical pump 3",
      KARCHER_OPERATION_COUNTER_40:"Washing station 8 chemical pump 4",
      KARCHER_OPERATION_COUNTER_41:"Osmosis pump",
      KARCHER_OPERATION_COUNTER_42:"Hot water generator",
      KARCHER_OPERATION_COUNTER_43:"Frost protection pump",
      KARCHER_OPERATION_COUNTER_44:"WSO filter inlay",
      KARCHER_OPERATION_COUNTER_45:"Washing station heater pump",
      KARCHER_OPERATION_COUNTER_46:"Hot water pump",
      KARCHER_OPERATION_COUNTER_47:"Foam hose heating",
      KARCHER_OPERATION_COUNTER_48:"Wheel cleaning pump",
      KARCHER_OPERATION_COUNTER_49:"Micro-emulsion pump",
      KARCHER_OPERATION_COUNTER_50:"Intensive foam pump",
      KARCHER_OPERATION_COUNTER_51:"Vacuum cleaner 1 turbine 1",
      KARCHER_OPERATION_COUNTER_52:"Vacuum cleaner 1 filter 1",
      KARCHER_OPERATION_COUNTER_53:"Vacuum cleaner 1 turbine 2",
      KARCHER_OPERATION_COUNTER_54:"Vacuum cleaner 1 filter 2",
      KARCHER_OPERATION_COUNTER_55:"Vacuum cleaner 2 turbine 1",
      KARCHER_OPERATION_COUNTER_56:"Vacuum cleaner 2 filter 1",
      KARCHER_OPERATION_COUNTER_57:"Vacuum cleaner 2 turbine 2",
      KARCHER_OPERATION_COUNTER_58:"Vacuum cleaner 2 filter 2",
      KARCHER_OPERATION_COUNTER_59:"Vacuum cleaner 3 turbine 1",
      KARCHER_OPERATION_COUNTER_60:"Vacuum cleaner 3 filter 1",
      KARCHER_OPERATION_COUNTER_61:"Vacuum cleaner 3 turbine 2",
      KARCHER_OPERATION_COUNTER_62:"Vacuum cleaner 3 filter 2",
      KARCHER_OPERATION_COUNTER_63:"Vacuum cleaner 4 turbine 1",
      KARCHER_OPERATION_COUNTER_64:"Vacuum cleaner 4 filter 1",
      KARCHER_OPERATION_COUNTER_65:"Vacuum cleaner 4 turbine 2",
      KARCHER_OPERATION_COUNTER_66:"Vacuum cleaner 4 filter 2",
      KARCHER_OPERATION_COUNTER_67:"Vacuum cleaner 5 turbine 1",
      KARCHER_OPERATION_COUNTER_68:"Vacuum cleaner 5 filter 1",
      KARCHER_OPERATION_COUNTER_69:"Vacuum cleaner 5 turbine 2",
      KARCHER_OPERATION_COUNTER_70:"Vacuum cleaner 5 filter 2",
      KARCHER_OPERATION_COUNTER_71:"Vacuum cleaner 6 turbine 1",
      KARCHER_OPERATION_COUNTER_72:"Vacuum cleaner 6 filter 1",
      KARCHER_OPERATION_COUNTER_73:"Vacuum cleaner 6 turbine 2",
      KARCHER_OPERATION_COUNTER_74:"Vacuum cleaner 6 filter 2",
      KARCHER_OPERATION_COUNTER_75:"Drain condensation water from the compressor",
      KARCHER_OPERATION_COUNTER_76:"Check frost protection system",
      KARCHER_OPERATION_COUNTER_77:"Burner fan",
      KARCHER_OPERATION_COUNTER_78:"Booster pump foam",
      DOWNLOAD_CSV_LARGE_DATA_WARNING:"Список данных содержит более 10000 элементов.",
      KARCHER_POINT_NAME_1:"Holiday",
      KARCHER_POINT_NAME_2:"Monday",
      KARCHER_POINT_NAME_3:"Tuesday",
      KARCHER_POINT_NAME_4:"Wednesday",
      KARCHER_POINT_NAME_5:"Thursday",
      KARCHER_POINT_NAME_6:"Friday",
      KARCHER_POINT_NAME_7:"Saturday",
      KARCHER_POINT_NAME_8:"Sunday",
      KARCHER_POINT_NAME_9:"Vacuums Holiday",
      KARCHER_POINT_NAME_10:"Vacuums Monday",
      KARCHER_POINT_NAME_11:"Vacuums Tuesday",
      KARCHER_POINT_NAME_12:"Vacuums Wednesday",
      KARCHER_POINT_NAME_13:"Vacuums Thursday",
      KARCHER_POINT_NAME_14:"Vacuums Friday",
      KARCHER_POINT_NAME_15:"Vacuums Saturday",
      KARCHER_POINT_NAME_16:"Vacuums Sunday",
      KARCHER_POINT_NAME_17:"Illumination Holiday",
      KARCHER_POINT_NAME_18:"Illumination Monday",
      KARCHER_POINT_NAME_19:"Illumination Tuesday",
      KARCHER_POINT_NAME_20:"Illumination Wednesday",
      KARCHER_POINT_NAME_21:"Illumination Thursday",
      KARCHER_POINT_NAME_22:"Illumination Friday",
      KARCHER_POINT_NAME_23:"Illumination Saturday",
      KARCHER_POINT_NAME_24:"Illumination Sunday",
      KARCHER_POINT_NAME_25:"Program 0",
      KARCHER_POINT_NAME_26:"Program 1",
      KARCHER_POINT_NAME_27:"Program 2",
      KARCHER_POINT_NAME_28:"Program 3",
      KARCHER_POINT_NAME_29:"Program 4",
      KARCHER_POINT_NAME_30:"Program 5",
      KARCHER_POINT_NAME_31:"Program 6",
      KARCHER_POINT_NAME_32:"Program 7",
      KARCHER_POINT_NAME_33:"Program 8",
      KARCHER_POINT_NAME_34:"Program 9",
      KARCHER_POINT_NAME_35:"Program 10",
      KARCHER_POINT_NAME_36:"Program 11",
      KARCHER_POINT_NAME_37:"Program 12",
      KARCHER_POINT_NAME_38:"Program 13",
      KARCHER_POINT_NAME_39:"Program 14",
      KARCHER_POINT_NAME_40:"Program 15",
      KARCHER_POINT_NAME_41:"Program 16",
      KARCHER_POINT_NAME_42:"Program 17",
      KARCHER_POINT_NAME_43:"Program 18",
      KARCHER_POINT_NAME_44:"Program 19",
      KARCHER_POINT_NAME_45:"Program 20",
      KARCHER_POINT_NAME_46:"Program 21",
      KARCHER_POINT_NAME_47:"Program 22",
      KARCHER_POINT_NAME_48:"Program 23",
      KARCHER_POINT_NAME_49:"Program 24",
      KARCHER_POINT_NAME_50:"Program 25",
      KARCHER_POINT_NAME_51:"Program 26",
      KARCHER_POINT_NAME_52:"Program 27",
      KARCHER_POINT_NAME_53:"Program 28",
      KARCHER_POINT_NAME_54:"Program 29",
      KARCHER_POINT_NAME_55:"Program 30",
      KARCHER_POINT_NAME_56: "Program 31",
      KARCHER_POINT_NAME_57: "Program 32",
      QR_CODE: "QR-код",
      ACCEPT_TERMS_AND_CONDITIONS: "Принять условия использования",
      CREATE_AND_PRINT_VOUCHERS: "Создать и напечатать ваучеры",
      CODE_PREFIX_QUESTION: "Префикс кода не введен",
      CODE_PREFIX_QUESTION_TEXT: "Хотите продолжить без префикса кода?",
    ISSUED_DATE: "Дата выдачи",
    VOUCHER_VALIDITY_DAYS: "Срок действия купона (дни)",
    VALIDATION_ONLY_NUMBERS: "Разрешены только цифры",
    REPRINT_VOUCHERS: "Напечатать копию купонов",
    EXPIRY_DATE: "Действителен до"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("roTranslations", {
    MESSAGE:"Mesaj",
    ERROR_TITLE:"Eroare",
    ERROR_MESSAGE:"A apărut o eroare in executarea operaţiunii.",
    ERROR_LOGIN:"A apărut o eroare in procesul de autentificare. Adresa de E-mail nu este validă",
    ERROR_LOGIN_ROLE:"Aceasta functie nu este valabila pentru aceasta aplicatie",
    OK:"OK",
    CANCEL:"Anulează",
    YES:"Da",
    NO:"Nu",
    FROM:"De la",
    TO:"Pana la",
    DELETE:"Șterge",
    SIGN_OUT:"Deconectare",
    NAME:"Nume",
    DATE:"Data",
    PIECES:"părți",
    HOURS:"Ore",
    DAYS:"Zile",
    MONTH:"Lună",
    MONTHS:"Luni",
    YEAR:"An",
    BOX:"Spaţiu / Boxă de spălare",
    SEARCH:"Caută",
    ALL_USERS:"Toți utilizatorii",
    ARE_YOU_SURE:"Ești sigur",
    BACK:"Inapoi",
    AMOUNT:"Cantitate/Număr",
    DESCRIPTION:"Descriere",
    FORGOT_PASSWORD_ERROR_MSG:"Ceva nu a mers bine. Te rugăm să verfici adresa de e-mail și să incerci din nou",
    REQUIRED_FIELD:"Câmpul este obligatoriu",
    LOGOUT_TITLE:"Sigur dorești să te deconectezi?",
    LOGOUT_MSG:"Toate datele tale nesalvate vor fi pierdute",
    ACTIVATION_ACCOUNT:"Ai activat contul tău cu succes",
    UNKNOWN_ERRROR_NOTIFICATION:"S-a produs o eroare necunoscută",
    CONTINUE:"Continuă",
    DATA_NOT_AVAILABLE:"Datele nu sunt disponibile",
    SELECT:"Selecteaza",
    SELECT_CURRENCY:"Selecteaza moneda",
    UPLOAD:"Încarca",
    PHONE:"Telefon",
    WEBSITE:"Website",
    WORKING_HOURS:"Orele de lucru",
    INSERT:"Insereaza",
    TEXT:"Text",
    CREATED:"Creat",
    VALID_UNTIL:"Valabil pănă la",
    SAVE:"Salvază",
    TOKENS:"Jetoane",
    DELETE_COMPANY_HISTORY:"Ștergeți istoricul companiei?",
    DELETE_COMPANY_HISTORY_MESSAGE:"ATENȚIE: După apăsarea acestui buton, toate tranzacțiile spălătoriei auto vor fi șterse permanent! Aceste date nu pot fi restaurate după ștergere.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Sunteți sigur că doriți să ștergeți permanent toate datele de tranzacție?",
    HISTORY_SUCCESSFULY_DELETED:"Istoricul a fost șters cu succes.",
    HELP:"Ajutor",
    VALUE:"Valoare",
    ACTIVATING_ACCOUNT_ERROR:"A apărut o problemă la activarea contului dvs. R2W.Te rugăm să încerci din nou, dacă problema persistă, contactează asistența noastră la support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Bine ați venit la Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Bun venit la R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Introdu noua parolă și confirmă pentru a activa contul R2W. Vei fi conectat automat la aplicație după aceea.",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Poti modifica mai tarziu in aplicatie setarile utilizatorului",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:"R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Te rog introdu noua parola si confirma pentru a reseta vechea parola. Vei fi automat inregistrat in aplicatie.",
    RESET_PASSWORD_WELCOME_MSG_3:"Poti modifica mai tarziu in aplicatie setarile utilizatorului",
    ENTER_NEW_PASSWORD:"Introdu noua parolă",
    REPEAT_NEW_PASSWORD:"Repetă noua parolă",
    PASSWORD_MIN_LENGTH:"Parola trebuie să aibă cel puțin 8 caractere",
    PASSWORD_MAX_LENGHT:"Parola trebuie să aibă o lungime mai mică de 32 de caractere",
    PASSWORD_PATTERN:"Parola trebuie să conțină cel puțin o literă mare și o literă mică",
    PASSWORD_MATCH:"Parolele nu se potrivesc",
    ACTIVATE:"Activează",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Ai trimis cu succes cererea. Te rog verifică-ți email-ul pentru mesajul de confirmare.",
    VALIDATION_REQUIRED:"Cămp obligatoriu",
    VALIDATION_EMAIL:"Adresa de e-mail nu este validă",
    VALIDATION_INTEGER_NUMBER:"Te rugăm introdu intreaga valoare",
    VALIDATION_HOURS_VALUE:"Valoarea trebuie să fie intre 0-23",
    VALIDATION_MINUTES_VALUE:"Valoarea trebuie să fie intre 0-59",
    VALIDATION_NOT_A_DATE:"Valoarea nu este o dată",
    VALIDATION_FROM:"De la data mai mare până la",
    VALIDATION_TO:"Până în prezent de la",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Această înregistrare există deja în baza de date",
    PASSWORD_VALIDATION_PATTERN_NEW:"Trebuie să existe cel puțin o cifră și o majusculă. Spațiile goale nu sunt permise",
    VALIDATION_PERCENT_VALUE:"Valoarea trebuie să fie între 1 și 999.",
    NUMBERS_ONLY_100:"Numărând până la 100.",
    NUMBERS_ONLY_1000:"Numărând până la 1000.",
    POSITIVE_NUMBERS_ONLY:"Doar numerele de numărare.",
    GRID_PAGER_PAGE:"Pagină",
    GRID_PAGER_ROWS_PER_PAGE:"Randuri per pagină",
    GRID_PAGER_PAGE_OF:"din",
    BREAD_CRUMBS_HOME:"Acasă",
    BREAD_CRUMBS_DASHBOARD_TECH:"Tehnica panoului de bord",
    BREAD_CRUMBS_DETAILS:"Detalii",
    BREAD_CRUMBS_SETTINGS:"Setări",
    BREAD_CRUMBS_WORKING_HOURS:"Orele de lucru",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Raport al totalului banilor pe zile",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Raport al mediei banilor pe ore",
    BREAD_CRUMBS_NEW_USER_GROUP:"Creează grup de utilizatori",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Editează grupul de utilizatori",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Creează șablon de promoție",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Editează șablonul de promoție",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Creează promoție",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Editează promoție",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Sumar periodic",
    LOGIN:"Logare",
    EMAIL:"E-mail",
    PASSWORD:"Parolă",
    LANGUAGE:"Limbă",
    FORGOT_PASSWORD:"Ai uitat parola?",
    SUBMIT:"Execută",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Număr de alarme in așteptare",
    HEADER_VIEW_ALL_ALARMS:"Vezi toate alarmele",
    HEADER_MY_ACCOUNT:"Contul meu",
    HEADER_ACCOUNT_MANAGEMENT:"Administrare cont",
    ACCOUNT_ALREADY_EXIST:"Adresa de E-mail este deja folosită",
    NEWSLETTER_CONFIRMATION:"Trimiteți notificare prin email pentru starea alarmelor",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Prezentarea generală a finanțelor zilnice",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Tehnologia panoului de bord",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Tablou de bord",
    ASIDE_MENU_ALARMS:"Mesaje",
    ASIDE_MENU_FACILITIES:"Facilități",
    ASIDE_MENU_REPORTS:"Rapoarte",
    ASIDE_MENU_REPORT:"Selecteaza raportul",
    ASIDE_MENU_LOYALTY:"Loialitate",
    ASIDE_MENU_USER_GROUPS:"Grupuri de utilizatori",
    ASIDE_MENU_PERIODIC_SUMMARY:"Prezentarea generală periodcă",
    ASIDE_MENU_MANAGING_TOKENS:"Administreaza jetoanele",
    ASIDE_MENU_NEWS:"Noutăți",
    DAILY_FINANCES_TOTAL_MONEY:"Total bani",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Total bani pentru toate facilitățile",
    DAILY_FINANCES_TOTAL_COINS:"Total jetoane metalice utilizate",
    DAILY_FINANCES_DOWNLOAD_CSV:"Descarcă CSV",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Numerar",
    DAILY_FINANCES_CHANGER:"Numerar în schimbător",
    DAILY_FINANCES_COINS:"Jetoane/Eurokey",
    REPORTS_FILTER:"Filtru",
    REPORTS_TYPE_OF_REPORT:"Tip de raport",
    REPORTS_CHOOSE_FACILITY:"Alege unitatea",
    REPORTS_PERIOD_1:"Perioada 1 -",
    REPORTS_PERIOD_2:"Perioada 2 -",
    MONEY_BY_DATE_REPORT:"Total bani până în data de",
    R2W_BY_DATE_REPORT:"Total plăți online până în data de",
    COINS_BY_DATE_REPORT:"Total plăți jetoane până în data de",
    AVG_MONEY_BY_HOUR_REPORT:"Medie a încasărilor pe oră",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Medie a încasărilor pe ziuă a săptămânii",
    AVG_MONEY_BY_BOX_REPORT:"Medie a încasărilot per boxă de spălare",
    COMPARE_PERIODS_REPORT:"Raport comparativ între unități",
    TOTAL_USERS_BY_GROUP:"Total utilizatori din grupuri",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"utilizatori",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"Vizite",
    VISITS_COUNT_REPORT:"Număr de utilizatori per vizită",
    LOYALTY_PER_DAY_REPORT:"Credit de fidelitate dat pe zi",
    LOYALTY_PER_PAYMENT_METHOD:"Loialitatea oferită in funcție de metoda de plată",
    VISITS:"Vizite",
    VISIT:"Vizită",
    TOTAL_SPENT_MONEY:"Bani cheltuiți in total",
    MONEY:"Bani",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Bani cheltuiți in total pentru perioada",
    DOWNLOAD_CSV:"Descarcă CSV",
    TOTAL_SPENT_COINS:"Total jetoane utilizate",
    TOTAL_USERS:"Total utilizatori",
    TOTAL_CREDIT_GIVEN:"Total credite acordate",
    EUROKEY_BY_DATE_REPORT:"Total plăți Eurokey pe date",
    TOTAL_SPENT_EUROKEY:"Total cheltuit",
    SELECT_TYPE_OF_REPORT:"Trebuie să selectați tipul de raport",
    NUMBER_OF_VISITS_TITLE:"Numărul de vizite",
    NUMBER_OF_USERS_TITLE:"Numărul de utilizatori",
    PIECES_TITLE:"Bucăți",
    TOTAL_VISITS:"Total vizite",
    TOKENS_TITLE:"Tokenuri",
    SEARCH_USERS_NO_RESULTS:"Nu au fost găsiți utilizatori pentru termenul de căutare dat",
    SEARCH_USERS:"Căută utilizatori",
    SEARCH_TELEPHONES:"Căută utilizatori după numărul de mobil",
    ADD_USER_TO_GROUP:"Adaugă utilizatorul la grup",
    REMOVE_USER_FROM_GROUP:"Elimină utilizatorul din grup",
    USER_GROUP_NAME_REQUIRED:"Numele grupului de utilizatori este necesar",
    USER_GROUP_NAME:"Numele grupului de utilizatori",
    USER_GROUPS_OVERVIEW:"Vizualizarea grupurilor de utilizatori",
    USER_COUNT:"Numărul utilizatorilor",
    NEW_USER_GROUP:"Creeaza un nou grup de utilizatori",
    DELETE_USER_GROUP:"Șterge grupul de utilizatori",
    UPDATE_USER_GROUP:"Editează grupul de utilizatori",
    DELETE_USER_GROUP_ERROR:"A apărut o eroare la ștergerea grupului de utilizatori selectat. Înceră din nou sau contactează asistența ...",
    CONFIRM_DELETE_USER_GROUP:"Sigur doreşti să ștergi grupul de utilizatori selectat?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Acțiunile de loialitate care au fost acordate grupului eliminat nu vor mai fi aplicate.",
    GROUP_NAME_MAX_LENGTH:"Numele grupului trebuie să aibă o lungime mai mică de 255 de caractere",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Utilizatorul este deja în acel grup",
    MISSING_USER:"Utilizator lipsă",
    USER_NOT_ON_LIST:"Utilizatorul nu se află în lista utilizatorilor activi. Verificați dacă adresa de email este validă și încercați din nou.",
    UPLOAD_USER_GROUP:"Încărcați lista de grupuri de utilizatori din fișierul *.csv",
    UKNOWN_USERS:"Listă de utilizatori necunoscuți",
    CAMPAIGN_TEMPLATE_RULE:"Regula de șablon",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"A apărut o eroare în timp ce încercai să ștergi șablonul de campanie. Încercă din nou sau contactați asistența ...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Sigur dorești să ștergi șablonul de campanie selectat",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Prezentare generală a șabloanelor de campanie",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Șterge șablonul de campanie",
    DELETE_CAMPAIGN_TEMPLATE:"Editează șablonul de campanie",
    UPDATE_CAMPAIGN_TEMPLATE:"Creează un nou șablon de campanie",
    CREATE_CAMPAIGN_TEMPLATE:"Este cerut numele șablonului de campanie",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Numele șablonului campaniei",
    CAMPAIGN_TEMPLATE_NAME:"Câmp necesar",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Oferă",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"dați %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"timp suplimentar",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Vă rugăm să selectați tipul întâi. Casete de spălat sau Mașini mici.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Șterge regula șablonului",
    CAMPAIGN_TEMPLATE_RULE_FROM:"De la",
    CAMPAIGN_TEMPLATE_RULE_TO:"pana la",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"ore",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minute",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Noua regulă în funcție de numărul de vizite",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Noua regulă în funcție de banii cheltuiți",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Noua regulă în funcție de zilele săptămânii",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Adăugă o regulă nouă pentru șablon",
    CAMPAIGN_TEMPLATE_RULE_1:"Fiecare",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Fiecare",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"credite cheltuite în mai puțin de",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"vizite in mai puțin de",
    CAMPAIGN_TEMPLATE_RULE_3:"zile",
    CAMPAIGN_TEMPLATE_RULE_4:"credite",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Lista de reguli este goală",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Data nu poate fi din trecut",
    DELETE_CAMPAIGN_ERROR:"A apărut o eroare în timp ce încercai să ștergi campania. Încercă din nou sau contactează asistența ...",
    CONFIRM_DELETE_CAMPAIGN:"Sigur dorești să ștergi campania selectată?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W nu este responsabil pentru experiența utilizatorului cauzată de această acțiune.",
    CAMPAIGNS_OVERVIEW:"Afișarea campaniilor",
    DELETE_CAMPAIGN:"Șterge campanie",
    UPDATE_CAMPAIGN:"Editează campanie",
    CREATE_CAMPAIGN:"Creează o nouă campanie",
    CAMPAIGN_ACTIVE:"Activ",
    CAMPAIGN_TEMPLATE:"Șablon",
    CAMPAIGN_GROUPS:"Grupuri",
    CAMPAIGN_ALL_USERS:"Toți utilizatorii",
    CAMPAIGN_NAME:"Numele campaniei",
    CAMPAIGN_NAME_REQUIRED:"Necesar",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Numărul de utilizatori din apropierea pragului pe zi",
    MESSAGE_TO_USERS:"Mesaj către utilizatorii filtrați",
    SEND_MESSAGE:"Trimite mesaj",
    THRESHOLD:"Prag",
    TYPE:"Tip",
    TOTAL_MONEY_SPENT:"Total bani cheltuiți in campanie",
    NUMBER_OF_VISITS:"Număr de vizite in cadrul campaniei",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Mesajul trebuie să aibă cel puțin 10 caractere",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Mesajul trebuie să aibă mai puțin de 350 de caractere",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Textul mesajului este necesar",
    TECHNOLOGY:"Tehnologie",
    TAP_WATER:"Apă de la robinet",
    REVERSE_OSMOSIS:"Osmoză inversă",
    SOFTENED_WATER:"Apă dedurizată",
    DOSER:"Dozator",
    STATUS:"Statut",
    LAST_SYNCHRONIZATION:"Ultima sincronizare",
    NO_OF_CURRENT_ALARMS:"Numărul de alarme curente",
    NO_OF_CURRENT_WARNINGS:"Numărul de avertizări curente",
    WEATHER:"Vreme",
    BOXES_WORK_HOURS_COUNTERS:"Program de lucru al boxelor de spălare",
    BOX_TOTAL_HOURS:"Total ore de lucru",
    BOX_SERVICE_HOURS:"Total ore de lucru (servicii)",
    BOX_COUNTER_HOURS:"ore",
    ALARMS_AND_WARNINGS:"Alarme & avertizări",
    FILTER_AND_BOILER:"Filtru & boiler",
    FILTER_TOTAL_DAYS:"Zile de muncă filtru",
    BOILER_TOTAL_DAYS:"Zile de muncă boiler",
    DAYS_UNIT:"zile",
    SOFTENER:"Balsam",
    MANUAL_COLD_DRAIN:"Scurgere manuală la rece",
    EL_COLD:"El. Rece",
    DRAIN:"scurgere",
    TAP:"robinet",
    WASTE:"Deșeuri",
    OSMOSIS:"osmoză",
    DEMI_WATER:"Demi-apă",
    EL_RINSE:"El. m. clătire",
    BOILER:"Boiler",
    EL_WAX:"El. m. ceară",
    FLOOR_HEATING:"Înclazire în podea",
    DOSER_TANK:"Bazin dozator",
    EL_WASH:"El. m. spălare",
    DETERGENT:"Detergent",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Actualizează setările",
    GENERAL_SETTINGS:"Setări generale",
    LIGHTS:"Lumini",
    GROUPS:"Grupuri",
    ANTI_FREEZE:"Antigel",
    AUTO:"Auto",
    MANUAL:"Manual",
    ON:"Pornit",
    OFF:"Oprit",
    TEMPERATURE:"Temperatură",
    UPDATE_DEVICE:"Actualizează setările unității",
    BOX_CLEAN_HOURS:"Număr de ore de curăţienie in boxa de spălare",
    GROUP_COUNTERS:"Contoare de grupuri",
    RESET:"Resetează",
    CASH_COUNT:"Număr monezi",
    COINS_COUNT:"Număr jetoane",
    EUROKEY_COUNT:"Număr Eurokey",
    DOSER_WORK:"Timp de funcționare a dozatorului (sec)",
    DOSER_PAUSE:"Pauză dozator (sec.)",
    DELAY_BFV:"Întârziere BFV (ms)",
    DELAY_6M1:"Întârziere 6M1 (ms)",
    DELAY_LPS:"Întârziere LPS (ms)",
    RESET_CASH_COUNT_ALL:"Resetează toată numărătoarea monedelor",
    RESET_COINS_COUNT_ALL:"Resetează toată numărătoarea jetoanelor",
    RESET_EUROKEY_COUNT_ALL:"Resetează toată numărătoarea Eurokey",
    FACILITY_DETAILS:"Detalii unități",
    FACILITY_NAME:"Nume unități",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Ai încărcat cu succes imaginea",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Ai actualizat datele cu succes",
    CONNECTED:"Conectat",
    DISCONNECTED:"Deconectat",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Filtrul de mesaje",
    FACILITY:"Unitate",
    APPLY:"Aplică",
    TIME:"Timp",
    LOCATION:"Locație",
    ACKNOWLEDGED:"Recunoscut",
    FILTERED_MESSAGES:"Mesaje filtrate",
    ACK:"Recunoscute",
    NOT_ACK:"Nerecunoscute",
    ALL:"Tot",
    ALL_FACILITIES:"Toate facilitățile",
    ENTER_DATE_PLACEHOLDER:"Introdu dată",
    OP_NESTANAK_NAPONA:"Lipsește voltajul pe indicatorul de fază 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"S-a stricat întrerupătorul pompei de înaltă presiune",
    OP_UPR_NAPON_24VAC_GRE:"Lipsește 24 VAC - Întrerupator 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Rezervorul de apă proaspătă este gol",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Întrerupătorul circuitului pompei de apă a scăzut",
    OP_MIN_NIVO_OMEKS_VODE:"Rezervorul de apă dedurizată",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Întrerupătorul pompei de apă dedurizată s-a stricat",
    OP_MIN_NIVO_DEMIN_VODE:"Rezervorul de apă de osmoză este gol",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Întrerupătorul pompei de apă de osmoză s-a stricat",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Întrerupătorul pompe de producție a de apei de osmoză s-a stricat",
    OP_BOJLER_GRESKA_MZS:"Eroare la încălzirea apei",
    OP_CRPKA_PRASKA_GRE_MZS:"Întrerupătorul circuitului pompei de apă caldă s-a stricat",
    OP_DOZATOR_PRASKA_GRE_MZS:"Dispozitivul pentru întreruperea motorului de dozare a pulberilor s-a stricat",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Pulverizatorul de vibrații de dozare a pulberii s-a stricat",
    OP_MIN_PRASAK_TON_ALARM:"Rezervorul de amestecare a pulberii este gol",
    OP_USIS_KOV_TURBINA_GRESKA:"Montajul aspiratorului turbină s-a stricat",
    OP_FILTER_VODE_ZACEPLJEN:"Filtrul de apă este blocat",
    OP_VISKTL_RESET_SATI_RADA:"Pompă de înaltă presiune - service",
    OPW_VISKTL_RESET_SATI_RADA:"Pompă de înaltă presiune - service",
    OP_FILTER_DANI_RADA:"Defecțiune la filtrul de apă",
    OP_BOJLER_DANI_RADA:"Defecțiune la încălzitorul de apă",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarma pompei de înaltă presiune",
    OPW_ALARM_FILTER_SERVIS:"Alarmă de serviciu filtru",
    OPW_ALARM_BOJLER_SERVIS:"Alarmă de serviciu boiler",
    HAS_MEMBERS:"Grupul selectat are membri și nu poate fi șters. Mai întâi trebuie șterși membrii.",
    PERIODIC_SUMMARY_FOR:"Rezumatul raportului periodic R2W pentru",
    PERIODIC_SUMMARY_REPORTS:"Rapoartele periodice",
    DATE_RANGE:"Interval de date",
    FINANCIAL_REPORT:"Raport financiar",
    GROSS_INCOME:"Venit brut",
    GROSS_INCOME_SUM:"Sumă venit brut",
    COMMISSION_FEE:"Comision",
    NET_INCOME:"Venitul net (pentru facturare)",
    COMMISSION_FEE_DETAILS:"Taxa de comision include comisionul bancar / furnizor PayPal sau furnizorul de servicii SMS.",
    LOYALTY_CREDITS_REPORT:"Raport de credite de loialitate",
    LOYALTY_GIVEN:"Credite de loialitate acordate",
    LOYALTY_USED:"Credite de loialitate folosite",
    LOYALTY_SOLD:"Credite de loialitate vândute",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Luna curentă",
    SOMETHING_WENT_WRONG:"Oooops",
    MISSING_PAGE:"Scuze. Nu am putut găsi pagina",
    TRY_AGAIN:"Incearcă din nou",
    DEFAULT_ERROR_NAME:"Eroare necunoscută",
    DEFAULT_ERROR_DESCRIPTION:"Te rugăm încearcă din nou",
    MY_ACCOUNT_DETAILS:"Detaliile contului meu",
    SAVE_CHANGES:"Salvează modificările",
    USERNAME:"Nume utilizator",
    FIRST_NAME:"Nume mic",
    LAST_NAME:"Nume mare",
    USER_ROLE:"Rol utilizator",
    OLD_PASSWORD:"Parolă veche",
    NEW_PASSWORD:"Parolă nouă",
    OLD_PASSWORD_REQUIRED:"Este necesară parola veche",
    NEW_PASSWORD_REQUIRED:"Este necesară parola nouă",
    NEW_PASSWORD_REPEAT:"Este nevoie sa repetați noua parolă",
    NEW_PASSWORD_NOT_MATCH:"Parola veche cu parola nouă nu se potrivesc",
    PASSWORD_DIFFERENT_VALIDATION:"Parola nouă trebuie să fie diferită de cea veche",
    PASSWORD_MIN_CHAR:"Parola dvs. trebuie să aibă cel puțin 8 caractere",
    PASSWORD_MAX_CHAR:"Parola dvs. trebuie să aibă maximum 32 de caractere",
    PASSWORD_PATTERN_VALIDATION:"Parola trebuie să conțină cel puțin un număr",
    ACCOUNT_MANAGEMENT:"Managementul contului",
    NOT_ACTIVE:"Inactiv",
    ASSIGN_ROLE:"Atribuie rolul",
    UPDATE:"Actualizează",
    ADD_NEW_ACCOUNT:"Adaugă un cont nou",
    EMAIL_REQUIRED:"Este necesară o adresă de e-mail",
    EMAIL_NOT_VALID:"Adresa de email nu este validă",
    ADD_NEW_USER_TEXT:"E-mailul cu linkul de activare va fi trimis la adresa de e-mail furnizată.",
    UPDATE_USER_NOTIFICATION:"Ai actualizat informațiile cu succes",
    CHANGED_PASSWORD_NOTIFICATION:"Ai schimbat cu succes parola",
    UPDATE_USER_GROUP_NOTIFICATION:"Ai actualizat cu succes numele grupului de utilizatori",
    CREATE_USER_GROUP_NOTIFICATION:"Ai creat grupul cu succes",
    DETELE_USER_GROUP_NOTIFICATION:"Ai șters grupul cu succes",
    EMPTY_GROUP_LIST_MSG:"Nu există grupuri create. Începe prin a crea unul",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Ai șters cu succes utilizatorul din grup",
    ADD_USER_TO_GROUP_NOTIFICATION:"Ai adăugat cu succes utilizatorul în grup",
    ADD_USER_NOTIFICATION:"Ai adăugat cu succes un utilizator nou",
    DELETE_USER_NOTIFICATION:"Ai șters cu succes utilizatorul",
    RESEND_USER_VERIFICATION_EMAIL:"Emailul de verificare a fost retransmis cu succes",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Pentru a crea un grup de utilizatori",
    DELETE_USER:"Șterge utilizatorul",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Sigur doriești să ștergi utilizatorul din grupul de utilizatori?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Dragă utilizator R2W",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Regula de loialitate pentru numărul de vizite",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Regula de loialitate pe suma de bani cheltuită",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Regula de loialitate în funcție de ziua din săptămână",
    REMOVE_CAMPAIGN_RULE_TITLE:"Eliminarea regulii de campanie",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Sigur dorești să elimini regula campaniei?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Ai creat cu succes o nouă campanie",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Ai activat campania",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Nu există campanii create. Începe prin a crea una",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Ai trimis cu succes mesajul",
    COMPANY_ACCOUNTS:"Conturile companiei",
    BUSSINESS_INVOICES_LIST:"Facturile mele B2B",
    LOCALE_TOKEN:"Jetone local",
    R2W:"Jetone global",
    START_MONTH:"Începutul lunii",
    END_MONTH:"Sfârșitul lunii",
    TOKEN_TYPE:"Tipul de token",
    TOKEN_NUMBER:"Numărul tokenului",
    NOTHING_TO_DISPLAY:"* Nimic de afișat",
    CREATE_INVOICE:"Creați factură",
    INVOICE:"Factura fiscala",
    INVOICES:"Facturi",
    EDIT_INVOICE:"Editează factura",
    UPDATE_INVOICE_NOTIFICATION:"Ai actualizat cu succes factura în starea în așteptare",
    CURRENT_CHARGES:"Taxele pentru perioada curentă",
    PAYMENTS_ON_HOLD:"Facturi în procesare",
    FOR_INVOICING:"Pentru facturare",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Ești pe cale să anulezi factura",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Sigur dorești să anulezi această factură?",
    INVOICING_NOTIFICATION_HEADER:"Esti pe cale să faci facturarea",
    INVOICING_NOTIFICATION_TEXT:"Sigur doreșt să trimiți factura?",
    SENT_INVOICE_NOTIFICATION:"Ai trimis cu succes o factură",
    CANCELED_INVOICE_NOTIFICATION:"Ai anulat factura",
    INVOICE_DESCRIPTION_TEXT:"Factură pentru",
    INVOICE_STATE:"Starea facturii",
    INVOICE_NUMBER:"Numărul facturii",
    INVOICE_TOTAL:"Total",
    SELECT_YEAR:"Selectează an",
    DOWNLOAD:"Descarcă PDF",
    INVOICE_NUMBER_HEADER:"Ești pe cale să trimiti factura cu numărul",
    INVOICE_PAYMENT_CONFIRMATION:"Ești pe cale să confirmi plata pentru",
    INSERT_INVOICE_NUMBER:"Introdu numărul facturii",
    INVOICED_WARNING:"E-mailul nu a fost trimis. Te rog asteapta ...",
    SEND_INVOICE:"Trimite",
    INVOICE_ALL:"Toate",
    INVOICE_FROM_R2W:"De la R2W",
    INVOICE_TO_R2W:"Către R2W",
    PAYMENT_REQUEST:"Cerere de plată",
    PAYMENT_REQUEST_STATE:"Stare cerere de plată",
    PAYMENT_REQUEST_NUMBER:"Număr cerere de plată",
    FOR_PAYMENT_REQUEST:"Pentru cererile de plată",
    PAYMENT_REQUEST_ON_HOLD:"Cererile de plată în proces",
    DOWNLOAD_INVOICE:"Descarcă factura",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Click pentru opțiuni de descărcare",
    B2B_SPEC:"Specificație B2B",
    B2C_SPEC:"Specificație B2C",
    DOWNLOAD_PAYMENT_REQUEST:"Descarcă cererea de plată",
    LOYALTY_PREVIEW:"Previzualizare loialitate",
    ACTIVATED:"Activat",
    RUNNING:"Functionează",
    NOT_ACTIVATED:"Nu este actviat",
    FINISHED:"Terminat",
    DEPRECATED:"Depreciată",
    UPCOMING:"Pe cale să se întâmple",
    NONE:"Nici unul",
    STARTED:"A început",
    ENDS:"Se termină",
    DEDICATED:"Dedicat pentru",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Sunteți pe punctul de a activa",
    CAMPAIGN:"campanie",
    SEND_MESSAGE_NOTIFICATION:"Sunteți pe cale să trimiteți mesaje către grupurile de utilizatori selectate",
    DIVISIBLE_TO_NUMBER:"Numărul trebuie să fie divizibil cu",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Tipul dispozitivului",
    LISTENER:"Mașini mici",
    BRIDGE:"Boxe de spălare",
    WASH_BOXES:"Boxe de spălare",
    VACUUMS:"Aspiratoare",
    SAVE_NEWS:"Salvează știrile",
    CREATE_NEW_NEWS:"Creați noi știri",
    HISTORY_OF_ALL_NEWS:"Istoria tuturor știrilor",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Introduceți numele facilității",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Adăugați o altă facilitate",
    NEWS_TEXT:"Știri text",
    NEWS_TITLE:"Titliu Știri",
    DELETE_NEWS_CONFIRMATION:"Ești pe cale să ștergi știri",
    NEWS_DELETE_NOTIFICATION:"Ai șterges cu succes știrile",
    NEWS_SAVE_NOTIFICATION:"Ai salvat știrile",
    NEWS_CREATION_DATE:"Data creării",
    NO_TITLE:"Fără nume",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Textul de știri trebuie să fie mai mic de 255 de caractere",
    NEWS_TEXT_REQUIRED_VALIDATION:"Este necesar un text de știri",
    NEWS_TITLE_REQUIRED_VALIDATION:"Este necesar titlul știrii",
    DEACTIVATE:"Dezactivează",
    ASIDE_MENU_LOCAL_TOKENS:"Jetoane locale",
    CREATE_NEW_LOCAL_TOKENS:"Emite noi jetoane locale",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Introdu adresa de e-mail a clientului și cantitatea de jetoane locale pe care dorești să le emiți clientului",
    CREATE_TOKENS:"Etichete de emitere",
    MINIMUM_ONE_TOKEN:"Valoarea trebuie să fie mai mare de 0",
    CUSTOMER_EMAIL:"E-mail client",
    AMOUNT_OF_TOKENS:"Numărul de jetoane",
    ISSUING_LOCAL_TOKENS_SUCCESS:"S-a realizat cu succes emiterea de jetoane locale către",
    PROBLEM_ISSUING_LOCAL_TOKENS:"A apărut o eroare la emiterea jetoanelor locale.Verificați adresa de e-mail a clientului și încercați din nou.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Privire de ansamblu asupra jetoanelor locale emise",
    ISSUED_AT:"Emis la",
    ISSUED_BY:"Emis de",
    CODE:"Cod promotional",
    REDEEMED_BY:"Folosește pănă la",
    REDEEMED_AT:"Folosește la",
    ASIDE_MENU_VOUCHERS:"Vouchere",
    PRINT:"Printează",
    VOUCHERS_OVERVIEW:"Prezentare generală a voucherelor",
    CREATE_NEW_VOUCHERS:"Creează vouchere noi",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Creează un nou lot de vouchere rambursabile, introducând suma de jetoane pentru fiecare voucher",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Cantitatea de jetoane per voucher",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Poți aloca între 1 și 20 de jetoane pentru fiecare voucher",
    NUMBER_OF_NEW_VOUCHERS:"Numărul de vouchere care urmează a fi create",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Poți crea vouchere între 1 și {{size}} într-un singur lot",
    NEW_VOUCHERS_PREFIX:"Prefixul codului de serie al voucherelor noi",
    VALIDATION_VOUCHER_PREFIX:"Prefixul de cod trebuie să fie din caractere superioare și între 1 și 16 litere și/sau caractere numerice",
    PROBLEM_CREATING_NEW_VOUCHERS:"A apărut o problemă la crearea de vouchere noi.Încercați din nou sau contactați asistența noastră.",
    CREATE_VOUCHERS:"Creează vouchere",
    CREATING_VOUCHERS_SUCCESS:"Noi vouchere create cu succes",
    PRINT_NEW_VOUCHERS:"Imprimați vouchere",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Introdu un prefix de cod de serie al voucherului pentru a imprima o serie întreagă de vouchere.",
    PRINT_VOUCHERS_PREFIX:"Codul prefixului voucher (serie)",
    NO_VOUCHERS_FOR_PRINT:"Nu au fost găsite vouchere care să corespundă prefixului codului furnizat pentru tipărire",
    PRINT_VOUCHERS:"Imprima voucher(e)",
    VALIDATION_VOUCHER_CODE_FILTER:"Termenul de căutare a cuponului trebuie să conțină litere mari și numere",
    FILTER_VOUCHERS_BY_CODE:"Căută vouchere prin introducerea codului",
    FILTER_VOUCHERS:"Căută vouchere",
    WASH_BOX:"Boxă de spălare",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Total jetoane digitale utilizate",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:" Total vândute jetoane locale după dată",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Total cheltuite jetoane locale după dată",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Total acordate jetoane locale după dată",
    LOCAL_TOKEN:"Jeton local",
    GIVEN_TOKEN:"Jetoni locali acordați",
    SOLD_TOKEN:"Jetoni locali vânduți",
    SMALL_MACHINES:"Mașini mici",
    R2W_Listener:"Ascultător",
    HHANLE_DEVICE:"Boxă de spălare HHanle",
    CODE_PREFIX_EXIST:"Prefixul codului există deja",
    CODE_PREFIX_EXIST_TEXT:"Nu puteți crea un cupon nou cu acest prefix de cod. Vă rugăm să setați altul.",
    MIN_FOUR_VALIDATION:"Exact 4 caractere",
    ALL_INFORMATION_1:"Toate informațiile despre",
    ALL_INFORMATION_2:"vor fi pierdute",
    ASIDE_MENU_TRANSACTIONS:"Tranzacții",
    EXPENSES:"Cheltuieli",
    TOPUPS:"Încărcări",
    EXPENSES_LIST:"Listă de cheltuieli",
    USER_EMAIL:"Adresa de email a utilizatorului",
    COMPANY_NAME:"Numele companiei",
    TOPUPS_LIST:"Listă de reîncărcări",
    CONSUMER:"Consumator",
    SYSTEM_ADMIN:"Administrator de sistem",
    MERCHANT_ADMIN:"Administrator comerciant",
    COMPANY_ADMIN:"Administrator companie",
    FACILITY_ADMIN:"Facility administrator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Număr de serie",
    SETUP_UNIT_MATERIAL_NO:"Număr de material",
    SETUP_UNIT_WEBAPI_VERSION:"Versiune WebApi",
    TOTAL_TURNOVER:"Volum de afaceri al facilității de spălare",
    AVAILABILITY_ALL:"Disponibilitate",
    AVAILIBILITY:"Disponibilitatea boxelor de spălare:",
    AVAILABILITY_VACUUMS:"Disponibilitatea aspiratoarelor:",
    WASH_BOX_INFO:"Informații despre boxele de spălare",
    VACUUM_CLEANER_INFO:"Informații despre aspiratoare",
    BREAD_CRUMBS_SERVICE:"Serviciu",
    HOLIDAYS:"Zilele libere ",
    HOLIDAY:"Zi libera",
    LIGHTS_ON:"Luminile pornite",
    LIGHTS_OFF:"Luminile oprite",
    WASH_BOXES_ON:"Box de spălare pornit",
    WASH_BOXES_OFF:"Box de spălare oprit",
    VACUUMS_ON:"Aspiratoare pornite",
    VACUUMS_OFF:"Aspiratoare oprite",
    TURNOVER:"Încasări",
    TURNOVER_MANUAL_WASH_UNIT:"Încasări manuale",
    STATUS_BAY_RUN_TIME:"Timp total de funcționare al boxului de spălat",
    STATUS_BAY_PROGRAM_NAME:"Numele programului",
    STATUS_BAY_CREDIT:"Credit pentru boxul de spălat",
    CLOUD_KREDIT:"Credit de pe cloud",
    STATUS_VACUUM_RUN_TIME:"Timp total de funcționare al aspiratoarelor",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Informații despre serviciile facilității, programul boxului de spălat și datele curente despre defecte",
    UNAVAILABLE:"Unitate indisponibilă",
    SHOW_HIDE_TABLE:"Afișare/ascundere tabel de ore de lucru",
    PROGRAM_NAME:"Numele programului",
    PROGRAM_COUNTER:"Contorul programului",
    NO_NAME:"Referința nu are nume",
    COUNTER_SERVICE_DATA:"Date despre serviciu",
    NEED_SERVICE:"Necesita service",
    PROGRAM_DATA:"Date despre programul boxului de spălat",
    CURRENT_FAULT_DATA:"Date curente despre defecte",
    REFERENCE_DUE:"Scadență",
    REFERENCE_SECONDS:"Secunde",
    REFERENCE_NAME:"Nume piesă",
    WASHBOX_NAME:"Nume box de spălat",
    FAULT_NAME:"Nume defect",
    FAULT_NUMBER:"Număr defect",
    CURRENT_FAULT_COUNT:"Defecte active",
    DEVICE_NOT_INSTALLED:"Dispozitiv neinstalat",
    STATUS_READY:"Stare gata",
    STATUS_ERROR:"Starea erorii",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Eroare software",
    SOFTWARE_RESET:"Eroare software",
    EXTERNAL_PIN_RESET:"Eroare software",
    RESTART_OR_BROWNOUT_OCCURRED:"Eroare software",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Eroare hardware",
    COULD_NOT_SIMULATE_COIN:"Eroare hardware",
    ERROR_SETTING_INHIBIT_MODE:"Eroare hardware",
    OFFLINE_DEVICE:"Spălătorie offline",
    TARIFFS:"Tarife",
    DAY:"Zi",
    NIGHT:"Noapte",
    VOUCHER_CODE:"Cod voucher",
    DISMISS_ALARM:"Resetezi alarma?",
    ALARM_ACTIVE:"Alarme active",
    NO_ALARM_ACTIVE:"Nu exista alarme active",
    ALARM_HISTORY:"Istoric alerte",
    MANAGING_TOKENS:"Administreaza jetoanele",
    EXPIRATION_DATE:"Data expirării",
    EXTEND_TOKEN_DATE:"Extindeți data de expirare a simbolului pentru",
    DELETE_TOKENS_FOR:"Ștergeți jetoanele pentru",
    PUMP_TYPE:"Tipul de pompa",
    TURN_OFF_DEVICE:"Starea echipamentului",
    OPERATION_DATA:"Date de operare",
    PUMP_DATA:"Date pompa",
    PUMP_NAME:"Nume pompa",
    POINT_NAME:"Nume punct",
    CHANGER_INCOME:"Total venit bancomat dupa data",
    SELECTED_OPEN:"Deschis la orele de lucru selectate",
    ALWAYS_OPEN:"Intotdeauna deschisa (24/7)",
    CLOSED:"Închis",
    CLOSED_24:"Inchis 24 ore",
    OPENED_24:"Deschis 24 ore",
    MON:"Luni",
    TUE:"Marți",
    WED:"Miercuri",
    THU:"Joi",
    FRI:"Vineri",
    SAT:"Sâmbătă",
    SUN:"Duminică",
    PRICING:"Stabileste pretul",
    PRICE:"Pret",
    VALIDITY:"Valabilitate",
    TOKEN_PACKAGES:"Pachete de jetoane",
    SINGLE_WASH:"O singura spalare",
    FACILITY_WORKING_HOURS:"Stabileste orarul de functionare pentru spalatoria selectata",
    WORKING_HOURS_ALWAYS_OPEN:"Intotdeauna deschisa",
    WORKING_HOURS_ALWAYS_CLOSE:"Inchisa de operator",
    WORKING_HOURS_CUSTOM:"Stabileste orele de functionare",
    KARCHER_ERROR_CODE:"Alerta cod eroare",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor buffer tank empty activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor buffer container empty and buffer contianer full switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor ro pump on and buffer container full switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizatia",
    CREATE_ORGANIZATION:"Creaza organizatia",
    CREATE_ORGANIZATION_AS:"Creaza organizatia ca filiala a",
    DELETE_ORGANIZATION:"Sterge organizatia",
    EDIT_ORGANIZATION:"Editeaza organizatia",
    SUPPORTED_ORG_NAME:"Organizatie sustinuta",
    SUPPORTED_ORG_TYPE:"Tip de sustinere",
    ORG_NAME:"Nume",
    ORG_TYPE:"Tip",
    SET_ORG_TITLE:"Setati filiala organizatiei",
    SET_SUPPORTED_ORG_TITLE:"Setati filiala organizatiei sustinuta",
    SAVE_ORGANIZATION:"Salveaza organizatia",
    SELECT_ORGANIZATION_TYPE:"Selecteaza tipul organizatiei",
    SELECT_ORGANIZATION_SELECTOR:"Selecteaza",
    SELECT_SUPPORTED_ORGANIZATION:"Selecteaza organizatia sustinuta",
    ORGANIZATION_DELETED:"Organizatia a fost stearsa",
    ORGANIZATION_SAVED:"Organizatia a fost salvata cu succes",
    ORGANIZATION_UPDATED:"Organizatia a fost actualizata cu succes",
    ALERTS:"Alerte",
    DEVICE_STATUS:"Starea echipamentului",
    SITE_DETAILS:"Detaliile locatiei",
    ALARM_STATUS:"Status alerta",
    FILTER:"Filtrare ...",
    FILTER_BY_ALERT_CENTER:"Filtrare dupa cod, nume sau descriere",
    TOTAL_ALARM:"Total",
    LOW_ALARM:"Incident/ eveniment",
    MEDIUM_ALARM:"Defectiune",
    HIGH_ALARM:"Defectiune critica",
    NO_FACILITIES_NEARBY:"Nu exista locatii in apropiere",
    GRAY_MAP:"Harta in stil gri",
    READY:"Este gata",
    WARNING:"Defectiune",
    ERROR:"Eroar",
    SITE_NAME:"Nume locatie",
    ACCOUNTS_INFO:"Informatii cont",
    USER_ORGANIZATION:"Utilizator organizatie",
    ADD_USER_ORGANIZATION:"Adauga un nou utilizator al organizatiei",
    EDIT_USER_ORGANIZATION:"Editeaza utilizatorii organizatiei",
    SELECT_ROLE:"Selecteaza rolul",
    SELECT_ORGANIZATION:"Selecteaza organizatia",
    SELECT_USER:"Selecteaza utilizatorul",
    USER_FOR_ORGANIZATION_CREATED:"Un nou utilizator a fost creat cu succes",
    SELECT_REGION:"Selecteaza regiunea",
    SELECT_LANGUAGE:"Selecteaza limba",
    LOADING_DATA:"Se incarca, te rog sa astepti…",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Suport tehnic",
    CONTROLLER:"Supervizor",
    EDIT_ORGANIZATION_USER:"Editeaza utilizatorii organizatiei tale",
    DELETE_ORGANIZATION_USER:"Sterge utilizatorii organizatiei tale",
    USER_UPDATED:"Utilizator actualizat cu succes",
    USER_CREATED:"Utilizator creat cu succes",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"Abonamente",
    RESOLVED_STATUS:"Rezolvat",
    NOT_RESOLVED_STATUS:"Nu s-a rezolvat",
    ALERT_NAME:"Nume alerta",
    ALERT_DESCRIPTION:"Descriere alerta",
    ALERT_CODE:"Cod alerta",
    ALERT_TYPE:"Tip alerta",
    UNSUBSCRIBE:"Alerta dezabonare",
    SUBSCRIBE:"Alerta abonare",
    ALARM_SUBSCRIBED:"Te-ai abonat cu succes",
    UNSUBSCRIBED_CONFIRM:"Doresti sa te dezabonezi?",
    ALARM_UNSUBSCRIBED:"Te-ai dezabonat cu succes",
    ASIDE_MENU_CASHLESS_SALES:"Vanzari fara numerar",
    FILTERED_CASHLESS_PAYMENTS:"Ai selectat plati fara numerar",
    REFUND_DIALOG_TITLE:"Doresti sa restitui tranzactia?",
    REFUND_DIALOG_SUBTITLE:"Suma poate fi mai mica sau egala cu suma transferata",
    REFUND:"Restituire",
    INPUT_NOT_VALID:"Valoarea introdusa nu este corecta",
    REFUND_SUCCESSFULLY:"Restituirea pentru plata selectata s-a realizat cu succes",
    USER:"Utilizator",
    TRANSACTION_ID:"Referinta PSP",
    DEVICE_ID:"ID terminal",
    NET_AMOUNT:"Suma neta",
    REPORT_NAME:"Nume raport",
    TIME_FRAME:"Interval orar",
    SUB_POINT:"Selectati subpunctul",
    SUB_POINT_LIST_NOT_EXIST:"Lista subpuncte nu exista pentru spalatoria selectata",
    FACILITY_TYPE:"Tip locatie",
    MACHINE_NAME:"Nume utilaj",
    WASH_FACILITY_DETAILS:"Detalii spalatorie",
    WASH_BAY_DETAILS:"Detalii piste de spalare",
    DEVICES_INFO:"Lista echipamente",
    OPERATION_TIME_INFO:"Timp de operare",
    OPERATION_TIME_VACUUM_INFO:"Timp de operare pentru aspiratoare",
    OPERATION_TIME_ILLUMINATION_INFO:"Timp de operare pentru iluminare",
    AVAILABLE_TITLE:"Disponibil",
    UNAVAILABLE_TITLE:"Indisponibil",
    CURRENT_PROGRAM:"Programul curent",
    CREDITS:"Credite",
    DEVICE_NAME:"Nume echipament",
    ACTIVE_ALARMS:"Alerte active",
    ALL_DAY:"Toata ziua",
    OPERATING_TIME_WASH_FACILITY:"Sistem de spalare self-service",
    OPERATING_TIME_VACUUMS:"Aspiratoare",
    OPERATING_TIME_ILLUMINATION:"Iluminare",
    OPERATION_COUNTERS:"Contoare functionare",
    EDIT:"Editare",
    WASHING_PROGRAMS:"Programe de spalare",
    INFO:"Incident/ eveniment",
    STATISTIC:"Statistic",
    ROLLOVER_DOSING:"Dozaj",
    ROLLOVER_SPEED:"Viteze",
    ROLLOVER_RESETS:"Resetare portal de la distanta",
    ROLLOVER_RESETS_INFO:"Resetarea de la distanta trebuie sa fie in acord cu reglementarile locale. Important: Inainte sa resetezi, asigura-te ca portalul este gol.",
    RESET_ROLLOVER:"Resetare portal",
    OPEN_DOOR_ROLLOVER:"Deschide",
    ROLLOVER_OPEN_DOOR_INFO:"Deschide usa culuarului de spalare. Cu atentie.",
    ROLLOVER_OPEN_DOOR:"Deschide usa",
    APPLY_DOSING_CHANGES:"Aplica modificari de dozaj",
    APPLY_SPEED_CHANGES:"Aplica modificari de viteza",
    ACTUATION_SUCCESS:"Solicitare transmisa",
    REMAINING_TIME:"Timp ramas",
    OPEN_24H:"Deschis 24 ore",
    CLOSE_24H:"Inchis 24 ore",
    VALIDATION_OPERATION_TIME:"Formatul nu este corect. Foloseste hh:mm",
    ROLLOVER:"Portal",
    UPDATE_WASHING_PROGRAM:"Actualizeaza programul de spalare",
    UPDATE_ACTUATORS:"Actualizeaza dispozitivele de actionare",
    OPEN_ROLOVER_DOOR_TITLE:"Doresti sa deschizi usa portalului?",
    OPEN_ROLOVER_DOOR_CONTENT:"Esti sigur ca doresti sa deschizi usa?",
    RESET_ROLOVER_TITLE:"Doresti sa resetezi portalul?",
    RESET_ROLOVER_CONTENT:"Esti sigur ca doresti sa resetezi portalul?",
    G0:"{{brand === 'r2w' ? 'Pista 0' : 'Pista 1'}}",
    G1:"{{brand === 'r2w' ? 'Pista 1' : 'Pista 2'}}",
    G2:"{{brand === 'r2w' ? 'Pista 2' : 'Pista 3'}}",
    G3:"{{brand === 'r2w' ? 'Pista 3' : 'Pista 4'}}",
    G4:"{{brand === 'r2w' ? 'Pista 4' : 'Pista 5'}}",
    G5:"{{brand === 'r2w' ? 'Pista 5' : 'Pista 6'}}",
    G6:"{{brand === 'r2w' ? 'Pista 6' : 'Pista 7'}}",
    G7:"{{brand === 'r2w' ? 'Pista 7' : 'Pista 8'}}",
    G8:"{{brand === 'r2w' ? 'Pista 8' : 'Pista 9'}}",
    G9:"{{brand === 'r2w' ? 'Pista 9' : 'Pista 10'}}",
    G10:"{{brand === 'r2w' ? 'Pista 10' : 'Pista 11'}}",
    U0:"{{brand === 'r2w' ? 'Aspirator 0' : 'Aspirator 1'}}",
    U1:"{{brand === 'r2w' ? 'Aspirator 1' : 'Aspirator 2'}}",
    U2:"{{brand === 'r2w' ? 'Aspirator 2' : 'Aspirator 3'}}",
    U3:"{{brand === 'r2w' ? 'Aspirator 3' : 'Aspirator 4'}}",
    U4:"{{brand === 'r2w' ? 'Aspirator 4' : 'Aspirator 5'}}",
    U5:"{{brand === 'r2w' ? 'Aspirator 5' : 'Aspirator 6'}}",
    U6:"{{brand === 'r2w' ? 'Aspirator 6' : 'Aspirator 7'}}",
    U7:"{{brand === 'r2w' ? 'Aspirator 7' : 'Aspirator 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Alert center report created by selected site from dashboard",
    ALERT_CENTER_TITLE_BY_FACILITY:"Alert center report created by selected facility from dashboard",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Raportul centrului de alerta",
    ERROR_MESSAGE_403:"Nu ai dreptul de a utiliza acest apel api. Eroare Cod: 403",
    LAST_ACTIVE_PROGRAM:"Programul activ / Ultimul program activ",
    PROGRAM_ID:"Numarul programului",
    PROGRAM_PRICE:"Pretul programului",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Necesita reumplerea",
    EMPTY_CHEMICAL_LEVEL:"Gol",
    CHEMICAL_LEVEL:"Nivelul de detergent (%)",
    ROLLOVER_STATUS:"Status portal",
    ROLLOVER_STATUS_CODE_0:"Spalarea nu functioneaza momentan",
    ROLLOVER_STATUS_CODE_1:"In afara programului de functionare",
    ROLLOVER_STATUS_CODE_2:"Introducerea programului este permisa",
    ROLLOVER_STATUS_CODE_3:"Pozitioneaza-ti vehicolul",
    ROLLOVER_STATUS_CODE_4:"Mergi in fata",
    ROLLOVER_STATUS_CODE_5:"Mergi in spate",
    ROLLOVER_STATUS_CODE_6:"Opreste",
    ROLLOVER_STATUS_CODE_7:"Spalare in curs",
    ROLLOVER_STATUS_CODE_8:"Spalarea s-a terminat",
    ROLLOVER_STATUS_CODE_9:"Spalare in curs (tact)",
    ROLLOVER_STATUS_CODE_10:"Iesire cu spatele",
    ROLLOVER_STATUS_CODE_11:"Oprire de urgenta",
    ROLLOVER_STATUS_CODE_12:"Iesire cu fata",
    ROLLOVER_STATUS_CODE_13:"Degivrare activa",
    ROLLOVER_STATUS_CODE_14:"Butonul de siguranta din fata este activat",
    ROLLOVER_STATUS_CODE_15:"Butonul de siguranta din spate este activat",
    ROLLOVER_STATUS_CODE_16:"Butonul de siguranta din stanga fata este activat",
    ROLLOVER_STATUS_CODE_17:"Butonul de siguranta din dreapta fata este activat",
    ROLLOVER_STATUS_CODE_18:"Butonul de siguranta din stanga spate este activat",
    ROLLOVER_STATUS_CODE_19:"Butonul de siguranta din dreapta spate este activat",
    ROLLOVER_STATUS_CODE_20:"Vehicolul este pozitionat prea mult in partea stanga",
    ROLLOVER_STATUS_CODE_21:"Vehicolul este pozitionat prea mult in partea dreapta",
    ROLLOVER_STATUS_CODE_22:"Usa din stanga nu este inchisa",
    ROLLOVER_STATUS_CODE_23:"Usa din dreapta nu este inchisa",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, programul de spalare este selectat gresit",
    ROLLOVER_STATUS_CODE_25:"Senzor claxon",
    ROLLOVER_STATUS_CODE_98:"Modul de ajustare / manual",
    ROLLOVER_STATUS_CODE_99:"Status necunoscut",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Cod status nedefinit",
    ALARM:"Defectiune critica",
    NO_ALARM:"Nu sunt erori critice",
    SOFTWARE_VERSION:"Versiune software",
    SOFTWARE_DATE:"Data software",
    SITE_ADDRESS:"Adresa locatie",
    SECONDS:"Secunde",
    SERVICE_PART_NAME:"Numele serviciului:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Contor functionare si service",
    OPERATION_COUNTER:"Contor functionare",
    SERVICE_COUNTER:"Contor service",
    FAULT_CODE:"Cod alerta",
    PRESSURE_TITLE:"Presiune aer",
    TIME_TITLE:"Ora curenta",
    COUNTRY_TITLE:"Tara",
    CITY_TITLE:"Orasul",
    REGION_TITLE:"Regiunea",
    SELECT_POINTS_TO_SEARCH:"Punctele selectate ...",
    LOGS_HISTORY:"Istoric modificari parametri",
    ACTUATOR_REFERENCE:"Actuator referinta",
    ACTUATOR_VALUE:"Actuator valoare",
    POINT_ID:"Point id",
    VALIDATION_NOT_VALID_RANGE:"Interval incorect",
    ENABLE_ROLLOVER_RESET:"Bifand aceasta casuta confirmi ca ai citit si esti de acord cu instructiunile privind siguranta.",
    CHANGE_OF_PARAMETERS:"Modificare de parametri",
    SELECT_OPTIONS:"Selecteaza optiunile",
    AUTOMATIC:"Automat",
    DESALTING:"Functia de desalinizare (dedurizare)",
    SEASON_WASH:"Programe de spalare in functie de sezon",
    SPRING_PROGRAM:"Programe de spalare primavara",
    SUMMER_PROGRAM:"Programe de spalare vara",
    AUTUMN_PROGRAM:"Programe de spalare toamna",
    WINTER_PROGRAM:"Programe de spalare iarna",
    DOOR_CONTROL:"Controlul usii",
    SUMMER_DOOR_CONTROL:"Vara, operat cu control poarta in modul vara",
    WINTER_DOOR_CONTROL:"Iarna, operat cu control poarta in modul iarna",
    APPLY_PARAMETERS_CHANGES:"Aplica modificarile de parametri",
    WORKING_SCHEDULES:"Program de functionare",
    HOLIDAY_SCHEDULES:"Program de sărbători",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Zilele libere pentru locatie au fost create cu succes",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Zilele libere pentru locatie au fost actualizate cu succes",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Zilele libere pentru locatie au fost sterse",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Programul de functionare a fost transmis cu succes",
    HOLIDAY_SUCCESSFULLY_DELETED:"Zilele libere au fost sterse",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:" CWB3_3_0_0_Trans",
    CWB3_3_1_0:" CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Nivel scazut agent de uscare",
    CHEM_LEVEL_LOW_SHAMPOO:"Nivel scazut sampon",
    CHEM_LEVEL_LOW_FOAM:"Nivel scazut spuma",
    CHEM_LEVEL_LOW_WAX_1:"Nivel scazut ceara",
    CHEM_LEVEL_LOW_POLISH_1:"Nivel scazut polish",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Nivel scazut agent spalare roti",
    CHEM_LEVEL_LOW_WAX_2:"Nivel scazut ceara",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Nivel scazut luciu de roti",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Nivel scazut solutie indepartare insecte",
    CHEM_LEVEL_LOW_POLISH_2:"Nivel scazut polish",
    CHEM_LEVEL_LOW_INTENSIVE:"Nivel scazut intensiv",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Nivel scazut ploaie spuma",
    CHEM_LEVEL_DRYING_AGENT:"Nivel agent de uscare",
    CHEM_LEVEL_SHAMPOO:"Nivel sampon",
    CHEM_LEVEL_FOAM:"Nivel spuma",
    CHEM_LEVEL_WAX_1:"Nivel ceara",
    CHEM_LEVEL_POLISH_1:"Nivel polish",
    CHEM_LEVEL_RIM_CLEANER:"Nivel agent curatare jenti",
    CHEM_LEVEL_WAX_2:"Nivel ceara",
    CHEM_LEVEL_TYRE_SHINE:"Nivel luciu de roti",
    CHEM_LEVEL_INSECT_REMOVER:"Nivel solutie indepartare insecte",
    CHEM_LEVEL_POLISH_2:"Nivel polish",
    CHEM_LEVEL_INTENSIVE:"Nivel intensive",
    CHEM_LEVEL_FOAM_RAIN:"Nivel ploaie spuma",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Service counter roof-brush lifting belt",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Service counter dryer lifting belt",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Service counter motor cable roof-brush",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Service counter fresh water pump service",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Service counter pump service used water",
    DRYING_AGENT:"Agent de uscare",
    FOAM_DRYING_AGENT:"Agent de uscare spuma",
    SHAMPOO:"Sampon",
    FOAM:"Spuma",
    BRUSH_FOAM:"Pre-spalare",
    WAX_1:"Ceara",
    FOAM_WAX_1:"Ceara spumata",
    POLISH_1:"Polish",
    RIM_CLEANING:"Curatare jenti",
    WAX_2:"Ceara",
    FOAM_WAX_2:"Ceara spumata",
    TYRE_SHINE:"Luciu de roti",
    INSECT_REMOVER:"Solutie indepartare insecte",
    POLISH_2:"Polish",
    INTENSIVE_BASIC:"Intensive basic",
    INTENSIVE_SIDE:"Intensive side",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensive roof spray bar",
    TAR_REMOVER:"Indepartare reziduu",
    UNDER_CHASSIS_CONVERSATION:"Spalare sub sasiu",
    STATIONARY_PRE_SPRAY_ARCH:"Stationary pre-spray arch",
    FOAM_RAIN:"Ploaie spuma",
    PRE_CLEANING:" Pre-cleaning",
    BRUSH:"Perie",
    CARE:"Ingrijire",
    DRYING:"Uscare",
    DRYING_LOW_NOISE:"Uscare cu zgomot redus",
    INTENSIVE_CLEANING:"Curatare intensiva",
    BRUSH_CLEANING:"Curatare cu perie",
    EMPTY_RUN:"Functionare in gol",
    DRYING_AID:"Drying aid",
    WAX:"Ceara",
    FOAM_WASH:"Spalare cu spuma",
    POLISH:"Polish",
    FOAM_POLISH:"Spuma pentru polish",
    WHEEL_CLEANING:"Curatare roti",
    HIGH_PRESSURE_ROOF:"Inalta presiune pentru acoperis",
    HIGH_PRESSURE_SIDE:"Inalta presiune pentru laterale",
    DRYER_FORWARD:"Uscator pentru partea din fata",
    DRYER_BACKWARD:"Uscator pentru partea din spate",
    DELETE_ALL_HOLIDAYS:"Sterge toate zilele libere pentru locatia selectata",
    CREATE_NEW_HOLIDAY:"Creaza o noua",
    RESET_INPUTS:"Sterge toate zilele libere introduse",
    TWENTY_FOUR_HOURS_OPEN:"Deschis 24 ore",
    EVERY_YEAR:"Anual",
    DELETE_HOLIDAY:"Sterge zilele libere",
    ADD_NEW_HOLIDAY:"Adauga o noua zi libera",
    HOLIDAYS_LIST:"Lista zilelor libere existenta",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Stergi toate zilele libere pentru locatia selectata?",
    VALIDATION_HOLIDAY_DATE:"Formatul nu este corect. Foloseste formatul mm-dd",
    FOR_DATE:"Pentru data",
    WITH_ID:"Cu ID",
    FROM_HOURS:"De la (ora)",
    FROM_MINUTES:"De la (min)",
    TO_HOURS:"Pana la (ora)",
    TO_MINUTES:"Pana la (min)",
    NOT_MATCH:"Nu se potriveste",
    START:"De la",
    STOP:"Pena la",
    DAILY_TIME:"Lista 24 ore",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Setare timp individual",
    PROGRAM_NOT_STARTED:"Programul nu a inceput inca",
    JETWASH:"Sistem de spalare self-service",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"Boxa spalare: Numarul de ore per program de spalare pentru fiecare pista si in total",
    KARCHER_REPORT_9:"Boxa spalare: Venitul total per pista de spalare si in total",
    KARCHER_REPORT_10:"Contor jetoane per jetoniera",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Pompa apa proaspata",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Pompa de apa procesata",
    OPERATION_COUNTER_HP_PUMP_1:"Pompa inalta presiune 1",
    OPERATION_COUNTER_HP_PUMP_2:"Pompa inalta presiune 2",
    RELEASE_NOTES:"Versiunile app si notele de la lansare",
    BACKEND_RELEASE_NOTES:"Note la lansarea platformei:",
    FRONTEND_RELEASE_NOTES:"Note la lansarea aplicatiei web:",
    SELECTED_FACILITY_TIMEZONE:"Fusul orar pentru locatia selectata:",
    REFRESH_PAGE:"Reimprospateaza pagina",
    REFRESH_MAPS:"Reimprospateaza harta",
    PUMPS:"Pompe",
    RUN_TIME:"Timp de functionare",
    RUN_TIME1:"Timp de functionare 1",
    RUN_TIME2:"Timp de functionare 2",
    PROGRAM_RUNTIME_ACTUATOR:"Actuator for run time",
    PROGRAM_RUNTIME_ACTUATOR_1:"Actuator for run time 1 ",
    PROGRAM_RUNTIME_ACTUATOR_2:"Actuator for run time 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Valoarea minima este 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Valoarea maxima este 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Foloseste formatul de pret x,xx",
    ACTUATION_NOT_ALLOWED:"Actionarea nu este permisa pentru rolul actual de utilizator",
    MAINTENANCE_DAYS:"Zile de mentenanta",
    MAINTENANCE_WASHES:"Spalari de mentenanta",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Venit total POS",
    PROPAGATE:"Procesare",
    ALL_DAY_HOURS_SELECTOR:"Tip seletor 24 ore",
    GET_OPERATING_TIME_FROM_SITE:"Setare orar de functionare",
    USER_NOT_VALID:"Utilizatorul nu este valid. Incearca un alt utilizator.",
    VERIFIED:"Verificat",
    RESEND_VERIFICATION_MAIL:"Retrimite email de verificare",
    RETURN_TO_DASHBOARD:"Reveniti la meniul principal",
    ERROR_PAGE_BAD_REQUEST:"400 Solicitare gresita.",
    WASHES:"Numarul de spalari",
    TIME_TO_SERVICE:"Timp de service/ functionare",
    ACCOUNT_ALREADY_ACTIVATED:"Contul a fost deja activat",
    DEVICE_EVENTS:"Evenimente dispozitiv",
    DEVICE_EVENTS_LOG_PULLED:"Jurnal de evenimente extras pentru dispozitiv",
    EVENTS_PULL_DATE:"Timpul evenimentelor extrase:",
    DEVICE_EVENTS_REFRESH:"Extrage datele noi ale evenimentelor",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problemă de conexiune cu socket-urile web. Încercați să reîncărcați pagina.",
    INSTALLATION_DATE:"Data instalării mașinii",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Ceară caldă",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Spălare cu presiune înaltă",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Spumă puternică pentru jante",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Spumă puternică",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Oprire",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Spălare cu spumă HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Spălare",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Îngrijire de top",
    INFO_TITLE:"Informații",
    FOAM_WAX1:"Ceara spumata",
    POLISH1:"Polish",
    WAX1:"Ceara",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Detaliile site-ului au fost actualizate cu succes",
    COMPANY:"Companie",
    FACILITY_HAS_CHANGER:"Aveți schimbător?",
    DISABLE_OFFLINE_ALARM:"Dezactivați alarmele R2W",
    ASIDE_WORKING_SCHEDULES:"Detalii site aplicație",
    TERMS_OF_SERVICE_R2W_TITLE:"Termenii și condițiile Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Termenii și condițiile Ready2Wash",
    DATA_PROCESSING_TITLE:"Date procesate",
    PRIVACY_POLICY_TITLE:"Politica de confidențialitate",
    READY_TO_PAY_TERMS_OF_SERVICE:"Termenii și condițiile Ready2Pay",
    TERMS_AND_SERVICES:"Termeni și servicii",
    HOURLY: "Orar",
    DAILY: "Zilnic",
    WEEKLY: "Săptămânal",
    MONTHLY: "Lunar",
    YEARLY: "Anual",
    DELETE_ITEM_SUCCESS:"Ați șters cu succes elementul",
    STATE: "Stare",
    AVAILABILITY_STATUS_1: "Unitate deschisă",
    AVAILABILITY_STATUS_2: "Unitate închisă (vacanță)",
    AVAILABILITY_STATUS_3: "Unitate închisă (program de funcționare)",
    AVAILABILITY_STATUS_4: "Unitate închisă (defecțiune)",
    AVAILABILITY_STATUS_5: "Unitate închisă (altceva)",
    AVAILABILITY_VACUUMS_STATUS_1: "Aspiratoarele nu sunt instalate",
    AVAILABILITY_VACUUMS_STATUS_2: "Aspiratoare deschise",
    AVAILABILITY_VACUUMS_STATUS_3: "Aspiratoare închise (vacanță)",
    AVAILABILITY_VACUUMS_STATUS_4: "Aspiratoare închise (program de funcționare)",
    AVAILABILITY_VACUUMS_STATUS_5: "Aspiratoare închise (defecțiune)",
    AVAILABILITY_VACUUMS_STATUS_6: "Aspiratoare închise (altceva)",
    ECOM_AMOUNT: "Total Ecom pentru toate locațiile",
    CAPTURED: "Înregistrat",
    DELETE_COMPANY_HISTORY_INFO:"Această acțiune va șterge toate datele rapoartelor companiei dumneavoastră. Această acțiune este ireversibilă.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Sunteți sigur că doriți să ștergeți definitiv toate datele rapoartelor?",
    VALUE_DATE: "Data valorii",
    KARCHER_EVENT_NAME_1: "Schimbătorul de căldură principal regenerat",
    KARCHER_EVENT_NAME_2: "Regenerarea schimbătorului de căldură principal finalizată",
    KARCHER_EVENT_NAME_3: "Material / număr de serie",
    KARCHER_EVENT_NAME_4: "Sistemul a fost dezinfectat",
    KARCHER_EVENT_NAME_5: "Pompa HP 1 dezinfectată",
    KARCHER_EVENT_NAME_6: "Pompa HP 2 dezinfectată",
    KARCHER_EVENT_NAME_7: "Pompa HP 3 dezinfectată",
    KARCHER_EVENT_NAME_8: "Pompa HP 4 dezinfectată",
    KARCHER_EVENT_NAME_9: "Pompa HP 5 dezinfectată",
    KARCHER_EVENT_NAME_10: "Stația de spălare 1 blocată",
    KARCHER_EVENT_NAME_11: "Stația de spălare 2 blocată",
    KARCHER_EVENT_NAME_12: "Stația de spălare 3 blocată",
    KARCHER_EVENT_NAME_13: "Stația de spălare 4 blocată",
    KARCHER_EVENT_NAME_14: "Stația de spălare 5 blocată",
    KARCHER_EVENT_NAME_15: "Stația de spălare 6 blocată",
    KARCHER_EVENT_NAME_16: "Stația de spălare 7 blocată",
    KARCHER_EVENT_NAME_17: "Stația de spălare 8 blocată",
    KARCHER_EVENT_NAME_18: "Actualizare începută",
    KARCHER_EVENT_NAME_19: "Actualizare finalizată",
    KARCHER_EVENT_NAME_20: "Pornire WS Reg",
    KARCHER_EVENT_NAME_21: "Finalizare WS Reg",
    KARCHER_EVENT_NAME_22: "Senzor WS 75%",
    KARCHER_EVENT_NAME_23: "Defecțiune tehnică",
    KARCHER_EVENT_NAME_24: "Defecțiune operațională",
    KARCHER_EVENT_NAME_25: "Dispozitiv pornit",
    KARCHER_EVENT_NAME_26: "Dispozitiv oprit",
    KARCHER_EVENT_NAME_27: "Cutia 1 închisă",
    KARCHER_EVENT_NAME_28: "Cutia 2 închisă",
    KARCHER_EVENT_NAME_29: "Cutia 3 închisă",
    KARCHER_EVENT_NAME_30: "Cutia 4 închisă",
    KARCHER_EVENT_NAME_31: "Cutia 5 închisă",
    KARCHER_EVENT_NAME_32: "Cutia 6 închisă",
    KARCHER_EVENT_NAME_33: "Cutia 7 închisă",
    KARCHER_EVENT_NAME_34: "Cutia 8 închisă",
    KARCHER_EVENT_NAME_35: "Stația pompei HP 1",
    KARCHER_EVENT_NAME_36: "Stația pompei HP 2",
    KARCHER_EVENT_NAME_37: "Stația pompei HP 3",
    KARCHER_EVENT_NAME_38: "Stația pompei HP 4",
    KARCHER_EVENT_NAME_39: "Stația pompei HP 5",
    KARCHER_EVENT_NAME_40: "Stația pompei HP 6",
    KARCHER_EVENT_NAME_41: "Stația pompei HP 7",
    KARCHER_EVENT_NAME_42: "Stația pompei HP 8",
    KARCHER_EVENT_NAME_43: "Arzător",
    KARCHER_EVENT_NAME_44: "Ventilatorul arzătorului",
    KARCHER_EVENT_NAME_45: "Pompa de apă caldă",
    KARCHER_EVENT_NAME_46: "Pompa de protecție împotriva înghețului",
    KARCHER_EVENT_NAME_47: "Pompa osmozei",
    KARCHER_EVENT_NAME_48: "Încălzire prin pardoseală",
    KARCHER_EVENT_NAME_49: "Încălzire furtun",
    KARCHER_EVENT_NAME_50: "Curățarea micro / jantelor",
    KARCHER_EVENT_NAME_51: "Pompa de spălare a șasiului",
    KARCHER_EVENT_NAME_52: "Pompa de spumă Booster",
    KARCHER_EVENT_NAME_53: "Aspirator 1",
    KARCHER_EVENT_NAME_54: "Aspirator 2",
    KARCHER_EVENT_NAME_55: "Aspirator 3",
    KARCHER_EVENT_NAME_56: "Aspirator 4",
    KARCHER_EVENT_NAME_57: "Aspirator 5",
    KARCHER_EVENT_NAME_58: "Aspirator 6",
    KARCHER_EVENT_NAME_59: "Aspirator 7",
    KARCHER_EVENT_NAME_60: "Aspirator 8",
    KARCHER_EVENT_NAME_61: "Aspirator 9",
    KARCHER_EVENT_NAME_62: "Aspirator 10",
    KARCHER_EVENT_NAME_63: "Aspirator 11",
    KARCHER_EVENT_NAME_64: "Aspirator 12",
    KARCHER_EVENT_NAME_65: "Pompa de curățare a jantelor",
    KARCHER_EVENT_NAME_66: "Pompa micro",
    KARCHER_EVENT_NAME_67: "Pompa intensivă",
    KARCHER_EVENT_NAME_68: "Turbina aspirator 1",
    KARCHER_EVENT_NAME_69: "Filtru aspirator 1",
    KARCHER_EVENT_NAME_70: "Turbina aspirator 2",
    KARCHER_EVENT_NAME_71: "Filtru aspirator 2",
    KARCHER_EVENT_NAME_72: "Turbina aspirator 3",
    KARCHER_EVENT_NAME_73: "Filtru aspirator 3",
    KARCHER_EVENT_NAME_74: "Turbina aspirator 4",
    KARCHER_EVENT_NAME_75: "Filtru aspirator 4",
    KARCHER_EVENT_NAME_76: "Turbina aspirator 5",
    KARCHER_EVENT_NAME_77: "Filtru aspirator 5",
    KARCHER_EVENT_NAME_78: "Turbina aspirator 6",
    KARCHER_EVENT_NAME_79: "Filtru aspirator 6",
    KARCHER_EVENT_NAME_80: "Turbina aspirator 7",
    KARCHER_EVENT_NAME_81: "Filtru aspirator 7",
    KARCHER_EVENT_NAME_82: "Turbina aspirator 8",
    KARCHER_EVENT_NAME_83: "Filtru aspirator 8",
    KARCHER_EVENT_NAME_84: "Turbina aspirator 9",
    KARCHER_EVENT_NAME_85: "Filtru aspirator 9",
    KARCHER_EVENT_NAME_86: "Turbina aspirator 10",
    KARCHER_EVENT_NAME_87: "Filtru aspirator 10",
    KARCHER_EVENT_NAME_88: "Turbina aspirator 11",
    KARCHER_EVENT_NAME_89: "Filtru aspirator 11",
    KARCHER_EVENT_NAME_90: "Turbina aspirator 12",
    KARCHER_EVENT_NAME_91: "Filtru aspirator 12",
    INSERT_TOKEN: "Introduceți token-urile și porniți serviciul",
    OPEN_SESSION: "Sesiune deschisă cu succes",
    IN_PROGRESS: "În desfășurare ...",
    TOKEN_INSERTED: "Token-urile au fost introduse cu succes",
    EXPIRED_SESSION: "Sesiunea a expirat",
    TWO_DIGIT_INTEGER_VALIDATION: "Utilizați un număr întreg de maximum două cifre",
    KARCHER_OPERATION_COUNTER_1: "Stație de spălare 1 pompă HP",
    KARCHER_OPERATION_COUNTER_2: "Stație de spălare 1 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_3: "Stație de spălare 1 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_4: "Stație de spălare 1 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_5: "Stație de spălare 1 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_6: "Stație de spălare 2 pompă HP",
    KARCHER_OPERATION_COUNTER_7: "Stație de spălare 2 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_8: "Stație de spălare 2 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_9: "Stație de spălare 2 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_10: "Stație de spălare 2 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_11: "Stație de spălare 3 pompă HP",
    KARCHER_OPERATION_COUNTER_12: "Stație de spălare 3 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_13: "Stație de spălare 3 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_14: "Stație de spălare 3 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_15: "Stație de spălare 3 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_16: "Stație de spălare 4 pompă HP",
    KARCHER_OPERATION_COUNTER_17: "Stație de spălare 4 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_18: "Stație de spălare 4 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_19: "Stație de spălare 4 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_20: "Stație de spălare 4 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_21: "Stație de spălare 5 pompă HP",
    KARCHER_OPERATION_COUNTER_22: "Stație de spălare 5 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_23: "Stație de spălare 5 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_24: "Stație de spălare 5 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_25: "Stație de spălare 5 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_26: "Stație de spălare 6 pompă HP",
    KARCHER_OPERATION_COUNTER_27: "Stație de spălare 6 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_28: "Stație de spălare 6 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_29: "Stație de spălare 6 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_30: "Stație de spălare 6 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_31: "Stație de spălare 7 pompă HP",
    KARCHER_OPERATION_COUNTER_32: "Stație de spălare 7 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_33: "Stație de spălare 7 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_34: "Stație de spălare 7 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_35: "Stație de spălare 7 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_36: "Stație de spălare 8 pompă HP",
    KARCHER_OPERATION_COUNTER_37: "Stație de spălare 8 pompă chimică 1",
    KARCHER_OPERATION_COUNTER_38: "Stație de spălare 8 pompă chimică 2",
    KARCHER_OPERATION_COUNTER_39: "Stație de spălare 8 pompă chimică 3",
    KARCHER_OPERATION_COUNTER_40: "Stație de spălare 8 pompă chimică 4",
    KARCHER_OPERATION_COUNTER_41: "Pompă cu osmoză",
    KARCHER_OPERATION_COUNTER_42: "Generator de apă caldă",
    KARCHER_OPERATION_COUNTER_43: "Pompă de protecție împotriva înghețului",
    KARCHER_OPERATION_COUNTER_44: "Cartușe de filtrare WSO",
    KARCHER_OPERATION_COUNTER_45: "Pompă de încălzire stație de spălare",
    KARCHER_OPERATION_COUNTER_46: "Pompă de apă caldă",
    KARCHER_OPERATION_COUNTER_47: "Încălzitor pentru furtunuri de spumă",
    KARCHER_OPERATION_COUNTER_48: "Pompă pentru spălarea roților",
    KARCHER_OPERATION_COUNTER_49: "Pompă de microemulzie",
    KARCHER_OPERATION_COUNTER_50: "Pompă pentru spumă intensă",
    KARCHER_OPERATION_COUNTER_51: "Aspirator 1 turbină 1",
    KARCHER_OPERATION_COUNTER_52: "Aspirator 1 filtru 1",
    KARCHER_OPERATION_COUNTER_53: "Aspirator 1 turbină 2",
    KARCHER_OPERATION_COUNTER_54: "Aspirator 1 filtru 2",
    KARCHER_OPERATION_COUNTER_55: "Aspirator 2 turbină 1",
    KARCHER_OPERATION_COUNTER_56: "Aspirator 2 filtru 1",
    KARCHER_OPERATION_COUNTER_57: "Aspirator 2 turbină 2",
    KARCHER_OPERATION_COUNTER_58: "Aspirator 2 filtru 2",
    KARCHER_OPERATION_COUNTER_59: "Aspirator 3 turbină 1",
    KARCHER_OPERATION_COUNTER_60: "Aspirator 3 filtru 1",
    KARCHER_OPERATION_COUNTER_61: "Aspirator 3 turbină 2",
    KARCHER_OPERATION_COUNTER_62: "Aspirator 3 filtru 2",
    KARCHER_OPERATION_COUNTER_63: "Aspirator 4 turbină 1",
    KARCHER_OPERATION_COUNTER_64: "Aspirator 4 filtru 1",
    KARCHER_OPERATION_COUNTER_65: "Aspirator 4 turbină 2",
    KARCHER_OPERATION_COUNTER_66: "Aspirator 4 filtru 2",
    KARCHER_OPERATION_COUNTER_67: "Aspirator 5 turbină 1",
    KARCHER_OPERATION_COUNTER_68: "Aspirator 5 filtru 1",
    KARCHER_OPERATION_COUNTER_69: "Aspirator 5 turbină 2",
    KARCHER_OPERATION_COUNTER_70: "Aspirator 5 filtru 2",
    KARCHER_OPERATION_COUNTER_71: "Aspirator 6 turbină 1",
    KARCHER_OPERATION_COUNTER_72: "Aspirator 6 filtru 1",
    KARCHER_OPERATION_COUNTER_73: "Aspirator 6 turbină 2",
    KARCHER_OPERATION_COUNTER_74: "Aspirator 6 filtru 2",
    KARCHER_OPERATION_COUNTER_75: "Goliți apa de condens din compresor",
    KARCHER_OPERATION_COUNTER_76: "Verificați sistemul de protecție împotriva înghețului",
    KARCHER_OPERATION_COUNTER_77: "Ventilator arzător",
    KARCHER_OPERATION_COUNTER_78: "Pompă de spumă intensificată",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Lista de date este mai mare de 10000 de articole",
    KARCHER_POINT_NAME_1: "Sărbătoare",
    KARCHER_POINT_NAME_2: "Luni",
    KARCHER_POINT_NAME_3: "Marți",
    KARCHER_POINT_NAME_4: "Miercuri",
    KARCHER_POINT_NAME_5: "Joi",
    KARCHER_POINT_NAME_6: "Vineri",
    KARCHER_POINT_NAME_7: "Sâmbătă",
    KARCHER_POINT_NAME_8: "Duminică",
    KARCHER_POINT_NAME_9: "Aspiratoare Sărbătoare",
    KARCHER_POINT_NAME_10: "Aspiratoare Luni",
    KARCHER_POINT_NAME_11: "Aspiratoare Marți",
    KARCHER_POINT_NAME_12: "Aspiratoare Miercuri",
    KARCHER_POINT_NAME_13: "Aspiratoare Joi",
    KARCHER_POINT_NAME_14: "Aspiratoare Vineri",
    KARCHER_POINT_NAME_15: "Aspiratoare Sâmbătă",
    KARCHER_POINT_NAME_16: "Aspiratoare Duminică",
    KARCHER_POINT_NAME_17: "Iluminare Sărbătoare",
    KARCHER_POINT_NAME_18: "Iluminare Luni",
    KARCHER_POINT_NAME_19: "Iluminare Marți",
    KARCHER_POINT_NAME_20: "Iluminare Miercuri",
    KARCHER_POINT_NAME_21: "Iluminare Joi",
    KARCHER_POINT_NAME_22: "Iluminare Vineri",
    KARCHER_POINT_NAME_23: "Iluminare Sâmbătă",
    KARCHER_POINT_NAME_24: "Iluminare Duminică",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "Cod QR",
    ACCEPT_TERMS_AND_CONDITIONS: "Acceptă termenii și condițiile",
    CREATE_AND_PRINT_VOUCHERS: "Creează și imprimă vouchere",
    CODE_PREFIX_QUESTION: "Prefixul codului nu este introdus",
    CODE_PREFIX_QUESTION_TEXT: "Doriți să continuați fără prefix de cod?",
    ISSUED_DATE: "Data emiterii",
    VOUCHER_VALIDITY_DAYS: "Valabilitatea cuponului (zile)",
    VALIDATION_ONLY_NUMBERS: "Sunt permise doar numere",
    REPRINT_VOUCHERS: "Imprimați copia cuponului",
    EXPIRY_DATE: "Valabil până la"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("plTranslations", {
    MESSAGE:"Message",
    ERROR_TITLE:"Błąd",
    ERROR_MESSAGE:"Wystąpił błąd podczas realizacji zadania”",
    ERROR_LOGIN:"Błąd podczas logowania. Nieprawidłowy adres e-mali lub hasło. Spróbuj ponownie”",
    OK:"OK",
    CANCEL:"Anuluj",
    YES:"Tak",
    NO:"Nie",
    FROM:"Od",
    TO:"Do",
    DELETE:"Usuń",
    SIGN_OUT:"Wyloguj się",
    NAME:"Imię",
    DATE:"Data",
    PIECES:"sztuki",
    HOURS:"Godziny",
    DAYS:"Dni",
    MONTH:"Miesiąc",
    MONTHS:"Miesiące",
    YEAR:"Lata",
    BOX:"Stanowisko / Boks",
    SEARCH:"Szukaj",
    ALL_USERS:"Wszyscy użytkownicy",
    ARE_YOU_SURE:"Powrót?",
    BACK:"Kwota",
    AMOUNT:"Opis",
    DESCRIPTION:"Opis",
    FORGOT_PASSWORD_ERROR_MSG:"Czy jesteś pewien",
    REQUIRED_FIELD:"Pole obowiązkowe",
    LOGOUT_TITLE:"Czy na pewno chcesz się wylogować?",
    LOGOUT_MSG:"Niezachowane zmiany zostaną usunięte",
    ACTIVATION_ACCOUNT:"Pomyślna aktywacja konta, przejdź do ekranu logowania",
    UNKNOWN_ERRROR_NOTIFICATION:"Kontynuuj",
    CONTINUE:"Wystąpił nieznany błąd",
    DATA_NOT_AVAILABLE:"Dane nie są dostępne",
    SELECT:"Wybierz",
    UPLOAD:"Wyślij",
    PHONE:"Telefon",
    WEBSITE:"Strona internetowa",
    WORKING_HOURS:"Godziny pracy",
    INSERT:"Wpisz",
    TEXT:"Tekst",
    CREATED:"Tworzona",
    VALID_UNTIL:"Ważne do",
    SAVE:"Zachowaj",
    TOKENS:"Żetony",
    DELETE_COMPANY_HISTORY:"Usuń historię firmy?",
    DELETE_COMPANY_HISTORY_MESSAGE:" WARNING: After pressing this button, all transactions of your car wash will be permanently deleted! This data cannot be restored after deletion.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Are you sure you want to permanently delete all transaction data?",
    HISTORY_SUCCESSFULY_DELETED:"History successfuly deleted",
    HELP:"Wsparcie",
    VALUE:"Wartość",
    ACTIVATING_ACCOUNT_ERROR:"Wystąpił błąd podczas aktywacji konta R2W. Spróbuj ponownie, gdy problem nie ustąpi, skontaktuj się z support@sempra.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Witamy w myjni samochodowej Kärcher",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Witaj w R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Wpisz i powtórz hasło, aby aktywować swoje konto R2W. Automatyczne logowanie nastąpi po pomyślnej weryfikacji hasła",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Można zmienić ustawienia użytkownika w aplikacji",
    ENTER_NEW_PASSWORD:"Wprowadź nowe hasło",
    REPEAT_NEW_PASSWORD:"Powtórz hasło",
    PASSWORD_MIN_LENGTH:"Hasło musi mieć co najmniej 8 znaków",
    PASSWORD_MAX_LENGHT:"Hasło nie może mieć więcej niż 32 znaki",
    PASSWORD_PATTERN:"Hasło musi zawierać przynajmniej jedną wielką i jedną małą literę",
    PASSWORD_MATCH:"Hasła nie pasują do siebie",
    ACTIVATE:"Aktywuj",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Pomyślnie przesłałeś żądanie. Sprawdź, czy otrzymałeś wiadomość e-mail z potwierdzeniem",
    VALIDATION_REQUIRED:"Pole obowiązkowe",
    VALIDATION_EMAIL:"Nieprawidłowy adres e-mail",
    VALIDATION_INTEGER_NUMBER:"Wprowadzona wartość musi być liczbą całkowitą",
    VALIDATION_HOURS_VALUE:"Wartość musi wynosić pomiędzy 0-23",
    VALIDATION_MINUTES_VALUE:"Wartość musi wynosić pomiędzy 0-59",
    VALIDATION_NOT_A_DATE:"Wprowadzona wartość nie jest datą",
    VALIDATION_FROM:"Data większa od ostatniej daty",
    VALIDATION_TO:"Data mniejsza od początkowej daty",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Podane informacje są już w bazie",
    PASSWORD_VALIDATION_PATTERN_NEW:"Hasło musi zawierać przynajmniej jedną wielką literę i jedną cyfrę. Puste pola nie są dozwolone",
    VALIDATION_PERCENT_VALUE:"Wartość musi wynosić pomiędzy 1-999",
    NUMBERS_ONLY_100:"Numer do 100",
    NUMBERS_ONLY_1000:"Numer do 1000",
    POSITIVE_NUMBERS_ONLY:"Tylko liczba dodatnia",
    GRID_PAGER_PAGE:"Strona",
    GRID_PAGER_ROWS_PER_PAGE:"Wiersze na stronie",
    GRID_PAGER_PAGE_OF:"od",
    BREAD_CRUMBS_HOME:"Główna",
    BREAD_CRUMBS_DASHBOARD_TECH:"Przegląd myjni",
    BREAD_CRUMBS_DETAILS:"Szczegóły",
    BREAD_CRUMBS_SETTINGS:"Ustawienia",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Całkowity raport finansowy z poszczególnych dni",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Raport finansowy dobowy",
    BREAD_CRUMBS_NEW_USER_GROUP:"Tworzenie grupy użytkowników",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Edycja grupy użytkowników",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Tworzenie szablonu kamapanii",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Edycja szablonu kampanii",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Tworzenie kampanii",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Edycja kampanii",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Raport finansowy okresowy",
    LOGIN:"Logowanie",
    EMAIL:"E-mail",
    PASSWORD:"Hasło",
    LANGUAGE:"Język",
    FORGOT_PASSWORD:"Zapomniałeś hasło?",
    SUBMIT:"Zatwierdź",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Liczba oczekujących alarmów",
    HEADER_VIEW_ALL_ALARMS:"Zobacz wszystkie alarmy…",
    HEADER_MY_ACCOUNT:"Moje konto",
    HEADER_ACCOUNT_MANAGEMENT:"Zarządzanie kontami",
    ACCOUNT_ALREADY_EXIST:"Adres e-mail jest już zajęty",
    NEWSLETTER_CONFIRMATION:"Wyślij powiadomienie e-mailem o stanie alarmów",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Dzienny przegląd finansowy",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Przegląd myjni",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Deska rozdzielcza",
    ASIDE_MENU_ALARMS:"Alarmy",
    ASIDE_MENU_FACILITIES:"Myjnie",
    ASIDE_MENU_REPORTS:"Raporty",
    ASIDE_MENU_LOYALTY:"Kampanie",
    ASIDE_MENU_USER_GROUPS:"Grupy użytkowników",
    ASIDE_MENU_PERIODIC_SUMMARY:"Przegląd okresowy",
    ASIDE_MENU_NEWS:"Wiadomości",
    DAILY_FINANCES_TOTAL_MONEY:"Całkowita suma pieniędzy",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Całkowita suma z wszystkich myjni",
    DAILY_FINANCES_TOTAL_COINS:"Łącznie zużytych metalowych tokenów",
    DAILY_FINANCES_DOWNLOAD_CSV:"Pobierz CSV",
    DAILY_FINANCES_ONLINE:"Online",
    DAILY_FINANCES_OFFLINE:"Gotówka",
    DAILY_FINANCES_CHANGER:"Gotówka w rozmieniarce",
    DAILY_FINANCES_COINS:"Żetony",
    REPORTS_FILTER:"Filtr",
    REPORTS_TYPE_OF_REPORT:"Typ raportu",
    REPORTS_CHOOSE_FACILITY:"Wybór myjni",
    REPORTS_PERIOD_1:"Okres 1 – ",
    REPORTS_PERIOD_2:"Okres 2 – ",
    MONEY_BY_DATE_REPORT:"Całkowity raport dzienny",
    R2W_BY_DATE_REPORT:"Wszystkie płatności z poszczególnych dni online",
    COINS_BY_DATE_REPORT:"Liczba wszystkich żetonów z dnia",
    AVG_MONEY_BY_HOUR_REPORT:"Średnia kwota z godziny",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Średnia kwota z dnia",
    AVG_MONEY_BY_BOX_REPORT:"Wydatki przez washbox",
    COMPARE_PERIODS_REPORT:"Raport porównawczy z myjni",
    TOTAL_USERS_BY_GROUP:"Łącznie użytkowników z dnia",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"użytkownicy",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"odwiedziny",
    VISITS_COUNT_REPORT:"Liczba użytkowników według wizyt",
    LOYALTY_PER_DAY_REPORT:"Wydane kredyty z dnia",
    LOYALTY_PER_PAYMENT_METHOD:"Lojalność według sposobu płacenia",
    VISITS:"Wizyty",
    VISIT:"Wizyta",
    TOTAL_SPENT_MONEY:"Całkowita liczba wydanych środków",
    MONEY:"Pieniądze",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Całkowity raport wydanych środków za okres",
    DOWNLOAD_CSV:"Ściągnij CSV",
    TOTAL_SPENT_COINS:"Całkowita liczba wykorzystanych żetonów",
    TOTAL_USERS:"Całkowita liczba użytkowników",
    TOTAL_CREDIT_GIVEN:"Łącznie wydany kredyt",
    EUROKEY_BY_DATE_REPORT:"Całkowity raport płatności EuroKey",
    TOTAL_SPENT_EUROKEY:"Wydane razem",
    SELECT_TYPE_OF_REPORT:"Musisz wybrać rodzaj raportu :)",
    NUMBER_OF_VISITS_TITLE:"Liczba odwiedzin",
    NUMBER_OF_USERS_TITLE:"Liczba użytkowników",
    PIECES_TITLE:"Część",
    TOTAL_VISITS:"Łączna liczba odwiedzin",
    TOKENS_TITLE:"żeton",
    SEARCH_USERS_NO_RESULTS:"Brak użytkowników dla danego kryterium wyszukiwania",
    SEARCH_USERS:"Wyszukiwanie użytkowników",
    SEARCH_TELEPHONES:"Wyszukiwanie według numeru telefonu",
    ADD_USER_TO_GROUP:"Dodaj użytkownika do grupy",
    REMOVE_USER_FROM_GROUP:"Usuń użytkownika z grupy",
    USER_GROUP_NAME_REQUIRED:"Nazwa grupy użytkowników jest obowiązkowa",
    USER_GROUP_NAME:"Nazwa grupy użytkowników",
    USER_GROUPS_OVERVIEW:"Przegląd grupy użytkowników",
    USER_COUNT:"Liczba użytkowników",
    NEW_USER_GROUP:"Utwórz nową grupę użytkowników",
    DELETE_USER_GROUP:"Usuń grupę użytkowników",
    UPDATE_USER_GROUP:"Edytuj grupę użytkowników",
    DELETE_USER_GROUP_ERROR:"Wystąpił błąd podczas usuwania wybranych grup użytkowników. Proszę spróbować ponownie lub skontaktować się z pomocą techniczną…",
    CONFIRM_DELETE_USER_GROUP:"Czy jesteś pewien, że chcesz usunąć wybraną grupę użytkowników?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Działania, które były przypisane grupie nie będą ważne dla użytkowników usuniętej grupy",
    GROUP_NAME_MAX_LENGTH:"Nazwa grupy powinna być mniejsza niż 255 znaków",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Użytkownik należy już do danej grupy",
    MISSING_USER:"Missing user(en)",
    USER_NOT_ON_LIST:"User is not in the active users list. Check if the email address is valid and try again(en).",
    UPLOAD_USER_GROUP:"Upload user group list from *.csv file",
    UKNOWN_USERS:"List of uknown users",
    CAMPAIGN_TEMPLATE_RULE:"Zasada kampanii",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Wystąpił błąd podczas usuwania wybranego szablonu kampanii. Spróbuj ponownie lub skontaktuj się z pomocą techniczną…",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Potwierdź usunięcie wybranego szablonu kampanii",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Czy na pewno chcesz usunąć wybrany szablon kampanii?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Przegląd szablonów kampanii",
    DELETE_CAMPAIGN_TEMPLATE:"Usuń szablon kampanii",
    UPDATE_CAMPAIGN_TEMPLATE:"Aktualizuj szablon kampanii",
    CREATE_CAMPAIGN_TEMPLATE:"Utwórz nowy szablon kampanii",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Wymagana nazwa szablonu kampanii",
    CAMPAIGN_TEMPLATE_NAME:"Nazwa szablonu kampanii",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Pole obowiązkowe",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"upominki %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"Dodatkowy czas",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Najpierw wybierz typ. Myj pudła lub małe maszyny.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Usuń regułę",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"godziny",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuty",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nowa reguła w zależności od liczby wizyt",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nowa reguła przez ilość żetonów spędził",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nowa zasada w zależności od dnia tygodnia",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Dodaj nową zasadę",
    CAMPAIGN_TEMPLATE_RULE_1:"Każdy / Wszystkich",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Każdy / Wszystkich",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"Żetony za mniej niż",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"wizyty za mniej niż",
    CAMPAIGN_TEMPLATE_RULE_3:"dni, podarunki",
    CAMPAIGN_TEMPLATE_RULE_4:"Żetony",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Lista zasad jest pusta",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Data nie może być w przeszłości",
    DELETE_CAMPAIGN_ERROR:"Wystąpił błąd podczas usuwania wybranej kampanii. Spróbuj ponownie lub skontaktuj się ze wsparciem technicznym…",
    CONFIRM_DELETE_CAMPAIGN:"Czy jesteś pewien, że chcesz usunąć daną kampanię?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W nie odpowiada za doświadczenia użytkownika wynikające z tej akcji.",
    CAMPAIGNS_OVERVIEW:"Przegląd kampanii",
    DELETE_CAMPAIGN:"Usuń kampanię",
    UPDATE_CAMPAIGN:"Aktualizuj kampanię",
    CREATE_CAMPAIGN:"Utwórz nową kampanię",
    CAMPAIGN_ACTIVE:"Aktywna",
    CAMPAIGN_TEMPLATE:"Szablon",
    CAMPAIGN_GROUPS:"Grupy",
    CAMPAIGN_ALL_USERS:"Wszyscy użytkownicy",
    CAMPAIGN_NAME:"Nazwa kampanii",
    CAMPAIGN_NAME_REQUIRED:"Wymagana nazwa kampanii",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Użytkownicy blisko limitu dziennej premii",
    MESSAGE_TO_USERS:"Wiadomość do wybranych użytkowników",
    SEND_MESSAGE:"Wyślij wiadomość",
    THRESHOLD:"Limit",
    TYPE:"Typ",
    TOTAL_MONEY_SPENT:"Całkowita suma środków wydanych w kampanii",
    NUMBER_OF_VISITS:"Całkowita liczba wizyt w ramach kampanii",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Wiadomość musi mieć co najmniej 10 znaków",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Wiadomość nie może mieć więcej niż 350 znaków",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Tekst wiadomości jest obowiązkowy",
    TECHNOLOGY:"Technologia",
    TAP_WATER:"Woda z kranu",
    REVERSE_OSMOSIS:"Odwrócona osmoza",
    SOFTENED_WATER:"Zmiękczona woda",
    DOSER:"Dozownik",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Ostatnia synchronizacja",
    NO_OF_CURRENT_ALARMS:"Liczba bieżących alarmów",
    NO_OF_CURRENT_WARNINGS:"Liczba bieżących ostrzeżeń",
    WEATHER:"Pogoda",
    BOXES_WORK_HOURS_COUNTERS:"Licznik godzin pracy boksu",
    BOX_TOTAL_HOURS:"Całkowita liczba godzin pracy",
    BOX_SERVICE_HOURS:"Całkowita liczba godzin pracy (serwis)",
    BOX_COUNTER_HOURS:"Godziny",
    ALARMS_AND_WARNINGS:"Alarmy i ostrzeżenia",
    FILTER_AND_BOILER:"Filtr i bojler",
    FILTER_TOTAL_DAYS:"Dni pracy filtra",
    BOILER_TOTAL_DAYS:"Dni pracy bojlera",
    DAYS_UNIT:"dni",
    SOFTENER:"Zmiękczacz",
    MANUAL_COLD_DRAIN:"Ręczny odpływ zimnej wody",
    EL_COLD:"El. zimny",
    DRAIN:"odpływ",
    TAP:"kran",
    WASTE:"Odpad",
    OSMOSIS:"osmoza",
    DEMI_WATER:"Woda deminaralna",
    EL_RINSE:"El. m. płukanie",
    BOILER:"Bojler",
    EL_WAX:"El. m. wosk",
    FLOOR_HEATING:"Ogrzewanie podłogowe",
    DOSER_TANK:"Zbiornik dozownika",
    EL_WASH:"El. m. mycia",
    DETERGENT:"Detergent",
    VIBRATOR:"Wibrator",
    UPDATE_FACILITY_SETTINGS:"Aktualizacja ustawień myjni",
    GENERAL_SETTINGS:"Ustawienia ogólne",
    LIGHTS:"Światło",
    GROUPS:"Grupy",
    ANTI_FREEZE:"Środek przeciw zamarzaniu",
    AUTO:"Auto",
    MANUAL:"Ręcznie",
    ON:"Włączone",
    OFF:"Wyłączone",
    TEMPERATURE:"Temperatura",
    UPDATE_DEVICE:"Aktualizacja ustawień myjni",
    BOX_CLEAN_HOURS:"Licznik godzin pracy stanowiska (czyszczenie)",
    GROUP_COUNTERS:"Liczniki grup",
    RESET:"Reset",
    CASH_COUNT:"Licznik monet",
    COINS_COUNT:"Licznik żetonów",
    EUROKEY_COUNT:"Licznik Eurokey",
    DOSER_WORK:"Czas pracy dozownika (sec.)",
    DOSER_PAUSE:"Czas przerwy dozownika (sec.)",
    DELAY_BFV:"BFV opóźnienie (ms)",
    DELAY_6M1:"6M1 opóźnienie (ms)",
    DELAY_LPS:"LPS opóźnienie (ms)",
    RESET_CASH_COUNT_ALL:"Wyzerowanie wszystkich liczników monet",
    RESET_COINS_COUNT_ALL:"Wyzerowanie wszystkich liczników żetonów",
    RESET_EUROKEY_COUNT_ALL:"Wyzerowanie wszystkich liczników Eurokey",
    FACILITY_DETAILS:"Szczegóły myjni",
    FACILITY_NAME:"Nazwa myjni",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Pomyślne przesłanie obrazu",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Pomyślna zmiana danych",
    CONNECTED:"połączony",
    OFFLINE:"niepowiązany",
    MESSAGES_FILTER:"Filtr wiadomości",
    FACILITY:"Myjnia",
    APPLY:"Zastosuj",
    TIME:"Czas",
    LOCATION:"Lokalizacja",
    ACKNOWLEDGED:"Potwierdzone",
    FILTERED_MESSAGES:"Przefiltrowane wiadomości",
    ACK:"Potwierdzone",
    NOT_ACK:"Nie potwierdzone",
    ALL:"Wszystkie / Wszystko",
    ALL_FACILITIES:"Wszystkie myjnie",
    ENTER_DATE_PLACEHOLDER:"Wprowadź datę",
    OP_NESTANAK_NAPONA:"Awaria zasilania – 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Błąd pompy MZS",
    OP_UPR_NAPON_24VAC_GRE:"Kierowanie napięciem 24 V AC błąd wyłącznika obwodu – 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Pusty zbiornik świeżej wody",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Wyłączony wyłącznik pompy wodnej",
    OP_MIN_NIVO_OMEKS_VODE:"Pusty zbiornik zmiękczonej wody",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Błąd wyłącznika pompy zmiękczonej wody",
    OP_MIN_NIVO_DEMIN_VODE:"Pusty zbiornik wody osmotycznej",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Błąd wyłącznika pompy wody osmotycznej",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Błąd wyłącznika pompy produkujące osmozę",
    OP_BOJLER_GRESKA_MZS:"Błąd bojlera",
    OP_CRPKA_PRASKA_GRE_MZS:"Błąd wyłącznika pompy bojlera",
    OP_DOZATOR_PRASKA_GRE_MZS:"Błąd wyłącznika dozującego proszek",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Błąd wyłącznika wibratora dozującego proszek",
    OP_MIN_PRASAK_TON_ALARM:"Pusty zbiornik mieszający proszek",
    OP_USIS_KOV_TURBINA_GRESKA:"Błąd wyłącznika turbiny zasysającej monety",
    OP_FILTER_VODE_ZACEPLJEN:"Zablokowany filtr wody",
    OP_VISKTL_RESET_SATI_RADA:"Serwis pompy wysokociśnieniowej",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Serwis filtra",
    OP_BOJLER_DANI_RADA:"Serwis bojlera",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm pompy wysokociśnieniowej",
    OPW_ALARM_FILTER_SERVIS:"Alarm serwisu filtra",
    OPW_ALARM_BOJLER_SERVIS:"Alarm serwisu bojlera",
    HAS_MEMBERS:"Wybrana grupa ma członków i nie można jej usunąć. Członkowie muszą zostać najpierw usunięci.",
    PERIODIC_SUMMARY_FOR:"OKRESOWE PODSUMOWANIE ZA",
    PERIODIC_SUMMARY_REPORTS:"Okresowe podsumowanie",
    DATE_RANGE:"Zakres dat",
    FINANCIAL_REPORT:"Raport finansowy",
    GROSS_INCOME:"Całkowity przychód",
    GROSS_INCOME_SUM:"Suma całkowitego przychodu",
    COMMISSION_FEE:"Prowizje",
    NET_INCOME:"Zysk netto (do rozliczenia)",
    COMMISSION_FEE_DETAILS:"Prowizja obejmuje transakcje bankowe / PayPal lub usługodawcę usług SMS",
    LOYALTY_CREDITS_REPORT:"Raport dotyczący lokalnych tokenów",
    LOYALTY_GIVEN:"Biorąc pod uwagę lokalne żetony",
    LOYALTY_USED:"Używane lokalne tokeny",
    LOYALTY_SOLD:"Załadowano lokalne tokeny",
    LOYALTY_TOTAL:"Całkowity",
    LOYALTY_CURRENT_MONTH:"Bieżący miesiąc",
    SOMETHING_WENT_WRONG:"Uuuuuuuuuuups, pojawił się błąd :-(",
    MISSING_PAGE:"Nie można odnaleźć podanej strony",
    TRY_AGAIN:"Spróbuj ponownie",
    DEFAULT_ERROR_NAME:"Wystąpił nieznany błąd",
    DEFAULT_ERROR_DESCRIPTION:"Spróbuj ponownie, jeśli problem będzie się powtarzał skontaktuj się z upoważnioną osobą",
    MY_ACCOUNT_DETAILS:"Szczegóły konta użytkownika",
    SAVE_CHANGES:"Zachowaj zmiany",
    USERNAME:"Nazwa użytkownika",
    FIRST_NAME:"Imię",
    LAST_NAME:"Nazwisko",
    USER_ROLE:"Grupa użytkowników",
    OLD_PASSWORD:"Stare hasło",
    NEW_PASSWORD:"Nowe hasło",
    OLD_PASSWORD_REQUIRED:"Stare hasło jest wymagane",
    NEW_PASSWORD_REQUIRED:"Nowe hasło jest wymagane",
    NEW_PASSWORD_REPEAT:"Powtórzenie nowego hasła jest wymagane",
    NEW_PASSWORD_NOT_MATCH:"Stare i nowe hasła nie są identyczne",
    PASSWORD_DIFFERENT_VALIDATION:"Nowe hasło musi być inne od starego",
    PASSWORD_MIN_CHAR:"Twoje hasło musi mieć przynajmniej 8 znaków",
    PASSWORD_MAX_CHAR:"Twoje hasło musi mieć maksymalnie 32 znaki",
    PASSWORD_PATTERN_VALIDATION:"Hasło powinno mieć przynajmniej jedną cyfrę, jedną małą i jedną wielką literę",
    ACCOUNT_MANAGEMENT:"Zarządzanie użytkownikami",
    NOT_ACTIVE:"Nieaktywny",
    ASSIGN_ROLE:"Grupa użytkowników",
    UPDATE:"Aktualizuj",
    ADD_NEW_ACCOUNT:"Dodawanie nowego użytkownika",
    EMAIL_REQUIRED:"Adres e-mail jest obowiązkowy",
    EMAIL_NOT_VALID:"Adres e-mail nie jest poprawny",
    ADD_NEW_USER_TEXT:"E-mail z linkiem aktywacyjnym zostanie wysłany na podany adres",
    UPDATE_USER_NOTIFICATION:"Pomyślnie zaktualizowane dane",
    CHANGED_PASSWORD_NOTIFICATION:"Pomyślna zmiana hasła",
    UPDATE_USER_GROUP_NOTIFICATION:"Pomyślna zmiana nazwy grupy",
    CREATE_USER_GROUP_NOTIFICATION:"Pomyślnie utworzono grupę",
    DETELE_USER_GROUP_NOTIFICATION:"Pomyślnie usunięto grupę",
    EMPTY_GROUP_LIST_MSG:"Nie ma utworzonej grupy. Rozpocznij od utworzenia grupy",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Pomyślnie usunięto użytkownika z grupy",
    ADD_USER_TO_GROUP_NOTIFICATION:"Pomyślnie dodano użytkownika do grupy",
    ADD_USER_NOTIFICATION:"Pomyślnie dodanie nowego użytkownika",
    DELETE_USER_NOTIFICATION:"Pomyślnie usunięto użytkownika",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Aby utworzyć grupę użytkowników proszę wpisać nazwę grupy",
    DELETE_USER:"Usuwanie użytkownika",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Czy jesteś pewien, że chcesz usunąć użytkownika z grupy?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Szanowni Państwo, jeśli odwiedzicie nas w trakcie trwania kampanii otrzymacie dodatkowy bonus na koncie",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Zasady kampanii za liczbę wizyt",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Zasady kampanii za wydane środki finansowe",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Zasady kampanii na dni tygodnia",
    REMOVE_CAMPAIGN_RULE_TITLE:"Usuwanie zasad kampanii",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Czy na pewno chcesz usunąć zasadę kampanii?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Pomyślnie zachowana zasada kampanii",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Pomyślna aktywacja kampanii",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Brak utworzonych kampanii. Aby rozpocząć należy utworzyć pierwszą",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Pomyślnie wysłano wiadomość",
    COMPANY_ACCOUNTS:"Konta firmowe",
    BUSSINESS_INVOICES_LIST:"Moje faktury B2B",
    LOCALE_TOKEN:"Lokalny token",
    R2W:"Globalny token",
    START_MONTH:"Rozpocznij miesiąc",
    END_MONTH:"Koniec miesiąca",
    TOKEN_TYPE:"Typ tokena",
    TOKEN_NUMBER:"Numer tokena",
    NOTHING_TO_DISPLAY:"* Nic do wyświetlenia",
    CREATE_INVOICE:"Nowa Faktura",
    INVOICE:"Faktura",
    INVOICES:"Faktury",
    EDIT_INVOICE:"Zmień Fakturę",
    UPDATE_INVOICE_NOTIFICATION:"Pomyślna zmiana statusu faktury na 'w realizacji'",
    CURRENT_CHARGES:"Obciążenia za bieżący okres",
    PAYMENTS_ON_HOLD:"Faktury w realizacji",
    FOR_INVOICING:"Niezafakturowane",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Spróbuj anulować fakturę",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Czy na pewno chcesz anulować fakturę???",
    INVOICING_NOTIFICATION_HEADER:"Masz zamiar wysłać fakturę",
    INVOICING_NOTIFICATION_TEXT:"Czy na pewno chcesz wysłać fakturę?",
    SENT_INVOICE_NOTIFICATION:"Pomyślnie wysłałeś fakturę",
    CANCELED_INVOICE_NOTIFICATION:"Pomyślnie anulowano fakturę",
    INVOICE_DESCRIPTION_TEXT:"Faktura za miesiąc",
    INVOICE_STATE:"Status faktury",
    INVOICE_NUMBER:"Numer faktury",
    INVOICE_TOTAL:"Ogółem",
    SELECT_YEAR:"Wybierz rok",
    DOWNLOAD:"Pobierz PDF",
    INVOICE_NUMBER_HEADER:"Zamierzasz wysłać fakturę z numerem",
    INVOICE_PAYMENT_CONFIRMATION:"Zamierzasz potwierdzić płacenie faktury z numerem",
    INSERT_INVOICE_NUMBER:"Wprowadź numer faktury",
    INVOICED_WARNING:"Email nie został wysłany. Proszę zaczekać…",
    SEND_INVOICE:"Wyślij",
    INVOICE_ALL:"Wszystkie",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Dla R2W",
    PAYMENT_REQUEST:"Prośba o zapłatę",
    PAYMENT_REQUEST_STATE:"Stan żądania płatności",
    PAYMENT_REQUEST_NUMBER:"Numer wniosku o płatność",
    FOR_PAYMENT_REQUEST:"Do żądania zapłaty",
    PAYMENT_REQUEST_ON_HOLD:"Żądanie płatności w przetwarzaniu",
    DOWNLOAD_INVOICE:"Pobierz fakturę",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknij, aby pobrać opcje",
    B2B_SPEC:"B2B Specyfikacja",
    B2C_SPEC:"B2C Specyfikacja",
    DOWNLOAD_PAYMENT_REQUEST:"Pobierz prośbę o płatność",
    LOYALTY_PREVIEW:"Przegląd kampanii",
    ACTIVATED:"Aktywna",
    RUNNING:"Trwa",
    NOT_ACTIVATED:"Nieaktywna",
    FINISHED:"Zakończona",
    DEPRECATED:"Przestarzała",
    UPCOMING:"Nadchodząca",
    NONE:"Nikt",
    STARTED:"Rozpoczęta",
    ENDS:"Kończy się",
    DEDICATED:"Przydzielona",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Masz zamiar aktywować",
    CAMPAIGN:"kampania",
    SEND_MESSAGE_NOTIFICATION:"Czy chcesz wysłać wiadomość wszystkim grupom użytkowników?",
    DIVISIBLE_TO_NUMBER:"Liczba powinna być podzielna za pomocą ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Rodzaj urządzenia",
    LISTENER:"Małe maszyny",
    BRIDGE:"Umyć pudełka",
    WASH_BOXES:"Umyć pudełka",
    VACUUMS:" Vacuums",
    SAVE_NEWS:"Zachowaj wiadomość",
    CREATE_NEW_NEWS:"Utwórz nową wiadomość",
    HISTORY_OF_ALL_NEWS:"Historia wszystkich wiadomości",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Wpisz nazwę myjni",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Dodaj nową myjnię",
    NEWS_TEXT:"Tekst wiadomości",
    NEWS_TITLE:"Tytuł wiadomości",
    DELETE_NEWS_CONFIRMATION:"Chcesz usunąć wiadomość?",
    NEWS_DELETE_NOTIFICATION:"Pomyślnie usunięta wiadomość",
    NEWS_SAVE_NOTIFICATION:"Pomyślnie zachowana wiadomość",
    NEWS_CREATION_DATE:"Data utworzenia",
    NO_TITLE:"Brak tematu",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Tekst wiadomości nie może być dłuższy niż 255 znaków",
    NEWS_TEXT_REQUIRED_VALIDATION:"Tekst wiadomości jest wymagany",
    NEWS_TITLE_REQUIRED_VALIDATION:"Tytuł wiadomości jest wymagany",
    DEACTIVATE:"Dezaktywuj",
    ASIDE_MENU_LOCAL_TOKENS:"Żetony lokalne",
    CREATE_NEW_LOCAL_TOKENS:"Wydawanie nowych lokalnych żetonów",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Wprowadź adres email użytkownika i numer żetonu, który chcesz mu wydać",
    CREATE_TOKENS:"Wydaj żetony",
    MINIMUM_ONE_TOKEN:"Wartość musi być większa od 0",
    CUSTOMER_EMAIL:"Adres email użytkownika",
    AMOUNT_OF_TOKENS:"Liczba żetonów",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Pomyślne wydanie lokalnych tokenów dla",
    PROBLEM_ISSUING_LOCAL_TOKENS:"„Wystąpił błąd podczas wydawania żetonów. Sprawdź adres e-mail użytkownika i spróbuj ponownie",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Przegląd wydanych lokalnych żetonów",
    ISSUED_AT:"Czas wydania",
    ISSUED_BY:"Wydane przez",
    CODE:"Kod",
    REDEEMED_BY:"Wykorzystane przez",
    REDEEMED_AT:"Czas",
    ASIDE_MENU_VOUCHERS:"Kupony",
    PRINT:"Druk",
    VOUCHERS_OVERVIEW:"Przegląd kuponów",
    CREATE_NEW_VOUCHERS:"Tworzenie nowych kuponów",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Utwórz nową serię kuponów wpisując liczbę żetonów w serii i kod prefiksu dla serii",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Ilość żetonów na kupon",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Na jeden kupon można przydzielić od 1 do 100 żetonów",
    NUMBER_OF_NEW_VOUCHERS:"Liczba kuponów w serii",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"W jednej serii można utworzyć od 1 do {{size}} kuponów",
    NEW_VOUCHERS_PREFIX:"Kod prefiksowy kuponu w serii",
    VALIDATION_VOUCHER_PREFIX:"Przedrostek kodu musi składać się z dokładnie 4 znaków (wielkie litery i / lub cyfry)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Wystąpił błąd podczas tworzenia nowych kuponów. Spróbuj ponownie lub skontaktuj się ze wsparciem technicznym",
    CREATE_VOUCHERS:"Utwórz nową serię kuponów",
    CREATING_VOUCHERS_SUCCESS:"Pomyślnie utworzono nową serię kuponów",
    PRINT_NEW_VOUCHERS:"Drukuj kupony",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Wprowadź numer serii kuponów, cały kod lub jego część, aby wydrukować odpowiednie kupony",
    PRINT_VOUCHERS_PREFIX:"Kod prefiksowy (seria) kuponów",
    NO_VOUCHERS_FOR_PRINT:"Brak kuponów do wydruku z wpisanym kodem prefiksowym",
    PRINT_VOUCHERS:"Drukuj kupony",
    VALIDATION_VOUCHER_CODE_FILTER:"Filtr kodu prefiksowego może zawierać od 1 do 16 znaków i obsługuje tylko wielkie litery i liczby",
    FILTER_VOUCHERS_BY_CODE:"Filtr kuponów według kodu",
    FILTER_VOUCHERS:"Search vouchers",
    WASH_BOX:"Umyj pudełko",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Łącznie zużytych cyfrowych tokenów",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Łącznie sprzedane lokalne tokeny według daty",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Łącznie wydane lokalne tokeny według daty",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Łącznie podane lokalne tokeny według daty",
    LOCAL_TOKEN:"Local token ",
    GIVEN_TOKEN:"Given local tokens",
    SOLD_TOKEN:"Sold local tokens",
    SMALL_MACHINES:"Small machines",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Umyj pudełko",
    CODE_PREFIX_EXIST:"Prefiks kodu już istnieje",
    CODE_PREFIX_EXIST_TEXT:"Nie możesz utworzyć nowego kuponu z tym prefiksem kodu. Ustaw inny.",
    MIN_FOUR_VALIDATION:"Dokładnie 4 znaki",
    ALL_INFORMATION_1:"Wszystkie informacje na temat",
    ALL_INFORMATION_2:"będzie zgubiony",
    ASIDE_MENU_TRANSACTIONS:"Transakcje",
    EXPENSES:"Wydatki",
    TOPUPS:"Kupione tokeny",
    EXPENSES_LIST:"Lista wydatków",
    USER_EMAIL:"Adres e-mail użytkownika",
    COMPANY_NAME:"Nazwa firmy",
    TOPUPS_LIST:"Lista zakupionych tokenów",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serial number",
    SETUP_UNIT_MATERIAL_NO:"Material number",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi version",
    TOTAL_TURNOVER:"Wash facility turnover",
    AVAILABILITY_ALL:"Availability",
    AVAILIBILITY:"Wash boxes availability:",
    AVAILABILITY_VACUUMS:"Vacuums availability:",
    WASH_BOX_INFO:"Wash boxes info",
    VACUUM_CLEANER_INFO:"Vacuum cleaners info",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Holidays",
    LIGHTS_ON:"Lights on",
    LIGHTS_OFF:"Lights off",
    WASH_BOXES_ON:"Wash box on",
    WASH_BOXES_OFF:"Wash box off",
    VACUUMS_ON:"Vacuums on",
    VACUUMS_OFF:"Vacuums off",
    TURNOVER:"Turnover",
    TURNOVER_MANUAL_WASH_UNIT:"Turnover manual",
    STATUS_BAY_RUN_TIME:"Wash box total work time",
    STATUS_BAY_PROGRAM_NAME:"Program name",
    STATUS_BAY_CREDIT:"Wash box credit",
    CLOUD_KREDIT:"Cloud credit",
    STATUS_VACUUM_RUN_TIME:"Vacuum total work time",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facility services, wash box program and current fault data information",
    UNAVAILABLE:"Unit is unavailable",
    SHOW_HIDE_TABLE:"Show/hide working hours table",
    PROGRAM_NAME:"Program name",
    PROGRAM_COUNTER:"Program counter",
    NO_NAME:"Reference has no name",
    COUNTER_SERVICE_DATA:"Service data",
    NEED_SERVICE:" Service needed",
    PROGRAM_DATA:"Wash box program data",
    CURRENT_FAULT_DATA:"Current fault data",
    REFERENCE_DUE:"Due",
    REFERENCE_SECONDS:"Seconds",
    REFERENCE_NAME:"Part name",
    WASHBOX_NAME:"Wash box name",
    FAULT_NAME:"Fault name",
    FAULT_NUMBER:"Fault number",
    CURRENT_FAULT_COUNT:"Active faults",
    DEVICE_NOT_INSTALLED:"Device not installed",
    STATUS_READY:"Gotowy status",
    STATUS_ERROR:"Status błędu",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:" Software error",
    SOFTWARE_RESET:" Software error",
    EXTERNAL_PIN_RESET:" Software error",
    RESTART_OR_BROWNOUT_OCCURRED:" Software error",
    DEAD_RM5_CHANNEL_PIN_ERROR:" Hardware error",
    COULD_NOT_SIMULATE_COIN:" Hardware error",
    ERROR_SETTING_INHIBIT_MODE:" Hardware error",
    OFFLINE_DEVICE:" Offline car wash",
    TARIFFS:" Tariffs",
    DAY:" Day",
    NIGHT:" Night",
    VOUCHER_CODE:" Voucher code",
    DISMISS_ALARM:" Reset alarm?",
    ALARM_ACTIVE:" Active alarms",
    NO_ALARM_ACTIVE:" There are no active alarms",
    ALARM_HISTORY:" Alert history",
    MANAGING_TOKENS:"Managing tokens",
    EXPIRATION_DATE:"Expiration date",
    EXTEND_TOKEN_DATE:"Extend token expiration date for",
    DELETE_TOKENS_FOR:"Delete tokens for ",
    PUMP_TYPE:"Pump type",
    TURN_OFF_DEVICE:" Device status",
    OPERATION_DATA:" Operation data",
    PUMP_DATA:" Pump data",
    PUMP_NAME:" Pump name",
    POINT_NAME:" Point name",
    CHANGER_INCOME:" Total changer income by date",
    SELECTED_OPEN:"Otwarte w wybrane godziny pracy",
    ALWAYS_OPEN:"Zawsze otwarte (24/7)",
    CLOSED:"Zamknięte",
    MON:"Poniedziałek",
    TUE:"Wtorek",
    WED:"Środa",
    THU:"Czwartek",
    FRI:"Piątek",
    SAT:"Sobota",
    SUN:"Niedziela ",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    SITE_DETAILS_SUCCESSFULLY_UPDATED: "Site details successfully updated",
    COMPANY: "Company",
    FACILITY_HAS_CHANGER: "Have changer?",
    DISABLE_OFFLINE_ALARM: "Disable R2W alarms",
    ASIDE_WORKING_SCHEDULES: "App Site details",
    TERMS_OF_SERVICE_R2W_TITLE: "Ready2Wash terms of service",
    TERMS_OF_SERVICE_R2W: "Ready2Wash terms of service",
    DATA_PROCESSING_TITLE: "Data Processed",
    PRIVACY_POLICY_TITLE: "Privacy Policy",
    READY_TO_PAY_TERMS_OF_SERVICE: "Ready2Pay Terms of service",
    TERMS_AND_SERVICES: "Terms and services",
    INFO_TITLE: "Info",
    HOURLY: "Co godzinę",
    DAILY: "Codziennie",
    WEEKLY: "Co tydzień",
    MONTHLY: "Co miesiąc",
    YEARLY: "Co roku",
    DELETE_ITEM_SUCCESS:"Pomyślnie usunięto element",
    STATE: "Stan",
    AVAILABILITY_STATUS_1: "Jednostka otwarta",
    AVAILABILITY_STATUS_2: "Jednostka zamknięta (wakacje)",
    AVAILABILITY_STATUS_3: "Jednostka zamknięta (godziny pracy)",
    AVAILABILITY_STATUS_4: "Jednostka zamknięta (awaria)",
    AVAILABILITY_STATUS_5: "Jednostka zamknięta (inne)",
    AVAILABILITY_VACUUMS_STATUS_1: "Odkurzacze nie zainstalowane",
    AVAILABILITY_VACUUMS_STATUS_2: "Odkurzacze otwarte",
    AVAILABILITY_VACUUMS_STATUS_3: "Odkurzacze zamknięte (wakacje)",
    AVAILABILITY_VACUUMS_STATUS_4: "Odkurzacze zamknięte (godziny pracy)",
    AVAILABILITY_VACUUMS_STATUS_5: "Odkurzacze zamknięte (awaria)",
    AVAILABILITY_VACUUMS_STATUS_6: "Odkurzacze zamknięte (inne)",
    ECOM_AMOUNT: "Całkowity Ecom dla wszystkich lokalizacji",
    CAPTURED: "Zarejestrowano",
    G0:"{{brand === 'r2w' ? 'Bay 0' : 'Bay 1'}}",
    G1:"{{brand === 'r2w' ? 'Bay 1' : 'Bay 2'}}",
    G2:"{{brand === 'r2w' ? 'Bay 2' : 'Bay 3'}}",
    G3:"{{brand === 'r2w' ? 'Bay 3' : 'Bay 4'}}",
    G4:"{{brand === 'r2w' ? 'Bay 4' : 'Bay 5'}}",
    G5:"{{brand === 'r2w' ? 'Bay 5' : 'Bay 6'}}",
    G6:"{{brand === 'r2w' ? 'Bay 6' : 'Bay 7'}}",
    G7:"{{brand === 'r2w' ? 'Bay 7' : 'Bay 8'}}",
    G8:"{{brand === 'r2w' ? 'Bay 8' : 'Bay 9'}}",
    G9:"{{brand === 'r2w' ? 'Bay 9' : 'Bay 10'}}",
    G10:"{{brand === 'r2w' ? 'Bay 10' : 'Bay 11'}}",
    U0:"{{brand === 'r2w' ? 'Vacuum 0' : 'Vacuum 1'}}",
    U1:"{{brand === 'r2w' ? 'Vacuum 1' : 'Vacuum 2'}}",
    U2:"{{brand === 'r2w' ? 'Vacuum 2' : 'Vacuum 3'}}",
    U3:"{{brand === 'r2w' ? 'Vacuum 3' : 'Vacuum 4'}}",
    U4:"{{brand === 'r2w' ? 'Vacuum 4' : 'Vacuum 5'}}",
    U5:"{{brand === 'r2w' ? 'Vacuum 5' : 'Vacuum 6'}}",
    U6:"{{brand === 'r2w' ? 'Vacuum 6' : 'Vacuum 7'}}",
    U7:"{{brand === 'r2w' ? 'Vacuum 7' : 'Vacuum 8'}}",
    DELETE_COMPANY_HISTORY_INFO:"Ta akcja usunie wszystkie dane raportów Twojej firmy. Tej akcji nie można cofnąć.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Czy na pewno chcesz trwale usunąć wszystkie dane raportów?",
    VALUE_DATE: "Data waluty",
    KARCHER_EVENT_NAME_1: "Podstawowy wymiennik ciepła zregenerowany",
    KARCHER_EVENT_NAME_2: "Regeneracja podstawowego wymiennika ciepła zakończona",
    KARCHER_EVENT_NAME_3: "Materiał / numer seryjny",
    KARCHER_EVENT_NAME_4: "System został zdezynfekowany",
    KARCHER_EVENT_NAME_5: "Pompa HP 1 zdezynfekowana",
    KARCHER_EVENT_NAME_6: "Pompa HP 2 zdezynfekowana",
    KARCHER_EVENT_NAME_7: "Pompa HP 3 zdezynfekowana",
    KARCHER_EVENT_NAME_8: "Pompa HP 4 zdezynfekowana",
    KARCHER_EVENT_NAME_9: "Pompa HP 5 zdezynfekowana",
    KARCHER_EVENT_NAME_10: "Stacja myjąca 1 zablokowana",
    KARCHER_EVENT_NAME_11: "Stacja myjąca 2 zablokowana",
    KARCHER_EVENT_NAME_12: "Stacja myjąca 3 zablokowana",
    KARCHER_EVENT_NAME_13: "Stacja myjąca 4 zablokowana",
    KARCHER_EVENT_NAME_14: "Stacja myjąca 5 zablokowana",
    KARCHER_EVENT_NAME_15: "Stacja myjąca 6 zablokowana",
    KARCHER_EVENT_NAME_16: "Stacja myjąca 7 zablokowana",
    KARCHER_EVENT_NAME_17: "Stacja myjąca 8 zablokowana",
    KARCHER_EVENT_NAME_18: "Aktualizacja rozpoczęta",
    KARCHER_EVENT_NAME_19: "Aktualizacja zakończona",
    KARCHER_EVENT_NAME_20: "Start WS Reg",
    KARCHER_EVENT_NAME_21: "Koniec WS Reg",
    KARCHER_EVENT_NAME_22: "Czujnik WS 75%",
    KARCHER_EVENT_NAME_23: "Usterka techniczna",
    KARCHER_EVENT_NAME_24: "Usterka operacyjna",
    KARCHER_EVENT_NAME_25: "Jednostka włączona",
    KARCHER_EVENT_NAME_26: "Jednostka wyłączona",
    KARCHER_EVENT_NAME_27: "Skrzynka 1 zamknięta",
    KARCHER_EVENT_NAME_28: "Skrzynka 2 zamknięta",
    KARCHER_EVENT_NAME_29: "Skrzynka 3 zamknięta",
    KARCHER_EVENT_NAME_30: "Skrzynka 4 zamknięta",
    KARCHER_EVENT_NAME_31: "Skrzynka 5 zamknięta",
    KARCHER_EVENT_NAME_32: "Skrzynka 6 zamknięta",
    KARCHER_EVENT_NAME_33: "Skrzynka 7 zamknięta",
    KARCHER_EVENT_NAME_34: "Skrzynka 8 zamknięta",
    KARCHER_EVENT_NAME_35: "Stacja pomp HP 1",
    KARCHER_EVENT_NAME_36: "Stacja pomp HP 2",
    KARCHER_EVENT_NAME_37: "Stacja pomp HP 3",
    KARCHER_EVENT_NAME_38: "Stacja pomp HP 4",
    KARCHER_EVENT_NAME_39: "Stacja pomp HP 5",
    KARCHER_EVENT_NAME_40: "Stacja pomp HP 6",
    KARCHER_EVENT_NAME_41: "Stacja pomp HP 7",
    KARCHER_EVENT_NAME_42: "Stacja pomp HP 8",
    KARCHER_EVENT_NAME_43: "Palnik",
    KARCHER_EVENT_NAME_44: "Wentylator palnika",
    KARCHER_EVENT_NAME_45: "Pompa ciepłej wody",
    KARCHER_EVENT_NAME_46: "Pompa przeciwzamrożeniowa",
    KARCHER_EVENT_NAME_47: "Pompa osmotyczna",
    KARCHER_EVENT_NAME_48: "Ogrzewanie podłogowe",
    KARCHER_EVENT_NAME_49: "Podgrzewanie węża",
    KARCHER_EVENT_NAME_50: "Czyszczenie mikro / felg",
    KARCHER_EVENT_NAME_51: "Pompa do mycia podwozia",
    KARCHER_EVENT_NAME_52: "Pompa Boostera piany",
    KARCHER_EVENT_NAME_53: "Odkurzacz 1",
    KARCHER_EVENT_NAME_54: "Odkurzacz 2",
    KARCHER_EVENT_NAME_55: "Odkurzacz 3",
    KARCHER_EVENT_NAME_56: "Odkurzacz 4",
    KARCHER_EVENT_NAME_57: "Odkurzacz 5",
    KARCHER_EVENT_NAME_58: "Odkurzacz 6",
    KARCHER_EVENT_NAME_59: "Odkurzacz 7",
    KARCHER_EVENT_NAME_60: "Odkurzacz 8",
    KARCHER_EVENT_NAME_61: "Odkurzacz 9",
    KARCHER_EVENT_NAME_62: "Odkurzacz 10",
    KARCHER_EVENT_NAME_63: "Odkurzacz 11",
    KARCHER_EVENT_NAME_64: "Odkurzacz 12",
    KARCHER_EVENT_NAME_65: "Pompa do czyszczenia felg",
    KARCHER_EVENT_NAME_66: "Pompa mikro",
    KARCHER_EVENT_NAME_67: "Pompa intensywna",
    KARCHER_EVENT_NAME_68: "Turbina odkurzacza 1",
    KARCHER_EVENT_NAME_69: "Filtr odkurzacza 1",
    KARCHER_EVENT_NAME_70: "Turbina odkurzacza 2",
    KARCHER_EVENT_NAME_71: "Filtr odkurzacza 2",
    KARCHER_EVENT_NAME_72: "Turbina odkurzacza 3",
    KARCHER_EVENT_NAME_73: "Filtr odkurzacza 3",
    KARCHER_EVENT_NAME_74: "Turbina odkurzacza 4",
    KARCHER_EVENT_NAME_75: "Filtr odkurzacza 4",
    KARCHER_EVENT_NAME_76: "Turbina odkurzacza 5",
    KARCHER_EVENT_NAME_77: "Filtr odkurzacza 5",
    KARCHER_EVENT_NAME_78: "Turbina odkurzacza 6",
    KARCHER_EVENT_NAME_79: "Filtr odkurzacza 6",
    KARCHER_EVENT_NAME_80: "Turbina odkurzacza 7",
    KARCHER_EVENT_NAME_81: "Filtr odkurzacza 7",
    KARCHER_EVENT_NAME_82: "Turbina odkurzacza 8",
    KARCHER_EVENT_NAME_83: "Filtr odkurzacza 8",
    KARCHER_EVENT_NAME_84: "Turbina odkurzacza 9",
    KARCHER_EVENT_NAME_85: "Filtr odkurzacza 9",
    KARCHER_EVENT_NAME_86: "Turbina odkurzacza 10",
    KARCHER_EVENT_NAME_87: "Filtr odkurzacza 10",
    KARCHER_EVENT_NAME_88: "Turbina odkurzacza 11",
    KARCHER_EVENT_NAME_89: "Filtr odkurzacza 11",
    KARCHER_EVENT_NAME_90: "Turbina odkurzacza 12",
    KARCHER_EVENT_NAME_91: "Filtr odkurzacza 12",
    INSERT_TOKEN: "Wprowadź tokeny i uruchom usługę",
    OPEN_SESSION: "Sesja została pomyślnie otwarta",
    IN_PROGRESS: "W trakcie ...",
    TOKEN_INSERTED: "Tokeny zostały pomyślnie wprowadzone",
    EXPIRED_SESSION: "Sesja wygasła",
    TWO_DIGIT_INTEGER_VALIDATION: "Użyj maksymalnie dwucyfrowej liczby całkowitej",
    KARCHER_OPERATION_COUNTER_1: "Stanowisko mycia 1 pompa HD",
    KARCHER_OPERATION_COUNTER_2: "Stanowisko mycia 1 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_3: "Stanowisko mycia 1 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_4: "Stanowisko mycia 1 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_5: "Stanowisko mycia 1 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_6: "Stanowisko mycia 2 pompa HD",
    KARCHER_OPERATION_COUNTER_7: "Stanowisko mycia 2 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_8: "Stanowisko mycia 2 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_9: "Stanowisko mycia 2 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_10: "Stanowisko mycia 2 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_11: "Stanowisko mycia 3 pompa HD",
    KARCHER_OPERATION_COUNTER_12: "Stanowisko mycia 3 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_13: "Stanowisko mycia 3 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_14: "Stanowisko mycia 3 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_15: "Stanowisko mycia 3 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_16: "Stanowisko mycia 4 pompa HD",
    KARCHER_OPERATION_COUNTER_17: "Stanowisko mycia 4 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_18: "Stanowisko mycia 4 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_19: "Stanowisko mycia 4 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_20: "Stanowisko mycia 4 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_21: "Stanowisko mycia 5 pompa HD",
    KARCHER_OPERATION_COUNTER_22: "Stanowisko mycia 5 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_23: "Stanowisko mycia 5 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_24: "Stanowisko mycia 5 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_25: "Stanowisko mycia 5 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_26: "Stanowisko mycia 6 pompa HD",
    KARCHER_OPERATION_COUNTER_27: "Stanowisko mycia 6 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_28: "Stanowisko mycia 6 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_29: "Stanowisko mycia 6 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_30: "Stanowisko mycia 6 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_31: "Stanowisko mycia 7 pompa HD",
    KARCHER_OPERATION_COUNTER_32: "Stanowisko mycia 7 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_33: "Stanowisko mycia 7 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_34: "Stanowisko mycia 7 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_35: "Stanowisko mycia 7 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_36: "Stanowisko mycia 8 pompa HD",
    KARCHER_OPERATION_COUNTER_37: "Stanowisko mycia 8 pompa środka chemicznego 1",
    KARCHER_OPERATION_COUNTER_38: "Stanowisko mycia 8 pompa środka chemicznego 2",
    KARCHER_OPERATION_COUNTER_39: "Stanowisko mycia 8 pompa środka chemicznego 3",
    KARCHER_OPERATION_COUNTER_40: "Stanowisko mycia 8 pompa środka chemicznego 4",
    KARCHER_OPERATION_COUNTER_41: "Pompa wody osmotycznej",
    KARCHER_OPERATION_COUNTER_42: "Podgrzewacz gorącej wody",
    KARCHER_OPERATION_COUNTER_43: "Pompa ochrony przed zamarzaniem",
    KARCHER_OPERATION_COUNTER_44: "Wkład filtra WSO",
    KARCHER_OPERATION_COUNTER_45: "Pompa ogrzewania myjni",
    KARCHER_OPERATION_COUNTER_46: "Pompa ciepłej wody",
    KARCHER_OPERATION_COUNTER_47: "Ogrzewanie węża pianowego",
    KARCHER_OPERATION_COUNTER_48: "Pompa środka do czyszczenia felg",
    KARCHER_OPERATION_COUNTER_49: "Pompa mikroemulsji",
    KARCHER_OPERATION_COUNTER_50: "Pompa piany intensywnej",
    KARCHER_OPERATION_COUNTER_51: "Ssawka 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Ssawka 1 filtr 1",
    KARCHER_OPERATION_COUNTER_53: "Ssawka 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Ssawka 1 filtr 2",
    KARCHER_OPERATION_COUNTER_55: "Ssawka 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Ssawka 2 filtr 1",
    KARCHER_OPERATION_COUNTER_57: "Ssawka 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Ssawka 2 filtr 2",
    KARCHER_OPERATION_COUNTER_59: "Ssawka 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Ssawka 3 filtr 1",
    KARCHER_OPERATION_COUNTER_61: "Ssawka 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Ssawka 3 filtr 2",
    KARCHER_OPERATION_COUNTER_63: "Ssawka 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Ssawka 4 filtr 1",
    KARCHER_OPERATION_COUNTER_65: "Ssawka 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Ssawka 4 filtr 2",
    KARCHER_OPERATION_COUNTER_67: "Ssawka 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Ssawka 5 filtr 1",
    KARCHER_OPERATION_COUNTER_69: "Ssawka 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Ssawka 5 filtr 2",
    KARCHER_OPERATION_COUNTER_71: "Ssawka 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Ssawka 6 filtr 1",
    KARCHER_OPERATION_COUNTER_73: "Ssawka 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Ssawka 6 filtr 2",
    KARCHER_OPERATION_COUNTER_75: "Spuścić kondensat przy kompresorze",
    KARCHER_OPERATION_COUNTER_76: "Sprawdzić system ochrony przed zamarzaniem",
    KARCHER_OPERATION_COUNTER_77: "Dmuchawa palnika",
    KARCHER_OPERATION_COUNTER_78: "Piana pompy wspomagającej",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Lista danych jest większa niż 10000 pozycji",
    KARCHER_POINT_NAME_1: "Święto",
    KARCHER_POINT_NAME_2: "Poniedziałek",
    KARCHER_POINT_NAME_3: "Wtorek",
    KARCHER_POINT_NAME_4: "Środa",
    KARCHER_POINT_NAME_5: "Czwartek",
    KARCHER_POINT_NAME_6: "Piątek",
    KARCHER_POINT_NAME_7: "Sobota",
    KARCHER_POINT_NAME_8: "Niedziela",
    KARCHER_POINT_NAME_9: "Odkurzacze Święto",
    KARCHER_POINT_NAME_10: "Odkurzacze Poniedziałek",
    KARCHER_POINT_NAME_11: "Odkurzacze Wtorek",
    KARCHER_POINT_NAME_12: "Odkurzacze Środa",
    KARCHER_POINT_NAME_13: "Odkurzacze Czwartek",
    KARCHER_POINT_NAME_14: "Odkurzacze Piątek",
    KARCHER_POINT_NAME_15: "Odkurzacze Sobota",
    KARCHER_POINT_NAME_16: "Odkurzacze Niedziela",
    KARCHER_POINT_NAME_17: "Oświetlenie Święto",
    KARCHER_POINT_NAME_18: "Oświetlenie Poniedziałek",
    KARCHER_POINT_NAME_19: "Oświetlenie Wtorek",
    KARCHER_POINT_NAME_20: "Oświetlenie Środa",
    KARCHER_POINT_NAME_21: "Oświetlenie Czwartek",
    KARCHER_POINT_NAME_22: "Oświetlenie Piątek",
    KARCHER_POINT_NAME_23: "Oświetlenie Sobota",
    KARCHER_POINT_NAME_24: "Oświetlenie Niedziela",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "Kod QR",
    ACCEPT_TERMS_AND_CONDITIONS: "Zaakceptuj warunki korzystania",
    CREATE_AND_PRINT_VOUCHERS: "Utwórz i drukuj kupony",
    CODE_PREFIX_QUESTION: "Prefiks kodu nie jest wprowadzony",
    CODE_PREFIX_QUESTION_TEXT: "Czy chcesz kontynuować bez prefiksu kodu?",
    ISSUED_DATE: "Data wydania",
    VOUCHER_VALIDITY_DAYS: "Ważność kuponu (dni)",
    VALIDATION_ONLY_NUMBERS: "Dozwolone są tylko liczby",
    REPRINT_VOUCHERS: "Drukuj kopię kuponów",
    EXPIRY_DATE: "Ważny do"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("nlTranslations", {
    MESSAGE:"Bericht",
    ERROR_TITLE:"Fout",
    ERROR_MESSAGE:"Er is een fout opgetreden bij het uitvoeren van de functie. ",
    ERROR_LOGIN:"Er is een fout opgetreden tijdens login. Het opgegeven email adres is niet geldig.",
    ERROR_LOGIN_ROLE:"Rol voor huidig applicatiemerk is niet geldig",
    OK:"OK",
    CANCEL:"Annuler ",
    YES:"Ja",
    NO:"Néé ",
    FROM:"Van",
    TO:"Tot",
    DELETE:"Verwijderen ",
    SIGN_OUT:"Log uit",
    NAME:"Naam",
    DATE:"Datum",
    PIECES:"Aantal ",
    HOURS:"uren",
    DAYS:"Dagen",
    MONTH:"Maand",
    MONTHS:"Maanden ",
    YEAR:"Jaar",
    BOX:"Box",
    SEARCH:"Zoek",
    ALL_USERS:"Alle gebruikers ",
    ARE_YOU_SURE:"Weet U zéker?",
    BACK:"Terug",
    AMOUNT:"Bedrag",
    DESCRIPTION:"Omschrijving ",
    FORGOT_PASSWORD_ERROR_MSG:"Er is een fout opgetreden. Controleer uw email adres en probeer het opnieuw.",
    REQUIRED_FIELD:"Verplichte veld",
    LOGOUT_TITLE:"Weet U zéker dat u wilt uitloggen?",
    LOGOUT_MSG:"Alle niet-opgeslagen gegevent gaat u kwijt raken?",
    ACTIVATION_ACCOUNT:"U account was met succes geactiveerd",
    UNKNOWN_ERRROR_NOTIFICATION:"Onebekende fout is opgetreden",
    CONTINUE:"Door gaan",
    DATA_NOT_AVAILABLE:"Gegevens  zijn niet beschikbaar.",
    SELECT:"Selecteer ",
    SELECT_CURRENCY:"Selecteer valuta",
    UPLOAD:"Uploaden",
    PHONE:"Telefoon",
    WEBSITE:"Web pagina",
    WORKING_HOURS:"Openingstijden",
    INSERT:"Invoegen",
    TEXT:"Tekst",
    CREATED:"Gemaakt",
    VALID_UNTIL:"Geldig tot en met",
    SAVE:"Opslaan",
    TOKENS:"Munten",
    DELETE_COMPANY_HISTORY:"Bedrijfsgeschiedenis verwijderen?",
    DELETE_COMPANY_HISTORY_MESSAGE:" WARNING: After pressing this button, all transactions of your car wash will be permanently deleted! This data cannot be restored after deletion.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Are you sure you want to permanently delete all transaction data?",
    HISTORY_SUCCESSFULY_DELETED:"Geschiedenis verwijdert",
    HELP:"Hulp",
    VALUE:"Waarde",
    ACTIVATING_ACCOUNT_ERROR:"Er is een probleem met activatie van uw R2W account. Probeer het opnieuw alstublieft.",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Welkom bij Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Welkom bij R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Voer uw nieuwe wachtwoord en bevestig alstublieft om uw R2W account te activeren. U wordt automatisch ingelogd. ",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"U kunt later uw gebruikersinstellingen in de applicatie wijzigen",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:" Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:" R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Voer uw nieuwe wachtwoord in en bevestig het om het oude wachtwoord te resetten. U wordt automatisch ingelogd in de applicatie bij succes",
    RESET_PASSWORD_WELCOME_MSG_3:"U kunt later uw gebruikersinstellingen in de applicatie wijzigen",
    ENTER_NEW_PASSWORD:"Nieuw wachtwoord invoeren",
    REPEAT_NEW_PASSWORD:"Nieuw wachtwoord herhalen ",
    PASSWORD_MIN_LENGTH:"Wachtwoord moet minstens 8 charactera lang zíjn",
    PASSWORD_MAX_LENGHT:"Wachtwoord mag niet langer dan 32 characters zijn",
    PASSWORD_PATTERN:"Wachtwoord moet minstens een hoofdletter en een klein letter bevatten",
    PASSWORD_MATCH:"Wachtwoorden komen niet overeen",
    ACTIVATE:"Actieveren",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Je verzoek is met succes ingediend. Controleer uw e-mail voor een bevestigingsbericht",
    VALIDATION_REQUIRED:"Verplichte veld",
    VALIDATION_EMAIL:"Ongeldige e-mail adres",
    VALIDATION_INTEGER_NUMBER:"Geheel getal invoeren alstublieft ",
    VALIDATION_HOURS_VALUE:"Waarde moet tussen 0-23 liggen",
    VALIDATION_MINUTES_VALUE:"Waarde moet tussen 0-59 liggen",
    VALIDATION_NOT_A_DATE:"Waarde is geen datum",
    VALIDATION_FROM:"Vanaf de datum later dan tot",
    VALIDATION_TO:"Tot de datum eerder dan vanaf",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Die vermelding bestaat al in de database",
    PASSWORD_VALIDATION_PATTERN_NEW:"Er moet minstens één cijfer, één kleine letter en één hoofdletter zijn. Witte spaties zijn niet toegestaan",
    VALIDATION_PERCENT_VALUE:"Waarde moet tussen 1-1999 liggen",
    NUMBERS_ONLY_100:"Tellende nummer tot en met 100",
    NUMBERS_ONLY_1000:"Tellende nummer tot en met 1000",
    POSITIVE_NUMBERS_ONLY:"Alleen tellende nummers",
    GRID_PAGER_PAGE:"Pagina",
    GRID_PAGER_ROWS_PER_PAGE:"Rijen per pagina",
    GRID_PAGER_PAGE_OF:"van",
    BREAD_CRUMBS_HOME:"Tuis",
    BREAD_CRUMBS_DASHBOARD_TECH:"Dashboard technologie",
    BREAD_CRUMBS_DETAILS:"Details",
    BREAD_CRUMBS_SETTINGS:"Instellingen",
    BREAD_CRUMBS_WORKING_HOURS:"Werkuren",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Verslag van totale omzet per dag",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Verslag van gemiddelde omzet per uur",
    BREAD_CRUMBS_NEW_USER_GROUP:"Gebruikers groep aanmaken",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Gebruikers groep bewerken",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Campagne sjabloon aanmaken",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Campagne sjabloon bewerken",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Campagne aanmaken",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Campagne aanmaken",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Periodiek overzicht",
    LOGIN:"Inloggen",
    EMAIL:"E-mail",
    PASSWORD:"Wachtwoord",
    LANGUAGE:"Taal",
    FORGOT_PASSWORD:"Wachtwoord vergeten?",
    SUBMIT:"Indienen",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Aantal alarmen in behandeling:",
    HEADER_VIEW_ALL_ALARMS:"Bekijk alle alarmen",
    HEADER_MY_ACCOUNT:"Mijn account",
    HEADER_ACCOUNT_MANAGEMENT:"Account beheer",
    ACCOUNT_ALREADY_EXIST:"Deze e-mail adres is al in gebruik",
    NEWSLETTER_CONFIRMATION:"Stuur een e-mailmelding voor de alarmstatus",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Overzicht van de dagelijkse financiën",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Dashboard Technologie",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Dashboard",
    ASIDE_MENU_ALARMS:"Berichten",
    ASIDE_MENU_FACILITIES:"Faciliteiten",
    ASIDE_MENU_REPORTS:"Raporten",
    ASIDE_MENU_REPORT:"Geselecteerd rapport",
    ASIDE_MENU_LOYALTY:"Loyaliteit",
    ASIDE_MENU_USER_GROUPS:"Gebruikers groep",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodieke overzicht",
    ASIDE_MENU_MANAGING_TOKENS:"Tokens beheren",
    ASIDE_MENU_NEWS:"Nieuws",
    DAILY_FINANCES_TOTAL_MONEY:"Totaal omzet",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Totaal omzet voor alle faciliteiten",
    DAILY_FINANCES_TOTAL_COINS:"Totaal gebruikte metalen tokens",
    DAILY_FINANCES_DOWNLOAD_CSV:"CVS downloaden",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Contant geld",
    DAILY_FINANCES_CHANGER:"Contant geld in wisselaar",
    DAILY_FINANCES_COINS:"Munten/Eurokey",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Rapport type",
    REPORTS_CHOOSE_FACILITY:"Faciliteit kiezen",
    REPORTS_PERIOD_1:"Periode 1 - ",
    REPORTS_PERIOD_2:"Periode 2 -",
    MONEY_BY_DATE_REPORT:"Totaal inkomen per datum",
    R2W_BY_DATE_REPORT:"Totaal inkomen uit R2W-munten per datum",
    COINS_BY_DATE_REPORT:"Totaal gebruikte munten per datum",
    AVG_MONEY_BY_HOUR_REPORT:"Gemiddelde inkomen per uur",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Gemiddelde inkomen per dag van de week",
    AVG_MONEY_BY_BOX_REPORT:"Uitgaven per box",
    COMPARE_PERIODS_REPORT:"Vergelijkend verslag van de faciliteit",
    TOTAL_USERS_BY_GROUP:"Totaal R2W app bezoekers per dag",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"gebruikers",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"bezoeken",
    VISITS_COUNT_REPORT:"Aantal R2W app gebruikers per bezoek",
    LOYALTY_PER_DAY_REPORT:"Aantal Lokale munten uitgegeven per dag",
    LOYALTY_PER_PAYMENT_METHOD:"Gegeven lokale munten per betaalmethode",
    VISITS:"Bezoeken",
    VISIT:"Bezoek",
    TOTAL_SPENT_MONEY:"Totaal inkomen",
    MONEY:"Geld",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Totale geld inkomen per periode",
    DOWNLOAD_CSV:"CSV downloaden",
    TOTAL_SPENT_COINS:"Totaal uitgegeven munten ",
    TOTAL_USERS:"Totaal gebruikers",
    TOTAL_CREDIT_GIVEN:"Totaal gebruikte lokale virtuele munten",
    EUROKEY_BY_DATE_REPORT:"Totaal Eurokey betalingen per datum",
    TOTAL_SPENT_EUROKEY:"Totaal uitgegeven",
    SELECT_TYPE_OF_REPORT:"U moet het type rapport selecteren",
    NUMBER_OF_VISITS_TITLE:"Aantal bezoeken ",
    NUMBER_OF_USERS_TITLE:"Aantal gebruikers",
    PIECES_TITLE:"Stukken",
    TOTAL_VISITS:"Totaal bezoeken",
    TOKENS_TITLE:"munten",
    SEARCH_USERS_NO_RESULTS:"Geen gebruikers gevonden voor opgegeven zoekterm",
    SEARCH_USERS:"Zoek gebruikers",
    SEARCH_TELEPHONES:"Zoek gebruikers per mobiele nummer",
    ADD_USER_TO_GROUP:"Gebruiker aan groep toevoegen",
    REMOVE_USER_FROM_GROUP:"Gebruiker uit groep verwijderen",
    USER_GROUP_NAME_REQUIRED:"Naam gebruikersgroep is vereist",
    USER_GROUP_NAME:"Gebruikersgroep naam",
    USER_GROUPS_OVERVIEW:"Gebruikersgroep overzicht",
    USER_COUNT:"Aantal gebruikers",
    NEW_USER_GROUP:"Nieuwe gebruikersgroep aanmaken",
    DELETE_USER_GROUP:"Gebruikersgroep verwijderen",
    UPDATE_USER_GROUP:"Gebruikersgroep bewerken",
    DELETE_USER_GROUP_ERROR:"Er is een fout opgetreden bij het verwijderen van de geselecteerde gebruikersgroep. Probeer het opnieuw of neem contact op met ondersteuning ...",
    CONFIRM_DELETE_USER_GROUP:"Weet u zeker dat u de geselecteerde gebruikersgroep wilt verwijderen?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Loyaliteitsacties waaraan de verwijderde groep is toegewezen, worden niet meer toegepast.",
    GROUP_NAME_MAX_LENGTH:"De groepsnaam mag niet langer zijn dan 255 tekens",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Gebruiker is al in deze groep",
    MISSING_USER:"Ontbrekende gebruiker",
    USER_NOT_ON_LIST:"Gebruiker staat niet in de lijst met actieve gebruikers. Controleer of het e-mailadres geldig is en probeer het opnieuw.",
    UPLOAD_USER_GROUP:"Upload gebruikersgroeplijst vanuit * .csv-bestand",
    UKNOWN_USERS:"Lijst van onbekende gebruikers",
    CAMPAIGN_TEMPLATE_RULE:"Sjabloon regel",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Er is een fout opgetreden bij het verwijderen van de campagnesjabloon. Probeer het opnieuw of neem contact op met ondersteuning ...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Weet u zeker dat u de geselecteerde campagnesjabloon wilt verwijderen",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Weet u zeker dat u de geselecteerde campagnesjabloon wilt verwijderen",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Campagnesjabloon overzicht",
    DELETE_CAMPAIGN_TEMPLATE:"Campagnesjabloon verwijderen",
    UPDATE_CAMPAIGN_TEMPLATE:"Campagnesjabloon bewerken",
    CREATE_CAMPAIGN_TEMPLATE:"Nieuwe campagnesjabloon aanmaken",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Naam van campagnesjabloon is vereist",
    CAMPAIGN_TEMPLATE_NAME:"Campagnesjabloon naam",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Verplichte veld",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"geef %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"extra tijd",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Selecteer type als eerst alstublieft. Wasboxen of Kleine machines",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Sjabloon regel verwijderen",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Van",
    CAMPAIGN_TEMPLATE_RULE_TO:"tot",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"uren",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuten",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nieuwe regel per aantal bezoeken",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nieuwe regel per aantal munten uitgegeven",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nieuwe regel per dag van de week",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Nieuwe sjabloon regel",
    CAMPAIGN_TEMPLATE_RULE_1:"Ieder",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Ieder",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"munten uitgegeven in minder dan",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"bezoeken in minder dan",
    CAMPAIGN_TEMPLATE_RULE_3:"dagen",
    CAMPAIGN_TEMPLATE_RULE_4:"munten",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Regellijst is leeg.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum kan niet in het verleden liggen",
    DELETE_CAMPAIGN_ERROR:"Er is een fout opgetreden bij het verwijderen van de campagne. Probeer het opnieuw of neem contact op met ondersteuning ...",
    CONFIRM_DELETE_CAMPAIGN:"Weet u zeker dat u de geselecteerde campagne wilt verwijderen?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W is niet verantwoordelijk voor de gebruikerservaring die door deze actie wordt veroorzaakt.",
    CAMPAIGNS_OVERVIEW:"Campagnes overzicht",
    DELETE_CAMPAIGN:"Campagne verwijderen",
    UPDATE_CAMPAIGN:"Campagne bewerken",
    CREATE_CAMPAIGN:"Nieuwe campagne aanmaken",
    CAMPAIGN_ACTIVE:"Actief",
    CAMPAIGN_TEMPLATE:"Sjabloon",
    CAMPAIGN_GROUPS:"Groepen",
    CAMPAIGN_ALL_USERS:"Alle gebruikers",
    CAMPAIGN_NAME:"Campagnenaam",
    CAMPAIGN_NAME_REQUIRED:"Verplicht",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Aantal gebruikers nabij drempel per dag",
    MESSAGE_TO_USERS:"Bericht aan gefilterde gebruikers",
    SEND_MESSAGE:"Bericht sturen",
    THRESHOLD:"Drempel",
    TYPE:"Type",
    TOTAL_MONEY_SPENT:"Totaal geld besteed aan campagne",
    NUMBER_OF_VISITS:"Aantal bezoeken in campagne",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Bericht minimaal 10 tekens lang zijn",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Bericht moet minder dan 350 tekens lang zijn",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Bericht tekst is verplicht",
    TECHNOLOGY:"Technologie",
    TAP_WATER:"Kraan water",
    REVERSE_OSMOSIS:"Omgekeerde osmose",
    SOFTENED_WATER:"Onthard water",
    DOSER:"Doser",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Laatste synchronisatie",
    NO_OF_CURRENT_ALARMS:"Aantal huidige alarmen",
    NO_OF_CURRENT_WARNINGS:"Aantal huidige waarschuwingen",
    WEATHER:"Het weer",
    BOXES_WORK_HOURS_COUNTERS:"Openingstijden boxen",
    BOX_TOTAL_HOURS:"Totaal openingstijden ",
    BOX_SERVICE_HOURS:"Totaal openingstijden (dienst)",
    BOX_COUNTER_HOURS:"uren",
    ALARMS_AND_WARNINGS:"Alarmen & waarschuwingen",
    FILTER_AND_BOILER:"Filter & ketel",
    FILTER_TOTAL_DAYS:"Filter werk dagen",
    BOILER_TOTAL_DAYS:"Ketel werk dagen",
    DAYS_UNIT:"dagen",
    SOFTENER:"Verzachter",
    MANUAL_COLD_DRAIN:"Handmatige koude afvoer",
    EL_COLD:"El. koud",
    DRAIN:"afvoer",
    TAP:"kraan",
    WASTE:"Verspilling",
    OSMOSIS:"osmosis",
    DEMI_WATER:"Demi water",
    EL_RINSE:"El. m. afspoelling",
    BOILER:"Ketel",
    EL_WAX:"El. m. wax",
    FLOOR_HEATING:"Vloer verwarming",
    DOSER_TANK:"Doseertank",
    EL_WASH:"El. m. afwas",
    DETERGENT:"Afwasmiddel",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Update-instellingen",
    GENERAL_SETTINGS:"Algemene instellingen",
    LIGHTS:"Lichten",
    GROUPS:"Groepen",
    ANTI_FREEZE:"Antivries",
    AUTO:"Auto",
    MANUAL:"Handmatig",
    ON:"Aan",
    OFF:"Uit",
    TEMPERATURE:"Temperatuur",
    UPDATE_DEVICE:"Faciliteiten instellingen bijwerken",
    BOX_CLEAN_HOURS:"Box schoon toonbank",
    GROUP_COUNTERS:"Group toonbank",
    RESET:"Opnieuw instellen",
    CASH_COUNT:"Aantal munten",
    COINS_COUNT:"Aantal tokens",
    EUROKEY_COUNT:"Aantal Eurokeys",
    DOSER_WORK:"Doseer dienst duur (seconden)",
    DOSER_PAUSE:"Doseer pauze tijd (seconden)",
    DELAY_BFV:"BFV vertraging (ms)",
    DELAY_6M1:"6M1 vertraging (ms)",
    DELAY_LPS:"LPS vertraging (ms)",
    RESET_CASH_COUNT_ALL:"Alle munten tellers opnieuw instellen",
    RESET_COINS_COUNT_ALL:"Alle token tellers opnieuw instellen",
    RESET_EUROKEY_COUNT_ALL:"Alle Eurokey tellers opnieuw instellen",
    FACILITY_DETAILS:"Faciliteit details",
    FACILITY_NAME:"Naam faciliteit",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Uw afbeelding is met succes geüpload",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Uw gegevens zijn met succes geüpload",
    CONNECTED:"Verbonden",
    DISCONNECTED:"Verbinding verbroken",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Berichten filter",
    FACILITY:"Faciliteit",
    APPLY:"Toepassen",
    TIME:"Tijd",
    LOCATION:"Locatie",
    ACKNOWLEDGED:"Erkend",
    FILTERED_MESSAGES:"Gefilterde berichten",
    ACK:"Erkend",
    NOT_ACK:"Niet erkend",
    ALL:"Alle",
    ALL_FACILITIES:"Alle faciliteiten",
    ENTER_DATE_PLACEHOLDER:"Datum invoeren",
    OP_NESTANAK_NAPONA:"Ontbrekende spanning op fase-indicator 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"De zekering van de hogedrukpomp is gevallen",
    OP_UPR_NAPON_24VAC_GRE:"Ontbrekende 24VAC - zekering 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Watertank leeg",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Hoofd waterpomp zekering is uitgevallen",
    OP_MIN_NIVO_OMEKS_VODE:"Verzachte watertank is leeg",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Verzachte waterpomp zekering is uitgevallen",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosis watertank is leeg",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Osmosis watertank zekering is uitgevallen",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Osmosis productiepomp zekering is uitgevallen",
    OP_BOJLER_GRESKA_MZS:"Ketel fout melding",
    OP_CRPKA_PRASKA_GRE_MZS:"Heet water zekering is uitgevallen",
    OP_DOZATOR_PRASKA_GRE_MZS:"Poeder doseer motor  zekering is uitgevallen",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Poeder doseer vibratoor zekering is uitgevallen",
    OP_MIN_PRASAK_TON_ALARM:"Poedermengtank leeg",
    OP_USIS_KOV_TURBINA_GRESKA:"Munt stofzuiger turbine zekering is uitgevallen",
    OP_FILTER_VODE_ZACEPLJEN:"Waterfilter verstopt ",
    OP_VISKTL_RESET_SATI_RADA:"Hogedrukpomp servies",
    OPW_VISKTL_RESET_SATI_RADA:"Hogedrukpomp servies",
    OP_FILTER_DANI_RADA:"Waterfilter fout",
    OP_BOJLER_DANI_RADA:"Ketel fout",
    OPW_ALARM_VISOKOTL_PUMPA:"Hogedrukpomp alarm",
    OPW_ALARM_FILTER_SERVIS:"Filter servies alarm",
    OPW_ALARM_BOJLER_SERVIS:"Ketel servies alarm",
    HAS_MEMBERS:"De geselecteerde groep heeft leden en kan niet worden verwijderd. Leden moeten eerst worden verwijderd.",
    PERIODIC_SUMMARY_FOR:"PERIODIEK SAMENVATTEND RAPPORT VOOR",
    PERIODIC_SUMMARY_REPORTS:"Periodieke samenvattend rapport",
    DATE_RANGE:"Datumbereik",
    FINANCIAL_REPORT:"Finantieel rapport",
    GROSS_INCOME:"Bruto inkomen",
    GROSS_INCOME_SUM:"Bruto inkomen som",
    COMMISSION_FEE:"Provisie vergoeding",
    NET_INCOME:"Net inkomen (voor facturering)",
    COMMISSION_FEE_DETAILS:"Provisie vergoeding bevat bank / PayPal provisie of SMS providers dienst vergoeding ",
    LOYALTY_CREDITS_REPORT:"Lokale munten rapport",
    LOYALTY_GIVEN:"Lokale munten uitgegeven",
    LOYALTY_USED:"Lokale munten gebruikt",
    LOYALTY_SOLD:"Lokale munten ingeladen ",
    LOYALTY_TOTAL:"Totaal",
    LOYALTY_CURRENT_MONTH:"Deze maand",
    SOMETHING_WENT_WRONG:"Oooooops",
    MISSING_PAGE:"Sorry. We konden die pagina niet vinden",
    TRY_AGAIN:"Probeer opnieuw",
    DEFAULT_ERROR_NAME:"Onbekende fout opgetreden",
    DEFAULT_ERROR_DESCRIPTION:"Probeer het opnieuw alstublieft ",
    MY_ACCOUNT_DETAILS:"Mijn account gegevens",
    SAVE_CHANGES:"Veranderingen opslaan",
    USERNAME:"Gebruikersnaam",
    FIRST_NAME:"Voornaam",
    LAST_NAME:"Achternaam",
    USER_ROLE:"Gebruikersrol",
    OLD_PASSWORD:"Oud wachtwoord",
    NEW_PASSWORD:"Nieuw wachtwoord",
    OLD_PASSWORD_REQUIRED:"Oud wachtwoord vereist",
    NEW_PASSWORD_REQUIRED:"Nieuw wachtwoord vereist",
    NEW_PASSWORD_REPEAT:"Herhaling van nieuw wachtwoord is vereist",
    NEW_PASSWORD_NOT_MATCH:"Oud en nieuw wachtwoord komen niet overeen",
    PASSWORD_DIFFERENT_VALIDATION:"Het nieuwe wachtwoord moet anders zijn dan het oude",
    PASSWORD_MIN_CHAR:"Uw wachtwoord moet minimaal acht symbolen lang zijn",
    PASSWORD_MAX_CHAR:"Uw wachtwoord mag maximaal 32 symbolen lang zijn",
    PASSWORD_PATTERN_VALIDATION:"Wachtwoord moet minimaal een getal bevatten",
    ACCOUNT_MANAGEMENT:"Accountbeheer",
    NOT_ACTIVE:"Niet aktief",
    ASSIGN_ROLE:"Rol toewijzen",
    UPDATE:"Bijwerken",
    ADD_NEW_ACCOUNT:"Nieuw account toevoegen",
    EMAIL_REQUIRED:"E-mail adres is vereist",
    EMAIL_NOT_VALID:"E-mail adres ongeldig",
    ADD_NEW_USER_TEXT:"E-mail met activatielink wordt naar het opgegeven e-mailadres gestuurd.",
    UPDATE_USER_NOTIFICATION:"U heeft uw informatie met succes bijgewerkt",
    CHANGED_PASSWORD_NOTIFICATION:"U heeft uw informatie met succes verandert",
    UPDATE_USER_GROUP_NOTIFICATION:"U heeft de naam van de gebruikersgroep met succes bijgewerkt",
    CREATE_USER_GROUP_NOTIFICATION:"U heeft met succes een groep gemaakt",
    DETELE_USER_GROUP_NOTIFICATION:"U heeft met succes een groep verwijdert",
    EMPTY_GROUP_LIST_MSG:"Er zijn geen gemaakte groepen. Begin met maken van een groep",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"U heeft de gebruiker uit de groep verwijderd",
    ADD_USER_TO_GROUP_NOTIFICATION:"U heeft de gebruiker met succes aan de groep toegevoegd",
    ADD_USER_NOTIFICATION:"U heeft met succes de gebruiker toegevoegd ",
    DELETE_USER_NOTIFICATION:"U heeft met succes de gebruiker verwijdert",
    RESEND_USER_VERIFICATION_EMAIL:"U hebt succesvol de verificatie-e-mail opnieuw verzonden",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Om een gebruikersgroep aan te maken",
    DELETE_USER:"Gebruiker verwijderen",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Weet u zeker dat u de gebruiker uit de gebruikersgroep wilt verwijderen?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Beste R2W gebruiker",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Loyaliteitsregel per aantal bezoeken",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Loyaliteitsregel per aantal uitgegeven munten",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Loyaliteitsregel per dag van de week",
    REMOVE_CAMPAIGN_RULE_TITLE:"Campagneregel verwijdering",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Weet u zeker dat u de campagneregel wilt verwijderen?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Je hebt met succes een nieuwe campagne gemaakt",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"U heeft de campagne geactiveerd",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Er zijn geen gemaakte campagnes. Begin met het maken van een",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"U heeft  met succes een bericht gestuurd",
    COMPANY_ACCOUNTS:"Bedrijfsaccount",
    BUSSINESS_INVOICES_LIST:"Mijn B2B facturen ",
    LOCALE_TOKEN:"Lokale munten",
    R2W:"Globaal munten",
    START_MONTH:"Begin maand",
    END_MONTH:"End maand",
    TOKEN_TYPE:"Munt type",
    TOKEN_NUMBER:"Munt nummer",
    NOTHING_TO_DISPLAY:"* Niets om te laten zien",
    CREATE_INVOICE:"Factuur maken",
    INVOICE:"Factuur",
    INVOICES:"Factuuren",
    EDIT_INVOICE:"Factuur bewerken ",
    UPDATE_INVOICE_NOTIFICATION:"U heeft de factuur succesvol bijgewerkt naar de status 'In behandeling'",
    CURRENT_CHARGES:"Kosten voor de huidige periode",
    PAYMENTS_ON_HOLD:"Facturen in behandeling",
    FOR_INVOICING:"voor factureren",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"U staat op het punt de factuur te annuleren",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Weet u zeker dat u deze factuur wilt annuleren?",
    INVOICING_NOTIFICATION_HEADER:"U staat op het punt om te factureren",
    INVOICING_NOTIFICATION_TEXT:"Weet u zeker dat u deze factuur wilt versturen?",
    SENT_INVOICE_NOTIFICATION:"U heeft met succes een factuur verzonden",
    CANCELED_INVOICE_NOTIFICATION:"U heeft met succes een factuur granuleert ",
    INVOICE_DESCRIPTION_TEXT:"Factuur voor",
    INVOICE_STATE:"Factuur status",
    INVOICE_NUMBER:"Factuur nummer",
    INVOICE_TOTAL:"Totaal",
    SELECT_YEAR:"Selecteer jaar",
    DOWNLOAD:"PDF downloaden",
    INVOICE_NUMBER_HEADER:"U staat op het punt een factuur te verzenden met nummer",
    INVOICE_PAYMENT_CONFIRMATION:"Je gaat bevestigen de betaling voor",
    INSERT_INVOICE_NUMBER:"Factuur nummer invoegen",
    INVOICED_WARNING:"E-mail was niet verstuurd. Wacht alsjeblieft ...",
    SEND_INVOICE:"Verzenden",
    INVOICE_ALL:"Alle ",
    INVOICE_FROM_R2W:"Van R2W",
    INVOICE_TO_R2W:"Naar R2W",
    PAYMENT_REQUEST:"Betaal verzoek",
    PAYMENT_REQUEST_STATE:"Status betalingsverzoek",
    PAYMENT_REQUEST_NUMBER:"Nummer betalingsverzoek",
    FOR_PAYMENT_REQUEST:"Voor betalingsverzoeken",
    PAYMENT_REQUEST_ON_HOLD:"Betalingsverzoeken in behandeling",
    DOWNLOAD_INVOICE:"Factuur downloaden",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Klik voor downloadopties",
    B2B_SPEC:"B2B Specificatie",
    B2C_SPEC:"B2C Specificatie",
    DOWNLOAD_PAYMENT_REQUEST:"Betalingsverzoek downloaden",
    LOYALTY_PREVIEW:"Loyaliteitsvoorbeeld",
    ACTIVATED:"Geactiveerd",
    RUNNING:"Aan het uitvoeren",
    NOT_ACTIVATED:"Niet geactiveerd ",
    FINISHED:"Afgewerkt",
    DEPRECATED:"Verouderd",
    UPCOMING:"Aanstaande",
    NONE:"Geen",
    STARTED:"Begonnen",
    ENDS:"Loopt af",
    DEDICATED:"Toegewijd aan",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"U staat op het punt te activeren",
    CAMPAIGN:"campagne",
    SEND_MESSAGE_NOTIFICATION:"U staat op het punt een bericht te verzenden naar geselecteerde gebruikersgroepen",
    DIVISIBLE_TO_NUMBER:"Het nummer moet deelbaar zijn met",
    BRIDGE_PLC:"Brug - PLC",
    DEVICE_TYPE:"Soort apparaat",
    LISTENER:"Kleine machines",
    BRIDGE:"Wasboksen",
    WASH_BOXES:"Wasboksen",
    VACUUMS:"Stofzuigers",
    SAVE_NEWS:"Nieuws opslaan",
    CREATE_NEW_NEWS:"Maak nieuwe nieuws",
    HISTORY_OF_ALL_NEWS:"Geschiedenis van alle nieuws",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Typ de naam van de faciliteit",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Voeg een andere faciliteit toe",
    NEWS_TEXT:"Nieuws tekst",
    NEWS_TITLE:"Nieuws titel",
    DELETE_NEWS_CONFIRMATION:"U staat op het punt om nieuws te verwijderen",
    NEWS_DELETE_NOTIFICATION:"U heeft met succes nieuws verwijderd",
    NEWS_SAVE_NOTIFICATION:"U heeft met succes nieuws opgeslagen",
    NEWS_CREATION_DATE:"Aanmaakdatum",
    NO_TITLE:"Geen titel",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Nieuws tekst moet minder dan 255 symbolen bevatten",
    NEWS_TEXT_REQUIRED_VALIDATION:"Nieuws tekst vereist ",
    NEWS_TITLE_REQUIRED_VALIDATION:"Nieuws tekst vereist ",
    DEACTIVATE:"Deactiveren",
    ASIDE_MENU_LOCAL_TOKENS:"Lokale munten",
    CREATE_NEW_LOCAL_TOKENS:"Geef nieuwe lokale munten uit",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Voer het e-mailadres van de klant in en het aantal lokale munten dat u aan de klant wilt geven",
    CREATE_TOKENS:"Geef munten uit",
    MINIMUM_ONE_TOKEN:"Waarde moet groter dan 0 zijn",
    CUSTOMER_EMAIL:"Klanten e-mail",
    AMOUNT_OF_TOKENS:"Aantal munten",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Succesvolle uitgifte van lokale tokens aan",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Er is een fout opgetreden bij het uitgeven van lokale munten. Controleer het e-mailadres van de klant en probeer het opnieuw.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Overzicht van uitgegeven munten",
    ISSUED_AT:"Uitgegeven aan",
    ISSUED_BY:"Uitgegeven door",
    CODE:"Code inwisselen",
    REDEEMED_BY:"Ingewisseld door",
    REDEEMED_AT:"Ingewisseld bij",
    ASIDE_MENU_VOUCHERS:"Waardebonnen",
    PRINT:"Afdrukken",
    VOUCHERS_OVERVIEW:"Waardebonnen overzicht",
    CREATE_NEW_VOUCHERS:"Nieuwe waardebonnen maken",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Maak een nieuwe inwisselbare waardebonnen partij door het aantal munten per voucher in te voeren",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Aantal munten per waardebon",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"U kunt per voucher tussen de 1 en 100 munten toewijzen",
    NUMBER_OF_NEW_VOUCHERS:"Aantal te creëren waardebonnen",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"U kunt in één batch tussen 1 en {{size}} waardebonnen maken",
    NEW_VOUCHERS_PREFIX:"Nieuw code-voorvoegsel voor serie vouchers",
    VALIDATION_VOUCHER_PREFIX:"Het codevoorvoegsel moet exact 4 tekens bevatten (hoofdletters en / of cijfers)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Er is een probleem opgetreden bij het maken van nieuwe waardebonnen. Probeer het opnieuw of neem contact op met onze ondersteuning.",
    CREATE_VOUCHERS:"Maak waardebonnen",
    CREATING_VOUCHERS_SUCCESS:"Nieuwe waardebonnen met succes gemaakt",
    PRINT_NEW_VOUCHERS:"Waardebonnen afdrukken",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Voer een codevoorvoegsel voor de waardebonnenserie in om de hele serie af te drukken. alternatief",
    PRINT_VOUCHERS_PREFIX:"Waardebonnen (serie) codevoorvoegsel",
    NO_VOUCHERS_FOR_PRINT:"Er zijn geen waardebonnen gevonden die overeenkomen met het opgegeven codevoorvoegsel voor afdrukken",
    PRINT_VOUCHERS:"Waardebon(nen) afdrukken",
    VALIDATION_VOUCHER_CODE_FILTER:"De zoekterm voor waardebonnen moet bestaan uit hoofdletters en cijfers",
    FILTER_VOUCHERS_BY_CODE:"Zoek waardebonnen bij hun inwissel code",
    FILTER_VOUCHERS:"Waardebonnen zoeken",
    WASH_BOX:"Wasboks",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Totaal gebruikte digitale tokens",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Totaal verkochte munten per datum",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Totaal uitgegeven lokale munten op datum",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Totaal gegeven lokale munten op datum",
    LOCAL_TOKEN:"Lokaal munten",
    GIVEN_TOKEN:"Gegeven lokale munten",
    SOLD_TOKEN:"Verkochte lokale munten",
    SMALL_MACHINES:"Kleine machines",
    R2W_Listener:"Luisteraar ",
    HHANLE_DEVICE:"HHanle wasboks",
    CODE_PREFIX_EXIST:"Het codevoorvoegsel bestaat al",
    CODE_PREFIX_EXIST_TEXT:"U kunt geen nieuwe voucher maken met dit codevoorvoegsel. Stel een andere in altublieft..",
    MIN_FOUR_VALIDATION:"Exact 4 symbolen",
    ALL_INFORMATION_1:"Alle informatie over",
    ALL_INFORMATION_2:"wordt verloren",
    ASIDE_MENU_TRANSACTIONS:"Transacties",
    EXPENSES:"Kosten",
    TOPUPS:"TopUps",
    EXPENSES_LIST:"Kostenlijst",
    USER_EMAIL:"Gebruikers e-mail",
    COMPANY_NAME:"Bedrijfsnaam",
    TOPUPS_LIST:"Top-ups lijst",
    CONSUMER:"Consument",
    SYSTEM_ADMIN:"Systeem beheerder ",
    MERCHANT_ADMIN:"Merchant-beheerder",
    COMPANY_ADMIN:"Bedrijfsbeheerder",
    FACILITY_ADMIN:"Faciliteitsbeheerder",
    SUBSCRIBER:"Abonee",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serienummer",
    SETUP_UNIT_MATERIAL_NO:"Materiaalnummer",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi versie",
    TOTAL_TURNOVER:"Washfaciliteit omzet",
    AVAILABILITY_ALL:"Beschikbaarheid ",
    AVAILIBILITY:"Beschikbaarheid wasboksen:",
    AVAILABILITY_VACUUMS:"Stofzuiger beschikbaarheid:",
    WASH_BOX_INFO:"Wasboksen informatie",
    VACUUM_CLEANER_INFO:"Stofzuiger informatie",
    BREAD_CRUMBS_SERVICE:"Diensten",
    HOLIDAYS:"Vakantie",
    HOLIDAY:"Vakantie",
    LIGHTS_ON:"Licht/aan",
    LIGHTS_OFF:"Licht/uit",
    WASH_BOXES_ON:"Wasboks/aan",
    WASH_BOXES_OFF:"Wasboks/uit",
    VACUUMS_ON:"Stofzuiger/aan",
    VACUUMS_OFF:"Stofzuiger/uit",
    TURNOVER:"Omzet",
    TURNOVER_MANUAL_WASH_UNIT:"Omzet handleiding",
    STATUS_BAY_RUN_TIME:"Totale werktijd wasboksen",
    STATUS_BAY_PROGRAM_NAME:"Programma naam ",
    STATUS_BAY_CREDIT:"Wasboks credit",
    CLOUD_KREDIT:"Cloud credit",
    STATUS_VACUUM_RUN_TIME:"Totale werktijd stofzuiger",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facilitaire diensten, wasboxprogramma en actuele foutgegevens",
    UNAVAILABLE:"Eenheid is niet beschikbaar",
    SHOW_HIDE_TABLE:"Tabel werktijden weergeven/verbergen",
    PROGRAM_NAME:"Programma naam",
    PROGRAM_COUNTER:"Programma teller",
    NO_NAME:"Referentie heeft geen naam",
    COUNTER_SERVICE_DATA:"Dienst gegevens",
    NEED_SERVICE:"Onderhoud nodig",
    PROGRAM_DATA:"Programmagegevens van wasboks",
    CURRENT_FAULT_DATA:"Huidige fout gegevens",
    REFERENCE_DUE:"Due",
    REFERENCE_SECONDS:"Seconden",
    REFERENCE_NAME:"Deeltijd ",
    WASHBOX_NAME:"Naam wasboks",
    FAULT_NAME:"Fout naam",
    FAULT_NUMBER:"Fout nummer",
    CURRENT_FAULT_COUNT:"Actieve fouten",
    DEVICE_NOT_INSTALLED:"Apparaat niet geïnstalleerd",
    STATUS_READY:"status gereed",
    STATUS_ERROR:"Fout status",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Softwarefout",
    SOFTWARE_RESET:"Softwarefout",
    EXTERNAL_PIN_RESET:"Softwarefout",
    RESTART_OR_BROWNOUT_OCCURRED:"Softwarefout",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardwarefout",
    COULD_NOT_SIMULATE_COIN:"Hardwarefout",
    ERROR_SETTING_INHIBIT_MODE:"Hardwarefout",
    OFFLINE_DEVICE:"Offline autowasstraat",
    TARIFFS:"Tarieven",
    DAY:"Dag",
    NIGHT:"Nacht",
    VOUCHER_CODE:"Waardeboncode",
    DISMISS_ALARM:"Alarm resetten?",
    ALARM_ACTIVE:"Actieve alarmen",
    NO_ALARM_ACTIVE:"Er zijn geen actieve alarmen",
    ALARM_HISTORY:"Meldingsgeschiedenis",
    MANAGING_TOKENS:"Tokens beheren",
    EXPIRATION_DATE:"Uiterste houdbaarheidsdatum",
    EXTEND_TOKEN_DATE:"Verleng de vervaldatum van het token voor:",
    DELETE_TOKENS_FOR:"Tokens verwijderen voor",
    PUMP_TYPE:"Pomptype",
    TURN_OFF_DEVICE:"Apparaatstatus",
    OPERATION_DATA:"Bedrijfsgegevens",
    PUMP_DATA:"Pompen gegevens",
    PUMP_NAME:"Pompen naam",
    POINT_NAME:"Puntnaam",
    CHANGER_INCOME:"Totaal omzet door wisselaar op datum",
    SELECTED_OPEN:"Open op geselecteerde werkuren",
    ALWAYS_OPEN:"Altijd open (24/7)",
    CLOSED:"Gesloten",
    CLOSED_24:"24 uur gesloten",
    OPENED_24:"24 uur geopend",
    MON:"Maandag",
    TUE:"Dinsdag",
    WED:"Woensdag",
    THU:"Donderdag",
    FRI:"Vrijdag",
    SAT:"Zaterdag",
    SUN:"Zondag",
    PRICING:"Prijzen",
    PRICE:"Prijs",
    VALIDITY:"Geldigheid",
    TOKEN_PACKAGES:"Tokenpakketten",
    SINGLE_WASH:"Enkele wasbeurt",
    FACILITY_WORKING_HOURS:"Werkuren instellen voor geselecteerde faciliteit",
    WORKING_HOURS_ALWAYS_OPEN:"Altijd open",
    WORKING_HOURS_ALWAYS_CLOSE:"Gesloten door operator",
    WORKING_HOURS_CUSTOM:"Werkuren instellen",
    KARCHER_ERROR_CODE:"Meldingsfoutcode",
    KARCHER_ERROR_MESSAGE_1:"Elektronische stopcontacten overbelast",
    KARCHER_ERROR_MESSAGE_2:"De olieafscheider moet worden geleegd",
    KARCHER_ERROR_MESSAGE_4:"Dimsensor defect",
    KARCHER_ERROR_MESSAGE_5:"Motorbeveiligingsschakelaar op hogedrukpompen is geactiveerd",
    KARCHER_ERROR_MESSAGE_6:"Verbinding met RDS defect",
    KARCHER_ERROR_MESSAGE_7:"De drukschakelaar voor lucht op de compressor meldt geen",
    KARCHER_ERROR_MESSAGE_8:"Oorzaak: geen verbinding met de elektronica 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"Geen verbinding met pompelektronica op wasstation 1",
    KARCHER_ERROR_MESSAGE_11:"Elektronische stopcontacten bij wasstation 1 overbelast",
    KARCHER_ERROR_MESSAGE_12:"Stroomopname van hogedrukpomp bij wasstation 1 te hoog",
    KARCHER_ERROR_MESSAGE_13:"Stroomopname van hogedrukpomp bij wasstation 1 te laag",
    KARCHER_ERROR_MESSAGE_14:"Contact van hogedrukpomp bij wasstation 1 zit vast",
    KARCHER_ERROR_MESSAGE_15:"Semiloadklep bij wasstation 1 defect",
    KARCHER_ERROR_MESSAGE_16:"Coilbeschermingscontact van hogedrukpompwasstation 1",
    KARCHER_ERROR_MESSAGE_17:"Oliepeil hogedrukpomp bij wasstation 1 te laag",
    KARCHER_ERROR_MESSAGE_18:"Elektronica bij wasstation 1 defect",
    KARCHER_ERROR_MESSAGE_19:"Zekering motor hogedrukpomp wasstation 1 is uitgevallen",
    KARCHER_ERROR_MESSAGE_20:"Geen verbinding met afstandsbedieningselektronica bij wasstation 1",
    KARCHER_ERROR_MESSAGE_21:"Storing muntautomaat wasstation 1",
    KARCHER_ERROR_MESSAGE_22:"Storing muntautomaat wasstation 1",
    KARCHER_ERROR_MESSAGE_30:"Geen verbinding met pompelektronica op wasstation 2",
    KARCHER_ERROR_MESSAGE_31:"Elektronische stopcontacten bij wasstation 2 overbelast",
    KARCHER_ERROR_MESSAGE_32:"Stroomopname van hogedrukpomp bij wasstation 2 te hoog",
    KARCHER_ERROR_MESSAGE_33:"Stroomopname van hogedrukpomp bij wasstation 2 te laag",
    KARCHER_ERROR_MESSAGE_34:"Contact van hogedrukpomp bij wasstation 2 zit vast",
    KARCHER_ERROR_MESSAGE_35:"Semiloadklep bij wasstation 2 defect",
    KARCHER_ERROR_MESSAGE_36:"Coilbeschermingscontact van hogedrukpompwasstation 2",
    KARCHER_ERROR_MESSAGE_37:"Oliepeil hogedrukpomp bij wasstation 2 te laag",
    KARCHER_ERROR_MESSAGE_38:"Elektronica bij wasstation 2 defect",
    KARCHER_ERROR_MESSAGE_39:"Zekering motor hogedrukpomp wasstation 2 is uitgevallen",
    KARCHER_ERROR_MESSAGE_40:"Geen verbinding met afstandsbedieningselektronica bij wasstation 2",
    KARCHER_ERROR_MESSAGE_41:"Storing muntautomaat wasstation 2",
    KARCHER_ERROR_MESSAGE_42:"Storing muntautomaat wasstation 2",
    KARCHER_ERROR_MESSAGE_50:"Geen verbinding met pompelektronica op wasstation 3",
    KARCHER_ERROR_MESSAGE_51:"Elektronische stopcontacten bij wasstation 3 overbelast",
    KARCHER_ERROR_MESSAGE_52:"Stroomopname van hogedrukpomp bij wasstation 3 te hoog",
    KARCHER_ERROR_MESSAGE_53:"Stroomopname van hogedrukpomp bij wasstation 3 te laag",
    KARCHER_ERROR_MESSAGE_54:"Contact van hogedrukpomp bij wasstation 3 zit vast",
    KARCHER_ERROR_MESSAGE_55:"Semiloadklep bij wasstation 3 defect",
    KARCHER_ERROR_MESSAGE_56:"Coilbeschermingscontact van hogedrukpompwasstation 3",
    KARCHER_ERROR_MESSAGE_57:"Oliepeil hogedrukpomp bij wasstation 3 te laag",
    KARCHER_ERROR_MESSAGE_58:"Elektronica bij wasstation 3 defect",
    KARCHER_ERROR_MESSAGE_59:"Zekering motor hogedrukpomp wasstation 3 is uitgevallen",
    KARCHER_ERROR_MESSAGE_60:"Geen verbinding met afstandsbedieningselektronica bij wasstation 3",
    KARCHER_ERROR_MESSAGE_61:"Storing muntautomaat wasstation 3",
    KARCHER_ERROR_MESSAGE_62:"Storing muntautomaat wasstation 3",
    KARCHER_ERROR_MESSAGE_70:"Geen verbinding met pompelektronica op wasstation 4",
    KARCHER_ERROR_MESSAGE_71:"Elektronische stopcontacten bij wasstation 4 overbelast",
    KARCHER_ERROR_MESSAGE_72:"Stroomopname van hogedrukpomp bij wasstation 4 te hoog",
    KARCHER_ERROR_MESSAGE_73:"Stroomopname van hogedrukpomp bij wasstation 4 te laag",
    KARCHER_ERROR_MESSAGE_74:"Contact van hogedrukpomp bij wasstation 4 zit vast",
    KARCHER_ERROR_MESSAGE_75:"Semiloadklep bij wasstation 4 defect",
    KARCHER_ERROR_MESSAGE_76:"Coilbeschermingscontact van hogedrukpompwasstation 4",
    KARCHER_ERROR_MESSAGE_77:"Oliepeil hogedrukpomp bij wasstation 4 te laag",
    KARCHER_ERROR_MESSAGE_78:"Elektronica bij wasstation 4 defect",
    KARCHER_ERROR_MESSAGE_79:"Zekering motor hogedrukpomp wasstation 4 is uitgevallen",
    KARCHER_ERROR_MESSAGE_80:"Geen verbinding met afstandsbedieningselektronica bij wasstation 4",
    KARCHER_ERROR_MESSAGE_81:"Storing muntautomaat wasstation 4",
    KARCHER_ERROR_MESSAGE_82:"Storing muntautomaat wasstation 4",
    KARCHER_ERROR_MESSAGE_90:"Geen verbinding met pompelektronica op wasstation 5",
    KARCHER_ERROR_MESSAGE_91:"Elektronische stopcontacten bij wasstation 5 overbelast",
    KARCHER_ERROR_MESSAGE_92:"Stroomopname van hogedrukpomp bij wasstation 5 te hoog",
    KARCHER_ERROR_MESSAGE_93:"Stroomopname van hogedrukpomp bij wasstation 5 te laag",
    KARCHER_ERROR_MESSAGE_94:"Contact van hogedrukpomp bij wasstation 5 zit vast",
    KARCHER_ERROR_MESSAGE_95:"Semiloadklep bij wasstation 5 defect",
    KARCHER_ERROR_MESSAGE_96:"Coilbeschermingscontact van hogedrukpompwasstation 5",
    KARCHER_ERROR_MESSAGE_97:"Oliepeil hogedrukpomp bij wasstation 5 te laag",
    KARCHER_ERROR_MESSAGE_98:"Elektronica bij wasstation 5 defect",
    KARCHER_ERROR_MESSAGE_99:"Zekering motor hogedrukpomp wasstation 5 is uitgevallen",
    KARCHER_ERROR_MESSAGE_100:"Geen verbinding met afstandsbedieningselektronica bij wasstation 5",
    KARCHER_ERROR_MESSAGE_101:"Storing muntautomaat wasstation 5",
    KARCHER_ERROR_MESSAGE_102:"Storing muntautomaat wasstation 5",
    KARCHER_ERROR_MESSAGE_110:"Geen verbinding met pompelektronica op wasstation 6",
    KARCHER_ERROR_MESSAGE_111:"Elektronische stopcontacten bij wasstation 6 overbelast",
    KARCHER_ERROR_MESSAGE_112:"Stroomopname van hogedrukpomp bij wasstation 6 te hoog",
    KARCHER_ERROR_MESSAGE_113:"Stroomopname van hogedrukpomp bij wasstation 6 te laag",
    KARCHER_ERROR_MESSAGE_114:"Contact van hogedrukpomp bij wasstation 6 zit vast",
    KARCHER_ERROR_MESSAGE_115:"Semiloadklep bij wasstation 6 defect",
    KARCHER_ERROR_MESSAGE_116:"Coilbeschermingscontact van hogedrukpompwasstation 6",
    KARCHER_ERROR_MESSAGE_117:"Oliepeil hogedrukpomp bij wasstation 6 te laag",
    KARCHER_ERROR_MESSAGE_118:"Elektronica bij wasstation 6 defect",
    KARCHER_ERROR_MESSAGE_119:"Zekering motor hogedrukpomp wasstation 6 is uitgevallen",
    KARCHER_ERROR_MESSAGE_120:"Geen verbinding met afstandsbedieningselektronica bij wasstation 6",
    KARCHER_ERROR_MESSAGE_121:"Storing muntautomaat wasstation 6",
    KARCHER_ERROR_MESSAGE_122:"Storing muntautomaat wasstation 6",
    KARCHER_ERROR_MESSAGE_130:"Geen verbinding met pompelektronica op wasstation 7",
    KARCHER_ERROR_MESSAGE_131:"Elektronische stopcontacten bij wasstation 7 overbelast",
    KARCHER_ERROR_MESSAGE_132:"Stroomopname van hogedrukpomp bij wasstation 7 te hoog",
    KARCHER_ERROR_MESSAGE_133:"Stroomopname van hogedrukpomp bij wasstation 7 te laag",
    KARCHER_ERROR_MESSAGE_134:"Contact van hogedrukpomp bij wasstation 7 zit vast",
    KARCHER_ERROR_MESSAGE_135:"Semiloadklep bij wasstation 7 defect",
    KARCHER_ERROR_MESSAGE_136:"Coilbeschermingscontact van hogedrukpompwasstation 7",
    KARCHER_ERROR_MESSAGE_137:"Oliepeil hogedrukpomp bij wasstation 7 te laag",
    KARCHER_ERROR_MESSAGE_138:"Elektronica bij wasstation 7 defect",
    KARCHER_ERROR_MESSAGE_139:"Zekering motor hogedrukpomp wasstation 7 is uitgevallen",
    KARCHER_ERROR_MESSAGE_140:"Geen verbinding met afstandsbedieningselektronica bij wasstation 7",
    KARCHER_ERROR_MESSAGE_141:"Storing muntautomaat wasstation 7",
    KARCHER_ERROR_MESSAGE_142:"Storing muntautomaat wasstation 7",
    KARCHER_ERROR_MESSAGE_150:"Geen verbinding met pompelektronica op wasstation 8",
    KARCHER_ERROR_MESSAGE_151:"Elektronische stopcontacten bij wasstation 8 overbelast",
    KARCHER_ERROR_MESSAGE_152:"Stroomopname van hogedrukpomp bij wasstation 8 te hoog",
    KARCHER_ERROR_MESSAGE_153:"Stroomopname van hogedrukpomp bij wasstation 8 te laag",
    KARCHER_ERROR_MESSAGE_154:"Contact van hogedrukpomp bij wasstation 8 zit vast",
    KARCHER_ERROR_MESSAGE_155:"Semiloadklep bij wasstation 8 defect",
    KARCHER_ERROR_MESSAGE_156:"Coilbeschermingscontact van hogedrukpompwasstation 8",
    KARCHER_ERROR_MESSAGE_157:"Oliepeil hogedrukpomp bij wasstation 8 te laag",
    KARCHER_ERROR_MESSAGE_158:"Elektronica bij wasstation 8 defect",
    KARCHER_ERROR_MESSAGE_159:"Zekering motor hogedrukpomp wasstation 8 is uitgevallen",
    KARCHER_ERROR_MESSAGE_160:"Geen verbinding met afstandsbedieningselektronica bij wasstation 8",
    KARCHER_ERROR_MESSAGE_161:"Storing muntautomaat wasstation 8",
    KARCHER_ERROR_MESSAGE_162:"Storing muntautomaat wasstation 8",
    KARCHER_ERROR_MESSAGE_170:"Geen verbinding met elektronica A2 overbelast ",
    KARCHER_ERROR_MESSAGE_171:"Uitgang van de elektronica A2 overbelast",
    KARCHER_ERROR_MESSAGE_172:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_173:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_174:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_175:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_176:"Wasmiddelbakje is leeg",
    KARCHER_ERROR_MESSAGE_177:"Stroomopname van onderwagenreinigingspomp was te hoog",
    KARCHER_ERROR_MESSAGE_178:"Geen druk na het inschakelen van de bodemwas",
    KARCHER_ERROR_MESSAGE_190:"Geen verbinding met elektronica A3",
    KARCHER_ERROR_MESSAGE_191:"Uitgang van de elektronica A3 overbelast",
    KARCHER_ERROR_MESSAGE_200:"Geen verbinding tussen besturing en elektronica van de WSO",
    KARCHER_ERROR_MESSAGE_201:"Uitgangen van de besturing naar de WSO overbelast",
    KARCHER_ERROR_MESSAGE_202:"De hardheidssensor toont na regeneratie hard water",
    KARCHER_ERROR_MESSAGE_204:"Storing in de elektronica",
    KARCHER_ERROR_MESSAGE_210:"Niveausensor BUFFERTANK LEEG geactiveerd",
    KARCHER_ERROR_MESSAGE_211:"Niveausensor BUFFER CONTAINER LEEG en BUFFER CONTAINER FULL-schakelaar tegelijkertijd",
    KARCHER_ERROR_MESSAGE_212:"Niveausensor RO PUMP ON en BUFFER CONTAINER FULL-schakelaar tegelijkertijd",
    KARCHER_ERROR_MESSAGE_213:"Geen waterdruk ",
    KARCHER_ERROR_MESSAGE_214:"Locatie geleverde waterbereiding meldt een storing",
    KARCHER_ERROR_MESSAGE_220:"Watertekort",
    KARCHER_ERROR_MESSAGE_221:"Uitlaattemperatuur is te hoog",
    KARCHER_ERROR_MESSAGE_222:"Stroomopname circulatiepomp voor warm water te hoog",
    KARCHER_ERROR_MESSAGE_223:"Storing brander",
    KARCHER_ERROR_MESSAGE_224:"Veiligheidsthermostaat van de brander is geactiveerd",
    KARCHER_ERROR_MESSAGE_225:"Brandervertraging actief",
    KARCHER_ERROR_MESSAGE_226:"Stroomindicator ging niet open binnen 5 seconden nadat de circulatiepomp voor warm water was uitgeschakeld",
    KARCHER_ERROR_MESSAGE_227:"Stroomindicator ging niet open binnen 3 seconden nadat de circulatiepomp voor warm water was uitgeschakeld",
    KARCHER_ERROR_MESSAGE_228:"De uitlaat voor warm water koelt te langzaam af nadat de brander is uitgeschakeld",
    KARCHER_ERROR_MESSAGE_229:"Storing temperatuursensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Storing in temperatuursensor branderuitlaat",
    KARCHER_ERROR_MESSAGE_231:"Storing in temperatuursensor warm water ",
    KARCHER_ERROR_MESSAGE_232:"Storing in temperatuursensor branderuitlaat",
    KARCHER_ERROR_MESSAGE_233:"Watertemperatuur met externe toevoer met warm water heter dan 60 ° C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionellaprogrammafout",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warmwatertemperatuur niet bereikt",
    KARCHER_ERROR_MESSAGE_240:"Storing buitentemperatuursensor",
    KARCHER_ERROR_MESSAGE_241:"Storing buitentemperatuursensor",
    KARCHER_ERROR_MESSAGE_242:"Stroomopname circulatiepomp voor vorstbeveiliging te hoog ",
    KARCHER_ERROR_MESSAGE_243:"Stroomopname circulatiepomp voor wasstationverwarming te hoog",
    KARCHER_ERROR_MESSAGE_244:"Warmwatertemperatuur te laag, wasstationverwarming was uitgeschakeld",
    KARCHER_ERROR_MESSAGE_245:"Stroomverbruik van schuimslangverwarmer voor het schuim te hoog",
    KARCHER_ERROR_MESSAGE_247:"Storing in de elektronica",
    KARCHER_ERROR_MESSAGE_248:"Storing in de elektronica",
    KARCHER_ERROR_MESSAGE_250:"Stroomopname pomp voor speciaal wasprogramma te hoog",
    KARCHER_ERROR_MESSAGE_255:"Storing in de elektronica",
    KARCHER_ERROR_MESSAGE_260:"Geen verbinding met elektronica A5",
    KARCHER_ERROR_MESSAGE_261:"Uitgangen van de elektronica A5 overbelast",
    KARCHER_ERROR_MESSAGE_280:"Geen verbinding met elektronica A6",
    KARCHER_ERROR_MESSAGE_281:"Uitgangen van de elektronica A6 overbelast",
    KARCHER_ERROR_MESSAGE_282:"Stroomverbruik pomp voor velgenreiniger te hoog",
    KARCHER_ERROR_MESSAGE_283:"Stroomverbruik pomp voor velgenreiniger te laag",
    KARCHER_ERROR_MESSAGE_284:"Schakelaar van pomp voor velgenreiniger zit vast",
    KARCHER_ERROR_MESSAGE_300:"Geen verbinding met elektronica A7",
    KARCHER_ERROR_MESSAGE_301:"Uitgangen van de elektronica A7 overbelast",
    KARCHER_ERROR_MESSAGE_320:"Geen verbinding met elektronica A8",
    KARCHER_ERROR_MESSAGE_321:"Uitgangen van de elektronica A8 overbelast",
    KARCHER_ERROR_MESSAGE_322:"Stroomverbruik van pomp voor micro-emulsie te hoog",
    KARCHER_ERROR_MESSAGE_323:"Stroomverbruik pomp voor micro-emulsie te laag",
    KARCHER_ERROR_MESSAGE_324:"Schakelaar van pomp voor micro-emulsie zit vast",
    KARCHER_ERROR_MESSAGE_340:"Geen verbinding met elektronica A9",
    KARCHER_ERROR_MESSAGE_341:"Uitgangen van de elektronica A9 overbelast",
    KARCHER_ERROR_MESSAGE_342:"Stroomverbruik pomp voor intensieve reiniging te hoog",
    KARCHER_ERROR_MESSAGE_343:"Stroomverbruik pomp voor intensieve reiniging te laag",
    KARCHER_ERROR_MESSAGE_344:"Schakelaar van pomp voor intensieve reiniging is vastgelopen",
    KARCHER_ERROR_MESSAGE_400:"Warm water zonder druk",
    KARCHER_ERROR_MESSAGE_401:"Zoet water geen druk",
    KARCHER_ERROR_MESSAGE_402:"Doordring geen druk",
    KARCHER_ERROR_MESSAGE_403:"4. type water geen druk",
    KARCHER_ERROR_MESSAGE_404:"4. Soort water, temperatuur boven 60 ° C of externe storing",
    KARCHER_ERROR_MESSAGE_405:"Vorstbeveiliging geen druk",
    KARCHER_ERROR_MESSAGE_406:"Druk in de vorstbeveiliging ondanks uitgeschakelde antivriespomp",
    KARCHER_ERROR_MESSAGE_410:"Fout F 400 trad 4 keer op binnen 24 uur",
    KARCHER_ERROR_MESSAGE_411:"Fout F 401 is al 300 seconden actief",
    KARCHER_ERROR_MESSAGE_412:"Fout F 402 trad 4 keer op binnen 24 uur",
    KARCHER_ERROR_MESSAGE_413:"Fout F 403 trad 4 keer op binnen 24 uur",
    KARCHER_ERROR_MESSAGE_414:"Fout F 405 trad 4 keer op binnen 24 uur",
    KARCHER_ERROR_MESSAGE_420:"Foutmuntenwisselaar 1",
    KARCHER_ERROR_MESSAGE_421:"Foutmuntenwisselaar 1",
    KARCHER_ERROR_MESSAGE_440:"Geen verbinding met elektronica A31",
    KARCHER_ERROR_MESSAGE_441:"Uitgangen van de elektronica A31 overbelast",
    KARCHER_ERROR_MESSAGE_500:"Verbinding van stofzuigerelektronica 1/2",
    KARCHER_ERROR_MESSAGE_501:"Startknop van stofzuiger 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Startknop van stofzuiger 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Verbinding van stofzuigerelektronica 3/4",
    KARCHER_ERROR_MESSAGE_511:"Startknop van stofzuiger 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Startknop van stofzuiger 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Verbinding van stofzuigerelektronica 5/6",
    KARCHER_ERROR_MESSAGE_521:"Startknop van stofzuiger 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Startknop van stofzuiger 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Verbinding van stofzuigerelektronica 7/8",
    KARCHER_ERROR_MESSAGE_531:"Startknop van stofzuiger 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Startknop van stofzuiger 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Verbinding van stofzuigerelektronica 9/10",
    KARCHER_ERROR_MESSAGE_541:"Startknop van stofzuiger 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Startknop van stofzuiger 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Startknop van stofzuiger 10/11 permanent contact",
    KARCHER_ERROR_MESSAGE_551:"Startknop van stofzuiger 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Startknop van stofzuiger 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"Geen verbinding met de elektronica A30",
    KARCHER_ERROR_MESSAGE_801:"Uitgangen van de elektronica A30 overbelast",
    KARCHER_ERROR_MESSAGE_802:"Storing in onthardingsinstallatie",
    KARCHER_ERROR_MESSAGE_803:"Beschermende motorschakelaar voordrukpomp RO geactiveerd",
    KARCHER_INFO_MESSAGE_1:"De regeneratie van de basiswisselaar is gestart",
    KARCHER_INFO_MESSAGE_2:"Regeneratie van basisuitwisseling voltooid",
    KARCHER_INFO_MESSAGE_3:"Basiswisselaar leeg 75%",
    KARCHER_INFO_MESSAGE_4:"Unit niet beschikbaar vanwege technisch probleem",
    KARCHER_INFO_MESSAGE_5:"Eenheid niet beschikbaar vanwege een operationeel probleem",
    KARCHER_INFO_MESSAGE_6:"Unit is ingeschakeld",
    KARCHER_INFO_MESSAGE_10:"Hoewel het zich binnen de bedrijfsuren bevindt",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is niet beschikbaar",
    KARCHER_INFO_MESSAGE_20:"Anti-legionellaprogramma warmwatertank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionellaprogramma HD-pomp 1 vereist",
    KARCHER_INFO_MESSAGE_22:"Anti-legionellaprogramma HD-pomp 2 vereist",
    KARCHER_INFO_MESSAGE_23:"Anti-legionellaprogramma HD-pomp 3 vereist",
    KARCHER_INFO_MESSAGE_24:"Anti-legionellaprogramma HD-pomp 4 vereist",
    KARCHER_INFO_MESSAGE_25:"Anti-legionellaprogramma HD-pomp 5 vereist",
    KARCHER_INFO_MESSAGE_26:"Anti-legionellaprogramma HD-pomp 6 vereist",
    KARCHER_INFO_MESSAGE_27:"Anti-legionellaprogramma HD-pomp 7 vereist",
    KARCHER_INFO_MESSAGE_28:"Anti-legionellaprogramma HD-pomp 8 vereist",
    KARCHER_INFO_MESSAGE_29:"Anti-legionellaprogramma voltooid",
    KARCHER_INFO_MESSAGE_101:"Hogedrukpomp 1 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_102:"Hogedrukpomp 2 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_103:"Hogedrukpomp 3 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_104:"Hogedrukpomp 4 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_105:"Hogedrukpomp 5 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_106:"Hogedrukpomp 6 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_107:"Hogedrukpomp 7 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_108:"Hogedrukpomp 8 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_109:"Brander moet worden onderhouden",
    KARCHER_INFO_MESSAGE_110:"Branderblazer moet worden onderhouden",
    KARCHER_INFO_MESSAGE_111:"Warmwaterpomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_112:"Antivriespomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_113:"Osmosepomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Leidingverwarming moet worden onderhouden",
    KARCHER_INFO_MESSAGE_116:"Micro-emulsie / velg-reinigingsmiddelpomp moet worden nagekeken",
    KARCHER_INFO_MESSAGE_117:"Onderwagenreinigingspomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_118:"Systeemdrukpomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_119:"Stofzuiger 1 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_120:"Stofzuiger 2 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_121:"Stofzuiger 3 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_122:"Stofzuiger 4 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_123:"Stofzuiger 5 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_124:"Stofzuiger 6 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_125:"Stofzuiger 7 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_126:"Stofzuiger 8 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_127:"Stofzuiger 9 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_128:"Stofzuiger 10 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_129:"Stofzuiger 11 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_130:"Stofzuiger 12 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_131:"Velgenreinigingspomp moet worden nagekeken",
    KARCHER_INFO_MESSAGE_132:"Micro-emulsiepomp moet worden onderhouden",
    KARCHER_INFO_MESSAGE_133:"Intensieve schuimpomp wegens onderhoud",
    KARCHER_INFO_MESSAGE_142:"Stofzuiger 1 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_143:"Filter voor stofzuiger 1 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_144:"Stofzuiger 2 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_145:"Filter voor stofzuiger 2 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_146:"Stofzuiger 3 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_147:"Filter voor stofzuiger 3 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_148:"Stofzuiger 4 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_149:"Filter voor stofzuiger 4 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_150:"Stofzuiger 5 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_151:"Filter voor stofzuiger 5 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_152:"Stofzuiger 6 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_153:"Filter voor stofzuiger 6 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_154:"Stofzuiger 7 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_155:"Filter voor stofzuiger 7 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_156:"Stofzuiger 8 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_157:"Filter voor stofzuiger 8 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_158:"Stofzuiger 9 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_159:"Filter voor stofzuiger 9 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_160:"Stofzuiger 10 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_161:"Filter voor stofzuiger 10 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_162:"Stofzuiger 11 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_163:"Filter voor stofzuiger 11 moet worden onderhouden",
    KARCHER_INFO_MESSAGE_164:"Stofzuiger 12 turbine moet worden onderhouden",
    KARCHER_INFO_MESSAGE_165:"Filter voor stofzuiger 12 moet worden onderhouden",
    ORGANIZATION:"Organisatie",
    CREATE_ORGANIZATION:"Organisatie aanmaken",
    CREATE_ORGANIZATION_AS:"Organisatie aanmaken als kind van",
    DELETE_ORGANIZATION:"Organisatie verwijderen",
    EDIT_ORGANIZATION:"Organisatie bewerken",
    SUPPORTED_ORG_NAME:"Ondersteunde organisatie",
    SUPPORTED_ORG_TYPE:"Ondersteund type",
    ORG_NAME:"Naam",
    ORG_TYPE:"Type",
    SET_ORG_TITLE:"Stel kindorganisatie in",
    SET_SUPPORTED_ORG_TITLE:"Stel ondersteunde kindorganisatie in",
    SAVE_ORGANIZATION:"Organisatie opslaan",
    SELECT_ORGANIZATION_TYPE:"Selecteer organisatietype",
    SELECT_ORGANIZATION_SELECTOR:"Selecteer",
    SELECT_SUPPORTED_ORGANIZATION:"Selecteer ondersteunde organisatie",
    ORGANIZATION_DELETED:"Organisatie succesvol verwijderd",
    ORGANIZATION_SAVED:"Organisatie succesvol opgeslagen",
    ORGANIZATION_UPDATED:"Organisatie succesvol bijgewerkt",
    ALERTS:"Meldingen",
    DEVICE_STATUS:"Apparaatstatus",
    SITE_DETAILS:"Locatiedetails",
    ALARM_STATUS:"Meldingsstatus",
    FILTER:"Filteren op ...",
    FILTER_BY_ALERT_CENTER:"Filteren op code, naam of beschrijving",
    TOTAL_ALARM:"Totaal",
    LOW_ALARM:"Evenement",
    MEDIUM_ALARM:"Storingsmelding",
    HIGH_ALARM:"Kritieke fout",
    NO_FACILITIES_NEARBY:"Er zijn geen nabijgelegen faciliteiten",
    GRAY_MAP:"Grijs gestileerde kaart",
    READY:"Gereed",
    WARNING:"Storingsmelding",
    ERROR:"Error",
    SITE_NAME:"Locatienaam",
    ACCOUNTS_INFO:"Accountinformatie",
    USER_ORGANIZATION:"Gebruikersorganisatie",
    ADD_USER_ORGANIZATION:"Nieuwe organisatiegebruiker toevoegen",
    EDIT_USER_ORGANIZATION:"Bewerk gebruikers van de organisatie",
    SELECT_ROLE:"Selecteer rol",
    SELECT_ORGANIZATION:"Selecteer organisatie",
    SELECT_USER:"Selecteer gebruiker",
    USER_FOR_ORGANIZATION_CREATED:"Nieuwe gebruiker succesvol aangemaakt",
    SELECT_REGION:"Selecteer regio",
    SELECT_LANGUAGE:"Selecteer taal",
    LOADING_DATA:"Gegevens laden, een moment geduld alstublieft ...",
    ADMINISTRATOR:"Beheerder",
    TECHNICAL_SUPPORT:"Technische ondersteuning",
    CONTROLLER:"Controller",
    EDIT_ORGANIZATION_USER:"Bewerk gebruikers van de organisatie",
    DELETE_ORGANIZATION_USER:"Verwijder gebruikers van de organisatie",
    USER_UPDATED:"Gebruiker succesvol bijgewerkt",
    USER_CREATED:"Gebruiker succesvol aangemaakt",
    ADDRESS:"Adres",
    SUBSCRIPTIONS:"Abonnementen",
    RESOLVED_STATUS:"Opgelost",
    NOT_RESOLVED_STATUS:"Niet opgelost",
    ALERT_NAME:"Meldingsnaam",
    ALERT_DESCRIPTION:"Meldingsbeschrijving",
    ALERT_CODE:"Meldingscode",
    ALERT_TYPE:"Meldingscode",
    UNSUBSCRIBE:"Melding afmelden",
    SUBSCRIBE:"Melding aanmelden",
    ALARM_SUBSCRIBED:"Succesvol aangemeld",
    UNSUBSCRIBED_CONFIRM:"Afmelden?",
    ALARM_UNSUBSCRIBED:"Succesvol afgemeld",
    ASIDE_MENU_CASHLESS_SALES:"Contactloze verkoop",
    FILTERED_CASHLESS_PAYMENTS:"Gefilterde contactloze betalingen",
    REFUND_DIALOG_TITLE:"Transactie terugbetalen?",
    REFUND_DIALOG_SUBTITLE:"Bedrag kan minder zijn dan of gelijk zijn aan transactiebedrag",
    REFUND:"Terugbetaling",
    INPUT_NOT_VALID:"Invoer is niet geldig",
    REFUND_SUCCESSFULLY:"Terugbetaling voor geselecteerde betaling is succesvol uitgevoerd",
    USER:"Gebruiker",
    TRANSACTION_ID:"PSP-referentie",
    DEVICE_ID:"Apparaat-ID",
    NET_AMOUNT:"Netto bedrag",
    REPORT_NAME:"Rapportnaam",
    TIME_FRAME:"Tijdsspanne",
    SUB_POINT:"Selecteer subpunt",
    SUB_POINT_LIST_NOT_EXIST:"Subpuntlijst bestaat niet voor geselecteerde wasfaciliteit",
    FACILITY_TYPE:"Faciliteittype",
    MACHINE_NAME:"Machinenaam",
    WASH_FACILITY_DETAILS:"Wasfaciliteit details",
    WASH_BAY_DETAILS:"Wasbaai details",
    DEVICES_INFO:"Apparaatlijst",
    OPERATION_TIME_INFO:"Bedrijfstijd",
    OPERATION_TIME_VACUUM_INFO:"Bedrijfstijd voor stofzuigers",
    OPERATION_TIME_ILLUMINATION_INFO:"Bedrijfstijd voor verlichting",
    AVAILABLE_TITLE:"Beschikbaar",
    UNAVAILABLE_TITLE:"Niet beschikbaar",
    CURRENT_PROGRAM:"Huidig programma",
    CREDITS:"Kredieten",
    DEVICE_NAME:"Apparaatnaam",
    ACTIVE_ALARMS:"Actieve meldingen",
    ALL_DAY:"De hele dag",
    OPERATING_TIME_WASH_FACILITY:"Zelfbedieningswassysteem",
    OPERATING_TIME_VACUUMS:"Stofzuigers",
    OPERATING_TIME_ILLUMINATION:"Verlichting",
    OPERATION_COUNTERS:"Bedrijfsmeters",
    EDIT:"Bewerken",
    WASHING_PROGRAMS:"Wasprogramma's",
    INFO:"Evenement",
    STATISTIC:"Statistiek",
    ROLLOVER_DOSING:"Dosering",
    ROLLOVER_SPEED:"Snelheden",
    ROLLOVER_RESETS:"Rollover reset op afstand",
    ROLLOVER_RESETS_INFO:"De reset op afstand moet in overeenstemming zijn met de lokale voorschriften. Belangrijk: Zorg ervoor dat rollover leeg is voordat u reset.",
    RESET_ROLLOVER:"Reset rollover",
    OPEN_DOOR_ROLLOVER:"Open",
    ROLLOVER_OPEN_DOOR_INFO:"Open washal deur. Wees voorzichtig.",
    ROLLOVER_OPEN_DOOR:"Open de deur",
    APPLY_DOSING_CHANGES:"Pas doseerveranderingen toe",
    APPLY_SPEED_CHANGES:"Pas snelheidsveranderingen toe",
    ACTUATION_SUCCESS:"Verzoek verzonden",
    REMAINING_TIME:"Resterende tijd",
    OPEN_24H:"24 uur open",
    CLOSE_24H:"24 uur gesloten",
    VALIDATION_OPERATION_TIME:"Formaat niet correct. Gebruik hh:mm",
    ROLLOVER:"Rollover",
    UPDATE_WASHING_PROGRAM:"Update wasprogramma",
    UPDATE_ACTUATORS:"Update actuatoren",
    OPEN_ROLOVER_DOOR_TITLE:"Wilt u de rollover deur openen?",
    OPEN_ROLOVER_DOOR_CONTENT:"Weet u zeker dat u de deur wilt openen?",
    RESET_ROLOVER_TITLE:"Wilt u rollover resetten?",
    RESET_ROLOVER_CONTENT:"Weet u zeker dat u rollover wilt resetten?",
    G0:"{{brand === 'r2w' ? 'Baai 0' : 'Baai 1'}}",
    G1:"{{brand === 'r2w' ? 'Baai 1' : 'Baai 2'}}",
    G2:"{{brand === 'r2w' ? 'Baai 2' : 'Baai 3'}}",
    G3:"{{brand === 'r2w' ? 'Baai 3' : 'Baai 4'}}",
    G4:"{{brand === 'r2w' ? 'Baai 4' : 'Baai 5'}}",
    G5:"{{brand === 'r2w' ? 'Baai 5' : 'Baai 6'}}",
    G6:"{{brand === 'r2w' ? 'Baai 6' : 'Baai 7'}}",
    G7:"{{brand === 'r2w' ? 'Baai 7' : 'Baai 8'}}",
    G8:"{{brand === 'r2w' ? 'Baai 8' : 'Baai 9'}}",
    G9:"{{brand === 'r2w' ? 'Baai 9' : 'Baai 10'}}",
    G10:"{{brand === 'r2w' ? 'Baai 10' : 'Baai 11'}}",
    U0:"{{brand === 'r2w' ? 'Stofzuiger 0' : 'Stofzuiger 1'}}",
    U1:"{{brand === 'r2w' ? 'Stofzuiger 1' : 'Stofzuiger 2'}}",
    U2:"{{brand === 'r2w' ? 'Stofzuiger 2' : 'Stofzuiger 3'}}",
    U3:"{{brand === 'r2w' ? 'Stofzuiger 3' : 'Stofzuiger 4'}}",
    U4:"{{brand === 'r2w' ? 'Stofzuiger 4' : 'Stofzuiger 5'}}",
    U5:"{{brand === 'r2w' ? 'Stofzuiger 5' : 'Stofzuiger 6'}}",
    U6:"{{brand === 'r2w' ? 'Stofzuiger 6' : 'Stofzuiger 7'}}",
    U7:"{{brand === 'r2w' ? 'Stofzuiger 7' : 'Stofzuiger 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Meldingsrapport gemaakt door geselecteerde locatie vanuit dashboard",
    ALERT_CENTER_TITLE_BY_FACILITY:"Meldingsrapport gemaakt door geselecteerde faciliteit vanuit dashboard",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Meldingsrapport",
    ERROR_MESSAGE_403:"U hebt geen rechten om deze API-aanroep te gebruiken. Foutcode: 403",
    LAST_ACTIVE_PROGRAM:"Actief programma / Laatst actieve programma",
    PROGRAM_ID:"Programmanummer",
    PROGRAM_PRICE:"Programmaprijs",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Bijvullen vereist",
    EMPTY_CHEMICAL_LEVEL:"Leeg",
    CHEMICAL_LEVEL:"Niveau-indicatie reinigingsmiddelen (%)",
    ROLLOVER_STATUS:"Rollover status",
    ROLLOVER_STATUS_CODE_0:"Was momenteel buiten gebruik",
    ROLLOVER_STATUS_CODE_1:"Buiten bedrijfstijd",
    ROLLOVER_STATUS_CODE_2:"Programma-invoer toegestaan",
    ROLLOVER_STATUS_CODE_3:"Plaats uw voertuig",
    ROLLOVER_STATUS_CODE_4:"Voertuig vooruit",
    ROLLOVER_STATUS_CODE_5:"Voertuig achteruit",
    ROLLOVER_STATUS_CODE_6:"Voertuig stoppen",
    ROLLOVER_STATUS_CODE_7:"Was actief",
    ROLLOVER_STATUS_CODE_8:"Was gestopt",
    ROLLOVER_STATUS_CODE_9:"Was actief (tact)",
    ROLLOVER_STATUS_CODE_10:"Verlaat voertuig achteruit",
    ROLLOVER_STATUS_CODE_11:"Noodstop",
    ROLLOVER_STATUS_CODE_12:"Verlaat voertuig vooruit",
    ROLLOVER_STATUS_CODE_13:"Anti-vorst actief",
    ROLLOVER_STATUS_CODE_14:"Veiligheidsschakelaar voorkant geactiveerd",
    ROLLOVER_STATUS_CODE_15:"Veiligheidsschakelaar achterkant geactiveerd",
    ROLLOVER_STATUS_CODE_16:"Veiligheidsschakelaar linker voorkant geactiveerd",
    ROLLOVER_STATUS_CODE_17:"Veiligheidsschakelaar rechter voorkant geactiveerd",
    ROLLOVER_STATUS_CODE_18:"Veiligheidsschakelaar linker achterkant geactiveerd",
    ROLLOVER_STATUS_CODE_19:"Veiligheidsschakelaar rechter achterkant geactiveerd",
    ROLLOVER_STATUS_CODE_20:"Voertuigpositie te ver aan de linkerzijde",
    ROLLOVER_STATUS_CODE_21:"Voertuigpositie te ver aan de rechterzijde",
    ROLLOVER_STATUS_CODE_22:"Linker deur niet gesloten",
    ROLLOVER_STATUS_CODE_23:"Rechter deur niet gesloten",
    ROLLOVER_STATUS_CODE_24:"Transporter gedetecteerd, verkeerd wasprogramma geselecteerd",
    ROLLOVER_STATUS_CODE_25:"Claxonsensor",
    ROLLOVER_STATUS_CODE_98:"Handmatige / aanpassingsmodus",
    ROLLOVER_STATUS_CODE_99:"Onbekende status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Statuscode niet gedefinieerd",
    ALARM:"Kritieke fout",
    NO_ALARM:"Geen kritieke fout",
    SOFTWARE_VERSION:"Softwareversie",
    SOFTWARE_DATE:"Softwaredatum",
    SITE_ADDRESS:"Site adres",
    SECONDS:"Seconden",
    SERVICE_PART_NAME:"Servicenaam:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"bediening- en onderhoudsteller",
    OPERATION_COUNTER:"Bedieningsteller",
    SERVICE_COUNTER:"Servicecounter",
    FAULT_CODE:"Meldingscode",
    PRESSURE_TITLE:"Luchtdruk",
    TIME_TITLE:"Huidige tijd",
    COUNTRY_TITLE:"Land",
    CITY_TITLE:"Stad",
    REGION_TITLE:"Regio",
    SELECT_POINTS_TO_SEARCH:"Selecteer punten ...",
    LOGS_HISTORY:"Parameterwijzigingsgeschiedenis",
    ACTUATOR_REFERENCE:"Actuatorreferentie",
    ACTUATOR_VALUE:"Actuatorwaarde",
    POINT_ID:"Punt-ID",
    VALIDATION_NOT_VALID_RANGE:"Onjuiste reeks",
    ENABLE_ROLLOVER_RESET:"Door dit vakje aan te vinken bevestigt u dat u de veiligheidsinstructies hebt gelezen en ermee akkoord gaat.",
    CHANGE_OF_PARAMETERS:"Wijziging van parameters",
    SELECT_OPTIONS:"Selecteer opties",
    AUTOMATIC:"Automatisch",
    DESALTING:"Ontzoutingsfunctie",
    SEASON_WASH:"Seizoen wasprogramma's",
    SPRING_PROGRAM:"Lente wasprogramma's",
    SUMMER_PROGRAM:"Zomer wasprogramma's",
    AUTUMN_PROGRAM:"Herfst wasprogramma's",
    WINTER_PROGRAM:"Winter wasprogramma's",
    DOOR_CONTROL:"Deurbediening",
    SUMMER_DOOR_CONTROL:"Zomer, bediend met de poortbediening in zomermodus",
    WINTER_DOOR_CONTROL:"Winter, bediend met de poortbediening in wintermodus",
    APPLY_PARAMETERS_CHANGES:"Pas parameterwijzigingen toe",
    WORKING_SCHEDULES:"Werkroosters",
    HOLIDAY_SCHEDULES:"Vakantieschema's",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Vakanties op locatie succesvol aangemaakt",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Vakanties op locatie succesvol bijgewerkt",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Vakanties op locatie succesvol verwijderd",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Werkroosters succesvol verspreid",
    HOLIDAY_SUCCESSFULLY_DELETED:"Vakantie succesvol verwijderd",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Droogmiddel met laag vulniveau",
    CHEM_LEVEL_LOW_SHAMPOO:"Shampoo met laag vulniveau",
    CHEM_LEVEL_LOW_FOAM:"Schuim met laag vulniveau",
    CHEM_LEVEL_LOW_WAX_1:"Was met laag vulniveau",
    CHEM_LEVEL_LOW_POLISH_1:"Polish met laag vulniveau",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Velgenreiniger met laag vulniveau",
    CHEM_LEVEL_LOW_WAX_2:"Was met laag vulniveau",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Bandenglans met laag vulniveau",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Insectenverwijderaar met laag vulniveau",
    CHEM_LEVEL_LOW_POLISH_2:"Polish met laag vulniveau",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensief met laag vulniveau",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Schuimregen met laag vulniveau",
    CHEM_LEVEL_DRYING_AGENT:"Vulniveau droogmiddel",
    CHEM_LEVEL_SHAMPOO:"Vulniveau shampoo",
    CHEM_LEVEL_FOAM:"Vulniveau schuim",
    CHEM_LEVEL_WAX_1:"Vulniveau was",
    CHEM_LEVEL_POLISH_1:"Vulniveau polish",
    CHEM_LEVEL_RIM_CLEANER:"Vulniveau velgenreiniger",
    CHEM_LEVEL_WAX_2:"Vulniveau was",
    CHEM_LEVEL_TYRE_SHINE:"Vulniveau bandenglans",
    CHEM_LEVEL_INSECT_REMOVER:"Vulniveau insectenverwijderaar",
    CHEM_LEVEL_POLISH_2:"Vulniveau polish",
    CHEM_LEVEL_INTENSIVE:"Vulniveau intensief",
    CHEM_LEVEL_FOAM_RAIN:"Vulniveau schuimregen",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servicebalie dakborstel hijsband",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servicebalie droger hijsband",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servicebalie motorkabel dakborstel",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servicebalie zoetwaterpomp onderhoud",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servicebalie pomp onderhoud gebruikt water",
    DRYING_AGENT:"Droogmiddel",
    FOAM_DRYING_AGENT:"Schuim droogmiddel",
    SHAMPOO:"Shampoo",
    FOAM:"Schuim",
    BRUSH_FOAM:"Brush foam",
    WAX_1:"Was",
    FOAM_WAX_1:"Schuim was",
    POLISH_1:"Polish",
    RIM_CLEANING:"Velgenreiniger",
    WAX_2:"Was",
    FOAM_WAX_2:"Schuim was",
    TYRE_SHINE:"Bandenglans",
    INSECT_REMOVER:"Insectenverwijderaar",
    POLISH_2:"Polish",
    INTENSIVE_BASIC:"Intensief basis",
    INTENSIVE_SIDE:"Intensieve zijde",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensieve dak spray bar",
    TAR_REMOVER:"Teer verwijderaar",
    UNDER_CHASSIS_CONVERSATION:"Onderstel gesprek",
    STATIONARY_PRE_SPRAY_ARCH:"Stationaire voor-spray boog",
    FOAM_RAIN:"Schuimregen",
    PRE_CLEANING:"Voorreiniging",
    BRUSH:"Borstel",
    CARE:"Verzorging",
    DRYING:"Drogen",
    DRYING_LOW_NOISE:"Drogen met verminderd geluid",
    INTENSIVE_CLEANING:"Intensieve reiniging",
    BRUSH_CLEANING:"Borstels reinigen",
    EMPTY_RUN:"Lege run",
    DRYING_AID:"Drooghulp",
    WAX:"Was",
    FOAM_WASH:"Schuimwas",
    POLISH:"Polish",
    FOAM_POLISH:"Schuim polish",
    WHEEL_CLEANING:"Wielen reinigen",
    HIGH_PRESSURE_ROOF:"Dak hoge druk",
    HIGH_PRESSURE_SIDE:"Zijkant hoge druk",
    DRYER_FORWARD:"Droger vooruit",
    DRYER_BACKWARD:"Droger achteruit",
    DELETE_ALL_HOLIDAYS:" Verwijder alle feestdagen voor geselecteerde locatie",
    CREATE_NEW_HOLIDAY:"Maak nieuw",
    RESET_INPUTS:"Reset alle feestdagen invoer",
    TWENTY_FOUR_HOURS_OPEN:"24 uur open",
    EVERY_YEAR:"Jaarlijks",
    DELETE_HOLIDAY:"Verwijder feestdag",
    ADD_NEW_HOLIDAY:"Voeg nieuwe feestdag toe",
    HOLIDAYS_LIST:"Lijst van bestaande feestdagen",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Verwijder alle feestdagen voor geselecteerde locatie?",
    VALIDATION_HOLIDAY_DATE:"Formaat niet correct. Gebruik mm-dd",
    FOR_DATE:"Voor datum",
    WITH_ID:"Met ID",
    FROM_HOURS:"Van (u)",
    FROM_MINUTES:"Van (min)",
    TO_HOURS:"Tot (u)",
    TO_MINUTES:"Tot (min)",
    NOT_MATCH:"Komt niet overeen",
    START:"Van",
    STOP:"Tot",
    DAILY_TIME:"24 uur lijst",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individuele tijdinstelling",
    PROGRAM_NOT_STARTED:"Programma nog niet gestart",
    JETWASH:"Zelfbedieningswassysteem",
    KARCHER_REPORT_1:"Rollover: Omzetindicatie per programma en in totaal",
    KARCHER_REPORT_2:"Rollover: Gestarte wasbeurten per programma en in totaal",
    KARCHER_REPORT_3:"Rollover: Uitgevoerde wasbeurten per programma en in totaal",
    KARCHER_REPORT_4:"Rollover: Aantal gestarte wasbeurten via betaalterminal per programma en in totaal",
    KARCHER_REPORT_5:"Rollover: Aantal handmatig gestarte wasbeurten per programma en in totaal",
    KARCHER_REPORT_6:"Rollover: Aantal geannuleerde wasbeurten per programma en in totaal",
    KARCHER_REPORT_7:"Rollover: Aantal stroomstoringen",
    KARCHER_REPORT_8:"SB-Units: Aantal uren per wasprogramma gefilterd per baai en in totaal",
    KARCHER_REPORT_9:"SB-Units: Omzetindicatie per wasbaai en in totaal",
    KARCHER_REPORT_10:"SB-Units: Token/Munten teller per muntkanaal",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Zoetwaterpomp",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Proceswaterpomp",
    OPERATION_COUNTER_HP_PUMP_1:"Hogedrukpomp 1",
    OPERATION_COUNTER_HP_PUMP_2:"Hogedrukpomp 2",
    RELEASE_NOTES:"App-versies en release-opmerkingen",
    BACKEND_RELEASE_NOTES:"Platform release-opmerkingen:",
    FRONTEND_RELEASE_NOTES:"Webapplicatie release-opmerkingen:",
    SELECTED_FACILITY_TIMEZONE:"Tijdzone voor geselecteerde faciliteit:",
    REFRESH_PAGE:"Vernieuw pagina",
    REFRESH_MAPS:"Vernieuw kaarten",
    PUMPS:"Pompen",
    RUN_TIME:"Looptijd",
    RUN_TIME1:"Looptijd 1",
    RUN_TIME2:"Looptijd 2",
    PROGRAM_RUNTIME_ACTUATOR:"Actuator voor looptijd",
    PROGRAM_RUNTIME_ACTUATOR_1:"Actuator voor looptijd 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Actuator voor looptijd 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimale waarde is 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maximale waarde is 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Gebruik prijsformaat x.xx",
    ACTUATION_NOT_ALLOWED:"Actuatie niet toegestaan voor huidige gebruikersrol",
    MAINTENANCE_DAYS:"Onderhoudsdagen",
    MAINTENANCE_WASHES:"Onderhoudsbeurten",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Totaal inkomen POS",
    PROPAGATE:"Verspreiden",
    ALL_DAY_HOURS_SELECTOR:"24-uurs type selector",
    GET_OPERATING_TIME_FROM_SITE:"Haal bedrijfstijd van huidig apparaat uit werkschema's van de site",
    USER_NOT_VALID:"Gebruiker is niet geldig. Probeer met andere accountgegevens.",
    VERIFIED:"Geverifieerd",
    RESEND_VERIFICATION_MAIL:"Verificatie-e-mail opnieuw verzenden",
    RETURN_TO_DASHBOARD:"Terug naar dashboard",
    ERROR_PAGE_BAD_REQUEST:"400 Foutieve aanvraag.",
    WASHES:"Aantal wasbeurten",
    TIME_TO_SERVICE:"Tijd tot onderhoud",
    ACCOUNT_ALREADY_ACTIVATED:"Account al geactiveerd",
    DEVICE_EVENTS:"Apparatuurevenementen",
    DEVICE_EVENTS_LOG_PULLED:"Opgevraagd evenementenlogboek voor apparaat",
    EVENTS_PULL_DATE:"Opgevraagde evenementen tijd",
    DEVICE_EVENTS_REFRESH:"Nieuwe evenementgegevens ophalen",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Websockets verbindingsprobleem. Probeer de pagina te verversen.",
    INSTALLATION_DATE:"Installatiedatum van de machine",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Heet wax",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Hoge druk reiniging",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Power rim schuim",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Power schuim",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Stop",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Schuimwas HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Was",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Topverzorging",
    INFO_TITLE:"Info",
    FOAM_WAX1:"Schuim was",
    POLISH1:"Polish",
    WAX1:"Was",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Sitegegevens succesvol bijgewerkt",
    COMPANY:"Bedrijf",
    FACILITY_HAS_CHANGER:"Heeft u een wisselaar?",
    DISABLE_OFFLINE_ALARM:"R2W-alarmen uitschakelen",
    ASIDE_WORKING_SCHEDULES:"App-sitegegevens",
    TERMS_OF_SERVICE_R2W_TITLE:"Ready2Wash servicevoorwaarden",
    TERMS_OF_SERVICE_R2W:"Ready2Wash servicevoorwaarden",
    DATA_PROCESSING_TITLE:"Gegevens verwerkt",
    PRIVACY_POLICY_TITLE:"Privacybeleid",
    READY_TO_PAY_TERMS_OF_SERVICE:"Ready2Pay servicevoorwaarden",
    TERMS_AND_SERVICES:"Voorwaarden en diensten",
    HOURLY: "Elk uur",
    DAILY: "Dagelijks",
    WEEKLY: "Wekelijks",
    MONTHLY: "Maandelijks",
    YEARLY: "Jaarlijks",
    DELETE_ITEM_SUCCESS:"U heeft het item succesvol verwijderd",
    STATE: "Staat",
    AVAILABILITY_STATUS_1: "Eenheid open",
    AVAILABILITY_STATUS_2: "Eenheid gesloten (vakantie)",
    AVAILABILITY_STATUS_3: "Eenheid gesloten (openingstijden)",
    AVAILABILITY_STATUS_4: "Eenheid gesloten (storing)",
    AVAILABILITY_STATUS_5: "Eenheid gesloten (overig)",
    AVAILABILITY_VACUUMS_STATUS_1: "Stofzuigers niet geïnstalleerd",
    AVAILABILITY_VACUUMS_STATUS_2: "Stofzuigers open",
    AVAILABILITY_VACUUMS_STATUS_3: "Stofzuigers gesloten (vakantie)",
    AVAILABILITY_VACUUMS_STATUS_4: "Stofzuigers gesloten (openingstijden)",
    AVAILABILITY_VACUUMS_STATUS_5: "Stofzuigers gesloten (storing)",
    AVAILABILITY_VACUUMS_STATUS_6: "Stofzuigers gesloten (overig)",
    ECOM_AMOUNT: "Totale Ecom voor alle locaties",
    CAPTURED: "Gevangen",
    DELETE_COMPANY_HISTORY_INFO:"Deze actie verwijdert alle rapportgegevens van uw bedrijf. Deze actie kan niet ongedaan worden gemaakt.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Weet u zeker dat u alle rapportgegevens permanent wilt verwijderen?",
    VALUE_DATE: "Waardedatum",
    KARCHER_EVENT_NAME_1: "Basis warmtewisselaar geregenereerd",
    KARCHER_EVENT_NAME_2: "Regeneratie van de basis warmtewisselaar voltooid",
    KARCHER_EVENT_NAME_3: "Materiaal / serienummer",
    KARCHER_EVENT_NAME_4: "Het systeem is gedesinfecteerd",
    KARCHER_EVENT_NAME_5: "HP-pomp 1 gedesinfecteerd",
    KARCHER_EVENT_NAME_6: "HP-pomp 2 gedesinfecteerd",
    KARCHER_EVENT_NAME_7: "HP-pomp 3 gedesinfecteerd",
    KARCHER_EVENT_NAME_8: "HP-pomp 4 gedesinfecteerd",
    KARCHER_EVENT_NAME_9: "HP-pomp 5 gedesinfecteerd",
    KARCHER_EVENT_NAME_10: "Waspunt 1 vergrendeld",
    KARCHER_EVENT_NAME_11: "Waspunt 2 vergrendeld",
    KARCHER_EVENT_NAME_12: "Waspunt 3 vergrendeld",
    KARCHER_EVENT_NAME_13: "Waspunt 4 vergrendeld",
    KARCHER_EVENT_NAME_14: "Waspunt 5 vergrendeld",
    KARCHER_EVENT_NAME_15: "Waspunt 6 vergrendeld",
    KARCHER_EVENT_NAME_16: "Waspunt 7 vergrendeld",
    KARCHER_EVENT_NAME_17: "Waspunt 8 vergrendeld",
    KARCHER_EVENT_NAME_18: "Update gestart",
    KARCHER_EVENT_NAME_19: "Update voltooid",
    KARCHER_EVENT_NAME_20: "WS Reg start",
    KARCHER_EVENT_NAME_21: "WS Reg einde",
    KARCHER_EVENT_NAME_22: "WS 75%-sensor",
    KARCHER_EVENT_NAME_23: "Technische storing",
    KARCHER_EVENT_NAME_24: "Bedrijfsstoring",
    KARCHER_EVENT_NAME_25: "Eenheid ingeschakeld",
    KARCHER_EVENT_NAME_26: "Eenheid uitgeschakeld",
    KARCHER_EVENT_NAME_27: "Doos 1 gesloten",
    KARCHER_EVENT_NAME_28: "Doos 2 gesloten",
    KARCHER_EVENT_NAME_29: "Doos 3 gesloten",
    KARCHER_EVENT_NAME_30: "Doos 4 gesloten",
    KARCHER_EVENT_NAME_31: "Doos 5 gesloten",
    KARCHER_EVENT_NAME_32: "Doos 6 gesloten",
    KARCHER_EVENT_NAME_33: "Doos 7 gesloten",
    KARCHER_EVENT_NAME_34: "Doos 8 gesloten",
    KARCHER_EVENT_NAME_35: "HP-pomppunt 1",
    KARCHER_EVENT_NAME_36: "HP-pomppunt 2",
    KARCHER_EVENT_NAME_37: "HP-pomppunt 3",
    KARCHER_EVENT_NAME_38: "HP-pomppunt 4",
    KARCHER_EVENT_NAME_39: "HP-pomppunt 5",
    KARCHER_EVENT_NAME_40: "HP-pomppunt 6",
    KARCHER_EVENT_NAME_41: "HP-pomppunt 7",
    KARCHER_EVENT_NAME_42: "HP-pomppunt 8",
    KARCHER_EVENT_NAME_43: "Brander",
    KARCHER_EVENT_NAME_44: "Ventilator van de brander",
    KARCHER_EVENT_NAME_45: "Warmwaterpomp",
    KARCHER_EVENT_NAME_46: "Vorstbeschermingspomp",
    KARCHER_EVENT_NAME_47: "Osmosepomp",
    KARCHER_EVENT_NAME_48: "Vloerverwarming",
    KARCHER_EVENT_NAME_49: "Slangverwarming",
    KARCHER_EVENT_NAME_50: "Micro-/velgenreiniging",
    KARCHER_EVENT_NAME_51: "Onderstel waspomp",
    KARCHER_EVENT_NAME_52: "Schuimpompbooster",
    KARCHER_EVENT_NAME_53: "Stofzuiger 1",
    KARCHER_EVENT_NAME_54: "Stofzuiger 2",
    KARCHER_EVENT_NAME_55: "Stofzuiger 3",
    KARCHER_EVENT_NAME_56: "Stofzuiger 4",
    KARCHER_EVENT_NAME_57: "Stofzuiger 5",
    KARCHER_EVENT_NAME_58: "Stofzuiger 6",
    KARCHER_EVENT_NAME_59: "Stofzuiger 7",
    KARCHER_EVENT_NAME_60: "Stofzuiger 8",
    KARCHER_EVENT_NAME_61: "Stofzuiger 9",
    KARCHER_EVENT_NAME_62: "Stofzuiger 10",
    KARCHER_EVENT_NAME_63: "Stofzuiger 11",
    KARCHER_EVENT_NAME_64: "Stofzuiger 12",
    KARCHER_EVENT_NAME_65: "Velgreinigingspomp",
    KARCHER_EVENT_NAME_66: "Micro pomp",
    KARCHER_EVENT_NAME_67: "Intensieve pomp",
    KARCHER_EVENT_NAME_68: "Turbine stofzuiger 1",
    KARCHER_EVENT_NAME_69: "Filter stofzuiger 1",
    KARCHER_EVENT_NAME_70: "Turbine stofzuiger 2",
    KARCHER_EVENT_NAME_71: "Filter stofzuiger 2",
    KARCHER_EVENT_NAME_72: "Turbine stofzuiger 3",
    KARCHER_EVENT_NAME_73: "Filter stofzuiger 3",
    KARCHER_EVENT_NAME_74: "Turbine stofzuiger 4",
    KARCHER_EVENT_NAME_75: "Filter stofzuiger 4",
    KARCHER_EVENT_NAME_76: "Turbine stofzuiger 5",
    KARCHER_EVENT_NAME_77: "Filter stofzuiger 5",
    KARCHER_EVENT_NAME_78: "Turbine stofzuiger 6",
    KARCHER_EVENT_NAME_79: "Filter stofzuiger 6",
    KARCHER_EVENT_NAME_80: "Turbine stofzuiger 7",
    KARCHER_EVENT_NAME_81: "Filter stofzuiger 7",
    KARCHER_EVENT_NAME_82: "Turbine stofzuiger 8",
    KARCHER_EVENT_NAME_83: "Filter stofzuiger 8",
    KARCHER_EVENT_NAME_84: "Turbine stofzuiger 9",
    KARCHER_EVENT_NAME_85: "Filter stofzuiger 9",
    KARCHER_EVENT_NAME_86: "Turbine stofzuiger 10",
    KARCHER_EVENT_NAME_87: "Filter stofzuiger 10",
    KARCHER_EVENT_NAME_88: "Turbine stofzuiger 11",
    KARCHER_EVENT_NAME_89: "Filter stofzuiger 11",
    KARCHER_EVENT_NAME_90: "Turbine stofzuiger 12",
    KARCHER_EVENT_NAME_91: "Filter stofzuiger 12",
    INSERT_TOKEN: "Voer tokens in en start de service",
    OPEN_SESSION: "Sessie succesvol geopend",
    IN_PROGRESS: "Bezig ...",
    TOKEN_INSERTED: "Tokens succesvol ingevoerd",
    EXPIRED_SESSION: "Sessie verlopen",
    TWO_DIGIT_INTEGER_VALIDATION: "Gebruik maximaal een tweecijferig geheel getal",
    KARCHER_OPERATION_COUNTER_1: "Wasstation 1 HP-pomp",
    KARCHER_OPERATION_COUNTER_2: "Wasstation 1 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_3: "Wasstation 1 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_4: "Wasstation 1 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_5: "Wasstation 1 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_6: "Wasstation 2 HP-pomp",
    KARCHER_OPERATION_COUNTER_7: "Wasstation 2 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_8: "Wasstation 2 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_9: "Wasstation 2 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_10: "Wasstation 2 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_11: "Wasstation 3 HP-pomp",
    KARCHER_OPERATION_COUNTER_12: "Wasstation 3 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_13: "Wasstation 3 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_14: "Wasstation 3 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_15: "Wasstation 3 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_16: "Wasstation 4 HP-pomp",
    KARCHER_OPERATION_COUNTER_17: "Wasstation 4 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_18: "Wasstation 4 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_19: "Wasstation 4 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_20: "Wasstation 4 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_21: "Wasstation 5 HP-pomp",
    KARCHER_OPERATION_COUNTER_22: "Wasstation 5 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_23: "Wasstation 5 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_24: "Wasstation 5 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_25: "Wasstation 5 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_26: "Wasstation 6 HP-pomp",
    KARCHER_OPERATION_COUNTER_27: "Wasstation 6 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_28: "Wasstation 6 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_29: "Wasstation 6 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_30: "Wasstation 6 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_31: "Wasstation 7 HP-pomp",
    KARCHER_OPERATION_COUNTER_32: "Wasstation 7 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_33: "Wasstation 7 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_34: "Wasstation 7 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_35: "Wasstation 7 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_36: "Wasstation 8 HP-pomp",
    KARCHER_OPERATION_COUNTER_37: "Wasstation 8 chemische pomp 1",
    KARCHER_OPERATION_COUNTER_38: "Wasstation 8 chemische pomp 2",
    KARCHER_OPERATION_COUNTER_39: "Wasstation 8 chemische pomp 3",
    KARCHER_OPERATION_COUNTER_40: "Wasstation 8 chemische pomp 4",
    KARCHER_OPERATION_COUNTER_41: "Osmosepomp",
    KARCHER_OPERATION_COUNTER_42: "Warmwatergenerator",
    KARCHER_OPERATION_COUNTER_43: "Antivriespomp",
    KARCHER_OPERATION_COUNTER_44: "WSO-filterpatronen",
    KARCHER_OPERATION_COUNTER_45: "Verwarmingspomp voor wasstation",
    KARCHER_OPERATION_COUNTER_46: "Warmwaterpomp",
    KARCHER_OPERATION_COUNTER_47: "Slangverwarming voor schuim",
    KARCHER_OPERATION_COUNTER_48: "Wielwaspomp",
    KARCHER_OPERATION_COUNTER_49: "Micro-emulsiepomp",
    KARCHER_OPERATION_COUNTER_50: "Intensieve schuimpomp",
    KARCHER_OPERATION_COUNTER_51: "Stofzuiger 1 turbine 1",
    KARCHER_OPERATION_COUNTER_52: "Stofzuiger 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Stofzuiger 1 turbine 2",
    KARCHER_OPERATION_COUNTER_54: "Stofzuiger 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Stofzuiger 2 turbine 1",
    KARCHER_OPERATION_COUNTER_56: "Stofzuiger 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Stofzuiger 2 turbine 2",
    KARCHER_OPERATION_COUNTER_58: "Stofzuiger 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Stofzuiger 3 turbine 1",
    KARCHER_OPERATION_COUNTER_60: "Stofzuiger 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Stofzuiger 3 turbine 2",
    KARCHER_OPERATION_COUNTER_62: "Stofzuiger 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Stofzuiger 4 turbine 1",
    KARCHER_OPERATION_COUNTER_64: "Stofzuiger 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Stofzuiger 4 turbine 2",
    KARCHER_OPERATION_COUNTER_66: "Stofzuiger 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Stofzuiger 5 turbine 1",
    KARCHER_OPERATION_COUNTER_68: "Stofzuiger 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Stofzuiger 5 turbine 2",
    KARCHER_OPERATION_COUNTER_70: "Stofzuiger 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Stofzuiger 6 turbine 1",
    KARCHER_OPERATION_COUNTER_72: "Stofzuiger 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Stofzuiger 6 turbine 2",
    KARCHER_OPERATION_COUNTER_74: "Stofzuiger 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Condenswater uit de compressor verwijderen",
    KARCHER_OPERATION_COUNTER_76: "Controleer antivriessysteem",
    KARCHER_OPERATION_COUNTER_77: "Ventilator van brander",
    KARCHER_OPERATION_COUNTER_78: "Schuimversterkingspomp",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "De gegevenslijst is groter dan 10000 items",
    KARCHER_POINT_NAME_1: "Feestdag",
    KARCHER_POINT_NAME_2: "Maandag",
    KARCHER_POINT_NAME_3: "Dinsdag",
    KARCHER_POINT_NAME_4: "Woensdag",
    KARCHER_POINT_NAME_5: "Donderdag",
    KARCHER_POINT_NAME_6: "Vrijdag",
    KARCHER_POINT_NAME_7: "Zaterdag",
    KARCHER_POINT_NAME_8: "Zondag",
    KARCHER_POINT_NAME_9: "Stofzuigers Feestdag",
    KARCHER_POINT_NAME_10: "Stofzuigers Maandag",
    KARCHER_POINT_NAME_11: "Stofzuigers Dinsdag",
    KARCHER_POINT_NAME_12: "Stofzuigers Woensdag",
    KARCHER_POINT_NAME_13: "Stofzuigers Donderdag",
    KARCHER_POINT_NAME_14: "Stofzuigers Vrijdag",
    KARCHER_POINT_NAME_15: "Stofzuigers Zaterdag",
    KARCHER_POINT_NAME_16: "Stofzuigers Zondag",
    KARCHER_POINT_NAME_17: "Verlichting Feestdag",
    KARCHER_POINT_NAME_18: "Verlichting Maandag",
    KARCHER_POINT_NAME_19: "Verlichting Dinsdag",
    KARCHER_POINT_NAME_20: "Verlichting Woensdag",
    KARCHER_POINT_NAME_21: "Verlichting Donderdag",
    KARCHER_POINT_NAME_22: "Verlichting Vrijdag",
    KARCHER_POINT_NAME_23: "Verlichting Zaterdag",
    KARCHER_POINT_NAME_24: "Verlichting Zondag",
    KARCHER_POINT_NAME_25: "Programma 0",
    KARCHER_POINT_NAME_26: "Programma 1",
    KARCHER_POINT_NAME_27: "Programma 2",
    KARCHER_POINT_NAME_28: "Programma 3",
    KARCHER_POINT_NAME_29: "Programma 4",
    KARCHER_POINT_NAME_30: "Programma 5",
    KARCHER_POINT_NAME_31: "Programma 6",
    KARCHER_POINT_NAME_32: "Programma 7",
    KARCHER_POINT_NAME_33: "Programma 8",
    KARCHER_POINT_NAME_34: "Programma 9",
    KARCHER_POINT_NAME_35: "Programma 10",
    KARCHER_POINT_NAME_36: "Programma 11",
    KARCHER_POINT_NAME_37: "Programma 12",
    KARCHER_POINT_NAME_38: "Programma 13",
    KARCHER_POINT_NAME_39: "Programma 14",
    KARCHER_POINT_NAME_40: "Programma 15",
    KARCHER_POINT_NAME_41: "Programma 16",
    KARCHER_POINT_NAME_42: "Programma 17",
    KARCHER_POINT_NAME_43: "Programma 18",
    KARCHER_POINT_NAME_44: "Programma 19",
    KARCHER_POINT_NAME_45: "Programma 20",
    KARCHER_POINT_NAME_46: "Programma 21",
    KARCHER_POINT_NAME_47: "Programma 22",
    KARCHER_POINT_NAME_48: "Programma 23",
    KARCHER_POINT_NAME_49: "Programma 24",
    KARCHER_POINT_NAME_50: "Programma 25",
    KARCHER_POINT_NAME_51: "Programma 26",
    KARCHER_POINT_NAME_52: "Programma 27",
    KARCHER_POINT_NAME_53: "Programma 28",
    KARCHER_POINT_NAME_54: "Programma 29",
    KARCHER_POINT_NAME_55: "Programma 30",
    KARCHER_POINT_NAME_56: "Programma 31",
    KARCHER_POINT_NAME_57: "Programma 32",
    QR_CODE: "QR-code",
    ACCEPT_TERMS_AND_CONDITIONS: "Accepteer algemene voorwaarden",
    CREATE_AND_PRINT_VOUCHERS: "Maak en print waardebonnen",
    CODE_PREFIX_QUESTION: "Codevoorvoegsel is niet ingevoerd",
    CODE_PREFIX_QUESTION_TEXT: "Wilt u doorgaan zonder codevoorvoegsel?",
    ISSUED_DATE: "Uitgiftedatum",
    VOUCHER_VALIDITY_DAYS: "Geldigheid waardebon (dagen)",
    VALIDATION_ONLY_NUMBERS: "Alleen nummers zijn toegestaan",
    REPRINT_VOUCHERS: "Kopie van waardebonnen afdrukken",
    EXPIRY_DATE: "Geldig tot"
  });
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('locales', localesConfig);
  /* eslint-disable */
  /** @ngInject */
  function localesConfig($translate, $locale) {
    return {
      sr: {
        DATETIME_FORMATS: {
          AMPMS: ['pre podne', 'po podne'],
          DAY: [
            'nedelja',
            'ponedeljak',
            'utorak',
            'sreda',
            '\u010detvrtak',
            'petak',
            'subota'
          ],
          ERANAMES: ['Pre nove ere', 'Nove ere'],
          ERAS: ['p. n. e.', 'n. e.'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'januar',
            'februar',
            'mart',
            'april',
            'maj',
            'jun',
            'jul',
            'avgust',
            'septembar',
            'oktobar',
            'novembar',
            'decembar'
          ],
          SHORTDAY: ['ned', 'pon', 'uto', 'sre', '\u010det', 'pet', 'sub'],
          SHORTMONTH: [
            'jan',
            'feb',
            'mar',
            'apr',
            'maj',
            'jun',
            'jul',
            'avg',
            'sep',
            'okt',
            'nov',
            'dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, dd. MMMM y.',
          longDate: 'dd. MMMM y.',
          medium: 'dd.MM.y. HH.mm.ss',
          mediumDate: 'dd.MM.y.',
          mediumTime: 'HH.mm.ss',
          short: 'd.M.yy. HH.mm',
          shortDate: 'd.M.yy.',
          shortTime: 'HH.mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'din',
          DECIMAL_SEP: ',',
          GROUP_SEP: '.',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'sr-latn',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (
            (vf.v == 0 && i % 10 == 1 && i % 100 != 11) ||
            (vf.f % 10 == 1 && vf.f % 100 != 11)
          ) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            (vf.v == 0 &&
              i % 10 >= 2 &&
              i % 10 <= 4 &&
              (i % 100 < 12 || i % 100 > 14)) ||
            (vf.f % 10 >= 2 &&
              vf.f % 10 <= 4 &&
              (vf.f % 100 < 12 || vf.f % 100 > 14))
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      en: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
          ],
          SHORTDAY: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          SHORTMONTH: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '$',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'en',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      tw: {
        DATETIME_FORMATS: {
          AMPMS: ['上午', '下午'],
          DAY: [
            '星期日',
            '星期一',
            '星期二',
            '星期三',
            '星期四',
            '星期五',
            '星期六'
          ],
          ERANAMES: ['西元前', '西元'],
          ERAS: ['西元前', '西元'],
          FIRSTDAYOFWEEK: 0,
          MONTH: [
            '一月',
            '二月',
            '三月',
            '四月',
            '五月',
            '六月',
            '七月',
            '八月',
            '九月',
            '十月',
            '十一月',
            '十二月'
          ],
          SHORTDAY: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
          SHORTMONTH: [
            '1月',
            '2月',
            '3月',
            '4月',
            '5月',
            '6月',
            '7月',
            '8月',
            '9月',
            '10月',
            '11月',
            '12月'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'y年M月d日 EEEE',
          longDate: 'y年M月d日',
          medium: 'y年M月d日 ah:mm:ss',
          mediumDate: 'y年M月d日',
          mediumTime: 'ah:mm:ss',
          short: 'y/M/d ah:mm',
          shortDate: 'y/M/d',
          shortTime: 'ah:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'NT$',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'tw',
        pluralCat: function (n, opt_precision) {
          return PLURAL_CATEGORY.OTHER;
        }
      },
      pl: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'niedziela',
            'poniedziałek',
            'wtorek',
            'środa',
            'czwartek',
            'piątek',
            'sobota'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'styczeń',
            'luty',
            'marzec',
            'kwiecień',
            'maj',
            'czerwiec',
            'lipiec',
            'sierpień',
            'wrzesień',
            'październik',
            'listopad',
            'grudzień'
          ],
          SHORTDAY: ['ndz', 'pon', 'wt', 'śr', 'czw', 'pt', 'sob'],
          SHORTMONTH: [
            'sty',
            'lut',
            'mar',
            'kwi',
            'maj',
            'cze',
            'lip',
            'sie',
            'wrz',
            'paź',
            'lis',
            'gru'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'zl',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'pl',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      cs: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'neděle',
            'pondělí',
            'úterý',
            'středa',
            'čtvrtek',
            'pátek',
            'sobota'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'leden',
            'únor',
            'březen',
            'duben',
            'květen',
            'červen',
            'červenec',
            'srpen',
            'září',
            'říjen',
            'listopad',
            'prosinec'
          ],
          SHORTDAY: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
          SHORTMONTH: [
            'led',
            'úno',
            'bře',
            'dub',
            'kvě',
            'čvn',
            'čvc',
            'srp',
            'zář',
            'říj',
            'lis',
            'pro'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'kč',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'cs',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      de: {
        DATETIME_FORMATS: {
          AMPMS: ['vorm.', 'nachm.'],
          DAY: [
            'Sonntag',
            'Montag',
            'Dienstag',
            'Mittwoch',
            'Donnerstag',
            'Freitag',
            'Samstag'
          ],
          ERANAMES: ['v. Chr.', 'n. Chr.'],
          ERAS: ['v. Chr.', 'n. Chr.'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Januar',
            'Februar',
            'M\u00e4rz',
            'April',
            'Mai',
            'Juni',
            'Juli',
            'August',
            'September',
            'Oktober',
            'November',
            'Dezember'
          ],
          SHORTDAY: ['So.', 'Mo.', 'Di.', 'Mi.', 'Do.', 'Fr.', 'Sa.'],
          SHORTMONTH: [
            'Jan.',
            'Feb.',
            'M\u00e4rz',
            'Apr.',
            'Mai',
            'Juni',
            'Juli',
            'Aug.',
            'Sep.',
            'Okt.',
            'Nov.',
            'Dez.'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, d. MMMM y',
          longDate: 'd. MMMM y',
          medium: 'dd.MM.y HH:mm:ss',
          mediumDate: 'dd.MM.y',
          mediumTime: 'HH:mm:ss',
          short: 'dd.MM.yy HH:mm',
          shortDate: 'dd.MM.yy',
          shortTime: 'HH:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: ',',
          GROUP_SEP: '.',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'de',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      fr: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Dimanche',
            'Lundi',
            'Mardi',
            'Mercredi',
            'Jeudi',
            'Vendredi',
            'Samedi'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Janvier',
            'Février',
            'Mars',
            'Avril',
            'Mai',
            'Juin',
            'Juillet',
            'Août',
            'Septembre',
            'Octobre',
            'Novembre',
            'Décembre'
          ],
          SHORTDAY: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
          SHORTMONTH: [
            'janv',
            'févr',
            'mars',
            'avr',
            'mai',
            'juin',
            'juill',
            'août',
            'sept',
            'oct',
            'nov',
            'déc'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '/u20ac',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'fr',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      hr: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'nedjelja',
            'ponedjeljak',
            'utorak',
            'srijeda',
            '\u010detvrtak',
            'petak',
            'subota'
          ],
          ERANAMES: ['Prije Krista', 'Poslije Krista'],
          ERAS: ['pr. Kr.', 'p. Kr.'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'sije\u010dnja',
            'velja\u010de',
            'o\u017eujka',
            'travnja',
            'svibnja',
            'lipnja',
            'srpnja',
            'kolovoza',
            'rujna',
            'listopada',
            'studenoga',
            'prosinca'
          ],
          SHORTDAY: ['ned', 'pon', 'uto', 'sri', '\u010det', 'pet', 'sub'],
          SHORTMONTH: [
            'sij',
            'velj',
            'o\u017eu',
            'tra',
            'svi',
            'lip',
            'srp',
            'kol',
            'ruj',
            'lis',
            'stu',
            'pro'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, d. MMMM y.',
          longDate: 'd. MMMM y.',
          medium: 'd. MMM y. HH:mm:ss',
          mediumDate: 'd. MMM y.',
          mediumTime: 'HH:mm:ss',
          short: 'dd.MM.y. HH:mm',
          shortDate: 'dd.MM.y.',
          shortTime: 'HH:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'kn',
          DECIMAL_SEP: ',',
          GROUP_SEP: '.',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'hr',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (
            (vf.v == 0 && i % 10 == 1 && i % 100 != 11) ||
            (vf.f % 10 == 1 && vf.f % 100 != 11)
          ) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            (vf.v == 0 &&
              i % 10 >= 2 &&
              i % 10 <= 4 &&
              (i % 100 < 12 || i % 100 > 14)) ||
            (vf.f % 10 >= 2 &&
              vf.f % 10 <= 4 &&
              (vf.f % 100 < 12 || vf.f % 100 > 14))
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      sl: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'nedelja',
            'ponedeljek',
            'torek',
            'sreda',
            '\u010detrtek',
            'petek',
            'sobota'
          ],
          ERANAMES: ['Pred Kristusom', 'Po Kristusu'],
          ERAS: ['pr. Kr.', 'p. Kr.'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'januar',
            'februar',
            'marec',
            'april',
            'maj',
            'junij',
            'julij',
            'avgust',
            'september',
            'oktober',
            'november',
            'december'
          ],
          SHORTDAY: ['ned', 'pon', 'tor', 'sri', '\u010det', 'pet', 'sob'],
          SHORTMONTH: [
            'jan',
            'feb',
            'mar',
            'apr',
            'maj',
            'jun',
            'jul',
            'avg',
            'sep',
            'okt',
            'nov',
            'dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, d. MMMM y.',
          longDate: 'd. MMMM y.',
          medium: 'd. MMM y. HH:mm:ss',
          mediumDate: 'd. MMM y.',
          mediumTime: 'HH:mm:ss',
          short: 'dd.MM.y. HH:mm',
          shortDate: 'dd.MM.y.',
          shortTime: 'HH:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: ',',
          GROUP_SEP: '.',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'sl',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (
            (vf.v == 0 && i % 10 == 1 && i % 100 != 11) ||
            (vf.f % 10 == 1 && vf.f % 100 != 11)
          ) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            (vf.v == 0 &&
              i % 10 >= 2 &&
              i % 10 <= 4 &&
              (i % 100 < 12 || i % 100 > 14)) ||
            (vf.f % 10 >= 2 &&
              vf.f % 10 <= 4 &&
              (vf.f % 100 < 12 || vf.f % 100 > 14))
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      uk: {
        DATETIME_FORMATS: {
          AMPMS: ['\u0434\u043f', '\u043f\u043f'],
          DAY: [
            '\u0441\u0443\u0431\u043e\u0442\u0430',
            '\u043d\u0435\u0434\u0456\u043b\u044f',
            '\u043f\u043e\u043d\u0435\u0434\u0456\u043b\u043e\u043a',
            '\u0432\u0456\u0432\u0442\u043e\u0440\u043e\u043a',
            '\u0441\u0435\u0440\u0435\u0434\u0430',
            '\u0447\u0435\u0442\u0432\u0435\u0440',
            '\u043f\u02bc\u044f\u0442\u043d\u0438\u0446\u044f'
          ],
          MONTH: [
            '\u0441\u0456\u0447\u043d\u044f',
            '\u043b\u044e\u0442\u043e\u0433\u043e',
            '\u0431\u0435\u0440\u0435\u0437\u043d\u044f',
            '\u043a\u0432\u0456\u0442\u043d\u044f',
            '\u0442\u0440\u0430\u0432\u043d\u044f',
            '\u0447\u0435\u0440\u0432\u043d\u044f',
            '\u043b\u0438\u043f\u043d\u044f',
            '\u0441\u0435\u0440\u043f\u043d\u044f',
            '\u0432\u0435\u0440\u0435\u0441\u043d\u044f',
            '\u0436\u043e\u0432\u0442\u043d\u044f',
            '\u043b\u0438\u0441\u0442\u043e\u043f\u0430\u0434\u0430',
            '\u0433\u0440\u0443\u0434\u043d\u044f'
          ],
          SHORTDAY: [
            '\u041d\u0434',
            '\u041f\u043d',
            '\u0412\u0442',
            '\u0421\u0440',
            '\u0427\u0442',
            '\u041f\u0442',
            '\u0421\u0431'
          ],
          SHORTMONTH: [
            '\u0441\u0456\u0447.',
            '\u043b\u044e\u0442.',
            '\u0431\u0435\u0440.',
            '\u043a\u0432\u0456\u0442.',
            '\u0442\u0440\u0430\u0432.',
            '\u0447\u0435\u0440\u0432.',
            '\u043b\u0438\u043f.',
            '\u0441\u0435\u0440\u043f.',
            '\u0432\u0435\u0440.',
            '\u0436\u043e\u0432\u0442.',
            '\u043b\u0438\u0441\u0442.',
            '\u0433\u0440\u0443\u0434.'
          ],
          fullDate: "EEEE, d MMMM y '\u0440'.",
          longDate: "d MMMM y '\u0440'.",
          medium: "d MMM y '\u0440'. HH:mm:ss",
          mediumDate: "d MMM y '\u0440'.",
          mediumTime: 'HH:mm:ss',
          short: 'dd.MM.yy HH:mm',
          shortDate: 'dd.MM.yy',
          shortTime: 'HH:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20b4',
          DECIMAL_SEP: ',',
          GROUP_SEP: '\u00a0',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'uk',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (vf.v == 0 && i % 10 == 1 && i % 100 != 11) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            vf.v == 0 &&
            i % 10 >= 2 &&
            i % 10 <= 4 &&
            (i % 100 < 12 || i % 100 > 14)
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          if (
            (vf.v == 0 && i % 10 == 0) ||
            (vf.v == 0 && i % 10 >= 5 && i % 10 <= 9) ||
            (vf.v == 0 && i % 100 >= 11 && i % 100 <= 14)
          ) {
            return PLURAL_CATEGORY.MANY;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      hu: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'vasárnap',
            'hétfő',
            'kedd',
            'szerda',
            'csütörtök',
            'péntek',
            'szombat'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'január',
            'február',
            'március',
            'április',
            'május',
            'június',
            'július',
            'augusztus',
            'szeptember',
            'október',
            'november',
            'december'
          ],
          SHORTDAY: ['vas', 'hét', 'kedd', 'sze', 'csüt', 'pén', 'szo'],
          SHORTMONTH: [
            'jan',
            'feb',
            'márc',
            'ápr',
            'máj',
            'jún',
            'júl',
            'aug',
            'szept',
            'okt',
            'nov',
            'dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'ft',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'hu',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      ro: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Duminică',
            'Luni',
            'Marți',
            'Miercuri',
            'Joi',
            'Vineri',
            'Sâmbătă'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Ianuarie',
            'Februarie',
            'Martie',
            'Aprilie',
            'Mai',
            'Iunie',
            'Iulie',
            'August',
            'Septembrie',
            'Octombrie',
            'Noiembrie',
            'Decembrie'
          ],
          SHORTDAY: ['Dum', 'Lun', 'Mar', 'Mie', 'Joi', 'Vin', 'Sâm'],
          SHORTMONTH: [
            'Ian.',
            'Febr.',
            'Mart.',
            'Apr.',
            'Mai',
            'Iun.',
            'Iul.',
            'Aug.',
            'Sept.',
            'Oct.',
            'Nov.',
            'Dec.'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'M/d/yy h:mm a',
          shortDate: 'M/d/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: 'leu',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'ro',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      ru: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            '\u0441\u0443\u0431\u0431\u043e\u0442\u0430',
            '\u0432\u043e\u0441\u043a\u0440\u0435\u0441\u0435\u043d\u044c\u0435',
            '\u043f\u043e\u043d\u0435\u0434\u0435\u043b\u044c\u043d\u0438\u043a',
            '\u0432\u0442\u043e\u0440\u043d\u0438\u043a',
            '\u0441\u0440\u0435\u0434\u0430',
            '\u0447\u0435\u0442\u0432\u0435\u0440\u0433',
            '\u043f\u044f\u0442\u043d\u0438\u0446\u0430'
          ],
          MONTH: [
            '\u044f\u043d\u0432\u0430\u0440\u044f',
            '\u0444\u0435\u0432\u0440\u0430\u043b\u044f',
            '\u043c\u0430\u0440\u0442\u0430',
            '\u0430\u043f\u0440\u0435\u043b\u044f',
            '\u043c\u0430\u044f',
            '\u0438\u044e\u043d\u044f',
            '\u0438\u044e\u043b\u044f',
            '\u0430\u0432\u0433\u0443\u0441\u0442\u0430',
            '\u0441\u0435\u043d\u0442\u044f\u0431\u0440\u044f',
            '\u043e\u043a\u0442\u044f\u0431\u0440\u044f',
            '\u043d\u043e\u044f\u0431\u0440\u044f',
            '\u0434\u0435\u043a\u0430\u0431\u0440\u044f'
          ],
          SHORTDAY: [
            '\u0432\u0441',
            '\u043f\u043d',
            '\u0432\u0442',
            '\u0441\u0440',
            '\u0447\u0442',
            '\u043f\u0442',
            '\u0441\u0431'
          ],
          SHORTMONTH: [
            '\u044f\u043d\u0432.',
            '\u0444\u0435\u0432\u0440.',
            '\u043c\u0430\u0440\u0442\u0430',
            '\u0430\u043f\u0440.',
            '\u043c\u0430\u044f',
            '\u0438\u044e\u043d\u044f',
            '\u0438\u044e\u043b\u044f',
            '\u0430\u0432\u0433.',
            '\u0441\u0435\u043d\u0442.',
            '\u043e\u043a\u0442.',
            '\u043d\u043e\u044f\u0431.',
            '\u0434\u0435\u043a.'
          ],
          fullDate: "EEEE, d MMMM y '\u0433'.",
          longDate: "d MMMM y '\u0433'.",
          medium: "d MMM y '\u0433'. H:mm:ss",
          mediumDate: "d MMM y '\u0433'.",
          mediumTime: 'H:mm:ss',
          short: 'dd.MM.yy H:mm',
          shortDate: 'dd.MM.yy',
          shortTime: 'H:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u0440\u0443\u0431.',
          DECIMAL_SEP: ',',
          GROUP_SEP: '\u00a0',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: '\u00a0\u00a4',
              posPre: '',
              posSuf: '\u00a0\u00a4'
            }
          ]
        },
        id: 'ru',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (vf.v == 0 && i % 10 == 1 && i % 100 != 11) {
            return PLURAL_CATEGORY.ONE;
          }
          if (
            vf.v == 0 &&
            i % 10 >= 2 &&
            i % 10 <= 4 &&
            (i % 100 < 12 || i % 100 > 14)
          ) {
            return PLURAL_CATEGORY.FEW;
          }
          if (
            (vf.v == 0 && i % 10 == 0) ||
            (vf.v == 0 && i % 10 >= 5 && i % 10 <= 9) ||
            (vf.v == 0 && i % 100 >= 11 && i % 100 <= 14)
          ) {
            return PLURAL_CATEGORY.MANY;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      nl: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Zondag',
            'Maandag',
            'Dinsdag',
            'Woensdag',
            'Donderdag',
            'Vrijdag',
            'Zaterdag'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Januari',
            'Februari',
            'Maart',
            'April',
            'Mei',
            'Juni',
            'Juli',
            'Augustus',
            'September',
            'Oktober',
            'November',
            'December'
          ],
          SHORTDAY: ['Zo', 'Ma', 'Di', 'Wo', 'Do', 'Vr', 'Za'],
          SHORTMONTH: [
            'Jan',
            'Feb',
            'Mrt',
            'Apr',
            'Mei',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'd/M/yy h:mm a',
          shortDate: 'd/M/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'nl',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      sv: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Söndag',
            'Måndag',
            'Tisdag',
            'Onsdag',
            'Torsdag',
            'Fredag',
            'Lördag'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Januari',
            'Februari',
            'Mars',
            'April',
            'Maj',
            'Juni',
            'Juli',
            'Augusti',
            'September',
            'Oktober',
            'November',
            'December'
          ],
          SHORTDAY: ['sön', 'mån', 'tis', 'ons', 'tor', 'fre', 'lör'],
          SHORTMONTH: [
            'Jan',
            'Feb',
            'Mat',
            'Apr',
            'Maj',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Okt',
            'Nov',
            'Dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'd/M/yy h:mm a',
          shortDate: 'd/M/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'sv',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      sk: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'nedeľa',
            'pondelok',
            'utorok',
            'streda',
            'štvrtok',
            'piatok',
            'sobota'
          ],
          ERANAMES: ['pred Kristom', 'po Kristovi'],
          ERAS: ['pred Kr.', 'po Kr.'],
          FIRSTDAYOFWEEK: 0,
          MONTH: [
            'január',
            'február',
            'marec',
            'apríl',
            'máj',
            'jún',
            'júl',
            'august',
            'september',
            'október',
            'november',
            'december'
          ],
          SHORTDAY: ['ne', 'po', 'ut', 'st', 'št', 'pi', 'so'],
          SHORTMONTH: [
            'jan',
            'feb',
            'mar',
            'apr',
            'máj',
            'jún',
            'júl',
            'aug',
            'sep',
            'okt',
            'nov',
            'dec'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, d. MMMM y',
          longDate: 'd. MMMM y',
          medium: 'd. M. y H:mm:ss',
          mediumDate: 'd. M. y',
          mediumTime: 'H:mm:ss',
          short: 'd. M. y H:mm',
          shortDate: 'd. M. y',
          shortTime: 'H:mm'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '€',
          DECIMAL_SEP: ',',
          GROUP_SEP: ' ',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-',
              negSuf: ' \u00a4',
              posPre: '',
              posSuf: ' \u00a4'
            }
          ]
        },
        id: 'sk',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          if (i >= 2 && i <= 4 && vf.v == 0) {
            return PLURAL_CATEGORY.FEW;
          }
          if (vf.v != 0) {
            return PLURAL_CATEGORY.MANY;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      fi: {
        DATETIME_FORMATS: {
          AMPMS: ['AM', 'PM'],
          DAY: [
            'Sunnuntai',
            'Maanantai',
            'Tiistai',
            'Keskiviikko',
            'Torstai',
            'Perjantai',
            'Lauantai'
          ],
          ERANAMES: ['Before Christ', 'Anno Domini'],
          ERAS: ['BC', 'AD'],
          FIRSTDAYOFWEEK: 6,
          MONTH: [
            'Tammikuu',
            'Helmikuu',
            'Maaliskuu',
            'Huhtikuu',
            'Toukokuu',
            'Kesäkuu',
            'Heinäkuu',
            'Elokuu',
            'Syyskuu',
            'Lokakuu',
            'Marraskuu',
            'Joulukuu'
          ],
          SHORTDAY: ['su', 'ma', 'ti', 'ke', 'to', 'pe', 'la'],
          SHORTMONTH: [
            'Tammi',
            'Helmi',
            'Maalis',
            'Huhti',
            'Touko',
            'Kesä',
            'Heinä',
            'Elo',
            'Syys',
            'Loka',
            'Marras',
            'Joulu'
          ],
          WEEKENDRANGE: [5, 6],
          fullDate: 'EEEE, MMMM d, y',
          longDate: 'MMMM d, y',
          medium: 'MMM d, y h:mm:ss a',
          mediumDate: 'MMM d, y',
          mediumTime: 'h:mm:ss a',
          short: 'd/M/yy h:mm a',
          shortDate: 'd/M/yy',
          shortTime: 'h:mm a'
        },
        NUMBER_FORMATS: {
          CURRENCY_SYM: '\u20ac',
          DECIMAL_SEP: '.',
          GROUP_SEP: ',',
          PATTERNS: [
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 3,
              minFrac: 0,
              minInt: 1,
              negPre: '-',
              negSuf: '',
              posPre: '',
              posSuf: ''
            },
            {
              gSize: 3,
              lgSize: 3,
              maxFrac: 2,
              minFrac: 2,
              minInt: 1,
              negPre: '-\u00a4',
              negSuf: '',
              posPre: '\u00a4',
              posSuf: ''
            }
          ]
        },
        id: 'fi',
        pluralCat: function (n, opt_precision) {
          var i = n | 0;
          var vf = getVF(n, opt_precision);
          if (i == 1 && vf.v == 0) {
            return PLURAL_CATEGORY.ONE;
          }
          return PLURAL_CATEGORY.OTHER;
        }
      },
      setLanguage: function (languageKey) {
        $translate.use(languageKey);
        angular.copy(this[languageKey], $locale);
        moment.locale(languageKey);
      }
    };

    function getDecimals(n) {
      n = n + '';
      var i = n.indexOf('.');
      return i == -1 ? 0 : n.length - i - 1;
    }

    function getVF(n, opt_precision) {
      var v = opt_precision;

      if (undefined === v) {
        v = Math.min(getDecimals(n), 3);
      }

      var base = Math.pow(10, v);
      var f = ((n * base) | 0) % base;
      return { v: v, f: f };
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('localeFilters', localeFiltersService);

  /** @ngInject */
  function localeFiltersService ($locale, currencyFilter, dateFilter, numberFilter) {

    this.defaultDateFormat = $locale.DATETIME_FORMATS.shortDate;

    this.currency = function (amount, currencySymbol, fractionSize) {
      return currencyFilter(amount, currencySymbol, fractionSize);
    };

    this.date = function (date, format, timezone) {
      if (!format) {
        format = $locale.DATETIME_FORMATS.shortDate;
      }
      return dateFilter(date, format, timezone);
    };

    this.monthYear = function (date) {
      return this.date(date, 'MMMM yyyy');
    };

    this.hourly = function (date) {
      return this.date(date, 'dd/MM/yy HH:mm');
    };

    this.daily = function (date) {
      return this.date(date, 'dd/MM/yy');
    };

    this.monthly = function (date) {
      return this.date(date, 'MM/yy');
    };

    this.yearly = function (date) {
      return this.date(date, 'yyyy');
    };

    this.number = function (number, fractionSize) {
      return numberFilter(number, fractionSize);
    };

    this.checkIfNumber = function (number) {
      if (Number.isInteger(number)) {
        return number
      }
    };

    this.getMonthLocale = function (monthIndex, long) {
      if (!long) {
        return $locale.DATETIME_FORMATS.SHORTMONTH[monthIndex];
      } else {
        return $locale.DATETIME_FORMATS.MONTH[monthIndex];
      }
    };

    this.getDayLocale = function (dayIndex, long) {
      if (!long) {
        return $locale.DATETIME_FORMATS.SHORTDAY[dayIndex];
      } else {
        return $locale.DATETIME_FORMATS.DAY[dayIndex];
      }
    }

  }
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("huTranslations", {
    MESSAGE:"Üzenet",
    ERROR_TITLE:"Hiba",
    ERROR_MESSAGE:"Hiba történt a művelet végrehajtása során.",
    ERROR_LOGIN:"Hiba történt a bejelentkezés során. Érvénytelen e-mail cím",
    ERROR_LOGIN_ROLE:"Az applikáció és a márka szerepköre nem érvényes",
    OK:"Rendben",
    CANCEL:"Mégse",
    YES:"Igen",
    NO:"Nem",
    FROM:"Innentől:",
    TO:"Idáig:",
    DELETE:"Törlés",
    SIGN_OUT:"Kijelentkezés",
    NAME:"Név",
    DATE:"Dátum",
    PIECES:"darab",
    HOURS:"óra",
    DAYS:"nap",
    MONTH:"hónap",
    MONTHS:"hónap",
    YEAR:"év",
    BOX:"beálló",
    SEARCH:"Keresés",
    ALL_USERS:"Minden felhasználó",
    ARE_YOU_SURE:"Biztos benne",
    BACK:"Vissza",
    AMOUNT:"Összeg",
    DESCRIPTION:"Leírás",
    FORGOT_PASSWORD_ERROR_MSG:"Hiba történt. Kérjük, hogy ellenőrizze e-mail címét és próbálja újra!",
    REQUIRED_FIELD:"A mező kitöltése kötelező",
    LOGOUT_TITLE:"Biztosan ki akar jelentkezni?",
    LOGOUT_MSG:"Minden el nem mentett adata elveszik",
    ACTIVATION_ACCOUNT:"Sikeresen aktiválta felhasználói fiókját",
    UNKNOWN_ERRROR_NOTIFICATION:"Ismeretlen hiba történt",
    CONTINUE:"Folytatás",
    DATA_NOT_AVAILABLE:"Nem áll rendelkezésre adat",
    SELECT:"Kiválasztás ",
    SELECT_CURRENCY:"Válasszon pénznemet",
    UPLOAD:"Feltöltés",
    PHONE:"Telefon",
    WEBSITE:"Webhely",
    WORKING_HOURS:"Nyitvatartási idő",
    INSERT:"Beillesztés",
    TEXT:"Szöveg",
    CREATED:"Létrehozva",
    VALID_UNTIL:"Érvényes eddig:",
    SAVE:"Mentés",
    TOKENS:"Zsetonok",
    DELETE_COMPANY_HISTORY:"Vállalat előtörténetének törlése?",
    DELETE_COMPANY_HISTORY_MESSAGE:"FIGYELMEZTETÉS: A gomb megnyomása után az autómosó összes tranzakciója véglegesen törlődik! Ezek az adatok törlés után nem állíthatók vissza.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Biztos benne, hogy véglegesen törölni szeretné az összes tranzakciós adatot?",
    HISTORY_SUCCESSFULY_DELETED:"Az előtörténet törlése sikeres volt.",
    HELP:"Segítség",
    VALUE:"Érték",
    ACTIVATING_ACCOUNT_ERROR:"Az R2W felhasználói fiókja aktiválása során hiba történt. Kérjük, hogy próbálja újra, és ha a hiba továbbra is fennáll, lépjen kapcsolatba ügyfélszolgálatunkkal a support@ready2wash.com címen!",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Üdvözöljük a Kärcher Autómosó",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Üdvözöljük a R2W-nél!",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Írja be az új jelszavát, és erősítse meg, hogy aktiválja az R2W fiókját! Ha ezt sikerrel végrehajtja, automatikusan bejelentkezik az alkalmazásba",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Később, az alkalmazásban módosíthatja felhasználói beállításait",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher autómosó",
    RESET_PASSWORD_WELCOME_MSG:"R2W autómosó",
    RESET_PASSWORD_WELCOME_MSG_2:"Kérjük, adja meg új jelszavát, és erősítse meg a régi jelszó visszaállításához. Sikeres esetben automatikusan bejelentkezik az alkalmazásba",
    RESET_PASSWORD_WELCOME_MSG_3:"A felhasználói beállításokat később az alkalmazásban módosíthatja",
    ENTER_NEW_PASSWORD:"Új jelszó megadása",
    REPEAT_NEW_PASSWORD:"Új jelszó ismét",
    PASSWORD_MIN_LENGTH:"A jelszónak legalább 8 karakterhosszúnak kell lennie",
    PASSWORD_MAX_LENGHT:"A jelszó nem lehet 32 karakternél hosszabb",
    PASSWORD_PATTERN:"A jelszónak tartalmaznia kell legalább egy nagybetűt és egy kisbetűt",
    PASSWORD_MATCH:"A jelszók nem egyeznek",
    ACTIVATE:"Aktiválás",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Sikeresen elküldte a kérést. Kérjük, ellenőrizze e-mailben a megerősítő üzenetet",
    VALIDATION_REQUIRED:"Kötelezően kitöltendő mező",
    VALIDATION_EMAIL:"Érvénytelen e-mail cím",
    VALIDATION_INTEGER_NUMBER:"Kérjük, hogy egész számot adjon meg",
    VALIDATION_HOURS_VALUE:"Az értéknek 0 és 23 között kell lennie",
    VALIDATION_MINUTES_VALUE:"Az értéknek 0 és 59 között kell lennie",
    VALIDATION_NOT_A_DATE:"A megadott érték nem dátum",
    VALIDATION_FROM:"    utáni dátumtól",
    VALIDATION_TO:"   előtti dátumig",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Ez az adat már szerepel az adatbázisban",
    PASSWORD_VALIDATION_PATTERN_NEW:"Tartalmaznia kell legalább egy számjegyet, egy kisbetűt és egy nagybetűt Szóközt nem tartalmazhat",
    VALIDATION_PERCENT_VALUE:"Az értéknek 1 és 999 között kell lennie",
    NUMBERS_ONLY_100:"Csak egy pozitív szám 100-ig",
    NUMBERS_ONLY_1000:"Csak egy pozitív szám 1000-ig",
    POSITIVE_NUMBERS_ONLY:"Csak egy pozitív szám",
    GRID_PAGER_PAGE:"Oldal",
    GRID_PAGER_ROWS_PER_PAGE:"Sorok egy oldalon",
    GRID_PAGER_PAGE_OF:"közül",
    BREAD_CRUMBS_HOME:"Főoldal",
    BREAD_CRUMBS_DASHBOARD_TECH:"Irányítópult (dashboard) technológia",
    BREAD_CRUMBS_DETAILS:"Adatok",
    BREAD_CRUMBS_SETTINGS:"Beállítások",
    BREAD_CRUMBS_WORKING_HOURS:"Munkaidő",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Teljes pénzösszeg kimutatása napi bontásban",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Átlagos pénzösszeg kimutatása óránkénti bontásban",
    BREAD_CRUMBS_NEW_USER_GROUP:"Felhasználói csoport létrehozása",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Felhasználói csoport szerkesztése",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Kampány-sablon létrehozása",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Kampány-sablon szerkesztése",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Kampány létrehozása",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Kampány szerkesztése",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Időszaki összegzés",
    LOGIN:"Bejelentkezés",
    EMAIL:"E-mail",
    PASSWORD:"Jelszó",
    LANGUAGE:"Nyelv",
    FORGOT_PASSWORD:"Elfelejtette a jelszavát?",
    SUBMIT:"Küldés",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Folyamatban levő riasztások száma:",
    HEADER_VIEW_ALL_ALARMS:"Az összes riasztás megtekintése...",
    HEADER_MY_ACCOUNT:"Fiókom",
    HEADER_ACCOUNT_MANAGEMENT:"Felhasználói fiók kezelése",
    ACCOUNT_ALREADY_EXIST:"Már használatban levő e-mail cím",
    NEWSLETTER_CONFIRMATION:"E-mail értesítés küldése a riasztások állapotáról",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Napi pénzügyi áttekintése",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Irányítópult (dashboard) technológia",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Irányítópult",
    ASIDE_MENU_ALARMS:"Üzenetek",
    ASIDE_MENU_FACILITIES:"Autómosók",
    ASIDE_MENU_REPORTS:"Kimutatások",
    ASIDE_MENU_REPORT:"Kiválasztott kimutatás",
    ASIDE_MENU_LOYALTY:"Hűségprogram",
    ASIDE_MENU_USER_GROUPS:"Felhasználói csoportok",
    ASIDE_MENU_PERIODIC_SUMMARY:"Időszaki összegzés",
    ASIDE_MENU_MANAGING_TOKENS:"Zsetonok kezelése",
    ASIDE_MENU_NEWS:"Hírek",
    DAILY_FINANCES_TOTAL_MONEY:"Teljes pénzösszeg",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Teljes pénzösszeg az összes autómosóra vonatkozóan",
    DAILY_FINANCES_TOTAL_COINS:"Felhasznált fém zsetonok összesen",
    DAILY_FINANCES_DOWNLOAD_CSV:"CSV-fájl letöltése",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Készpénz",
    DAILY_FINANCES_CHANGER:"Készpénz a pénzváltóban",
    DAILY_FINANCES_COINS:"Zsetonok/Eurokey",
    REPORTS_FILTER:"Szűrő",
    REPORTS_TYPE_OF_REPORT:"Kimutatás típusa",
    REPORTS_CHOOSE_FACILITY:"Autómosó kiválasztása",
    REPORTS_PERIOD_1:"1. időszak -",
    REPORTS_PERIOD_2:"2. időszak -",
    MONEY_BY_DATE_REPORT:"Teljes bevétel dátumokra lebontva",
    R2W_BY_DATE_REPORT:"Összes elköltött R2W zseton dátumokra lebontva",
    COINS_BY_DATE_REPORT:"Bankkártyás forgalom",
    AVG_MONEY_BY_HOUR_REPORT:"Átlagos bevétel órákra lebontva",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Átlagos bevétel a hét napjaira lebontva",
    AVG_MONEY_BY_BOX_REPORT:"Forgalom beállónként",
    COMPARE_PERIODS_REPORT:"Autómosó összehasonlító kimutatás",
    TOTAL_USERS_BY_GROUP:"Az R2W alkalmazás felhasználói összesen, napokra lebontva",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"felhasználók",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"látogatók",
    VISITS_COUNT_REPORT:"Az R2W alkalmazás felhasználók száma látogatásonként",
    LOYALTY_PER_DAY_REPORT:"Naponta elköltött helyi zsetonok száma",
    LOYALTY_PER_PAYMENT_METHOD:"Az egyes fizetési módokra jutó kiadott helyi zsetonok száma",
    VISITS:"Látogatások",
    VISIT:"Látogatás",
    TOTAL_SPENT_MONEY:"Teljes bevétel",
    MONEY:"Pénz",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Az időszak során költött teljes pénzösszeg",
    DOWNLOAD_CSV:"CSV-fájl letöltése",
    TOTAL_SPENT_COINS:"Forgalom összesen",
    TOTAL_USERS:"Felhasználók összesen",
    TOTAL_CREDIT_GIVEN:"Összesen elköltött helyi virtuális zsetonok",
    EUROKEY_BY_DATE_REPORT:"Eurokey kifizetések összesen, dátumokra lebontva",
    TOTAL_SPENT_EUROKEY:"Teljes költés",
    SELECT_TYPE_OF_REPORT:"Ki kell választania a jelentés típusát :)",
    NUMBER_OF_VISITS_TITLE:"Látogatások száma",
    NUMBER_OF_USERS_TITLE:"Felhasználók száma",
    PIECES_TITLE:"Darabok",
    TOTAL_VISITS:"Összes látogatás",
    TOKENS_TITLE:"zseton",
    SEARCH_USERS_NO_RESULTS:"A megadott keresési szó alapján nem található felhasználó",
    SEARCH_USERS:"Felhasználók keresése",
    SEARCH_TELEPHONES:"Felhasználók keresése mobilszám alapján",
    ADD_USER_TO_GROUP:"Felhasználó hozzáadása csoporthoz",
    REMOVE_USER_FROM_GROUP:"Felhasználó törlése csoportból",
    USER_GROUP_NAME_REQUIRED:"A felhasználói csoport neve kötelezően kitöltendő",
    USER_GROUP_NAME:"Felhasználói csoport neve",
    USER_GROUPS_OVERVIEW:"Felhasználói csoportok áttekintése",
    USER_COUNT:"Felhasználók száma",
    NEW_USER_GROUP:"Új felhasználói csoport létrehozása",
    DELETE_USER_GROUP:"Felhasználói csoport törlése",
    UPDATE_USER_GROUP:"Felhasználói csoport szerkesztése",
    DELETE_USER_GROUP_ERROR:"Hiba történt a kiválasztott felhasználói csoport törlése során. Kérjük, próbálja újra, vagy lépjen kapcsolatba ügyfélszolgálatunkkal...",
    CONFIRM_DELETE_USER_GROUP:"Biztosan törölni akarja a kiválasztott felhasználói csoportot?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"A továbbiakban nem érvényesek azok a hűségprogram-akciók, amelyekhez a törölt felhasználói csoport hozzá volt rendelve.",
    GROUP_NAME_MAX_LENGTH:"A csoport neve nem lehet 255 karakternél hosszabb",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"A felhasználó már tagja a csoportnak",
    MISSING_USER:"Hiányzó felhasználó",
    USER_NOT_ON_LIST:"A felhasználó nem szerepel az aktív felhasználók listáján. Ellenőrizze, hogy az e-mail cím érvényes-e, és próbálja újra.",
    UPLOAD_USER_GROUP:"A *.csv fájlból töltse fel a felhasználócsoport-listát",
    UKNOWN_USERS:"Ismeretlen felhasználók listája",
    CAMPAIGN_TEMPLATE_RULE:"Sablon-szabály",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Hiba történt a kampány-sablon törlése során. Kérjük, próbálja újra, vagy lépjen kapcsolatba ügyfélszolgálatunkkal...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Biztosan törölni akarja a kiválasztott kampány-sablont?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Biztosan törölni akarja a kiválasztott kampány-sablont?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Kampány-sablonok áttekintése",
    DELETE_CAMPAIGN_TEMPLATE:"Kampány-sablon törlése",
    UPDATE_CAMPAIGN_TEMPLATE:"Kampány-sablon szerkesztése",
    CREATE_CAMPAIGN_TEMPLATE:"Új kampány-sablon létrehozása",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Kötelező  nevet adni a kampány-sablonnak",
    CAMPAIGN_TEMPLATE_NAME:"Kampány-sablon neve",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Kötelezően kitöltendő mező",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"kiadott %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"többletidő",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Először válassza ki a típust. Mosódobozok vagy kisgépek.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Sablon-szabály törlése",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Innentől:",
    CAMPAIGN_TEMPLATE_RULE_TO:"-ig",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"óra múlva",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"perc",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Új szabály a látogatások száma szerinti bontásban",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Új szabály az elköltött zsetonok összege szerinti bontásban",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Új szabály a hét napjai szerinti bontásban",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Új sablon-szabály hozzáadása",
    CAMPAIGN_TEMPLATE_RULE_1:"Minden",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Minden",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"elköltött zseton kevesebb mint alatt",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"látogatások kevesebb mint alatt",
    CAMPAIGN_TEMPLATE_RULE_3:"nap",
    CAMPAIGN_TEMPLATE_RULE_4:"zsetonok",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"A szabálylista üres.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"A dátum nem lehet múltbeli időpont.",
    DELETE_CAMPAIGN_ERROR:"Hiba történt a kampány törlése során. Kérjük, próbálja újra, vagy lépjen kapcsolatba ügyfélszolgálatunkkal...",
    CONFIRM_DELETE_CAMPAIGN:"Biztosan törölni akarja a kiválasztott kampányt?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"Az R2W nem felelős az ezen művelet okozta felhasználói élményért.",
    CAMPAIGNS_OVERVIEW:"Kampányok áttekintése",
    DELETE_CAMPAIGN:"Kampány törlése",
    UPDATE_CAMPAIGN:"Kampány szerkesztése",
    CREATE_CAMPAIGN:"Új kampány létrehozása",
    CAMPAIGN_ACTIVE:"Aktív",
    CAMPAIGN_TEMPLATE:"Sablon",
    CAMPAIGN_GROUPS:"Csoportok",
    CAMPAIGN_ALL_USERS:"Minden felhasználó",
    CAMPAIGN_NAME:"Kampány neve",
    CAMPAIGN_NAME_REQUIRED:"Kötelezően kitöltendő",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Az értékhatárt megközelítő felhasználók száma napi bontásban",
    MESSAGE_TO_USERS:"Üzenet a felhasználók megszűrt körének",
    SEND_MESSAGE:"Üzenet küldése",
    THRESHOLD:"Értékhatár",
    TYPE:"Típus",
    TOTAL_MONEY_SPENT:"A kampány során elköltött teljes pénzösszeg",
    NUMBER_OF_VISITS:"A kampányhoz kapcsolódó látogatások száma ",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"A jelszónak legalább 10 karakter hosszúnak kell lennie",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Az üzenet nem lehet 350 karakternél hosszabb",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Szöveges üzenetet kell küldeni",
    TECHNOLOGY:"Technológia",
    TAP_WATER:"Csapvíz",
    REVERSE_OSMOSIS:"Fordított ozmózis",
    SOFTENED_WATER:"Lágyított víz",
    DOSER:"Adagoló",
    STATUS:"Státusz",
    LAST_SYNCHRONIZATION:"Utolsó szinkronizálás",
    NO_OF_CURRENT_ALARMS:"Aktuális riasztások száma",
    NO_OF_CURRENT_WARNINGS:"Aktuális figyelmeztetések száma",
    WEATHER:"Időjárás",
    BOXES_WORK_HOURS_COUNTERS:"Beállók üzemórái",
    BOX_TOTAL_HOURS:"Üzemórák összesen",
    BOX_SERVICE_HOURS:"Üzemórák összesen (szolgáltatás)",
    BOX_COUNTER_HOURS:"óra múlva",
    ALARMS_AND_WARNINGS:"Riasztások és figyelmeztetések",
    FILTER_AND_BOILER:"Szűrő és vízmelegítő",
    FILTER_TOTAL_DAYS:"Szűrő üzemi napok",
    BOILER_TOTAL_DAYS:"Vízmelegítő üzemi napok",
    DAYS_UNIT:"nap",
    SOFTENER:"Vízlágyító",
    MANUAL_COLD_DRAIN:"Manuális kifolyóvíz-visszahűtő",
    EL_COLD:"Elektromos kifolyóvíz-",
    DRAIN:"visszahűtő",
    TAP:"csap",
    WASTE:"Szennyvíz",
    OSMOSIS:"ozmózis",
    DEMI_WATER:"Ioncserélt víz",
    EL_RINSE:"Elekt. öblítés",
    BOILER:"Vízmelegítő",
    EL_WAX:"Elekt. viaszolás",
    FLOOR_HEATING:"Padlófűtés",
    DOSER_TANK:"Adagolótartály",
    EL_WASH:"Elekt. mosás",
    DETERGENT:"Mosószer",
    VIBRATOR:"Rezgőadagoló berendezés",
    UPDATE_FACILITY_SETTINGS:"Beállítások frissítése",
    GENERAL_SETTINGS:"Általános beállítások",
    LIGHTS:"Lámpák",
    GROUPS:"Csoportok",
    ANTI_FREEZE:"Fagyálló",
    AUTO:"Automata",
    MANUAL:"Manuális",
    ON:"Be",
    OFF:"Ki",
    TEMPERATURE:"Hőmérséklet",
    UPDATE_DEVICE:"Autómosó beállítások frissítése",
    BOX_CLEAN_HOURS:"Beállók tisztítási számlálói (óra)",
    GROUP_COUNTERS:"Csoport számlálók",
    RESET:"Visszaállítás",
    CASH_COUNT:"Érmék száma",
    COINS_COUNT:"Zsetonok száma",
    EUROKEY_COUNT:"Eurokey szám",
    DOSER_WORK:"Adagoló üzemideje (másodperc)",
    DOSER_PAUSE:"Adagoló állásideje (másodperc)",
    DELAY_BFV:"BFV késleltetés (perc)",
    DELAY_6M1:"6M1 késleltetés (perc)",
    DELAY_LPS:"LPS késleltetés (perc)",
    RESET_CASH_COUNT_ALL:"Minden érmeszámláló alaphelyzetbe állítása",
    RESET_COINS_COUNT_ALL:"Minden zsetonszámláló alaphelyzetbe állítása",
    RESET_EUROKEY_COUNT_ALL:"Minden Eurokey-számláló alaphelyzetbe állítása",
    FACILITY_DETAILS:"Autómosó adatai",
    FACILITY_NAME:"Autómosó neve",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"A képfeltöltése sikeres volt",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Az adatfeltöltése sikeres volt",
    CONNECTED:"Csatlakoztatva",
    DISCONNECTED:"Lecsatlakoztatva",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Üzenetszűrő",
    FACILITY:"Autómosó",
    APPLY:"Alkalmaz",
    TIME:"Idő",
    LOCATION:"Hely",
    ACKNOWLEDGED:"Visszaigazolva",
    FILTERED_MESSAGES:"Szűrt üzenetek",
    ACK:"Visszaigazolva",
    NOT_ACK:"Nincs visszaigazolva",
    ALL:"Mind",
    ALL_FACILITIES:"Összes autómosó",
    ENTER_DATE_PLACEHOLDER:"Dátum megadása",
    OP_NESTANAK_NAPONA:"Feszültséghiány az 3A5 fázisjelzőnél",
    OP_OTB_PUMPA_GRESKA_MZS:"Nagynyomású szivattyú áramköri megszakítója lekapcsolt",
    OP_UPR_NAPON_24VAC_GRE:"24 VAC feszültséghiány - 5F1.1 áramköri megszakító",
    OP_MIN_NIVO_PITKA_VODA:"Frissvizes tartály üres",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Fő vízvezeték szivattyú áramköri megszakítója lekapcsolt",
    OP_MIN_NIVO_OMEKS_VODE:"Lágyított vizes tartály üres",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Lágyítottvíz-szivattyú áramköri megszakítója lekapcsolt",
    OP_MIN_NIVO_DEMIN_VODE:"Ozmózis berendezés víztartálya üres",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Ozmózis berendezés szivattyújának áramköri megszakítója lekapcsolt",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Ozmózis berendezés szivattyújának áramköri megszakítója lekapcsolt",
    OP_BOJLER_GRESKA_MZS:"Vízmelegítő hibája",
    OP_CRPKA_PRASKA_GRE_MZS:"Forróvíz-szivattyú áramköri megszakítója lekapcsolt",
    OP_DOZATOR_PRASKA_GRE_MZS:"Poradagoló motor áramköri megszakítója lekapcsolt",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Rezgő poradagoló áramköri megszakítója lekapcsolt",
    OP_MIN_PRASAK_TON_ALARM:"Porkeverő tartály üres",
    OP_USIS_KOV_TURBINA_GRESKA:"Érme vákuumos berendezés turbinájának áramköri megszakítója lekapcsolt",
    OP_FILTER_VODE_ZACEPLJEN:"Vízszűrő eltömődött",
    OP_VISKTL_RESET_SATI_RADA:"Nagynyomású szivattyú szervíz",
    OPW_VISKTL_RESET_SATI_RADA:"Nagynyomású szivattyú szervíz",
    OP_FILTER_DANI_RADA:"Vízszűrő hiba",
    OP_BOJLER_DANI_RADA:"Vízmelegítő hiba",
    OPW_ALARM_VISOKOTL_PUMPA:"Nagynyomású szivattyú riasztás",
    OPW_ALARM_FILTER_SERVIS:"Szűrő szervíz riasztás",
    OPW_ALARM_BOJLER_SERVIS:"Vízmelegítő szervíz riasztás",
    HAS_MEMBERS:"A kiválasztott csoportnak vannak tagjai, ezért nem törölhető. Először a tagokat kell törölni.",
    PERIODIC_SUMMARY_FOR:"IDŐSZAKI R2W JELENTÉS",
    PERIODIC_SUMMARY_REPORTS:"Időszaki összegfoglaló jelentések",
    DATE_RANGE:"Dátumtartomány",
    FINANCIAL_REPORT:"Pénzügyi beszámoló",
    GROSS_INCOME:"Bruttó bevétel",
    GROSS_INCOME_SUM:"Bruttó bevétel összesen",
    COMMISSION_FEE:"Jutalékok, díjak",
    NET_INCOME:"Nettó bevétel (számlázásból)",
    COMMISSION_FEE_DETAILS:"A jutalékok, díjak a banki /Paypal szolgáltatás, ill. SMS szolgáltatók díját foglalja magában.",
    LOYALTY_CREDITS_REPORT:"Helyi zsetonforgalmi jelentés",
    LOYALTY_GIVEN:"Kiadott helyi zsetonok",
    LOYALTY_USED:"Felhasznált helyi zsetonok",
    LOYALTY_SOLD:"Betöltött helyi zsetonok",
    LOYALTY_TOTAL:"Összesen",
    LOYALTY_CURRENT_MONTH:"Tárgyhó",
    SOMETHING_WENT_WRONG:"Hoppáááá",
    MISSING_PAGE:"Sajnáljuk. Nem találtuk a megadott oldalt",
    TRY_AGAIN:"Próbálja újra!",
    DEFAULT_ERROR_NAME:"Ismeretlen hiba történt",
    DEFAULT_ERROR_DESCRIPTION:"Kérjük, próbálja újra!",
    MY_ACCOUNT_DETAILS:"Felhasználói fiókom adatai",
    SAVE_CHANGES:"Változások mentése",
    USERNAME:"Felhasználói név",
    FIRST_NAME:"Utónév",
    LAST_NAME:"Vezetéknév",
    USER_ROLE:"Felhasználói szerep",
    OLD_PASSWORD:"Régi jelszó",
    NEW_PASSWORD:"Új jelszó",
    OLD_PASSWORD_REQUIRED:"A régi jelszót kell megadni",
    NEW_PASSWORD_REQUIRED:"Új jelszót kell megadni",
    NEW_PASSWORD_REPEAT:"Az új jelszót újra meg kell adni",
    NEW_PASSWORD_NOT_MATCH:"A régi és az új jelszó nem egyezik",
    PASSWORD_DIFFERENT_VALIDATION:"Az új jelszónak el kell térnie a régitől",
    PASSWORD_MIN_CHAR:"Az Ön jelszavának legalább 8 karakter hosszúnak kell lennie",
    PASSWORD_MAX_CHAR:"Az Ön jelszava legfeljebb 32 karakter hosszú lehet",
    PASSWORD_PATTERN_VALIDATION:"A jelszónak tartalmaznia kell legalább egy számjegyet",
    ACCOUNT_MANAGEMENT:"Felhasználói fiók kezelése",
    NOT_ACTIVE:"Inaktív",
    ASSIGN_ROLE:"Feladatkör hozzárendelése",
    UPDATE:"Frissítés",
    ADD_NEW_ACCOUNT:"Új felhasználói fiók hozzáadása",
    EMAIL_REQUIRED:"E-mail cím szükséges",
    EMAIL_NOT_VALID:"Érvénytelen e-mail cím",
    ADD_NEW_USER_TEXT:"A megadott e-mail címre e-mailt küldünk az aktiváláshoz szükséges hivatkozással",
    UPDATE_USER_NOTIFICATION:"Az adatfeltöltése sikeres volt",
    CHANGED_PASSWORD_NOTIFICATION:"Sikeresen módosította jelszavát",
    UPDATE_USER_GROUP_NOTIFICATION:"Sikeresen módosította a felhasználói csoport nevét",
    CREATE_USER_GROUP_NOTIFICATION:"Sikeresen létrehozta a csoportot",
    DETELE_USER_GROUP_NOTIFICATION:"Sikeresen törölte a csoportot",
    EMPTY_GROUP_LIST_MSG:"Nem lett létrehozva csoport. Először hozzon létre egyet!",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Sikeresen törölte a felhasználót a csoportból",
    ADD_USER_TO_GROUP_NOTIFICATION:"Sikeresen hozzáadta a felhasználót a csoporthoz",
    ADD_USER_NOTIFICATION:"Az új felhasználó hozzáadása sikeres volt",
    DELETE_USER_NOTIFICATION:"A felhasználó törlése sikeres volt",
    RESEND_USER_VERIFICATION_EMAIL:"Sikeresen újraküldte az ellenőrző e-mailt",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Felhasználói csoport létrehozásához",
    DELETE_USER:"Felhasználó törlése",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Biztosan törölni akarja ezt a felhasználót a felhasználói csoportból?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Tisztelt R2W felhasználó",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Hűségprogram-szabály a látogatások száma szerinti bontásban",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Hűségprogram-szabály az elköltött zsetonok összege szerinti bontásban",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Hűségprogram-szabály a hét napjai szerinti bontásban",
    REMOVE_CAMPAIGN_RULE_TITLE:"Kampányszabály törlése",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Biztosan törölni akarja a kampányszabályt?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Sikeresen létrehozta az új kampányt",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Sikeresen aktiválta a kampányt",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Nem lett létrehozva kampány. Először hozzon létre egyet!",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Sikeresen elküldte az üzenetet",
    COMPANY_ACCOUNTS:"Vállalati fiókok",
    BUSSINESS_INVOICES_LIST:"Saját B2B számlám",
    LOCALE_TOKEN:"Helyi zsetonok",
    R2W:"Globális zsetonok",
    START_MONTH:"Kezdő hónap",
    END_MONTH:"Vég hónap",
    TOKEN_TYPE:"Zseton típus",
    TOKEN_NUMBER:"Zsetonok száma",
    NOTHING_TO_DISPLAY:"* Semmi nem látható",
    CREATE_INVOICE:"Számla létrehozása",
    INVOICE:"Számla",
    INVOICES:"Számlák",
    EDIT_INVOICE:"Számla szerkesztése",
    UPDATE_INVOICE_NOTIFICATION:"Sikeresen módosította a számla státuszát „Folyamatban levő”-re",
    CURRENT_CHARGES:"Az aktuális időszakot érintő változások",
    PAYMENTS_ON_HOLD:"Feldolgozás alatt álló számlák",
    FOR_INVOICING:"Számlázáshoz",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"A számla törlésére készül",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Biztosan törölni akarja ezt a számlát?",
    INVOICING_NOTIFICATION_HEADER:"A számlázásra készül",
    INVOICING_NOTIFICATION_TEXT:"Biztosan ki akar jelentkezni?",
    SENT_INVOICE_NOTIFICATION:"Sikeresen elküldte a számlát",
    CANCELED_INVOICE_NOTIFICATION:"Sikeresen törölte a számlát",
    INVOICE_DESCRIPTION_TEXT:"Számla",
    INVOICE_STATE:"Számla státusza",
    INVOICE_NUMBER:"Számlaszám",
    INVOICE_TOTAL:"Összesen",
    SELECT_YEAR:"Év kiválasztása",
    DOWNLOAD:"PDF-fájl letöltése",
    INVOICE_NUMBER_HEADER:"      számú számla elküldésére készül",
    INVOICE_PAYMENT_CONFIRMATION:"      kifizetésének megerősítésére készül",
    INSERT_INVOICE_NUMBER:"Számlaszám megadása",
    INVOICED_WARNING:"Az e-mail elküldése meghiúsult. Kérjük, várjon...",
    SEND_INVOICE:"Küldés",
    INVOICE_ALL:"Mind",
    INVOICE_FROM_R2W:"Az R2W-től",
    INVOICE_TO_R2W:"Az R2W-nek",
    PAYMENT_REQUEST:"Fizetési kérelem",
    PAYMENT_REQUEST_STATE:"Fizetési kérelem állapota",
    PAYMENT_REQUEST_NUMBER:"Fizetési kérelem száma",
    FOR_PAYMENT_REQUEST:"Fizetési kérelmek",
    PAYMENT_REQUEST_ON_HOLD:"Fizetési kérelmek feldolgozásban",
    DOWNLOAD_INVOICE:"Számla letöltése",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kattintson a letöltési beállításokhoz",
    B2B_SPEC:"B2B Leírás",
    B2C_SPEC:"B2C Leírás",
    DOWNLOAD_PAYMENT_REQUEST:"Fizetési kérelem letöltése",
    LOYALTY_PREVIEW:"Hűségprogram előnézet",
    ACTIVATED:"Aktiválva",
    RUNNING:"Folyamatban",
    NOT_ACTIVATED:"Nincs aktiválva",
    FINISHED:"Kész",
    DEPRECATED:"Érvénytelenítve",
    UPCOMING:"Következő",
    NONE:"Egyik sem",
    STARTED:"Kezdés",
    ENDS:"Vége",
    DEDICATED:"Számára",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Ön kampány aktiválására",
    CAMPAIGN:"készül",
    SEND_MESSAGE_NOTIFICATION:"Ön arra készül, hogy üzenetet küldjön bizonyos felhasználói csoportoknak",
    DIVISIBLE_TO_NUMBER:"A számnak oszthatónak kell lennie ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Eszköztípus",
    LISTENER:"Kis gépek",
    BRIDGE:"Mosódobozok",
    WASH_BOXES:"Mosódobozok",
    VACUUMS:"Porszívók",
    SAVE_NEWS:"Hírek mentése",
    CREATE_NEW_NEWS:"Új hírek létrehozása",
    HISTORY_OF_ALL_NEWS:"Az összes korábbi hír megjelenítése",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Autómosó nevének beírása",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Másik autómosó hozzáadása",
    NEWS_TEXT:"Hír szövege",
    NEWS_TITLE:"Hír címe",
    DELETE_NEWS_CONFIRMATION:"Ön hír törlésére készül",
    NEWS_DELETE_NOTIFICATION:"Sikeresen törölte a hírt",
    NEWS_SAVE_NOTIFICATION:"Sikeresen mentette a hírt",
    NEWS_CREATION_DATE:"Létrehozás dátuma",
    NO_TITLE:"Nincs cím",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"A hír szövege nem lehet 255 karakternél hosszabb",
    NEWS_TEXT_REQUIRED_VALIDATION:"Be kell írni a hír szövegét",
    NEWS_TITLE_REQUIRED_VALIDATION:"Be kell írni a hír címét",
    DEACTIVATE:"Deaktiválás",
    ASIDE_MENU_LOCAL_TOKENS:"Helyi zsetonok",
    CREATE_NEW_LOCAL_TOKENS:"Új helyi zsetonok kibocsátása",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Adja meg az ügyfél e-mail címét, és azt, hogy hány helyi zsetont szeretne kibocsátani az ügyfél számára",
    CREATE_TOKENS:"Zsetonok kibocsátása",
    MINIMUM_ONE_TOKEN:"Az értéknek nagyobbnak kell lenni nullánál",
    CUSTOMER_EMAIL:"Az ügyfél e-mail címe",
    AMOUNT_OF_TOKENS:"A zsetonok száma",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Helyi zsetonok sikeres kibocsátása a következő számára:",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Hiba történt a helyi zsetonok kibocsátása során. Kérjük, hogy ellenőrizze az ügyfél e-mail címét és próbálja újra!",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"A kibocsátott helyi zsetonok áttekintése",
    ISSUED_AT:"Kibocsátva:",
    ISSUED_BY:"Kibocsátotta:",
    CODE:"Beváltási kód",
    REDEEMED_BY:"Beváltotta:",
    REDEEMED_AT:"Beváltás:",
    ASIDE_MENU_VOUCHERS:"Kuponok",
    PRINT:"Nyomtatás",
    VOUCHERS_OVERVIEW:"Kuponok áttekintése",
    CREATE_NEW_VOUCHERS:"Új kuponok létrehozása",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Új beváltható kupontétel létrehozása az egy kuponra jutó zsetonok számának megadásával",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Egy kuponra jutó zsetonok száma",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Egy kuponhoz 1 és 20 közötti számú zsetont rendelhet hozzá",
    NUMBER_OF_NEW_VOUCHERS:"Létrehozni kívánt kuponok száma",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Egy tételen belül 1 és {{méret}} közötti számú kupon hozható létre",
    NEW_VOUCHERS_PREFIX:"Új kuponsorozat kódjának előtagja",
    VALIDATION_VOUCHER_PREFIX:"A kód előtagját nagybetűkkel kell megadni, és 1 és 16 közötti számú betű, ill. számjegy alkothatja.",
    PROBLEM_CREATING_NEW_VOUCHERS:"Az új kuponok létrehozása során hiba történt. Kérjük, próbálja újra, vagy lépjen kapcsolatba ügyfélszolgálatunkkal!",
    CREATE_VOUCHERS:"Kuponok létrehozása",
    CREATING_VOUCHERS_SUCCESS:"Az új kuponok létrehozása sikeres volt",
    PRINT_NEW_VOUCHERS:"Kuponok nyomtatása",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Adja meg a kuponsorozat kódjának előtagját, ha a teljes kuponsorozatot ki akarja nyomtatni! Másik lehetőség:",
    PRINT_VOUCHERS_PREFIX:"Kupon(sorozat) kódjának előtagja",
    NO_VOUCHERS_FOR_PRINT:"Nincs a megadott kód-előtagnak megfelelő kupon, amelyet kinyomtathatnánk",
    PRINT_VOUCHERS:"Kupon(ok) nyomtatása",
    VALIDATION_VOUCHER_CODE_FILTER:"A kuponok kereséséhez használt kifejezésnek nagybetűkből és számjegyekből kell állnia",
    FILTER_VOUCHERS_BY_CODE:"Kuponok keresése beváltási kód alapján",
    FILTER_VOUCHERS:"Kuponok keresése",
    WASH_BOX:"Mosó beálló",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Felhasznált digitális zsetonok összesen",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Az adott napon megvásárolt helyi zsetonok összesen",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Az adott napon elköltött helyi zsetonok összesen",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Az adott napon kiadott helyi zsetonok összesen",
    LOCAL_TOKEN:"Helyi zseton",
    GIVEN_TOKEN:"Kiadott helyi zsetonok",
    SOLD_TOKEN:"Eladott helyi zsetonok",
    SMALL_MACHINES:"Kisberendezések",
    R2W_Listener:"Hallgató",
    HHANLE_DEVICE:"HHanle - Mosó beálló",
    CODE_PREFIX_EXIST:"A kód-előtag már létezik",
    CODE_PREFIX_EXIST_TEXT:"Nem hozhat létre új kupont ezzel a kód-előtaggal. Állítson be másikat",
    MIN_FOUR_VALIDATION:"Legalább 4 karakter",
    ALL_INFORMATION_1:"Minden információ",
    ALL_INFORMATION_2:"el fog veszni",
    ASIDE_MENU_TRANSACTIONS:"Tranzakciók",
    EXPENSES:"Költségek",
    TOPUPS:"Feltöltések",
    EXPENSES_LIST:"Költségek listája",
    USER_EMAIL:"Felhasználói e-mail",
    COMPANY_NAME:"Cégnév",
    TOPUPS_LIST:"Feltöltések listája",
    CONSUMER:"Felhasználó",
    SYSTEM_ADMIN:"Rendszeradminisztrátor",
    MERCHANT_ADMIN:"Kereskedő-adminisztrátor",
    COMPANY_ADMIN:"Vállalati adminisztrátor",
    FACILITY_ADMIN:"Autómosó adminisztrátor",
    SUBSCRIBER:"Feliratkozó",
    CONFIGURATOR:"Konfiguráló",
    SETUP_UNIT_SERIAL_NO:"Serial number",
    SETUP_UNIT_MATERIAL_NO:"Material number",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi version",
    TOTAL_TURNOVER:"Autómosó forgalma",
    AVAILABILITY_ALL:"Availability",
    AVAILIBILITY:"Wash boxes availability:",
    AVAILABILITY_VACUUMS:"Vacuums availability:",
    WASH_BOX_INFO:"Wash boxes info",
    VACUUM_CLEANER_INFO:"Vacuum cleaners info",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Holidays",
    HOLIDAY:"Ünnep nap",
    LIGHTS_ON:"Lights/on",
    LIGHTS_OFF:"Lights/off",
    WASH_BOXES_ON:"Wash box/on",
    WASH_BOXES_OFF:"Wash box/off",
    VACUUMS_ON:"Vacuums/on",
    VACUUMS_OFF:"Vacuums/off",
    TURNOVER:"Turnover",
    TURNOVER_MANUAL_WASH_UNIT:"Turnover manual",
    STATUS_BAY_RUN_TIME:"Wash box total work time",
    STATUS_BAY_PROGRAM_NAME:"Program name",
    STATUS_BAY_CREDIT:"Wash box credit",
    CLOUD_KREDIT:"Cloud credit",
    STATUS_VACUUM_RUN_TIME:"Vacuum total work time",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facility services, wash box program and current fault data information",
    UNAVAILABLE:"Unit is unavailable",
    SHOW_HIDE_TABLE:"Show/hide working hours table",
    PROGRAM_NAME:"Program name",
    PROGRAM_COUNTER:"Program counter",
    NO_NAME:"Reference has no name",
    COUNTER_SERVICE_DATA:"Service data",
    NEED_SERVICE:"Szerviz szükséges",
    PROGRAM_DATA:"Wash box program data",
    CURRENT_FAULT_DATA:"Current fault data",
    REFERENCE_DUE:"Due",
    REFERENCE_SECONDS:"Seconds",
    REFERENCE_NAME:"Part name",
    WASHBOX_NAME:"Wash box name",
    FAULT_NAME:"Fault name",
    FAULT_NUMBER:"Fault number",
    CURRENT_FAULT_COUNT:"Active faults",
    DEVICE_NOT_INSTALLED:"Device not installed",
    STATUS_READY:"Kész állapot",
    STATUS_ERROR:"Hiba állapota",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Szoftver hiba",
    SOFTWARE_RESET:"Szoftver hiba",
    EXTERNAL_PIN_RESET:"Szoftver hiba",
    RESTART_OR_BROWNOUT_OCCURRED:"Szoftver hiba",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardver hiba",
    COULD_NOT_SIMULATE_COIN:"Hardver hiba",
    ERROR_SETTING_INHIBIT_MODE:"Hardver hiba",
    OFFLINE_DEVICE:"Offline autómosó",
    TARIFFS:"Tarifák",
    DAY:"Nap",
    NIGHT:"Éjszaka",
    VOUCHER_CODE:"Kupon kód",
    DISMISS_ALARM:"Riasztás visszaállítása?",
    ALARM_ACTIVE:"Aktív riasztások",
    NO_ALARM_ACTIVE:"Nincsenek aktív riasztások",
    ALARM_HISTORY:"Riasztási előzmények",
    MANAGING_TOKENS:"Zsetonok kezelése",
    EXPIRATION_DATE:"Lejárati dátum",
    EXTEND_TOKEN_DATE:"Hosszabbítsa meg a zseton lejárati dátumát a következőnél",
    DELETE_TOKENS_FOR:"Zsetonok törlése:",
    PUMP_TYPE:"Szivattyú típusa",
    TURN_OFF_DEVICE:"Eszköz állapota",
    OPERATION_DATA:"Működési adatok",
    PUMP_DATA:"Szivattyú adatok",
    PUMP_NAME:"Szivattyú neve",
    POINT_NAME:"Pont neve",
    CHANGER_INCOME:"A pénzváltó összes bevétele dátum szerint",
    SELECTED_OPEN:"Nyitva a kiválasztott munkaidőben",
    ALWAYS_OPEN:"Mindig nyitva (24/7)",
    CLOSED:"Zárva",
    CLOSED_24:"24 órát zárva",
    OPENED_24:"24 órát zárva",
    MON:"Hétfő",
    TUE:"Kedd ",
    WED:"Szerda ",
    THU:"Csütörtök ",
    FRI:"Péntek ",
    SAT:"Szombat ",
    SUN:"Vasárnap ",
    PRICING:"Árazás",
    PRICE:"Ár",
    VALIDITY:"Érvényesség",
    TOKEN_PACKAGES:"Zseton csomagok",
    SINGLE_WASH:"Egyszeri mosás",
    FACILITY_WORKING_HOURS:"Állítsa be a kiválasztott autómosó munkaidejét",
    WORKING_HOURS_ALWAYS_OPEN:"Mindig nyitva",
    WORKING_HOURS_ALWAYS_CLOSE:"Üzemeltető által zárva",
    WORKING_HOURS_CUSTOM:"Állítsa be a munkaidőt",
    KARCHER_ERROR_CODE:"Figyelmeztető hibakód",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Szervezet",
    CREATE_ORGANIZATION:"Szervezet létrehozása",
    CREATE_ORGANIZATION_AS:"Alszervezet létrehozása",
    DELETE_ORGANIZATION:"Szervezet törlése",
    EDIT_ORGANIZATION:"Szervezet szerkesztése",
    SUPPORTED_ORG_NAME:"Támogatott szervezet",
    SUPPORTED_ORG_TYPE:"Támogatott típus",
    ORG_NAME:"Név",
    ORG_TYPE:"Típus",
    SET_ORG_TITLE:"Alszervezet beállítása",
    SET_SUPPORTED_ORG_TITLE:"Támogatott alszervezet beállítása",
    SAVE_ORGANIZATION:"Szervezet mentése",
    SELECT_ORGANIZATION_TYPE:"Válassza ki a szervezet típusát",
    SELECT_ORGANIZATION_SELECTOR:"Válassza ki",
    SELECT_SUPPORTED_ORGANIZATION:"Válassza ki a támogatott szervezetet",
    ORGANIZATION_DELETED:"Szervezet sikeresen törölve",
    ORGANIZATION_SAVED:"Szervezet sikeresen mentve",
    ORGANIZATION_UPDATED:"A szervezet sikeresen frissítve",
    ALERTS:"Figyelmeztetések",
    DEVICE_STATUS:"Eszköz állapota",
    SITE_DETAILS:"Hely részletei",
    ALARM_STATUS:"Figyelmeztetés állapota",
    FILTER:"Szűrés alapján ...",
    FILTER_BY_ALERT_CENTER:"Szűrés kód, név vagy leírás alapján",
    TOTAL_ALARM:"Összes",
    LOW_ALARM:"Esemény",
    MEDIUM_ALARM:"Üzemzavar",
    HIGH_ALARM:"Kritikus hiba",
    NO_FACILITIES_NEARBY:"A közelben nincsenek autómosók",
    GRAY_MAP:"Szürke stílusú térkép",
    READY:"Rendelkezésre áll",
    WARNING:"Üzemzavar",
    ERROR:"Hiba",
    SITE_NAME:"Hely neve",
    ACCOUNTS_INFO:"Számlainformáció",
    USER_ORGANIZATION:"Felhasználói szervezet",
    ADD_USER_ORGANIZATION:"Új szervezeti felhasználó hozzáadása",
    EDIT_USER_ORGANIZATION:"Szervezet felhasználóinak szerkesztése",
    SELECT_ROLE:"Válasszon szerepet",
    SELECT_ORGANIZATION:"Válasszon szervezetet",
    SELECT_USER:"Válasszon felhasználót",
    USER_FOR_ORGANIZATION_CREATED:"Új felhasználó sikeresen létrehozva",
    SELECT_REGION:"Válasszon régiót",
    SELECT_LANGUAGE:"Válasszon nyelvet",
    LOADING_DATA:"Adatok betöltése, kérem várjon...",
    ADMINISTRATOR:"Adminisztrátor",
    TECHNICAL_SUPPORT:"Technikai támogatás",
    CONTROLLER:"Vezérlő",
    EDIT_ORGANIZATION_USER:"Szervezet felhasználóinak szerkesztése",
    DELETE_ORGANIZATION_USER:"Törölje a szervezet felhasználóit",
    USER_UPDATED:"Felhasználó sikeresen frissítve",
    USER_CREATED:"Felhasználó sikeresen létrehozva",
    ADDRESS:"Cím",
    SUBSCRIPTIONS:"Előfizetések",
    RESOLVED_STATUS:"Megoldva",
    NOT_RESOLVED_STATUS:"Nincs megoldva",
    ALERT_NAME:"Figyelmeztetés neve",
    ALERT_DESCRIPTION:"Figyelmeztetés leírása",
    ALERT_CODE:"Figyelmeztető kód",
    ALERT_TYPE:"Figyelmeztetés típusa",
    UNSUBSCRIBE:"Leiratkozási figyelmeztetés",
    SUBSCRIBE:"Feliratkozási figyelmeztetés",
    ALARM_SUBSCRIBED:"Sikeres előfizetés",
    UNSUBSCRIBED_CONFIRM:"Leiratkozik?",
    ALARM_UNSUBSCRIBED:"Sikeresen leiratkozott",
    ASIDE_MENU_CASHLESS_SALES:"Készpénz nélküli értékesítés",
    FILTERED_CASHLESS_PAYMENTS:"Szűrt készpénz nélküli fizetések",
    REFUND_DIALOG_TITLE:"Tranzakció viszatérítése?",
    REFUND_DIALOG_SUBTITLE:"Az összeg kisebb vagy egyenlő lehet, mint a tranzakció összege",
    REFUND:"Visszatérítés",
    INPUT_NOT_VALID:"A bevitel nem érvényes",
    REFUND_SUCCESSFULLY:"A kiválasztott fizetés visszatérítése sikeresen megtörtént",
    USER:"Felhasználó",
    TRANSACTION_ID:"PSP hivatkozás",
    DEVICE_ID:"Eszköz azonosító",
    NET_AMOUNT:"Nettó összeg",
    REPORT_NAME:"Kimutatás neve",
    TIME_FRAME:"Időkeret",
    SUB_POINT:"Válassza ki az alpontot",
    SUB_POINT_LIST_NOT_EXIST:"A kiválasztott mosási lehetőséghez nem létezik alpontlista",
    FACILITY_TYPE:"Autómosó típusa",
    MACHINE_NAME:"A gép neve",
    WASH_FACILITY_DETAILS:"A mosási lehetőség részletei",
    WASH_BAY_DETAILS:"Mosóhely részletei",
    DEVICES_INFO:"Eszközök listája",
    OPERATION_TIME_INFO:"Működési idő",
    OPERATION_TIME_VACUUM_INFO:"Porszívók működési ideje",
    OPERATION_TIME_ILLUMINATION_INFO:"A megvilágítás működési ideje",
    AVAILABLE_TITLE:"Elérhető",
    UNAVAILABLE_TITLE:"Nem érhető el",
    CURRENT_PROGRAM:"Aktuális program",
    CREDITS:"Kredit",
    DEVICE_NAME:"Eszköz neve",
    ACTIVE_ALARMS:"Aktív riasztások",
    ALL_DAY:"Egész nap",
    OPERATING_TIME_WASH_FACILITY:"Önkiszolgáló mosórendszer",
    OPERATING_TIME_VACUUMS:"Porszívók",
    OPERATING_TIME_ILLUMINATION:"Megvilágítás",
    OPERATION_COUNTERS:"Műveletszámlálók",
    EDIT:"Szerkesztés",
    WASHING_PROGRAMS:"Mosási programok",
    INFO:"Esemény",
    STATISTIC:"Statisztikai",
    ROLLOVER_DOSING:"Dosing",
    ROLLOVER_SPEED:" Speeds",
    ROLLOVER_RESETS:" Rollover remote reset",
    ROLLOVER_RESETS_INFO:" The remote reset has to be in accordance with local regulations. Important: Before resetting make sure that rollover is empty.",
    RESET_ROLLOVER:" Reset rollover",
    OPEN_DOOR_ROLLOVER:" Open",
    ROLLOVER_OPEN_DOOR_INFO:"Open wash hall door. Be careful.",
    ROLLOVER_OPEN_DOOR:" Open the door",
    APPLY_DOSING_CHANGES:" Apply dosing changes",
    APPLY_SPEED_CHANGES:" Apply speed changes",
    ACTUATION_SUCCESS:"Request sent",
    REMAINING_TIME:" Remaining time",
    OPEN_24H:" Open 24 hours",
    CLOSE_24H:" Close 24 hours",
    VALIDATION_OPERATION_TIME:" Format not correct. Use hh:mm",
    ROLLOVER:" Rollover",
    UPDATE_WASHING_PROGRAM:" Update washing program",
    UPDATE_ACTUATORS:"Update actuators",
    OPEN_ROLOVER_DOOR_TITLE:" Want to open rollover door?",
    OPEN_ROLOVER_DOOR_CONTENT:" Are you sure you want to open the door?",
    RESET_ROLOVER_TITLE:" Want to reset rollover?",
    RESET_ROLOVER_CONTENT:" Are you sure you want to reset rollover?",
    G0:"{{brand === 'r2w' ? 'Autómosó beálló 0' : 'Autómosó beálló 1'}}",
    G1:"{{brand === 'r2w' ? 'Autómosó beálló 1' : 'Autómosó beálló 2'}}",
    G2:"{{brand === 'r2w' ? 'Autómosó beálló 2' : 'Autómosó beálló 3'}}",
    G3:"{{brand === 'r2w' ? 'Autómosó beálló 3' : 'Autómosó beálló 4'}}",
    G4:"{{brand === 'r2w' ? 'Autómosó beálló 4' : 'Autómosó beálló 5'}}",
    G5:"{{brand === 'r2w' ? 'Autómosó beálló 5' : 'Autómosó beálló 6'}}",
    G6:"{{brand === 'r2w' ? 'Autómosó beálló 6' : 'Autómosó beálló 7'}}",
    G7:"{{brand === 'r2w' ? 'Autómosó beálló 7' : 'Autómosó beálló 8'}}",
    G8:"{{brand === 'r2w' ? 'Autómosó beálló 8' : 'Autómosó beálló 9'}}",
    G9:"{{brand === 'r2w' ? 'Autómosó beálló 9' : 'Autómosó beálló 10'}}",
    G10:"{{brand === 'r2w' ? 'Autómosó beálló 10' : 'Autómosó beálló 11'}}",
    U0:"{{brand === 'r2w' ? 'Porszívó 0' : 'Porszívó 1'}}",
    U1:"{{brand === 'r2w' ? 'Porszívó 1' : 'Porszívó 2'}}",
    U2:"{{brand === 'r2w' ? 'Porszívó 2' : 'Porszívó 3'}}",
    U3:"{{brand === 'r2w' ? 'Porszívó 3' : 'Porszívó 4'}}",
    U4:"{{brand === 'r2w' ? 'Porszívó 4' : 'Porszívó 5'}}",
    U5:"{{brand === 'r2w' ? 'Porszívó 5' : 'Porszívó 6'}}",
    U6:"{{brand === 'r2w' ? 'Porszívó 6' : 'Porszívó 7'}}",
    U7:"{{brand === 'r2w' ? 'Porszívó 7' : 'Porszívó 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Riasztási központ jelentést hozott létre a kiválasztott helyre az irányítópultról",
    ALERT_CENTER_TITLE_BY_FACILITY:"Riasztási központ jelentést hozott létre a kiválasztott autómosó által az irányítópultról",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Riasztási központ jelentés",
    ERROR_MESSAGE_403:"Nincs jogosultsága ennek az API-hívásnak a használatára. Hibakód: 403",
    LAST_ACTIVE_PROGRAM:"Aktív program / Utolsó aktív program",
    PROGRAM_ID:"Program szám",
    PROGRAM_PRICE:"Program ár",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Utántöltés szükséges",
    EMPTY_CHEMICAL_LEVEL:"Üres",
    CHEMICAL_LEVEL:"Level indication detergents (%)",
    ROLLOVER_STATUS:" Rollover status",
    ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
    ROLLOVER_STATUS_CODE_1:" Outside operating time",
    ROLLOVER_STATUS_CODE_2:" Program entry allowed",
    ROLLOVER_STATUS_CODE_3:"Position your vehicle",
    ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
    ROLLOVER_STATUS_CODE_5:"Vehicle back",
    ROLLOVER_STATUS_CODE_6:"Vehicle stop",
    ROLLOVER_STATUS_CODE_7:"Wash active",
    ROLLOVER_STATUS_CODE_8:"Wash stopped",
    ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
    ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
    ROLLOVER_STATUS_CODE_11:"Emergency stop",
    ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
    ROLLOVER_STATUS_CODE_13:"Anti frost active",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
    ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Kritikus hiba",
    NO_ALARM:"Nincs kritikus hiba",
    SOFTWARE_VERSION:"Szoftver verzió",
    SOFTWARE_DATE:"Szoftver dátum",
    SITE_ADDRESS:"Hely címe",
    SECONDS:"Másodpercek",
    SERVICE_PART_NAME:"Szolgáltatás neve:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Működési és szolgáltatási számláló",
    OPERATION_COUNTER:"Működési számláló",
    SERVICE_COUNTER:"Szolgáltatási számláló",
    FAULT_CODE:"Figyelmeztetési kód",
    PRESSURE_TITLE:"Légnyomás",
    TIME_TITLE:"Jelenlegi idő",
    COUNTRY_TITLE:"Ország",
    CITY_TITLE:"Város",
    REGION_TITLE:"Régió",
    SELECT_POINTS_TO_SEARCH:"Select points ...",
    LOGS_HISTORY:"Paraméterváltozás előzményei",
    ACTUATOR_REFERENCE:"Aktuátor referencia",
    ACTUATOR_VALUE:"Aktuátor érték",
    POINT_ID:"Pont azonosító",
    VALIDATION_NOT_VALID_RANGE:"Hibás tartomány",
    ENABLE_ROLLOVER_RESET:"A jelölőnégyzet bepipálásával megerősíti, hogy elolvasta és elfogadja a biztonsági utasításokat.",
    CHANGE_OF_PARAMETERS:"Paraméterek módosítása",
    SELECT_OPTIONS:"Opciók kiválasztása",
    AUTOMATIC:"Automatikus",
    DESALTING:" Sómentesítő funkció",
    SEASON_WASH:"Szezonális mosási programok",
    SPRING_PROGRAM:"Tavaszi mosási programok",
    SUMMER_PROGRAM:"Nyári mosási programok",
    AUTUMN_PROGRAM:"Őszi mosási programok",
    WINTER_PROGRAM:"Téli mosási programok",
    DOOR_CONTROL:"Ajtóvezérlés",
    SUMMER_DOOR_CONTROL:"Nyár, nyári üzemmódban működtetett kapuvezérléssel",
    WINTER_DOOR_CONTROL:"él, téli üzemmódban működtetett kapuvezérléssel",
    APPLY_PARAMETERS_CHANGES:"Paraméterváltozások alkalmazása",
    WORKING_SCHEDULES:"Munkarendek",
    HOLIDAY_SCHEDULES:"Üdülési ütemtervek",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Ünnepek a helyszínen sikeresen létrehozva",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Ünnepek a helyszínen sikeresen frissítve",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Ünnepnapok a helyszínen sikeresen törölve",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Munkarendek sikeresen átvitelre kerültek",
    HOLIDAY_SUCCESSFULLY_DELETED:"Üdülés sikeresen törölve",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Drying agent with low filling level",
    CHEM_LEVEL_LOW_SHAMPOO:"Shampoo with low filling level",
    CHEM_LEVEL_LOW_FOAM:"Foam with low filling level",
    CHEM_LEVEL_LOW_WAX_1:"Wax with low filling level",
    CHEM_LEVEL_LOW_POLISH_1:"Polish with low filling level",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Rim cleaner with low filling level",
    CHEM_LEVEL_LOW_WAX_2:"Wax with low filling level",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Tyre shine with low filling level",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Insect remover with low filling level",
    CHEM_LEVEL_LOW_POLISH_2:"Polish with low filling level",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensive with low filling level",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Foam rain with low filling level",
    CHEM_LEVEL_DRYING_AGENT:"Filling level drying agent",
    CHEM_LEVEL_SHAMPOO:"Filling level shampoo",
    CHEM_LEVEL_FOAM:"Filling level foam",
    CHEM_LEVEL_WAX_1:"Filling level wax",
    CHEM_LEVEL_POLISH_1:"Filling level polish",
    CHEM_LEVEL_RIM_CLEANER:"Filling level rim cleaner",
    CHEM_LEVEL_WAX_2:"Filling level wax",
    CHEM_LEVEL_TYRE_SHINE:"Filling level tyre shine",
    CHEM_LEVEL_INSECT_REMOVER:"Filling level insect remover",
    CHEM_LEVEL_POLISH_2:"Filling level polish",
    CHEM_LEVEL_INTENSIVE:"Filling level intensive ",
    CHEM_LEVEL_FOAM_RAIN:"Filling level foam rain",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Service counter roof-brush lifting belt",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Service counter dryer lifting belt",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Service counter motor cable roof-brush",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Service counter fresh water pump service",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Service counter pump service used water",
    DRYING_AGENT:"Drying agent",
    FOAM_DRYING_AGENT:"Foam drying agent",
    SHAMPOO:"Shampoo",
    FOAM:"Foam",
    BRUSH_FOAM:"Brush foam",
    WAX_1:"Wax",
    FOAM_WAX_1:"Foam wax",
    POLISH_1:"Polish",
    RIM_CLEANING:"Rim cleaner",
    WAX_2:"Wax",
    FOAM_WAX_2:"Foam wax",
    TYRE_SHINE:"Tyre shine",
    INSECT_REMOVER:"Insect remover",
    POLISH_2:"Polish",
    INTENSIVE_BASIC:"Intensive basic",
    INTENSIVE_SIDE:"Intensive side",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensive roof spray bar",
    TAR_REMOVER:"Tar remover",
    UNDER_CHASSIS_CONVERSATION:"Under chassis conversation",
    STATIONARY_PRE_SPRAY_ARCH:"Stationary pre-spray arch",
    FOAM_RAIN:"Foam rain",
    PRE_CLEANING:"Pre-cleaning",
    BRUSH:"Brush",
    CARE:"Care",
    DRYING:"Drying",
    DRYING_LOW_NOISE:"Drying reduced noise",
    INTENSIVE_CLEANING:"Intensive cleaning",
    BRUSH_CLEANING:"Brush cleaning",
    EMPTY_RUN:"Empty run",
    DRYING_AID:"Drying aid",
    WAX:"Wax",
    FOAM_WASH:"Foam wash",
    POLISH:"Polish",
    FOAM_POLISH:"Foam polish",
    WHEEL_CLEANING:"Wheel cleaning",
    HIGH_PRESSURE_ROOF:"Roof high pressure",
    HIGH_PRESSURE_SIDE:"Side high pressure",
    DRYER_FORWARD:"Dryer forward",
    DRYER_BACKWARD:"Dryer backward",
    DELETE_ALL_HOLIDAYS:"A kiválasztott hely összes ünnepének törlése",
    CREATE_NEW_HOLIDAY:"Új létrehozása",
    RESET_INPUTS:"Minden üdülési adat visszaállítása",
    TWENTY_FOUR_HOURS_OPEN:"24 órás nyitva tartás",
    EVERY_YEAR:"Éves",
    DELETE_HOLIDAY:"Üdülés törlése",
    ADD_NEW_HOLIDAY:"Új üdülés hozzáadása",
    HOLIDAYS_LIST:"Meglévő üdülések listája",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Törli az összes ünnepnapot a kiválasztott helyen?",
    VALIDATION_HOLIDAY_DATE:"Format not correct. Use mm-dd",
    FOR_DATE:"For date",
    WITH_ID:"With ID",
    FROM_HOURS:"From (h)",
    FROM_MINUTES:"From (min)",
    TO_HOURS:"To (h)",
    TO_MINUTES:"To (min)",
    NOT_MATCH:"Not match",
    START:"Start",
    STOP:"Stop",
    DAILY_TIME:"24 hours list",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individual time setting",
    PROGRAM_NOT_STARTED:"Program not started yet",
    JETWASH:"Self-service wash system",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Friss víz szivattyú",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Feldolgozó víz szivattyú",
    OPERATION_COUNTER_HP_PUMP_1:"Nagy nyomású szivattyú 1",
    OPERATION_COUNTER_HP_PUMP_2:"Nagy nyomású szivattyú 2",
    RELEASE_NOTES:"Alkalmazás verziók és kiadási megjegyzések",
    BACKEND_RELEASE_NOTES:"Platform kiadási megjegyzések:",
    FRONTEND_RELEASE_NOTES:"Webalkalmazás kiadási megjegyzések:",
    SELECTED_FACILITY_TIMEZONE:"Kiválasztott autómosó időzónája",
    REFRESH_PAGE:"Oldal frissítése",
    REFRESH_MAPS:"Térképek frissítése",
    PUMPS:"Szivattyúk",
    RUN_TIME:"Futási idő ",
    RUN_TIME1:"Futási idő 1",
    RUN_TIME2:"Futási idő 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuátor futási időhöz",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuátor futási idő 1-hez",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuátor futási idő 2-höz",
    PUMP_RUN_TIME_MIN_VALIDATION:"Min érték 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Max érték 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Ár formátum használata x.xx",
    ACTUATION_NOT_ALLOWED:"Aktuálás nem engedélyezett a jelenlegi felhasználói szerepkörhöz",
    MAINTENANCE_DAYS:"Karbantartási napok",
    MAINTENANCE_WASHES:"Karbantartási mosások",
    DAILY_FINANCES_POS:"POS ",
    POS_INCOME:"Összes jövedelem POS",
    PROPAGATE:"Propagate",
    ALL_DAY_HOURS_SELECTOR:"24 órás típusválasztó",
    GET_OPERATING_TIME_FROM_SITE:"Kérje le az aktuális eszköz működési idejét a helyszíni munkarendből",
    USER_NOT_VALID:"A felhasználó érvénytelen. Próbálja meg egy másik fiók hitelesítő adataival.",
    VERIFIED:"Ellenőrzött",
    RESEND_VERIFICATION_MAIL:"Ellenőrző e-mail újraküldése",
    RETURN_TO_DASHBOARD:"Vissza a műszerfalhoz",
    ERROR_PAGE_BAD_REQUEST:"400 Hibás kérés.",
    WASHES:"Mosások száma",
    TIME_TO_SERVICE:"Szolgáltatás időpontja",
    ACCOUNT_ALREADY_ACTIVATED:"Fiók már aktiválva",
    DEVICE_EVENTS:"Eszköz események",
    DEVICE_EVENTS_LOG_PULLED:"Eszköz eseménynapló lekérve",
    EVENTS_PULL_DATE:"Események lekérési idő:",
    DEVICE_EVENTS_REFRESH:"Új eseményadatok lekérése",
    WEB_SOCKETS_CONNECTION_PROBLEM:" Websocket-kapcsolati probléma. Próbálja meg frissíteni az oldalt.",
    INSTALLATION_DATE:"Gép telepítési dátuma",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Forró viasz",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Nagy nyomású mosás",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Erőteljes peremhab",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Erőteljes hab",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Megállítás",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Habmosás HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Mosás",
    KARCHER_CUSTOM_PROGRAM_NAME_8:" Kiemelt ápolás",
    INFO_TITLE:"Információ",
    FOAM_WAX1:"Habviasz",
    POLISH1:"Polír",
    WAX1:"Viasz",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Az oldal részletei sikeresen frissítve",
    COMPANY:"Cég",
    FACILITY_HAS_CHANGER:" Van váltó?",
    DISABLE_OFFLINE_ALARM:"R2W riasztások kikapcsolása",
    ASIDE_WORKING_SCHEDULES:"Alkalmazás oldal részletei",
    TERMS_OF_SERVICE_R2W_TITLE:"Ready2Wash szolgáltatási feltételek",
    TERMS_OF_SERVICE_R2W:"Ready2Wash szolgáltatási feltételek",
    DATA_PROCESSING_TITLE:"Adatok feldolgozva",
    PRIVACY_POLICY_TITLE:"Adatvédelmi irányelvek",
    READY_TO_PAY_TERMS_OF_SERVICE:"Ready2Pay szolgáltatási feltételek",
    TERMS_AND_SERVICES:"Feltételek és szolgáltatások",
    HOURLY: "Óránként",
    DAILY: "Naponta",
    WEEKLY: "Hetente",
    MONTHLY: "Havonta",
    YEARLY: "Évente",
    DELETE_ITEM_SUCCESS:"Sikeresen törölte az elemet",
    STATE: "Állapot",
    AVAILABILITY_STATUS_1: "Egység nyitva",
    AVAILABILITY_STATUS_2: "Egység zárva (szabadság)",
    AVAILABILITY_STATUS_3: "Egység zárva (üzemidő)",
    AVAILABILITY_STATUS_4: "Egység zárva (hiba)",
    AVAILABILITY_STATUS_5: "Egység zárva (egyéb)",
    AVAILABILITY_VACUUMS_STATUS_1: "Porszívók nincsenek telepítve",
    AVAILABILITY_VACUUMS_STATUS_2: "Porszívók nyitva",
    AVAILABILITY_VACUUMS_STATUS_3: "Porszívók zárva (szabadság)",
    AVAILABILITY_VACUUMS_STATUS_4: "Porszívók zárva (üzemidő)",
    AVAILABILITY_VACUUMS_STATUS_5: "Porszívók zárva (hiba)",
    AVAILABILITY_VACUUMS_STATUS_6: "Porszívók zárva (egyéb)",
    ECOM_AMOUNT: "Összesített Ecom minden helyszínre",
    CAPTURED: "Rögzítve",
    DELETE_COMPANY_HISTORY_INFO:"Ez a művelet törölni fogja a vállalata összes jelentésadatát. Ez a művelet nem vonható vissza.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Biztos benne, hogy véglegesen törölni szeretné az összes jelentésadatot?",
    VALUE_DATE: "Értéknap",
    KARCHER_EVENT_NAME_1: "Alap hőcserélő regenerálva",
    KARCHER_EVENT_NAME_2: "Alap hőcserélő regeneráció befejezve",
    KARCHER_EVENT_NAME_3: "Anyag / sorozatszám",
    KARCHER_EVENT_NAME_4: "A rendszer fertőtlenítve",
    KARCHER_EVENT_NAME_5: "HP szivattyú 1 fertőtlenítve",
    KARCHER_EVENT_NAME_6: "HP szivattyú 2 fertőtlenítve",
    KARCHER_EVENT_NAME_7: "HP szivattyú 3 fertőtlenítve",
    KARCHER_EVENT_NAME_8: "HP szivattyú 4 fertőtlenítve",
    KARCHER_EVENT_NAME_9: "HP szivattyú 5 fertőtlenítve",
    KARCHER_EVENT_NAME_10: "1. mosóállomás zárolva",
    KARCHER_EVENT_NAME_11: "2. mosóállomás zárolva",
    KARCHER_EVENT_NAME_12: "3. mosóállomás zárolva",
    KARCHER_EVENT_NAME_13: "4. mosóállomás zárolva",
    KARCHER_EVENT_NAME_14: "5. mosóállomás zárolva",
    KARCHER_EVENT_NAME_15: "6. mosóállomás zárolva",
    KARCHER_EVENT_NAME_16: "7. mosóállomás zárolva",
    KARCHER_EVENT_NAME_17: "8. mosóállomás zárolva",
    KARCHER_EVENT_NAME_18: "Frissítés elindítva",
    KARCHER_EVENT_NAME_19: "Frissítés befejezve",
    KARCHER_EVENT_NAME_20: "WS Reg kezdés",
    KARCHER_EVENT_NAME_21: "WS Reg befejezés",
    KARCHER_EVENT_NAME_22: "WS 75%-os érzékelő",
    KARCHER_EVENT_NAME_23: "Műszaki hiba",
    KARCHER_EVENT_NAME_24: "Üzemzavar",
    KARCHER_EVENT_NAME_25: "Egység bekapcsolva",
    KARCHER_EVENT_NAME_26: "Egység kikapcsolva",
    KARCHER_EVENT_NAME_27: "1. doboz lezárva",
    KARCHER_EVENT_NAME_28: "2. doboz lezárva",
    KARCHER_EVENT_NAME_29: "3. doboz lezárva",
    KARCHER_EVENT_NAME_30: "4. doboz lezárva",
    KARCHER_EVENT_NAME_31: "5. doboz lezárva",
    KARCHER_EVENT_NAME_32: "6. doboz lezárva",
    KARCHER_EVENT_NAME_33: "7. doboz lezárva",
    KARCHER_EVENT_NAME_34: "8. doboz lezárva",
    KARCHER_EVENT_NAME_35: "1. HP szivattyúállomás",
    KARCHER_EVENT_NAME_36: "2. HP szivattyúállomás",
    KARCHER_EVENT_NAME_37: "3. HP szivattyúállomás",
    KARCHER_EVENT_NAME_38: "4. HP szivattyúállomás",
    KARCHER_EVENT_NAME_39: "5. HP szivattyúállomás",
    KARCHER_EVENT_NAME_40: "6. HP szivattyúállomás",
    KARCHER_EVENT_NAME_41: "7. HP szivattyúállomás",
    KARCHER_EVENT_NAME_42: "8. HP szivattyúállomás",
    KARCHER_EVENT_NAME_43: "Égőfej",
    KARCHER_EVENT_NAME_44: "Égőfej ventilátor",
    KARCHER_EVENT_NAME_45: "Melegvíz szivattyú",
    KARCHER_EVENT_NAME_46: "Fagyvédő szivattyú",
    KARCHER_EVENT_NAME_47: "Ozmózis szivattyú",
    KARCHER_EVENT_NAME_48: "Padlófűtés",
    KARCHER_EVENT_NAME_49: "Tömlőfűtés",
    KARCHER_EVENT_NAME_50: "Mikro-/Felni tisztítás",
    KARCHER_EVENT_NAME_51: "Alvázmosó szivattyú",
    KARCHER_EVENT_NAME_52: "Habosító Booster szivattyú",
    KARCHER_EVENT_NAME_53: "1. porszívó",
    KARCHER_EVENT_NAME_54: "2. porszívó",
    KARCHER_EVENT_NAME_55: "3. porszívó",
    KARCHER_EVENT_NAME_56: "4. porszívó",
    KARCHER_EVENT_NAME_57: "5. porszívó",
    KARCHER_EVENT_NAME_58: "6. porszívó",
    KARCHER_EVENT_NAME_59: "7. porszívó",
    KARCHER_EVENT_NAME_60: "8. porszívó",
    KARCHER_EVENT_NAME_61: "9. porszívó",
    KARCHER_EVENT_NAME_62: "10. porszívó",
    KARCHER_EVENT_NAME_63: "11. porszívó",
    KARCHER_EVENT_NAME_64: "12. porszívó",
    KARCHER_EVENT_NAME_65: "Felni tisztítószivattyú",
    KARCHER_EVENT_NAME_66: "Mikroszivattyú",
    KARCHER_EVENT_NAME_67: "Intenzív szivattyú",
    KARCHER_EVENT_NAME_68: "1. porszívó turbinája",
    KARCHER_EVENT_NAME_69: "1. porszívó szűrője",
    KARCHER_EVENT_NAME_70: "2. porszívó turbinája",
    KARCHER_EVENT_NAME_71: "2. porszívó szűrője",
    KARCHER_EVENT_NAME_72: "3. porszívó turbinája",
    KARCHER_EVENT_NAME_73: "3. porszívó szűrője",
    KARCHER_EVENT_NAME_74: "4. porszívó turbinája",
    KARCHER_EVENT_NAME_75: "4. porszívó szűrője",
    KARCHER_EVENT_NAME_76: "5. porszívó turbinája",
    KARCHER_EVENT_NAME_77: "5. porszívó szűrője",
    KARCHER_EVENT_NAME_78: "6. porszívó turbinája",
    KARCHER_EVENT_NAME_79: "6. porszívó szűrője",
    KARCHER_EVENT_NAME_80: "7. porszívó turbinája",
    KARCHER_EVENT_NAME_81: "7. porszívó szűrője",
    KARCHER_EVENT_NAME_82: "8. porszívó turbinája",
    KARCHER_EVENT_NAME_83: "8. porszívó szűrője",
    KARCHER_EVENT_NAME_84: "9. porszívó turbinája",
    KARCHER_EVENT_NAME_85: "9. porszívó szűrője",
    KARCHER_EVENT_NAME_86: "10. porszívó turbinája",
    KARCHER_EVENT_NAME_87: "10. porszívó szűrője",
    KARCHER_EVENT_NAME_88: "11. porszívó turbinája",
    KARCHER_EVENT_NAME_89: "11. porszívó szűrője",
    KARCHER_EVENT_NAME_90: "12. porszívó turbinája",
    KARCHER_EVENT_NAME_91: "12. porszívó szűrője",
    INSERT_TOKEN: "Adja meg a tokeneket, és indítsa el a szolgáltatást",
    OPEN_SESSION: "A munkamenet sikeresen megnyílt",
    IN_PROGRESS: "Folyamatban ...",
    TOKEN_INSERTED: "A tokeneket sikeresen megadták",
    EXPIRED_SESSION: "A munkamenet lejárt",
    TWO_DIGIT_INTEGER_VALIDATION: "Legfeljebb kétszámjegyű egész számot használjon",
    KARCHER_OPERATION_COUNTER_1: "Mosóállomás 1 HP szivattyú",
    KARCHER_OPERATION_COUNTER_2: "Mosóállomás 1 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_3: "Mosóállomás 1 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_4: "Mosóállomás 1 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_5: "Mosóállomás 1 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_6: "Mosóállomás 2 HP szivattyú",
    KARCHER_OPERATION_COUNTER_7: "Mosóállomás 2 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_8: "Mosóállomás 2 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_9: "Mosóállomás 2 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_10: "Mosóállomás 2 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_11: "Mosóállomás 3 HP szivattyú",
    KARCHER_OPERATION_COUNTER_12: "Mosóállomás 3 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_13: "Mosóállomás 3 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_14: "Mosóállomás 3 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_15: "Mosóállomás 3 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_16: "Mosóállomás 4 HP szivattyú",
    KARCHER_OPERATION_COUNTER_17: "Mosóállomás 4 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_18: "Mosóállomás 4 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_19: "Mosóállomás 4 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_20: "Mosóállomás 4 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_21: "Mosóállomás 5 HP szivattyú",
    KARCHER_OPERATION_COUNTER_22: "Mosóállomás 5 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_23: "Mosóállomás 5 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_24: "Mosóállomás 5 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_25: "Mosóállomás 5 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_26: "Mosóállomás 6 HP szivattyú",
    KARCHER_OPERATION_COUNTER_27: "Mosóállomás 6 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_28: "Mosóállomás 6 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_29: "Mosóállomás 6 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_30: "Mosóállomás 6 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_31: "Mosóállomás 7 HP szivattyú",
    KARCHER_OPERATION_COUNTER_32: "Mosóállomás 7 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_33: "Mosóállomás 7 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_34: "Mosóállomás 7 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_35: "Mosóállomás 7 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_36: "Mosóállomás 8 HP szivattyú",
    KARCHER_OPERATION_COUNTER_37: "Mosóállomás 8 vegyi szivattyú 1",
    KARCHER_OPERATION_COUNTER_38: "Mosóállomás 8 vegyi szivattyú 2",
    KARCHER_OPERATION_COUNTER_39: "Mosóállomás 8 vegyi szivattyú 3",
    KARCHER_OPERATION_COUNTER_40: "Mosóállomás 8 vegyi szivattyú 4",
    KARCHER_OPERATION_COUNTER_41: "Ozmózisszivattyú",
    KARCHER_OPERATION_COUNTER_42: "Melegvíz-generátor",
    KARCHER_OPERATION_COUNTER_43: "Fagyvédő szivattyú",
    KARCHER_OPERATION_COUNTER_44: "WSO szűrőpatronok",
    KARCHER_OPERATION_COUNTER_45: "Mosóállomás fűtési szivattyú",
    KARCHER_OPERATION_COUNTER_46: "Melegvíz-szivattyú",
    KARCHER_OPERATION_COUNTER_47: "Habcső fűtése",
    KARCHER_OPERATION_COUNTER_48: "Kerékmosó szivattyú",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulziós szivattyú",
    KARCHER_OPERATION_COUNTER_50: "Intenzív habtakarék szivattyú",
    KARCHER_OPERATION_COUNTER_51: "Porszívó 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Porszívó 1 szűrő 1",
    KARCHER_OPERATION_COUNTER_53: "Porszívó 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Porszívó 1 szűrő 2",
    KARCHER_OPERATION_COUNTER_55: "Porszívó 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Porszívó 2 szűrő 1",
    KARCHER_OPERATION_COUNTER_57: "Porszívó 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Porszívó 2 szűrő 2",
    KARCHER_OPERATION_COUNTER_59: "Porszívó 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Porszívó 3 szűrő 1",
    KARCHER_OPERATION_COUNTER_61: "Porszívó 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Porszívó 3 szűrő 2",
    KARCHER_OPERATION_COUNTER_63: "Porszívó 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Porszívó 4 szűrő 1",
    KARCHER_OPERATION_COUNTER_65: "Porszívó 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Porszívó 4 szűrő 2",
    KARCHER_OPERATION_COUNTER_67: "Porszívó 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Porszívó 5 szűrő 1",
    KARCHER_OPERATION_COUNTER_69: "Porszívó 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Porszívó 5 szűrő 2",
    KARCHER_OPERATION_COUNTER_71: "Porszívó 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Porszívó 6 szűrő 1",
    KARCHER_OPERATION_COUNTER_73: "Porszívó 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Porszívó 6 szűrő 2",
    KARCHER_OPERATION_COUNTER_75: "Távolítsa el a kondenzvizet a kompresszorból",
    KARCHER_OPERATION_COUNTER_76: "Ellenőrizze a fagyvédelmi rendszert",
    KARCHER_OPERATION_COUNTER_77: "Égő ventilátora",
    KARCHER_OPERATION_COUNTER_78: "Habfelerősítő szivattyú",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Az adatlista több mint 10000 elemet tartalmaz",
    KARCHER_POINT_NAME_1: "Ünnepnap",
    KARCHER_POINT_NAME_2: "Hétfő",
    KARCHER_POINT_NAME_3: "Kedd",
    KARCHER_POINT_NAME_4: "Szerda",
    KARCHER_POINT_NAME_5: "Csütörtök",
    KARCHER_POINT_NAME_6: "Péntek",
    KARCHER_POINT_NAME_7: "Szombat",
    KARCHER_POINT_NAME_8: "Vasárnap",
    KARCHER_POINT_NAME_9: "Porszívók Ünnepnap",
    KARCHER_POINT_NAME_10: "Porszívók Hétfő",
    KARCHER_POINT_NAME_11: "Porszívók Kedd",
    KARCHER_POINT_NAME_12: "Porszívók Szerda",
    KARCHER_POINT_NAME_13: "Porszívók Csütörtök",
    KARCHER_POINT_NAME_14: "Porszívók Péntek",
    KARCHER_POINT_NAME_15: "Porszívók Szombat",
    KARCHER_POINT_NAME_16: "Porszívók Vasárnap",
    KARCHER_POINT_NAME_17: "Világítás Ünnepnap",
    KARCHER_POINT_NAME_18: "Világítás Hétfő",
    KARCHER_POINT_NAME_19: "Világítás Kedd",
    KARCHER_POINT_NAME_20: "Világítás Szerda",
    KARCHER_POINT_NAME_21: "Világítás Csütörtök",
    KARCHER_POINT_NAME_22: "Világítás Péntek",
    KARCHER_POINT_NAME_23: "Világítás Szombat",
    KARCHER_POINT_NAME_24: "Világítás Vasárnap",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR-kód",
    ACCEPT_TERMS_AND_CONDITIONS: "Felhasználási feltételek elfogadása",
    CREATE_AND_PRINT_VOUCHERS: "Kuponok létrehozása és nyomtatása",
    CODE_PREFIX_QUESTION: "Kód-előtag nincs megadva",
    CODE_PREFIX_QUESTION_TEXT: "Szeretné kód-előtag nélkül folytatni?",
    ISSUED_DATE: "Kibocsátás dátuma",
    VOUCHER_VALIDITY_DAYS: "Kupon érvényessége (napok)",
    VALIDATION_ONLY_NUMBERS: "Csak számok engedélyezettek",
    REPRINT_VOUCHERS: "Kuponok másolatának nyomtatása",
    EXPIRY_DATE: "Érvényes eddig"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("hrTranslations", {
    MESSAGE:"Poruka",
    ERROR_TITLE:"Greška",
    ERROR_MESSAGE:"Došlo je do greške tokom izvršavanja operacije.",
    ERROR_LOGIN:"Greška prilikom prijavljivanja. Email adresa je nepoznata ili se lozika ne podudara. Molimo Vas pokušajte ponovo.",
    ERROR_LOGIN_ROLE:"Uloga za trenutnu aplikaciju nije važeća",
    OK:"OK",
    CANCEL:"Otkaži",
    YES:"Da",
    NO:"Ne",
    FROM:"Od",
    TO:"Do",
    DELETE:"Obriši",
    SIGN_OUT:"Odjavi se",
    NAME:"Ime",
    DATE:"Datum",
    PIECES:"komada",
    HOURS:"Sati",
    DAYS:"Dani",
    MONTH:"Mjesec",
    MONTHS:"Mjeseci",
    YEAR:"Godina",
    BOX:"Box",
    SEARCH:"Traži",
    ALL_USERS:"Svi korisnici",
    ARE_YOU_SURE:"Sigurni ste?",
    BACK:"Nazad",
    AMOUNT:"Opis",
    DESCRIPTION:"Opis",
    FORGOT_PASSWORD_ERROR_MSG:"Da li ste sigurni",
    REQUIRED_FIELD:"Polje je obavezno",
    LOGOUT_TITLE:"Da li ste sigurni da se želite odjaviti",
    LOGOUT_MSG:"Sve nespremljene izmjene bit će obrisane",
    ACTIVATION_ACCOUNT:"Uspješno ste aktivirali nalog, nastavite ka ekranu za prijavu",
    UNKNOWN_ERRROR_NOTIFICATION:"Nastavite",
    CONTINUE:"Dogodila se nepoznata greška",
    DATA_NOT_AVAILABLE:"Podaci nisu pronađeni",
    SELECT:"Izaberi",
    SELECT_CURRENCY:"Izaberi valutu",
    UPLOAD:"Pošalji",
    PHONE:"Telefon",
    WEBSITE:"Internet stranica",
    WORKING_HOURS:"Radno vrijeme",
    INSERT:"Unesi",
    TEXT:"Tekst",
    CREATED:"Kreirana",
    VALID_UNTIL:"Traje do",
    SAVE:"Spremi",
    TOKENS:"Žetona",
    DELETE_COMPANY_HISTORY:"Obrisati istoriju kompanije?",
    DELETE_COMPANY_HISTORY_MESSAGE:"UPOZORENJE: Nakon pritiska na ovaj gumb, sve transakcije Vaše autopraonice bit će trajno izbrisane! Ovi podaci se ne mogu vratiti nakon brisanja.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Jeste li sigurni da želite trajno izbrisati sve podatke o transakcijama?",
    HISTORY_SUCCESSFULY_DELETED:"Istorija uspešno obrisana",
    HELP:"Pomoć",
    VALUE:"Vrijednost",
    ACTIVATING_ACCOUNT_ERROR:"Došlo je do greške prilikom aktivacije vašeg R2W računa.Molimo pokušajte ponovo i ako problem i dalje postoji kontaktirajte support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Dobrodošli u Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Dobrodošli na R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Molimo upišite i ponovite svoju lozinku da bi aktivirali svoj R2W račun. Bit ćete automatski prijavljeni na sistem nakon uspješne verifikacije lozinke",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Svoje podatke možete mijenjati kasnije u aplikaciji",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher autopraonica",
    RESET_PASSWORD_WELCOME_MSG:"R2W autopraonica",
    RESET_PASSWORD_WELCOME_MSG_2:"Molimo unesite svoju novu lozinku i potvrdite je kako biste resetirali staru lozinku. Nakon uspješno promenjene lozinke bit ćete automatski prijavljeni u aplikaciju.",
    RESET_PASSWORD_WELCOME_MSG_3:"Vaše korisničke postavke možete kasnije promijeniti u aplikaciji.",
    ENTER_NEW_PASSWORD:"Unesite novu lozinku",
    REPEAT_NEW_PASSWORD:"Ponovite lozinku",
    PASSWORD_MIN_LENGTH:"Lozinka mora imati barem 8 znakova",
    PASSWORD_MAX_LENGHT:"Lozinka ne smije imati više od 32 znakova",
    PASSWORD_PATTERN:"Lozinka mora sadržavati barem jedno veliko i jedno malo slovo",
    PASSWORD_MATCH:"Lozinke nisu identične",
    ACTIVATE:"Aktiviraj",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Uspješno ste poslali zahtjev. Provjerite poruku u e-pošti za potvrdu",
    VALIDATION_REQUIRED:"Obavezno polje",
    VALIDATION_EMAIL:"Neispravna email adresa",
    VALIDATION_INTEGER_NUMBER:"Vrijednost mora biti cijeli broj",
    VALIDATION_HOURS_VALUE:"Vrijednost mora biti između 0-23",
    VALIDATION_MINUTES_VALUE:"Vrijednost mora biti između 0-59",
    VALIDATION_NOT_A_DATE:"Unesena vrijednost nije datum",
    VALIDATION_FROM:"Datum veći od krajnjeg datuma",
    VALIDATION_TO:"Datum manji od početnog datuma",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Taj podatak već postoji u bazi podataka",
    PASSWORD_VALIDATION_PATTERN_NEW:"Lozinka mora sadržavati barem jedno veliko i malo slovo i jedan broj. Prazna polja također nisu dozvoljena.",
    VALIDATION_PERCENT_VALUE:"Vrijednost mora biti između 1-999",
    NUMBERS_ONLY_100:"Broj do 100",
    NUMBERS_ONLY_1000:"Broj do 1000",
    POSITIVE_NUMBERS_ONLY:"Samo pozitivan broj",
    GRID_PAGER_PAGE:"Stranica",
    GRID_PAGER_ROWS_PER_PAGE:"Redova po stranici",
    GRID_PAGER_PAGE_OF:"od",
    BREAD_CRUMBS_HOME:"Početna",
    BREAD_CRUMBS_DASHBOARD_TECH:"Pregled praonica",
    BREAD_CRUMBS_DETAILS:"Detalji",
    BREAD_CRUMBS_SETTINGS:"Podešavanja",
    BREAD_CRUMBS_WORKING_HOURS:"Radno vrijeme",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Ukupno novca po danima",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Prosječno novca po satima",
    BREAD_CRUMBS_NEW_USER_GROUP:"Kreiranje korisničke grupe",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Izmjena korisničke grupe",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Kreiranje šablona kampanje",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Izmjena šablona kampanje",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Kreiranje kampanje",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Izmjena kampanje",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Pregled financija za razdoblje",
    LOGIN:"Prijava",
    EMAIL:"E-mail",
    PASSWORD:"Lozinka",
    LANGUAGE:"Jezik",
    FORGOT_PASSWORD:"Zaboravljena lozinka?",
    SUBMIT:"Potvrdi",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Broj tekućih alarma:",
    HEADER_VIEW_ALL_ALARMS:"Svi alarmi...",
    HEADER_MY_ACCOUNT:"Moj račun",
    HEADER_ACCOUNT_MANAGEMENT:"Upravljanje računima",
    ACCOUNT_ALREADY_EXIST:"Email adresa već postoji",
    NEWSLETTER_CONFIRMATION:"Pošaljite obavijest e-poštom za stanje alarma",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Dnevni pregled financija",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Pregled praonica",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Praonice",
    ASIDE_MENU_ALARMS:"Alarmi",
    ASIDE_MENU_FACILITIES:"Praonice",
    ASIDE_MENU_REPORTS:"Izvještaji",
    ASIDE_MENU_REPORT:"Odabrano izvješće",
    ASIDE_MENU_LOYALTY:"Kampanje",
    ASIDE_MENU_USER_GROUPS:"Grupe korisnika",
    ASIDE_MENU_PERIODIC_SUMMARY:"Pregled po razdoblju",
    ASIDE_MENU_MANAGING_TOKENS:"Upravljanje žetonima",
    ASIDE_MENU_NEWS:"Vijesti",
    DAILY_FINANCES_TOTAL_MONEY:"Ukupno novca",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Ukupno novca za sve praonice",
    DAILY_FINANCES_TOTAL_COINS:"Ukupno iskorištenih metalnih žetona",
    DAILY_FINANCES_DOWNLOAD_CSV:"Preuzmi CSV",
    DAILY_FINANCES_ONLINE:"Online",
    DAILY_FINANCES_OFFLINE:"Gotovina",
    DAILY_FINANCES_CHANGER:"Gotovina u mjenjaču",
    DAILY_FINANCES_COINS:"Žetoni",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Tip izvještaja",
    REPORTS_CHOOSE_FACILITY:"Odabir praonice",
    REPORTS_PERIOD_1:"Period 1 - ",
    REPORTS_PERIOD_2:"Period 2 - ",
    MONEY_BY_DATE_REPORT:"Ukupno novca po danu",
    R2W_BY_DATE_REPORT:"Ukupno online plaćanja po danu",
    COINS_BY_DATE_REPORT:"Ukupno žetona po danu",
    AVG_MONEY_BY_HOUR_REPORT:"Prosječno novca po satu",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Prosječno novca po danu",
    AVG_MONEY_BY_BOX_REPORT:"Potrošnja po box-u",
    COMPARE_PERIODS_REPORT:"Usporedni prikaz po praonici",
    TOTAL_USERS_BY_GROUP:"Ukupno korisnika po danu",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"korisnika",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"posjeta",
    VISITS_COUNT_REPORT:"Broj korisnika po dolascima",
    LOYALTY_PER_DAY_REPORT:"Izdanih žetona po danu",
    LOYALTY_PER_PAYMENT_METHOD:"Lojalnost po načinu plaćanja",
    VISITS:"Posjete",
    VISIT:"Posjeta",
    TOTAL_SPENT_MONEY:"Ukupno potrošenog novca",
    MONEY:"Novac",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Ukupno potrošenog novca za razdoblje",
    DOWNLOAD_CSV:"Preuzmi CSV",
    TOTAL_SPENT_COINS:"Ukupno potrošenih žetona",
    TOTAL_USERS:"Ukupno korisnika",
    TOTAL_CREDIT_GIVEN:"Ukupno potrošenih lokalnih virtualnih žetona",
    EUROKEY_BY_DATE_REPORT:"Ukupna plaćanja euro ključa",
    TOTAL_SPENT_EUROKEY:"Ukupno potrošeno",
    SELECT_TYPE_OF_REPORT:"Morate odabrati vrstu izvješća :)",
    NUMBER_OF_VISITS_TITLE:"Broj posjeta",
    NUMBER_OF_USERS_TITLE:"Broj korisnika",
    PIECES_TITLE:"Komadi",
    TOTAL_VISITS:"Ukupno posjeta",
    TOKENS_TITLE:"žetona",
    SEARCH_USERS_NO_RESULTS:"Nema korisnika za zadani kriterij pretrage",
    SEARCH_USERS:"Pretraga korisnika",
    SEARCH_TELEPHONES:"Pretraga po broju mob. telefona",
    ADD_USER_TO_GROUP:"Dodaj korisnika u grupu",
    REMOVE_USER_FROM_GROUP:"Obriši korisnika iz grupe",
    USER_GROUP_NAME_REQUIRED:"Ime grupe korisnika je obavezno polje.",
    USER_GROUP_NAME:"Ime grupe korisnika",
    USER_GROUPS_OVERVIEW:"Pregled grupa korisnika",
    USER_COUNT:"Broj korisnika",
    NEW_USER_GROUP:"Kreiraj novu grupu korisnika",
    DELETE_USER_GROUP:"Obriši grupu korisnika",
    UPDATE_USER_GROUP:"Izmjeni grupu korisnika",
    DELETE_USER_GROUP_ERROR:"Došlo je do greške prilikom brisanja odabrane korisničke grupe. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_USER_GROUP:"Da li ste sigurni da želite obrisati odabranu grupu korisnika?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Akcije kojima je grupa bila dodijeljena prestat će vrijediti za korisnike obrisane grupe.",
    GROUP_NAME_MAX_LENGTH:"Ime grupe mora biti manje od 255 karaktera",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Korisnik je već u ovoj grupi",
    MISSING_USER:"Nepoznat korisnik",
    USER_NOT_ON_LIST:"Korisnik nije u aktivnoj listi. Proverite da li je email ispravan i pokušajte ponovo.",
    UPLOAD_USER_GROUP:"Uvezi grupe iz *.csv-a",
    UKNOWN_USERS:"Lista nepoznatih korisnika",
    CAMPAIGN_TEMPLATE_RULE:"Pravilo kampanje",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Došlo je do pogreške prilikom brisanja odabranog šablona kampanje. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Da li ste sigurni da želite obrisati odabrani šablon kampanje?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:" Jeste li sigurni da želite izbrisati odabrani predložak kampanje",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Pregled predloška kampanja",
    DELETE_CAMPAIGN_TEMPLATE:"Obriši predložak kampanje",
    UPDATE_CAMPAIGN_TEMPLATE:"Izmjeni predložak kampanje",
    CREATE_CAMPAIGN_TEMPLATE:"Kreiraj novi predložak kampanje",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Ime predloška kampanje je obavezno polje.",
    CAMPAIGN_TEMPLATE_NAME:"Ime predloška kampanje",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Obavezno polje",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"pokloni %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"dodatnog vremena",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Prvo odaberite vrstu uređaja. Perilicu ili mali stroj.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Obriši pravilo",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"sati",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuta",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Novo pravilo po broju dolazaka",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Novo pravilo po količini potrošenih žetona",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Novo pravilo po danima u tjednu",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Dodaj novo pravilo",
    CAMPAIGN_TEMPLATE_RULE_1:"Svakih",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Svakih",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"žetona za manje od",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"dolazaka za manje od",
    CAMPAIGN_TEMPLATE_RULE_3:"dana, pokloni",
    CAMPAIGN_TEMPLATE_RULE_4:"žetona ",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Lista pravila je prazna.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Nije moguće unijeti prošlo vrijeme ",
    DELETE_CAMPAIGN_ERROR:"Došlo je do greške prilikom brisanja odabrane kampanje. Molimo Vas pokušajte ponovo ili kontaktirajte tehničku podršku...",
    CONFIRM_DELETE_CAMPAIGN:"Da li ste sigurni da želite obrisati odabranu kampanju?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W nije odgovoran za korisničko iskustvo uzrokovano ovom radnjom.",
    CAMPAIGNS_OVERVIEW:"Pregled kampanja",
    DELETE_CAMPAIGN:"Obriši kampanju",
    UPDATE_CAMPAIGN:"Izmjeni kampanju",
    CREATE_CAMPAIGN:"Kreiraj novu kampanju",
    CAMPAIGN_ACTIVE:"Aktivna",
    CAMPAIGN_TEMPLATE:"predložak",
    CAMPAIGN_GROUPS:"Grupe",
    CAMPAIGN_ALL_USERS:"Svi korisnici",
    CAMPAIGN_NAME:"Ime kampanje",
    CAMPAIGN_NAME_REQUIRED:"Ime kampanje je obavezno polje",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Korisnici blizu limita bonusa po danu",
    MESSAGE_TO_USERS:"Poruka pronađenim korisnicima",
    SEND_MESSAGE:"Pošalji poruku",
    THRESHOLD:"Limit",
    TYPE:"Tip",
    TOTAL_MONEY_SPENT:"Ukupno novca potrošenog u kampanji",
    NUMBER_OF_VISITS:"Ukupno posjeta u kampanji",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Poruka mora imati barem 10 znakova",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Poruka nesmije imati više od 350 znakova ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Tekst poruke je obavezan",
    TECHNOLOGY:"Tehnologija",
    TAP_WATER:"Gradska voda",
    REVERSE_OSMOSIS:"Reverzna osmoza",
    SOFTENED_WATER:"Omekšana voda",
    DOSER:"Dozer",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Posljednja sinkronizacija",
    NO_OF_CURRENT_ALARMS:"Vaš broj tekućih alarma",
    NO_OF_CURRENT_WARNINGS:"Broj tekućih upozorenja",
    WEATHER:"Vrijeme",
    BOXES_WORK_HOURS_COUNTERS:"Brojači sati rada bokseva",
    BOX_TOTAL_HOURS:"Ukupno rada",
    BOX_SERVICE_HOURS:"Ukupno rada (servis)",
    BOX_COUNTER_HOURS:"Sati",
    ALARMS_AND_WARNINGS:"Alarmi i upozorenja",
    FILTER_AND_BOILER:"Filter i bojler",
    FILTER_TOTAL_DAYS:"Dani rada filtera",
    BOILER_TOTAL_DAYS:"Dani rada bojlera",
    DAYS_UNIT:"dana",
    SOFTENER:"Omekšivač",
    MANUAL_COLD_DRAIN:"Ručni zimski odvod",
    EL_COLD:"El. zimski",
    DRAIN:"odvod",
    TAP:"slavina",
    WASTE:"Otpad",
    OSMOSIS:"osmoza",
    DEMI_WATER:"Demi voda",
    EL_RINSE:"El. m. ispiranja",
    BOILER:"Bojler",
    EL_WAX:"El. m. voska",
    FLOOR_HEATING:"Podno grejanje",
    DOSER_TANK:"Kadica dozatora",
    EL_WASH:"El. m. pranja",
    DETERGENT:"Prašak",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Ažuriranje postavki praonice",
    GENERAL_SETTINGS:"Opće postavke",
    LIGHTS:"Svjetlo",
    GROUPS:"Grupe",
    ANTI_FREEZE:"Anti smrzavanje",
    AUTO:"Auto",
    MANUAL:"Ručno",
    ON:"Uključeno",
    OFF:"Isključeno",
    TEMPERATURE:"Temperatura",
    UPDATE_DEVICE:"Postavi postavke praonice",
    BOX_CLEAN_HOURS:"Brojač sati rada (čišćenje)",
    GROUP_COUNTERS:"Brojači grupa",
    RESET:"Reset",
    CASH_COUNT:"Brojač kovanica",
    COINS_COUNT:"Brojač žetona ",
    EUROKEY_COUNT:"Brojač Eurokey",
    DOSER_WORK:"Vrijeme rada dozera (sec.)",
    DOSER_PAUSE:"Vrijeme pauze dozera (sec.)",
    DELAY_BFV:"BFV kašnjenje (ms)",
    DELAY_6M1:"6M1 kašnjenje (ms)",
    DELAY_LPS:"LPS kašnjenje (ms)",
    RESET_CASH_COUNT_ALL:"Reset svih brojača kovanica",
    RESET_COINS_COUNT_ALL:"Reset svih brojača žetona ",
    RESET_EUROKEY_COUNT_ALL:"Reset svih brojača Eurokey-a",
    FACILITY_DETAILS:"Detalji praonice",
    FACILITY_NAME:"Ime praonice",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Uspješno ste poslali sliku",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Uspješno ste promijenili podatke",
    CONNECTED:"Povezan",
    DISCONNECTED:"Nepovezan",
    OFFLINE:"Isključen",
    MESSAGES_FILTER:"Filter poruka",
    FACILITY:"Praonica",
    APPLY:"Primjeni",
    TIME:"Vrijeme",
    LOCATION:"Lokacija",
    ACKNOWLEDGED:"Priznata",
    FILTERED_MESSAGES:"Filtrirane poruke",
    ACK:"Primijćena",
    NOT_ACK:"Ne primijećena",
    ALL:"Svi",
    ALL_FACILITIES:"Sve praonice",
    ENTER_DATE_PLACEHOLDER:"Unesite datum",
    OP_NESTANAK_NAPONA:"Nestanak napona - 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Pumpa greška MZS",
    OP_UPR_NAPON_24VAC_GRE:"Upravljački napon 24VAC error -5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Zaštita na suho spremnik pitke vode",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Pumpa pitke vode greška motorna zaštitna sklopka",
    OP_MIN_NIVO_OMEKS_VODE:"Zaštita na suho spremnik omekšane vode",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Pumpa omekšane vode greška motorske zaštitne sklopke",
    OP_MIN_NIVO_DEMIN_VODE:"Zaštita na suho spremnik demilizirane vode",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Pumpa demilizirane vode greška motorske zaštitne sklopke",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Pumpa reverzna osmoza greška motorske zaštitne sklopke",
    OP_BOJLER_GRESKA_MZS:"Bojler greška",
    OP_CRPKA_PRASKA_GRE_MZS:"Pumpa praška greška motorne zaštitne sklopke",
    OP_DOZATOR_PRASKA_GRE_MZS:"Dozator praška greška",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Vibrator raspršuje greška",
    OP_MIN_PRASAK_TON_ALARM:"Minimalni nivo spremnik praška",
    OP_USIS_KOV_TURBINA_GRESKA:"Usis kovanica turbina greška motorne zaštitne sklopke",
    OP_FILTER_VODE_ZACEPLJEN:"Filter vode začepljen",
    OP_VISKTL_RESET_SATI_RADA:"Visokotlačna pumpa servis",
    OPW_VISKTL_RESET_SATI_RADA:"Visokotlačna pumpa servis",
    OP_FILTER_DANI_RADA:"Filter servis",
    OP_BOJLER_DANI_RADA:"Bojler servis",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarm visokotlačne pumpe",
    OPW_ALARM_FILTER_SERVIS:"Filter servis alarm",
    OPW_ALARM_BOJLER_SERVIS:"Bojler servis alarm",
    HAS_MEMBERS:"Izabrana grupa ima članove i ne može biti uklonjena. Morate prvo ukloniti članove.",
    PERIODIC_SUMMARY_FOR:"PERIODIČAN SUMARNI IZVJEŠTAJ ZA",
    PERIODIC_SUMMARY_REPORTS:"Periodičnii sumarni izvještaji",
    DATE_RANGE:"Vremenski period",
    FINANCIAL_REPORT:"Financijski izvještaj",
    GROSS_INCOME:"Ukupan prihod",
    GROSS_INCOME_SUM:"Suma ukupnog prihoda",
    COMMISSION_FEE:"Provizije",
    NET_INCOME:"Neto prihod (za naplatu)",
    COMMISSION_FEE_DETAILS:"Uključuju bankovne / PayPal provizije na transakcije ili SMS servis provizije.",
    LOYALTY_CREDITS_REPORT:"Lokalni žetoni",
    LOYALTY_GIVEN:"Poklonjeni lokalni žetoni",
    LOYALTY_USED:"Iskorišteni lokalni žetoni",
    LOYALTY_SOLD:"Prodati lokalni žetoni",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Tekući mjesec",
    SOMETHING_WENT_WRONG:"Uuuuuuuuuuups, došlo je do greške :-(",
    MISSING_PAGE:"Oprostite, nismo u mogućnosti pronaći traženu stranicu",
    TRY_AGAIN:"Pokušajte ponovo",
    DEFAULT_ERROR_NAME:"Došlo je do nepoznate greška",
    DEFAULT_ERROR_DESCRIPTION:"Molimo pokušajte ponovo, ako problem i dalje postoji kontaktirajte ovlaštenu osobu",
    MY_ACCOUNT_DETAILS:"Detalji korisničkog računa",
    SAVE_CHANGES:"Spremi promjene",
    USERNAME:"Korisničko ime",
    FIRST_NAME:"Ime",
    LAST_NAME:"Prezime",
    USER_ROLE:"Korisnička grupa",
    OLD_PASSWORD:"Stara šifra",
    NEW_PASSWORD:"Nova šifra",
    OLD_PASSWORD_REQUIRED:"Stara šifra polje je obavezno",
    NEW_PASSWORD_REQUIRED:"Nova šifra polje je obavezno",
    NEW_PASSWORD_REPEAT:"Ponoviti novu šifru polje je obavezno",
    NEW_PASSWORD_NOT_MATCH:"Stara i nova šifra nisu identične",
    PASSWORD_DIFFERENT_VALIDATION:"Nova lozinka mora biti drugačija od stare",
    PASSWORD_MIN_CHAR:"Vaša lozinka mora imati barem 8 znakova",
    PASSWORD_MAX_CHAR:"Vaša lozinka mora imati do 32 znaka",
    PASSWORD_PATTERN_VALIDATION:"Lozinka mora sadržavati barem jedan broj, jedno malo i jedno veliko slovo",
    ACCOUNT_MANAGEMENT:"Upravljanje Korisnicima",
    NOT_ACTIVE:"Neaktivan",
    ASSIGN_ROLE:"Korisnička grupa",
    UPDATE:"Ažuriraj",
    ADD_NEW_ACCOUNT:"Dodavanje novog korisnika",
    EMAIL_REQUIRED:"E-mail adresa je obavezna",
    EMAIL_NOT_VALID:"E-mail adresa nije validna",
    ADD_NEW_USER_TEXT:"E-mail sa aktivacijskim linkom će biti poslan na upisanu adresu",
    UPDATE_USER_NOTIFICATION:"Uspješno ste ažurirali podatke",
    CHANGED_PASSWORD_NOTIFICATION:"Uspješno ste promijenili lozinku",
    UPDATE_USER_GROUP_NOTIFICATION:"Uspješno ste promijenili ime grupe",
    CREATE_USER_GROUP_NOTIFICATION:"Uspješno ste kreirali grupu",
    DETELE_USER_GROUP_NOTIFICATION:"Uspješno ste obrisali grupu",
    EMPTY_GROUP_LIST_MSG:"Nema kreiranih grupa. Za početak, napravite jednu",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Uspješno ste obrisali korisnika iz grupe",
    ADD_USER_TO_GROUP_NOTIFICATION:"Uspješno ste dodali korisnika u grupu",
    ADD_USER_NOTIFICATION:"Uspješno ste dodali novog korisnika",
    DELETE_USER_NOTIFICATION:"Uspješno ste obrisali korisnika",
    RESEND_USER_VERIFICATION_EMAIL:"Uspješno ste ponovo poslali verifikacijski email.",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Da bi ste kreirali grupu korisnika, molimo Vas unesite naziv grupe.",
    DELETE_USER:"Brisanje korisnika",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Da li ste sigurni da želite obrisati korisnika iz grupe?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Poštovani, ukoliko nas posjetite tokom akcije ovog mjeseca dobit ćete dodatni bonus na vaš račun.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Pravilo kampanje po broju dolazaka",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Pravilo kampanje po potrošenim žetonima",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Pravilo kampanje po danima u tjednu",
    REMOVE_CAMPAIGN_RULE_TITLE:"Brisanje pravila kampanje",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Da li ste sigurni da želite obrisati pravilo kampanje?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Uspješno ste spremili novo pravilo kampanje",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Uspješno ste aktivirali kampanju",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Nema kreiranih kampanja. Za početak, napravite jednu",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Uspješno ste poslali poruku",
    COMPANY_ACCOUNTS:"Računi tvrtki",
    BUSSINESS_INVOICES_LIST:"Moji B2B računi",
    LOCALE_TOKEN:"Lokalni žeton",
    R2W:"Globalni žeton",
    START_MONTH:"Početni mjesec",
    END_MONTH:"Krajnji mjesec",
    TOKEN_TYPE:"Tip žetona",
    TOKEN_NUMBER:"Broj žetona",
    NOTHING_TO_DISPLAY:"* Ništa za prikaz",
    CREATE_INVOICE:"Nova faktura",
    INVOICE:"Faktura",
    INVOICES:"Fakture",
    EDIT_INVOICE:"Promjeni fakturu",
    UPDATE_INVOICE_NOTIFICATION:"Uspješno ste promijenili status fakture u 'u izvršenju'",
    CURRENT_CHARGES:"Zaduženje za tekuće razdoblje",
    PAYMENTS_ON_HOLD:"Poslani računi",
    FOR_INVOICING:"Nije fakturirano",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Pokušavate poništiti fakturu",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Da li ste sigurni da želite poništiti fakturu ???",
    INVOICING_NOTIFICATION_HEADER:"Pokušavate poslati fakturu",
    INVOICING_NOTIFICATION_TEXT:"Da li ste sigurni da želite poslati fakturu?",
    SENT_INVOICE_NOTIFICATION:"Račun je uspješno poslan ",
    CANCELED_INVOICE_NOTIFICATION:"Uspješno ste poništili račun ",
    INVOICE_DESCRIPTION_TEXT:"Faktura za mjesec ",
    INVOICE_STATE:"Status fakture",
    INVOICE_NUMBER:"Broj fakture",
    INVOICE_TOTAL:"Ukupno",
    SELECT_YEAR:"Izaberi godinu",
    DOWNLOAD:"Skini PDF",
    INVOICE_NUMBER_HEADER:"Namjeravate poslati fakturu sa brojem ",
    INVOICE_PAYMENT_CONFIRMATION:"Namjeravate potvrditi plaćanje fakture sa brojem ",
    INSERT_INVOICE_NUMBER:"Unesi broj fakture",
    INVOICED_WARNING:"Email nije poslan. Molim Vas pričekajte ...",
    SEND_INVOICE:"Pošalji",
    INVOICE_ALL:"Sve",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Za R2W",
    PAYMENT_REQUEST:"Zahtjev za plaćanje",
    PAYMENT_REQUEST_STATE:"Stanje zahtjeva za plaćanje",
    PAYMENT_REQUEST_NUMBER:"Broj zahtjeva za plaćanje",
    FOR_PAYMENT_REQUEST:"Za zahtjev za plaćanjem",
    PAYMENT_REQUEST_ON_HOLD:"Zahtjev za plaćanjem u obradi",
    DOWNLOAD_INVOICE:"Preuzmite fakturu",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Kliknite opcije za preuzimanje",
    B2B_SPEC:"B2B Specifikacija",
    B2C_SPEC:"B2C Specifikacija",
    DOWNLOAD_PAYMENT_REQUEST:"Preuzmite zahtjev za plaćanje",
    LOYALTY_PREVIEW:"Pregled kampanje",
    ACTIVATED:"Aktivna",
    RUNNING:"Traje",
    NOT_ACTIVATED:"Nije aktivna",
    FINISHED:"Završena",
    DEPRECATED:"Obustavljena",
    UPCOMING:"Nadolazeća",
    NONE:"Nitko",
    STARTED:"Počela",
    ENDS:"Završava se",
    DEDICATED:"Posvećena",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Pokušavate se aktivirati",
    CAMPAIGN:"kampanju",
    SEND_MESSAGE_NOTIFICATION:"Da želite poslati poruku svim korisničkim grupama",
    DIVISIBLE_TO_NUMBER:"Broj bi trebao biti djeljiv s ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Tip uređaja",
    LISTENER:"Mali stroj",
    BRIDGE:"Boxovi za pranje",
    WASH_BOXES:"Boxovi za pranje",
    VACUUMS:"Usisavači",
    SAVE_NEWS:"Spremite vijest",
    CREATE_NEW_NEWS:"Kreiraj novu vijest",
    HISTORY_OF_ALL_NEWS:"Povijest svih vijesti",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Upiši ime praonice",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Dodaj novu praonicu",
    NEWS_TEXT:"Tekst vijesti",
    NEWS_TITLE:"Naslov vijesti",
    DELETE_NEWS_CONFIRMATION:"želite obrisati vijest ?",
    NEWS_DELETE_NOTIFICATION:"Uspješno ste obrisali vijest",
    NEWS_SAVE_NOTIFICATION:"Uspješno ste spremili vijest",
    NEWS_CREATION_DATE:"Datum kreiranja",
    NO_TITLE:"Nema naslova",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Tekst vijesti nesmije biti duži od 255 znakova",
    NEWS_TEXT_REQUIRED_VALIDATION:"Tekst vijesti je obavezan",
    NEWS_TITLE_REQUIRED_VALIDATION:"Naslov vijesti je obavezan",
    DEACTIVATE:"Deaktiviraj",
    ASIDE_MENU_LOCAL_TOKENS:"Lokalni žetoni",
    CREATE_NEW_LOCAL_TOKENS:"Izdavanje novih lokalnih žetona",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Unesite email adresu korisnika i broj žetona koje mu želite izdati",
    CREATE_TOKENS:"Izdaj žetone",
    MINIMUM_ONE_TOKEN:"Vrijednost mora biti veća od 0",
    CUSTOMER_EMAIL:"Korisnikova email adresa",
    AMOUNT_OF_TOKENS:"Broj žetona",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Uspješno ste izdali lokalne žetone na",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Dogodila se greška prilikom izdavanja žetona. Molimo Vas provjerite korisnikovu email adresu i pokušajte ponovno.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Pregled izdanih lokalnih žetona",
    ISSUED_AT:"Vrijeme izdavanja",
    ISSUED_BY:"Izdano od",
    CODE:"Kod",
    REDEEMED_BY:"Iskorišteno od",
    REDEEMED_AT:"Vrijeme",
    ASIDE_MENU_VOUCHERS:"Vaučeri",
    PRINT:"Štampa",
    VOUCHERS_OVERVIEW:"Pregled vaučera",
    CREATE_NEW_VOUCHERS:"Kreiranje novih vaučera",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Kreirajte novu seriju vaučera unošenjem broja žetona po vaučeru, količine vaučera u seriji i prefiks koda za seriju",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Broj žetona po vaučeru",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Dozvoljeno je dodijeliti između 1 i 100 žetona po vaučeru",
    NUMBER_OF_NEW_VOUCHERS:"Količina vaučera u seriji",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Dozvoljeno je kreiranje između 1 i {{size}} vaučera u jednoj seriji",
    NEW_VOUCHERS_PREFIX:"Prefiks kod vaučera u seriji",
    VALIDATION_VOUCHER_PREFIX:"Prefiks kod mora biti točno 4 znaka (velika slova i / ili brojevi)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Dogodio se problem prilikom kreiranja novih vaučera. Molimo Vas pokušajte ponovo ili kotaktirajte tehničku podršku.",
    CREATE_VOUCHERS:"Kreiraj seriju vaučera",
    CREATING_VOUCHERS_SUCCESS:"Nova serija vaučera uspješno kreirana",
    PRINT_NEW_VOUCHERS:"Printaj vaučere",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Unesite broj serije vaučera, cijeli kod ili dio koda vaučera, kako bi isprintali odgovarajuće vaučere.",
    PRINT_VOUCHERS_PREFIX:"Prefiks kod (serija) vaučera",
    NO_VOUCHERS_FOR_PRINT:"Nema vaučera za printanje sa unesenim prefix kodom",
    PRINT_VOUCHERS:"Printaj vaučere",
    VALIDATION_VOUCHER_CODE_FILTER:"Prefiks kod filter može sadržavati između 1 i 16 znakova i podržava samo velika slova i brojeve.",
    FILTER_VOUCHERS_BY_CODE:"Filter vaučera po kodu",
    FILTER_VOUCHERS:"Filter",
    WASH_BOX:"Box za pranje",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Ukupno iskorišćenih digitalnih žetona",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Ukupno kupljenih lokalnih žetona",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Ukupno potrošenih lokalnih žetona",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Ukupno poklonjenih lokalnih žetona",
    LOCAL_TOKEN:"Lokalni žeton",
    GIVEN_TOKEN:"Poklonjeni žetoni",
    SOLD_TOKEN:"Kupljeni žetoni",
    SMALL_MACHINES:"Mali strojevi",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Box za pranje",
    CODE_PREFIX_EXIST:"Code prefix već postoji",
    CODE_PREFIX_EXIST_TEXT:"Ne možete kreirati novi voucher sa ovim code prefix-om. Definišite novi.",
    MIN_FOUR_VALIDATION:"Točno 4 znaka",
    ALL_INFORMATION_1:"Sve informacije o",
    ALL_INFORMATION_2:"će biti izgubljene",
    ASIDE_MENU_TRANSACTIONS:"Transakcije",
    EXPENSES:"Troškovi",
    TOPUPS:"Kupljeni žetoni",
    EXPENSES_LIST:"Popis troškova",
    USER_EMAIL:"E-pošte korisnika",
    COMPANY_NAME:"Naziv tvrtke",
    TOPUPS_LIST:"Popis kupljenih žetona",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serijski broj",
    SETUP_UNIT_MATERIAL_NO:"Broj materijala",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi verzija",
    TOTAL_TURNOVER:"Promet autopraonice",
    AVAILABILITY_ALL:"Dostupnost",
    AVAILIBILITY:"Dostupnost boxova za pranje:",
    AVAILABILITY_VACUUMS:"Dostupnost usisavača:",
    WASH_BOX_INFO:" Informacije o boxovima za pranje",
    VACUUM_CLEANER_INFO:"Informacije o usisavačima",
    BREAD_CRUMBS_SERVICE:"Servis",
    HOLIDAYS:"Blagdani",
    HOLIDAY:"Blagdan",
    LIGHTS_ON:"Svjetla upaljena",
    LIGHTS_OFF:"Svjetla ugašena",
    WASH_BOXES_ON:"Box za pranje uključen",
    WASH_BOXES_OFF:"Box za pranje isključen",
    VACUUMS_ON:"Usisavač uključen",
    VACUUMS_OFF:"Usisavač isključen",
    TURNOVER:"Promet",
    TURNOVER_MANUAL_WASH_UNIT:"Priručnik za promet",
    STATUS_BAY_RUN_TIME:"Ukupno radno vrijeme boxa",
    STATUS_BAY_PROGRAM_NAME:"Naziv programa",
    STATUS_BAY_CREDIT:"Kredit za boxeve za pranje",
    CLOUD_KREDIT:"Cloud kredit",
    STATUS_VACUUM_RUN_TIME:"Ukupno radno vrijeme usisavača",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Usluge objekta, program boxa i informacije o trenutnim greškama",
    UNAVAILABLE:"Jedinica je zauzeta",
    SHOW_HIDE_TABLE:"Prikaži/sakrij tabelu radnog vremena",
    PROGRAM_NAME:"Naziv programa",
    PROGRAM_COUNTER:"Brojač programa",
    NO_NAME:"Referenca nema ime",
    COUNTER_SERVICE_DATA:"Podaci o servisu",
    NEED_SERVICE:"Potreban servis",
    PROGRAM_DATA:"Podaci o programu boxa",
    CURRENT_FAULT_DATA:"Trenutni podaci o kvaru",
    REFERENCE_DUE:"Rok",
    REFERENCE_SECONDS:"Sekunde",
    REFERENCE_NAME:"Naziv dijela",
    WASHBOX_NAME:"Naziv boxa",
    FAULT_NAME:"Naziv kvara",
    FAULT_NUMBER:"Broj kvara",
    CURRENT_FAULT_COUNT:"Aktivni kvarovi",
    DEVICE_NOT_INSTALLED:"Uređaj nije instaliran",
    STATUS_READY:"Spreman",
    STATUS_ERROR:"Greška",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Softverska greška",
    SOFTWARE_RESET:"Softverska greška",
    EXTERNAL_PIN_RESET:"Softverska greška",
    RESTART_OR_BROWNOUT_OCCURRED:"Softverska greška",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardverska greška",
    COULD_NOT_SIMULATE_COIN:"Hardverska greška",
    ERROR_SETTING_INHIBIT_MODE:"Hardverska greška",
    OFFLINE_DEVICE:"Offline autopraonica",
    TARIFFS:"Tarife",
    DAY:"Dan",
    NIGHT:"Noć",
    VOUCHER_CODE:"Kod vaučera",
    DISMISS_ALARM:"Resetirati alarm?",
    ALARM_ACTIVE:"Aktivni alarmi",
    NO_ALARM_ACTIVE:"Nema aktivnih alarma",
    ALARM_HISTORY:"Povijest upozorenja",
    MANAGING_TOKENS:"Upravljanje lokalnim žetonima",
    EXPIRATION_DATE:"Rok trajanja",
    EXTEND_TOKEN_DATE:"Produlji datum isteka žetona za",
    DELETE_TOKENS_FOR:"Izbrišite lokalne žetone za",
    PUMP_TYPE:"Tip pumpe",
    TURN_OFF_DEVICE:"Status uređaja",
    OPERATION_DATA:"Podaci o radu",
    PUMP_DATA:"Podaci o pumpi",
    PUMP_NAME:"Naziv pumpe",
    POINT_NAME:"Naziv tačke",
    CHANGER_INCOME:"Ukupni prihod od mijenjača po datumu",
    SELECTED_OPEN:"Otvoreno u odabrano radno vrijeme",
    ALWAYS_OPEN:"Uvijek otvoreno (24/7)",
    CLOSED:"Zatvoreno",
    CLOSED_24:"Zatvoreno 24h",
    OPENED_24:"Otvoreno 24h",
    MON:"Ponedjeljak",
    TUE:"Utorak",
    WED:"Srijeda",
    THU:"Četvrtak",
    FRI:"Petak",
    SAT:"Subota",
    SUN:"Nedjelja",
    PRICING:"Cjenovnik",
    PRICE:"Cijena",
    VALIDITY:"Validnosti",
    TOKEN_PACKAGES:"Paketi žetona",
    SINGLE_WASH:"Jedno pranje",
    FACILITY_WORKING_HOURS:"Postavite radno vrijeme za odabrani objekt",
    WORKING_HOURS_ALWAYS_OPEN:"Uvijek otvoreno ",
    WORKING_HOURS_ALWAYS_CLOSE:"Zatvoreno od strane operatera",
    WORKING_HOURS_CUSTOM:"Postavite radno vrijeme",
    KARCHER_ERROR_CODE:"Kod greške upozorenja",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizacija",
    CREATE_ORGANIZATION:"Kreiraj organizaciju",
    CREATE_ORGANIZATION_AS:"Kreiraj organizaciju kao podorganizaciju za",
    DELETE_ORGANIZATION:"Izbriši organizaciju",
    EDIT_ORGANIZATION:"Uredi organizaciju",
    SUPPORTED_ORG_NAME:"Podržana organizacija",
    SUPPORTED_ORG_TYPE:"Podržani tip",
    ORG_NAME:"Naziv",
    ORG_TYPE:"Tip",
    SET_ORG_TITLE:"Postavi podorganizaciju",
    SET_SUPPORTED_ORG_TITLE:"Postavi podržanu podorganizaciju",
    SAVE_ORGANIZATION:"Sačuvaj organizaciju",
    SELECT_ORGANIZATION_TYPE:"Odaberite tip organizacije",
    SELECT_ORGANIZATION_SELECTOR:"Odaberi",
    SELECT_SUPPORTED_ORGANIZATION:"Odaberite podržanu organizaciju",
    ORGANIZATION_DELETED:"Organizacija uspješno izbrisana",
    ORGANIZATION_SAVED:"Organizacija uspješno spremljena",
    ORGANIZATION_UPDATED:"Organizacija uspješno ažurirana",
    ALERTS:"Upozorenja",
    DEVICE_STATUS:"Status uređaja",
    SITE_DETAILS:"Detalji autopraone",
    ALARM_STATUS:"Status upozorenja",
    FILTER:"Filtriraj po...",
    FILTER_BY_ALERT_CENTER:"Filtriraj po kodu, nazivu ili opisu",
    TOTAL_ALARM:"Svi alarmi",
    LOW_ALARM:"Događaj",
    MEDIUM_ALARM:"Kvar",
    HIGH_ALARM:"Kritičan kvar",
    NO_FACILITIES_NEARBY:"Nema obližnjih autopraona",
    GRAY_MAP:"Mapa s sivim stilom",
    READY:"Spreman",
    WARNING:"Kvar",
    ERROR:"Greška",
    SITE_NAME:"Naziv autopraonice",
    ACCOUNTS_INFO:"Informacije o nalogu",
    USER_ORGANIZATION:"Korisnička organizacija",
    ADD_USER_ORGANIZATION:"Dodaj novog korisnika organizacije",
    EDIT_USER_ORGANIZATION:"Uredi korisnike organizacije",
    SELECT_ROLE:"Odaberi ulogu",
    SELECT_ORGANIZATION:"Odaberi organizaciju",
    SELECT_USER:"Odaberi korisnika",
    USER_FOR_ORGANIZATION_CREATED:"Novi korisnik uspješno kreiran",
    SELECT_REGION:"Odaberite region",
    SELECT_LANGUAGE:"Odaberite jezik",
    LOADING_DATA:"Učitavanje podataka, molimo pričekajte ...",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Tehnička podrška",
    CONTROLLER:"Kontroler",
    EDIT_ORGANIZATION_USER:"Uredi korisnike organizacije",
    DELETE_ORGANIZATION_USER:"Izbriši korisnike organizacije",
    USER_UPDATED:"Korisnik uspješno ažuriran",
    USER_CREATED:"Korisnik uspješno kreiran",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"Pretplate",
    RESOLVED_STATUS:"Riješeno",
    NOT_RESOLVED_STATUS:"Nije riješeno",
    ALERT_NAME:"Naziv upozorenja",
    ALERT_DESCRIPTION:"Opis upozorenja",
    ALERT_CODE:"Kod upozorenja",
    ALERT_TYPE:"Vrsta upozorenja",
    UNSUBSCRIBE:"Otpratite upozorenje",
    SUBSCRIBE:"Zapratite upozorenje",
    ALARM_SUBSCRIBED:"Uspješno zapraćeno",
    UNSUBSCRIBED_CONFIRM:"Otpratiti?",
    ALARM_UNSUBSCRIBED:"Uspješno otrpraćeno",
    ASIDE_MENU_CASHLESS_SALES:"Bezgotovisnka prodaja",
    FILTERED_CASHLESS_PAYMENTS:"Filtrirane bezgotovinske uplate",
    REFUND_DIALOG_TITLE:"Povrat transakcije?",
    REFUND_DIALOG_SUBTITLE:"Iznos može biti manji ili jednak iznosu transakcije",
    REFUND:"Povrat",
    INPUT_NOT_VALID:"Unos nije važeći",
    REFUND_SUCCESSFULLY:"Povrat za odabranu uplatu uspješno izvršen",
    USER:"Korisnik",
    TRANSACTION_ID:"PSP referenca",
    DEVICE_ID:"ID uređaja",
    NET_AMOUNT:"Neto iznos",
    REPORT_NAME:"Naziv izvještaja",
    TIME_FRAME:"Vremenski okvir",
    SUB_POINT:"Odaberi podtočku",
    SUB_POINT_LIST_NOT_EXIST:"Popis podtočaka ne postoji za odabrani objekt za pranje",
    FACILITY_TYPE:"Vrsta uređaja",
    MACHINE_NAME:"Naziv stroja",
    WASH_FACILITY_DETAILS:"Detalji uređaja",
    WASH_BAY_DETAILS:"Detalji boxa za pranje",
    DEVICES_INFO:"Lista uređaja",
    OPERATION_TIME_INFO:"Vrijeme rada",
    OPERATION_TIME_VACUUM_INFO:"Vrijeme rada usisavača",
    OPERATION_TIME_ILLUMINATION_INFO:"Vrijeme rada za osvjetljenje",
    AVAILABLE_TITLE:"Dostupno",
    UNAVAILABLE_TITLE:"Nedostupno",
    CURRENT_PROGRAM:"Trenutni program",
    CREDITS:"Krediti",
    DEVICE_NAME:"Naziv uređaja",
    ACTIVE_ALARMS:"Aktivna upozorenja",
    ALL_DAY:"Cijeli dan",
    OPERATING_TIME_WASH_FACILITY:"Sustav samoposlužnog pranja",
    OPERATING_TIME_VACUUMS:"Usisavači",
    OPERATING_TIME_ILLUMINATION:"Osvjetljenje",
    OPERATION_COUNTERS:"Brojači rada",
    EDIT:"Uredi",
    WASHING_PROGRAMS:"Programi pranja",
    INFO:"Događaj",
    STATISTIC:"Statistika",
    ROLLOVER_DOSING:"Doziranje",
    ROLLOVER_SPEED:"Brzine",
    ROLLOVER_RESETS:"Daljinsko resetiranje sustava četki",
    ROLLOVER_RESETS_INFO:"Daljinsko resetiranje mora biti u skladu s lokalnim propisima. Važno: Prije resetiranja provjerite je li sustav četki prazan.",
    RESET_ROLLOVER:"Resetiraj četke",
    OPEN_DOOR_ROLLOVER:"Otvori",
    ROLLOVER_OPEN_DOOR_INFO:"Otvori vrata za pranje. Budite oprezni.",
    ROLLOVER_OPEN_DOOR:"Otvori vrata",
    APPLY_DOSING_CHANGES:"Primijeni promjene doziranja",
    APPLY_SPEED_CHANGES:"Primijeni promjene brzine",
    ACTUATION_SUCCESS:"Zahtjev poslan",
    REMAINING_TIME:"Preostalo vrijeme",
    OPEN_24H:"Otvoreno 24h",
    CLOSE_24H:"Zatvoreno 24h",
    VALIDATION_OPERATION_TIME:"Format nije ispravan. Koristite hh:mm",
    ROLLOVER:"Četke",
    UPDATE_WASHING_PROGRAM:"Ažuriraj program pranja",
    UPDATE_ACTUATORS:"Ažuriraj aktuatore",
    OPEN_ROLOVER_DOOR_TITLE:"Želite otvoriti vrata četki za pranje?",
    OPEN_ROLOVER_DOOR_CONTENT:"Jeste li sigurni da želite otvoriti vrata?",
    RESET_ROLOVER_TITLE:"Želite li resetirati četku?",
    RESET_ROLOVER_CONTENT:"Jeste li sigurni da želite resetirati četku?",
    G0:"{{brand === 'r2w' ? 'Box 0' : 'Box 1'}}",
    G1:"{{brand === 'r2w' ? 'Box 1' : 'Box 2'}}",
    G2:"{{brand === 'r2w' ? 'Box 2' : 'Box 3'}}",
    G3:"{{brand === 'r2w' ? 'Box 3' : 'Box 4'}}",
    G4:"{{brand === 'r2w' ? 'Box 4' : 'Box 5'}}",
    G5:"{{brand === 'r2w' ? 'Box 5' : 'Box 6'}}",
    G6:"{{brand === 'r2w' ? 'Box 6' : 'Box 7'}}",
    G7:"{{brand === 'r2w' ? 'Box 7' : 'Box 8'}}",
    G8:"{{brand === 'r2w' ? 'Box 8' : 'Box 9'}}",
    G9:"{{brand === 'r2w' ? 'Box 9' : 'Box 10'}}",
    G10:"{{brand === 'r2w' ? 'Box 10' : 'Box 11'}}",
    U0:"{{brand === 'r2w' ? 'Usisavač 0' : 'Usisavač 1'}}",
    U1:"{{brand === 'r2w' ? 'Usisavač 1' : 'Usisavač 2'}}",
    U2:"{{brand === 'r2w' ? 'Usisavač 2' : 'Usisavač 3'}}",
    U3:"{{brand === 'r2w' ? 'Usisavač 3' : 'Usisavač 4'}}",
    U4:"{{brand === 'r2w' ? 'Usisavač 4' : 'Usisavač 5'}}",
    U5:"{{brand === 'r2w' ? 'Usisavač 5' : 'Usisavač 6'}}",
    U6:"{{brand === 'r2w' ? 'Usisavač 6' : 'Usisavač 7'}}",
    U7:"{{brand === 'r2w' ? 'Usisavač 7' : 'Usisavač 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Izvještaj centra upozorenja stvoren odabrane lokacije s nadzorne ploče",
    ALERT_CENTER_TITLE_BY_FACILITY:"Izvještaj centra upozorenja stvoren odabrane objekta s nadzorne ploče",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Izvještaj centra upozorenja",
    ERROR_MESSAGE_403:"Nemate privilegiju za korištenje ove API poziva. Pogreška kod: 403",
    LAST_ACTIVE_PROGRAM:"Zadnji aktivni program",
    PROGRAM_ID:"Broj programa",
    PROGRAM_PRICE:"Cijena programa",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Potrebno nadopuniti",
    EMPTY_CHEMICAL_LEVEL:"Prazno",
    CHEMICAL_LEVEL:"Indikacija nivoa deterdženata (%)",
    ROLLOVER_STATUS:"Stanje rollovera",
    ROLLOVER_STATUS_CODE_0:"Perionica trenutno izvan pogona",
    ROLLOVER_STATUS_CODE_1:"Izvan radnog vremena",
    ROLLOVER_STATUS_CODE_2:"Dopušten ulazak u program",
    ROLLOVER_STATUS_CODE_3:"Pozicionirajte vozilo",
    ROLLOVER_STATUS_CODE_4:"Vozilo naprijed",
    ROLLOVER_STATUS_CODE_5:"Vozilo natrag",
    ROLLOVER_STATUS_CODE_6:"Zaustavljanje vozila",
    ROLLOVER_STATUS_CODE_7:"Perionica aktivna",
    ROLLOVER_STATUS_CODE_8:"Perionica zaustavljena",
    ROLLOVER_STATUS_CODE_9:"Perionica aktivna (takt)",
    ROLLOVER_STATUS_CODE_10:"Izlazak vozila unatrag",
    ROLLOVER_STATUS_CODE_11:"Hitno zaustavljanje",
    ROLLOVER_STATUS_CODE_12:"Izlazak vozila prema naprijed",
    ROLLOVER_STATUS_CODE_13:"Aktiviran protiv smrzavanja",
    ROLLOVER_STATUS_CODE_14:"Prednji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_15:"Zadnji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_16:"Lijevi prednji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_17:"Desni prednji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_18:"Lijevi stražnji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_19:"Desni stražnji sigurnosni prekidač aktiviran",
    ROLLOVER_STATUS_CODE_20:"Vozilo je prešlo predaleko ulijevo",
    ROLLOVER_STATUS_CODE_21:"Vozilo je prešlo predaleko udesno",
    ROLLOVER_STATUS_CODE_22:"Lijeva vrata nisu zatvorena",
    ROLLOVER_STATUS_CODE_23:"Desna vrata nisu zatvorena",
    ROLLOVER_STATUS_CODE_24:"Detektiran transporter, odabran je pogrešan program pranja",
    ROLLOVER_STATUS_CODE_25:"Senzor sirene",
    ROLLOVER_STATUS_CODE_98:"Ručni / prilagodbeni način",
    ROLLOVER_STATUS_CODE_99:"Nepoznati status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Neodređeni statusni kod",
    ALARM:"Kritični kvar",
    NO_ALARM:"Nema kritičnih kvarova",
    SOFTWARE_VERSION:"Softverska verzija",
    SOFTWARE_DATE:"Datum softvera",
    SITE_ADDRESS:"Adresa autopraone",
    SECONDS:"Sekunde",
    SERVICE_PART_NAME:"Naziv usluge:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Brojač rada i održavanja",
    OPERATION_COUNTER:"Brojač rada",
    SERVICE_COUNTER:"Brojač održavanja",
    FAULT_CODE:"Kod upozorenja",
    PRESSURE_TITLE:"Zračni tlak",
    TIME_TITLE:"Trenutno vrijeme",
    COUNTRY_TITLE:"Država",
    CITY_TITLE:"Grad",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Odabir točaka ...",
    LOGS_HISTORY:"Povijest promjene parametara",
    ACTUATOR_REFERENCE:"Referenca aktuatora",
    ACTUATOR_VALUE:"Vrijednost aktuatora",
    POINT_ID:"ID točke",
    VALIDATION_NOT_VALID_RANGE:"Pogrešan raspon",
    ENABLE_ROLLOVER_RESET:"Označavanjem ove kućice potvrđujete da ste pročitali i slažete se s sigurnosnim uputama.",
    CHANGE_OF_PARAMETERS:"Promjena parametara",
    SELECT_OPTIONS:"Odabir opcija",
    AUTOMATIC:"Automatski",
    DESALTING:"Funkcija odstranjivanja soli",
    SEASON_WASH:"Programi pranja za sezonu",
    SPRING_PROGRAM:"Programi pranja za proljeće",
    SUMMER_PROGRAM:"Programi pranja za ljeto",
    AUTUMN_PROGRAM:"Programi pranja za jesen",
    WINTER_PROGRAM:"Programi pranja za zimu",
    DOOR_CONTROL:"Upravljanje vratima",
    SUMMER_DOOR_CONTROL:"Ljeto, rad s upravljanjem vratima u ljetnom načinu rada",
    WINTER_DOOR_CONTROL:"Zima, rad s upravljanjem vratima u zimskom načinu rada",
    APPLY_PARAMETERS_CHANGES:"Primijeni promjene parametara",
    WORKING_SCHEDULES:"Radni rasporedi",
    HOLIDAY_SCHEDULES:"Rasporedi blagdana",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Blagdani za autopraonu uspješno kreirani",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Blagdani za autopraonu uspješno ažurirani",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Blagdani za autopraonu uspješno obrisani",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Radni rasporedi uspješno propagirani",
    HOLIDAY_SUCCESSFULLY_DELETED:"Praznik uspješno izbrisan",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:" CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Sredstvo za sušenje s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampon s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_FOAM:"Pjena s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_WAX_1:"Vosak s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_POLISH_1:"Poliranje s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Čistač felgi s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_WAX_2:"Vosak s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Sjaj guma s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Sredstvo za uklanjanje insekata s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_POLISH_2:"Poliranje s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_INTENSIVE:"Intenzivno s niskim nivoom punjenja",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pjena za kišu s niskim nivoom punjenja",
    CHEM_LEVEL_DRYING_AGENT:"Nivo punjenja sredstva za sušenje",
    CHEM_LEVEL_SHAMPOO:" Nivo punjenja šampona",
    CHEM_LEVEL_FOAM:"Nivo punjenja pjene",
    CHEM_LEVEL_WAX_1:"Nivo punjenja voska",
    CHEM_LEVEL_POLISH_1:"Nivo punjenja poliranja",
    CHEM_LEVEL_RIM_CLEANER:"Nivo punjenja čistača felgi",
    CHEM_LEVEL_WAX_2:"Nivo punjenja voska",
    CHEM_LEVEL_TYRE_SHINE:" Nivo punjenja sjaja guma",
    CHEM_LEVEL_INSECT_REMOVER:"Nivo punjenja sredstva za uklanjanje insekata",
    CHEM_LEVEL_POLISH_2:"Nivo punjenja poliranja",
    CHEM_LEVEL_INTENSIVE:"Nivo punjenja intenzivnog",
    CHEM_LEVEL_FOAM_RAIN:"Nivo punjenja pjene za kišu",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Brojač servisa za podizanje krovnih četki",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Brojač servisa za podizanje sušača",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Brojač servisa za motorne kablove krovnih četki",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Brojač servisa za servisiranje pumpe za svježu vodu",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Brojač servisa za servisiranje pumpe za korištenu vodu",
    DRYING_AGENT:"Sredstvo za sušenje",
    FOAM_DRYING_AGENT:"Pjena sredstva za sušenje",
    SHAMPOO:"Šampon",
    FOAM:"Pjena",
    BRUSH_FOAM:"Pjena za četke",
    WAX_1:"Vosak",
    FOAM_WAX_1:"Pjenušavi vosak",
    POLISH_1:"Poliranje",
    RIM_CLEANING:"Čistač felgi",
    WAX_2:"Vosak",
    FOAM_WAX_2:"Pjenušavi vosak",
    TYRE_SHINE:"Sjaj za gume",
    INSECT_REMOVER:"Sredstvo za uklanjanje insekata",
    POLISH_2:"Poliranje",
    INTENSIVE_BASIC:"Intenzivno osnovno",
    INTENSIVE_SIDE:"Intenzivno bočno",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzivno prskanje krovne trake",
    TAR_REMOVER:"Odstranjivač katrana",
    UNDER_CHASSIS_CONVERSATION:"Razgovor o podvozju",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionarni pred-sprej lukova",
    FOAM_RAIN:"Pjena za kišu",
    PRE_CLEANING:"Prečišćavanje",
    BRUSH:"Četka",
    CARE:"Nega",
    DRYING:"Sušenje",
    DRYING_LOW_NOISE:"Smanjenje buke prilikom sušenja",
    INTENSIVE_CLEANING:"Intenzivno čišćenje",
    BRUSH_CLEANING:"Čišćenje četkom",
    EMPTY_RUN:"Prazan ciklus",
    DRYING_AID:"Pomoć pri sušenju",
    WAX:"Vosak",
    FOAM_WASH:"Pjenušavi vosak",
    POLISH:"Poliranje",
    FOAM_POLISH:"Pjenušavo poliranje",
    WHEEL_CLEANING:"Čišćenje točkova",
    HIGH_PRESSURE_ROOF:"Visoki pritisak na krovu",
    HIGH_PRESSURE_SIDE:"Visoki pritisak sa strane",
    DRYER_FORWARD:"Sušilica prema naprijed",
    DRYER_BACKWARD:"Sušilica unatrag",
    DELETE_ALL_HOLIDAYS:"Izbriši sve praznike za odabranu lokaciju",
    CREATE_NEW_HOLIDAY:"Kreiraj nove blagdane",
    RESET_INPUTS:"Poništi sve unose blagdana",
    TWENTY_FOUR_HOURS_OPEN:"Otvoreno 24h",
    EVERY_YEAR:"Godišnje",
    DELETE_HOLIDAY:"Obriši blagdan",
    ADD_NEW_HOLIDAY:"Dodaj novi blagdan",
    HOLIDAYS_LIST:"Lista postojećih blagdana",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Izbrisati sve praznike za odabranu praonu?",
    VALIDATION_HOLIDAY_DATE:"Format nije ispravan. Koristite mm-dd",
    FOR_DATE:"Za datum",
    WITH_ID:"Sa ID",
    FROM_HOURS:"Od (h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:" Do (min)",
    NOT_MATCH:"Ne podudara se",
    START:"Od",
    STOP:"Do",
    DAILY_TIME:"Popis od 24 sata",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Postavljanje individualnog vremena",
    PROGRAM_NOT_STARTED:"Program još nije počeo",
    JETWASH:"Sustav za samoposlužno pranje",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Pumpa za svježu vodu",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Pumpa za procesnu vodu",
    OPERATION_COUNTER_HP_PUMP_1:"Visokotlačna pumpa 1",
    OPERATION_COUNTER_HP_PUMP_2:"Visokotlačna pumpa 2",
    RELEASE_NOTES:"Verzije aplikacije i bilješke o izdanju",
    BACKEND_RELEASE_NOTES:"Bilješke o izdanju platforme:",
    FRONTEND_RELEASE_NOTES:"Bilješke o izdanju web aplikacije:",
    SELECTED_FACILITY_TIMEZONE:"Vremenska zona za odabrani uređaj za pranje:",
    REFRESH_PAGE:"Osvježi stranicu",
    REFRESH_MAPS:"Osvježi mapu",
    PUMPS:"Pumpe",
    RUN_TIME:"Vrijeme rada ",
    RUN_TIME1:"Vrijeme rada 1",
    RUN_TIME2:"Vrijeme rada 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuator za vrijeme rada",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuator za vrijeme rada 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuator za vrijeme rada 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimalna vrijednost je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maksimalna vrijednost je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Koristite format cijene x.xx",
    ACTUATION_NOT_ALLOWED:"Aktuacija nije dopuštena za trenutnu ulogu korisnika",
    MAINTENANCE_DAYS:"Dani održavanja",
    MAINTENANCE_WASHES:"Pranja za održavanje",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Ukupni prihod POS",
    PROPAGATE:"Proširite",
    ALL_DAY_HOURS_SELECTOR:"Selektor tipa 24 sata",
    GET_OPERATING_TIME_FROM_SITE:"Dohvatite vrijeme rada za trenutni uređaj iz radnih rasporeda web stranice",
    USER_NOT_VALID:"Korisnik nije važeći. Pokušajte s drugim korisničkim podacima.",
    VERIFIED:"Verifikovano",
    RESEND_VERIFICATION_MAIL:"Ponovno pošalji verifikacijski email",
    RETURN_TO_DASHBOARD:"Povratak na pregled praonica",
    ERROR_PAGE_BAD_REQUEST:" 400 Bad Request.",
    WASHES:"Broj pranja",
    TIME_TO_SERVICE:"Vrijeme do servisa",
    ACCOUNT_ALREADY_ACTIVATED:"Nalog već aktiviran",
    DEVICE_EVENTS:" Događaji uređaja",
    DEVICE_EVENTS_LOG_PULLED:"Preuzet zapisnik događaja za uređaj",
    EVENTS_PULL_DATE:"Vrijeme preuzetih događaja",
    DEVICE_EVENTS_REFRESH:"Preuzmi nove podatke događaja",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problem s povezivanjem web socketa. Pokušajte osvježiti stranicu.",
    INSTALLATION_DATE:"Datum instalacije stroja",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Vrući vosak",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Pranje pod visokim pritiskom",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Pjena za naplatke",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Snažna pjena",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Zaustavi",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Pjensko pranje HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Pranje",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Vrhunska njega",
    INFO_TITLE:"Informacije",
    FOAM_WAX1:"Pjenušavi vosak",
    POLISH1:"Poliranje",
    WAX1:"Vosak",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Podaci o lokaciji uspješno ažurirani",
    COMPANY:"Tvrtka",
    FACILITY_HAS_CHANGER:"Imate li mjenjač?",
    DISABLE_OFFLINE_ALARM:"Onemogući R2W alarme",
    ASIDE_WORKING_SCHEDULES:"Podaci o lokaciji aplikacije",
    TERMS_OF_SERVICE_R2W_TITLE:"Uvjeti korištenja Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Uvjeti korištenja Ready2Wash",
    DATA_PROCESSING_TITLE:"Obrada podataka",
    PRIVACY_POLICY_TITLE:" Pravila privatnosti",
    READY_TO_PAY_TERMS_OF_SERVICE:"Uvjeti korištenja Ready2Pay",
    TERMS_AND_SERVICES:"Uvjeti i usluge",
    HOURLY: "Svakih sat vremena",
    DAILY: "Dnevno",
    WEEKLY: "Tjedno",
    MONTHLY: "Mjesečno",
    YEARLY: "Godišnje",
    DELETE_ITEM_SUCCESS:"Uspešno ste obrisali izabran element",
    STATE: "Stanje",
    AVAILABILITY_STATUS_1: "Jedinica otvorena",
    AVAILABILITY_STATUS_2: "Jedinica zatvorena (odmor)",
    AVAILABILITY_STATUS_3: "Jedinica zatvorena (radno vrijeme)",
    AVAILABILITY_STATUS_4: "Jedinica zatvorena (kvar)",
    AVAILABILITY_STATUS_5: "Jedinica zatvorena (ostalo)",
    AVAILABILITY_VACUUMS_STATUS_1: "Usisavači nisu instalirani",
    AVAILABILITY_VACUUMS_STATUS_2: "Usisavači otvoreni",
    AVAILABILITY_VACUUMS_STATUS_3: "Usisavači zatvoreni (odmor)",
    AVAILABILITY_VACUUMS_STATUS_4: "Usisavači zatvoreni (radno vrijeme)",
    AVAILABILITY_VACUUMS_STATUS_5: "Usisavači zatvoreni (kvar)",
    AVAILABILITY_VACUUMS_STATUS_6: "Usisavači zatvoreni (ostalo)",
    ECOM_AMOUNT: "Ukupni Ecom za sve lokacije",
    CAPTURED: "Zabilježeno",
    DELETE_COMPANY_HISTORY_INFO:"Ova radnja će izbrisati sve podatke izvješća vaše tvrtke. Ova radnja se ne može poništiti.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Jeste li sigurni da želite trajno izbrisati sve podatke izvješća?",
    VALUE_DATE: "Datum valute",
    KARCHER_EVENT_NAME_1: "Osnovni izmjenjivač topline regeneriran",
    KARCHER_EVENT_NAME_2: "Regeneracija osnovnog izmjenjivača dovršena",
    KARCHER_EVENT_NAME_3: "Materijal / serijski broj",
    KARCHER_EVENT_NAME_4: "Sustav je dezinficiran",
    KARCHER_EVENT_NAME_5: "HP pumpa 1 dezinficirana",
    KARCHER_EVENT_NAME_6: "HP pumpa 2 dezinficirana",
    KARCHER_EVENT_NAME_7: "HP pumpa 3 dezinficirana",
    KARCHER_EVENT_NAME_8: "HP pumpa 4 dezinficirana",
    KARCHER_EVENT_NAME_9: "HP pumpa 5 dezinficirana",
    KARCHER_EVENT_NAME_10: "Stanica za pranje 1 zaključana",
    KARCHER_EVENT_NAME_11: "Stanica za pranje 2 zaključana",
    KARCHER_EVENT_NAME_12: "Stanica za pranje 3 zaključana",
    KARCHER_EVENT_NAME_13: "Stanica za pranje 4 zaključana",
    KARCHER_EVENT_NAME_14: "Stanica za pranje 5 zaključana",
    KARCHER_EVENT_NAME_15: "Stanica za pranje 6 zaključana",
    KARCHER_EVENT_NAME_16: "Stanica za pranje 7 zaključana",
    KARCHER_EVENT_NAME_17: "Stanica za pranje 8 zaključana",
    KARCHER_EVENT_NAME_18: "Ažuriranje započeto",
    KARCHER_EVENT_NAME_19: "Ažuriranje dovršeno",
    KARCHER_EVENT_NAME_20: "Početak WS Reg",
    KARCHER_EVENT_NAME_21: "Kraj WS Reg",
    KARCHER_EVENT_NAME_22: "WS senzor 75%",
    KARCHER_EVENT_NAME_23: "Tehnički kvar",
    KARCHER_EVENT_NAME_24: "Operativni kvar",
    KARCHER_EVENT_NAME_25: "Uređaj uključen",
    KARCHER_EVENT_NAME_26: "Uređaj isključen",
    KARCHER_EVENT_NAME_27: "Kutija 1 zatvorena",
    KARCHER_EVENT_NAME_28: "Kutija 2 zatvorena",
    KARCHER_EVENT_NAME_29: "Kutija 3 zatvorena",
    KARCHER_EVENT_NAME_30: "Kutija 4 zatvorena",
    KARCHER_EVENT_NAME_31: "Kutija 5 zatvorena",
    KARCHER_EVENT_NAME_32: "Kutija 6 zatvorena",
    KARCHER_EVENT_NAME_33: "Kutija 7 zatvorena",
    KARCHER_EVENT_NAME_34: "Kutija 8 zatvorena",
    KARCHER_EVENT_NAME_35: "HP pumpna stanica 1",
    KARCHER_EVENT_NAME_36: "HP pumpna stanica 2",
    KARCHER_EVENT_NAME_37: "HP pumpna stanica 3",
    KARCHER_EVENT_NAME_38: "HP pumpna stanica 4",
    KARCHER_EVENT_NAME_39: "HP pumpna stanica 5",
    KARCHER_EVENT_NAME_40: "HP pumpna stanica 6",
    KARCHER_EVENT_NAME_41: "HP pumpna stanica 7",
    KARCHER_EVENT_NAME_42: "HP pumpna stanica 8",
    KARCHER_EVENT_NAME_43: "Plamenik",
    KARCHER_EVENT_NAME_44: "Ventilator plamenika",
    KARCHER_EVENT_NAME_45: "Pumpa za toplu vodu",
    KARCHER_EVENT_NAME_46: "Pumpa za zaštitu od smrzavanja",
    KARCHER_EVENT_NAME_47: "Osmotska pumpa",
    KARCHER_EVENT_NAME_48: "Podno grijanje",
    KARCHER_EVENT_NAME_49: "Grijanje crijeva",
    KARCHER_EVENT_NAME_50: "Mikro/čišćenje felgi",
    KARCHER_EVENT_NAME_51: "Podvozna pumpa",
    KARCHER_EVENT_NAME_52: "Pumpa za pjenu Booster",
    KARCHER_EVENT_NAME_53: "Usisavač 1",
    KARCHER_EVENT_NAME_54: "Usisavač 2",
    KARCHER_EVENT_NAME_55: "Usisavač 3",
    KARCHER_EVENT_NAME_56: "Usisavač 4",
    KARCHER_EVENT_NAME_57: "Usisavač 5",
    KARCHER_EVENT_NAME_58: "Usisavač 6",
    KARCHER_EVENT_NAME_59: "Usisavač 7",
    KARCHER_EVENT_NAME_60: "Usisavač 8",
    KARCHER_EVENT_NAME_61: "Usisavač 9",
    KARCHER_EVENT_NAME_62: "Usisavač 10",
    KARCHER_EVENT_NAME_63: "Usisavač 11",
    KARCHER_EVENT_NAME_64: "Usisavač 12",
    KARCHER_EVENT_NAME_65: "Pumpa za čišćenje felgi",
    KARCHER_EVENT_NAME_66: "Microe pumpa",
    KARCHER_EVENT_NAME_67: "Intenzivna pumpa",
    KARCHER_EVENT_NAME_68: "Turbina usisavača 1",
    KARCHER_EVENT_NAME_69: "Filter usisavača 1",
    KARCHER_EVENT_NAME_70: "Turbina usisavača 2",
    KARCHER_EVENT_NAME_71: "Filter usisavača 2",
    KARCHER_EVENT_NAME_72: "Turbina usisavača 3",
    KARCHER_EVENT_NAME_73: "Filter usisavača 3",
    KARCHER_EVENT_NAME_74: "Turbina usisavača 4",
    KARCHER_EVENT_NAME_75: "Filter usisavača 4",
    KARCHER_EVENT_NAME_76: "Turbina usisavača 5",
    KARCHER_EVENT_NAME_77: "Filter usisavača 5",
    KARCHER_EVENT_NAME_78: "Turbina usisavača 6",
    KARCHER_EVENT_NAME_79: "Filter usisavača 6",
    KARCHER_EVENT_NAME_80: "Turbina usisavača 7",
    KARCHER_EVENT_NAME_81: "Filter usisavača 7",
    KARCHER_EVENT_NAME_82: "Turbina usisavača 8",
    KARCHER_EVENT_NAME_83: "Filter usisavača 8",
    KARCHER_EVENT_NAME_84: "Turbina usisavača 9",
    KARCHER_EVENT_NAME_85: "Filter usisavača 9",
    KARCHER_EVENT_NAME_86: "Turbina usisavača 10",
    KARCHER_EVENT_NAME_87: "Filter usisavača 10",
    KARCHER_EVENT_NAME_88: "Turbina usisavača 11",
    KARCHER_EVENT_NAME_89: "Filter usisavača 11",
    KARCHER_EVENT_NAME_90: "Turbina usisavača 12",
    KARCHER_EVENT_NAME_91: "Filter usisavača 12",
    INSERT_TOKEN: "Unesite tokene i pokrenite uslugu",
    OPEN_SESSION: "Sesija uspješno otvorena",
    IN_PROGRESS: "U tijeku ...",
    TOKEN_INSERTED: "Tokeni su uspješno uneseni",
    EXPIRED_SESSION: "Sesija je istekla",
    TWO_DIGIT_INTEGER_VALIDATION: "Koristite maksimalno dvoznamenkasti cijeli broj",
    KARCHER_OPERATION_COUNTER_1: "Stanica za pranje 1 HP pumpa",
    KARCHER_OPERATION_COUNTER_2: "Stanica za pranje 1 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_3: "Stanica za pranje 1 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_4: "Stanica za pranje 1 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_5: "Stanica za pranje 1 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_6: "Stanica za pranje 2 HP pumpa",
    KARCHER_OPERATION_COUNTER_7: "Stanica za pranje 2 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_8: "Stanica za pranje 2 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_9: "Stanica za pranje 2 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_10: "Stanica za pranje 2 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_11: "Stanica za pranje 3 HP pumpa",
    KARCHER_OPERATION_COUNTER_12: "Stanica za pranje 3 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_13: "Stanica za pranje 3 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_14: "Stanica za pranje 3 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_15: "Stanica za pranje 3 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_16: "Stanica za pranje 4 HP pumpa",
    KARCHER_OPERATION_COUNTER_17: "Stanica za pranje 4 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_18: "Stanica za pranje 4 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_19: "Stanica za pranje 4 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_20: "Stanica za pranje 4 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_21: "Stanica za pranje 5 HP pumpa",
    KARCHER_OPERATION_COUNTER_22: "Stanica za pranje 5 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_23: "Stanica za pranje 5 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_24: "Stanica za pranje 5 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_25: "Stanica za pranje 5 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_26: "Stanica za pranje 6 HP pumpa",
    KARCHER_OPERATION_COUNTER_27: "Stanica za pranje 6 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_28: "Stanica za pranje 6 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_29: "Stanica za pranje 6 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_30: "Stanica za pranje 6 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_31: "Stanica za pranje 7 HP pumpa",
    KARCHER_OPERATION_COUNTER_32: "Stanica za pranje 7 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_33: "Stanica za pranje 7 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_34: "Stanica za pranje 7 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_35: "Stanica za pranje 7 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_36: "Stanica za pranje 8 HP pumpa",
    KARCHER_OPERATION_COUNTER_37: "Stanica za pranje 8 kemijska pumpa 1",
    KARCHER_OPERATION_COUNTER_38: "Stanica za pranje 8 kemijska pumpa 2",
    KARCHER_OPERATION_COUNTER_39: "Stanica za pranje 8 kemijska pumpa 3",
    KARCHER_OPERATION_COUNTER_40: "Stanica za pranje 8 kemijska pumpa 4",
    KARCHER_OPERATION_COUNTER_41: "Pumpa za osmozu",
    KARCHER_OPERATION_COUNTER_42: "Generator tople vode",
    KARCHER_OPERATION_COUNTER_43: "Pumpa za zaštitu od smrzavanja",
    KARCHER_OPERATION_COUNTER_44: "WSO ulošci filtra",
    KARCHER_OPERATION_COUNTER_45: "Pumpa za grijanje stanice za pranje",
    KARCHER_OPERATION_COUNTER_46: "Pumpa za toplu vodu",
    KARCHER_OPERATION_COUNTER_47: "Grijač crijeva za pjenu",
    KARCHER_OPERATION_COUNTER_48: "Pumpa za pranje kotača",
    KARCHER_OPERATION_COUNTER_49: "Pumpa za mikroemulziju",
    KARCHER_OPERATION_COUNTER_50: "Pumpa za intenzivnu pjenu",
    KARCHER_OPERATION_COUNTER_51: "Usisavač 1 turbina 1",
    KARCHER_OPERATION_COUNTER_52: "Usisavač 1 filtar 1",
    KARCHER_OPERATION_COUNTER_53: "Usisavač 1 turbina 2",
    KARCHER_OPERATION_COUNTER_54: "Usisavač 1 filtar 2",
    KARCHER_OPERATION_COUNTER_55: "Usisavač 2 turbina 1",
    KARCHER_OPERATION_COUNTER_56: "Usisavač 2 filtar 1",
    KARCHER_OPERATION_COUNTER_57: "Usisavač 2 turbina 2",
    KARCHER_OPERATION_COUNTER_58: "Usisavač 2 filtar 2",
    KARCHER_OPERATION_COUNTER_59: "Usisavač 3 turbina 1",
    KARCHER_OPERATION_COUNTER_60: "Usisavač 3 filtar 1",
    KARCHER_OPERATION_COUNTER_61: "Usisavač 3 turbina 2",
    KARCHER_OPERATION_COUNTER_62: "Usisavač 3 filtar 2",
    KARCHER_OPERATION_COUNTER_63: "Usisavač 4 turbina 1",
    KARCHER_OPERATION_COUNTER_64: "Usisavač 4 filtar 1",
    KARCHER_OPERATION_COUNTER_65: "Usisavač 4 turbina 2",
    KARCHER_OPERATION_COUNTER_66: "Usisavač 4 filtar 2",
    KARCHER_OPERATION_COUNTER_67: "Usisavač 5 turbina 1",
    KARCHER_OPERATION_COUNTER_68: "Usisavač 5 filtar 1",
    KARCHER_OPERATION_COUNTER_69: "Usisavač 5 turbina 2",
    KARCHER_OPERATION_COUNTER_70: "Usisavač 5 filtar 2",
    KARCHER_OPERATION_COUNTER_71: "Usisavač 6 turbina 1",
    KARCHER_OPERATION_COUNTER_72: "Usisavač 6 filtar 1",
    KARCHER_OPERATION_COUNTER_73: "Usisavač 6 turbina 2",
    KARCHER_OPERATION_COUNTER_74: "Usisavač 6 filtar 2",
    KARCHER_OPERATION_COUNTER_75: "Ispustite kondenziranu vodu iz kompresora",
    KARCHER_OPERATION_COUNTER_76: "Provjerite sustav zaštite od smrzavanja",
    KARCHER_OPERATION_COUNTER_77: "Ventilator plamenika",
    KARCHER_OPERATION_COUNTER_78: "Pojačana pumpa za pjenu",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Popis podataka je veći od 10000 stavki",
    KARCHER_POINT_NAME_1: "Praznik",
    KARCHER_POINT_NAME_2: "Ponedjeljak",
    KARCHER_POINT_NAME_3: "Utorak",
    KARCHER_POINT_NAME_4: "Srijeda",
    KARCHER_POINT_NAME_5: "Četvrtak",
    KARCHER_POINT_NAME_6: "Petak",
    KARCHER_POINT_NAME_7: "Subota",
    KARCHER_POINT_NAME_8: "Nedjelja",
    KARCHER_POINT_NAME_9: "Usisavači Praznik",
    KARCHER_POINT_NAME_10: "Usisavači Ponedjeljak",
    KARCHER_POINT_NAME_11: "Usisavači Utorak",
    KARCHER_POINT_NAME_12: "Usisavači Srijeda",
    KARCHER_POINT_NAME_13: "Usisavači Četvrtak",
    KARCHER_POINT_NAME_14: "Usisavači Petak",
    KARCHER_POINT_NAME_15: "Usisavači Subota",
    KARCHER_POINT_NAME_16: "Usisavači Nedjelja",
    KARCHER_POINT_NAME_17: "Rasvjeta Praznik",
    KARCHER_POINT_NAME_18: "Rasvjeta Ponedjeljak",
    KARCHER_POINT_NAME_19: "Rasvjeta Utorak",
    KARCHER_POINT_NAME_20: "Rasvjeta Srijeda",
    KARCHER_POINT_NAME_21: "Rasvjeta Četvrtak",
    KARCHER_POINT_NAME_22: "Rasvjeta Petak",
    KARCHER_POINT_NAME_23: "Rasvjeta Subota",
    KARCHER_POINT_NAME_24: "Rasvjeta Nedjelja",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR kod",
    ACCEPT_TERMS_AND_CONDITIONS: "Prihvati uvjete korištenja",
    CREATE_AND_PRINT_VOUCHERS: "Kreiraj i printaj vaučere",
    CODE_PREFIX_QUESTION: "Prefiks kod nije unesen",
    CODE_PREFIX_QUESTION_TEXT: "Želite li nastaviti bez prefiks koda?",
    ISSUED_DATE: "Datum izdavanja",
    VOUCHER_VALIDITY_DAYS: "Rok važenja vaučera (dani)",
    VALIDATION_ONLY_NUMBERS: "Dozvoljen je unos samo brojeva",
    REPRINT_VOUCHERS: "Printaj kopiju vaučera",
    EXPIRY_DATE: "Vrijedi do"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("frTranslations", {
    MESSAGE:"Message",
    ERROR_TITLE:"Erreur",
    ERROR_MESSAGE:"Une erreur lors d'exécution de l'opération est survenue.",
    ERROR_LOGIN:"Erreur de connexion. L'adresse e-mail ou le mot de passe incorrect. Veuillez réessayer.",
    ERROR_LOGIN_ROLE:"Ce rôle n'est pas valide pour la marque actuelle de l'application.",
    OK:"OK",
    CANCEL:"Annuler",
    YES:"Oui",
    NO:"Non",
    FROM:"Du",
    TO:"Jusqu'au",
    DELETE:"Supprimer",
    SIGN_OUT:"Se déconnecter",
    NAME:"Prénom",
    DATE:"Date",
    PIECES:"Pièces",
    HOURS:"Heures",
    DAYS:"Jours",
    MONTH:"Mois",
    MONTHS:"Mois",
    YEAR:"An",
    BOX:"Piste de lavage",
    SEARCH:"Rechercher",
    ALL_USERS:"Tous les utilisateurs",
    ARE_YOU_SURE:"Êtes-vous sûr(e)?",
    BACK:"Retour",
    AMOUNT:"Nombre",
    DESCRIPTION:"La description",
    FORGOT_PASSWORD_ERROR_MSG:"Une erreur s'est produite. Merci de vérifier votre adresse e-mail et réessayer",
    REQUIRED_FIELD:"Champ obligatoire",
    LOGOUT_TITLE:"Êtes-vous sûr(e) de vouloir vous déconnecter ?",
    LOGOUT_MSG:"Tous les modifications des données qui ne sont pas sauvegardées seront supprimées",
    ACTIVATION_ACCOUNT:"Le compte activé avec succès",
    UNKNOWN_ERRROR_NOTIFICATION:"Une erreur inconnue est sourvenue",
    CONTINUE:"Continuer",
    DATA_NOT_AVAILABLE:"Données introuvables",
    SELECT:"Sélectionnez",
    SELECT_CURRENCY:"Sélectionnez la devise",
    UPLOAD:"Envoyer",
    PHONE:"Téléphone",
    WEBSITE:"Site web",
    WORKING_HOURS:"Horaires d'ouverture",
    INSERT:"Insérer",
    TEXT:"Texte",
    CREATED:"Créé",
    VALID_UNTIL:"Valable jusqu'au",
    SAVE:"Sauvegarder",
    TOKENS:"Jetons",
    DELETE_COMPANY_HISTORY:"Supprimer l'historique de la société?",
    DELETE_COMPANY_HISTORY_MESSAGE:"ATTENTION : Une fois que vous appuyez sur ce bouton toutes les transactions de votre station de lavage seront supprimées ! Si ces données sont supprimées, elles ne peuvent pas être récupérées.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Etes-vous sûr(e) de vouloir supprimer toutes les données de transaction ?",
    HISTORY_SUCCESSFULY_DELETED:"Histoire supprimée avec succès",
    HELP:"Aide",
    VALUE:"Valeur",
    ACTIVATING_ACCOUNT_ERROR:"Une erreur est survenue lors de l'activation de votre compte R2W.Veuillez réessayer et si le problème persiste veuillez contacter support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Bienvenue à Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Bienvenu à R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Veuillez saisir et confirmer votre mot de passe pour activer votre compte R2W. Vous serez automatiquement connecté après avoir saisi correctement le mot de passe ",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Vous pouvez modifier les paramètres de l'application plus tard",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Station de lavage Kärcher",
    RESET_PASSWORD_WELCOME_MSG:"Station de lavage R2W",
    RESET_PASSWORD_WELCOME_MSG_2:"Veuillez saisir votre nouveau mot de passe et le confirmer pour réinitialiser l'ancien. Ensuite, vous serez automatiquement connecté(e) à l'application.",
    RESET_PASSWORD_WELCOME_MSG_3:"Vous pourrez ensuite changer les paramètres d'utilisation dans l'application.",
    ENTER_NEW_PASSWORD:"Introduisez le nouveau mot de passe",
    REPEAT_NEW_PASSWORD:"Confirmez votre nouveau mot de passe",
    PASSWORD_MIN_LENGTH:"Le mot de passe doit contenir au moins 8 caractères",
    PASSWORD_MAX_LENGHT:"Le mot de passe ne peut pas contenir plus de 32 caractères",
    PASSWORD_PATTERN:"Le mot de passe doit contenir au moins une lettre en majuscule et une lettre en miniscule",
    PASSWORD_MATCH:"Les mots de passe ne correspondent pas",
    ACTIVATE:"Activer",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Votre demande a été soumise avec succès. S'il vous plaît vérifiez votre email pour le message de confirmation",
    VALIDATION_REQUIRED:"Champ obligatoire",
    VALIDATION_EMAIL:"L'adresse e-mail n'est pas valide",
    VALIDATION_INTEGER_NUMBER:"La valeur saisie doit être un numéro entier",
    VALIDATION_HOURS_VALUE:"La valeur saisie doit être entre 0-23",
    VALIDATION_MINUTES_VALUE:"La valeur saisie doit être entre 0-59",
    VALIDATION_NOT_A_DATE:"La valeur saisie n'est pas une date",
    VALIDATION_FROM:"La date saisie est supérieure à la date de fin",
    VALIDATION_TO:"La date saisie est inférieure à la date de début",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Cette donnée est déjà dans la base de données",
    PASSWORD_VALIDATION_PATTERN_NEW:"Le mot de passe doit contenir au moins une lettre en majuscule, une en minuscule et un chiffre. L'espace vide n'est pas accepté.",
    VALIDATION_PERCENT_VALUE:"La valeur saisie doit être entre 1-999",
    NUMBERS_ONLY_100:"Nombre jusqu'à 100",
    NUMBERS_ONLY_1000:"Nombre jusqu'à 1000",
    POSITIVE_NUMBERS_ONLY:"Seul nombre positif",
    GRID_PAGER_PAGE:"Page",
    GRID_PAGER_ROWS_PER_PAGE:"Lignes par page",
    GRID_PAGER_PAGE_OF:"à partir de",
    BREAD_CRUMBS_HOME:"Page d'accueil",
    BREAD_CRUMBS_DASHBOARD_TECH:"Liste des stations de lavage",
    BREAD_CRUMBS_DETAILS:"Détails",
    BREAD_CRUMBS_SETTINGS:"Paramètres",
    BREAD_CRUMBS_WORKING_HOURS:"Horaires d'ouverture",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Dépenses totales par jours",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Dépenses moyennes par heure",
    BREAD_CRUMBS_NEW_USER_GROUP:"Créer un groupe d'utilisateurs",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Modifier le groupe d'utilisateurs",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Créer un modèle de promotion",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Modifier le modèle de promotion",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Créer une promotion",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Modifer la promotion",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Rapport financier pour la période",
    LOGIN:"Connexion",
    EMAIL:"E-mail",
    PASSWORD:"Mot de passe",
    LANGUAGE:"Langue",
    FORGOT_PASSWORD:"Mot de passe oublié?",
    SUBMIT:"Confirmer",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Nombre d'alarmes actives",
    HEADER_VIEW_ALL_ALARMS:"Toutes les alarmes...",
    HEADER_MY_ACCOUNT:"Mon compte",
    HEADER_ACCOUNT_MANAGEMENT:"Gestion des comptes",
    ACCOUNT_ALREADY_EXIST:"Cette adresse e-mail est déjà utilisée",
    NEWSLETTER_CONFIRMATION:"Envoyer une notification par mail pour l'état des alarmes",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Rapport financier par jour",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Liste des stations de lavage",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Tableau de bord",
    ASIDE_MENU_ALARMS:"Messages",
    ASIDE_MENU_FACILITIES:"Stations de lavage",
    ASIDE_MENU_REPORTS:"Rapports",
    ASIDE_MENU_REPORT:"Rapport sélectionné",
    ASIDE_MENU_LOYALTY:"Promotions",
    ASIDE_MENU_USER_GROUPS:"Groupes d'utilisateurs",
    ASIDE_MENU_PERIODIC_SUMMARY:"Rapport financier ",
    ASIDE_MENU_MANAGING_TOKENS:"Gestion de jetons",
    ASIDE_MENU_NEWS:"Nouvelles",
    DAILY_FINANCES_TOTAL_MONEY:"Montant total",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Montant total dépensé pour tous les services",
    DAILY_FINANCES_TOTAL_COINS:"Total des jetons métalliques utilisés",
    DAILY_FINANCES_DOWNLOAD_CSV:"Télécharger CSV",
    DAILY_FINANCES_ONLINE:"R2W Online",
    DAILY_FINANCES_OFFLINE:"Espèces",
    DAILY_FINANCES_CHANGER:"Espèces du changeur",
    DAILY_FINANCES_COINS:"Jetons/Eurokey",
    REPORTS_FILTER:"Filtre",
    REPORTS_TYPE_OF_REPORT:"Type de rapport",
    REPORTS_CHOOSE_FACILITY:"Choisir une station de lavage",
    REPORTS_PERIOD_1:"Période 1 - ",
    REPORTS_PERIOD_2:"Période 2 - ",
    MONEY_BY_DATE_REPORT:"Montant total dépensé par date",
    R2W_BY_DATE_REPORT:"Total des paiements en ligne par date",
    COINS_BY_DATE_REPORT:"Nombre de jetons dépensés par date au total",
    AVG_MONEY_BY_HOUR_REPORT:"Dépense moyenne d'argent par heure",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Dépense moyenne d'argent par jour de la semaine",
    AVG_MONEY_BY_BOX_REPORT:"Dépenses par la piste de lavage",
    COMPARE_PERIODS_REPORT:"Tableau comparatif de données",
    TOTAL_USERS_BY_GROUP:"Nombre d'utilisateurs au total par jour",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"utilisateurs",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"visites",
    VISITS_COUNT_REPORT:"Nombre d'utilisateurs par visites",
    LOYALTY_PER_DAY_REPORT:"Nombre des jetons locaux dépensés par jour",
    LOYALTY_PER_PAYMENT_METHOD:"Nombre des jetons locaux donnés par le mode de paiement",
    VISITS:"Visites",
    VISIT:"Visite",
    TOTAL_SPENT_MONEY:"Montant total dépensé",
    MONEY:"Argent",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Montant total dépensé pour la période",
    DOWNLOAD_CSV:"Télécharger CSV",
    TOTAL_SPENT_COINS:"Jetons dépensés au total",
    TOTAL_USERS:"Nombre total d'utilisateurs",
    TOTAL_CREDIT_GIVEN:"Nombre des jetons locaux virtuels dépensés ",
    EUROKEY_BY_DATE_REPORT:"Paiements Eurokey par date au total",
    TOTAL_SPENT_EUROKEY:"Dépensé au total",
    SELECT_TYPE_OF_REPORT:"Vous devez sélectionner le type de rapport :)",
    NUMBER_OF_VISITS_TITLE:"Nombre de visites",
    NUMBER_OF_USERS_TITLE:"Nombre d'utilisateurs",
    PIECES_TITLE:"Pièces",
    TOTAL_VISITS:"Total visites",
    TOKENS_TITLE:"jetons",
    SEARCH_USERS_NO_RESULTS:"Aucun utilisateur retrouvé pour ce critère de recherche",
    SEARCH_USERS:"Chercher des utilisateurs",
    SEARCH_TELEPHONES:"Recherche par le numéro de téléphone",
    ADD_USER_TO_GROUP:"Ajouter cet utilisateur au groupe",
    REMOVE_USER_FROM_GROUP:"Supprimer cet utilisateur du groupe",
    USER_GROUP_NAME_REQUIRED:"Le champ du nom d'utilisateurs est obligatoire.",
    USER_GROUP_NAME:"Nom du groupe d'utilisateurs",
    USER_GROUPS_OVERVIEW:"Sommaire des groupes d'utilisateurs",
    USER_COUNT:"Numéro d'utilisateur",
    NEW_USER_GROUP:"Créer un nouveau groupe d'utilisateurs",
    DELETE_USER_GROUP:"Supprimer le groupe d'utilisateurs",
    UPDATE_USER_GROUP:"Modifier le groupe d'utilisateurs",
    DELETE_USER_GROUP_ERROR:"Une erreur est sourvenue lors de la suppression de ce groupe d'utilisateurs. Veuillez réessayer ou contactez le support technique...",
    CONFIRM_DELETE_USER_GROUP:"Êtes-vous sûr(e) de vouloir supprimer ce groupe d'utilisateurs?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Les activités de fidélité ne seront plus disponibles aux membres du groupe d'utilisateurs supprimé.",
    GROUP_NAME_MAX_LENGTH:"Le nom de groupe ne doit pas dépasser 255 caractères",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Cet utilisateur est déjà membre de ce groupe",
    MISSING_USER:"Utilisateur manquant",
    USER_NOT_ON_LIST:"Utilisateur n'est pas dans la liste des utilisateurs actifs. Vérifiez si l'adresse mail est corrrecte et réessayez.",
    UPLOAD_USER_GROUP:"Envoyer la liste du groupe d'utilisateurs du fichier *.csv",
    UKNOWN_USERS:"Liste des utilisateurs inconnus",
    CAMPAIGN_TEMPLATE_RULE:"Règle du modèle",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Une erreur s'est produite  lors de la suppression de modèle de cette promotion. Veuillez réessayer ou contactez le support technique...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Êtes-vous sûr(e) de vouloir supprimer ce modèle de la promotion?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Êtes-vous sûr(e) de vouloir supprimer le modèle de campagne sélectionné?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Sommaire de modèle de promotion",
    DELETE_CAMPAIGN_TEMPLATE:"Supprimer le modèle de promotion",
    UPDATE_CAMPAIGN_TEMPLATE:"Modifier le modèle de promotion",
    CREATE_CAMPAIGN_TEMPLATE:"Créer le nouveau modèle de promotion",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Nom de modèle de promotion est le champ obligatoire.",
    CAMPAIGN_TEMPLATE_NAME:"Nom du modèle de promotion",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Champ obligatoire",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"donner %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"du temps en plus",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Tout d'abord veuillez sélectionner le type. Les pistes de lavage ou les petites machines.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Supprimer cette règle",
    CAMPAIGN_TEMPLATE_RULE_FROM:"du",
    CAMPAIGN_TEMPLATE_RULE_TO:"jusqu'au",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"heures",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minutes",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nouvelle règle par le nombre de visites",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nouvelle règle par le jetons dépensé",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nouvelle règle par les jours de la semaine",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Ajouter une nouvelle règle",
    CAMPAIGN_TEMPLATE_RULE_1:"Chaque",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Chaque",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"les jetons dépensés dans moins de",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"visites dans moins de",
    CAMPAIGN_TEMPLATE_RULE_3:"jours",
    CAMPAIGN_TEMPLATE_RULE_4:"jetons",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Aucune règle dans la liste.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Date ne peut pas être dans le passé",
    DELETE_CAMPAIGN_ERROR:"Une erreur s'est produite lors de la suppression de promotion. Veuillez réessayer ou contactez le support technique...",
    CONFIRM_DELETE_CAMPAIGN:"Êtes-vous sûr(e) de vouloir supprimer la promotion choisie?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W n'est pas responsable de l'expérience utilisateur causée par cette action.",
    CAMPAIGNS_OVERVIEW:"Sommaire de promotion",
    DELETE_CAMPAIGN:"Supprimer la promotion",
    UPDATE_CAMPAIGN:"Modifier la promotion",
    CREATE_CAMPAIGN:"Créer nouvelle promotion",
    CAMPAIGN_ACTIVE:"Active",
    CAMPAIGN_TEMPLATE:"Modèle",
    CAMPAIGN_GROUPS:"Groupes",
    CAMPAIGN_ALL_USERS:"Tous les utilisateurs",
    CAMPAIGN_NAME:"Nom de promotion",
    CAMPAIGN_NAME_REQUIRED:"Nom de promotion est le champ obligatoire",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Nombre des utilisateurs qui ont presque atteint le seuil par jour",
    MESSAGE_TO_USERS:"Message pour les utilisateurs retrouvés",
    SEND_MESSAGE:"Envoyer le message",
    THRESHOLD:"Seuil",
    TYPE:"Type",
    TOTAL_MONEY_SPENT:"L'argent dépensé dans la promotion au total",
    NUMBER_OF_VISITS:"Nombre des visites dans la promotion",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Message doit contenir au moins 10 caractères",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Message ne doit pas contenir plus de 350 caractères ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Le texte de message est obligatoire",
    TECHNOLOGY:"Technologie",
    TAP_WATER:"L'eau du robinet",
    REVERSE_OSMOSIS:"L'osmose inverse",
    SOFTENED_WATER:"L'eau aducie",
    DOSER:"Doseur",
    STATUS:"Etat",
    LAST_SYNCHRONIZATION:"Dernière synchronisation",
    NO_OF_CURRENT_ALARMS:"Nombre d'alarmes actives",
    NO_OF_CURRENT_WARNINGS:"Nombre d'avertissements actuels",
    WEATHER:"La météo",
    BOXES_WORK_HOURS_COUNTERS:"Compteurs des heures d'activité des pistes de lavage",
    BOX_TOTAL_HOURS:"Heures d'activité des pistes de lavage au total",
    BOX_SERVICE_HOURS:"Heures d'activité au total (le service)",
    BOX_COUNTER_HOURS:"Heures",
    ALARMS_AND_WARNINGS:"Alarmes et avertissements",
    FILTER_AND_BOILER:"Filtre et chaudière",
    FILTER_TOTAL_DAYS:"Jours d'activité des filtres",
    BOILER_TOTAL_DAYS:"Jours d'activité de chaudière",
    DAYS_UNIT:"jours",
    SOFTENER:"Adoucisseur d'eau",
    MANUAL_COLD_DRAIN:"Drainage froid manuel",
    EL_COLD:"El. froid",
    DRAIN:"drainage",
    TAP:"robinet",
    WASTE:"Déchet",
    OSMOSIS:"osmose",
    DEMI_WATER:"L'eau déminéralisée",
    EL_RINSE:"El. m. rinçage",
    BOILER:"Chaudière",
    EL_WAX:"El. m. cire",
    FLOOR_HEATING:"Chauffage du sol",
    DOSER_TANK:"Réservoir de doseur",
    EL_WASH:"El. m. lavage",
    DETERGENT:"Détergent",
    VIBRATOR:"Vibrateur",
    UPDATE_FACILITY_SETTINGS:"Modifier les paramètres de la station de lavage",
    GENERAL_SETTINGS:"Paramètres généraux",
    LIGHTS:"Lumière",
    GROUPS:"Groupes",
    ANTI_FREEZE:"Antigel",
    AUTO:"Auto",
    MANUAL:"Manuel",
    ON:"Activé",
    OFF:"Désactivé",
    TEMPERATURE:"Température",
    UPDATE_DEVICE:"Mettre à jour les paramètres de la station de lavage",
    BOX_CLEAN_HOURS:"Compteurs des heures d'activité (nettoyage)",
    GROUP_COUNTERS:"Compteurs de groupes",
    RESET:"Réinitialiser",
    CASH_COUNT:"Compteur des pièces de monnaie",
    COINS_COUNT:"Compteur des jetons",
    EUROKEY_COUNT:"Compteur Eurokey",
    DOSER_WORK:"Heures d'activité du doseur(sec.)",
    DOSER_PAUSE:"Heures de pause du doseur(sec.)",
    DELAY_BFV:"BFV retard (ms)",
    DELAY_6M1:"6M1 retard (ms)",
    DELAY_LPS:"LPS retard (ms)",
    RESET_CASH_COUNT_ALL:"Réinitialiser tous les compteurs de pièces en métal",
    RESET_COINS_COUNT_ALL:"Réinitialiser tous les compteurs de jetons",
    RESET_EUROKEY_COUNT_ALL:"Réinitialiser tous les compteurs d'Eurokey",
    FACILITY_DETAILS:"Détails de la station de lavage",
    FACILITY_NAME:"Nom de la station de lavage",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Photo envoyée avec succès",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Données modifiées avec succès",
    CONNECTED:"Connecté",
    DISCONNECTED:"Déconnecté(e)",
    OFFLINE:"Débranché",
    MESSAGES_FILTER:"Filtre de messages",
    FACILITY:"Station de lavage",
    APPLY:"Appliquer",
    TIME:"Temps",
    LOCATION:"Localisation",
    ACKNOWLEDGED:"Reconnue",
    FILTERED_MESSAGES:"Messages filtrés",
    ACK:"Reconnue",
    NOT_ACK:"Pas reconnue",
    ALL:"Toutes",
    ALL_FACILITIES:"Toutes les stations de lavage",
    ENTER_DATE_PLACEHOLDER:"Renseignez la date",
    OP_NESTANAK_NAPONA:"Voltage manquant sur l'indicateur de phase 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"La baisse du disjoncteur de la pompe haute pression",
    OP_UPR_NAPON_24VAC_GRE:"Absence 24VAC Disjoncteur -5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Réservoir d'eau potable est vide",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"La baisse du disjoncteur de la pompe de l'eau potable",
    OP_MIN_NIVO_OMEKS_VODE:"Réservoir d'eau adoucie est vide",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"La baisse du disjoncteur de la pompe de l'eau adoucie",
    OP_MIN_NIVO_DEMIN_VODE:"Réservoir de l'eau déminéralisée est vide",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"La baisse du disjoncteur de la pompe de l'eau déminéralisée",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"La baisse du disjoncteur de la pompe pour déminéralisation de l'eau",
    OP_BOJLER_GRESKA_MZS:"Erreur sur la chaudière",
    OP_CRPKA_PRASKA_GRE_MZS:"La baisse du disjoncteur de la pompe de circulation d'eau chaude",
    OP_DOZATOR_PRASKA_GRE_MZS:"La baisse du disjoncteur sur le moteur du doseur de détergent",
    OP_VIBRATOR_PRASKA_GRE_MZS:"La baisse du disjoncteur sur le vibrateur de doseur de détergent",
    OP_MIN_PRASAK_TON_ALARM:"Réservoir du détergent est vide",
    OP_USIS_KOV_TURBINA_GRESKA:"La baisse du disjoncteur sur la turbine pour l'aspiration des pièces",
    OP_FILTER_VODE_ZACEPLJEN:"Filtre pour l'eau bloqué",
    OP_VISKTL_RESET_SATI_RADA:"Service de pompe de haute pression",
    OPW_VISKTL_RESET_SATI_RADA:"Service de pompe de haute pression",
    OP_FILTER_DANI_RADA:"Erreur sur le filtrage de l'eau",
    OP_BOJLER_DANI_RADA:"Erreur sur la chaudière",
    OPW_ALARM_VISOKOTL_PUMPA:"Alarme sur la pompe de haut pression",
    OPW_ALARM_FILTER_SERVIS:"Alarme sur le service de filtrage d'eau",
    OPW_ALARM_BOJLER_SERVIS:"Alarme sur le service de chaudière",
    HAS_MEMBERS:"Le groupe sélectionné possède des membres et ne peut pas être supprimé. Les membres doivent d'abord être supprimés.",
    PERIODIC_SUMMARY_FOR:"RAPPORT PÉRIODIQUE POUR",
    PERIODIC_SUMMARY_REPORTS:"Rapports périodiques de synthèse",
    DATE_RANGE:"Période",
    FINANCIAL_REPORT:"Rapport financier",
    GROSS_INCOME:"Revenus brut",
    GROSS_INCOME_SUM:"Somme de revenus",
    COMMISSION_FEE:"Frais de commission",
    NET_INCOME:"Revenu net (pour facturation)",
    COMMISSION_FEE_DETAILS:"Frais de comission comprend la provision bancaire / PayPal ou les frais SMS de fournisseur.",
    LOYALTY_CREDITS_REPORT:"Rapport de jetons locaux",
    LOYALTY_GIVEN:"Jetons locaux donnés",
    LOYALTY_USED:"Jetons locaux utilisés",
    LOYALTY_SOLD:"Jetons locaux chargés",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Mois en cours",
    SOMETHING_WENT_WRONG:"Ouuups, une erreur est sourvenue",
    MISSING_PAGE:"Désolé, nous ne pouvons pas retrouver la page demandée",
    TRY_AGAIN:"Veuillez réessayer",
    DEFAULT_ERROR_NAME:"Une erreur inconnue est sourvenue",
    DEFAULT_ERROR_DESCRIPTION:"Veuillez réessayer, si le problème n'est pas résolu, veuillez contacter la personne en charge",
    MY_ACCOUNT_DETAILS:"Détails de votre compte",
    SAVE_CHANGES:"Sauvegarder les modifications",
    USERNAME:"Nom d'utilisateur",
    FIRST_NAME:"Prénom",
    LAST_NAME:"Nom",
    USER_ROLE:"Groupe d'utilisateurs",
    OLD_PASSWORD:"Ancien mot de passe",
    NEW_PASSWORD:"Nouveau mot de passe",
    OLD_PASSWORD_REQUIRED:"Le champ pour l'ancien mot de passe est obligatoire",
    NEW_PASSWORD_REQUIRED:"Le champ pour le nouveau mot de passe est obligatoire",
    NEW_PASSWORD_REPEAT:"Le champ pour confirmer le mot de passe est obligatoire",
    NEW_PASSWORD_NOT_MATCH:"Le mot de passe ne correspond pas à nouveau mot de passe",
    PASSWORD_DIFFERENT_VALIDATION:"Le nouveau mot de passe doit être différent de l'ancien",
    PASSWORD_MIN_CHAR:"Votre mot de passe doit contenir au moins 8 caractères",
    PASSWORD_MAX_CHAR:"Votre mot de passe ne doit pas contenir plus de 32 caractères",
    PASSWORD_PATTERN_VALIDATION:"Mot de passe doit contenir au moins un chiffre, une lettre en majuscule et une en miniscule ",
    ACCOUNT_MANAGEMENT:"Gestion de compte",
    NOT_ACTIVE:"Inactif",
    ASSIGN_ROLE:"Attribuer un rôle",
    UPDATE:"Mettre à jour",
    ADD_NEW_ACCOUNT:"Ajouter un nouveau compte",
    EMAIL_REQUIRED:"Adresse e-mail est obligatoire",
    EMAIL_NOT_VALID:"Adresse e-mail n'est pas valide",
    ADD_NEW_USER_TEXT:"Le mail avec le lien d'activation sera envoyé à l'adresse e-mail enrégistrée",
    UPDATE_USER_NOTIFICATION:"Les données mises à jour avec succès",
    CHANGED_PASSWORD_NOTIFICATION:"Le mot de passe modifié avec succès",
    UPDATE_USER_GROUP_NOTIFICATION:"Le nom de groupe modifié avec succès",
    CREATE_USER_GROUP_NOTIFICATION:"Groupe d'utilisateurs créé avec succès",
    DETELE_USER_GROUP_NOTIFICATION:"Groupe d'utilisateurs supprimé avec succès",
    EMPTY_GROUP_LIST_MSG:"Aucun groupe d'utilisateurs créé. Pour commencer, créer un groupe d'utilisateurs",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"L'utilisateur supprimé du groupe avec succès",
    ADD_USER_TO_GROUP_NOTIFICATION:"L'utilisateur ajouté au groupe avec succès",
    ADD_USER_NOTIFICATION:"Le nouvel utilisateur ajouté avec succès",
    DELETE_USER_NOTIFICATION:"L'utilisateur supprimé avec succès",
    RESEND_USER_VERIFICATION_EMAIL:"L'e-mail de vérification a bien été envoyé.",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Pour créer un groupe d'utilisateurs, veuillez enrégistrer le nom du groupe.",
    DELETE_USER:"Supprimer les utilisateurs",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Êtes-vous sûr(e) de vouloir supprimer cet utilisateur du groupe?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Cher(Chère) utilisateur R2W, si vous nous rendez visite pendent notre promotion du mois en cours, vous recevrez le bonus sur votre compte.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Règle de promotion par le nombre de visites",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Règle de promotion par le nombre des jetons dépensés",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Règle de promotion par le jour de la semaine",
    REMOVE_CAMPAIGN_RULE_TITLE:"Annuler les règles de promotion",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Êtes-vous sûr(e) de vouloir supprimer cette règle de promotion?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Une nouvelle promotion créée avec succès",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Une nouvelle promotion activée avec succès",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Pas de promotions créées. Pour commencer, veuillez en créer une ",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Message envoyé avec succès",
    COMPANY_ACCOUNTS:"Comptes de la société",
    BUSSINESS_INVOICES_LIST:"Mes factures B2B",
    LOCALE_TOKEN:"Jeton local",
    R2W:"Jeton global",
    START_MONTH:"Mois de début",
    END_MONTH:"Mois de fin",
    TOKEN_TYPE:"Type de jeton",
    TOKEN_NUMBER:"Numéro de jeton",
    NOTHING_TO_DISPLAY:"* Rien à afficher",
    CREATE_INVOICE:"Créer la facture",
    INVOICE:"Facture",
    INVOICES:"Factures",
    EDIT_INVOICE:"Modifier la facture",
    UPDATE_INVOICE_NOTIFICATION:"Vous avez mis à jour la facture à l'état 'En cours' avec succès",
    CURRENT_CHARGES:"Vos obligations pour la période en cours",
    PAYMENTS_ON_HOLD:"Factures en cours de traitement",
    FOR_INVOICING:"Pour la facturation",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Vous êtes en train d'annuler la facture",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Êtes-vous sûr(e) de vouloir annuler cette facture ?",
    INVOICING_NOTIFICATION_HEADER:"Vous êtes sur le point de faire de la facturation",
    INVOICING_NOTIFICATION_TEXT:"Êtes-vous sûr(e) de vouloir envoyer la facture?",
    SENT_INVOICE_NOTIFICATION:"Vous avez envoyé la facture avec succès",
    CANCELED_INVOICE_NOTIFICATION:"Votre facture a été annulée avec succès",
    INVOICE_DESCRIPTION_TEXT:"Facture pour le mois ",
    INVOICE_STATE:"Etat de la facture",
    INVOICE_NUMBER:"Numéro de facture",
    INVOICE_TOTAL:"Total",
    SELECT_YEAR:"Choisir une année",
    DOWNLOAD:"Télécharger PDF",
    INVOICE_NUMBER_HEADER:"Vous allez envoyer la facture avec le numéro ",
    INVOICE_PAYMENT_CONFIRMATION:"Vous êtes en train de confirmer le paiement de la facture ",
    INSERT_INVOICE_NUMBER:"Saisir le numéro de la facture",
    INVOICED_WARNING:"E-mail n'est pas envoyé. Veuillez patienter ...",
    SEND_INVOICE:"Envoyer",
    INVOICE_ALL:"Tout",
    INVOICE_FROM_R2W:"de R2W",
    INVOICE_TO_R2W:"à R2W",
    PAYMENT_REQUEST:"Demande de paiement",
    PAYMENT_REQUEST_STATE:"État de la demande de paiement",
    PAYMENT_REQUEST_NUMBER:"Numéro de la demande de paiement",
    FOR_PAYMENT_REQUEST:"Pour paiements demandés",
    PAYMENT_REQUEST_ON_HOLD:"Demande de paiement en cours de traitement",
    DOWNLOAD_INVOICE:"Télécharger la facture",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Cliquez pour les options de téléchargement",
    B2B_SPEC:"B2B spécification",
    B2C_SPEC:"B2C spécification",
    DOWNLOAD_PAYMENT_REQUEST:"Télécharger la demande de paiement",
    LOYALTY_PREVIEW:"Prévisualisation de la promotion",
    ACTIVATED:"Activé",
    RUNNING:"En cours",
    NOT_ACTIVATED:"Pas activée",
    FINISHED:"Finie",
    DEPRECATED:"Obsolète",
    UPCOMING:"A venir",
    NONE:"Personne",
    STARTED:"Commencé",
    ENDS:"Se termine",
    DEDICATED:"Attribuée à",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Vous êtes en train d'activer",
    CAMPAIGN:"promotion",
    SEND_MESSAGE_NOTIFICATION:"Vous allez envoyer le message à tous les groupes d'utilisateurs",
    DIVISIBLE_TO_NUMBER:"Le nombre doit être divisible par ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Type d'appareil",
    LISTENER:"Petites machines",
    BRIDGE:"Pistes de lavage",
    WASH_BOXES:"Pistes de lavage",
    VACUUMS:"Aspirateurs",
    SAVE_NEWS:"Sauvegarder l'actualité",
    CREATE_NEW_NEWS:"Créer une actualité",
    HISTORY_OF_ALL_NEWS:"Historique de toutes les actualités",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Saisir le nom de la station de lavage",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Ajouter une autre station de lavage",
    NEWS_TEXT:"Texte de l'actualité",
    NEWS_TITLE:"Titre de l'actualité",
    DELETE_NEWS_CONFIRMATION:"Voulez-vous supprimer cette actualité ?",
    NEWS_DELETE_NOTIFICATION:"L'actualité supprimée avec succès",
    NEWS_SAVE_NOTIFICATION:"L'actualité sauvegardée avec succès",
    NEWS_CREATION_DATE:"Date d'enregistrement",
    NO_TITLE:"Sans titre",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Texte ne doit pas contenir plus de 255 caractères",
    NEWS_TEXT_REQUIRED_VALIDATION:"Texte de l'actualité est obligatoire",
    NEWS_TITLE_REQUIRED_VALIDATION:"Titre de l'actualité est obligatoire",
    DEACTIVATE:"Désactiver",
    ASIDE_MENU_LOCAL_TOKENS:"Jetons locaux",
    CREATE_NEW_LOCAL_TOKENS:"Emission de nouveaux jetons locaux",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Saisissez l'adresse e-mail d'utilisateur et le nombre de jetons à envoyer",
    CREATE_TOKENS:"Jetons envoyés",
    MINIMUM_ONE_TOKEN:"Valeur saisie doit être suppérieure de 0",
    CUSTOMER_EMAIL:"Adresse e-mail de l'utilisateur",
    AMOUNT_OF_TOKENS:"Nombre de jetons",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Jetons locaux émis avec succès pour",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Une erreur s'est produite lors d'émission des jetons locaux. Merci de vérifier l'adresse e-mail d'utilisateur et puis réessayez.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Historique d'émission des jetons locaux",
    ISSUED_AT:"émis à",
    ISSUED_BY:"émis par",
    CODE:"Code",
    REDEEMED_BY:"Utilisé par",
    REDEEMED_AT:"Utilisé à",
    ASIDE_MENU_VOUCHERS:"Coupon",
    PRINT:"Imprimer",
    VOUCHERS_OVERVIEW:"Sommaire des coupons",
    CREATE_NEW_VOUCHERS:"Créer de nouveaux coupons",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Créez une nouvelle série de coupons en indiquant le nombre de jetons par un coupon, le nombre de coupons par série et le code préfixe de la série",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Nombre de jetons par un coupon",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Il est possible d'attribuer entre 1 à 100 jetons par coupon",
    NUMBER_OF_NEW_VOUCHERS:"Nombre de coupons par série",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Il est possible de créer entre 1 et {{size}} coupons par une série",
    NEW_VOUCHERS_PREFIX:"Le code préfixe de coupon dans la série",
    VALIDATION_VOUCHER_PREFIX:"Le préfixe de code doit contenir exactement 4 caractères (lettres majuscules et / ou chiffres)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Une erreur s'est produite lors de la création de nouveaux vouchers. Veuillez réessayer ou contactez notre service de support.",
    CREATE_VOUCHERS:"Créer une série de coupons",
    CREATING_VOUCHERS_SUCCESS:"Nouvelle série de coupons créée avec succès",
    PRINT_NEW_VOUCHERS:"Imprimer les coupons",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Nombre de jetons par un coupon",
    PRINT_VOUCHERS_PREFIX:"Préfixe de code (de série) de coupons",
    NO_VOUCHERS_FOR_PRINT:"Aucun coupon retrouvé sous le code préfixe saisi",
    PRINT_VOUCHERS:"Imprimer les coupons",
    VALIDATION_VOUCHER_CODE_FILTER:"Le filtre de recherche des coupons doit être composé de 1 à 16 caractères dont les lettres en majuscule et les chiffres.",
    FILTER_VOUCHERS_BY_CODE:"Rechercher les voucher par le code",
    FILTER_VOUCHERS:"Recherche",
    WASH_BOX:"Piste de lavage",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Total des jetons numériques utilisés",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Nombre total de jetons locaux vendus par date",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Total de jetons locaux dépensés par date",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Nombre total de jetons locaux par date",
    LOCAL_TOKEN:"Jeton local ",
    GIVEN_TOKEN:"Jetons locaux donnés",
    SOLD_TOKEN:"Jetons locaux vendus",
    SMALL_MACHINES:"Petites machines",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle - Piste de lavage",
    CODE_PREFIX_EXIST:"Le préfixe du code existe déjà",
    CODE_PREFIX_EXIST_TEXT:"Vous ne pouvez pas créer le nouveau coupon avec ce préfixe du code. Veuillez définir un autre.",
    MIN_FOUR_VALIDATION:"Exactement 4 caractères",
    ALL_INFORMATION_1:"Toutes les informations sur",
    ALL_INFORMATION_2:"sera perdu",
    ASIDE_MENU_TRANSACTIONS:"Transactions",
    EXPENSES:"Les dépenses",
    TOPUPS:"Jetons achetés",
    EXPENSES_LIST:"Liste des dépenses",
    USER_EMAIL:"Email d'utilisateur",
    COMPANY_NAME:"Nom de la compagnie",
    TOPUPS_LIST:"Liste des jetons achetés",
    CONSUMER:"Consommateur",
    SYSTEM_ADMIN:"Administrateur de système",
    MERCHANT_ADMIN:"Administrateur marchand",
    COMPANY_ADMIN:"Administrateur de companie",
    FACILITY_ADMIN:"Administrateur de site de lavage",
    SUBSCRIBER:"Souscripteur",
    CONFIGURATOR:"Configurateur",
    SETUP_UNIT_SERIAL_NO:"Numéro de serie",
    SETUP_UNIT_MATERIAL_NO:"Numéro d'article",
    SETUP_UNIT_WEBAPI_VERSION:"Version WebApi",
    TOTAL_TURNOVER:"Rotation de site de lavage",
    AVAILABILITY_ALL:"Disponibilité",
    AVAILIBILITY:"Disponibilité des pistes de lavage",
    AVAILABILITY_VACUUMS:"Disponibilité des aspirateurs :",
    WASH_BOX_INFO:"Information sur les pistes de lavage",
    VACUUM_CLEANER_INFO:"Information sur les aspirateurs",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Jours fériés",
    HOLIDAY:"Jour férié",
    LIGHTS_ON:"Lumières allumées",
    LIGHTS_OFF:"Lumières éteintes",
    WASH_BOXES_ON:"Piste de lavage connectée",
    WASH_BOXES_OFF:"Piste de lavage déconnectée",
    VACUUMS_ON:"Aspirateurs connectés",
    VACUUMS_OFF:"Aspirateurs déconnectés",
    TURNOVER:"Rotation",
    TURNOVER_MANUAL_WASH_UNIT:"Rotation manuel",
    STATUS_BAY_RUN_TIME:"Heures d'activité de la piste de lavage au total",
    STATUS_BAY_PROGRAM_NAME:"Nom du programme",
    STATUS_BAY_CREDIT:"Le crédit de la piste de lavage",
    CLOUD_KREDIT:"Le crédit du cloud",
    STATUS_VACUUM_RUN_TIME:"Heures d'activité de l'aspirateur",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Afficher des informations du service et programme",
    UNAVAILABLE:"L'unité est indisponible",
    SHOW_HIDE_TABLE:"Afficher / masquer la table des heures d'activité",
    PROGRAM_NAME:"Nom du programme",
    PROGRAM_COUNTER:"Compteur du programme",
    NO_NAME:"La référence n'a pas de nom",
    COUNTER_SERVICE_DATA:"Données de la service",
    NEED_SERVICE:"Service requis",
    PROGRAM_DATA:"Données du programme de la piste de lavage",
    CURRENT_FAULT_DATA:"Données sur les défauts actuels",
    REFERENCE_DUE:"Echue",
    REFERENCE_SECONDS:"Secondes",
    REFERENCE_NAME:"Nom de la référence",
    WASHBOX_NAME:"Nom de la piste de lavage",
    FAULT_NAME:"Nom du défaut",
    FAULT_NUMBER:"Numéro du défault",
    CURRENT_FAULT_COUNT:"Défaults actifs",
    DEVICE_NOT_INSTALLED:"Appareil non installé",
    STATUS_READY:"État prêt",
    STATUS_ERROR:"Etat d'erreur",
    CONNECTION_ERROR:"Déconnecté",
    UNKNOWN_RESET:"Erreur de logiciel",
    SOFTWARE_RESET:"Erreur de logiciel",
    EXTERNAL_PIN_RESET:"Erreur de logiciel",
    RESTART_OR_BROWNOUT_OCCURRED:"Erreur de logiciel",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Erreur de progiciel",
    COULD_NOT_SIMULATE_COIN:"Erreur de progiciel",
    ERROR_SETTING_INHIBIT_MODE:"Erreur de progiciel",
    OFFLINE_DEVICE:"La piste de lavage déconnectée",
    TARIFFS:"Tarif",
    DAY:"Jour",
    NIGHT:"Nuit",
    VOUCHER_CODE:"Code de coupon",
    DISMISS_ALARM:"Réinitialiser l'alarme ?",
    ALARM_ACTIVE:"Alarmes actives",
    NO_ALARM_ACTIVE:"Il n'y a aucune alarme active.",
    ALARM_HISTORY:"Historique des alertes",
    MANAGING_TOKENS:"Gérer les jetons",
    EXPIRATION_DATE:"Date d'expiration",
    EXTEND_TOKEN_DATE:"Prolonger la date d'expiration du jeton pour",
    DELETE_TOKENS_FOR:"Supprimer les jetons pour",
    PUMP_TYPE:"Type de pompe",
    TURN_OFF_DEVICE:"Statut de l'appareil",
    OPERATION_DATA:"Données de l'opération",
    PUMP_DATA:"Données de la pompe",
    PUMP_NAME:"Nom de la pompe",
    POINT_NAME:"Nom du point",
    CHANGER_INCOME:"Revenu total du distributeur de jetons par date",
    SELECTED_OPEN:"Ouvert pendant les heures de travail sélectionnées",
    ALWAYS_OPEN:"Toujours ouvert (24/7)",
    CLOSED:"Fermé",
    CLOSED_24:"Fermé 24 heures",
    OPENED_24:"Ouvert 24 heures",
    MON:"Lundi",
    TUE:"Mardi",
    WED:"Mercredi",
    THU:"Jeudi",
    FRI:"Vendredi",
    SAT:"Samedi",
    SUN:"Dimanche",
    PRICING:"Tarif",
    PRICE:"Prix",
    VALIDITY:"Validité",
    TOKEN_PACKAGES:"Packs de jetons",
    SINGLE_WASH:"Lavage seul",
    FACILITY_WORKING_HOURS:"Indiquer les horaires d'ouverture de la station de lavage sélectionnée",
    WORKING_HOURS_ALWAYS_OPEN:"Toujours ouvert",
    WORKING_HOURS_ALWAYS_CLOSE:"Fermé par l'exploitant",
    WORKING_HOURS_CUSTOM:"Indiquer les horaires d'ouverture",
    KARCHER_ERROR_CODE:"Alerte code d'erreur",
    KARCHER_ERROR_MESSAGE_1:"Prises électroniques surchargées",
    KARCHER_ERROR_MESSAGE_2:"Le séparateur d'huile doit être vidé",
    KARCHER_ERROR_MESSAGE_4:"Le sensor d'obscurcissement défectueux",
    KARCHER_ERROR_MESSAGE_5:"Le commutateur du moteur protecteur des pompes de haute pression s'est déclenché.",
    KARCHER_ERROR_MESSAGE_6:"Connexion au RDS défectueuse",
    KARCHER_ERROR_MESSAGE_7:"Le commutateur de pression pour l'air sur le compresseur ne signale aucun",
    KARCHER_ERROR_MESSAGE_8:"Cause: pas de connexion avec l'électronique 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"Pas de connexion avec l'électronique de la pompe à la station 1",
    KARCHER_ERROR_MESSAGE_11:"Les prises électroniques de la station de lavage 1 sont surchargées",
    KARCHER_ERROR_MESSAGE_12:"La prise de courant de la pompe haute pression à la station de lavage 1 est trop élevée",
    KARCHER_ERROR_MESSAGE_13:"La prise de courant de la pompe haute pression à la station de lavage 1 est trop faible",
    KARCHER_ERROR_MESSAGE_14:"Contact de la pompe haute pression à la station de lavage 1 coincé",
    KARCHER_ERROR_MESSAGE_15:"Valve semi-automatique à la station de lavage 1 défectueuse",
    KARCHER_ERROR_MESSAGE_16:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 1 ",
    KARCHER_ERROR_MESSAGE_17:"Niveau d'huile de la pompe haute pression à la station de lavage 1 est trop bas",
    KARCHER_ERROR_MESSAGE_18:"L'électronique à la station de lavage 1 défectueuse",
    KARCHER_ERROR_MESSAGE_19:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 1",
    KARCHER_ERROR_MESSAGE_20:"Pas de connexion avec l'électronique de commande à distance à la station 1",
    KARCHER_ERROR_MESSAGE_21:"Défaut à l'accepteur de pièces à la station de lavage 1",
    KARCHER_ERROR_MESSAGE_22:"Défaut à l'accepteur de pièces à la station de lavage 1",
    KARCHER_ERROR_MESSAGE_30:"Pas de connexion avec l'électronique de la pompe à la station 2",
    KARCHER_ERROR_MESSAGE_31:"Les prises électroniques de la station de lavage 2 sont surchargées",
    KARCHER_ERROR_MESSAGE_32:"La prise de courant de la pompe haute pression à la station de lavage 2 est trop élevée",
    KARCHER_ERROR_MESSAGE_33:"La prise de courant de la pompe haute pression à la station de lavage 2 est trop faible",
    KARCHER_ERROR_MESSAGE_34:"Contact de la pompe haute pression à la station de lavage 2 coincé",
    KARCHER_ERROR_MESSAGE_35:"Valve semi-automatique à la station de lavage 2 défectueuse",
    KARCHER_ERROR_MESSAGE_36:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 2 ",
    KARCHER_ERROR_MESSAGE_37:"Niveau d'huile de la pompe haute pression à la station de lavage 2 est trop bas",
    KARCHER_ERROR_MESSAGE_38:"L'électronique à la station de lavage 2 défectueuse",
    KARCHER_ERROR_MESSAGE_39:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 2",
    KARCHER_ERROR_MESSAGE_40:"Pas de connexion avec l'électronique de commande à distance à la station 2",
    KARCHER_ERROR_MESSAGE_41:"Défaut à l'accepteur de pièces à la station de lavage 2",
    KARCHER_ERROR_MESSAGE_42:" Défaut à l'accepteur de pièces à la station de lavage 2",
    KARCHER_ERROR_MESSAGE_50:"Pas de connexion avec l'électronique de la pompe à la station 3",
    KARCHER_ERROR_MESSAGE_51:"Les prises électroniques de la station de lavage 3 sont surchargées",
    KARCHER_ERROR_MESSAGE_52:"La prise de courant de la pompe haute pression à la station de lavage 3 est trop élevée",
    KARCHER_ERROR_MESSAGE_53:"La prise de courant de la pompe haute pression à la station de lavage 3 est trop faible",
    KARCHER_ERROR_MESSAGE_54:"Contact de la pompe haute pression à la station de lavage 3 coincé",
    KARCHER_ERROR_MESSAGE_55:"Valve semi-automatique à la station de lavage 3 défectueuse",
    KARCHER_ERROR_MESSAGE_56:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 3",
    KARCHER_ERROR_MESSAGE_57:"Niveau d'huile de la pompe haute pression à la station de lavage 3 est trop bas",
    KARCHER_ERROR_MESSAGE_58:"L'électronique à la station de lavage 3 défectueuse",
    KARCHER_ERROR_MESSAGE_59:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 3",
    KARCHER_ERROR_MESSAGE_60:"Pas de connexion avec l'électronique de commande à distance à la station 3",
    KARCHER_ERROR_MESSAGE_61:"Défaut à l'accepteur de pièces à la station de lavage 3",
    KARCHER_ERROR_MESSAGE_62:"Défaut à l'accepteur de pièces à la station de lavage 3",
    KARCHER_ERROR_MESSAGE_70:"Pas de connexion avec l'électronique de la pompe à la station 4",
    KARCHER_ERROR_MESSAGE_71:"Les prises électroniques de la station de lavage 4 sont surchargées",
    KARCHER_ERROR_MESSAGE_72:"La prise de courant de la pompe haute pression à la station de lavage 4 est trop élevée",
    KARCHER_ERROR_MESSAGE_73:"La prise de courant de la pompe haute pression à la station de lavage 4 est trop faible",
    KARCHER_ERROR_MESSAGE_74:"Contact de la pompe haute pression à la station de lavage 4 coincé",
    KARCHER_ERROR_MESSAGE_75:"Valve semi-automatique à la station de lavage 4 défectueuse",
    KARCHER_ERROR_MESSAGE_76:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 4",
    KARCHER_ERROR_MESSAGE_77:"Niveau d'huile de la pompe haute pression à la station de lavage 4 est trop bas",
    KARCHER_ERROR_MESSAGE_78:"L'électronique à la station de lavage 4 défectueuse",
    KARCHER_ERROR_MESSAGE_79:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 4",
    KARCHER_ERROR_MESSAGE_80:"Pas de connexion avec l'électronique de commande à distance à la station 4",
    KARCHER_ERROR_MESSAGE_81:"Défaut à l'accepteur de pièces à la station de lavage 4",
    KARCHER_ERROR_MESSAGE_82:"Défaut à l'accepteur de pièces à la station de lavage 4",
    KARCHER_ERROR_MESSAGE_90:"Pas de connexion avec l'électronique de la pompe à la station 5",
    KARCHER_ERROR_MESSAGE_91:"Les prises électroniques de la station de lavage 5 sont surchargées",
    KARCHER_ERROR_MESSAGE_92:"La prise de courant de la pompe haute pression à la station de lavage 5 est trop élevée",
    KARCHER_ERROR_MESSAGE_93:"La prise de courant de la pompe haute pression à la station de lavage 5 est trop faible",
    KARCHER_ERROR_MESSAGE_94:"Contact de la pompe haute pression à la station de lavage 5 coincé",
    KARCHER_ERROR_MESSAGE_95:"Valve semi-automatique à la station de lavage 5 défectueuse",
    KARCHER_ERROR_MESSAGE_96:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 5",
    KARCHER_ERROR_MESSAGE_97:"Niveau d'huile de la pompe haute pression à la station de lavage 5 est trop bas",
    KARCHER_ERROR_MESSAGE_98:"L'électronique à la station de lavage 5 défectueuse",
    KARCHER_ERROR_MESSAGE_99:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 5",
    KARCHER_ERROR_MESSAGE_100:"Pas de connexion avec l'électronique de commande à distance à la station 5",
    KARCHER_ERROR_MESSAGE_101:"Défaut à l'accepteur de pièces à la station de lavage 5",
    KARCHER_ERROR_MESSAGE_102:"Défaut à l'accepteur de pièces à la station de lavage 5",
    KARCHER_ERROR_MESSAGE_110:"Pas de connexion avec l'électronique de la pompe à la station 6",
    KARCHER_ERROR_MESSAGE_111:"Les prises électroniques de la station de lavage 6 sont surchargées",
    KARCHER_ERROR_MESSAGE_112:"La prise de courant de la pompe haute pression à la station de lavage 6 est trop élevée",
    KARCHER_ERROR_MESSAGE_113:"La prise de courant de la pompe haute pression à la station de lavage 6 est trop faible",
    KARCHER_ERROR_MESSAGE_114:"Contact de la pompe haute pression à la station de lavage 6 coincé",
    KARCHER_ERROR_MESSAGE_115:"Valve semi-automatique à la station de lavage 6 défectueuse",
    KARCHER_ERROR_MESSAGE_116:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 6",
    KARCHER_ERROR_MESSAGE_117:"Niveau d'huile de la pompe haute pression à la station de lavage 6 est trop bas",
    KARCHER_ERROR_MESSAGE_118:"L'électronique à la station de lavage 6 défectueuse",
    KARCHER_ERROR_MESSAGE_119:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 6",
    KARCHER_ERROR_MESSAGE_120:"Pas de connexion avec l'électronique de commande à distance à la station 6",
    KARCHER_ERROR_MESSAGE_121:"Défaut à l'accepteur de pièces à la station de lavage 6",
    KARCHER_ERROR_MESSAGE_122:"Défaut à l'accepteur de pièces à la station de lavage 6",
    KARCHER_ERROR_MESSAGE_130:"Pas de connexion avec l'électronique de la pompe à la station 7",
    KARCHER_ERROR_MESSAGE_131:"Les prises électroniques de la station de lavage 7 sont surchargées",
    KARCHER_ERROR_MESSAGE_132:"La prise de courant de la pompe haute pression à la station de lavage 7 est trop élevée",
    KARCHER_ERROR_MESSAGE_133:"La prise de courant de la pompe haute pression à la station de lavage 7 est trop faible",
    KARCHER_ERROR_MESSAGE_134:"Contact de la pompe haute pression à la station de lavage 7 coincé",
    KARCHER_ERROR_MESSAGE_135:"Valve semi-automatique à la station de lavage 7 défectueuse",
    KARCHER_ERROR_MESSAGE_136:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 7",
    KARCHER_ERROR_MESSAGE_137:"Niveau d'huile de la pompe haute pression à la station de lavage 7 est trop bas",
    KARCHER_ERROR_MESSAGE_138:"L'électronique à la station de lavage 7 défectueuse",
    KARCHER_ERROR_MESSAGE_139:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 7",
    KARCHER_ERROR_MESSAGE_140:"Pas de connexion avec l'électronique de commande à distance à la station 7",
    KARCHER_ERROR_MESSAGE_141:"Défaut à l'accepteur de pièces à la station de lavage 7",
    KARCHER_ERROR_MESSAGE_142:"Défaut à l'accepteur de pièces à la station de lavage 7",
    KARCHER_ERROR_MESSAGE_150:"Pas de connexion avec l'électronique de la pompe à la station 8",
    KARCHER_ERROR_MESSAGE_151:"Les prises électroniques de la station de lavage 8 sont surchargées",
    KARCHER_ERROR_MESSAGE_152:"La prise de courant de la pompe haute pression à la station de lavage 8 est trop élevée",
    KARCHER_ERROR_MESSAGE_153:"La prise de courant de la pompe haute pression à la station de lavage 8 est trop faible",
    KARCHER_ERROR_MESSAGE_154:"Contact de la pompe haute pression à la station de lavage 8 coincé",
    KARCHER_ERROR_MESSAGE_155:"Valve semi-automatique à la station de lavage 8 défectueuse",
    KARCHER_ERROR_MESSAGE_156:"Contact de protection d'enroulement de la pompe haute pression à la station de lavage 8",
    KARCHER_ERROR_MESSAGE_157:"Niveau d'huile de la pompe haute pression à la station de lavage 8 est trop bas",
    KARCHER_ERROR_MESSAGE_158:"L'électronique à la station de lavage 8 défectueuse",
    KARCHER_ERROR_MESSAGE_159:"Déclenchement du disjoncteur sur le moteur de la pompe haute pression à la station 8",
    KARCHER_ERROR_MESSAGE_160:"Pas de connexion avec l'électronique de commande à distance à la station 8",
    KARCHER_ERROR_MESSAGE_161:"Défaut à l'accepteur de pièces à la station de lavage 8",
    KARCHER_ERROR_MESSAGE_162:"Défaut à l'accepteur de pièces à la station de lavage 8",
    KARCHER_ERROR_MESSAGE_170:"Pas de connexion à l'électronique A2",
    KARCHER_ERROR_MESSAGE_171:"Les sorties de l'électronique A2 sont surchargées",
    KARCHER_ERROR_MESSAGE_172:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_173:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_174:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_175:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_176:"Le réservoir de détergent est vide",
    KARCHER_ERROR_MESSAGE_177:"La prise de courant du châssis de la pompe est trop élevée.",
    KARCHER_ERROR_MESSAGE_178:"Pas de pression après avoir activé le lavage du dessous de caisse",
    KARCHER_ERROR_MESSAGE_190:"Pas de connexion à l'électronique A3",
    KARCHER_ERROR_MESSAGE_191:"Les sorties de l'électronique A3 sont surchargées",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Les sorties du contrôle à WSO sont surchargées",
    KARCHER_ERROR_MESSAGE_202:"Le senseur de dureté indique la présence d'eau dure après la régénération",
    KARCHER_ERROR_MESSAGE_204:"Panne de l'électronique",
    KARCHER_ERROR_MESSAGE_210:"Détecteur de niveau RÉSERVOIR TAMPON VIDE activé",
    KARCHER_ERROR_MESSAGE_211:"Détecteur de niveau CONTENEUR TAMPON VIDE et CONTENEUR TAMPON PLEIN commutent simultanément.",
    KARCHER_ERROR_MESSAGE_212:"Détecteur de niveau POMPE RO ACTIVÉE et CONTENEUR TAMPON PLEIN communent simultanément",
    KARCHER_ERROR_MESSAGE_213:"Absence de pression d'eau",
    KARCHER_ERROR_MESSAGE_214:"Défaut de préparation de l'eau fournie sur place",
    KARCHER_ERROR_MESSAGE_220:"Manque d'eau",
    KARCHER_ERROR_MESSAGE_221:"Température d'échappement trop élevée",
    KARCHER_ERROR_MESSAGE_222:"La prise de courant de la pompe de circulation pour l'eau chaude est trop élevée",
    KARCHER_ERROR_MESSAGE_223:"Défaut du brûleur",
    KARCHER_ERROR_MESSAGE_224:"Le thermostat de sécurité du brûleur s'est déclenché.",
    KARCHER_ERROR_MESSAGE_225:"Le délai du brûleur activé",
    KARCHER_ERROR_MESSAGE_226:"L'indicateur de débit ne s'est pas ouvert dans les 5 secondes suivant l'arrêt de la pompe de circulation d'eau chaude",
    KARCHER_ERROR_MESSAGE_227:"L'indicateur de débit ne s'est pas ouvert dans les 3 secondes suivant l'arrêt de la pompe de circulation d'eau chaude",
    KARCHER_ERROR_MESSAGE_228:"La sortie d'eau chaude s'apaise trop lentement après l'arrêt du brûleur",
    KARCHER_ERROR_MESSAGE_229:"Défaut de la sonde de température d'eau chaude",
    KARCHER_ERROR_MESSAGE_230:"Défaut dans la sonde de température de sortie du brûleur",
    KARCHER_ERROR_MESSAGE_231:"Défaut de la sonde de température d'eau chaude",
    KARCHER_ERROR_MESSAGE_232:"Défaut dans la sonde de température de sortie du brûleur",
    KARCHER_ERROR_MESSAGE_233:"Température de l'eau avec alimentation externe avec de l'eau chaude est plus chaude que 60°C",
    KARCHER_ERROR_MESSAGE_234:"Erreur programme anti-légionelles",
    KARCHER_ERROR_MESSAGE_235:"Température de l'eau chaude anti-légionelles non atteinte",
    KARCHER_ERROR_MESSAGE_240:"Erreur du capteur de température extérieure",
    KARCHER_ERROR_MESSAGE_241:"Erreur du capteur de température extérieure",
    KARCHER_ERROR_MESSAGE_242:"La prise de courant de la pompe de circulation pour la protection contre le gel est trop élevée",
    KARCHER_ERROR_MESSAGE_243:"La prise de courant de la pompe de circulation pour chauffage de la station de lavage est trop élevée",
    KARCHER_ERROR_MESSAGE_244:"La température de l'eau chaude est trop basse, le chauffage de la station de lavage était éteint.",
    KARCHER_ERROR_MESSAGE_245:"La consommation du tuyau de chauffage de la mousse est trop élevée.",
    KARCHER_ERROR_MESSAGE_247:"Panne de l'électronique",
    KARCHER_ERROR_MESSAGE_248:"Panne de l'électronique",
    KARCHER_ERROR_MESSAGE_250:"La prise de courant de la pompe de circulation pour le programme de lavage spécial est trop élevée",
    KARCHER_ERROR_MESSAGE_255:"Panne de l'électronique",
    KARCHER_ERROR_MESSAGE_260:"Pas de connexion à l'électronique A5",
    KARCHER_ERROR_MESSAGE_261:"Les sorties de l'électronique A5 sont surchargées",
    KARCHER_ERROR_MESSAGE_280:"Pas de connexion à l'électronique A6",
    KARCHER_ERROR_MESSAGE_281:"Les sorties de l'électronique A6 sont surchargées",
    KARCHER_ERROR_MESSAGE_282:"Consommation de courant de la pompe pour le nettoyeur de jantes trop élevée",
    KARCHER_ERROR_MESSAGE_283:"Consommation de courant de la pompe pour le nettoyeur de jantes trop basse",
    KARCHER_ERROR_MESSAGE_284:"Le contacteur de la pompe du nettoyeur de jantes est bloqué.",
    KARCHER_ERROR_MESSAGE_300:"Pas de connexion à l'électronique A7",
    KARCHER_ERROR_MESSAGE_301:"Les sorties de l'électronique A7 sont surchargées",
    KARCHER_ERROR_MESSAGE_320:"Pas de connexion à l'électronique A8",
    KARCHER_ERROR_MESSAGE_321:"Les sorties de l'électronique A8 sont surchargées",
    KARCHER_ERROR_MESSAGE_322:"Consommation de courant de la pompe pour micro-émulsion trop élevée",
    KARCHER_ERROR_MESSAGE_323:"Consommation de courant de la pompe pour micro-émulsion trop basse",
    KARCHER_ERROR_MESSAGE_324:"Le contacteur de la pompe à micro-émulsion est bloqué",
    KARCHER_ERROR_MESSAGE_340:"Pas de connexion à l'électronique A9",
    KARCHER_ERROR_MESSAGE_341:"Les sorties de l'électronique A9 sont surchargées",
    KARCHER_ERROR_MESSAGE_342:"Consommation de courant de la pompe pour le nettoyage intensif trop élevée",
    KARCHER_ERROR_MESSAGE_343:"Consommation de courant de la pompe pour le nettoyage intensif trop basse",
    KARCHER_ERROR_MESSAGE_344:"Le contacteur de la pompe pour le nettoyage intensif est bloqué",
    KARCHER_ERROR_MESSAGE_400:"Pas de pression de l'eau chaude",
    KARCHER_ERROR_MESSAGE_401:"Pas de pression de l'eau douce",
    KARCHER_ERROR_MESSAGE_402:"Perméat sans pression",
    KARCHER_ERROR_MESSAGE_403:"Pas de pression de l'eau de type 4",
    KARCHER_ERROR_MESSAGE_404:"Type 4 d'eau, température supérieure à 60 °C ou perturbation externe",
    KARCHER_ERROR_MESSAGE_405:"Pas de pression de la protection contre le gel ",
    KARCHER_ERROR_MESSAGE_406:"La pression dans la protection antigel est survenue malgré l'arrêt de la pompe antigel",
    KARCHER_ERROR_MESSAGE_410:"Erreur F 400 est survenue 4 fois dans 24 heures",
    KARCHER_ERROR_MESSAGE_411:"Erreur F 401 était active pour 300 secondes",
    KARCHER_ERROR_MESSAGE_412:"Erreur F 402 est survenue 4 fois dans 24 heures",
    KARCHER_ERROR_MESSAGE_413:"Erreur F 403 est survenue 4 fois dans 24 heures",
    KARCHER_ERROR_MESSAGE_414:"Erreur F 405 est survenue 4 fois dans 24 heures",
    KARCHER_ERROR_MESSAGE_420:"Erreur sur le distributeur des jetons 1",
    KARCHER_ERROR_MESSAGE_421:"Erreur sur le distributeur des jetons 2",
    KARCHER_ERROR_MESSAGE_440:"Pas de connexion avec l'électronique A31",
    KARCHER_ERROR_MESSAGE_441:"Les sorties de l'électronique A31 sont surchargées",
    KARCHER_ERROR_MESSAGE_500:"Connexion de l'électronique de l'aspirateur 1/2",
    KARCHER_ERROR_MESSAGE_501:"Touche de démarrage aspirateur 1 contact permanent",
    KARCHER_ERROR_MESSAGE_502:"Touche de démarrage aspirateur 2 contact permanent",
    KARCHER_ERROR_MESSAGE_510:"Connexion de l'électronique de l'aspirateur 3/4",
    KARCHER_ERROR_MESSAGE_511:"Touche de démarrage aspirateur 3 contact permanent",
    KARCHER_ERROR_MESSAGE_512:"Touche de démarrage aspirateur 4 contact permanent",
    KARCHER_ERROR_MESSAGE_520:"Connexion de l'électronique de l'aspirateur 5/6",
    KARCHER_ERROR_MESSAGE_521:"Touche de démarrage aspirateur 5 contact permanent",
    KARCHER_ERROR_MESSAGE_522:"Touche de démarrage aspirateur 6 contact permanent",
    KARCHER_ERROR_MESSAGE_530:"Connexion de l'électronique de l'aspirateur 7/8",
    KARCHER_ERROR_MESSAGE_531:"Touche de démarrage aspirateur 7 contact permanent",
    KARCHER_ERROR_MESSAGE_532:"Touche de démarrage aspirateur 8 contact permanent",
    KARCHER_ERROR_MESSAGE_540:"Connexion de l'électronique de l'aspirateur 9/10",
    KARCHER_ERROR_MESSAGE_541:"Touche de démarrage aspirateur 9 contact permanent",
    KARCHER_ERROR_MESSAGE_542:"Touche de démarrage aspirateur 10 contact permanent",
    KARCHER_ERROR_MESSAGE_550:"Connexion de l'électronique de l'aspirateur 10/11",
    KARCHER_ERROR_MESSAGE_551:"Touche de démarrage aspirateur 11 contact permanent",
    KARCHER_ERROR_MESSAGE_552:"Touche de démarrage aspirateur 12 contact permanent",
    KARCHER_ERROR_MESSAGE_800:"Pas de connexion avec l'électronique A30",
    KARCHER_ERROR_MESSAGE_801:"Les sorties de l'électronique A30 sont surchargées",
    KARCHER_ERROR_MESSAGE_802:"Erreur avec l'adoucisseur d'eau",
    KARCHER_ERROR_MESSAGE_803:"Déclenchement de l'interrupteur du moteur protectif de la pompe de prépression RO",
    KARCHER_INFO_MESSAGE_1:"La régénération de l'échangeur de base a commencé",
    KARCHER_INFO_MESSAGE_2:"La régénération de l'échangeur de base terminée",
    KARCHER_INFO_MESSAGE_3:"Echangeur de base épuisé à 75 %",
    KARCHER_INFO_MESSAGE_4:"Unité indisponible en raison d'un problème technique",
    KARCHER_INFO_MESSAGE_5:"Unité indisponible en raison d'un problème opérationnel",
    KARCHER_INFO_MESSAGE_6:"Unité en marche",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"La baie 1 est indisponible",
    KARCHER_INFO_MESSAGE_12:"La baie 2 est indisponible",
    KARCHER_INFO_MESSAGE_13:"La baie 3 est indisponible",
    KARCHER_INFO_MESSAGE_14:"La baie 4 est indisponible",
    KARCHER_INFO_MESSAGE_15:"La baie 5 est indisponible",
    KARCHER_INFO_MESSAGE_16:"La baie 6 est indisponible",
    KARCHER_INFO_MESSAGE_17:"La baie 7 est indisponible",
    KARCHER_INFO_MESSAGE_18:"La baie 8 est indisponible",
    KARCHER_INFO_MESSAGE_20:"Programme anti-légionelles pour réservoir d’eau chaude",
    KARCHER_INFO_MESSAGE_21:"Programme anti-légionelles pompe HP 1 requis",
    KARCHER_INFO_MESSAGE_22:"Programme anti-légionelles pompe HP 2 requis",
    KARCHER_INFO_MESSAGE_23:"Programme anti-légionelles pompe HP 3 requis",
    KARCHER_INFO_MESSAGE_24:"Programme anti-légionelles pompe HP 4 requis",
    KARCHER_INFO_MESSAGE_25:"Programme anti-légionelles pompe HP 5 requis",
    KARCHER_INFO_MESSAGE_26:"Programme anti-légionelles pompe HP 6 requis",
    KARCHER_INFO_MESSAGE_27:"Programme anti-légionelles pompe HP 7 requis",
    KARCHER_INFO_MESSAGE_28:"Programme anti-légionelles pompe HP 8 requis",
    KARCHER_INFO_MESSAGE_29:"Programme anti-légionelles terminé",
    KARCHER_INFO_MESSAGE_101:"La pompe haute pression 1 doit être révisée",
    KARCHER_INFO_MESSAGE_102:"La pompe haute pression 2 doit être révisée",
    KARCHER_INFO_MESSAGE_103:"La pompe haute pression 3 doit être révisée",
    KARCHER_INFO_MESSAGE_104:"La pompe haute pression 4 doit être révisée",
    KARCHER_INFO_MESSAGE_105:"La pompe haute pression 5 doit être révisée",
    KARCHER_INFO_MESSAGE_106:"La pompe haute pression 6 doit être révisée",
    KARCHER_INFO_MESSAGE_107:"La pompe haute pression 7 doit être révisée",
    KARCHER_INFO_MESSAGE_108:"La pompe haute pression 8 doit être révisée",
    KARCHER_INFO_MESSAGE_109:"Le brûleur doit être révisé",
    KARCHER_INFO_MESSAGE_110:"Ventilateur du brûleur doit être révisé",
    KARCHER_INFO_MESSAGE_111:"La pompe d'eau chaude doit être révisée",
    KARCHER_INFO_MESSAGE_112:"La pompe d'antigel doit être révisée",
    KARCHER_INFO_MESSAGE_113:"La pompe d'osmose doit être révisée",
    KARCHER_INFO_MESSAGE_114:"Pompe de chauffage au sol doit être révisée",
    KARCHER_INFO_MESSAGE_115:"Chauffage des tuyaux doit être révisé",
    KARCHER_INFO_MESSAGE_116:"Pompe de microémulsion / d'agent de nettoyage des jantes doit être révisée",
    KARCHER_INFO_MESSAGE_117:"Pompe de nettoyage du châssis doit être révisée",
    KARCHER_INFO_MESSAGE_118:"Pompe de pression du système doit être révisée",
    KARCHER_INFO_MESSAGE_119:"L'aspirateur 1 doit être révisée",
    KARCHER_INFO_MESSAGE_120:"L'aspirateur 2 doit être révisée",
    KARCHER_INFO_MESSAGE_121:"L'aspirateur 3 doit être révisée",
    KARCHER_INFO_MESSAGE_122:"L'aspirateur 4 doit être révisée",
    KARCHER_INFO_MESSAGE_123:"L'aspirateur 5 doit être révisée",
    KARCHER_INFO_MESSAGE_124:"L'aspirateur 6 doit être révisée",
    KARCHER_INFO_MESSAGE_125:"L'aspirateur 7 doit être révisée",
    KARCHER_INFO_MESSAGE_126:"L'aspirateur 8 doit être révisée",
    KARCHER_INFO_MESSAGE_127:"L'aspirateur 9 doit être révisée",
    KARCHER_INFO_MESSAGE_128:"L'aspirateur 10 doit être révisée",
    KARCHER_INFO_MESSAGE_129:"L'aspirateur 11 doit être révisée",
    KARCHER_INFO_MESSAGE_130:"L'aspirateur 12 doit être révisée",
    KARCHER_INFO_MESSAGE_131:"Pompe d'agent de nettoyage des jantes doit être révisée",
    KARCHER_INFO_MESSAGE_132:"Pompe de microémulsion doit être révisée",
    KARCHER_INFO_MESSAGE_133:"Pompe à mousse intensive doit être révisée",
    KARCHER_INFO_MESSAGE_142:"La turbine de l'aspirateur 1 doit être révisée",
    KARCHER_INFO_MESSAGE_143:"Le filtre de l'aspirateur 1 doit être révisé",
    KARCHER_INFO_MESSAGE_144:"La turbine de l'aspirateur 2 doit être révisée",
    KARCHER_INFO_MESSAGE_145:"Le filtre de l'aspirateur 2 doit être révisé",
    KARCHER_INFO_MESSAGE_146:"La turbine de l'aspirateur 3 doit être révisée",
    KARCHER_INFO_MESSAGE_147:"Le filtre de l'aspirateur 3 doit être révisé",
    KARCHER_INFO_MESSAGE_148:"La turbine de l'aspirateur 4 doit être révisée",
    KARCHER_INFO_MESSAGE_149:"Le filtre de l'aspirateur 4 doit être révisé",
    KARCHER_INFO_MESSAGE_150:"La turbine de l'aspirateur 5 doit être révisée",
    KARCHER_INFO_MESSAGE_151:"Le filtre de l'aspirateur 5 doit être révisé",
    KARCHER_INFO_MESSAGE_152:"La turbine de l'aspirateur 6 doit être révisée",
    KARCHER_INFO_MESSAGE_153:"Le filtre de l'aspirateur 6 doit être révisé",
    KARCHER_INFO_MESSAGE_154:"La turbine de l'aspirateur 7 doit être révisée",
    KARCHER_INFO_MESSAGE_155:"Le filtre de l'aspirateur 7 doit être révisé",
    KARCHER_INFO_MESSAGE_156:"La turbine de l'aspirateur 8 doit être révisée",
    KARCHER_INFO_MESSAGE_157:"Le filtre de l'aspirateur 8 doit être révisé",
    KARCHER_INFO_MESSAGE_158:"La turbine de l'aspirateur 9 doit être révisée",
    KARCHER_INFO_MESSAGE_159:"Le filtre de l'aspirateur 9 doit être révisé",
    KARCHER_INFO_MESSAGE_160:"La turbine de l'aspirateur 10 doit être révisée",
    KARCHER_INFO_MESSAGE_161:"Le filtre de l'aspirateur 10 doit être révisé",
    KARCHER_INFO_MESSAGE_162:"La turbine de l'aspirateur 11 doit être révisée",
    KARCHER_INFO_MESSAGE_163:"Le filtre de l'aspirateur 11 doit être révisé",
    KARCHER_INFO_MESSAGE_164:"La turbine de l'aspirateur 12 doit être révisée",
    KARCHER_INFO_MESSAGE_165:"Le filtre de l'aspirateur 12 doit être révisé",
    ORGANIZATION:"Organisation",
    CREATE_ORGANIZATION:"Créer l'organisation",
    CREATE_ORGANIZATION_AS:"Créer l'organisation en tant que filiale de",
    DELETE_ORGANIZATION:"Supprimer l'organisation",
    EDIT_ORGANIZATION:"Modifier l'organisation",
    SUPPORTED_ORG_NAME:"Organisation soutenue",
    SUPPORTED_ORG_TYPE:"Type d'organisation soutenue",
    ORG_NAME:"Nom",
    ORG_TYPE:"Type",
    SET_ORG_TITLE:"Créer la filiale",
    SET_SUPPORTED_ORG_TITLE:"Créer la filiale soutenue",
    SAVE_ORGANIZATION:"Sauvegarder l'organisation",
    SELECT_ORGANIZATION_TYPE:"Sélectionner le type d'organisation",
    SELECT_ORGANIZATION_SELECTOR:"Sélectionner",
    SELECT_SUPPORTED_ORGANIZATION:"Sélectionner l'organisation soutenue",
    ORGANIZATION_DELETED:"L'organisation a été supprimée.",
    ORGANIZATION_SAVED:"L'organisation a été sauvegardée.",
    ORGANIZATION_UPDATED:"L'organisation a été mise à jour.",
    ALERTS:"Alertes",
    DEVICE_STATUS:"Statut de l'appareil",
    SITE_DETAILS:"Détails du site",
    ALARM_STATUS:"Statut de l'alerte",
    FILTER:"Filtrer par...",
    FILTER_BY_ALERT_CENTER:"Filtrer par code, nom ou description",
    TOTAL_ALARM:"Total",
    LOW_ALARM:"Événement",
    MEDIUM_ALARM:"Défaillance",
    HIGH_ALARM:"Erreur critique",
    NO_FACILITIES_NEARBY:"Il n'y a aucune station de lavage à proximité.",
    GRAY_MAP:"Carte en gris",
    READY:"Prêt",
    WARNING:"Défaillance",
    ERROR:"Erreur",
    SITE_NAME:"Nom du site",
    ACCOUNTS_INFO:"Info du compte",
    USER_ORGANIZATION:"Organisation utilisateur",
    ADD_USER_ORGANIZATION:"Ajouter un nouvel utilisateur de l'organisation",
    EDIT_USER_ORGANIZATION:"Modifier les utilisateurs de l'organisation",
    SELECT_ROLE:"Sélectionner le rôle",
    SELECT_ORGANIZATION:"Sélectionner l'organisation",
    SELECT_USER:"Sélectionner l'utilisateur ",
    USER_FOR_ORGANIZATION_CREATED:"Un nouvel utilisateur a été créé. ",
    SELECT_REGION:"Sélectionner la région",
    SELECT_LANGUAGE:"Sélectionner la langue",
    LOADING_DATA:"Chargement des données, veuillez patienter...",
    ADMINISTRATOR:" Administrateur",
    TECHNICAL_SUPPORT:"Assistance technique",
    CONTROLLER:"Contrôleur",
    EDIT_ORGANIZATION_USER:"Modifier les utilisateurs de l'organisation",
    DELETE_ORGANIZATION_USER:"Supprimer les utilisateurs de l'organisation",
    USER_UPDATED:"L'utilisateur a été mis à jour.",
    USER_CREATED:"L'utilisateur a été créé.",
    ADDRESS:"Adresse",
    SUBSCRIPTIONS:"Abonnements",
    RESOLVED_STATUS:"Résolu",
    NOT_RESOLVED_STATUS:"Non résolu",
    ALERT_NAME:"Nom de l'alerte",
    ALERT_DESCRIPTION:"Description de l'alerte",
    ALERT_CODE:"Code de l'alerte",
    ALERT_TYPE:"Type d'alerte",
    UNSUBSCRIBE:"Se désabonner de l'alerte",
    SUBSCRIBE:"S'abonner à l'alerte",
    ALARM_SUBSCRIBED:"Vous êtes maintenant abonné(e).",
    UNSUBSCRIBED_CONFIRM:"Se désabonner?",
    ALARM_UNSUBSCRIBED:"Vous n'êtes plus abonné(e).",
    ASIDE_MENU_CASHLESS_SALES:"Transactions dématérialisées",
    FILTERED_CASHLESS_PAYMENTS:"Paiements dématérialisés filtrés",
    REFUND_DIALOG_TITLE:"Rembourser la transaction ?",
    REFUND_DIALOG_SUBTITLE:"Le montant peut être inférieur ou égal à celui de la transaction.",
    REFUND:"Rembourser",
    INPUT_NOT_VALID:"La saisie est invalide.",
    REFUND_SUCCESSFULLY:"Le remboursement du paiement sélectionné a été effectué.",
    USER:"Utilisateur",
    TRANSACTION_ID:"Référence PSP",
    DEVICE_ID:"ID de l'appareil",
    NET_AMOUNT:"Montant net",
    REPORT_NAME:"Nom du rapport",
    TIME_FRAME:"Période",
    SUB_POINT:"Sélectionner point de remplacement",
    SUB_POINT_LIST_NOT_EXIST:"Aucune liste de point de remplacement n'existe pour la station de lavage sélectionnée.",
    FACILITY_TYPE:"Type de station de lavage",
    MACHINE_NAME:"Nom de la machine",
    WASH_FACILITY_DETAILS:"Détails de la station de lavage",
    WASH_BAY_DETAILS:"Détails de la piste de lavage",
    DEVICES_INFO:"Liste des apaprailes",
    OPERATION_TIME_INFO:"Durée de fonctionnement",
    OPERATION_TIME_VACUUM_INFO:"Durée de fonctionnement des aspirateurs",
    OPERATION_TIME_ILLUMINATION_INFO:"Durée de fonctionnement de l'illumination",
    AVAILABLE_TITLE:"Disponible",
    UNAVAILABLE_TITLE:"Non disponible",
    CURRENT_PROGRAM:"Programme actuel",
    CREDITS:"Crédits",
    DEVICE_NAME:"Nom de l'appareil",
    ACTIVE_ALARMS:"Alertes actives",
    ALL_DAY:"Toute la journée",
    OPERATING_TIME_WASH_FACILITY:"Système de lavage en self-service",
    OPERATING_TIME_VACUUMS:"Aspirateurs",
    OPERATING_TIME_ILLUMINATION:"Illumination",
    OPERATION_COUNTERS:"Compteurs d'exploitation",
    EDIT:"Modifier",
    WASHING_PROGRAMS:"Programmes de lavage",
    INFO:"Événement",
    STATISTIC:"Statistique",
    ROLLOVER_DOSING:"Dosage",
    ROLLOVER_SPEED:"Vitesses",
    ROLLOVER_RESETS:"Réinitialisation à distance du portique",
    ROLLOVER_RESETS_INFO:"La réinitialisation doit être conforme aux réglementations locales. Attention : avant la réinitialisation, s'assurer que le portique est vide.",
    RESET_ROLLOVER:"Réinitialiser le portique",
    OPEN_DOOR_ROLLOVER:"Ouvrir",
    ROLLOVER_OPEN_DOOR_INFO:"Ouvrir la porte du hall de lavage en faisant attention.",
    ROLLOVER_OPEN_DOOR:"Ouvrir la porte",
    APPLY_DOSING_CHANGES:"Appliquer les changements de dosage",
    APPLY_SPEED_CHANGES:"Appliquer les changements de vitesse",
    ACTUATION_SUCCESS:"La demande a été envoyée.",
    REMAINING_TIME:"Temps restant",
    OPEN_24H:"Ouvert 24 heures",
    CLOSE_24H:"Fermé 24 heures",
    VALIDATION_OPERATION_TIME:" Format incorrect, veuillez utiliser hh:mm.",
    ROLLOVER:"Portique",
    UPDATE_WASHING_PROGRAM:"Mettre à jour les programmes de lavage",
    UPDATE_ACTUATORS:"Mettre les opérateurs à jour",
    OPEN_ROLOVER_DOOR_TITLE:"Voulez-vous ouvrir la porte du portique ?",
    OPEN_ROLOVER_DOOR_CONTENT:"Êtes-vous sûr(e) de vouloir ouvrir la porte ?",
    RESET_ROLOVER_TITLE:"Voulez-vous réinitialiser le portique ?",
    RESET_ROLOVER_CONTENT:"Êtes-vous sûr(e) de vouloir réinitialiser le portique ?",
    G0:"{{brand === 'r2w' ? 'Piste de lavage/Baie 0' : 'Piste de lavage/Baie 1'}}",
    G1:"{{brand === 'r2w' ? 'Piste de lavage/Baie 1' : 'Piste de lavage/Baie 2'}}",
    G2:"{{brand === 'r2w' ? 'Piste de lavage/Baie 2' : 'Piste de lavage/Baie 3'}}",
    G3:"{{brand === 'r2w' ? 'Piste de lavage/Baie 3' : 'Piste de lavage/Baie 4'}}",
    G4:"{{brand === 'r2w' ? 'Piste de lavage/Baie 4' : 'Piste de lavage/Baie 5'}}",
    G5:"{{brand === 'r2w' ? 'Piste de lavage/Baie 5' : 'Piste de lavage/Baie 6'}}",
    G6:"{{brand === 'r2w' ? 'Piste de lavage/Baie 6' : 'Piste de lavage/Baie 7'}}",
    G7:"{{brand === 'r2w' ? 'Piste de lavage/Baie 7' : 'Piste de lavage/Baie 8'}}",
    G8:"{{brand === 'r2w' ? 'Piste de lavage/Baie 8' : 'Piste de lavage/Baie 9'}}",
    G9:"{{brand === 'r2w' ? 'Piste de lavage/Baie 9' : 'Piste de lavage/Baie 10'}}",
    G10:"{{brand === 'r2w' ? 'Piste de lavage/Baie 10' : 'Piste de lavage/Baie 11'}}",
    U0:"{{brand === 'r2w' ? 'Aspirateur 0' : 'Aspirateur 1'}}",
    U1:"{{brand === 'r2w' ? 'Aspirateur 1' : 'Aspirateur 2'}}",
    U2:"{{brand === 'r2w' ? 'Aspirateur 2' : 'Aspirateur 3'}}",
    U3:"{{brand === 'r2w' ? 'Aspirateur 3' : 'Aspirateur 4'}}",
    U4:"{{brand === 'r2w' ? 'Aspirateur 4' : 'Aspirateur 5'}}",
    U5:"{{brand === 'r2w' ? 'Aspirateur 5' : 'Aspirateur 6'}}",
    U6:"{{brand === 'r2w' ? 'Aspirateur 6' : 'Aspirateur 7'}}",
    U7:"{{brand === 'r2w' ? 'Aspirateur 7' : 'Aspirateur 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Rapport du centre d'alerte créé par le site sélectionné depuis le tableau de bord.",
    ALERT_CENTER_TITLE_BY_FACILITY:"Rapport du centre d'alerte créé par la station de lavage sélectionnée depuis le tableau de bord.",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Rapport du centre d'alerte",
    ERROR_MESSAGE_403:"Vous n'avez pas le droit d'utiliser cet appel api. Code d'erreur : 403",
    LAST_ACTIVE_PROGRAM:"Programme actif/dernier programme actif",
    PROGRAM_ID:"Numéro de programme",
    PROGRAM_PRICE:"Prix du programme",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Recharge requise",
    EMPTY_CHEMICAL_LEVEL:"Vide",
    CHEMICAL_LEVEL:"Indication du niveau de détergents (%)",
    ROLLOVER_STATUS:" Statut du portique",
    ROLLOVER_STATUS_CODE_0:"Lavage actuellement en panne",
    ROLLOVER_STATUS_CODE_1:"Durée de fonctionnement extérieure",
    ROLLOVER_STATUS_CODE_2:"Saisie du programme autorisée",
    ROLLOVER_STATUS_CODE_3:"Mettez votre véhicule en position.",
    ROLLOVER_STATUS_CODE_4:"Avancez votre véhicule.",
    ROLLOVER_STATUS_CODE_5:"Reculez votre véhicule.",
    ROLLOVER_STATUS_CODE_6:"Arrêtez votre véhicule.",
    ROLLOVER_STATUS_CODE_7:"Lavage actif",
    ROLLOVER_STATUS_CODE_8:"Lavage arrêté",
    ROLLOVER_STATUS_CODE_9:"Lavage actif (tact)",
    ROLLOVER_STATUS_CODE_10:"Faites sortir votre véhicule en marche arrière",
    ROLLOVER_STATUS_CODE_11:"Arrêt d'urgence",
    ROLLOVER_STATUS_CODE_12:"Faites sortir votre véhicule en marche avant",
    ROLLOVER_STATUS_CODE_13:"Antigel actif",
    ROLLOVER_STATUS_CODE_14:"Interrupteur de sécurité avant activé",
    ROLLOVER_STATUS_CODE_15:"Interrupteur de sécurité arrière activé",
    ROLLOVER_STATUS_CODE_16:"Interrupteur de sécurité avant gauche activé",
    ROLLOVER_STATUS_CODE_17:"Interrupteur de sécurité avant droit activé",
    ROLLOVER_STATUS_CODE_18:"Interrupteur de sécurité arrière gauche activé",
    ROLLOVER_STATUS_CODE_19:"Interrupteur de sécurité arrière droit activé",
    ROLLOVER_STATUS_CODE_20:"Le véhicule est trop loin à gauche.",
    ROLLOVER_STATUS_CODE_21:"Le véhicule est trop loin à droite.",
    ROLLOVER_STATUS_CODE_22:"Portière gauche ouverte",
    ROLLOVER_STATUS_CODE_23:"Portière droite ouverte",
    ROLLOVER_STATUS_CODE_24:"Transporter détecté, mauvais programme de lavage sélectionné.",
    ROLLOVER_STATUS_CODE_25:"Détecteur de klaxon",
    ROLLOVER_STATUS_CODE_98:"Mode manuel/d'ajustement",
    ROLLOVER_STATUS_CODE_99:"Statut inconnu",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Code de statut non défini",
    ALARM:"Erreur critique",
    NO_ALARM:"Pas d'erreur critique",
    SOFTWARE_VERSION:" Version du logiciel",
    SOFTWARE_DATE:" Date du logiciel",
    SITE_ADDRESS:"Adresse du site",
    SECONDS:"Secondes",
    SERVICE_PART_NAME:"Nom du service :",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Compteur d'exploitation et d'entretien",
    OPERATION_COUNTER:"Compteur d'exploitation",
    SERVICE_COUNTER:"Compteur d'entretien",
    FAULT_CODE:"Code d'alerte",
    PRESSURE_TITLE:"Pression de l'air",
    TIME_TITLE:"Heure actuelle",
    COUNTRY_TITLE:"Pays",
    CITY_TITLE:"Ville",
    REGION_TITLE:"Région",
    SELECT_POINTS_TO_SEARCH:"Sélectionnez les points...",
    LOGS_HISTORY:"Historique des changements de paramètres ",
    ACTUATOR_REFERENCE:"Référence de l'opérateur",
    ACTUATOR_VALUE:"Valeur de l'opérateur",
    POINT_ID:"ID du point",
    VALIDATION_NOT_VALID_RANGE:"Gamme incorrecte",
    ENABLE_ROLLOVER_RESET:"En cochant cette case, vous confirmez avoir lu et accepté les instructions de sécurité.",
    CHANGE_OF_PARAMETERS:"Changement de paramètres",
    SELECT_OPTIONS:"Sélectionner les options",
    AUTOMATIC:"Automatique",
    DESALTING:"Fonction de dessalage",
    SEASON_WASH:"Programmes de lavage saisonniers",
    SPRING_PROGRAM:"Programmes de lavage de printemps",
    SUMMER_PROGRAM:"Programmes de lavage d'été",
    AUTUMN_PROGRAM:"Programmes de lavage d'automne",
    WINTER_PROGRAM:"Programmes de lavage d'hiver",
    DOOR_CONTROL:"Contrôle de la porte",
    SUMMER_DOOR_CONTROL:"Été, contrôle de la porte en mode été",
    WINTER_DOOR_CONTROL:"Hiver, contrôle de la porte en mode hiver",
    APPLY_PARAMETERS_CHANGES:"Appliquer les changements de paramètres",
    WORKING_SCHEDULES:"Heures de travail",
    HOLIDAY_SCHEDULES:"Horaires de vacances",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Les jours fériés ont été créés pour ce site.",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Les jours fériés ont été mis à jour pour ce site.",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Les jours fériés ont été supprimés pour ce site.",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Les heures de travail sont propagées.",
    HOLIDAY_SUCCESSFULLY_DELETED:"Les jours fériés ont été supprimés.",
    SB_MU_MB_2_2_0:" SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:" SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:" SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:" SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:" SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:" SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:" SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:" SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:" SB_OB_2_0_0_Trans",
    CB3_1_0_0:" CB3_1_0_0_Trans",
    CW35_3_0_0:" CW35_3_0_0_Trans",
    CW35_3_1_0:" CW35_3_1_0_Trans",
    CWB3_3_0_0:" CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Agent séchant à faible niveau de remplissage",
    CHEM_LEVEL_LOW_SHAMPOO:"Shampoing à faible niveau de remplissage",
    CHEM_LEVEL_LOW_FOAM:"Mousse à faible niveau de remplissage",
    CHEM_LEVEL_LOW_WAX_1:"Cire à faible niveau de remplissage",
    CHEM_LEVEL_LOW_POLISH_1:"Agent lustrant à faible niveau de remplissage",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Nettoyant pour jantes à faible niveau de remplissage",
    CHEM_LEVEL_LOW_WAX_2:"Cire à faible niveau de remplissage",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Lustrant pour roues à faible niveau de remplissage",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Nettoyant insectes à faible niveau de remplissage",
    CHEM_LEVEL_LOW_POLISH_2:"Agent lustrant à faible niveau de remplissage",
    CHEM_LEVEL_LOW_INTENSIVE:"Détergent intense à faible niveau de remplissage",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pluie de mousse à faible niveau de remplissage",
    CHEM_LEVEL_DRYING_AGENT:"Niveau de remplissage de l'agent de séchage",
    CHEM_LEVEL_SHAMPOO:"Niveau de remplissage du shampoing",
    CHEM_LEVEL_FOAM:"Niveau de remplissage de la mousse",
    CHEM_LEVEL_WAX_1:"Niveau de remplissage de la cire",
    CHEM_LEVEL_POLISH_1:"Niveau de remplissage de l'agent lustrant",
    CHEM_LEVEL_RIM_CLEANER:"Niveau de remplissage du nettoyant pour jantes",
    CHEM_LEVEL_WAX_2:"Niveau de remplissage de la cire",
    CHEM_LEVEL_TYRE_SHINE:"Niveau de remplissage du lustrant pour roues",
    CHEM_LEVEL_INSECT_REMOVER:"Niveau de remplissage du nettoyant insectes",
    CHEM_LEVEL_POLISH_2:"Niveau de remplissage de l'agent lustrant",
    CHEM_LEVEL_INTENSIVE:"Niveau de remplissage du détergent intense",
    CHEM_LEVEL_FOAM_RAIN:"Niveau de remplissage de la pluie de mousse",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Compteur d'entretien courroie de levage du rouleau de toit",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Compteur d'entretien courroie de levage du sécheur",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Compteur d'entretien brosse de toit du câble moteur",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Compteur d'entretien entretien de la pompe eau douce",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Compteur d'entretien entretien de la pompe eau usagée",
    DRYING_AGENT:"Agent de séchage",
    FOAM_DRYING_AGENT:"Agent de séchage mousse",
    SHAMPOO:"Shampoing",
    FOAM:"Mousse",
    BRUSH_FOAM:"Mousse brosse",
    WAX_1:"Cire",
    FOAM_WAX_1:"Cire mousse",
    POLISH_1:"Agent lustrant",
    RIM_CLEANING:"Nettoyant pour jantes",
    WAX_2:"Cire",
    FOAM_WAX_2:"Cire mousse",
    TYRE_SHINE:"Lustrant pour roues",
    INSECT_REMOVER:"Nettoyant insectes",
    POLISH_2:"Agent lustrant",
    INTENSIVE_BASIC:"Lavage intensif basique",
    INTENSIVE_SIDE:"Lavage intensif côté",
    INTENSIVE_ROOF_SPRAY_BAR:"Lavage intensif barre de pulvérisation toit",
    TAR_REMOVER:"Dégoudronnant",
    UNDER_CHASSIS_CONVERSATION:" Conversation sous le châssis",
    STATIONARY_PRE_SPRAY_ARCH:"Portique stationnaire prépulvérisation",
    FOAM_RAIN:"Pluie de mousse",
    PRE_CLEANING:"Prénettoyage",
    BRUSH:"Brosse",
    CARE:"Soin",
    DRYING:"Séchage",
    DRYING_LOW_NOISE:"Séchage moins bruyant",
    INTENSIVE_CLEANING:"Nettoyage intense",
    BRUSH_CLEANING:"Nettoyage à la brosse",
    EMPTY_RUN:"Fonctionnement à vide",
    DRYING_AID:"Accélérateur de séchage",
    WAX:"Cire",
    FOAM_WASH:"Lavage mousse",
    POLISH:"Agent lustrant",
    FOAM_POLISH:"Agent lustrant mousse",
    WHEEL_CLEANING:"Nettoyage des roues",
    HIGH_PRESSURE_ROOF:"Haute pression toit",
    HIGH_PRESSURE_SIDE:"Haute pression côté",
    DRYER_FORWARD:"Sécheur avant",
    DRYER_BACKWARD:"Sécheur arrière",
    DELETE_ALL_HOLIDAYS:"Supprimer tous les jours fériés pour ce site",
    CREATE_NEW_HOLIDAY:"Créer un nouveau jour férié",
    RESET_INPUTS:"Réinitialiser toutes les saisies de jour férié",
    TWENTY_FOUR_HOURS_OPEN:"Ouvert 24/24 h",
    EVERY_YEAR:"Annuellement",
    DELETE_HOLIDAY:"Supprimer le jour férié",
    ADD_NEW_HOLIDAY:"Ajouter un nouveau jour férié",
    HOLIDAYS_LIST:"Liste des jours fériés existants",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Supprimer tous les jours fériés pour ce site ?",
    VALIDATION_HOLIDAY_DATE:" Format incorrect, veuillez utiliser mm-jj.",
    FOR_DATE:"Pour la date",
    WITH_ID:"Avec ID",
    FROM_HOURS:"De (h)",
    FROM_MINUTES:"De (min)",
    TO_HOURS:"À (h)",
    TO_MINUTES:"À (min)",
    NOT_MATCH:"Ne correspond pas",
    START:"De",
    STOP:"À",
    DAILY_TIME:"Liste de 24 heures",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Réglage individuel de l'heure",
    PROGRAM_NOT_STARTED:"Le programme n'a pas encore commencé.",
    JETWASH:"Système de lavage en self-service",
    KARCHER_REPORT_1:"Portique : indication de la rotation par programme et au total",
    KARCHER_REPORT_2:"Portique : lavages commencés par programme et au total",
    KARCHER_REPORT_3:"Portique : lavages effectués par programme et au total",
    KARCHER_REPORT_4:"Portique : nombre de lavages commencés au moyen du terminal de paiement par programme et au total",
    KARCHER_REPORT_5:"Portique : nombre de lavages commencés manuellement par programme et au total",
    KARCHER_REPORT_6:"Portique : nombre de lavages annulés par programme et au total",
    KARCHER_REPORT_7:"Portique : nombre de défaillances de l'alimentation électrique",
    KARCHER_REPORT_8:"Unités SB : nombre d'heures par programme de lavage filtré par piste de lavage/baie et au total",
    KARCHER_REPORT_9:"Unités SB : indication de la rotation par piste de lavage/baie et au total",
    KARCHER_REPORT_10:"Unités SB : compteur de jetons/pièces par canal de pièce",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Pompe eau douce",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Pompe eau traitée",
    OPERATION_COUNTER_HP_PUMP_1:"Pompe haute pression 1",
    OPERATION_COUNTER_HP_PUMP_2:"Pompe haute pression 2",
    RELEASE_NOTES:" Versions de l'appli et notes de mise à jour",
    BACKEND_RELEASE_NOTES:"Notes de mise à jour de la plateforme :",
    FRONTEND_RELEASE_NOTES:"Notes de mise à jour de l'application web :",
    SELECTED_FACILITY_TIMEZONE:"Fuseau horaire de la station de lavage sélectionnée :",
    REFRESH_PAGE:"Rafraîchir la page",
    REFRESH_MAPS:"Rafraîchir les cartes",
    PUMPS:"Pompes",
    RUN_TIME:"Durée de fonctionnement",
    RUN_TIME1:"Durée de fonctionnement 1",
    RUN_TIME2:"Durée de fonctionnement 2",
    PROGRAM_RUNTIME_ACTUATOR:"Opérateur de la durée de fonctionnement",
    PROGRAM_RUNTIME_ACTUATOR_1:"Opérateur de la durée de fonctionnement 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Opérateur de la durée de fonctionnement 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"La valeur minimum est 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"La valeur maximum est 25",
    WASH_PROGRAM_MIN_MAX_VALIDATION:" Utiliser un format de prix x.xx",
    ACTUATION_NOT_ALLOWED:"L'activation n'est pas autorisée pour le rôle d'utilisateur actuel.",
    MAINTENANCE_DAYS:"Jours de maintenance",
    MAINTENANCE_WASHES:"Lavages de maintenance",
    DAILY_FINANCES_POS:"PDV",
    POS_INCOME:"Revenu total PDV",
    PROPAGATE:"Propager",
    ALL_DAY_HOURS_SELECTOR:"Sélecteur type 24 heures",
    GET_OPERATING_TIME_FROM_SITE:"Obtenir la durée de fonctionnement de l'appareil actuel depuis les heures de travail du site.",
    USER_NOT_VALID:"L'utilisateur n'est pas valide. Essayez avec un autre identifiant de compte.",
    VERIFIED:"Vérifié",
    RESEND_VERIFICATION_MAIL:"Envoyer un nouvel e-mail de vérification",
    RETURN_TO_DASHBOARD:"Retour au tableau de bord",
    ERROR_PAGE_BAD_REQUEST:" 400 requête non valide",
    WASHES:"Nombre de lavages",
    TIME_TO_SERVICE:"Entretien requis",
    ACCOUNT_ALREADY_ACTIVATED:"Compte déjà activé",
    DEVICE_EVENTS:"Événements de l'appareil",
    DEVICE_EVENTS_LOG_PULLED:"Journal des événements récupérés pour l'appareil",
    EVENTS_PULL_DATE:"Heure des événements récupérés :",
    DEVICE_EVENTS_REFRESH:"Récupérer de nouvelles données d'événements",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problème de connexion des Web sockets. Essayez de rafraîchir la page.",
    INSTALLATION_DATE:"Date d'installation de la machine",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Cire chaude",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Lavage haute pression",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Mousse de jante puissante",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Mousse puissante",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Arrêter",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Lavage à mousse HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Lavage",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Soins de haut niveau",
    INFO_TITLE:"Info",
    FOAM_WAX1:"Cire mousse",
    POLISH1:"Agent lustrant",
    WAX1:"Cire",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Détails du site mis à jour avec succès",
    COMPANY:"Société",
    FACILITY_HAS_CHANGER:"Avez-vous un changeur ?",
    DISABLE_OFFLINE_ALARM:"Désactiver les alarmes R2W",
    ASIDE_WORKING_SCHEDULES:"Détails du site de l'application",
    TERMS_OF_SERVICE_R2W_TITLE:"Conditions de service de Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Conditions de service de Ready2Wash",
    DATA_PROCESSING_TITLE:"Données traitées",
    PRIVACY_POLICY_TITLE:"Politique de confidentialité",
    READY_TO_PAY_TERMS_OF_SERVICE:"Conditions de service de Ready2Pay",
    TERMS_AND_SERVICES:"Termes et services",
    HOURLY: "Toutes les heures",
    DAILY: "Quotidien",
    WEEKLY: "Hebdomadaire",
    MONTHLY: "Mensuel",
    YEARLY: "Annuel",
    DELETE_ITEM_SUCCESS:"Vous avez supprimé l'élément avec succès",
    STATE: "État",
    AVAILABILITY_STATUS_1: "Unité ouverte",
    AVAILABILITY_STATUS_2: "Unité fermée (vacances)",
    AVAILABILITY_STATUS_3: "Unité fermée (heures d'ouverture)",
    AVAILABILITY_STATUS_4: "Unité fermée (panne)",
    AVAILABILITY_STATUS_5: "Unité fermée (autre)",
    AVAILABILITY_VACUUMS_STATUS_1: "Aspirateurs non installés",
    AVAILABILITY_VACUUMS_STATUS_2: "Aspirateurs ouverts",
    AVAILABILITY_VACUUMS_STATUS_3: "Aspirateurs fermés (vacances)",
    AVAILABILITY_VACUUMS_STATUS_4: "Aspirateurs fermés (heures d'ouverture)",
    AVAILABILITY_VACUUMS_STATUS_5: "Aspirateurs fermés (panne)",
    AVAILABILITY_VACUUMS_STATUS_6: "Aspirateurs fermés (autre)",
    ECOM_AMOUNT: "Total Ecom pour tous les sites",
    CAPTURED: "Capturé",
    DELETE_COMPANY_HISTORY_INFO:"Cette action supprimera toutes les données de rapport de votre entreprise. Cette action est irréversible.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Êtes-vous sûr de vouloir supprimer définitivement toutes les données de rapport ?",
    VALUE_DATE: "Date de valeur",
    KARCHER_EVENT_NAME_1: "Échangeur de base régénéré",
    KARCHER_EVENT_NAME_2: "Régénération de l'échangeur de base terminée",
    KARCHER_EVENT_NAME_3: "Matériel / numéro de série",
    KARCHER_EVENT_NAME_4: "Le système a été désinfecté",
    KARCHER_EVENT_NAME_5: "Pompe HP 1 désinfectée",
    KARCHER_EVENT_NAME_6: "Pompe HP 2 désinfectée",
    KARCHER_EVENT_NAME_7: "Pompe HP 3 désinfectée",
    KARCHER_EVENT_NAME_8: "Pompe HP 4 désinfectée",
    KARCHER_EVENT_NAME_9: "Pompe HP 5 désinfectée",
    KARCHER_EVENT_NAME_10: "Station de lavage 1 verrouillée",
    KARCHER_EVENT_NAME_11: "Station de lavage 2 verrouillée",
    KARCHER_EVENT_NAME_12: "Station de lavage 3 verrouillée",
    KARCHER_EVENT_NAME_13: "Station de lavage 4 verrouillée",
    KARCHER_EVENT_NAME_14: "Station de lavage 5 verrouillée",
    KARCHER_EVENT_NAME_15: "Station de lavage 6 verrouillée",
    KARCHER_EVENT_NAME_16: "Station de lavage 7 verrouillée",
    KARCHER_EVENT_NAME_17: "Station de lavage 8 verrouillée",
    KARCHER_EVENT_NAME_18: "Mise à jour démarrée",
    KARCHER_EVENT_NAME_19: "Mise à jour terminée",
    KARCHER_EVENT_NAME_20: "Démarrage WS Reg",
    KARCHER_EVENT_NAME_21: "Fin WS Reg",
    KARCHER_EVENT_NAME_22: "Capteur WS 75%",
    KARCHER_EVENT_NAME_23: "Défaut technique",
    KARCHER_EVENT_NAME_24: "Défaut de fonctionnement",
    KARCHER_EVENT_NAME_25: "Unité activée",
    KARCHER_EVENT_NAME_26: "Unité désactivée",
    KARCHER_EVENT_NAME_27: "Boîte 1 fermée",
    KARCHER_EVENT_NAME_28: "Boîte 2 fermée",
    KARCHER_EVENT_NAME_29: "Boîte 3 fermée",
    KARCHER_EVENT_NAME_30: "Boîte 4 fermée",
    KARCHER_EVENT_NAME_31: "Boîte 5 fermée",
    KARCHER_EVENT_NAME_32: "Boîte 6 fermée",
    KARCHER_EVENT_NAME_33: "Boîte 7 fermée",
    KARCHER_EVENT_NAME_34: "Boîte 8 fermée",
    KARCHER_EVENT_NAME_35: "Station des pompes HP 1",
    KARCHER_EVENT_NAME_36: "Station des pompes HP 2",
    KARCHER_EVENT_NAME_37: "Station des pompes HP 3",
    KARCHER_EVENT_NAME_38: "Station des pompes HP 4",
    KARCHER_EVENT_NAME_39: "Station des pompes HP 5",
    KARCHER_EVENT_NAME_40: "Station des pompes HP 6",
    KARCHER_EVENT_NAME_41: "Station des pompes HP 7",
    KARCHER_EVENT_NAME_42: "Station des pompes HP 8",
    KARCHER_EVENT_NAME_43: "Brûleur",
    KARCHER_EVENT_NAME_44: "Ventilateur du brûleur",
    KARCHER_EVENT_NAME_45: "Pompe à eau chaude",
    KARCHER_EVENT_NAME_46: "Pompe antigel",
    KARCHER_EVENT_NAME_47: "Pompe à osmose",
    KARCHER_EVENT_NAME_48: "Chauffage par le sol",
    KARCHER_EVENT_NAME_49: "Chauffage du tuyau",
    KARCHER_EVENT_NAME_50: "Nettoyage micro / jantes",
    KARCHER_EVENT_NAME_51: "Pompe de lavage sous-châssis",
    KARCHER_EVENT_NAME_52: "Pompe booster mousse",
    KARCHER_EVENT_NAME_53: "Aspirateur 1",
    KARCHER_EVENT_NAME_54: "Aspirateur 2",
    KARCHER_EVENT_NAME_55: "Aspirateur 3",
    KARCHER_EVENT_NAME_56: "Aspirateur 4",
    KARCHER_EVENT_NAME_57: "Aspirateur 5",
    KARCHER_EVENT_NAME_58: "Aspirateur 6",
    KARCHER_EVENT_NAME_59: "Aspirateur 7",
    KARCHER_EVENT_NAME_60: "Aspirateur 8",
    KARCHER_EVENT_NAME_61: "Aspirateur 9",
    KARCHER_EVENT_NAME_62: "Aspirateur 10",
    KARCHER_EVENT_NAME_63: "Aspirateur 11",
    KARCHER_EVENT_NAME_64: "Aspirateur 12",
    KARCHER_EVENT_NAME_65: "Pompe de nettoyage des jantes",
    KARCHER_EVENT_NAME_66: "Pompe Microe.",
    KARCHER_EVENT_NAME_67: "Pompe intensive",
    KARCHER_EVENT_NAME_68: "Turbine de l'aspirateur 1",
    KARCHER_EVENT_NAME_69: "Filtre de l'aspirateur 1",
    KARCHER_EVENT_NAME_70: "Turbine de l'aspirateur 2",
    KARCHER_EVENT_NAME_71: "Filtre de l'aspirateur 2",
    KARCHER_EVENT_NAME_72: "Turbine de l'aspirateur 3",
    KARCHER_EVENT_NAME_73: "Filtre de l'aspirateur 3",
    KARCHER_EVENT_NAME_74: "Turbine de l'aspirateur 4",
    KARCHER_EVENT_NAME_75: "Filtre de l'aspirateur 4",
    KARCHER_EVENT_NAME_76: "Turbine de l'aspirateur 5",
    KARCHER_EVENT_NAME_77: "Filtre de l'aspirateur 5",
    KARCHER_EVENT_NAME_78: "Turbine de l'aspirateur 6",
    KARCHER_EVENT_NAME_79: "Filtre de l'aspirateur 6",
    KARCHER_EVENT_NAME_80: "Turbine de l'aspirateur 7",
    KARCHER_EVENT_NAME_81: "Filtre de l'aspirateur 7",
    KARCHER_EVENT_NAME_82: "Turbine de l'aspirateur 8",
    KARCHER_EVENT_NAME_83: "Filtre de l'aspirateur 8",
    KARCHER_EVENT_NAME_84: "Turbine de l'aspirateur 9",
    KARCHER_EVENT_NAME_85: "Filtre de l'aspirateur 9",
    KARCHER_EVENT_NAME_86: "Turbine de l'aspirateur 10",
    KARCHER_EVENT_NAME_87: "Filtre de l'aspirateur 10",
    KARCHER_EVENT_NAME_88: "Turbine de l'aspirateur 11",
    KARCHER_EVENT_NAME_89: "Filtre de l'aspirateur 11",
    KARCHER_EVENT_NAME_90: "Turbine de l'aspirateur 12",
    KARCHER_EVENT_NAME_91: "Filtre de l'aspirateur 12",
    INSERT_TOKEN: "Insérez les jetons et démarrez le service",
    OPEN_SESSION: "Session ouverte avec succès",
    IN_PROGRESS: "En cours ...",
    TOKEN_INSERTED: "Jetons insérés avec succès",
    EXPIRED_SESSION: "Session expirée",
    TWO_DIGIT_INTEGER_VALIDATION: "Utilisez un entier de deux chiffres maximum",
    KARCHER_OPERATION_COUNTER_1: "Zone de lavage 1, pompe HP",
    KARCHER_OPERATION_COUNTER_2: "Zone de lavage 1, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_3: "Zone de lavage 1, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_4: "Zone de lavage 1, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_5: "Zone de lavage 1, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_6: "Zone de lavage 2, pompe HP",
    KARCHER_OPERATION_COUNTER_7: "Zone de lavage 2, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_8: "Zone de lavage 2, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_9: "Zone de lavage 2, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_10: "Zone de lavage 2, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_11: "Zone de lavage 3, pompe HP",
    KARCHER_OPERATION_COUNTER_12: "Zone de lavage 3, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_13: "Zone de lavage 3, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_14: "Zone de lavage 3, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_15: "Zone de lavage 3, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_16: "Zone de lavage 4, pompe HP",
    KARCHER_OPERATION_COUNTER_17: "Zone de lavage 4, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_18: "Zone de lavage 4, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_19: "Zone de lavage 4, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_20: "Zone de lavage 4, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_21: "Zone de lavage 5, pompe HP",
    KARCHER_OPERATION_COUNTER_22: "Zone de lavage 5, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_23: "Zone de lavage 5, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_24: "Zone de lavage 5, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_25: "Zone de lavage 5, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_26: "Zone de lavage 6, pompe HP",
    KARCHER_OPERATION_COUNTER_27: "Zone de lavage 6, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_28: "Zone de lavage 6, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_29: "Zone de lavage 6, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_30: "Zone de lavage 6, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_31: "Zone de lavage 7, pompe HP",
    KARCHER_OPERATION_COUNTER_32: "Zone de lavage 7, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_33: "Zone de lavage 7, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_34: "Zone de lavage 7, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_35: "Zone de lavage 7, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_36: "Zone de lavage 8, pompe HP",
    KARCHER_OPERATION_COUNTER_37: "Zone de lavage 8, pompe de produits chimiques 1",
    KARCHER_OPERATION_COUNTER_38: "Zone de lavage 8, pompe de produits chimiques 2",
    KARCHER_OPERATION_COUNTER_39: "Zone de lavage 8, pompe de produits chimiques 3",
    KARCHER_OPERATION_COUNTER_40: "Zone de lavage 8, pompe de produits chimiques 4",
    KARCHER_OPERATION_COUNTER_41: "Pompe à osmose",
    KARCHER_OPERATION_COUNTER_42: "Générateur d’eau chaude",
    KARCHER_OPERATION_COUNTER_43: "Pompe de protection antigel",
    KARCHER_OPERATION_COUNTER_44: "Insert de filtre WSO",
    KARCHER_OPERATION_COUNTER_45: "Pompe de chauffage de la piste de lavage",
    KARCHER_OPERATION_COUNTER_46: "Pompe à eau chaude",
    KARCHER_OPERATION_COUNTER_47: "Chauffage du flexible de mousse",
    KARCHER_OPERATION_COUNTER_48: "Pompe de nettoyage de jantes",
    KARCHER_OPERATION_COUNTER_49: "Pompe de micro-émulsion",
    KARCHER_OPERATION_COUNTER_50: "Pompe de mousse intensive",
    KARCHER_OPERATION_COUNTER_51: "Aspirateur 1, turbine 1",
    KARCHER_OPERATION_COUNTER_52: "Aspirateur 1, filtre 1",
    KARCHER_OPERATION_COUNTER_53: "Aspirateur 1, turbine 2",
    KARCHER_OPERATION_COUNTER_54: "Aspirateur 1, filtre 2",
    KARCHER_OPERATION_COUNTER_55: "Aspirateur 2, turbine 1",
    KARCHER_OPERATION_COUNTER_56: "Aspirateur 2, filtre 1",
    KARCHER_OPERATION_COUNTER_57: "Aspirateur 2, turbine 2",
    KARCHER_OPERATION_COUNTER_58: "Aspirateur 2, filtre 2",
    KARCHER_OPERATION_COUNTER_59: "Aspirateur 3, turbine 1",
    KARCHER_OPERATION_COUNTER_60: "Aspirateur 3, filtre 1",
    KARCHER_OPERATION_COUNTER_61: "Aspirateur 3, turbine 2",
    KARCHER_OPERATION_COUNTER_62: "Aspirateur 3, filtre 2",
    KARCHER_OPERATION_COUNTER_63: "Aspirateur 4, turbine 1",
    KARCHER_OPERATION_COUNTER_64: "Aspirateur 4, filtre 1",
    KARCHER_OPERATION_COUNTER_65: "Aspirateur 4, turbine 2",
    KARCHER_OPERATION_COUNTER_66: "Aspirateur 4, filtre 2",
    KARCHER_OPERATION_COUNTER_67: "Aspirateur 5, turbine 1",
    KARCHER_OPERATION_COUNTER_68: "Aspirateur 5, filtre 1",
    KARCHER_OPERATION_COUNTER_69: "Aspirateur 5, turbine 2",
    KARCHER_OPERATION_COUNTER_70: "Aspirateur 5, filtre 2",
    KARCHER_OPERATION_COUNTER_71: "Aspirateur 6, turbine 1",
    KARCHER_OPERATION_COUNTER_72: "Aspirateur 6, filtre 1",
    KARCHER_OPERATION_COUNTER_73: "Aspirateur 6, turbine 2",
    KARCHER_OPERATION_COUNTER_74: "Aspirateur 6, filtre 2",
    KARCHER_OPERATION_COUNTER_75: "Vider l’eau de condensation du compresseur",
    KARCHER_OPERATION_COUNTER_76: "Vérifier le système antigel",
    KARCHER_OPERATION_COUNTER_77: "Soufflerie du brûleur",
    KARCHER_OPERATION_COUNTER_78: "Augmentation de pression Mousse",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "La liste des données est supérieure à 10000 éléments",
    KARCHER_POINT_NAME_1: "Jour férié",
    KARCHER_POINT_NAME_2: "Lundi",
    KARCHER_POINT_NAME_3: "Mardi",
    KARCHER_POINT_NAME_4: "Mercredi",
    KARCHER_POINT_NAME_5: "Jeudi",
    KARCHER_POINT_NAME_6: "Vendredi",
    KARCHER_POINT_NAME_7: "Samedi",
    KARCHER_POINT_NAME_8: "Dimanche",
    KARCHER_POINT_NAME_9: "Aspirateurs Jour férié",
    KARCHER_POINT_NAME_10: "Aspirateurs Lundi",
    KARCHER_POINT_NAME_11: "Aspirateurs Mardi",
    KARCHER_POINT_NAME_12: "Aspirateurs Mercredi",
    KARCHER_POINT_NAME_13: "Aspirateurs Jeudi",
    KARCHER_POINT_NAME_14: "Aspirateurs Vendredi",
    KARCHER_POINT_NAME_15: "Aspirateurs Samedi",
    KARCHER_POINT_NAME_16: "Aspirateurs Dimanche",
    KARCHER_POINT_NAME_17: "Éclairage Jour férié",
    KARCHER_POINT_NAME_18: "Éclairage Lundi",
    KARCHER_POINT_NAME_19: "Éclairage Mardi",
    KARCHER_POINT_NAME_20: "Éclairage Mercredi",
    KARCHER_POINT_NAME_21: "Éclairage Jeudi",
    KARCHER_POINT_NAME_22: "Éclairage Vendredi",
    KARCHER_POINT_NAME_23: "Éclairage Samedi",
    KARCHER_POINT_NAME_24: "Éclairage Dimanche",
    KARCHER_POINT_NAME_25: "Programme 0",
    KARCHER_POINT_NAME_26: "Programme 1",
    KARCHER_POINT_NAME_27: "Programme 2",
    KARCHER_POINT_NAME_28: "Programme 3",
    KARCHER_POINT_NAME_29: "Programme 4",
    KARCHER_POINT_NAME_30: "Programme 5",
    KARCHER_POINT_NAME_31: "Programme 6",
    KARCHER_POINT_NAME_32: "Programme 7",
    KARCHER_POINT_NAME_33: "Programme 8",
    KARCHER_POINT_NAME_34: "Programme 9",
    KARCHER_POINT_NAME_35: "Programme 10",
    KARCHER_POINT_NAME_36: "Programme 11",
    KARCHER_POINT_NAME_37: "Programme 12",
    KARCHER_POINT_NAME_38: "Programme 13",
    KARCHER_POINT_NAME_39: "Programme 14",
    KARCHER_POINT_NAME_40: "Programme 15",
    KARCHER_POINT_NAME_41: "Programme 16",
    KARCHER_POINT_NAME_42: "Programme 17",
    KARCHER_POINT_NAME_43: "Programme 18",
    KARCHER_POINT_NAME_44: "Programme 19",
    KARCHER_POINT_NAME_45: "Programme 20",
    KARCHER_POINT_NAME_46: "Programme 21",
    KARCHER_POINT_NAME_47: "Programme 22",
    KARCHER_POINT_NAME_48: "Programme 23",
    KARCHER_POINT_NAME_49: "Programme 24",
    KARCHER_POINT_NAME_50: "Programme 25",
    KARCHER_POINT_NAME_51: "Programme 26",
    KARCHER_POINT_NAME_52: "Programme 27",
    KARCHER_POINT_NAME_53: "Programme 28",
    KARCHER_POINT_NAME_54: "Programme 29",
    KARCHER_POINT_NAME_55: "Programme 30",
    KARCHER_POINT_NAME_56: "Programme 31",
    KARCHER_POINT_NAME_57: "Programme 32",
    QR_CODE: "Code QR",
    ACCEPT_TERMS_AND_CONDITIONS: "Accepter les conditions générales",
    CREATE_AND_PRINT_VOUCHERS: "Créer et imprimer les coupons",
    CODE_PREFIX_QUESTION: "Le préfixe du code n'est pas saisi",
    CODE_PREFIX_QUESTION_TEXT: "Voulez-vous continuer sans préfixe de code ?",
    ISSUED_DATE: "Date d'émission",
    VOUCHER_VALIDITY_DAYS: "Validité du coupon (jours)",
    VALIDATION_ONLY_NUMBERS: "Seuls les chiffres sont autorisés",
    REPRINT_VOUCHERS: "Imprimer une copie des coupons",
    EXPIRY_DATE: "Valable jusqu'au"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("fiTranslations", {
    MESSAGE:"Ilmoitus",
    ERROR_TITLE:"Virhe",
    ERROR_MESSAGE:"Toiminnon suorittamisessa tapahtui virhe",
    ERROR_LOGIN:"Sisäänkirjautumisessa tapahtui virhe. Sähköpostiosoite tai salasana ei kelpaa",
    ERROR_LOGIN_ROLE:"Role for current application brand is not valid",
    OK:"OK",
    CANCEL:"Peruuta",
    YES:"Kyllä",
    NO:"Ei",
    FROM:"Alkaen",
    TO:"Päättyen",
    DELETE:"Poista",
    SIGN_OUT:"Kirjaudu ulos",
    NAME:"Nimi",
    DATE:"Päiväys",
    PIECES:"Kappaletta",
    HOURS:"Tuntia",
    DAYS:"Päivää",
    MONTH:"Kuukausi",
    MONTHS:"Kuukautta",
    YEAR:"Vuosi",
    BOX:"Box",
    SEARCH:"Haku",
    ALL_USERS:"Kaikki käyttäjät",
    ARE_YOU_SURE:"Oletko varma?",
    BACK:"Takaisin",
    AMOUNT:"Määrä",
    DESCRIPTION:"Kuvaus",
    FORGOT_PASSWORD_ERROR_MSG:"Jokin meni pieleen. Tarkasta sähköpostiosoitteesi ja yritä uudelleen",
    REQUIRED_FIELD:"Pakollinen kenttä",
    LOGOUT_TITLE:"Oletko varma, että haluat kirjautua ulos?",
    LOGOUT_MSG:"Kaikki tallentamattomat tiedot katoavat",
    ACTIVATION_ACCOUNT:"Tilisi aktivointi onnistui",
    UNKNOWN_ERRROR_NOTIFICATION:"Tuntematon virhe",
    CONTINUE:"Jatka",
    DATA_NOT_AVAILABLE:"Tietoja ei ole saatavilla",
    SELECT:"Valitse",
    SELECT_CURRENCY:"Valitse valuutta",
    UPLOAD:"Lataa",
    PHONE:"Puhelin",
    WEBSITE:"Nettisivu",
    WORKING_HOURS:"Aukioloaika",
    INSERT:"Lisää",
    TEXT:"Teksti",
    CREATED:"Luotu",
    VALID_UNTIL:"Voimassa asti",
    SAVE:"Tallenna",
    TOKENS:"Poletit",
    DELETE_COMPANY_HISTORY:"Poista yrityshistoria ",
    DELETE_COMPANY_HISTORY_MESSAGE:" VAROITUS: Tämän painikkeen painamisen jälkeen kaikki autopesusi tapahtumat poistetaan pysyvästi! Näitä tietoja ei voida palauttaa poistamisen jälkeen.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Oletko varma, että haluat pysyvästi poistaa tapahtumatiedot?",
    HISTORY_SUCCESSFULY_DELETED:"Historia poistettu onnistuneesti",
    HELP:"Apua",
    VALUE:"Arvo",
    ACTIVATING_ACCOUNT_ERROR:"R2W tilin aktivoinnissa tapahtui virhe. Yritä uudelleen ja ongelman uusiutuessa ota yhteyttä meidän tukeen: support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Tervetuloa Kärcher Car Wash sovellukseen",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Tervetuloa R2W:lle",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Syötä uusi salasanasi ja vahvista se aktivoidaksesi R2W tilisi. Teidät kirjataan automaattisesti sisään onnistumisen merkiksi",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Voit muuttaa tilisi asetuksia myöhemmin aplikaatiossa",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:"R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Syötä uusi salasanasi ja vahvista se vaihtaaksesi vanha salasanasi. Teidät kirjataan automaattisesti sisään oonistumisen merkiksi",
    RESET_PASSWORD_WELCOME_MSG_3:"Voit muuttaa tilisi asetuksia myöhemmin aplikaatiossa",
    ENTER_NEW_PASSWORD:"Syötä uusi salasana",
    REPEAT_NEW_PASSWORD:"Syötä uusi salasana uudelleen",
    PASSWORD_MIN_LENGTH:"Salasanan pitää olla vähintään 8 merkkiä pitkä",
    PASSWORD_MAX_LENGHT:"Salasanan täytyy olla alle 32 merkkiä pitkä",
    PASSWORD_PATTERN:"Salasanan täytii sisältää vähintään yksi iso kirjain ja yksi pieni kirjain",
    PASSWORD_MATCH:"Salasanat eivät täsmää",
    ACTIVATE:"Aktivoi",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:" Lähetit pyynnön onnistuneesti. Tarkista sähköpostistasi vahvistusviesti",
    VALIDATION_REQUIRED:"Pakollinen kenttä",
    VALIDATION_EMAIL:"Virheellinen sähköpostiosoite",
    VALIDATION_INTEGER_NUMBER:"Anna kokonaislukuarvo",
    VALIDATION_HOURS_VALUE:"Arvon täytyy olla väliltä 0-23",
    VALIDATION_MINUTES_VALUE:"Arvon täytyy olla väliltä 0-59",
    VALIDATION_NOT_A_DATE:"Arvo ei ole päivämäärä",
    VALIDATION_FROM:"Päivämäärästä alkaen",
    VALIDATION_TO:"Päivämäärään asti",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Kyseinen tietue on jo olemassa tietokannassa",
    PASSWORD_VALIDATION_PATTERN_NEW:"Salasanan täytyy sisältää vähintään yksi numero, yksi pieni kirjain ja yksi iso kirjain. Välilyönnit eivät ole sallittu",
    VALIDATION_PERCENT_VALUE:"Arvon täytyy olla väliltä 1-999",
    NUMBERS_ONLY_100:"Lukumäärä sataan asti",
    NUMBERS_ONLY_1000:"Lukumäärä tuhanteen asti",
    POSITIVE_NUMBERS_ONLY:"Vain numero",
    GRID_PAGER_PAGE:"Sivu",
    GRID_PAGER_ROWS_PER_PAGE:"Riviä sivulla",
    GRID_PAGER_PAGE_OF:"yhteensä",
    BREAD_CRUMBS_HOME:"Koti",
    BREAD_CRUMBS_DASHBOARD_TECH:"Dashboard technology",
    BREAD_CRUMBS_DETAILS:"Tiedot",
    BREAD_CRUMBS_SETTINGS:"Asetukset",
    BREAD_CRUMBS_WORKING_HOURS:"Käyttötunnit",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Päivä liikevaihto raportti",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Keskiarvo liikevaihto tunneittain",
    BREAD_CRUMBS_NEW_USER_GROUP:"Luo käyttäjäryhmä",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Muokka käyttäjäryhmää",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Luo kampanjasivu",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Muokkaa kampanjasivua",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Luo kampanja",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Muokkaa kampanjaa",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Jakson yhteenveto",
    LOGIN:"Kirjaudu sisään",
    EMAIL:"Sähköposti",
    PASSWORD:"Salasana",
    LANGUAGE:"Kieli",
    FORGOT_PASSWORD:"Unohtuiko salasana?",
    SUBMIT:"Lähetä",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Odottavien hälytysten määrä",
    HEADER_VIEW_ALL_ALARMS:"Näytä kaikki hälyytykset",
    HEADER_MY_ACCOUNT:"Minun tilini",
    HEADER_ACCOUNT_MANAGEMENT:"Tilin hallinta",
    ACCOUNT_ALREADY_EXIST:"Sähköposti on jo käytössä",
    NEWSLETTER_CONFIRMATION:"Lähetä sähköposti vikatilasta",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Päivittäinen talouskatsaus",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Dashboard Technology",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Etusivu",
    ASIDE_MENU_ALARMS:"Viestit",
    ASIDE_MENU_FACILITIES:"Facilities",
    ASIDE_MENU_REPORTS:"Raportit",
    ASIDE_MENU_REPORT:"Valittu raportti",
    ASIDE_MENU_LOYALTY:"Uskollisuus",
    ASIDE_MENU_USER_GROUPS:"Käyttäjäryhmät",
    ASIDE_MENU_PERIODIC_SUMMARY:"Aikajakson yhteenveto",
    ASIDE_MENU_MANAGING_TOKENS:"Polettien hallinta",
    ASIDE_MENU_NEWS:"Uutiset",
    DAILY_FINANCES_TOTAL_MONEY:"Rahaa yhteensä",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Rahaa yhteensä kaikki laitteet",
    DAILY_FINANCES_TOTAL_COINS:"Metallisia polettia käytetty yhteensä",
    DAILY_FINANCES_DOWNLOAD_CSV:"Lataa CSV",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Käteinen",
    DAILY_FINANCES_CHANGER:"Käteinen vaihtajassa",
    DAILY_FINANCES_COINS:"Tokens/Eurokey",
    REPORTS_FILTER:"Suodatin",
    REPORTS_TYPE_OF_REPORT:"Raportin tyyppi",
    REPORTS_CHOOSE_FACILITY:"Valitse laite",
    REPORTS_PERIOD_1:"Jakso 1",
    REPORTS_PERIOD_2:"Jakso 2",
    MONEY_BY_DATE_REPORT:"Päivän tulot",
    R2W_BY_DATE_REPORT:"Päivän tulot R2W poleteista",
    COINS_BY_DATE_REPORT:"Käytetyt poletit yhteensä per päivä",
    AVG_MONEY_BY_HOUR_REPORT:"Keskiarvo tulo per tunti",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Keskiarvo tulo päivässä per viikko",
    AVG_MONEY_BY_BOX_REPORT:"Kulutus per paikka",
    COMPARE_PERIODS_REPORT:"Laitteiden vertailuraportti",
    TOTAL_USERS_BY_GROUP:"Yhteenlasketut käynnit R2W aplikaatiossa päivässä",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"Käyttäjät",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"Käynnit",
    VISITS_COUNT_REPORT:"R2W aplikaation käyttäjät verrattuna käyntimäärään",
    LOYALTY_PER_DAY_REPORT:"Paikallisten polettien käyttö per päivä",
    LOYALTY_PER_PAYMENT_METHOD:"Annettuja paikallisia poletteja per maksutapa",
    VISITS:"Käyntejä",
    VISIT:"Käynti",
    TOTAL_SPENT_MONEY:"Yhteenlaskettu tulo",
    MONEY:"Raha",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Yhteenlaskettu tulo jaksolla",
    DOWNLOAD_CSV:"Lataa CSV",
    TOTAL_SPENT_COINS:"Poletteja käytetty yhteensä",
    TOTAL_USERS:"Käyttäjiä yhteensä",
    TOTAL_CREDIT_GIVEN:"Käytettyjen virtuaalisten polettejen määrä yhteensä",
    EUROKEY_BY_DATE_REPORT:"Total Eurokey payments by date",
    TOTAL_SPENT_EUROKEY:"Yhteenlaskettu kulutus",
    SELECT_TYPE_OF_REPORT:"Valitse raportin tyyppi",
    NUMBER_OF_VISITS_TITLE:"Käyntien määrä",
    NUMBER_OF_USERS_TITLE:"Käyttäjien määrä",
    PIECES_TITLE:"Kappaletta",
    TOTAL_VISITS:"Käynnit yhteensä",
    TOKENS_TITLE:"poletit",
    SEARCH_USERS_NO_RESULTS:"Käyttäjiä ei löytynyt valitulla hakutermillä",
    SEARCH_USERS:"Etsi käyttäjiä",
    SEARCH_TELEPHONES:"Etsi käyttäjiä puhelinnumerolla",
    ADD_USER_TO_GROUP:"Lisää käyttäjä ryhmään",
    REMOVE_USER_FROM_GROUP:"Poista käyttäjä ryhmästä",
    USER_GROUP_NAME_REQUIRED:"Käyttäjäryhmän nimi vaaditaan",
    USER_GROUP_NAME:"Käyttäjäryhmän nimi",
    USER_GROUPS_OVERVIEW:"Käyttäjäryhmien yhteenveto",
    USER_COUNT:"Käyttäjämäärä",
    NEW_USER_GROUP:"Luo uusi käyttäjäryhmä",
    DELETE_USER_GROUP:"Poista käyttäjäryhmä",
    UPDATE_USER_GROUP:"Muokkaa käyttäjäryhmää",
    DELETE_USER_GROUP_ERROR:"Käyttäjäryhmää poistettaessa tapahtui virhe. Yritä uudelleen tai ota yhteyttä tukeen.",
    CONFIRM_DELETE_USER_GROUP:"Oletko varma, että haluat poistaa valitun käyttäjäryhmän",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Uskollisuus toimenpiteet poistettavalle käyttäjäryhmälle ei ole enää käytössä",
    GROUP_NAME_MAX_LENGTH:"Ryhmän nimi pitää olla pienempi kuin 255 merkkiä",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Käyttäjä on jo valitussa ryhmässä",
    MISSING_USER:"Käyttäjä puuttuu",
    USER_NOT_ON_LIST:"Käyttäjä ei ole aktiivisessa käyttäjäryhmässä. Tarkasta onko sähköpostiosoite oikein ja yritä uudelleen",
    UPLOAD_USER_GROUP:"Lataa käyttäjäryhmä *.CSV tiedostosta",
    UKNOWN_USERS:"Tuntemattomien käyttäjien lista",
    CAMPAIGN_TEMPLATE_RULE:"Suodatin",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Kampanjasivua poistettaessa tapahtui virhe. Yritä uudelleen tai ota yhteyttä tukeen.",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Haluatko varmasti poistaa valitun kampanjasivun",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Haluatko varmasti poistaa valitun kampanjasivun",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Kampanjasivujen yhteenveto",
    DELETE_CAMPAIGN_TEMPLATE:"Poista kampanjasivu",
    UPDATE_CAMPAIGN_TEMPLATE:"Muokkaa kampanjasivua",
    CREATE_CAMPAIGN_TEMPLATE:"Luo kampanjasivu",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Kampanjasivun nimi vaaditaan",
    CAMPAIGN_TEMPLATE_NAME:"Kampanjasivun nimi",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Vaadittu kenttä",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"Anna prosentti %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"Ylimääräinen aika",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Valitse ensin tyyppi. Pesupaikkoja vai pieniä laitteita.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Poista sääntö",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Alkaen",
    CAMPAIGN_TEMPLATE_RULE_TO:"asti",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"tuntia",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuuttia",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Uusi sääntö käynti määrille",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Uusi sääntö käytetyille poleteille",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Uusi sääntö viikonpäiville",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Lisää sivun sääntö",
    CAMPAIGN_TEMPLATE_RULE_1:"Jokainen",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Jokainen",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"poletteja käytetty vähemmän kuin",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"käyntejä vähemmän kuin",
    CAMPAIGN_TEMPLATE_RULE_3:"päiviä",
    CAMPAIGN_TEMPLATE_RULE_4:"poletteja",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Sääntölistaus on tyhjä",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Päivämäärä ei voi olla menneisyydessä",
    DELETE_CAMPAIGN_ERROR:"Kampanjaa poistettaessa tapahtui virhe. Yritä uudelleen tai ota yhteyttä tukeen.",
    CONFIRM_DELETE_CAMPAIGN:"Haluatko varmasti poistaa valitun kampanjan?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W ei ole vastuussa tämän toimen aiheuttamasta käyttäjäkokemuksesta.",
    CAMPAIGNS_OVERVIEW:"Kampanjojen yhteenveto",
    DELETE_CAMPAIGN:"Poista kampanja",
    UPDATE_CAMPAIGN:"Muokkaa kampanjaa",
    CREATE_CAMPAIGN:"Luo uusi kampanja",
    CAMPAIGN_ACTIVE:"Aktiivinen",
    CAMPAIGN_TEMPLATE:"Pohja",
    CAMPAIGN_GROUPS:"Ryhmät",
    CAMPAIGN_ALL_USERS:"Kaikki käyttäjät",
    CAMPAIGN_NAME:"Kampanjan nimi",
    CAMPAIGN_NAME_REQUIRED:"Vaadittu",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Käyttäjien määrä lähellä kynnystä per päivä",
    MESSAGE_TO_USERS:"Viesti valituille käyttäjille",
    SEND_MESSAGE:"Lähetä viesti",
    THRESHOLD:"Kynnys",
    TYPE:"Tyyppi",
    TOTAL_MONEY_SPENT:"Rahaa käytetty kampanjan aikana yhteensä",
    NUMBER_OF_VISITS:"Käyntien määrä kampanjan aikana",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Viestin täytyy olla vähintään 10 merkkiä pitkä",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Viestin täytyy olla alle 350 merkkiä pitkä",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Viestin täytyy sisältää tekstiä",
    TECHNOLOGY:"Teknologia",
    TAP_WATER:"Juomavesi",
    REVERSE_OSMOSIS:"Käänteisosmoosi",
    SOFTENED_WATER:"Pehmennetty vesi",
    DOSER:"Annostelija",
    STATUS:"Tila",
    LAST_SYNCHRONIZATION:"Edellinen synkronointi",
    NO_OF_CURRENT_ALARMS:"Aktiivisten hälyytysten määrä",
    NO_OF_CURRENT_WARNINGS:"Aktiivisten varoitusten määrä",
    WEATHER:"Säätila",
    BOXES_WORK_HOURS_COUNTERS:"Pilttuiden käyttöajat",
    BOX_TOTAL_HOURS:"Kaikki käyttöajat",
    BOX_SERVICE_HOURS:"Kaikki käyttöajat (huolto)",
    BOX_COUNTER_HOURS:"tunnit",
    ALARMS_AND_WARNINGS:"Hälyytykset & varoitukset",
    FILTER_AND_BOILER:"Suodatin & lämmitin",
    FILTER_TOTAL_DAYS:"Suodattimen käyttöaika",
    BOILER_TOTAL_DAYS:"Lämmittimen käyttöaika",
    DAYS_UNIT:"Päiviä",
    SOFTENER:"Pehmennin",
    MANUAL_COLD_DRAIN:"Manuaalinen kylmätyhjennys",
    EL_COLD:"El. cold",
    DRAIN:"tyhjennys",
    TAP:"hana",
    WASTE:"Hukka",
    OSMOSIS:"osmoosi",
    DEMI_WATER:"Demi water",
    EL_RINSE:"El. m. rinse",
    BOILER:"Lämmitin",
    EL_WAX:"El. m. wax",
    FLOOR_HEATING:"Lattialämmitys",
    DOSER_TANK:"Annostelijan tankki",
    EL_WASH:"El. m. wash",
    DETERGENT:"Pesuaine",
    VIBRATOR:"Täristin",
    UPDATE_FACILITY_SETTINGS:"Päivitä säädöt",
    GENERAL_SETTINGS:"Yleiset asetukset",
    LIGHTS:"Valot",
    GROUPS:"Ryhmät",
    ANTI_FREEZE:"Pakkassuojaus",
    AUTO:"Automaattinen",
    MANUAL:"Manuaalinen",
    ON:"Päällä",
    OFF:"Pois",
    TEMPERATURE:"Lämpötila",
    UPDATE_DEVICE:"Päivitä laitteen asetuksia",
    BOX_CLEAN_HOURS:"Pilttuun puhdistus laskuri (tuntia)",
    GROUP_COUNTERS:"Ryhmän laskurit",
    RESET:"Nollaa",
    CASH_COUNT:"Kolikkojen määrä",
    COINS_COUNT:"Polettien määrä",
    EUROKEY_COUNT:"Eurokey count",
    DOSER_WORK:"Annostelijan käyntiaika (sekuntia)",
    DOSER_PAUSE:"Annostelijan taukoaika (sekuntia)",
    DELAY_BFV:"BFV delay (ms)",
    DELAY_6M1:"6M1 delay (ms)",
    DELAY_LPS:"LPS delay (ms)",
    RESET_CASH_COUNT_ALL:"Nollaa kaikki kolikkolaskurit",
    RESET_COINS_COUNT_ALL:"Nollaa kaikki polettilaskurit",
    RESET_EUROKEY_COUNT_ALL:"Reset all Eurokey counters",
    FACILITY_DETAILS:"Laitteen tiedot",
    FACILITY_NAME:"Laitteen nimi",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Kuva ladattu onnistuneesti",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Tiedot päivitetty onnistuneesti",
    CONNECTED:"Yhteydessä",
    DISCONNECTED:"Ei yhteyttä",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Viesti suodatin",
    FACILITY:"Laite",
    APPLY:"Käytä",
    TIME:"Aika",
    LOCATION:"Paikka",
    ACKNOWLEDGED:"Hyväksytty",
    FILTERED_MESSAGES:"Suodatetut viestit",
    ACK:"Hyväksytty",
    NOT_ACK:"Ei hyväksytty",
    ALL:"Kaikki",
    ALL_FACILITIES:"Kaikki laitteet",
    ENTER_DATE_PLACEHOLDER:"Syötä päivämäärä",
    OP_NESTANAK_NAPONA:"Missing voltage on phase indicator 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"High pressure pump circuit breaker dropped",
    OP_UPR_NAPON_24VAC_GRE:"Missing 24 VAC - circuit breaker 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Fresh water tank empty",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Mains water pump circuit breaker dropped",
    OP_MIN_NIVO_OMEKS_VODE:"Softened water tank empty",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Softened water pump circuit breaker dropped",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosis water tank empty",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Osmosis water pump circuit breaker dropped",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Osmosis production pump circuit breaker dropped",
    OP_BOJLER_GRESKA_MZS:"Water heater error",
    OP_CRPKA_PRASKA_GRE_MZS:"Hot water pump circuit breaker dropped",
    OP_DOZATOR_PRASKA_GRE_MZS:"Powder dosing motor circuit breaker dropped",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Powder dosing vibrator circuit breaker dropped",
    OP_MIN_PRASAK_TON_ALARM:"Powder mixing tank empty",
    OP_USIS_KOV_TURBINA_GRESKA:"Coin vacuuming turbine circuit breaker dropped",
    OP_FILTER_VODE_ZACEPLJEN:"Water filter blocked",
    OP_VISKTL_RESET_SATI_RADA:"High pressure pump service",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Water filter fault",
    OP_BOJLER_DANI_RADA:"Water heater fault",
    OPW_ALARM_VISOKOTL_PUMPA:"High pressure pump alarm",
    OPW_ALARM_FILTER_SERVIS:"Filter service alarm",
    OPW_ALARM_BOJLER_SERVIS:"Boiler service alarm",
    HAS_MEMBERS:"Valitussa ryhmässä on jäseniä ja sitä ei voida poistaa. Poista ensin jäsenet.",
    PERIODIC_SUMMARY_FOR:"Jakson yhteenveto raportti",
    PERIODIC_SUMMARY_REPORTS:"Jakson yhteenveto raportit",
    DATE_RANGE:"Päivämäärä väli",
    FINANCIAL_REPORT:"Liikevaihto raportti",
    GROSS_INCOME:"Bruttotulo",
    GROSS_INCOME_SUM:"Bruttotulo summa",
    COMMISSION_FEE:"Välityspalkkio",
    NET_INCOME:"Nettotulo (Laskutusta varten)",
    COMMISSION_FEE_DETAILS:"Välityspalkkio sisältää pankki / PayPal provision tai SMS palveluntarjoajien palkkion",
    LOYALTY_CREDITS_REPORT:"Paikallisten polettien raportti",
    LOYALTY_GIVEN:"Annettuja paikallisia poletteja",
    LOYALTY_USED:"Käytetyt paikalliset poletit",
    LOYALTY_SOLD:"Paikallisia poletteja ladattu",
    LOYALTY_TOTAL:"Yhteensä",
    LOYALTY_CURRENT_MONTH:"Kuluva kuukausi",
    SOMETHING_WENT_WRONG:"Jokin meni pieleen",
    MISSING_PAGE:"Pahoittelut, sivua ei löydy",
    TRY_AGAIN:"Yritä uudelleen",
    DEFAULT_ERROR_NAME:"Tuntematon virhe",
    DEFAULT_ERROR_DESCRIPTION:"Voitko yrittää uudelleen",
    MY_ACCOUNT_DETAILS:"Tilini tiedot",
    SAVE_CHANGES:"Tallenna muutokset",
    USERNAME:"Käyttäjänimi",
    FIRST_NAME:"Etunimi",
    LAST_NAME:"Sukunimi",
    USER_ROLE:"Käyttäjärooli",
    OLD_PASSWORD:"Vanha salasana",
    NEW_PASSWORD:"Uusi salasana",
    OLD_PASSWORD_REQUIRED:"Vanha salasana vaaditaan",
    NEW_PASSWORD_REQUIRED:"Uusi salasana vaaditaan",
    NEW_PASSWORD_REPEAT:"Vaaditaan uusi salasana uudelleen",
    NEW_PASSWORD_NOT_MATCH:"Salasanat eivät kohtaa",
    PASSWORD_DIFFERENT_VALIDATION:"Uuden salasanan täytyy olla eri kuin aikaisempi",
    PASSWORD_MIN_CHAR:"Salasanan pitää olla vähintään 8 merkkiä pitkä",
    PASSWORD_MAX_CHAR:"Salasana saa olla enintään 32 merkkiä pitkä",
    PASSWORD_PATTERN_VALIDATION:"Salasanan pitää sisältää vähintään yksi numero",
    ACCOUNT_MANAGEMENT:"Tilinhallinta",
    NOT_ACTIVE:"Ei aktiivinen",
    ASSIGN_ROLE:"Lisää rooli",
    UPDATE:"Päivitä",
    ADD_NEW_ACCOUNT:"Lisää uusi tili",
    EMAIL_REQUIRED:"Sähköpostiosoite vaaditaan",
    EMAIL_NOT_VALID:"Sähköpostiosoite ei ole hyväksytty",
    ADD_NEW_USER_TEXT:"Sähköposti joka sisältää aktivointilinkin on lähetetty annettuun sähköposti -osoitteeseen",
    UPDATE_USER_NOTIFICATION:"Tietosi on päivitetty onnistuneesti",
    CHANGED_PASSWORD_NOTIFICATION:"Salasanasi on päivitetty onnistuneesti",
    UPDATE_USER_GROUP_NOTIFICATION:"Käyttäjäryhmän nimi on päivitetty onnistuneesti",
    CREATE_USER_GROUP_NOTIFICATION:"Ryhmä on luotu onnistuneesti",
    DETELE_USER_GROUP_NOTIFICATION:"Ryhmä on poistettu onnistuneesti",
    EMPTY_GROUP_LIST_MSG:"Ryhmiä ei löydy. Aloita luomalla sellainen.",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Käyttäjä on onnistuneesti poistettu ryhmästä",
    ADD_USER_TO_GROUP_NOTIFICATION:"Käyttäjä on lisätty ryhmään onnistuneesti",
    ADD_USER_NOTIFICATION:"Lisäsit onnistuneesti uuden käyttäjän",
    DELETE_USER_NOTIFICATION:"Käyttäjän poisto onnistui",
    RESEND_USER_VERIFICATION_EMAIL:"Lähetit onnistuneesti uudelleen todentamis -sähköpostin",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Luo käyttäjäryhmän nimi",
    DELETE_USER:"Poista käyttäjä",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Haluatko varmasti poistaa käyttäjäryhmän?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Hyvä R2W käyttäjä",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Uskollisuussääntö käyntimäärälle",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Uskollisuussääntö käytetyille poleteille",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Uskollisuussääntö viikonpäivälle",
    REMOVE_CAMPAIGN_RULE_TITLE:"Kampanjasäännön poistaminen",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Haluatko varmasti poistaa kampanjasäännön?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Loit onnistuneesti uuden kampanjan",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Aktivoit kampanjan onnistuneesti",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Valmiita kampanjoita ei löydy. Aloita luomalla kampanja",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Viesti lähetetty onnistuneesti",
    COMPANY_ACCOUNTS:"Yritystilit",
    BUSSINESS_INVOICES_LIST:"Minun B2B laskut",
    LOCALE_TOKEN:"Paikallinen poletti",
    R2W:"Globaali poletti",
    START_MONTH:"Alku kuukausi",
    END_MONTH:"Loppu kuukausi",
    TOKEN_TYPE:"Poletin tyyppi",
    TOKEN_NUMBER:"Poletin numero",
    NOTHING_TO_DISPLAY:"* Ei näytettävää",
    CREATE_INVOICE:"Luo lasku",
    INVOICE:"Lasku",
    INVOICES:"Laskut",
    EDIT_INVOICE:"Muokkaa laskua",
    UPDATE_INVOICE_NOTIFICATION:"Muutit onnistuneesti laskun 'odottaa' tilaan",
    CURRENT_CHARGES:"Veloitukset nykyiseltä jaksolta",
    PAYMENTS_ON_HOLD:"Laskut käsittelyssä",
    FOR_INVOICING:"Laskutukseen",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Olet perumassa laskua",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Haluatko varmasti perua tämän laskun?",
    INVOICING_NOTIFICATION_HEADER:"Olet tekemässä laskutuksen",
    INVOICING_NOTIFICATION_TEXT:"Haluatko varmasti lähettää laskun?",
    SENT_INVOICE_NOTIFICATION:"Lasku lähetetty onnistuneesti",
    CANCELED_INVOICE_NOTIFICATION:"Lasku peruutettu onnistuneesti",
    INVOICE_DESCRIPTION_TEXT:"Lasku",
    INVOICE_STATE:"Laskun tila",
    INVOICE_NUMBER:"Laskun numero",
    INVOICE_TOTAL:"Yhteensä",
    SELECT_YEAR:"Valitse vuosi",
    DOWNLOAD:"Lataa PDF",
    INVOICE_NUMBER_HEADER:"Olet lähettämässä laskua numerolla",
    INVOICE_PAYMENT_CONFIRMATION:"Olet hyväksymässä maksua",
    INSERT_INVOICE_NUMBER:"Syötä laskun numero",
    INVOICED_WARNING:"Sähköpostia ei lähetetty. Ole hyvä ja odota ...",
    SEND_INVOICE:"Lähetä",
    INVOICE_ALL:"Kaikki",
    INVOICE_FROM_R2W:"R2W:ltä",
    INVOICE_TO_R2W:"R2W:lle",
    PAYMENT_REQUEST:"Maksupyyntö",
    PAYMENT_REQUEST_STATE:"Maksupyynnön tila",
    PAYMENT_REQUEST_NUMBER:"Maksupyynnön numero",
    FOR_PAYMENT_REQUEST:"Maksupyynnölle",
    PAYMENT_REQUEST_ON_HOLD:"Maksupyyntö käsittelyssä",
    DOWNLOAD_INVOICE:"Lataa lasku",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Lataus vaihtoehdot",
    B2B_SPEC:"B2B erittely",
    B2C_SPEC:"B2C Erittely",
    DOWNLOAD_PAYMENT_REQUEST:"Lataa maksupyyntö",
    LOYALTY_PREVIEW:"Uskollisuus katselmointi",
    ACTIVATED:"Aktivoitu",
    RUNNING:"Käynnissä",
    NOT_ACTIVATED:"Ei aktivoitu",
    FINISHED:"Valmis",
    DEPRECATED:"Käytöstä poistettu",
    UPCOMING:"Tulossa",
    NONE:"Yksilöllinen",
    STARTED:"Aloitettu",
    ENDS:"Päättyy",
    DEDICATED:"Omistettu",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Olet aktivoimassa",
    CAMPAIGN:"Kampanja",
    SEND_MESSAGE_NOTIFICATION:"Olet lähettämässä viestiä valitulle käyttäjäryhmälle",
    DIVISIBLE_TO_NUMBER:"Numeron tulee olla jaollinen",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Laitteen tyyppi",
    LISTENER:"Pienet laitteet",
    BRIDGE:"Pesupaikat",
    WASH_BOXES:"Pesupaikat",
    VACUUMS:"Imurit",
    SAVE_NEWS:"Tallenna uutiset",
    CREATE_NEW_NEWS:"Luo uusia uutisia",
    HISTORY_OF_ALL_NEWS:"Uutisten historia",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Kirjoita laitteen nimi",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Lisää laite",
    NEWS_TEXT:"Uutisten teksti",
    NEWS_TITLE:"Uutisten otsikko",
    DELETE_NEWS_CONFIRMATION:"Olet poistamassa uutisia",
    NEWS_DELETE_NOTIFICATION:"Uutiset poistettu onnistuneesti",
    NEWS_SAVE_NOTIFICATION:"Uutiset tallennettu onnistuneesti",
    NEWS_CREATION_DATE:"Luontipäivä",
    NO_TITLE:"Ei otsikkoa",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Uutisen tekstin täytyy olla lyhyempi kuin 255 merkkiä",
    NEWS_TEXT_REQUIRED_VALIDATION:"Uutisen teksti vaaditaan",
    NEWS_TITLE_REQUIRED_VALIDATION:"Uutisen otsikko vaaditaan",
    DEACTIVATE:"Deaktivoi",
    ASIDE_MENU_LOCAL_TOKENS:"Paikallisia poletteja",
    CREATE_NEW_LOCAL_TOKENS:"Anna uusia paikallisia poletteja",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:" Anna asiakkaan sähköpostiosoite ja paikallisten polettien määrä, jotka haluat antaa asiakkaalle",
    CREATE_TOKENS:"Anna poletteja",
    MINIMUM_ONE_TOKEN:"Arvon täytyy olla isompi kuin 0",
    CUSTOMER_EMAIL:"Asiakkaan sähköpostiosoite",
    AMOUNT_OF_TOKENS:"Polettien määrä",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Poletteja annettu onnistuneesti käyttäjälle",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Virhe annettaessa poletteja. Tarkasta asiakkaan sähköposti ja yritä uudelleen",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Annettujen polettien yhteenveto",
    ISSUED_AT:"Annettu kohteessa",
    ISSUED_BY:"Annettu toimesta",
    CODE:"Syötä koodi",
    REDEEMED_BY:"Lunastettu toimesta",
    REDEEMED_AT:"Lunastettu kohteessa",
    ASIDE_MENU_VOUCHERS:"Kupongit",
    PRINT:"Tulosta",
    VOUCHERS_OVERVIEW:"Kuponkejen yhteenveto",
    CREATE_NEW_VOUCHERS:"Luo uusia kuponkeja",
    CREATE_NEW_VOUCHERS_DESCRIPTION:" Luo uusi lunastettavissa oleva kuponkierä syöttämällä polettien määrä kuponkia kohden",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Polettien määrä kuponkia kohden",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Voit määrittää kupongille poletteja 1 ja 100 väliltä",
    NUMBER_OF_NEW_VOUCHERS:"Luotavien kuponkien määrä",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"You can create between 1 and {{size}} vouchers in a single batch",
    NEW_VOUCHERS_PREFIX:"Uusien kuponkien koodin etuliite",
    VALIDATION_VOUCHER_PREFIX:"Koodin etuliitteen pitää olla 4 merkkiä (Suuria kirjaimia ja/tai numeroita)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Uusien kuponkien luonnissa tapahtui virhe. Ole hyvä ja yritä uudelleen tai ota yhteyttä meidän asiakastukeen.",
    CREATE_VOUCHERS:"Luo kuponkeja",
    CREATING_VOUCHERS_SUCCESS:"Uudet kupongit luotiin onnistuneesti",
    PRINT_NEW_VOUCHERS:"Tulosta kuponkeja",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Syötä kuponkisarjan koodin etuliite tulostaaksesi koko kuponkisarjan. Vaihtoehtoisesti",
    PRINT_VOUCHERS_PREFIX:"Kuponki(sarjan) koodin etuliite",
    NO_VOUCHERS_FOR_PRINT:"Koodi etuliitettä vastaavia kuponkeja ei löytynyt tulostettavaksi",
    PRINT_VOUCHERS:"Tulosta kuponki/kuponkeja",
    VALIDATION_VOUCHER_CODE_FILTER:"Kupongin -haun pitää sisältää isojakirjaimia ja numeroita",
    FILTER_VOUCHERS_BY_CODE:"Hae kuponkeja lunastuskoodilla",
    FILTER_VOUCHERS:"Etsi kuponkeja",
    WASH_BOX:"Pesupaikka",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Digitaalisia polettia käytetty yhteensä",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Myydyt paikalliset poletit päivämäärän mukaan",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Käytetyt paikalliset poletit päivämäärän mukaan",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Annetut paikalliset poletit päivämäärän mukaan",
    LOCAL_TOKEN:"Paikallinen poletti",
    GIVEN_TOKEN:"Anna paikallisia poletteja",
    SOLD_TOKEN:"Myydyt paikalliset poletit",
    SMALL_MACHINES:"Pienet laitteet",
    R2W_Listener:"Listaaja",
    HHANLE_DEVICE:"HHanle pesupaikka",
    CODE_PREFIX_EXIST:"Koodin etuliite on jo käytössä",
    CODE_PREFIX_EXIST_TEXT:"Et voi luoda uutta kuponkia tällä koodin etuliitteellä. Ole hyvä ja syötä toinen.",
    MIN_FOUR_VALIDATION:"Tasan 4 merkkiä",
    ALL_INFORMATION_1:"Kaikki tiedot tästä",
    ALL_INFORMATION_2:"katoavat",
    ASIDE_MENU_TRANSACTIONS:"Tapahtumat",
    EXPENSES:"Kulut",
    TOPUPS:"Täydennykset",
    EXPENSES_LIST:"Kulujen listaus",
    USER_EMAIL:"Käyttäjä sähköposti",
    COMPANY_NAME:"Yrityksen nimi",
    TOPUPS_LIST:"Täydennyslista",
    CONSUMER:"Kuluttaja",
    SYSTEM_ADMIN:"Järjestelmän ylläpitäjä",
    MERCHANT_ADMIN:"Kauppiaan ylläpitäjä",
    COMPANY_ADMIN:"Yrityksen ylläpitäjä",
    FACILITY_ADMIN:"Laitteen ylläpitäjä",
    SUBSCRIBER:"Tilaaja",
    CONFIGURATOR:"Konfiguraattori",
    SETUP_UNIT_SERIAL_NO:"Sarjanumero",
    SETUP_UNIT_MATERIAL_NO:"Materiaalinumero",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi versio",
    TOTAL_TURNOVER:"Pesulaitteen liikevaihto",
    AVAILABILITY_ALL:"Saatavuus",
    AVAILIBILITY:"Pesupaikan saatavuus",
    AVAILABILITY_VACUUMS:"Imureiden saatavuus",
    WASH_BOX_INFO:"Pesupaikan tiedot",
    VACUUM_CLEANER_INFO:"Imureiden tiedot",
    BREAD_CRUMBS_SERVICE:"Palvelu",
    HOLIDAYS:"Lomat",
    HOLIDAY:"Loma",
    LIGHTS_ON:"Valot päälle",
    LIGHTS_OFF:"Valot pois",
    WASH_BOXES_ON:"Pesupaikka päällä",
    WASH_BOXES_OFF:"Pesupaikka pois päältä",
    VACUUMS_ON:"imurit päällä",
    VACUUMS_OFF:"imurit pois päältä",
    TURNOVER:"Liikevaihto",
    TURNOVER_MANUAL_WASH_UNIT:"Liikevaihto manuaalinen",
    STATUS_BAY_RUN_TIME:"Pesupaikan totaali käyttöaika",
    STATUS_BAY_PROGRAM_NAME:"Pesuohjelman nimi",
    STATUS_BAY_CREDIT:"Pesupaikan arvo",
    CLOUD_KREDIT:"Pilvessä oleva arvo",
    STATUS_VACUUM_RUN_TIME:"Imurin totaali käyttöaika",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Laitteen palvelut, pesupaikan ohjelma ja tämän hetkinen vikakoodi tilanne",
    UNAVAILABLE:"Laite ei ole käytettävissä",
    SHOW_HIDE_TABLE:"Näytä/piilota käyttötuntitaulukko",
    PROGRAM_NAME:"Ohjelman nimi",
    PROGRAM_COUNTER:"Ohjelma laskuri",
    NO_NAME:"Viitteellä ei ole nimeä",
    COUNTER_SERVICE_DATA:"Huoltotieto",
    NEED_SERVICE:"Huolto vaaditaan",
    PROGRAM_DATA:"Pesupaikan ohjelma -tieto",
    CURRENT_FAULT_DATA:"Tämän hetkiset viat",
    REFERENCE_DUE:"Mennessä",
    REFERENCE_SECONDS:"Sekuntia",
    REFERENCE_NAME:"Osan nimi",
    WASHBOX_NAME:"Pesupaikan nimi",
    FAULT_NAME:"Viankuvaus",
    FAULT_NUMBER:"Vikakoodi",
    CURRENT_FAULT_COUNT:"Aktiiviset viat",
    DEVICE_NOT_INSTALLED:"Laitetta ei ole asennettu",
    STATUS_READY:"Valmiina -tila",
    STATUS_ERROR:"Vikatila",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:"Ohjelmistovirhe",
    SOFTWARE_RESET:"Ohjelmistovirhe",
    EXTERNAL_PIN_RESET:"Ohjelmistovirhe",
    RESTART_OR_BROWNOUT_OCCURRED:"Ohjelmistovirhe",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Komponenttivirhe",
    COULD_NOT_SIMULATE_COIN:" Komponenttivirhe",
    ERROR_SETTING_INHIBIT_MODE:" Komponenttivirhe",
    OFFLINE_DEVICE:"Autonpesu Offline",
    TARIFFS:"Tariffit",
    DAY:"Päivä",
    NIGHT:"Yö",
    VOUCHER_CODE:"Kupongin koodi",
    DISMISS_ALARM:"Resetoi hälytys?",
    ALARM_ACTIVE:"Aktiiviset hälytykset",
    NO_ALARM_ACTIVE:"Ei aktiivisia hälytyksiä",
    ALARM_HISTORY:"Hälytys historia",
    MANAGING_TOKENS:"Polettien hallinta",
    EXPIRATION_DATE:"Vanhenemis aika",
    EXTEND_TOKEN_DATE:"Siirrä poletin vanhenemisaikaa",
    DELETE_TOKENS_FOR:"Poista poletit:",
    PUMP_TYPE:"Pumpun tyyppi",
    TURN_OFF_DEVICE:"Laitteen tila",
    OPERATION_DATA:"Käyttödata",
    PUMP_DATA:"Pumpun data",
    PUMP_NAME:"Pumpun nimi",
    POINT_NAME:"Pisteen nimi",
    CHANGER_INCOME:"Vaihtajan totaali tulo päivämäärän mukaan",
    SELECTED_OPEN:"Avoinna valittuna työaikana",
    ALWAYS_OPEN:"Avoinna aina (24/7)",
    CLOSED:"Suljettu",
    CLOSED_24:"Suljettu 24h",
    OPENED_24:"Avoinna 24h",
    MON:"Maanantai",
    TUE:"Tiistai",
    WED:"Keskiviikko",
    THU:"Torstai",
    FRI:"Perjantai",
    SAT:"Lauantai",
    SUN:"Sunnuntai",
    PRICING:"Hinnoittelu",
    PRICE:"Hinta",
    VALIDITY:"Voimassaolo",
    TOKEN_PACKAGES:"Polettipaketit",
    SINGLE_WASH:"Yksittäinen pesu",
    FACILITY_WORKING_HOURS:"Määritä käyttöajat valitulle laitteistolle",
    WORKING_HOURS_ALWAYS_OPEN:"Aina avoinna",
    WORKING_HOURS_ALWAYS_CLOSE:"Suljettu operaattorin toimesta",
    WORKING_HOURS_CUSTOM:"Syötä käyttöajat",
    KARCHER_ERROR_CODE:"Hälytyksen vikakoodi",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor buffer tank empty activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor buffer container empty and buffer contianer full switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor ro pump on and buffer container full switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organisaatio",
    CREATE_ORGANIZATION:"Luo organisaatio",
    CREATE_ORGANIZATION_AS:"Luo ali-organisaatio",
    DELETE_ORGANIZATION:"Poista organisaatio",
    EDIT_ORGANIZATION:"Muokkaa organisaatiota",
    SUPPORTED_ORG_NAME:"Tuettu organisaatio",
    SUPPORTED_ORG_TYPE:"Tuen tyyppi",
    ORG_NAME:"Nimi",
    ORG_TYPE:"Tyyppi",
    SET_ORG_TITLE:"Luo ali-organisaatio",
    SET_SUPPORTED_ORG_TITLE:"Aseta tuettu ali-organisaatio",
    SAVE_ORGANIZATION:"Tallenna organisaatio",
    SELECT_ORGANIZATION_TYPE:"Valitse organisaation tyyppi",
    SELECT_ORGANIZATION_SELECTOR:"Valitse",
    SELECT_SUPPORTED_ORGANIZATION:"Valitse tuettu organisaatio",
    ORGANIZATION_DELETED:"Organisaatio onnistuneesti poistettu",
    ORGANIZATION_SAVED:"Organisaatio onnistuneesti tallennettu",
    ORGANIZATION_UPDATED:"Organisaatio onnistuneesti päivitetty",
    ALERTS:"Hälytykset",
    DEVICE_STATUS:"Laitteen tila",
    SITE_DETAILS:"Kohteen tiedot",
    ALARM_STATUS:"hälytyksen tila",
    FILTER:"Suodatettu:",
    FILTER_BY_ALERT_CENTER:"Suodatettu koodin, nimen tai kuvauksen mukaisesti",
    TOTAL_ALARM:"Yhteensä",
    LOW_ALARM:"Tapahtuma",
    MEDIUM_ALARM:"Toimintahäiriö",
    HIGH_ALARM:"Kriittinen virhe",
    NO_FACILITIES_NEARBY:"Lähettyvillä ei ole laitteita",
    GRAY_MAP:"Harmaasävyinen kartta",
    READY:"Valmis",
    WARNING:"Toimintahäiriö",
    ERROR:"Virhe",
    SITE_NAME:"Kohteen nimi",
    ACCOUNTS_INFO:"Tilin tiedot",
    USER_ORGANIZATION:"Käyttäjä organisaatio",
    ADD_USER_ORGANIZATION:"Lisää uusi organisaatio käyttäjä",
    EDIT_USER_ORGANIZATION:"Muokkaa organisaation käyttäjiä",
    SELECT_ROLE:"Valitse rooli",
    SELECT_ORGANIZATION:"Valitse organisaatio",
    SELECT_USER:"Valitse käyttäjä",
    USER_FOR_ORGANIZATION_CREATED:"Uusi käyttäjä luotu onnistuneesti",
    SELECT_REGION:"Valitse regioona",
    SELECT_LANGUAGE:"Valitse kieli",
    LOADING_DATA:"Ladataan tietoja, ole hyvä ja odota",
    ADMINISTRATOR:"Ylläpitäjä",
    TECHNICAL_SUPPORT:"Tekninen tuki",
    CONTROLLER:"Controller",
    EDIT_ORGANIZATION_USER:"Muokkaa käyttäjiä organisaatiossa",
    DELETE_ORGANIZATION_USER:"Poista käyttäjiä organisaatiossa",
    USER_UPDATED:"Käyttäjä päivitetty onniostuneesti",
    USER_CREATED:"Käyttäjä luotu onnistuneesti",
    ADDRESS:"Osoite",
    SUBSCRIPTIONS:"Tilaukset",
    RESOLVED_STATUS:"Ratkaistu",
    NOT_RESOLVED_STATUS:"Ei ratkaistu",
    ALERT_NAME:"Vian nimi",
    ALERT_DESCRIPTION:"Viankuvaus",
    ALERT_CODE:"Vikakoodi",
    ALERT_TYPE:"Viantyyppi",
    UNSUBSCRIBE:"Lopeta vian seuraaminen",
    SUBSCRIBE:"Seuraa vikaa",
    ALARM_SUBSCRIBED:"Onnistuneesti tilattu",
    UNSUBSCRIBED_CONFIRM:"Peruuta seuranta?",
    ALARM_UNSUBSCRIBED:"Seuranta onnistuneesti peruutettu",
    ASIDE_MENU_CASHLESS_SALES:"Rahaton myynti",
    FILTERED_CASHLESS_PAYMENTS:"suodata rahattomat myynnit",
    REFUND_DIALOG_TITLE:"Hyvitä tapahtuma?",
    REFUND_DIALOG_SUBTITLE:"Määrä voi olla pienempi kuin tai sama kuin tapahtuman arvo",
    REFUND:"Hyvitä",
    INPUT_NOT_VALID:"Syöttö ei kelpaa",
    REFUND_SUCCESSFULLY:"Hyvitys valitulle tapahtumalle suoritettu onnistuneesti",
    USER:"Käyttäjä",
    TRANSACTION_ID:"PSP reference",
    DEVICE_ID:"Laitteen ID",
    NET_AMOUNT:"Nettoarvo",
    REPORT_NAME:"Raportin nimi",
    TIME_FRAME:"Aikajakso",
    SUB_POINT:"Valitse alipiste",
    SUB_POINT_LIST_NOT_EXIST:"Alipisteiden listaa ei ole valitulle pesulaitteistolle",
    FACILITY_TYPE:"Laitteiston tyyppi",
    MACHINE_NAME:"Laitteen nimi",
    WASH_FACILITY_DETAILS:"Laitteiston tiedot",
    WASH_BAY_DETAILS:"Pesupaikan tiedot",
    DEVICES_INFO:"Laitteistolistaus",
    OPERATION_TIME_INFO:"Käyttöaika",
    OPERATION_TIME_VACUUM_INFO:"Käyttöaika imureille",
    OPERATION_TIME_ILLUMINATION_INFO:"Käyttöaika valaistukselle",
    AVAILABLE_TITLE:"Käytettävissä",
    UNAVAILABLE_TITLE:"Ei käytettävissä",
    CURRENT_PROGRAM:"Tämän hetkinen ohjelma",
    CREDITS:"Krediitit",
    DEVICE_NAME:"Laitteen nimi",
    ACTIVE_ALARMS:"Aktiiviset hälytykset",
    ALL_DAY:"Koko päivä",
    OPERATING_TIME_WASH_FACILITY:"Itsepalvelupesulaitteisto",
    OPERATING_TIME_VACUUMS:"Imurit",
    OPERATING_TIME_ILLUMINATION:"Valaistus",
    OPERATION_COUNTERS:"Käyttölaskurit",
    EDIT:"Muokkaa",
    WASHING_PROGRAMS:"Pesuohjelmat",
    INFO:"Tapahtuma",
    STATISTIC:"Tilasto",
    ROLLOVER_DOSING:"Annostelu",
    ROLLOVER_SPEED:"Nopeudet",
    ROLLOVER_RESETS:"Autonpesukoneen resetointi",
    ROLLOVER_RESETS_INFO:"Etäresetoinnin pitää täyttää paikalliset vaatimukset. Tärkeää: Ennen resetointia varmista, että autonpesukone on tyhjä.",
    RESET_ROLLOVER:"Resetoi autonpesukone",
    OPEN_DOOR_ROLLOVER:"Avaa",
    ROLLOVER_OPEN_DOOR_INFO:"Avaa pesuhallin ovi. Ole varovainen.",
    ROLLOVER_OPEN_DOOR:"Avaa ovi",
    APPLY_DOSING_CHANGES:"Hyväksy muutokset annostelussa",
    APPLY_SPEED_CHANGES:"Hyväksy nopeus muutokset",
    ACTUATION_SUCCESS:"Pyyntö lähetetty",
    REMAINING_TIME:"Jäljellä oleva aika",
    OPEN_24H:"Avoinna 24 tuntia",
    CLOSE_24H:"Suljettu 24 tuntia",
    VALIDATION_OPERATION_TIME:"Muoto ei ole oikei. Käytä tt:mm",
    ROLLOVER:"Autonpesukone",
    UPDATE_WASHING_PROGRAM:"Päivitä pesuohjelma",
    UPDATE_ACTUATORS:"Päivitä toimilaitteet",
    OPEN_ROLOVER_DOOR_TITLE:"Haluatko avata autonpesukoneen oven?",
    OPEN_ROLOVER_DOOR_CONTENT:"Oletko varma, että haluat avata oven?",
    RESET_ROLOVER_TITLE:"Haluatko resetoida autonpesukoneen?",
    RESET_ROLOVER_CONTENT:"Oletko varma, että haluat resetoida autonpesukoneen?",
    G0:"{{brand === 'r2w' ? 'Paikka 0' : 'Paikka 1'}}",
    G1:"{{brand === 'r2w' ? 'Paikka 1' : 'Paikka 2'}}",
    G2:"{{brand === 'r2w' ? 'Paikka 2' : 'Paikka 3'}}",
    G3:"{{brand === 'r2w' ? 'Paikka 3' : 'Paikka 4'}}",
    G4:"{{brand === 'r2w' ? 'Paikka 4' : 'Paikka 5'}}",
    G5:"{{brand === 'r2w' ? 'Paikka 5' : 'Paikka 6'}}",
    G6:"{{brand === 'r2w' ? 'Paikka 6' : 'Paikka 7'}}",
    G7:"{{brand === 'r2w' ? 'Paikka 7' : 'Paikka 8'}}",
    G8:"{{brand === 'r2w' ? 'Paikka 8' : 'Paikka 9'}}",
    G9:"{{brand === 'r2w' ? 'Paikka 9' : 'Paikka 10'}}",
    G10:"{{brand === 'r2w' ? 'Paikka 10' : 'Paikka 11'}}",
    U0:"{{brand === 'r2w' ? 'Imuri 0' : 'Imuri 1'}}",
    U1:"{{brand === 'r2w' ? 'Imuri 1' : 'Imuri 2'}}",
    U2:"{{brand === 'r2w' ? 'Imuri 2' : 'Imuri 3'}}",
    U3:"{{brand === 'r2w' ? 'Imuri 3' : 'Imuri 4'}}",
    U4:"{{brand === 'r2w' ? 'Imuri 4' : 'Imuri 5'}}",
    U5:"{{brand === 'r2w' ? 'Imuri 5' : 'Imuri 6'}}",
    U6:"{{brand === 'r2w' ? 'Imuri 6' : 'Imuri 7'}}",
    U7:"{{brand === 'r2w' ? 'Imuri 7' : 'Imuri 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Vikakoodiraportti luotu valitusta kohteesta",
    ALERT_CENTER_TITLE_BY_FACILITY:"Vikakoodiraportti luotu valitusta laitteesta",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Vikakoodiraportti",
    ERROR_MESSAGE_403:" You don't have privilege to use this api call. Error Code: 403",
    LAST_ACTIVE_PROGRAM:"Aktiivinen pesuohjelma / Edellinen aktiivinen pesuohjelma",
    PROGRAM_ID:"Pesuohjelman numero",
    PROGRAM_PRICE:"Pesuohjelman hinta",
    NORMAL_CHEMICAL_LEVEL:"Ok",
    LOW_CHEMICAL_LEVEL:"Täyttö vaaditaan",
    CHEMICAL_LEVEL:"Pesuaineiden pinnantasot (%)",
    ROLLOVER_STATUS:"Autonpesukoneen tila",
    ROLLOVER_STATUS_CODE_0:"Pesu tällä hetkellä poissa käytöstä",
    ROLLOVER_STATUS_CODE_1:"Aukioloajan ulkopuolella",
    ROLLOVER_STATUS_CODE_2:"Ohjelman aloitus hyväksytty",
    ROLLOVER_STATUS_CODE_3:"Aja koneeseen",
    ROLLOVER_STATUS_CODE_4:"Aja eteenpäin",
    ROLLOVER_STATUS_CODE_5:"Peruuta",
    ROLLOVER_STATUS_CODE_6:"Pysäytä auto",
    ROLLOVER_STATUS_CODE_7:"Pesu aktiivinen",
    ROLLOVER_STATUS_CODE_8:"Pesu pysäytetty",
    ROLLOVER_STATUS_CODE_9:"Pesu aktiivinen (tact)",
    ROLLOVER_STATUS_CODE_10:"Poistu peruuttaen",
    ROLLOVER_STATUS_CODE_11:"Hätäseis painettu",
    ROLLOVER_STATUS_CODE_12:"Poistu eteenpäin",
    ROLLOVER_STATUS_CODE_13:"Pakkassuojaus aktiivinen",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Peiliturvaraja vasen",
    ROLLOVER_STATUS_CODE_21:"Peiliturvaraja oikea",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Kriittinen virhe",
    NO_ALARM:"Ei kriittistä virhettä",
    SOFTWARE_VERSION:"Ohjelmisto versio",
    SOFTWARE_DATE:"Ohjelmisto päivämäärä",
    SITE_ADDRESS:"Kohteen osoite",
    SECONDS:"Sekuntia",
    SERVICE_PART_NAME:"Huollon nimi:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Käyttö- ja huoltolaskuri",
    OPERATION_COUNTER:"Käyttölaskuri",
    SERVICE_COUNTER:"Huoltolaskuri",
    FAULT_CODE:"Vikakoodi",
    PRESSURE_TITLE:"Ilmanpaine",
    TIME_TITLE:"Aika",
    COUNTRY_TITLE:"Maa",
    CITY_TITLE:"Kaupunki",
    REGION_TITLE:"Alue",
    SELECT_POINTS_TO_SEARCH:"Valitse pisteet ...",
    LOGS_HISTORY:"Parametrien päivitys historia",
    ACTUATOR_REFERENCE:" Actuator reference",
    ACTUATOR_VALUE:" Actuator value",
    POINT_ID:" Point id",
    VALIDATION_NOT_VALID_RANGE:" Incorrect range",
    ENABLE_ROLLOVER_RESET:"Painamalla tätä ruutua vahvistat, että olet lukenut ja hyväksyt turvallisuusohjeet.",
    CHANGE_OF_PARAMETERS:"Muuta parametreja",
    SELECT_OPTIONS:"Valitse vaihtoehdot",
    AUTOMATIC:"Automaattinen",
    DESALTING:"Suolanpoisto toiminto",
    SEASON_WASH:"Pesuohjelma kausi",
    SPRING_PROGRAM:"Kevät pesuohjelmat",
    SUMMER_PROGRAM:"Kesä pesuohjelmat",
    AUTUMN_PROGRAM:"Syksy pesuohjelmat",
    WINTER_PROGRAM:"Talvi pesuohjelmat",
    DOOR_CONTROL:"Oviohjaus",
    SUMMER_DOOR_CONTROL:"Kesä, oviohjaus kesä asetuksella",
    WINTER_DOOR_CONTROL:"Talvi, oviohjaus talvi asetuksella",
    APPLY_PARAMETERS_CHANGES:"Hyväksy parametrien muutokset",
    WORKING_SCHEDULES:"Työaikataulut",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Loma-aika kohteelle luotu onnistuneesti",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Loma-ajat kohteelle päivitetty onnistuneesti",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Loma-ajat poistettu kohteelta onnistuneesti",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Työaikataulut etenevät onnistuneesti",
    HOLIDAY_SUCCESSFULLY_DELETED:"Loma poistettu onnistuneesti",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Kuivausapuaine vähissä",
    CHEM_LEVEL_LOW_SHAMPOO:"Harjashampoo vähissä",
    CHEM_LEVEL_LOW_FOAM:"Vaahto vähissä",
    CHEM_LEVEL_LOW_WAX_1:"Vaha vähissä",
    CHEM_LEVEL_LOW_POLISH_1:"Kiiltovaha vähissä",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Vannepesuaine vähissä",
    CHEM_LEVEL_LOW_WAX_2:"Vaha vähissä",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Renkaidenkiiltoaine vähissä",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Hyönteisirroite vähissä",
    CHEM_LEVEL_LOW_POLISH_2:"Kiiltovaha vähissä",
    CHEM_LEVEL_LOW_INTENSIVE:"Esipesuaine vähissä",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Vaahtosade -pesuaine vähissä",
    CHEM_LEVEL_DRYING_AGENT:"Kuivausavun määrä",
    CHEM_LEVEL_SHAMPOO:"Shampoon määrä",
    CHEM_LEVEL_FOAM:"Vaahdon määrä",
    CHEM_LEVEL_WAX_1:"Vahan määrä",
    CHEM_LEVEL_POLISH_1:"Kiiltovahan määrä",
    CHEM_LEVEL_RIM_CLEANER:"Vannepesuaineen määrä",
    CHEM_LEVEL_WAX_2:"Vahan määrä",
    CHEM_LEVEL_TYRE_SHINE:"Renkaidenkiiltoaineen määrä",
    CHEM_LEVEL_INSECT_REMOVER:"Hyönteisirrotteen määrä",
    CHEM_LEVEL_POLISH_2:"Kiiltovahan määrä",
    CHEM_LEVEL_INTENSIVE:"Esipesuaineen määrä",
    CHEM_LEVEL_FOAM_RAIN:"Vaahtosade -pesuaineen määrä",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Huoltolaskuri kattoharjan nostohihnoille",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Huoltolaskuri kattokuivaimen nostohihnoille",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Huoltolaskuri kattoharjanpyöritysmoottorin kaapelille",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Huoltolaskuri raikasvesipumpulle",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Huoltolaskuri kierrätysvesipumpulle",
    DRYING_AGENT:"Kuivausapu",
    FOAM_DRYING_AGENT:"Vaahtokuivausapuaine",
    SHAMPOO:"Shampoo",
    FOAM:"Vaahto",
    BRUSH_FOAM:"Vaahtoshampoo",
    WAX_1:"Vaha",
    FOAM_WAX_1:"Vaahtovaha",
    POLISH_1:"Kiiltovaha",
    RIM_CLEANING:"Vanteenpesuaine",
    WAX_2:"Vaha",
    FOAM_WAX_2:"Vaahtovaha",
    TYRE_SHINE:"Renkaankiillotusaine",
    INSECT_REMOVER:"Hyönteisirrote",
    POLISH_2:"Kiiltovaha",
    INTENSIVE_BASIC:"tavallinen esipesu",
    INTENSIVE_SIDE:"Esipesu kyljet",
    INTENSIVE_ROOF_SPRAY_BAR:"Esipesu katto",
    TAR_REMOVER:"Bituminpoisto",
    UNDER_CHASSIS_CONVERSATION:"Under chassis conversation",
    STATIONARY_PRE_SPRAY_ARCH:"Kiinteä esipesukaari",
    FOAM_RAIN:"Vaahtosade",
    PRE_CLEANING:"Esipesu",
    BRUSH:"Harja",
    CARE:"Huuhtelu",
    DRYING:"Kuivaus",
    DRYING_LOW_NOISE:"Kuivaus alennetulla äänellä",
    INTENSIVE_CLEANING:"Tehopuhdistus",
    BRUSH_CLEANING:"Harjapesu",
    EMPTY_RUN:"Tyhjä ylitys",
    DRYING_AID:"Kuivausapu",
    WAX:"Vaha",
    FOAM_WASH:"Vaahtopesu",
    POLISH:"Kiiltovaha",
    FOAM_POLISH:"Vaahtokiiltovaha",
    WHEEL_CLEANING:"Renkaanpesu",
    HIGH_PRESSURE_ROOF:"Kattokorkeapaine",
    HIGH_PRESSURE_SIDE:"Sivukorkeapaine",
    DRYER_FORWARD:"Kuivaus eteenpäin",
    DRYER_BACKWARD:"Kuivaus taaksepäin",
    DELETE_ALL_HOLIDAYS:"Poista kaikki lomat valitulta kohteelta",
    CREATE_NEW_HOLIDAY:"Luo uusi",
    RESET_INPUTS:"Reset all holidays inputs",
    TWENTY_FOUR_HOURS_OPEN:"Avoinna 24 tuntia",
    EVERY_YEAR:"Vuosittain",
    DELETE_HOLIDAY:"Poista loma ",
    ADD_NEW_HOLIDAY:"Luo uusi loma",
    HOLIDAYS_LIST:"Listaus olemassa olevista lomista",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Poista kaikki lomat valitulta kohteelta",
    VALIDATION_HOLIDAY_DATE:"Muoto on väärä. Käytä kk-pp",
    FOR_DATE:"Päivämäärälle",
    WITH_ID:"Tunnisteella",
    FROM_HOURS:"Alkaen tunnista",
    FROM_MINUTES:"Alkaen minuutista",
    TO_HOURS:"Päättyen tuntiin",
    TO_MINUTES:"Päättyen minuuttiin",
    NOT_MATCH:"Ei täsmää",
    START:"Alkaen",
    STOP:"Päättyen",
    DAILY_TIME:"24h lista",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Yksilöllinen aika-asetus",
    PROGRAM_NOT_STARTED:"Ohjelmaa ei aloitettu vielä",
    JETWASH:"Itsepalvelupesujärjestelmä",
    KARCHER_REPORT_1:"Autonpesukone: Liikevaihto pesuohjelmittain ja yhteensä",
    KARCHER_REPORT_2:"Autonpesukone: Aloitetut pesut ohjelmittain ja yhteensä",
    KARCHER_REPORT_3:"Autonpesukone: Suoritetut pesut pesuohjelmittain ja yhteensä",
    KARCHER_REPORT_4:"Autonpesukone: Maksuautomaatista käynnistettyjen pesujen määrä per pesuohjelma ja yhteensä",
    KARCHER_REPORT_5:"Autonpesukone: Manuaalisesti käynnistettyjen pesuohjelmien määrä pesuohjelmittain ja yhteensä",
    KARCHER_REPORT_6:"Autonpesukone: Keskeytettyjen pesujen päärä pesuohjelmittain ja yhteensä",
    KARCHER_REPORT_7:"Autonpesukone: Sähkönsyötönhäiriöiden määrä",
    KARCHER_REPORT_8:"SB-Laitteistot: Käyttöajat pesuohjelmittain suodatettuna per pesupaikka ja yhteensä",
    KARCHER_REPORT_9:"SB-Laitteistot: Liikevaihto indikaatio per pesupaikka ja yhteensä",
    KARCHER_REPORT_10:"SB-Laitteistot: Poletit/Kolikot laskuri per kolikkokanava",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Tuorevesipumppu",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Kierrätysvesipumppu",
    OPERATION_COUNTER_HP_PUMP_1:"Korkeapainepumppu 1",
    OPERATION_COUNTER_HP_PUMP_2:"Korkeapainepumppu 2",
    RELEASE_NOTES:"Aplikaatiovarsio ja julkaisu ilmoitukset",
    BACKEND_RELEASE_NOTES:"Alustan julkaisu ilmoitukset:",
    FRONTEND_RELEASE_NOTES:"Verkko aplikaation julkaisu ilmoitukset:",
    SELECTED_FACILITY_TIMEZONE:"Aikavyöhyke valitulle laitteistolle",
    REFRESH_PAGE:"Päivitä sivu",
    REFRESH_MAPS:"Päivitä kartta",
    PUMPS:"Pumput",
    RUN_TIME:"Käyntiaika",
    RUN_TIME1:"Käyntiaika 1",
    RUN_TIME2:" Käyntiaika 2",
    PROGRAM_RUNTIME_ACTUATOR:"Actuator for run time",
    PROGRAM_RUNTIME_ACTUATOR_1:"Actuator for run time 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Actuator for run time 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimi arvo on 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maksimi arvo on 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Käytä hinta formaattina x.xx",
    ACTUATION_NOT_ALLOWED:"Aktivointi ei ole sallittu nykyiselle käyttäjäroolille",
    MAINTENANCE_DAYS:"Huoltoon päiviä",
    MAINTENANCE_WASHES:"Huoltoon pesuja",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Total income POS",
    PROPAGATE:"Propagate",
    ALL_DAY_HOURS_SELECTOR:"24 hours type selector",
    GET_OPERATING_TIME_FROM_SITE:"Get operating time for current device from site working schedules",
    USER_NOT_VALID:" Käyttäjä ei kelpaa. Kokeile toisella tilin tunnistetiedoilla.",
    VERIFIED:"Varmistettu",
    RESEND_VERIFICATION_MAIL:"Lähetä uudelleen varmistus sähköposti",
    RETURN_TO_DASHBOARD:"Palaa etusivulle",
    ERROR_PAGE_BAD_REQUEST:"400 Bad Request.",
    WASHES:"Pesujen määrä",
    TIME_TO_SERVICE:"Aikaa huoltoon",
    ACCOUNT_ALREADY_ACTIVATED:"Käyttäjätili on jo käytössä",
    SITE_DETAILS_SUCCESSFULLY_UPDATED: "Site details successfully updated",
    COMPANY: "Company",
    FACILITY_HAS_CHANGER: "Have changer?",
    DISABLE_OFFLINE_ALARM: "Disable R2W alarms",
    ASIDE_WORKING_SCHEDULES: "App Site details",
    TERMS_OF_SERVICE_R2W_TITLE: "Ready2Wash terms of service",
    TERMS_OF_SERVICE_R2W: "Ready2Wash terms of service",
    DATA_PROCESSING_TITLE: "Data Processed",
    PRIVACY_POLICY_TITLE: "Privacy Policy",
    READY_TO_PAY_TERMS_OF_SERVICE: "Ready2Pay Terms of service",
    TERMS_AND_SERVICES: "Terms and services",
    INFO_TITLE: "Info",
    HOURLY: "Tunneittain",
    DAILY: "Päivittäin",
    WEEKLY: "Viikoittain",
    MONTHLY: "Kuukausittain",
    YEARLY: "Vuosittain",
    DELETE_ITEM_SUCCESS:"Onnistuit poistamaan kohteen",
    STATE: "Osavaltio",
    AVAILABILITY_STATUS_1: "Yksikkö avoinna",
    AVAILABILITY_STATUS_2: "Yksikkö suljettu (loma)",
    AVAILABILITY_STATUS_3: "Yksikkö suljettu (toiminta-aika)",
    AVAILABILITY_STATUS_4: "Yksikkö suljettu (vika)",
    AVAILABILITY_STATUS_5: "Yksikkö suljettu (muu syy)",
    AVAILABILITY_VACUUMS_STATUS_1: "Imurit eivät asennettu",
    AVAILABILITY_VACUUMS_STATUS_2: "Imurit avoinna",
    AVAILABILITY_VACUUMS_STATUS_3: "Imurit suljettu (loma)",
    AVAILABILITY_VACUUMS_STATUS_4: "Imurit suljettu (toiminta-aika)",
    AVAILABILITY_VACUUMS_STATUS_5: "Imurit suljettu (vika)",
    AVAILABILITY_VACUUMS_STATUS_6: "Imurit suljettu (muu syy)",
    ECOM_AMOUNT: "Kokonais-Ecom kaikille paikoille",
    CAPTURED: "Tallennettu",
    DELETE_COMPANY_HISTORY_INFO:"Tämä toiminto poistaa kaikki yrityksesi raporttitiedot. Tätä toimintoa ei voi peruuttaa.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Oletko varma, että haluat pysyvästi poistaa kaikki raporttitiedot?",
    VALUE_DATE: "Arvopäivä",
    KARCHER_EVENT_NAME_1: "Peruslämmönvaihdin regeneroitu",
    KARCHER_EVENT_NAME_2: "Peruslämmönvaihtimen regenerointi päättyi",
    KARCHER_EVENT_NAME_3: "Materiaali / sarjanumero",
    KARCHER_EVENT_NAME_4: "Järjestelmä on desinfioitu",
    KARCHER_EVENT_NAME_5: "HP-pumppu 1 desinfioitu",
    KARCHER_EVENT_NAME_6: "HP-pumppu 2 desinfioitu",
    KARCHER_EVENT_NAME_7: "HP-pumppu 3 desinfioitu",
    KARCHER_EVENT_NAME_8: "HP-pumppu 4 desinfioitu",
    KARCHER_EVENT_NAME_9: "HP-pumppu 5 desinfioitu",
    KARCHER_EVENT_NAME_10: "Pesuasema 1 lukittu",
    KARCHER_EVENT_NAME_11: "Pesuasema 2 lukittu",
    KARCHER_EVENT_NAME_12: "Pesuasema 3 lukittu",
    KARCHER_EVENT_NAME_13: "Pesuasema 4 lukittu",
    KARCHER_EVENT_NAME_14: "Pesuasema 5 lukittu",
    KARCHER_EVENT_NAME_15: "Pesuasema 6 lukittu",
    KARCHER_EVENT_NAME_16: "Pesuasema 7 lukittu",
    KARCHER_EVENT_NAME_17: "Pesuasema 8 lukittu",
    KARCHER_EVENT_NAME_18: "Päivitys aloitettu",
    KARCHER_EVENT_NAME_19: "Päivitys valmis",
    KARCHER_EVENT_NAME_20: "WS Reg aloitus",
    KARCHER_EVENT_NAME_21: "WS Reg loppu",
    KARCHER_EVENT_NAME_22: "WS 75% sensori",
    KARCHER_EVENT_NAME_23: "Tekninen vika",
    KARCHER_EVENT_NAME_24: "Käyttöhäiriö",
    KARCHER_EVENT_NAME_25: "Yksikkö päällä",
    KARCHER_EVENT_NAME_26: "Yksikkö pois päältä",
    KARCHER_EVENT_NAME_27: "Laatikko 1 suljettu",
    KARCHER_EVENT_NAME_28: "Laatikko 2 suljettu",
    KARCHER_EVENT_NAME_29: "Laatikko 3 suljettu",
    KARCHER_EVENT_NAME_30: "Laatikko 4 suljettu",
    KARCHER_EVENT_NAME_31: "Laatikko 5 suljettu",
    KARCHER_EVENT_NAME_32: "Laatikko 6 suljettu",
    KARCHER_EVENT_NAME_33: "Laatikko 7 suljettu",
    KARCHER_EVENT_NAME_34: "Laatikko 8 suljettu",
    KARCHER_EVENT_NAME_35: "HP-pumppuasema 1",
    KARCHER_EVENT_NAME_36: "HP-pumppuasema 2",
    KARCHER_EVENT_NAME_37: "HP-pumppuasema 3",
    KARCHER_EVENT_NAME_38: "HP-pumppuasema 4",
    KARCHER_EVENT_NAME_39: "HP-pumppuasema 5",
    KARCHER_EVENT_NAME_40: "HP-pumppuasema 6",
    KARCHER_EVENT_NAME_41: "HP-pumppuasema 7",
    KARCHER_EVENT_NAME_42: "HP-pumppuasema 8",
    KARCHER_EVENT_NAME_43: "Poltin",
    KARCHER_EVENT_NAME_44: "Polttimen tuuletin",
    KARCHER_EVENT_NAME_45: "Lämminvesipumppu",
    KARCHER_EVENT_NAME_46: "Pakkassuojapumppu",
    KARCHER_EVENT_NAME_47: "Osmosipumppu",
    KARCHER_EVENT_NAME_48: "Lattialämmitys",
    KARCHER_EVENT_NAME_49: "Letkun lämmitys",
    KARCHER_EVENT_NAME_50: "Mikro/vannepesu",
    KARCHER_EVENT_NAME_51: "Alustan pesupumppu",
    KARCHER_EVENT_NAME_52: "Vaahtopumppu Booster",
    KARCHER_EVENT_NAME_53: "Imuri 1",
    KARCHER_EVENT_NAME_54: "Imuri 2",
    KARCHER_EVENT_NAME_55: "Imuri 3",
    KARCHER_EVENT_NAME_56: "Imuri 4",
    KARCHER_EVENT_NAME_57: "Imuri 5",
    KARCHER_EVENT_NAME_58: "Imuri 6",
    KARCHER_EVENT_NAME_59: "Imuri 7",
    KARCHER_EVENT_NAME_60: "Imuri 8",
    KARCHER_EVENT_NAME_61: "Imuri 9",
    KARCHER_EVENT_NAME_62: "Imuri 10",
    KARCHER_EVENT_NAME_63: "Imuri 11",
    KARCHER_EVENT_NAME_64: "Imuri 12",
    KARCHER_EVENT_NAME_65: "Vanteen pesupumppu",
    KARCHER_EVENT_NAME_66: "Micropumppu",
    KARCHER_EVENT_NAME_67: "Tehopesupumppu",
    KARCHER_EVENT_NAME_68: "Imuri 1 turbiini",
    KARCHER_EVENT_NAME_69: "Imuri 1 suodatin",
    KARCHER_EVENT_NAME_70: "Imuri 2 turbiini",
    KARCHER_EVENT_NAME_71: "Imuri 2 suodatin",
    KARCHER_EVENT_NAME_72: "Imuri 3 turbiini",
    KARCHER_EVENT_NAME_73: "Imuri 3 suodatin",
    KARCHER_EVENT_NAME_74: "Imuri 4 turbiini",
    KARCHER_EVENT_NAME_75: "Imuri 4 suodatin",
    KARCHER_EVENT_NAME_76: "Imuri 5 turbiini",
    KARCHER_EVENT_NAME_77: "Imuri 5 suodatin",
    KARCHER_EVENT_NAME_78: "Imuri 6 turbiini",
    KARCHER_EVENT_NAME_79: "Imuri 6 suodatin",
    KARCHER_EVENT_NAME_80: "Imuri 7 turbiini",
    KARCHER_EVENT_NAME_81: "Imuri 7 suodatin",
    KARCHER_EVENT_NAME_82: "Imuri 8 turbiini",
    KARCHER_EVENT_NAME_83: "Imuri 8 suodatin",
    KARCHER_EVENT_NAME_84: "Imuri 9 turbiini",
    KARCHER_EVENT_NAME_85: "Imuri 9 suodatin",
    KARCHER_EVENT_NAME_86: "Imuri 10 turbiini",
    KARCHER_EVENT_NAME_87: "Imuri 10 suodatin",
    KARCHER_EVENT_NAME_88: "Imuri 11 turbiini",
    KARCHER_EVENT_NAME_89: "Imuri 11 suodatin",
    KARCHER_EVENT_NAME_90: "Imuri 12 turbiini",
    KARCHER_EVENT_NAME_91: "Imuri 12 suodatin",
    INSERT_TOKEN: "Lisää tunnisteet ja käynnistä palvelu",
    OPEN_SESSION: "Istunto avattu onnistuneesti",
    IN_PROGRESS: "Meneillään ...",
    TOKEN_INSERTED: "Tunnisteet lisätty onnistuneesti",
    EXPIRED_SESSION: "Istunto vanhentunut",
    TWO_DIGIT_INTEGER_VALIDATION: "Käytä korkeintaan kaksinumeroista kokonaislukua",
    KARCHER_OPERATION_COUNTER_1: "Pesuasema 1 HP-pumppu",
    KARCHER_OPERATION_COUNTER_2: "Pesuasema 1 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_3: "Pesuasema 1 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_4: "Pesuasema 1 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_5: "Pesuasema 1 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_6: "Pesuasema 2 HP-pumppu",
    KARCHER_OPERATION_COUNTER_7: "Pesuasema 2 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_8: "Pesuasema 2 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_9: "Pesuasema 2 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_10: "Pesuasema 2 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_11: "Pesuasema 3 HP-pumppu",
    KARCHER_OPERATION_COUNTER_12: "Pesuasema 3 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_13: "Pesuasema 3 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_14: "Pesuasema 3 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_15: "Pesuasema 3 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_16: "Pesuasema 4 HP-pumppu",
    KARCHER_OPERATION_COUNTER_17: "Pesuasema 4 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_18: "Pesuasema 4 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_19: "Pesuasema 4 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_20: "Pesuasema 4 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_21: "Pesuasema 5 HP-pumppu",
    KARCHER_OPERATION_COUNTER_22: "Pesuasema 5 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_23: "Pesuasema 5 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_24: "Pesuasema 5 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_25: "Pesuasema 5 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_26: "Pesuasema 6 HP-pumppu",
    KARCHER_OPERATION_COUNTER_27: "Pesuasema 6 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_28: "Pesuasema 6 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_29: "Pesuasema 6 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_30: "Pesuasema 6 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_31: "Pesuasema 7 HP-pumppu",
    KARCHER_OPERATION_COUNTER_32: "Pesuasema 7 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_33: "Pesuasema 7 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_34: "Pesuasema 7 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_35: "Pesuasema 7 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_36: "Pesuasema 8 HP-pumppu",
    KARCHER_OPERATION_COUNTER_37: "Pesuasema 8 kemiallinen pumppu 1",
    KARCHER_OPERATION_COUNTER_38: "Pesuasema 8 kemiallinen pumppu 2",
    KARCHER_OPERATION_COUNTER_39: "Pesuasema 8 kemiallinen pumppu 3",
    KARCHER_OPERATION_COUNTER_40: "Pesuasema 8 kemiallinen pumppu 4",
    KARCHER_OPERATION_COUNTER_41: "Osmosipumppu",
    KARCHER_OPERATION_COUNTER_42: "Kuuman veden generaattori",
    KARCHER_OPERATION_COUNTER_43: "Jäänsuojapumppu",
    KARCHER_OPERATION_COUNTER_44: "WSO-suodatin",
    KARCHER_OPERATION_COUNTER_45: "Pesuaseman lämmityspumppu",
    KARCHER_OPERATION_COUNTER_46: "Kuuman veden pumppu",
    KARCHER_OPERATION_COUNTER_47: "Vaahdotusletkun lämmitys",
    KARCHER_OPERATION_COUNTER_48: "Renkaanpesupumppu",
    KARCHER_OPERATION_COUNTER_49: "Mikroemulsiopumppu",
    KARCHER_OPERATION_COUNTER_50: "Tehovaahtopumppu",
    KARCHER_OPERATION_COUNTER_51: "Pölynimuri 1 turbiini 1",
    KARCHER_OPERATION_COUNTER_52: "Pölynimuri 1 suodatin 1",
    KARCHER_OPERATION_COUNTER_53: "Pölynimuri 1 turbiini 2",
    KARCHER_OPERATION_COUNTER_54: "Pölynimuri 1 suodatin 2",
    KARCHER_OPERATION_COUNTER_55: "Pölynimuri 2 turbiini 1",
    KARCHER_OPERATION_COUNTER_56: "Pölynimuri 2 suodatin 1",
    KARCHER_OPERATION_COUNTER_57: "Pölynimuri 2 turbiini 2",
    KARCHER_OPERATION_COUNTER_58: "Pölynimuri 2 suodatin 2",
    KARCHER_OPERATION_COUNTER_59: "Pölynimuri 3 turbiini 1",
    KARCHER_OPERATION_COUNTER_60: "Pölynimuri 3 suodatin 1",
    KARCHER_OPERATION_COUNTER_61: "Pölynimuri 3 turbiini 2",
    KARCHER_OPERATION_COUNTER_62: "Pölynimuri 3 suodatin 2",
    KARCHER_OPERATION_COUNTER_63: "Pölynimuri 4 turbiini 1",
    KARCHER_OPERATION_COUNTER_64: "Pölynimuri 4 suodatin 1",
    KARCHER_OPERATION_COUNTER_65: "Pölynimuri 4 turbiini 2",
    KARCHER_OPERATION_COUNTER_66: "Pölynimuri 4 suodatin 2",
    KARCHER_OPERATION_COUNTER_67: "Pölynimuri 5 turbiini 1",
    KARCHER_OPERATION_COUNTER_68: "Pölynimuri 5 suodatin 1",
    KARCHER_OPERATION_COUNTER_69: "Pölynimuri 5 turbiini 2",
    KARCHER_OPERATION_COUNTER_70: "Pölynimuri 5 suodatin 2",
    KARCHER_OPERATION_COUNTER_71: "Pölynimuri 6 turbiini 1",
    KARCHER_OPERATION_COUNTER_72: "Pölynimuri 6 suodatin 1",
    KARCHER_OPERATION_COUNTER_73: "Pölynimuri 6 turbiini 2",
    KARCHER_OPERATION_COUNTER_74: "Pölynimuri 6 suodatin 2",
    KARCHER_OPERATION_COUNTER_75: "Kondenssiveden poisto kompressorista",
    KARCHER_OPERATION_COUNTER_76: "Tarkista jäänsuojausjärjestelmä",
    KARCHER_OPERATION_COUNTER_77: "Polttimen tuuletin",
    KARCHER_OPERATION_COUNTER_78: "Vaahtovahvistinpumppu",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Tietoluettelo on suurempi kuin 10000 kohdetta",
    KARCHER_POINT_NAME_1: "Pyhäpäivä",
    KARCHER_POINT_NAME_2: "Maanantai",
    KARCHER_POINT_NAME_3: "Tiistai",
    KARCHER_POINT_NAME_4: "Keskiviikko",
    KARCHER_POINT_NAME_5: "Torstai",
    KARCHER_POINT_NAME_6: "Perjantai",
    KARCHER_POINT_NAME_7: "Lauantai",
    KARCHER_POINT_NAME_8: "Sunnuntai",
    KARCHER_POINT_NAME_9: "Imurit Pyhäpäivä",
    KARCHER_POINT_NAME_10: "Imurit Maanantai",
    KARCHER_POINT_NAME_11: "Imurit Tiistai",
    KARCHER_POINT_NAME_12: "Imurit Keskiviikko",
    KARCHER_POINT_NAME_13: "Imurit Torstai",
    KARCHER_POINT_NAME_14: "Imurit Perjantai",
    KARCHER_POINT_NAME_15: "Imurit Lauantai",
    KARCHER_POINT_NAME_16: "Imurit Sunnuntai",
    KARCHER_POINT_NAME_17: "Valaistus Pyhäpäivä",
    KARCHER_POINT_NAME_18: "Valaistus Maanantai",
    KARCHER_POINT_NAME_19: "Valaistus Tiistai",
    KARCHER_POINT_NAME_20: "Valaistus Keskiviikko",
    KARCHER_POINT_NAME_21: "Valaistus Torstai",
    KARCHER_POINT_NAME_22: "Valaistus Perjantai",
    KARCHER_POINT_NAME_23: "Valaistus Lauantai",
    KARCHER_POINT_NAME_24: "Valaistus Sunnuntai",
    KARCHER_POINT_NAME_25: "Ohjelma 0",
    KARCHER_POINT_NAME_26: "Ohjelma 1",
    KARCHER_POINT_NAME_27: "Ohjelma 2",
    KARCHER_POINT_NAME_28: "Ohjelma 3",
    KARCHER_POINT_NAME_29: "Ohjelma 4",
    KARCHER_POINT_NAME_30: "Ohjelma 5",
    KARCHER_POINT_NAME_31: "Ohjelma 6",
    KARCHER_POINT_NAME_32: "Ohjelma 7",
    KARCHER_POINT_NAME_33: "Ohjelma 8",
    KARCHER_POINT_NAME_34: "Ohjelma 9",
    KARCHER_POINT_NAME_35: "Ohjelma 10",
    KARCHER_POINT_NAME_36: "Ohjelma 11",
    KARCHER_POINT_NAME_37: "Ohjelma 12",
    KARCHER_POINT_NAME_38: "Ohjelma 13",
    KARCHER_POINT_NAME_39: "Ohjelma 14",
    KARCHER_POINT_NAME_40: "Ohjelma 15",
    KARCHER_POINT_NAME_41: "Ohjelma 16",
    KARCHER_POINT_NAME_42: "Ohjelma 17",
    KARCHER_POINT_NAME_43: "Ohjelma 18",
    KARCHER_POINT_NAME_44: "Ohjelma 19",
    KARCHER_POINT_NAME_45: "Ohjelma 20",
    KARCHER_POINT_NAME_46: "Ohjelma 21",
    KARCHER_POINT_NAME_47: "Ohjelma 22",
    KARCHER_POINT_NAME_48: "Ohjelma 23",
    KARCHER_POINT_NAME_49: "Ohjelma 24",
    KARCHER_POINT_NAME_50: "Ohjelma 25",
    KARCHER_POINT_NAME_51: "Ohjelma 26",
    KARCHER_POINT_NAME_52: "Ohjelma 27",
    KARCHER_POINT_NAME_53: "Ohjelma 28",
    KARCHER_POINT_NAME_54: "Ohjelma 29",
    KARCHER_POINT_NAME_55: "Ohjelma 30",
    KARCHER_POINT_NAME_56: "Ohjelma 31",
    KARCHER_POINT_NAME_57: "Ohjelma 32",
    QR_CODE: "QR-koodi",
    ACCEPT_TERMS_AND_CONDITIONS: "Hyväksy käyttöehdot",
    CREATE_AND_PRINT_VOUCHERS: "Luo ja tulosta kuponkeja",
    CODE_PREFIX_QUESTION: "Koodin etuliitettä ei ole syötetty",
    CODE_PREFIX_QUESTION_TEXT: "Haluatko jatkaa ilman koodin etuliitettä?",
    ISSUED_DATE: "Myöntämispäivä",
    VOUCHER_VALIDITY_DAYS: "Kupongin voimassaolo (päivää)",
    VALIDATION_ONLY_NUMBERS: "Vain numerot ovat sallittuja",
    REPRINT_VOUCHERS: "Tulosta kopio kupongista",
    EXPIRY_DATE: "Voimassa asti"
  });
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").constant("enTranslations", {
    MESSAGE:"Message",
    ERROR_TITLE:"Error",
    ERROR_MESSAGE:"There was an error executing operation.",
    ERROR_LOGIN:"There was an error during log in. Email address or password is not valid",
    ERROR_LOGIN_ROLE: "Role for current application brand is not valid",
    OK:"OK",
    CANCEL:"Cancel",
    YES:"Yes",
    NO:"No",
    FROM:"From",
    TO:"To",
    DELETE:"Delete",
    SIGN_OUT:"Sign out",
    NAME:"Name",
    DATE:"Date",
    PIECES:"pieces",
    HOURS:"Hours",
    DAYS:"Days",
    MONTH:"Month",
    MONTHS:"Months",
    YEAR:"Year",
    BOX:"Box",
    SEARCH:"Search",
    ALL_USERS:"All users",
    ARE_YOU_SURE:"Are you sure?",
    BACK:"Back",
    AMOUNT:"Amount",
    DESCRIPTION:"Description",
    FORGOT_PASSWORD_ERROR_MSG:"Something went wrong. Please check your email address and try again",
    REQUIRED_FIELD:"Field is required",
    LOGOUT_TITLE:"Are you sure you want to sign out?",
    LOGOUT_MSG:"All of your unsaved data will be lost",
    ACTIVATION_ACCOUNT:"You successfully activated your account",
    UNKNOWN_ERRROR_NOTIFICATION:"Unknown error occured",
    CONTINUE:"Continue",
    DATA_NOT_AVAILABLE:"Please choose the Report type and select date",
    SELECT:"Select",
    SELECT_CURRENCY:" Select currency",
    UPLOAD:"Upload",
    PHONE:"Phone",
    WEBSITE:"Website",
    WORKING_HOURS:"Working hours",
    INSERT:"Insert",
    TEXT:"Text",
    CREATED:"Created",
    VALID_UNTIL:"Valid until",
    SAVE:"Save",
    TOKENS:"Tokens",
    DELETE_COMPANY_HISTORY:"Delete company history?",
    DELETE_COMPANY_HISTORY_INFO:"This action will delete all report data for your company. This action cannot be undone.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Are you sure you want to permanently delete all reports data?",
    DELETE_COMPANY_HISTORY_MESSAGE:" WARNING: After pressing this button, all transactions of your car wash will be permanently deleted! This data cannot be restored after deletion.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Are you sure you want to permanently delete all transaction data?",
    HISTORY_SUCCESSFULY_DELETED:"History successfully deleted",
    HELP:"Help",
    VALUE:"Value",
    ACTIVATING_ACCOUNT_ERROR:"There was a problem with activation of your R2W  account.Please try again and if the problem persists contact our support at support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Welcome to Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Welcome to R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Please enter your new password and confirm it in order to activate R2W account. You will be automatically signed in into the application upon success",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"You can change your user settings later in application",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:"R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Please enter your new password and confirm it in order to reset old password. You will be automatically signed in into the application upon success",
    RESET_PASSWORD_WELCOME_MSG_3:"You can change your user settings later in application",
    ENTER_NEW_PASSWORD:"Enter new password",
    REPEAT_NEW_PASSWORD:"Repeat new password",
    PASSWORD_MIN_LENGTH:"Password must be at least 8 characters long",
    PASSWORD_MAX_LENGHT:"Password must be less then 32 characters long",
    PASSWORD_PATTERN:"Password must contains at least one uppercase letter and one lowercase letter",
    PASSWORD_MATCH:"Passwords do not match",
    ACTIVATE:"Activate",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"You successfully submitted request. Please check you email for confirmation message",
    VALIDATION_REQUIRED:"Required field",
    VALIDATION_EMAIL:"Invalid email address",
    VALIDATION_INTEGER_NUMBER:"Please enter integer value",
    VALIDATION_HOURS_VALUE:"Value must be between 0-23",
    VALIDATION_MINUTES_VALUE:"Value must be between 0-59",
    VALIDATION_NOT_A_DATE:"Value is not a date",
    VALIDATION_FROM:"From date greater than to",
    VALIDATION_TO:"To date less than from",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"That record already exist in database",
    PASSWORD_VALIDATION_PATTERN_NEW:"There must be at least one digit, one lowercase and one upper case letter. White spaces are not allowed",
    VALIDATION_PERCENT_VALUE:"Value must be between 1-999",
    NUMBERS_ONLY_100:"Counting number up to 100",
    NUMBERS_ONLY_1000:"Counting number up to 1000",
    POSITIVE_NUMBERS_ONLY:"Only counting number",
    GRID_PAGER_PAGE:"Page",
    GRID_PAGER_ROWS_PER_PAGE:"Rows per page",
    GRID_PAGER_PAGE_OF:"of",
    BREAD_CRUMBS_HOME:"Home",
    BREAD_CRUMBS_DASHBOARD_TECH:"Dashboard technology",
    BREAD_CRUMBS_DETAILS:"Details",
    BREAD_CRUMBS_SETTINGS:"Settings",
    BREAD_CRUMBS_WORKING_HOURS:" Working hours",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Total money by days report",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Average money by hour report",
    BREAD_CRUMBS_NEW_USER_GROUP:"Create user group",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Edit user group",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Create campaign template",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Edit campaign template",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Create campaign",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Edit campaign",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Periodic summary",
    LOGIN:"Log in",
    EMAIL:"E-mail",
    PASSWORD:"Password",
    LANGUAGE:"Language",
    FORGOT_PASSWORD:"Forgot password?",
    SUBMIT:"Submit",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Number of pending alarms:",
    HEADER_VIEW_ALL_ALARMS:"View all alarms...",
    HEADER_MY_ACCOUNT:"My account",
    HEADER_ACCOUNT_MANAGEMENT:"Account management",
    ACCOUNT_ALREADY_EXIST:"Email address already in use",
    NEWSLETTER_CONFIRMATION:"Send email notification for alarms state",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Daily Finances Overview",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Dashboard Technology",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Dashboard",
    ASIDE_MENU_ALARMS:"Messages",
    ASIDE_MENU_FACILITIES:"Facilities",
    ASIDE_MENU_REPORTS:"Reports",
    ASIDE_MENU_REPORT:" Selected report",
    ASIDE_MENU_LOYALTY:"Loyalty",
    ASIDE_MENU_USER_GROUPS:"User groups",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodic summary",
    ASIDE_MENU_MANAGING_TOKENS:" Managing Tokens",
    ASIDE_MENU_NEWS:"News",
    DAILY_FINANCES_TOTAL_MONEY:"Total money",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Total money for all facilities",
    DAILY_FINANCES_TOTAL_COINS:"Total used metal tokens",
    DAILY_FINANCES_DOWNLOAD_CSV:"Download CSV",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Cash",
    DAILY_FINANCES_CHANGER:"Changer Cash",
    DAILY_FINANCES_COINS:"Tokens/Eurokey",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Type of report",
    REPORTS_CHOOSE_FACILITY:"Choose facility",
    REPORTS_PERIOD_1:"Period 1 - ",
    REPORTS_PERIOD_2:"Period 2 - ",
    MONEY_BY_DATE_REPORT:"Total income by date",
    R2W_BY_DATE_REPORT:"Total income from R2W tokens by date",
    COINS_BY_DATE_REPORT:"Total used token by date",
    AVG_MONEY_BY_HOUR_REPORT:"Average income by hour",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Average income by day of week",
    AVG_MONEY_BY_BOX_REPORT:"Spending by bay",
    COMPARE_PERIODS_REPORT:"Facility comparative report",
    TOTAL_USERS_BY_GROUP:"Total R2W app visits by day",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"users",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"visits",
    VISITS_COUNT_REPORT:"Number of R2W app users per visit count",
    LOYALTY_PER_DAY_REPORT:"Number of Local tokens spent per day",
    LOYALTY_PER_PAYMENT_METHOD:"Given local tokens per payment method",
    VISITS:"Visits",
    VISIT:"Visit",
    TOTAL_SPENT_MONEY:"Total income",
    MONEY:"Money",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Total income money for period",
    DOWNLOAD_CSV:"Download CSV",
    TOTAL_SPENT_COINS:"Total tokens spent",
    TOTAL_USERS:"Total users",
    TOTAL_CREDIT_GIVEN:"Total local virtual tokens spent",
    EUROKEY_BY_DATE_REPORT:"Total Eurokey payments by date",
    TOTAL_SPENT_EUROKEY:"Total spent",
    SELECT_TYPE_OF_REPORT:"You need to select type of report ",
    NUMBER_OF_VISITS_TITLE:"Number of visits",
    NUMBER_OF_USERS_TITLE:"Number of users",
    PIECES_TITLE:"Pieces",
    TOTAL_VISITS:"Total visits",
    TOKENS_TITLE:"tokens",
    SEARCH_USERS_NO_RESULTS:"No users found for given search term",
    SEARCH_USERS:"Search users",
    SEARCH_TELEPHONES:"Search users by mobile no.",
    ADD_USER_TO_GROUP:"Add user to group",
    REMOVE_USER_FROM_GROUP:"Remove user from group",
    USER_GROUP_NAME_REQUIRED:"User group name is required",
    USER_GROUP_NAME:"User group name",
    USER_GROUPS_OVERVIEW:"User groups overview",
    USER_COUNT:"User count",
    NEW_USER_GROUP:"Create new user group",
    DELETE_USER_GROUP:"Delete user group",
    UPDATE_USER_GROUP:"Edit user group",
    DELETE_USER_GROUP_ERROR:"There was an error deleting selected user group. Please try again or contact support...",
    CONFIRM_DELETE_USER_GROUP:"Are you sure you want to delete the selected user group?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Loyalty actions that the deleted group has been assigned to will no longer be applied.",
    GROUP_NAME_MAX_LENGTH:"Group name must be less then 255 characters long",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"User is already in that group",
    MISSING_USER:"Missing user",
    USER_NOT_ON_LIST:"User is not in the active users list. Check if the email address is valid and try again.",
    UPLOAD_USER_GROUP:"Upload user group list from *.csv file",
    UKNOWN_USERS:"List of uknown users",
    CAMPAIGN_TEMPLATE_RULE:"Template rule",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"There has been an error while trying to delete campaign template. Please try again or contact support...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Are you sure you want to delete selected campaign template",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Are you sure you want to delete selected campaign template",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Campaign templates overview",
    DELETE_CAMPAIGN_TEMPLATE:"Delete campaign template",
    UPDATE_CAMPAIGN_TEMPLATE:"Edit campaign template",
    CREATE_CAMPAIGN_TEMPLATE:"Create new campaign template",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Name of campaign template is required",
    CAMPAIGN_TEMPLATE_NAME:"Campaign template name",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Required field",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"give %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"extra time",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Please select type first. Wash boxes or Small machines.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Delete template rule",
    CAMPAIGN_TEMPLATE_RULE_FROM:"From",
    CAMPAIGN_TEMPLATE_RULE_TO:"to",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"hours",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minutes",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"New rule by number of visits",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"New rule by amount of tokens spent",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"New rule by days of week",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Add new template rule",
    CAMPAIGN_TEMPLATE_RULE_1:"Every",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Every",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"tokens spent in less than",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"visits in less than",
    CAMPAIGN_TEMPLATE_RULE_3:"days",
    CAMPAIGN_TEMPLATE_RULE_4:"tokens",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Rules list is empty.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Date cannot be in the past",
    DELETE_CAMPAIGN_ERROR:"There has been an error while trying to delete campaign. Please try again or contact support...",
    CONFIRM_DELETE_CAMPAIGN:"Are you really sure you want to delete this campaign?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W is not responsible for user's experience caused by this action.",
    CAMPAIGNS_OVERVIEW:"Campaigns overview",
    DELETE_CAMPAIGN:"Delete campaign",
    UPDATE_CAMPAIGN:"Edit campaign",
    CREATE_CAMPAIGN:"Create new campaign",
    CAMPAIGN_ACTIVE:"Active",
    CAMPAIGN_TEMPLATE:"Template",
    CAMPAIGN_GROUPS:"Groups",
    CAMPAIGN_ALL_USERS:"All users",
    CAMPAIGN_NAME:"Campaign name",
    CAMPAIGN_NAME_REQUIRED:"Required",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Number of users near threshold per day",
    MESSAGE_TO_USERS:"Message to filtered users",
    SEND_MESSAGE:"Send message",
    THRESHOLD:"Threshold",
    TYPE:"Type",
    TOTAL_MONEY_SPENT:"Total money spent in campaign",
    NUMBER_OF_VISITS:"Number of visits in campaign",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Message must be at least 10 characters long",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Message must be less then 350 characters long ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Message text is required",
    TECHNOLOGY:"Technology",
    TAP_WATER:"Tap water",
    REVERSE_OSMOSIS:"Reverse osmosis",
    SOFTENED_WATER:"Softened water",
    DOSER:"Doser",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Last synchronization",
    NO_OF_CURRENT_ALARMS:"Number of current alarms",
    NO_OF_CURRENT_WARNINGS:"Number of current warnings",
    WEATHER:"Weather",
    BOXES_WORK_HOURS_COUNTERS:"Boxes work hours",
    BOX_TOTAL_HOURS:"Total work hours",
    BOX_SERVICE_HOURS:"Total work hours (service)",
    BOX_COUNTER_HOURS:"hours",
    ALARMS_AND_WARNINGS:"Alarms & warnings",
    FILTER_AND_BOILER:"Filter & boiler",
    FILTER_TOTAL_DAYS:"Filter work days",
    BOILER_TOTAL_DAYS:"Boiler work days",
    DAYS_UNIT:"days",
    SOFTENER:"Softener",
    MANUAL_COLD_DRAIN:"Manual cold drain",
    EL_COLD:"El. cold",
    DRAIN:"drain",
    TAP:"tap",
    WASTE:"Waste",
    OSMOSIS:"osmosis",
    DEMI_WATER:"Demi water",
    EL_RINSE:"El. m. rinse",
    BOILER:"Boiler",
    EL_WAX:"El. m. wax",
    FLOOR_HEATING:"Floor heating",
    DOSER_TANK:"Doser tank",
    EL_WASH:"El. m. wash",
    DETERGENT:"Detergent",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Update settings",
    GENERAL_SETTINGS:"General settings",
    LIGHTS:"Lights",
    GROUPS:"Groups",
    ANTI_FREEZE:"Anti freeze",
    AUTO:"Auto",
    MANUAL:"Manual",
    ON:"On",
    OFF:"Off",
    TEMPERATURE:"Temperature",
    UPDATE_DEVICE:"Update facility settings",
    BOX_CLEAN_HOURS:"Box clean counters (hours)",
    GROUP_COUNTERS:"Group counters",
    RESET:"Reset",
    CASH_COUNT:"Coins count",
    COINS_COUNT:"Tokens count",
    EUROKEY_COUNT:"Eurokey count",
    DOSER_WORK:"Doser work time (sec.)",
    DOSER_PAUSE:"Doser pause time (sec.)",
    DELAY_BFV:"BFV delay (ms)",
    DELAY_6M1:"6M1 delay (ms)",
    DELAY_LPS:"LPS delay (ms)",
    RESET_CASH_COUNT_ALL:"Reset all coin counters",
    RESET_COINS_COUNT_ALL:"Reset all token counters",
    RESET_EUROKEY_COUNT_ALL:"Reset all Eurokey counters",
    FACILITY_DETAILS:"Facility details",
    FACILITY_NAME:"Facility name",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"You successfully uploaded image",
    FACILITY_UPDATE_DATA_NOTIFICATION:"You successfully updated data",
    CONNECTED:"Connected",
    DISCONNECTED:" Disconnected",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Messages filter",
    FACILITY:"Facility",
    APPLY:"Apply",
    TIME:"Time",
    LOCATION:"Location",
    ACKNOWLEDGED:"Acknowledged",
    FILTERED_MESSAGES:"Filtered messages",
    ACK:"Acknowledged",
    NOT_ACK:"Not acknowledged",
    ALL:"All",
    ALL_FACILITIES:"All facilities",
    ENTER_DATE_PLACEHOLDER:"Enter date",
    OP_NESTANAK_NAPONA:"Missing voltage on phase indicator 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"High pressure pump circuit breaker dropped",
    OP_UPR_NAPON_24VAC_GRE:"Missing 24 VAC - circuit breaker 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Fresh water tank empty",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Mains water pump circuit breaker dropped",
    OP_MIN_NIVO_OMEKS_VODE:"Softened water tank empty",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Softened water pump circuit breaker dropped",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosis water tank empty",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Osmosis water pump circuit breaker dropped",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Osmosis production pump circuit breaker dropped",
    OP_BOJLER_GRESKA_MZS:"Water heater error",
    OP_CRPKA_PRASKA_GRE_MZS:"Hot water pump circuit breaker dropped",
    OP_DOZATOR_PRASKA_GRE_MZS:"Powder dosing motor circuit breaker dropped",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Powder dosing vibrator circuit breaker dropped",
    OP_MIN_PRASAK_TON_ALARM:"Powder mixing tank empty",
    OP_USIS_KOV_TURBINA_GRESKA:"Coin vacuuming turbine circuit breaker dropped",
    OP_FILTER_VODE_ZACEPLJEN:"Water filter blocked",
    OP_VISKTL_RESET_SATI_RADA:"High pressure pump service",
    OPW_VISKTL_RESET_SATI_RADA:" High pressure pump service",
    OP_FILTER_DANI_RADA:"Water filter fault",
    OP_BOJLER_DANI_RADA:"Water heater fault",
    OPW_ALARM_VISOKOTL_PUMPA:"High pressure pump alarm",
    OPW_ALARM_FILTER_SERVIS:"Filter service alarm",
    OPW_ALARM_BOJLER_SERVIS:"Boiler service alarm",
    HAS_MEMBERS:"Selected group has members and can not be deleted. Members need to be deleted first.",
    PERIODIC_SUMMARY_FOR:"Periodic summary report for",
    PERIODIC_SUMMARY_REPORTS:"Periodic summary reports",
    DATE_RANGE:"Date range",
    FINANCIAL_REPORT:"Financial report",
    GROSS_INCOME:"Gross income",
    GROSS_INCOME_SUM:"Gross Income Sum",
    COMMISSION_FEE:"Commission fee",
    NET_INCOME:"Net income (for billing)",
    COMMISSION_FEE_DETAILS:"Commission fee includes bank / PayPal provision or SMS service providers fee.",
    LOYALTY_CREDITS_REPORT:"Local tokens report",
    LOYALTY_GIVEN:"Given local tokens",
    LOYALTY_USED:"Used local tokens",
    LOYALTY_SOLD:"Local tokens loaded",
    LOYALTY_TOTAL:"Total",
    LOYALTY_CURRENT_MONTH:"Current month",
    SOMETHING_WENT_WRONG:"Something went wrong",
    MISSING_PAGE:"Sorry. We could not find that page",
    TRY_AGAIN:"Try again",
    DEFAULT_ERROR_NAME:"Unknown error has occurred",
    DEFAULT_ERROR_DESCRIPTION:"Please try again",
    MY_ACCOUNT_DETAILS:"My account details",
    SAVE_CHANGES:"Save changes",
    USERNAME:"Username",
    FIRST_NAME:"First Name",
    LAST_NAME:"Last Name",
    USER_ROLE:"User Role",
    OLD_PASSWORD:"Old password",
    NEW_PASSWORD:"New password",
    OLD_PASSWORD_REQUIRED:"Old password is required",
    NEW_PASSWORD_REQUIRED:"New password is required",
    NEW_PASSWORD_REPEAT:"New password repeating is required",
    NEW_PASSWORD_NOT_MATCH:"Old and new password does not match",
    PASSWORD_DIFFERENT_VALIDATION:"New password must be different then old one",
    PASSWORD_MIN_CHAR:"Your password must be at least 8 characters long",
    PASSWORD_MAX_CHAR:"Your password must be maximum 32 characters long",
    PASSWORD_PATTERN_VALIDATION:"Password must contains at least one number",
    ACCOUNT_MANAGEMENT:"Account Management",
    NOT_ACTIVE:"Not active",
    ASSIGN_ROLE:"Assign role",
    UPDATE:"Update",
    ADD_NEW_ACCOUNT:"Add new account",
    EMAIL_REQUIRED:"Email adress is required",
    EMAIL_NOT_VALID:"Email adress is not valid",
    ADD_NEW_USER_TEXT:"Email with activation link will be sent to provided email address.",
    UPDATE_USER_NOTIFICATION:"You successfully updated your information",
    CHANGED_PASSWORD_NOTIFICATION:"You successfully changed your password",
    UPDATE_USER_GROUP_NOTIFICATION:"You successfully updated user group name",
    CREATE_USER_GROUP_NOTIFICATION:"You successfully created group",
    DETELE_USER_GROUP_NOTIFICATION:"You successfully deleted group",
    EMPTY_GROUP_LIST_MSG:"There is no created groups. Start by creating one",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"You successfully deleted user from group",
    ADD_USER_TO_GROUP_NOTIFICATION:"You successfully added user to group",
    ADD_USER_NOTIFICATION:"You successfully added new user",
    DELETE_USER_NOTIFICATION:"You successfully deleted user",
    RESEND_USER_VERIFICATION_EMAIL:"You successfully resend verification email",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"In order to create a user group",
    DELETE_USER:"Delete user",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Are you sure you want to delete user from user group?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Dear R2W user",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Loyalty rule per number of visits",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Loyalty rule per amount of tokens spent",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Loyalty rule per day of the week",
    REMOVE_CAMPAIGN_RULE_TITLE:"Campaign rule removal",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Are you sure you want to remove the campaign rule?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"You successfully created new campaign",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"You successfully activated campaign",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"There is no created campaigns. Start by creating one",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"You successfully sent message",
    COMPANY_ACCOUNTS:"Company accounts",
    BUSSINESS_INVOICES_LIST:"My B2B invoices",
    LOCALE_TOKEN:"Local token",
    R2W:"Global token",
    START_MONTH:"Start month",
    END_MONTH:"End month",
    TOKEN_TYPE:"Token type",
    TOKEN_NUMBER:"Token number",
    NOTHING_TO_DISPLAY:"* Nothing to display",
    CREATE_INVOICE:"Create Invoice",
    INVOICE:"Invoice",
    INVOICES:"Invoices",
    EDIT_INVOICE:"Edit invoice",
    UPDATE_INVOICE_NOTIFICATION:"You successfully updated invoice to pending status",
    CURRENT_CHARGES:"Charges for the current period",
    PAYMENTS_ON_HOLD:"Invoices in processing",
    FOR_INVOICING:"For invoicing",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"You are about to cancel invoice",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Are you sure you want to cancel this invoice ?",
    INVOICING_NOTIFICATION_HEADER:"You are about to do invoicing",
    INVOICING_NOTIFICATION_TEXT:"Are you sure you want to send invoice?",
    SENT_INVOICE_NOTIFICATION:"You successfully sent an invoice",
    CANCELED_INVOICE_NOTIFICATION:"You successfully canceled invoice",
    INVOICE_DESCRIPTION_TEXT:"Invoice for ",
    INVOICE_STATE:"Invoice state",
    INVOICE_NUMBER:"Invoice number",
    INVOICE_TOTAL:"Total",
    SELECT_YEAR:"Select year",
    DOWNLOAD:"Download PDF",
    INVOICE_NUMBER_HEADER:"You are about to send invoice with number ",
    INVOICE_PAYMENT_CONFIRMATION:"You are about to confirm payment for",
    INSERT_INVOICE_NUMBER:"Insert invoice number",
    INVOICED_WARNING:"The email was not sent. Please wait ...",
    SEND_INVOICE:"Send",
    INVOICE_ALL:"All",
    INVOICE_FROM_R2W:"From R2W",
    INVOICE_TO_R2W:"To R2W",
    PAYMENT_REQUEST:"Payment request",
    PAYMENT_REQUEST_STATE:"Payment request state",
    PAYMENT_REQUEST_NUMBER:"Payment request number",
    FOR_PAYMENT_REQUEST:"For payment requests",
    PAYMENT_REQUEST_ON_HOLD:"Payment requests in process",
    DOWNLOAD_INVOICE:"Download invoice",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Click for download options",
    B2B_SPEC:"B2B specification",
    B2C_SPEC:"B2C specification",
    DOWNLOAD_PAYMENT_REQUEST:"Download payment request",
    LOYALTY_PREVIEW:"Loyalty preview",
    ACTIVATED:"Activated",
    RUNNING:"Running",
    NOT_ACTIVATED:"Not activated",
    FINISHED:"Finished",
    DEPRECATED:"Deprecated",
    UPCOMING:"Upcoming",
    NONE:"Individual",
    STARTED:"Started",
    ENDS:"Ends",
    DEDICATED:"Dedicated to",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"You are about to activate",
    CAMPAIGN:"Campaign",
    SEND_MESSAGE_NOTIFICATION:"You are about to send message to selected user groups",
    DIVISIBLE_TO_NUMBER:"The number should be divisible with ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Device type",
    LISTENER:"Small machines",
    BRIDGE:"Wash boxes",
    WASH_BOXES:"Wash boxes",
    VACUUMS:" Vacuums",
    SAVE_NEWS:"Save news",
    CREATE_NEW_NEWS:"Create new news",
    HISTORY_OF_ALL_NEWS:"History of all news",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Type facility name",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Add another facility",
    NEWS_TEXT:"News text",
    NEWS_TITLE:"News title",
    DELETE_NEWS_CONFIRMATION:"You are about to delete news",
    NEWS_DELETE_NOTIFICATION:"You successfully deleted news",
    NEWS_SAVE_NOTIFICATION:"You successfully saved news",
    NEWS_CREATION_DATE:"Creation date",
    NO_TITLE:"No title",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"News text must be less then 255 characters",
    NEWS_TEXT_REQUIRED_VALIDATION:"News text is required",
    NEWS_TITLE_REQUIRED_VALIDATION:"News title is required",
    DEACTIVATE:"Deactivate",
    ASIDE_MENU_LOCAL_TOKENS:"Local tokens",
    CREATE_NEW_LOCAL_TOKENS:"Issue new local tokens",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Enter customer email address and amount of local tokens you would like to issue to the customer",
    CREATE_TOKENS:"Issue tokens",
    MINIMUM_ONE_TOKEN:"Value must be number greater than 0",
    CUSTOMER_EMAIL:"Customer email",
    AMOUNT_OF_TOKENS:"Amount of tokens",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Success issuing local tokens to",
    PROBLEM_ISSUING_LOCAL_TOKENS:"There was an error issuing local tokens. Please check customer email address and try again.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Overview of issued local tokens",
    ISSUED_AT:"Issued at",
    ISSUED_BY:"Issued by",
    CODE:"Redeem code",
    REDEEMED_BY:"Redeemed by",
    REDEEMED_AT:"Redeemed at",
    ASIDE_MENU_VOUCHERS:"Vouchers",
    PRINT:"Print",
    VOUCHERS_OVERVIEW:"Vouchers overview",
    CREATE_NEW_VOUCHERS:"Create new vouchers",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Create new redeemable voucher batch by entering amount of tokens per voucher",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Amount of tokens per voucher",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"You can assign between 1 and 100 tokens per voucher",
    NUMBER_OF_NEW_VOUCHERS:"Number of vouchers to be created",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"You can create between 1 and {{size}} vouchers in a single batch",
    NEW_VOUCHERS_PREFIX:"New vouchers series code prefix",
    VALIDATION_VOUCHER_PREFIX:"Code prefix must be exactly 4 characters (upper cased letters and/or numbers)",
    PROBLEM_CREATING_NEW_VOUCHERS:"There was a problem creating new vouchers. Please try again or contact our support.",
    CREATE_VOUCHERS:"Create vouchers",
    CREATE_AND_PRINT_VOUCHERS:"Create and print vouchers",
    CREATING_VOUCHERS_SUCCESS:"New vouchers created sucessfully",
    PRINT_NEW_VOUCHERS:"Print vouchers",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Enter a voucher series code prefix in order to print entire voucher series. Alternatively",
    PRINT_VOUCHERS_PREFIX:"Voucher (series) code prefix",
    NO_VOUCHERS_FOR_PRINT:"No vouchers matching provided code prefix were found for printing",
    PRINT_VOUCHERS:"Print voucher(s)",
    VALIDATION_VOUCHER_CODE_FILTER:"Voucher search term must consist of upper case letters and numbers",
    FILTER_VOUCHERS_BY_CODE:"Search vouchers by redeem code",
    FILTER_VOUCHERS:"Search vouchers",
    WASH_BOX:"Wash box",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Total used digital tokens",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Total sold local tokens by date",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Total spent local tokens by date",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Total given local tokens by date",
    LOCAL_TOKEN:"Local token ",
    GIVEN_TOKEN:"Given local tokens",
    SOLD_TOKEN:"Sold local tokens",
    SMALL_MACHINES:"Small machines",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:"HHanle wash box",
    CODE_PREFIX_EXIST:"Code prefix already exist",
    CODE_PREFIX_EXIST_TEXT:"You can't create new voucher with this code prefix. Please set another one.",
    MIN_FOUR_VALIDATION:"Exactly 4 characters",
    ALL_INFORMATION_1:"All information about",
    ALL_INFORMATION_2:"will be lost",
    ASIDE_MENU_TRANSACTIONS:"Transactions",
    EXPENSES:"Expenses",
    TOPUPS:"Top-ups",
    EXPENSES_LIST:"Expenses list",
    USER_EMAIL:"User email",
    COMPANY_NAME:"Company name",
    TOPUPS_LIST:"Top-ups list",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Serial number",
    SETUP_UNIT_MATERIAL_NO:"Material number",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi version",
    TOTAL_TURNOVER:"Wash facility turnover",
    AVAILABILITY_ALL:"Availability",
    AVAILIBILITY:"Wash boxes availability:",
    AVAILABILITY_VACUUMS:"Vacuums availability:",
    WASH_BOX_INFO:"Wash boxes info",
    VACUUM_CLEANER_INFO:"Vacuum cleaners info",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Holidays",
    HOLIDAY:"Holiday",
    LIGHTS_ON:"Lights on",
    LIGHTS_OFF:"Lights off",
    WASH_BOXES_ON:"Wash box on",
    WASH_BOXES_OFF:"Wash box off",
    VACUUMS_ON:"Vacuums on",
    VACUUMS_OFF:"Vacuums off",
    TURNOVER:"Turnover",
    TURNOVER_MANUAL_WASH_UNIT:"Turnover manual",
    STATUS_BAY_RUN_TIME:"Wash box total work time",
    STATUS_BAY_PROGRAM_NAME:"Program name",
    STATUS_BAY_CREDIT:"Wash box credit",
    CLOUD_KREDIT:"Cloud credit",
    STATUS_VACUUM_RUN_TIME:"Vacuum total work time",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Facility services, wash box program and current fault data information",
    UNAVAILABLE:"Unit is unavailable",
    SHOW_HIDE_TABLE:"Show/hide working hours table",
    PROGRAM_NAME:"Program name",
    PROGRAM_COUNTER:"Program counter",
    NO_NAME:"Reference has no name",
    COUNTER_SERVICE_DATA:"Service data",
    NEED_SERVICE:" Service needed",
    PROGRAM_DATA:"Wash box program data",
    CURRENT_FAULT_DATA:"Current fault data",
    REFERENCE_DUE:"Due",
    REFERENCE_SECONDS:"Seconds",
    REFERENCE_NAME:"Part name",
    WASHBOX_NAME:"Wash box name",
    FAULT_NAME:"Fault name",
    FAULT_NUMBER:"Fault number",
    CURRENT_FAULT_COUNT:"Active faults",
    DEVICE_NOT_INSTALLED:"Device not installed",
    STATUS_READY:" Ready status",
    STATUS_ERROR:" Error status",
    CONNECTION_ERROR:"Offline",
    UNKNOWN_RESET:" Software error",
    SOFTWARE_RESET:" Software error",
    EXTERNAL_PIN_RESET:" Software error",
    RESTART_OR_BROWNOUT_OCCURRED:" Software error",
    DEAD_RM5_CHANNEL_PIN_ERROR:" Hardware error",
    COULD_NOT_SIMULATE_COIN:" Hardware error",
    ERROR_SETTING_INHIBIT_MODE:" Hardware error",
    OFFLINE_DEVICE:" Offline car wash",
    TARIFFS:" Tariffs",
    DAY:" Day",
    NIGHT:" Night",
    VOUCHER_CODE:" Voucher code",
    DISMISS_ALARM:" Reset alarm?",
    ALARM_ACTIVE:" Active alarms",
    NO_ALARM_ACTIVE:" There are no active alarms",
    ALARM_HISTORY:" Alert history",
    MANAGING_TOKENS:"Managing tokens",
    EXPIRATION_DATE:"Expiration date",
    EXTEND_TOKEN_DATE:"Extend token expiration date for",
    DELETE_TOKENS_FOR:"Delete tokens for ",
    PUMP_TYPE:"Pump type",
    TURN_OFF_DEVICE:" Device status",
    OPERATION_DATA:" Operation data",
    PUMP_DATA:" Pump data",
    PUMP_NAME:" Pump name",
    POINT_NAME:" Point name",
    CHANGER_INCOME:" Total changer income by date",
    SELECTED_OPEN:"Open on selected working hours",
    ALWAYS_OPEN:" Always open (24/7)",
    CLOSED:" Closed",
    CLOSED_24:" Closed 24h",
    OPENED_24:" Opened 24h",
    MON:" Monday",
    TUE:" Tuesday",
    WED:" Wednesday",
    THU:" Thursday",
    FRI:" Friday",
    SAT:" Saturday",
    SUN:" Sunday",
    PRICING:" Pricing",
    PRICE:"Price",
    VALIDITY:"Validity",
    TOKEN_PACKAGES:" Token packages",
    SINGLE_WASH:" Single wash",
    FACILITY_WORKING_HOURS:" Set working hours for selected facility",
    WORKING_HOURS_ALWAYS_OPEN:" Always open",
    WORKING_HOURS_ALWAYS_CLOSE:" Closed by operator",
    WORKING_HOURS_CUSTOM:" Set working hours",
    KARCHER_ERROR_CODE:" Alert error code",
    KARCHER_ERROR_MESSAGE_1:"Electronic outlets overloaded",
    KARCHER_ERROR_MESSAGE_2:"The oil separator must be emptied",
    KARCHER_ERROR_MESSAGE_4:"Dimming sensor defective",
    KARCHER_ERROR_MESSAGE_5:"Protective motor switch on high pressure pumps was triggered",
    KARCHER_ERROR_MESSAGE_6:"Connection to RDS defective",
    KARCHER_ERROR_MESSAGE_7:"The pressure switch for air on the compressor does not report any",
    KARCHER_ERROR_MESSAGE_8:"Cause: no connection to the electronics 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"No connection to pump electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_11:"Electronic outlets at washing station 1 overloaded",
    KARCHER_ERROR_MESSAGE_12:"Current pickup of high pressure pump at washing station 1 too high",
    KARCHER_ERROR_MESSAGE_13:"Current pickup of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_14:"Contact of high pressure pump at washing station 1 stuck",
    KARCHER_ERROR_MESSAGE_15:"Semiload valve at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor buffer tank empty activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor buffer container empty and buffer contianer full switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor ro pump on and buffer container full switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:" Organization",
    CREATE_ORGANIZATION:" Create organization",
    CREATE_ORGANIZATION_AS:" Create organization as child for",
    DELETE_ORGANIZATION:" Delete organization",
    EDIT_ORGANIZATION:" Edit organization",
    SUPPORTED_ORG_NAME:" Supported organization",
    SUPPORTED_ORG_TYPE:" Supported type",
    ORG_NAME:" Name",
    ORG_TYPE:" Type",
    SET_ORG_TITLE:" Set child organization",
    SET_SUPPORTED_ORG_TITLE:" Set supported child organization",
    SAVE_ORGANIZATION:" Save organization",
    SELECT_ORGANIZATION_TYPE:" Select organization type",
    SELECT_ORGANIZATION_SELECTOR:"Select",
    SELECT_SUPPORTED_ORGANIZATION:" Supported by",
    ORGANIZATION_DELETED:" Organization successfully deleted",
    ORGANIZATION_SAVED:" Organization successfully saved",
    ORGANIZATION_UPDATED:" Organization successfully updated",
    ALERTS:" Alerts",
    DEVICE_STATUS:" Device status",
    SITE_DETAILS:" Site details",
    ALARM_STATUS:" Alert status",
    FILTER:" Filter by ...",
    FILTER_BY_ALERT_CENTER:"Filter by code, name or description",
    TOTAL_ALARM:" Total",
    LOW_ALARM:" Event",
    MEDIUM_ALARM:"Malfunction",
    HIGH_ALARM:"Critical fault",
    NO_FACILITIES_NEARBY:" There are no nearby facilities",
    GRAY_MAP:" Gray styled map",
    READY:" Ready",
    WARNING:"Malfunction",
    ERROR:" Error",
    SITE_NAME:" Site name",
    ACCOUNTS_INFO:" Account info",
    USER_ORGANIZATION:" User organization",
    ADD_USER_ORGANIZATION:" Add new organization user",
    EDIT_USER_ORGANIZATION:"Edit users of the organisation",
    SELECT_ROLE:" Select role",
    SELECT_ORGANIZATION:" Select organization",
    SELECT_USER:" Select user",
    USER_FOR_ORGANIZATION_CREATED:" New user created successfully",
    SELECT_REGION:" Select region",
    SELECT_LANGUAGE:" Select language",
    LOADING_DATA:" Loading data, please wait ...",
    ADMINISTRATOR:" Administrator",
    TECHNICAL_SUPPORT:" Technical support",
    CONTROLLER:"Controller",
    EDIT_ORGANIZATION_USER:"Edit users of the organisation",
    DELETE_ORGANIZATION_USER:"Delete users of the organisation",
    USER_UPDATED:" User successfully updated",
    USER_CREATED:" User successfully created",
    ADDRESS:"Address",
    SUBSCRIPTIONS:"Subscriptions",
    RESOLVED_STATUS:"Resolved",
    NOT_RESOLVED_STATUS:"Not resolved",
    ALERT_NAME:" Alert name",
    ALERT_DESCRIPTION:" Alert description",
    ALERT_CODE:"Alert code",
    ALERT_TYPE:" Alert type",
    UNSUBSCRIBE:" Unsubscribe alert",
    SUBSCRIBE:"Subscribe alert",
    ALARM_SUBSCRIBED:"Successfully subscribed",
    UNSUBSCRIBED_CONFIRM:" Unsubscribe?",
    ALARM_UNSUBSCRIBED:" Successfully unsubscribed",
    ASIDE_MENU_CASHLESS_SALES:" Cashless Sales",
    FILTERED_CASHLESS_PAYMENTS:" Filtered cashless payments",
    REFUND_DIALOG_TITLE:" Refund transaction?",
    REFUND_DIALOG_SUBTITLE:" Amount can be less than or equal to transaction amount",
    REFUND:" Refund",
    INPUT_NOT_VALID:" Input is not valid",
    REFUND_SUCCESSFULLY:" Refund for selected payment was successfully done",
    USER:"User",
    TRANSACTION_ID:" PSP reference",
    DEVICE_ID:" Device ID",
    NET_AMOUNT:" Net amount",
    REPORT_NAME:" Report name",
    TIME_FRAME:" Time frame",
    SUB_POINT:" Select sub point",
    SUB_POINT_LIST_NOT_EXIST:" Sub point list not exist for selected wash facility",
    FACILITY_TYPE:" Facility type",
    MACHINE_NAME:"Machine name",
    WASH_FACILITY_DETAILS:" Wash facility details",
    WASH_BAY_DETAILS:" Wash bay details",
    DEVICES_INFO:"Devices list",
    OPERATION_TIME_INFO:"Operation time",
    OPERATION_TIME_VACUUM_INFO:"Operation time for vacuum cleaners",
    OPERATION_TIME_ILLUMINATION_INFO:"Operation time for illumination",
    AVAILABLE_TITLE:"Available",
    UNAVAILABLE_TITLE:"Unavailable",
    CURRENT_PROGRAM:" Current program",
    CREDITS:" Credits",
    DEVICE_NAME:" Device name",
    ACTIVE_ALARMS:" Active alerts",
    ALL_DAY:" All day",
    OPERATING_TIME_WASH_FACILITY:" Self-service wash system",
    OPERATING_TIME_VACUUMS:" Vacuums",
    OPERATING_TIME_ILLUMINATION:" Illumination",
    OPERATION_COUNTERS:" Operation counters",
    EDIT:" Edit",
    WASHING_PROGRAMS:" Washing programs",
    INFO:"Event",
    STATISTIC:"Statistic",
    ROLLOVER_DOSING:"Dosing",
    ROLLOVER_SPEED:" Speeds",
    ROLLOVER_RESETS:" Rollover remote reset",
    ROLLOVER_RESETS_INFO:" The remote reset has to be in accordance with local regulations. Important: Before resetting make sure that rollover is empty.",
    RESET_ROLLOVER:" Reset rollover",
    OPEN_DOOR_ROLLOVER:" Open",
    ROLLOVER_OPEN_DOOR_INFO:"Open wash hall door. Be careful.",
    ROLLOVER_OPEN_DOOR:" Open the door",
    APPLY_DOSING_CHANGES:" Apply dosing changes",
    APPLY_SPEED_CHANGES:" Apply speed changes",
    ACTUATION_SUCCESS:"Request sent",
    REMAINING_TIME:" Remaining time",
    OPEN_24H:" Open 24 hours",
    CLOSE_24H:" Close 24 hours",
    VALIDATION_OPERATION_TIME:" Format not correct. Use hh:mm",
    ROLLOVER:" Rollover",
    UPDATE_WASHING_PROGRAM:" Update washing program",
    UPDATE_ACTUATORS:"Update actuators",
    OPEN_ROLOVER_DOOR_TITLE:" Want to open rollover door?",
    OPEN_ROLOVER_DOOR_CONTENT:" Are you sure you want to open the door?",
    RESET_ROLOVER_TITLE:" Want to reset rollover?",
    RESET_ROLOVER_CONTENT:" Are you sure you want to reset rollover?",
    G0:"{{brand === 'r2w' ? 'Bay 0' : 'Bay 1'}}",
    G1:"{{brand === 'r2w' ? 'Bay 1' : 'Bay 2'}}",
    G2:"{{brand === 'r2w' ? 'Bay 2' : 'Bay 3'}}",
    G3:"{{brand === 'r2w' ? 'Bay 3' : 'Bay 4'}}",
    G4:"{{brand === 'r2w' ? 'Bay 4' : 'Bay 5'}}",
    G5:"{{brand === 'r2w' ? 'Bay 5' : 'Bay 6'}}",
    G6:"{{brand === 'r2w' ? 'Bay 6' : 'Bay 7'}}",
    G7:"{{brand === 'r2w' ? 'Bay 7' : 'Bay 8'}}",
    G8:"{{brand === 'r2w' ? 'Bay 8' : 'Bay 9'}}",
    G9:"{{brand === 'r2w' ? 'Bay 9' : 'Bay 10'}}",
    G10:"{{brand === 'r2w' ? 'Bay 10' : 'Bay 11'}}",
    U0:"{{brand === 'r2w' ? 'Vacuum 0' : 'Vacuum 1'}}",
    U1:"{{brand === 'r2w' ? 'Vacuum 1' : 'Vacuum 2'}}",
    U2:"{{brand === 'r2w' ? 'Vacuum 2' : 'Vacuum 3'}}",
    U3:"{{brand === 'r2w' ? 'Vacuum 3' : 'Vacuum 4'}}",
    U4:"{{brand === 'r2w' ? 'Vacuum 4' : 'Vacuum 5'}}",
    U5:"{{brand === 'r2w' ? 'Vacuum 5' : 'Vacuum 6'}}",
    U6:"{{brand === 'r2w' ? 'Vacuum 6' : 'Vacuum 7'}}",
    U7:"{{brand === 'r2w' ? 'Vacuum 7' : 'Vacuum 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:" Alert center report created by selected site from dashboard",
    ALERT_CENTER_TITLE_BY_FACILITY:" Alert center report created by selected facility from dashboard",
    ALERT_CENTER_TITLE_BY_DEFAULT:" Alert center report",
    ERROR_MESSAGE_403:" You don't have privilege to use this api call. Error Code: 403",
    LAST_ACTIVE_PROGRAM:"Active program / Last active program",
    PROGRAM_ID:"Program number",
    PROGRAM_PRICE:"Program price",
    PROGRAM_DESCRIPTION: "Program description",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Refill required",
    EMPTY_CHEMICAL_LEVEL:"Empty",
    CHEMICAL_LEVEL:"Level indication detergents (%)",
    ROLLOVER_STATUS:" Rollover status",
    ROLLOVER_STATUS_CODE_0:" Wash currently out of order",
    ROLLOVER_STATUS_CODE_1:" Outside operating time",
    ROLLOVER_STATUS_CODE_2:" Program entry allowed",
    ROLLOVER_STATUS_CODE_3:"Position your vehicle",
    ROLLOVER_STATUS_CODE_4:"Vehicle forwards",
    ROLLOVER_STATUS_CODE_5:"Vehicle back",
    ROLLOVER_STATUS_CODE_6:"Vehicle stop",
    ROLLOVER_STATUS_CODE_7:"Wash active",
    ROLLOVER_STATUS_CODE_8:"Wash stopped",
    ROLLOVER_STATUS_CODE_9:"Wash active (tact)",
    ROLLOVER_STATUS_CODE_10:"Exit vehicle backwards",
    ROLLOVER_STATUS_CODE_11:"Emergency stop",
    ROLLOVER_STATUS_CODE_12:"Exit vehicle forward",
    ROLLOVER_STATUS_CODE_13:"Anti frost active",
    ROLLOVER_STATUS_CODE_14:"Safety switch front activated",
    ROLLOVER_STATUS_CODE_15:"Safety switch rear activated",
    ROLLOVER_STATUS_CODE_16:"Safety switch left front side activated",
    ROLLOVER_STATUS_CODE_17:" Safety switch right front side activated",
    ROLLOVER_STATUS_CODE_18:" Safety switch left rear side activated",
    ROLLOVER_STATUS_CODE_19:"Safety switch right rear side activated",
    ROLLOVER_STATUS_CODE_20:"Vehicle position too far left hand side",
    ROLLOVER_STATUS_CODE_21:" Vehicle position too far right hand side",
    ROLLOVER_STATUS_CODE_22:"Left door not closed",
    ROLLOVER_STATUS_CODE_23:" Right door not closed",
    ROLLOVER_STATUS_CODE_24:"Transporter detected, wrong wash program selected",
    ROLLOVER_STATUS_CODE_25:" Horn sensor",
    ROLLOVER_STATUS_CODE_98:"Manual / adjustment mode",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Critical fault",
    NO_ALARM:"No critical fault",
    SOFTWARE_VERSION:"Software version",
    SOFTWARE_DATE:"Software date",
    SITE_ADDRESS:"Site address",
    SECONDS:"Seconds",
    SERVICE_PART_NAME:" Service name:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:" Operation and service counter",
    OPERATION_COUNTER:" Operation counter",
    SERVICE_COUNTER:" Service counter",
    FAULT_CODE:"Alert code",
    PRESSURE_TITLE:"Air pressure",
    TIME_TITLE:"Current time",
    COUNTRY_TITLE:"Country",
    CITY_TITLE:"City",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Select points ...",
    LOGS_HISTORY:"Parameter change history",
    ACTUATOR_REFERENCE:" Actuator reference",
    ACTUATOR_VALUE:" Actuator value",
    POINT_ID:" Point id",
    VALIDATION_NOT_VALID_RANGE:" Incorrect range",
    ENABLE_ROLLOVER_RESET:"By ticking this box you confirm that you have read and agree with the safety instructions.",
    CHANGE_OF_PARAMETERS:" Change of parameters",
    SELECT_OPTIONS:" Select options",
    AUTOMATIC:" Automatic",
    DESALTING:" Desalting function",
    SEASON_WASH:" Season wash programs",
    SPRING_PROGRAM:" Spring washing programs",
    SUMMER_PROGRAM:" Summer washing programs",
    AUTUMN_PROGRAM:" Autumn washing programs",
    WINTER_PROGRAM:" Winter washing programs",
    DOOR_CONTROL:"Door control",
    SUMMER_DOOR_CONTROL:" Summer, operated with the gate control in summer mode",
    WINTER_DOOR_CONTROL:" Winter, operated with the gate control in winter mode",
    APPLY_PARAMETERS_CHANGES:" Apply parameters changes",
    WORKING_SCHEDULES:" Working schedules",
    HOLIDAY_SCHEDULES:" Holiday schedules",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:" Holidays on site successfully created",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:" Holidays on site successfully updated",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:" Holidays on site successfully deleted",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:" Working schedules successfully propagate",
    HOLIDAY_SUCCESSFULLY_DELETED:" Holiday successfully deleted",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:"CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Drying agent with low filling level",
    CHEM_LEVEL_LOW_SHAMPOO:"Shampoo with low filling level",
    CHEM_LEVEL_LOW_FOAM:"Foam with low filling level",
    CHEM_LEVEL_LOW_WAX_1:"Wax with low filling level",
    CHEM_LEVEL_LOW_POLISH_1:"Polish with low filling level",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Rim cleaner with low filling level",
    CHEM_LEVEL_LOW_WAX_2:"Wax with low filling level",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Tyre shine with low filling level",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Insect remover with low filling level",
    CHEM_LEVEL_LOW_POLISH_2:"Polish with low filling level",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensive with low filling level",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Foam rain with low filling level",
    CHEM_LEVEL_DRYING_AGENT:"Filling level drying agent",
    CHEM_LEVEL_SHAMPOO:"Filling level shampoo",
    CHEM_LEVEL_FOAM:"Filling level foam",
    CHEM_LEVEL_WAX_1:"Filling level wax",
    CHEM_LEVEL_POLISH_1:"Filling level polish",
    CHEM_LEVEL_RIM_CLEANER:"Filling level rim cleaner",
    CHEM_LEVEL_WAX_2:"Filling level wax",
    CHEM_LEVEL_TYRE_SHINE:"Filling level tyre shine",
    CHEM_LEVEL_INSECT_REMOVER:"Filling level insect remover",
    CHEM_LEVEL_POLISH_2:"Filling level polish",
    CHEM_LEVEL_INTENSIVE:"Filling level intensive ",
    CHEM_LEVEL_FOAM_RAIN:"Filling level foam rain",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Service counter roof-brush lifting belt",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Service counter dryer lifting belt",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Service counter motor cable roof-brush",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Service counter fresh water pump service",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Service counter pump service used water",
    DRYING_AGENT:"Drying agent",
    FOAM_DRYING_AGENT:"Foam drying agent",
    SHAMPOO:"Shampoo",
    FOAM:"Foam",
    BRUSH_FOAM:"Brush foam",
    WAX_1:"Wax",
    FOAM_WAX_1:"Foam wax",
    POLISH_1:"Polish",
    RIM_CLEANING:"Rim cleaner",
    WAX_2:"Wax",
    FOAM_WAX_2:"Foam wax",
    TYRE_SHINE:"Tyre shine",
    INSECT_REMOVER:"Insect remover",
    POLISH_2:"Polish",
    INTENSIVE_BASIC:"Intensive basic",
    INTENSIVE_SIDE:"Intensive side",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensive roof spray bar",
    TAR_REMOVER:"Tar remover",
    UNDER_CHASSIS_CONVERSATION:"Under chassis conversation",
    STATIONARY_PRE_SPRAY_ARCH:"Stationary pre-spray arch",
    FOAM_RAIN:"Foam rain",
    PRE_CLEANING:"Pre-cleaning",
    BRUSH:"Brush",
    CARE:"Care",
    DRYING:"Drying",
    DRYING_LOW_NOISE:"Drying reduced noise",
    INTENSIVE_CLEANING:"Intensive cleaning",
    BRUSH_CLEANING:"Brush cleaning",
    EMPTY_RUN:"Empty run",
    DRYING_AID:"Drying aid",
    WAX:"Wax",
    FOAM_WASH:"Foam wash",
    POLISH:"Polish",
    FOAM_POLISH:"Foam polish",
    WHEEL_CLEANING:"Wheel cleaning",
    HIGH_PRESSURE_ROOF:"Roof high pressure",
    HIGH_PRESSURE_SIDE:"Side high pressure",
    DRYER_FORWARD:"Dryer forward",
    DRYER_BACKWARD:"Dryer backward",
    DELETE_ALL_HOLIDAYS:"Delete all holidays for selected site",
    CREATE_NEW_HOLIDAY:"Create new",
    RESET_INPUTS:"Reset all holidays inputs",
    TWENTY_FOUR_HOURS_OPEN:"Open 24 hours",
    EVERY_YEAR:"Yearly",
    DELETE_HOLIDAY:"Delete holiday",
    ADD_NEW_HOLIDAY:"Add new holiday",
    HOLIDAYS_LIST:"List of existing holidays",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Delete all holidays for selected site?",
    VALIDATION_HOLIDAY_DATE:"Format not correct. Use dd-mm",
    FOR_DATE:"For date",
    WITH_ID:"With ID",
    FROM_HOURS:"From (h)",
    FROM_MINUTES:"From (min)",
    TO_HOURS:"To (h)",
    TO_MINUTES:"To (min)",
    NOT_MATCH:"Not match",
    START:"Start",
    STOP:"Stop",
    DAILY_TIME: "24 hours list",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individual time setting",
    PROGRAM_NOT_STARTED:"Program not started yet",
    JETWASH:"Self-service wash system",
    KARCHER_REPORT_1:"Rollover: Turnover indication per program and in total",
    KARCHER_REPORT_2:"Rollover: Started washes per program and in total",
    KARCHER_REPORT_3:"Rollover: Performed washes per program and in total",
    KARCHER_REPORT_4:"Rollover: Amount of started washes via payment terminal per program and in total",
    KARCHER_REPORT_5:"Rollover: Amount of manually started washes per program and in total",
    KARCHER_REPORT_6:" Rollover: Amount of cancelled washes per program and in total",
    KARCHER_REPORT_7:"Rollover: Amount of power supply failures",
    KARCHER_REPORT_8:"SB-Units: Amount of hours per washing program filtered by bay and in total",
    KARCHER_REPORT_9:"SB-Units: Turnover indication per wash bay and in total",
    KARCHER_REPORT_10:"SB-Units: Tokens/Coins counter per coin channel",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Fresh water pump",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Process water pump",
    OPERATION_COUNTER_HP_PUMP_1:"High pressure pump 1",
    OPERATION_COUNTER_HP_PUMP_2:"High pressure pump 2",
    RELEASE_NOTES: "App versions and release notes",
    BACKEND_RELEASE_NOTES: "Platform release notes:",
    FRONTEND_RELEASE_NOTES: "Web application release notes:",
    SELECTED_FACILITY_TIMEZONE: "Time zone for selected facility:",
    REFRESH_PAGE: "Refresh page",
    REFRESH_MAPS: "Refresh maps",
    PUMPS: "Pumps",
    RUN_TIME: "Run time",
    RUN_TIME1: "Run time 1",
    RUN_TIME2: "Run time 2",
    PROGRAM_RUNTIME_ACTUATOR: "Actuator for run time",
    PROGRAM_RUNTIME_ACTUATOR_1: "Actuator for run time 1",
    PROGRAM_RUNTIME_ACTUATOR_2: "Actuator for run time 2",
    PUMP_RUN_TIME_MIN_VALIDATION: "Min value is 1",
    PUMP_RUN_TIME_MAX_VALIDATION: "Max value is 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION: "Use price format x.xx",
    ACTUATION_NOT_ALLOWED:" Actuation not allowed for current user role",
    MAINTENANCE_DAYS: "Maintenance days",
    MAINTENANCE_WASHES: "Maintenance washes",
    DAILY_FINANCES_POS: "POS",
    POS_INCOME: "Total income POS",
    PROPAGATE: "Propagate",
    ALL_DAY_HOURS_SELECTOR: "24 hours type selector",
    GET_OPERATING_TIME_FROM_SITE: "Get operating time for current device from site working schedules",
    USER_NOT_VALID: "User is not valid. Try with another account credentials.",
    VERIFIED: "Verified",
    RESEND_VERIFICATION_MAIL: "Resend verification email",
    RETURN_TO_DASHBOARD: "Return to dashboard",
    ERROR_PAGE_BAD_REQUEST:"400 Bad Request.",
    WASHES: "Number of washes",
    TIME_TO_SERVICE: "Time to service",
    ACCOUNT_ALREADY_ACTIVATED: "Account already activated",
    DEVICE_EVENTS: "Device events",
    DEVICE_EVENTS_LOG_PULLED: "Pulled event log for device ",
    EVENTS_PULL_DATE: "Pulled events time: ",
    DEVICE_EVENTS_REFRESH: "Pull new event data",
    WEB_SOCKETS_CONNECTION_PROBLEM: "Web sockets connection problem. Try to refresh page.",
    INSTALLATION_DATE: "Installation date of machine",
    KARCHER_CUSTOM_PROGRAM_NAME_1: "Hot wax",
    KARCHER_CUSTOM_PROGRAM_NAME_2: "High pressure washing",
    KARCHER_CUSTOM_PROGRAM_NAME_3: "Power rim foam",
    KARCHER_CUSTOM_PROGRAM_NAME_4: "Power foam",
    KARCHER_CUSTOM_PROGRAM_NAME_5: "Stop",
    KARCHER_CUSTOM_PROGRAM_NAME_6: "Foam wash HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7: "Wash",
    KARCHER_CUSTOM_PROGRAM_NAME_8: "Top care",
    INFO_TITLE: "Info",
    FOAM_WAX1:"Foam wax",
    POLISH1:"Polish",
    WAX1:"Wax",
    SITE_DETAILS_SUCCESSFULLY_UPDATED: "Site details successfully updated",
    COMPANY: "Company",
    FACILITY_HAS_CHANGER: "Have changer?",
    DISABLE_OFFLINE_ALARM: "Disable R2W alarms",
    ASIDE_WORKING_SCHEDULES: "App Site details",
    TERMS_OF_SERVICE_R2W_TITLE: "Ready2Wash terms of service",
    TERMS_OF_SERVICE_R2W: "Ready2Wash terms of service",
    DATA_PROCESSING_TITLE: "Data Processed",
    PRIVACY_POLICY_TITLE: "Privacy Policy",
    READY_TO_PAY_TERMS_OF_SERVICE: "Ready2Pay Terms of service",
    TERMS_AND_SERVICES: "Terms and services",
    HOURLY: "Hourly",
    DAILY: "Daily",
    WEEKLY: "Weekly",
    MONTHLY: "Monthly",
    YEARLY: "Yearly",
    DELETE_ITEM_SUCCESS:"You successfully deleted item",
    STATE: "State",
    AVAILABILITY_STATUS_1: "Unit open",
    AVAILABILITY_STATUS_2: "Unit closed (holiday)",
    AVAILABILITY_STATUS_3: "Unit closed (operating time)",
    AVAILABILITY_STATUS_4: "Unit closed (fault)",
    AVAILABILITY_STATUS_5: "Unit closed (other)",
    AVAILABILITY_VACUUMS_STATUS_1: "Vacuums not installed",
    AVAILABILITY_VACUUMS_STATUS_2: "Vacuums open",
    AVAILABILITY_VACUUMS_STATUS_3: "Vacuums closed (holiday)",
    AVAILABILITY_VACUUMS_STATUS_4: "Vacuums closed (operating time)",
    AVAILABILITY_VACUUMS_STATUS_5: "Vacuums closed (fault)",
    AVAILABILITY_VACUUMS_STATUS_6: "Vacuums closed (other)",
    ECOM_AMOUNT: "Total Ecom for All Sites",
    CAPTURED: "Captured",
    VALUE_DATE: "Value date",
    VALIDATION_HOLIDAY_YEAR: "Format not correct. Use yyyy",
    KARCHER_EVENT_NAME_1: "Base exchanger regenerated",
    KARCHER_EVENT_NAME_2: "Base exchanger regeneration ended",
    KARCHER_EVENT_NAME_3: "Material / serial number",
    KARCHER_EVENT_NAME_4: "The system has been disinfected",
    KARCHER_EVENT_NAME_5: "HP pump 1 has been disinfected",
    KARCHER_EVENT_NAME_6: "HP pump 2 has been disinfected",
    KARCHER_EVENT_NAME_7: "HP pump 3 has been disinfected",
    KARCHER_EVENT_NAME_8: "HP pump 4 has been disinfected",
    KARCHER_EVENT_NAME_9: "HP pump 5 has been disinfected",
    KARCHER_EVENT_NAME_10: "Washing station 1 locked",
    KARCHER_EVENT_NAME_11: "Washing station 2 locked",
    KARCHER_EVENT_NAME_12: "Washing station 3 locked",
    KARCHER_EVENT_NAME_13: "Washing station 4 locked",
    KARCHER_EVENT_NAME_14: "Washing station 5 locked",
    KARCHER_EVENT_NAME_15: "Washing station 6 locked",
    KARCHER_EVENT_NAME_16: "Washing station 7 locked",
    KARCHER_EVENT_NAME_17: "Washing station 8 locked",
    KARCHER_EVENT_NAME_18: "Update started",
    KARCHER_EVENT_NAME_19: "Update finished",
    KARCHER_EVENT_NAME_20: "Start WS Reg",
    KARCHER_EVENT_NAME_21: "End WS Reg",
    KARCHER_EVENT_NAME_22: "WS 75% sensor",
    KARCHER_EVENT_NAME_23: "Tech. defect",
    KARCHER_EVENT_NAME_24: "Oper. defect",
    KARCHER_EVENT_NAME_25: "Unit on",
    KARCHER_EVENT_NAME_26: "Unit closed",
    KARCHER_EVENT_NAME_27: "Box 1 closed",
    KARCHER_EVENT_NAME_28: "Box 2 closed",
    KARCHER_EVENT_NAME_29: "Box 3 closed",
    KARCHER_EVENT_NAME_30: "Box 4 closed",
    KARCHER_EVENT_NAME_31: "Box 5 closed",
    KARCHER_EVENT_NAME_32: "Box 6 closed",
    KARCHER_EVENT_NAME_33: "Box 7 closed",
    KARCHER_EVENT_NAME_34: "Box 8 closed",
    KARCHER_EVENT_NAME_35: "HP pump bay 1",
    KARCHER_EVENT_NAME_36: "HP pump bay 2",
    KARCHER_EVENT_NAME_37: "HP pump bay 3",
    KARCHER_EVENT_NAME_38: "HP pump bay 4",
    KARCHER_EVENT_NAME_39: "HP pump bay 5",
    KARCHER_EVENT_NAME_40: "HP pump bay 6",
    KARCHER_EVENT_NAME_41: "HP pump bay 7",
    KARCHER_EVENT_NAME_42: "HP pump bay 8",
    KARCHER_EVENT_NAME_43: "Burner",
    KARCHER_EVENT_NAME_44: "Burner fan",
    KARCHER_EVENT_NAME_45: "Warm water pump",
    KARCHER_EVENT_NAME_46: "Freeze prot.pump",
    KARCHER_EVENT_NAME_47: "Osmosis pump",
    KARCHER_EVENT_NAME_48: "Floor heating",
    KARCHER_EVENT_NAME_49: "Hose heating",
    KARCHER_EVENT_NAME_50: "Microe/rim clean",
    KARCHER_EVENT_NAME_51: "Underc. pump",
    KARCHER_EVENT_NAME_52: "Booster pumpFoam",
    KARCHER_EVENT_NAME_53: "Vacuum clean. 1",
    KARCHER_EVENT_NAME_54: "Vacuum clean. 2",
    KARCHER_EVENT_NAME_55: "Vacuum clean. 3",
    KARCHER_EVENT_NAME_56: "Vacuum clean. 4",
    KARCHER_EVENT_NAME_57: "Vacuum clean. 5",
    KARCHER_EVENT_NAME_58: "Vacuum clean. 6",
    KARCHER_EVENT_NAME_59: "Vacuum clean. 7",
    KARCHER_EVENT_NAME_60: "Vacuum clean. 8",
    KARCHER_EVENT_NAME_61: "Vacuum clean. 9",
    KARCHER_EVENT_NAME_62: "Vacuum clean. 10",
    KARCHER_EVENT_NAME_63: "Vacuum clean. 11",
    KARCHER_EVENT_NAME_64: "Vacuum clean. 12",
    KARCHER_EVENT_NAME_65: "Pump rim clean",
    KARCHER_EVENT_NAME_66: "Pump Microe.",
    KARCHER_EVENT_NAME_67: "Pump Intensive",
    KARCHER_EVENT_NAME_68: "Vacuum1 turbine",
    KARCHER_EVENT_NAME_69: "Vacuum1 filter",
    KARCHER_EVENT_NAME_70: "Vacuum2 turbine",
    KARCHER_EVENT_NAME_71: "Vacuum2 filter",
    KARCHER_EVENT_NAME_72: "Vacuum3 turbine",
    KARCHER_EVENT_NAME_73: "Vacuum3 filter",
    KARCHER_EVENT_NAME_74: "Vacuum4 turbine",
    KARCHER_EVENT_NAME_75: "Vacuum4 filter",
    KARCHER_EVENT_NAME_76: "Vacuum5 turbine",
    KARCHER_EVENT_NAME_77: "Vacuum5 filter",
    KARCHER_EVENT_NAME_78: "Vacuum6 turbine",
    KARCHER_EVENT_NAME_79: "Vacuum6 filter",
    KARCHER_EVENT_NAME_80: "Vacuum7 turbine",
    KARCHER_EVENT_NAME_81: "Vacuum7 filter",
    KARCHER_EVENT_NAME_82: "Vacuum8 turbine",
    KARCHER_EVENT_NAME_83: "Vacuum8 filter",
    KARCHER_EVENT_NAME_84: "Vacuum9 turbine",
    KARCHER_EVENT_NAME_85: "Vacuum9 filter",
    KARCHER_EVENT_NAME_86: "Vacuum10 turbine",
    KARCHER_EVENT_NAME_87: "Vacuum10 filter",
    KARCHER_EVENT_NAME_88: "Vacuum11 turbine",
    KARCHER_EVENT_NAME_89: "Vacuum11 filter",
    KARCHER_EVENT_NAME_90: "Vacuum12 turbine",
    KARCHER_EVENT_NAME_91: "Vacuum12 filter",
    INSERT_TOKEN:  "Insert tokens and start service",
    OPEN_SESSION: "Session successfully opened",
    IN_PROGRESS: "In progress ...",
    TOKEN_INSERTED: "Tokens inserted successfully",
    EXPIRED_SESSION: "Session expired",
    TWO_DIGIT_INTEGER_VALIDATION: "Use max two digit integer",
    KARCHER_OPERATION_COUNTER_1: "Washing station 1 HP pump",
    KARCHER_OPERATION_COUNTER_2: "Washing station 1 chemical pump 1",
    KARCHER_OPERATION_COUNTER_3: "Washing station 1 chemical pump 2",
    KARCHER_OPERATION_COUNTER_4: "Washing station 1 chemical pump 3",
    KARCHER_OPERATION_COUNTER_5: "Washing station 1 chemical pump 4",
    KARCHER_OPERATION_COUNTER_6: "Washing station 2 HP pump",
    KARCHER_OPERATION_COUNTER_7: "Washing station 2 chemical pump 1",
    KARCHER_OPERATION_COUNTER_8: "Washing station 2 chemical pump 2",
    KARCHER_OPERATION_COUNTER_9: "Washing station 2 chemical pump 3",
    KARCHER_OPERATION_COUNTER_10: "Washing station 2 chemical pump 4",
    KARCHER_OPERATION_COUNTER_11: "Washing station 3 HP pump",
    KARCHER_OPERATION_COUNTER_12: "Washing station 3 chemical pump 1",
    KARCHER_OPERATION_COUNTER_13: "Washing station 3 chemical pump 2",
    KARCHER_OPERATION_COUNTER_14: "Washing station 3 chemical pump 3",
    KARCHER_OPERATION_COUNTER_15: "Washing station 3 chemical pump 4",
    KARCHER_OPERATION_COUNTER_16: "Washing station 4 HP pump",
    KARCHER_OPERATION_COUNTER_17: "Washing station 4 chemical pump 1",
    KARCHER_OPERATION_COUNTER_18: "Washing station 4 chemical pump 2",
    KARCHER_OPERATION_COUNTER_19: "Washing station 4 chemical pump 3",
    KARCHER_OPERATION_COUNTER_20: "Washing station 4 chemical pump 4",
    KARCHER_OPERATION_COUNTER_21: "Washing station 5 HP pump",
    KARCHER_OPERATION_COUNTER_22: "Washing station 5 chemical pump 1",
    KARCHER_OPERATION_COUNTER_23: "Washing station 5 chemical pump 2",
    KARCHER_OPERATION_COUNTER_24: "Washing station 5 chemical pump 3",
    KARCHER_OPERATION_COUNTER_25: "Washing station 5 chemical pump 4",
    KARCHER_OPERATION_COUNTER_26: "Washing station 6 HP pump",
    KARCHER_OPERATION_COUNTER_27: "Washing station 6 chemical pump 1",
    KARCHER_OPERATION_COUNTER_28: "Washing station 6 chemical pump 2",
    KARCHER_OPERATION_COUNTER_29: "Washing station 6 chemical pump 3",
    KARCHER_OPERATION_COUNTER_30: "Washing station 6 chemical pump 4",
    KARCHER_OPERATION_COUNTER_31: "Washing station 7 HP pump",
    KARCHER_OPERATION_COUNTER_32: "Washing station 7 chemical pump 1",
    KARCHER_OPERATION_COUNTER_33: "Washing station 7 chemical pump 2",
    KARCHER_OPERATION_COUNTER_34: "Washing station 7 chemical pump 3",
    KARCHER_OPERATION_COUNTER_35: "Washing station 7 chemical pump 4",
    KARCHER_OPERATION_COUNTER_36: "Washing station 8 HP pump",
    KARCHER_OPERATION_COUNTER_37: "Washing station 8 chemical pump 1",
    KARCHER_OPERATION_COUNTER_38: "Washing station 8 chemical pump 2",
    KARCHER_OPERATION_COUNTER_39: "Washing station 8 chemical pump 3",
    KARCHER_OPERATION_COUNTER_40: "Washing station 8 chemical pump 4",
    KARCHER_OPERATION_COUNTER_41: "Osmosis pump",
    KARCHER_OPERATION_COUNTER_42: "Hot water generator",
    KARCHER_OPERATION_COUNTER_43: "Frost protection pump",
    KARCHER_OPERATION_COUNTER_44: "WSO filter inlay",
    KARCHER_OPERATION_COUNTER_45: "Washing station heater pump",
    KARCHER_OPERATION_COUNTER_46: "Hot water pump",
    KARCHER_OPERATION_COUNTER_47: "Foam hose heating",
    KARCHER_OPERATION_COUNTER_48: "Wheel cleaning pump",
    KARCHER_OPERATION_COUNTER_49: "Micro-emulsion pump",
    KARCHER_OPERATION_COUNTER_50: "Intensive foam pump",
    KARCHER_OPERATION_COUNTER_51: "Vacuum cleaner 1 turbine 1",
    KARCHER_OPERATION_COUNTER_52: "Vacuum cleaner 1 filter 1",
    KARCHER_OPERATION_COUNTER_53: "Vacuum cleaner 1 turbine 2",
    KARCHER_OPERATION_COUNTER_54: "Vacuum cleaner 1 filter 2",
    KARCHER_OPERATION_COUNTER_55: "Vacuum cleaner 2 turbine 1",
    KARCHER_OPERATION_COUNTER_56: "Vacuum cleaner 2 filter 1",
    KARCHER_OPERATION_COUNTER_57: "Vacuum cleaner 2 turbine 2",
    KARCHER_OPERATION_COUNTER_58: "Vacuum cleaner 2 filter 2",
    KARCHER_OPERATION_COUNTER_59: "Vacuum cleaner 3 turbine 1",
    KARCHER_OPERATION_COUNTER_60: "Vacuum cleaner 3 filter 1",
    KARCHER_OPERATION_COUNTER_61: "Vacuum cleaner 3 turbine 2",
    KARCHER_OPERATION_COUNTER_62: "Vacuum cleaner 3 filter 2",
    KARCHER_OPERATION_COUNTER_63: "Vacuum cleaner 4 turbine 1",
    KARCHER_OPERATION_COUNTER_64: "Vacuum cleaner 4 filter 1",
    KARCHER_OPERATION_COUNTER_65: "Vacuum cleaner 4 turbine 2",
    KARCHER_OPERATION_COUNTER_66: "Vacuum cleaner 4 filter 2",
    KARCHER_OPERATION_COUNTER_67: "Vacuum cleaner 5 turbine 1",
    KARCHER_OPERATION_COUNTER_68: "Vacuum cleaner 5 filter 1",
    KARCHER_OPERATION_COUNTER_69: "Vacuum cleaner 5 turbine 2",
    KARCHER_OPERATION_COUNTER_70: "Vacuum cleaner 5 filter 2",
    KARCHER_OPERATION_COUNTER_71: "Vacuum cleaner 6 turbine 1",
    KARCHER_OPERATION_COUNTER_72: "Vacuum cleaner 6 filter 1",
    KARCHER_OPERATION_COUNTER_73: "Vacuum cleaner 6 turbine 2",
    KARCHER_OPERATION_COUNTER_74: "Vacuum cleaner 6 filter 2",
    KARCHER_OPERATION_COUNTER_75: "Drain condensation water from the compressor",
    KARCHER_OPERATION_COUNTER_76: "Check frost protection system",
    KARCHER_OPERATION_COUNTER_77: "Burner fan",
    KARCHER_OPERATION_COUNTER_78: "Booster pump foam",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Data list is larger than 10000 items",
    KARCHER_POINT_NAME_1: "Holiday",
    KARCHER_POINT_NAME_2: "Monday",
    KARCHER_POINT_NAME_3: "Tuesday",
    KARCHER_POINT_NAME_4: "Wednesday",
    KARCHER_POINT_NAME_5: "Thursday",
    KARCHER_POINT_NAME_6: "Friday",
    KARCHER_POINT_NAME_7: "Saturday",
    KARCHER_POINT_NAME_8: "Sunday",
    KARCHER_POINT_NAME_9: "Vacuums Holiday",
    KARCHER_POINT_NAME_10: "Vacuums Monday",
    KARCHER_POINT_NAME_11: "Vacuums Tuesday",
    KARCHER_POINT_NAME_12: "Vacuums Wednesday",
    KARCHER_POINT_NAME_13: "Vacuums Thursday",
    KARCHER_POINT_NAME_14: "Vacuums Friday",
    KARCHER_POINT_NAME_15: "Vacuums Saturday",
    KARCHER_POINT_NAME_16: "Vacuums Sunday",
    KARCHER_POINT_NAME_17: "Illumination Holiday",
    KARCHER_POINT_NAME_18: "Illumination Monday",
    KARCHER_POINT_NAME_19: "Illumination Tuesday",
    KARCHER_POINT_NAME_20: "Illumination Wednesday",
    KARCHER_POINT_NAME_21: "Illumination Thursday",
    KARCHER_POINT_NAME_22: "Illumination Friday",
    KARCHER_POINT_NAME_23: "Illumination Saturday",
    KARCHER_POINT_NAME_24: "Illumination Sunday",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR code",
    ACCEPT_TERMS_AND_CONDITIONS: "Accept terms and conditions",
    CODE_PREFIX_QUESTION: "Code prefix is not entered",
    CODE_PREFIX_QUESTION_TEXT: "Do you want to proceed without a code prefix?",
    ISSUED_DATE: "Issued date",
    VOUCHER_VALIDITY_DAYS: "Voucher validity (days)",
    VALIDATION_ONLY_NUMBERS: "Only numbers are allowed",
    REPRINT_VOUCHERS: "Print copy of vouchers",
    EXPIRY_DATE: "Valid until",
    VOUCHER_EXPIRATION_DAYS_UPDATED: "Voucher expiration days updated successfully"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("deTranslations", {
    MESSAGE:"Nachricht",
    ERROR_TITLE:"Fehler",
    ERROR_MESSAGE:"Ein Fehler ist während der Ausführung aufgetreten.",
    ERROR_LOGIN:"Es ist ein Fehler beim Log-In aufgetreten. Die angegebene E-Mail-Adresse ist ungültig. Bitte versuchen Sie es erneut.",
    ERROR_LOGIN_ROLE:"Die ausgewählte Rolle ist für die angegebene Person nicht freigeschaltet",
    OK:"Ok",
    CANCEL:"Abbrechen",
    YES:"Ja",
    NO:"Nein",
    FROM:"Von",
    TO:"Bis",
    DELETE:"Löschen",
    SIGN_OUT:"Abmelden",
    NAME:"Name",
    DATE:"Datum/Uhrzeit",
    PIECES:"Stücke",
    HOURS:"Stunden",
    DAYS:"Tage",
    MONTH:"Monat",
    MONTHS:"Monate",
    YEAR:"Jahr",
    BOX:"Box",
    SEARCH:"Suche",
    ALL_USERS:"Alle Benutzer",
    ARE_YOU_SURE:"Sind Sie sicher?",
    BACK:"Zurück",
    AMOUNT:"Menge",
    DESCRIPTION:"Beschreibung",
    FORGOT_PASSWORD_ERROR_MSG:"Es ist ein Fehler aufgetreten. Bitte überprüfen Sie Ihre E-Mail-Adresse und versuchen Sie es erneut.",
    REQUIRED_FIELD:"Das Feld ist erfolderlich",
    LOGOUT_TITLE:"Sind Sie sicher, dass Sie sich abmelden möchten?",
    LOGOUT_MSG:"All ihre ungespeicherten Daten gehen verloren.",
    ACTIVATION_ACCOUNT:"Sie haben Ihr Konto erfolgreich aktiviert",
    UNKNOWN_ERRROR_NOTIFICATION:"Es ist ein unbekannter Fehler aufgetreten",
    CONTINUE:"Weiter",
    DATA_NOT_AVAILABLE:"Keine Daten verfügbar",
    SELECT:"Auswählen",
    SELECT_CURRENCY:"Währung auswählen",
    UPLOAD:"Hochladen",
    PHONE:"Telefonnummer",
    WEBSITE:"Website",
    WORKING_HOURS:"Öffnungszeiten",
    INSERT:"Einfügen",
    TEXT:"Text",
    CREATED:"Erstellt",
    VALID_UNTIL:"Gültig bis",
    SAVE:"Speichern",
    TOKENS:"Wertmarken",
    DELETE_COMPANY_HISTORY:"Waschanlagenverlauf dauerhaft löschen?",
    DELETE_COMPANY_HISTORY_MESSAGE:"ACHTUNG: Nach Bestätigung werden alle Transaktionen Ihrer Waschanlage unwiderruflich gelöscht!",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Sind Sie sicher, dass Sie alle Transaktionsdaten unwiderruflich löschen möchten?",
    HISTORY_SUCCESSFULY_DELETED:"Verlauf erfolgreich gelöscht",
    HELP:"Hilfe",
    VALUE:"Wert",
    ACTIVATING_ACCOUNT_ERROR:"Ein Fehler ist während der Aktivierung Ihres R2W Kontos aufgetreten. Bitte versuchen Sie es erneut. Falls das Problem weiterhin besteht, wenden Sie sich bitte an support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Herzlich willkommen bei Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Herzlich willkommen bei R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Bitte geben Sie Ihr neues Passwort ein und bestätigen Sie es, um Ihr R2W-Konto zu aktivieren. Bei Erfolg werden Sie automatisch bei der Anwendung angemeldet.",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Sie können Ihre Benutzereinstellungen später in der Anwendung ändern",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:"Willkommen bei Kärcher Vehicle Wash",
    RESET_PASSWORD_WELCOME_MSG:"Ready2Wash Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Um ihr altes Passwort zu ersetzen geben Sie bitte ihr neues Passwort ein und bestätigen Sie dieses. Bei Erfolg werden Sie automatisch angemeldet.",
    RESET_PASSWORD_WELCOME_MSG_3:"Sie können ihre Profileinstellungen später in der Anwendung anpassen",
    ENTER_NEW_PASSWORD:"Geben Sie ein neues Passwort ein",
    REPEAT_NEW_PASSWORD:"Neues Passwort wiederholen",
    PASSWORD_MIN_LENGTH:"Das Passwort muss mindestens 8 Zeichen lang sein",
    PASSWORD_MAX_LENGHT:"Das Passwort darf nicht mehr als 32 Zeichen lang sein",
    PASSWORD_PATTERN:"Das Passwort muss mindestens einen großen und einen kleinen Buchstaben enthalten",
    PASSWORD_MATCH:"Die Passwörter sind nicht identisch",
    ACTIVATE:"Aktivieren",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Sie haben die Anfrage erfolgreich gesendet. Bitte überprüfen Sie ihr Postfach auf eine Bestätigungsnachricht",
    VALIDATION_REQUIRED:"Pflichtfeld",
    VALIDATION_EMAIL:"Falsche E-Mail-Adresse",
    VALIDATION_INTEGER_NUMBER:"Der Wert muss eine Zahl sein",
    VALIDATION_HOURS_VALUE:"Der Wert muss zwischen 0-23 sein",
    VALIDATION_MINUTES_VALUE:"Der Wert muss zwischen 0-59 sein",
    VALIDATION_NOT_A_DATE:"Der eingegebene Wert ist kein Datum",
    VALIDATION_FROM:"Das eingegebene Datum muss vor dem Enddatum liegen",
    VALIDATION_TO:"Das eingegebene Datum muss nach dem Sartdatum liegen",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Diese Informationen geben es bereits in der Datenbank",
    PASSWORD_VALIDATION_PATTERN_NEW:"Das Passwort muss mindestens einen Großbuchstaben und eine Zahl enthalten. Leerzeichen sind nicht erlaubt.",
    VALIDATION_PERCENT_VALUE:"Der Wert muss zwischen 1-999 sein",
    NUMBERS_ONLY_100:"Der Wert muss unter 100 liegen",
    NUMBERS_ONLY_1000:"Der Wert muss unter 1000 liegen",
    POSITIVE_NUMBERS_ONLY:"Nur positive Zahl",
    GRID_PAGER_PAGE:"Seite",
    GRID_PAGER_ROWS_PER_PAGE:"Zeilen pro Seite",
    GRID_PAGER_PAGE_OF:"Von",
    BREAD_CRUMBS_HOME:"Startseite",
    BREAD_CRUMBS_DASHBOARD_TECH:"Überblick der Waschanlagen",
    BREAD_CRUMBS_DETAILS:"Details",
    BREAD_CRUMBS_SETTINGS:"Einstellungen",
    BREAD_CRUMBS_WORKING_HOURS:"Öffnungszeiten",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Gesamtumsatz pro Tag",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Durchschnittlicher Umsatz pro Stunde",
    BREAD_CRUMBS_NEW_USER_GROUP:"Kundengruppe erstellen",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Benutzergruppe ändern",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage erstellen",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage bearbeiten",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Bonusprogramm erstellen",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Bonusprogramm bearbeiten",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Rechnungsübersicht",
    LOGIN:"Anmeldung",
    EMAIL:"E-Mail",
    PASSWORD:"Passwort",
    LANGUAGE:"Sprache",
    FORGOT_PASSWORD:"Passwort vergessen?",
    SUBMIT:"Bestätigen",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Anzahl der aktuellen kritischen Fehler:",
    HEADER_VIEW_ALL_ALARMS:"Alle Fehlermeldungen betrachten...",
    HEADER_MY_ACCOUNT:"Mein Konto",
    HEADER_ACCOUNT_MANAGEMENT:"Kontoverwaltung",
    ACCOUNT_ALREADY_EXIST:"Diese E-Mail-Adresse ist bereits in Verwendung",
    NEWSLETTER_CONFIRMATION:"Benachrichtigung per E-Mail bei Fehlermeldungen",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Umsätze",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Übersicht Waschanlagen",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Übersicht",
    ASIDE_MENU_ALARMS:"Übersicht Fehlermeldungen",
    ASIDE_MENU_FACILITIES:"Waschanlagen",
    ASIDE_MENU_REPORTS:"Reports",
    ASIDE_MENU_REPORT:"Ausgewählter Bericht",
    ASIDE_MENU_LOYALTY:"Bonusprogramm",
    ASIDE_MENU_USER_GROUPS:"Kundengruppen",
    ASIDE_MENU_PERIODIC_SUMMARY:"Rechnungsübersicht",
    ASIDE_MENU_MANAGING_TOKENS:"Wertmarken verwalten",
    ASIDE_MENU_NEWS:"Neuigkeiten",
    DAILY_FINANCES_TOTAL_MONEY:"Gesamtumsatz",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Gesamtumsatz aller Anlagen",
    DAILY_FINANCES_TOTAL_COINS:"Insgesamt verwendete Metall-Token",
    DAILY_FINANCES_DOWNLOAD_CSV:"CSV herunterladen",
    DAILY_FINANCES_ONLINE:"Online",
    DAILY_FINANCES_OFFLINE:"Bargeld",
    DAILY_FINANCES_CHANGER:"Wechselautomat Bargeld",
    DAILY_FINANCES_COINS:"Wertmarken",
    REPORTS_FILTER:"Filter",
    REPORTS_TYPE_OF_REPORT:"Art des Reports",
    REPORTS_CHOOSE_FACILITY:"Stationsauswahl",
    REPORTS_PERIOD_1:"Periode 1 - ",
    REPORTS_PERIOD_2:"Periode 2 - ",
    MONEY_BY_DATE_REPORT:"Gesamtumsatz pro Tag",
    R2W_BY_DATE_REPORT:"Online - Zahlungen pro Tag gesamt",
    COINS_BY_DATE_REPORT:"Wertmarken pro Tag gesamt",
    AVG_MONEY_BY_HOUR_REPORT:"Durchschnittlicher Umsatz pro Stunde",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Durchschnittlicher Umsatz pro Tag",
    AVG_MONEY_BY_BOX_REPORT:"Durchschnittlicher Umsatz pro Waschbox",
    COMPARE_PERIODS_REPORT:"Umsatzbericht im Zeitraum",
    TOTAL_USERS_BY_GROUP:"Nutzer pro Tag gesamt",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"Benutzer",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"Besuche",
    VISITS_COUNT_REPORT:"Anzahl der Besuche pro Tag",
    LOYALTY_PER_DAY_REPORT:"Anzahl der pro Tag ausgegebenen lokalen Wertmarken",
    LOYALTY_PER_PAYMENT_METHOD:"Gegebene lokale Wertmarken pro Zahlungsmethode",
    VISITS:"Besuche",
    VISIT:"Besuch",
    TOTAL_SPENT_MONEY:"Gesamtumsatz",
    MONEY:"Geld",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Gesamtumsatz für den Zeitraum",
    DOWNLOAD_CSV:"CSV herunterladen",
    TOTAL_SPENT_COINS:"Gesamtanzahl Token im Umlauf",
    TOTAL_USERS:"Benutzer insgesamt",
    TOTAL_CREDIT_GIVEN:"Wertmarken im Umlauf",
    EUROKEY_BY_DATE_REPORT:"Die Gesamtzahlungen von Euro-Taste",
    TOTAL_SPENT_EUROKEY:"Insgesamt verbracht",
    SELECT_TYPE_OF_REPORT:"Bitte wählen Sie den Typ des Berichts aus",
    NUMBER_OF_VISITS_TITLE:"Anzahl der Besuche",
    NUMBER_OF_USERS_TITLE:"Anzahl der Nutzer",
    PIECES_TITLE:"Stücke",
    TOTAL_VISITS:"Besuche insgesamt",
    TOKENS_TITLE:"Wertmarken",
    SEARCH_USERS_NO_RESULTS:"Keine Kunden für festgelegtes Suchkriterium gefunden",
    SEARCH_USERS:"Kunden suchen",
    SEARCH_TELEPHONES:"Kundensuche über Handynummer",
    ADD_USER_TO_GROUP:"Kunde durch E-Mail-Adresse zu der Gruppe hinzufügen",
    REMOVE_USER_FROM_GROUP:"Kunden aus der Gruppe entfernen",
    USER_GROUP_NAME_REQUIRED:"Ein Name für die Kundengruppe wird benötigt",
    USER_GROUP_NAME:"Name der Kundengruppe",
    USER_GROUPS_OVERVIEW:"Übersicht der Kundengruppen",
    USER_COUNT:"Kundenanzahl",
    NEW_USER_GROUP:"Erstellen Sie eine neue Kundengruppe",
    DELETE_USER_GROUP:"Kundengruppe löschen",
    UPDATE_USER_GROUP:"Kundengruppe bearbeiten",
    DELETE_USER_GROUP_ERROR:"Ein Fehler ist während der Löschung der ausgewählten Kundengruppe aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den technischen Support ...",
    CONFIRM_DELETE_USER_GROUP:"Sind Sie sicher, dass Sie die ausgewählte Kundengruppe löschen möchten?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Sonderangebote, denen die Gruppe zugeteilt wurde, werden nicht mehr aktiv sein.",
    GROUP_NAME_MAX_LENGTH:"Der Gruppenname muss weniger als 255 Zeichen haben.",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Der Kunde ist schon in dieser Gruppe.",
    MISSING_USER:"Kunde nicht gefunden",
    USER_NOT_ON_LIST:"Die von Ihnen eingegebene E-Mail-Adresse ist entweder nicht korrekt oder der Kunde ist noch nicht in der Kundenstammliste hinterlegt. Bitte überprüfen Sie die eingegebene E-Mail-Adresse und versuchen Sie es erneut.",
    UPLOAD_USER_GROUP:"Bitte laden Sie die Liste der Kundengruppe aus der CSV-Datei hoch",
    UKNOWN_USERS:"Liste der unbekannten Kunden",
    CAMPAIGN_TEMPLATE_RULE:"Vorlage Regeln Bonusprogramm",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Ein Fehler ist während der Löschung der ausgewählten Bonusprogramm-Vorlage aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den technischen Support...",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Sind Sie sicher, dass Sie die ausgewählte Bonusprogramm-Vorlage löschen möchten?",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Sind Sie sicher, dass Sie die ausgewählte Bonusprogramm-Vorlage löschen möchten?",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Übersicht der Bonusprogramm-Vorlagen",
    DELETE_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage löschen",
    UPDATE_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage ändern",
    CREATE_CAMPAIGN_TEMPLATE:"Bonusprogramm-Vorlage erstellen",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Es wird ein Name für die Vorlage des Bonusprogramms benötigt",
    CAMPAIGN_TEMPLATE_NAME:"Name der Bonusprogramm-Vorlage",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Pflichtfeld",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"Rabatt in %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"Extra Zeit",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Bitte wählen Sie zuerst den Typ. Waschboxen oder kleine Maschinen.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Vorlage löschen",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Von",
    CAMPAIGN_TEMPLATE_RULE_TO:"Bis",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"Stunden",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"Minuten",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Neue Regel erstellen: Bonusmarken durch häufuge Besuche",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Neue Regel erstellen: Bonusmarken durch hohen Umsatz",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Neue Regel bezüglich der Wochentage",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Die neue Regel hinzufügen",
    CAMPAIGN_TEMPLATE_RULE_1:"Bei",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Bei Ausgabe von",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"Wertmarken innerhalb von",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"besuchen in weniger als",
    CAMPAIGN_TEMPLATE_RULE_3:"Tagen bekommt der Kunde",
    CAMPAIGN_TEMPLATE_RULE_4:"Wertmarken",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Die Regelliste ist leer.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum kann nicht in der Vergangenheit sein",
    DELETE_CAMPAIGN_ERROR:"Ein Fehler ist während der Löschung der ausgewählten Bonusprogramms aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den technischen Support...",
    CONFIRM_DELETE_CAMPAIGN:"Sind Sie sicher, dass Sie das ausgewählte Bonusprogramm löschen möchten?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"Möchten Sie den ausgewählten Bonusprogramm-Text wirklich löschen?",
    CAMPAIGNS_OVERVIEW:"Bonusprogramm bearbeiten",
    DELETE_CAMPAIGN:"Bonusprogramm löschen",
    UPDATE_CAMPAIGN:"Bonusprogramm ändern",
    CREATE_CAMPAIGN:"Neues Bonusprogramm erstellen",
    CAMPAIGN_ACTIVE:"Aktiv",
    CAMPAIGN_TEMPLATE:"Vorlage",
    CAMPAIGN_GROUPS:"Gruppen",
    CAMPAIGN_ALL_USERS:"Alle Benutzer",
    CAMPAIGN_NAME:"Name des Bonusprogramms",
    CAMPAIGN_NAME_REQUIRED:"Es wird ein Name für das Bonusprogramm benötigt",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Kunden welche nah am Tageslimit sind",
    MESSAGE_TO_USERS:"Nachricht an die gefilterten Kunden",
    SEND_MESSAGE:"Nachricht senden",
    THRESHOLD:"Limit",
    TYPE:"Typ",
    TOTAL_MONEY_SPENT:"Insgesamt ausgegebenes Geld während dieses Bonusprogramms",
    NUMBER_OF_VISITS:"Besuche während des Bonusprogramms",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Die Nachricht muss mindestens 10 Zeichen lang sein",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Die Nachricht darf nicht mehr als 350 Zeichen haben ",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Ein Text ist erforderlich",
    TECHNOLOGY:"Technologie",
    TAP_WATER:"Stadtwasser",
    REVERSE_OSMOSIS:"Umkehrosmose",
    SOFTENED_WATER:"Weichwasser",
    DOSER:"Dosierer",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Letzte Synchronisierung",
    NO_OF_CURRENT_ALARMS:"Anzahl der aktuellen Fehlermeldungen",
    NO_OF_CURRENT_WARNINGS:"Anzahl der aktuellen Warnungen",
    WEATHER:"Wetter",
    BOXES_WORK_HOURS_COUNTERS:"Arbeitsstundenzähler der Waschboxen",
    BOX_TOTAL_HOURS:"Gesamtstunden aller Waschboxenzähler",
    BOX_SERVICE_HOURS:"Stundenzähler Service",
    BOX_COUNTER_HOURS:"Stunden",
    ALARMS_AND_WARNINGS:"Alarme und Warnungen",
    FILTER_AND_BOILER:"Filter und Boiler",
    FILTER_TOTAL_DAYS:"Stundenzähler Filter",
    BOILER_TOTAL_DAYS:"Stundenzähler Boilers",
    DAYS_UNIT:"Tage",
    SOFTENER:"Weichmacher",
    MANUAL_COLD_DRAIN:"Kaltwasserabfluss manuell",
    EL_COLD:"El. Winter",
    DRAIN:"Abfluss",
    TAP:"Wasserhahn",
    WASTE:"Abfall",
    OSMOSIS:"Osmose",
    DEMI_WATER:"demineralisiertes Wasser",
    EL_RINSE:"El. m. Spülung",
    BOILER:"Boiler",
    EL_WAX:"El. m. Vachs",
    FLOOR_HEATING:"Fußbodenheizung",
    DOSER_TANK:"Dosiertank",
    EL_WASH:"El. m. Waschen",
    DETERGENT:"Reinigungsmittel",
    VIBRATOR:"Vibrator",
    UPDATE_FACILITY_SETTINGS:"Einstellungen aktualisieren",
    GENERAL_SETTINGS:"Allgemeine Einstellungen",
    LIGHTS:"Licht",
    GROUPS:"Gruppen",
    ANTI_FREEZE:"Frostschutz",
    AUTO:"Auto",
    MANUAL:"Manuell",
    ON:"Ein",
    OFF:"Aus",
    TEMPERATURE:"Temperatur",
    UPDATE_DEVICE:"Waschanlagen Einstellungen aktualisieren",
    BOX_CLEAN_HOURS:"Stundenzähler Waschbox",
    GROUP_COUNTERS:"Gruppenzähler",
    RESET:"zurücksetzen",
    CASH_COUNT:"Münzzähler",
    COINS_COUNT:"Wertmarkenzähler",
    EUROKEY_COUNT:"Eurokeyzähler",
    DOSER_WORK:"Zähler Dosierer (Sek.)",
    DOSER_PAUSE:"Zähler Pausezeit Dosierer (Sek.)",
    DELAY_BFV:"BFV Verspätung (ms)",
    DELAY_6M1:"6M1 Verspätung (ms)",
    DELAY_LPS:"LPS Verspätung (ms)",
    RESET_CASH_COUNT_ALL:"Alle Münzzähler zurücksetzen",
    RESET_COINS_COUNT_ALL:"Alle Wertmarkenzähler zurücksetzen",
    RESET_EUROKEY_COUNT_ALL:"Alle Eurokeyzähler zurücksetzen",
    FACILITY_DETAILS:"Anlagendetails",
    FACILITY_NAME:"Anlagentyp",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Sie haben erfolgreich ein Bild hochgeladen",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Sie haben erfolgreich Angaben geändert",
    CONNECTED:"Verbunden",
    DISCONNECTED:"Getrennt",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Nachrichtenfilter",
    FACILITY:"Waschanlage",
    APPLY:"Anwenden",
    TIME:"Zeit",
    LOCATION:"Standort",
    ACKNOWLEDGED:"Bemerkt",
    FILTERED_MESSAGES:"gefilterte Nachrichten",
    ACK:"entdeckt",
    NOT_ACK:"Unentdeckt",
    ALL:"Alle",
    ALL_FACILITIES:"Alle Waschanlagen",
    ENTER_DATE_PLACEHOLDER:"Datum eingeben",
    OP_NESTANAK_NAPONA:"Netzausfall Fehler - 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Hochdruckpumpe - Fehler Motorschutzschalter",
    OP_UPR_NAPON_24VAC_GRE:"Steuerspannung 24VAC Fehler -5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Frischwassertank - Trockenlaufschutz",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Hauptpumpe - Fehler Motorschutzschalter",
    OP_MIN_NIVO_OMEKS_VODE:"Weichwassertank - Trockenlaufschutz",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Weichwasserpumpe - Fehler Motorschutzschalter",
    OP_MIN_NIVO_DEMIN_VODE:"Osmosewasser Tank - Trockenlaufschutz",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Osmosewasser Pumpe - Fehler Motorschutzschalter",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Umkehrosmose Pumpe - Fehler Motorschutzschalter",
    OP_BOJLER_GRESKA_MZS:"Boiler Fehler",
    OP_CRPKA_PRASKA_GRE_MZS:"Heißwasserpumpe - Fehler Motorschutzschalter",
    OP_DOZATOR_PRASKA_GRE_MZS:"Schaumdosierer - Fehler Motorschutzschalter",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Dosierpumpe Schaum - Fehler Schutzschalter",
    OP_MIN_PRASAK_TON_ALARM:"Pulvermischbehälter leer",
    OP_USIS_KOV_TURBINA_GRESKA:"Staubsaugerturbine - Fehler Motorschutzschalter",
    OP_FILTER_VODE_ZACEPLJEN:"Wasserfilter verstopft",
    OP_VISKTL_RESET_SATI_RADA:"Service Hochdruckpumpe",
    OPW_VISKTL_RESET_SATI_RADA:"Service Hochdruckpumpe",
    OP_FILTER_DANI_RADA:"Fehler Wasserfilter",
    OP_BOJLER_DANI_RADA:"Fehler Boiler",
    OPW_ALARM_VISOKOTL_PUMPA:"Fehlermeldung Hochdruckpumpe",
    OPW_ALARM_FILTER_SERVIS:"Servicealarm Filter",
    OPW_ALARM_BOJLER_SERVIS:"Servicealarm Boiler",
    HAS_MEMBERS:"Die ausgewählte Gruppe hat Mitglieder und kann somit nicht gelöscht werden. Bitte löschen Sie zuerst alle Mitglieder.",
    PERIODIC_SUMMARY_FOR:"periodischer Bericht für",
    PERIODIC_SUMMARY_REPORTS:"periodischer Bericht",
    DATE_RANGE:"Zeitraum",
    FINANCIAL_REPORT:"Finanzbericht",
    GROSS_INCOME:"Bruttoumsatz",
    GROSS_INCOME_SUM:"Summe Bruttoumsatz",
    COMMISSION_FEE:"Provisionsgebühr",
    NET_INCOME:"Nettoumsatz",
    COMMISSION_FEE_DETAILS:"Die Provisionsgebühren beinhalten die Gebühren der Bank, von PayPal und die Bereitstellungsgebühr von SMS",
    LOYALTY_CREDITS_REPORT:"Wertmarken-Bericht",
    LOYALTY_GIVEN:"Wertmarken aus Bonusprogrammen",
    LOYALTY_USED:"Verwendete Wertmarken",
    LOYALTY_SOLD:"Wertmarken im Umlauf",
    LOYALTY_TOTAL:"Insgesamt",
    LOYALTY_CURRENT_MONTH:"Aktueller Monat",
    SOMETHING_WENT_WRONG:"Es ist ein Fehler aufgetreten",
    MISSING_PAGE:"Tut uns leid. Wir konnten die Seite nicht laden.",
    TRY_AGAIN:"versuchen Sie es erneut",
    DEFAULT_ERROR_NAME:"Es ist ein unbekannter Fehler aufgetreten",
    DEFAULT_ERROR_DESCRIPTION:"Bitte versuchen Sie es erneut.",
    MY_ACCOUNT_DETAILS:"Meine Profildetails",
    SAVE_CHANGES:"Änderungen speichern",
    USERNAME:"E-Mail-Adresse des Kunden",
    FIRST_NAME:"Name",
    LAST_NAME:"Nachname",
    USER_ROLE:"Kundengruppe",
    OLD_PASSWORD:"Das alte Passwort",
    NEW_PASSWORD:"Das neue Passwort",
    OLD_PASSWORD_REQUIRED:"Das alte Passwortfeld ist erfolderlich",
    NEW_PASSWORD_REQUIRED:"Das neue Passwortfeld ist erforderlich",
    NEW_PASSWORD_REPEAT:"Es ist erforderlich, dass Sie das neue Passwort wiederholen",
    NEW_PASSWORD_NOT_MATCH:"Das alte und neue Passwort sind nicht identisch",
    PASSWORD_DIFFERENT_VALIDATION:"Das neue Passwort muss sich von dem alten unterscheiden",
    PASSWORD_MIN_CHAR:"Das Passwort muss mindestens 8 Zeichen enthalten",
    PASSWORD_MAX_CHAR:"Das Passwort darf nur maximal 32 Zeichen enthalten",
    PASSWORD_PATTERN_VALIDATION:"Das Passwort muss mindestens eine Ziffer enthalten",
    ACCOUNT_MANAGEMENT:"Profilverwaltung",
    NOT_ACTIVE:"Inaktiv",
    ASSIGN_ROLE:"Benutzergruppe",
    UPDATE:"Aktualisieren",
    ADD_NEW_ACCOUNT:"Einen neuen Benutzer hinzufügen",
    EMAIL_REQUIRED:"E-Mail-Adresse ist erforderlich",
    EMAIL_NOT_VALID:"Diese E-Mail-Adresse ist ungültig",
    ADD_NEW_USER_TEXT:"Email mit einem Aktivierungslink wird an diese Adresse gesendet",
    UPDATE_USER_NOTIFICATION:"Sie haben Ihre Informationen erfolgreich aktualisiert",
    CHANGED_PASSWORD_NOTIFICATION:"Sie haben Ihr Passwort erfolgreich geändert",
    UPDATE_USER_GROUP_NOTIFICATION:"Sie haben den Gruppennamen erfolgreich geändert",
    CREATE_USER_GROUP_NOTIFICATION:"Sie haben erfolgreich eine Gruppe erstellt",
    DETELE_USER_GROUP_NOTIFICATION:"Sie haben erfolgreich die Gruppe gelöscht",
    EMPTY_GROUP_LIST_MSG:"Es gibt noch keine Gruppen. Um zu beginnen, erstellen Sie eine",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Sie haben erfolgreich den Benutzer aus der Gruppe gelöscht",
    ADD_USER_TO_GROUP_NOTIFICATION:"Sie haben erfolgreich einen Benutzer zu einer Gruppe hinzugefügt",
    ADD_USER_NOTIFICATION:"Sie haben erfolgreich einen neuen Benutzer hinzugefügt.",
    DELETE_USER_NOTIFICATION:"Sie haben erfolgreich den Benutzer gelöscht.",
    RESEND_USER_VERIFICATION_EMAIL:"Sie haben erfolgreich die Autorisierungs-Mail erneut gesendet",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Um eine Kundengruppe zu erstellen, geben Sie bitte deren Namen ein",
    DELETE_USER:"Benutzer löschen",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Sind Sie sicher, dass Sie den Benutzer aus der Gruppe löschen möchten?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Sehr geehrte, wenn Sie uns während der Kampagne in diesem Monat besuchen, werden Sie einen Extrabonus auf Ihr Konto bekommen.",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Bonusmarken durch häufige Besuche",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Bonusmarken durch hohen Umsatz",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Regel bezüglich der Wochentage",
    REMOVE_CAMPAIGN_RULE_TITLE:"Diese Regel löschen",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Sind Sie sicher, dass Sie die Regel aus dem Bonusprogramm löschen möchten?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Sie haben erfolgreich ein neues Bonusprogramm erstellt",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Sie haben das Bonusprogramm erfolgreich aktiviert",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Es gibt noch keine gespeicherten Bonusprogramme. Um zu beginnen, müssen Sie eines erstellen.",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Sie haben die Nachricht erfolgreich versendet.",
    COMPANY_ACCOUNTS:"Firmenkontos",
    BUSSINESS_INVOICES_LIST:"Meine B2B Rechnungen",
    LOCALE_TOKEN:"Lokale Wertmarke",
    R2W:"Globale Wertmarke",
    START_MONTH:"Startmonat",
    END_MONTH:"Endmonat",
    TOKEN_TYPE:"Wertmarke Typ",
    TOKEN_NUMBER:"Anzahl der Wertmarken",
    NOTHING_TO_DISPLAY:"* Keine Anzeige",
    CREATE_INVOICE:"Rechnung erstellen",
    INVOICE:"Rechnung",
    INVOICES:"Rechnungen",
    EDIT_INVOICE:"Rechnung bearbeiten",
    UPDATE_INVOICE_NOTIFICATION:"Sie haben erfolgreich den Status der Rechnung in „ausstehend“ geändert",
    CURRENT_CHARGES:"Gebühren für den aktuellen Zeitraum",
    PAYMENTS_ON_HOLD:"Rechnungen in Bearbeitung",
    FOR_INVOICING:"Noch nicht in Rechnung gestellt",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Sie sind gerade dabei die Rechnung zu stornieren",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Sind Sie sicher, dass Sie die Rechnung stornieren möchten ?",
    INVOICING_NOTIFICATION_HEADER:"Sie sind gerade dabei eine Rechnung zu versenden",
    INVOICING_NOTIFICATION_TEXT:"Sind Sie sicher, dass Sie eine Rechnung schicken möchten?",
    SENT_INVOICE_NOTIFICATION:"Sie haben erfolgreich eine Rechnung gesendet",
    CANCELED_INVOICE_NOTIFICATION:"Sie haben erfolgreich die Rechnung storniert",
    INVOICE_DESCRIPTION_TEXT:"Rechnung für",
    INVOICE_STATE:"Status der Rechnung",
    INVOICE_NUMBER:"Rechnungsnummer",
    INVOICE_TOTAL:"Insgesamt",
    SELECT_YEAR:"Wählen Sie das Jahr",
    DOWNLOAD:"PDF herunterladen",
    INVOICE_NUMBER_HEADER:"Sie beabsichtigen die Rechnung mit folgender Nummer zu versenden:",
    INVOICE_PAYMENT_CONFIRMATION:"Sie beabsichtigen, folgende Zahlung zu bestätigen:",
    INSERT_INVOICE_NUMBER:"Rechnungsnummer eintragen",
    INVOICED_WARNING:"Die E-Mail wurde nicht gesendet. Bitte warten ...",
    SEND_INVOICE:"Senden",
    INVOICE_ALL:"Alle",
    INVOICE_FROM_R2W:"Von R2W",
    INVOICE_TO_R2W:"An R2W",
    PAYMENT_REQUEST:"Zahlungsaufforderung",
    PAYMENT_REQUEST_STATE:"Status der Zahlungsaufforderung",
    PAYMENT_REQUEST_NUMBER:"Nummer der Zahlungsaufforderung",
    FOR_PAYMENT_REQUEST:"Für Zahlungsaufforderungen",
    PAYMENT_REQUEST_ON_HOLD:"Zahlungsaufforderungen in Bearbeitung",
    DOWNLOAD_INVOICE:"Rechnung herunterladen",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Klicken Sie hier für die Optionen zum Herunterladen",
    B2B_SPEC:"B2B - Angaben",
    B2C_SPEC:"B2C - Angaben",
    DOWNLOAD_PAYMENT_REQUEST:"Zahlungsaufforderung herunterladen",
    LOYALTY_PREVIEW:"Übersicht Bonusprogramm",
    ACTIVATED:"Aktiviert",
    RUNNING:"Laufend",
    NOT_ACTIVATED:"Nicht aktiviert",
    FINISHED:"Fertig",
    DEPRECATED:"Veraltet",
    UPCOMING:"Kommend",
    NONE:"individuell",
    STARTED:"Gestartet",
    ENDS:"Endet",
    DEDICATED:"Profiteure",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Sie sind dabei folgendes zu aktivieren:",
    CAMPAIGN:"Treueprogramm",
    SEND_MESSAGE_NOTIFICATION:"Sie sind dabei eine Nachricht an die ausgewählte(n) Kundengruppe(n) zu senden",
    DIVISIBLE_TO_NUMBER:"Die Zahl sollte teilbar sein durch",
    BRIDGE_PLC:"PLC - Brücke",
    DEVICE_TYPE:"Gerätetyp",
    LISTENER:"Kleine Maschinen",
    BRIDGE:"Waschboxen",
    WASH_BOXES:"Waschboxen",
    VACUUMS:"Staubsauger",
    SAVE_NEWS:"Neuigkeit speichern",
    CREATE_NEW_NEWS:"Neue Neuigkeit erstellen",
    HISTORY_OF_ALL_NEWS:"Historie aller Neuigkeiten",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Geben Sie den Namen der Waschanlage ein",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Neue Waschanlage hinzufügen",
    NEWS_TEXT:"Text der Neuigkeit",
    NEWS_TITLE:"Titel der Neuigkeit",
    DELETE_NEWS_CONFIRMATION:"Möchten Sie die Neuigkeit löschen?",
    NEWS_DELETE_NOTIFICATION:"Sie haben erfolgreich die Neuigkeit gelöscht",
    NEWS_SAVE_NOTIFICATION:"Sie haben erfolgreich die Neuigkeit gespeichert",
    NEWS_CREATION_DATE:"Erstellungsdatum",
    NO_TITLE:"Ohne Titel",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Text der Neuigkeit darf nicht länger als 255 Zeichen sein",
    NEWS_TEXT_REQUIRED_VALIDATION:"Text der Neuigkeit ist erforderlich",
    NEWS_TITLE_REQUIRED_VALIDATION:"Titel der Neuigkeit ist erforderlich",
    DEACTIVATE:"Deaktivieren",
    ASIDE_MENU_LOCAL_TOKENS:"Lokale Wertmarken",
    CREATE_NEW_LOCAL_TOKENS:"Ausgabe neuer lokaler Wertmarken",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Geben Sie die E-Mail-Adresse des Kunden und die Anzahl der Wertmarken an, welche Sie ihm ausgeben möchten.",
    CREATE_TOKENS:"Wertmarken ausgeben",
    MINIMUM_ONE_TOKEN:"Der Wert muss größer als 0 sein",
    CUSTOMER_EMAIL:"Die E-Mail-Adresse des Kunden",
    AMOUNT_OF_TOKENS:"Anzahl der Wertmarken",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Erfolg bei der Ausgabe von Token an",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Ein Fehler ist  während der Ausgabe der Wertmarken aufgetreten. Bitte überprüfen Sie die E-Mail-Adresse des Kunden und versuchen Sie es erneut.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Übersicht aller ausgegebenen Wertmarken",
    ISSUED_AT:"ausgegeben am",
    ISSUED_BY:"ausgegeben von",
    CODE:"Gutscheincode",
    REDEEMED_BY:"eingelöst von",
    REDEEMED_AT:"eingelöst am",
    ASIDE_MENU_VOUCHERS:"Gutscheine",
    PRINT:"Drucken",
    VOUCHERS_OVERVIEW:"Übersicht der Gutscheine",
    CREATE_NEW_VOUCHERS:"Neue Gutscheine erstellen",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Erstellen Sie eine neue Gutscheinserie indem Sie die Anzahl der Wertmarken pro Gutschein bestimmen",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Anzahl der Wertmarken pro Gutschein",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Es ist erlaubt den Gutscheinen einen Wert zwischen 1 und 100 Wertmarken zuzuweisen",
    NUMBER_OF_NEW_VOUCHERS:"Anzahl an Gutscheinen in der Serie",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Sie können zwischen 1 und (Wert) Gutscheine in einer Serie erstellen",
    NEW_VOUCHERS_PREFIX:"Präfix der Gutscheinserie ",
    VALIDATION_VOUCHER_PREFIX:"Der Code-Präfix muss aus genau 4 Zeichen bestehen (Großbuchstaben und/oder Zahlen)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Es gab ein Problem während der Erstellung neuen Gutscheine. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support.",
    CREATE_VOUCHERS:"Gutscheine erstellen",
    CREATING_VOUCHERS_SUCCESS:"Die neuen Gutscheine wurden erfolgreich erstellt",
    PRINT_NEW_VOUCHERS:"Gutscheine drucken",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Alternativ können Sie den Präfixcode für eine Gutscheinreihe eingeben, um die ganze Gutscheinreihe zu drucken",
    PRINT_VOUCHERS_PREFIX:"Präfixcode des Gutscheines (Serie)",
    NO_VOUCHERS_FOR_PRINT:"Es wurden keine Gutscheine mit dem angegebenen Präfixcode zum Drucken gefunden",
    PRINT_VOUCHERS:"Gutschein(e) drucken",
    VALIDATION_VOUCHER_CODE_FILTER:"Der Suchbegriff für den Gutschein muss aus Großbuchstaben und Zahlen bestehen",
    FILTER_VOUCHERS_BY_CODE:"Suche Gutscheine nach dem Einlösecode",
    FILTER_VOUCHERS:"Gutscheine finden",
    WASH_BOX:"Waschbox",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Insgesamt verwendete digitale Token",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Gesamtanzahl pro Tag verkaufter Wertmarken",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Gesamtanzahl ausgegebener Wertmarken nach Datum",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Gesamtanzahl ausgegebener Wertmarken nach Datum",
    LOCAL_TOKEN:"Lokale Wertmarke",
    GIVEN_TOKEN:"Lokal ausgegebene Wertmarken",
    SOLD_TOKEN:"Lokal verkaufte Wertmarken",
    SMALL_MACHINES:"kleine Anlagen",
    R2W_Listener:"Höhrer",
    HHANLE_DEVICE:"HHanle - Waschbox",
    CODE_PREFIX_EXIST:"Präfixcode existiert bereits",
    CODE_PREFIX_EXIST_TEXT:"Sie können keinen neuen Gutschein mit diesem Präfixcode erstellen. Bitte geben Sie einen anderen Code ein.",
    MIN_FOUR_VALIDATION:"Genau 4 Zeichen",
    ALL_INFORMATION_1:"Alle Informationen über",
    ALL_INFORMATION_2:"werden verloren sein",
    ASIDE_MENU_TRANSACTIONS:"Transaktionen",
    EXPENSES:"Ausgaben",
    TOPUPS:"Aufladungen",
    EXPENSES_LIST:"Liste der Ausgaben",
    USER_EMAIL:"Kunden E-mail",
    COMPANY_NAME:"Name der Firma",
    TOPUPS_LIST:"Liste der Aufladungen",
    CONSUMER:"Verbraucher",
    SYSTEM_ADMIN:"Systemadministrator",
    MERCHANT_ADMIN:"Betreiber",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Betreuer Waschanlage",
    SUBSCRIBER:"Abonnent",
    CONFIGURATOR:"Konfigurator",
    SETUP_UNIT_SERIAL_NO:"Seriennummer",
    SETUP_UNIT_MATERIAL_NO:"Materialnummer",
    SETUP_UNIT_WEBAPI_VERSION:"WebApi - Version",
    TOTAL_TURNOVER:"Umsatz der Waschanlage",
    AVAILABILITY_ALL:"Verfügbarkeit",
    AVAILIBILITY:"Waschbox Verfügbarkeit:",
    AVAILABILITY_VACUUMS:"Staubsauger Verfügbarkeit:",
    WASH_BOX_INFO:"Info Waschboxen",
    VACUUM_CLEANER_INFO:"Info Staubsauger",
    BREAD_CRUMBS_SERVICE:"Service",
    HOLIDAYS:"Feiertage",
    HOLIDAY:"Feiertag",
    LIGHTS_ON:"Lichter an",
    LIGHTS_OFF:"Lichter aus",
    WASH_BOXES_ON:"Waschbox an",
    WASH_BOXES_OFF:"Waschbox aus",
    VACUUMS_ON:"Staubsauger an",
    VACUUMS_OFF:"Staubsauger aus",
    TURNOVER:"Umsatz",
    TURNOVER_MANUAL_WASH_UNIT:"Umsatz manuell",
    STATUS_BAY_RUN_TIME:"Gesamtstundenzähler Waschbox",
    STATUS_BAY_PROGRAM_NAME:"Programmname",
    STATUS_BAY_CREDIT:"Guthaben Waschbox",
    CLOUD_KREDIT:"Guthaben Cloud",
    STATUS_VACUUM_RUN_TIME:"Gesamtstundenzähler Staubsauger",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Informationen zu Diensten, Waschboxenprogrammen und aktuellen Fehlerdaten",
    UNAVAILABLE:"Einheit ist nicht verfügbar",
    SHOW_HIDE_TABLE:"Arbeitszeitentabelle anzeigen/verstecken",
    PROGRAM_NAME:"Programmname",
    PROGRAM_COUNTER:"Programmzähler",
    NO_NAME:"Die Referenz hat keinen Namen",
    COUNTER_SERVICE_DATA:"Sericedaten",
    NEED_SERVICE:"Service notwendig",
    PROGRAM_DATA:"Programmdaten der Waschbox",
    CURRENT_FAULT_DATA:"Aktuelle Fehlerdaten",
    REFERENCE_DUE:"wegen",
    REFERENCE_SECONDS:"Sekunden",
    REFERENCE_NAME:"Bauteilname",
    WASHBOX_NAME:"Name der Waschbox",
    FAULT_NAME:"Fehlerbezeichnung",
    FAULT_NUMBER:"Fehlernummer",
    CURRENT_FAULT_COUNT:"Aktive Fehler",
    DEVICE_NOT_INSTALLED:"Das Gerät ist nicht installiert",
    STATUS_READY:"Bereitschaftsstatus",
    STATUS_ERROR:"Fehlerstatus",
    CONNECTION_ERROR:"Verbindung getrennt",
    UNKNOWN_RESET:"Softwarefehler",
    SOFTWARE_RESET:"Softwarefehler",
    EXTERNAL_PIN_RESET:"Softwarefehler",
    RESTART_OR_BROWNOUT_OCCURRED:"Softwarefehler",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Hardwarefehler",
    COULD_NOT_SIMULATE_COIN:"Hardwarefehler",
    ERROR_SETTING_INHIBIT_MODE:"Hardwarefehler",
    OFFLINE_DEVICE:"Waschanlage vom Netz getrennt",
    TARIFFS:"Tarife",
    DAY:"Tag",
    NIGHT:"Nacht",
    VOUCHER_CODE:"Gutscheincode",
    DISMISS_ALARM:"Fehlermeldung zurücksetzen?",
    ALARM_ACTIVE:"Fehlermeldungen",
    NO_ALARM_ACTIVE:"Keine aktiven Fehlermeldungen",
    ALARM_HISTORY:"Fehlerhistorie",
    MANAGING_TOKENS:"Wertmarken verwalten",
    EXPIRATION_DATE:"Ablaufdatum",
    EXTEND_TOKEN_DATE:"Wertmarke ablaufdatum verlängern für",
    DELETE_TOKENS_FOR:"Wertmarken löschen für",
    PUMP_TYPE:"Pumpentyp",
    TURN_OFF_DEVICE:"Anlagenstatus",
    OPERATION_DATA:"Betriebsdaten",
    PUMP_DATA:"Pumpendaten",
    PUMP_NAME:"Pumpenname",
    POINT_NAME:"Bezugspunkt",
    CHANGER_INCOME:"Einnahmen vom Wechselautomaten nach Datum",
    SELECTED_OPEN:"Geöffnet zu ausgewählten Arbeitszeiten",
    ALWAYS_OPEN:"Immer geöffnet (24/7)",
    CLOSED:"Geschlossen",
    CLOSED_24:"24h geschlossen",
    OPENED_24:"24h geöffnet",
    MON:"Montag",
    TUE:"Dienstag",
    WED:"Mittwoch",
    THU:"Donnerstag",
    FRI:"Freitag",
    SAT:"Samstag",
    SUN:"Sonntag",
    PRICING:"Preise",
    PRICE:"Preis",
    VALIDITY:"Geltungsbereich",
    TOKEN_PACKAGES:"Waschmünzen-Pakete",
    SINGLE_WASH:"Einzelwäsche",
    FACILITY_WORKING_HOURS:"Öffnungszeiten für die ausgewählte Anlage festlegen",
    WORKING_HOURS_ALWAYS_OPEN:"Immer geöffnet",
    WORKING_HOURS_ALWAYS_CLOSE:"Durch den Betreiber geschlossen",
    WORKING_HOURS_CUSTOM:"Öffnungszeiten festlegen",
    KARCHER_ERROR_CODE:"Fehlercode",
    KARCHER_ERROR_MESSAGE_1:"Ausgänge Elektronik überlastet",
    KARCHER_ERROR_MESSAGE_2:"Der Ölabscheider  muss geleert werden",
    KARCHER_ERROR_MESSAGE_4:"Dämmerungssensor defekt",
    KARCHER_ERROR_MESSAGE_5:"Motorschutzschalter Hochdruckpumpen hat ausgelöst",
    KARCHER_ERROR_MESSAGE_6:"Verbindung zum RDS gestört",
    KARCHER_ERROR_MESSAGE_7:"Druckschalter für Luft am Kompressor meldet keinen Druck",
    KARCHER_ERROR_MESSAGE_8:"Ursache: keine Verbindung zur Elektronik 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"Keine Verbindung zur Pumpenelektronik Waschplatz 1",
    KARCHER_ERROR_MESSAGE_11:"Ausgänge der Elektronik Waschplatz 1 überlastet",
    KARCHER_ERROR_MESSAGE_12:"Stromaufnahme Hochdruckpumpe Waschplatz 1 zu hoch",
    KARCHER_ERROR_MESSAGE_13:"Stromaufnahme Hochdruckpumpe Waschplatz 1 zu niedrig",
    KARCHER_ERROR_MESSAGE_14:"Schütz Hochdruckpumpe Waschplatz 1 klemmt",
    KARCHER_ERROR_MESSAGE_15:"Halblastventil Waschplatz 1 defekt",
    KARCHER_ERROR_MESSAGE_16:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 1 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_17:"Ölstand Hochdruckpumpe Waschplatz 1 zu niedrig",
    KARCHER_ERROR_MESSAGE_18:"Elektronik Waschplatz 1 defekt",
    KARCHER_ERROR_MESSAGE_19:"Motorschutzschalter Hochdruckpumpe Waschplatz 1 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_20:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 1",
    KARCHER_ERROR_MESSAGE_21:"Störung am Münzprüfer Waschplatz 1",
    KARCHER_ERROR_MESSAGE_22:"Störung am Münzprüfer Waschplatz 1",
    KARCHER_ERROR_MESSAGE_30:"Keine Verbindung zur Pumpenelektronik Waschplatz 2",
    KARCHER_ERROR_MESSAGE_31:"Ausgänge der Elektronik Waschplatz 2 überlastet",
    KARCHER_ERROR_MESSAGE_32:"Stromaufnahme Hochdruckpumpe Waschplatz 2 zu hoch",
    KARCHER_ERROR_MESSAGE_33:"Stromaufnahme Hochdruckpumpe Waschplatz 2 zu niedrig",
    KARCHER_ERROR_MESSAGE_34:"Schütz Hochdruckpumpe Waschplatz 2 klemmt",
    KARCHER_ERROR_MESSAGE_35:"Halblastventil Waschplatz 2 defekt",
    KARCHER_ERROR_MESSAGE_36:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 2 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_37:"Ölstand Hochdruckpumpe Waschplatz 2 zu niedrig",
    KARCHER_ERROR_MESSAGE_38:"Elektronik Waschplatz 2 defekt.",
    KARCHER_ERROR_MESSAGE_39:"Motorschutzschalter Hochdruckpumpe Waschplatz 2 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_40:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 2",
    KARCHER_ERROR_MESSAGE_41:"Störung am Münzprüfer Waschplatz 2",
    KARCHER_ERROR_MESSAGE_42:"Störung am Münzprüfer Waschplatz 2",
    KARCHER_ERROR_MESSAGE_50:"Keine Verbindung zur Pumpenelektronik Waschplatz 3",
    KARCHER_ERROR_MESSAGE_51:"Ausgänge der Elektronik Waschplatz 3 überlastet",
    KARCHER_ERROR_MESSAGE_52:"Stromaufnahme Hochdruckpumpe Waschplatz 3 zu hoch",
    KARCHER_ERROR_MESSAGE_53:"Stromaufnahme Hochdruckpumpe Waschplatz 3 zu niedrig",
    KARCHER_ERROR_MESSAGE_54:"Schütz Hochdruckpumpe Waschplatz 3 klemmt",
    KARCHER_ERROR_MESSAGE_55:"Halblastventil Waschplatz 3 defekt",
    KARCHER_ERROR_MESSAGE_56:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 3 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_57:"Ölstand Hochdruckpumpe Waschplatz 3 zu niedrig",
    KARCHER_ERROR_MESSAGE_58:"Elektronik Waschplatz 3 defekt.",
    KARCHER_ERROR_MESSAGE_59:"Motorschutzschalter Hochdruckpumpe Waschplatz 3 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_60:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 3",
    KARCHER_ERROR_MESSAGE_61:"Störung am Münzprüfer Waschplatz 3",
    KARCHER_ERROR_MESSAGE_62:"Störung am Münzprüfer Waschplatz 3",
    KARCHER_ERROR_MESSAGE_70:"Keine Verbindung zur Pumpenelektronik Waschplatz 4",
    KARCHER_ERROR_MESSAGE_71:"Ausgänge der Elektronik Waschplatz 4 überlastet",
    KARCHER_ERROR_MESSAGE_72:"Stromaufnahme Hochdruckpumpe Waschplatz 4 zu hoch",
    KARCHER_ERROR_MESSAGE_73:"Stromaufnahme Hochdruckpumpe Waschplatz 4 zu niedrig",
    KARCHER_ERROR_MESSAGE_74:"Schütz Hochdruckpumpe Waschplatz 4 klemmt",
    KARCHER_ERROR_MESSAGE_75:"Halblastventil Waschplatz 4 defekt",
    KARCHER_ERROR_MESSAGE_76:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 4 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_77:"Ölstand Hochdruckpumpe Waschplatz 4 zu niedrig",
    KARCHER_ERROR_MESSAGE_78:"Elektronik Waschplatz 4 defekt.",
    KARCHER_ERROR_MESSAGE_79:"Motorschutzschalter Hochdruckpumpe Waschplatz 4 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_80:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 4",
    KARCHER_ERROR_MESSAGE_81:"Störung am Münzprüfer Waschplatz 4",
    KARCHER_ERROR_MESSAGE_82:"Störung am Münzprüfer Waschplatz 4",
    KARCHER_ERROR_MESSAGE_90:"Keine Verbindung zur Pumpenelektronik Waschplatz 5",
    KARCHER_ERROR_MESSAGE_91:"Ausgänge der Elektronik Waschplatz 5 überlastet",
    KARCHER_ERROR_MESSAGE_92:"Stromaufnahme Hochdruckpumpe Waschplatz 5 zu hoch",
    KARCHER_ERROR_MESSAGE_93:"Stromaufnahme Hochdruckpumpe Waschplatz 5 zu niedrig",
    KARCHER_ERROR_MESSAGE_94:"Schütz Hochdruckpumpe Waschplatz 5 klemmt",
    KARCHER_ERROR_MESSAGE_95:"Halblastventil Waschplatz 5 defekt",
    KARCHER_ERROR_MESSAGE_96:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 5 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_97:"Ölstand Hochdruckpumpe Waschplatz 5 zu niedrig",
    KARCHER_ERROR_MESSAGE_98:"Elektronik Waschplatz 5 defekt.",
    KARCHER_ERROR_MESSAGE_99:"Motorschutzschalter Hochdruckpumpe Waschplatz 5 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_100:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 5",
    KARCHER_ERROR_MESSAGE_101:"Störung am Münzprüfer Waschplatz 5",
    KARCHER_ERROR_MESSAGE_102:"Störung am Münzprüfer Waschplatz 5",
    KARCHER_ERROR_MESSAGE_110:"Keine Verbindung zur Pumpenelektronik Waschplatz 6",
    KARCHER_ERROR_MESSAGE_111:"Ausgänge der Elektronik Waschplatz 6 überlastet",
    KARCHER_ERROR_MESSAGE_112:"Stromaufnahme Hochdruckpumpe Waschplatz 6 zu hoch",
    KARCHER_ERROR_MESSAGE_113:"Stromaufnahme Hochdruckpumpe Waschplatz 6 zu niedrig",
    KARCHER_ERROR_MESSAGE_114:"Schütz Hochdruckpumpe Waschplatz 6 klemmt",
    KARCHER_ERROR_MESSAGE_115:"Halblastventil Waschplatz 6 defekt",
    KARCHER_ERROR_MESSAGE_116:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 6 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_117:"Ölstand Hochdruckpumpe Waschplatz 6 zu niedrig",
    KARCHER_ERROR_MESSAGE_118:"Elektronik Waschplatz 6 defekt.",
    KARCHER_ERROR_MESSAGE_119:"Motorschutzschalter Hochdruckpumpe Waschplatz 6 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_120:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 6",
    KARCHER_ERROR_MESSAGE_121:"Störung am Münzprüfer Waschplatz 6",
    KARCHER_ERROR_MESSAGE_122:"Störung am Münzprüfer Waschplatz 6",
    KARCHER_ERROR_MESSAGE_130:"Keine Verbindung zur Pumpenelektronik Waschplatz 7",
    KARCHER_ERROR_MESSAGE_131:"Ausgänge der Elektronik Waschplatz 7 überlastet",
    KARCHER_ERROR_MESSAGE_132:"Stromaufnahme Hochdruckpumpe Waschplatz 7 zu hoch",
    KARCHER_ERROR_MESSAGE_133:"Stromaufnahme Hochdruckpumpe Waschplatz 7 zu niedrig",
    KARCHER_ERROR_MESSAGE_134:"Schütz Hochdruckpumpe Waschplatz 7 klemmt",
    KARCHER_ERROR_MESSAGE_135:"Halblastventil Waschplatz 7 defekt",
    KARCHER_ERROR_MESSAGE_136:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 7 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_137:"Ölstand Hochdruckpumpe Waschplatz 7 zu niedrig",
    KARCHER_ERROR_MESSAGE_138:"Elektronik Waschplatz 7 defekt.",
    KARCHER_ERROR_MESSAGE_139:"Motorschutzschalter Hochdruckpumpe Waschplatz 7 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_140:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 7",
    KARCHER_ERROR_MESSAGE_141:"Störung am Münzprüfer Waschplatz 7",
    KARCHER_ERROR_MESSAGE_142:"Störung am Münzprüfer Waschplatz 7",
    KARCHER_ERROR_MESSAGE_150:"Keine Verbindung zur Pumpenelektronik Waschplatz 8",
    KARCHER_ERROR_MESSAGE_151:"Ausgänge der Elektronik Waschplatz 8 überlastet",
    KARCHER_ERROR_MESSAGE_152:"Stromaufnahme Hochdruckpumpe Waschplatz 8 zu hoch",
    KARCHER_ERROR_MESSAGE_153:"Stromaufnahme Hochdruckpumpe Waschplatz 8 zu niedrig",
    KARCHER_ERROR_MESSAGE_154:"Schütz Hochdruckpumpe Waschplatz 8 klemmt",
    KARCHER_ERROR_MESSAGE_155:"Halblastventil Waschplatz 8 defekt",
    KARCHER_ERROR_MESSAGE_156:"Wicklungsschutzkontakt Hochdruckpumpe Waschplatz 8 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_157:"Ölstand Hochdruckpumpe Waschplatz 8 zu niedrig",
    KARCHER_ERROR_MESSAGE_158:"Elektronik Waschplatz 8 defekt.",
    KARCHER_ERROR_MESSAGE_159:"Motorschutzschalter Hochdruckpumpe Waschplatz 8 hat ausgelöst",
    KARCHER_ERROR_MESSAGE_160:"Keine Verbindung zur Fernbedienungselektronik Waschplatz 8",
    KARCHER_ERROR_MESSAGE_161:"Störung am Münzprüfer Waschplatz 8",
    KARCHER_ERROR_MESSAGE_162:"Störung am Münzprüfer Waschplatz 8",
    KARCHER_ERROR_MESSAGE_170:"Keine Verbindung zur Elektronik A2",
    KARCHER_ERROR_MESSAGE_171:"Ausgänge der Elektronik A2 überlastet",
    KARCHER_ERROR_MESSAGE_172:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_173:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_174:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_175:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_176:"Reinigungsmittelbehälter leer",
    KARCHER_ERROR_MESSAGE_177:"Stromaufnahme Pumpe Unterbodenwäsche zu hoch",
    KARCHER_ERROR_MESSAGE_178:"Kein Druck nach Einschalten der Unterbodenwäsche",
    KARCHER_ERROR_MESSAGE_190:"Keine Verbindung zur Elektronik A3",
    KARCHER_ERROR_MESSAGE_191:"Ausgänge der Elektronik A3 überlastet",
    KARCHER_ERROR_MESSAGE_200:"Keine Verbindung zwischen Steuerung und Elektronik der WSO",
    KARCHER_ERROR_MESSAGE_201:"Ausgänge der Steuerung zur WSO überlastet",
    KARCHER_ERROR_MESSAGE_202:"Härtesensor zeigt nach Regeneration noch immer hartes Wasser an",
    KARCHER_ERROR_MESSAGE_204:"Störung in der Elektronik",
    KARCHER_ERROR_MESSAGE_210:"Wasserstandsensor 'Puffertank leer' aktiv",
    KARCHER_ERROR_MESSAGE_211:"Wasserstandsensor 'Puffertank leer' und 'Puffertank voll' gleichzeitig aktiv",
    KARCHER_ERROR_MESSAGE_212:"Wasserstandsensor 'Puffertank voll' aktiv. Keine Pumpe im Puffertank läuft.",
    KARCHER_ERROR_MESSAGE_213:"Kein Wasserdruck",
    KARCHER_ERROR_MESSAGE_214:"Bauseitige Wasseraufbereitungsanlage meldet Störung",
    KARCHER_ERROR_MESSAGE_220:"Wassermangel",
    KARCHER_ERROR_MESSAGE_221:"Abgastemperatur zu hoch",
    KARCHER_ERROR_MESSAGE_222:"Stromaufnahme Umwälzpumpe Warmwasser zu hoch",
    KARCHER_ERROR_MESSAGE_223:"Brennerstörung",
    KARCHER_ERROR_MESSAGE_224:"Sicherungsautomat Brenner hat ausgelöst",
    KARCHER_ERROR_MESSAGE_225:"Brennerverzögerung aktiv",
    KARCHER_ERROR_MESSAGE_226:"Der Durchflussanzeiger öffnete sich nicht innerhalb von 5 Sekunden, nachdem die Zirkulationspumpe für Warmwasser ausgeschaltet wurde",
    KARCHER_ERROR_MESSAGE_227:"Der Durchflussanzeiger schloss sich nicht innerhalb von 3 Sekunden, nachdem die Zirkulationspumpe für Warmwasser ausgeschaltet wurde",
    KARCHER_ERROR_MESSAGE_228:"Heißwasserausgang kühlt nach Abschaltung des Brenners zu langsam ab",
    KARCHER_ERROR_MESSAGE_229:"Störung Temperaursensor Warmwasser",
    KARCHER_ERROR_MESSAGE_230:"Störung Temperaursensor Brennerausgang",
    KARCHER_ERROR_MESSAGE_231:"Störung Temperaursensor Warmwasser",
    KARCHER_ERROR_MESSAGE_232:"Störung Temperaursensor Brennerausgang",
    KARCHER_ERROR_MESSAGE_233:"Wassertemperatur bei externer Versorgung mit Warmwasser über 60°C",
    KARCHER_ERROR_MESSAGE_234:"Fehler Antilegionellen-Programm",
    KARCHER_ERROR_MESSAGE_235:"Antilegionellen Warmwassertemperatur nicht erreicht",
    KARCHER_ERROR_MESSAGE_240:"Störung Außentemperatursensor",
    KARCHER_ERROR_MESSAGE_241:"Störung Außentemperatursensor",
    KARCHER_ERROR_MESSAGE_242:"Stromaufnahme Umwälzpumpe Frostschutz zu hoch",
    KARCHER_ERROR_MESSAGE_243:"Stromaufnahme Umwälzpumpe Waschplatzheizung zu hoch",
    KARCHER_ERROR_MESSAGE_244:"Warmwassertemperatur zu niedrig, Waschplatzheizung wurde abgestellt",
    KARCHER_ERROR_MESSAGE_245:"Stromaufnahme Schlauchheizung Trockenschaum zu hoch",
    KARCHER_ERROR_MESSAGE_247:"Störung in der Elektronik",
    KARCHER_ERROR_MESSAGE_248:"Störung in der Elektronik",
    KARCHER_ERROR_MESSAGE_250:"Stromaufnahme Pumpe für Sonder-Waschprogramm zu hoch",
    KARCHER_ERROR_MESSAGE_255:"Störung in der Elektronik",
    KARCHER_ERROR_MESSAGE_260:"Keine Verbindung zur Elektronik A5",
    KARCHER_ERROR_MESSAGE_261:"Ausgänge der Elektronik A5 überlastet",
    KARCHER_ERROR_MESSAGE_280:"Keine Verbindung zur Elektronik A6",
    KARCHER_ERROR_MESSAGE_281:"Ausgänge der Elektronik A6 überlastet",
    KARCHER_ERROR_MESSAGE_282:"Stromaufnahme Pumpe Felgenreiniger zu hoch",
    KARCHER_ERROR_MESSAGE_283:"Stromaufnahme Pumpe Felgenreiniger zu niedrig",
    KARCHER_ERROR_MESSAGE_284:"Schütz Pumpe Felgenreiniger klemmt",
    KARCHER_ERROR_MESSAGE_300:"Keine Verbindung zur Elektronik A7",
    KARCHER_ERROR_MESSAGE_301:"Ausgänge der Elektronik A7 überlastet",
    KARCHER_ERROR_MESSAGE_320:"Keine Verbindung zur Elektronik A8",
    KARCHER_ERROR_MESSAGE_321:"Ausgänge der Elektronik A8 überlastet",
    KARCHER_ERROR_MESSAGE_322:"Stromaufnahme Pumpe Microemulsion zu hoch",
    KARCHER_ERROR_MESSAGE_323:"Stromaufnahme Pumpe Microemulsion zu niedrig",
    KARCHER_ERROR_MESSAGE_324:"Schütz Pumpe Microemulsion klemmt",
    KARCHER_ERROR_MESSAGE_340:"Keine Verbindung zur Elektronik A9",
    KARCHER_ERROR_MESSAGE_341:"Ausgänge der Elektronik A9 überlastet",
    KARCHER_ERROR_MESSAGE_342:"Stromaufnahme Pumpe Intensivreinigung zu hoch",
    KARCHER_ERROR_MESSAGE_343:"Stromaufnahme Pumpe Intensivreinigung zu niedrig",
    KARCHER_ERROR_MESSAGE_344:"Schütz Pumpe Intensivreinigung klemmt",
    KARCHER_ERROR_MESSAGE_400:"Warmwasser hat keinen Druck",
    KARCHER_ERROR_MESSAGE_401:"Frischwasser hat keinen Druck",
    KARCHER_ERROR_MESSAGE_402:"Permeat hat keinen Druck",
    KARCHER_ERROR_MESSAGE_403:"4. Wasserart hat keinen Druck",
    KARCHER_ERROR_MESSAGE_404:"4. Wasserart, Temperatur über 60 °C oder externe Störung",
    KARCHER_ERROR_MESSAGE_405:"Frostschutz hat keinen Druck",
    KARCHER_ERROR_MESSAGE_406:"Druck im Frostschutz trotz ausgeschalteter Frostschutzpumpe",
    KARCHER_ERROR_MESSAGE_410:"Fehler F 400 ist 4 mal innerhalb 24 Stunden aufgetreten",
    KARCHER_ERROR_MESSAGE_411:"Fehler F 401 ist seit 300 Sekunden aktiv",
    KARCHER_ERROR_MESSAGE_412:"Fehler F 402 ist 4 mal innerhalb 24 Stunden aufgetreten",
    KARCHER_ERROR_MESSAGE_413:"Fehler F 403 ist 4 mal innerhalb 24 Stunden aufgetreten",
    KARCHER_ERROR_MESSAGE_414:"Fehler F 405 ist 4 mal innerhalb 24 Stunden aufgetreten",
    KARCHER_ERROR_MESSAGE_420:"Störung Wertmünzenwechsler 1",
    KARCHER_ERROR_MESSAGE_421:"Störung Wertmünzenwechsler 2",
    KARCHER_ERROR_MESSAGE_440:"Keine Verbindung zur Elektronik A31",
    KARCHER_ERROR_MESSAGE_441:"Ausgänge der Elektronik A31 überlastet",
    KARCHER_ERROR_MESSAGE_500:"Anschluss Staubsaugerelektronik 1/2",
    KARCHER_ERROR_MESSAGE_501:"Starttaster Sauger 1 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_502:"Starttaster Sauger 2 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_510:"Verbindung Elektronik Sauger 3/4",
    KARCHER_ERROR_MESSAGE_511:"Starttaster Sauger 3 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_512:"Starttaster Sauger 4 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_520:"Verbindung Elektronik Sauger 5/6",
    KARCHER_ERROR_MESSAGE_521:"Starttaster Sauger 5 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_522:"Starttaster Sauger 6 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_530:"Verbindung Elektronik Sauger 7/8",
    KARCHER_ERROR_MESSAGE_531:"Starttaster Sauger 7 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_532:"Starttaster Sauger 8 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_540:"Verbindung Elektronik Sauger 9/10",
    KARCHER_ERROR_MESSAGE_541:"Starttaster Sauger 9 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_542:"Starttaster Sauger 10 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_550:"Verbindung Elektronik Sauger 10/11",
    KARCHER_ERROR_MESSAGE_551:"Starttaster Sauger 11 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_552:"Starttaster Sauger 12 Dauerkontakt",
    KARCHER_ERROR_MESSAGE_800:"Keine Verbindung zur Elektronik A30",
    KARCHER_ERROR_MESSAGE_801:"Ausgänge der Elektronik A30 überlastet",
    KARCHER_ERROR_MESSAGE_802:"Störung Enthärtungsanlage",
    KARCHER_ERROR_MESSAGE_803:"Motorschutzschalter Vordruckpumpe RO hat ausgelöst",
    KARCHER_INFO_MESSAGE_1:"Start Regeneration Basenaustauscher",
    KARCHER_INFO_MESSAGE_2:"Ende Regeneration Basenaustauscher",
    KARCHER_INFO_MESSAGE_3:"Basenaustauscher ist zu 75% erschöpft",
    KARCHER_INFO_MESSAGE_4:"Anlage aufgrund eines technischen Problems nicht verfügbar",
    KARCHER_INFO_MESSAGE_5:"Anlage aufgrund einer Betriebsstörung nicht verfügbar",
    KARCHER_INFO_MESSAGE_6:"Anlage wurde eingeschaltet",
    KARCHER_INFO_MESSAGE_10:"Anlage ausgeschaltet",
    KARCHER_INFO_MESSAGE_11:"Waschbox 1 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_12:"Waschbox 2 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_13:"Waschbox 3 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_14:"Waschbox 4 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_15:"Waschbox 5 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_16:"Waschbox 6 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_17:"Waschbox 7 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_18:"Waschbox 8 ist nicht verfügbar",
    KARCHER_INFO_MESSAGE_20:"Antilegionellen Programm Warmwassertank",
    KARCHER_INFO_MESSAGE_21:"Antilegionellen Programm HD Pumpe 1 erforderlich",
    KARCHER_INFO_MESSAGE_22:"Antilegionellen Programm HD Pumpe 2 erforderlich",
    KARCHER_INFO_MESSAGE_23:"Antilegionellen Programm HD Pumpe 3 erforderlich",
    KARCHER_INFO_MESSAGE_24:"Antilegionellen Programm HD Pumpe 4 erforderlich",
    KARCHER_INFO_MESSAGE_25:"Antilegionellen Programm HD Pumpe 5 erforderlich",
    KARCHER_INFO_MESSAGE_26:"Antilegionellen Programm HD Pumpe 6 erforderlich",
    KARCHER_INFO_MESSAGE_27:"Antilegionellen Programm HD Pumpe 7 erforderlich",
    KARCHER_INFO_MESSAGE_28:"Antilegionellen Programm HD Pumpe 8 erforderlich",
    KARCHER_INFO_MESSAGE_29:"Antilegionellen Programm erfolgreich durchgeführt",
    KARCHER_INFO_MESSAGE_101:"HD Pumpe Waschplatz 1: Wartung fällig",
    KARCHER_INFO_MESSAGE_102:"HD Pumpe Waschplatz 2: Wartung fällig",
    KARCHER_INFO_MESSAGE_103:"HD Pumpe Waschplatz 3: Wartung fällig",
    KARCHER_INFO_MESSAGE_104:"HD Pumpe Waschplatz 4: Wartung fällig",
    KARCHER_INFO_MESSAGE_105:"HD Pumpe Waschplatz 5: Wartung fällig",
    KARCHER_INFO_MESSAGE_106:"HD Pumpe Waschplatz 6: Wartung fällig",
    KARCHER_INFO_MESSAGE_107:"HD Pumpe Waschplatz 7: Wartung fällig",
    KARCHER_INFO_MESSAGE_108:"HD Pumpe Waschplatz 8: Wartung fällig",
    KARCHER_INFO_MESSAGE_109:"Brenner: Wartung fällig",
    KARCHER_INFO_MESSAGE_110:"Brennergebläse: Wartung fällig",
    KARCHER_INFO_MESSAGE_111:"Warmwasserpumpe: Wartung fällig",
    KARCHER_INFO_MESSAGE_112:"Frostschutzpumpe: Wartung fällig",
    KARCHER_INFO_MESSAGE_113:"Vordruckpumpe Osmose: Wartung fällig",
    KARCHER_INFO_MESSAGE_114:"Pumpe Fußbodenheizung: Wartung fällig",
    KARCHER_INFO_MESSAGE_115:"Schlauchheizung: Wartung fällig",
    KARCHER_INFO_MESSAGE_116:"Pumpe Mikroemulsion / Felgenreiniger: Wartung fällig",
    KARCHER_INFO_MESSAGE_117:"Pumpe Unterbodenwäsche: Wartung fällig",
    KARCHER_INFO_MESSAGE_118:"Vordruckpumpe Schaum: Wartung fällig",
    KARCHER_INFO_MESSAGE_119:"Sauger 1: Wartung fällig",
    KARCHER_INFO_MESSAGE_120:"Sauger 2: Wartung fällig",
    KARCHER_INFO_MESSAGE_121:"Sauger 3: Wartung fällig",
    KARCHER_INFO_MESSAGE_122:"Sauger 4: Wartung fällig",
    KARCHER_INFO_MESSAGE_123:"Sauger 5: Wartung fällig",
    KARCHER_INFO_MESSAGE_124:"Sauger 6: Wartung fällig",
    KARCHER_INFO_MESSAGE_125:"Sauger 7: Wartung fällig",
    KARCHER_INFO_MESSAGE_126:"Sauger 8: Wartung fällig",
    KARCHER_INFO_MESSAGE_127:"Sauger 9: Wartung fällig",
    KARCHER_INFO_MESSAGE_128:"Sauger 10: Wartung fällig",
    KARCHER_INFO_MESSAGE_129:"Sauger 11: Wartung fällig",
    KARCHER_INFO_MESSAGE_130:"Sauger 12: Wartung fällig",
    KARCHER_INFO_MESSAGE_131:"Pumpe Felgenreiniger: Wartung fällig",
    KARCHER_INFO_MESSAGE_132:"Pumpe Mikroemulsion: Wartung fällig",
    KARCHER_INFO_MESSAGE_133:"Pumpe Intensivschaum: Wartung fällig",
    KARCHER_INFO_MESSAGE_142:"Sauger 1 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_143:"Sauger 1 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_144:"Sauger 2 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_145:"Sauger 2 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_146:"Sauger 3 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_147:"Sauger 3 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_148:"Sauger 4 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_149:"Sauger 4 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_150:"Sauger 5 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_151:"Sauger 5 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_152:"Sauger 6 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_153:"Sauger 6 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_154:"Sauger 7 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_155:"Sauger 7 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_156:"Sauger 8 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_157:"Sauger 8 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_158:"Sauger 9 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_159:"Sauger 9 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_160:"Sauger 10 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_161:"Sauger 10 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_162:"Sauger 11 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_163:"Sauger 11 Filter: Wartung fällig",
    KARCHER_INFO_MESSAGE_164:"Sauger 12 Turbine: Wartung fällig",
    KARCHER_INFO_MESSAGE_165:"Sauger 12 Filter: Wartung fällig",
    ORGANIZATION:"Organisation",
    CREATE_ORGANIZATION:"Organisation erstellen",
    CREATE_ORGANIZATION_AS:"Unterorganisation erstellen",
    DELETE_ORGANIZATION:"Organisation löschen",
    EDIT_ORGANIZATION:"Organisation bearbeiten",
    SUPPORTED_ORG_NAME:"Unterstützte Organisation",
    SUPPORTED_ORG_TYPE:"Kooperationstyp",
    ORG_NAME:"Name",
    ORG_TYPE:"Typ",
    SET_ORG_TITLE:"Unterorganisation festlegen",
    SET_SUPPORTED_ORG_TITLE:"Unterstützte Unterorganisation festlegen",
    SAVE_ORGANIZATION:"Organisation sichern",
    SELECT_ORGANIZATION_TYPE:"Wähle Organisationstyp",
    SELECT_ORGANIZATION_SELECTOR:"Wählen",
    SELECT_SUPPORTED_ORGANIZATION:"Wählen Sie aus den verfügbaren Organisationen/ Standorten ihren Kooperationspartner",
    ORGANIZATION_DELETED:"Organisation erfolgreich gelöscht ",
    ORGANIZATION_SAVED:"Organisation erfolgreich gespeichert",
    ORGANIZATION_UPDATED:"Organisation erfolgreich aktualisiert",
    ALERTS:"Fehlermeldungen",
    DEVICE_STATUS:"Gerätestatus",
    SITE_DETAILS:"Einzelheiten zum Standort",
    ALARM_STATUS:"Alarmstatus",
    FILTER:"Filtern nach...",
    FILTER_BY_ALERT_CENTER:"Filtern nach Stichwort, Name oder Beschreibung",
    TOTAL_ALARM:"Gesamt",
    LOW_ALARM:"Ereignis",
    MEDIUM_ALARM:"Warnungen",
    HIGH_ALARM:"Kritische Fehler",
    NO_FACILITIES_NEARBY:"Es sind keine Waschanlagen in der Nähe",
    GRAY_MAP:"Karte in Grau",
    READY:"Bereit",
    WARNING:"Warnungen",
    ERROR:"Fehler",
    SITE_NAME:"Standortname",
    ACCOUNTS_INFO:"Profilinformationen",
    USER_ORGANIZATION:"Kundenorganisation",
    ADD_USER_ORGANIZATION:"Einen neuen Benutzer für die Organisation hinzufügen",
    EDIT_USER_ORGANIZATION:"Die Benutzer der Organisation bearbeiten",
    SELECT_ROLE:"Rolle wählen",
    SELECT_ORGANIZATION:"Organisation wählen",
    SELECT_USER:"Benutzer wählen",
    USER_FOR_ORGANIZATION_CREATED:"Der neue Benutzer wurde erfolgreich erstellt",
    SELECT_REGION:"Region wählen",
    SELECT_LANGUAGE:"Sprache wählen",
    LOADING_DATA:"Die Daten werden geladen, bitte warten Sie einen Moment...",
    ADMINISTRATOR:"Administrator",
    TECHNICAL_SUPPORT:"Technischer Support",
    CONTROLLER:"Steuergerät",
    EDIT_ORGANIZATION_USER:"Benutzer der Organisation bearbeiten",
    DELETE_ORGANIZATION_USER:"Benutzer der Organisation löschen",
    USER_UPDATED:"Benutzer erfolgreich aktualisiert",
    USER_CREATED:"Benutzer erfolgreich erstellt",
    ADDRESS:"Adresse",
    SUBSCRIPTIONS:"Abonnements",
    RESOLVED_STATUS:"behoben",
    NOT_RESOLVED_STATUS:"Nicht behoben",
    ALERT_NAME:"Fehlermeldung",
    ALERT_DESCRIPTION:"Fehlerbeschreibung",
    ALERT_CODE:"Fehlercode",
    ALERT_TYPE:"Fehlertyp",
    UNSUBSCRIBE:"Abonnement löschen",
    SUBSCRIBE:"Fehlermeldung abonnieren",
    ALARM_SUBSCRIBED:"Abonnement erfolgreich abgeschlossen",
    UNSUBSCRIBED_CONFIRM:"Abonnement beenden?",
    ALARM_UNSUBSCRIBED:"Abonnement erfolgreich beendet",
    ASIDE_MENU_CASHLESS_SALES:"Bargeldlose Zahlungen",
    FILTERED_CASHLESS_PAYMENTS:"Gefiltert nach bargeldlosen Zahlungen",
    REFUND_DIALOG_TITLE:"Transaktion zurückerstatten?",
    REFUND_DIALOG_SUBTITLE:"Die Rückerstattung kann kleiner oder gleichgroß wie die ursprüngliche Transaktion sein",
    REFUND:"Erstattung",
    INPUT_NOT_VALID:"Die Eingabe ist ungültig",
    REFUND_SUCCESSFULLY:"Die Rückerstattung der ausgewählten Transaktion war erfolgreich",
    USER:"Benutzer",
    TRANSACTION_ID:"PSP-Referenz",
    DEVICE_ID:"Geräte ID",
    NET_AMOUNT:"Netto- Betrag",
    REPORT_NAME:"Name melden",
    TIME_FRAME:"Zeitfenster",
    SUB_POINT:"Waschplatz wählen",
    SUB_POINT_LIST_NOT_EXIST:"Es existieren keine Unterpunkte bei der gewählten Waschanlage",
    FACILITY_TYPE:"Waschanlagentyp",
    MACHINE_NAME:"Name Waschanlage",
    WASH_FACILITY_DETAILS:"Waschanlagendetails",
    WASH_BAY_DETAILS:"Details zur Waschbox",
    DEVICES_INFO:"Waschplätze",
    OPERATION_TIME_INFO:"Öffnungszeiten Waschplätze",
    OPERATION_TIME_VACUUM_INFO:"Öffnungszeiten Staubsauger",
    OPERATION_TIME_ILLUMINATION_INFO:"Betriebszeiten Beleuchtung",
    AVAILABLE_TITLE:"Verfügbar",
    UNAVAILABLE_TITLE:"Nicht Verfügbar",
    CURRENT_PROGRAM:"Aktuelles Programm",
    CREDITS:"Guthaben",
    DEVICE_NAME:"Gerätename",
    ACTIVE_ALARMS:"Fehlermeldungen",
    ALL_DAY:"Ganztags",
    OPERATING_TIME_WASH_FACILITY:"SB-Anlage Waschsystem",
    OPERATING_TIME_VACUUMS:"Staubsauger",
    OPERATING_TIME_ILLUMINATION:"Beleuchtung",
    OPERATION_COUNTERS:"Betriebsstunden- und Wartungszähler",
    EDIT:"Bearbeiten",
    WASHING_PROGRAMS:"Waschprogramme",
    INFO:"Ereignis",
    STATISTIC:"Statistik",
    ROLLOVER_DOSING:"Dosierung",
    ROLLOVER_SPEED:"Geschwindigkeiten",
    ROLLOVER_RESETS:"Portalanlage zurücksetzen via Fernbedienung",
    ROLLOVER_RESETS_INFO:"Achtung, das Zurücksetzen der Portalanlage muss den örtlichen Regularien entsprechen.WICHTIG: VOR DEM ZURÜCKSETZEN IST ES DIE VERANTWORTUNG DES KUNDEN, SICHERZUSTELLEN, DASS DIE WASCHHALLE FREI VON FAHRZEUGEN UND MENSCHEN IST.",
    RESET_ROLLOVER:"Portalanlage zurücksetzten",
    OPEN_DOOR_ROLLOVER:"Öffnen",
    ROLLOVER_OPEN_DOOR_INFO:"Das Rolltor wird geöffnet. Vorsicht bitte.",
    ROLLOVER_OPEN_DOOR:"Rolltor öffnen",
    APPLY_DOSING_CHANGES:"Änderung an den Dosiereinstellungen übernehmen",
    APPLY_SPEED_CHANGES:"Änderungen an der Verfahrgeschwindigkeit übernehmen",
    ACTUATION_SUCCESS:"Anfrage gesendet",
    REMAINING_TIME:"Verbleibende Zeit",
    OPEN_24H:"24 Stunden geöffnet",
    CLOSE_24H:"24 Stunden geschlossen",
    VALIDATION_OPERATION_TIME:"Format nicht korrekt. Bitte verwenden Sie das Format 'hh:mm' Uhr",
    ROLLOVER:"Portalanlage",
    UPDATE_WASHING_PROGRAM:"Waschprogramm aktualisieren",
    UPDATE_ACTUATORS:"Akteure aktualisieren",
    OPEN_ROLOVER_DOOR_TITLE:"Möchten Sie das Rolltor öffnen?",
    OPEN_ROLOVER_DOOR_CONTENT:"Wollen Sie das Rolltor wirklich öffnen?",
    RESET_ROLOVER_TITLE:"Wollen Sie den Waschvorgang zurücksetzen?",
    RESET_ROLOVER_CONTENT:"Wollen Sie den Waschvorgang wirklich zurücksetzen?",
    G0:"{{brand === 'r2w' ? 'Waschplatz 0' : 'Waschplatz 1'}}",
    G1:"{{brand === 'r2w' ? 'Waschplatz 1' : 'Waschplatz 2'}}",
    G2:"{{brand === 'r2w' ? 'Waschplatz 2' : 'Waschplatz 3'}}",
    G3:"{{brand === 'r2w' ? 'Waschplatz 3' : 'Waschplatz 4'}}",
    G4:"{{brand === 'r2w' ? 'Waschplatz 4' : 'Waschplatz 5'}}",
    G5:"{{brand === 'r2w' ? 'Waschplatz 5' : 'Waschplatz 6'}}",
    G6:"{{brand === 'r2w' ? 'Waschplatz 6' : 'Waschplatz 7'}}",
    G7:"{{brand === 'r2w' ? 'Waschplatz 7' : 'Waschplatz 8'}}",
    G8:"{{brand === 'r2w' ? 'Waschplatz 8' : 'Waschplatz 9'}}",
    G9:"{{brand === 'r2w' ? 'Waschplatz 9' : 'Waschplatz 10'}}",
    G10:"{{brand === 'r2w' ? 'Waschplatz 10' : 'Waschplatz 11'}}",
    U0:"{{brand === 'r2w' ? 'Staubsauger 0' : 'Staubsauger 1'}}",
    U1:"{{brand === 'r2w' ? 'Staubsauger 1' : 'Staubsauger 2'}}",
    U2:"{{brand === 'r2w' ? 'Staubsauger 2' : 'Staubsauger 3'}}",
    U3:"{{brand === 'r2w' ? 'Staubsauger 3' : 'Staubsauger 4'}}",
    U4:"{{brand === 'r2w' ? 'Staubsauger 4' : 'Staubsauger 5'}}",
    U5:"{{brand === 'r2w' ? 'Staubsauger 5' : 'Staubsauger 6'}}",
    U6:"{{brand === 'r2w' ? 'Staubsauger 6' : 'Staubsauger 7'}}",
    U7:"{{brand === 'r2w' ? 'Staubsauger 7' : 'Staubsauger 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Bericht des Fehlerspeicher zu der ausgewählten Seite des Dashboards.",
    ALERT_CENTER_TITLE_BY_FACILITY:"Bericht des Fehlerspeicher zu der ausgewählten Anlage des Dashboards.",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Fehlerspeicher",
    ERROR_MESSAGE_403:"Sie haben keine Berechtigung, diesen API-Aufruf zu verwenden. Fehlercode: 403",
    LAST_ACTIVE_PROGRAM:"Aktuelles- oder zuletzt aktives Programm",
    PROGRAM_ID:"Programmnummer",
    PROGRAM_PRICE:"Preis",
    PROGRAM_DESCRIPTION: "Programmbeschreibung",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Nachfüllen erforderlich",
    EMPTY_CHEMICAL_LEVEL:"Leer",
    CHEMICAL_LEVEL:"Füllstand Reinigungsmittel (%)",
    ROLLOVER_STATUS:"Anlagenstatus",
    ROLLOVER_STATUS_CODE_0:"Waschanlage außer Betrieb",
    ROLLOVER_STATUS_CODE_1:"Außerhalb der Öffnungszeiten",
    ROLLOVER_STATUS_CODE_2:"Anlage frei",
    ROLLOVER_STATUS_CODE_3:"Bitte positionieren Sie ihr Fahrzeug",
    ROLLOVER_STATUS_CODE_4:"Bitte fahren Sie etwas weiter vor",
    ROLLOVER_STATUS_CODE_5:"Bitte fahren Sie etwas zurück",
    ROLLOVER_STATUS_CODE_6:"Fahrzeug korrekt positioniert",
    ROLLOVER_STATUS_CODE_7:"Waschvorgang aktiv",
    ROLLOVER_STATUS_CODE_8:"Der Waschvorgang wurde gestoppt",
    ROLLOVER_STATUS_CODE_9:"Waschvorgang aktiv (Takt)",
    ROLLOVER_STATUS_CODE_10:"Bitte fahren Sie mit ihrem Fahrzeug rückwärts aus der Waschanlage.",
    ROLLOVER_STATUS_CODE_11:"Not-Stop",
    ROLLOVER_STATUS_CODE_12:"Bitte fahren Sie mit ihrem Fahrzeug vorwärts aus der Waschanlage.",
    ROLLOVER_STATUS_CODE_13:"Frostschutz aktiv",
    ROLLOVER_STATUS_CODE_14:"Sicherheitsschalter Vorderseite ausgelöst!",
    ROLLOVER_STATUS_CODE_15:"Sicherheitsschalter Rückseite ausgelöst!",
    ROLLOVER_STATUS_CODE_16:"Sicherheitsschalter vorne links hat ausgelöst!",
    ROLLOVER_STATUS_CODE_17:"Sicherheitsschalter vorne rechts hat ausgelöst!",
    ROLLOVER_STATUS_CODE_18:"Sicherheitsschalter hinten links hat ausgelöst!",
    ROLLOVER_STATUS_CODE_19:"Sicherheitsschalter hinten rechts hat ausgelöst!",
    ROLLOVER_STATUS_CODE_20:"Ihr Fahrzeug steht zu weit links",
    ROLLOVER_STATUS_CODE_21:"Ihr Fahrzeug steht zu weit rechts",
    ROLLOVER_STATUS_CODE_22:"Die linke Fahrzeugtür ist nicht geschlossen",
    ROLLOVER_STATUS_CODE_23:"Die rechte Fahrzeugtür ist nicht geschlossen",
    ROLLOVER_STATUS_CODE_24:"Transporter erkannt, falsches Waschprogramm gewählt!",
    ROLLOVER_STATUS_CODE_25:"Sensor akustisches Signal",
    ROLLOVER_STATUS_CODE_98:"Modus manuelle Einstellungen",
    ROLLOVER_STATUS_CODE_99:"Unbekannter Zustand",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status Code unbekannt",
    ALARM:"Kritischer Fehler",
    NO_ALARM:"Unkritischer Fehler",
    SOFTWARE_VERSION:"Software Version",
    SOFTWARE_DATE:"Erscheinungsdatum Software",
    SITE_ADDRESS:"Standortadresse",
    SECONDS:"Sekunden",
    SERVICE_PART_NAME:"Wartungsname:",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Betriebs- und Wartungszähler",
    OPERATION_COUNTER:"Betriebszähler",
    SERVICE_COUNTER:"Wartungszähler",
    FAULT_CODE:"Fehlercode",
    PRESSURE_TITLE:"Luftdruck",
    TIME_TITLE:"Aktuelle Uhrzeit",
    COUNTRY_TITLE:"Land",
    CITY_TITLE:"Stadt",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Wähle Suchkriterien...",
    LOGS_HISTORY:"Änderungshistorie",
    ACTUATOR_REFERENCE:"Referenz",
    ACTUATOR_VALUE:"Wert",
    POINT_ID:"Punkt-ID",
    VALIDATION_NOT_VALID_RANGE:"Wert außerhalb des zugelassenen Bereichs",
    ENABLE_ROLLOVER_RESET:"Wenn Sie in diese Box einen Haken setzen bestätigen Sie, dass Sie die Sicherheitshinweise gelesen und akzeptiert haben.",
    CHANGE_OF_PARAMETERS:"Parameter ändern",
    SELECT_OPTIONS:"Optionen wählen",
    AUTOMATIC:"Automatik",
    DESALTING:"Entsalzungsfunktion",
    SEASON_WASH:"Saisonale Waschprogramme",
    SPRING_PROGRAM:"Waschprogramme Frühling",
    SUMMER_PROGRAM:"Waschprogramme Sommer",
    AUTUMN_PROGRAM:"Waschprogramme Herbst",
    WINTER_PROGRAM:"Waschprogramme Winter",
    DOOR_CONTROL:"Steuerung Rolltor",
    SUMMER_DOOR_CONTROL:"Sommersaison: Betrieb mit der Torsteuerung im Sommermodus",
    WINTER_DOOR_CONTROL:"Wintersaison: Betrieb mit der Torsteuerung im Wintermodus",
    APPLY_PARAMETERS_CHANGES:"Änderungen bestätigen",
    WORKING_SCHEDULES:"Öffnungszeiten",
    HOLIDAY_SCHEDULES:"Feiertagspläne",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Feiertage vor Ort erfolgreich erstellt",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Feiertage vor Ort erfolgreich aktualisiert",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Feiertage vor Ort erfolgreich gelöscht",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Arbeitszeiten erfolgreich ausgerufen",
    HOLIDAY_SUCCESSFULLY_DELETED:"Feiertag(e) erfolgreich gelöscht",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:"SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:"SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:"SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:"SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:"SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:"SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:"SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:"SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:"SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:"SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:"SB_OB_2_0_0_Trans",
    CB3_1_0_0:"CB3_1_0_0_Trans",
    CW35_3_0_0:"CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:"CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:"CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Trocknungsmittel mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_SHAMPOO:"Flüssigwaschmittel mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_FOAM:"Schaum mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_WAX_1:"Wachs mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_POLISH_1:"Polish mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Felgenreiniger mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_WAX_2:"Wachs mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Reifenglanz mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Insektenreiniger mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_POLISH_2:"Polish mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensivreiniger mit niedrigem Füllstand",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Niedriger Füllstand: Schaumregen",
    CHEM_LEVEL_DRYING_AGENT:"Füllstand Trocknungsmittel",
    CHEM_LEVEL_SHAMPOO:"Füllstand Flüssigseife",
    CHEM_LEVEL_FOAM:"Füllstand Schaum",
    CHEM_LEVEL_WAX_1:"Füllstand Wachs",
    CHEM_LEVEL_POLISH_1:"Füllstand Polish",
    CHEM_LEVEL_RIM_CLEANER:"Füllstand Felgenreiniger",
    CHEM_LEVEL_WAX_2:"Füllstand Wachs",
    CHEM_LEVEL_TYRE_SHINE:"Füllstand Reifenglanz",
    CHEM_LEVEL_INSECT_REMOVER:"Füllstand Insektenentferner",
    CHEM_LEVEL_POLISH_2:"Füllstand Polish",
    CHEM_LEVEL_INTENSIVE:"Füllstand Intensivreiniger",
    CHEM_LEVEL_FOAM_RAIN:"Füllstand Schaumregen",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servicezähler Dachbürste-Hebeband",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servicezähler Trockner-Hebeband",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servicezähler Dachbürste Motorkabel",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servicezähler Frischwasserpumpe",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servicezähler Bracuhwasserpumpe",
    DRYING_AGENT:"Trocknungsmittel",
    FOAM_DRYING_AGENT:"Schaumtrocknungsmittel",
    SHAMPOO:"Flüssigwaschmittel",
    FOAM:"Schaum",
    BRUSH_FOAM:"Bürstenschaum",
    WAX_1:"Wachs",
    FOAM_WAX_1:"Schaumwachs 1",
    POLISH_1:"Polish 1",
    RIM_CLEANING:"Felgenreiniger",
    WAX_2:"Wachs",
    FOAM_WAX_2:"Schaumwachs 2",
    TYRE_SHINE:"Reifenglanz",
    INSECT_REMOVER:"Insektenreiniger",
    POLISH_2:"Polish 2",
    INTENSIVE_BASIC:"Intensiv Basic",
    INTENSIVE_SIDE:"Intensiv Seite",
    INTENSIVE_ROOF_SPRAY_BAR:"Intensiv Dachsprühbogen",
    TAR_REMOVER:"Teerentferner",
    UNDER_CHASSIS_CONVERSATION:"Unterbodenversiegelung",
    STATIONARY_PRE_SPRAY_ARCH:"Stationärer Vorsprühbogen",
    FOAM_RAIN:"Schaumregen",
    PRE_CLEANING:"Vorwäsche",
    BRUSH:"Bürsten",
    CARE:"Pflege",
    DRYING:"Trocknung",
    DRYING_LOW_NOISE:"Lärmreduzierte Trocknung",
    INTENSIVE_CLEANING:"Intensivwäsche",
    BRUSH_CLEANING:"Bürstenwäsche",
    EMPTY_RUN:"Leerfahrt",
    DRYING_AID:"Trocknungshilfe",
    WAX:"Wachs",
    FOAM_WASH:"Schaumwäsche",
    POLISH:"Polish",
    FOAM_POLISH:"Schaumpolish",
    WHEEL_CLEANING:"Felgen vorsprühen",
    HIGH_PRESSURE_ROOF:"Hochdruck Dach",
    HIGH_PRESSURE_SIDE:"Seitenhochdruck",
    DRYER_FORWARD:"Trocknung vorwärts",
    DRYER_BACKWARD:"Trocknung rückwärts",
    DELETE_ALL_HOLIDAYS:"Alle Urlaube für ausgewählte Anlage löschen",
    CREATE_NEW_HOLIDAY:"Neu erstellen",
    RESET_INPUTS:"Alle Urlaube zurücksetzen",
    TWENTY_FOUR_HOURS_OPEN:"24 Stunden geöffnet",
    EVERY_YEAR:"Jährlich",
    DELETE_HOLIDAY:"Urlaub löschen",
    ADD_NEW_HOLIDAY:"Neuen Urlaub hinzufügen",
    HOLIDAYS_LIST:"Liste der bestehenden Urlaube",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Alle Urlaube für ausgewählte Anlage löschen?",
    VALIDATION_HOLIDAY_DATE:"Format nicht korrekt. Bitte MM-DD benutzen",
    FOR_DATE:"Für Datum",
    WITH_ID:"Mit ID",
    FROM_HOURS:"Von (h)",
    FROM_MINUTES:"Von (min)",
    TO_HOURS:"bis (h)",
    TO_MINUTES:"Bis (min)",
    NOT_MATCH:"Passt nicht",
    START:"Von",
    STOP:"Bis",
    DAILY_TIME:"24 Stunden Liste",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individuelle Zeiteinstellung",
    PROGRAM_NOT_STARTED:"Programm noch nicht gestartet",
    JETWASH:"SB-Anlage Waschsystem",
    KARCHER_REPORT_1:"Portalwäsche: Umsatzindikation pro Programm und insgesamt",
    KARCHER_REPORT_2:"Portalwäsche: Gestartete Wäschen pro Programm und insgesamt",
    KARCHER_REPORT_3:"Portalwäsche: Durchgeführte Waschvorgänge pro Programm und insgesamt",
    KARCHER_REPORT_4:"Portalwäsche: Anzahl der gestarteten Wäschen über das Bezahlungsterminal pro Programm und insgesamt",
    KARCHER_REPORT_5:"Portalwäsche: Anzahl der manuell gestarteten Wäschen pro Programm und insgesamt",
    KARCHER_REPORT_6:"Portalwäsche: Anzahl der abgebrochenen Wäschen pro Programm und insgesamt",
    KARCHER_REPORT_7:"Portalanlage: Anzahl der Stromausfälle",
    KARCHER_REPORT_8:"SB-Anlage: Betriebsstunden pro Waschprogramm gefiltert nach Waschplatz und gesamt",
    KARCHER_REPORT_9:"SB-Anlage: Umsatzindikation pro Waschplatz und gesamt",
    KARCHER_REPORT_10:"SB-Anlage: Wertmarken-/Münzenzähler pro Münzkanal",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Frischwasserpumpe",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Prozesswasserpumpe",
    OPERATION_COUNTER_HP_PUMP_1:"Hochdruckpumpe 1",
    OPERATION_COUNTER_HP_PUMP_2:"Hochdruckpumpe 2",
    RELEASE_NOTES:"App-Versionen und Versionshinweise",
    BACKEND_RELEASE_NOTES:"Versionshinweise zur Plattform:",
    FRONTEND_RELEASE_NOTES:"Webanwendung Versionshinweise:",
    SELECTED_FACILITY_TIMEZONE:"Zeitzone für ausgewählte Anlage:",
    REFRESH_PAGE:"Seite neu laden",
    REFRESH_MAPS:"Karte neu laden",
    PUMPS:"Pumpen",
    RUN_TIME:"Laufzeit",
    RUN_TIME1:"Laufzeit 1",
    RUN_TIME2:"Laufzeit 2",
    PROGRAM_RUNTIME_ACTUATOR:"Aktuator für Laufzeit",
    PROGRAM_RUNTIME_ACTUATOR_1:"Aktuator für Laufzeit 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Aktuator für Laufzeit 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Min-Wert ist 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Max-Wert ist 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Preis im Format x.xx verwenden",
    ACTUATION_NOT_ALLOWED:"Betätigung für aktuelle Benutzerrolle nicht zulässig",
    MAINTENANCE_DAYS:"Wartungstage",
    MAINTENANCE_WASHES:"Wartungswäschen",
    DAILY_FINANCES_POS:"Kartenterminal",
    POS_INCOME:"Gesamteinkommen Kartenterminal",
    PROPAGATE:"Verbreiten",
    ALL_DAY_HOURS_SELECTOR:"24 Stunden Einstellung",
    GET_OPERATING_TIME_FROM_SITE:"Betriebszeit des aktuellen Geräts aus den Einsatzplänen der Anlage abrufen",
    USER_NOT_VALID:"Der Benutzer ist ungültig. Versuchen Sie es mit den Anmeldeinformationen eines anderen Kontos.",
    VERIFIED:"Verifiziert",
    RESEND_VERIFICATION_MAIL:"Bestätigungsmail erneut senden",
    RETURN_TO_DASHBOARD:"Zurück zum Dashboard",
    ERROR_PAGE_BAD_REQUEST:"400 Ungültige Anfrage.",
    WASHES:"Anzahl der Wäschen",
    TIME_TO_SERVICE:"Zeit bis zur Wartung",
    ACCOUNT_ALREADY_ACTIVATED:"Konto bereits aktiviert",
    DEVICE_EVENTS:"Ereignisse",
    DEVICE_EVENTS_LOG_PULLED:"Ereignisprotokoll für das Gerät abgerufen",
    EVENTS_PULL_DATE:"Informationen angefordert am:",
    DEVICE_EVENTS_REFRESH:"Ereignisse aktualisieren",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problem mit der WebSocket-Verbindung. Versuchen Sie, die Seite zu aktualisieren.",
    INSTALLATION_DATE:"Installationsdatum",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Heißwachs",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Hochdruckwäsche",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Powerfelgenschaum ",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Powerschaum",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Stopp",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Schaumwäsche",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Wäsche",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Top-Pflege",
    INFO_TITLE:"Info",
    FOAM_WAX1:"Schaumwachs",
    POLISH1:"Polish",
    WAX1:"Wachs",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Standortdetails erfolgreich aktualisiert",
    COMPANY:"Unternehmen",
    FACILITY_HAS_CHANGER:"Wechsler vorhanden?",
    DISABLE_OFFLINE_ALARM:"R2W-Alarme deaktivieren",
    ASIDE_WORKING_SCHEDULES:"App-Standortdetails",
    TERMS_OF_SERVICE_R2W_TITLE:"Ready2Wash-Nutzungsbedingungen",
    TERMS_OF_SERVICE_R2W:" Ready2Wash-Nutzungsbedingungen",
    DATA_PROCESSING_TITLE:"Daten verarbeitet",
    PRIVACY_POLICY_TITLE:"Datenschutzrichtlinie",
    READY_TO_PAY_TERMS_OF_SERVICE:"Ready2Pay-Nutzungsbedingungen",
    TERMS_AND_SERVICES:"Allgemeine Geschäftsbedingungen",
    HOURLY: "Stündlich",
    DAILY: "Täglich",
    WEEKLY: "Wöchentlich",
    MONTHLY: "Monatlich",
    YEARLY: "Jährlich",
    DELETE_ITEM_SUCCESS:"Sie haben das Element erfolgreich gelöscht",
    STATE: "Zustand",
    AVAILABILITY_STATUS_1: "Einheit geöffnet",
    AVAILABILITY_STATUS_2: "Einheit geschlossen (Feiertag)",
    AVAILABILITY_STATUS_3: "Einheit geschlossen (Betriebszeit)",
    AVAILABILITY_STATUS_4: "Einheit geschlossen (Störung)",
    AVAILABILITY_STATUS_5: "Einheit geschlossen (sonstiges)",
    AVAILABILITY_VACUUMS_STATUS_1: "Staubsauger nicht installiert",
    AVAILABILITY_VACUUMS_STATUS_2: "Staubsauger geöffnet",
    AVAILABILITY_VACUUMS_STATUS_3: "Staubsauger geschlossen (Feiertag)",
    AVAILABILITY_VACUUMS_STATUS_4: "Staubsauger geschlossen (Betriebszeit)",
    AVAILABILITY_VACUUMS_STATUS_5: "Staubsauger geschlossen (Störung)",
    AVAILABILITY_VACUUMS_STATUS_6: "Staubsauger geschlossen (sonstiges)",
    ECOM_AMOUNT: "Gesamt Ecom für alle Standorte",
    CAPTURED: "Erfasst",
    DELETE_COMPANY_HISTORY_INFO:"Diese Aktion löscht alle Berichtsdaten Ihres Unternehmens. Diese Aktion kann nicht rückgängig gemacht werden.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Sind Sie sicher, dass Sie alle Berichtsdaten dauerhaft löschen möchten?",
    VALUE_DATE: "Valutadatum",
    KARCHER_EVENT_NAME_1: "Grundwärmetauscher regeneriert",
    KARCHER_EVENT_NAME_2: "Regeneration des Grundwärmetauschers beendet",
    KARCHER_EVENT_NAME_3: "Material / Seriennummer",
    KARCHER_EVENT_NAME_4: "Das System wurde desinfiziert",
    KARCHER_EVENT_NAME_5: "HP-Pumpe 1 wurde desinfiziert",
    KARCHER_EVENT_NAME_6: "HP-Pumpe 2 wurde desinfiziert",
    KARCHER_EVENT_NAME_7: "HP-Pumpe 3 wurde desinfiziert",
    KARCHER_EVENT_NAME_8: "HP-Pumpe 4 wurde desinfiziert",
    KARCHER_EVENT_NAME_9: "HP-Pumpe 5 wurde desinfiziert",
    KARCHER_EVENT_NAME_10: "Waschanlage 1 gesperrt",
    KARCHER_EVENT_NAME_11: "Waschanlage 2 gesperrt",
    KARCHER_EVENT_NAME_12: "Waschanlage 3 gesperrt",
    KARCHER_EVENT_NAME_13: "Waschanlage 4 gesperrt",
    KARCHER_EVENT_NAME_14: "Waschanlage 5 gesperrt",
    KARCHER_EVENT_NAME_15: "Waschanlage 6 gesperrt",
    KARCHER_EVENT_NAME_16: "Waschanlage 7 gesperrt",
    KARCHER_EVENT_NAME_17: "Waschanlage 8 gesperrt",
    KARCHER_EVENT_NAME_18: "Update gestartet",
    KARCHER_EVENT_NAME_19: "Update abgeschlossen",
    KARCHER_EVENT_NAME_20: "WS Reg Start",
    KARCHER_EVENT_NAME_21: "WS Reg Ende",
    KARCHER_EVENT_NAME_22: "WS 75% Sensor",
    KARCHER_EVENT_NAME_23: "Technischer Defekt",
    KARCHER_EVENT_NAME_24: "Betriebsfehler",
    KARCHER_EVENT_NAME_25: "Einheit eingeschaltet",
    KARCHER_EVENT_NAME_26: "Einheit ausgeschaltet",
    KARCHER_EVENT_NAME_27: "Box 1 geschlossen",
    KARCHER_EVENT_NAME_28: "Box 2 geschlossen",
    KARCHER_EVENT_NAME_29: "Box 3 geschlossen",
    KARCHER_EVENT_NAME_30: "Box 4 geschlossen",
    KARCHER_EVENT_NAME_31: "Box 5 geschlossen",
    KARCHER_EVENT_NAME_32: "Box 6 geschlossen",
    KARCHER_EVENT_NAME_33: "Box 7 geschlossen",
    KARCHER_EVENT_NAME_34: "Box 8 geschlossen",
    KARCHER_EVENT_NAME_35: "HP-Pumpenstation 1",
    KARCHER_EVENT_NAME_36: "HP-Pumpenstation 2",
    KARCHER_EVENT_NAME_37: "HP-Pumpenstation 3",
    KARCHER_EVENT_NAME_38: "HP-Pumpenstation 4",
    KARCHER_EVENT_NAME_39: "HP-Pumpenstation 5",
    KARCHER_EVENT_NAME_40: "HP-Pumpenstation 6",
    KARCHER_EVENT_NAME_41: "HP-Pumpenstation 7",
    KARCHER_EVENT_NAME_42: "HP-Pumpenstation 8",
    KARCHER_EVENT_NAME_43: "Brenner",
    KARCHER_EVENT_NAME_44: "Brennerlüfter",
    KARCHER_EVENT_NAME_45: "Warmwasserpumpe",
    KARCHER_EVENT_NAME_46: "Frostschutzpumpe",
    KARCHER_EVENT_NAME_47: "Osmosepumpe",
    KARCHER_EVENT_NAME_48: "Fußbodenheizung",
    KARCHER_EVENT_NAME_49: "Schlauchheizung",
    KARCHER_EVENT_NAME_50: "Mikro-/Felgenreinigung",
    KARCHER_EVENT_NAME_51: "Unterbodenpumpe",
    KARCHER_EVENT_NAME_52: "Booster Pumpe Schaum",
    KARCHER_EVENT_NAME_53: "Staubsauger 1",
    KARCHER_EVENT_NAME_54: "Staubsauger 2",
    KARCHER_EVENT_NAME_55: "Staubsauger 3",
    KARCHER_EVENT_NAME_56: "Staubsauger 4",
    KARCHER_EVENT_NAME_57: "Staubsauger 5",
    KARCHER_EVENT_NAME_58: "Staubsauger 6",
    KARCHER_EVENT_NAME_59: "Staubsauger 7",
    KARCHER_EVENT_NAME_60: "Staubsauger 8",
    KARCHER_EVENT_NAME_61: "Staubsauger 9",
    KARCHER_EVENT_NAME_62: "Staubsauger 10",
    KARCHER_EVENT_NAME_63: "Staubsauger 11",
    KARCHER_EVENT_NAME_64: "Staubsauger 12",
    KARCHER_EVENT_NAME_65: "Felgenreinigungspumpe",
    KARCHER_EVENT_NAME_66: "Mikropumpe",
    KARCHER_EVENT_NAME_67: "Intensivpumpe",
    KARCHER_EVENT_NAME_68: "Turbine Staubsauger 1",
    KARCHER_EVENT_NAME_69: "Filter Staubsauger 1",
    KARCHER_EVENT_NAME_70: "Turbine Staubsauger 2",
    KARCHER_EVENT_NAME_71: "Filter Staubsauger 2",
    KARCHER_EVENT_NAME_72: "Turbine Staubsauger 3",
    KARCHER_EVENT_NAME_73: "Filter Staubsauger 3",
    KARCHER_EVENT_NAME_74: "Turbine Staubsauger 4",
    KARCHER_EVENT_NAME_75: "Filter Staubsauger 4",
    KARCHER_EVENT_NAME_76: "Turbine Staubsauger 5",
    KARCHER_EVENT_NAME_77: "Filter Staubsauger 5",
    KARCHER_EVENT_NAME_78: "Turbine Staubsauger 6",
    KARCHER_EVENT_NAME_79: "Filter Staubsauger 6",
    KARCHER_EVENT_NAME_80: "Turbine Staubsauger 7",
    KARCHER_EVENT_NAME_81: "Filter Staubsauger 7",
    KARCHER_EVENT_NAME_82: "Turbine Staubsauger 8",
    KARCHER_EVENT_NAME_83: "Filter Staubsauger 8",
    KARCHER_EVENT_NAME_84: "Turbine Staubsauger 9",
    KARCHER_EVENT_NAME_85: "Filter Staubsauger 9",
    KARCHER_EVENT_NAME_86: "Turbine Staubsauger 10",
    KARCHER_EVENT_NAME_87: "Filter Staubsauger 10",
    KARCHER_EVENT_NAME_88: "Turbine Staubsauger 11",
    KARCHER_EVENT_NAME_89: "Filter Staubsauger 11",
    KARCHER_EVENT_NAME_90: "Turbine Staubsauger 12",
    KARCHER_EVENT_NAME_91: "Filter Staubsauger 12",
    INSERT_TOKEN: "Token einfügen und Dienst starten",
    OPEN_SESSION: "Sitzung erfolgreich geöffnet",
    IN_PROGRESS: "In Bearbeitung ...",
    TOKEN_INSERTED: "Token erfolgreich eingefügt",
    EXPIRED_SESSION: "Sitzung abgelaufen",
    TWO_DIGIT_INTEGER_VALIDATION: "Verwenden Sie eine maximale zweistellige Ganzzahl",
    KARCHER_OPERATION_COUNTER_1: "Waschplatz 1 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_2: "Waschplatz 1 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_3: "Waschplatz 1 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_4: "Waschplatz 1 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_5: "Waschplatz 1 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_6: "Waschplatz 2 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_7: "Waschplatz 2 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_8: "Waschplatz 2 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_9: "Waschplatz 2 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_10: "Waschplatz 2 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_11: "Waschplatz 3 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_12: "Waschplatz 3 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_13: "Waschplatz 3 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_14: "Waschplatz 3 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_15: "Waschplatz 3 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_16: "Waschplatz 4 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_17: "Waschplatz 4 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_18: "Waschplatz 4 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_19: "Waschplatz 4 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_20: "Waschplatz 4 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_21: "Waschplatz 5 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_22: "Waschplatz 5 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_23: "Waschplatz 5 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_24: "Waschplatz 5 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_25: "Waschplatz 5 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_26: "Waschplatz 6 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_27: "Waschplatz 6 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_28: "Waschplatz 6 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_29: "Waschplatz 6 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_30: "Waschplatz 6 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_31: "Waschplatz 7 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_32: "Waschplatz 7 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_33: "Waschplatz 7 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_34: "Waschplatz 7 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_35: "Waschplatz 7 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_36: "Waschplatz 8 HD-Pumpe",
    KARCHER_OPERATION_COUNTER_37: "Waschplatz 8 Chemiepumpe 1",
    KARCHER_OPERATION_COUNTER_38: "Waschplatz 8 Chemiepumpe 2",
    KARCHER_OPERATION_COUNTER_39: "Waschplatz 8 Chemiepumpe 3",
    KARCHER_OPERATION_COUNTER_40: "Waschplatz 8 Chemiepumpe 4",
    KARCHER_OPERATION_COUNTER_41: "Osmosepumpe",
    KARCHER_OPERATION_COUNTER_42: "Heißwassererzeuger",
    KARCHER_OPERATION_COUNTER_43: "Frostschutzpumpe",
    KARCHER_OPERATION_COUNTER_44: "Filtereinsatz WSO",
    KARCHER_OPERATION_COUNTER_45: "Pumpe Waschplatzheizung",
    KARCHER_OPERATION_COUNTER_46: "Warmwasserpumpe",
    KARCHER_OPERATION_COUNTER_47: "Schaumschlauchheizung",
    KARCHER_OPERATION_COUNTER_48: "Pumpe Felgenreinigung",
    KARCHER_OPERATION_COUNTER_49: "Pumpe Micro-Emulsion",
    KARCHER_OPERATION_COUNTER_50: "Pumpe Intensivschaum",
    KARCHER_OPERATION_COUNTER_51: "Sauger 1 Turbine 1",
    KARCHER_OPERATION_COUNTER_52: "Sauger 1 Filter 1",
    KARCHER_OPERATION_COUNTER_53: "Sauger 1 Turbine 2",
    KARCHER_OPERATION_COUNTER_54: "Sauger 1 Filter 2",
    KARCHER_OPERATION_COUNTER_55: "Sauger 2 Turbine 1",
    KARCHER_OPERATION_COUNTER_56: "Sauger 2 Filter 1",
    KARCHER_OPERATION_COUNTER_57: "Sauger 2 Turbine 2",
    KARCHER_OPERATION_COUNTER_58: "Sauger 2 Filter 2",
    KARCHER_OPERATION_COUNTER_59: "Sauger 3 Turbine 1",
    KARCHER_OPERATION_COUNTER_60: "Sauger 3 Filter 1",
    KARCHER_OPERATION_COUNTER_61: "Sauger 3 Turbine 2",
    KARCHER_OPERATION_COUNTER_62: "Sauger 3 Filter 2",
    KARCHER_OPERATION_COUNTER_63: "Sauger 4 Turbine 1",
    KARCHER_OPERATION_COUNTER_64: "Sauger 4 Filter 1",
    KARCHER_OPERATION_COUNTER_65: "Sauger 4 Turbine 2",
    KARCHER_OPERATION_COUNTER_66: "Sauger 4 Filter 2",
    KARCHER_OPERATION_COUNTER_67: "Sauger 5 Turbine 1",
    KARCHER_OPERATION_COUNTER_68: "Sauger 5 Filter 1",
    KARCHER_OPERATION_COUNTER_69: "Sauger 5 Turbine 2",
    KARCHER_OPERATION_COUNTER_70: "Sauger 5 Filter 2",
    KARCHER_OPERATION_COUNTER_71: "Sauger 6 Turbine 1",
    KARCHER_OPERATION_COUNTER_72: "Sauger 6 Filter 1",
    KARCHER_OPERATION_COUNTER_73: "Sauger 6 Turbine 2",
    KARCHER_OPERATION_COUNTER_74: "Sauger 6 Filter 2",
    KARCHER_OPERATION_COUNTER_75: "Kondenswasser am Kompressor ablassen",
    KARCHER_OPERATION_COUNTER_76: "Frostschutzsystem überprüfen",
    KARCHER_OPERATION_COUNTER_77: "Brennergebläse",
    KARCHER_OPERATION_COUNTER_78: "Druckerhöhung Schaum",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Datenliste ist größer als 10000 Einträge",
    KARCHER_POINT_NAME_1: "Feiertag",
    KARCHER_POINT_NAME_2: "Montag",
    KARCHER_POINT_NAME_3: "Dienstag",
    KARCHER_POINT_NAME_4: "Mittwoch",
    KARCHER_POINT_NAME_5: "Donnerstag",
    KARCHER_POINT_NAME_6: "Freitag",
    KARCHER_POINT_NAME_7: "Samstag",
    KARCHER_POINT_NAME_8: "Sonntag",
    KARCHER_POINT_NAME_9: "Staubsauger Feiertag",
    KARCHER_POINT_NAME_10: "Staubsauger Montag",
    KARCHER_POINT_NAME_11: "Staubsauger Dienstag",
    KARCHER_POINT_NAME_12: "Staubsauger Mittwoch",
    KARCHER_POINT_NAME_13: "Staubsauger Donnerstag",
    KARCHER_POINT_NAME_14: "Staubsauger Freitag",
    KARCHER_POINT_NAME_15: "Staubsauger Samstag",
    KARCHER_POINT_NAME_16: "Staubsauger Sonntag",
    KARCHER_POINT_NAME_17: "Beleuchtung Feiertag",
    KARCHER_POINT_NAME_18: "Beleuchtung Montag",
    KARCHER_POINT_NAME_19: "Beleuchtung Dienstag",
    KARCHER_POINT_NAME_20: "Beleuchtung Mittwoch",
    KARCHER_POINT_NAME_21: "Beleuchtung Donnerstag",
    KARCHER_POINT_NAME_22: "Beleuchtung Freitag",
    KARCHER_POINT_NAME_23: "Beleuchtung Samstag",
    KARCHER_POINT_NAME_24: "Beleuchtung Sonntag",
    KARCHER_POINT_NAME_25: "Programm 0",
    KARCHER_POINT_NAME_26: "Programm 1",
    KARCHER_POINT_NAME_27: "Programm 2",
    KARCHER_POINT_NAME_28: "Programm 3",
    KARCHER_POINT_NAME_29: "Programm 4",
    KARCHER_POINT_NAME_30: "Programm 5",
    KARCHER_POINT_NAME_31: "Programm 6",
    KARCHER_POINT_NAME_32: "Programm 7",
    KARCHER_POINT_NAME_33: "Programm 8",
    KARCHER_POINT_NAME_34: "Programm 9",
    KARCHER_POINT_NAME_35: "Programm 10",
    KARCHER_POINT_NAME_36: "Programm 11",
    KARCHER_POINT_NAME_37: "Programm 12",
    KARCHER_POINT_NAME_38: "Programm 13",
    KARCHER_POINT_NAME_39: "Programm 14",
    KARCHER_POINT_NAME_40: "Programm 15",
    KARCHER_POINT_NAME_41: "Programm 16",
    KARCHER_POINT_NAME_42: "Programm 17",
    KARCHER_POINT_NAME_43: "Programm 18",
    KARCHER_POINT_NAME_44: "Programm 19",
    KARCHER_POINT_NAME_45: "Programm 20",
    KARCHER_POINT_NAME_46: "Programm 21",
    KARCHER_POINT_NAME_47: "Programm 22",
    KARCHER_POINT_NAME_48: "Programm 23",
    KARCHER_POINT_NAME_49: "Programm 24",
    KARCHER_POINT_NAME_50: "Programm 25",
    KARCHER_POINT_NAME_51: "Programm 26",
    KARCHER_POINT_NAME_52: "Programm 27",
    KARCHER_POINT_NAME_53: "Programm 28",
    KARCHER_POINT_NAME_54: "Programm 29",
    KARCHER_POINT_NAME_55: "Programm 30",
    KARCHER_POINT_NAME_56: "Programm 31",
    KARCHER_POINT_NAME_57: "Programm 32",
    QR_CODE: "QR-Code",
    ACCEPT_TERMS_AND_CONDITIONS: "Geschäftsbedingungen akzeptieren",
    CREATE_AND_PRINT_VOUCHERS: "Gutscheine erstellen und drucken",
    CODE_PREFIX_QUESTION: "Präfixcode ist nicht eingegeben",
    CODE_PREFIX_QUESTION_TEXT: "Möchten Sie ohne Präfixcode fortfahren?",
    ISSUED_DATE: "Ausstellungsdatum",
    VOUCHER_VALIDITY_DAYS: "Gutscheingültigkeit (Tage)",
    VALIDATION_ONLY_NUMBERS: "Nur Zahlen sind erlaubt",
    REPRINT_VOUCHERS: "Kopie der Gutscheine drucken",
    EXPIRY_DATE: "Gültig bis"
  });
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").constant("csTranslations", {
    MESSAGE:"Zpráva",
    ERROR_TITLE:"Chyba",
    ERROR_MESSAGE:"Při spuštění operace došlo k chybě.",
    ERROR_LOGIN:"Během přihlášení došlo k chybě. E-mailová adresa není platná",
    ERROR_LOGIN_ROLE:"Role pro aktuální verzi aplikace není platná",
    OK:"OK",
    CANCEL:"Zrušit",
    YES:"Ano",
    NO:"Ne",
    FROM:"Od ",
    TO:"Do",
    DELETE:"Vymazat, odstranit",
    SIGN_OUT:"Odhlásit",
    NAME:"Jméno",
    DATE:"Datum",
    PIECES:"Kusů",
    HOURS:"Hodiny",
    DAYS:"Dnů",
    MONTH:"Měsíc",
    MONTHS:"Měsíce",
    YEAR:"Rok",
    BOX:"Box",
    SEARCH:"Hledat",
    ALL_USERS:"Všichni uživatelé",
    ARE_YOU_SURE:"Jste si jisti?",
    BACK:"Zpět",
    AMOUNT:"Množství",
    DESCRIPTION:"Popis",
    FORGOT_PASSWORD_ERROR_MSG:"Něco se pokazilo. Zkontrolujte prosím svou e-mailovou adresu a zkuste to znovu",
    REQUIRED_FIELD:"Pole je povinné",
    LOGOUT_TITLE:"Opravdu se chcete odhlásit?",
    LOGOUT_MSG:"Všechny neuložené údaje budou ztraceny",
    ACTIVATION_ACCOUNT:"Úspěšně jste aktivovali svůj účet",
    UNKNOWN_ERRROR_NOTIFICATION:"Došlo k neznámé chybě",
    CONTINUE:"Pokračovat",
    DATA_NOT_AVAILABLE:"Data nejsou k dispozici",
    SELECT:"Vybrat",
    SELECT_CURRENCY:"Vybrat měnu",
    UPLOAD:"Nahrát",
    PHONE:"Telefon",
    WEBSITE:"Webová stránka",
    WORKING_HOURS:"Otevírací doba",
    INSERT:"Vložit",
    TEXT:"Text",
    CREATED:"Vytvořeno",
    VALID_UNTIL:"Platné do",
    SAVE:"Uložit",
    TOKENS:"Žetony ",
    DELETE_COMPANY_HISTORY:"Odstranit historii společnosti?",
    DELETE_COMPANY_HISTORY_MESSAGE:"VAROVÁNÍ: Po stisknutí tohoto tlačítka budou všechny transakce vaší myčky nenávratně smazány! Tato data nelze po smazání obnovit.",
    DELETE_COMPANY_HISTORY_CONFIRMATION:"Jste si jisti, že chcete trvale smazat všechna data transakcí?",
    HISTORY_SUCCESSFULY_DELETED:"History successfuly deleted",
    HELP:"Pomoc",
    VALUE:"Hodnota",
    ACTIVATING_ACCOUNT_ERROR:"Při aktivaci účtu R2W došlo k problému. Zkuste to znovu a pokud problém přetrvává, kontaktujte naši podporu na adrese support@ready2wash.com",
    ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG:"Vítejte v Kärcher Car Wash",
    ACTIVATING_ACCOUNT_WELCOME_MSG:"Vítejté v R2W",
    ACTIVATING_ACCOUNT_WELCOME_MSG_2:"Zadejte své nové heslo a potvrďte jej, abyste aktivovali účet R2W. Po úspěšné aktiaci se automaticky přihlásíte do aplikace",
    ACTIVATING_ACCOUNT_WELCOME_MSG_3:"Uživatelské nastavení můžete později změnit v aplikaci",
    RESET_PASSWORD_WELCOME_KARCHER_MSG:" Kärcher Car Wash",
    RESET_PASSWORD_WELCOME_MSG:"R2W Car Wash",
    RESET_PASSWORD_WELCOME_MSG_2:"Zadejte prosím své nové heslo a potvrďte jej, aby bylo možné resetovat staré heslo. Po úspěšné operaci budete automaticky přihlášeni do aplikace",
    RESET_PASSWORD_WELCOME_MSG_3:"Svá uživatelská nastavení můžete později v aplikaci změnit",
    ENTER_NEW_PASSWORD:"Zadejte nové heslo",
    REPEAT_NEW_PASSWORD:"Opakujte nové heslo",
    PASSWORD_MIN_LENGTH:"Heslo musí mít alespoň 8 znaků",
    PASSWORD_MAX_LENGHT:"Heslo musí mít délku menší než 32 znaků",
    PASSWORD_PATTERN:"Heslo musí obsahovat alespoň jedno velké písmeno a jedno malé písmeno",
    PASSWORD_MATCH:"Hesla neodpovídají",
    ACTIVATE:"Aktivovat",
    SUCCESS_FORGOT_PASSWORD_NOTIFICATION:"Úspěšně jste podali žádost. Zkontrolujte prosím svůj e-mail, zda jste obdrželi potvrzující zprávu",
    VALIDATION_REQUIRED:"Povinné pole",
    VALIDATION_EMAIL:"Neplatná emailová adresa",
    VALIDATION_INTEGER_NUMBER:"Zadejte celé číslo",
    VALIDATION_HOURS_VALUE:"Hodnota musí být mezi 0-23",
    VALIDATION_MINUTES_VALUE:"Hodnota musí být mezi 0-59",
    VALIDATION_NOT_A_DATE:"Hodnota není datum",
    VALIDATION_FROM:"Od data většího než ",
    VALIDATION_TO:"K datu méně než ",
    ERROR_MESSAGE_ITEM_ALREADY_EXIST:"Tento záznam již existuje v databázi",
    PASSWORD_VALIDATION_PATTERN_NEW:"Musí existovat alespoň jedna číslice a jedno velké písmeno. Mezery nejsou povoleny",
    VALIDATION_PERCENT_VALUE:"Hodnota musí být mezi 1-999",
    NUMBERS_ONLY_100:"Number up to 100",
    NUMBERS_ONLY_1000:"Number up to 1000",
    POSITIVE_NUMBERS_ONLY:"Only positive number",
    GRID_PAGER_PAGE:"Stránka",
    GRID_PAGER_ROWS_PER_PAGE:"Řádků na stránku",
    GRID_PAGER_PAGE_OF:"z",
    BREAD_CRUMBS_HOME:"Domu",
    BREAD_CRUMBS_DASHBOARD_TECH:"Technologie přístrojové desky",
    BREAD_CRUMBS_DETAILS:"Detaily",
    BREAD_CRUMBS_SETTINGS:"Nastavení",
    BREAD_CRUMBS_WORKING_HOURS:"Pracovní doba",
    BREAD_CRUMBS_DAILY_TOTAL_REPORT:"Celkový denní peněžní report",
    BREAD_CRUMBS_AVG_BY_HOUR_REPORT:"Průměrný hodinový peněžní report",
    BREAD_CRUMBS_NEW_USER_GROUP:"Vytvořit uživatelskou skupinu",
    BREAD_CRUMBS_EDIT_USER_GROUP:"Upravit uživatelskou skupinu",
    BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE:"Vytvořit šablonu kampaně",
    BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE:"Upravit šablonu kampaně ",
    BREAD_CRUMBS_NEW_CAMPAIGN:"Vytvořit kampaň",
    BREAD_CRUMBS_EDIT_CAMPAIGN:"Upravit kampaň",
    BREAD_CRUMBS_PERIODIC_SUMMARY:"Periodické shrnutí",
    LOGIN:"Přihlásit",
    EMAIL:"E-mail",
    PASSWORD:"Heslo",
    LANGUAGE:"Jazyk",
    FORGOT_PASSWORD:"Zapomenuté heslo?",
    SUBMIT:"Předložit",
    HEADER_NUMBER_OF_PENDING_ALARMS:"Počet nevyřízených alarmů:",
    HEADER_VIEW_ALL_ALARMS:"Zobrazit všechny alarmy ...",
    HEADER_MY_ACCOUNT:"Můj účet",
    HEADER_ACCOUNT_MANAGEMENT:"Zpráva účtu",
    ACCOUNT_ALREADY_EXIST:"Emailová adresa je již použita",
    NEWSLETTER_CONFIRMATION:"Odeslat e-mailové upozornění pro stav poplachů",
    ASIDE_MENU_DASHBOARD_FINANCIAL:"Denní finanční přehled",
    ASIDE_MENU_DASHBOARD_TECHNOLOGY:"Technologie přístrojové desky",
    ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY:"Přístrojová deska",
    ASIDE_MENU_ALARMS:"Zprávy",
    ASIDE_MENU_FACILITIES:"Vybavení",
    ASIDE_MENU_REPORTS:"Reporty",
    ASIDE_MENU_REPORT:"Vybraný přehled",
    ASIDE_MENU_LOYALTY:"Věrnost",
    ASIDE_MENU_USER_GROUPS:"Uživatelské skupiny",
    ASIDE_MENU_PERIODIC_SUMMARY:"Periodické shrnutí",
    ASIDE_MENU_MANAGING_TOKENS:"Správa žetonů",
    ASIDE_MENU_NEWS:"Zprávy",
    DAILY_FINANCES_TOTAL_MONEY:"Celkem peněz",
    DAILY_FINANCES_TOTAL_MONEY_ALL:"Celkem peněz za veškeré vybavení",
    DAILY_FINANCES_TOTAL_COINS:"Celkově použité kovové tokeny",
    DAILY_FINANCES_DOWNLOAD_CSV:"Nahrát CSV",
    DAILY_FINANCES_ONLINE:"R2W (Online)",
    DAILY_FINANCES_OFFLINE:"Hotovost",
    DAILY_FINANCES_CHANGER:"Hotovost ve měniči",
    DAILY_FINANCES_COINS:"Žetony/Eurokey",
    REPORTS_FILTER:"Filtr",
    REPORTS_TYPE_OF_REPORT:"Druh reportu",
    REPORTS_CHOOSE_FACILITY:"Vyber zařízení",
    REPORTS_PERIOD_1:"Období 1 -",
    REPORTS_PERIOD_2:"Období 2 -",
    MONEY_BY_DATE_REPORT:"Peníze celkem podle data",
    R2W_BY_DATE_REPORT:"Celkem online platby podle data",
    COINS_BY_DATE_REPORT:"Celkem platby žetony podle data",
    AVG_MONEY_BY_HOUR_REPORT:"Průměrně peněz za hodinu",
    AVG_MONEY_BY_DAY_OF_WEEK_REPORT:"Průměrně peněz za den v týdnu",
    AVG_MONEY_BY_BOX_REPORT:"Tržby podle přístroje",
    COMPARE_PERIODS_REPORT:"Srovnávací zpráva zařízení",
    TOTAL_USERS_BY_GROUP:"Počet uživatelů celkem podle skupin",
    TOTAL_USERS_BY_GROUP_USERS_UNIT:"uživatelé",
    TOTAL_USERS_BY_GROUP_VISITS_UNIT:"návštěv",
    VISITS_COUNT_REPORT:"Počet uživatelů na počet návštěv",
    LOYALTY_PER_DAY_REPORT:"Poskytnuté místní R2W žetony za den",
    LOYALTY_PER_PAYMENT_METHOD:"Poskytnté místní žetony dle platební metody",
    VISITS:"Návštěvy",
    VISIT:"Návštěva",
    TOTAL_SPENT_MONEY:"Celkem použito peněz",
    MONEY:"Peníze",
    TOTAL_SPENT_MONEY_FOR_PERIOD:"Celkem použito peněz za období",
    DOWNLOAD_CSV:"Nahrát CSV",
    TOTAL_SPENT_COINS:"Celkem použito žetonů",
    TOTAL_USERS:"Celkem uživatelů",
    TOTAL_CREDIT_GIVEN:"Celkový poskytnutý kredit",
    EUROKEY_BY_DATE_REPORT:"Celkové platby Eurokey podle data",
    TOTAL_SPENT_EUROKEY:"Celkem vynaloženon ",
    SELECT_TYPE_OF_REPORT:"Je třeba vybrat typ přehledu :)",
    NUMBER_OF_VISITS_TITLE:"Počet návštěv",
    NUMBER_OF_USERS_TITLE:"Počet uživatelů",
    PIECES_TITLE:"Kousky",
    TOTAL_VISITS:"Celkový počet návštěv",
    TOKENS_TITLE:"žetony",
    SEARCH_USERS_NO_RESULTS:"Pro daný hledaný výraz nenalezeny žádní uživatelé",
    SEARCH_USERS:"Hledání uživatelů",
    SEARCH_TELEPHONES:"Hledání uživatelů dle mobilního čísla",
    ADD_USER_TO_GROUP:"Přidat uživatele do skupiny",
    REMOVE_USER_FROM_GROUP:"Odstranit uživatele ze skupiny",
    USER_GROUP_NAME_REQUIRED:"Je vyžadován název skupiny uživatelů",
    USER_GROUP_NAME:"Název skupiny uživatelů",
    USER_GROUPS_OVERVIEW:"Přehled skupin uživatelů",
    USER_COUNT:"Počet uživatelů",
    NEW_USER_GROUP:"Vytvořit novou uživatelskou skupinu",
    DELETE_USER_GROUP:"Odstranit uživatelskou skupinu",
    UPDATE_USER_GROUP:"Upravit skupinu uživatelů",
    DELETE_USER_GROUP_ERROR:"Při odstraňování vybrané skupiny uživatelů došlo k chybě. Zkuste to prosím znovu nebo kontaktujte podporu ...",
    CONFIRM_DELETE_USER_GROUP:"Opravdu chcete smazat vybranou skupinu uživatelů?",
    CONFIRM_DELETE_USER_GROUP_TEXT:"Věrnostní akce, ke kterým byla přiřazena smazaná skupina, již nebudou použiváné.",
    GROUP_NAME_MAX_LENGTH:"Název skupiny musí mít délku menší než 255 znaků",
    USER_IS_ALREADY_IN_GROUP_NOTIFICATION:"Uživatel je již v této skupině",
    MISSING_USER:"Missing user(en)",
    USER_NOT_ON_LIST:"User is not in the active users list. Check if the email address is valid and try again(en).",
    UPLOAD_USER_GROUP:"Upload user group list from *.csv file",
    UKNOWN_USERS:"List of uknown users",
    CAMPAIGN_TEMPLATE_RULE:"Pravidlo šablony",
    DELETE_CAMPAIGN_TEMPLATE_ERROR:"Při pokusu o odstranění šablony kampaně došlo k chybě. Zkuste to prosím znovu nebo kontaktujte podporu …",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE:"Opravdu chcete vybranou šablonu kampaně smazat",
    CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT:"Opravdu chcete vybranou šablonu kampaně smazat",
    CAMPAIGN_TEMPLATES_OVERVIEW:"Přehled šablon kampaní",
    DELETE_CAMPAIGN_TEMPLATE:"Smazat šablonu kampaně",
    UPDATE_CAMPAIGN_TEMPLATE:"Upravit šablonu kampaně",
    CREATE_CAMPAIGN_TEMPLATE:"Vytvořte novou šablonu kampaně",
    CAMPAIGN_TEMPLATE_NAME_REQUIRED:"Je požadován název šablony kampaně",
    CAMPAIGN_TEMPLATE_NAME:"Název šablony kampaně",
    CAMPAIGN_TEMPLATE_RULE_REQUIRED:"Povinné pole",
    CAMPAIGN_TEMPLATE_RULE_GIVE:"dát %",
    CAMPAIGN_TEMPLATE_RULE_CREDITS:"více času",
    CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP:"Nejprve prosím vyberte typ. Mycí boxy nebo malé stroje.",
    CAMPAIGN_TEMPLATE_REMOVE_RULE:"Smazat pravidlo šablony",
    CAMPAIGN_TEMPLATE_RULE_FROM:"Od",
    CAMPAIGN_TEMPLATE_RULE_TO:"do",
    CAMPAIGN_TEMPLATE_RULE_HOURS:"hodiny",
    CAMPAIGN_TEMPLATE_RULE_MINUTES:"minuty",
    CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS:"Nové pravidlo podle počtu návštěv",
    CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT:"Nové pravidlo založené na použitých žetonech",
    CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS:"Nové pravidlo podle dnů v týdnu",
    CAMPAIGN_TEMPLATE_ADD_RULE:"Přidat nové pravidlo šablony",
    CAMPAIGN_TEMPLATE_RULE_1:"Každý",
    CAMPAIGN_TEMPLATE_RULE_1_KARCHER:"Každý",
    CAMPAIGN_TEMPLATE_RULE_2_CREDITS:"Žetony vynaložené za méně než",
    CAMPAIGN_TEMPLATE_RULE_2_VISITS:"návštěv za méně než",
    CAMPAIGN_TEMPLATE_RULE_3:"dny",
    CAMPAIGN_TEMPLATE_RULE_4:"Žetony",
    CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST:"Seznam pravidel je prázdný.",
    CAMPAIGN_FROM_DATE_TOO_EARLY:"Datum nemůže být v minulosti",
    DELETE_CAMPAIGN_ERROR:"Při pokusu o smazání kampaně došlo k chybě. Zkuste to prosím znovu nebo kontaktujte podporu ...",
    CONFIRM_DELETE_CAMPAIGN:"Opravdu chcete smazat vybranou kampaň?",
    CONFIRM_DELETE_CAMPAIGN_TEXT:"R2W není odpovědný za uživatelskou zkušenost způsobenou touto akcí.",
    CAMPAIGNS_OVERVIEW:"Přehled kampaní",
    DELETE_CAMPAIGN:"Smazet kampaň",
    UPDATE_CAMPAIGN:"Upravit kampaň",
    CREATE_CAMPAIGN:"Vytvořit novou kampaň",
    CAMPAIGN_ACTIVE:"Aktivní",
    CAMPAIGN_TEMPLATE:"Šablona",
    CAMPAIGN_GROUPS:"Skupiny",
    CAMPAIGN_ALL_USERS:"Všechny uživatele",
    CAMPAIGN_NAME:"Název kampaňe",
    CAMPAIGN_NAME_REQUIRED:"Povinný",
    CAMPAIGN_USERS_NEAR_TRESHOLD:"Počet uživatelů blízko denního prahu",
    MESSAGE_TO_USERS:"Zpráva pro filtrované uživatele",
    SEND_MESSAGE:"Odeslat zprávu",
    THRESHOLD:"Práh",
    TYPE:"Druh ",
    TOTAL_MONEY_SPENT:"Celkové peníze vynaložené v kampani",
    NUMBER_OF_VISITS:"Počet návštěv v kampani",
    SEND_MESSAGE_MIN_LENGTH_VALIDATION:"Zpráva musí mít délku nejméně 10 znaků",
    SEND_MESSAGE_MAX_LENGTH_VALIDATION:"Zpráva musí mít délku menší než 350 znaků",
    SEND_MESSAGE_REQUIRED_VALIDATION:"Text zprávy je vyžadován",
    TECHNOLOGY:"Technologie ",
    TAP_WATER:"Voda z vodovodu",
    REVERSE_OSMOSIS:"Reverzní osmóza",
    SOFTENED_WATER:"Změkčená voda",
    DOSER:"Dávkovač",
    STATUS:"Status",
    LAST_SYNCHRONIZATION:"Poslední synchronizace",
    NO_OF_CURRENT_ALARMS:"Počet aktuálních alarmů",
    NO_OF_CURRENT_WARNINGS:"Počet aktuálních varování",
    WEATHER:"Počasí",
    BOXES_WORK_HOURS_COUNTERS:"Pracovní doba boxů",
    BOX_TOTAL_HOURS:"Celková pracovní doba",
    BOX_SERVICE_HOURS:"Celková pracovní doba (servis)",
    BOX_COUNTER_HOURS:"hodiny",
    ALARMS_AND_WARNINGS:"Alarmy a varování",
    FILTER_AND_BOILER:"Filtr a bojler",
    FILTER_TOTAL_DAYS:"Filtr pracovní dny",
    BOILER_TOTAL_DAYS:"Bojler pracovní dny",
    DAYS_UNIT:"dny",
    SOFTENER:"Změkčovač",
    MANUAL_COLD_DRAIN:"Ruční studený odtok",
    EL_COLD:"El. studený",
    DRAIN:"odtok",
    TAP:"Kohoutek",
    WASTE:"Odpad",
    OSMOSIS:"Osmóza",
    DEMI_WATER:"Demineralizovaná voda",
    EL_RINSE:"El. m. oplach",
    BOILER:"Bojler",
    EL_WAX:"El. M. vosk",
    FLOOR_HEATING:"Podlahové topení",
    DOSER_TANK:"Dávkovací nádrž",
    EL_WASH:"El. M. mytí",
    DETERGENT:"Saponát",
    VIBRATOR:"Vibrátor",
    UPDATE_FACILITY_SETTINGS:"Aktualizovat nastavení",
    GENERAL_SETTINGS:"Obecné nastavení",
    LIGHTS:"Světla",
    GROUPS:"Skupiny",
    ANTI_FREEZE:"Nemrznoucí směs",
    AUTO:"Auto",
    MANUAL:"Návod",
    ON:"Zapnuto",
    OFF:"Vypnuto",
    TEMPERATURE:"Teplota",
    UPDATE_DEVICE:"Aktualizace nastavení zařízení",
    BOX_CLEAN_HOURS:"Počitadla čítačů (hodiny)",
    GROUP_COUNTERS:"Skupinové čítače",
    RESET:"resetovat",
    CASH_COUNT:"Počet mincí",
    COINS_COUNT:"Počet žetonů",
    EUROKEY_COUNT:"Počet Eurokeyů",
    DOSER_WORK:"Dávkovač provozní doba (sec)",
    DOSER_PAUSE:"Doba pozastavení dávkování (sec)",
    DELAY_BFV:"BFV zpoždění (ms)",
    DELAY_6M1:"6M1 zpoždění (ms)",
    DELAY_LPS:"LPS zpoždění (ms)",
    RESET_CASH_COUNT_ALL:"Resetovat všechny počitadla mincí",
    RESET_COINS_COUNT_ALL:"Resetovat všechny počítadla žetonů",
    RESET_EUROKEY_COUNT_ALL:"Resetovat všechny počítadla Eurokey",
    FACILITY_DETAILS:"Podrobnosti o zařízení",
    FACILITY_NAME:"Název zařízení",
    FACILITY_UPLOAD_IMAGE_NOTIFICATION:"Úspěšně jste nahráli obrázek",
    FACILITY_UPDATE_DATA_NOTIFICATION:"Úspěšně jste aktualizovali data",
    CONNECTED:"Připojeno",
    DISCONNECTED:"Odpojeno",
    OFFLINE:"Offline",
    MESSAGES_FILTER:"Filtr zpráv",
    FACILITY:"Zařízení",
    APPLY:"Použít",
    TIME:"Čas",
    LOCATION:"Umístění",
    ACKNOWLEDGED:"Potvrzeno",
    FILTERED_MESSAGES:"Filtrované zprávy",
    ACK:"Potvrzeno",
    NOT_ACK:"Nepotvrzeno",
    ALL:"Vše ",
    ALL_FACILITIES:"Všechná zařízení",
    ENTER_DATE_PLACEHOLDER:"Vložit datum",
    OP_NESTANAK_NAPONA:"Chybějící napětí na indikátoru fáze 3A5",
    OP_OTB_PUMPA_GRESKA_MZS:"Jistič vysokotlakého čerpadal klesl",
    OP_UPR_NAPON_24VAC_GRE:"Chybí 24 VAC - jistič 5F1.1",
    OP_MIN_NIVO_PITKA_VODA:"Nádrž na čistou vodu je prázdná",
    OP_CRPKA_PITKE_VODE_GRE_MZS:"Síťový jištič čerpadla klesl",
    OP_MIN_NIVO_OMEKS_VODE:"Nádrž na změkčenou vodu je prázdná",
    OP_CRPKA_OMEKS_VODE_GRE_MZS:"Jistič čerpadla změkčené vody klesl",
    OP_MIN_NIVO_DEMIN_VODE:"Nádrž na osmózní vodu je prázdná",
    OP_CRPKA_DEMIN_VODE_GRE_MZS:"Jistič čerpadla osmózní vody klesl",
    OP_CRPKA_REV_OSMOZA_GRE_MZS:"Jistič čerpadla na výrobu osmózní vody klesl",
    OP_BOJLER_GRESKA_MZS:"Chyba ohřívače vody",
    OP_CRPKA_PRASKA_GRE_MZS:"Jistič čerpadla horké vody klesl",
    OP_DOZATOR_PRASKA_GRE_MZS:"Jistič motoru dávkovače prášku klesl",
    OP_VIBRATOR_PRASKA_GRE_MZS:"Jistič vibrátoru dávkovače prášku klesl",
    OP_MIN_PRASAK_TON_ALARM:"Nádoba na míchání prášku je prázdná",
    OP_USIS_KOV_TURBINA_GRESKA:"Jistič vaakuového vysavače na mince klesl",
    OP_FILTER_VODE_ZACEPLJEN:"Vodní filtr je zablokován",
    OP_VISKTL_RESET_SATI_RADA:"Servis vysokotlakého čerpadla",
    OPW_VISKTL_RESET_SATI_RADA:"Servis vysokotlakého čerpadla",
    OP_FILTER_DANI_RADA:"Porucha vodního filtru",
    OP_BOJLER_DANI_RADA:"Chyba ohřívače vody",
    OPW_ALARM_VISOKOTL_PUMPA:"Výstraha vysokotlakého čerpadla",
    OPW_ALARM_FILTER_SERVIS:"Výstraha servisu filtru",
    OPW_ALARM_BOJLER_SERVIS:"Výstraha servisu bojleru",
    HAS_MEMBERS:"Vybraná skupina má členy a nelze ji odstranit. Členové musí být nejprve smazáni.",
    PERIODIC_SUMMARY_FOR:"Periodické souhrnné hlášení za",
    PERIODIC_SUMMARY_REPORTS:"Periodické souhrnné zprávy",
    DATE_RANGE:"Časové období",
    FINANCIAL_REPORT:"Finanční zpráva",
    GROSS_INCOME:"Hrubý příjem",
    GROSS_INCOME_SUM:"Výše hrubého příjmu",
    COMMISSION_FEE:"Poplatek za zprostředkování",
    NET_INCOME:"Čistý příjem (pro fakturaci)",
    COMMISSION_FEE_DETAILS:"Poplatek zahrnuje bankovní / PayPal poplatky anebo provize poskytovatele SMS služeb.",
    LOYALTY_CREDITS_REPORT:"Mistní R2W výkaz o žetonech",
    LOYALTY_GIVEN:"Dané lokální R2E žetony",
    LOYALTY_USED:"Použité lokální R2W žetony",
    LOYALTY_SOLD:"Prodáno lokálních R2W žetonů",
    LOYALTY_TOTAL:"Celkem",
    LOYALTY_CURRENT_MONTH:"Aktuální měsíc",
    SOMETHING_WENT_WRONG:"Ooooops",
    MISSING_PAGE:"Promiňte. Tuto stránku jsme nenalezli",
    TRY_AGAIN:"Zkuste to znovu",
    DEFAULT_ERROR_NAME:"Došlo k neznámé chybě",
    DEFAULT_ERROR_DESCRIPTION:"Prosím, zkuste to znovu",
    MY_ACCOUNT_DETAILS:"Detaily mého účtu",
    SAVE_CHANGES:"Uložit změny",
    USERNAME:"Uživatelské jméno",
    FIRST_NAME:"Jméno",
    LAST_NAME:"Přímení",
    USER_ROLE:"Role uživatele",
    OLD_PASSWORD:"Staré heslo",
    NEW_PASSWORD:"Nové heslo",
    OLD_PASSWORD_REQUIRED:"Je vyžadováno staré heslo",
    NEW_PASSWORD_REQUIRED:"Je vyžadováno nové heslo",
    NEW_PASSWORD_REPEAT:"Je vyžadováno opakování nového hesla",
    NEW_PASSWORD_NOT_MATCH:"Staré a nové heslo neodpovídají",
    PASSWORD_DIFFERENT_VALIDATION:"Nové heslo musí být jiné než staré",
    PASSWORD_MIN_CHAR:"Vaše heslo musí mít délku alespoň 8 znaků",
    PASSWORD_MAX_CHAR:"Vaše heslo musí mít délku maximálně 32 znaků",
    PASSWORD_PATTERN_VALIDATION:"Heslo musí obsahovat alespoň jedno číslo",
    ACCOUNT_MANAGEMENT:"Správce účtu",
    NOT_ACTIVE:"Neaktivní",
    ASSIGN_ROLE:"Přiřaďte roli",
    UPDATE:"Aktualizace",
    ADD_NEW_ACCOUNT:"Přidat nový účet",
    EMAIL_REQUIRED:"Je vyžadována e-mailová adresa",
    EMAIL_NOT_VALID:"E-mailová adresa není platná",
    ADD_NEW_USER_TEXT:"E-mail s aktivačním odkazem bude odeslán na poskytnutou e-mailovou adresu.",
    UPDATE_USER_NOTIFICATION:"Úspěšně jste aktualizovali své informace",
    CHANGED_PASSWORD_NOTIFICATION:"Úspěšně jste změnili heslo",
    UPDATE_USER_GROUP_NOTIFICATION:"Úspěšně jste aktualizovali název skupiny uživatelů",
    CREATE_USER_GROUP_NOTIFICATION:"Úspěšně jste vytvořili skupinu",
    DETELE_USER_GROUP_NOTIFICATION:"Úspěšně jste smazali skupinu",
    EMPTY_GROUP_LIST_MSG:"Neexistují žádné vytvořené skupiny. Začněte tím, že vytvoříte jednu",
    DELETE_USER_FROM_GROUP_NOTIFICATION:"Úspěšně jste smazali uživatele ze skupiny",
    ADD_USER_TO_GROUP_NOTIFICATION:"Úspěšně jste přidali uživatele do skupiny",
    ADD_USER_NOTIFICATION:"Úspěšně jste přidali nového uživatele",
    DELETE_USER_NOTIFICATION:"Úspěšně jste smazali uživatele",
    RESEND_USER_VERIFICATION_EMAIL:"Úspěšně jste znovu odeslali ověřovací e-mail",
    ENTER_USER_GROUP_NAME_TO_CONTINUE:"Chcete-li vytvořit skupinu uživatelů",
    DELETE_USER:"Odstranit uživatele",
    DELETE_USER_FROM_USER_GROUP_QUESTION:"Opravdu chcete smazat uživatele ze skupiny uživatelů?",
    CAMPAIGN_DEFAULT_SMS_MESSAGE:"Vážený uživateli R2W",
    CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE:"Věrnostní pravidlo podle počtu návštěv",
    CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE:"Věrnostní pravidlo pro množství vynakládaných žetonů",
    CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE:"Věrnostní pravidlo za den v týdnu",
    REMOVE_CAMPAIGN_RULE_TITLE:"Odstranění pravidla kampaně",
    REMOVE_CAMPAIGN_RULE_CONFIRMATION:"Opravdu chcete zrušit pravidlo kampaně?",
    LOYALTY_CREATE_CAMPAIGN_NOTIFICATION:"Úspěšně jste vytvořili novou kampaň",
    LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION:"Úspěšně jste aktivovali kampaň",
    LOYALTY_EMPTY_LIST_NOTIFICATION:"Neexistují žádné vytvořené kampaně. Začněte tím, že vytvoříte jednu",
    LOYALTY_SENT_MESSAGE_NOTIFICATION:"Úspěšně jste odeslali zprávu",
    COMPANY_ACCOUNTS:"Firemní účty",
    BUSSINESS_INVOICES_LIST:"My B2B faktury",
    LOCALE_TOKEN:"Místní token",
    R2W:"Globální token",
    START_MONTH:"Počáteční měsíc",
    END_MONTH:"Měsíc konce",
    TOKEN_TYPE:"Typ tokenu",
    TOKEN_NUMBER:"Číslo tokenu",
    NOTHING_TO_DISPLAY:"* Nic k zobrazení",
    CREATE_INVOICE:"Vytvoření faktury",
    INVOICE:"Faktura",
    INVOICES:"Faktury",
    EDIT_INVOICE:"Upravit fakturu",
    UPDATE_INVOICE_NOTIFICATION:"Úspěšně jste aktualizovali fakturu do stavu čekajícího",
    CURRENT_CHARGES:"Poplatky za běžné období",
    PAYMENTS_ON_HOLD:"Rozpracované faktury",
    FOR_INVOICING:"Pro fakturaci",
    CANCEL_INVOICING_NOTIFICATION_HEADER:"Chystáte se zrušit fakturu",
    CANCEL_INVOICING_NOTIFICATION_TEXT:"Opravdu chcete tuto fakturu zrušit?",
    INVOICING_NOTIFICATION_HEADER:"Chystáte se fakturovat",
    INVOICING_NOTIFICATION_TEXT:"Opravdu chcete zaslat fakturu?",
    SENT_INVOICE_NOTIFICATION:"Úspěšně jste zaslali fakturu",
    CANCELED_INVOICE_NOTIFICATION:"Úspěšně jste zrušili fakturu",
    INVOICE_DESCRIPTION_TEXT:"Faktura za",
    INVOICE_STATE:"Stav fakturace",
    INVOICE_NUMBER:"Číslo faktury",
    INVOICE_TOTAL:"Celkem",
    SELECT_YEAR:"Vybrat rok",
    DOWNLOAD:"Stáhnout PDF",
    INVOICE_NUMBER_HEADER:"Chystáte se odeslat fakturu s číslem",
    INVOICE_PAYMENT_CONFIRMATION:"Chystáte se potvrdit platbu",
    INSERT_INVOICE_NUMBER:"Vložte číslo faktury",
    INVOICED_WARNING:"E-mail nebyl odeslán. Prosím, čekejte ...",
    SEND_INVOICE:"Poslat",
    INVOICE_ALL:"Vše",
    INVOICE_FROM_R2W:"Od R2W",
    INVOICE_TO_R2W:"Do R2W",
    PAYMENT_REQUEST:"Výzva k úhradě",
    PAYMENT_REQUEST_STATE:"Stav žádosti o platbu",
    PAYMENT_REQUEST_NUMBER:"Číslo žádosti o platbu",
    FOR_PAYMENT_REQUEST:"Pro žádost o platbu",
    PAYMENT_REQUEST_ON_HOLD:"Žádost o platbu při zpracování",
    DOWNLOAD_INVOICE:"Stažení faktury",
    CLICK_FOR_DOWNLOAD_OPTIONS:"Klepněte pro možnosti stahování",
    B2B_SPEC:"B2B Specifikace",
    B2C_SPEC:"B2C Specifikace",
    DOWNLOAD_PAYMENT_REQUEST:"Stáhnout žádost o platbu",
    LOYALTY_PREVIEW:"Náhled do věrnostního programu",
    ACTIVATED:"Aktivováno",
    RUNNING:"Běžící",
    NOT_ACTIVATED:"Neaktivní",
    FINISHED:"Ukončeno",
    DEPRECATED:"Zastaralé",
    UPCOMING:"Nadcházející",
    NONE:"Žádný",
    STARTED:"zahájena",
    ENDS:"Končí",
    DEDICATED:"Věnované",
    ACTIVATE_CAMPAIGN_CONFIRMATION_MSG:"Chystáte se aktivovat",
    CAMPAIGN:"kampaň",
    SEND_MESSAGE_NOTIFICATION:"Chystáte se odeslat zprávu vybraným skupinám uživatelů",
    DIVISIBLE_TO_NUMBER:"Číslo by mělo být dělitelné ",
    BRIDGE_PLC:"Bridge - PLC",
    DEVICE_TYPE:"Typ zařízení",
    LISTENER:"Malé stroje",
    BRIDGE:"Mycí boxy",
    WASH_BOXES:"Mycí boxy",
    VACUUMS:"Vysavače",
    SAVE_NEWS:"Uložit zprávy",
    CREATE_NEW_NEWS:"Vytvořte nové zprávy",
    HISTORY_OF_ALL_NEWS:"Historie všech zpráv",
    TYPE_FACILITY_NAME_PLACEHOLDER:"Zadejte název zařízení",
    ADD_ANOTHER_FACILITY_PLACEHOLDER:"Přidat další zařízení",
    NEWS_TEXT:"Text zprávy",
    NEWS_TITLE:"Název zprávy",
    DELETE_NEWS_CONFIRMATION:"Chystáte se smazat zprávy",
    NEWS_DELETE_NOTIFICATION:"Úspěšně jste smazali zprávy",
    NEWS_SAVE_NOTIFICATION:"Úspěšně jste uložili zprávy",
    NEWS_CREATION_DATE:"Datum vzniku",
    NO_TITLE:"Bez názvu",
    NEWS_TEXT_MAX_CHAR_VALIDATION:"Text zprávy musí obsahovat méně než 255 znaků",
    NEWS_TEXT_REQUIRED_VALIDATION:"Text zprávy je vyžadován",
    NEWS_TITLE_REQUIRED_VALIDATION:"Je vyžadován název zprávy",
    DEACTIVATE:"Deaktivujte",
    ASIDE_MENU_LOCAL_TOKENS:"Lokální žetony",
    CREATE_NEW_LOCAL_TOKENS:"Vydat nové lokální žetony?",
    ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER:"Zadejte e-mailovou adresu zákazníka a množství místních žetonů, které chcete vystavit zákazníkovi",
    CREATE_TOKENS:"Vydání žetonů",
    MINIMUM_ONE_TOKEN:"Hodnota musí být větší než 0",
    CUSTOMER_EMAIL:"Zákaznický e-mail",
    AMOUNT_OF_TOKENS:"Množství žetonů",
    ISSUING_LOCAL_TOKENS_SUCCESS:"Úspěšné vydání místních žetonů",
    PROBLEM_ISSUING_LOCAL_TOKENS:"Při vydávání místních žetonů došlo k chybě. Zkontrolujte prosím e-mailovou adresu zákazníka a zkuste to znovu.",
    HISTORY_OF_ISSUED_LOCAL_TOKENS:"Přehled vydaných místních žetonů",
    ISSUED_AT:"Vydáno v",
    ISSUED_BY:"Vydáno",
    CODE:"Použít kód",
    REDEEMED_BY:"Vykoupeno",
    REDEEMED_AT:"Vykoupeno u",
    ASIDE_MENU_VOUCHERS:"Poukazy",
    PRINT:"Tisk",
    VOUCHERS_OVERVIEW:"Přehled poukazů",
    CREATE_NEW_VOUCHERS:"Vytvořte nové poukazy",
    CREATE_NEW_VOUCHERS_DESCRIPTION:"Vytvořte novou sadu poukazů zadáním množství žetonů na jednom poukaze",
    AMOUNT_OF_TOKENS_PER_VOUCHER:"Množství žetonů na jeden poukaz",
    VALIDATION_MIN_MAX_NEW_VOUCHERS_TOKENS:"Můžete přiřadit 1 až 100 žetonů na poukaz",
    NUMBER_OF_NEW_VOUCHERS:"Počet poukazů, který mají být vytvořeny",
    VALIDATION_MIN_MAX_NEW_VOUCHERS:"Můžete si vytvořit jednen až {{size}} poukazů v jedné dávce",
    NEW_VOUCHERS_PREFIX:"Předpony kódů nové série poukazů",
    VALIDATION_VOUCHER_PREFIX:"Předpona kódu musí mít přesně 4 znaky (velká písmena a / nebo čísla)",
    PROBLEM_CREATING_NEW_VOUCHERS:"Při vytváření nových poukazů došlo k problému. Zkuste to prosím znovu nebo kontaktujte naši podporu.",
    CREATE_VOUCHERS:"Vytvořte poukazy",
    CREATING_VOUCHERS_SUCCESS:"Nové vouchery byly úspěšně vytvořeny",
    PRINT_NEW_VOUCHERS:"Tisk poukazů",
    PRINT_NEW_VOUCHERS_DESCRIPTION:"Zadejte předponu kódu série poukazů, abyste vytiskli celou sérii poukazů. Alternativně",
    PRINT_VOUCHERS_PREFIX:"Předvolba kódu série poukazů",
    NO_VOUCHERS_FOR_PRINT:"Nebyly nalezeny žádné poukazy odpovídající dané předponě kódu pro tisk",
    PRINT_VOUCHERS:"Tisknout poukaz(y)",
    VALIDATION_VOUCHER_CODE_FILTER:"Výsledek hledání voucheru musí obsahovat velká písmena a čísla",
    FILTER_VOUCHERS_BY_CODE:"Vyhledat poukazy pomocí kódu vykoupení",
    FILTER_VOUCHERS:"Vyhledat poukaz",
    WASH_BOX:"Mycí box",
    DAILY_FINANCES_TOTAL_LOCAL_TOKENS:"Celkově použité digitální tokeny",
    TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY:"Celkem nakoupené lokální žetony za den",
    TOTAL_SPENT_LOCAL_TOKENS_PER_DAY:"Celkem utracené lokální žetony za den",
    TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY:"Celkem vydané lokální žetony za den",
    LOCAL_TOKEN:"Lokální žetony",
    GIVEN_TOKEN:"Vydané lokální žetony",
    SOLD_TOKEN:"Prodané lokální žetony",
    SMALL_MACHINES:"Malé stroje",
    R2W_Listener:"Listener",
    HHANLE_DEVICE:" HHanle wash box",
    CODE_PREFIX_EXIST:"Předpony kódu již existují",
    CODE_PREFIX_EXIST_TEXT:"Nelze vytvořit nový voucher s touto předponou kódu. Nastavte prosím jinou.",
    MIN_FOUR_VALIDATION:"Přesně 4 znaky",
    ALL_INFORMATION_1:"Všechny informace o",
    ALL_INFORMATION_2:"bude ztraceno",
    ASIDE_MENU_TRANSACTIONS:"Transakce",
    EXPENSES:"Výdaje",
    TOPUPS:"Zakoupené žetony",
    EXPENSES_LIST:"Seznam výdajů",
    USER_EMAIL:"Uživatelský e-mail",
    COMPANY_NAME:"Jméno společnosti",
    TOPUPS_LIST:"Seznam zakoupených symbolů",
    CONSUMER:"Consumer",
    SYSTEM_ADMIN:"System administrator",
    MERCHANT_ADMIN:"Merchant administrator",
    COMPANY_ADMIN:"Company administrator",
    FACILITY_ADMIN:"Facility administator",
    SUBSCRIBER:"Subscriber",
    CONFIGURATOR:"Configurator",
    SETUP_UNIT_SERIAL_NO:"Sériové číslo",
    SETUP_UNIT_MATERIAL_NO:"Číslo materiálu",
    SETUP_UNIT_WEBAPI_VERSION:"Verze WebApi",
    TOTAL_TURNOVER:"Obrat mycího zařízení",
    AVAILABILITY_ALL:"Dostupnost",
    AVAILIBILITY:"Dostupnost mycích boxů:",
    AVAILABILITY_VACUUMS:"Dostupnost vysavačů:",
    WASH_BOX_INFO:"Informace o mycích boxech",
    VACUUM_CLEANER_INFO:"Informace o vysavačích",
    BREAD_CRUMBS_SERVICE:"Servis",
    HOLIDAYS:"Prázdniny",
    HOLIDAY:"Dovolená",
    LIGHTS_ON:"Svetla zapnuo",
    LIGHTS_OFF:"Světla vypnuto",
    WASH_BOXES_ON:"Mycí box zapnuto",
    WASH_BOXES_OFF:"Mycí box vypnuto",
    VACUUMS_ON:"Vysasvač zapnuto",
    VACUUMS_OFF:"Vysavač vypnuto",
    TURNOVER:" Obrat",
    TURNOVER_MANUAL_WASH_UNIT:"Manuál obratu",
    STATUS_BAY_RUN_TIME:"Celková doba práce mycího boxu",
    STATUS_BAY_PROGRAM_NAME:"Název programu",
    STATUS_BAY_CREDIT:"Kredit na mycí box",
    CLOUD_KREDIT:"Cloudový kredit",
    STATUS_VACUUM_RUN_TIME:"Celková doba práce vysavače",
    SHOW_SERVICE_AND_PROGRAM_INFO:"Služby zařízení, program mycího boxu a aktuální informace o poruchách",
    UNAVAILABLE:"Jednotka není k dispozici",
    SHOW_HIDE_TABLE:"Zobrazit/skrýt tabulku pracovní doby",
    PROGRAM_NAME:"Název programu",
    PROGRAM_COUNTER:"Počítadlo programu",
    NO_NAME:"Odkaz nemá jméno",
    COUNTER_SERVICE_DATA:"Servisní informace",
    NEED_SERVICE:"Nutný servis",
    PROGRAM_DATA:"Data programu mycího boxu",
    CURRENT_FAULT_DATA:"Aktuální údaje o závadě",
    REFERENCE_DUE:"Z důvodu",
    REFERENCE_SECONDS:"Vtreřiny",
    REFERENCE_NAME:"Název dílu",
    WASHBOX_NAME:"Název micího boxu",
    FAULT_NAME:"Název poruchy",
    FAULT_NUMBER:"Číslo poruchy",
    CURRENT_FAULT_COUNT:"Aktivní poruchy",
    DEVICE_NOT_INSTALLED:"Zařízení není instalováno",
    STATUS_READY:"Stav připraven",
    STATUS_ERROR:"Chybový stav",
    CONNECTION_ERROR:"offline",
    UNKNOWN_RESET:"Chyba softwaru",
    SOFTWARE_RESET:"Chyba softwaru",
    EXTERNAL_PIN_RESET:"Chyba softwaru",
    RESTART_OR_BROWNOUT_OCCURRED:"Chyba softwaru",
    DEAD_RM5_CHANNEL_PIN_ERROR:"Chyba hardwaru",
    COULD_NOT_SIMULATE_COIN:"Chyba hardwaru",
    ERROR_SETTING_INHIBIT_MODE:"Chyba hardwaru",
    OFFLINE_DEVICE:" Offline myčka",
    TARIFFS:"Tarify",
    DAY:"Den",
    NIGHT:"Noc",
    VOUCHER_CODE:"Kód poukazu",
    DISMISS_ALARM:"Resetovat alarm?",
    ALARM_ACTIVE:"Aktivní alarmy",
    NO_ALARM_ACTIVE:"Nejsou žádné aktivní alarmy",
    ALARM_HISTORY:"Historie upozornění",
    MANAGING_TOKENS:"Správa žetonů",
    EXPIRATION_DATE:"Datum spotřeby",
    EXTEND_TOKEN_DATE:"Prodloužit datum vypršení platnosti tokenu pro",
    DELETE_TOKENS_FOR:" Delete tokens for",
    PUMP_TYPE:"Typ čerpadla",
    TURN_OFF_DEVICE:"Stav zařízení",
    OPERATION_DATA:"Provozní údaje",
    PUMP_DATA:"Údaje čerpadla",
    PUMP_NAME:"Název čerpadla",
    POINT_NAME:"Název bodu",
    CHANGER_INCOME:"Celkový příjem měniče podle data",
    SELECTED_OPEN:"Otevřeno ve vybranou pracovní dobu",
    ALWAYS_OPEN:"Vždy otevřeno (24/7)",
    CLOSED:"Zavřeno",
    CLOSED_24:"Zavřeno 24h",
    OPENED_24:"Otevřeno 24h",
    MON:"Pondělí",
    TUE:"Úterý",
    WED:"Středa",
    THU:"Čtvrtek",
    FRI:"Pátek",
    SAT:"Sobota",
    SUN:"Neděle",
    PRICING:"Ceny",
    PRICE:"Cena",
    VALIDITY:"Platnost",
    TOKEN_PACKAGES:"balíčky žetonů",
    SINGLE_WASH:"Jednorázové mytí",
    FACILITY_WORKING_HOURS:"Nastavte pracovní dobu pro vybrané zařízení",
    WORKING_HOURS_ALWAYS_OPEN:"Vždy otevřeno",
    WORKING_HOURS_ALWAYS_CLOSE:"Uzavřeno provozovatelem",
    WORKING_HOURS_CUSTOM:"Nastavte pracovní dobu",
    KARCHER_ERROR_CODE:"Varovný chybový kód",
    KARCHER_ERROR_MESSAGE_1:"Elektrické zásuvky jsou přetížené",
    KARCHER_ERROR_MESSAGE_2:"Separátor oleje se musí vyprázdnit",
    KARCHER_ERROR_MESSAGE_4:"Vadný snímač stmívání",
    KARCHER_ERROR_MESSAGE_5:"Byl spuštěn ochranný spínač motoru na vysokotlakých čerpadlech",
    KARCHER_ERROR_MESSAGE_6:"Vadné připojení k RDS",
    KARCHER_ERROR_MESSAGE_7:"Tlakový spínač pro vzduch na kompresoru nehlásí žádný",
    KARCHER_ERROR_MESSAGE_8:"Příčina: žádné spojení s elektronikou 'MSWS'.",
    KARCHER_ERROR_MESSAGE_10:"Žádné připojení k elektronice čerpadla na mycí stanici 1",
    KARCHER_ERROR_MESSAGE_11:"Elektronické zásuvky na mycí stanici 1 jsou přetížené",
    KARCHER_ERROR_MESSAGE_12:"Příliš vysoký proud vysokotlakého čerpadla na mycí stanici 1",
    KARCHER_ERROR_MESSAGE_13:"Přílišnízký proud vysokotlakého čerpadla na mycí stanici 1",
    KARCHER_ERROR_MESSAGE_14:"Zaseknutý kontakt vysokotlakého čerpadla na mycí stanici 1",
    KARCHER_ERROR_MESSAGE_15:"Polozátěžový ventil na mycí stanici 1 vadný",
    KARCHER_ERROR_MESSAGE_16:"Coiling protection contact of high pressure pump washing station 1",
    KARCHER_ERROR_MESSAGE_17:"Oil level of high pressure pump at washing station 1 too low",
    KARCHER_ERROR_MESSAGE_18:"Electronics at washing station 1 defective",
    KARCHER_ERROR_MESSAGE_19:"Motor circuit breaker high pressure pump washing station 1 has tripped",
    KARCHER_ERROR_MESSAGE_20:"No connection to remote control electronics at washing station 1",
    KARCHER_ERROR_MESSAGE_21:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_22:"Fault at coin acceptor at washing station 1",
    KARCHER_ERROR_MESSAGE_30:"No connection to pump electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_31:"Electronic outlets at washing station 2 overloaded",
    KARCHER_ERROR_MESSAGE_32:"Current pickup of high pressure pump at washing station 2 too high",
    KARCHER_ERROR_MESSAGE_33:"Current pickup of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_34:"Contact of high pressure pump at washing station 2 stuck",
    KARCHER_ERROR_MESSAGE_35:"Semiload valve at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_36:"Coiling protection contact of high pressure pump washing station 2",
    KARCHER_ERROR_MESSAGE_37:"Oil level of high pressure pump at washing station 2 too low",
    KARCHER_ERROR_MESSAGE_38:"Electronics at washing station 2 defective",
    KARCHER_ERROR_MESSAGE_39:"Motor circuit breaker high pressure pump washing station 2 has tripped",
    KARCHER_ERROR_MESSAGE_40:"No connection to remote control electronics at washing station 2",
    KARCHER_ERROR_MESSAGE_41:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_42:"Fault at coin acceptor at washing station 2",
    KARCHER_ERROR_MESSAGE_50:"No connection to pump electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_51:"Electronic outlets at washing station 3 overloaded",
    KARCHER_ERROR_MESSAGE_52:"Current pickup of high pressure pump at washing station 3 too high",
    KARCHER_ERROR_MESSAGE_53:"Current pickup of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_54:"Contact of high pressure pump at washing station 3 stuck",
    KARCHER_ERROR_MESSAGE_55:"Semiload valve at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_56:"Coiling protection contact of high pressure pump washing station 3",
    KARCHER_ERROR_MESSAGE_57:"Oil level of high pressure pump at washing station 3 too low",
    KARCHER_ERROR_MESSAGE_58:"Electronics at washing station 3 defective",
    KARCHER_ERROR_MESSAGE_59:"Motor circuit breaker high pressure pump washing station 3 has tripped",
    KARCHER_ERROR_MESSAGE_60:"No connection to remote control electronics at washing station 3",
    KARCHER_ERROR_MESSAGE_61:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_62:"Fault at coin acceptor at washing station 3",
    KARCHER_ERROR_MESSAGE_70:"No connection to pump electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_71:"Electronic outlets at washing station 4 overloaded",
    KARCHER_ERROR_MESSAGE_72:"Current pickup of high pressure pump at washing station 4 too high",
    KARCHER_ERROR_MESSAGE_73:"Current pickup of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_74:"Contact of high pressure pump at washing station 4 stuck",
    KARCHER_ERROR_MESSAGE_75:"Semiload valve at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_76:"Coiling protection contact of high pressure pump washing station 4",
    KARCHER_ERROR_MESSAGE_77:"Oil level of high pressure pump at washing station 4 too low",
    KARCHER_ERROR_MESSAGE_78:"Electronics at washing station 4 defective",
    KARCHER_ERROR_MESSAGE_79:"Motor circuit breaker high pressure pump washing station 4 has tripped",
    KARCHER_ERROR_MESSAGE_80:"No connection to remote control electronics at washing station 4",
    KARCHER_ERROR_MESSAGE_81:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_82:"Fault at coin acceptor at washing station 4",
    KARCHER_ERROR_MESSAGE_90:"No connection to pump electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_91:"Electronic outlets at washing station 5 overloaded",
    KARCHER_ERROR_MESSAGE_92:"Current pickup of high pressure pump at washing station 5 too high",
    KARCHER_ERROR_MESSAGE_93:"Current pickup of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_94:"Contact of high pressure pump at washing station 5 stuck",
    KARCHER_ERROR_MESSAGE_95:"Semiload valve at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_96:"Coiling protection contact of high pressure pump washing station 5",
    KARCHER_ERROR_MESSAGE_97:"Oil level of high pressure pump at washing station 5 too low",
    KARCHER_ERROR_MESSAGE_98:"Electronics at washing station 5 defective",
    KARCHER_ERROR_MESSAGE_99:"Motor circuit breaker high pressure pump washing station 5 has tripped",
    KARCHER_ERROR_MESSAGE_100:"No connection to remote control electronics at washing station 5",
    KARCHER_ERROR_MESSAGE_101:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_102:"Fault at coin acceptor at washing station 5",
    KARCHER_ERROR_MESSAGE_110:"No connection to pump electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_111:"Electronic outlets at washing station 6 overloaded",
    KARCHER_ERROR_MESSAGE_112:"Current pickup of high pressure pump at washing station 6 too high",
    KARCHER_ERROR_MESSAGE_113:"Current pickup of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_114:"Contact of high pressure pump at washing station 6 stuck",
    KARCHER_ERROR_MESSAGE_115:"Semiload valve at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_116:"Coiling protection contact of high pressure pump washing station 6",
    KARCHER_ERROR_MESSAGE_117:"Oil level of high pressure pump at washing station 6 too low",
    KARCHER_ERROR_MESSAGE_118:"Electronics at washing station 6 defective",
    KARCHER_ERROR_MESSAGE_119:"Motor circuit breaker high pressure pump washing station 6 has tripped",
    KARCHER_ERROR_MESSAGE_120:"No connection to remote control electronics at washing station 6",
    KARCHER_ERROR_MESSAGE_121:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_122:"Fault at coin acceptor at washing station 6",
    KARCHER_ERROR_MESSAGE_130:"No connection to pump electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_131:"Electronic outlets at washing station 7 overloaded",
    KARCHER_ERROR_MESSAGE_132:"Current pickup of high pressure pump at washing station 7 too high",
    KARCHER_ERROR_MESSAGE_133:"Current pickup of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_134:"Contact of high pressure pump at washing station 7 stuck",
    KARCHER_ERROR_MESSAGE_135:"Semiload valve at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_136:"Coiling protection contact of high pressure pump washing station 7",
    KARCHER_ERROR_MESSAGE_137:"Oil level of high pressure pump at washing station 7 too low",
    KARCHER_ERROR_MESSAGE_138:"Electronics at washing station 7 defective",
    KARCHER_ERROR_MESSAGE_139:"Motor circuit breaker high pressure pump washing station 7 has tripped",
    KARCHER_ERROR_MESSAGE_140:"No connection to remote control electronics at washing station 7",
    KARCHER_ERROR_MESSAGE_141:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_142:"Fault at coin acceptor at washing station 7",
    KARCHER_ERROR_MESSAGE_150:"No connection to pump electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_151:"Electronic outlets at washing station 8 overloaded",
    KARCHER_ERROR_MESSAGE_152:"Current pickup of high pressure pump at washing station 8 too high",
    KARCHER_ERROR_MESSAGE_153:"Current pickup of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_154:"Contact of high pressure pump at washing station 8 stuck",
    KARCHER_ERROR_MESSAGE_155:"Semiload valve at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_156:"Coiling protection contact of high pressure pump washing station 8",
    KARCHER_ERROR_MESSAGE_157:"Oil level of high pressure pump at washing station 8 too low",
    KARCHER_ERROR_MESSAGE_158:"Electronics at washing station 8 defective",
    KARCHER_ERROR_MESSAGE_159:"Motor circuit breaker high pressure pump washing station 8 has tripped",
    KARCHER_ERROR_MESSAGE_160:"No connection to remote control electronics at washing station 8",
    KARCHER_ERROR_MESSAGE_161:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_162:"Fault at coin acceptor at washing station 8",
    KARCHER_ERROR_MESSAGE_170:"No connection to electronics A2",
    KARCHER_ERROR_MESSAGE_171:"Outputs of the electronics A2 overloaded",
    KARCHER_ERROR_MESSAGE_172:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_173:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_174:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_175:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_176:"Detergent container is empty",
    KARCHER_ERROR_MESSAGE_177:"Current pickup of pump undercarriage wash too high",
    KARCHER_ERROR_MESSAGE_178:"No pressure after switching on the underbody wash",
    KARCHER_ERROR_MESSAGE_190:"No connection to electronics A3",
    KARCHER_ERROR_MESSAGE_191:"Outputs of the electronics A3 overloaded",
    KARCHER_ERROR_MESSAGE_200:"No connection between control and electronics of the WSO",
    KARCHER_ERROR_MESSAGE_201:"Outputs of the control to the WSO overloaded",
    KARCHER_ERROR_MESSAGE_202:"Hardness sensor shows hard water after regeneration",
    KARCHER_ERROR_MESSAGE_204:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_210:"Level sensor BUFFER TANK EMPTY activated",
    KARCHER_ERROR_MESSAGE_211:"Level sensor BUFFER CONTAINER EMPTY and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_212:"Level sensor RO PUMP ON and BUFFER CONTAINER FULL switch simultaneously",
    KARCHER_ERROR_MESSAGE_213:"No water pressure",
    KARCHER_ERROR_MESSAGE_214:"Site-supplied water preparation reports fault",
    KARCHER_ERROR_MESSAGE_220:"Water shortage",
    KARCHER_ERROR_MESSAGE_221:"Exhaust temperature is too high",
    KARCHER_ERROR_MESSAGE_222:"Current pickup of circulation pump for warm water too high",
    KARCHER_ERROR_MESSAGE_223:"Burner fault",
    KARCHER_ERROR_MESSAGE_224:"Safety thermostat of the burner has got triggered",
    KARCHER_ERROR_MESSAGE_225:"Burner delay active",
    KARCHER_ERROR_MESSAGE_226:"Flow indicator did not open within 5 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_227:"Flow indicator did not close within 3 seconds after the circulation pump for warm water was turned off",
    KARCHER_ERROR_MESSAGE_228:"Hot water outlet cools off too slowly after the burner is turned off",
    KARCHER_ERROR_MESSAGE_229:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_230:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_231:"Fault temperature sensor warm water",
    KARCHER_ERROR_MESSAGE_232:"Fault in burner outlet temperature sensor",
    KARCHER_ERROR_MESSAGE_233:"Water temperature with external supply with warm water hotter than 60°C",
    KARCHER_ERROR_MESSAGE_234:"Anti-legionella program fault",
    KARCHER_ERROR_MESSAGE_235:"Anti-legionella warm water temperature not reached",
    KARCHER_ERROR_MESSAGE_240:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_241:"Failure exterior temperature sensor",
    KARCHER_ERROR_MESSAGE_242:"Current pickup of circulation pump for anti frost protection too high",
    KARCHER_ERROR_MESSAGE_243:"Current pickup of circulation pump for wash station heater too high",
    KARCHER_ERROR_MESSAGE_244:"Warm water temperature too low, washing station heater was turned off",
    KARCHER_ERROR_MESSAGE_245:"Current consumption of foam hose heater for the foam too high",
    KARCHER_ERROR_MESSAGE_247:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_248:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_250:"Current pickup of pump for special washing programme too high",
    KARCHER_ERROR_MESSAGE_255:"Failure in the electronics",
    KARCHER_ERROR_MESSAGE_260:"No connection to electronics A5",
    KARCHER_ERROR_MESSAGE_261:"Outputs of the electronics A5 overloaded",
    KARCHER_ERROR_MESSAGE_280:"No connection to electronics A6",
    KARCHER_ERROR_MESSAGE_281:"Outputs of the electronics A6 overloaded",
    KARCHER_ERROR_MESSAGE_282:"Current consumption of pump for rim cleaner too high",
    KARCHER_ERROR_MESSAGE_283:"Current consumption of pump for rim cleaner too low",
    KARCHER_ERROR_MESSAGE_284:"Contactor of pump for rim cleaner is jammed",
    KARCHER_ERROR_MESSAGE_300:"No connection to electronics A7",
    KARCHER_ERROR_MESSAGE_301:"Outputs of the electronics A7 overloaded",
    KARCHER_ERROR_MESSAGE_320:"No connection to electronics A8",
    KARCHER_ERROR_MESSAGE_321:"Outputs of the electronics A8 overloaded",
    KARCHER_ERROR_MESSAGE_322:"Current consumption of pump for micro-emulsion too high",
    KARCHER_ERROR_MESSAGE_323:"Current consumption of pump for micro-emulsion too low",
    KARCHER_ERROR_MESSAGE_324:"Contactor of pump for micro-emulsion is jammed",
    KARCHER_ERROR_MESSAGE_340:"No connection to electronics A9",
    KARCHER_ERROR_MESSAGE_341:"Outputs of the electronics A9 overloaded",
    KARCHER_ERROR_MESSAGE_342:"Current consumption of pump for intensive cleaning too high",
    KARCHER_ERROR_MESSAGE_343:"Current consumption of pump for intensive cleaning too low",
    KARCHER_ERROR_MESSAGE_344:"Contactor of pump for intensive cleaning is jammed",
    KARCHER_ERROR_MESSAGE_400:"Warm water no pressure",
    KARCHER_ERROR_MESSAGE_401:"Fresh water no pressure",
    KARCHER_ERROR_MESSAGE_402:"Permeate no pressure",
    KARCHER_ERROR_MESSAGE_403:"4. type of water no pressure",
    KARCHER_ERROR_MESSAGE_404:"4. Type of water, temperature over 60 °C or external disturbance",
    KARCHER_ERROR_MESSAGE_405:"Frost protection no pressure",
    KARCHER_ERROR_MESSAGE_406:"Pressure in the frost protection despite switched off anti-freeze pump",
    KARCHER_ERROR_MESSAGE_410:"Error F 400 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_411:"Error F 401 has been active for 300 seconds",
    KARCHER_ERROR_MESSAGE_412:"Error F 402 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_413:"Error F 403 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_414:"Error F 405 occured 4 times within 24 hours",
    KARCHER_ERROR_MESSAGE_420:"Fault token changer 1",
    KARCHER_ERROR_MESSAGE_421:"Fault token changer 2",
    KARCHER_ERROR_MESSAGE_440:"No connection to the electronics A31",
    KARCHER_ERROR_MESSAGE_441:"Outputs of the electronics A31 overloaded",
    KARCHER_ERROR_MESSAGE_500:"Connection of vacuum cleaner electronics 1/2",
    KARCHER_ERROR_MESSAGE_501:"Start button of vacuum cleaner 1 permanent contact",
    KARCHER_ERROR_MESSAGE_502:"Start button of vacuum cleaner 2 permanent contact",
    KARCHER_ERROR_MESSAGE_510:"Connection of vacuum cleaner electronics 3/4",
    KARCHER_ERROR_MESSAGE_511:"Start button of vacuum cleaner 3 permanent contact",
    KARCHER_ERROR_MESSAGE_512:"Start button of vacuum cleaner 4 permanent contact",
    KARCHER_ERROR_MESSAGE_520:"Connection of vacuum cleaner electronics 5/6",
    KARCHER_ERROR_MESSAGE_521:"Start button of vacuum cleaner 5 permanent contact",
    KARCHER_ERROR_MESSAGE_522:"Start button of vacuum cleaner 6 permanent contact",
    KARCHER_ERROR_MESSAGE_530:"Connection of vacuum cleaner electronics 7/8",
    KARCHER_ERROR_MESSAGE_531:"Start button of vacuum cleaner 7 permanent contact",
    KARCHER_ERROR_MESSAGE_532:"Start button of vacuum cleaner 8 permanent contact",
    KARCHER_ERROR_MESSAGE_540:"Connection of vacuum cleaner electronics 9/10",
    KARCHER_ERROR_MESSAGE_541:"Start button of vacuum cleaner 9 permanent contact",
    KARCHER_ERROR_MESSAGE_542:"Start button of vacuum cleaner 10 permanent contact",
    KARCHER_ERROR_MESSAGE_550:"Connection of vacuum cleaner electronics 10/11",
    KARCHER_ERROR_MESSAGE_551:"Start button of vacuum cleaner 11 permanent contact",
    KARCHER_ERROR_MESSAGE_552:"Start button of vacuum cleaner 12 permanent contact",
    KARCHER_ERROR_MESSAGE_800:"No connection to the electronics A30",
    KARCHER_ERROR_MESSAGE_801:"Outputs of the electronics A30 overloaded",
    KARCHER_ERROR_MESSAGE_802:"Fault in softening plant",
    KARCHER_ERROR_MESSAGE_803:"Protective motor switch prepressure pump RO tripped",
    KARCHER_INFO_MESSAGE_1:"Base exchanger regeneration started",
    KARCHER_INFO_MESSAGE_2:"Base exchanger regernation completed",
    KARCHER_INFO_MESSAGE_3:"Base exchanger depleted 75%",
    KARCHER_INFO_MESSAGE_4:"Unit unavailable due to technical issue",
    KARCHER_INFO_MESSAGE_5:"Unit unavailable due to operational issue",
    KARCHER_INFO_MESSAGE_6:"Unit turned turned on",
    KARCHER_INFO_MESSAGE_10:" obwohl sie sich innerhalb der Betriebszeit befindet",
    KARCHER_INFO_MESSAGE_11:"Bay 1 is unavailable",
    KARCHER_INFO_MESSAGE_12:"Bay 2 is unavailable",
    KARCHER_INFO_MESSAGE_13:"Bay 3 is unavailable",
    KARCHER_INFO_MESSAGE_14:"Bay 4 is unavailable",
    KARCHER_INFO_MESSAGE_15:"Bay 5 is unavailable",
    KARCHER_INFO_MESSAGE_16:"Bay 6 is unavailable",
    KARCHER_INFO_MESSAGE_17:"Bay 7 is unavailable",
    KARCHER_INFO_MESSAGE_18:"Bay 8 is unavailable",
    KARCHER_INFO_MESSAGE_20:"Anti-legionella program warm water tank",
    KARCHER_INFO_MESSAGE_21:"Anti-legionella program HD pump 1 required",
    KARCHER_INFO_MESSAGE_22:"Anti-legionella program HD pump 2 required",
    KARCHER_INFO_MESSAGE_23:"Anti-legionella program HD pump 3 required",
    KARCHER_INFO_MESSAGE_24:"Anti-legionella program HD pump 4 required",
    KARCHER_INFO_MESSAGE_25:"Anti-legionella program HD pump 5 required",
    KARCHER_INFO_MESSAGE_26:"Anti-legionella program HD pump 6 required",
    KARCHER_INFO_MESSAGE_27:"Anti-legionella program HD pump 7 required",
    KARCHER_INFO_MESSAGE_28:"Anti-legionella program HD pump 8 required",
    KARCHER_INFO_MESSAGE_29:"Anti-legionella program complete",
    KARCHER_INFO_MESSAGE_101:"High pressure pump 1 due to be serviced",
    KARCHER_INFO_MESSAGE_102:"High pressure pump 2 due to be serviced",
    KARCHER_INFO_MESSAGE_103:"High pressure pump 3 due to be serviced",
    KARCHER_INFO_MESSAGE_104:"High pressure pump 4 due to be serviced",
    KARCHER_INFO_MESSAGE_105:"High pressure pump 5 due to be serviced",
    KARCHER_INFO_MESSAGE_106:"High pressure pump 6 due to be serviced",
    KARCHER_INFO_MESSAGE_107:"High pressure pump 7 due to be serviced",
    KARCHER_INFO_MESSAGE_108:"High pressure pump 8 due to be serviced",
    KARCHER_INFO_MESSAGE_109:"Burner due to be serviced",
    KARCHER_INFO_MESSAGE_110:"Burner blower due to be serviced",
    KARCHER_INFO_MESSAGE_111:"Warm water pump due to be serviced",
    KARCHER_INFO_MESSAGE_112:"Antifreeze pump due to be serviced",
    KARCHER_INFO_MESSAGE_113:"Osmosis pump due to be serviced",
    KARCHER_INFO_MESSAGE_114:"Floor heating pumpt due to be serviced",
    KARCHER_INFO_MESSAGE_115:"Pipe heating due to be serviced",
    KARCHER_INFO_MESSAGE_116:"Microemulsion / rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_117:"Undercarriage cleaning pump due to be serviced",
    KARCHER_INFO_MESSAGE_118:"System pressure pump due to be serviced",
    KARCHER_INFO_MESSAGE_119:"Vacuum cleaner 1 due to be serviced",
    KARCHER_INFO_MESSAGE_120:"Vacuum cleaner 2 due to be serviced",
    KARCHER_INFO_MESSAGE_121:"Vacuum cleaner 3 due to be serviced",
    KARCHER_INFO_MESSAGE_122:"Vacuum cleaner 4 due to be serviced",
    KARCHER_INFO_MESSAGE_123:"Vacuum cleaner 5 due to be serviced",
    KARCHER_INFO_MESSAGE_124:"Vacuum cleaner 6 due to be serviced",
    KARCHER_INFO_MESSAGE_125:"Vacuum cleaner 7 due to be serviced",
    KARCHER_INFO_MESSAGE_126:"Vacuum cleaner 8 due to be serviced",
    KARCHER_INFO_MESSAGE_127:"Vacuum cleaner 9 due to be serviced",
    KARCHER_INFO_MESSAGE_128:"Vacuum cleaner 10 due to be serviced",
    KARCHER_INFO_MESSAGE_129:"Vacuum cleaner 11 due to be serviced",
    KARCHER_INFO_MESSAGE_130:"Vacuum cleaner 12 due to be serviced",
    KARCHER_INFO_MESSAGE_131:"Rim cleaning agent pump due to be serviced",
    KARCHER_INFO_MESSAGE_132:"Microemulsion pump due to be serviced",
    KARCHER_INFO_MESSAGE_133:"Intensive foam pump due to be serviced",
    KARCHER_INFO_MESSAGE_142:"Vacuum cleaner 1 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_143:"Vacuum cleaner 1 filter due to be serviced",
    KARCHER_INFO_MESSAGE_144:"Vacuum cleaner 2 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_145:"Vacuum cleaner 2 filter due to be serviced",
    KARCHER_INFO_MESSAGE_146:"Vacuum cleaner 3 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_147:"Vacuum cleaner 3 filter due to be serviced",
    KARCHER_INFO_MESSAGE_148:"Vacuum cleaner 4 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_149:"Vacuum cleaner 4 filter due to be serviced",
    KARCHER_INFO_MESSAGE_150:"Vacuum cleaner 5 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_151:"Vacuum cleaner 5 filter due to be serviced",
    KARCHER_INFO_MESSAGE_152:"Vacuum cleaner 6 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_153:"Vacuum cleaner 6 filter due to be serviced",
    KARCHER_INFO_MESSAGE_154:"Vacuum cleaner 7 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_155:"Vacuum cleaner 7 filter due to be serviced",
    KARCHER_INFO_MESSAGE_156:"Vacuum cleaner 8 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_157:"Vacuum cleaner 8 filter due to be serviced",
    KARCHER_INFO_MESSAGE_158:"Vacuum cleaner 9 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_159:"Vacuum cleaner 9 filter due to be serviced",
    KARCHER_INFO_MESSAGE_160:"Vacuum cleaner 10 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_161:"Vacuum cleaner 10 filter due to be serviced",
    KARCHER_INFO_MESSAGE_162:"Vacuum cleaner 11 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_163:"Vacuum cleaner 11 filter due to be serviced",
    KARCHER_INFO_MESSAGE_164:"Vacuum cleaner 12 turbine due to be serviced",
    KARCHER_INFO_MESSAGE_165:"Vacuum cleaner 12 filter due to be serviced",
    ORGANIZATION:"Organizace",
    CREATE_ORGANIZATION:"Vytvořit organizaci",
    CREATE_ORGANIZATION_AS:"Vytvořit jako dceřinou organizaci pro",
    DELETE_ORGANIZATION:"Smazat organizaci",
    EDIT_ORGANIZATION:"Upravit organizaci",
    SUPPORTED_ORG_NAME:"Podporovaná organizace",
    SUPPORTED_ORG_TYPE:"Podporovaný druh",
    ORG_NAME:"Jméno",
    ORG_TYPE:"Typ",
    SET_ORG_TITLE:"Nastavit podřízenou organizaci",
    SET_SUPPORTED_ORG_TITLE:"Nastavit podporu podřízené organizace",
    SAVE_ORGANIZATION:"Uložit organizaci",
    SELECT_ORGANIZATION_TYPE:"Vybrat druh organizace",
    SELECT_ORGANIZATION_SELECTOR:"Vybrat",
    SELECT_SUPPORTED_ORGANIZATION:"Vybrat podporovanou organizaci",
    ORGANIZATION_DELETED:"Organizace úspěšně odstraněna",
    ORGANIZATION_SAVED:"Organizace úspěšně uložena",
    ORGANIZATION_UPDATED:"Organizace byla úspěšně aktualizována",
    ALERTS:"Upozornění",
    DEVICE_STATUS:"Stav zařízení",
    SITE_DETAILS:"Podrobnosti sítě",
    ALARM_STATUS:"Stav upozornění",
    FILTER:"Filtrovat podle ...",
    FILTER_BY_ALERT_CENTER:"Filtrujte podle kódu, názvu nebo popisu",
    TOTAL_ALARM:"Celkem",
    LOW_ALARM:"Událost",
    MEDIUM_ALARM:"Porucha",
    HIGH_ALARM:"Kritická chyba",
    NO_FACILITIES_NEARBY:"V okolí se nenachází žádné zařízení",
    GRAY_MAP:"Šedá mapa",
    READY:"Připraven",
    WARNING:"Porucha",
    ERROR:"Chyba",
    SITE_NAME:"Název sítě",
    ACCOUNTS_INFO:"Informace o účtu",
    USER_ORGANIZATION:"Organizace uživatele",
    ADD_USER_ORGANIZATION:"Přidat nového firemního uživatele ",
    EDIT_USER_ORGANIZATION:"Upravte uživatele v organizaci",
    SELECT_ROLE:"Vybrat roli",
    SELECT_ORGANIZATION:"Vybrat organizaci",
    SELECT_USER:"Vybrat uživatele",
    USER_FOR_ORGANIZATION_CREATED:"Nový uživatel byl úspěšně vytvořen",
    SELECT_REGION:"Vyberte region",
    SELECT_LANGUAGE:"Vyberte jazyk",
    LOADING_DATA:"Načítání dat, čekejte prosím...",
    ADMINISTRATOR:"Administrátor",
    TECHNICAL_SUPPORT:"Technická podpora",
    CONTROLLER:"Kontrola",
    EDIT_ORGANIZATION_USER:"Upravte uživatele v organizaci",
    DELETE_ORGANIZATION_USER:"Smazat uživatele v organizaci",
    USER_UPDATED:"Uživatel byl úspěšně aktualizován",
    USER_CREATED:"Uživatel byl úspěšně vytvořen",
    ADDRESS:"Adresa",
    SUBSCRIPTIONS:"odběry",
    RESOLVED_STATUS:"Vyřešeno",
    NOT_RESOLVED_STATUS:"Nevyřešeno",
    ALERT_NAME:"Název upozornění",
    ALERT_DESCRIPTION:"Popis upozornění",
    ALERT_CODE:"Kód upozornění ",
    ALERT_TYPE:"Typ upozornění",
    UNSUBSCRIBE:"Odhlásit upozornění",
    SUBSCRIBE:"Odebírat upozornění",
    ALARM_SUBSCRIBED:"Úspěšně přihlášeni k odběru",
    UNSUBSCRIBED_CONFIRM:"Odhlásit?",
    ALARM_UNSUBSCRIBED:"Úspěšně odhlášen",
    ASIDE_MENU_CASHLESS_SALES:"Bezhotovostní prodej",
    FILTERED_CASHLESS_PAYMENTS:"Filtrované bezhotovostní platby",
    REFUND_DIALOG_TITLE:"Vrácení transakce?",
    REFUND_DIALOG_SUBTITLE:"Hodnota může být menší nebo rovna částce transakce",
    REFUND:"Refundace",
    INPUT_NOT_VALID:"Zadaná hodnota není platná",
    REFUND_SUCCESSFULLY:"Vrácení vybrané platby proběhlo úspěšně",
    USER:"Uživatel",
    TRANSACTION_ID:"PSP reference",
    DEVICE_ID:"ID zařízení",
    NET_AMOUNT:"Netto částka",
    REPORT_NAME:"Název reportu",
    TIME_FRAME:"Časový rámec",
    SUB_POINT:"Vyberte dílčí bod",
    SUB_POINT_LIST_NOT_EXIST:"Pro zvolené mycí zařízení neexistuje seznam dílčích bodů",
    FACILITY_TYPE:"Typ zařízení",
    MACHINE_NAME:"Název stroje",
    WASH_FACILITY_DETAILS:"Podrobnosti o mycím zařízení",
    WASH_BAY_DETAILS:"Podrobnosti o mycím doku",
    DEVICES_INFO:"Seznam zařízení",
    OPERATION_TIME_INFO:"Provozní doba",
    OPERATION_TIME_VACUUM_INFO:"Provozní doba vysavačů",
    OPERATION_TIME_ILLUMINATION_INFO:"Provozní doba pro osvětlení",
    AVAILABLE_TITLE:"Dostupné",
    UNAVAILABLE_TITLE:"nedostupné",
    CURRENT_PROGRAM:"Současný program",
    CREDITS:"Kredity",
    DEVICE_NAME:"Název zařízení",
    ACTIVE_ALARMS:"Aktivní upozornění",
    ALL_DAY:"Celý den",
    OPERATING_TIME_WASH_FACILITY:"Systém samoobslužného mytí",
    OPERATING_TIME_VACUUMS:"Vysavače",
    OPERATING_TIME_ILLUMINATION:"Osvětlení",
    OPERATION_COUNTERS:"Počítadla operací",
    EDIT:"Upravit",
    WASHING_PROGRAMS:"Mycí programy",
    INFO:"Událost",
    STATISTIC:"Statistika",
    ROLLOVER_DOSING:"Dávkování",
    ROLLOVER_SPEED:"Rychlosti",
    ROLLOVER_RESETS:"Dálkový reset rolloveru",
    ROLLOVER_RESETS_INFO:"Vzdálené resetování musí být v souladu s místními předpisy. Důležité: Před resetováním se ujistěte, že rollover je prázdný.",
    RESET_ROLLOVER:"Resetovat rollover",
    OPEN_DOOR_ROLLOVER:"Otevřít",
    ROLLOVER_OPEN_DOOR_INFO:"Otevřete dveře mycí haly. Buďte opatrní.",
    ROLLOVER_OPEN_DOOR:"Otevřít dveře",
    APPLY_DOSING_CHANGES:"Použít změny dávkování",
    APPLY_SPEED_CHANGES:" Apply speed changes",
    ACTUATION_SUCCESS:"Použijte změny rychlosti",
    REMAINING_TIME:"Zbývající čas",
    OPEN_24H:"Otevřeno 24 hodin",
    CLOSE_24H:"Zavřeno 24 hodin",
    VALIDATION_OPERATION_TIME:"Formát není správný. Použijte hh:mm",
    ROLLOVER:" Rollover",
    UPDATE_WASHING_PROGRAM:"Aktualizace mycího programu",
    UPDATE_ACTUATORS:"Aktualizace pohonu",
    OPEN_ROLOVER_DOOR_TITLE:"Chcete otevřít dveře rolloveru?",
    OPEN_ROLOVER_DOOR_CONTENT:"Opravdu chcete otevřít dveře?",
    RESET_ROLOVER_TITLE:"Chcete resetovat rollover?",
    RESET_ROLOVER_CONTENT:"Jste si jistí, že chcete resetovat rollover?",
    G0:"{{brand === 'r2w' ? 'Dok 0' : 'Dok 1'}}",
    G1:"{{brand === 'r2w' ? 'Dok 1' : 'Dok 2'}}",
    G2:"{{brand === 'r2w' ? 'Dok 2' : 'Dok 3'}}",
    G3:"{{brand === 'r2w' ? 'Dok 3' : 'Dok 4'}}",
    G4:"{{brand === 'r2w' ? 'Dok 4' : 'Dok 5'}}",
    G5:"{{brand === 'r2w' ? 'Dok 5' : 'Dok 6'}}",
    G6:"{{brand === 'r2w' ? 'Dok 6' : 'Dok 7'}}",
    G7:"{{brand === 'r2w' ? 'Dok 7' : 'Dok 8'}}",
    G8:"{{brand === 'r2w' ? 'Dok 8' : 'Dok 9'}}",
    G9:"{{brand === 'r2w' ? 'Dok 9' : 'Dok 10'}}",
    G10:"{{brand === 'r2w' ? 'Dok 10' : 'Dok 11'}}",
    U0:"{{brand === 'r2w' ? 'Vysavač 0' : 'Vysavač 1'}}",
    U1:"{{brand === 'r2w' ? 'Vysavač 1' : 'Vysavač 2'}}",
    U2:"{{brand === 'r2w' ? 'Vysavač 2' : 'Vysavač 3'}}",
    U3:"{{brand === 'r2w' ? 'Vysavač 3' : 'Vysavač 4'}}",
    U4:"{{brand === 'r2w' ? 'Vysavač 4' : 'Vysavač 5'}}",
    U5:"{{brand === 'r2w' ? 'Vysavač 5' : 'Vysavač 6'}}",
    U6:"{{brand === 'r2w' ? 'Vysavač 6' : 'Vysavač 7'}}",
    U7:"{{brand === 'r2w' ? 'Vysavač 7' : 'Vysavač 8'}}",
    ALERT_CENTER_TITLE_BY_SITE:"Zpráva centra upozornění vytvořená vybranou sítí z řídicího panelu",
    ALERT_CENTER_TITLE_BY_FACILITY:"Zpráva centra výstrah vytvořená vybraným zařízením z řídicího panelu",
    ALERT_CENTER_TITLE_BY_DEFAULT:"Zpráva centra výstrah",
    ERROR_MESSAGE_403:"Nemáte oprávnění použít toto volání rozhraní API. Kód chyby: 403",
    LAST_ACTIVE_PROGRAM:"Aktivní program / Poslední aktivní program",
    PROGRAM_ID:"Číslo programu",
    PROGRAM_PRICE:"Cena programu",
    NORMAL_CHEMICAL_LEVEL:"OK",
    LOW_CHEMICAL_LEVEL:"Nutné doplnit",
    EMPTY_CHEMICAL_LEVEL:"Prázdný",
    CHEMICAL_LEVEL:"Indikace hladiny mycích prostředků (%)",
    ROLLOVER_STATUS:"Stav rolloveru",
    ROLLOVER_STATUS_CODE_0:"Mytí je momentálně mimo provoz",
    ROLLOVER_STATUS_CODE_1:"Mimo provozní dobu",
    ROLLOVER_STATUS_CODE_2:"Vstup do programu povolen",
    ROLLOVER_STATUS_CODE_3:"Umístěte své vozidlo",
    ROLLOVER_STATUS_CODE_4:"Vozidlo dopředu",
    ROLLOVER_STATUS_CODE_5:"Vozidlo dozadu",
    ROLLOVER_STATUS_CODE_6:"Zastavit vozidlo",
    ROLLOVER_STATUS_CODE_7:"Mytí aktivní",
    ROLLOVER_STATUS_CODE_8:"Mytí zastaveno",
    ROLLOVER_STATUS_CODE_9:"Mytí aktivní (tact) ",
    ROLLOVER_STATUS_CODE_10:"Vystupte směrem dozadu",
    ROLLOVER_STATUS_CODE_11:"Nouzové zastavení",
    ROLLOVER_STATUS_CODE_12:"Vystupte směrem dozadu",
    ROLLOVER_STATUS_CODE_13:"Aktivní protinámraza",
    ROLLOVER_STATUS_CODE_14:"Bezpečnostní spínač vpředu aktivován",
    ROLLOVER_STATUS_CODE_15:"Bezpečnostní spínač vzadu aktivován",
    ROLLOVER_STATUS_CODE_16:"Aktivován bezpečnostní spínač na levé přední straně",
    ROLLOVER_STATUS_CODE_17:"Aktivován bezpečnostní spínač na pravé přední straně",
    ROLLOVER_STATUS_CODE_18:"Aktivován bezpečnostní spínač na levé zadní straně",
    ROLLOVER_STATUS_CODE_19:"Aktivován bezpečnostní spínač na pravé zadní straně",
    ROLLOVER_STATUS_CODE_20:"Poloha vozidla příliš na levé straně",
    ROLLOVER_STATUS_CODE_21:"Poloha vozidla příliš na pravé straně",
    ROLLOVER_STATUS_CODE_22:"Levé dveře nejsou zavřené",
    ROLLOVER_STATUS_CODE_23:"Pravé dveře nejsou zavřené",
    ROLLOVER_STATUS_CODE_24:"Detekován přepravník, zvolen nesprávný mycí program",
    ROLLOVER_STATUS_CODE_25:"Senzor houkačky",
    ROLLOVER_STATUS_CODE_98:"Manuální / režim nastavení",
    ROLLOVER_STATUS_CODE_99:" Unknown status",
    ROLLOVER_STATUS_CODE_UNDEFINED:"Status code undefined",
    ALARM:"Kritická závada",
    NO_ALARM:"Žádná kritická závada",
    SOFTWARE_VERSION:"Verze softwaru",
    SOFTWARE_DATE:"Datum softwaru",
    SITE_ADDRESS:"Adresa místa",
    SECONDS:"Sekundy",
    SERVICE_PART_NAME:"Název služby",
    OPERATION_SERVICE_COUNTER_ROLLOVER:"Počítadlo operací a služeb",
    OPERATION_COUNTER:"Počítadlo operací",
    SERVICE_COUNTER:"Počítadlo služeb",
    FAULT_CODE:"Kód upozornění",
    PRESSURE_TITLE:"Tlak vzduchu",
    TIME_TITLE:"Aktuální čas",
    COUNTRY_TITLE:"Země",
    CITY_TITLE:"Město",
    REGION_TITLE:"Region",
    SELECT_POINTS_TO_SEARCH:"Vyberte body ...",
    LOGS_HISTORY:"Historie změn parametrů",
    ACTUATOR_REFERENCE:"Referenční číslo aktuátoru",
    ACTUATOR_VALUE:"Hodnota aktuátoru",
    POINT_ID:" ID bodu",
    VALIDATION_NOT_VALID_RANGE:"Nesprávný rozsah",
    ENABLE_ROLLOVER_RESET:"Zaškrtnutím tohoto políčka potvrzujete, že jste si přečetli a souhlasíte s bezpečnostními pokyny.",
    CHANGE_OF_PARAMETERS:"Změna parametrů",
    SELECT_OPTIONS:"Vyberte možnosti",
    AUTOMATIC:"Automatické",
    DESALTING:"Funkce odsolování",
    SEASON_WASH:"Sezónní mycí programy",
    SPRING_PROGRAM:"Jarní mycí programy",
    SUMMER_PROGRAM:"Letní mycí programy",
    AUTUMN_PROGRAM:"Podzimní mycí programy",
    WINTER_PROGRAM:"Zimní mycí programy",
    DOOR_CONTROL:"Ovládání dveří",
    SUMMER_DOOR_CONTROL:"Léto, ovládání brány v letním režimu",
    WINTER_DOOR_CONTROL:"Zima, ovládání brány v zimním režimu",
    APPLY_PARAMETERS_CHANGES:"Použít změny parametrů",
    WORKING_SCHEDULES:"Pracovní doba",
    HOLIDAY_SCHEDULES:"Rozvrhy dovolených",
    SITE_HOLIDAY_SUCCESSFULLY_CREATED:"Dovolená na webu byla úspěšně vytvořena",
    SITE_HOLIDAY_SUCCESSFULLY_UPDATED:"Dovolená na webu byla úspěšně aktualizována",
    SITE_HOLIDAY_SUCCESSFULLY_DELETED:"Prázdniny na webu byly úspěšně smazány",
    WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE:"Plán pracovní doby úspěšně rozšířen",
    HOLIDAY_SUCCESSFULLY_DELETED:"Dovolená úspěšně smazána",
    SB_MU_MB_2_2_0:"SB_MU_MB_2_2_0_Trans",
    SB_MU_MB_2_1_0:" SB_MU_MB_2_1_0_Trans",
    SB_MU_MB_2_0_0:" SB_MU_MB_2_0_0_Trans",
    SB_MU_2_2_0:" SB_MU_2_2_0_Trans",
    SB_MU_2_1_0:" SB_MU_2_1_0_Trans",
    SB_MU_2_0_0:" SB_MU_2_0_0_Trans",
    SB_MB_2_2_0:" SB_MB_2_2_0_Trans",
    SB_MB_2_1_0:" SB_MB_2_1_0_Trans",
    SB_MB_2_0_0:" SB_MB_2_0_0_Trans",
    SB_OB_2_2_0:" SB_OB_2_2_0_Trans",
    SB_OB_2_1_0:" SB_OB_2_1_0_Trans",
    SB_OB_2_0_0:" SB_OB_2_0_0_Trans",
    CB3_1_0_0:" CB3_1_0_0_Trans",
    CW35_3_0_0:" CW35_3_0_0_Trans",
    CW35_3_1_0:"CW35_3_1_0_Trans",
    CWB3_3_0_0:" CWB3_3_0_0_Trans",
    CWB3_3_1_0:"CWB3_3_1_0_Trans",
    CW1_3_0_0:" CW1_3_0_0_Trans",
    CW1_3_1_0:" CW1_3_1_0_Trans",
    CHEM_LEVEL_LOW_DRYING_AGENT:"Vysoušeč má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_SHAMPOO:"Šampón má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_FOAM:"Pěna má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_WAX_1:"Vosk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_POLISH_1:"Lesk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_RIM_CLEANER:"Čistič disků má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_WAX_2:"Vosk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_TYRE_SHINE:"Lesk pneumatk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_INSECT_REMOVER:"Odstraňovač hmyzu má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_POLISH_2:"Lesk má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_INTENSIVE:"Intensiv má nízkou hladinu náplně",
    CHEM_LEVEL_LOW_FOAM_RAIN:"Pěnový déšť má nízkou hladinu náplně",
    CHEM_LEVEL_DRYING_AGENT:"Úroveň náplně vysoušeč",
    CHEM_LEVEL_SHAMPOO:"Úroveň náplně šampón",
    CHEM_LEVEL_FOAM:"Úroveň náplně pěna",
    CHEM_LEVEL_WAX_1:"Úroveň náplně vosk",
    CHEM_LEVEL_POLISH_1:" Úroveň náplně lesk",
    CHEM_LEVEL_RIM_CLEANER:" Úroveň náplně čistič disků",
    CHEM_LEVEL_WAX_2:" Úroveň náplně vosk",
    CHEM_LEVEL_TYRE_SHINE:" Úroveň náplně lesk pneumatik",
    CHEM_LEVEL_INSECT_REMOVER:" Úroveň náplně odstraňovač hmyzu",
    CHEM_LEVEL_POLISH_2:" Úroveň náplně lesk",
    CHEM_LEVEL_INTENSIVE:" Úroveň náplně intenzivní",
    CHEM_LEVEL_FOAM_RAIN:" Úroveň náplně pěnový dešť",
    SERVICE_COUNTER_REPLACE_ROOFBRUSH_LIFTING_BELT:"Servisní počítadlo na zvedací pás střešních kartáčů",
    SERVICE_COUNTER_REPLACE_DRYER_LIFTING_BELT:"Servisní počítadlo zvedací lišty sušičky",
    SERVICE_COUNTER_REPLACE_MOTORCABLE_ROOFBRUSH_ROTATION:"Servisní počítadlo motoru střešního kartáče ",
    SERVICE_COUNTER_HP_PUMPSERVICE_FRESH_WATER_USE:"Servisní počítadlo čerpadla čerstvé vody",
    SERVICE_COUNTER_HP_PUMPSERVICE_USED_WATER_USE:"Servisní počítadlo čerpadla použité vody",
    DRYING_AGENT:"Vysoušecí prostředek",
    FOAM_DRYING_AGENT:"Pěnový vysoušecí prostředek",
    SHAMPOO:"Šampón",
    FOAM:"Pěna",
    BRUSH_FOAM:"Čištění kartáčem",
    WAX_1:"Vosk",
    FOAM_WAX_1:"Pěnový vosk",
    POLISH_1:"lesk",
    RIM_CLEANING:"Čistič disků",
    WAX_2:"Vosk",
    FOAM_WAX_2:"Pěnový vosk",
    TYRE_SHINE:"Lesk pneumatik",
    INSECT_REMOVER:"Odstraňovač hmyzu",
    POLISH_2:"Lesk",
    INTENSIVE_BASIC:"Intenzivní základní",
    INTENSIVE_SIDE:"Intenzivní boční",
    INTENSIVE_ROOF_SPRAY_BAR:"Intenzivní střešní stříkací lišta",
    TAR_REMOVER:"Odstraňovač dehtu",
    UNDER_CHASSIS_CONVERSATION:"Konzervace podvozku",
    STATIONARY_PRE_SPRAY_ARCH:"Stacionární přednástřikový oblouk",
    FOAM_RAIN:"Pěnový déšť",
    PRE_CLEANING:"Předmytí",
    BRUSH:"Kartáč",
    CARE:"Péče",
    DRYING:"Sušení",
    DRYING_LOW_NOISE:"Snížení hluku sušení",
    INTENSIVE_CLEANING:"Intenzivní čištění",
    BRUSH_CLEANING:"Čištění kartáčem",
    EMPTY_RUN:"Prázdný běh",
    DRYING_AID:"Vysoušeč",
    WAX:"Vosk",
    FOAM_WASH:"Mytí pěnou",
    POLISH:"Lesk",
    FOAM_POLISH:"Pěnové leštění",
    WHEEL_CLEANING:"Čištění kol",
    HIGH_PRESSURE_ROOF:"Střešní vysoký tlak",
    HIGH_PRESSURE_SIDE:"Boční vysoký tlak",
    DRYER_FORWARD:"Boční vysoký tlak",
    DRYER_BACKWARD:"Vysoušeč dopředu",
    DELETE_ALL_HOLIDAYS:"Smazat všechny svátky pro vybranou síť",
    CREATE_NEW_HOLIDAY:"Vytvořit nový",
    RESET_INPUTS:"Resetujte všechny svátky",
    TWENTY_FOUR_HOURS_OPEN:"Otevřeno 24 hodin",
    EVERY_YEAR:"Roční",
    DELETE_HOLIDAY:"Odstranit prázdniny",
    ADD_NEW_HOLIDAY:"Přidat nové prázdiny",
    HOLIDAYS_LIST:"Seznam existujících svátků",
    DELETE_ALL_HOLIDAYS_FOR_SELECTED_SITE:"Smazat všechny svátky pro vybranou síť?",
    VALIDATION_HOLIDAY_DATE:"Formát není správný. Použijte mm-dd",
    FOR_DATE:"Na datum",
    WITH_ID:"S ID",
    FROM_HOURS:"Od (h)",
    FROM_MINUTES:"Od (min)",
    TO_HOURS:"Do (h)",
    TO_MINUTES:"Do (m)",
    NOT_MATCH:"Neshoduje se",
    START:"Od",
    STOP:"Do",
    DAILY_TIME:"24 hodinový seznam",
    INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE:"Individuální nastavení času",
    PROGRAM_NOT_STARTED:"Program ještě nebyl spuštěn",
    JETWASH:"Systém samoobslužného mytí",
    KARCHER_REPORT_1:"Rollover: Indikace obratu dle programu a celkem",
    KARCHER_REPORT_2:"Rollover: Zahájené mytí dle programu a celkem",
    KARCHER_REPORT_3:"Rollover: Provedené mytí dle programu a celkem",
    KARCHER_REPORT_4:"Rollover: Množství zahájených mytí prostřednictvím platebního terminálu dle programu a celkem",
    KARCHER_REPORT_5:"Rollover: Počet ručně spuštěných mytí dle programu a celkem",
    KARCHER_REPORT_6:"Rollover: Počet zrušených mytí dle programu a celkem",
    KARCHER_REPORT_7:"Rollover: Počet výpadků napájení",
    KARCHER_REPORT_8:"Jednotky SB: Počet hodin dle mycího programu filtrovaný podle doku a celkem",
    KARCHER_REPORT_9:"Jednotky SB: Indikace obratu na mycí pozici a celkem",
    KARCHER_REPORT_10:"Jednotky SB: Počítadlo tokenů/mincí dle kanálu mincí",
    OPERATION_COUNTER_FRESH_WATER_PUMP:"Čerpadlo na čerstvou vodu",
    OPERATION_COUNTER_PROCESS_WATER_PUMP:"Proces vodního čerpadla",
    OPERATION_COUNTER_HP_PUMP_1:"Vysokotlaké čerpadlo 1",
    OPERATION_COUNTER_HP_PUMP_2:"Vysokotlaké čerpadlo 2",
    RELEASE_NOTES:"Verze aplikace a poznámky k verzi",
    BACKEND_RELEASE_NOTES:"Poznámky k verzi platformy:",
    FRONTEND_RELEASE_NOTES:"Poznámky k verzi webové aplikace:",
    SELECTED_FACILITY_TIMEZONE:"Časové pásmo pro vybrané zařízení:",
    REFRESH_PAGE:"Obnovit stránku",
    REFRESH_MAPS:"Obnovit mapy",
    PUMPS:"čerpadla",
    RUN_TIME:"Doba chodu",
    RUN_TIME1:"Doba chodu 1",
    RUN_TIME2:"Doba chodu 2",
    PROGRAM_RUNTIME_ACTUATOR:"Regulátor doby chodu ",
    PROGRAM_RUNTIME_ACTUATOR_1:"Regulátor doby chodu 1",
    PROGRAM_RUNTIME_ACTUATOR_2:"Regulátor doby chodu 2",
    PUMP_RUN_TIME_MIN_VALIDATION:"Minimální hodnota je 1",
    PUMP_RUN_TIME_MAX_VALIDATION:"Maximální hodnota je 255",
    WASH_PROGRAM_MIN_MAX_VALIDATION:"Použijte formát ceny x.xx",
    ACTUATION_NOT_ALLOWED:"Pro aktuální uživatelskou roli není povoleno ovládání",
    MAINTENANCE_DAYS:"Dny údržby",
    MAINTENANCE_WASHES:"Údržba myčky",
    DAILY_FINANCES_POS:"POS",
    POS_INCOME:"Celkový příjem POS",
    PROPAGATE:"Propagovat",
    ALL_DAY_HOURS_SELECTOR:"Volič typu na 24 hodin",
    GET_OPERATING_TIME_FROM_SITE:"Získejte provozní dobu pro aktuální zařízení z místního pracovního plánu",
    USER_NOT_VALID:"Uživatel není platný. Zkuste použít jiné přihlašovací údaje k účtu.",
    VERIFIED:"Ověřeno",
    RESEND_VERIFICATION_MAIL:"Opětovné zaslání ověřovacího e-mailu",
    RETURN_TO_DASHBOARD:"Vraťte se na ovládací panel",
    ERROR_PAGE_BAD_REQUEST:"400 špatný požadavek.",
    WASHES:"Počet mytí",
    TIME_TO_SERVICE:"Čas na servis",
    ACCOUNT_ALREADY_ACTIVATED:"Účet je již aktivován",
    DEVICE_EVENTS:"Události zařízení",
    DEVICE_EVENTS_LOG_PULLED:"Stažený log událostí pro zařízení",
    EVENTS_PULL_DATE:"Čas stažených událostí",
    DEVICE_EVENTS_REFRESH:"Stáhnout nová data událostí",
    WEB_SOCKETS_CONNECTION_PROBLEM:"Problém s připojením webových socketů. Zkuste obnovit stránku.",
    INSTALLATION_DATE:"Datum instalace zařízení",
    KARCHER_CUSTOM_PROGRAM_NAME_1:"Horký vosk",
    KARCHER_CUSTOM_PROGRAM_NAME_2:"Mytí vysokým tlakem",
    KARCHER_CUSTOM_PROGRAM_NAME_3:"Pěna na kola",
    KARCHER_CUSTOM_PROGRAM_NAME_4:"Pěna s vysokým výkonem",
    KARCHER_CUSTOM_PROGRAM_NAME_5:"Zastavit",
    KARCHER_CUSTOM_PROGRAM_NAME_6:"Mytí pěnou HD",
    KARCHER_CUSTOM_PROGRAM_NAME_7:"Mytí",
    KARCHER_CUSTOM_PROGRAM_NAME_8:"Vrcholná péče",
    INFO_TITLE:"Informace",
    FOAM_WAX1:"Pěnový vosk",
    POLISH1:"Lesk",
    WAX1:"Vosk",
    SITE_DETAILS_SUCCESSFULLY_UPDATED:"Podrobnosti o místě byly úspěšně aktualizovány",
    COMPANY:"Společnost",
    FACILITY_HAS_CHANGER:"Máte měnič?",
    DISABLE_OFFLINE_ALARM:"Zakázat alarmy R2W",
    ASIDE_WORKING_SCHEDULES:"Podrobnosti o místě aplikace",
    TERMS_OF_SERVICE_R2W_TITLE:"Podmínky služby Ready2Wash",
    TERMS_OF_SERVICE_R2W:"Podmínky služby Ready2Wash",
    DATA_PROCESSING_TITLE:"Zpracovaná data",
    PRIVACY_POLICY_TITLE:"Zásady ochrany osobních údajů",
    READY_TO_PAY_TERMS_OF_SERVICE:" Podmínky služby Ready2Pay",
    TERMS_AND_SERVICES:"Podmínky a služby",
    HOURLY: "Hodinově",
    DAILY: "Denně",
    WEEKLY: "Týdně",
    MONTHLY: "Měsíčně",
    YEARLY: "Ročně",
    DELETE_ITEM_SUCCESS:"Úspěšně jste smazali položku",
    STATE: "Stát",
    AVAILABILITY_STATUS_1: "Jednotka otevřená",
    AVAILABILITY_STATUS_2: "Jednotka zavřená (dovolená)",
    AVAILABILITY_STATUS_3: "Jednotka zavřená (provozní doba)",
    AVAILABILITY_STATUS_4: "Jednotka zavřená (porucha)",
    AVAILABILITY_STATUS_5: "Jednotka zavřená (ostatní)",
    AVAILABILITY_VACUUMS_STATUS_1: "Vysavače nenainstalované",
    AVAILABILITY_VACUUMS_STATUS_2: "Vysavače otevřené",
    AVAILABILITY_VACUUMS_STATUS_3: "Vysavače zavřené (dovolená)",
    AVAILABILITY_VACUUMS_STATUS_4: "Vysavače zavřené (provozní doba)",
    AVAILABILITY_VACUUMS_STATUS_5: "Vysavače zavřené (porucha)",
    AVAILABILITY_VACUUMS_STATUS_6: "Vysavače zavřené (ostatní)",
    ECOM_AMOUNT: "Celkový Ecom pro všechny lokality",
    CAPTURED: "Zachyceno",
    DELETE_COMPANY_HISTORY_INFO:"Tato akce odstraní všechna data zpráv vaší společnosti. Tuto akci nelze vrátit zpět.",
    DELETE_COMPANY_HISTORY_CONFIRMATION_INFO:"Opravdu chcete natrvalo odstranit všechna data zpráv?",
    VALUE_DATE: "Datum hodnoty",
    KARCHER_EVENT_NAME_1: "Základní výměník obnoven",
    KARCHER_EVENT_NAME_2: "Regenerace základního výměníku ukončena",
    KARCHER_EVENT_NAME_3: "Materiál / sériové číslo",
    KARCHER_EVENT_NAME_4: "Systém byl dezinfikován",
    KARCHER_EVENT_NAME_5: "HP čerpadlo 1 bylo dezinfikováno",
    KARCHER_EVENT_NAME_6: "HP čerpadlo 2 bylo dezinfikováno",
    KARCHER_EVENT_NAME_7: "HP čerpadlo 3 bylo dezinfikováno",
    KARCHER_EVENT_NAME_8: "HP čerpadlo 4 bylo dezinfikováno",
    KARCHER_EVENT_NAME_9: "HP čerpadlo 5 bylo dezinfikováno",
    KARCHER_EVENT_NAME_10: "Mytí stanice 1 zamčeno",
    KARCHER_EVENT_NAME_11: "Mytí stanice 2 zamčeno",
    KARCHER_EVENT_NAME_12: "Mytí stanice 3 zamčeno",
    KARCHER_EVENT_NAME_13: "Mytí stanice 4 zamčeno",
    KARCHER_EVENT_NAME_14: "Mytí stanice 5 zamčeno",
    KARCHER_EVENT_NAME_15: "Mytí stanice 6 zamčeno",
    KARCHER_EVENT_NAME_16: "Mytí stanice 7 zamčeno",
    KARCHER_EVENT_NAME_17: "Mytí stanice 8 zamčeno",
    KARCHER_EVENT_NAME_18: "Aktualizace zahájena",
    KARCHER_EVENT_NAME_19: "Aktualizace dokončena",
    KARCHER_EVENT_NAME_20: "Spuštění WS Reg",
    KARCHER_EVENT_NAME_21: "Konec WS Reg",
    KARCHER_EVENT_NAME_22: "WS 75% senzor",
    KARCHER_EVENT_NAME_23: "Technická závada",
    KARCHER_EVENT_NAME_24: "Provozní závada",
    KARCHER_EVENT_NAME_25: "Jednotka zapnuta",
    KARCHER_EVENT_NAME_26: "Jednotka vypnuta",
    KARCHER_EVENT_NAME_27: "Box 1 zavřen",
    KARCHER_EVENT_NAME_28: "Box 2 zavřen",
    KARCHER_EVENT_NAME_29: "Box 3 zavřen",
    KARCHER_EVENT_NAME_30: "Box 4 zavřen",
    KARCHER_EVENT_NAME_31: "Box 5 zavřen",
    KARCHER_EVENT_NAME_32: "Box 6 zavřen",
    KARCHER_EVENT_NAME_33: "Box 7 zavřen",
    KARCHER_EVENT_NAME_34: "Box 8 zavřen",
    KARCHER_EVENT_NAME_35: "HP čerpadlová stanice 1",
    KARCHER_EVENT_NAME_36: "HP čerpadlová stanice 2",
    KARCHER_EVENT_NAME_37: "HP čerpadlová stanice 3",
    KARCHER_EVENT_NAME_38: "HP čerpadlová stanice 4",
    KARCHER_EVENT_NAME_39: "HP čerpadlová stanice 5",
    KARCHER_EVENT_NAME_40: "HP čerpadlová stanice 6",
    KARCHER_EVENT_NAME_41: "HP čerpadlová stanice 7",
    KARCHER_EVENT_NAME_42: "HP čerpadlová stanice 8",
    KARCHER_EVENT_NAME_43: "Hořák",
    KARCHER_EVENT_NAME_44: "Ventilátor hořáku",
    KARCHER_EVENT_NAME_45: "Čerpadlo teplé vody",
    KARCHER_EVENT_NAME_46: "Čerpadlo protimrazové ochrany",
    KARCHER_EVENT_NAME_47: "Osmotické čerpadlo",
    KARCHER_EVENT_NAME_48: "Podlahové vytápění",
    KARCHER_EVENT_NAME_49: "Ohřev hadice",
    KARCHER_EVENT_NAME_50: "Čištění mikro/prahu",
    KARCHER_EVENT_NAME_51: "Čerpadlo podvozku",
    KARCHER_EVENT_NAME_52: "Pěnové čerpadlo Booster",
    KARCHER_EVENT_NAME_53: "Vysavač 1",
    KARCHER_EVENT_NAME_54: "Vysavač 2",
    KARCHER_EVENT_NAME_55: "Vysavač 3",
    KARCHER_EVENT_NAME_56: "Vysavač 4",
    KARCHER_EVENT_NAME_57: "Vysavač 5",
    KARCHER_EVENT_NAME_58: "Vysavač 6",
    KARCHER_EVENT_NAME_59: "Vysavač 7",
    KARCHER_EVENT_NAME_60: "Vysavač 8",
    KARCHER_EVENT_NAME_61: "Vysavač 9",
    KARCHER_EVENT_NAME_62: "Vysavač 10",
    KARCHER_EVENT_NAME_63: "Vysavač 11",
    KARCHER_EVENT_NAME_64: "Vysavač 12",
    KARCHER_EVENT_NAME_65: "Čerpadlo prahů",
    KARCHER_EVENT_NAME_66: "Čerpadlo Microe.",
    KARCHER_EVENT_NAME_67: "Intenzivní čerpadlo",
    KARCHER_EVENT_NAME_68: "Turbína vysavače 1",
    KARCHER_EVENT_NAME_69: "Filtr vysavače 1",
    KARCHER_EVENT_NAME_70: "Turbína vysavače 2",
    KARCHER_EVENT_NAME_71: "Filtr vysavače 2",
    KARCHER_EVENT_NAME_72: "Turbína vysavače 3",
    KARCHER_EVENT_NAME_73: "Filtr vysavače 3",
    KARCHER_EVENT_NAME_74: "Turbína vysavače 4",
    KARCHER_EVENT_NAME_75: "Filtr vysavače 4",
    KARCHER_EVENT_NAME_76: "Turbína vysavače 5",
    KARCHER_EVENT_NAME_77: "Filtr vysavače 5",
    KARCHER_EVENT_NAME_78: "Turbína vysavače 6",
    KARCHER_EVENT_NAME_79: "Filtr vysavače 6",
    KARCHER_EVENT_NAME_80: "Turbína vysavače 7",
    KARCHER_EVENT_NAME_81: "Filtr vysavače 7",
    KARCHER_EVENT_NAME_82: "Turbína vysavače 8",
    KARCHER_EVENT_NAME_83: "Filtr vysavače 8",
    KARCHER_EVENT_NAME_84: "Turbína vysavače 9",
    KARCHER_EVENT_NAME_85: "Filtr vysavače 9",
    KARCHER_EVENT_NAME_86: "Turbína vysavače 10",
    KARCHER_EVENT_NAME_87: "Filtr vysavače 10",
    KARCHER_EVENT_NAME_88: "Turbína vysavače 11",
    KARCHER_EVENT_NAME_89: "Filtr vysavače 11",
    KARCHER_EVENT_NAME_90: "Turbína vysavače 12",
    KARCHER_EVENT_NAME_91: "Filtr vysavače 12",
    INSERT_TOKEN: "Vložte tokeny a spusťte službu",
    OPEN_SESSION: "Relace byla úspěšně otevřena",
    IN_PROGRESS: "Probíhá ...",
    TOKEN_INSERTED: "Tokeny byly úspěšně vloženy",
    EXPIRED_SESSION: "Relace vypršela",
    TWO_DIGIT_INTEGER_VALIDATION: "Použijte maximálně dvoumístné celé číslo",
    KARCHER_OPERATION_COUNTER_1: "Mytí stanice 1 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_2: "Mytí stanice 1 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_3: "Mytí stanice 1 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_4: "Mytí stanice 1 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_5: "Mytí stanice 1 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_6: "Mytí stanice 2 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_7: "Mytí stanice 2 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_8: "Mytí stanice 2 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_9: "Mytí stanice 2 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_10: "Mytí stanice 2 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_11: "Mytí stanice 3 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_12: "Mytí stanice 3 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_13: "Mytí stanice 3 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_14: "Mytí stanice 3 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_15: "Mytí stanice 3 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_16: "Mytí stanice 4 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_17: "Mytí stanice 4 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_18: "Mytí stanice 4 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_19: "Mytí stanice 4 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_20: "Mytí stanice 4 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_21: "Mytí stanice 5 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_22: "Mytí stanice 5 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_23: "Mytí stanice 5 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_24: "Mytí stanice 5 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_25: "Mytí stanice 5 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_26: "Mytí stanice 6 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_27: "Mytí stanice 6 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_28: "Mytí stanice 6 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_29: "Mytí stanice 6 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_30: "Mytí stanice 6 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_31: "Mytí stanice 7 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_32: "Mytí stanice 7 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_33: "Mytí stanice 7 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_34: "Mytí stanice 7 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_35: "Mytí stanice 7 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_36: "Mytí stanice 8 HP čerpadlo",
    KARCHER_OPERATION_COUNTER_37: "Mytí stanice 8 chemické čerpadlo 1",
    KARCHER_OPERATION_COUNTER_38: "Mytí stanice 8 chemické čerpadlo 2",
    KARCHER_OPERATION_COUNTER_39: "Mytí stanice 8 chemické čerpadlo 3",
    KARCHER_OPERATION_COUNTER_40: "Mytí stanice 8 chemické čerpadlo 4",
    KARCHER_OPERATION_COUNTER_41: "Osmotické čerpadlo",
    KARCHER_OPERATION_COUNTER_42: "Generátor horké vody",
    KARCHER_OPERATION_COUNTER_43: "Čerpadlo na ochranu proti mrazu",
    KARCHER_OPERATION_COUNTER_44: "WSO filtr",
    KARCHER_OPERATION_COUNTER_45: "Čerpadlo vyhřívání mycí stanice",
    KARCHER_OPERATION_COUNTER_46: "Čerpadlo horké vody",
    KARCHER_OPERATION_COUNTER_47: "Vyhřívání hadice na pěnu",
    KARCHER_OPERATION_COUNTER_48: "Čerpadlo na mytí kol",
    KARCHER_OPERATION_COUNTER_49: "Mikro-emulzní čerpadlo",
    KARCHER_OPERATION_COUNTER_50: "Čerpadlo na intenzivní pěnu",
    KARCHER_OPERATION_COUNTER_51: "Vysavač 1 turbína 1",
    KARCHER_OPERATION_COUNTER_52: "Vysavač 1 filtr 1",
    KARCHER_OPERATION_COUNTER_53: "Vysavač 1 turbína 2",
    KARCHER_OPERATION_COUNTER_54: "Vysavač 1 filtr 2",
    KARCHER_OPERATION_COUNTER_55: "Vysavač 2 turbína 1",
    KARCHER_OPERATION_COUNTER_56: "Vysavač 2 filtr 1",
    KARCHER_OPERATION_COUNTER_57: "Vysavač 2 turbína 2",
    KARCHER_OPERATION_COUNTER_58: "Vysavač 2 filtr 2",
    KARCHER_OPERATION_COUNTER_59: "Vysavač 3 turbína 1",
    KARCHER_OPERATION_COUNTER_60: "Vysavač 3 filtr 1",
    KARCHER_OPERATION_COUNTER_61: "Vysavač 3 turbína 2",
    KARCHER_OPERATION_COUNTER_62: "Vysavač 3 filtr 2",
    KARCHER_OPERATION_COUNTER_63: "Vysavač 4 turbína 1",
    KARCHER_OPERATION_COUNTER_64: "Vysavač 4 filtr 1",
    KARCHER_OPERATION_COUNTER_65: "Vysavač 4 turbína 2",
    KARCHER_OPERATION_COUNTER_66: "Vysavač 4 filtr 2",
    KARCHER_OPERATION_COUNTER_67: "Vysavač 5 turbína 1",
    KARCHER_OPERATION_COUNTER_68: "Vysavač 5 filtr 1",
    KARCHER_OPERATION_COUNTER_69: "Vysavač 5 turbína 2",
    KARCHER_OPERATION_COUNTER_70: "Vysavač 5 filtr 2",
    KARCHER_OPERATION_COUNTER_71: "Vysavač 6 turbína 1",
    KARCHER_OPERATION_COUNTER_72: "Vysavač 6 filtr 1",
    KARCHER_OPERATION_COUNTER_73: "Vysavač 6 turbína 2",
    KARCHER_OPERATION_COUNTER_74: "Vysavač 6 filtr 2",
    KARCHER_OPERATION_COUNTER_75: "Odvod kondenzátu z kompresoru",
    KARCHER_OPERATION_COUNTER_76: "Zkontrolujte ochranu proti mrazu",
    KARCHER_OPERATION_COUNTER_77: "Ventilátor hořáku",
    KARCHER_OPERATION_COUNTER_78: "Posilovací čerpadlo pěny",
    DOWNLOAD_CSV_LARGE_DATA_WARNING: "Seznam dat je větší než 10000 položek",
    KARCHER_POINT_NAME_1: "Svátek",
    KARCHER_POINT_NAME_2: "Pondělí",
    KARCHER_POINT_NAME_3: "Úterý",
    KARCHER_POINT_NAME_4: "Středa",
    KARCHER_POINT_NAME_5: "Čtvrtek",
    KARCHER_POINT_NAME_6: "Pátek",
    KARCHER_POINT_NAME_7: "Sobota",
    KARCHER_POINT_NAME_8: "Neděle",
    KARCHER_POINT_NAME_9: "Vysavače Svátek",
    KARCHER_POINT_NAME_10: "Vysavače Pondělí",
    KARCHER_POINT_NAME_11: "Vysavače Úterý",
    KARCHER_POINT_NAME_12: "Vysavače Středa",
    KARCHER_POINT_NAME_13: "Vysavače Čtvrtek",
    KARCHER_POINT_NAME_14: "Vysavače Pátek",
    KARCHER_POINT_NAME_15: "Vysavače Sobota",
    KARCHER_POINT_NAME_16: "Vysavače Neděle",
    KARCHER_POINT_NAME_17: "Osvětlení Svátek",
    KARCHER_POINT_NAME_18: "Osvětlení Pondělí",
    KARCHER_POINT_NAME_19: "Osvětlení Úterý",
    KARCHER_POINT_NAME_20: "Osvětlení Středa",
    KARCHER_POINT_NAME_21: "Osvětlení Čtvrtek",
    KARCHER_POINT_NAME_22: "Osvětlení Pátek",
    KARCHER_POINT_NAME_23: "Osvětlení Sobota",
    KARCHER_POINT_NAME_24: "Osvětlení Neděle",
    KARCHER_POINT_NAME_25: "Program 0",
    KARCHER_POINT_NAME_26: "Program 1",
    KARCHER_POINT_NAME_27: "Program 2",
    KARCHER_POINT_NAME_28: "Program 3",
    KARCHER_POINT_NAME_29: "Program 4",
    KARCHER_POINT_NAME_30: "Program 5",
    KARCHER_POINT_NAME_31: "Program 6",
    KARCHER_POINT_NAME_32: "Program 7",
    KARCHER_POINT_NAME_33: "Program 8",
    KARCHER_POINT_NAME_34: "Program 9",
    KARCHER_POINT_NAME_35: "Program 10",
    KARCHER_POINT_NAME_36: "Program 11",
    KARCHER_POINT_NAME_37: "Program 12",
    KARCHER_POINT_NAME_38: "Program 13",
    KARCHER_POINT_NAME_39: "Program 14",
    KARCHER_POINT_NAME_40: "Program 15",
    KARCHER_POINT_NAME_41: "Program 16",
    KARCHER_POINT_NAME_42: "Program 17",
    KARCHER_POINT_NAME_43: "Program 18",
    KARCHER_POINT_NAME_44: "Program 19",
    KARCHER_POINT_NAME_45: "Program 20",
    KARCHER_POINT_NAME_46: "Program 21",
    KARCHER_POINT_NAME_47: "Program 22",
    KARCHER_POINT_NAME_48: "Program 23",
    KARCHER_POINT_NAME_49: "Program 24",
    KARCHER_POINT_NAME_50: "Program 25",
    KARCHER_POINT_NAME_51: "Program 26",
    KARCHER_POINT_NAME_52: "Program 27",
    KARCHER_POINT_NAME_53: "Program 28",
    KARCHER_POINT_NAME_54: "Program 29",
    KARCHER_POINT_NAME_55: "Program 30",
    KARCHER_POINT_NAME_56: "Program 31",
    KARCHER_POINT_NAME_57: "Program 32",
    QR_CODE: "QR kód",
    ACCEPT_TERMS_AND_CONDITIONS: "Přijmout smluvní podmínky",
    CREATE_AND_PRINT_VOUCHERS: "Vytvořte a vytiskněte poukazy",
    CODE_PREFIX_QUESTION: "Předpona kódu není zadána",
    CODE_PREFIX_QUESTION_TEXT: "Chcete pokračovat bez předpony kódu?",
    ISSUED_DATE: "Datum vydání",
    VOUCHER_VALIDITY_DAYS: "Platnost poukazu (dny)",
    VALIDATION_ONLY_NUMBERS: "Jsou povolena pouze čísla",
    REPRINT_VOUCHERS: "Vytisknout kopii poukazů",
    EXPIRY_DATE: "Platí do"
  });
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('webSocketsStore', webSocketsStoreFactory);

  /** @ngInject */
  function webSocketsStoreFactory (dispatcher, EventEmitter, ActionTypesEnum) {
    var WebSocketsStore = new EventEmitter(),
      /* eslint-disable */
      dataImmutable = Immutable.fromJS({
        connected: false
      });
      /* eslint-enable */
    WebSocketsStore.events = Object.freeze({
      CONNECTED_CHANGE: 'connected_change',
      DEVICE_FEED_CHANGE: 'device_feed_change',
      DEVICE_ACTUATOR_CHANGE: 'device_actuator_change',
      DEVICE_STATE_CHANGE: 'device_state_change',
      MESSAGES_UPDATE_AVAILABLE: 'messages_update_available',
      DAILY_FINANCES_CHANGE: 'daily_finances_change',
      NOTICE_CHANGE: 'notice_change',
      DEVICE_EVENT_CHANGE: 'device_event_change'
    });

    WebSocketsStore.isConnected = function () {
      return dataImmutable.toJSON().connected;
    };

    WebSocketsStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.CONNECTED_CHANGE:
          var data = dataImmutable.toJSON();
          data.connected = actionData.payload;
          /* eslint-disable */
          dataImmutable = Immutable.fromJS(data);
          /* eslint-enable */
          WebSocketsStore.emit(WebSocketsStore.events.CONNECTED_CHANGE, dataImmutable.get("connected"));
          break;
        case ActionTypesEnum.DEVICE_FEED_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DEVICE_FEED_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.DEVICE_ACTUATOR_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DEVICE_ACTUATOR_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.DEVICE_STATE_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DEVICE_STATE_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.MESSAGES_UPDATE_AVAILABLE:
          WebSocketsStore.emit(WebSocketsStore.events.MESSAGES_UPDATE_AVAILABLE, actionData.payload);
          break;
        case ActionTypesEnum.DAILY_FINANCES_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DAILY_FINANCES_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.NOTICE_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.NOTICE_CHANGE, actionData.payload);
          break;
        case ActionTypesEnum.DEVICE_EVENT_CHANGE:
          WebSocketsStore.emit(WebSocketsStore.events.DEVICE_EVENT_CHANGE, actionData.payload);
          break;
      }
    });

    return WebSocketsStore;
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('reportsFilterStore', reportsFilterStoreFactory);

  /** @ngInject */
  function reportsFilterStoreFactory (dispatcher, EventEmitter, DateTime, ActionTypesEnum) {
    var ReportFiltersStore = new EventEmitter(),
      filterDataImmutable = Immutable.fromJS({
        fromTimestamp: new DateTime().startOf(DateTime.units.MONTH).timestamp,
        toTimestamp: new DateTime().endOf(DateTime.units.DAY).timestamp,
        selectedFacilitySerial: null,
        period1From: 1,
        period1To: 12,
        period2From: moment().year(),
        period2To: moment().year() - 1,
        period3From: 0,
        period3To: 24,
        currency: 'EUR'
      });

    ReportFiltersStore.events = Object.freeze({
      CHANGE: 'change'
    });

    ReportFiltersStore.getFilterData = function () {
      return filterDataImmutable !== null
        ? filterDataImmutable.toJSON()
        : null;
    };

    ReportFiltersStore.dispatchToken = dispatcher.register(function (actionData) {
      var updatedData = filterDataImmutable.toJSON();

      switch (actionData.type) {

        case ActionTypesEnum.UPDATE_REPORT_FILTER:

          if (actionData.payload.fromTimestamp) {
            updatedData.fromTimestamp = actionData.payload.fromTimestamp;
          }
          if (actionData.payload.toTimestamp) {
            updatedData.toTimestamp = actionData.payload.toTimestamp;
          }
          if (actionData.payload.selectedFacilitySerial) {
            updatedData.selectedFacilitySerial = actionData.payload.selectedFacilitySerial;
          }
          if (actionData.payload.period1From) {
            updatedData.period1From = actionData.payload.period1From;
          }
          if (actionData.payload.period1To) {
            updatedData.period1To = actionData.payload.period1To;
          }
          if (actionData.payload.period2From) {
            updatedData.period2From = actionData.payload.period2From;
          }
          if (actionData.payload.period2To) {
            updatedData.period2To = actionData.payload.period2To;
          }
          if (actionData.payload.currency) {
            updatedData.currency = actionData.payload.currency;
          }
          if (actionData.payload.period3From !== null || actionData.payload.period3From !== angular.isUndefined) {
            updatedData.period3From = actionData.payload.period3From;
          }
          if (actionData.payload.period3To !== null || actionData.payload.period3To !== angular.isUndefined) {
            updatedData.period3To = actionData.payload.period3To;
          }
          filterDataImmutable = Immutable.fromJS(updatedData);
          ReportFiltersStore.emit(ReportFiltersStore.events.CHANGE);
          break;
      }
    });

    return ReportFiltersStore;
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('messagesStore', messagesStoreFactory);

  /** @ngInject */
  function messagesStoreFactory (dispatcher, EventEmitter, messageActions, ActionTypesEnum) {
    var MessagesStore = new EventEmitter(),
      messagesImmutable = null, messagesKarcherImmutable = null;

    MessagesStore.events = Object.freeze({
      CHANGE: 'change',
      CHANGE_KARCHER: 'change Karcher'
    });

    MessagesStore.getMessages = function () {
      return messagesImmutable !== null
        ? messagesImmutable.toJSON()
        : null;
    };

    MessagesStore.getKarcherMessages = function () {
      return messagesKarcherImmutable !== null
          ? messagesKarcherImmutable.toJSON()
          : null;
    };

    MessagesStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.GET_ALARM_MESSAGES:
          messagesImmutable = Immutable.fromJS(actionData.payload);
          MessagesStore.emit(MessagesStore.events.CHANGE);
          break;
        case ActionTypesEnum.GET_ALARM_KARCHER_MESSAGES:
          messagesKarcherImmutable = Immutable.fromJS(actionData.payload);
          MessagesStore.emit(MessagesStore.events.CHANGE_KARCHER);
          break;
      }
    });

    return MessagesStore;
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('devicesStore', devicesStoreFactory);

  /** @ngInject */
  function devicesStoreFactory (dispatcher, EventEmitter, deviceActions, ActionTypesEnum) {
    var DevicesStore = new EventEmitter(),
      devicesImmutable = null;

    DevicesStore.events = Object.freeze({
      CHANGE: 'change'
    });

    DevicesStore.getDevices = function () {
      return devicesImmutable !== null
        ? devicesImmutable.toJSON()
        : null;
    };

    DevicesStore.getDevice = function () {
      return devicesImmutable !== null
          ? devicesImmutable.toJSON()
          : null;
    };

    DevicesStore.getDeviceBySerial = function (deviceSerial) {
      if (devicesImmutable === null) {
        return null;
      }

      var result = devicesImmutable.toJSON().find(function (deviceJson) {
        return deviceJson.deviceKey === deviceSerial;
      });

      return result ? result : null;
    };

    DevicesStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.GET_DEVICES:
          devicesImmutable = Immutable.fromJS(actionData.payload);
          DevicesStore.emit(DevicesStore.events.CHANGE);
          break;
        case ActionTypesEnum.GET_KARCHER_DEVICE:
          devicesImmutable = Immutable.fromJS(actionData.payload);
          DevicesStore.emit(DevicesStore.events.CHANGE);
          break;
      }
    });

    return DevicesStore;
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('dailyFinancesStore', dailyFinancesStoreFactory);

  /** @ngInject */
  function dailyFinancesStoreFactory (dispatcher, EventEmitter, dailyFinancesActions, ActionTypesEnum) {
    var DailyFinancesStore = new EventEmitter(),
      dailyFinancesImmutable = null;

    DailyFinancesStore.events = Object.freeze({
      CHANGE: 'change'
    });

    DailyFinancesStore.getDailyFinances = function () {
      return dailyFinancesImmutable !== null
        ? dailyFinancesImmutable.toJSON()
        : null;
    };

    DailyFinancesStore.getDailyFinancesBySerialNumber = function (deviceSerialNumber) {
      if (dailyFinancesImmutable === null) {
        return null;
      }

      var result = dailyFinancesImmutable.toJSON().find(function (deviceJson) {
        return deviceJson.deviceSerial === deviceSerialNumber;
      });

      return result ? result : null;
    };

    DailyFinancesStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.GET_DAILY_FINANCES:
              dailyFinancesImmutable = Immutable.fromJS(actionData.payload);
              DailyFinancesStore.emit(DailyFinancesStore.events.CHANGE);
      }
    });

    dailyFinancesActions.getDailyFinances();

    return DailyFinancesStore;
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('applicationStore', applicationStoreFactory);

  /** @ngInject */
  function applicationStoreFactory (dispatcher, EventEmitter, ActionTypesEnum, $translate) {
    var ApplicationStore = new EventEmitter(),
      loaderImmutable = Immutable.fromJS({
        loaderVisible: false,
        hasErrors : false,
        errorName : $translate.instant('DEFAULT_ERROR_NAME'),
        errorDescription : $translate.instant('DEFAULT_ERROR_DESCRIPTION'),
        errorPageMsg : '',
        toasterMsg : ''
      });

    ApplicationStore.events = Object.freeze({
      CHANGE: 'change',
      LOADER_CHANGE: 'loader_change',
      ERROR_STATE_CHANGE : 'error_state_change',
      ERROR_PAGE_STATE_CHANGE : 'error_page_state_change',
      TOAST_CHANGE : 'toast_change'
    });

    ApplicationStore.get = function () {
      return loaderImmutable.toJSON();
    };

    ApplicationStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.SHOW_LOADER:
          loaderImmutable = loaderImmutable.set('loaderVisible', true);
          ApplicationStore.emit(ApplicationStore.events.LOADER_CHANGE, loaderImmutable.get('loaderVisible'));
          break;
        case ActionTypesEnum.HIDE_LOADER:
          loaderImmutable = loaderImmutable.set('loaderVisible', false);
          ApplicationStore.emit(ApplicationStore.events.LOADER_CHANGE, loaderImmutable.get('loaderVisible'));
          break;
        case ActionTypesEnum.SHOW_ERROR_MSG:
          // show error msg and emmit
          loaderImmutable = loaderImmutable.set('hasErrors', true);
          loaderImmutable = loaderImmutable.set('errorName', actionData.payload.errorDescription.error);
          loaderImmutable = loaderImmutable.set('errorDescription', actionData.payload.errorDescription.message);
          ApplicationStore.emit(ApplicationStore.events.ERROR_STATE_CHANGE, loaderImmutable.get('hasErrors'), loaderImmutable.get('errorName'), loaderImmutable.get('errorDescription'));
          break;
        case ActionTypesEnum.HIDE_ERROR_MSG:
          // hide error msg 
          loaderImmutable = loaderImmutable.set('hasErrors', false);
          loaderImmutable = loaderImmutable.set('errorName', '');
          loaderImmutable = loaderImmutable.set('errorDescription', '');
          ApplicationStore.emit(ApplicationStore.events.ERROR_STATE_CHANGE, loaderImmutable.get('hasErrors'), loaderImmutable.get('errorName'), loaderImmutable.get('errorDescription'));
          break;
        case ActionTypesEnum.SHOW_ERROR_PAGE:
          // redirect to error page
          loaderImmutable = loaderImmutable.set('errorPageMsg', actionData.payload.errorPageMsg);
          ApplicationStore.emit(ApplicationStore.events.ERROR_PAGE_STATE_CHANGE, loaderImmutable.get('errorPageMsg'));
          break;
        case ActionTypesEnum.HIDE_ERROR_PAGE:
          // window go back
          ApplicationStore.emit(ApplicationStore.events.ERROR_PAGE_STATE_CHANGE, loaderImmutable.get('errorPageMsg'));
          break;
        case ActionTypesEnum.SHOW_TOASTER_MSG:
          // show toaster
          loaderImmutable = loaderImmutable.set('toasterMsg', actionData.payload.message);
          ApplicationStore.emit(ApplicationStore.events.TOAST_CHANGE, loaderImmutable.get('toasterMsg'));
          break;
      }
    });

    return ApplicationStore;
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").factory("alarmsStore", alarmsStoreFactory);

  /** @ngInject */
  function alarmsStoreFactory(
    dispatcher,
    EventEmitter,
    devicesStore,
    ActionTypesEnum,
    AlarmStateEnum,
    PointTypeEnum,
    modelUtils
  ) {
    var AlarmsStore = new EventEmitter(),
      alarmsImmutable = null;

    AlarmsStore.events = Object.freeze({
      CHANGE: "change"
    });

    AlarmsStore.getAlarms = function () {
      return alarmsImmutable !== null ? alarmsImmutable.toJSON() : null;
    };

    AlarmsStore.getAlarmsParams = function () {
      return alarmsImmutable !== null ? alarmsImmutable.toJSON() : null;
    };

    AlarmsStore.getAlarmsBySerial = function (deviceSerial) {
      return alarmsImmutable !== null
        ? alarmsImmutable.toJSON().find(function (deviceAlarms) {
            return deviceAlarms.deviceSerial === deviceSerial;
          })
        : null;
    };

    AlarmsStore.deleteStore = function () {
      alarmsImmutable = null;
    };

    AlarmsStore.dispatchToken = dispatcher.register(function (actionData) {
      switch (actionData.type) {
        case ActionTypesEnum.GET_DEVICES:
          dispatcher.waitFor([devicesStore.dispatchToken]);
          alarmsImmutable = Immutable.fromJS(normalize(actionData.payload));
          AlarmsStore.emit(AlarmsStore.events.CHANGE);
          break;
        case ActionTypesEnum.GET_ALARM_FROM_DASHBOARD_MESSAGE:
          alarmsImmutable = Immutable.fromJS(actionData.payload);
          AlarmsStore.emit(AlarmsStore.events.CHANGE);
          break;
      }
    });

    return AlarmsStore;

    function normalize(devicesJson) {
      var alarms = [];

      devicesJson.forEach(function (deviceJson) {
        var device = {
          deviceSerial: deviceJson.deviceSerial,
          name: deviceJson.points ? deviceJson.points.find(function (pointJson) {
            return pointJson.pointType === PointTypeEnum.WASH_FACILITY;
          }).name : null,
          alarms: []
        };
        this.push(device);
        findAlarms(device.alarms, deviceJson);
      }, alarms);

      return alarms;
    }

    function findAlarms(resultDeviceAlarms, jsonData) {
      if (jsonData.feeds) {
        jsonData.feeds.forEach(function (feedJson) {
          if (feedJson.alarmState !== AlarmStateEnum.NORMAL) {
            var newAlarm = {
              pointName: jsonData.name
            };
            modelUtils.extendObject(newAlarm, feedJson);
            this.push(newAlarm);
          }
        }, resultDeviceAlarms);
      }

      if (jsonData.points) {
        jsonData.points.forEach(function (pointJson) {
          findAlarms(resultDeviceAlarms, pointJson);
        });
      }
    }
  }
})();

angular.module('sempraWebapp').factory('AppStateService', function () {
  var state = {};

  return {
    getState: function () {
      return state;
    },
    setState: function (key, value) {
      state[key] = value;
    },
    clearState: function () {
      state = {};
    }
  };
});

(function () {
  'use strict';

  angular.module('sempraWebapp').service('washBoxUtils', washBoxUtilsService);

  /** @ngInject */
  function washBoxUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getWashBoxPoint = function (facilityJson, boxName) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.WASH_BOX
          && pointJson.name === boxName;
      });
    };

    this.getWashBoxPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType === PointTypeEnum.WASH_BOX);
      });
    };

    this.getListenerPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType !== PointTypeEnum.WASH_BOX && pointJson.pointType !== PointTypeEnum.SUBSYSTEM);
      });
    };

    this.getListenerWashBoxPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType === PointTypeEnum.WASH_BOX);
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_OTB_PUMPA_GRESKA_MZS: 'OP_OTB_PUMPA_GRESKA_MZS',
      OPW_ALARM_VISOKOTL_PUMPA: 'OPW_ALARM_VISOKOTL_PUMPA',
      OP_CLEAN_BROJ_MIN_RADA: 'OP_CLEAN_BROJ_MIN_RADA',
      OP_CLEAN_BROJ_SATI_RADA: 'OP_CLEAN_BROJ_SATI_RADA',
      OP_VISKTL_BROJ_SATI_RADA: 'OP_VISKTL_BROJ_SATI_RADA',
      OP_VISKTL_RESET_SATI_RADA: 'OP_VISKTL_RESET_SATI_RADA',
      properties: {
        OP_OTB_PUMPA_GRESKA_MZS: getFeedPropertiesObject('OP_OTB_PUMPA_GRESKA_MZS'),
        OPW_ALARM_VISOKOTL_PUMPA: getFeedPropertiesObject('OPW_ALARM_VISOKOTL_PUMPA'),
        OP_CLEAN_BROJ_MIN_RADA: getFeedPropertiesObject('OP_CLEAN_BROJ_MIN_RADA'),
        OP_CLEAN_BROJ_SATI_RADA: getFeedPropertiesObject('OP_CLEAN_BROJ_SATI_RADA'),
        OP_VISKTL_BROJ_SATI_RADA: getFeedPropertiesObject('OP_VISKTL_BROJ_SATI_RADA'),
        OP_VISKTL_RESET_SATI_RADA: getFeedPropertiesObject('OP_VISKTL_RESET_SATI_RADA')
      }

    });

    this.ActuatorReferences = Object.freeze({
      OP_BUTTON_CLEAN: 'OP_BUTTON_CLEAN',
      OP_CC_KOVANICE_RESET: 'OP_CC_KOVANICE_RESET',
      OP_CC_ZETONI_RESET: 'OP_CC_ZETONI_RESET',
      OP_CC_KEY_KREDIT_RESET: 'OP_CC_KEY_KREDIT_RESET',
      OP_BUTTON : 'OP_BUTTON',
      OP_CLEAN_BROJ_SATI_RADA : 'OP_CLEAN_BROJ_SATI_RADA',

      properties: {
        OP_BUTTON_CLEAN: getActuatorPropertiesObject('OP_BUTTON_CLEAN'),
        OP_CC_KOVANICE_RESET: getActuatorPropertiesObject('OP_CC_KOVANICE_RESET'),
        OP_CC_ZETONI_RESET: getActuatorPropertiesObject('OP_CC_ZETONI_RESET'),
        OP_CC_KEY_KREDIT_RESET: getActuatorPropertiesObject('OP_CC_KEY_KREDIT_RESET'),
        OP_BUTTON: getActuatorPropertiesObject('OP_BUTTON'),
        OP_CLEAN_BROJ_SATI_RADA: getActuatorPropertiesObject('OP_CLEAN_BROJ_SATI_RADA')
        }
    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (washBoxPointJson) {
          return modelUtils.getFeedCurrentValue(washBoxPointJson, feedReference);
        },
        getFeed: function (washBoxPointJson) {
          return modelUtils.getFeed(washBoxPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (washBoxPointJson) {
          return modelUtils.getActuatorCurrentValue(washBoxPointJson, actuatorReference);
        },
        getActuator: function (washBoxPointJson) {
          return modelUtils.getActuator(washBoxPointJson, actuatorReference);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('washBoxKarcherUtils', washBoxKarcherUtilsService);

  /** @ngInject */
  function washBoxKarcherUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getWashBoxPoint = function (facilityJson, boxName) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.KARCHER_WASH_BOX
          && pointJson.name === boxName;
      });
    };

    this.getWashBoxPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType === PointTypeEnum.KARCHER_WASH_BOX);
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferencesProperties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferencesProperties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = {
      TURNOVER: 'TURNOVER',
      TURNOVER_MANUAL_TOKEN: 'TURNOVER_MANUAL_TOKEN',
      STATUS_BAY_AVAILABILITY: 'STATUS_BAY_AVAILABILITY',
      STATUS_BAY_RUN_TIME: 'STATUS_BAY_RUN_TIME',
      STATUS_BAY_CREDIT: 'STATUS_BAY_CREDIT',
      STATUS_BAY_ACTIVE_PROGRAM_ID: 'STATUS_BAY_ACTIVE_PROGRAM_ID',
      STATUS_BAY_ACTIVE_PROGRAM_NAME: 'STATUS_BAY_ACTIVE_PROGRAM_NAME',
      PUMP_TYPE: 'PUMP_TYPE',
      OP_CC_ZETONI: 'OP_CC_ZETONI',
      OP_CC_KOVANICE: 'OP_CC_KOVANICE'
    };

    this.FeedReferencesProperties = {
      TURNOVER: getFeedPropertiesObject('TURNOVER'),
      TURNOVER_MANUAL_TOKEN: getFeedPropertiesObject('TURNOVER_MANUAL_TOKEN'),
      STATUS_BAY_AVAILABILITY: getFeedPropertiesObject('STATUS_BAY_AVAILABILITY'),
      STATUS_BAY_RUN_TIME: getFeedPropertiesObject('STATUS_BAY_RUN_TIME'),
      STATUS_BAY_CREDIT: getFeedPropertiesObject('STATUS_BAY_CREDIT'),
      STATUS_BAY_ACTIVE_PROGRAM_ID: getFeedPropertiesObject('STATUS_BAY_ACTIVE_PROGRAM_ID'),
      STATUS_BAY_ACTIVE_PROGRAM_NAME: getFeedPropertiesObject('STATUS_BAY_ACTIVE_PROGRAM_NAME'),
      PUMP_TYPE: getFeedPropertiesObject('PUMP_TYPE'),
      OP_CC_ZETONI: getFeedPropertiesObject('OP_CC_ZETONI'),
      OP_CC_KOVANICE: getFeedPropertiesObject('OP_CC_KOVANICE')
    }

    this.ActuatorReferences = Object.freeze({
      OP_BUTTON: 'OP_BUTTON',
      DISABLED: 'DISABLED',
      properties: {
        OP_BUTTON: getActuatorPropertiesObject('OP_BUTTON'),
        DISABLED: getActuatorPropertiesObject('DISABLED')
      }
    });

    // Setting dynamic references - begin ====================================================================================================

    var programName = 'PROGRAM_NAME_', programCounter = 'PROGRAM_COUNTER_',
        washBoxId = 'SETUP_UNIT_BAY_PROGRAM_ID_', washBoxProgramName = 'SETUP_UNIT_BAY_PROGRAM_NAME_',

    // ----------------
        i, j;

    for(i=0; i<8; i++) {
      this.FeedReferences[programName + i] = programName + i;
      this.FeedReferences[programCounter + i] = programCounter + i;
      this.FeedReferencesProperties[programName + i] = getFeedPropertiesObject(programName + i);
      this.FeedReferencesProperties[programCounter + i] = getFeedPropertiesObject(programCounter + i);
    }

    for(j=0; j<12; j++) {
      this.FeedReferences[washBoxId + j] = washBoxId + j;
      this.FeedReferences[washBoxProgramName + j] = washBoxProgramName + j;
      this.FeedReferencesProperties[washBoxId + j] = getFeedPropertiesObject(washBoxId + j);
      this.FeedReferencesProperties[washBoxProgramName + j] = getFeedPropertiesObject(washBoxProgramName + j);
    }

    // Setting dynamic references - end ====================================================================================================

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (washBoxPointJson) {
          return modelUtils.getFeedCurrentValue(washBoxPointJson, feedReference);
        },
        getFeed: function (washBoxPointJson) {
          return modelUtils.getFeed(washBoxPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (washBoxPointJson) {
          return modelUtils.getActuatorCurrentValue(washBoxPointJson, actuatorReference);
        },
        getActuator: function (washBoxPointJson) {
          return modelUtils.getActuator(washBoxPointJson, actuatorReference);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('vacuumKarcherUtils', vacuumKarcherUtilsService);

  /** @ngInject */
  function vacuumKarcherUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getVacuumPoint = function (facilityJson, boxName) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.KARCHER_VACUUM
          && pointJson.name === boxName;
      });
    };

    this.getVacuumPoints = function (facilityJson) {
      return facilityJson.points.filter(function (pointJson) {
        return (pointJson.pointType === PointTypeEnum.KARCHER_VACUUM);
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferencesProperties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferencesProperties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = {
      STATUS_VACUUM_AVAILABLE: 'STATUS_VACUUM_AVAILABLE',
      STATUS_VACUUM_RUN_TIME: 'STATUS_VACUUM_RUN_TIME',
      TURNOVER_MANUAL_TOKEN: 'TURNOVER_MANUAL_TOKEN',
      TURNOVER: 'TURNOVER'
    };

    this.FeedReferencesProperties = {
      STATUS_VACUUM_AVAILABLE: getFeedPropertiesObject('STATUS_VACUUM_AVAILABLE'),
      STATUS_VACUUM_RUN_TIME: getFeedPropertiesObject('STATUS_VACUUM_RUN_TIME'),
      TURNOVER_MANUAL_TOKEN: getFeedPropertiesObject('TURNOVER_MANUAL_TOKEN'),
      TURNOVER: getFeedPropertiesObject('TURNOVER')
    }

    this.ActuatorReferences = Object.freeze({
      OP_BUTTON: 'OP_BUTTON',
      properties: {
        OP_BUTTON: getActuatorPropertiesObject('OP_BUTTON')
      }
    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (vacuumPointJson) {
          return modelUtils.getFeedCurrentValue(vacuumPointJson, feedReference);
        },
        getFeed: function (vacuumPointJson) {
          return modelUtils.getFeed(vacuumPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (vacuumPointJson) {
          return modelUtils.getActuatorCurrentValue(vacuumPointJson, actuatorReference);
        },
        getActuator: function (vacuumPointJson) {
          return modelUtils.getActuator(vacuumPointJson, actuatorReference);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('tapWaterSubsystemUtils', tapWaterSubsystemUtilsService);

  /** @ngInject */
  function tapWaterSubsystemUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getTapWaterSubsystemPoint = function (facilityJson) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.SUBSYSTEM
          && pointJson.name === PointTypeEnum.properties.NAMES.TAP_WATER;
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_MIN_NIVO_PITKA_VODA: 'OP_MIN_NIVO_PITKA_VODA',
      OP_CRPKA_PITKE_VODE_GRE_MZS: 'OP_CRPKA_PITKE_VODE_GRE_MZS',
      OP_MAX_NIVO_PITKA_VODA: 'OP_MAX_NIVO_PITKA_VODA',
      OP_TLAK_PITKA_VODA: 'OP_TLAK_PITKA_VODA',
      OP_CRPKA_PITKE_VODE_RAD: 'OP_CRPKA_PITKE_VODE_RAD',
      OP_EMV_SPR_PITKA_VODA: 'OP_EMV_SPR_PITKA_VODA',
      OP_BUTTON_6M6_BR_RESET: 'OP_BUTTON_6M6_BR_RESET',
      OP_CPV_6M6_BROJ_SATI_RADA: 'OP_CPV_6M6_BROJ_SATI_RADA',
      properties: {
        OP_MIN_NIVO_PITKA_VODA: getFeedPropertiesObject('OP_MIN_NIVO_PITKA_VODA'),
        OP_CRPKA_PITKE_VODE_GRE_MZS: getFeedPropertiesObject('OP_CRPKA_PITKE_VODE_GRE_MZS'),
        OP_MAX_NIVO_PITKA_VODA: getFeedPropertiesObject('OP_MAX_NIVO_PITKA_VODA'),
        OP_TLAK_PITKA_VODA: getFeedPropertiesObject('OP_TLAK_PITKA_VODA'),
        OP_CRPKA_PITKE_VODE_RAD: getFeedPropertiesObject('OP_CRPKA_PITKE_VODE_RAD'),
        OP_EMV_SPR_PITKA_VODA: getFeedPropertiesObject('OP_EMV_SPR_PITKA_VODA'),
        OP_BUTTON_6M6_BR_RESET: getFeedPropertiesObject('OP_BUTTON_6M6_BR_RESET'),
        OP_CPV_6M6_BROJ_SATI_RADA: getFeedPropertiesObject('OP_CPV_6M6_BROJ_SATI_RADA')
      }
    });

    this.ActuatorReferences = Object.freeze({

    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getFeedCurrentValue(facilityPointJson, feedReference);
        },
        getFeed: function (facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      }
    }
    //
    //function getActuatorPropertiesObject (actuatorReference) {
    //  return {
    //    getValue: function (facilityPointJson) {
    //      return modelUtils.getActuatorCurrentValue(facilityPointJson, actuatorReference);
    //    },
    //    getActuator: function (facilityPointJson) {
    //      return modelUtils.getActuator(facilityPointJson, actuatorReference);
    //    }
    //  }
    //}
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('softenedWaterSubsystemUtils', softenedWaterSubsystemUtilsService);

  /** @ngInject */
  function softenedWaterSubsystemUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getSoftenedWaterSubsystemPoint = function (facilityJson) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.SUBSYSTEM
          && pointJson.name === PointTypeEnum.properties.NAMES.SOFTENED_WATER;
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_MIN_NIVO_OMEKS_VODE: 'OP_MIN_NIVO_OMEKS_VODE',
      OP_CRPKA_OMEKS_VODE_GRE_MZS: 'OP_CRPKA_OMEKS_VODE_GRE_MZS',
      OP_MAX_NIVO_OMEKS_VODE: 'OP_MAX_NIVO_OMEKS_VODE',
      OP_TLAK_OMEKSANE_VODE: 'OP_TLAK_OMEKSANE_VODE',
      OP_CRPKA_OMEKS_VODE_RAD: 'OP_CRPKA_OMEKS_VODE_RAD',
      OP_EMV_SPR_OMEKSANA_VODA: 'OP_EMV_SPR_OMEKSANA_VODA',
      OP_BUTTON_7M6_BR_RESET: 'OP_BUTTON_7M6_BR_RESET',
      OP_COV_7M6_BROJ_SATI_RADA: 'OP_COV_7M6_BROJ_SATI_RADA',
      properties: {
        OP_MIN_NIVO_OMEKS_VODE: getFeedPropertiesObject('OP_MIN_NIVO_OMEKS_VODE'),
        OP_CRPKA_OMEKS_VODE_GRE_MZS: getFeedPropertiesObject('OP_CRPKA_OMEKS_VODE_GRE_MZS'),
        OP_MAX_NIVO_OMEKS_VODE: getFeedPropertiesObject('OP_MAX_NIVO_OMEKS_VODE'),
        OP_TLAK_OMEKSANE_VODE: getFeedPropertiesObject('OP_TLAK_OMEKSANE_VODE'),
        OP_CRPKA_OMEKS_VODE_RAD: getFeedPropertiesObject('OP_CRPKA_OMEKS_VODE_RAD'),
        OP_EMV_SPR_OMEKSANA_VODA: getFeedPropertiesObject('OP_EMV_SPR_OMEKSANA_VODA'),
        OP_BUTTON_7M6_BR_RESET: getFeedPropertiesObject('OP_BUTTON_7M6_BR_RESET'),
        OP_COV_7M6_BROJ_SATI_RADA: getFeedPropertiesObject('OP_COV_7M6_BROJ_SATI_RADA')
      }
    });

    this.ActuatorReferences = Object.freeze({

    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getFeedCurrentValue(facilityPointJson, feedReference);
        },
        getFeed: function (facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('reverseOsmosisSubsystemUtils', reverseOsmosisSubsystemUtilsService);

  /** @ngInject */
  function reverseOsmosisSubsystemUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getReverseOsmosisSubsystemPoint = function (facilityJson) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.SUBSYSTEM
          && pointJson.name === PointTypeEnum.properties.NAMES.REVERSE_OSMOSIS;
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_CRPKA_REV_OSMOZA_GRE_MZS: 'OP_CRPKA_REV_OSMOZA_GRE_MZS',
      OP_TLAK_REV_OSMOZA: 'OP_TLAK_REV_OSMOZA',
      OP_FWV_REV_OSMOZA: 'OP_FWV_REV_OSMOZA',
      OP_BFV_REV_OSMOZA: 'OP_BFV_REV_OSMOZA',
      OP_CRP_REV_OSMOZA_U_RADU: 'OP_CRP_REV_OSMOZA_U_RADU',
      OP_BUTTON_9M1_BR_RESET: 'OP_BUTTON_9M1_BR_RESET',
      OP_CRO_9M1_BROJ_SATI_RADA: 'OP_CRO_9M1_BROJ_SATI_RADA',
      properties: {
        OP_CRPKA_REV_OSMOZA_GRE_MZS: getFeedPropertiesObject('OP_CRPKA_REV_OSMOZA_GRE_MZS'),
        OP_TLAK_REV_OSMOZA: getFeedPropertiesObject('OP_TLAK_REV_OSMOZA'),
        OP_FWV_REV_OSMOZA: getFeedPropertiesObject('OP_FWV_REV_OSMOZA'),
        OP_BFV_REV_OSMOZA: getFeedPropertiesObject('OP_BFV_REV_OSMOZA'),
        OP_CRP_REV_OSMOZA_U_RADU: getFeedPropertiesObject('OP_CRP_REV_OSMOZA_U_RADU'),
        OP_BUTTON_9M1_BR_RESET: getFeedPropertiesObject('OP_BUTTON_9M1_BR_RESET'),
        OP_CRO_9M1_BROJ_SATI_RADA: getFeedPropertiesObject('OP_CRO_9M1_BROJ_SATI_RADA')
      }
    });

    this.ActuatorReferences = Object.freeze({
      OP_TON_TLAK_REV_OSM: 'OP_TON_TLAK_REV_OSM', // LPS DELAY (MS)
      OP_ZADRSKA_BFV_OSMOZA: 'OP_ZADRSKA_BFV_OSMOZA', // BFV DELAY
      OP_ZADRSKA_CRPKA_OSMOZA: 'OP_ZADRSKA_CRPKA_OSMOZA', // 6M1 DELAY

      properties: {
        OP_TON_TLAK_REV_OSM: getActuatorPropertiesObject('OP_TON_TLAK_REV_OSM'),
        OP_ZADRSKA_BFV_OSMOZA: getActuatorPropertiesObject('OP_ZADRSKA_BFV_OSMOZA'),
        OP_ZADRSKA_CRPKA_OSMOZA: getActuatorPropertiesObject('OP_ZADRSKA_CRPKA_OSMOZA')
      }
    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getFeedCurrentValue(facilityPointJson, feedReference);
        },
        getFeed: function (facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getActuatorCurrentValue(facilityPointJson, actuatorReference);
        },
        getActuator: function (facilityPointJson) {
          return modelUtils.getActuator(facilityPointJson, actuatorReference);
        }
      }
    }

  }
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").service("modelUtils", modelUtilsService);

  /** @ngInject */
  function modelUtilsService(ReadingTypeEnum, ActuatorTypeEnum) {
    this.getPoint = function(pointJson, pointReference) {
      var foundPointJson = findPoint(pointJson, pointReference);
      return foundPointJson ? foundPointJson : null;
    };

    this.getFeedCurrentValue = function(pointJson, feedReference) {
      var foundFeedJson = findFeed(pointJson, feedReference);
      return foundFeedJson
        ? parseFeedCurrentValue(
            foundFeedJson.currentValue,
            foundFeedJson.readingType
          )
        : null;
    };

    this.getFeed = function(pointJson, feedReference) {
      var foundFeedJson = findFeed(pointJson, feedReference);
      return foundFeedJson ? foundFeedJson : null;
    };

    this.parseFeedCurrentValue = function(currentValue, readingType) {
      return parseFeedCurrentValue(currentValue, readingType);
    };

    this.getActuatorCurrentValue = function(pointJson, actuatorReference) {
      var foundActuatorJson = findActuator(pointJson, actuatorReference);
      return foundActuatorJson
        ? parseActuatorCurrentValue(
            foundActuatorJson.value,
            foundActuatorJson.actuatorType
          )
        : null;
    };

    this.getActuator = function(pointJson, actuatorReference) {
      var foundActuatorJson = findActuator(pointJson, actuatorReference);
      return foundActuatorJson ? foundActuatorJson : null;
    };

    this.parseActuatorCurrentValue = function(currentValue, actuatorType) {
      return parseActuatorCurrentValue(currentValue, actuatorType);
    };

    this.parseActuatorCurrentHourValue = function(currentValue) {
      return parseInt(currentValue.substring(0, 2));
    };

    this.parseActuatorCurrentMinuteValue = function(currentValue) {
      return parseInt(currentValue.substring(2, 4));
    };

    this.parseActuatorRangeValue = function(currentValue, actuatorType) {
      return parseActuatorRangeValue(currentValue, actuatorType);
    };

    this.extendObject = function() {
      angular.extend.apply(this, arguments);
    };

    this.copyObject = function() {
      angular.copy.apply(this, arguments);
    };

    this.extendArray = function(
      arrayDest,
      arraySrc,
      constructor,
      destIdentifierKey,
      srcIdentifierKey
    ) {
      //remove no longer available in source
      arrayDest.forEach(function(dstItem, dstItemIndex) {
        var foundSrcItem = arraySrc.find(function(srcItem) {
          return dstItem[destIdentifierKey] === srcItem[srcIdentifierKey];
        });

        if (typeof foundSrcItem === "undefined") {
          arrayDest.splice(dstItemIndex, 1);
        }
      });

      //add-update existing in source
      if (arraySrc !== null) {
        arraySrc.forEach(function(srcItem) {
          var foundDstItem = arrayDest.find(function(dstItem) {
            return dstItem[destIdentifierKey] === srcItem[srcIdentifierKey];
          });

          if (foundDstItem) {
            if (isFunction(foundDstItem.refresh)) {
              foundDstItem.refresh(srcItem);
            } else {
              foundDstItem = srcItem;
            }
          } else {
            if (isFunction(constructor)) {
              arrayDest.push(new constructor(srcItem));
            } else {
              arrayDest.push(srcItem);
            }
          }
        });
      }
    };

    function findPoint(pointJson, pointReference) {
      return pointJson.points.find(function(point) {
        return point.reference === pointReference;
      });
    }

    function findFeed(pointJson, feedReference) {
      return pointJson.feeds.find(function(feed) {
        return feed.reference === feedReference;
      });
    }

    function findActuator(pointJson, actuatorReference) {
      return pointJson.actuators.find(function(actuator) {
        return actuator.reference === actuatorReference;
      });
    }

    // function findSubSystemActuator(pointJson, actuatorReference){
    //   return pointJson.points.find(function (actuator) {
    //     return actuator.reference === actuatorReference;
    //   });
    // }

    function parseFeedCurrentValue(currentValue, readingType) {
      return ReadingTypeEnum.properties[readingType].parse(currentValue);
    }

    function parseActuatorCurrentValue(currentValue, actuatorType) {
      return ActuatorTypeEnum.properties[actuatorType].parseValue(currentValue);
    }

    function parseActuatorRangeValue(rangeValue, actuatorType) {
      return ActuatorTypeEnum.properties[actuatorType].parseRange(rangeValue);
    }

    function isFunction(obj) {
      return !!(obj && obj.constructor && obj.call && obj.apply);
    }
  }
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").service("facilityUtils", facilityUtilsService);

  /** @ngInject */
  function facilityUtilsService(PointTypeEnum, modelUtils) {
    var that = this;

    this.getFacilityPoint = function(deviceJson) {
      deviceJson.point.deviceType = deviceJson.deviceType;
      return deviceJson.point;
      //return deviceJson.points.find(function (pointJson) {
      //  return pointJson.pointType === PointTypeEnum.WASH_FACILITY;
      //});
    };

    this.getFeedValue = function(pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function(pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function(pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(
        pointJson
      );
    };

    this.getActuator = function(pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(
        pointJson
      );
    };

    this.getTariffs = function(pointJson) {
      return pointJson.actuators.filter(function(actuator) {
        if (actuator.reference.includes("TARIFA")) {
          return actuator;
        }
      });
    };

    //this.isLightCurrentlyOn = function (facilityPoint) {
    //  //todo implement logic based on auto-rucno, rasvjetarad
    //  return that.getFeedValue(facilityPoint, that.FeedReferences.OP_RASVJETA_RAD);
    //};
    //
    //this.areGroupsCurrentlyOn = function (facilityPoint) {
    //  //todo implement logic based on auto-rucno, grupeOn
    //  return that.getActuatorValue(facilityPoint, that.ActuatorReferences.OP_BUTTON_GRUPE_ON);
    //};

    this.FeedReferences = Object.freeze({
      OP_NESTANAK_NAPONA: "OP_NESTANAK_NAPONA",
      OP_UPR_NAPON_24VAC_GRE: "OP_UPR_NAPON_24VAC_GRE",
      OP_BOJLER_GRESKA_MZS: "OP_BOJLER_GRESKA_MZS",
      OP_USIS_KOV_TURBINA_GRESKA: "OP_USIS_KOV_TURBINA_GRESKA",
      OP_FILTER_VODE_ZACEPLJEN: "OP_FILTER_VODE_ZACEPLJEN",
      OPW_ALARM_FILTER_SERVIS: "OPW_ALARM_FILTER_SERVIS",
      OPW_ALARM_BOJLER_SERVIS: "OPW_ALARM_BOJLER_SERVIS",
      OP_RASVJETA_RAD: "OP_RASVJETA_RAD",
      OP_TEMPERATURA_MJERENA: "OP_TEMPERATURA_MJERENA",
      OP_TARIFE_SCHEDULE_ACTIVE_Q: "OP_TARIFE_SCHEDULE_ACTIVE_Q",
      properties: {
        OP_NESTANAK_NAPONA: getFeedPropertiesObject("OP_NESTANAK_NAPONA"),
        OP_UPR_NAPON_24VAC_GRE: getFeedPropertiesObject(
          "OP_UPR_NAPON_24VAC_GRE"
        ),
        OP_BOJLER_GRESKA_MZS: getFeedPropertiesObject("OP_BOJLER_GRESKA_MZS"),
        OP_USIS_KOV_TURBINA_GRESKA: getFeedPropertiesObject(
          "OP_USIS_KOV_TURBINA_GRESKA"
        ),
        OP_FILTER_VODE_ZACEPLJEN: getFeedPropertiesObject(
          "OP_FILTER_VODE_ZACEPLJEN"
        ),
        OPW_ALARM_FILTER_SERVIS: getFeedPropertiesObject(
          "OPW_ALARM_FILTER_SERVIS"
        ),
        OPW_ALARM_BOJLER_SERVIS: getFeedPropertiesObject(
          "OPW_ALARM_BOJLER_SERVIS"
        ),
        OP_RASVJETA_RAD: getFeedPropertiesObject("OP_RASVJETA_RAD"),
        OP_TEMPERATURA_MJERENA: getFeedPropertiesObject(
          "OP_TEMPERATURA_MJERENA"
        ),
        OP_TARIFE_SCHEDULE_ACTIVE_Q: getFeedPropertiesObject(
          "OP_TARIFE_SCHEDULE_ACTIVE_Q"
        )
      }
    });

    this.ActuatorReferences = Object.freeze({
      OP_BUTTON_RASVJETA_AUTO: "OP_BUTTON_RASVJETA_AUTO",
      OP_BUTTON_RASVJETA_ON: "OP_BUTTON_RASVJETA_ON",
      OP_BUTTON_GRUPE_AUTO: "OP_BUTTON_GRUPE_AUTO",
      OP_BUTTON_GRUPE_ON: "OP_BUTTON_GRUPE_ON",
      OP_BUTTON_ANTISMRZ: "OP_BUTTON_ANTISMRZ",
      OP_TEMPER_ANTISMRZ: "OP_TEMPER_ANTISMRZ",
      OP_FILTER_DANI_RADA: "OP_FILTER_DANI_RADA",
      OP_BOJLER_DANI_RADA: "OP_BOJLER_DANI_RADA",
      OP_BUTTON_REV_OSMOZA: "OP_BUTTON_REV_OSMOZA",
      OP_BUTTON_TEHNOLOGIJA: "OP_BUTTON_TEHNOLOGIJA",
      OP_RASVJETA_STOP: "OP_RASVJETA_STOP",
      OP_RASVJETA_START: "OP_RASVJETA_START",
      OP_SCHED_GRUPE_STOP: "OP_SCHED_GRUPE_STOP",
      OP_SCHED_GRUPE_START: "OP_SCHED_GRUPE_START",
      OP_RASVJ_SCHEDULE_START_HOUR: "OP_RASVJ_SCHEDULE_START_HOUR",
      OP_RASVJ_SCHEDULE_START_MINUTE: "OP_RASVJ_SCHEDULE_START_MINUTE",
      OP_RASVJ_SCHEDULE_STOP_HOUR: "OP_RASVJ_SCHEDULE_STOP_HOUR",
      OP_RASVJ_SCHEDULE_STOP_MINUTE: "OP_RASVJ_SCHEDULE_STOP_MINUTE",
      OP_NAPAJ_SCHEDULE_START_HOUR: "OP_NAPAJ_SCHEDULE_START_HOUR",
      OP_NAPAJ_SCHEDULE_START_MINUTE: "OP_NAPAJ_SCHEDULE_START_MINUTE",
      OP_NAPAJ_SCHEDULE_STOP_HOUR: "OP_NAPAJ_SCHEDULE_STOP_HOUR",
      OP_NAPAJ_SCHEDULE_STOP_MINUTE: "OP_NAPAJ_SCHEDULE_STOP_MINUTE",
      OP_TARIFE_SCHEDULE_START_HOUR: "OP_TARIFE_SCHEDULE_START_HOUR",
      OP_TARIFE_SCHEDULE_START_MINUTE: "OP_TARIFE_SCHEDULE_START_MINUTE",
      OP_TARIFE_SCHEDULE_STOP_HOUR: "OP_TARIFE_SCHEDULE_STOP_HOUR",
      OP_TARIFE_SCHEDULE_STOP_MINUTE: "OP_TARIFE_SCHEDULE_STOP_MINUTE",
      OP_TARIFE_SCHEDULE_BUTTON_ENABLE: "OP_TARIFE_SCHEDULE_BUTTON_ENABLE",
      properties: {
        OP_BUTTON_RASVJETA_AUTO: getActuatorPropertiesObject(
          "OP_BUTTON_RASVJETA_AUTO"
        ),
        OP_BUTTON_RASVJETA_ON: getActuatorPropertiesObject(
          "OP_BUTTON_RASVJETA_ON"
        ),
        OP_BUTTON_GRUPE_AUTO: getActuatorPropertiesObject(
          "OP_BUTTON_GRUPE_AUTO"
        ),
        OP_BUTTON_GRUPE_ON: getActuatorPropertiesObject("OP_BUTTON_GRUPE_ON"),
        OP_BUTTON_ANTISMRZ: getActuatorPropertiesObject("OP_BUTTON_ANTISMRZ"),
        OP_TEMPER_ANTISMRZ: getActuatorPropertiesObject("OP_TEMPER_ANTISMRZ"),
        OP_FILTER_DANI_RADA: getActuatorPropertiesObject("OP_FILTER_DANI_RADA"),
        OP_BOJLER_DANI_RADA: getActuatorPropertiesObject("OP_BOJLER_DANI_RADA"),
        OP_BUTTON_REV_OSMOZA: getActuatorPropertiesObject(
          "OP_BUTTON_REV_OSMOZA"
        ),
        OP_TOP_TLAK_REV_OSM: getActuatorPropertiesObject("OP_TOP_TLAK_REV_OSM"),
        OP_ZADRSKA_BFV_OSMOZA: getActuatorPropertiesObject(
          "OP_ZADRSKA_BFC_OSMOZA"
        ),
        OP_ZADRSKA_CRPKA_OSMOZA: getActuatorPropertiesObject(
          "OP_ZADRSKA_CRPKA_OSMOZA"
        ),
        OP_BUTTON_TEHNOLOGIJA: getActuatorPropertiesObject(
          "OP_BUTTON_TEHNOLOGIJA"
        ),
        OP_RASVJETA_STOP: getActuatorPropertiesObject("OP_RASVJETA_STOP"),
        OP_RASVJETA_START: getActuatorPropertiesObject("OP_RASVJETA_START"),
        OP_SCHED_GRUPE_STOP: getActuatorPropertiesObject("OP_SCHED_GRUPE_STOP"),
        OP_SCHED_GRUPE_START: getActuatorPropertiesObject(
          "OP_SCHED_GRUPE_START"
        ),
        OP_RASVJ_SCHEDULE_START_HOUR: getActuatorPropertiesObject(
          "OP_RASVJ_SCHEDULE_START_HOUR"
        ),
        OP_RASVJ_SCHEDULE_START_MINUTE: getActuatorPropertiesObject(
          "OP_RASVJ_SCHEDULE_START_MINUTE"
        ),
        OP_RASVJ_SCHEDULE_STOP_HOUR: getActuatorPropertiesObject(
          "OP_RASVJ_SCHEDULE_STOP_HOUR"
        ),
        OP_RASVJ_SCHEDULE_STOP_MINUTE: getActuatorPropertiesObject(
          "OP_RASVJ_SCHEDULE_STOP_MINUTE"
        ),
        OP_NAPAJ_SCHEDULE_START_HOUR: getActuatorPropertiesObject(
          "OP_NAPAJ_SCHEDULE_START_HOUR"
        ),
        OP_NAPAJ_SCHEDULE_START_MINUTE: getActuatorPropertiesObject(
          "OP_NAPAJ_SCHEDULE_START_MINUTE"
        ),
        OP_NAPAJ_SCHEDULE_STOP_HOUR: getActuatorPropertiesObject(
          "OP_NAPAJ_SCHEDULE_STOP_HOUR"
        ),
        OP_NAPAJ_SCHEDULE_STOP_MINUTE: getActuatorPropertiesObject(
          "OP_NAPAJ_SCHEDULE_STOP_MINUTE"
        ),
        OP_TARIFE_SCHEDULE_START_HOUR: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_START_HOUR"
        ),
        OP_TARIFE_SCHEDULE_START_MINUTE: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_START_MINUTE"
        ),
        OP_TARIFE_SCHEDULE_STOP_HOUR: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_STOP_HOUR"
        ),
        OP_TARIFE_SCHEDULE_STOP_MINUTE: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_STOP_MINUTE"
        ),
        OP_TARIFE_SCHEDULE_BUTTON_ENABLE: getActuatorPropertiesObject(
          "OP_TARIFE_SCHEDULE_BUTTON_ENABLE"
        )
      }
    });

    function getFeedPropertiesObject(feedReference) {
      return {
        getValue: function(facilityPointJson) {
          return modelUtils.getFeedCurrentValue(
            facilityPointJson,
            feedReference
          );
        },
        getFeed: function(facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      };
    }

    function getActuatorPropertiesObject(actuatorReference) {
      return {
        getValue: function(facilityPointJson) {
          return modelUtils.getActuatorCurrentValue(
            facilityPointJson,
            actuatorReference
          );
        },
        getActuator: function(facilityPointJson) {
          return modelUtils.getActuator(facilityPointJson, actuatorReference);
        }
      };
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('doserSubsystemUtils', doserSubsystemUtilsService);

  /** @ngInject */
  function doserSubsystemUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getDoserSubsystemPoint = function (facilityJson) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.SUBSYSTEM
          && pointJson.name === PointTypeEnum.properties.NAMES.DOSER;
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_CRPKA_PRASKA_GRE_MZS: 'OP_CRPKA_PRASKA_GRE_MZS',
      OP_DOZATOR_PRASKA_GRE_MZS: 'OP_DOZATOR_PRASKA_GRE_MZS',
      OP_VIBRATOR_PRASKA_GRE_MZS: 'OP_VIBRATOR_PRASKA_GRE_MZS',
      OP_MIN_PRASAK_TON_ALARM: 'OP_MIN_PRASAK_TON_ALARM',
      OP_MAX_NIVO_PRASAK: 'OP_MAX_NIVO_PRASAK',
      OP_MIN_NIVO_PRASAK: 'OP_MIN_NIVO_PRASAK',
      OP_CRPKA_PRASKA_RAD: 'OP_CRPKA_PRASKA_RAD',
      OP_DOZATOR_PRASKA_RAD: 'OP_DOZATOR_PRASKA_RAD',
      OP_EMV_SPREMNIK_PRASKA: 'OP_EMV_SPREMNIK_PRASKA',
      OP_BUTTON_11M4_BR_RESET: 'OP_BUTTON_11M4_BR_RESET',
      OP_CPR_11M4_BROJ_SATI_RADA: 'OP_CPR_11M4_BROJ_SATI_RADA',
      properties: {
        OP_CRPKA_PRASKA_GRE_MZS: getFeedPropertiesObject('OP_CRPKA_PRASKA_GRE_MZS'),
        OP_DOZATOR_PRASKA_GRE_MZS: getFeedPropertiesObject('OP_DOZATOR_PRASKA_GRE_MZS'),
        OP_VIBRATOR_PRASKA_GRE_MZS: getFeedPropertiesObject('OP_VIBRATOR_PRASKA_GRE_MZS'),
        OP_MIN_PRASAK_TON_ALARM: getFeedPropertiesObject('OP_MIN_PRASAK_TON_ALARM'),
        OP_MAX_NIVO_PRASAK: getFeedPropertiesObject('OP_MAX_NIVO_PRASAK'),
        OP_MIN_NIVO_PRASAK: getFeedPropertiesObject('OP_MIN_NIVO_PRASAK'),
        OP_CRPKA_PRASKA_RAD: getFeedPropertiesObject('OP_CRPKA_PRASKA_RAD'),
        OP_DOZATOR_PRASKA_RAD: getFeedPropertiesObject('OP_DOZATOR_PRASKA_RAD'),
        OP_EMV_SPREMNIK_PRASKA: getFeedPropertiesObject('OP_EMV_SPREMNIK_PRASKA'),
        OP_BUTTON_11M4_BR_RESET: getFeedPropertiesObject('OP_BUTTON_11M4_BR_RESET'),
        OP_CPR_11M4_BROJ_SATI_RADA: getFeedPropertiesObject('OP_CPR_11M4_BROJ_SATI_RADA')
      }
    });

    this.ActuatorReferences = Object.freeze({
      OP_PRASAK_VRIJEME_RADA: 'OP_PRASAK_VRIJEME_RADA',
      OP_PRASAK_VRIJEME_PAUZE : 'OP_PRASAK_VRIJEME_PAUZE',  // DOSER PAUSE TIME (SEC)
      properties: {
        OP_PRASAK_VRIJEME_RADA: getActuatorPropertiesObject('OP_PRASAK_VRIJEME_RADA'),
        OP_PRASAK_VRIJEME_PAUZE: getActuatorPropertiesObject('OP_PRASAK_VRIJEME_PAUZE')
      }
    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getFeedCurrentValue(facilityPointJson, feedReference);
        },
        getFeed: function (facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      }
    }

    function getActuatorPropertiesObject (actuatorReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getActuatorCurrentValue(facilityPointJson, actuatorReference);
        },
        getActuator: function (facilityPointJson) {
          return modelUtils.getActuator(facilityPointJson, actuatorReference);
        }
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('demiWaterSubsystemUtils', demiWaterSubsystemUtilsService);

  /** @ngInject */
  function demiWaterSubsystemUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getDemiWaterSubsystemPoint = function (facilityJson) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.SUBSYSTEM
          && pointJson.name === PointTypeEnum.properties.NAMES.DEMI_WATER;
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_MIN_NIVO_DEMIN_VODE: 'OP_MIN_NIVO_DEMIN_VODE',
      OP_CRPKA_DEMIN_VODE_GRE_MZS: 'OP_CRPKA_DEMIN_VODE_GRE_MZS',
      OP_MAX_NIVO_DEMIN_VODE: 'OP_MAX_NIVO_DEMIN_VODE',
      OP_TLAK_DEMIN_VODE: 'OP_TLAK_DEMIN_VODE',
      OP_CRPKA_DEMIN_VODE_RAD: 'OP_CRPKA_DEMIN_VODE_RAD',
      OP_BUTTON_8M6_BR_RESET: 'OP_BUTTON_8M6_BR_RESET',
      OP_CDV_8M6_BROJ_SATI_RADA: 'OP_CDV_8M6_BROJ_SATI_RADA',
      properties: {
        OP_MIN_NIVO_DEMIN_VODE: getFeedPropertiesObject('OP_MIN_NIVO_DEMIN_VODE'),
        OP_CRPKA_DEMIN_VODE_GRE_MZS: getFeedPropertiesObject('OP_CRPKA_DEMIN_VODE_GRE_MZS'),
        OP_MAX_NIVO_DEMIN_VODE: getFeedPropertiesObject('OP_MAX_NIVO_DEMIN_VODE'),
        OP_TLAK_DEMIN_VODE: getFeedPropertiesObject('OP_TLAK_DEMIN_VODE'),
        OP_CRPKA_DEMIN_VODE_RAD: getFeedPropertiesObject('OP_CRPKA_DEMIN_VODE_RAD'),
        OP_BUTTON_8M6_BR_RESET: getFeedPropertiesObject('OP_BUTTON_8M6_BR_RESET'),
        OP_CDV_8M6_BROJ_SATI_RADA: getFeedPropertiesObject('OP_CDV_8M6_BROJ_SATI_RADA')
      }
    });

    this.ActuatorReferences = Object.freeze({

    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getFeedCurrentValue(facilityPointJson, feedReference);
        },
        getFeed: function (facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("workingSchedulesActions", workingSchedulesActionsFactory);

  /** @ngInject */
  function workingSchedulesActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    return {
      getSiteHolidays: getSiteHolidays,
      createSiteHolidays: createSiteHolidays,
      updateSiteHolidays: updateSiteHolidays,
      deleteSiteHolidays: deleteSiteHolidays,
      deleteHoliday: deleteHoliday,
      getWorkingSchedules: getWorkingSchedules,
      updateWorkingSchedules: updateWorkingSchedules,
      propagateWorkingSchedules: propagateWorkingSchedules,
      getSiteDetailsById: getSiteDetailsById,
      updateSiteDetails: updateSiteDetails
    };

    function getSiteHolidays(siteId) {
      var deferred = $q.defer();
      api.getSiteHolidays(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function createSiteHolidays(siteId, data) {
      var deferred = $q.defer();
      api.createSiteHolidays(siteId, data).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_HOLIDAY_SUCCESSFULLY_CREATED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function updateSiteHolidays(siteId, data) {
      var deferred = $q.defer();
      api.updateSiteHolidays(siteId, data).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_HOLIDAY_SUCCESSFULLY_UPDATED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function deleteSiteHolidays(siteId) {
      var deferred = $q.defer();
      api.deleteSiteHolidays(siteId).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_HOLIDAY_SUCCESSFULLY_DELETED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function deleteHoliday(siteId, holidayId) {
      var deferred = $q.defer();
      api.deleteHoliday(siteId, holidayId).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("HOLIDAY_SUCCESSFULLY_DELETED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getWorkingSchedules(siteId) {
      var deferred = $q.defer();
      api.getWorkingSchedules(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function updateWorkingSchedules(siteId, data) {
      var deferred = $q.defer();
      api.updateWorkingSchedules(siteId, data).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_HOLIDAY_SUCCESSFULLY_UPDATED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function propagateWorkingSchedules(siteId, path) {
      var deferred = $q.defer();
      api.propagateWorkingSchedules(siteId, path).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("WORKING_SCHEDULES_SUCCESSFULLY_PROPAGATE")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getSiteDetailsById(siteId) {
      var deferred = $q.defer();
      api.getSiteDetailsById(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function updateSiteDetails(siteId, data) {
      var deferred = $q.defer();
      api.updateSiteDetails(siteId, data).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("SITE_DETAILS_SUCCESSFULLY_UPDATED")
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('webSocketActions', webSocketFactory);

  /** @ngInject */
  function webSocketFactory (dispatcher, ActionTypesEnum) {
    return {
      notifyConnectionChange: notifyConnectionChange,
      notifyDeviceChange: notifyDeviceChange,
      notifyDeviceFeedChange: notifyDeviceFeedChange,
      notifyDeviceActuatorChange: notifyDeviceActuatorChange,
      notifyMessagesChange: notifyMessagesChange,
      notifyFinancesChange: notifyFinancesChange,
      notifyNoticeChange: notifyNoticeChange,
      notifyDeviceEventChange: notifyDeviceEventChange
    };

    function notifyConnectionChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.CONNECTED_CHANGE,
        payload: payload
      });
    }

    function notifyDeviceChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DEVICE_STATE_CHANGE,
        payload: payload
      });
    }

    function notifyDeviceFeedChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DEVICE_FEED_CHANGE,
        payload: payload
      });
    }

    function notifyDeviceActuatorChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DEVICE_ACTUATOR_CHANGE,
        payload: payload
      });
    }

    function notifyMessagesChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.MESSAGES_UPDATE_AVAILABLE,
        payload: payload
      });
    }

    function notifyFinancesChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DAILY_FINANCES_CHANGE,
        payload: payload
      });
    }

    function notifyNoticeChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.NOTICE_CHANGE,
        payload: payload
      });
    }

    function notifyDeviceEventChange (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.DEVICE_EVENT_CHANGE,
        payload: payload
      });
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("weatherKarcherActions", weatherKarcherActionsFactory);

  /** @ngInject */
  function weatherKarcherActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum,
    $log
  ) {
    return {
      getCurrentWeather: getCurrentWeather,
      getHistoryWeather: getHistoryWeather
    };

    function getCurrentWeather(latitude, longitude) {
      var deferred = $q.defer();
      api.getCurrentWeather(latitude, longitude).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          $log.error(errorData);
        }
      );

      return deferred.promise;
    }

    function getHistoryWeather(latitude, longitude, from, to) {
      var deferred = $q.defer();
      api.getHistoryWeather(latitude, longitude, from, to).then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            $log.error(errorData);
          }
      );

      return deferred.promise;
    }

  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('voucherActions', voucherActionsFactory);

    /** @ngInject */
    function voucherActionsFactory(api, $q, $translate, dispatcher, ActionTypesEnum) {
        return {
            createLocalTokens: createLocalTokens,
            getVouchersHistory: getVouchersHistory,
            createVouchers: createVouchers,
            vouchersToCSV: vouchersToCSV,
            createAndRetrieveVouchers: createAndRetrieveVouchers
        };

        function createLocalTokens(email, amount) {
            var deferred = $q.defer();
            api.createLocalTokens(email, amount).then(function (data) {
                dispatcher.dispatch({
                    type: ActionTypesEnum.SHOW_TOASTER_MSG,
                    payload: {
                        type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                        message : $translate.instant('ISSUING_LOCAL_TOKENS_SUCCESS') + email
                    }
                });
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function createVouchers(amountTokens, numberOfVouchers, voucherPrefix, expireInDays) {
            var deferred = $q.defer();
            api.createVouchers(amountTokens, numberOfVouchers, voucherPrefix, expireInDays).then(function (data) {

                dispatcher.dispatch({
                    type: ActionTypesEnum.SHOW_TOASTER_MSG,
                    payload: {
                        type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                        message : $translate.instant('CREATING_VOUCHERS_SUCCESS')
                    }
                });

                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function createAndRetrieveVouchers(amountTokens, numberOfVouchers, voucherPrefix, expireInDays) {
            var deferred = $q.defer();
            api.createAndRetrieveVouchers(amountTokens, numberOfVouchers, voucherPrefix, expireInDays).then(function (data) {

                dispatcher.dispatch({
                    type: ActionTypesEnum.SHOW_TOASTER_MSG,
                    payload: {
                        type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                        message : $translate.instant('CREATING_VOUCHERS_SUCCESS')
                    }
                });

                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function getVouchersHistory(page, pageSize, orderBy, order, seriesPrefix) {
            var deferred = $q.defer();
            api.getVouchersHistory(page, pageSize, orderBy, order, seriesPrefix).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function vouchersToCSV(seriesPrefix) {
            var deferred = $q.defer();
            api.vouchersToCSV(seriesPrefix).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }
    }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('userGroupActions', userGroupActionsFactory);

  /** @ngInject */
  function userGroupActionsFactory ($q, api, dispatcher, ActionTypesEnum, $translate) {
    return {
      getUserGroups: getUserGroups,
      getUserGroupById: getUserGroupById,
      createUserGroup: createUserGroup,
      updateUserGroup: updateUserGroup,
      deleteUserGroup: deleteUserGroup,
      getUsersForUserGroup: getUsersForUserGroup,
      addUserToUserGroup: addUserToUserGroup,
      removeUserFromUserGroup: removeUserFromUserGroup,
      getActiveUsersForUserGroup : getActiveUsersForUserGroup,
      getTemporalRulePercentage : getTemporalRulePercentage
    };

    function getUsersForUserGroup (groupId, page, pageSize, orderBy, order) {
      var deferred = $q.defer();

      api.getUsersForUserGroup(groupId, page, pageSize, orderBy, order).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getActiveUsersForUserGroup (groupId, page, pageSize, orderBy, order) {
      var deferred = $q.defer();
      // dispatcher.dispatch({type: ActionTypesEnum.SHOW_LOADER});

      api.getActiveUsersForUserGroup(groupId, page, pageSize, orderBy, order).then(function (data) {
        // dispatcher.dispatch({type: ActionTypesEnum.HIDE_LOADER});
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function removeUserFromUserGroup (membershipId) {
      var deferred = $q.defer();

      api.removeUserFromUserGroup(membershipId).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('DELETE_USER_FROM_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function addUserToUserGroup (groupId, userId) {
      var deferred = $q.defer();
      api.addUserToUserGroup(groupId, userId).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('ADD_USER_TO_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getUserGroups () {
      var deferred = $q.defer();
      // dispatcher.dispatch({type: ActionTypesEnum.SHOW_LOADER});

      api.getUserGroups().then(function (data) {
        // dispatcher.dispatch({type: ActionTypesEnum.HIDE_LOADER});
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getUserGroupById (groupId) {
      var deferred = $q.defer();

      api.getUserGroupById(groupId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getTemporalRulePercentage (temporalDeviceType) {
      var deferred = $q.defer();

      api.getTemporalRulePercentage (temporalDeviceType).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function createUserGroup (groupName) {
      var deferred = $q.defer();

      api.createUserGroup(groupName).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('CREATE_USER_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function updateUserGroup (groupId, groupName) {
      var deferred = $q.defer();

      api.updateUserGroup(groupId, groupName).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('UPDATE_USER_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function deleteUserGroup (groupId) {
      var deferred = $q.defer();
      
      api.deleteUserGroup(groupId).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('DETELE_USER_GROUP_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('userActions', userActionsFactory);

  /** @ngInject */
  function userActionsFactory(api, $q, dispatcher, ActionTypesEnum, $translate, sessionData) {
    return {
      signIn: signIn,
      updateUserInfo : updateUserInfo,
      changeUserRole : changeUserRole,
      changePassword : changePassword,
      getAllCompanyUsers : getAllCompanyUsers,
      deleteUser : deleteUser,
      addNewUser : addNewUser,
      forgotPassword : forgotPassword,
      activateAccount : activateAccount,
      deleteHistory: deleteHistory,
      getCompanyDetails: getCompanyDetails,
      getRegionById: getRegionById,
      getOrganizationUsers: getOrganizationUsers,
      deleteOrganizationUser: deleteOrganizationUser,
      getOrganizationUserById: getOrganizationUserById,
      refreshToken: refreshToken,
      getReleaseNotes: getReleaseNotes,
      resendVerificationMail: resendVerificationMail,
      resetPassword: resetPassword,
      getTermsOfServiceDocument: getTermsOfServiceDocument,
      acceptTermsOfServiceDocument: acceptTermsOfServiceDocument
    };

    function signIn(username, password) {
      var deferred = $q.defer();
      api.signIn(username, password).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function updateUserInfo(data) {
      var deferred = $q.defer();
      api.updateUserInfo(data).then(function () {
        // save to local storage
        sessionData.setValue('firstName', data.firstName);
        sessionData.setValue('lastName', data.lastName);
        // dispatch message
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('UPDATE_USER_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function changeUserRole(data) {
      var deferred = $q.defer();
      api.changeUserRole(data).then(function () {
        // dispatch message
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('UPDATE_USER_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function changePassword(data) {
      var deferred = $q.defer();
      api.changePassword(data).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('CHANGED_PASSWORD_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getAllCompanyUsers (page, pageSize, orderBy, order){
      var deferred = $q.defer();

      api.getCompanyUsers(page, pageSize, orderBy, order).then(function(data){
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function deleteUser(userId){
      var deferred = $q.defer();

      api.deleteUser(userId).then(function(data){
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('DELETE_USER_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function addNewUser(data){
      var deferred = $q.defer();

      api.addNewUser(data).then(function(data){
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('ADD_USER_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function forgotPassword(email, language) {
      var deferred = $q.defer();
      api.forgotPassword(email, language).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('SUCCESS_FORGOT_PASSWORD_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function activateAccount(data){
      var deferred = $q.defer();
      api.activateAccount(data).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function resetPassword(data){
      var deferred = $q.defer();
      api.resetPassword(data).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function deleteHistory(){
      var deferred = $q.defer();
      api.deleteHistory().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getCompanyDetails(){
      var deferred = $q.defer();
      api.getCompanyDetails().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getRegionById(id){
      var deferred = $q.defer();
      api.getRegionById(id).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getOrganizationUsers (email, page, pageSize, orderBy, order){
      var deferred = $q.defer();

      api.getOrganizationUsers(email, page, pageSize, orderBy, order).then(function(data){
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function deleteOrganizationUser(userId, organizationId){
      var deferred = $q.defer();

      api.deleteOrganizationUser(userId, organizationId).then(function(data){
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message : $translate.instant('DELETE_USER_NOTIFICATION')
          }
        });
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getOrganizationUserById(userId){
      var deferred = $q.defer();

      api.getOrganizationUserById(userId).then(function(data){
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function refreshToken(token) {
      var deferred = $q.defer();
      api.refreshToken(token).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getReleaseNotes() {
      var deferred = $q.defer();
      api.getReleaseNotes().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function resendVerificationMail(userEmail){
      var deferred = $q.defer();
      api.resendVerificationMail(userEmail).then(function(data){
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message : $translate.instant('RESEND_USER_VERIFICATION_EMAIL')
          }
        });
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getTermsOfServiceDocument(isoCode, language) {
      var deferred = $q.defer();
      api.getTermsOfServiceDocument(isoCode, language).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function acceptTermsOfServiceDocument() {
      var deferred = $q.defer();
      api.acceptTermsOfServiceDocument().then(function (data) {
        // dispatch message
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message : $translate.instant('ACCEPT_TERMS_AND_CONDITIONS')
          }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('transactionsActions', transactionsActionsFactory);

    /** @ngInject */
    function transactionsActionsFactory(api, $q) {
        return {
            getTransactionsExpenses: getTransactionsExpenses,
            getTransactionsTopUps : getTransactionsTopUps
        };

        function getTransactionsExpenses(email, from, to, page, pageSize, orderBy, order) {
            var deferred = $q.defer();
            api.getTransactionsExpenses(email, from, to, page, pageSize, orderBy, order).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function getTransactionsTopUps(email, from, to, page, pageSize, orderBy, order) {
            var deferred = $q.defer();
            api.getTransactionsTopUps(email, from, to, page, pageSize, orderBy, order).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

    }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('sempraUsersActions', sempraUsersActionsFactory);

  /** @ngInject */
  function sempraUsersActionsFactory ($q, api, dispatcher, ActionTypesEnum) {
    return {
      getSempraUsers: getSempraUsers,
      searchSempraUsers: searchSempraUsers,
      searchSempraUsersByTelephone: searchSempraUsersByTelephone
    };

    function getSempraUsers () {
      var deferred = $q.defer();

      api.getSempraUsers().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function searchSempraUsers (searchTerm) {
      var deferred = $q.defer();

      api.searchSempraUsers(searchTerm).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function searchSempraUsersByTelephone (searchTerm) {
      var deferred = $q.defer();

      api.searchSempraUsersByTelephoneNumber(searchTerm).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('reportActions', reportActionsFactory);

  /** @ngInject */
  function reportActionsFactory($q, api, dispatcher, ActionTypesEnum) {
    return {
      updateReportFilter: updateReportFilter,
      getFinancesByDate: getFinancesByDate,
      getTotalR2WByDate: getTotalR2WByDate,
      getAvgByHours: getAvgByHours,
      getAvgMoneyByDay: getAvgMoneyByDay,
      getAvgMoneyByBox: getAvgMoneyByBox,
      getCoinsByDate: getCoinsByDate,
      getTotalEuroKeyByDate: getTotalEuroKeyByDate,
      getComparationFinances: getComparationFinances,
      getTotalUsersByGroupsAndDate: getTotalUsersByGroupsAndDate,
      getUsersPerVisitCount: getUsersPerVisitCount,
      getTotalSpentLocalTokensPerDay: getTotalSpentLocalTokensPerDay,
      getLoyaltyPerPaymentMethodForPeriod: getLoyaltyPerPaymentMethodForPeriod,
      getTotalTokenPaymentsByDate: getTotalTokenPaymentsByDate,
      getTotalPurchasedLocalTokensPerDay: getTotalPurchasedLocalTokensPerDay,
      getTotalGivenLocalTokensPerDay: getTotalGivenLocalTokensPerDay,
      getTotalTokenCount: getTotalTokenCount,
      getChangerIncomePerDate: getChangerIncomePerDate,
      getPosIncome: getPosIncome,
      getAllReportConfigurations: getAllReportConfigurations,
      getSelectedReportConfiguration: getSelectedReportConfiguration,
      executeDynamicReport: executeDynamicReport,
      deleteReportsData: deleteReportsData
    };

    function updateReportFilter(
      fromTimestamp,
      toTimestamp,
      serialNumber,
      period1From,
      period1To,
      period2From,
      period2To,
      period3From,
      period3To,
      currency
    ) {
      dispatcher.dispatch({
        type: ActionTypesEnum.UPDATE_REPORT_FILTER,
        payload: {
          fromTimestamp: fromTimestamp,
          toTimestamp: toTimestamp,
          selectedFacilitySerial: serialNumber,
          period1From: period1From,
          period1To: period1To,
          period2From: period2From,
          period2To: period2To,
          period3From: period3From,
          period3To: period3To,
          currency: currency
        }
      });
    }

    function getLoyaltyPerPaymentMethodForPeriod(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getLoyaltyPerPaymentMethodForPeriod(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalSpentLocalTokensPerDay(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalSpentLocalTokensPerDay(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalGivenLocalTokensPerDay(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalGivenLocalTokensPerDay(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalPurchasedLocalTokensPerDay(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalPurchasedLocalTokensPerDay(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getUsersPerVisitCount(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getVisitsCountForPeriod(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalUsersByGroupsAndDate(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalByUserGroupsForPeriod(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getFinancesByDate(
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getFinancesByDate(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getTotalR2WByDate(
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getTotalR2WByDate(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getAvgByHours(deviceSerial, fromTimestamp, toTimestamp, currency) {
      var deferred = $q.defer();
      api
        .getAvgMoneyByHours(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getAvgMoneyByDay(
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getAvgMoneyByDay(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getAvgMoneyByBox(
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getAvgMoneyByBox(deviceSerial, fromTimestamp, toTimestamp, currency)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getCoinsByDate(deviceSerial, fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalCoinsByDate(deviceSerial, fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalTokenPaymentsByDate(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalTokenPaymentsByDate(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalTokenCount(fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalTokenCount(fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getTotalEuroKeyByDate(deviceSerial, fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      api.getTotalEuroKeyByDate(deviceSerial, fromTimestamp, toTimestamp).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getComparationFinances(
      facilityPointId,
      fromTimestamp1,
      toTimestamp1,
      fromTimestamp2,
      toTimestamp2
    ) {
      var deferred = $q.defer();
      api
        .getComparationForPeriod(
          facilityPointId,
          fromTimestamp1,
          toTimestamp1,
          fromTimestamp2,
          toTimestamp2
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getChangerIncomePerDate(
      selectedFacilitySerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getChangerIncomePerDate(
          selectedFacilitySerial,
          fromTimestamp,
          toTimestamp,
          currency
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getPosIncome(
      selectedFacilitySerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      api
        .getPosIncome(
          selectedFacilitySerial,
          fromTimestamp,
          toTimestamp,
          currency
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getAllReportConfigurations() {
      var deferred = $q.defer();
      api.getAllReportConfigurations().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getSelectedReportConfiguration(configurationId) {
      var deferred = $q.defer();
      api.getSelectedReportConfiguration(configurationId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function executeDynamicReport(configurationId, data) {
      var deferred = $q.defer();
      api.executeDynamicReport(configurationId, data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function deleteReportsData(companyId) {
      var deferred = $q.defer();
      api.deleteReportsData(companyId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

  }
})();

(function() {
	"use strict";

	angular
		.module("sempraWebapp")
		.factory("pricingActions", pricingActionsFactory);

	/** @ngInject */
	function pricingActionsFactory(api, $q) {
		return {
			getCompanyTokenPackage: getCompanyTokenPackage,
			getSingleCompanyTokenPackage: getSingleCompanyTokenPackage,
			createCompanyTokenPackage: createCompanyTokenPackage,
			updateCompanyTokenPackage: updateCompanyTokenPackage,
			deleteCompanyTokenPackage: deleteCompanyTokenPackage,
			getSingeWashes: getSingeWashes,
			getSingeWash: getSingeWash,
			createSingeWash: createSingeWash,
			updateSingeWash: updateSingeWash,
			deleteSingeWash: deleteSingeWash
		};

		function getCompanyTokenPackage() {
			var deferred = $q.defer();
			api.getCompanyTokenPackage().then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getSingleCompanyTokenPackage(id) {
			var deferred = $q.defer();
			api.getSingleCompanyTokenPackage(id).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function createCompanyTokenPackage(data) {
			var deferred = $q.defer();
			api.createCompanyTokenPackage(data).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateCompanyTokenPackage(data) {
			var deferred = $q.defer();
			api.updateCompanyTokenPackage(data).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function deleteCompanyTokenPackage(id) {
			var deferred = $q.defer();
			api.deleteCompanyTokenPackage(id).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getSingeWashes() {
			var deferred = $q.defer();
			api.getSingeWashes().then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getSingeWash(id) {
			var deferred = $q.defer();
			api.getSingeWash(id).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function createSingeWash(data) {
			var deferred = $q.defer();
			api.createSingeWash(data).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateSingeWash(data) {
			var deferred = $q.defer();
			api.updateSingeWash(data).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function deleteSingeWash(id) {
			var deferred = $q.defer();
			api.deleteSingeWash(id).then(
				function(data) {
					deferred.resolve(data);
				},
				function(errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

	}
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('periodicSummaryActions', periodicSummaryActionsFactory);

    /** @ngInject */
    function periodicSummaryActionsFactory(api, $q) {
        return {
            getPeriodicSummary: getPeriodicSummary,
            getInvoices : getInvoices,
            updateInvoice : updateInvoice,
            downloadB2bSpec: downloadB2bSpec,
            downloadB2cSpec: downloadB2cSpec,
            downloadInvoice: downloadInvoice,
            getBusinessTransactions: getBusinessTransactions,
            downloadBusinessInvoice: downloadBusinessInvoice
        };

        function getPeriodicSummary() {
            var deferred = $q.defer();
            api.getPeriodicSummary().then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function getInvoices(selectedYear, selectedType, page, pageSize, orderBy, order) {
            var deferred = $q.defer();
            api.getInvoices(selectedYear, selectedType, page, pageSize, orderBy, order).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function getBusinessTransactions(fromMonth, toMonth, year, page, pageSize, orderBy, order) {
            var deferred = $q.defer();
            api.getBusinessTransactions(fromMonth, toMonth, year, page, pageSize, orderBy, order).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function updateInvoice(id, number, status) {
            var deferred = $q.defer();
            api.updateInvoice(id, number, status).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);

            });
            return deferred.promise;
        }

        function downloadInvoice(transactionId){
            var deferred = $q.defer();
            api.downloadInvoice(transactionId).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function downloadBusinessInvoice(userId, month, year){
            var deferred = $q.defer();
            api.downloadBusinessInvoice(userId, month, year).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });

            return deferred.promise;
        }

        function downloadB2bSpec(transactionId){
            var deferred = $q.defer();
            api.downloadB2bSpec(transactionId).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });
      
            return deferred.promise;
          }
      
          function downloadB2cSpec(transactionId){
            var deferred = $q.defer();
            api.downloadB2cSpec(transactionId).then(function (data) {
                deferred.resolve(data);
            }, function (errorData) {
                deferred.reject(errorData);
            });
      
            return deferred.promise;
          }

    }
})();

(function () {
	'use strict';

	angular
		.module('sempraWebapp')
		.factory('organizationActions', organizationActionsFactory);

	/** @ngInject */
	function organizationActionsFactory(api, $q, dispatcher, ActionTypesEnum, $translate) {
		return {
			getOrganizationsListByType: getOrganizationsListByType,
			getOrganizationById: getOrganizationById,
			getSupportedOrganizationList: getSupportedOrganizationList,
			createChildOrganization: createChildOrganization,
			updateChildOrganization: updateChildOrganization,
			deleteOrganization: deleteOrganization,
			getAllCompaniesShort: getAllCompaniesShort,
			getAllRegionsShort: getAllRegionsShort,
			getAllSitesShort: getAllSitesShort,
			getForUserCreateOrganizationList: getForUserCreateOrganizationList,
			createUserForSelectedOrganizationAndRole: createUserForSelectedOrganizationAndRole,
			getForUserOrganizationListByUserId: getForUserOrganizationListByUserId,
			updateUserForSelectedOrganizationAndRole: updateUserForSelectedOrganizationAndRole,
			getAllSitesForExactUser: getAllSitesForExactUser,
			getOrganizationsCompanyById: getOrganizationsCompanyById,
			updateOrganizationVoucherExpirationDays: updateOrganizationVoucherExpirationDays
		};

		function getOrganizationsListByType() {
			var deferred = $q.defer();
			api.getOrganizationsListByType().then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getOrganizationById(organizationId) {
			var deferred = $q.defer();
			api.getOrganizationById(organizationId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getSupportedOrganizationList(organizationId) {
			var deferred = $q.defer();
			api.getSupportedOrganizationList(organizationId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function createChildOrganization(data) {
			var deferred = $q.defer();
			api.createChildOrganization(data).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('ORGANIZATION_SAVED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateChildOrganization(data) {
			var deferred = $q.defer();
			api.updateChildOrganization(data).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('ORGANIZATION_UPDATED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function deleteOrganization(organizationId) {
			var deferred = $q.defer();
			api.deleteOrganization(organizationId).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('ORGANIZATION_DELETED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getAllCompaniesShort(organizationId) {
			var deferred = $q.defer();
			api.getAllCompaniesShort(organizationId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getAllRegionsShort() {
			var deferred = $q.defer();
			api.getAllRegionsShort().then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getAllSitesShort(organizationId) {
			var deferred = $q.defer();
			api.getAllSitesShort(organizationId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getForUserCreateOrganizationList() {
			var deferred = $q.defer();
			api.getForUserCreateOrganizationList().then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function createUserForSelectedOrganizationAndRole(data) {
			var deferred = $q.defer();
			api.createUserForSelectedOrganizationAndRole(data).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('USER_CREATED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getForUserOrganizationListByUserId(userId) {
			var deferred = $q.defer();
			api.getForUserOrganizationListByUserId(userId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateUserForSelectedOrganizationAndRole(userId, data) {
			var deferred = $q.defer();
			api.updateUserForSelectedOrganizationAndRole(userId, data).then(
				function (data) {
					// dispatch message
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('USER_UPDATED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getAllSitesForExactUser() {
			var deferred = $q.defer();
			api.getAllSitesForExactUser().then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function getOrganizationsCompanyById(companyId) {
			var deferred = $q.defer();
			api.getOrganizationsCompanyById(companyId).then(
				function (data) {
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

		function updateOrganizationVoucherExpirationDays(companyId, voucherExpirationDays) {
			var deferred = $q.defer();
			api.updateOrganizationVoucherExpirationDays(companyId, voucherExpirationDays).then(
				function (data) {
					dispatcher.dispatch({
						type: ActionTypesEnum.SHOW_TOASTER_MSG,
						payload: {
							type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
							message: $translate.instant('VOUCHER_EXPIRATION_DAYS_UPDATED')
						}
					});
					deferred.resolve(data);
				},
				function (errorData) {
					deferred.reject(errorData);
				}
			);

			return deferred.promise;
		}

	}
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('newsActions', newsActionsFactory);

  /** @ngInject */
  function newsActionsFactory(api, $q) {
    return {
      getCompanyNews: getCompanyNews,
      deleteNews : deleteNews,
      saveNews : saveNews,
      getGlobalNotice: getGlobalNotice
    };

    function getCompanyNews(page, pageSize, orderBy, order, companyId) {
      var deferred = $q.defer();
      api.getCompanyNews(page, pageSize, orderBy, order, companyId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function deleteNews(newsId) {
      var deferred = $q.defer();
      api.deleteNews(newsId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function saveNews(data) {
      var deferred = $q.defer();
      api.saveNews(data).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getGlobalNotice() {
      var deferred = $q.defer();
      api.getGlobalNotice().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('messageActions', messageActionsFactory);

  /** @ngInject */
  function messageActionsFactory ($q, api, dispatcher, ActionTypesEnum, $translate) {
    return {
      getAllMessages: getAllMessages,
      getAlarmMessages: getAlarmMessages,
      dismissAlarm: dismissAlarm,
      getKarcherAlarms: getKarcherAlarms,
      getKarcherAlarmSubscriptions: getKarcherAlarmSubscriptions,
      createAlarmSubscription: createAlarmSubscription,
      unsubscribeKarcherAlert: unsubscribeKarcherAlert
    };

    function getAlarmMessages () {
      var deferred = $q.defer();

      api.getAlarmMessages().then(function (data) {
        deferred.resolve(data);
        dispatcher.dispatch({
          type: ActionTypesEnum.GET_ALARM_MESSAGES,
          payload: data
        });
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getAllMessages (deviceKey, fromTimeStamp, toTimestamp, page, pageSize, orderBy, order) {
      var deferred = $q.defer();

      api.getMessages(deviceKey, fromTimeStamp, toTimestamp, page, pageSize, orderBy, order).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function dismissAlarm (alarmId) {
      var deferred = $q.defer();

      api.dismissAlarm(alarmId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getKarcherAlarms () {
      var deferred = $q.defer();

      api.getKarcherAlarms().then(function(response) {
        deferred.resolve(response);
        dispatcher.dispatch({
          type: ActionTypesEnum.GET_ALARM_KARCHER_MESSAGES,
          payload: response
        });
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getKarcherAlarmSubscriptions() {
      var deferred = $q.defer();

      api.getKarcherAlarmSubscriptions().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function createAlarmSubscription(data) {
      var deferred = $q.defer();

      api.createAlarmSubscription(data).then(function (data) {
        deferred.resolve(data);
        // dispatch message
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message: $translate.instant('ALARM_SUBSCRIBED')
          }
        });
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function unsubscribeKarcherAlert(siteId) {
      var deferred = $q.defer();

      api.unsubscribeKarcherAlert(siteId).then(function (data) {
        deferred.resolve(data);
        // dispatch message
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message: $translate.instant('ALARM_UNSUBSCRIBED')
          }
        });
      }, function (errorData) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('managingTokensActions', managingTokensActionsFactory);

  /** @ngInject */
  function managingTokensActionsFactory(
    api,
    $q,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    return {
      getManagingTokens: getManagingTokens,
      deleteManagingTokens: deleteManagingTokens,
      extendManagingTokens: extendManagingTokens,
      createDeviceSession: createDeviceSession,
      startDeviceService: startDeviceService
    };

    function getManagingTokens(email) {
      var deferred = $q.defer();
      api.getManagingTokens(email).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function deleteManagingTokens(data) {
      var deferred = $q.defer();
      api.deleteManagingTokens(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function extendManagingTokens(data) {
      var deferred = $q.defer();
      api.extendManagingTokens(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function createDeviceSession(pointId) {
      var deferred = $q.defer();
      api.createDeviceSession(pointId).then(
        function (data) {
          deferred.resolve(data);
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant('OPEN_SESSION')
            }
          });
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function startDeviceService(facilityId, pointId, token) {
      var deferred = $q.defer();
      api.startDeviceService(facilityId, pointId, token).then(
        function (data) {
          deferred.resolve(data);
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant('TOKEN_INSERTED')
            }
          });
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('layoutActions', layoutActionsFactory);

    /** @ngInject */
    function layoutActionsFactory (dispatcher, ActionTypesEnum) {
        return {
            showLoader: showLoader,
            hideLoader: hideLoader
        };

        function showLoader () {
            dispatcher.dispatch({
               type: ActionTypesEnum.SHOW_LOADER
            });
        }

        function hideLoader () {
            dispatcher.dispatch({
               type: ActionTypesEnum.HIDE_LOADER
            });
        }
    }
})();
(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("karcherReportActions", karcherReportActionsFactory);

  /** @ngInject */
  function karcherReportActionsFactory($q, api, dispatcher, ActionTypesEnum) {
    return {
      getWashFacilityBoxesByWashFacilityId:
        getWashFacilityBoxesByWashFacilityId,
      getWashFacilityShortList: getWashFacilityShortList,
      getJetwashReportWorkingHoursPerProgram:
        getJetwashReportWorkingHoursPerProgram,
      getJetwashReportTurnoverPerBay: getJetwashReportTurnoverPerBay,
      getRolloverReportWashesPerProgram: getRolloverReportWashesPerProgram,
      getRolloverReportTurnover: getRolloverReportTurnover,
      getJetwashReportTurnoverPerChannel: getJetwashReportTurnoverPerChannel
    };

    function getWashFacilityBoxesByWashFacilityId(washFacilityId) {
      var deferred = $q.defer();
      api.getWashFacilityBoxesByWashFacilityId(washFacilityId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getWashFacilityShortList() {
      var deferred = $q.defer();
      api.getWashFacilityShortList().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getJetwashReportWorkingHoursPerProgram(data) {
      var deferred = $q.defer();
      api.getJetwashReportWorkingHoursPerProgram(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getJetwashReportTurnoverPerBay(data) {
      var deferred = $q.defer();
      api.getJetwashReportTurnoverPerBay(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getRolloverReportWashesPerProgram(data) {
      var deferred = $q.defer();
      api.getRolloverReportWashesPerProgram(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getRolloverReportTurnover(data) {
      var deferred = $q.defer();
      api.getRolloverReportTurnover(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getJetwashReportTurnoverPerChannel(data) {
      var deferred = $q.defer();
      api.getJetwashReportTurnoverPerChannel(data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('errorActions', errorActionsFactory);

  /** @ngInject */
  function errorActionsFactory (dispatcher, ActionTypesEnum, $state) {
    return {
      showErrorPage : showErrorPage,
      acknowledgeAndGoBack : acknowledgeAndGoBack,
      showErrorMsg : showErrorMsg,
      acknowledgeErrorMsg : acknowledgeErrorMsg,
      showErrorPageReturnToDashboard: showErrorPageReturnToDashboard
    };


    function showErrorPage (payload) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_ERROR_PAGE,
            payload: payload
        });
        $state.go('app.errorPage');
    }

    function showErrorPageReturnToDashboard (payload) {
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_ERROR_PAGE,
        payload: payload
      });
      $state.go('app.errorPageWithRedirectToDashboard');
    }

    function acknowledgeAndGoBack(){
        dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_ERROR_PAGE,
            payload: true
        });
      history.go(-2);
    }

    function showErrorMsg(payload){
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_ERROR_MSG,
            payload: payload
        });
    }

    function acknowledgeErrorMsg(){
        dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_ERROR_MSG,
            payload: true
        });
    }

  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").factory("deviceActions", deviceActionsFactory);

  /** @ngInject */
  function deviceActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    return {
      getDevices: getDevices,
      getDeviceBySerialNumber: getDeviceBySerialNumber,
      getAllDevices: getAllDevices,
      getDeviceDetails: getDeviceDetails,
      updateDeviceDetails: updateDeviceDetails,
      getDevice: getDevice,
      actuate: actuate,
      getDeviceWorkingHours: getDeviceWorkingHours,
      updateDeviceWorkingHours: updateDeviceWorkingHours,
      groupActuate: groupActuate,
      getHistoryOfActuatedPointsByDeviceKey:
        getHistoryOfActuatedPointsByDeviceKey,
      getPointsListByDeviceKey: getPointsListByDeviceKey,
      changeDeviceLabelName: changeDeviceLabelName
    };

    function getAllDevices() {
      var deferred = $q.defer();
      api.getDevices().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getDeviceDetails(deviceId) {
      var deferred = $q.defer();
      api.getDeviceDetails(deviceId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function updateDeviceDetails(deviceId, data) {
      var deferred = $q.defer();
      api.updateDeviceDetails(deviceId, data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getDevice(deviceSerial) {
      var deferred = $q.defer();
      api.getDeviceBySerialNumber(deviceSerial).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function actuate(deviceSerial, data) {
      var deferred = $q.defer();
      api.actuate(deviceSerial, data).then(
        function () {
          deferred.resolve();
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getDevices() {
      api.getDevices().then(
        function (data) {
          dispatcher.dispatch({
            type: ActionTypesEnum.GET_DEVICES,
            payload: data
          });
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );
    }

    function getDeviceBySerialNumber(serialNumber) {
      api.getDeviceBySerialNumber(serialNumber).then(
        function (data) {
          dispatcher.dispatch({
            type: ActionTypesEnum.GET_DEVICE,
            payload: data
          });
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );
    }

    function getDeviceWorkingHours(pointId) {
      var deferred = $q.defer();
      api.getDeviceWorkingHours(pointId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function updateDeviceWorkingHours(pointId, data) {
      var deferred = $q.defer();
      api.updateDeviceWorkingHours(pointId, data).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function groupActuate(deviceKey, pointId, data) {
      var deferred = $q.defer();
      api.groupActuate(deviceKey, pointId, data).then(
        function () {
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant("ACTUATION_SUCCESS")
            }
          });
          deferred.resolve();
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getHistoryOfActuatedPointsByDeviceKey(
      deviceKey,
      pointIds,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer();
      api
        .getHistoryOfActuatedPointsByDeviceKey(
          deviceKey,
          pointIds,
          page,
          pageSize,
          orderBy,
          order
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getPointsListByDeviceKey(deviceKet) {
      var deferred = $q.defer();
      api.getPointsListByDeviceKey(deviceKet).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function changeDeviceLabelName(deviceData) {
      var deferred = $q.defer();
      api.changeDeviceLabelName(deviceData).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("dashboardKarcherActions", dashboardKarcherActionsFactory);

  /** @ngInject */
  function dashboardKarcherActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum
  ) {
    return {
      getKarcherSitesData: getKarcherSitesData,
      getKarcherSitesInfoWindowData: getKarcherSitesInfoWindowData,
      getKarcherSiteDetailsById: getKarcherSiteDetailsById,
      getKarcherSiteAlarmList: getKarcherSiteAlarmList,
      getKarcherAlarmsHistoryList: getKarcherAlarmsHistoryList,
      getKarcherDeviceDetailsById: getKarcherDeviceDetailsById,
      getKarcherFaultsByDeviceId: getKarcherFaultsByDeviceId,
      getEventsListForSelectedDevice: getEventsListForSelectedDevice
    };

    function getKarcherSitesData(siteName, alarmStatus) {
      var deferred = $q.defer();
      api.getKarcherSitesData(siteName, alarmStatus).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getKarcherSitesInfoWindowData(siteId) {
      var deferred = $q.defer();
      api.getKarcherSitesInfoWindowData(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getKarcherSiteDetailsById(siteId) {
      var deferred = $q.defer();
      api.getKarcherSiteDetailsById(siteId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getKarcherFaultsByDeviceId(deviceId) {
      var deferred = $q.defer();
      api.getKarcherFaultsByDeviceId(deviceId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getKarcherSiteAlarmList(
      filter,
      faultStatus,
      facilityId,
      siteId,
      from,
      to,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer();
      api
        .getKarcherSiteAlarmList(
          filter,
          faultStatus,
          facilityId,
          siteId,
          from,
          to,
          page,
          pageSize,
          orderBy,
          order
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getKarcherAlarmsHistoryList(
      filter,
      facilityId,
      from,
      to,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer();
      api
        .getKarcherAlarmsHistoryList(
          filter,
          facilityId,
          from,
          to,
          page,
          pageSize,
          orderBy,
          order
        )
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            dispatcher.dispatch({
              type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
              payload: errorData
            });
          }
        );

      return deferred.promise;
    }

    function getKarcherDeviceDetailsById(siteId, deviceId) {
      var deferred = $q.defer();
      api.getKarcherDeviceDetailsById(siteId, deviceId).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getEventsListForSelectedDevice(deviceKey) {
      var deferred = $q.defer();
      api.getEventsListForSelectedDevice(deviceKey).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("dailyFinancesActions", dailyFinancesActionsFactory);

  /** @ngInject */
  function dailyFinancesActionsFactory($q, api, dispatcher, ActionTypesEnum) {
    return {
      getData: getData,
      getDailyFinances: getDailyFinances,
      getDailyFinancesBySerialNumber: getDailyFinancesBySerialNumber
    };

    function getData() {
      var deferred = $q.defer();

      api.getDailyFinances().then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );

      return deferred.promise;
    }

    function getDailyFinances() {
      api.getDailyFinances().then(
        function (data) {
          dispatcher.dispatch({
            type: ActionTypesEnum.GET_DAILY_FINANCES,
            payload: data
          });
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );
    }

    function getDailyFinancesBySerialNumber(serialNumber) {
      api.getDailyFinancesBySerialNumber(serialNumber).then(
        function (data) {
          dispatcher.dispatch({
            type: ActionTypesEnum.GET_DAILY_FINANCES_FOR_DEVICE,
            payload: data
          });
        },
        function (errorData) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
            payload: errorData
          });
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('cashlessActions', cashlessActionsFactory);

  /** @ngInject */
  function cashlessActionsFactory(
    $q,
    api,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    return {
      getCashlessSales: getCashlessSales,
      refundCashlessPayment: refundCashlessPayment,
      getCashlessTotals: getCashlessTotals,
      getCashlessSalesExportCSV: getCashlessSalesExportCSV
    };

    function getCashlessSales(
      filter,
      since,
      until,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer();
      api
        .getCashlessSales(filter, since, until, page, pageSize, orderBy, order)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            deferred.reject(errorData);
          }
        );

      return deferred.promise;
    }

    function refundCashlessPayment(id, amount) {
      var deferred = $q.defer();
      api.refundCashlessPayment(id, amount).then(
        function (data) {
          // dispatch message
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant('REFUND_SUCCESSFULLY')
            }
          });
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getCashlessTotals(since, until, filter) {
      var deferred = $q.defer();
      api.getCashlessTotals(since, until, filter).then(
        function (data) {
          deferred.resolve(data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    }

    function getCashlessSalesExportCSV(
      filter,
      since,
      until
    ) {
      var deferred = $q.defer();
      api
        .getCashlessSalesExportCSV(filter, since, until)
        .then(
          function (data) {
            deferred.resolve(data);
          },
          function (errorData) {
            deferred.reject(errorData);
          }
        );

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('campaignTemplateActions', campaignTemplateActionsFactory);

  /** @ngInject */
  function campaignTemplateActionsFactory ($q, api, dispatcher, ActionTypesEnum) {
    return {
      getCampaignTemplates: getCampaignTemplates,
      getCampaignTemplateById: getCampaignTemplateById,
      createCampaignTemplate: createCampaignTemplate,
      updateCampaignTemplate: updateCampaignTemplate,
      deleteCampaignTemplate: deleteCampaignTemplate
    };

    function getCampaignTemplates () {
      var deferred = $q.defer();

      api.getCampaignTemplates().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getCampaignTemplateById (campaignTemplateId) {
      var deferred = $q.defer();

      api.getCampaignTemplateById(campaignTemplateId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function createCampaignTemplate (campaignTemplate) {
      var deferred = $q.defer();

      api.createCampaignTemplate(campaignTemplate).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function updateCampaignTemplate (campaignTemplate) {
      var deferred = $q.defer();

      api.updateCampaignTemplate(campaignTemplate).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function deleteCampaignTemplate (campaignTemplateId) {
      var deferred = $q.defer();

      api.deleteCampaignTemplate(campaignTemplateId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('campaignActions', campaignActionsFactory);

  /** @ngInject */
  function campaignActionsFactory ($q, api, dispatcher, ActionTypesEnum, $translate) {
    return {
      getCampaigns: getCampaigns,
      getCampaignById: getCampaignById,
      createCampaign: createCampaign,
      updateCampaign: updateCampaign,
      deleteCampaign: deleteCampaign,
      getLoyaltyTresholds: getLoyaltyTresholds,
      activateCampaign: activateCampaign,
      sendCampaignUsersMessage : sendCampaignUsersMessage
    };

    function activateCampaign (campaignId) {
      var deferred = $q.defer();

      api.activateCampaign(campaignId).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('LOYALTY_ACTIVATE_CAMPAIGN_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getLoyaltyTresholds (campaignId, type, tresholdValue, fromTimestamp, toTimestamp) {
      var deferred = $q.defer();

      api.getLoyaltyTresholds(campaignId, type, tresholdValue, fromTimestamp, toTimestamp).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function sendCampaignUsersMessage(campaignId, tresholdValue, type, msg){
      var deferred = $q.defer();

      api.sendMessageToCampaignUsers(campaignId, tresholdValue, type, msg).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('LOYALTY_SENT_MESSAGE_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getCampaigns () {
      var deferred = $q.defer();

      api.getCampaigns().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function getCampaignById (campaignId) {
      var deferred = $q.defer();

      api.getCampaignById(campaignId).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function createCampaign (campaign) {
      var deferred = $q.defer();

      api.createCampaign(campaign).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('LOYALTY_CREATE_CAMPAIGN_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function updateCampaign (campaign) {
      var deferred = $q.defer();

      api.updateCampaign(campaign).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

    function deleteCampaign (campaignId) {
      var deferred = $q.defer();

      api.deleteCampaign(campaignId).then(function (data) {
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message : $translate.instant('DELETE_ITEM_SUCCESS')
          }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
        dispatcher.dispatch({
          type: ActionTypesEnum.SERVER_RESPONSE_FAILED,
          payload: errorData
        });
      });

      return deferred.promise;
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ActionTypesEnum', actionTypesEnumFactory);

  /** @ngInject */
  function actionTypesEnumFactory () {
    return Object.freeze({
      //user
      SIGN_IN: 'SIGN_IN',
      //devices
      GET_DEVICES: 'GET_DEVICES',
      GET_DEVICE: 'GET_DEVICE',
      GET_KARCHER_DEVICE: 'GET_KARCHER_DEVICE',
      //messages
      GET_MESSAGES: 'GET_MESSAGES',
      GET_ALARM_MESSAGES: 'GET_ALARM_MESSAGES',
      GET_ALARM_KARCHER_MESSAGES: 'GET_KARCHER_ALARM_MESSAGES',
      GET_ALARM_FROM_DASHBOARD_MESSAGE: 'GET_ALARM_FROM_DASHBOARD_MESSAGE',
      //daily finances
      GET_DAILY_FINANCES: 'GET_DAILY_FINANCES',
      GET_DAILY_FINANCES_FOR_DEVICE: 'GET_DAILY_FINANCES_FOR_DEVICE',
      //reports
      UPDATE_REPORT_FILTER: 'UPDATE_REPORT_FILTER',
      CHANGE_FACILITY_POINT_ID : 'CHANGE_FACILITY_POINT_ID',
      //global
      SERVER_RESPONSE_PENDING: 'SERVER_RESPONSE_PENDING',
      SERVER_RESPONSE_FAILED: 'SERVER_RESPONSE_FAILED',
      SERVER_RESPONSE_SUCCESS: 'SERVER_RESPONSE_SUCCESS',
      //show/hide loader
      SHOW_LOADER : 'SHOW_LOADER',
      HIDE_LOADER : 'HIDE_LOADER',
      // show hide error msg
      SHOW_ERROR_MSG : 'SHOW_ERROR_MSG',
      HIDE_ERROR_MSG : 'HIDE_ERROR_MSG',
      // show toaster msg
      SHOW_TOASTER_MSG : 'SHOW_TOASTER_MSG',
      TOAST_TYPE_NOTIFICATION : 'TOAST_TYPE_NOTIFICATION',
      TOAST_TYPE_WARNING : 'TOAST_TYPE_WARNING',
      TOAST_TYPE_ERROR : 'TOAST_TYPE_ERROR',
      // error page
      SHOW_ERROR_PAGE : 'SHOW_ERROR_PAGE',
      HIDE_ERROR_PAGE : 'HIDE_ERROR_PAGE',
      //web sockets
      CONNECTED_CHANGE: 'CONNECTED_CHANGE',
      DEVICE_FEED_CHANGE: 'DEVICE_FEED_CHANGE',
      DEVICE_ACTUATOR_CHANGE: 'DEVICE_ACTUATOR_CHANGE',
      DEVICE_STATE_CHANGE: 'DEVICE_STATE_CHANGE',
      MESSAGES_UPDATE_AVAILABLE: 'MESSAGES_UPDATE_AVAILABLE',
      DAILY_FINANCES_CHANGE: 'DAILY_FINANCES_CHANGE',
      NOTICE_CHANGE: 'NOTICE_CHANGE',
      DEVICE_EVENT_CHANGE: 'DEVICE_EVENT_CHANGE'
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("httpInterceptor", httpInterceptorFactory);

  /** @ngInject */
  function httpInterceptorFactory($q, $injector, sessionData) {
    var interceptor = {
      request: function (config) {
        var interceptorService = $injector.get("InterceptorEnum");

        if (
          interceptorService.isStringValid(config.url) &&
          interceptorService.isApiCall(config.url)
        ) {
          //grab the token
          var token = sessionData.getValue(sessionData.Keys.ACCESS_TOKEN_KEY);

          if (token) {
            // bind token to Authorization header for every api request
            config.headers["Authorization"] = "Bearer " + token;
          }
        }

        return config;
      },
      response: function (response) {
        return response;
      },
      responseError: function (response) {
        return $q.reject(response);
      }
    };

    return interceptor;
  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').service('apiMockService', apiMockService);

    /** @ngInject */
    function apiMockService($http, $q, $timeout, apiErrorHandlerService) {

        var serverDelayMs = 100;
        /* eslint-disable */
        this.signIn = function (username, password) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({
                    username: username,
                    userId: 1,
                    accessToken: '123qwerty456asdfgh',
                    refreshToken: '123qwerty456asdfgh',
                    role: 'ADMIN',
                    firstName: 'Admin',
                    lastName: 'Demo'
                });
            }, serverDelayMs);

            return deferred.promise;
        };

        this.getWebSocketsToken = function () {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve('1234567890');
            }, serverDelayMs);

            return deferred.promise;
        };

        this.forgotPassword = function (email) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({
                    username: email,
                    userId: 1,
                    accessToken: '123qwerty456asdfgh',
                    refreshToken: '123qwerty456asdfgh',
                    role: 'ADMIN',
                    firstName: 'Admin',
                    lastName: 'Demo'
                });
            }, serverDelayMs);

            return deferred.promise;
        };

        this.updateUserInfo = function (data) {
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.addNewUser = function (data) {
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.deleteUser = function (userId) {
            var deferred = $q.defer();
            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.activateAccount = function (data) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.getDevices = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/devices.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getDeviceBySerialNumber = function (serialNumber) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/devices.json').success(function (data) {
                $timeout(function () {
                    var result = data.find(function (device) {
                        return device.deviceKey === serialNumber;
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.actuate = function (serialNumber, data) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.getMessages = function (deviceKey, fromTimeStamp, toTimestamp, page, pageSize) {
            var deferred = $q.defer(),
                start = page,
                end = pageSize;

            $http.get('../../../assets/mockData/messages.json').success(function (data) {
                var result = {
                    total: data.length,
                    data: data.slice(start * end, (start * end) + end)
                };
                $timeout(function () {
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getAlarmMessages = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/messages.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data.filter(function (message) {
                        return message.collapseKey === 'alarm';
                    }));
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getDailyFinances = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/dailyFinances.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getDailyFinancesBySerialNumber = function (serialNumber) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/dailyFinances.json').success(function (data) {
                $timeout(function () {
                    var result = data.facilities.find(function (facility) {
                        return facility.deviceSerial === serialNumber;
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getFinancesByDate = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalMoneyByDate.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalCoinsByDate = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalCoinsByDate.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalEuroKeyByDate = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalEuroKeyByDate.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getAvgMoneyByHours = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/avgMoneyByHours.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getAvgMoneyByDay = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/avgMoneyByDayOfWeek.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getAvgMoneyByBox = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/avgMoneyByBox.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalR2WByDate = function (deviceSerial, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/dailyR2WReport.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getComparationForPeriod = function (deviceSerial, fromTimestamp1, toTimestamp1, fromTimestamp2, toTimestamp2) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/comparationReportForPeriod.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalByUserGroupsForPeriod = function (fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalUserGroupsByDate.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getVisitsCountForPeriod = function (fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/totalVisitsByMonth.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getTotalSpentLocalTokensPerDay = function (fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/loyaltyPerDay.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getLoyaltyPerPaymentMethodForPeriod = function (fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/loyaltyPerPaymentMethod.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getLoyaltyTresholds = function (campaignId, type, tresholdValue, fromTimestamp, toTimestamp) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/loyaltyTreshold.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        // sempra users

        this.getCompanyUsers = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/sempraUsers.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        // get all user roles
        this.getUserRoles = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/userRoles.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.searchSempraUsers = function (searchTerm) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/sempraUsers.json').success(function (data) {
                $timeout(function () {
                    var result = data.filter(function (user) {
                        if (user.username.indexOf(searchTerm) > -1 || user.firstName.indexOf(searchTerm) > -1
                            || user.lastName.indexOf(searchTerm) > -1 || user.email.indexOf(searchTerm) > -1) {
                            return user;
                        }
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.searchSempraUsersByTelephoneNumber = function (searchTerm) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/sempraUsers.json').success(function (data) {
                $timeout(function () {
                    var result = [];
                    if (searchTerm === '11111') {
                        result.push(data[0]);
                    } else if (searchTerm === '22222') {
                        result.push(data[1]);
                    } else if (searchTerm === '33333') {
                        result.push(data[2]);
                    }
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        // end sempra users

        //user groups CRUD

        this.getUserGroupById = function (groupId) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/groups.json').success(function (data) {
                $timeout(function () {
                    var result = data.find(function (group) {
                        return group.id.toString() === groupId.toString();
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getUserGroups = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/groups.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.createUserGroup = function (groupName) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({
                    id: 123
                });
            }, serverDelayMs);

            return deferred.promise;
        };

        this.updateUserGroup = function (groupId, groupName) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.deleteUserGroup = function (groupId) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        //end user groups CRUD

        // campaign templates

        var campaignTemplatesFetched = false,
            campaignTemplatesCache = [];

        this.getCampaignTemplateById = function (campaignTemplateId) {
            var deferred = $q.defer();

            if (campaignTemplatesFetched) {
                $timeout(function () {
                    var result = campaignTemplatesCache.find(function (campaignTemplate) {
                        return campaignTemplate.id.toString() === campaignTemplateId.toString();
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            } else {
                $http.get('../../../assets/mockData/campaignTemplates.json').success(function (data) {
                    $timeout(function () {
                        campaignTemplatesFetched = true;
                        campaignTemplatesCache = data;
                        var result = campaignTemplatesCache.find(function (campaignTemplate) {
                            return campaignTemplate.id.toString() === campaignTemplateId.toString();
                        });
                        deferred.resolve(result);
                    }, serverDelayMs);
                }).error(function (data, header, status) {
                    apiErrorHandlerService(data, header, status, deferred);
                });
            }

            return deferred.promise;
        };

        this.getCampaignTemplates = function () {
            var deferred = $q.defer();

            if (campaignTemplatesFetched) {
                $timeout(function () {
                    deferred.resolve(campaignTemplatesCache);
                }, serverDelayMs);
            } else {
                $http.get('../../../assets/mockData/campaignTemplates.json').success(function (data) {
                    $timeout(function () {
                        campaignTemplatesFetched = true;
                        campaignTemplatesCache = data;
                        deferred.resolve(campaignTemplatesCache);
                    }, serverDelayMs);
                }).error(function (data, header, status) {
                    apiErrorHandlerService(data, header, status, deferred);
                });
            }

            return deferred.promise;
        };

        this.createCampaignTemplate = function (newCampaignTemplate) {
            var deferred = $q.defer();

            $timeout(function () {
                newCampaignTemplate.id = campaignTemplatesCache.length + 1;
                campaignTemplatesCache.push(newCampaignTemplate);
                deferred.resolve(newCampaignTemplate);
            }, serverDelayMs);

            return deferred.promise;
        };

        this.updateCampaignTemplate = function (updatedCampaignTemplate) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignTemplatesCache.findIndex(function (campaignTemplate) {
                    return campaignTemplate.id.toString() === updatedCampaignTemplate.id.toString();
                });
                campaignTemplatesCache.splice(foundIndex, 1, updatedCampaignTemplate);
                deferred.resolve(updatedCampaignTemplate);
            }, serverDelayMs);


            return deferred.promise;
        };

        this.deleteCampaignTemplate = function (campaignTemplateId) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignTemplatesCache.findIndex(function (campaignTemplate) {
                    return campaignTemplate.id.toString() === campaignTemplateId.toString();
                });

                if (foundIndex > -1) {
                    campaignTemplatesCache.splice(foundIndex, 1);
                    deferred.resolve(campaignTemplateId);
                } else {
                    apiErrorHandlerService(campaignTemplateId);
                }
            }, serverDelayMs);

            return deferred.promise;
        };

        // end campaign templates

        // campaigns

        var campaignsFetched = false,
            campaignsCache = [];

        this.getCampaignById = function (campaignId) {
            var deferred = $q.defer();

            if (campaignsFetched) {
                $timeout(function () {
                    var result = campaignsCache.find(function (campaign) {
                        return campaign.id.toString() === campaignId.toString();
                    });
                    deferred.resolve(result);
                }, serverDelayMs);
            } else {
                $http.get('../../../assets/mockData/campaigns.json').success(function (data) {
                    $timeout(function () {
                        campaignsFetched = true;
                        campaignsCache = data;
                        var result = campaignsCache.find(function (campaign) {
                            return campaign.id.toString() === campaignId.toString();
                        });
                        deferred.resolve(result);
                    }, serverDelayMs);
                }).error(function (data, header, status) {
                    apiErrorHandlerService(data, header, status, deferred);
                });
            }

            return deferred.promise;
        };

        this.getCampaigns = function () {
            var deferred = $q.defer();

            if (campaignsFetched) {
                $timeout(function () {
                    deferred.resolve(campaignsCache);
                }, serverDelayMs);
            } else {
                $http.get('../../../assets/mockData/campaigns.json').success(function (data) {
                    $timeout(function () {
                        campaignsFetched = true;
                        campaignsCache = data;
                        deferred.resolve(campaignsCache);
                    }, serverDelayMs);
                }).error(function (data, header, status) {
                    apiErrorHandlerService(data, header, status, deferred);
                });
            }

            return deferred.promise;
        };

        this.createCampaign = function (newCampaign) {
            var deferred = $q.defer();

            $timeout(function () {
                newCampaign.id = campaignsCache.length + 1;
                campaignsCache.push(newCampaign);
                deferred.resolve(newCampaign);
            }, serverDelayMs);

            return deferred.promise;
        };

        this.updateCampaign = function (updatedCampaign) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignsCache.findIndex(function (campaign) {
                    return campaign.id.toString() === updatedCampaign.id.toString();
                });
                campaignsCache.splice(foundIndex, 1, updatedCampaign);
                deferred.resolve(updatedCampaign);
            }, serverDelayMs);


            return deferred.promise;
        };

        this.activateCampaign = function (campaignId) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignsCache.findIndex(function (campaign) {
                    return campaign.id.toString() === campaignId.toString();
                });
                campaignsCache[foundIndex].isActive = true;
                deferred.resolve();
            }, serverDelayMs);

            return deferred.promise;
        };

        this.deleteCampaign = function (campaignId) {
            var deferred = $q.defer();

            $timeout(function () {
                var foundIndex = campaignsCache.findIndex(function (campaign) {
                    return campaign.id.toString() === campaignId.toString();
                });

                if (foundIndex > -1) {
                    campaignsCache.splice(foundIndex, 1);
                    deferred.resolve(campaignId);
                } else {
                    apiErrorHandlerService(campaignId);
                }
            }, serverDelayMs);

            return deferred.promise;
        };


        // end campaigns

        this.getUsersForUserGroup = function (groupId, page, pageSize, orderBy, order) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/groupUsers.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.addUserToUserGroup = function (groupId, userId) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        };

        this.removeUserFromUserGroup = function (membershipId) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        };

        // INVOICES
        // get all invoices by selected date interval

        this.getPeriodicSummary = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/periodicSummary.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        this.getInvoices = function (fromTimestamp, toTimestamp, page, pageSize, orderBy, order) {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/invoices.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        };

        // update new invoice
        this.updateInvoice = function (invoiceId, status) {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        };

        this.createLocalTokens = function () {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        };

        this.getLocalTokensHistory = function () {
            var deferred = $q.defer();

            $http.get('../../../assets/mockData/vouchers.json').success(function (data) {
                $timeout(function () {
                    deferred.resolve(data);
                }, serverDelayMs);
            }).error(function (data, header, status) {
                apiErrorHandlerService(data, header, status, deferred);
            });

            return deferred.promise;
        }

        this.createVouchers = function () {
            var deferred = $q.defer();

            $timeout(function () {
                deferred.resolve({});
            }, serverDelayMs);

            return deferred.promise;
        }
        /* eslint-enable */
    }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('apiErrorHandlerService', apiErrorHandlerService);

  /** @ngInject */
  function apiErrorHandlerService(
    $log,
    errorActions,
    layoutActions,
    $translate,
    $state,
    sessionData,
    dispatcher,
    ActionTypesEnum,
    $window,
    checkAccessRefreshTokenValidity
  ) {
    function apiErrorCallback(data, header, status, apiPromise) {
      var payload;

      // Handle case when data is null or undefined
      if (!data) {
        $log.error('The "data" object is null or undefined.');
        layoutActions.hideLoader();
        payload = {
          errorPageMsg:
            $translate.instant('DEFAULT_ERROR_NAME') +
            '. ' +
            $translate.instant('DEFAULT_ERROR_DESCRIPTION')
        };
        errorActions.showErrorPage(payload);
        apiPromise.reject('An unknown error occurred.');
        return;
      }

      // Handle case when data.message is undefined
      var errorMessage = data.message || $translate.instant('DEFAULT_ERROR_DESCRIPTION');

      $log.error('MESSAGE: ' + errorMessage + ' | ' + 'HEADER: ' + header);

      layoutActions.hideLoader();
      switch (status) {
        case 400:
          if (header === 'onlyMsg') {
            dispatcher.dispatch({
              type: ActionTypesEnum.SHOW_TOASTER_MSG,
              payload: {
                type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                message: $translate.instant(errorMessage)
              }
            });
            break;
          }
          payload = {
            errorPageMsg: errorMessage
          };
          errorActions.showErrorPageReturnToDashboard(payload);
          break;
        case 401:
          checkAccessRefreshTokenValidity.refreshToken();
          break;
        case 403:
          if (errorMessage === 'Access is denied') {
            sessionData.clearAll();
            $state.go('login');
          } else {
            payload = {
              errorDescription: {
                error: header,
                message: $translate.instant(errorMessage)
              }
            };
            errorActions.showErrorMsg(payload);
            $window.scrollTo(0, 0);
          }
          break;
        case 404:
          payload = {
            errorPageMsg: $translate.instant('MISSING_PAGE')
          };
          errorActions.showErrorPage(payload);
          break;
        case 409:
          payload = {
            errorDescription: {
              error: header,
              message: $translate.instant(errorMessage)
            }
          };
          errorActions.showErrorMsg(payload);
          break;
        case 503:
          payload = {
            errorPageMsg:
              $translate.instant('DEFAULT_ERROR_NAME') +
              '. ' +
              $translate.instant('DEFAULT_ERROR_DESCRIPTION')
          };
          errorActions.showErrorPage(payload);
          break;
        case 500:
          payload = {
            errorPageMsg:
              $translate.instant('DEFAULT_ERROR_NAME') +
              '. ' +
              $translate.instant('DEFAULT_ERROR_DESCRIPTION')
          };
          errorActions.showErrorPage(payload);
          break;
        default:
          payload = {
            errorPageMsg:
              $translate.instant('DEFAULT_ERROR_NAME') +
              '. ' +
              $translate.instant('DEFAULT_ERROR_DESCRIPTION')
          };
          errorActions.showErrorPage(payload);
          apiPromise.reject(errorMessage);
      }
    }

    return apiErrorCallback;
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('apiService', apiService);

  /** @ngInject */
  function apiService(
    $http,
    $q,
    apiErrorHandlerService,
    sessionData,
    apiMockService,
    $log
  ) {
    var apiHostUrl = '';

    this.init = function (hostUrl) {
      apiHostUrl = hostUrl;
    };

    this.signIn = function (username, password) {
      var deferred = $q.defer();
      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/emailSignIn',
        headers: {
          Accept: 'text/plain, application/vnd.authentication.v2+json'
        },
        data: {
          username: username,
          password: password
        }
      }).then(
        function (successResponse) {
          deferred.resolve(successResponse.data);
        },
        function (errorResponse) {
          deferred.reject(
            errorResponse.data,
            errorResponse.header,
            errorResponse.status
          );
        }
      );

      return deferred.promise;
    };

    this.getWebSocketsToken = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/websocketsToken'
      }).then(
        function (successResponse) {
          deferred.resolve(successResponse.data);
        },
        function (errorResponse) {
          apiErrorHandlerService(
            errorResponse.data,
            errorResponse.header,
            errorResponse.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.forgotPassword = function (_email, language) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/passwordReset?language=' + language,
        headers: {
          Accept: 'text/plain, application/vnd.resetpassword.v1+json'
        },
        data: {
          email: _email,
          clientType: 'MERCHANT'
        }
      }).then(
        function (successResponse) {
          deferred.resolve(successResponse.data);
        },
        function (errorResponse) {
          deferred.reject(
            errorResponse.data,
            errorResponse.header,
            errorResponse.status
          );
        }
      );

      return deferred.promise;
    };

    this.resetPassword = function (data) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/resetPassword/' + data.code,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data.password
      }).then(
        function (successResponse) {
          deferred.resolve(successResponse.data);
        },
        function (errorResponse) {
          deferred.reject(
            errorResponse.data,
            errorResponse.header,
            errorResponse.status
          );
        }
      );

      return deferred.promise;
    };

    this.refreshToken = function () {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        async: false,
        url: apiHostUrl + '/api/refreshToken',
        headers: {
          Accept: 'text/plain, application/vnd.authentication.v2+json'
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.changeUserRole = function (data) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/employees/' + data.userId,
        data: {
          role: data.role,
          adminId: data.adminId
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateUserInfo = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/users/me/',
        headers: { Accept: 'application/vnd.noemail.v1+json' },
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.changePassword = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/users/me/passwordChange',
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.addNewUser = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        data: data,
        url: apiHostUrl + '/api/companies/myCompany/facilityAdmins'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (err) {
          deferred.reject(err);
        }
      );

      return deferred.promise;
    };

    this.deleteUser = function (userId) {
      var deferred = $q.defer();
      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/employees/' + userId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.activateAccount = function (data) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/accountActivation/' + data.activationCode,
        data: data.password
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            'onlyMsg',
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getDevices = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/r2wDevices'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getDeviceDetails = function (deviceId) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/washFacilities/' + deviceId + '/details'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateDeviceDetails = function (deviceId, data) {
      var deferred = $q.defer();
      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        data: data,
        url: apiHostUrl + '/api/washFacilities/' + deviceId + '/details'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // DON'T ERASE ----------------------------------------------------------------

    // this.getDeviceBySerialNumber = function (serialNumber) {
    //     var deferred = $q.defer();

    //     $http({
    //         method: 'GET',
    //         cache: false,
    //         headers: { 'Accept': 'text/plain, application/json'},
    //         url: apiHostUrl + '/api/devices/' + serialNumber
    //     }).then(function (successData) {
    //         deferred.resolve(successData.data);
    //     }, function (errorData) {
    //         apiErrorHandlerService(errorData.data, errorData.header, errorData.status, deferred);
    //     });

    //     return deferred.promise;
    // };

    // -----------------------------------------------------------------------------

    this.getDeviceBySerialNumber = function (serialNumber) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/r2wDevices/' + serialNumber
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.actuate = function (serialNumber, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/devices/' + serialNumber + '/actuation',
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.groupActuate = function (deviceKey, pointId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/devices/' +
          deviceKey +
          '/' +
          pointId +
          '/groupActuation',
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getMessages = function (
      deviceKey,
      fromTimeStamp,
      toTimestamp,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&since=' +
          fromTimeStamp +
          '&to=' +
          toTimestamp +
          '&sort=' +
          orderBy +
          ',' +
          order;

      if (deviceKey) {
        query += '&deviceKey=' + deviceKey;
      }

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/messages' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getAlarmMessages = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/messages/alarms'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.dismissAlarm = function (alarmId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/messages/alarms/' + alarmId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getKarcherAlarms = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/karcher-alarm/list'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // REPORTS
    this.getDailyFinances = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/vnd.dailyturnover.v2+json' },
        url: apiHostUrl + '/api/periodicReports/dailyTurnover'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getDailyFinancesBySerialNumber = function (serialNumber) {
      return apiMockService.getDailyFinancesBySerialNumber(serialNumber);
    };

    this.getFinancesByDate = function (
      serialNumber,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalByDate?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalCoinsByDate = function (
      serialNumber,
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalCoinsPayments?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalTokenPaymentsByDate = function (fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalTokenPayments?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalTokenCount = function (fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalTokenCount?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalEuroKeyByDate = function (
      deviceSerial,
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalEurokeyPayments?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getLoyaltyTresholds = function (
      campaignId,
      type,
      tresholdValue,
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/loyaltyCampaigns/' +
          campaignId +
          '/thresholdReport?from=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          '&threshold=' +
          tresholdValue +
          '&type=' +
          type
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getAvgMoneyByHours = function (
      serialNumber,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/averageByHour?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getAvgMoneyByBox = function (
      facilityPointId,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/spendingByBox?facilityId=' +
          facilityPointId +
          '&since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getAvgMoneyByDay = function (
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/averageByDayOfWeek?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getPosIncome = function (
      facilityId,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalIncomePOS?facilityId=' +
          facilityId +
          '&since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalR2WByDate = function (
      deviceSerial,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/totalOnlinePayments?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getComparationForPeriod = function (
      deviceSerial,
      fromMonth,
      toMonth,
      fromYear,
      toYear
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/comparativeFacilityReport?facilityId=' +
          deviceSerial +
          '&sinceMonth=' +
          fromMonth +
          '&toMonth=' +
          toMonth +
          '&yearOne=' +
          fromYear +
          '&yearTwo=' +
          toYear
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalByUserGroupsForPeriod = function (fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/usersPerGroup?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getVisitsCountForPeriod = function (fromTimestamp, toTimestamp) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/usersPerVisitCount?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalSpentLocalTokensPerDay = function (
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/lwtsSpentByFacility?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalGivenLocalTokensPerDay = function (
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/lwtsGivenByDay?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTotalPurchasedLocalTokensPerDay = function (
      fromTimestamp,
      toTimestamp
    ) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/lwtsSoldByDay?since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getChangerIncomePerDate = function (
      facilityId,
      fromTimestamp,
      toTimestamp,
      currency
    ) {
      var deferred = $q.defer();
      var currencyQuery = currency ? '&currency=' + currency : '';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/reports/changerIncome?facilityId=' +
          facilityId +
          '&since=' +
          fromTimestamp +
          '&to=' +
          toTimestamp +
          currencyQuery
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getLoyaltyPerPaymentMethodForPeriod = function (
      fromTimestamp,
      toTimestamp
    ) {
      return apiMockService.getLoyaltyPerPaymentMethodForPeriod(
        fromTimestamp,
        toTimestamp
      );
    };

    this.sendMessageToCampaignUsers = function (
      campaignId,
      tresholdValue,
      type,
      msg
    ) {
      var deferred = $q.defer();
      $http({
        method: 'POST',
        data: msg,
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/loyaltyCampaigns/' +
          campaignId +
          '/message?threshold=' +
          tresholdValue +
          '&type=' +
          type
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    //sempra users

    this.getCompanyUsers = function (page, pageSize, orderBy, order) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;
      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/employees' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.searchSempraUsers = function (searchTerm) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/users/search',
        data: searchTerm
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.searchSempraUsersByTelephoneNumber = function (searchTerm) {
      return this.searchSempraUsers(searchTerm);
    };

    //end sempra users

    // user groups

    this.getUserGroupById = function (groupId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getUserGroups = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/userGroups'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTemporalRulePercentage = function (temporalDeviceType) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/r2wDevices/temporalRulePercentage?temporalDeviceType=' +
          temporalDeviceType
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createUserGroup = function (groupName) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/userGroups',
        data: groupName
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateUserGroup = function (groupId, groupName) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId,
        data: groupName
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteUserGroup = function (groupId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // end user groups

    // campaign templates

    this.getCampaignTemplateById = function (campaignTemplateId) {
      return apiMockService.getCampaignTemplateById(campaignTemplateId);
    };

    this.getCampaignTemplates = function () {
      return apiMockService.getCampaignTemplates();
    };

    this.createCampaignTemplate = function (newCampaignTemplate) {
      return apiMockService.createCampaignTemplate(newCampaignTemplate);
    };

    this.updateCampaignTemplate = function (updatedCampaignTemplate) {
      return apiMockService.updateCampaignTemplate(updatedCampaignTemplate);
    };

    this.deleteCampaignTemplate = function (campaignTemplateId) {
      return apiMockService.deleteCampaignTemplate(campaignTemplateId);
    };

    // end campaign templates

    // campaigns

    this.getCampaignById = function (campaignId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns/' + campaignId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getCampaigns = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createCampaign = function (newCampaign) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns',
        data: newCampaign
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateCampaign = function (updatedCampaign) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns/' + updatedCampaign.id,
        data: updatedCampaign
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.activateCampaign = function (campaignId) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns/' + campaignId + '/status',
        data: true
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteCampaign = function (campaignId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/loyaltyCampaigns/' + campaignId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // end campaigns

    this.getUsersForUserGroup = function (groupId, page, pageSize) {
      var deferred = $q.defer(),
        query = '?page=' + page + '&size=' + pageSize;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId + '/memberships' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getActiveUsersForUserGroup = function (
      groupId,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/userGroups/' +
          groupId +
          '/memberships/active' +
          query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.addUserToUserGroup = function (groupId, userId) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/userGroups/' + groupId + '/memberships',
        data: userId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.removeUserFromUserGroup = function (membershipId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/memberships/' + membershipId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // INVOICES
    // get all invoices by selected year and type

    this.getPeriodicSummary = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/periodicReports/periodicSummary'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getInvoices = function (
      selectedYear,
      selectedType,
      page,
      pageSize,
      orderBy,
      order
    ) {
      orderBy = orderBy.indexOf('-') > -1 ? orderBy.substring(1) : orderBy;

      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&year=' +
          selectedYear +
          '&type=' +
          selectedType +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/invoices/' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // SEND INVOICE TO R2W
    this.updateInvoice = function (invoiceId, invoiceNumber, status) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/invoices/' + invoiceId + '/' + status, // only payment
        data: invoiceNumber
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // GET INVOICE PDF
    this.downloadInvoice = function (id) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/invoices/' + id + '/pdf',
        responseType: 'arraybuffer',
        headers: { Accept: 'text/plain, application/pdf' }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET B2B SPECIFICATION PDF
    this.downloadB2bSpec = function (id) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/invoices/' + id + '/b2b',
        responseType: 'arraybuffer',
        headers: { Accept: 'text/plain, application/pdf' }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET B2C SPECIFICATION PDF
    this.downloadB2cSpec = function (id) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/invoices/' + id + '/b2c',
        responseType: 'arraybuffer',
        headers: { Accept: 'text/plain, application/pdf' }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET BUSINESS TRANSACTIONS
    this.getBusinessTransactions = function (
      sinceMonth,
      toMonth,
      year,
      orderBy,
      order,
      page,
      pageSize
    ) {
      var deferred = $q.defer(),
        query =
          '?sinceMonth=' +
          sinceMonth +
          '&toMonth=' +
          toMonth +
          '&year=' +
          year +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: {
          Accept: 'application/vnd.businessuserexpenses+json'
        },
        url: apiHostUrl + '/api/invoices/expenses' + query
      }).then(
        function successCallback(response) {
          deferred.resolve(response.data);
        },
        function errorCallback(errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.headers,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // GET BUSINESS INVOICE PDF
    this.downloadBusinessInvoice = function (userId, month, year) {
      var deferred = $q.defer(),
        query = '?userId=' + userId + '&month=' + month + '&year=' + year;

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/invoices/pdf' + query,
        responseType: 'arraybuffer',
        headers: { Accept: 'text/plain, application/pdf' }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // NEWS
    this.getCompanyNews = function (page, pageSize, orderBy, order, companyId) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order +
          '&company=' +
          companyId;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/news/' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteNews = function (newsId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/news/' + newsId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.saveNews = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/news/',
        data: data
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // GLOBAL NOTICE
    this.getGlobalNotice = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/vnd.news.merchant.notice+json' },
        url: apiHostUrl + '/api/news/notice'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createLocalTokens = function (email, amount) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers/directTopUp',
        data: {
          email: email,
          amount: amount
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    };

    this.getVouchersHistory = function (
      page,
      pageSize,
      orderBy,
      order,
      voucherPrefixFilter
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      if (voucherPrefixFilter) {
        query = query + '&codePrefix=' + voucherPrefixFilter;
      }

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.vouchersToCSV = function (voucherPrefixFilter) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/csv, application/vnd.voucher.list+json' },
        responseType: 'text',
        url: apiHostUrl + '/api/vouchers?codePrefix=' + voucherPrefixFilter
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createVouchers = function (
      amountTokens,
      numberOfVouchers,
      voucherPrefix,
      expireInDays
    ) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers/create',
        data: {
          amountTokens: amountTokens,
          numberOfVouchers: numberOfVouchers,
          prefix: voucherPrefix,
          expiresInDays: expireInDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    };

    this.createAndRetrieveVouchers = function (
      amountTokens,
      numberOfVouchers,
      voucherPrefix,
      expireInDays
    ) {
      var deferred = $q.defer();

      console.log('🚀 API Service - Sending expiresInDays:', expireInDays, 'Type:', typeof expireInDays);

      $http({
        method: 'POST',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/vouchers/createAndRetrieve',
        data: {
          amountTokens: amountTokens,
          numberOfVouchers: numberOfVouchers,
          prefix: voucherPrefix,
          expiresInDays: expireInDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData);
        }
      );

      return deferred.promise;
    };

    this.deleteHistory = function () {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/myCompany/cashHistory'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTransactionsExpenses = function (
      email,
      fromTimeStamp,
      toTimestamp,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?email=' +
          email +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&since=' +
          fromTimeStamp +
          '&to=' +
          toTimestamp +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/invoices/expenses' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getTransactionsTopUps = function (
      email,
      fromTimeStamp,
      toTimestamp,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?email=' +
          email +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&since=' +
          fromTimeStamp +
          '&to=' +
          toTimestamp +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/invoices/locals' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getManagingTokens = function (email) {
      var deferred = $q.defer();

      var encodeEmail = encodeURIComponent(email);

      var query = '?email=' + encodeEmail;

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/accountBalances' + query,
        headers: { Accept: 'application/vnd.listvirtual.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteManagingTokens = function (data) {
      var deferred = $q.defer();

      var query = data.accountId + '?amount=' + data.amount;

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/accountBalances/' + query,
        headers: { Accept: 'application/vnd.delete.v2+json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.extendManagingTokens = function (data) {
      var deferred = $q.defer();

      var query = data.accountId + '?timestamp=' + data.timestamp;

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/accountBalances/' + query,
        headers: { Accept: 'application/vnd.extend.v2+json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getCompanyDetails = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/companies/myCompany',
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getRegionById = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/regions/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Pricing

    this.getCompanyTokenPackage = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage',
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getSingleCompanyTokenPackage = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createCompanyTokenPackage = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage',
        headers: { Accept: 'application/json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateCompanyTokenPackage = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage/' + data.id,
        headers: { Accept: 'application/json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteCompanyTokenPackage = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/prices/companyTokenPackage/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getSingeWashes = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash',
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getSingeWash = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createSingeWash = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash?price=' + data.price,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateSingeWash = function (data) {
      var deferred = $q.defer();

      var query = '?price=' + data.price;

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash/' + data.id + query,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteSingeWash = function (id) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/prices/companySingleWash/' + id,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Working hours

    this.getDeviceWorkingHours = function (pointId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/facilityWorkingSchedule/' + pointId,
        headers: { Accept: 'application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateDeviceWorkingHours = function (pointId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/facilityWorkingSchedule/' + pointId,
        headers: { Accept: 'application/json' },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // ORGANIZATIONS
    this.getOrganizationsListByType = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations',
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getOrganizationById = function (organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/' + organizationId,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getSupportedOrganizationList = function (organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url:
          apiHostUrl +
          '/api/merchant-organizations/' +
          organizationId +
          '/support',
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createChildOrganization = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations',
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateChildOrganization = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/' + data.id,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteOrganization = function (organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/' + organizationId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getForUserOrganizationListByUserId = function (userId) {
      var deferred = $q.defer(),
        paramUrl = userId
          ? '/api/merchant-organizations/userOrganization/' +
            userId +
            '/organizations'
          : '/api/merchant-organizations/userOrganization/organizations';
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + paramUrl,
        headers: { Accept: 'text/plain, application/vnd.organizations.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getForUserCreateOrganizationList = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/userOrganization/list',
        headers: {
          Accept: 'text/plain, application/vnd.user.organizations.v1+json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createUserForSelectedOrganizationAndRole = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/merchant-organizations/userOrganization',
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateUserForSelectedOrganizationAndRole = function (userId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url:
          apiHostUrl + '/api/merchant-organizations/userOrganization/' + userId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.resendVerificationMail = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/merchant/verificationMail',
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getOrganizationUsers = function (
      email,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?email=' +
          email +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;
      $http({
        method: 'GET',
        cache: false,
        headers: {
          Accept: 'text/plain, application/vnd.user.organizations.v1+json'
        },
        url:
          apiHostUrl +
          '/api/merchant-organizations/userOrganization/list' +
          query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getOrganizationUserById = function (userId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl + '/api/merchant-organizations/userOrganization/' + userId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteOrganizationUser = function (userId, organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'DELETE',
        cache: false,
        url:
          apiHostUrl +
          '/api/merchant-organizations/userOrganization/' +
          userId +
          '/' +
          organizationId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Use only for create organization
    this.getAllCompaniesShort = function (organizationId) {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/companies/organizations/' + organizationId + '/list',
        headers: { Accept: 'text/plain, application/vnd.companyshort.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getAllRegionsShort = function () {
      var deferred = $q.defer();
      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/regions/list',
        headers: { Accept: 'text/plain, application/vnd.regionshort.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getAllSitesShort = function (organizationId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/organizations/' + organizationId + '/list',
        headers: { Accept: 'text/plain, application/vnd.all.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Karcher - Dashboard
    this.getKarcherSitesData = function (siteName, alarmStatus) {
      var deferred = $q.defer();
      var query = '?siteName=' + siteName + '&statuses=' + alarmStatus;

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites' + query,
        headers: { Accept: 'text/plain, application/vnd.overview.v1+json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherSitesInfoWindowData = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/' + siteId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherSiteDetailsById = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/' + siteId + '/devices',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherFaultsByDeviceId = function (deviceId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm/' + deviceId + '/faults',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherDeviceDetailsById = function (siteId, deviceId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url:
          apiHostUrl + '/api/merchantSites/' + siteId + '/devices/' + deviceId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Karcher alarms (messages)
    this.getKarcherSiteAlarmList = function (
      filter,
      faultStatus,
      facilityId,
      siteIds,
      from,
      to,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?filter=' +
          filter +
          '&faultStatus=' +
          faultStatus +
          '&washFacilityId=' +
          facilityId +
          siteIds +
          '&from=' +
          from +
          '&to=' +
          to +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm' + query,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Karcher alarms history (messages)
    this.getKarcherAlarmsHistoryList = function (
      filter,
      facilityId,
      from,
      to,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?filter=' +
          filter +
          '&from=' +
          from +
          '&to=' +
          to +
          '&page=' +
          page +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        url:
          apiHostUrl + '/api/karcher-alarm/' + facilityId + '/history' + query,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getKarcherAlarmSubscriptions = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm/subscriptions',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.createAlarmSubscription = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm/subscriptions',
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.unsubscribeKarcherAlert = function (siteId) {
      var deferred = $q.defer();
      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/karcher-alarm/subscriptions/' + siteId,
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getAllSitesForExactUser = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/list',
        headers: { Accept: 'text/plain, application/json' }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // Cashless Payment and Refund
    this.getCashlessSales = function (
      filter,
      since,
      until,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          '&size=' +
          pageSize +
          '&filter=' +
          filter +
          '&since=' +
          since +
          '&until=' +
          until +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/cashlessSales' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getCashlessSalesExportCSV = function (
      filter,
      since,
      until
    ) {
      var deferred = $q.defer(),
        query =
          '?filter=' +
          filter +
          '&since=' +
          since +
          '&until=' +
          until;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/cashlessSales/exportCSV' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.refundCashlessPayment = function (id, amount) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url:
          apiHostUrl + '/api/cashlessSales/' + id + '/refund?amount=' + amount,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getCashlessTotals = function (since, until, filter) {
      var deferred = $q.defer(),
        query = '?since=' + since + '&until=' + until + '&filter=' + filter;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/cashlessSales/total' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // FOR KARCHER REPORTS REQUIRED APIS
    this.getWashFacilityBoxesByWashFacilityId = function (washFacilityId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url:
          apiHostUrl +
          '/api/washFacilities/' +
          washFacilityId +
          '/washFacilityBoxes'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getWashFacilityShortList = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/washFacilities/accessible'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // KARCHER REPORTS
    this.getJetwashReportTurnoverPerBay = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/jetwash/turnoverPerBay' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getJetwashReportTurnoverPerChannel = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&bayId=' +
          data.bayId +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/jetwash/turnoverPerChannel' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getJetwashReportWorkingHoursPerProgram = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&bayId=' +
          data.bayId +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/jetwash/workingHoursPerProgram' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getRolloverReportWashesPerProgram = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&type=' +
          data.type +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/rollover/washesPerProgram' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getRolloverReportTurnover = function (data) {
      var deferred = $q.defer(),
        query =
          '?facilityId=' +
          data.facilityId +
          '&timeUnit=' +
          data.timeUnit +
          '&since=' +
          data.since +
          '&to=' +
          data.to;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: apiHostUrl + '/api/reports/rollover/turnover' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getHistoryOfActuatedPointsByDeviceKey = function (
      deviceKey,
      pointIds,
      page,
      pageSize,
      orderBy,
      order
    ) {
      var deferred = $q.defer(),
        query =
          '?page=' +
          page +
          pointIds +
          '&size=' +
          pageSize +
          '&sort=' +
          orderBy +
          ',' +
          order;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl +
          '/api/devices/' +
          deviceKey +
          '/actuators/history' +
          query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getPointsListByDeviceKey = function (deviceKey) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/points/device/' + deviceKey + '/actuators'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // WEATHER API
    this.getCurrentWeather = function (latitude, longitude) {
      var deferred = $q.defer(),
        weatherApiKey = 'c88952ff3c1743289b0134557231406',
        query = '?q=' + latitude + ', ' + longitude + '&key=' + weatherApiKey;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: 'https://api.weatherapi.com/v1/current.json' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          $log.error(errorData);
        }
      );

      return deferred.promise;
    };

    this.getHistoryWeather = function (latitude, longitude, from, to) {
      var deferred = $q.defer(),
        weatherApiKey = 'c88952ff3c1743289b0134557231406',
        query =
          '?q=' +
          latitude +
          ', ' +
          longitude +
          '&dt=' +
          from +
          '&end_dt=' +
          to +
          '&key=' +
          weatherApiKey;

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/json' },
        url: 'https://api.weatherapi.com/v1/history.json' + query
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          $log.error(errorData);
        }
      );

      return deferred.promise;
    };

    // SITE WORKING SCHEDULES AND HOLIDAYS

    this.getSiteHolidays = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/siteholiday/' + siteId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.createSiteHolidays = function (siteId, data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/siteholiday/' + siteId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.updateSiteHolidays = function (siteId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/siteholiday/' + siteId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteSiteHolidays = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        url: apiHostUrl + '/api/siteholiday/' + siteId,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.deleteHoliday = function (siteId, holidayId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        url:
          apiHostUrl +
          '/api/siteholiday/' +
          siteId +
          '/siteHoliday/' +
          holidayId,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getWorkingSchedules = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/siteWorkingSchedule/' + siteId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateWorkingSchedules = function (siteId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/siteWorkingSchedule/' + siteId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.propagateWorkingSchedules = function (siteId, path) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/siteWorkingSchedule/' + siteId + '/propagate' + path,
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.getReleaseNotes = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/release-notes'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // API FOR ORGANIZATIONS TYPES BY ID
    this.getOrganizationsCompanyById = function (companyId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/' + companyId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateOrganizationVoucherExpirationDays = function (companyId,voucherExpirationDays) {
      var deferred = $q.defer();

      $http({
        method: 'PATCH',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/companies/' + companyId + '/voucherExpirationDays',
        data: {
          days: voucherExpirationDays
        }
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // Get events list for selected device - used on device details page, Karcher brand
    this.getEventsListForSelectedDevice = function (deviceKey) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/devices/' + deviceKey + '/pullRequest/events'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    // Report builder (dynamic reports)

    this.getAllReportConfigurations = function () {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url: apiHostUrl + '/api/reports/dynamic/configuration'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.getSelectedReportConfiguration = function (configurationId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl + '/api/reports/dynamic/configuration/' + configurationId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.deleteReportsData = function (companyId) {
      var deferred = $q.defer();

      $http({
        method: 'DELETE',
        cache: false,
        headers: { Accept: 'text/plain, application/json' },
        url:
          apiHostUrl + '/api/reports/transaction/' + companyId + '/cache'
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.executeDynamicReport = function (configurationId, data) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/reports/dynamic/report/' + configurationId,
        headers: {
          Accept: 'text/plain, application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // SITES DETAILS

    this.getSiteDetailsById = function (siteId) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'application/vnd.site.overview.v2+json' },
        url:
          apiHostUrl + '/api/merchantSites/' + siteId
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.updateSiteDetails = function (siteId, data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/merchantSites/' + siteId,
        headers: {
          Accept: 'application/vnd.site.update.v2+json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res.data);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET TERMS OF SERVICE DOCUMENT

    this.getTermsOfServiceDocument = function (isoCode, language) {
      var deferred = $q.defer();

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: 'text/html' },
        url:
          apiHostUrl +
          '/api/termsAndConditions/document/merchant?countryIsoCode=' + isoCode + '&locale=' + language
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          apiErrorHandlerService(
            errorData.data,
            errorData.header,
            errorData.status,
            deferred
          );
        }
      );

      return deferred.promise;
    };

    this.acceptTermsOfServiceDocument = function () {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/termsAndConditions/accept/merchant',
        headers: {
          Accept: 'text/plain, application/json'
        }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    // GET SESSION AND ACTIVATE SERVICE ON DEVICES

    this.createDeviceSession = function (boxPointId) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/points/' + boxPointId + '/sessions',
        headers: {
          Accept: 'application/vnd.session.v1+json'
        }
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.startDeviceService = function (facilityId, boxPointId, token) {
      var deferred = $q.defer();

      $http({
        method: 'POST',
        cache: false,
        url: apiHostUrl + '/api/washFacilities/admin/' + facilityId + '/boxes/' + boxPointId + '/activation',
        headers: {
          Accept: 'application/json'
        },
        data: token
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

    this.changeDeviceLabelName = function (data) {
      var deferred = $q.defer();

      $http({
        method: 'PUT',
        cache: false,
        url: apiHostUrl + '/api/points/label',
        headers: {
          Accept: 'application/json'
        },
        data: data
      }).then(
        function (res) {
          deferred.resolve(res);
        },
        function (err) {
          apiErrorHandlerService(err.data, err.headers, err.status, deferred);
        }
      );

      return deferred.promise;
    };

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').provider('api', apiProvider);

  /** @ngInject */
  function apiProvider () {
    this.$get = ['useServerMock', 'apiService', 'apiMockService', 'hostProtocol', 'hostDomain', 'useRemoteServerConnection',
      function (useServerMock, apiService, apiMockService, hostProtocol, hostDomain, useRemoteServerConnection) {
        if (useServerMock) {
          return apiMockService;
        }

        if (useRemoteServerConnection) {
          apiService.init(hostProtocol + '://' + hostDomain);
        }

        return apiService;
      }];
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').component('reportBuilderTableView', {
    templateUrl:
      'app/reportsBuilderKarcher/reportBuilderTableView/reportBuilderTableView.html',
    controller: reportBuilderTableView,
    bindings: {
      reportBuilderTableViewData: '<',
      reportBodyData: '<',
      paginationParams: '&'
    },
    controllerAs: 'vm'
  });

  function reportBuilderTableView($translate) {
    var vm = this;
    // GRID CONFIG
    vm.tablePageOptions = [2, 10, 20, 50];
    vm.pagerTranslations = {
      page: $translate.instant('GRID_PAGER_PAGE'),
      rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
      of: $translate.instant('GRID_PAGER_PAGE_OF')
    };

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      switch (true) {
        case changes.hasOwnProperty('reportBuilderTableViewData') && changes.hasOwnProperty('reportBodyData'):
          vm.tableData = changes.reportBuilderTableViewData.currentValue;
          vm.tableData.columnNames = Object.keys(vm.tableData.data[0]);
          vm.tableOrderBy = changes.reportBodyData.currentValue.sortBy;
          vm.tableOrder = changes.reportBodyData.currentValue.sortDir;
          vm.tablePageSize = changes.reportBodyData.currentValue.pageSize;
          vm.tablePage = changes.reportBodyData.currentValue.page + 1;
          break;
        case changes.hasOwnProperty('reportBuilderTableViewData'):
          vm.tableData = changes.reportBuilderTableViewData.currentValue;
          vm.tableData.columnNames = Object.keys(vm.tableData.data[0]);
          break;
        case changes.hasOwnProperty('reportBodyData'):
          vm.tableOrderBy = changes.reportBodyData.currentValue.sortBy;
          vm.tableOrder = changes.reportBodyData.currentValue.sortDir;
          vm.tablePageSize = changes.reportBodyData.currentValue.pageSize;
          vm.tablePage = changes.reportBodyData.currentValue.page + 1;
          break;
      }
    };

    vm.pageChanged = function (page, limit) {
      vm.paginationParams({ page: page, limit: limit });
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('UsersPerVisitReportViewModel', usersPerVisitReportViewModelFactory);

  /** @ngInject */
  function usersPerVisitReportViewModelFactory($translate, reportActions, reportsFilterStore, dispatcher, ActionTypesEnum) {
    function UsersPerVisitReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'category',
          label: {
              text: '(' + $translate.instant('TOTAL_USERS_BY_GROUP_VISITS_UNIT') + ')',
              position: 'outer-right'
          }
        }
      };

      this.chartType = 'TOTAL_USERS_BY_GROUP_USERS_UNIT';

      init.call(this);
    }

    UsersPerVisitReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return UsersPerVisitReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions.getUsersPerVisitCount(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        successData.unit = $translate.instant('TOTAL_USERS_BY_GROUP_USERS_UNIT');
        successData.groupNames = successData.groupNames.map(function(item){
          return $translate.instant(item);
        });
        successData.groupsData.sort(function(a,b) {
          return (a.groupValue > b.groupValue) ? 1 : -1;
        });
        that.chart.data = successData;
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('usersPerVisitReportController', usersPerVisitReportController);

  /** @ngInject */
  function usersPerVisitReportController($scope, $translate, reportExportUtil, exportToCsv, UsersPerVisitReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new UsersPerVisitReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant('NUMBER_OF_VISITS_TITLE'),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DEFAULT,
        reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
        $translate.instant('VISITS_COUNT_REPORT'),
        true);
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('UserGroupsByDateViewModel', userGroupsByDateViewModelFactory);

  /** @ngInject */
  function userGroupsByDateViewModelFactory(reportActions, localeFilters, reportsFilterStore, $translate, dispatcher, ActionTypesEnum) {
    function UserGroupsByDateViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      this.chartType = 'TOTAL_USERS_BY_GROUP_VISITS_UNIT';

      init.call(this);
    }

    UserGroupsByDateViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return UserGroupsByDateViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();
      that.total = 0;
      that.totalByGroupName = [];
      reportActions.getTotalUsersByGroupsAndDate(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        successData.groupTotal.forEach(function (item, index) {
          that.total += item;

          that.totalByGroupName.push({
            total: item,
            name: successData.groupNames[index]
          });
        });
        successData.unit = $translate.instant('TOTAL_USERS_BY_GROUP_USERS_UNIT');
        that.chart.data = successData;
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('userGroupsByDateController', userGroupsByDateController);

  /** @ngInject */
  function userGroupsByDateController ($scope, $translate, reportExportUtil, exportToCsv, UserGroupsByDateViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new UserGroupsByDateViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('TOTAL_USERS_BY_GROUP'),
          true);
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('totalPurchasedLocalTokensPerDayReportViewModel', totalPurchasedLocalTokensPerDayReportViewModelFactory);

  /** @ngInject */
  function totalPurchasedLocalTokensPerDayReportViewModelFactory(reportActions, localeFilters, reportsFilterStore, $translate, dispatcher, ActionTypesEnum) {
    function totalPurchasedLocalTokensPerDayReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      init.call(this);
    }

    totalPurchasedLocalTokensPerDayReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return totalPurchasedLocalTokensPerDayReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      that.totalByGroupName = [];

      reportActions.getTotalPurchasedLocalTokensPerDay(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {

        if (successData.length > 0) {
          that.total = successData.map(function (item) {
            return item.count;
          }).reduce(function (total, value) {
            return total + value;
          });
        }

        //successData.unit = 'TOTAL_USERS_BY_GROUP_USERS_UNIT';
        that.chart.data = successData;
        that.unit = $translate.instant('LOCAL_TOKEN');
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('totalPurchasedLocalTokensPerDayReportController', totalPurchasedLocalTokensPerDayReportController);

  /** @ngInject */
  function totalPurchasedLocalTokensPerDayReportController($scope, $translate, reportExportUtil, exportToCsv, totalPurchasedLocalTokensPerDayReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new totalPurchasedLocalTokensPerDayReportViewModel();
    vm.exportToCsv = exportCsv;
    vm.namingData = 'TOKENS_TITLE';

    init();

    function init() {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant('DATE'),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER, vm.namingData);

      exportToCsv.export(jsonArrayForExport,
        $translate.instant('TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY'),
        true);
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('PosIncomeReportViewModel', PosIncomeReportViewModelFactory);

  /** @ngInject */
  function PosIncomeReportViewModelFactory(
    reportActions,
    reportsFilterStore,
    $translate,
    localeFilters,
    dispatcher,
    ActionTypesEnum
  ) {
    function PosIncomeReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (xItem) {
              return $translate.instant(localeFilters.date(xItem));
            }
          }
        }
      };

      init.call(this);
    }

    PosIncomeReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return PosIncomeReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions
        .getPosIncome(
          reportFilterData.selectedFacilitySerial,
          reportFilterData.fromTimestamp,
          reportFilterData.toTimestamp,
          reportFilterData.currency
        )
        .then(function (successData) {
          that.chart.data = successData;
          successData.groupsData.map(function (data) {
            //Increase day index by 1 to get proper schedule in the table (6 is sunday)
            data.groupValue = data.groupValue === 6 ? 0 : data.groupValue + 1;
          });
          that.isChartVisible = successData.total !== 0;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('posIncomeReportController', posIncomeReportController);

  /** @ngInject */
  function posIncomeReportController(
    $scope,
    $translate,
    reportExportUtil,
    exportToCsv,
    PosIncomeReportViewModel,
    dispatcher,
    ActionTypesEnum
  ) {
    var vm = this;

    vm.report = new PosIncomeReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant('DAYS'),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER
      );

      exportToCsv.export(
        jsonArrayForExport,
        $translate.instant('POS_INCOME'),
        true
      );
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('totalGivenLocalTokensPerDayReportViewModel', totalGivenLocalTokensPerDayReportViewModelFactory);

  /** @ngInject */
  function totalGivenLocalTokensPerDayReportViewModelFactory(reportActions, localeFilters, reportsFilterStore, $translate, dispatcher, ActionTypesEnum) {
    function totalGivenLocalTokensPerDayReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      init.call(this);
    }

    totalGivenLocalTokensPerDayReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return totalGivenLocalTokensPerDayReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      that.totalByGroupName = [];

      reportActions.getTotalGivenLocalTokensPerDay(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        that.total = successData.map(function (item) {
          return item.count;
        }).reduce(function (total, value) {
          return total + value;
        }, 0);
        that.chart.data = successData;
        that.unit = $translate.instant('LOCAL_TOKEN');
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('totalGivenLocalTokensPerDayReportController', totalGivenLocalTokensPerDayReportController);

  /** @ngInject */
  function totalGivenLocalTokensPerDayReportController($scope, $translate, reportExportUtil, exportToCsv, totalGivenLocalTokensPerDayReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new totalGivenLocalTokensPerDayReportViewModel();
    vm.exportToCsv = exportCsv;
    vm.namingData = 'TOKENS_TITLE';

    init();

    function init() {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant('DATE'),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER, vm.namingData);

      exportToCsv.export(jsonArrayForExport,
        $translate.instant('TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY'),
        true);
    }

  }
})();

//LoyaltyPerPaymentMethodReportViewModel
(function () {
  'use strict';

  angular.module('sempraWebapp').factory('LoyaltyPerPaymentMethodReportViewModel', loyaltyPerPaymentMethodReportViewModelFactory);

  /** @ngInject */
  function loyaltyPerPaymentMethodReportViewModelFactory(reportActions, localeFilters, reportsFilterStore, dispatcher, ActionTypesEnum) {
    function LoyaltyPerPaymentMethodReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'line',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      init.call(this);
    }

    LoyaltyPerPaymentMethodReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return LoyaltyPerPaymentMethodReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();
      that.total = 0;
      that.totalByGroupName = [];
      reportActions.getLoyaltyPerPaymentMethodForPeriod(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        successData.total.forEach(function (item, index) {
          that.total += item;

          that.totalByGroupName.push({
            total: item,
            name: successData.groupNames[index]
          });
        });
        that.chart.data = successData;
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();

//loyaltyPerPaymentMethodReportController
(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('loyaltyPerPaymentMethodReportController', loyaltyPerPaymentMethodReportController);

  /** @ngInject */
  function loyaltyPerPaymentMethodReportController ($scope, $translate, reportExportUtil, exportToCsv, LoyaltyPerPaymentMethodReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new LoyaltyPerPaymentMethodReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('LOYALTY_PER_PAYMENT_METHOD'),
          true);
    }


  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('GivenLoyaltyPerDayReportViewModel', givenLoyaltyPerDayReportViewModelFactory);

  /** @ngInject */
  function givenLoyaltyPerDayReportViewModelFactory(reportActions, localeFilters, reportsFilterStore, $translate, dispatcher, ActionTypesEnum) {
    function GivenLoyaltyPerDayReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: 'bar',
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      init.call(this);
    }

    GivenLoyaltyPerDayReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return GivenLoyaltyPerDayReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();
      that.total = 0;
      that.totalByGroupName = [];
      reportActions.getTotalSpentLocalTokensPerDay(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {

        that.total = successData.total;
        successData.groupTotal.forEach(function (item, index) {
          that.totalByGroupName.push({
            total: item,
            name: successData.groupNames[index]
          });
        });

        //successData.unit = 'TOTAL_USERS_BY_GROUP_USERS_UNIT';
        that.chart.data = successData;
        that.unit = $translate.instant('LOCAL_TOKEN');
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('givenLoyaltyPerDayReportController', givenLoyaltyPerDayReportController);

  /** @ngInject */
  function givenLoyaltyPerDayReportController ($scope, $translate, reportExportUtil, exportToCsv, GivenLoyaltyPerDayReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new GivenLoyaltyPerDayReportViewModel();
    vm.exportToCsv = exportCsv;
    vm.namingData = 'TOKENS_TITLE';

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('TOTAL_SPENT_LOCAL_TOKENS_PER_DAY'),
          true);
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("DailyTotalReportViewModel", dailyTotalReportViewModelFactory);

  /** @ngInject */
  function dailyTotalReportViewModelFactory(
    reportActions,
    localeFilters,
    reportsFilterStore,
    dispatcher,
    ActionTypesEnum
  ) {
    function DailyTotalReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          type: "timeseries",
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        },
        y: {
          tick: {
            rotate: 60
          }
        }
      };

      init.call(this);
    }

    DailyTotalReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return DailyTotalReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };
      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();
      reportActions
        .getFinancesByDate(
          "",
          reportFilterData.fromTimestamp,
          reportFilterData.toTimestamp,
          reportFilterData.currency
        )
        .then(function (successData) {
          that.chart.data = successData;
          that.isChartVisible = successData.total !== 0;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("dailyTotalReportController", dailyTotalReportController);

  /** @ngInject */
  function dailyTotalReportController(
    $scope,
    $translate,
    DailyTotalReportViewModel,
    reportExportUtil,
    exportToCsv,
    dispatcher,
    ActionTypesEnum
  ) {
    var vm = this;

    vm.report = new DailyTotalReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init() {
      $scope.$on("$destroy", destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant("DATE"),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER
      );

      exportToCsv.export(
        jsonArrayForExport,
        $translate.instant("MONEY_BY_DATE_REPORT"),
        true
      );
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("DailyR2WReportViewModel", DailyR2WReportViewModelFactory);

  /** @ngInject */
  function DailyR2WReportViewModelFactory(
    reportActions,
    reportsFilterStore,
    localeFilters,
    dispatcher,
    ActionTypesEnum
  ) {
    function DailyR2WReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          type: "timeseries",
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };

      init.call(this);
    }

    DailyR2WReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return DailyR2WReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions
        .getTotalR2WByDate(
          "",
          reportFilterData.fromTimestamp,
          reportFilterData.toTimestamp,
          reportFilterData.currency
        )
        .then(function (successData) {
          that.chart.data = successData;
          that.isChartVisible = successData.total !== 0 ? true : false;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('dailyR2WReportController', dailyR2WReportController);

  /** @ngInject */
  function dailyR2WReportController ($scope, $translate, reportExportUtil, exportToCsv, DailyR2WReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new DailyR2WReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('R2W_BY_DATE_REPORT'),
          true);
    }

  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('DailyEuroKeyReportViewModel', DailyEuroKeyReportViewModelFactory);

    /** @ngInject */
    function DailyEuroKeyReportViewModelFactory(reportActions, reportsFilterStore, localeFilters, dispatcher, ActionTypesEnum) {
        function DailyEuroKeyReportViewModel() {
            this._reportsFilterStoreChangeHandler = null;
            this.chart = {
                data: null,
                x: {
                    type: 'timeseries',
                    tick: {
                        culling: {max: 15},
                        rotate: 60,
                        format: function (item) {
                            return localeFilters.date(item);
                        }
                    }
                }
            };

            init.call(this);
        }

        DailyEuroKeyReportViewModel.prototype.destroy = function () {
            reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
        };

        return DailyEuroKeyReportViewModel;

        function init() {
            var that = this;
            this.isChartVisible = false;

            searchByFilter.call(that);
            this._reportsFilterStoreChangeHandler = function () {
                searchByFilter.call(that);
            };

            reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
        }

        function searchByFilter() {
            var that = this,
                reportFilterData = reportsFilterStore.getFilterData();

            reportActions.getTotalEuroKeyByDate('', reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
                that.chart.data = successData;
                that.isChartVisible = (successData.total !== 0) ? true : false;
                dispatcher.dispatch({
                    type: ActionTypesEnum.HIDE_LOADER
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sempraWebapp')
        .controller('dailyEuroKeyReportController', dailyEuroKeyReportController);

    /** @ngInject */
    function dailyEuroKeyReportController ($scope, $translate, reportExportUtil, exportToCsv, DailyEuroKeyReportViewModel, dispatcher, ActionTypesEnum) {
        var vm = this;

        vm.report = new DailyEuroKeyReportViewModel();
        vm.exportToCsv = exportCsv;

        init();

        function init () {
            $scope.$on('$destroy', destroy);
            dispatcher.dispatch({
                type: ActionTypesEnum.SHOW_LOADER
              });
        }

        function destroy () {
            vm.report.destroy();
        }

        function exportCsv () {
            var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
                $translate.instant('DATE'),
                vm.report.chart.data,
                reportExportUtil.ValueFormattersEnum.DATE,
                reportExportUtil.ValueFormattersEnum.NUMBER);

            exportToCsv.export(jsonArrayForExport,
                $translate.instant('EUROKEY_BY_DATE_REPORT'),
                true);
        }

    }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('DailyCoinsReportViewModel', DailyCoinsReportViewModelFactory);

  /** @ngInject */
  function DailyCoinsReportViewModelFactory(reportActions, reportsFilterStore, localeFilters, dispatcher, ActionTypesEnum) {
    function DailyCoinsReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          type: 'timeseries',
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (item) {
              return localeFilters.date(item);
            }
          }
        }
      };
      this.chartType = 'TOKENS_TITLE';

      init.call(this);
    }

    DailyCoinsReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    };

    return DailyCoinsReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions.getTotalTokenCount(reportFilterData.fromTimestamp, reportFilterData.toTimestamp).then(function (successData) {
        that.chart.data = successData;
        that.isChartVisible = (successData.total !== 0) ? true : false;
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('dailyCoinsReportController', dailyCoinsReportController);

  /** @ngInject */
  function dailyCoinsReportController ($scope, DailyCoinsReportViewModel, $translate, reportExportUtil, exportToCsv, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new DailyCoinsReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('COINS_BY_DATE_REPORT'),
          true);
    }

  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('ComparationReportViewModel', ComparationReportViewModelFactory);

    /** @ngInject */
    function ComparationReportViewModelFactory(reportActions, reportsFilterStore, localeFilters, dispatcher, ActionTypesEnum) {

        function ComparationReportViewModel() {
            this._reportsFilterStoreChangeHandler = null;
            this.chart = {
                data: null,
                x: {
                    tick: {
                        culling: { max: 15 },
                        rotate: 60,
                        format: function (item) {
                            return localeFilters.getMonthLocale(item);
                        }
                    }
                }
            };

            init.call(this);
        }

        ComparationReportViewModel.prototype.destroy = function () {
            reportsFilterStore.off(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
        };

        return ComparationReportViewModel;

        function init() {
            var that = this;
            this.isChartVisible = false;

            searchByFilter.call(that);
            this._reportsFilterStoreChangeHandler = function () {
                searchByFilter.call(that);
            };

            reportsFilterStore.on(reportsFilterStore.events.CHANGE, this._reportsFilterStoreChangeHandler);
        }

        function searchByFilter() {
            var that = this;

            // get all init data for filtering (default ones)
            var reportFilterData = reportsFilterStore.getFilterData();

            if (reportFilterData.selectedFacilitySerial) {
                // prepare data for chart legend (create group names / column / row names )
                this.period1 = '(' + reportFilterData.period2From + ') '
                    + localeFilters.getMonthLocale((reportFilterData.period1From - 1), false)
                    + ' - '
                    + localeFilters.getMonthLocale((reportFilterData.period1To - 1), false);
                this.period2 = '(' + reportFilterData.period2To + ') '
                    + localeFilters.getMonthLocale((reportFilterData.period1From - 1), false)
                    + ' - '
                    + localeFilters.getMonthLocale((reportFilterData.period1To - 1), false);

                reportActions.getComparationFinances(reportFilterData.selectedFacilitySerial, reportFilterData.period1From, reportFilterData.period1To, reportFilterData.period2From, reportFilterData.period2To).then(function (successData) {
                    successData.groupsData.sort(function(a,b){
                        return (a.groupValue > b.groupValue) ? 1 : -1;
                    });
                    successData.groupNames = [
                        that.period1,
                        that.period2
                    ];
                    successData.groupsData.forEach(function (group) {
                        group.groupValue -= 1;
                    });
                    that.chart.data = successData;
                    that.isChartVisible = (successData.total !== 0) ? true : false;
                    dispatcher.dispatch({
                        type: ActionTypesEnum.HIDE_LOADER
                    });
                });
            } else {
                that.isChartVisible = false;
            }

            return false;
        }


    }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('comparationReportController', comparationReportController);

  /** @ngInject */
  function comparationReportController ($scope, $translate, reportExportUtil, exportToCsv, ComparationReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new ComparationReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('MONTHS'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.MONTH,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('COMPARE_PERIODS_REPORT'),
          true);
    }

  }
})();

//ChangerIncomeByDateViewModel
(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory(
      "ChangerIncomeByDateViewModel",
      changerIncomeByDateViewModelFactory
    );

  /** @ngInject */
  function changerIncomeByDateViewModelFactory(
    reportActions,
    localeFilters,
    reportsFilterStore,
    dispatcher,
    ActionTypesEnum,
    sortArrayService
  ) {
    function ChangerIncomeByDateViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.total = 0;
      this.dailyData = false;
      this.totalByGroupName = [];
      this.chart = {
        data: null,
        chartType: "bar"
      };

      init.call(this);
    }

    ChangerIncomeByDateViewModel.prototype.destroy = function() {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return ChangerIncomeByDateViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function() {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      that.dailyData = reportFilterData.fromTimestamp === reportFilterData.toTimestamp;
      that.totalByGroupName = [];

      if (!reportFilterData.selectedFacilitySerial) {
        return;
      }

      var from =
        reportFilterData.period3From > 0
          ? reportFilterData.fromTimestamp +
            reportFilterData.period3From * 3600000
          : reportFilterData.fromTimestamp;

      var to =
        reportFilterData.period3To > 0
          ? reportFilterData.toTimestamp +
            reportFilterData.period3To * 3600000 -
            1
          : reportFilterData.toTimestamp;

      reportActions
        .getChangerIncomePerDate(
          reportFilterData.selectedFacilitySerial,
          from,
          to, reportFilterData.currency
        )
        .then(function(successData) {
          //successData.unit = 'TOTAL_USERS_BY_GROUP_USERS_UNIT';
          successData.groupsData =
            successData.groupsData.length > 0
              ? sortArrayService.sortByGroupValue(successData.groupsData)
              : successData.groupsData;
          that.chart.data = successData;
          that.chart.x = {
            type: "x",
            tick: {
              culling: { max: 15 },
              rotate: 60,
              format: function(item) {
                return that.dailyData ? localeFilters.checkIfNumber(item) : localeFilters.date(item);
              }
            }
          }
          that.total = successData.total
          that.unit = successData.unit;
          that.isChartVisible = successData.total !== 0 ? true : false;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();

//loyaltyPerPaymentMethodReportController
(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("changerIncomeByDateController", changerIncomeByDateController);

  /** @ngInject */
  function changerIncomeByDateController(
    $scope,
    $translate,
    reportExportUtil,
    exportToCsv,
    ChangerIncomeByDateViewModel,
    dispatcher,
    ActionTypesEnum
  ) {
    var vm = this;

    vm.report = new ChangerIncomeByDateViewModel();
    vm.exportToCsv = exportCsv;
    vm.namingData = "TOKENS_TITLE";

    init();

    function init() {
      $scope.$on("$destroy", destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy() {
      vm.report.destroy();
    }

    function exportCsv() {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant("DATE"),
        vm.report.chart.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER,
        vm.namingData
      );

      exportToCsv.export(
        jsonArrayForExport,
        $translate.instant("CHANGER_INCOME"),
        true
      );
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("AvgByHourReportViewModel", avgByHourReportViewModelFactory);

  /** @ngInject */
  function avgByHourReportViewModelFactory(
    reportActions,
    reportsFilterStore,
    dispatcher,
    ActionTypesEnum
  ) {
    function AvgByHourReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          tick: {
            culling: { max: 15 },
            rotate: 60
          }
        }
      };

      init.call(this);
    }

    AvgByHourReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return AvgByHourReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions
        .getAvgByHours(
          "",
          reportFilterData.fromTimestamp,
          reportFilterData.toTimestamp,
          reportFilterData.currency
        )
        .then(function (successData) {
          that.chart.data = successData;
          that.isChartVisible = successData.total !== 0 ? true : false;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('avgByHourReportController', avgByHourReportController);

  /** @ngInject */
  function avgByHourReportController ($scope, $translate, reportExportUtil, exportToCsv, AvgByHourReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new AvgByHourReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('HOURS'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.NUMBER,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('AVG_MONEY_BY_HOUR_REPORT'),
          true);
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("AvgByDayReportViewModel", AvgByDayReportViewModelFactory);

  /** @ngInject */
  function AvgByDayReportViewModelFactory(
    reportActions,
    reportsFilterStore,
    $translate,
    localeFilters,
    dispatcher,
    ActionTypesEnum
  ) {
    function AvgByDayReportViewModel() {
      this._reportsFilterStoreChangeHandler = null;
      this.chart = {
        data: null,
        x: {
          tick: {
            culling: { max: 15 },
            rotate: 60,
            format: function (xItem) {
              return $translate.instant(localeFilters.getDayLocale(xItem));
            }
          }
        }
      };

      init.call(this);
    }

    AvgByDayReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return AvgByDayReportViewModel;

    function init() {
      var that = this;
      this.isChartVisible = false;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      reportActions
        .getAvgMoneyByDay(
          "",
          reportFilterData.fromTimestamp,
          reportFilterData.toTimestamp,
          reportFilterData.currency
        )
        .then(function (successData) {
          that.chart.data = successData;
          successData.groupsData.map(function (data) {
            //Increase day index by 1 to get proper schedule in the table (6 is sunday)
            data.groupValue = data.groupValue === 6 ? 0 : data.groupValue + 1;
          });
          that.isChartVisible = successData.total !== 0 ? true : false;
          dispatcher.dispatch({
            type: ActionTypesEnum.HIDE_LOADER
          });
        });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('avgByDayReportController', avgByDayReportController);

  /** @ngInject */
  function avgByDayReportController ($scope, $translate, reportExportUtil, exportToCsv, AvgByDayReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new AvgByDayReportViewModel();
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

    function exportCsv () {
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DAYS'),
          vm.report.chart.data,
          reportExportUtil.ValueFormattersEnum.DAY,
          reportExportUtil.ValueFormattersEnum.NUMBER);

      exportToCsv.export(jsonArrayForExport,
          $translate.instant('AVG_MONEY_BY_DAY_OF_WEEK_REPORT'),
          true);
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("AvgByBoxReportViewModel", AvgByBoxReportViewModelFactory);

  /** @ngInject */
  function AvgByBoxReportViewModelFactory(
    reportActions,
    reportsFilterStore,
    dispatcher,
    ActionTypesEnum,
    ByBoxrViewModel
  ) {
    function AvgByBoxReportViewModel() {
      this.exportToComponent = new ByBoxrViewModel();
      this._reportsFilterStoreChangeHandler = null;
      this.chartRegionCurrency = {
        data: null,
        chartType: "bar",
        rotated: true,
        x: {
          type: "category"
        },
        chartName: "regionCurrency"
      };
      this.chartTokens = {
        data: null,
        chartType: "bar",
        rotated: true,
        x: {
          type: "category"
        },
        chartName: "tokens"
      };

      init.call(this);
    }

    AvgByBoxReportViewModel.prototype.destroy = function () {
      reportsFilterStore.off(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    };

    return AvgByBoxReportViewModel;

    function init() {
      var that = this;

      searchByFilter.call(that);
      this._reportsFilterStoreChangeHandler = function () {
        searchByFilter.call(that);
      };

      reportsFilterStore.on(
        reportsFilterStore.events.CHANGE,
        this._reportsFilterStoreChangeHandler
      );
    }

    function searchByFilter() {
      var that = this,
        reportFilterData = reportsFilterStore.getFilterData();

      if (reportFilterData.selectedFacilitySerial) {
        reportActions
          .getAvgMoneyByBox(
            reportFilterData.selectedFacilitySerial,
            reportFilterData.fromTimestamp,
            reportFilterData.toTimestamp,
            reportFilterData.currency
          )
          .then(function (successData) {
            var exportData =
              that.exportToComponent.createChartData(successData);

            exportData.regionCurrency.groupsData = sortBoxes(
              exportData.regionCurrency.groupsData
            );
            that.chartRegionCurrency.data = exportData.regionCurrency;

            exportData.tokens.groupsData = sortBoxes(
              exportData.tokens.groupsData
            );
            that.chartTokens.data = exportData.tokens;

            dispatcher.dispatch({
              type: ActionTypesEnum.HIDE_LOADER
            });
          });
      } else {
        dispatcher.dispatch({
          type: ActionTypesEnum.HIDE_LOADER
        });
      }

      return false;
    }

    function sortBoxes(groupsData) {
      return groupsData.sort(function (a, b) {
        var nameA = a.groupValue.toUpperCase(); // ignore upper and lowercase
        var nameB = b.groupValue.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
          return -1;
        }
        if (nameA > nameB) {
          return 1;
        }

        // names must be equal
        return 0;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('avgByBoxReportController', avgByBoxReportController);

  /** @ngInject */
  function avgByBoxReportController ($scope, AvgByBoxReportViewModel, dispatcher, ActionTypesEnum) {
    var vm = this;

    vm.report = new AvgByBoxReportViewModel();

    init();

    function init () {
      $scope.$on('$destroy', destroy);
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_LOADER
      });
    }

    function destroy () {
      vm.report.destroy();
    }

  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("tokenPackages", {
    templateUrl: "app/pricing/tokenPackages/tokenPackages.component.html",
    controller: tokenPackagesController,
    bindings: {
      tokenPackageData: "<",
      regionCurrency: "<",
      onCreate: "&"
    },
    controllerAs: "vm"
  });

  function tokenPackagesController(pricingActions, $translate, $scope) {
    var vm = this;

    $scope.saveButtonClass = "md-primary";

    vm.tokenPackagesData = {};
    vm.tokenPackageList = [];
    vm.editTokenPackages = false;
    vm.deleteTokenPackages = false;
    vm.buttonTitle = $translate.instant("SAVE");

    vm.$onChanges = function (changes) {
      if (changes.tokenPackageData) {
        vm.tokenPackageList = changes.tokenPackageData.currentValue;
      } else if (changes.regionCurrency) {
        vm.regionCurrency = changes.regionCurrency.currentValue;
      } else {
        return;
      }
    };

    vm.save = function (tokenPackageData) {
      var data = {
        id: tokenPackageData.id,
        name: tokenPackageData.name,
        tokenAmount: tokenPackageData.tokenAmount,
        priceAmount: tokenPackageData.priceAmount,
        validity: tokenPackageData.validity
      };
      if (vm.editTokenPackages) {
        updateTokenPackageData(data);
      } else if (vm.deleteTokenPackages) {
        deleteTokenPackageData(data);
      } else {
        saveTokenPackageData(data);
      }
    };

    vm.editPackage = function (tokenPackage) {
      vm.tokenPackagesData = {
        id: tokenPackage.id,
        name: tokenPackage.name,
        tokenAmount: tokenPackage.tokens.amount,
        priceAmount: tokenPackage.price.amount,
        validity: tokenPackage.validity
      };
      vm.buttonTitle = $translate.instant("UPDATE");
      vm.editTokenPackages = true;
    };

    vm.deletePackage = function (tokenPackage) {
      $scope.saveButtonClass = "custom-save-button-class";
      vm.tokenPackagesData = {
        id: tokenPackage.id,
        name: tokenPackage.name,
        tokenAmount: tokenPackage.tokens.amount,
        priceAmount: tokenPackage.price.amount,
        validity: tokenPackage.validity
      };
      vm.buttonTitle = $translate.instant("DELETE");
      vm.editTokenPackages = false;
      vm.deleteTokenPackages = true;
    };

    vm.cancel = function () {
      vm.tokenPackagesData = {
        id: null,
        name: null,
        tokenAmount: null,
        priceAmount: null,
        validity: null
      };
      vm.buttonTitle = $translate.instant("SAVE");
      vm.editTokenPackages = false;
      vm.deleteTokenPackages = false;
      $scope.tokenPackageForm.$setUntouched();
      $scope.saveButtonClass = "md-primary";
    };

    function saveTokenPackageData(data) {
      pricingActions.createCompanyTokenPackage(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function updateTokenPackageData(data) {
      pricingActions.updateCompanyTokenPackage(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function deleteTokenPackageData(data) {
      pricingActions.deleteCompanyTokenPackage(data.id).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("singleWash", {
    templateUrl: "app/pricing/singleWash/singleWash.component.html",
    controller: singleWashController,
    bindings: {
      singleWashData: "<",
      regionCurrency: "<",
      onCreate: "&"
    },
    controllerAs: "vm"
  });

  function singleWashController($scope, $translate, pricingActions) {
    var vm = this;

    $scope.saveButtonClass = "md-primary";

    vm.singleWashData = {};
    vm.singleWashList = [];
    vm.editSingleWash = false;
    vm.deleteSingleWash = false;
    vm.buttonTitle = $translate.instant("SAVE");

    vm.$onChanges = function (changes) {
      if (changes.singleWashData) {
        vm.singleWashList = changes.singleWashData.currentValue;
      } else if (changes.regionCurrency) {
        vm.regionCurrency = changes.regionCurrency.currentValue;
      } else {
        return;
      }
    };

    vm.save = function (singleWashData) {
      var data = {
        id: singleWashData.id,
        price: singleWashData.price
      };
      if (vm.editSingleWash) {
        updateSingleWashData(data);
      } else if (vm.deleteSingleWash) {
        deleteSingleWashData(data);
      } else {
        saveSingleWashData(data);
      }
    };

    function saveSingleWashData(data) {
      pricingActions.createSingeWash(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function updateSingleWashData(data) {
      pricingActions.updateSingeWash(data).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    function deleteSingleWashData(data) {
      pricingActions.deleteSingeWash(data.id).then(function () {
        vm.onCreate();
        vm.cancel();
      });
    }

    vm.editingSingleWash = function (singleWash) {
      vm.singleWashData = {
        id: singleWash.id,
        price: singleWash.price.amount
      };
      vm.buttonTitle = $translate.instant("UPDATE");
      vm.editSingleWash = true;
    };

    vm.deletingSingleWash = function (singleWash) {
      $scope.saveButtonClass = "custom-save-button-class";
      vm.singleWashData = {
        id: singleWash.id,
        price: singleWash.price.amount
      };
      vm.buttonTitle = $translate.instant("DELETE");
      vm.editSingleWash = false;
      vm.deleteSingleWash = true;
    };

    vm.cancel = function () {
      vm.singleWashData = {
        id: null,
        price: null
      };
      vm.buttonTitle = $translate.instant("SAVE");
      vm.editSingleWash = false;
      vm.deleteSingleWash = false;
      $scope.singleWashForm.$setUntouched();
      $scope.saveButtonClass = "md-primary";
    };

  }
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").component("businessTransactions", {
    templateUrl:
      "app/periodicSummary/businessTransactions/businessTransactions.html",
    controller: businessTransactionsController,
    bindings: {
      activate: "<"
    },
    controllerAs: "vm"
  });

  function businessTransactionsController(
    periodicSummaryActions,
    $log,
    getMonthsService,
    $filter,
    $translate
  ) {
    var vm = this;

    // GRID CONFIIG
    vm.businessTransactionData = [];
    vm.businessTransactionOrderBy = "";
    vm.businessTransactionOrder = "desc";
    vm.businessTransactionPage = 1;
    vm.businessTransactionTotal = 0;
    vm.businessTransactionPageSize = 10;
    vm.businessTransactionPageOptions = [10, 20];
    vm.selectedbusinessTransaction = [];
    vm.pagerTranslations = {
      page: $translate.instant("GRID_PAGER_PAGE"),
      rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
      of: $translate.instant("GRID_PAGER_PAGE_OF")
    };

    vm.yearList = getYearList();
    vm.selectFromMonth = 0;
    vm.selectToMonth = new Date().getMonth();
    vm.selectYear = vm.currentYear = new Date().getFullYear();
    vm.currentMonth = new Date().getMonth() + 1;
    vm.checkAfterSearch = true;

    vm.createToMonthList = function(fromMonth, toMOnth) {
      var selectedMonth = $filter("monthToStringFilter")(fromMonth + 1);
      var indexOfSelectedMonth = vm.monthList.indexOf(selectedMonth);
      vm.monthToList = vm.monthList.slice(fromMonth);
      vm.selectToMonthIndex = indexOfSelectedMonth;
      vm.disableSearch = fromMonth > toMOnth ? true : false;
    };

    vm.checkSearchCriteria = function(fromMonth, toMOnth) {
      vm.disableSearch = fromMonth > toMOnth ? true : false;
    };

    vm.sortChanged = function(order) {
      var orderQuery = getOrderObject(order);
      vm.businessTransactionOrderBy = orderQuery.orderBy;
      vm.businessTransactionOrder = orderQuery.order;
      refreshBusinessInvoices();
    };

    vm.pageChanged = function(page, limit) {
      vm.businessTransactionPage = page;
      vm.businessTransactionPageSize = limit;
      vm.sortChanged(vm.businessTransactionOrderBy);
    };

    vm.search = function() {
      vm.businessTransactionPage = 1;
      vm.checkAfterSearch = vm.selectYear === vm.currentYear ? true : false;
      refreshBusinessInvoices();
    };

    vm.downloadBusinessInvoice = function(id, month) {
      periodicSummaryActions
        .downloadBusinessInvoice(id, month, vm.selectYear)
        .then(function(data) {
          var invoiceTitle = data.headers().pdfname;

          var file = new Blob([data.data], { type: "application/pdf" });
          var fileURL = URL.createObjectURL(file);

          var file_path = fileURL;
          /* eslint-disable */
          var a = document.createElement("A");
          a.href = file_path;
          a.download = invoiceTitle;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          /* eslint-enable */
        });
    };

    function refreshBusinessInvoices() {
      vm.promise = periodicSummaryActions
        .getBusinessTransactions(
          vm.selectFromMonth + 1,
          vm.selectToMonth + 1,
          vm.selectYear,
          vm.businessTransactionOrderBy,
          vm.businessTransactionOrder,
          vm.businessTransactionPage - 1,
          vm.businessTransactionPageSize
        )
        .then(
          function(data) {
            vm.businessInvoices = data.content.map(function(item) {
              item.disableSearch =
                item.month === vm.currentMonth &&
                vm.selectYear === vm.currentYear
                  ? true
                  : false;
              return item;
            });
            vm.businessTransactionTotal = data.totalElements;
          },
          function(errorData) {
            $log.log("an error occured" + errorData);
          }
        );
    }

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    refreshBusinessInvoices();

    //Create year list
    function getYearList() {
      var list = [];
      var currentYear = new Date().getFullYear();
      for (var i = 2015; i < currentYear + 1; i++) {
        list.push(i);
      }
      return list.reverse();
    }

    //Get month list from moment locale (via getMonths service)
    this.monthList = getMonthsService.getMonthList();
    this.monthToList = getMonthsService.getMonthList();
  }
})();

(function () {
	'use strict';

	angular.module('sempraWebapp').factory('OrganizationDetailsViewModel', OrganizationDetailsViewModelFactory);

	/** @ngInject */
	function OrganizationDetailsViewModelFactory($translate) {
		function OrganizationDetailsViewModel() {
			this.parentOrganizationName = '';
			this.organizationType = '';
			this.organizationName = '';
			this.organizationAddress = '';
			this.typeSelector = '';
			this.typeSelectorList = [];
			this.supportedOrganization = '';
			this.supportedOrganizationType = '';
			this.organizationList = [];
			this.placeHolderText = $translate.instant("SELECT_ORGANIZATION_SELECTOR");
			this.hideSelectorList = true;
			this.organizationTypeSelectorInEditMode = null;
			this.organizationTypes = [
				{
					name: 'Company',
					value: 'COMPANY'
				},
				{
					name: 'Region',
					value: 'REGION'
				},
				{
					name: 'Site',
					value: 'SITE'
				},
				{
					name: 'Self',
					value: 'SELF'
				}
			];
			this.voucherExpirationDays = '';
		}

		OrganizationDetailsViewModel.prototype.destroy = function () {

		};

		OrganizationDetailsViewModel.prototype.refreshTypeSelectorList = function (data) {
			this.typeSelectorList = data;
		};

		OrganizationDetailsViewModel.prototype.refreshOrganizationList = function (data) {
			this.organizationList = data;
		};

		return OrganizationDetailsViewModel;
	}
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('OrganizationDetailsController', OrganizationDetailsController);

  /** @ngInject */
  function OrganizationDetailsController(
    OrganizationDetailsViewModel,
    OrganizationViewModel,
    $scope,
    $state,
    $stateParams,
    $mdToast,
    $log,
    $translate,
    layoutActions,
    organizationActions,
    userActions,
    dashboardKarcherActions,
    brand
  ) {
    var vm = this;
    var organizationParentType = '';
    var originalVoucherExpirationDays = null; // Čuva originalnu vrednost iz baze
    var currentCompanyId = null; // Čuva company ID za update

    vm.organizationDetails = new OrganizationDetailsViewModel();
    vm.isEditMode = !($stateParams.create === 'true');
    vm.brand = brand;

    init();

    vm.createOrganization = function () {
      var data = {
        name: vm.organizationDetails.organizationName,
        address: vm.organizationDetails.organizationAddress,
        type: vm.organizationDetails.organizationType,
        voucherExpirationDays: vm.organizationDetails.voucherExpirationDays
      };

      if (vm.organizationDetails.supportedOrganization) {
        data.support = {
          id: parseInt(vm.organizationDetails.supportedOrganization),
          type: vm.organizationDetails.supportedOrganizationType
        };
      }

      if (!vm.isEditMode) {
        data.parent = {
          id: parseInt($stateParams.id),
          type: organizationParentType
        };
        switch (vm.organizationDetails.organizationType) {
          case 'COMPANY':
            data.company = vm.organizationDetails.typeSelector;
            break;
          case 'REGION':
            data.region = vm.organizationDetails.typeSelector;
            break;
          case 'SITE':
            data.sitePointId = vm.organizationDetails.typeSelector;
            break;
        }
      } else {
        data.id = parseInt($stateParams.id);
      }

      if (!vm.isEditMode) {
        organizationActions.createChildOrganization(data).then(function () {});
      } else {
        // Edit mode - prvo update organizacije
        organizationActions
          .updateChildOrganization(data)
          .then(function () {
            // Proveri da li je promenjena vrednost voucherExpirationDays za COMPANY tip
            if (vm.organizationDetails.organizationType === 'COMPANY' && 
                currentCompanyId && 
                originalVoucherExpirationDays !== null) {
              
              var newValue = parseInt(vm.organizationDetails.voucherExpirationDays);
              
              // Ako se vrednost promenila, pozovi update
              if (originalVoucherExpirationDays !== newValue) {
                return organizationActions.updateOrganizationVoucherExpirationDays(
                  currentCompanyId, 
                  newValue
                );
              }
            }
          });
      }
    };

    vm.clearInput = function () {
      vm.organizationDetails.supportedOrganization = '';
      vm.organizationDetails.supportedOrganizationType = '';
      $scope.createOrganizationForm.$setDirty();
    };

    vm.selectOrganizationType = function () {
      createOrganizationTypeList();
    };
    vm.selectSupportedOrganization = function () {
      mapSupportedOrganizationType();
    };

    vm.getSelectedValue = function (ids) {
      vm.organizationDetails.typeSelector = ids;
    };

    vm.clearSelectorInput = function () {
      vm.organizationDetails.typeSelector = '';
    };

    function createOrganizationTypeList() {
      layoutActions.showLoader();
      vm.organizationDetails.hideSelectorList = true;
      vm.organizationDetails.placeHolderText =
        $translate.instant('SELECT_ORGANIZATION_SELECTOR') + " " +
        vm.organizationDetails.organizationType.toLowerCase();
      switch (vm.organizationDetails.organizationType) {
        case 'COMPANY':
          getCompanyList();
          break;
        case 'REGION':
          getRegionList();
          break;
        case 'SITE':
          getSiteList();
          break;
        default:
          vm.organizationDetails.hideSelectorList = false;
          vm.organizationDetails.typeSelector = '-';
          layoutActions.hideLoader();
          return;
      }
    }

    function getCompanyList() {
      if (vm.isEditMode) {
        organizationActions
          .getOrganizationsCompanyById(vm.organizationDetails.typeSelector)
          .then(function (companyDetails) {
            vm.organizationDetails.organizationTypeSelectorInEditMode = companyDetails.name;
            vm.organizationDetails.voucherExpirationDays = companyDetails.voucherExpirationDays || '';
            // Čuvaj originalnu vrednost i company ID za proveru prilikom čuvanja
            originalVoucherExpirationDays = companyDetails.voucherExpirationDays;
            currentCompanyId = companyDetails.id;
          });
      } else {
        vm.organizationDetails.typeSelectorList = [];
        organizationActions
          .getAllCompaniesShort($stateParams.id)
          .then(function (res) {
            vm.organizationDetails.refreshTypeSelectorList(res);
            layoutActions.hideLoader();
          });
      }
    }

    function getRegionList() {
      if (vm.isEditMode) {
        userActions
          .getRegionById(vm.organizationDetails.typeSelector)
          .then(function (regionDetails) {
            vm.organizationDetails.organizationTypeSelectorInEditMode = regionDetails.name;
          });
      } else {
        vm.organizationDetails.typeSelectorList = [];
        organizationActions.getAllRegionsShort().then(function(res) {
          vm.organizationDetails.refreshTypeSelectorList(res);
          layoutActions.hideLoader();
        });
      }
    }

    function getSiteList() {
      if (vm.isEditMode) {
        dashboardKarcherActions
          .getKarcherSitesInfoWindowData(vm.organizationDetails.typeSelector)
          .then(function (siteDetails) {
            vm.organizationDetails.organizationTypeSelectorInEditMode = siteDetails.site.name;
          });
      } else {
        vm.organizationDetails.typeSelectorList = [];
        organizationActions
          .getAllSitesShort($stateParams.id)
          .then(function(res) {
            vm.organizationDetails.refreshTypeSelectorList(res);
            layoutActions.hideLoader();
          });
      }
    }

    function mapSupportedOrganizationType() {
      vm.organizationDetails.organizationList.forEach(function (org) {
        if (parseInt(vm.organizationDetails.supportedOrganization) === org.id) {
          vm.organizationDetails.supportedOrganizationType = org.type;
        }
      });
      createOrganizationTypeList();
      layoutActions.hideLoader();
    }

    function init() {
      $scope.$on('$destroy', destroy);
      layoutActions.showLoader();

      organizationActions
        .getSupportedOrganizationList($stateParams.id)
        .then(function (res) {
          vm.organizationDetails.refreshOrganizationList(res);
          organizationActions
            .getOrganizationById($stateParams.id)
            .then(function (organizationData) {
              organizationParentType = organizationData.type;
              if (vm.isEditMode) {
                vm.organizationDetails.organizationName = organizationData.name;
                vm.organizationDetails.organizationType = organizationData.type;
                vm.organizationDetails.supportedOrganization =
                  organizationData.support ? organizationData.support.id : '';
                vm.organizationDetails.organizationAddress =
                  organizationData.address;
                vm.organizationDetails.voucherExpirationDays =
                  organizationData.voucherExpirationDays || '';
                switch (organizationData.type) {
                  case 'COMPANY':
                    vm.organizationDetails.typeSelector =
                      organizationData.company;
                    break;
                  case 'REGION':
                    vm.organizationDetails.typeSelector =
                      organizationData.region;
                    break;
                  case 'SITE':
                    vm.organizationDetails.typeSelector =
                      organizationData.sitePointId;
                    break;
                  default:
                    vm.organizationDetails.typeSelector = '-';
                }
                mapSupportedOrganizationType();
              } else {
                vm.organizationDetails.parentOrganizationName =
                  organizationData.name;
                layoutActions.hideLoader();
              }
            });
        });
    }

    function destroy() {
      vm.organizationDetails.destroy();
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("ChangeDeviceLabelNameController", ChangeDeviceLabelNameController);

  /** @ngInject */
  function ChangeDeviceLabelNameController($scope, $mdDialog, data) {
    var vm = this;

    init();

    vm.actuate = function () {
      $mdDialog.hide({
        pointId: data.pointId,
        label: vm.labelToEdit
      });
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    function init() {
      $scope.$on("$destroy", destroy);
      vm.data = data;
      vm.labelToEdit = data.deviceLabel;
    }

    function destroy() {}
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller(
      "ActuateWashingProgramsController",
      ActuateWashingProgramsController
    );

  /** @ngInject */
  function ActuateWashingProgramsController($scope, $mdDialog, data, $filter) {
    var vm = this;

    init();

    vm.actuate = function () {
      $mdDialog.hide(data);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    function init() {
      data.forEach(function (item) {
        item.value =
          item.reference === "NAME" && item.reference !== "DESCRIPTION"
            ? $filter("removews")(item.value)
            : item.value;
        item.regexCheck =
          item.reference !== "NAME" && item.reference !== "DESCRIPTION"
            ? "^\\d{1,10}(\\.\\d{1,2})?$"
            : null;
      });
      $scope.$on("$destroy", destroy);
      vm.data = data;
    }

    function destroy() {}
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("ActuatePumpProgramsController", ActuatePumpProgramsController);

  /** @ngInject */
  function ActuatePumpProgramsController($scope, $mdDialog, data) {
    var vm = this;

    init();

    vm.actuate = function () {
      $mdDialog.hide(data);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    function init() {
      data.forEach(function (item) {
        item.value = parseInt(item.value);
      });
      $scope.$on("$destroy", destroy);
      vm.data = data;
    }

    function destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'ActuateOperationTimeVacuumController',
      ActuateOperationTimeVacuumController
    );

  /** @ngInject */
  function ActuateOperationTimeVacuumController(
    $scope,
    $mdDialog,
    data,
    sortArrayService
  ) {
    var vm = this;
    vm.disableInputs = true;
    vm.patternForHourInputs = '';

    init();

    vm.actuate = function () {
      data.actuators.forEach(function (actuator) {
        if (actuator.reference === 'VAC_START') {
          actuator.value = actuator.value.replace(/:/g, '-');
        } else if (actuator.reference === 'VAC_STOP') {
          actuator.value = actuator.value.replace(/:/g, '-');
        }
      });
      $mdDialog.hide(data);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.change24hValue = function (form) {
      vm.data.forEach(function (item) {
        if (item.reference === 'VAC_24H' && item.value !== 'false') {
          vm.disableInputs = true;
          vm.patternForHourInputs = '';
          resetInputs(form);
        } else if (item.reference === 'VAC_24H' && item.value === 'false') {
          vm.disableInputs = false;
          vm.patternForHourInputs = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
        }
      });
    };

    function resetInputs(form) {
      vm.data.forEach(function (item) {
        if (item.reference === 'VAC_START') {
          item.value = ' ';
        } else if (item.reference === 'VAC_STOP') {
          item.value = ' ';
        }
      });
      form.$invalid = false;
    }

    function init() {
      $scope.$on('$destroy', destroy);
      vm.currentDay = data.day;
      vm.data = sortArrayService.sortByGroupValue(data.actuators);
      vm.data.forEach(function (item) {
        if (item.reference === 'VAC_24H' && item.value !== 'false') {
          vm.disableInputs = true;
        } else if (item.reference === 'VAC_24H' && item.value === 'false') {
          vm.disableInputs = false;
          vm.patternForHourInputs = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
        } else if (item.reference !== 'VAC_24H') {
          item.value = item.value.replace('-', ':');
        }
      });
    }

    function destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'ActuateOperationTimeIlluminationController',
      ActuateOperationTimeIlluminationController
    );

  /** @ngInject */
  function ActuateOperationTimeIlluminationController(
    $scope,
    $mdDialog,
    data,
    sortArrayService
  ) {
    var vm = this;
    vm.disableInputs = true;
    vm.patternForHourInputs = '';

    init();

    vm.actuate = function () {
      data.actuators.forEach(function (actuator) {
        if (actuator.reference === 'ILL_START') {
          actuator.value = actuator.value.replace(/:/g, '-');
        } else if (actuator.reference === 'ILL_STOP') {
          actuator.value = actuator.value.replace(/:/g, '-');
        }
      });
      $mdDialog.hide(data);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.change24hValue = function (form) {
      vm.data.forEach(function (item) {
        if (item.reference === 'ILL_24H' && item.value !== 'false') {
          vm.disableInputs = true;
          vm.patternForHourInputs = '';
          resetInputs(form);
        } else if (item.reference === 'ILL_24H' && item.value === 'false') {
          vm.disableInputs = false;
          vm.patternForHourInputs = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
        }
      });
    };

    function resetInputs(form) {
      vm.data.forEach(function (item) {
        if (item.reference === 'ILL_START') {
          item.value = ' ';
        } else if (item.reference === 'ILL_STOP') {
          item.value = ' ';
        }
      });
      form.$invalid = false;
    }

    function init() {
      $scope.$on('$destroy', destroy);
      vm.currentDay = data.day;
      vm.data = sortArrayService.sortByGroupValue(data.actuators);
      vm.data.forEach(function (item) {
        if (item.reference === 'ILL_24H' && item.value !== 'false') {
          vm.disableInputs = true;
        } else if (item.reference === 'ILL_24H' && item.value === 'false') {
          vm.disableInputs = false;
          vm.patternForHourInputs = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
        } else if (item.reference !== 'ILL_24H') {
          item.value = item.value.replace('-', ':');
        }
      });
    }

    function destroy() {}
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'ActuateOperationTimeController',
      ActuateOperationTimeController
    );

  /** @ngInject */
  function ActuateOperationTimeController(
    $scope,
    $mdDialog,
    data,
    sortArrayService
  ) {
    var vm = this;
    vm.disableInputs = true;
    vm.patternForHourInputs = '';

    init();

    vm.actuate = function () {
      data.actuators.forEach(function (actuator) {
        if (actuator.reference === 'START') {
          actuator.value = actuator.value.replace(/:/g, '-');
        } else if (actuator.reference === 'STOP') {
          actuator.value = actuator.value.replace(/:/g, '-');
        }
      });
      $mdDialog.hide(data);
    };

    vm.cancel = function () {
      $mdDialog.cancel();
    };

    vm.change24hValue = function (form) {
      vm.data.forEach(function (item) {
        if (item.reference === '24H' && item.value !== 'false') {
          vm.disableInputs = true;
          vm.patternForHourInputs = '';
          resetInputs(form);
        } else if (item.reference === '24H' && item.value === 'false') {
          vm.disableInputs = false;
          vm.patternForHourInputs = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
        }
      });
    };

    function resetInputs(form) {
      vm.data.forEach(function (item) {
        if (item.reference === 'START') {
          item.value = ' ';
        } else if (item.reference === 'STOP') {
          item.value = ' ';
        }
      });
      form.$invalid = false;
    }

    function init() {
      $scope.$on('$destroy', destroy);
      vm.currentDay = data.day;
      vm.data = sortArrayService.sortByGroupValue(data.actuators);
      vm.data.forEach(function (item) {
        if (item.reference === '24H' && item.value !== 'false') {
          vm.disableInputs = true;
        } else if (item.reference === '24H' && item.value === 'false') {
          vm.disableInputs = false;
          vm.patternForHourInputs = '([01]?[0-9]|2[0-3]):[0-5][0-9]';
        } else if (item.reference !== '24H') {
          item.value = item.value.replace('-', ':');
        }
      });
    }

    function destroy() {}
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("washingPrograms", {
    templateUrl:
      "app/facilityKarcherDetails/washingPrograms/washingPrograms.html",
    controller: washingPrograms,
    bindings: {
      programList: "<",
      activation: "&",
      defaultVisibilityState: "<"
    },
    controllerAs: "vm"
  });

  function washingPrograms($log, $mdDialog, $filter, sortArrayService) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
      if(!vm.programList) {
        return;
      }
      vm.newList = sortArrayService.sortArrayById(
        createSimpleProgramList(vm.programList)
      );
    };

    vm.$onChanges = function (changes) {
      if (changes.programList && changes.programList.currentValue) {
        vm.newList = sortArrayService.sortArrayById(
          createSimpleProgramList(changes.programList.currentValue)
        );
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateProgramInfo = function (ev, dataToUpdate, parentId) {
      $mdDialog
        .show({
          controller: "ActuateWashingProgramsController",
          controllerAs: "vm",
          templateUrl:
            "app/karcherCustomDialogs/actuateWashingPrograms/actuateWashingPrograms.html",
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: dataToUpdate, parentId: parentId },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            vm.activation({ data: data, parentPointId: parentId });
          },
          function () {}
        );
    };

    function createSimpleProgramList(data) {
      return data.reduce(function (total, current) {
        var tempObj = {};
        tempObj.actuators = [];
        tempObj.parentId = current.id;
        tempObj.availability = true;
        for (var j = 0; j < current.feeds.length; j++) {
          if (current.feeds[j].reference === "ID") {
            tempObj.id = parseInt(
              $filter("removeAfterDot")(current.feeds[j].currentValue)
            );
          } else if (current.feeds[j].reference === "AVAILABILITY") {
            tempObj.availability = current.feeds[j].currentValue === "1.0";
          }
        }
        for (var k = 0; k < current.actuators.length; k++) {
          if (current.actuators[k].reference === "PRICE") {
            tempObj.price = current.actuators[k].value;
            tempObj.priceState = current.actuators[k].state;
            tempObj.actuators.push(current.actuators[k]);
          } else if (current.actuators[k].reference === "NAME") {
            tempObj.name = current.actuators[k].value;
            tempObj.nameState = current.actuators[k].state;
            tempObj.actuators.push(current.actuators[k]);
          } else if (current.actuators[k].reference === "DESCRIPTION") {
            tempObj.description = current.actuators[k].value;
            tempObj.descriptionState = current.actuators[k].state;
            tempObj.actuators.push(current.actuators[k]);
          }
        }

        // Check if tempObj is empty
        if (tempObj.actuators.length !== 0) {
          total.push(tempObj);
        }
        return total;
      }, []);
    }
  }
})();

(function() {
	"use strict";

	angular.module("sempraWebapp").component("washBayDetails", {
		templateUrl:
			"app/facilityKarcherDetails/washBayDetails/washBayDetails.html",
		controller: washBayDetails,
		bindings: {
			washFacilityData: "<"
		},
		controllerAs: "vm"
	});

	function washBayDetails() {}
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').component('rolloverSpeed', {
    templateUrl: 'app/facilityKarcherDetails/rolloverSpeed/rolloverSpeed.html',
    controller: rolloverSpeed,
    bindings: {
      speedList: '<',
      activation: '&',
      defaultVisibilityState: '<'
    },
    controllerAs: 'vm'
  });

  function rolloverSpeed() {
    var vm = this;

    vm.$onInit = function () {
      if (!vm.speedList) {
        return;
      }
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState ? 'expand_less' : 'expand_more';
      vm.speedList.map(function (item) {
        if (item.name === 'DRYING_LOW_NOISE') {
          item.sliderMin = 50;
          item.sliderMax = 100;
        } else {
          item.sliderMin = 70;
          item.sliderMax = 130;
        }
      });
    };

    vm.$onChanges = function () {};

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState ? 'expand_less' : 'expand_more';
    };

    vm.sliderLimits = {
      min: 70,
      max: 130
    };

    vm.updateSpeed = function (dataToUpdate) {
      vm.activation({
        data: dataToUpdate
      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').component('rolloverDosing', {
    templateUrl:
      'app/facilityKarcherDetails/rolloverDosing/rolloverDosing.html',
    controller: rolloverDosing,
    bindings: {
      dosingList: '<',
      activation: '&',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function rolloverDosing() {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function () {};

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateDosing = function (dataToUpdate) {
      vm.activation({
        data: dataToUpdate
      });
    };
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("pumps", {
    templateUrl: "app/facilityKarcherDetails/pumps/pumps.html",
    controller: pumps,
    bindings: {
      pumpsList: "<",
      activation: "&",
      defaultVisibilityState: "<"
    },
    controllerAs: "vm"
  });

  function pumps($mdDialog) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function (changes) {
      if(!changes.pumpsList.currentValue) {
        return;
      }
      vm.pumpsList = mapPumpData(changes.pumpsList.currentValue);
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.actuatePumpProgram = function(ev, dataToUpdate, parentId) {
      $mdDialog
          .show({
            controller: "ActuatePumpProgramsController",
            controllerAs: "vm",
            templateUrl:
                "app/karcherCustomDialogs/actuatePumpPrograms/actuatePumpPrograms.html",
            /* eslint-disable */
            parent: angular.element(document.body),
            /* eslint-enable */
            targetEvent: ev,
            locals: { data: dataToUpdate, parentId: parentId },
            clickOutsideToClose: false
          })
          .then(
              function (data) {
                vm.activation({ data: data, parentPointId: parentId });
              },
              function () {}
          );
    }

    function mapPumpData(data) {
      data.forEach(function (item) {
        for (var i = 0; i < item.programsList.length; i++) {
          for (var j = 0; j < item.programsList[i].feeds.length; j++) {
            if (item.programsList[i].feeds[j].reference === "NAME") {
              item.programsList[i].programName =
                item.programsList[i].feeds[j].currentValue;
            }
          }
          for (var k = 0; k < item.programsList[i].actuators.length; k++) {
            if (
              item.programsList[i].actuators[k].reference.includes("RUN_TIME")
            ) {
              item.programsList[i][
                item.programsList[i].actuators[k].reference
              ] = item.programsList[i].actuators[k].value;
              item.programsList[i][
                item.programsList[i].actuators[k].reference + "_ID"
              ] = item.programsList[i].actuators[k].id;
              item.programsList[i][
              item.programsList[i].actuators[k].reference + "_STATE"
                ] = item.programsList[i].actuators[k].state;
            }
          }
        }
      });
      return data;
    }
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("operationCounters", {
    templateUrl:
      "app/facilityKarcherDetails/operationCounters/operationCounters.html",
    controller: operationCounters,
    bindings: {
      operationCountersList: "<",
      defaultVisibilityState: "<"
    },
    controllerAs: "vm"
  });

  function operationCounters() {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function () {};

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.convertToInt = function(data) {
      return parseInt(data);
    }
  }
})();

(function () {
	"use strict";

	angular.module("sempraWebapp").component("operationAndServiceCountersRollover", {
		templateUrl:
			"app/facilityKarcherDetails/operationAndServiceCountersRollover/operationAndServiceCountersRollover.html",
		controller: operationAndServiceCountersRollover,
		bindings: {
			operationCountersList: "<",
			serviceCountersList: "<",
			defaultVisibilityState: "<"
		},
		controllerAs: "vm"
	});

	function operationAndServiceCountersRollover() {
		var vm = this;

		vm.$onInit = function () {
			vm.visibilityState = vm.defaultVisibilityState;
			vm.iconSource = !vm.visibilityState
				? 'expand_less'
				: 'expand_more';
		};

		vm.$onChanges = function () {};

		vm.hideContent = function () {
			vm.visibilityState = !vm.visibilityState;
			vm.iconSource = !vm.visibilityState
				? 'expand_less'
				: 'expand_more';
		};

		vm.convertToInt = function(data) {
			return parseInt(data);
		}
	}
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').component('operatingTimeVacuum', {
    templateUrl:
      'app/facilityKarcherDetails/operatingTimeVacuum/operatingTimeVacuum.html',
    controller: operatingTimeVacuum,
    bindings: {
      operatingTimeVacuumList: '<',
      activation: '&',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function operatingTimeVacuum(
    sortArrayService,
    helperService,
    $log,
    $mdDialog,
    karcherOperatingTimeDaysMapper
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function (changes) {
      if (
        changes.operatingTimeVacuumList &&
        changes.operatingTimeVacuumList.currentValue
      ) {
        vm.operatingTimeVacuumList = sortArrayService.sortByGroupValue(
          karcherOperatingTimeDaysMapper.getDays(
            changes.operatingTimeVacuumList.currentValue
          )
        );
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateOperationVacuumTime = function (ev, data) {
      if (!data) {
        return;
      }
      $mdDialog
        .show({
          controller: 'ActuateOperationTimeVacuumController',
          controllerAs: 'vm',
          templateUrl:
            'app/karcherCustomDialogs/actuateOperationTimeVacuum/actuateOperationTimeVacuum.html',
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: data },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            vm.activation({ data: data.actuators, parentPointId: data.id });
          },
          function () {}
        );
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').component('operatingTimeIllumination', {
    templateUrl:
      'app/facilityKarcherDetails/operatingTimeIllumination/operatingTimeIllumination.html',
    controller: operatingTimeIllumination,
    bindings: {
      operatingTimeIlluminationList: '<',
      activation: '&',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function operatingTimeIllumination(
    sortArrayService,
    helperService,
    $log,
    $mdDialog,
    karcherOperatingTimeDaysMapper
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function (changes) {
      if (
        changes.operatingTimeIlluminationList &&
        changes.operatingTimeIlluminationList.currentValue
      ) {
        vm.operatingTimeIlluminationList = sortArrayService.sortByGroupValue(
          karcherOperatingTimeDaysMapper.getDays(
            changes.operatingTimeIlluminationList.currentValue
          )
        );
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateOperationIlluminationTime = function (ev, data) {
      if (!data) {
        return;
      }
      $mdDialog
        .show({
          controller: 'ActuateOperationTimeIlluminationController',
          controllerAs: 'vm',
          templateUrl:
            'app/karcherCustomDialogs/actuateOperationTimeIllumination/actuateOperationTimeIllumination.html',
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: data },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            vm.activation({ data: data.actuators, parentPointId: data.id });
          },
          function () {}
        );
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').component('operatingTime', {
    templateUrl: 'app/facilityKarcherDetails/operatingTime/operatingTime.html',
    controller: operatingTime,
    bindings: {
      operatingTimeList: '<',
      deviceKey: '<',
      activation: '&',
      refreshData: '&',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function operatingTime(
    sortArrayService,
    helperService,
    $log,
    $mdDialog,
    workingSchedulesActions,
    layoutActions,
    $stateParams,
    karcherOperatingTimeDaysMapper
  ) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.$onChanges = function (changes) {
      if (changes.operatingTimeList && changes.operatingTimeList.currentValue) {
        vm.operatingTimeList = sortArrayService.sortByGroupValue(
          karcherOperatingTimeDaysMapper.getDays(
            changes.operatingTimeList.currentValue
          )
        );
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    // Temporary, delete when testing is done
    vm.displayDepelopersOnly = helperService.getDevelopAccess();

    vm.updateOperationTime = function (ev, data) {
      if (!data) {
        return;
      }
      $mdDialog
        .show({
          controller: 'ActuateOperationTimeController',
          controllerAs: 'vm',
          templateUrl:
            'app/karcherCustomDialogs/actuateOperationTime/actuateOperationTime.html',
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: data },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            vm.activation({ data: data.actuators, parentPointId: data.id });
          },
          function () {}
        );
    };

    vm.getSiteWorkingSchedules = function () {
      layoutActions.showLoader();
      var path = '?deviceKey=' + vm.deviceKey;
      workingSchedulesActions
        .propagateWorkingSchedules($stateParams.id, path)
        .then(function () {
          vm.refreshData();
          layoutActions.hideLoader();
        });
    };
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("logsHistory", {
    templateUrl: "app/facilityKarcherDetails/logsHistory/logsHistory.html",
    controller: logsHistory,
    bindings: {
      deviceKey: "<"
    },
    controllerAs: "vm"
  });

  function logsHistory(
    dashboardKarcherActions,
    $translate,
    deviceActions,
    fromArrayToPathParam,
    layoutActions,
    helperService
  ) {
    var vm = this;
    vm.selectedPoints = "";
    vm.placeHolderText = $translate.instant("SELECT_POINTS_TO_SEARCH");
    // Grid data
    vm.logsOrderBy = "dateTime";
    vm.logsOrder = "desc";
    vm.logsPage = 1;
    vm.logsTotal = 0;
    vm.logsPageSize = 10;
    vm.logsPageOptions = [5, 10, 15, 50, 100];
    vm.pagerTranslations = {
      page: $translate.instant("GRID_PAGER_PAGE"),
      rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
      of: $translate.instant("GRID_PAGER_PAGE_OF")
    };

    vm.$onInit = function () {
      if (vm.deviceKey) {
        refreshHistoryLogList();
      }
    };

    vm.$onChanges = function () {
      if (vm.deviceKey) {
        refreshHistoryLogList();
        getDeviceList();
      }
    };

    vm.pageChanged = function (page, limit) {
      vm.logsPage = page;
      vm.logsPageSize = limit;
      refreshHistoryLogList();
    };

    vm.sortChanged = function (order) {
      var orderQuery = getOrderObject(order);
      vm.logsOrderBy = orderQuery.orderBy;
      vm.logsOrder = orderQuery.order;
      refreshHistoryLogList();
    };

    vm.selectedLogs = function (ids) {
      vm.selectedPoints = ids;
    };

    vm.clearPointsInput = function () {
      vm.selectedPoints = "";
    };

    vm.searchLogs = function () {
      refreshHistoryLogList();
    };

    vm.refreshLogPage = function() {
      refreshHistoryLogList();
    }

    function refreshHistoryLogList() {
      layoutActions.showLoader();
      deviceActions
        .getHistoryOfActuatedPointsByDeviceKey(
          vm.deviceKey,
          fromArrayToPathParam.createPath(vm.selectedPoints, "pointId="),
          vm.logsPage - 1,
          vm.logsPageSize,
          helperService.orderByRemover(vm.logsOrderBy),
          vm.logsOrder
        )
        .then(function (data) {
          if (data.content.length === 0) {
            vm.logsList = [];
            vm.logsList.push({
              dateTime: $translate.instant("NOTHING_TO_DISPLAY"),
              displayNotResolve: true
            });
          } else {
            vm.logsList = data.content;
          }
          vm.logsTotal = data.totalElements;
          layoutActions.hideLoader();
        });
    }

    function getDeviceList() {
      deviceActions
        .getPointsListByDeviceKey(vm.deviceKey)
        .then(function (deviceList) {
          vm.pointList = deviceList;
        });
    }

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').component('logsEvents', {
    templateUrl: 'app/facilityKarcherDetails/logsEvents/logsEvents.html',
    controller: logsEvents,
    bindings: {
      eventData: '<',
      deviceSerial: '<',
      pullNewData: '&'
    },
    controllerAs: 'vm'
  });

  function logsEvents() {
    var vm = this;

    vm.deviceEventDataList = null;

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      if (changes.eventData) {
        changes.eventData.currentValue ? changes.eventData.currentValue.data.forEach(function(item) {
          item.newTimestamp = moment(item.timestamp, 'YYYY-MM-DD hh:mm:ss').format('LLL');
        }) : null;
        vm.deviceEventDataList = changes.eventData.currentValue;
      }
    };

    vm.refreshLogPage = function () {
      vm.pullNewData();
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').component('chemicalLevel', {
    templateUrl: 'app/facilityKarcherDetails/chemicalLevel/chemicalLevel.html',
    controller: chemicalLevel,
    bindings: {
      chemicalLevelData: '<',
      defaultVisibilityState: "<"
    },
    controllerAs: 'vm'
  });

  function chemicalLevel($translate) {
    var vm = this;

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.mapServiceInfo = function(chemicalLevel, flag) {
      // with + operator convert string to number
      var toNumber = +chemicalLevel;
      switch (true) {
        case toNumber < 30 && toNumber > 4:
          return flag ? $translate.instant('LOW_CHEMICAL_LEVEL') : 'chemical-level-low-state';
        case toNumber < 5:
          return flag ? $translate.instant('EMPTY_CHEMICAL_LEVEL') : 'chemical-level-empty-state';
        default:
          return flag ? $translate.instant('NORMAL_CHEMICAL_LEVEL') : 'chemical-level-normal-state';
      }
    }

  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("changeOfParameters", {
    templateUrl:
      "app/facilityKarcherDetails/changeOfParameters/changeOfParameters.html",
    controller: changeOfParameters,
    bindings: {
      changeOfParametersData: "<",
      activation: "&",
      defaultVisibilityState: "<"
    },
    controllerAs: "vm"
  });

  function changeOfParameters($translate) {
    var vm = this;
    vm.iconSource = 'assets/icons/ic_arrow_drop_side_content_black.svg';
    vm.parametersState = {};

    vm.$onInit = function () {
      vm.visibilityState = vm.defaultVisibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
      vm.desaltingList = [
        {
          value: 0,
          name: $translate.instant("OFF")
        },
        {
          value: 1,
          name: $translate.instant("ON")
        },
        {
          value: 2,
          name: $translate.instant("AUTOMATIC")
        }
      ];
      vm.seasonList = [
        {
          value: 0,
          name: $translate.instant("SPRING_PROGRAM")
        },
        {
          value: 1,
          name: $translate.instant("SUMMER_PROGRAM")
        },
        {
          value: 2,
          name: $translate.instant("AUTUMN_PROGRAM")
        },
        {
          value: 3,
          name: $translate.instant("WINTER_PROGRAM")
        }
      ];
      vm.doorControlList = [
        {
          value: 0,
          name: $translate.instant("OFF")
        },
        {
          value: 1,
          name: $translate.instant("SUMMER_DOOR_CONTROL")
        },
        {
          value: 2,
          name: $translate.instant("WINTER_DOOR_CONTROL")
        }
      ];
    };

    vm.$onChanges = function (changes) {
      if(changes.changeOfParametersData.currentValue) {
        mapToModel(changes.changeOfParametersData.currentValue, true);
      }
    };

    vm.hideContent = function () {
      vm.visibilityState = !vm.visibilityState;
      vm.iconSource = !vm.visibilityState
        ? 'expand_less'
        : 'expand_more';
    };

    vm.updateParameters = function() {
      mapToModel(vm.changeOfParametersData, false);
      vm.activation({
        data: vm.changeOfParametersData
      });
    }

    function mapToModel(parametersList, init) {
      init ? parametersList.forEach(function(parameter) {
        switch (parameter.name) {
          case "SEASON":
            vm.season = parameter.value;
            vm.parametersState.season = parameter.state;
            break;
          case "DOOR_CONTROL":
            vm.doorControl = parameter.value;
            vm.parametersState.doorControl = parameter.state;
            break;
          case "SALT_EXPULSION":
            vm.desalting = parameter.value;
            vm.parametersState.saltExpulsion = parameter.state;
            break;
        }
      }) : parametersList.forEach(function(parameter) {
        switch (parameter.name) {
          case "SEASON":
            parameter.value = vm.season;
            parameter.state = vm.parametersState.season;
            break;
          case "DOOR_CONTROL":
            parameter.value = vm.doorControl;
            parameter.state = vm.parametersState.doorControl;
            break;
          case "SALT_EXPULSION":
            parameter.value = vm.desalting;
            parameter.state = vm.parametersState.saltExpulsion;
            break;
        }
      });
    }

  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("alertHistory", {
    templateUrl: "app/facilityKarcherDetails/alertHistory/alertHistory.html",
    controller: alertHistory,
    bindings: {
      facilityId: "<",
      facilityName: "<"
    },
    controllerAs: "vm"
  });

  function alertHistory(
    dashboardKarcherActions,
    $translate,
    layoutActions,
    reportExportUtil,
    exportToCsv,
    localeFilters,
    helperService
  ) {
    var vm = this;
    // Grid data
    setGridData();

    vm.$onInit = function () {
      if (vm.facilityId) {
        refreshHistoryAlarmList();
      }
    };

    vm.$onChanges = function () {
      if (vm.facilityId) {
        refreshHistoryAlarmList();
      }
    };

    vm.pageChanged = function (page, limit) {
      vm.alarmsPage = page;
      vm.alarmsPageSize = limit;
      refreshHistoryAlarmList();
    };

    vm.sortChanged = function (order) {
      var orderQuery = getOrderObject(order);
      vm.alarmsOrderBy = orderQuery.orderBy;
      vm.alarmsOrder = orderQuery.order;
      refreshHistoryAlarmList();
    };

    vm.refreshAlertPage = function () {
      setGridData();
      refreshHistoryAlarmList();
    };

    vm.downloadCsv = function () {
      getDataForCSVDownload(vm.alarmsTotal).then(function (csvData) {
        var updatedData = {
          groupNames: [
            $translate.instant("ALERT_CODE"),
            $translate.instant("COMPANY_NAME"),
            $translate.instant("SITE_NAME"),
            $translate.instant("FACILITY_NAME"),
            $translate.instant("ALERT_NAME"),
            $translate.instant("ALERT_DESCRIPTION"),
            $translate.instant("STATUS")
          ],
          groupTotal: [],
          groupsData: csvData.content.map(function (item) {
            return {
              groupValue: localeFilters.hourly(item.timestamp),
              values: [].concat(
                item.karcherFault.number,
                item.companyName,
                item.siteName,
                item.washFacilityName,
                item.karcherFault.name,
                item.karcherFault.description,
                item.status
                  ? $translate.instant("RESOLVED_STATUS")
                  : $translate.instant("NOT_RESOLVED_STATUS")
              )
            };
          })
        };
        var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant("DATE"),
          updatedData,
          reportExportUtil.ValueFormattersEnum.DEFAULT,
          reportExportUtil.ValueFormattersEnum.DEFAULT
        );

        exportToCsv.export(
          jsonArrayForExport,
          vm.facilityName + $translate.instant("ALARM_HISTORY"),
          true
        );
      });
    };

    function setGridData() {
      vm.alarmsOrderBy = "timestamp";
      vm.alarmsOrder = "desc";
      vm.alarmsPage = 1;
      vm.alarmsTotal = 0;
      vm.alarmsPageSize = 10;
      vm.alarmsPageOptions = [5, 10, 15, 50, 100];
      vm.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };
    }

    function refreshHistoryAlarmList() {
      layoutActions.showLoader();
      dashboardKarcherActions
        .getKarcherAlarmsHistoryList(
          "",
          vm.facilityId,
          "",
          "",
          vm.alarmsPage - 1,
          vm.alarmsPageSize,
          helperService.orderByRemover(vm.alarmsOrderBy),
          vm.alarmsOrder
        )
        .then(function (data) {
          if (data.content.length === 0) {
            vm.alarmList = [];
            vm.alarmList.push({
              timestamp: $translate.instant("NOTHING_TO_DISPLAY"),
              displayNotResolve: true
            });
          } else {
            vm.alarmList = setStateIcon(data.content, false);
          }
          vm.alarmsTotal = data.totalElements;
          layoutActions.hideLoader();
        });
    }

    function getDataForCSVDownload(totalNumberOfElements) {
      layoutActions.showLoader();
      return dashboardKarcherActions
        .getKarcherAlarmsHistoryList(
          "",
          vm.facilityId,
          "",
          "",
          vm.alarmsPage - 1,
          totalNumberOfElements,
          vm.alarmsOrderBy,
          vm.alarmsOrder
        )
        .then(function (data) {
          layoutActions.hideLoader();
          return data;
        });
    }

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    function setStateIcon(data, switcher) {
      for (var i = 0; i < data.length; i++) {
        var caseItem = switcher
          ? data[i].status
          : data[i].karcherFault.washFacilityStatus;
        switch (caseItem) {
          case "INFO":
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
          case "WARNING":
            data[i].icon = "assets/icons/ic_medium_alarm.svg";
            break;
          case "ALARM":
            data[i].icon = "assets/icons/ic_high_alarm.svg";
            break;
          default:
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
        }
      }
      return data;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('errorPageWithRedirectToDashboardController', errorPageWithRedirectToDashboardController);

  /** @ngInject */
  function errorPageWithRedirectToDashboardController($scope, ErrorPageViewModel, errorActions, applicationStore, $state) {
    var vm = this;

    vm.error = new ErrorPageViewModel();

    init ();

    function init () {
      // listen for message from dispatcher
      showErrorMsg(applicationStore.get().errorPageMsg);

      $scope.$on('$destroy', function () {
        vm.error.destroy();
      });
    }

    function showErrorMsg(errText){
      vm.error.errorMessage = errText;
    }

    vm.goBack = function(){
      errorActions.acknowledgeAndGoBack();
    };

    vm.goToDashboard = function(){
      $state.go('app.dashboardTechnology');
    };

  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("SiteDetailsViewModel", SiteDetailsViewModelFactory);

  /** @ngInject */
  function SiteDetailsViewModelFactory(gridUtils, $translate, $timeout) {
    function SiteDetailsViewModel() {
      this.gridSettings = gridUtils.getDefaultGridSettings();

      this.washFacilityList = [];
      this.alarmList = [];
      this.lastReportTimestamp = "";
      this.selected = [];
      this.limitPerPage = this.gridSettings.limitPerPage;
      this.currentPage = this.gridSettings.page;
      this.pagerLabel = this.gridSettings.translations;

      // Grid data
      this.alarmsData = [];
      this.alarmsOrderBy = "timestamp";
      this.alarmsOrder = "desc";
      this.alarmsPage = 1;
      this.alarmsTotal = 0;
      this.alarmsPageSize = 10;
      this.alarmsPageOptions = [5, 10, 15];
      this.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };
    }

    SiteDetailsViewModel.prototype.destroy = function () {};

    SiteDetailsViewModel.prototype.alarmsPaginationChanged = function (
      page,
      limit
    ) {
      this.alarmsPage = page;
      this.alarmsPageSize = limit;
    };

    SiteDetailsViewModel.prototype.alarmsOrderingChanged = function (order) {
      var orderQuery = getOrderObject(order);
      this.alarmsOrderBy = orderQuery.orderBy;
      this.alarmsOrder = orderQuery.order;
    };

    SiteDetailsViewModel.prototype.refresh = function (data) {
      this.washFacilityList = this.setStateIcon(data, true);
      this.alarmList = this.setFacilityIcon(data);
    };

    SiteDetailsViewModel.prototype.refreshAlarmList = function (data) {
      if (data.content.length === 0) {
        this.alarmList = [];
        this.alarmList.push({
          timestamp: $translate.instant("NOTHING_TO_DISPLAY")
        });
      } else {
        this.alarmList = this.setStateIcon(data.content, false);
      }
      this.alarmsTotal = data.totalElements;
    };

    SiteDetailsViewModel.prototype.setStateIcon = function (data, switcher) {
      for (var i = 0; i < data.length; i++) {
        data[i].lastReportedTime = moment(
          data[i].lastReportTimestamp
        ).fromNow();
        switch (true) {
          case data[i].temperature > 23:
            data[i].currentFacilityTempIcon = "assets/images/weather_sunny.png";
            break;
          case 7 < data[i].temperature && data[i].temperature < 23:
            data[i].currentFacilityTempIcon = "assets/images/weather_cloud.png";
            break;
          case data[i].temperature < 7:
            data[i].currentFacilityTempIcon = "assets/images/weather_snow.png";
            break;
        }

        // Set alarm icons
        var caseItem = switcher
          ? data[i].facilityStatus
          : data[i].karcherFault.washFacilityStatus;
        switch (caseItem) {
          case "INFO":
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
          case "WARNING":
            data[i].icon = "assets/icons/ic_medium_alarm.svg";
            break;
          case "ALARM":
            data[i].icon = "assets/icons/ic_high_alarm.svg";
            break;
          default:
            data[i].icon = "assets/icons/ic_low_alarm.svg";
            break;
        }
      }
      return data;
    };

    SiteDetailsViewModel.prototype.setFacilityIcon = function (data) {
      data.forEach(function (item) {
        switch (item.facilityType) {
          case "JETWASH":
            item.washFacilityIcon = "assets/images/self_service_new.svg";
            break;
          case "ROLLOVER":
            item.washFacilityIcon = "assets/images/rollover_new.svg";
            break;
        }
      });
      return data;
    };

    SiteDetailsViewModel.prototype.updateFeedValues = function (newFeedData) {
      var that = this;
      $timeout(function () {
        that.washFacilityList.forEach(function (washFacilityItem) {
          if (newFeedData.path.indexOf(washFacilityItem.deviceKey) > -1) {
            if (newFeedData.data.reference === "OP_TEMPERATURA_MJERENA") {
              washFacilityItem.temperature = newFeedData.data.currentValue;
              washFacilityItem.lastReportedTime = moment(
                newFeedData.data.lastUpdate
              ).fromNow();
              switch (true) {
                case washFacilityItem.temperature > 23:
                  washFacilityItem.currentFacilityTempIcon = "assets/images/weather_sunny.png";
                  break;
                case 7 < washFacilityItem.temperature && washFacilityItem.temperature < 23:
                  washFacilityItem.currentFacilityTempIcon = "assets/images/weather_cloud.png";
                  break;
                case washFacilityItem.temperature < 7:
                  washFacilityItem.currentFacilityTempIcon = "assets/images/weather_snow.png";
                  break;
              }
            }
            if (newFeedData.data.reference === "RTC") {
              washFacilityItem.lastReportedTime = moment(
                newFeedData.data.lastUpdate
              ).fromNow();
            }
            if (newFeedData.data.reference === "STATE") {
              washFacilityItem.lastReportedTime = moment(
                newFeedData.data.lastUpdate
              ).fromNow();
              washFacilityItem.state = newFeedData.data.currentValue;
            }
          }
        });
      }, 50);
    };


    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    return SiteDetailsViewModel;
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("SiteDetailsController", siteDetailsController);

  /** @ngInject */
  function siteDetailsController(
    $stateParams,
    SiteDetailsViewModel,
    dashboardKarcherActions,
    $log,
    fromArrayToPathParam,
    $state,
    sessionData,
    webSocketsStore,
    broker,
    $scope
  ) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onFeedChangedHandler = refreshDeviceFeed,
      forSelectedSiteDeviceKeyList = [];

    vm.siteDetailsVM = new SiteDetailsViewModel();

    vm.pageChanged = function (page, limit) {
      vm.siteDetailsVM.alarmsPaginationChanged(page, limit);
      refresh();
    };

    vm.sortChanged = function (order) {
      vm.siteDetailsVM.alarmsOrderingChanged(order);
      refresh();
    };

    vm.facilityDetails = function (facility) {
      $state.go("app.dashboardTechnology.siteDetails.facilityDetails", {
        deviceId: facility.deviceId
      });
    };

    init();

    function init() {
      // If WS are not connected
      if (!webSocketsStore.isConnected()) {
        broker.initWebSockets();
      }
      $scope.$on("$destroy", destroy);
      dashboardKarcherActions
        .getKarcherSiteDetailsById($stateParams.id)
        .then(function (response) {
          forSelectedSiteDeviceKeyList = response.map(function(device) {
            return device.deviceKey;
          });
          subscribeToSocket();
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          vm.siteDetailsVM.refresh(response);
          refresh();
        });
    }

    function subscribeToSocket() {
      if (webSocketsStore.isConnected()) {
        broker.subscribeToFeedChanges(forSelectedSiteDeviceKeyList);
      }
    }

    function refreshDeviceFeed(newFeedData) {
      vm.siteDetailsVM.updateFeedValues(newFeedData);
    }

    function destroy() {
      if (broker.isConnected()) {
        broker.unsubscribeSocket();
        webSocketsStore.off(
          webSocketsStore.events.CONNECTED_CHANGE,
          _webSocketStoreConnectedChangeHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_FEED_CHANGE,
          _onFeedChangedHandler
        );
      }
    }

    function refresh() {
      dashboardKarcherActions
        .getKarcherSiteAlarmList(
          "",
          "",
          "",
          fromArrayToPathParam.createPath([$stateParams.id], "sitePointId="),
          "",
          "",
          vm.siteDetailsVM.alarmsPage - 1,
          vm.siteDetailsVM.alarmsPageSize,
          vm.siteDetailsVM.alarmsOrderBy,
          vm.siteDetailsVM.alarmsOrder
        )
        .then(function (response) {
          vm.siteDetailsVM.refreshAlarmList(response);
        });
    }
  }
})();

(function () {
	"use strict";

	angular.module("sempraWebapp").component("weatherHistoryChart", {
		templateUrl:
			"app/components/weatherHistoryChart/weatherHistoryChart.html",
		controller: weatherHistoryChartController,
		bindings: {
			weatherData: "<",
			locationData: "<"
		},
		controllerAs: "vm"
	});

	function weatherHistoryChartController() {
		var vm = this;

		vm.$onInit = function () {};

		vm.$onChanges = function () {};

		vm.$onDestroy = function () {};
	}
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').directive('toGreaterThanFrom', function() {
    return {
      restrict: 'A',
      require: "ngModel",
      link: function(scope, element, attributes, ngModel) {

        ngModel.$parsers.push(function (value) {
          if(!value || value.length == 0) return;

          var otherValueString = scope.$eval(attributes.toGreaterThanFrom);

          ngModel.$setValidity('toGreaterThanFrom', true);

          if (value < new Date(otherValueString)) {
            ngModel.$setValidity('toGreaterThanFrom', false);
          }

          return value;
        });

      }
    };
  });
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').directive('fromLessThanTo', function() {
    return {
      restrict: 'A',
      require: "ngModel",
      link: function(scope, element, attributes, ngModel) {

        ngModel.$parsers.push(function (value) {
          if(!value || value.length == 0) return;

          var otherValueString = scope.$eval(attributes.fromLessThanTo);

          ngModel.$setValidity('fromLessThanTo', true);

          if (value > new Date(otherValueString)) {
            ngModel.$setValidity('fromLessThanTo', false);
          }

          return value;
        });

      }
    };
  });
})();

/* eslint-disable */
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 1.3.2 - 2016-04-14
 * License: MIT
 */angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse","ui.bootstrap.accordion","ui.bootstrap.alert","ui.bootstrap.buttons","ui.bootstrap.carousel","ui.bootstrap.dateparser","ui.bootstrap.isClass","ui.bootstrap.datepicker","ui.bootstrap.position","ui.bootstrap.datepickerPopup","ui.bootstrap.debounce","ui.bootstrap.dropdown","ui.bootstrap.stackedMap","ui.bootstrap.modal","ui.bootstrap.paging","ui.bootstrap.pager","ui.bootstrap.pagination","ui.bootstrap.tooltip","ui.bootstrap.popover","ui.bootstrap.progressbar","ui.bootstrap.rating","ui.bootstrap.tabs","ui.bootstrap.timepicker","ui.bootstrap.typeahead"]);
angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html","uib/template/accordion/accordion.html","uib/template/alert/alert.html","uib/template/carousel/carousel.html","uib/template/carousel/slide.html","uib/template/datepicker/datepicker.html","uib/template/datepicker/day.html","uib/template/datepicker/month.html","uib/template/datepicker/year.html","uib/template/datepickerPopup/popup.html","uib/template/modal/backdrop.html","uib/template/modal/window.html","uib/template/pager/pager.html","uib/template/pagination/pagination.html","uib/template/tooltip/tooltip-html-popup.html","uib/template/tooltip/tooltip-popup.html","uib/template/tooltip/tooltip-template-popup.html","uib/template/popover/popover-html.html","uib/template/popover/popover-template.html","uib/template/popover/popover.html","uib/template/progressbar/bar.html","uib/template/progressbar/progress.html","uib/template/progressbar/progressbar.html","uib/template/rating/rating.html","uib/template/tabs/tab.html","uib/template/tabs/tabset.html","uib/template/timepicker/timepicker.html","uib/template/typeahead/typeahead-match.html","uib/template/typeahead/typeahead-popup.html"]);
angular.module('ui.bootstrap.collapse', [])

  .directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function($animate, $q, $parse, $injector) {
    var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
    return {
      link: function(scope, element, attrs) {
        var expandingExpr = $parse(attrs.expanding),
            expandedExpr = $parse(attrs.expanded),
            collapsingExpr = $parse(attrs.collapsing),
            collapsedExpr = $parse(attrs.collapsed);

        if (!scope.$eval(attrs.uibCollapse)) {
          element.addClass('in')
            .addClass('collapse')
            .attr('aria-expanded', true)
            .attr('aria-hidden', false)
            .css({height: 'auto'});
        }

        function expand() {
          if (element.hasClass('collapse') && element.hasClass('in')) {
            return;
          }

          $q.resolve(expandingExpr(scope))
            .then(function() {
              element.removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false);

              if ($animateCss) {
                $animateCss(element, {
                  addClass: 'in',
                  easing: 'ease',
                  to: { height: element[0].scrollHeight + 'px' }
                }).start()['finally'](expandDone);
              } else {
                $animate.addClass(element, 'in', {
                  to: { height: element[0].scrollHeight + 'px' }
                }).then(expandDone);
              }
            });
        }

        function expandDone() {
          element.removeClass('collapsing')
            .addClass('collapse')
            .css({height: 'auto'});
          expandedExpr(scope);
        }

        function collapse() {
          if (!element.hasClass('collapse') && !element.hasClass('in')) {
            return collapseDone();
          }

          $q.resolve(collapsingExpr(scope))
            .then(function() {
              element
                // IMPORTANT: The height must be set before adding "collapsing" class.
                // Otherwise, the browser attempts to animate from height 0 (in
                // collapsing class) to the given height here.
                .css({height: element[0].scrollHeight + 'px'})
                // initially all panel collapse have the collapse class, this removal
                // prevents the animation from jumping to collapsed state
                .removeClass('collapse')
                .addClass('collapsing')
                .attr('aria-expanded', false)
                .attr('aria-hidden', true);

              if ($animateCss) {
                $animateCss(element, {
                  removeClass: 'in',
                  to: {height: '0'}
                }).start()['finally'](collapseDone);
              } else {
                $animate.removeClass(element, 'in', {
                  to: {height: '0'}
                }).then(collapseDone);
              }
            });
        }

        function collapseDone() {
          element.css({height: '0'}); // Required so that collapse works when animation is disabled
          element.removeClass('collapsing')
            .addClass('collapse');
          collapsedExpr(scope);
        }

        scope.$watch(attrs.uibCollapse, function(shouldCollapse) {
          if (shouldCollapse) {
            collapse();
          } else {
            expand();
          }
        });
      }
    };
  }]);

angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse'])

.constant('uibAccordionConfig', {
  closeOthers: true
})

.controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function(openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ?
      $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function(group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function(groupScope) {
    var that = this;
    this.groups.push(groupScope);

    groupScope.$on('$destroy', function(event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function(group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function() {
  return {
    controller: 'UibAccordionController',
    controllerAs: 'accordion',
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function() {
  return {
    require: '^uibAccordion',         // We need this directive to be inside an accordion
    transclude: true,              // It transcludes the contents of the directive into the template
    replace: true,                // The element containing the directive will be replaced with the template
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',               // Interpolate the heading attribute onto this scope
      panelClass: '@?',           // Ditto with panelClass
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function() {
      this.setHeading = function(element) {
        this.heading = element;
      };
    },
    link: function(scope, element, attrs, accordionCtrl) {
      accordionCtrl.addGroup(scope);

      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass || 'panel-default';
      scope.$watch('isOpen', function(value) {
        element.toggleClass(scope.openClass, !!value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });

      scope.toggleOpen = function($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };

      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      scope.headingId = id + '-tab';
      scope.panelId = id + '-panel';
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function() {
  return {
    transclude: true,   // Grab the contents to be used as the heading
    template: '',       // In effect remove this element!
    replace: true,
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function() {
  return {
    require: '^uibAccordionGroup',
    link: function(scope, element, attrs, controller) {
      scope.$watch(function() { return controller[attrs.uibAccordionTransclude]; }, function(heading) {
        if (heading) {
          var elem = angular.element(element[0].querySelector('[uib-accordion-header]'));
          elem.html('');
          elem.append(heading);
        }
      });
    }
  };
});

angular.module('ui.bootstrap.alert', [])

.controller('UibAlertController', ['$scope', '$attrs', '$interpolate', '$timeout', function($scope, $attrs, $interpolate, $timeout) {
  $scope.closeable = !!$attrs.close;

  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ?
    $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;

  if (dismissOnTimeout) {
    $timeout(function() {
      $scope.close();
    }, parseInt(dismissOnTimeout, 10));
  }
}])

.directive('uibAlert', function() {
  return {
    controller: 'UibAlertController',
    controllerAs: 'alert',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/alert/alert.html';
    },
    transclude: true,
    replace: true,
    scope: {
      type: '@',
      close: '&'
    }
  };
});

angular.module('ui.bootstrap.buttons', [])

.constant('uibButtonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
})

.controller('UibButtonsController', ['uibButtonConfig', function(buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}])

.directive('uibBtnRadio', ['$parse', function($parse) {
  return {
    require: ['uibBtnRadio', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'buttons',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      var uncheckableExpr = $parse(attrs.uibUncheckable);

      element.find('input').css({display: 'none'});

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        var isActive = element.hasClass(buttonsCtrl.activeClass);

        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function() {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
            ngModelCtrl.$render();
          });
        }
      });

      if (attrs.uibUncheckable) {
        scope.$watch(uncheckableExpr, function(uncheckable) {
          attrs.$set('uncheckable', uncheckable ? '' : undefined);
        });
      }
    }
  };
}])

.directive('uibBtnCheckbox', function() {
  return {
    require: ['uibBtnCheckbox', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'button',
    link: function(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      element.find('input').css({display: 'none'});

      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }

      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }

      function getCheckboxValue(attribute, defaultValue) {
        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function() {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function() {
        if (attrs.disabled) {
          return;
        }

        scope.$apply(function() {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});

angular.module('ui.bootstrap.carousel', [])

.controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function($scope, $element, $interval, $timeout, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = $scope.active,
    currentInterval, isPlaying, bufferedTransitions = [];

  var destroyed = false;

  self.addSlide = function(slide, element) {
    slides.push({
      slide: slide,
      element: element
    });
    slides.sort(function(a, b) {
      return +a.slide.index - +b.slide.index;
    });
    //if this is the first slide or the slide is set to active, select it
    if (slide.index === $scope.active || slides.length === 1 && !angular.isNumber($scope.active)) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }

      currentIndex = slide.index;
      $scope.active = slide.index;
      setActive(currentIndex);
      self.select(slides[findSlideIndex(slide)]);
      if (slides.length === 1) {
        $scope.play();
      }
    }
  };

  self.getCurrentIndex = function() {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide.index === currentIndex) {
        return i;
      }
    }
  };

  self.next = $scope.next = function() {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;

    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'next');
  };

  self.prev = $scope.prev = function() {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;

    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }

    return self.select(slides[newIndex], 'prev');
  };

  self.removeSlide = function(slide) {
    var index = findSlideIndex(slide);

    var bufferedIndex = bufferedTransitions.indexOf(slides[index]);
    if (bufferedIndex !== -1) {
      bufferedTransitions.splice(bufferedIndex, 1);
    }

    //get the index of the slide inside the carousel
    slides.splice(index, 1);
    if (slides.length > 0 && currentIndex === index) {
      if (index >= slides.length) {
        currentIndex = slides.length - 1;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[slides.length - 1]);
      } else {
        currentIndex = index;
        $scope.active = currentIndex;
        setActive(currentIndex);
        self.select(slides[index]);
      }
    } else if (currentIndex > index) {
      currentIndex--;
      $scope.active = currentIndex;
    }

    //clean the active value when no more slide
    if (slides.length === 0) {
      currentIndex = null;
      $scope.active = null;
      clearBufferedTransitions();
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function(nextSlide, direction) {
    var nextIndex = findSlideIndex(nextSlide.slide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide.slide.index !== currentIndex &&
      !$scope.$currentTransition) {
      goNext(nextSlide.slide, nextIndex, direction);
    } else if (nextSlide && nextSlide.slide.index !== currentIndex && $scope.$currentTransition) {
      bufferedTransitions.push(slides[nextIndex]);
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function(slide) {
    return +slide.slide.index;
  };

  $scope.isActive = function(slide) {
    return $scope.active === slide.slide.index;
  };

  $scope.isPrevDisabled = function() {
    return $scope.active === 0 && $scope.noWrap();
  };

  $scope.isNextDisabled = function() {
    return $scope.active === slides.length - 1 && $scope.noWrap();
  };

  $scope.pause = function() {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };

  $scope.play = function() {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };

  $scope.$on('$destroy', function() {
    destroyed = true;
    resetTimer();
  });

  $scope.$watch('noTransition', function(noTransition) {
    $animate.enabled($element, !noTransition);
  });

  $scope.$watch('interval', restartTimer);

  $scope.$watchCollection('slides', resetTransition);

  $scope.$watch('active', function(index) {
    if (angular.isNumber(index) && currentIndex !== index) {
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].slide.index === index) {
          index = i;
          break;
        }
      }

      var slide = slides[index];
      if (slide) {
        setActive(index);
        self.select(slides[index]);
        currentIndex = index;
      }
    }
  });

  function clearBufferedTransitions() {
    while (bufferedTransitions.length) {
      bufferedTransitions.shift();
    }
  }

  function getSlideByIndex(index) {
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }

  function setActive(index) {
    for (var i = 0; i < slides.length; i++) {
      slides[i].slide.active = i === index;
    }
  }

  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }

    angular.extend(slide, {direction: direction});
    angular.extend(slides[currentIndex].slide || {}, {direction: direction});
    if ($animate.enabled($element) && !$scope.$currentTransition &&
      slides[index].element && self.slides.length > 1) {
      slides[index].element.data(SLIDE_DIRECTION, slide.direction);
      var currentIdx = self.getCurrentIndex();

      if (angular.isNumber(currentIdx) && slides[currentIdx].element) {
        slides[currentIdx].element.data(SLIDE_DIRECTION, slide.direction);
      }

      $scope.$currentTransition = true;
      $animate.on('addClass', slides[index].element, function(element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
          if (bufferedTransitions.length) {
            var nextSlide = bufferedTransitions.pop().slide;
            var nextIndex = nextSlide.index;
            var nextDirection = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
            clearBufferedTransitions();

            goNext(nextSlide, nextIndex, nextDirection);
          }
        }
      });
    }

    $scope.active = slide.index;
    currentIndex = slide.index;
    setActive(index);

    //every time you change slides, reset the timer
    restartTimer();
  }

  function findSlideIndex(slide) {
    for (var i = 0; i < slides.length; i++) {
      if (slides[i].slide === slide) {
        return i;
      }
    }
  }

  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }

  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
      clearBufferedTransitions();
    }
  }

  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }

  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}])

.directive('uibCarousel', function() {
  return {
    transclude: true,
    replace: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
    },
    scope: {
      active: '=',
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
})

.directive('uibSlide', function() {
  return {
    require: '^uibCarousel',
    transclude: true,
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/slide.html';
    },
    scope: {
      actual: '=?',
      index: '=?'
    },
    link: function (scope, element, attrs, carouselCtrl) {
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function() {
        carouselCtrl.removeSlide(scope);
      });
    }
  };
})

.animation('.item', ['$animateCss',
function($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';

  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }

  return {
    beforeAddClass: function(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element,
          directionClass + ' ' + direction, done);
        element.addClass(direction);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function (element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);

        $animateCss(element, {addClass: directionClass})
          .start()
          .done(removeClassFn);

        return function() {
          stopped = true;
        };
      }
      done();
    }
  };
}]);

angular.module('ui.bootstrap.dateparser', [])

.service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', function($log, $locale, dateFilter, orderByFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;

  var localeId;
  var formatCodeToRegex;

  this.init = function() {
    localeId = $locale.id;

    this.parsers = {};
    this.formatters = {};

    formatCodeToRegex = [
      {
        key: 'yyyy',
        regex: '\\d{4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yyyy');
        }
      },
      {
        key: 'yy',
        regex: '\\d{2}',
        apply: function(value) { value = +value; this.year = value < 69 ? value + 2000 : value + 1900; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'yy');
        }
      },
      {
        key: 'y',
        regex: '\\d{1,4}',
        apply: function(value) { this.year = +value; },
        formatter: function(date) {
          var _date = new Date();
          _date.setFullYear(Math.abs(date.getFullYear()));
          return dateFilter(_date, 'y');
        }
      },
      {
        key: 'M!',
        regex: '0?[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) {
          var value = date.getMonth();
          if (/^[0-9]$/.test(value)) {
            return dateFilter(date, 'MM');
          }

          return dateFilter(date, 'M');
        }
      },
      {
        key: 'MMMM',
        regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMMM'); }
      },
      {
        key: 'MMM',
        regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
        apply: function(value) { this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value); },
        formatter: function(date) { return dateFilter(date, 'MMM'); }
      },
      {
        key: 'MM',
        regex: '0[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'MM'); }
      },
      {
        key: 'M',
        regex: '[1-9]|1[0-2]',
        apply: function(value) { this.month = value - 1; },
        formatter: function(date) { return dateFilter(date, 'M'); }
      },
      {
        key: 'd!',
        regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) {
          var value = date.getDate();
          if (/^[1-9]$/.test(value)) {
            return dateFilter(date, 'dd');
          }

          return dateFilter(date, 'd');
        }
      },
      {
        key: 'dd',
        regex: '[0-2][0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'dd'); }
      },
      {
        key: 'd',
        regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
        apply: function(value) { this.date = +value; },
        formatter: function(date) { return dateFilter(date, 'd'); }
      },
      {
        key: 'EEEE',
        regex: $locale.DATETIME_FORMATS.DAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEEE'); }
      },
      {
        key: 'EEE',
        regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
        formatter: function(date) { return dateFilter(date, 'EEE'); }
      },
      {
        key: 'HH',
        regex: '(?:0|1)[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'HH'); }
      },
      {
        key: 'hh',
        regex: '0[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'hh'); }
      },
      {
        key: 'H',
        regex: '1?[0-9]|2[0-3]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'H'); }
      },
      {
        key: 'h',
        regex: '[0-9]|1[0-2]',
        apply: function(value) { this.hours = +value; },
        formatter: function(date) { return dateFilter(date, 'h'); }
      },
      {
        key: 'mm',
        regex: '[0-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'mm'); }
      },
      {
        key: 'm',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.minutes = +value; },
        formatter: function(date) { return dateFilter(date, 'm'); }
      },
      {
        key: 'sss',
        regex: '[0-9][0-9][0-9]',
        apply: function(value) { this.milliseconds = +value; },
        formatter: function(date) { return dateFilter(date, 'sss'); }
      },
      {
        key: 'ss',
        regex: '[0-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 'ss'); }
      },
      {
        key: 's',
        regex: '[0-9]|[1-5][0-9]',
        apply: function(value) { this.seconds = +value; },
        formatter: function(date) { return dateFilter(date, 's'); }
      },
      {
        key: 'a',
        regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
        apply: function(value) {
          if (this.hours === 12) {
            this.hours = 0;
          }

          if (value === 'PM') {
            this.hours += 12;
          }
        },
        formatter: function(date) { return dateFilter(date, 'a'); }
      },
      {
        key: 'Z',
        regex: '[+-]\\d{4}',
        apply: function(value) {
          var matches = value.match(/([+-])(\d{2})(\d{2})/),
            sign = matches[1],
            hours = matches[2],
            minutes = matches[3];
          this.hours += toInt(sign + hours);
          this.minutes += toInt(sign + minutes);
        },
        formatter: function(date) {
          return dateFilter(date, 'Z');
        }
      },
      {
        key: 'ww',
        regex: '[0-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'ww'); }
      },
      {
        key: 'w',
        regex: '[0-9]|[1-4][0-9]|5[0-3]',
        formatter: function(date) { return dateFilter(date, 'w'); }
      },
      {
        key: 'GGGG',
        regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
        formatter: function(date) { return dateFilter(date, 'GGGG'); }
      },
      {
        key: 'GGG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GGG'); }
      },
      {
        key: 'GG',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'GG'); }
      },
      {
        key: 'G',
        regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
        formatter: function(date) { return dateFilter(date, 'G'); }
      }
    ];
  };

  this.init();

  function createParser(format, func) {
    var map = [], regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i+1] === '\'') { // escaped single quote
              format[i+1] = '$';
              regex[i+1] = '';
            } else { // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') { // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }

      format = format.join('');
    }

    angular.forEach(formatCodeToRegex, function(data) {
      var index = format.indexOf(data.key);

      if (index > -1) {
        format = format.split('');

        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');

        map.push({
          index: index,
          key: data.key,
          apply: data[func],
          matcher: data.regex
        });
      }
    });

    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }

  this.filter = function(date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }

    format = $locale.DATETIME_FORMATS[format] || format;

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.formatters[format]) {
      this.formatters[format] = createParser(format, 'formatter');
    }

    var parser = this.formatters[format],
      map = parser.map;

    var _format = format;

    return map.reduce(function(str, mapper, i) {
      var match = _format.match(new RegExp('(.*)' + mapper.key));
      if (match && angular.isString(match[1])) {
        str += match[1];
        _format = _format.replace(match[1] + mapper.key, '');
      }

      var endStr = i === map.length - 1 ? _format : '';

      if (mapper.apply) {
        return str + mapper.apply.call(null, date) + endStr;
      }

      return str + endStr;
    }, '');
  };

  this.parse = function(input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }

    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');

    if ($locale.id !== localeId) {
      this.init();
    }

    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }

    var parser = this.parsers[format],
        regex = parser.regex,
        map = parser.map,
        results = input.match(regex),
        tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = { year: 1900, month: 0, date: 1, hours: 0, minutes: 0, seconds: 0, milliseconds: 0 };
      }

      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }

        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }

      var datesetter = tzOffset ? Date.prototype.setUTCFullYear :
        Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours :
        Date.prototype.setHours;

      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes,
            fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0,
            fields.seconds || 0, fields.milliseconds || 0);
        }
      }

      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }

    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }

    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }

    return true;
  }

  function toInt(str) {
    return parseInt(str, 10);
  }

  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;

  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }

  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/4daafd3dbe6a80d578f5a31df1bb99c77559543e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }

  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }

  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var timezoneOffset = timezoneToOffset(timezone, date.getTimezoneOffset());
    return addDateMinutes(date, reverse * (timezoneOffset - date.getTimezoneOffset()));
  }
}]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', [])
.directive('uibIsClass', [
         '$animate',
function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;

  var dataPerTracked = {};

  return {
    restrict: 'A',
    compile: function(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');

      return linkFn;

      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });

        exps.forEach(function(exp, k) {
          addForExp(exp, scope);
        });

        scope.$on('$destroy', removeScope);
      }

      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function(compareWithVal) {
            var newActivated = null;
            instances.some(function(instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }

      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function(data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass'])

.value('$datepickerSuppressError', false)

.value('$datepickerLiteralWarning', true)

.constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
})

.controller('UibDatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerLiteralWarning', '$datepickerSuppressError', 'uibDateParser',
  function($scope, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerLiteralWarning, $datepickerSuppressError, dateParser) {
  var self = this,
      ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl;
      ngModelOptions = {},
      watchListeners = [],
      optionsUsed = !!$attrs.datepickerOptions;

  if (!$scope.datepickerOptions) {
    $scope.datepickerOptions = {};
  }

  // Modes chain
  this.modes = ['day', 'month', 'year'];

  [
    'customClass',
    'dateDisabled',
    'datepickerMode',
    'formatDay',
    'formatDayHeader',
    'formatDayTitle',
    'formatMonth',
    'formatMonthTitle',
    'formatYear',
    'maxDate',
    'maxMode',
    'minDate',
    'minMode',
    'showWeeks',
    'shortcutPropagation',
    'startingDay',
    'yearColumns',
    'yearRows'
  ].forEach(function(key) {
    switch (key) {
      case 'customClass':
      case 'dateDisabled':
        $scope[key] = $scope.datepickerOptions[key] || angular.noop;
        break;
      case 'datepickerMode':
        $scope.datepickerMode = angular.isDefined($scope.datepickerOptions.datepickerMode) ?
          $scope.datepickerOptions.datepickerMode : datepickerConfig.datepickerMode;
        break;
      case 'formatDay':
      case 'formatDayHeader':
      case 'formatDayTitle':
      case 'formatMonth':
      case 'formatMonthTitle':
      case 'formatYear':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $interpolate($scope.datepickerOptions[key])($scope.$parent) :
          datepickerConfig[key];
        break;
      case 'showWeeks':
      case 'shortcutPropagation':
      case 'yearColumns':
      case 'yearRows':
        self[key] = angular.isDefined($scope.datepickerOptions[key]) ?
          $scope.datepickerOptions[key] : datepickerConfig[key];
        break;
      case 'startingDay':
        if (angular.isDefined($scope.datepickerOptions.startingDay)) {
          self.startingDay = $scope.datepickerOptions.startingDay;
        } else if (angular.isNumber(datepickerConfig.startingDay)) {
          self.startingDay = datepickerConfig.startingDay;
        } else {
          self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        }

        break;
      case 'maxDate':
      case 'minDate':
        $scope.$watch('datepickerOptions.' + key, function(value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
            } else {
              if ($datepickerLiteralWarning) {
                $log.warn('Literal date support has been deprecated, please switch to date object usage');
              }

              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = datepickerConfig[key] ?
              dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) :
              null;
          }

          self.refreshView();
        });

        break;
      case 'maxMode':
      case 'minMode':
        if ($scope.datepickerOptions[key]) {
          $scope.$watch(function() { return $scope.datepickerOptions[key]; }, function(value) {
            self[key] = $scope[key] = angular.isDefined(value) ? value : datepickerOptions[key];
            if (key === 'minMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) < self.modes.indexOf(self[key]) ||
              key === 'maxMode' && self.modes.indexOf($scope.datepickerOptions.datepickerMode) > self.modes.indexOf(self[key])) {
              $scope.datepickerMode = self[key];
              $scope.datepickerOptions.datepickerMode = self[key];
            }
          });
        } else {
          self[key] = $scope[key] = datepickerConfig[key] || null;
        }

        break;
    }
  });

  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function(disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }

  $scope.isActive = function(dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = ngModelCtrl_.$options || datepickerConfig.ngModelOptions;
    if ($scope.datepickerOptions.initDate) {
      self.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.timezone) || new Date();
      $scope.$watch('datepickerOptions.initDate', function(initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
          self.refreshView();
        }
      });
    } else {
      self.activeDate = new Date();
    }

    this.activeDate = ngModelCtrl.$modelValue ?
      dateParser.fromTimezone(new Date(ngModelCtrl.$modelValue), ngModelOptions.timezone) :
      dateParser.fromTimezone(new Date(), ngModelOptions.timezone);

    ngModelCtrl.$render = function() {
      self.render();
    };
  };

  this.render = function() {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
          isValid = !isNaN(date);

      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.timezone);
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };

  this.refreshView = function() {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }

      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.timezone);
      ngModelCtrl.$setValidity('dateDisabled', !date ||
        this.element && !this.isDisabled(date));
    }
  };

  this.createDateObject = function(date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.timezone);
    var today = new Date();
    today = dateParser.fromTimezone(today, ngModelOptions.timezone);
    var time = this.compare(date, today);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      past: time < 0,
      current: time === 0,
      future: time > 0,
      customClass: this.customClass(date) || null
    };

    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }

    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }

    return dt;
  };

  this.isDisabled = function(date) {
    return $scope.disabled ||
      this.minDate && this.compare(date, this.minDate) < 0 ||
      this.maxDate && this.compare(date, this.maxDate) > 0 ||
      $scope.dateDisabled && $scope.dateDisabled({date: date, mode: $scope.datepickerMode});
  };

  this.customClass = function(date) {
    return $scope.customClass({date: date, mode: $scope.datepickerMode});
  };

  // Split array into smaller arrays
  this.split = function(arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };

  $scope.select = function(date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.timezone) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.timezone);
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      setMode(self.modes[self.modes.indexOf($scope.datepickerMode) - 1]);

      $scope.$emit('uib:datepicker.mode');
    }

    $scope.$broadcast('uib:datepicker.focus');
  };

  $scope.move = function(direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
        month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };

  $scope.toggleMode = function(direction) {
    direction = direction || 1;

    if ($scope.datepickerMode === self.maxMode && direction === 1 ||
      $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }

    setMode(self.modes[self.modes.indexOf($scope.datepickerMode) + direction]);

    $scope.$emit('uib:datepicker.mode');
  };

  // Key event mapper
  $scope.keys = { 13: 'enter', 32: 'space', 33: 'pageup', 34: 'pagedown', 35: 'end', 36: 'home', 37: 'left', 38: 'up', 39: 'right', 40: 'down' };

  var focusElement = function() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);

  $scope.keydown = function(evt) {
    var key = $scope.keys[evt.which];

    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }

    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }

    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };

  $scope.$on('$destroy', function() {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });

  function setMode(mode) {
    $scope.datepickerMode = mode;
    $scope.datepickerOptions.datepickerMode = mode;
  }
}])

.controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

  this.step = { months: 1 };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 &&
      (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };

  this.getDates = function(startDate, n) {
    var dates = new Array(n), current = new Date(startDate), i = 0, date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };

  this._refreshView = function() {
    var year = this.activeDate.getFullYear(),
      month = this.activeDate.getMonth(),
      firstDayOfMonth = new Date(this.activeDate);

    firstDayOfMonth.setFullYear(year, month, 1);

    var difference = this.startingDay - firstDayOfMonth.getDay(),
      numDisplayedFromPreviousMonth = difference > 0 ?
        7 - difference : - difference,
      firstDate = new Date(firstDayOfMonth);

    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i ++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }

    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);

    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
          numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(
          getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getDate();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}])

.controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  this.step = { years: 1 };
  this.element = $element;

  this.init = function(ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };

  this._refreshView = function() {
    var months = new Array(12),
        year = this.activeDate.getFullYear(),
        date;

    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, 3);
  };

  this.compare = function(date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getMonth();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 3;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 3;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? - 1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}])

.controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function(scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;

  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }

  this.yearpickerInit = function() {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = { years: range };
  };

  this._refreshView = function() {
    var years = new Array(range), date;

    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }

    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };

  this.compare = function(date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };

  this.handleKeyDown = function(key, evt) {
    var date = this.activeDate.getFullYear();

    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? - 1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}])

.directive('uibDatepicker', function() {
  return {
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerOptions: '=?'
    },
    require: ['uibDatepicker', '^ngModel'],
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      datepickerCtrl.init(ngModelCtrl);
    }
  };
})

.directive('uibDaypicker', function() {
  return {
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    controller: 'UibDaypickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        daypickerCtrl = ctrls[1];

      daypickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibMonthpicker', function() {
  return {
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    controller: 'UibMonthpickerController',
    link: function(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        monthpickerCtrl = ctrls[1];

      monthpickerCtrl.init(datepickerCtrl);
    }
  };
})

.directive('uibYearpicker', function() {
  return {
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    controller: 'UibYearpickerController',
    link: function(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();

      ctrl.refreshView();
    }
  };
});

angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */
  .factory('$uibPosition', ['$document', '$window', function($document, $window) {
    /**
     * Used by scrollbarWidth() function to cache scrollbar's width.
     * Do not access this variable directly, use scrollbarWidth() instead.
     */
    var SCROLLBAR_WIDTH;
    /**
     * scrollbar on body and html element in IE and Edge overlay
     * content and should be considered 0 width.
     */
    var BODY_SCROLLBAR_WIDTH;
    var OVERFLOW_REGEX = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    };
    var PLACEMENT_REGEX = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
    var BODY_REGEX = /(HTML|BODY)/;

    return {

      /**
       * Provides a raw DOM element from a jQuery/jQLite element.
       *
       * @param {element} elem - The element to convert.
       *
       * @returns {element} A HTML element.
       */
      getRawNode: function(elem) {
        return elem.nodeName ? elem : elem[0] || elem;
      },

      /**
       * Provides a parsed number for a style property.  Strips
       * units and casts invalid numbers to 0.
       *
       * @param {string} value - The style value to parse.
       *
       * @returns {number} A valid number.
       */
      parseStyle: function(value) {
        value = parseFloat(value);
        return isFinite(value) ? value : 0;
      },

      /**
       * Provides the closest positioned ancestor.
       *
       * @param {element} element - The element to get the offest parent for.
       *
       * @returns {element} The closest positioned ancestor.
       */
      offsetParent: function(elem) {
        elem = this.getRawNode(elem);

        var offsetParent = elem.offsetParent || $document[0].documentElement;

        function isStaticPositioned(el) {
          return ($window.getComputedStyle(el).position || 'static') === 'static';
        }

        while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
          offsetParent = offsetParent.offsetParent;
        }

        return offsetParent || $document[0].documentElement;
      },

      /**
       * Provides the scrollbar width, concept from TWBS measureScrollbar()
       * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
       * In IE and Edge, scollbar on body and html element overlay and should
       * return a width of 0.
       *
       * @returns {number} The width of the browser scollbar.
       */
      scrollbarWidth: function(isBody) {
        if (isBody) {
          if (angular.isUndefined(BODY_SCROLLBAR_WIDTH)) {
            var bodyElem = $document.find('body');
            bodyElem.addClass('uib-position-body-scrollbar-measure');
            BODY_SCROLLBAR_WIDTH = $window.innerWidth - bodyElem[0].clientWidth;
            BODY_SCROLLBAR_WIDTH = isFinite(BODY_SCROLLBAR_WIDTH) ? BODY_SCROLLBAR_WIDTH : 0;
            bodyElem.removeClass('uib-position-body-scrollbar-measure');
          }
          return BODY_SCROLLBAR_WIDTH;
        }

        if (angular.isUndefined(SCROLLBAR_WIDTH)) {
          var scrollElem = angular.element('<div class="uib-position-scrollbar-measure"></div>');
          $document.find('body').append(scrollElem);
          SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
          SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
          scrollElem.remove();
        }

        return SCROLLBAR_WIDTH;
      },

      /**
       * Provides the padding required on an element to replace the scrollbar.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**scrollbarWidth**: the width of the scrollbar</li>
       *     <li>**widthOverflow**: whether the the width is overflowing</li>
       *     <li>**right**: the amount of right padding on the element needed to replace the scrollbar</li>
       *     <li>**rightOriginal**: the amount of right padding currently on the element</li>
       *     <li>**heightOverflow**: whether the the height is overflowing</li>
       *     <li>**bottom**: the amount of bottom padding on the element needed to replace the scrollbar</li>
       *     <li>**bottomOriginal**: the amount of bottom padding currently on the element</li>
       *   </ul>
       */
      scrollbarPadding: function(elem) {
        elem = this.getRawNode(elem);

        var elemStyle = $window.getComputedStyle(elem);
        var paddingRight = this.parseStyle(elemStyle.paddingRight);
        var paddingBottom = this.parseStyle(elemStyle.paddingBottom);
        var scrollParent = this.scrollParent(elem, false, true);
        var scrollbarWidth = this.scrollbarWidth(scrollParent, BODY_REGEX.test(scrollParent.tagName));

        return {
          scrollbarWidth: scrollbarWidth,
          widthOverflow: scrollParent.scrollWidth > scrollParent.clientWidth,
          right: paddingRight + scrollbarWidth,
          originalRight: paddingRight,
          heightOverflow: scrollParent.scrollHeight > scrollParent.clientHeight,
          bottom: paddingBottom + scrollbarWidth,
          originalBottom: paddingBottom
         };
      },

      /**
       * Checks to see if the element is scrollable.
       *
       * @param {element} elem - The element to check.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       *
       * @returns {boolean} Whether the element is scrollable.
       */
      isScrollable: function(elem, includeHidden) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var elemStyle = $window.getComputedStyle(elem);
        return overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX);
      },

      /**
       * Provides the closest scrollable ancestor.
       * A port of the jQuery UI scrollParent method:
       * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
       *
       * @param {element} elem - The element to find the scroll parent of.
       * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
       *   default is false.
       * @param {boolean=} [includeSelf=false] - Should the element being passed be
       * included in the scrollable llokup.
       *
       * @returns {element} A HTML element.
       */
      scrollParent: function(elem, includeHidden, includeSelf) {
        elem = this.getRawNode(elem);

        var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
        var documentEl = $document[0].documentElement;
        var elemStyle = $window.getComputedStyle(elem);
        if (includeSelf && overflowRegex.test(elemStyle.overflow + elemStyle.overflowY + elemStyle.overflowX)) {
          return elem;
        }
        var excludeStatic = elemStyle.position === 'absolute';
        var scrollParent = elem.parentElement || documentEl;

        if (scrollParent === documentEl || elemStyle.position === 'fixed') {
          return documentEl;
        }

        while (scrollParent.parentElement && scrollParent !== documentEl) {
          var spStyle = $window.getComputedStyle(scrollParent);
          if (excludeStatic && spStyle.position !== 'static') {
            excludeStatic = false;
          }

          if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
            break;
          }
          scrollParent = scrollParent.parentElement;
        }

        return scrollParent;
      },

      /**
       * Provides read-only equivalent of jQuery's position function:
       * http://api.jquery.com/position/ - distance to closest positioned
       * ancestor.  Does not account for margins by default like jQuery position.
       *
       * @param {element} elem - The element to caclulate the position on.
       * @param {boolean=} [includeMargins=false] - Should margins be accounted
       * for, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of offset parent</li>
       *     <li>**left**: distance to left edge of offset parent</li>
       *   </ul>
       */
      position: function(elem, includeMagins) {
        elem = this.getRawNode(elem);

        var elemOffset = this.offset(elem);
        if (includeMagins) {
          var elemStyle = $window.getComputedStyle(elem);
          elemOffset.top -= this.parseStyle(elemStyle.marginTop);
          elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
        }
        var parent = this.offsetParent(elem);
        var parentOffset = {top: 0, left: 0};

        if (parent !== $document[0].documentElement) {
          parentOffset = this.offset(parent);
          parentOffset.top += parent.clientTop - parent.scrollTop;
          parentOffset.left += parent.clientLeft - parent.scrollLeft;
        }

        return {
          width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
          top: Math.round(elemOffset.top - parentOffset.top),
          left: Math.round(elemOffset.left - parentOffset.left)
        };
      },

      /**
       * Provides read-only equivalent of jQuery's offset function:
       * http://api.jquery.com/offset/ - distance to viewport.  Does
       * not account for borders, margins, or padding on the body
       * element.
       *
       * @param {element} elem - The element to calculate the offset on.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**width**: the width of the element</li>
       *     <li>**height**: the height of the element</li>
       *     <li>**top**: distance to top edge of viewport</li>
       *     <li>**right**: distance to bottom edge of viewport</li>
       *   </ul>
       */
      offset: function(elem) {
        elem = this.getRawNode(elem);

        var elemBCR = elem.getBoundingClientRect();
        return {
          width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
          height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
          top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
          left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
        };
      },

      /**
       * Provides offset distance to the closest scrollable ancestor
       * or viewport.  Accounts for border and scrollbar width.
       *
       * Right and bottom dimensions represent the distance to the
       * respective edge of the viewport element.  If the element
       * edge extends beyond the viewport, a negative value will be
       * reported.
       *
       * @param {element} elem - The element to get the viewport offset for.
       * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
       * of the first scrollable element, default is false.
       * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
       * be accounted for, default is true.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: distance to the top content edge of viewport element</li>
       *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
       *     <li>**left**: distance to the left content edge of viewport element</li>
       *     <li>**right**: distance to the right content edge of viewport element</li>
       *   </ul>
       */
      viewportOffset: function(elem, useDocument, includePadding) {
        elem = this.getRawNode(elem);
        includePadding = includePadding !== false ? true : false;

        var elemBCR = elem.getBoundingClientRect();
        var offsetBCR = {top: 0, left: 0, bottom: 0, right: 0};

        var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
        var offsetParentBCR = offsetParent.getBoundingClientRect();

        offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
        offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
        if (offsetParent === $document[0].documentElement) {
          offsetBCR.top += $window.pageYOffset;
          offsetBCR.left += $window.pageXOffset;
        }
        offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
        offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;

        if (includePadding) {
          var offsetParentStyle = $window.getComputedStyle(offsetParent);
          offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
          offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
          offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
          offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
        }

        return {
          top: Math.round(elemBCR.top - offsetBCR.top),
          bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
          left: Math.round(elemBCR.left - offsetBCR.left),
          right: Math.round(offsetBCR.right - elemBCR.right)
        };
      },

      /**
       * Provides an array of placement values parsed from a placement string.
       * Along with the 'auto' indicator, supported placement strings are:
       *   <ul>
       *     <li>top: element on top, horizontally centered on host element.</li>
       *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
       *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
       *     <li>bottom: element on bottom, horizontally centered on host element.</li>
       *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
       *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
       *     <li>left: element on left, vertically centered on host element.</li>
       *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
       *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
       *     <li>right: element on right, vertically centered on host element.</li>
       *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
       *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
       *   </ul>
       * A placement string with an 'auto' indicator is expected to be
       * space separated from the placement, i.e: 'auto bottom-left'  If
       * the primary and secondary placement values do not match 'top,
       * bottom, left, right' then 'top' will be the primary placement and
       * 'center' will be the secondary placement.  If 'auto' is passed, true
       * will be returned as the 3rd value of the array.
       *
       * @param {string} placement - The placement string to parse.
       *
       * @returns {array} An array with the following values
       * <ul>
       *   <li>**[0]**: The primary placement.</li>
       *   <li>**[1]**: The secondary placement.</li>
       *   <li>**[2]**: If auto is passed: true, else undefined.</li>
       * </ul>
       */
      parsePlacement: function(placement) {
        var autoPlace = PLACEMENT_REGEX.auto.test(placement);
        if (autoPlace) {
          placement = placement.replace(PLACEMENT_REGEX.auto, '');
        }

        placement = placement.split('-');

        placement[0] = placement[0] || 'top';
        if (!PLACEMENT_REGEX.primary.test(placement[0])) {
          placement[0] = 'top';
        }

        placement[1] = placement[1] || 'center';
        if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
          placement[1] = 'center';
        }

        if (autoPlace) {
          placement[2] = true;
        } else {
          placement[2] = false;
        }

        return placement;
      },

      /**
       * Provides coordinates for an element to be positioned relative to
       * another element.  Passing 'auto' as part of the placement parameter
       * will enable smart placement - where the element fits. i.e:
       * 'auto left-top' will check to see if there is enough space to the left
       * of the hostElem to fit the targetElem, if not place right (same for secondary
       * top placement).  Available space is calculated using the viewportOffset
       * function.
       *
       * @param {element} hostElem - The element to position against.
       * @param {element} targetElem - The element to position.
       * @param {string=} [placement=top] - The placement for the targetElem,
       *   default is 'top'. 'center' is assumed as secondary placement for
       *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
       *   <ul>
       *     <li>top</li>
       *     <li>top-right</li>
       *     <li>top-left</li>
       *     <li>bottom</li>
       *     <li>bottom-left</li>
       *     <li>bottom-right</li>
       *     <li>left</li>
       *     <li>left-top</li>
       *     <li>left-bottom</li>
       *     <li>right</li>
       *     <li>right-top</li>
       *     <li>right-bottom</li>
       *   </ul>
       * @param {boolean=} [appendToBody=false] - Should the top and left values returned
       *   be calculated from the body element, default is false.
       *
       * @returns {object} An object with the following properties:
       *   <ul>
       *     <li>**top**: Value for targetElem top.</li>
       *     <li>**left**: Value for targetElem left.</li>
       *     <li>**placement**: The resolved placement.</li>
       *   </ul>
       */
      positionElements: function(hostElem, targetElem, placement, appendToBody) {
        hostElem = this.getRawNode(hostElem);
        targetElem = this.getRawNode(targetElem);

        // need to read from prop to support tests.
        var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
        var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');

        placement = this.parsePlacement(placement);

        var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
        var targetElemPos = {top: 0, left: 0, placement: ''};

        if (placement[2]) {
          var viewportOffset = this.viewportOffset(hostElem, appendToBody);

          var targetElemStyle = $window.getComputedStyle(targetElem);
          var adjustedSize = {
            width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
            height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
          };

          placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' :
                         placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' :
                         placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' :
                         placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' :
                         placement[0];

          placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' :
                         placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' :
                         placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' :
                         placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' :
                         placement[1];

          if (placement[1] === 'center') {
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
              if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
                placement[1] = 'left';
              } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
                placement[1] = 'right';
              }
            } else {
              var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
              if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
                placement[1] = 'top';
              } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
                placement[1] = 'bottom';
              }
            }
          }
        }

        switch (placement[0]) {
          case 'top':
            targetElemPos.top = hostElemPos.top - targetHeight;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left - targetWidth;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width;
            break;
        }

        switch (placement[1]) {
          case 'top':
            targetElemPos.top = hostElemPos.top;
            break;
          case 'bottom':
            targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
            break;
          case 'left':
            targetElemPos.left = hostElemPos.left;
            break;
          case 'right':
            targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
            break;
          case 'center':
            if (PLACEMENT_REGEX.vertical.test(placement[0])) {
              targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
            } else {
              targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
            }
            break;
        }

        targetElemPos.top = Math.round(targetElemPos.top);
        targetElemPos.left = Math.round(targetElemPos.left);
        targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];

        return targetElemPos;
      },

      /**
      * Provides a way for positioning tooltip & dropdown
      * arrows when using placement options beyond the standard
      * left, right, top, or bottom.
      *
      * @param {element} elem - The tooltip/dropdown element.
      * @param {string} placement - The placement for the elem.
      */
      positionArrow: function(elem, placement) {
        elem = this.getRawNode(elem);

        var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
        if (!innerElem) {
          return;
        }

        var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');

        var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
        if (!arrowElem) {
          return;
        }

        var arrowCss = {
          top: '',
          bottom: '',
          left: '',
          right: ''
        };

        placement = this.parsePlacement(placement);
        if (placement[1] === 'center') {
          // no adjustment necessary - just reset styles
          angular.element(arrowElem).css(arrowCss);
          return;
        }

        var borderProp = 'border-' + placement[0] + '-width';
        var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];

        var borderRadiusProp = 'border-';
        if (PLACEMENT_REGEX.vertical.test(placement[0])) {
          borderRadiusProp += placement[0] + '-' + placement[1];
        } else {
          borderRadiusProp += placement[1] + '-' + placement[0];
        }
        borderRadiusProp += '-radius';
        var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];

        switch (placement[0]) {
          case 'top':
            arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'bottom':
            arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'left':
            arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
            break;
          case 'right':
            arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
            break;
        }

        arrowCss[placement[1]] = borderRadius;

        angular.element(arrowElem).css(arrowCss);
      }
    };
  }]);

angular.module('ui.bootstrap.datepickerPopup', ['ui.bootstrap.datepicker', 'ui.bootstrap.position'])

.value('$datepickerPopupLiteralWarning', true)

.constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepickerPopup/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true,
  placement: 'auto bottom-left'
})

.controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$log', '$parse', '$window', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', '$datepickerPopupLiteralWarning',
function($scope, $element, $attrs, $compile, $log, $parse, $window, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig, $datepickerPopupLiteralWarning) {
  var cache = {},
    isHtml5DateInput = false;
  var dateFormat, closeOnDateSelection, appendToBody, onOpenFocus,
    datepickerPopupTemplateUrl, datepickerTemplateUrl, popupEl, datepickerEl, scrollParentEl,
    ngModel, ngModelOptions, $popup, altInputFormats, watchListeners = [],
    timezone;

  this.init = function(_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = _ngModel_.$options;
    closeOnDateSelection = angular.isDefined($attrs.closeOnDateSelection) ?
      $scope.$parent.$eval($attrs.closeOnDateSelection) :
      datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined($attrs.datepickerAppendToBody) ?
      $scope.$parent.$eval($attrs.datepickerAppendToBody) :
      datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined($attrs.onOpenFocus) ?
      $scope.$parent.$eval($attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined($attrs.datepickerPopupTemplateUrl) ?
      $attrs.datepickerPopupTemplateUrl :
      datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined($attrs.datepickerTemplateUrl) ?
      $attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined($attrs.altInputFormats) ?
      $scope.$parent.$eval($attrs.altInputFormats) :
      datepickerPopupConfig.altInputFormats;

    $scope.showButtonBar = angular.isDefined($attrs.showButtonBar) ?
      $scope.$parent.$eval($attrs.showButtonBar) :
      datepickerPopupConfig.showButtonBar;

    if (datepickerPopupConfig.html5Types[$attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[$attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = $attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      $attrs.$observe('uibDatepickerPopup', function(value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;

          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }

    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }

    if (isHtml5DateInput && $attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
    if (ngModelOptions) {
      timezone = ngModelOptions.timezone;
      $scope.ngModelOptions = angular.copy(ngModelOptions);
      $scope.ngModelOptions.timezone = null;
      if ($scope.ngModelOptions.updateOnDefault === true) {
        $scope.ngModelOptions.updateOn = $scope.ngModelOptions.updateOn ?
          $scope.ngModelOptions.updateOn + ' default' : 'default';
      }

      popupEl.attr('ng-model-options', 'ngModelOptions');
    } else {
      timezone = null;
    }

    popupEl.attr({
      'ng-model': 'date',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);

    if (!$scope.datepickerOptions) {
      $scope.datepickerOptions = {};
    }

    if (isHtml5DateInput) {
      if ($attrs.type === 'month') {
        $scope.datepickerOptions.datepickerMode = 'month';
        $scope.datepickerOptions.minMode = 'month';
      }
    }

    datepickerEl.attr('datepicker-options', 'datepickerOptions');

    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function(value) {
        if (ngModel.$isEmpty(value)) {
          $scope.date = value;
          return value;
        }

        $scope.date = dateParser.fromTimezone(value, timezone);

        if (angular.isNumber($scope.date)) {
          $scope.date = new Date($scope.date);
        }

        return dateParser.filter($scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function(value) {
        $scope.date = dateParser.fromTimezone(value, timezone);
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function() {
      $scope.date = parseDateString(ngModel.$viewValue);
    });

    $element.on('keydown', inputKeydownBind);

    $popup = $compile(popupEl)($scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();

    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      $element.after($popup);
    }

    $scope.$on('$destroy', function() {
      if ($scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          $scope.$apply(function() {
            $scope.isOpen = false;
          });
        }
      }

      $popup.remove();
      $element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };

  $scope.getText = function(key) {
    return $scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };

  $scope.isDisabled = function(date) {
    if (date === 'today') {
      date = dateParser.fromTimezone(new Date(), timezone);
    }

    var dates = {};
    angular.forEach(['minDate', 'maxDate'], function(key) {
      if (!$scope.datepickerOptions[key]) {
        dates[key] = null;
      } else if (angular.isDate($scope.datepickerOptions[key])) {
        dates[key] = dateParser.fromTimezone(new Date($scope.datepickerOptions[key]), timezone);
      } else {
        if ($datepickerPopupLiteralWarning) {
          $log.warn('Literal date support has been deprecated, please switch to date object usage');
        }

        dates[key] = new Date(dateFilter($scope.datepickerOptions[key], 'medium'));
      }
    });

    return $scope.datepickerOptions &&
      dates.minDate && $scope.compare(date, dates.minDate) < 0 ||
      dates.maxDate && $scope.compare(date, dates.maxDate) > 0;
  };

  $scope.compare = function(date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  $scope.dateSelection = function(dt) {
    if (angular.isDefined(dt)) {
      $scope.date = dt;
    }
    var date = $scope.date ? dateParser.filter($scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    $element.val(date);
    ngModel.$setViewValue(date);

    if (closeOnDateSelection) {
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.keydown = function(evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      $scope.isOpen = false;
      $element[0].focus();
    }
  };

  $scope.select = function(date, evt) {
    evt.stopPropagation();

    if (date === 'today') {
      var today = new Date();
      if (angular.isDate($scope.date)) {
        date = new Date($scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = new Date(today.setHours(0, 0, 0, 0));
      }
    }
    $scope.dateSelection(date);
  };

  $scope.close = function(evt) {
    evt.stopPropagation();

    $scope.isOpen = false;
    $element[0].focus();
  };

  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if ($attrs.ngDisabled) {
    watchListeners.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(disabled) {
      $scope.disabled = disabled;
    }));
  }

  $scope.$watch('isOpen', function(value) {
    if (value) {
      if (!$scope.disabled) {
        $timeout(function() {
          positionPopup();

          if (onOpenFocus) {
            $scope.$broadcast('uib:datepicker.focus');
          }

          $document.on('click', documentClickBind);

          var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
          if (appendToBody || $position.parsePlacement(placement)[2]) {
            scrollParentEl = scrollParentEl || angular.element($position.scrollParent($element));
            if (scrollParentEl) {
              scrollParentEl.on('scroll', positionPopup);
            }
          } else {
            scrollParentEl = null;
          }

          angular.element($window).on('resize', positionPopup);
        }, 0, false);
      } else {
        $scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
      if (scrollParentEl) {
        scrollParentEl.off('scroll', positionPopup);
      }
      angular.element($window).off('resize', positionPopup);
    }
  });

  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function($1) { return '-' + $1.toLowerCase(); });
  }

  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, $scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], $scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }

  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }

    if (!viewValue) {
      return null;
    }

    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }

    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.toTimezone(date, timezone);
      }
    }

    return ngModel.$options && ngModel.$options.allowInvalid ? viewValue : undefined;
  }

  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;

    if (!$attrs.ngRequired && !value) {
      return true;
    }

    if (angular.isNumber(value)) {
      value = new Date(value);
    }

    if (!value) {
      return true;
    }

    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }

    if (angular.isString(value)) {
      return !isNaN(parseDateString(viewValue));
    }

    return false;
  }

  function documentClickBind(event) {
    if (!$scope.isOpen && $scope.disabled) {
      return;
    }

    var popup = $popup[0];
    var dpContainsTarget = $element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if ($scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
    }
  }

  function inputKeydownBind(evt) {
    if (evt.which === 27 && $scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = false;
      });
      $element[0].focus();
    } else if (evt.which === 40 && !$scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.$apply(function() {
        $scope.isOpen = true;
      });
    }
  }

  function positionPopup() {
    if ($scope.isOpen) {
      var dpElement = angular.element($popup[0].querySelector('.uib-datepicker-popup'));
      var placement = $attrs.popupPlacement ? $attrs.popupPlacement : datepickerPopupConfig.placement;
      var position = $position.positionElements($element, dpElement, placement, appendToBody);
      dpElement.css({top: position.top + 'px', left: position.left + 'px'});
      if (dpElement.hasClass('uib-position-measure')) {
        dpElement.removeClass('uib-position-measure');
      }
    }
  }

  $scope.$on('uib:datepicker.mode', function() {
    $timeout(positionPopup, 0, false);
  });
}])

.directive('uibDatepickerPopup', function() {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@'
    },
    link: function(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
        ctrl = ctrls[1];

      ctrl.init(ngModel);
    }
  };
})

.directive('uibDatepickerPopupWrap', function() {
  return {
    replace: true,
    transclude: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepickerPopup/popup.html';
    }
  };
});

angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */
  .factory('$$debounce', ['$timeout', function($timeout) {
    return function(callback, debounceTime) {
      var timeoutPromise;

      return function() {
        var self = this;
        var args = Array.prototype.slice.call(arguments);
        if (timeoutPromise) {
          $timeout.cancel(timeoutPromise);
        }

        timeoutPromise = $timeout(function() {
          callback.apply(self, args);
        }, debounceTime);
      };
    };
  }]);

angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position'])

.constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
})

.service('uibDropdownService', ['$document', '$rootScope', function($document, $rootScope) {
  var openScope = null;

  this.open = function(dropdownScope, element) {
    if (!openScope) {
      $document.on('click', closeDropdown);
      element.on('keydown', keybindFilter);
    }

    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }

    openScope = dropdownScope;
  };

  this.close = function(dropdownScope, element) {
    if (openScope === dropdownScope) {
      openScope = null;
      $document.off('click', closeDropdown);
      element.off('keydown', keybindFilter);
    }
  };

  var closeDropdown = function(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope) { return; }

    if (evt && openScope.getAutoClose() === 'disabled') { return; }

    if (evt && evt.which === 3) { return; }

    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }

    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' &&
      dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }

    openScope.isOpen = false;

    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };

  var keybindFilter = function(evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}])

.controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(), // create a child scope so we are not polluting original one
    templateScope,
    appendToOpenClass = dropdownConfig.appendToOpenClass,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    appendToBody = false,
    appendTo = null,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');

  $element.addClass('dropdown');

  this.init = function() {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;

      $scope.$watch(getIsOpen, function(value) {
        scope.isOpen = !!value;
      });
    }

    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }

    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
    keynavEnabled = angular.isDefined($attrs.keyboardNav);

    if (appendToBody && !appendTo) {
      appendTo = body;
    }

    if (appendTo && self.dropdownMenu) {
      appendTo.append(self.dropdownMenu);
      $element.on('$destroy', function handleDestroyEvent() {
        self.dropdownMenu.remove();
      });
    }
  };

  this.toggle = function(open) {
    scope.isOpen = arguments.length ? !!open : !scope.isOpen;
    if (angular.isFunction(setIsOpen)) {
      setIsOpen(scope, scope.isOpen);
    }

    return scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function() {
    return scope.isOpen;
  };

  scope.getToggleElement = function() {
    return self.toggleElement;
  };

  scope.getAutoClose = function() {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };

  scope.getElement = function() {
    return $element;
  };

  scope.isKeynavEnabled = function() {
    return keynavEnabled;
  };

  scope.focusDropdownEntry = function(keyCode) {
    var elems = self.dropdownMenu ? //If append to body is used.
      angular.element(self.dropdownMenu).find('a') :
      $element.find('ul').eq(0).find('a');

    switch (keyCode) {
      case 40: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = 0;
        } else {
          self.selectedOption = self.selectedOption === elems.length - 1 ?
            self.selectedOption :
            self.selectedOption + 1;
        }
        break;
      }
      case 38: {
        if (!angular.isNumber(self.selectedOption)) {
          self.selectedOption = elems.length - 1;
        } else {
          self.selectedOption = self.selectedOption === 0 ?
            0 : self.selectedOption - 1;
        }
        break;
      }
    }
    elems[self.selectedOption].focus();
  };

  scope.getDropdownElement = function() {
    return self.dropdownMenu;
  };

  scope.focusToggleElement = function() {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };

  scope.$watch('isOpen', function(isOpen, wasOpen) {
    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
        css,
        rightalign;

      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };

      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        css.right = window.innerWidth -
          (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);

        css.top = pos.top - appendOffset.top + 'px';

        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth -
            (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }

      self.dropdownMenu.css(css);
    }

    var openContainer = appendTo ? appendTo : $element;
    var hasOpenClass = openContainer.hasClass(appendTo ? appendToOpenClass : openClass);

    if (hasOpenClass === !isOpen) {
      $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, appendTo ? appendToOpenClass : openClass).then(function() {
        if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
          toggleInvoker($scope, { open: !!isOpen });
        }
      });
    }

    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function(tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function(dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
          });
        });
      }

      scope.focusToggleElement();
      uibDropdownService.open(scope, $element);
    } else {
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }

      uibDropdownService.close(scope, $element);
      self.selectedOption = null;
    }

    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
}])

.directive('uibDropdown', function() {
  return {
    controller: 'UibDropdownController',
    link: function(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
})

.directive('uibDropdownMenu', function() {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }

      element.addClass('dropdown-menu');

      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }

      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
})

.directive('uibDropdownToggle', function() {
  return {
    require: '?^uibDropdown',
    link: function(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }

      element.addClass('dropdown-toggle');

      dropdownCtrl.toggleElement = element;

      var toggleDropdown = function(event) {
        event.preventDefault();

        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function() {
            dropdownCtrl.toggle();
          });
        }
      };

      element.bind('click', toggleDropdown);

      // WAI-ARIA
      element.attr({ 'aria-haspopup': true, 'aria-expanded': false });
      scope.$watch(dropdownCtrl.isOpen, function(isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });

      scope.$on('$destroy', function() {
        element.unbind('click', toggleDropdown);
      });
    }
  };
});

angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */
  .factory('$$stackedMap', function() {
    return {
      createNew: function() {
        var stack = [];

        return {
          add: function(key, value) {
            stack.push({
              key: key,
              value: value
            });
          },
          get: function(key) {
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                return stack[i];
              }
            }
          },
          keys: function() {
            var keys = [];
            for (var i = 0; i < stack.length; i++) {
              keys.push(stack[i].key);
            }
            return keys;
          },
          top: function() {
            return stack[stack.length - 1];
          },
          remove: function(key) {
            var idx = -1;
            for (var i = 0; i < stack.length; i++) {
              if (key === stack[i].key) {
                idx = i;
                break;
              }
            }
            return stack.splice(idx, 1)[0];
          },
          removeTop: function() {
            return stack.splice(stack.length - 1, 1)[0];
          },
          length: function() {
            return stack.length;
          }
        };
      }
    };
  });
angular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap', 'ui.bootstrap.position'])
/**
 * A helper, internal data structure that stores all references attached to key
 */
  .factory('$$multiMap', function() {
    return {
      createNew: function() {
        var map = {};

        return {
          entries: function() {
            return Object.keys(map).map(function(key) {
              return {
                key: key,
                value: map[key]
              };
            });
          },
          get: function(key) {
            return map[key];
          },
          hasKey: function(key) {
            return !!map[key];
          },
          keys: function() {
            return Object.keys(map);
          },
          put: function(key, value) {
            if (!map[key]) {
              map[key] = [];
            }

            map[key].push(value);
          },
          remove: function(key, value) {
            var values = map[key];

            if (!values) {
              return;
            }

            var idx = values.indexOf(value);

            if (idx !== -1) {
              values.splice(idx, 1);
            }

            if (!values.length) {
              delete map[key];
            }
          }
        };
      }
    };
  })

/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */
  .provider('$uibResolve', function() {
    var resolve = this;
    this.resolver = null;

    this.setResolver = function(resolver) {
      this.resolver = resolver;
    };

    this.$get = ['$injector', '$q', function($injector, $q) {
      var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
      return {
        resolve: function(invocables, locals, parent, self) {
          if (resolver) {
            return resolver.resolve(invocables, locals, parent, self);
          }

          var promises = [];

          angular.forEach(invocables, function(value) {
            if (angular.isFunction(value) || angular.isArray(value)) {
              promises.push($q.resolve($injector.invoke(value)));
            } else if (angular.isString(value)) {
              promises.push($q.resolve($injector.get(value)));
            } else {
              promises.push($q.resolve(value));
            }
          });

          return $q.all(promises).then(function(resolves) {
            var resolveObj = {};
            var resolveIter = 0;
            angular.forEach(invocables, function(value, key) {
              resolveObj[key] = resolves[resolveIter++];
            });

            return resolveObj;
          });
        }
      };
    }];
  })

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */
  .directive('uibModalBackdrop', ['$animate', '$injector', '$uibModalStack',
  function($animate, $injector, $modalStack) {
    return {
      replace: true,
      templateUrl: 'uib/template/modal/backdrop.html',
      compile: function(tElement, tAttrs) {
        tElement.addClass(tAttrs.backdropClass);
        return linkFn;
      }
    };

    function linkFn(scope, element, attrs) {
      if (attrs.modalInClass) {
        $animate.addClass(element, attrs.modalInClass);

        scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
          var done = setIsAsync();
          if (scope.modalOptions.animation) {
            $animate.removeClass(element, attrs.modalInClass).then(done);
          } else {
            done();
          }
        });
      }
    }
  }])

  .directive('uibModalWindow', ['$uibModalStack', '$q', '$animateCss', '$document',
  function($modalStack, $q, $animateCss, $document) {
    return {
      scope: {
        index: '@'
      },
      replace: true,
      transclude: true,
      templateUrl: function(tElement, tAttrs) {
        return tAttrs.templateUrl || 'uib/template/modal/window.html';
      },
      link: function(scope, element, attrs) {
        element.addClass(attrs.windowClass || '');
        element.addClass(attrs.windowTopClass || '');
        scope.size = attrs.size;

        scope.close = function(evt) {
          var modal = $modalStack.getTop();
          if (modal && modal.value.backdrop &&
            modal.value.backdrop !== 'static' &&
            evt.target === evt.currentTarget) {
            evt.preventDefault();
            evt.stopPropagation();
            $modalStack.dismiss(modal.key, 'backdrop click');
          }
        };

        // moved from template to fix issue #2280
        element.on('click', scope.close);

        // This property is only added to the scope for the purpose of detecting when this directive is rendered.
        // We can detect that by using this property in the template associated with this directive and then use
        // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
        scope.$isRendered = true;

        // Deferred object that will be resolved when this modal is render.
        var modalRenderDeferObj = $q.defer();
        // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
        // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
        attrs.$observe('modalRender', function(value) {
          if (value === 'true') {
            modalRenderDeferObj.resolve();
          }
        });

        modalRenderDeferObj.promise.then(function() {
          var animationPromise = null;

          if (attrs.modalInClass) {
            animationPromise = $animateCss(element, {
              addClass: attrs.modalInClass
            }).start();

            scope.$on($modalStack.NOW_CLOSING_EVENT, function(e, setIsAsync) {
              var done = setIsAsync();
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            });
          }


          $q.when(animationPromise).then(function() {
            // Notify {@link $modalStack} that modal is rendered.
            var modal = $modalStack.getTop();
            if (modal) {
              $modalStack.modalRendered(modal.key);
            }

            /**
             * If something within the freshly-opened modal already has focus (perhaps via a
             * directive that causes focus). then no need to try and focus anything.
             */
            if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
              var inputWithAutofocus = element[0].querySelector('[autofocus]');
              /**
               * Auto-focusing of a freshly-opened modal element causes any child elements
               * with the autofocus attribute to lose focus. This is an issue on touch
               * based devices which will show and then hide the onscreen keyboard.
               * Attempts to refocus the autofocus element via JavaScript will not reopen
               * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
               * the modal element if the modal does not contain an autofocus element.
               */
              if (inputWithAutofocus) {
                inputWithAutofocus.focus();
              } else {
                element[0].focus();
              }
            }
          });
        });
      }
    };
  }])

  .directive('uibModalAnimationClass', function() {
    return {
      compile: function(tElement, tAttrs) {
        if (tAttrs.modalAnimation) {
          tElement.addClass(tAttrs.uibModalAnimationClass);
        }
      }
    };
  })

  .directive('uibModalTransclude', function() {
    return {
      link: function(scope, element, attrs, controller, transclude) {
        transclude(scope.$parent, function(clone) {
          element.empty();
          element.append(clone);
        });
      }
    };
  })

  .factory('$uibModalStack', ['$animate', '$animateCss', '$document',
    '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', '$uibPosition',
    function($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap, $uibPosition) {
      var OPENED_MODAL_CLASS = 'modal-open';

      var backdropDomEl, backdropScope;
      var openedWindows = $$stackedMap.createNew();
      var openedClasses = $$multiMap.createNew();
      var $modalStack = {
        NOW_CLOSING_EVENT: 'modal.stack.now-closing'
      };
      var topModalIndex = 0;
      var previousTopOpenedModal = null;

      //Modal focus behavior
      var tabableSelector = 'a[href], area[href], input:not([disabled]), ' +
        'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' +
        'iframe, object, embed, *[tabindex], *[contenteditable=true]';
      var scrollbarPadding;

      function isVisible(element) {
        return !!(element.offsetWidth ||
          element.offsetHeight ||
          element.getClientRects().length);
      }

      function backdropIndex() {
        var topBackdropIndex = -1;
        var opened = openedWindows.keys();
        for (var i = 0; i < opened.length; i++) {
          if (openedWindows.get(opened[i]).value.backdrop) {
            topBackdropIndex = i;
          }
        }

        // If any backdrop exist, ensure that it's index is always
        // right below the top modal
        if (topBackdropIndex > -1 && topBackdropIndex < topModalIndex) {
          topBackdropIndex = topModalIndex;
        }
        return topBackdropIndex;
      }

      $rootScope.$watch(backdropIndex, function(newBackdropIndex) {
        if (backdropScope) {
          backdropScope.index = newBackdropIndex;
        }
      });

      function removeModalWindow(modalInstance, elementToReceiveFocus) {
        var modalWindow = openedWindows.get(modalInstance).value;
        var appendToElement = modalWindow.appendTo;

        //clean up the stack
        openedWindows.remove(modalInstance);
        previousTopOpenedModal = openedWindows.top();
        if (previousTopOpenedModal) {
          topModalIndex = parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10);
        }

        removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function() {
          var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
          openedClasses.remove(modalBodyClass, modalInstance);
          var areAnyOpen = openedClasses.hasKey(modalBodyClass);
          appendToElement.toggleClass(modalBodyClass, areAnyOpen);
          if (!areAnyOpen && scrollbarPadding && scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            if (scrollbarPadding.originalRight) {
              appendToElement.css({paddingRight: scrollbarPadding.originalRight + 'px'});
            } else {
              appendToElement.css({paddingRight: ''});
            }
            scrollbarPadding = null;
          }
          toggleTopWindowClass(true);
        }, modalWindow.closedDeferred);
        checkRemoveBackdrop();

        //move focus to specified element if available, or else to body
        if (elementToReceiveFocus && elementToReceiveFocus.focus) {
          elementToReceiveFocus.focus();
        } else if (appendToElement.focus) {
          appendToElement.focus();
        }
      }

      // Add or remove "windowTopClass" from the top window in the stack
      function toggleTopWindowClass(toggleSwitch) {
        var modalWindow;

        if (openedWindows.length() > 0) {
          modalWindow = openedWindows.top().value;
          modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
        }
      }

      function checkRemoveBackdrop() {
        //remove backdrop if no longer needed
        if (backdropDomEl && backdropIndex() === -1) {
          var backdropScopeRef = backdropScope;
          removeAfterAnimate(backdropDomEl, backdropScope, function() {
            backdropScopeRef = null;
          });
          backdropDomEl = undefined;
          backdropScope = undefined;
        }
      }

      function removeAfterAnimate(domEl, scope, done, closedDeferred) {
        var asyncDeferred;
        var asyncPromise = null;
        var setIsAsync = function() {
          if (!asyncDeferred) {
            asyncDeferred = $q.defer();
            asyncPromise = asyncDeferred.promise;
          }

          return function asyncDone() {
            asyncDeferred.resolve();
          };
        };
        scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

        // Note that it's intentional that asyncPromise might be null.
        // That's when setIsAsync has not been called during the
        // NOW_CLOSING_EVENT broadcast.
        return $q.when(asyncPromise).then(afterAnimating);

        function afterAnimating() {
          if (afterAnimating.done) {
            return;
          }
          afterAnimating.done = true;

          $animate.leave(domEl).then(function() {
            domEl.remove();
            if (closedDeferred) {
              closedDeferred.resolve();
            }
          });

          scope.$destroy();
          if (done) {
            done();
          }
        }
      }

      $document.on('keydown', keydownListener);

      $rootScope.$on('$destroy', function() {
        $document.off('keydown', keydownListener);
      });

      function keydownListener(evt) {
        if (evt.isDefaultPrevented()) {
          return evt;
        }

        var modal = openedWindows.top();
        if (modal) {
          switch (evt.which) {
            case 27: {
              if (modal.value.keyboard) {
                evt.preventDefault();
                $rootScope.$apply(function() {
                  $modalStack.dismiss(modal.key, 'escape key press');
                });
              }
              break;
            }
            case 9: {
              var list = $modalStack.loadFocusElementList(modal);
              var focusChanged = false;
              if (evt.shiftKey) {
                if ($modalStack.isFocusInFirstItem(evt, list) || $modalStack.isModalFocused(evt, modal)) {
                  focusChanged = $modalStack.focusLastFocusableElement(list);
                }
              } else {
                if ($modalStack.isFocusInLastItem(evt, list)) {
                  focusChanged = $modalStack.focusFirstFocusableElement(list);
                }
              }

              if (focusChanged) {
                evt.preventDefault();
                evt.stopPropagation();
              }

              break;
            }
          }
        }
      }

      $modalStack.open = function(modalInstance, modal) {
        var modalOpener = $document[0].activeElement,
          modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;

        toggleTopWindowClass(false);

        // Store the current top first, to determine what index we ought to use
        // for the current top modal
        previousTopOpenedModal = openedWindows.top();

        openedWindows.add(modalInstance, {
          deferred: modal.deferred,
          renderDeferred: modal.renderDeferred,
          closedDeferred: modal.closedDeferred,
          modalScope: modal.scope,
          backdrop: modal.backdrop,
          keyboard: modal.keyboard,
          openedClass: modal.openedClass,
          windowTopClass: modal.windowTopClass,
          animation: modal.animation,
          appendTo: modal.appendTo
        });

        openedClasses.put(modalBodyClass, modalInstance);

        var appendToElement = modal.appendTo,
            currBackdropIndex = backdropIndex();

        if (!appendToElement.length) {
          throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
        }

        if (currBackdropIndex >= 0 && !backdropDomEl) {
          backdropScope = $rootScope.$new(true);
          backdropScope.modalOptions = modal;
          backdropScope.index = currBackdropIndex;
          backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
          backdropDomEl.attr('backdrop-class', modal.backdropClass);
          if (modal.animation) {
            backdropDomEl.attr('modal-animation', 'true');
          }
          $compile(backdropDomEl)(backdropScope);
          $animate.enter(backdropDomEl, appendToElement);
          scrollbarPadding = $uibPosition.scrollbarPadding(appendToElement);
          if (scrollbarPadding.heightOverflow && scrollbarPadding.scrollbarWidth) {
            appendToElement.css({paddingRight: scrollbarPadding.right + 'px'});
          }
        }

        // Set the top modal index based on the index of the previous top modal
        topModalIndex = previousTopOpenedModal ? parseInt(previousTopOpenedModal.value.modalDomEl.attr('index'), 10) + 1 : 0;
        var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
        angularDomEl.attr({
          'template-url': modal.windowTemplateUrl,
          'window-class': modal.windowClass,
          'window-top-class': modal.windowTopClass,
          'size': modal.size,
          'index': topModalIndex,
          'animate': 'animate'
        }).html(modal.content);
        if (modal.animation) {
          angularDomEl.attr('modal-animation', 'true');
        }

        appendToElement.addClass(modalBodyClass);
        $animate.enter($compile(angularDomEl)(modal.scope), appendToElement);

        openedWindows.top().value.modalDomEl = angularDomEl;
        openedWindows.top().value.modalOpener = modalOpener;
      };

      function broadcastClosing(modalWindow, resultOrReason, closing) {
        return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
      }

      $modalStack.close = function(modalInstance, result) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, result, true)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.resolve(result);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismiss = function(modalInstance, reason) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
          modalWindow.value.modalScope.$$uibDestructionScheduled = true;
          modalWindow.value.deferred.reject(reason);
          removeModalWindow(modalInstance, modalWindow.value.modalOpener);
          return true;
        }
        return !modalWindow;
      };

      $modalStack.dismissAll = function(reason) {
        var topModal = this.getTop();
        while (topModal && this.dismiss(topModal.key, reason)) {
          topModal = this.getTop();
        }
      };

      $modalStack.getTop = function() {
        return openedWindows.top();
      };

      $modalStack.modalRendered = function(modalInstance) {
        var modalWindow = openedWindows.get(modalInstance);
        if (modalWindow) {
          modalWindow.value.renderDeferred.resolve();
        }
      };

      $modalStack.focusFirstFocusableElement = function(list) {
        if (list.length > 0) {
          list[0].focus();
          return true;
        }
        return false;
      };

      $modalStack.focusLastFocusableElement = function(list) {
        if (list.length > 0) {
          list[list.length - 1].focus();
          return true;
        }
        return false;
      };

      $modalStack.isModalFocused = function(evt, modalWindow) {
        if (evt && modalWindow) {
          var modalDomEl = modalWindow.value.modalDomEl;
          if (modalDomEl && modalDomEl.length) {
            return (evt.target || evt.srcElement) === modalDomEl[0];
          }
        }
        return false;
      };

      $modalStack.isFocusInFirstItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[0];
        }
        return false;
      };

      $modalStack.isFocusInLastItem = function(evt, list) {
        if (list.length > 0) {
          return (evt.target || evt.srcElement) === list[list.length - 1];
        }
        return false;
      };

      $modalStack.loadFocusElementList = function(modalWindow) {
        if (modalWindow) {
          var modalDomE1 = modalWindow.value.modalDomEl;
          if (modalDomE1 && modalDomE1.length) {
            var elements = modalDomE1[0].querySelectorAll(tabableSelector);
            return elements ?
              Array.prototype.filter.call(elements, function(element) {
                return isVisible(element);
              }) : elements;
          }
        }
      };

      return $modalStack;
    }])

  .provider('$uibModal', function() {
    var $modalProvider = {
      options: {
        animation: true,
        backdrop: true, //can also be false or 'static'
        keyboard: true
      },
      $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack',
        function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
          var $modal = {};

          function getTemplatePromise(options) {
            return options.template ? $q.when(options.template) :
              $templateRequest(angular.isFunction(options.templateUrl) ?
                options.templateUrl() : options.templateUrl);
          }

          var promiseChain = null;
          $modal.getPromiseChain = function() {
            return promiseChain;
          };

          $modal.open = function(modalOptions) {
            var modalResultDeferred = $q.defer();
            var modalOpenedDeferred = $q.defer();
            var modalClosedDeferred = $q.defer();
            var modalRenderDeferred = $q.defer();

            //prepare an instance of a modal to be injected into controllers and returned to a caller
            var modalInstance = {
              result: modalResultDeferred.promise,
              opened: modalOpenedDeferred.promise,
              closed: modalClosedDeferred.promise,
              rendered: modalRenderDeferred.promise,
              close: function (result) {
                return $modalStack.close(modalInstance, result);
              },
              dismiss: function (reason) {
                return $modalStack.dismiss(modalInstance, reason);
              }
            };

            //merge and clean up options
            modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
            modalOptions.resolve = modalOptions.resolve || {};
            modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

            //verify options
            if (!modalOptions.template && !modalOptions.templateUrl) {
              throw new Error('One of template or templateUrl options is required.');
            }

            var templateAndResolvePromise =
              $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);

            function resolveWithTemplate() {
              return templateAndResolvePromise;
            }

            // Wait for the resolution of the existing promise chain.
            // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
            // Then add to $modalStack and resolve opened.
            // Finally clean up the chain variable if no subsequent modal has overwritten it.
            var samePromise;
            samePromise = promiseChain = $q.all([promiseChain])
              .then(resolveWithTemplate, resolveWithTemplate)
              .then(function resolveSuccess(tplAndVars) {
                var providedScope = modalOptions.scope || $rootScope;

                var modalScope = providedScope.$new();
                modalScope.$close = modalInstance.close;
                modalScope.$dismiss = modalInstance.dismiss;

                modalScope.$on('$destroy', function() {
                  if (!modalScope.$$uibDestructionScheduled) {
                    modalScope.$dismiss('$uibUnscheduledDestruction');
                  }
                });

                var ctrlInstance, ctrlInstantiate, ctrlLocals = {};

                //controllers
                if (modalOptions.controller) {
                  ctrlLocals.$scope = modalScope;
                  ctrlLocals.$uibModalInstance = modalInstance;
                  angular.forEach(tplAndVars[1], function(value, key) {
                    ctrlLocals[key] = value;
                  });

                  // the third param will make the controller instantiate later,private api
                  // @see https://github.com/angular/angular.js/blob/master/src/ng/controller.js#L126
                  ctrlInstantiate = $controller(modalOptions.controller, ctrlLocals, true);
                  if (modalOptions.controllerAs) {
                    ctrlInstance = ctrlInstantiate.instance;

                    if (modalOptions.bindToController) {
                      ctrlInstance.$close = modalScope.$close;
                      ctrlInstance.$dismiss = modalScope.$dismiss;
                      angular.extend(ctrlInstance, providedScope);
                    }

                    ctrlInstance = ctrlInstantiate();

                    modalScope[modalOptions.controllerAs] = ctrlInstance;
                  } else {
                    ctrlInstance = ctrlInstantiate();
                  }

                  if (angular.isFunction(ctrlInstance.$onInit)) {
                    ctrlInstance.$onInit();
                  }
                }

                $modalStack.open(modalInstance, {
                  scope: modalScope,
                  deferred: modalResultDeferred,
                  renderDeferred: modalRenderDeferred,
                  closedDeferred: modalClosedDeferred,
                  content: tplAndVars[0],
                  animation: modalOptions.animation,
                  backdrop: modalOptions.backdrop,
                  keyboard: modalOptions.keyboard,
                  backdropClass: modalOptions.backdropClass,
                  windowTopClass: modalOptions.windowTopClass,
                  windowClass: modalOptions.windowClass,
                  windowTemplateUrl: modalOptions.windowTemplateUrl,
                  size: modalOptions.size,
                  openedClass: modalOptions.openedClass,
                  appendTo: modalOptions.appendTo
                });
                modalOpenedDeferred.resolve(true);

            }, function resolveError(reason) {
              modalOpenedDeferred.reject(reason);
              modalResultDeferred.reject(reason);
            })['finally'](function() {
              if (promiseChain === samePromise) {
                promiseChain = null;
              }
            });

            return modalInstance;
          };

          return $modal;
        }
      ]
    };

    return $modalProvider;
  });

angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */
.factory('uibPaging', ['$parse', function($parse) {
  return {
    create: function(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = { $setViewValue: angular.noop }; // nullModelCtrl
      ctrl._watchers = [];

      ctrl.init = function(ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;

        ngModelCtrl.$render = function() {
          ctrl.render();
        };

        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($attrs.itemsPerPage, function(value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }

        $scope.$watch('totalItems', function(newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };

      ctrl.calculateTotalPages = function() {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };

      ctrl.render = function() {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };

      $scope.selectPage = function(page, evt) {
        if (evt) {
          evt.preventDefault();
        }

        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.getText = function(key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };

      $scope.noPrevious = function() {
        return $scope.page === 1;
      };

      $scope.noNext = function() {
        return $scope.page === $scope.totalPages;
      };

      ctrl.updatePage = function() {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };

      $scope.$on('$destroy', function() {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);

angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging'])

.controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function($scope, $attrs, uibPaging, uibPagerConfig) {
  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;

  uibPaging.create(this, $scope, $attrs);
}])

.constant('uibPagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
})

.directive('uibPager', ['uibPagerConfig', function(uibPagerConfig) {
  return {
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['uibPager', '?ngModel'],
    controller: 'UibPagerController',
    controllerAs: 'pager',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pager/pager.html';
    },
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
    }
  };
}]);

angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging'])
.controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers,
    pageLabel = angular.isDefined($attrs.pageLabel) ? function(idx) { return $scope.$parent.$eval($attrs.pageLabel, {$page: idx}); } : angular.identity;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;

  uibPaging.create(this, $scope, $attrs);

  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function(value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }

  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1, endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, pageLabel(number), number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) { //need ellipsis for all options unless range is too close to beginning
        var previousPageSet = makePage(startPage - 1, '...', false);
        pages.unshift(previousPageSet);
      }
        if (boundaryLinkNumbers) {
          if (startPage === 3) { //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }

      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) { //need ellipsis for all options unless range is too close to end
        var nextPageSet = makePage(endPage + 1, '...', false);
        pages.push(nextPageSet);
      }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) { //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }

  var originalRender = this.render;
  this.render = function() {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}])

.constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
})

.directive('uibPagination', ['$parse', 'uibPaginationConfig', function($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled:'='
    },
    require: ['uibPagination', '?ngModel'],
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (!ngModelCtrl) {
         return; // do nothing if no ng-model
      }

      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */
.provider('$uibTooltip', function() {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    placementClassPrefix: '',
    animation: true,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'outsideClick': 'outsideClick',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
	this.options = function(value) {
		angular.extend(globalOptions, value);
	};

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( { 'openTrigger': 'closeTrigger' } );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake_case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function(letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
    var openedTooltips = $$stackedMap.createNew();
    $document.on('keypress', keypressListener);

    $rootScope.$on('$destroy', function() {
      $document.off('keypress', keypressListener);
    });

    function keypressListener(e) {
      if (e.which === 27) {
        var last = openedTooltips.top();
        if (last) {
          last.value.close();
          openedTooltips.removeTop();
          last = null;
        }
      }
    }

    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function(trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }

      var directiveName = snake_case(ttType);

      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template =
        '<div '+ directiveName + '-popup ' +
          'uib-title="' + startSym + 'title' + endSym + '" ' +
          (options.useContentExp ?
            'content-exp="contentExp()" ' :
            'content="' + startSym + 'content' + endSym + '" ') +
          'placement="' + startSym + 'placement' + endSym + '" ' +
          'popup-class="' + startSym + 'popupClass' + endSym + '" ' +
          'animation="animation" ' +
          'is-open="isOpen" ' +
          'origin-scope="origScope" ' +
          'class="uib-position-measure"' +
          '>' +
        '</div>';

      return {
        compile: function(tElem, tAttrs) {
          var tooltipLinker = $compile(template);

          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var showTimeout;
            var hideTimeout;
            var positionTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
            var observers = [];
            var lastPlacement;

            var positionTooltip = function() {
              // check if tooltip exists and is not empty
              if (!tooltip || !tooltip.html()) { return; }

              if (!positionTimeout) {
                positionTimeout = $timeout(function() {
                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  tooltip.css({ top: ttPosition.top + 'px', left: ttPosition.left + 'px' });

                  if (!tooltip.hasClass(ttPosition.placement.split('-')[0])) {
                    tooltip.removeClass(lastPlacement.split('-')[0]);
                    tooltip.addClass(ttPosition.placement.split('-')[0]);
                  }

                  if (!tooltip.hasClass(options.placementClassPrefix + ttPosition.placement)) {
                    tooltip.removeClass(options.placementClassPrefix + lastPlacement);
                    tooltip.addClass(options.placementClassPrefix + ttPosition.placement);
                  }

                  // first time through tt element will have the
                  // uib-position-measure class or if the placement
                  // has changed we need to position the arrow.
                  if (tooltip.hasClass('uib-position-measure')) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                    tooltip.removeClass('uib-position-measure');
                  } else if (lastPlacement !== ttPosition.placement) {
                    $position.positionArrow(tooltip, ttPosition.placement);
                  }
                  lastPlacement = ttPosition.placement;

                  positionTimeout = null;
                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;
            openedTooltips.add(ttScope, {
              close: hide
            });

            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }

              cancelHide();
              prepareTooltip();

              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!showTimeout) {
                  showTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }

            function hideTooltipBind() {
              cancelShow();

              if (ttScope.popupCloseDelay) {
                if (!hideTimeout) {
                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                }
              } else {
                hide();
              }
            }

            // Show the tooltip popup element.
            function show() {
              cancelShow();
              cancelHide();

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }

              createTooltip();

              // And show the tooltip.
              ttScope.$evalAsync(function() {
                ttScope.isOpen = true;
                assignIsOpen(true);
                positionTooltip();
              });
            }

            function cancelShow() {
              if (showTimeout) {
                $timeout.cancel(showTimeout);
                showTimeout = null;
              }

              if (positionTimeout) {
                $timeout.cancel(positionTimeout);
                positionTimeout = null;
              }
            }

            // Hide the tooltip popup element.
            function hide() {
              if (!ttScope) {
                return;
              }

              // First things first: we don't show it anymore.
              ttScope.$evalAsync(function() {
                if (ttScope) {
                  ttScope.isOpen = false;
                  assignIsOpen(false);
                  // And now we remove it from the DOM. However, if we have animation, we
                  // need to wait for it to expire beforehand.
                  // FIXME: this is a placeholder for a port of the transitions library.
                  // The fade transition in TWBS is 150ms.
                  if (ttScope.animation) {
                    if (!transitionTimeout) {
                      transitionTimeout = $timeout(removeTooltip, 150, false);
                    }
                  } else {
                    removeTooltip();
                  }
                }
              });
            }

            function cancelHide() {
              if (hideTimeout) {
                $timeout.cancel(hideTimeout);
                hideTimeout = null;
              }

              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }
            }

            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                return;
              }

              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function(tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });

              prepObservers();
            }

            function removeTooltip() {
              cancelShow();
              cancelHide();
              unregisterObservers();

              if (tooltip) {
                tooltip.remove();
                tooltip = null;
              }
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            /**
             * Set the initial scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in sync.
             */
            function prepareTooltip() {
              ttScope.title = attrs[prefix + 'Title'];
              if (contentParse) {
                ttScope.content = contentParse(scope);
              } else {
                ttScope.content = attrs[ttType];
              }

              ttScope.popupClass = attrs[prefix + 'Class'];
              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
              var placement = $position.parsePlacement(ttScope.placement);
              lastPlacement = placement[1] ? placement[0] + '-' + placement[1] : placement[0];

              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
            }

            function assignIsOpen(isOpen) {
              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                isOpenParse.assign(scope, isOpen);
              }
            }

            ttScope.contentExp = function() {
              return ttScope.content;
            };

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe('disabled', function(val) {
              if (val) {
                cancelShow();
              }

              if (val && ttScope.isOpen) {
                hide();
              }
            });

            if (isOpenParse) {
              scope.$watch(isOpenParse, function(val) {
                if (ttScope && !val === ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }

            function prepObservers() {
              observers.length = 0;

              if (contentParse) {
                observers.push(
                  scope.$watch(contentParse, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    }
                  })
                );

                observers.push(
                  tooltipLinkedScope.$watch(function() {
                    if (!repositionScheduled) {
                      repositionScheduled = true;
                      tooltipLinkedScope.$$postDigest(function() {
                        repositionScheduled = false;
                        if (ttScope && ttScope.isOpen) {
                          positionTooltip();
                        }
                      });
                    }
                  })
                );
              } else {
                observers.push(
                  attrs.$observe(ttType, function(val) {
                    ttScope.content = val;
                    if (!val && ttScope.isOpen) {
                      hide();
                    } else {
                      positionTooltip();
                    }
                  })
                );
              }

              observers.push(
                attrs.$observe(prefix + 'Title', function(val) {
                  ttScope.title = val;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );

              observers.push(
                attrs.$observe(prefix + 'Placement', function(val) {
                  ttScope.placement = val ? val : options.placement;
                  if (ttScope.isOpen) {
                    positionTooltip();
                  }
                })
              );
            }

            function unregisterObservers() {
              if (observers.length) {
                angular.forEach(observers, function(observer) {
                  observer();
                });
                observers.length = 0;
              }
            }

            // hide tooltips/popovers for outsideClick trigger
            function bodyHideTooltipBind(e) {
              if (!ttScope || !ttScope.isOpen || !tooltip) {
                return;
              }
              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                hideTooltipBind();
              }
            }

            var unregisterTriggers = function() {
              triggers.show.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  element.off('click', toggleTooltipBind);
                } else {
                  element.off(trigger, showTooltipBind);
                  element.off(trigger, toggleTooltipBind);
                }
              });
              triggers.hide.forEach(function(trigger) {
                if (trigger === 'outsideClick') {
                  $document.off('click', bodyHideTooltipBind);
                } else {
                  element.off(trigger, hideTooltipBind);
                }
              });
            };

            function prepTriggers() {
              var val = attrs[prefix + 'Trigger'];
              unregisterTriggers();

              triggers = getTriggers(val);

              if (triggers.show !== 'none') {
                triggers.show.forEach(function(trigger, idx) {
                  if (trigger === 'outsideClick') {
                    element.on('click', toggleTooltipBind);
                    $document.on('click', bodyHideTooltipBind);
                  } else if (trigger === triggers.hide[idx]) {
                    element.on(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element.on(trigger, showTooltipBind);
                    element.on(triggers.hide[idx], hideTooltipBind);
                  }

                  element.on('keypress', function(e) {
                    if (e.which === 27) {
                      hideTooltipBind();
                    }
                  });
                });
              }
            }

            prepTriggers();

            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;

            var appendToBodyVal;
            var appendKey = prefix + 'AppendToBody';
            if (appendKey in attrs && attrs[appendKey] === undefined) {
              appendToBodyVal = true;
            } else {
              appendToBodyVal = scope.$eval(attrs[appendKey]);
            }

            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              unregisterTriggers();
              removeTooltip();
              openedTooltips.remove(ttScope);
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('uibTooltipTemplateTransclude', [
         '$animate', '$sce', '$compile', '$templateRequest',
function ($animate, $sce, $compile, $templateRequest) {
  return {
    link: function(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);

      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;

      var cleanupLastIncludeContent = function() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }

        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }

        if (currentElement) {
          $animate.leave(currentElement).then(function() {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };

      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function(src) {
        var thisChangeId = ++changeCounter;

        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function(response) {
            if (thisChangeId !== changeCounter) { return; }
            var newScope = origScope.$new();
            var template = response;

            var clone = $compile(template)(newScope, function(clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });

            currentScope = newScope;
            currentElement = clone;

            currentScope.$emit('$includeContentLoaded', src);
          }, function() {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });

      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */
.directive('uibTooltipClasses', ['$uibPosition', function($uibPosition) {
  return {
    restrict: 'A',
    link: function(scope, element, attrs) {
      // need to set the primary position so the
      // arrow has space during position measure.
      // tooltip.positionTooltip()
      if (scope.placement) {
        // // There are no top-left etc... classes
        // // in TWBS, so we need the primary position.
        var position = $uibPosition.parsePlacement(scope.placement);
        element.addClass(position[0]);
      }

      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }

      if (scope.animation()) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
}])

.directive('uibTooltipPopup', function() {
  return {
    replace: true,
    scope: { content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
  };
})

.directive('uibTooltip', [ '$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
}])

.directive('uibTooltipTemplatePopup', function() {
  return {
    replace: true,
    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
      originScope: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
  };
})

.directive('uibTooltipTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}])

.directive('uibTooltipHtmlPopup', function() {
  return {
    replace: true,
    scope: { contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
})

.directive('uibTooltipHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip'])

.directive('uibPopoverTemplatePopup', function() {
  return {
    replace: true,
    scope: { uibTitle: '@', contentExp: '&', placement: '@', popupClass: '@', animation: '&', isOpen: '&',
      originScope: '&' },
    templateUrl: 'uib/template/popover/popover-template.html'
  };
})

.directive('uibPopoverTemplate', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverHtmlPopup', function() {
  return {
    replace: true,
    scope: { contentExp: '&', uibTitle: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
    templateUrl: 'uib/template/popover/popover-html.html'
  };
})

.directive('uibPopoverHtml', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}])

.directive('uibPopoverPopup', function() {
  return {
    replace: true,
    scope: { uibTitle: '@', content: '@', placement: '@', popupClass: '@', animation: '&', isOpen: '&' },
    templateUrl: 'uib/template/popover/popover.html'
  };
})

.directive('uibPopover', ['$uibTooltip', function($uibTooltip) {
  return $uibTooltip('uibPopover', 'popover', 'click');
}]);

angular.module('ui.bootstrap.progressbar', [])

.constant('uibProgressConfig', {
  animate: true,
  max: 100
})

.controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function($scope, $attrs, progressConfig) {
  var self = this,
      animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;

  this.bars = [];
  $scope.max = getMaxOrDefault();

  this.addBar = function(bar, element, attrs) {
    if (!animate) {
      element.css({'transition': 'none'});
    }

    this.bars.push(bar);

    bar.max = getMaxOrDefault();
    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';

    bar.$watch('value', function(value) {
      bar.recalculatePercentage();
    });

    bar.recalculatePercentage = function() {
      var totalPercentage = self.bars.reduce(function(total, bar) {
        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
        return total + bar.percent;
      }, 0);

      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };

    bar.$on('$destroy', function() {
      element = null;
      self.removeBar(bar);
    });
  };

  this.removeBar = function(bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
    this.bars.forEach(function (bar) {
      bar.recalculatePercentage();
    });
  };

  //$attrs.$observe('maxParam', function(maxParam) {
  $scope.$watch('maxParam', function(maxParam) {
    self.bars.forEach(function(bar) {
      bar.max = getMaxOrDefault();
      bar.recalculatePercentage();
    });
  });

  function getMaxOrDefault () {
    return angular.isDefined($scope.maxParam) ? $scope.maxParam : progressConfig.max;
  }
}])

.directive('uibProgress', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    require: 'uibProgress',
    scope: {
      maxParam: '=?max'
    },
    templateUrl: 'uib/template/progressbar/progress.html'
  };
})

.directive('uibBar', function() {
  return {
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/bar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element, attrs);
    }
  };
})

.directive('uibProgressbar', function() {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    scope: {
      value: '=',
      maxParam: '=?max',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/progressbar.html',
    link: function(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]), {title: attrs.title});
    }
  };
});

angular.module('ui.bootstrap.rating', [])

.constant('uibRatingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  enableReset: true,
  titles : ['one', 'two', 'three', 'four', 'five']
})

.controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function($scope, $attrs, ratingConfig) {
  var ngModelCtrl = { $setViewValue: angular.noop },
    self = this;

  this.init = function(ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.push(function(value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }

      return value;
    });

    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    this.enableReset = angular.isDefined($attrs.enableReset) ?
      $scope.$parent.$eval($attrs.enableReset) : ratingConfig.enableReset;
    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ?
      tmpTitles : ratingConfig.titles;

    var ratingStates = angular.isDefined($attrs.ratingStates) ?
      $scope.$parent.$eval($attrs.ratingStates) :
      new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };

  this.buildTemplateObjects = function(states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({ index: i }, { stateOn: this.stateOn, stateOff: this.stateOff, title: this.getTitle(i) }, states[i]);
    }
    return states;
  };

  this.getTitle = function(index) {
    if (index >= this.titles.length) {
      return index + 1;
    }

    return this.titles[index];
  };

  $scope.rate = function(value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      var newViewValue = self.enableReset && ngModelCtrl.$viewValue === value ? 0 : value;
      ngModelCtrl.$setViewValue(newViewValue);
      ngModelCtrl.$render();
    }
  };

  $scope.enter = function(value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({value: value});
  };

  $scope.reset = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };

  $scope.onKeydown = function(evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };

  this.render = function() {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.title = self.getTitle($scope.value - 1);
  };
}])

.directive('uibRating', function() {
  return {
    require: ['uibRating', 'ngModel'],
    scope: {
      readonly: '=?readOnly',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'UibRatingController',
    templateUrl: 'uib/template/rating/rating.html',
    replace: true,
    link: function(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0], ngModelCtrl = ctrls[1];
      ratingCtrl.init(ngModelCtrl);
    }
  };
});

angular.module('ui.bootstrap.tabs', [])

.controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
    oldIndex;
  ctrl.tabs = [];

  ctrl.select = function(index, evt) {
    if (!destroyed) {
      var previousIndex = findTabIndex(oldIndex);
      var previousSelected = ctrl.tabs[previousIndex];
      if (previousSelected) {
        previousSelected.tab.onDeselect({
          $event: evt
        });
        if (evt && evt.isDefaultPrevented()) {
          return;
        }
        previousSelected.tab.active = false;
      }

      var selected = ctrl.tabs[index];
      if (selected) {
        selected.tab.onSelect({
          $event: evt
        });
        selected.tab.active = true;
        ctrl.active = selected.index;
        oldIndex = selected.index;
      } else if (!selected && angular.isNumber(oldIndex)) {
        ctrl.active = null;
        oldIndex = null;
      }
    }
  };

  ctrl.addTab = function addTab(tab) {
    ctrl.tabs.push({
      tab: tab,
      index: tab.index
    });
    ctrl.tabs.sort(function(t1, t2) {
      if (t1.index > t2.index) {
        return 1;
      }

      if (t1.index < t2.index) {
        return -1;
      }

      return 0;
    });

    if (tab.index === ctrl.active || !angular.isNumber(ctrl.active) && ctrl.tabs.length === 1) {
      var newActiveIndex = findTabIndex(tab.index);
      ctrl.select(newActiveIndex);
    }
  };

  ctrl.removeTab = function removeTab(tab) {
    var index;
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].tab === tab) {
        index = i;
        break;
      }
    }

    if (ctrl.tabs[index].index === ctrl.active) {
      var newActiveTabIndex = index === ctrl.tabs.length - 1 ?
        index - 1 : index + 1 % ctrl.tabs.length;
      ctrl.select(newActiveTabIndex);
    }

    ctrl.tabs.splice(index, 1);
  };

  $scope.$watch('tabset.active', function(val) {
    if (angular.isNumber(val) && val !== oldIndex) {
      ctrl.select(findTabIndex(val));
    }
  });

  var destroyed;
  $scope.$on('$destroy', function() {
    destroyed = true;
  });

  function findTabIndex(index) {
    for (var i = 0; i < ctrl.tabs.length; i++) {
      if (ctrl.tabs[i].index === index) {
        return i;
      }
    }
  }
}])

.directive('uibTabset', function() {
  return {
    transclude: true,
    replace: true,
    scope: {},
    bindToController: {
      active: '=?',
      type: '@'
    },
    controller: 'UibTabsetController',
    controllerAs: 'tabset',
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tabset.html';
    },
    link: function(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ?
        scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ?
        scope.$parent.$eval(attrs.justified) : false;
      if (angular.isUndefined(attrs.active)) {
        scope.active = 0;
      }
    }
  };
})

.directive('uibTab', ['$parse', function($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || 'uib/template/tabs/tab.html';
    },
    transclude: true,
    scope: {
      heading: '@',
      index: '=?',
      classes: '@?',
      onSelect: '&select', //This callback is called in contentHeadingTransclude
                          //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function(value) {
          scope.disabled = !! value;
        });
      }

      if (angular.isUndefined(attrs.index)) {
        if (tabsetCtrl.tabs && tabsetCtrl.tabs.length) {
          scope.index = Math.max.apply(null, tabsetCtrl.tabs.map(function(t) { return t.index; })) + 1;
        } else {
          scope.index = 0;
        }
      }

      if (angular.isUndefined(attrs.classes)) {
        scope.classes = '';
      }

      scope.select = function(evt) {
        if (!scope.disabled) {
          var index;
          for (var i = 0; i < tabsetCtrl.tabs.length; i++) {
            if (tabsetCtrl.tabs[i].tab === scope) {
              index = i;
              break;
            }
          }

          tabsetCtrl.select(index, evt);
        }
      };

      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function() {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}])

.directive('uibTabHeadingTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
})

.directive('uibTabContentTransclude', function() {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude).tab;

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function(contents) {
        angular.forEach(contents, function(node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };

  function isTabHeading(node) {
    return node.tagName && (
      node.hasAttribute('uib-tab-heading') ||
      node.hasAttribute('data-uib-tab-heading') ||
      node.hasAttribute('x-uib-tab-heading') ||
      node.tagName.toLowerCase() === 'uib-tab-heading' ||
      node.tagName.toLowerCase() === 'data-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'x-uib-tab-heading' ||
      node.tagName.toLowerCase() === 'uib:tab-heading'
    );
  }
});

angular.module('ui.bootstrap.timepicker', [])

.constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
})

.controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var selected = new Date(),
    watchers = [],
    ngModelCtrl = { $setViewValue: angular.noop }, // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS,
    padHours = angular.isDefined($attrs.padHours) ? $scope.$parent.$eval($attrs.padHours) : true;

  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');

  this.init = function(ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;

    ngModelCtrl.$formatters.unshift(function(modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });

    var hoursInputEl = inputs.eq(0),
        minutesInputEl = inputs.eq(1),
        secondsInputEl = inputs.eq(2);

    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;

    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }

    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };

  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function(value) {
      hourStep = +value;
    }));
  }

  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function(value) {
      minuteStep = +value;
    }));
  }

  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function(value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));

  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function(value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));

  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function(value) {
      disabled = value;
    }));
  }

  $scope.noIncrementHours = function() {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementHours = function() {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementMinutes = function() {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementMinutes = function() {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noIncrementSeconds = function() {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max ||
      incrementedSelected < selected && incrementedSelected < min;
  };

  $scope.noDecrementSeconds = function() {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min ||
      decrementedSelected > selected && decrementedSelected > max;
  };

  $scope.noToggleMeridian = function() {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }

    return disabled || addMinutes(selected, -12 * 60) < min;
  };

  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function(value) {
      secondStep = +value;
    }));
  }

  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function(value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function(value) {
      $scope.showMeridian = !!value;

      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(), minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 :
      hours >= 0 && hours < 24;
    if (!valid || $scope.hours === '') {
      return undefined;
    }

    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }

  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    var valid = minutes >= 0 && minutes < 60;
    if (!valid || $scope.minutes === '') {
      return undefined;
    }
    return minutes;
  }

  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }

  function pad(value, noPad) {
    if (value === null) {
      return '';
    }

    return angular.isDefined(value) && value.toString().length < 2 && !noPad ?
      '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };

    hoursInputEl.bind('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });

    minutesInputEl.bind('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });

     secondsInputEl.bind('mousewheel wheel', function(e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.bind('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });

    minutesInputEl.bind('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });

    secondsInputEl.bind('keydown', function(e) {
      if (!disabled) {
        if (e.which === 38) { // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) { // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };

  this.setupInputEvents = function(hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }

    var invalidate = function(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
      }

      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
      }

      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
      }
    };

    $scope.updateHours = function() {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };

    hoursInputEl.bind('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function() {
          $scope.hours = pad($scope.hours, !padHours);
        });
      }
    });

    $scope.updateMinutes = function() {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };

    minutesInputEl.bind('blur', function(e) {
      ngModelCtrl.$setTouched();
      if (modelIsEmpty()) {
        makeValid();
      } else if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function() {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });

    $scope.updateSeconds = function() {
      var seconds = getSecondsFromTemplate();

      ngModelCtrl.$setDirty();

      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };

    secondsInputEl.bind('blur', function(e) {
      if (modelIsEmpty()) {
        makeValid();
      } else if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply( function() {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });

  };

  this.render = function() {
    var date = ngModelCtrl.$viewValue;

    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }

      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }

  function makeValid() {
    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }

  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
        minutes = selected.getMinutes(),
        seconds = selected.getSeconds();

      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }

      $scope.hours = keyboardChange === 'h' ? hours : pad(hours, !padHours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];

      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }

  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }

  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes*60);
  }

  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }

  function modelIsEmpty() {
    return ($scope.hours === null || $scope.hours === '') &&
      ($scope.minutes === null || $scope.minutes === '') &&
      (!$scope.showSeconds || $scope.showSeconds && ($scope.seconds === null || $scope.seconds === ''));
  }

  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ?
    $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;

  $scope.incrementHours = function() {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };

  $scope.decrementHours = function() {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };

  $scope.incrementMinutes = function() {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };

  $scope.decrementMinutes = function() {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };

  $scope.incrementSeconds = function() {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };

  $scope.decrementSeconds = function() {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };

  $scope.toggleMeridian = function() {
    var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();

    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };

  $scope.blur = function() {
    ngModelCtrl.$setTouched();
  };

  $scope.$on('$destroy', function() {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}])

.directive('uibTimepicker', ['uibTimepickerConfig', function(uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    replace: true,
    scope: {},
    templateUrl: function(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0], ngModelCtrl = ctrls[1];

      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);

angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */
  .factory('uibTypeaheadParser', ['$parse', function($parse) {
    //                      00000111000000000000022200000000000000003333333333333330000000000044000
    var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
    return {
      parse: function(input) {
        var match = input.match(TYPEAHEAD_REGEXP);
        if (!match) {
          throw new Error(
            'Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' +
              ' but got "' + input + '".');
        }

        return {
          itemName: match[3],
          source: $parse(match[4]),
          viewMapper: $parse(match[2] || match[1]),
          modelMapper: $parse(match[1])
        };
      }
    };
  }])

  .controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser',
    function(originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
    var HOT_KEYS = [9, 13, 27, 38, 40];
    var eventDebounceTime = 200;
    var modelCtrl, ngModelOptions;
    //SUPPORTED ATTRIBUTES (OPTIONS)

    //minimal no of characters that needs to be entered before typeahead kicks-in
    var minLength = originalScope.$eval(attrs.typeaheadMinLength);
    if (!minLength && minLength !== 0) {
      minLength = 1;
    }

    originalScope.$watch(attrs.typeaheadMinLength, function (newVal) {
        minLength = !newVal && newVal !== 0 ? 1 : newVal;
    });

    //minimal wait time after last character typed before typeahead kicks-in
    var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

    //should it restrict model values to the ones selected from the popup only?
    var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
    originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
      isEditable = newVal !== false;
    });

    //binding to a variable that indicates if matches are being retrieved asynchronously
    var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

    //a callback executed when a match is selected
    var onSelectCallback = $parse(attrs.typeaheadOnSelect);

    //should it select highlighted popup value when losing focus?
    var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

    //binding to a variable that indicates if there were no results after the query is completed
    var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;

    var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;

    var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;

    var appendTo = attrs.typeaheadAppendTo ?
      originalScope.$eval(attrs.typeaheadAppendTo) : null;

    var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

    //If input matches an item of the list exactly, select it automatically
    var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

    //binding to a variable that indicates if dropdown is open
    var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;

    var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

    //INTERNAL VARIABLES

    //model setter executed upon match selection
    var parsedModel = $parse(attrs.ngModel);
    var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
    var $setModelValue = function(scope, newValue) {
      if (angular.isFunction(parsedModel(originalScope)) &&
        ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
        return invokeModelSetter(scope, {$$$p: newValue});
      }

      return parsedModel.assign(scope, newValue);
    };

    //expressions used by typeahead
    var parserResult = typeaheadParser.parse(attrs.uibTypeahead);

    var hasFocus;

    //Used to avoid bug in iOS webview where iOS keyboard does not fire
    //mousedown & mouseup events
    //Issue #3699
    var selected;

    //create a child scope for the typeahead directive so we are not polluting original scope
    //with typeahead-specific data (matches, query etc.)
    var scope = originalScope.$new();
    var offDestroy = originalScope.$on('$destroy', function() {
      scope.$destroy();
    });
    scope.$on('$destroy', offDestroy);

    // WAI-ARIA
    var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
    element.attr({
      'aria-autocomplete': 'list',
      'aria-expanded': false,
      'aria-owns': popupId
    });

    var inputsContainer, hintInputElem;
    //add read-only input to show hint
    if (showHint) {
      inputsContainer = angular.element('<div></div>');
      inputsContainer.css('position', 'relative');
      element.after(inputsContainer);
      hintInputElem = element.clone();
      hintInputElem.attr('placeholder', '');
      hintInputElem.attr('tabindex', '-1');
      hintInputElem.val('');
      hintInputElem.css({
        'position': 'absolute',
        'top': '0px',
        'left': '0px',
        'border-color': 'transparent',
        'box-shadow': 'none',
        'opacity': 1,
        'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
        'color': '#999'
      });
      element.css({
        'position': 'relative',
        'vertical-align': 'top',
        'background-color': 'transparent'
      });
      inputsContainer.append(hintInputElem);
      hintInputElem.after(element);
    }

    //pop-up element used to display matches
    var popUpEl = angular.element('<div uib-typeahead-popup></div>');
    popUpEl.attr({
      id: popupId,
      matches: 'matches',
      active: 'activeIdx',
      select: 'select(activeIdx, evt)',
      'move-in-progress': 'moveInProgress',
      query: 'query',
      position: 'position',
      'assign-is-open': 'assignIsOpen(isOpen)',
      debounce: 'debounceUpdate'
    });
    //custom item template
    if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
      popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
    }

    if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
      popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
    }

    var resetHint = function() {
      if (showHint) {
        hintInputElem.val('');
      }
    };

    var resetMatches = function() {
      scope.matches = [];
      scope.activeIdx = -1;
      element.attr('aria-expanded', false);
      resetHint();
    };

    var getMatchId = function(index) {
      return popupId + '-option-' + index;
    };

    // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
    // This attribute is added or removed automatically when the `activeIdx` changes.
    scope.$watch('activeIdx', function(index) {
      if (index < 0) {
        element.removeAttr('aria-activedescendant');
      } else {
        element.attr('aria-activedescendant', getMatchId(index));
      }
    });

    var inputIsExactMatch = function(inputValue, index) {
      if (scope.matches.length > index && inputValue) {
        return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
      }

      return false;
    };

    var getMatchesAsync = function(inputValue, evt) {
      var locals = {$viewValue: inputValue};
      isLoadingSetter(originalScope, true);
      isNoResultsSetter(originalScope, false);
      $q.when(parserResult.source(originalScope, locals)).then(function(matches) {
        //it might happen that several async queries were in progress if a user were typing fast
        //but we are interested only in responses that correspond to the current view value
        var onCurrentRequest = inputValue === modelCtrl.$viewValue;
        if (onCurrentRequest && hasFocus) {
          if (matches && matches.length > 0) {
            scope.activeIdx = focusFirst ? 0 : -1;
            isNoResultsSetter(originalScope, false);
            scope.matches.length = 0;

            //transform labels
            for (var i = 0; i < matches.length; i++) {
              locals[parserResult.itemName] = matches[i];
              scope.matches.push({
                id: getMatchId(i),
                label: parserResult.viewMapper(scope, locals),
                model: matches[i]
              });
            }

            scope.query = inputValue;
            //position pop-up with matches - we need to re-calculate its position each time we are opening a window
            //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
            //due to other elements being rendered
            recalculatePosition();

            element.attr('aria-expanded', true);

            //Select the single remaining option if user input matches
            if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
              if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
                $$debounce(function() {
                  scope.select(0, evt);
                }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
              } else {
                scope.select(0, evt);
              }
            }

            if (showHint) {
              var firstLabel = scope.matches[0].label;
              if (angular.isString(inputValue) &&
                inputValue.length > 0 &&
                firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
                hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
              } else {
                hintInputElem.val('');
              }
            }
          } else {
            resetMatches();
            isNoResultsSetter(originalScope, true);
          }
        }
        if (onCurrentRequest) {
          isLoadingSetter(originalScope, false);
        }
      }, function() {
        resetMatches();
        isLoadingSetter(originalScope, false);
        isNoResultsSetter(originalScope, true);
      });
    };

    // bind events only if appendToBody params exist - performance feature
    if (appendToBody) {
      angular.element($window).on('resize', fireRecalculating);
      $document.find('body').on('scroll', fireRecalculating);
    }

    // Declare the debounced function outside recalculating for
    // proper debouncing
    var debouncedRecalculate = $$debounce(function() {
      // if popup is visible
      if (scope.matches.length) {
        recalculatePosition();
      }

      scope.moveInProgress = false;
    }, eventDebounceTime);

    // Default progress type
    scope.moveInProgress = false;

    function fireRecalculating() {
      if (!scope.moveInProgress) {
        scope.moveInProgress = true;
        scope.$digest();
      }

      debouncedRecalculate();
    }

    // recalculate actual position and set new values to scope
    // after digest loop is popup in right position
    function recalculatePosition() {
      scope.position = appendToBody ? $position.offset(element) : $position.position(element);
      scope.position.top += element.prop('offsetHeight');
    }

    //we need to propagate user's query so we can higlight matches
    scope.query = undefined;

    //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
    var timeoutPromise;

    var scheduleSearchWithTimeout = function(inputValue) {
      timeoutPromise = $timeout(function() {
        getMatchesAsync(inputValue);
      }, waitTime);
    };

    var cancelPreviousTimeout = function() {
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
    };

    resetMatches();

    scope.assignIsOpen = function (isOpen) {
      isOpenSetter(originalScope, isOpen);
    };

    scope.select = function(activeIdx, evt) {
      //called from within the $digest() cycle
      var locals = {};
      var model, item;

      selected = true;
      locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
      model = parserResult.modelMapper(originalScope, locals);
      $setModelValue(originalScope, model);
      modelCtrl.$setValidity('editable', true);
      modelCtrl.$setValidity('parse', true);

      onSelectCallback(originalScope, {
        $item: item,
        $model: model,
        $label: parserResult.viewMapper(originalScope, locals),
        $event: evt
      });

      resetMatches();

      //return focus to the input element if a match was selected via a mouse click event
      // use timeout to avoid $rootScope:inprog error
      if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
        $timeout(function() { element[0].focus(); }, 0, false);
      }
    };

    //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
    element.on('keydown', function(evt) {
      //typeahead is open and an "interesting" key was pressed
      if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
        return;
      }

      /**
       * if there's nothing selected (i.e. focusFirst) and enter or tab is hit
       * or
       * shift + tab is pressed to bring focus to the previous element
       * then clear the results
       */
      if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13) || evt.which === 9 && !!evt.shiftKey) {
        resetMatches();
        scope.$digest();
        return;
      }

      evt.preventDefault();
      var target;
      switch (evt.which) {
        case 9:
        case 13:
          scope.$apply(function () {
            if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
              $$debounce(function() {
                scope.select(scope.activeIdx, evt);
              }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
            } else {
              scope.select(scope.activeIdx, evt);
            }
          });
          break;
        case 27:
          evt.stopPropagation();

          resetMatches();
          originalScope.$digest();
          break;
        case 38:
          scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
          scope.$digest();
          target = popUpEl.find('li')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
        case 40:
          scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
          scope.$digest();
          target = popUpEl.find('li')[scope.activeIdx];
          target.parentNode.scrollTop = target.offsetTop;
          break;
      }
    });

    element.bind('focus', function (evt) {
      hasFocus = true;
      if (minLength === 0 && !modelCtrl.$viewValue) {
        $timeout(function() {
          getMatchesAsync(modelCtrl.$viewValue, evt);
        }, 0);
      }
    });

    element.bind('blur', function(evt) {
      if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
        selected = true;
        scope.$apply(function() {
          if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
            $$debounce(function() {
              scope.select(scope.activeIdx, evt);
            }, scope.debounceUpdate.blur);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
      }
      if (!isEditable && modelCtrl.$error.editable) {
        modelCtrl.$setViewValue();
        // Reset validity as we are clearing
        modelCtrl.$setValidity('editable', true);
        modelCtrl.$setValidity('parse', true);
        element.val('');
      }
      hasFocus = false;
      selected = false;
    });

    // Keep reference to click handler to unbind it.
    var dismissClickHandler = function(evt) {
      // Issue #3973
      // Firefox treats right click as a click on document
      if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
        resetMatches();
        if (!$rootScope.$$phase) {
          originalScope.$digest();
        }
      }
    };

    $document.on('click', dismissClickHandler);

    originalScope.$on('$destroy', function() {
      $document.off('click', dismissClickHandler);
      if (appendToBody || appendTo) {
        $popup.remove();
      }

      if (appendToBody) {
        angular.element($window).off('resize', fireRecalculating);
        $document.find('body').off('scroll', fireRecalculating);
      }
      // Prevent jQuery cache memory leak
      popUpEl.remove();

      if (showHint) {
          inputsContainer.remove();
      }
    });

    var $popup = $compile(popUpEl)(scope);

    if (appendToBody) {
      $document.find('body').append($popup);
    } else if (appendTo) {
      angular.element(appendTo).eq(0).append($popup);
    } else {
      element.after($popup);
    }

    this.init = function(_modelCtrl, _ngModelOptions) {
      modelCtrl = _modelCtrl;
      ngModelOptions = _ngModelOptions;

      scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);

      //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
      //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
      modelCtrl.$parsers.unshift(function(inputValue) {
        hasFocus = true;

        if (minLength === 0 || inputValue && inputValue.length >= minLength) {
          if (waitTime > 0) {
            cancelPreviousTimeout();
            scheduleSearchWithTimeout(inputValue);
          } else {
            getMatchesAsync(inputValue);
          }
        } else {
          isLoadingSetter(originalScope, false);
          cancelPreviousTimeout();
          resetMatches();
        }

        if (isEditable) {
          return inputValue;
        }

        if (!inputValue) {
          // Reset in case user had typed something previously.
          modelCtrl.$setValidity('editable', true);
          return null;
        }

        modelCtrl.$setValidity('editable', false);
        return undefined;
      });

      modelCtrl.$formatters.push(function(modelValue) {
        var candidateViewValue, emptyViewValue;
        var locals = {};

        // The validity may be set to false via $parsers (see above) if
        // the model is restricted to selected values. If the model
        // is set manually it is considered to be valid.
        if (!isEditable) {
          modelCtrl.$setValidity('editable', true);
        }

        if (inputFormatter) {
          locals.$model = modelValue;
          return inputFormatter(originalScope, locals);
        }

        //it might happen that we don't have enough info to properly render input value
        //we need to check for this situation and simply return model value if we can't apply custom formatting
        locals[parserResult.itemName] = modelValue;
        candidateViewValue = parserResult.viewMapper(originalScope, locals);
        locals[parserResult.itemName] = undefined;
        emptyViewValue = parserResult.viewMapper(originalScope, locals);

        return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
      });
    };
  }])

  .directive('uibTypeahead', function() {
    return {
      controller: 'UibTypeaheadController',
      require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
      link: function(originalScope, element, attrs, ctrls) {
        ctrls[2].init(ctrls[0], ctrls[1]);
      }
    };
  })

  .directive('uibTypeaheadPopup', ['$$debounce', function($$debounce) {
    return {
      scope: {
        matches: '=',
        query: '=',
        active: '=',
        position: '&',
        moveInProgress: '=',
        select: '&',
        assignIsOpen: '&',
        debounce: '&'
      },
      replace: true,
      templateUrl: function(element, attrs) {
        return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
      },
      link: function(scope, element, attrs) {
        scope.templateUrl = attrs.templateUrl;

        scope.isOpen = function() {
          var isDropdownOpen = scope.matches.length > 0;
          scope.assignIsOpen({ isOpen: isDropdownOpen });
          return isDropdownOpen;
        };

        scope.isActive = function(matchIdx) {
          return scope.active === matchIdx;
        };

        scope.selectActive = function(matchIdx) {
          scope.active = matchIdx;
        };

        scope.selectMatch = function(activeIdx, evt) {
          var debounce = scope.debounce();
          if (angular.isNumber(debounce) || angular.isObject(debounce)) {
            $$debounce(function() {
              scope.select({activeIdx: activeIdx, evt: evt});
            }, angular.isNumber(debounce) ? debounce : debounce['default']);
          } else {
            scope.select({activeIdx: activeIdx, evt: evt});
          }
        };
      }
    };
  }])

  .directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function($templateRequest, $compile, $parse) {
    return {
      scope: {
        index: '=',
        match: '=',
        query: '='
      },
      link: function(scope, element, attrs) {
        var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
        $templateRequest(tplUrl).then(function(tplContent) {
          var tplEl = angular.element(tplContent.trim());
          element.replaceWith(tplEl);
          $compile(tplEl)(scope);
        });
      }
    };
  }])

  .filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function($sce, $injector, $log) {
    var isSanitizePresent;
    isSanitizePresent = $injector.has('$sanitize');

    function escapeRegexp(queryToEscape) {
      // Regex: capture the whole query string and replace it with the string that will be used to match
      // the results, for example if the capture is "a" the result will be \a
      return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
    }

    function containsHtml(matchItem) {
      return /<.*>/g.test(matchItem);
    }

    return function(matchItem, query) {
      if (!isSanitizePresent && containsHtml(matchItem)) {
        $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
      }
      matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
      if (!isSanitizePresent) {
        matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
      }
      return matchItem;
    };
  }]);

angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion-group.html",
    "<div class=\"panel\" ng-class=\"panelClass || 'panel-default'\">\n" +
    "  <div role=\"tab\" id=\"{{::headingId}}\" aria-selected=\"{{isOpen}}\" class=\"panel-heading\" ng-keypress=\"toggleOpen($event)\">\n" +
    "    <h4 class=\"panel-title\">\n" +
    "      <a role=\"button\" data-toggle=\"collapse\" href aria-expanded=\"{{isOpen}}\" aria-controls=\"{{::panelId}}\" tabindex=\"0\" class=\"accordion-toggle\" ng-click=\"toggleOpen()\" uib-accordion-transclude=\"heading\"><span uib-accordion-header ng-class=\"{'text-muted': isDisabled}\">{{heading}}</span></a>\n" +
    "    </h4>\n" +
    "  </div>\n" +
    "  <div id=\"{{::panelId}}\" aria-labelledby=\"{{::headingId}}\" aria-hidden=\"{{!isOpen}}\" role=\"tabpanel\" class=\"panel-collapse collapse\" uib-collapse=\"!isOpen\">\n" +
    "    <div class=\"panel-body\" ng-transclude></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/accordion/accordion.html",
    "<div role=\"tablist\" class=\"panel-group\" ng-transclude></div>");
}]);

angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/alert/alert.html",
    "<div class=\"alert\" ng-class=\"['alert-' + (type || 'warning'), closeable ? 'alert-dismissible' : null]\" role=\"alert\">\n" +
    "    <button ng-show=\"closeable\" type=\"button\" class=\"close\" ng-click=\"close({$event: $event})\">\n" +
    "        <span aria-hidden=\"true\">&times;</span>\n" +
    "        <span class=\"sr-only\">Close</span>\n" +
    "    </button>\n" +
    "    <div ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/carousel.html",
    "<div ng-mouseenter=\"pause()\" ng-mouseleave=\"play()\" class=\"carousel\" ng-swipe-right=\"prev()\" ng-swipe-left=\"next()\">\n" +
    "  <div class=\"carousel-inner\" ng-transclude></div>\n" +
    "  <a role=\"button\" href class=\"left carousel-control\" ng-click=\"prev()\" ng-class=\"{ disabled: isPrevDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-left\"></span>\n" +
    "    <span class=\"sr-only\">previous</span>\n" +
    "  </a>\n" +
    "  <a role=\"button\" href class=\"right carousel-control\" ng-click=\"next()\" ng-class=\"{ disabled: isNextDisabled() }\" ng-show=\"slides.length > 1\">\n" +
    "    <span aria-hidden=\"true\" class=\"glyphicon glyphicon-chevron-right\"></span>\n" +
    "    <span class=\"sr-only\">next</span>\n" +
    "  </a>\n" +
    "  <ol class=\"carousel-indicators\" ng-show=\"slides.length > 1\">\n" +
    "    <li ng-repeat=\"slide in slides | orderBy:indexOfSlide track by $index\" ng-class=\"{ active: isActive(slide) }\" ng-click=\"select(slide)\">\n" +
    "      <span class=\"sr-only\">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if=\"isActive(slide)\">, currently active</span></span>\n" +
    "    </li>\n" +
    "  </ol>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/carousel/slide.html",
    "<div ng-class=\"{\n" +
    "    'active': active\n" +
    "  }\" class=\"item text-center\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/datepicker.html",
    "<div class=\"uib-datepicker\" ng-switch=\"datepickerMode\" role=\"application\" ng-keydown=\"keydown($event)\">\n" +
    "  <uib-daypicker ng-switch-when=\"day\" tabindex=\"0\"></uib-daypicker>\n" +
    "  <uib-monthpicker ng-switch-when=\"month\" tabindex=\"0\"></uib-monthpicker>\n" +
    "  <uib-yearpicker ng-switch-when=\"year\" tabindex=\"0\"></uib-yearpicker>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/day.html",
    "<table class=\"uib-daypicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::5 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <th ng-if=\"showWeeks\" class=\"text-center\"></th>\n" +
    "      <th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-weeks\" ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td>\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-day text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default btn-sm\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-muted': dt.secondary, 'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/month.html",
    "<table class=\"uib-monthpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-months\" ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-month text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepicker/year.html",
    "<table class=\"uib-yearpicker\" role=\"grid\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\">\n" +
    "  <thead>\n" +
    "    <tr>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-left uib-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button></th>\n" +
    "      <th colspan=\"{{::columns - 2}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm uib-title\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\"><strong>{{title}}</strong></button></th>\n" +
    "      <th><button type=\"button\" class=\"btn btn-default btn-sm pull-right uib-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button></th>\n" +
    "    </tr>\n" +
    "  </thead>\n" +
    "  <tbody>\n" +
    "    <tr class=\"uib-years\" ng-repeat=\"row in rows track by $index\">\n" +
    "      <td ng-repeat=\"dt in row\" class=\"uib-year text-center\" role=\"gridcell\"\n" +
    "        id=\"{{::dt.uid}}\"\n" +
    "        ng-class=\"::dt.customClass\">\n" +
    "        <button type=\"button\" class=\"btn btn-default\"\n" +
    "          uib-is-class=\"\n" +
    "            'btn-info' for selectedDt,\n" +
    "            'active' for activeDt\n" +
    "            on dt\"\n" +
    "          ng-click=\"select(dt.date)\"\n" +
    "          ng-disabled=\"::dt.disabled\"\n" +
    "          tabindex=\"-1\"><span ng-class=\"::{'text-info': dt.current}\">{{::dt.label}}</span></button>\n" +
    "      </td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/datepickerPopup/popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/datepickerPopup/popup.html",
    "<div>\n" +
    "  <ul class=\"uib-datepicker-popup dropdown-menu uib-position-measure\" dropdown-nested ng-if=\"isOpen\" ng-keydown=\"keydown($event)\" ng-click=\"$event.stopPropagation()\">\n" +
    "    <li ng-transclude></li>\n" +
    "    <li ng-if=\"showButtonBar\" class=\"uib-button-bar\">\n" +
    "      <span class=\"btn-group pull-left\">\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-info uib-datepicker-current\" ng-click=\"select('today', $event)\" ng-disabled=\"isDisabled('today')\">{{ getText('current') }}</button>\n" +
    "        <button type=\"button\" class=\"btn btn-sm btn-danger uib-clear\" ng-click=\"select(null, $event)\">{{ getText('clear') }}</button>\n" +
    "      </span>\n" +
    "      <button type=\"button\" class=\"btn btn-sm btn-success pull-right uib-close\" ng-click=\"close($event)\">{{ getText('close') }}</button>\n" +
    "    </li>\n" +
    "  </ul>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/modal/backdrop.html",
    "<div class=\"modal-backdrop\"\n" +
    "     uib-modal-animation-class=\"fade\"\n" +
    "     modal-in-class=\"in\"\n" +
    "     ng-style=\"{'z-index': 1040 + (index && 1 || 0) + index*10}\"\n" +
    "></div>\n" +
    "");
}]);

angular.module("uib/template/modal/window.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/modal/window.html",
    "<div modal-render=\"{{$isRendered}}\" tabindex=\"-1\" role=\"dialog\" class=\"modal\"\n" +
    "    uib-modal-animation-class=\"fade\"\n" +
    "    modal-in-class=\"in\"\n" +
    "    ng-style=\"{'z-index': 1050 + index*10, display: 'block'}\">\n" +
    "    <div class=\"modal-dialog {{size ? 'modal-' + size : ''}}\"><div class=\"modal-content\" uib-modal-transclude></div></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pager/pager.html",
    "<ul class=\"pager\">\n" +
    "  <li ng-class=\"{disabled: noPrevious()||ngDisabled, previous: align}\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
    "  <li ng-class=\"{disabled: noNext()||ngDisabled, next: align}\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/pagination/pagination.html",
    "<ul class=\"pagination\">\n" +
    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-first\"><a href ng-click=\"selectPage(1, $event)\">{{::getText('first')}}</a></li>\n" +
    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"pagination-prev\"><a href ng-click=\"selectPage(page - 1, $event)\">{{::getText('previous')}}</a></li>\n" +
    "  <li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"pagination-page\"><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li>\n" +
    "  <li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-next\"><a href ng-click=\"selectPage(page + 1, $event)\">{{::getText('next')}}</a></li>\n" +
    "  <li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"pagination-last\"><a href ng-click=\"selectPage(totalPages, $event)\">{{::getText('last')}}</a></li>\n" +
    "</ul>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-html-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" ng-bind-html=\"contentExp()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\" ng-bind=\"content\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tooltip/tooltip-template-popup.html",
    "<div class=\"tooltip\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"tooltip-arrow\"></div>\n" +
    "  <div class=\"tooltip-inner\"\n" +
    "    uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "    tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-html.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "      <div class=\"popover-content\" ng-bind-html=\"contentExp()\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover-template.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "      <div class=\"popover-content\"\n" +
    "        uib-tooltip-template-transclude=\"contentExp()\"\n" +
    "        tooltip-template-transclude-scope=\"originScope()\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/popover/popover.html",
    "<div class=\"popover\"\n" +
    "  tooltip-animation-class=\"fade\"\n" +
    "  uib-tooltip-classes\n" +
    "  ng-class=\"{ in: isOpen() }\">\n" +
    "  <div class=\"arrow\"></div>\n" +
    "\n" +
    "  <div class=\"popover-inner\">\n" +
    "      <h3 class=\"popover-title\" ng-bind=\"uibTitle\" ng-if=\"uibTitle\"></h3>\n" +
    "      <div class=\"popover-content\" ng-bind=\"content\"></div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/bar.html",
    "<div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "");
}]);

angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progress.html",
    "<div class=\"progress\" ng-transclude aria-labelledby=\"{{::title}}\"></div>");
}]);

angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/progressbar/progressbar.html",
    "<div class=\"progress\">\n" +
    "  <div class=\"progress-bar\" ng-class=\"type && 'progress-bar-' + type\" role=\"progressbar\" aria-valuenow=\"{{value}}\" aria-valuemin=\"0\" aria-valuemax=\"{{max}}\" ng-style=\"{width: (percent < 100 ? percent : 100) + '%'}\" aria-valuetext=\"{{percent | number:0}}%\" aria-labelledby=\"{{::title}}\" ng-transclude></div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/rating/rating.html",
    "<span ng-mouseleave=\"reset()\" ng-keydown=\"onKeydown($event)\" tabindex=\"0\" role=\"slider\" aria-valuemin=\"0\" aria-valuemax=\"{{range.length}}\" aria-valuenow=\"{{value}}\" aria-valuetext=\"{{title}}\">\n" +
    "    <span ng-repeat-start=\"r in range track by $index\" class=\"sr-only\">({{ $index < value ? '*' : ' ' }})</span>\n" +
    "    <i ng-repeat-end ng-mouseenter=\"enter($index + 1)\" ng-click=\"rate($index + 1)\" class=\"glyphicon\" ng-class=\"$index < value && (r.stateOn || 'glyphicon-star') || (r.stateOff || 'glyphicon-star-empty')\" ng-attr-title=\"{{r.title}}\"></i>\n" +
    "</span>\n" +
    "");
}]);

angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tab.html",
    "<li ng-class=\"[{active: active, disabled: disabled}, classes]\" class=\"uib-tab nav-item\">\n" +
    "  <a href ng-click=\"select($event)\" class=\"nav-link\" uib-tab-heading-transclude>{{heading}}</a>\n" +
    "</li>\n" +
    "");
}]);

angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/tabs/tabset.html",
    "<div>\n" +
    "  <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul>\n" +
    "  <div class=\"tab-content\">\n" +
    "    <div class=\"tab-pane\"\n" +
    "         ng-repeat=\"tab in tabset.tabs\"\n" +
    "         ng-class=\"{active: tabset.active === tab.index}\"\n" +
    "         uib-tab-content-transclude=\"tab\">\n" +
    "    </div>\n" +
    "  </div>\n" +
    "</div>\n" +
    "");
}]);

angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/timepicker/timepicker.html",
    "<table class=\"uib-timepicker\">\n" +
    "  <tbody>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-increment hours\"><a ng-click=\"incrementHours()\" ng-class=\"{disabled: noIncrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-increment minutes\"><a ng-click=\"incrementMinutes()\" ng-class=\"{disabled: noIncrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-increment seconds\"><a ng-click=\"incrementSeconds()\" ng-class=\"{disabled: noIncrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noIncrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-up\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "    <tr>\n" +
    "      <td class=\"form-group uib-time hours\" ng-class=\"{'has-error': invalidHours}\">\n" +
    "        <input type=\"text\" placeholder=\"HH\" ng-model=\"hours\" ng-change=\"updateHours()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementHours()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time minutes\" ng-class=\"{'has-error': invalidMinutes}\">\n" +
    "        <input type=\"text\" placeholder=\"MM\" ng-model=\"minutes\" ng-change=\"updateMinutes()\" class=\"form-control text-center\" ng-readonly=\"::readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementMinutes()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-separator\">:</td>\n" +
    "      <td class=\"form-group uib-time seconds\" ng-class=\"{'has-error': invalidSeconds}\" ng-show=\"showSeconds\">\n" +
    "        <input type=\"text\" placeholder=\"SS\" ng-model=\"seconds\" ng-change=\"updateSeconds()\" class=\"form-control text-center\" ng-readonly=\"readonlyInput\" maxlength=\"2\" tabindex=\"{{::tabindex}}\" ng-disabled=\"noIncrementSeconds()\" ng-blur=\"blur()\">\n" +
    "      </td>\n" +
    "      <td ng-show=\"showMeridian\" class=\"uib-time am-pm\"><button type=\"button\" ng-class=\"{disabled: noToggleMeridian()}\" class=\"btn btn-default text-center\" ng-click=\"toggleMeridian()\" ng-disabled=\"noToggleMeridian()\" tabindex=\"{{::tabindex}}\">{{meridian}}</button></td>\n" +
    "    </tr>\n" +
    "    <tr class=\"text-center\" ng-show=\"::showSpinners\">\n" +
    "      <td class=\"uib-decrement hours\"><a ng-click=\"decrementHours()\" ng-class=\"{disabled: noDecrementHours()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementHours()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td>&nbsp;</td>\n" +
    "      <td class=\"uib-decrement minutes\"><a ng-click=\"decrementMinutes()\" ng-class=\"{disabled: noDecrementMinutes()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementMinutes()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showSeconds\">&nbsp;</td>\n" +
    "      <td ng-show=\"showSeconds\" class=\"uib-decrement seconds\"><a ng-click=\"decrementSeconds()\" ng-class=\"{disabled: noDecrementSeconds()}\" class=\"btn btn-link\" ng-disabled=\"noDecrementSeconds()\" tabindex=\"{{::tabindex}}\"><span class=\"glyphicon glyphicon-chevron-down\"></span></a></td>\n" +
    "      <td ng-show=\"showMeridian\"></td>\n" +
    "    </tr>\n" +
    "  </tbody>\n" +
    "</table>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-match.html",
    "<a href\n" +
    "   tabindex=\"-1\"\n" +
    "   ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"\n" +
    "   ng-attr-title=\"{{match.label}}\"></a>\n" +
    "");
}]);

angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function($templateCache) {
  $templateCache.put("uib/template/typeahead/typeahead-popup.html",
    "<ul class=\"dropdown-menu\" ng-show=\"isOpen() && !moveInProgress\" ng-style=\"{top: position().top+'px', left: position().left+'px'}\" role=\"listbox\" aria-hidden=\"{{!isOpen()}}\">\n" +
    "    <li ng-repeat=\"match in matches track by $index\" ng-class=\"{active: isActive($index) }\" ng-mouseenter=\"selectActive($index)\" ng-click=\"selectMatch($index, $event)\" role=\"option\" id=\"{{::match.id}}\">\n" +
    "        <div uib-typeahead-match index=\"$index\" match=\"match\" query=\"query\" template-url=\"templateUrl\"></div>\n" +
    "    </li>\n" +
    "</ul>\n" +
    "");
}]);
angular.module('ui.bootstrap.carousel').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibCarouselCss && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>'); angular.$$uibCarouselCss = true; });
angular.module('ui.bootstrap.datepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-left,.uib-right{width:100%}</style>'); angular.$$uibDatepickerCss = true; });
angular.module('ui.bootstrap.position').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibPositionCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-position-measure{display:block !important;visibility:hidden !important;position:absolute !important;top:-9999px !important;left:-9999px !important;}.uib-position-scrollbar-measure{position:absolute !important;top:-9999px !important;width:50px !important;height:50px !important;overflow:scroll !important;}.uib-position-body-scrollbar-measure{overflow:scroll !important;}</style>'); angular.$$uibPositionCss = true; });
angular.module('ui.bootstrap.datepickerPopup').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibDatepickerpopupCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker-popup.dropdown-menu{display:block;float:none;margin:0;}.uib-button-bar{padding:10px 9px 2px;}</style>'); angular.$$uibDatepickerpopupCss = true; });
angular.module('ui.bootstrap.tooltip').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTooltipCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-tooltip-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-html-popup].tooltip.right-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.top-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-left > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.bottom-right > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.left-bottom > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-top > .tooltip-arrow,[uib-tooltip-template-popup].tooltip.right-bottom > .tooltip-arrow,[uib-popover-popup].popover.top-left > .arrow,[uib-popover-popup].popover.top-right > .arrow,[uib-popover-popup].popover.bottom-left > .arrow,[uib-popover-popup].popover.bottom-right > .arrow,[uib-popover-popup].popover.left-top > .arrow,[uib-popover-popup].popover.left-bottom > .arrow,[uib-popover-popup].popover.right-top > .arrow,[uib-popover-popup].popover.right-bottom > .arrow,[uib-popover-html-popup].popover.top-left > .arrow,[uib-popover-html-popup].popover.top-right > .arrow,[uib-popover-html-popup].popover.bottom-left > .arrow,[uib-popover-html-popup].popover.bottom-right > .arrow,[uib-popover-html-popup].popover.left-top > .arrow,[uib-popover-html-popup].popover.left-bottom > .arrow,[uib-popover-html-popup].popover.right-top > .arrow,[uib-popover-html-popup].popover.right-bottom > .arrow,[uib-popover-template-popup].popover.top-left > .arrow,[uib-popover-template-popup].popover.top-right > .arrow,[uib-popover-template-popup].popover.bottom-left > .arrow,[uib-popover-template-popup].popover.bottom-right > .arrow,[uib-popover-template-popup].popover.left-top > .arrow,[uib-popover-template-popup].popover.left-bottom > .arrow,[uib-popover-template-popup].popover.right-top > .arrow,[uib-popover-template-popup].popover.right-bottom > .arrow{top:auto;bottom:auto;left:auto;right:auto;margin:0;}[uib-popover-popup].popover,[uib-popover-html-popup].popover,[uib-popover-template-popup].popover{display:block !important;}</style>'); angular.$$uibTooltipCss = true; });
angular.module('ui.bootstrap.timepicker').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTimepickerCss && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>'); angular.$$uibTimepickerCss = true; });
angular.module('ui.bootstrap.typeahead').run(function() {!angular.$$csp().noInlineStyle && !angular.$$uibTypeaheadCss && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>'); angular.$$uibTypeaheadCss = true; });

(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('totalMoneyByDaysChart', totalMoneyByDaysChartDirective)
    .controller('totalMoneyByDaysChartController', totalMoneyByDaysChartController);

  /** @ngInject */
  function totalMoneyByDaysChartDirective($timeout) {
    return {
      restrict: 'E',
      scope: {
        data: '='
      },
      templateUrl: 'app/components/totalMoneyByDaysChart/totalMoneyByDaysChart.html',
      controller: 'totalMoneyByDaysChartController',
      controllerAs: 'vm',
      link: function (scope) {
        $timeout(function () {
          scope.vm.refresh(scope.data);
          scope.$watch('data', function (newValue) {
            scope.vm.refresh(newValue);
          });
        }, 100)
      }
    };
  }

  /** @ngInject */
  function totalMoneyByDaysChartController($scope) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'totalMoneyByDaysChart';
    vm.refresh = refreshChart;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function refreshChart(data) {
        var groupColumnName = 'date',
        rowsData = [];

      if (data === null) {
        return;
      }

      rowsData = [[groupColumnName].concat(data.facilities)];

      data.dates.forEach(function (item) {
        rowsData.push([item.date].concat(item.values));
      });

      vm.chart === null
        ? createChart(vm.chartElementId, groupColumnName, rowsData)
        : updateChart(groupColumnName, rowsData);

    }

    function createChart(chartElementId, groupColumnName, rowsData) {
      vm.chart = c3.generate({
        bindto: '#' + chartElementId,
        data: {
          x: groupColumnName,
          rows: rowsData
        },
        subchart: {
          show: true
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              format: '%Y-%m-%d'
            }
          }
        }
      });
    }

    function updateChart(groupColumnName, rowsData) {
      vm.chart.load({
        data: {
          x: groupColumnName,
          rows: rowsData
        },
        subchart: {
          show: true
        },
        axis: {
          x: {
            type: 'timeseries',
            tick: {
              format: '%Y-%m-%d'
            }
          }
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('schemaUtils', schemaUtilsService);

  /** @ngInject */
  function schemaUtilsService () {
    this.COLORS = Object.freeze({
      working: 'green',
      notWorking: 'gray',
      error: 'red',
      highFloatWorking : 'gray',
      highFloatNotWorking : 'green'
    });
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").component("multiplyItemsSelector", {
    templateUrl:
      "app/components/multiplyItemsSelector/multiplyItemsSelector.html",
    controller: multiplyItemsSelectorController,
    bindings: {
      list: "<",
      enableSelector: "<",
      clearSiteTextInput: "<",
      placeHolderText: '<',
      selectedItem: "<",
      disableSelector: "<",
      selectedList: "&",
      validateInput: "&"
    },
    controllerAs: "vm"
  });

  function multiplyItemsSelectorController($translate, $scope, $element) {
    var vm = this;

    vm.searchTerm = "";
    vm.selectedItem = "";
    $element.find("input").on("keydown", function (ev) {
      ev.stopPropagation();
    });

    vm.$onInit = function () {};

    vm.$onChanges = function (changes) {
      if (changes.list) {
        vm.datas = changes.list.currentValue;
        if(changes.list.currentValue.length === 0) {
          vm.validateInput({valid: true});
        }
      }
      if (changes.clearSiteTextInput) {
        if (changes.clearSiteTextInput.currentValue === "") {
          vm.selectedItem = "";
          vm.searchTerm = "";
          vm.validateInput({valid: true});
        } else {
          vm.validateInput({valid: false});
        }
      }
    };

    vm.$onDestroy = function () {};
  }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('loader',  loaderInject);

  /** @ngInject */
  function loaderInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/loader/loader.html',
      controller: LoaderController,
      controllerAs: 'vm',
      scope : {},
      replace: true,
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function LoaderController() {

    }
  }

})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('lineChart', lineChartDirective)
    .controller('lineChartController', lineChartController);

  /** @ngInject */
  function lineChartDirective($timeout) {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        leftPadding: '<',
        chartId: '@',
        subChart: '=?',
        chartDataName: '='
      },
      templateUrl: 'app/components/lineChart/lineChart.html',
      controller: 'lineChartController',
      controllerAs: 'vm',
      link: function (scope, element) {
        scope.vm.chartElementId += scope.chartId; // += scope.index;
        scope.vm.showSubChart = scope.subChart ? scope.subChart : false;
        scope.vm.xAxisOptions = scope.options.x ? scope.options.x : {};
        scope.vm.chartType = scope.options.chartType
          ? scope.options.chartType
          : 'line';
        scope.vm.rotated = scope.options.rotated
          ? scope.options.rotated
          : false;
        scope.vm.leftPadding = scope.leftPadding
          ? parseInt(scope.leftPadding)
          : 70;
        scope.vm.chartDataName = scope.chartDataName
          ? scope.chartDataName
          : null;
        angular
          .element(element.find('.lineChartContainer'))
          .attr('id', scope.vm.chartElementId);
        $timeout(function () {
          scope.vm.refresh(scope.options.data);
          scope.$watch('options.data', function (newValue) {
            scope.vm.refresh(newValue);
          });
        }, 100);
      }
    };
  }

  /** @ngInject */
  function lineChartController($scope, $translate, $filter, brand) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'lineChart';
    vm.refresh = refreshChart;
    vm.showSubChart = false;
    vm.xAxisOptions = {};
    vm.chartType = 'line';
    vm.rotated = false;
    vm.leftPadding = 70;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function refreshChart(data) {
      var groupColumnName = 'x',
        rowsData = [];

      if (!data) {
        return;
      }

      if (data.groupNames) {
        rowsData = [
          [groupColumnName].concat(filterWhiteSpaceNames(data.groupNames))
        ];

        data.groupsData.forEach(function (item) {
          rowsData.push([item.groupValue].concat(item.values));
        });
      } else {
        rowsData = [
          [groupColumnName].concat($translate.instant($scope.chartDataName))
        ];

        data.forEach(function (item) {
          rowsData.push([item.date].concat(item.count));
        });
      }

      var temp = vm.chartDataName ? vm.chartDataName : data.unit;
      createChart(groupColumnName, rowsData, temp);
    }

    function createChart(groupColumnName, rowsData, unit) {
      vm.chart = c3.generate({
        bindto: '#' + vm.chartElementId,
        data: {
          x: groupColumnName,
          rows: rowsData,
          type: vm.chartType
        },
        subchart: {
          show: vm.showSubChart,
          size: {
            height: 20
          }
        },
        axis: {
          rotated: vm.rotated,
          x: vm.xAxisOptions,
          y: {
            label: {
              text: '(' + $translate.instant(unit) + ')'
            },
            tick: {
              format: function (d) {
                var int = 0;
                var check = d - Math.floor(d) !== 0;
                if (check) {
                  int = 2;
                }
                return d.toFixed(int);
              }
            }
          }
        },
        padding: {
          top: 10,
          right: 50,
          bottom: 10,
          left: vm.leftPadding
        },
        size: {
          height: 360
        },
        transition: {
          duration: 0
        }
      });
    }

    function filterWhiteSpaceNames(array) {
      return array.map(function (item) {
        // Check for Karcher custom program naming and remove special characters
        return $translate.instant(
          $filter('removews')($filter('karcherCustomTranslation')(item)),
          { brand: brand }
        );
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('MyAccountViewModel', myAccountViewModelFactory);

  /** @ngInject */
  function myAccountViewModelFactory (sessionData) {
    function MyAccountViewModel () {
        var data = sessionData.getAll();
        this.username = data.username;
        this.firstName = data.firstName;
        this.lastName = data.lastName;
        this.userRole = (data.userRole.constructor === Array) ? data.userRole : data.userRole.split(',');
        this.oldPassword  = '';
        this.newPassword = '';
        this.newPasswordRepeat = '';
        this.newsLetter = (data.receiveEmailNotifications.toString() === 'true');

      init.call(this);
    }

    MyAccountViewModel.prototype.destroy = function () {
    };

    return MyAccountViewModel;

    function init () {

    }

  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("HeaderAlarmsViewModel", headerAlarmsViewModelFactory);

  /** @ngInject */
  function headerAlarmsViewModelFactory(messagesStore, MessageTypeEnum) {
    function HeaderAlarmsViewModel() {
      this.alarms = [];
      this._messagesStoreChangeHandler = null;
      this._messagesStoreChangeKarcherHandler = null;

      init.call(this);
    }

    HeaderAlarmsViewModel.prototype.destroy = function() {
      messagesStore.off(
        messagesStore.events.CHANGE,
        this._messagesStoreChangeHandler
      );
    };

    return HeaderAlarmsViewModel;

    function init() {
      var that = this;

      refresh.call(that);

      this._messagesStoreChangeHandler = function() {
        refresh.call(that);
      };

      messagesStore.on(
        messagesStore.events.CHANGE,
        this._messagesStoreChangeHandler
      );
    }

    function refresh() {
      var that = this;
      var messagesData = messagesStore.getMessages();
      that.alarms = [];
      if (messagesData !== null) {
        messagesData.forEach(function(message) {
          if (message.collapseKey === MessageTypeEnum.ALARM) {
            that.alarms.push({
              deviceSerial: message.device,
              message: message.content,
              time: moment(message.timestamp).fromNow(),
              location: message.details
            });
          }
        });
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").directive("layoutHeader", headerInject);

  /** @ngInject */
  function headerInject($window) {
    var directive = {
      restrict: "E",
      templateUrl: "app/components/header/header.html",
      controller: HeaderController,
      controllerAs: "vm",
      scope: {},
      replace: true,
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function HeaderController(
      $scope,
      $mdSidenav,
      $state,
      $log,
      sessionData,
      HeaderAlarmsViewModel,
      MyAccountViewModel,
      $mdDialog,
      $mdMenu,
      $translate,
      deviceActions,
      messageActions,
      userActions,
      webSocketsStore,
      broker,
      version,
      brand,
      checkUserRole
    ) {
      var vm = this,
        _webSocketStoreConnectedChangeHandler = subscribeToSocket,
        _onMessageAvailableHandler = refreshAlarms;

      vm.notifications = 5;
      vm.version = version;
      vm.brand = brand;

      vm.openMobileMenu = buildToggler("left");

      vm.alarmsViewModel = new HeaderAlarmsViewModel();
      vm.myAccount = new MyAccountViewModel();

      vm.gotoHelp = function () {
        switch (brand) {
          case "karcher":
            $window.open("https://www.kaercher.com/", "_blank");
            break;
          default:
            $state.go("app.help");
            break;
        }
      };

      vm.goTermsAndServices = function (marker) {
        $state.go("app.termsAndService", { marker: marker });
      };

      vm.closeMobileMenu = function () {
        $mdSidenav("left").close();
      };

      vm.doLogout = function (ev) {
        // open confirmation dialog
        var confirm = $mdDialog
          .confirm()
          .title($translate.instant("LOGOUT_TITLE"))
          .textContent($translate.instant("LOGOUT_MSG"))
          .ariaLabel("logout confirmation dialog")
          .targetEvent(ev)
          .ok($translate.instant("SIGN_OUT"))
          .cancel($translate.instant("CANCEL"));
        $mdDialog.show(confirm).then(
          function () {
            // after success do logout
            sessionData.clearAll();
            if (broker.isConnected()) {
              broker.unsubscribeSocket();
              broker.disconnectSockets();
            }
            $state.go("login");
          },
          function () {
            $scope.status = "You decided to keep login.";
          }
        );
      };

      vm.openMenu = function ($mdMenu, ev) {
        $mdMenu.open(ev);
      };

      vm.showAdvanced = function (ev) {
        $mdDialog.show({
          controller: modalController,
          controllerAs: "vm",
          bindToController: true,
          templateUrl: "app/components/header/headerMyAccountModalView.html",
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          clickOutsideToClose: true
        });
        $mdMenu.hide();
      };

      // MODAL VIEW CONTROLLER ==================================================================================
      // TO-DO move to separate file
      function modalController($mdDialog, userActions) {
        var that = this;

        // set initial values
        that.username = vm.myAccount.username;
        that.firstName = vm.myAccount.firstName;
        that.lastName = vm.myAccount.lastName;
        that.userRole = vm.myAccount.userRole;
        that.oldPassword = vm.myAccount.oldPassword;
        that.newPassword = vm.myAccount.newPassword;
        that.newPasswordRepeat = vm.myAccount.newPasswordRepeat;
        that.passwordIdentical = false;
        that.passwordNotMatch = false;
        that.newsLetter = vm.myAccount.newsLetter;

        that.checkPasswordChangeRequest = function () {
          return (
            that.oldPassword !== "" &&
            that.newPassword !== "" &&
            that.newPasswordRepeat !== ""
          );
        };

        // on each input change call updateInfo method to validate
        that.updateInfo = function (param, form) {
          var myAccountForm = form;
          switch (param) {
            case "new_password":
              that.passwordIdentical =
                myAccountForm.oldPassword.$viewValue ===
                myAccountForm.newPassword.$viewValue;
              if (
                that.passwordIdentical &&
                myAccountForm.oldPassword.$viewValue !== "" &&
                myAccountForm.newPassword.$viewValue !== ""
              ) {
                myAccountForm.newPassword.$setValidity("prop", false);
              } else {
                myAccountForm.newPassword.$setValidity("prop", true);
              }
              that.passwordNotMatch =
                myAccountForm.newPassword.$viewValue !==
                  myAccountForm.repeatNewPassword.$viewValue &&
                myAccountForm.repeatNewPassword.$viewValue !== "";

              break;
            case "repeat_new_password":
              that.passwordNotMatch =
                myAccountForm.newPassword.$viewValue !==
                myAccountForm.repeatNewPassword.$viewValue;
              if (that.passwordNotMatch) {
                myAccountForm.$setValidity("prop", false);
              } else {
                myAccountForm.$setValidity("prop", true);
              }
              break;
          }
        };
        // on form submit get all input values from model and call api action to submit
        that.saveChanges = function (myAccountForm) {
          var userInfoData = {
            firstName: myAccountForm.firstName.$modelValue,
            lastName: myAccountForm.lastName.$modelValue,
            receiveEmailNotificationsSelected:
              myAccountForm.newsLetter.$modelValue
          };

          var passwordData = {
            oldPassword: myAccountForm.oldPassword.$modelValue,
            newPassword: myAccountForm.newPassword.$modelValue
          };

          // call change password action
          if (passwordData.oldPassword && passwordData.newPassword.length > 0) {
            userActions.changePassword(passwordData).then(function () {
              $log.log("Password was successfully changed");
            });
          }

          // call update user info action
          if (
            userInfoData.firstName.length > 0 &&
            userInfoData.lastName.length > 0
          ) {
            userActions.updateUserInfo(userInfoData).then(function (data) {
              $log.log("Basic info was successfully changed");
              vm.myAccount.firstName = data.firstName;
              vm.myAccount.lastName = data.lastName;
              vm.myAccount.newsLetter = data.receiveEmailNotificationsSelected;
              sessionData.setValue(
                sessionData.Keys.RECEIVE_EMAIL,
                data.receiveEmailNotificationsSelected
              );
            });
          }

          that.closeDialog();
        };

        that.closeDialog = function () {
          $mdDialog.hide();
        };
      } // end of modal controller =============================================================

      vm.goToMessagesPage = function () {
        $state.go("app.alarms");
        $mdMenu.hide();
      };

      vm.goToFacilityDetails = function (deviceSerial) {
        $state.go("app.dashboardTechnology.facilityDetails", {
          id: deviceSerial
        });
        $mdMenu.hide();
      };

      vm.gotoReleaseNotesPage = function() {
        $state.go("app.releaseNotes");
        $mdMenu.hide();
      }

      vm.checkUserForUserAccountManagement = function() {
        return checkUserRole.isAdministrator() || checkUserRole.isMerchantAdmin();
      }

      init();

      function init() {
        $scope.$on("$destroy", destroy);
        if (brand !== "karcher") {
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.MESSAGES_UPDATE_AVAILABLE,
            _onMessageAvailableHandler
          );

          subscribeToSocket();
          refreshAlarms();
        }
      }

      function subscribeToSocket() {
        if (webSocketsStore.isConnected()) {
          var deviceSerialArray = sessionData.getValue(
            sessionData.Keys.TOPICS_LIST
          );
          broker.subscribeToMessageChanges(deviceSerialArray);
        }
      }

      function refreshAlarms() {
        if (checkUserRole.hasAcceptNewTerms(sessionData.getValue('userRole'))) {
          return;
        }
        messageActions.getAlarmMessages();
      }

      function destroy() {
        vm.alarmsViewModel.destroy();
        vm.myAccount.destroy();
        webSocketsStore.off(
          webSocketsStore.events.CONNECTED_CHANGE,
          _webSocketStoreConnectedChangeHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.MESSAGES_UPDATE_AVAILABLE,
          _onMessageAvailableHandler
        );
      }

      function buildToggler(navID) {
        return function () {
          $mdSidenav(navID).toggle();
        };
      }
    }
  }
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").component("globalNotice", {
    templateUrl: "app/components/globalNotice/globalNotice.component.html",
    controller: noticeController,
    bindings: {},
    controllerAs: "vm"
  });

  function noticeController($log, newsActions, webSocketsStore, $timeout, checkUserRole, sessionData) {
    var vm = this,
      today = new Date().getTime(),
      _onNoticeDataChangeHandler = refreshNoticeData;

    vm.$onInit = function() {
      refresh();
      webSocketsStore.on(
        webSocketsStore.events.NOTICE_CHANGE,
        _onNoticeDataChangeHandler
      );
    };

    vm.close = function() {
      vm.showContent = !vm.showContent;
    };

    function refresh() {
      if (checkUserRole.hasAcceptNewTerms(sessionData.getValue('userRole'))) {
        return;
      }
      newsActions.getGlobalNotice().then(function(res) {
        if (res.length > 0) {
          vm.content = res[0].content;
          vm.showContent = res[0].validUntil > today && res[0].active;
        }
      });
    }

    function refreshNoticeData(newNoticeData) {
      $timeout(function() {
        vm.content = newNoticeData.content;
        vm.showContent = newNoticeData.validUntil > today && newNoticeData.active;
      }, 50);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('facilitiesGroupGrid', facilitiesGroupGridDirective)
    .controller('facilitiesGroupGridController', facilitiesGroupGridController);

  /** @ngInject */
  function facilitiesGroupGridDirective() {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        groupLabel: '@',
        showPagination: '=',
        chartDataName: '='
      },
      templateUrl:
        'app/components/facilitiesGroupGrid/facilitiesGroupGrid.html',
      controller: 'facilitiesGroupGridController',
      controllerAs: 'vm',
      link: function (scope) {
        scope.vm.groupColumnLabel = scope.groupLabel;
        scope.vm.showPagination = scope.showPagination;
        scope.vm.xOptions = scope.options.x ? scope.options.x : {};
        scope.vm.refresh(scope.options.data);
        scope.$watch('options.data', function (newValue) {
          scope.vm.refresh(newValue);
        });
      }
    };
  }

  /** @ngInject */
  function facilitiesGroupGridController($scope, gridUtils, $translate, brand) {
    var vm = this;

    vm.brand = brand;
    vm.count = 0;
    vm.currentPage = 1;
    vm.groupColumnLabel = '';
    vm.xOptions = {};
    vm.refresh = refreshGridData;
    vm.listFirstType = vm.listSecondType = false;

    init();

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      vm.limitPerPage = gridSettings.limitPerPage;
      vm.pagerLabel = gridSettings.translations;

      $scope.$on('$destroy', destroy);
    }

    function destroy() {}

    function refreshGridData(data) {
      if (!data) {
        return;
      }

      if (data.groupsData) {
        vm.listFirstType = true;
        vm.count = data.groupsData.length;
        vm.columns = [vm.groupColumnLabel].concat(
          data.groupNames,
          $translate.instant('LOYALTY_TOTAL')
        );
        vm.totals = [$translate.instant('LOYALTY_TOTAL')].concat(
          data.groupTotal,
          data.total
        );
        vm.rowsData = data.groupsData.map(function (item) {
          var formattedGroupItem = item.groupValue;
          var sumOfValues = item.values.reduce(function (a, b) {
            return a + b;
          }, 0);
          if (vm.xOptions.tick && vm.xOptions.tick.format) {
            formattedGroupItem = vm.xOptions.tick.format(item.groupValue);
          }
          return {
            group: item.groupValue,
            groupFormatted: formattedGroupItem,
            values: item.values.concat(sumOfValues)
          };
        });
      } else {
        vm.listSecondType = true;
        vm.count = data.length;
        vm.columns = [vm.groupColumnLabel].concat($scope.chartDataName);
        vm.rowsData = data.map(function (item) {
          var formattedGroupItem = item.date;
          if (vm.xOptions.tick && vm.xOptions.tick.format) {
            formattedGroupItem = vm.xOptions.tick.format(item.date);
          }
          return {
            group: item.date,
            groupFormatted: formattedGroupItem,
            values: item.count
          };
        });
      }
    }

    vm.setColor = function (lastItem) {
      if (lastItem) {
        return { color: '#000000', 'font-weight': 900 };
      }
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('errorContainer',  errorContainerInject);

  /** @ngInject */
  function errorContainerInject(errorActions) {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/errorContainer/errorContainer.html',
      controller: ErrorContainerController,
      controllerAs: 'vm',
      scope : {},
      replace: true,
      bindToController : {
        errorHeader : '=',
        errorName : '=',
        errorDescription : '='
      }
    };

    return directive;

    /** @ngInject */
    function ErrorContainerController() {
      var vm = this;

      vm.closeErrorBox = function(){
        errorActions.acknowledgeErrorMsg();
      }

    }
  }

})();

(function () {
  'use strict';
  /* eslint-disable */
  angular.module('sempraWebapp').config(['$provide', Decorate]);
  /* eslint-enable */

  /** @ngInject */
  function Decorate($provide) {
    $provide.decorator('uibDaypickerDirective', function ($delegate) {
      var directive = $delegate[0];
      directive.templateUrl = "app/components/dateTimePicker/day.html";
      return $delegate;
    });
    $provide.decorator('uibMonthpickerDirective', function ($delegate) {
      var directive = $delegate[0];
      directive.templateUrl = "app/components/dateTimePicker/month.html";
      return $delegate;
    });
    $provide.decorator('uibYearpickerDirective', function ($delegate) {
      var directive = $delegate[0];
      directive.templateUrl = "app/components/dateTimePicker/year.html";
      return $delegate;
    });
  }

})();
(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('dateFacilityGrid', dateFacilityGridDirective)
    .controller('dateFacilityGridController', dateFacilityGridController);

  /** @ngInject */
  function dateFacilityGridDirective () {
    return {
      restrict: 'E',
      scope: {
        data: '='
      },
      templateUrl: 'app/components/dateFacilityGrid/dateFacilityGrid.html',
      controller: 'dateFacilityGridController',
      controllerAs: 'vm',
      link: function (scope) {
        scope.vm.refresh(scope.data);
        scope.$watch('data', function (newValue) {
          scope.vm.refresh(newValue);
        });
      }
    }
  }

  /** @ngInject */
  function dateFacilityGridController ($scope, gridUtils) {
    var vm = this;

    vm.count = 0;
    vm.currentPage = 1;
    vm.refresh = refreshGridData;

    init();

    function init () {
      var gridSettings = gridUtils.getDefaultGridSettings();
      vm.limitPerPage = gridSettings.limitPerPage;
      vm.pagerLabel = gridSettings.translations;

      $scope.$on('$destroy', destroy);
    }

    function destroy () {

    }

    function refreshGridData (data) {
      if (data === null) {
        return;
      }

      vm.count = data.dates.length;
      vm.columns = ["DATE"].concat(data.facilities);
      vm.rowsData = data.dates.map(function (dateItem) {
        return {
          date: dateItem.date,
          dateFormatted: dateItem.date, //todo format
          values: dateItem.values
        }
      });
    }
  }
})();

/**
 * uiBreadcrumbs automatic breadcrumbs directive for AngularJS & Angular ui-router.
 *
 * https://github.com/michaelbromley/angularUtils/tree/master/src/directives/uiBreadcrumbs
 *
 * Copyright 2014 Michael Bromley <michael@michaelbromley.co.uk>
 */


(function() {

    /**
     * Config
     */
    var moduleName = 'angularUtils.directives.uiBreadcrumbs';
    // var templateUrl = 'app/components/uiBreadcrumbs.tpl.html';

    /**
     * Module
     */
    var module;
    try {
        module = angular.module(moduleName);
    } catch(err) {
        // named module does not exist, so create one
        module = angular.module(moduleName, ['ui.router']);
    }
    /* eslint-disable */
    module.directive('uiBreadcrumbs', ['$interpolate', '$state', function($interpolate, $state) {
    /* eslint-enable */
            return {
                restrict: 'E',
                templateUrl: 'app/components/breadcrumbs/uiBreadcrumbs.tpl.html',
                scope: {
                    displaynameProperty: '@',
                    abstractProxyProperty: '@?'
                },
                link: function(scope) {
                    scope.breadcrumbs = [];
                    if ($state.$current.name !== '') {
                        updateBreadcrumbsArray();
                    }
                    scope.$on('$stateChangeSuccess', function() {
                        updateBreadcrumbsArray();
                    });

                    /**
                     * Start with the current state and traverse up the path to build the
                     * array of breadcrumbs that can be used in an ng-repeat in the template.
                     */
                    function updateBreadcrumbsArray() {
                        var workingState;
                        var displayName;
                        var breadcrumbs = [];
                        var currentState = $state.$current;

                        while(currentState && currentState.name !== '') {
                            workingState = getWorkingState(currentState);
                            if (workingState) {
                                displayName = getDisplayName(workingState);

                                if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
                                    breadcrumbs.push({
                                        displayName: displayName,
                                        route: workingState.name
                                    });
                                }
                            }
                            currentState = currentState.parent;
                        }
                        breadcrumbs.reverse();
                        scope.breadcrumbs = breadcrumbs;
                    }

                    /**
                     * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
                     * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
                     * set it to `false` which means this breadcrumb level will be skipped entirely.
                     * @param currentState
                     * @returns {*}
                     */
                    function getWorkingState(currentState) {
                        var proxyStateName;
                        var workingState = currentState;
                        if (currentState.abstract === true) {
                            if (typeof scope.abstractProxyProperty !== 'undefined') {
                                proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
                                if (proxyStateName) {
                                    workingState = angular.copy($state.get(proxyStateName));
                                    if (workingState) {
                                        workingState.locals = currentState.locals;
                                    }
                                } else {
                                    workingState = false;
                                }
                            } else {
                                workingState = false;
                            }
                        }
                        return workingState;
                    }

                    /**
                     * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
                     * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
                     * properties on the state config object, by using the usual {{ }} syntax.
                     * @param currentState
                     * @returns {*}
                     */
                    function getDisplayName(currentState) {
                        var interpolationContext;
                        var propertyReference;
                        var displayName;

                        if (!scope.displaynameProperty) {
                            // if the displayname-property attribute was not specified, default to the state's name
                            return currentState.name;
                        }
                        propertyReference = getObjectValue(scope.displaynameProperty, currentState);

                        if (propertyReference === false) {
                            return false;
                        } else if (typeof propertyReference === 'undefined') {
                            return currentState.name;
                        } else {
                            // use the $interpolate service to handle any bindings in the propertyReference string.
                            interpolationContext =  (typeof currentState.locals !== 'undefined') ? currentState.locals.globals : currentState;
                            displayName = $interpolate(propertyReference)(interpolationContext);
                            return displayName;
                        }
                    }

                    /**
                     * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
                     * value found at that path.
                     *
                     * @param objectPath
                     * @param context
                     * @returns {*}
                     */
                    function getObjectValue(objectPath, context) {
                        var i;
                        var propertyArray = objectPath.split('.');
                        var propertyReference = context;

                        for (i = 0; i < propertyArray.length; i ++) {
                            if (angular.isDefined(propertyReference[propertyArray[i]])) {
                                propertyReference = propertyReference[propertyArray[i]];
                            } else {
                                // if the specified property was not found, default to the state's name
                                return undefined;
                            }
                        }
                        return propertyReference;
                    }

                    /**
                     * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
                     * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
                     * @param state
                     * @param breadcrumbs
                     * @returns {boolean}
                     */
                    function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
                        var i;
                        var alreadyUsed = false;
                        for(i = 0; i < breadcrumbs.length; i++) {
                            if (breadcrumbs[i].route === state.name) {
                                alreadyUsed = true;
                            }
                        }
                        return alreadyUsed;
                    }
                }
            };
        }]);
})();

(function () {
  'use strict';
  /* eslint-disable */
  angular
    .module('sempraWebapp')
    .directive('dailyFinancesChart', dailyFinancesChartDirective)
    .controller('dailyFinancesChartController', dailyFinancesChartController);

  /** @ngInject */
  function dailyFinancesChartDirective($timeout) {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        chartId: '=',
        currencyCode: '='
      },
      templateUrl: 'app/components/dailyFinancesChart/dailyFinancesChart.html',
      controller: 'dailyFinancesChartController',
      controllerAs: 'vm',
      link: function (scope, element, $window) {
        scope.vm.chartElementId = scope.chartId; // += scope.index;
        scope.vm.data = scope.data;
        scope.vm.currency = scope.currencyCode;
        angular
          .element(element.find('.chart'))
          .attr('id', scope.vm.chartElementId);
        $timeout(function () {
          scope.vm.initChart();
          scope.$watch('data', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              scope.vm.data = newValue;
              scope.vm.refreshChart();
            }
          });
        }, 200);
      }
    };
  }

  /** @ngInject */
  function dailyFinancesChartController(
    $scope,
    $timeout,
    $translate,
    localeFilters
  ) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'dailyFinancesChart';
    vm.data = null;
    vm.initChart = createChart;
    vm.refreshChart = refreshChart;

    init();

    function init() {
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function createChart() {
      vm.chart = c3.generate({
        onresize: function () {
          //refreshChart();
          var that = this;
          $timeout(function () {
            that.redraw();
          }, 500);
        },
        bindto: '#' + vm.chartElementId,
        data: {
          columns: [
            [
              vm.data.facilityName,
              // vm.data.totalOnlinePayments,
              vm.data.totalCashPayments,
              vm.data.totalChangerMoney,
              vm.data.totalPosMoney
            ]
          ],
          type: 'bar',
          //labels: true,
          labels: {
            format: function (v, id, i, j) {
              return localeFilters.currency(v, vm.currency);
            }
          },
          color: function (color, d) {
            switch (d.x) {
              case 0:
                return 'cadetblue';
              case 1:
                return '#2E71D6';
              case 2:
                return '#639D00';
              case 3:
                return 'green';
            }
          }
        },
        legend: {
          show: false
        },
        bar: {
          width: {
            ratio: 0.5 // this makes bar width 50% of length between ticks
          }
        },
        axis: {
          x: {
            type: 'category',
            categories: [
              // $translate.instant('DAILY_FINANCES_ONLINE'),
              $translate.instant('DAILY_FINANCES_OFFLINE'),
              $translate.instant('DAILY_FINANCES_CHANGER'),
              $translate.instant("DAILY_FINANCES_POS")
            ],
            colors: {
              Sempra: '#FFAF12'
            }
          },
          y: {
            label: {
              text: '(' + vm.currency + ')'
            },
            tick: {
              format: function (y) {
                return localeFilters.number(y);
              }
            }
          }
        }
      });
    }

    function refreshChart() {
      vm.chart.load({
        columns: [
          [
            vm.data.facilityName,
            vm.data.totalOnlinePayments,
            vm.data.totalCashPayments,
            vm.data.totalChangerMoney,
            vm.data.totalPosMoney
          ]
        ]
      });
    }
    /* eslint-enable */
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('barChart', barChartDirective)
    .controller('barChartController', barChartController);

  /** @ngInject */
  function barChartDirective ($timeout) {
    return {
      restrict: 'E',
      scope: {
        options: '=',
        chartId: '@'
      },
      templateUrl: 'app/components/barChart/barChart.html',
      controller: 'barChartController',
      controllerAs: 'vm',
      link: function (scope, element) {
        scope.vm.chartElementId += scope.chartId; // += scope.index;
        scope.vm.xAxisOptions = scope.options.x ? scope.options.x : {};
        angular.element(element.find('.barChartContainer')).attr('id', scope.vm.chartElementId);
        $timeout(function () {
          scope.vm.refresh(scope.options.data);
          scope.$watch('options.data', function (newValue) {
            scope.vm.refresh(newValue);
          });
        }, 100)
      }
    };
  }

  /** @ngInject */
  function barChartController ($scope, $translate) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'barChart';
    vm.refresh = refreshChart;
    vm.xAxisOptions = {};

    init();

    function init() {
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function refreshChart(data) {
      var groupColumnName = 'x',
        rowsData = [];

      if (!data) {
        return;
      }

      rowsData = [[groupColumnName].concat(data.facilities)];

      data.groups.forEach(function (item) {
        rowsData.push([item.group].concat(item.values));
      });

      vm.chart === null
        ? createChart(groupColumnName, rowsData, $translate.instant(data.unit))
        : updateChart(groupColumnName, rowsData, $translate.instant(data.unit));

    }

    function createChart(groupColumnName, rowsData, unit) {
      vm.chart = c3.generate({
        bindto: '#' + vm.chartElementId,
        data: {
          x: groupColumnName,
          rows: rowsData,
          type: 'bar'
        },
        bar: {
          width: {
            ratio: 0.5
          }
        },
        axis: {
          rotated: true,
          x: vm.xAxisOptions,
          y: {
            label: {
              text: '(' + unit + ')'
            }
          }
        }
      });
    }

    function updateChart(groupColumnName, rowsData, unit) {
      vm.chart.load({
        data: {
          x: groupColumnName,
          rows: rowsData,
          type: 'bar'
        },
        bar: {
          width: {
            ratio: 0.5
          }
        },
        axis: {
          rotated: true,
          x: vm.xAxisOptions,
          y: {
            label: {
              text: '(' + unit + ')'
            }
          }
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('averageMoneyPerBoxChart', averageMoneyPerBoxChartDirective)
    .controller('averageMoneyPerBoxChartController', averageMoneyPerBoxChartController);

  /** @ngInject */
  function averageMoneyPerBoxChartDirective ($timeout) {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/components/averageMoneyPerBoxChart/averageMoneyPerBoxChart.html',
      controller: 'averageMoneyPerBoxChartController',
      controllerAs: 'vm',
      link: function (scope) {
        $timeout(scope.vm.initChart, 100);
      }
    };
  }

  /** @ngInject */
  function averageMoneyPerBoxChartController ($scope) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'averageMoneyPerBoxChart';
    vm.data = null;
    vm.initChart = createChart;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
    }

    function destroy () {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function createChart () {
      vm.chart = c3.generate({
        bindto: '#' + vm.chartElementId,
        data: {
          x: 'x',
          columns: [
            ['x', 1, 2, 3, 4],
            ['R2W', 300, 200, 100, 400],
            ['Zetoni', 100, 300, 200, 200],
            ['Kovanice', 500, 400, 300, 100]
          ],
          type: 'bar'
        },
        bar: {
          width: {
            ratio: 0.5
          }
        },
        axis : {
          rotated: true,
          x : {
            type : 'bar',
            tick: {
              format: function (x) { return 'BOX ' + x; }
            }
          }
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp')
    .directive('averageMoneyByHourChart', averageMoneyByHourChartDirective)
    .controller('averageMoneyByHourChartController', averageMoneyByHourChartController);

  /** @ngInject */
  function averageMoneyByHourChartDirective ($timeout) {
    return {
      restrict: 'E',
      scope: {},
      templateUrl: 'app/components/averageMoneyByHourChart/averageMoneyByHourChart.html',
      controller: 'averageMoneyByHourChartController',
      controllerAs: 'vm',
      link: function (scope) {
        $timeout(scope.vm.initChart, 100);
      }
    };
  }

  /** @ngInject */
  function averageMoneyByHourChartController ($scope) {
    var vm = this;

    vm.chart = null;
    vm.chartElementId = 'averageMoneyByHourChart';
    vm.data = null;
    vm.initChart = createChart;

    init();

    function init () {
      $scope.$on('$destroy', destroy);
    }

    function destroy () {
      if (vm.chart) {
        vm.chart.destroy();
      }
    }

    function createChart () {
      vm.chart = c3.generate({
        bindto: '#' + vm.chartElementId,
        data: {
          x: 'x',
          columns: [
            ['x', 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23],
            ['Subotica', 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 30, 200, 100, 400, 150, 250, 150, 250, 30, 200, 100, 400, 150, 250],
            ['Zrenjanin', 130, 300, 200, 300, 250, 450, 130, 300, 200, 300, 250, 450, 130, 300, 200, 300, 250, 450, 130, 300, 200, 300, 250, 450],
            ['Beograd', 100, 250, 150, 200, 100, 350, 100, 250, 150, 200, 100, 350, 100, 250, 150, 200, 100, 350, 100, 250, 150, 200, 100, 350]
          ]
        }
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('AsideMenuViewModel', asideMenuViewModelFactory);

  /** @ngInject */
  function asideMenuViewModelFactory(
    $translate,
    brand,
    checkUserRole,
    service,
    helperService
  ) {
    function AsideMenuViewModel() {
      this.items = [];
      this.refresh();
    }

    AsideMenuViewModel.prototype.destroy = function () {
      this.items = [];
    };

    AsideMenuViewModel.prototype.refresh = function () {
      this.items.push({
        id: 'app.dashboardTechnology',
        name:
          brand === 'karcher'
            ? $translate.instant('ASIDE_MENU_KARCHER_DASHBOARD_TECHNOLOGY')
            : $translate.instant('ASIDE_MENU_DASHBOARD_TECHNOLOGY'),
        icon: 'assets/icons/ic-dashboard-white.svg',
        link: '',
        subMenuItems: []
      });
      if (checkUserRole.isMerchantAdmin()) {
        this.items.push({
          id: 'app.dashboardFinancial',
          name: $translate.instant('ASIDE_MENU_DASHBOARD_FINANCIAL'),
          icon: 'assets/icons/ic-daily-finances-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) {
        this.items.push({
          id: 'app.organization',
          name: $translate.instant('ORGANIZATION'),
          icon: 'assets/icons/ic_organization_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (
        (checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) &&
        service
      ) {
        this.items.push({
          id: 'app.workingSchedules',
          name: $translate.instant('ASIDE_WORKING_SCHEDULES'),
          icon: 'assets/icons/ic_content_paste_white_48px.svg',
          link: '',
          subMenuItems: [],
          roles: []
        });
      }
      this.items.push({
        id: 'app.alarms',
        name: $translate.instant('ASIDE_MENU_ALARMS'),
        icon: 'assets/icons/ic-messages-white.svg',
        link: '',
        subMenuItems: []
      });
      // this.items.push({
      //     id: 'app.news',
      //     name: $translate.instant('ASIDE_MENU_NEWS'),
      //     icon: "assets/icons/ic_comment_white_24px.svg",
      //     link: "",
      //     subMenuItems: []
      // });
      if (
        checkUserRole.isMerchantAdmin() ||
        checkUserRole.isAdministrator() ||
        checkUserRole.isTechnicalSupportUser() ||
        checkUserRole.isControllerUser()
      ) {
        this.items.push({
          id: 'app.reports',
          name: $translate.instant('ASIDE_MENU_REPORTS'),
          icon: 'assets/icons/ic-reports-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (
        checkUserRole.isMerchantAdmin() ||
          checkUserRole.isAdministrator() ||
          checkUserRole.isTechnicalSupportUser() ||
          checkUserRole.isControllerUser()
      ) {
        this.items.push({
          id: 'app.cashlessSales',
          name: $translate.instant('ASIDE_MENU_CASHLESS_SALES'),
          icon: 'assets/icons/ic_cashless.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (
        (checkUserRole.isMerchantAdmin() || checkUserRole.isAdministrator()) &&
        service
      ) {
        this.items.push({
          id: 'app.userGroups',
          name: $translate.instant('ASIDE_MENU_USER_GROUPS'),
          icon: 'assets/icons/ic-user-groups-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.loyalty',
          name: $translate.instant('ASIDE_MENU_LOYALTY'),
          icon: 'assets/icons/ic-loyalty-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.periodicSummary',
          name: $translate.instant('ASIDE_MENU_PERIODIC_SUMMARY'),
          icon: 'assets/icons/ic-periodic-summary-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && (brand === 'r2w' || helperService.showVouchersSideItemByUserId())) {
        this.items.push({
          id: 'app.vouchers',
          name: $translate.instant('ASIDE_MENU_VOUCHERS'),
          icon: 'assets/icons/ic-vouchers-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.transactions',
          name: $translate.instant('ASIDE_MENU_TRANSACTIONS'),
          icon: 'assets/icons/ic-transactions-white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.tokens',
          name: $translate.instant('ASIDE_MENU_MANAGING_TOKENS'),
          icon: 'assets/icons/coins_white.svg',
          link: '',
          subMenuItems: []
        });
      }
      if (checkUserRole.isMerchantAdmin() && service) {
        this.items.push({
          id: 'app.pricing',
          name: $translate.instant('PRICING'),
          icon: 'assets/icons/ic_dolar_circle_white.svg',
          link: '',
          subMenuItems: []
        });
      }
    };

    return AsideMenuViewModel;
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").directive("layoutAsideMenu", asideMenuInject);

  /** @ngInject */
  function asideMenuInject() {
    var directive = {
      restrict: "EA",
      templateUrl: "app/components/asideMenu/asideMenu.html",
      controller: AsideMenuController,
      controllerAs: "vm",
      scope: {
        localValue: "=?menu"
      },
      replace: true,
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function AsideMenuController(
      $mdSidenav,
      $scope,
      AsideMenuViewModel,
      $state,
      brand,
      version,
      sessionData
    ) {
      var vm = this;

      vm.asideMenu = new AsideMenuViewModel();
      vm.brand = brand;
      vm.version = version;
      vm.smallMenu = vm.localValue;

      vm.closeMenu = function () {
        $mdSidenav("left").close();
      };

      vm.setSmallMenu = function () {
        vm.smallMenu = !vm.smallMenu;
        sessionData.setValue(sessionData.Keys.SMALL_MENU, vm.smallMenu);
      };

      vm.getBrandIcon = function () {
        switch (true) {
          case vm.brand === "karcher":
            return "assets/images/logo_Karcher_white.svg";
          case vm.brand === "r2w" && !vm.smallMenu:
            return "assets/images/logoComplete.svg";
          case vm.brand === "r2w" && vm.smallMenu:
            return "assets/images/logor2w.svg";
        }
      };

      init();

      function init() {
        $scope.$on("$destroy", destroy);
      }

      function destroy() {
        vm.asideMenu.destroy();
      }
    }
  }
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").component("karcherAlarms", {
    templateUrl: "app/alarms/karcherAlarmsComponent/karcherAlarms.html",
    controller: karcherAlarmsController,
    bindings: {},
    controllerAs: "vm"
  });

  function karcherAlarmsController(
    deviceActions,
    messagesStore,
    karcherActiveAlarmsService,
    messageActions
  ) {
    var vm = this;

    deviceActions.getAllDevices().then(function(devicesData) {
      var karcherDevices = devicesData.filter(function(device) {
        return device.deviceType === "KARCHER";
      });

      if (messagesStore.getKarcherMessages()) {
        vm.karcherAlarmList = karcherActiveAlarmsService.mapFacilityNameToActiveAlarmList(
          karcherDevices,
          messagesStore.getKarcherMessages()
        );
      } else {
        messageActions.getKarcherAlarms().then(function(data) {
          vm.karcherAlarmList = karcherActiveAlarmsService.mapFacilityNameToActiveAlarmList(
            karcherDevices,
            data
          );
        });
      }
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory(
      "KarcherSubscriptionsAlarmsViewModel",
      karcherSubscriptionsAlarmsViewModelFactory
    );

  /** @ngInject */
  function karcherSubscriptionsAlarmsViewModelFactory($translate) {
    function KarcherSubscriptionsAlarmsViewModel() {
      this.subscriptionsData = [];
    }

    KarcherSubscriptionsAlarmsViewModel.prototype.destroy = function () {};

    KarcherSubscriptionsAlarmsViewModel.prototype.refreshSubscriptionsList =
      function (data) {
        if (data.length === 0) {
          this.subscriptionsData = [];
          this.subscriptionsData.push({
            siteName: $translate.instant("NOTHING_TO_DISPLAY"),
            hideButton: true
          });
        } else {
          this.subscriptionsData = data;
        }
      };

    return KarcherSubscriptionsAlarmsViewModel;
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller(
      "KarcherAlarmSubscriptionsController",
      KarcherAlarmSubscriptionsController
    );

  /** @ngInject */
  function KarcherAlarmSubscriptionsController(
    $scope,
    KarcherSubscriptionsAlarmsViewModel,
    messageActions,
    layoutActions,
    $mdDialog,
    dashboardKarcherActions
  ) {
    var vm = this;

    vm.alarmSubscriptions = new KarcherSubscriptionsAlarmsViewModel();
    /* eslint-disable */
    vm.addNewSubscription = function (ev) {
      $mdDialog
        .show({
          controller: CreateNewSubscriptionController,
          controllerAs: "vm",
          templateUrl:
            "app/alarmsKarcher/alarmSubscriptions/createSubscriptionDialog/createSubscription.html",
          parent: angular.element(document.body),
          targetEvent: ev,
          clickOutsideToClose: false
        })
        .then(function () {});
    };

    vm.openMenu = function ($mdMenu, ev) {
      $mdMenu(ev);
    };

    vm.unsubscribeAlarm = function (id) {
      messageActions.unsubscribeKarcherAlert(id).then(function () {
        refresh();
      });
    };

    init();

    function init() {
      layoutActions.showLoader();
      $scope.$on("destroy", function () {});
      refresh();
    }

    function refresh() {
      messageActions.getKarcherAlarmSubscriptions().then(function (response) {
        vm.alarmSubscriptions.refreshSubscriptionsList(response);
        layoutActions.hideLoader();
      });
    }

    function CreateNewSubscriptionController(organizationActions) {
      var that = this;
      that.selectedSite = {};
      that.lowAlarm = false;
      that.mediumAlarm = false;
      that.highAlarm = false;
      that.deviceListForSelectedSite = [];
      that.selectedDevice = null;
      that.faultListForSelectedDevice = [];
      that.faultCode = "";
      that.validateMultiplyItem = false;

      that.closeSubscribeDialog = function () {
        $mdDialog.hide();
      };

      that.onSelectSite = function () {
        dashboardKarcherActions
          .getKarcherSiteDetailsById(that.selectedSite.id)
          .then(function (response) {
            that.deviceListForSelectedSite = response;
          });
      };

      that.onSelectDevice = function () {
        dashboardKarcherActions
          .getKarcherFaultsByDeviceId(that.selectedDevice)
          .then(function (response) {
            that.faultListForSelectedDevice = response.map(function (fault) {
              return {
                id: fault.code,
                name: fault.name
              };
            });
          });
      };

      that.getFault = function (id) {
        that.lowAlarm = false;
        that.mediumAlarm = false;
        that.highAlarm = false;
        that.faultCode = id;
      };

      that.clearFaultInput = function () {
        that.faultCode = "";
      };

      that.clearDeviceInput = function () {
        that.selectedDevice = null;
        that.faultListForSelectedDevice = [];
        that.faultCode = "";
      };

      that.validateMultiplyItemsInput = function (validCheck) {
        that.validateMultiplyItem = validCheck;
      };

      that.onSelectCheckBox = function () {
        that.validateMultiplyItem =
          !that.lowAlarm && !that.mediumAlarm && !that.highAlarm;
      };

      that.subscribeData = function () {
        layoutActions.showLoader();
        var dataToSave = {
          sitePointId: that.selectedSite.id,
          deviceId: that.selectedDevice,
          faultNumber: that.faultCode === "" ? null : that.faultCode,
          siteName: that.selectedSite.name,
          low: that.lowAlarm,
          medium: that.mediumAlarm,
          high: that.highAlarm
        };

        messageActions.createAlarmSubscription(dataToSave).then(function () {
          $mdDialog.hide();
          layoutActions.hideLoader();
          refresh();
        });
      };

      /* eslint-enable */

      organizationActions.getAllSitesForExactUser().then(function (res) {
        that.siteList = res;
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('UserOrganizationController', userOrganizationController);

  /** @ngInject */
  function userOrganizationController(
    organizationActions,
    userRolesEnum,
    $stateParams,
    layoutActions,
    $state,
    userActions,
    brand
  ) {
    var vm = this;
    vm.selectedOrganization = '';
    vm.selectedRole = '';
    vm.selectedUser = '';
    vm.selectedRegion = '';
    vm.userRoles =
      brand === 'karcher'
        ? [
            userRolesEnum.MERCHANT_ADMIN,
            userRolesEnum.FACILITY_ADMIN,
            userRolesEnum.ADMINISTRATOR,
            userRolesEnum.TECHNICAL_SUPPORT,
            userRolesEnum.CONTROLLER
          ]
        : [userRolesEnum.MERCHANT_ADMIN, userRolesEnum.FACILITY_ADMIN];
    vm.regionList = [];
    vm.organizationListForAvailableUsers = [];
    vm.editMode = false;
    vm.isSystemAdministrator = false;
    vm.isSubscriber = false;

    init();

    function init() {
      vm.editMode = $stateParams.userId;
      refresh();
    }

    vm.saveNewOrganizationUser = function () {
      layoutActions.showLoader();
      var data = {
        firstName: vm.firstName,
        lastName: vm.lastName,
        email: vm.selectedUser,
        roles: [vm.selectedRole],
        regionId: parseInt(vm.selectedRegion),
        organizations: [
          {
            id: parseInt(vm.selectedOrganization)
          }
        ],
        originApp: brand.toUpperCase(),
        verified: vm.editMode ? vm.verified : false
      };

      !vm.editMode
        ? organizationActions
            .createUserForSelectedOrganizationAndRole(data)
            .then(function () {
              layoutActions.hideLoader();
              $state.go('app.accountManagement');
            })
        : organizationActions
            .updateUserForSelectedOrganizationAndRole($stateParams.userId, data)
            .then(function () {
              layoutActions.hideLoader();
              $state.go('app.accountManagement');
            });
    };

    function mapUserRoles(rolesList) {
      rolesList.forEach(function (role) {
        switch (role) {
          case userRolesEnum.SYSTEM_ADMIN:
            vm.isSystemAdministrator = true;
            break;
          case userRolesEnum.SUBSCRIBER:
            vm.isSubscriber = true;
            break;
          case userRolesEnum.CONSUMER:
            vm.isSubscriber = true;
            break;
          default:
            vm.selectedRole = role;
            break;
        }
      });
    }

    function refresh() {
      layoutActions.showLoader();
      organizationActions
        .getForUserOrganizationListByUserId()
        .then(function (response) {
          vm.organizationListForAvailableUsers = response;
          if (vm.editMode) {
            userActions
              .getOrganizationUserById($stateParams.userId)
              .then(function (response) {
                vm.selectedOrganization = response.organizations[0].id;
                vm.selectedRole = response.role;
                vm.selectedUser = response.email;
                vm.selectedRegion = response.regionId;
                vm.firstName = response.firstName;
                vm.lastName = response.lastName;
                mapUserRoles(response.roles);
                vm.verified = response.verified;
              });
          }
          layoutActions.hideLoader();
        });
      organizationActions.getAllRegionsShort().then(function (regionList) {
        vm.regionList = regionList;
        layoutActions.hideLoader();
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('WorkingSchedulesController', WorkingSchedulesController);

  /** @ngInject */
  function WorkingSchedulesController(
    layoutActions,
    $translate,
    organizationActions,
    workingSchedulesActions,
    dashboardKarcherActions,
    fromArrayToPathParam,
    brand
  ) {
    var vm = this;

    vm.placeHolderText = $translate.instant('SITE_NAME');
    vm.deviceListPlaceHolder = $translate.instant('DEVICES_INFO');
    vm.deviceId = '';
    vm.brand = brand;

    init();

    vm.getSchedulesForSiteId = function (id) {
      vm.siteId = id;
      getDevicesList(id);
      vm.refreshHolidayList();
      vm.refreshSchedules();
    };

    vm.clearSiteInput = function () {
      vm.siteId = '';
      vm.scheduleList = [];
      vm.holidayList = [];
    };

    vm.clearDevicesInput = function () {
      vm.deviceId = '';
    };

    vm.getDevicesId = function (id) {
      vm.deviceId = id;
    };

    vm.propagate = function () {
      layoutActions.showLoader();
      var path = fromArrayToPathParam.createOnlyPath(
        vm.deviceId,
        'deviceKey='
      );
      workingSchedulesActions
        .propagateWorkingSchedules(vm.siteId, path)
        .then(function () {
          layoutActions.hideLoader();
        });
    };

    function init() {
      vm.scheduleList = [];
      vm.holidayList = [];
      layoutActions.showLoader();
      organizationActions.getAllSitesForExactUser().then(function (response) {
        vm.siteList = response;
      });
      layoutActions.hideLoader();
    }
    function getDevicesList(siteId) {
      dashboardKarcherActions
        .getKarcherSiteDetailsById(siteId)
        .then(function (response) {
          vm.devicesList = response.map(function (device) {
            return {
              name: device.pointName,
              id: device.deviceKey
            };
          });
        });
    }

    vm.refreshHolidayList = function () {
      layoutActions.showLoader();
      workingSchedulesActions
        .getSiteHolidays(vm.siteId)
        .then(function (holidays) {
          vm.holidayList = holidays;
          layoutActions.hideLoader();
        });
    };

    vm.refreshSchedules = function () {
      layoutActions.showLoader();
      workingSchedulesActions
        .getWorkingSchedules(vm.siteId)
        .then(function (schedules) {
          vm.scheduleList = schedules.days;
          vm.allDayCheckBoxData = schedules.state24h;
          layoutActions.hideLoader();
        });
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("WorkingHoursController", WorkingHoursController);

  /** @ngInject */
  function WorkingHoursController(
    deviceActions,
    $scope,
    $state,
    $stateParams,
    layoutActions
  ) {
    var vm = this;

    vm.workingHoursData = {
      alwaysOpen: false,
      closedByMerchant: false,
      days: [
        {
          day: 0,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null
        },
        {
          day: 1,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null
        },
        {
          day: 2,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null
        },
        {
          day: 3,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null
        },
        {
          day: 4,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null
        },
        {
          day: 5,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null
        },
        {
          day: 6,
          hoursFrom: null,
          minutesFrom: null,
          hoursTo: null,
          minutesTo: null
        }
      ]
    };

    vm.cancelChanges = function () {
      goToDetailsPage($stateParams.id);
    };

    vm.saveChanges = function (workingHoursData) {
      layoutActions.showLoader();
      deviceActions
        .updateDeviceWorkingHours($stateParams.pointId, workingHoursData)
        .then(
          function () {
            init();
          },
          function () {
            //todo error handling
          }
        );
    };

    vm.changeType = function (workingHoursType) {
      switch (true) {
        case workingHoursType === "WH_ALWAYS_OPEN":
          vm.workingHoursData.alwaysOpen = true;
          vm.workingHoursData.closedByMerchant = false;
          vm.disableCustomWorkingHours = true;
          break;
        case workingHoursType === "WH_ALWAYS_CLOSE":
          vm.workingHoursData.closedByMerchant = true;
          vm.workingHoursData.alwaysOpen = false;
          vm.disableCustomWorkingHours = true;
          break;
        default:
          vm.workingHoursData.alwaysOpen = false;
          vm.workingHoursData.closedByMerchant = false;
          vm.disableCustomWorkingHours = false;
          break;
      }
    };

    function init() {
      layoutActions.showLoader();
      deviceActions
        .getDeviceWorkingHours($stateParams.pointId)
        .then(function (workingHoursDto) {
          layoutActions.hideLoader();
          vm.workingHoursData = workingHoursDto;
          switch (true) {
            case workingHoursDto.alwaysOpen:
              vm.workingHoursSelector = "WH_ALWAYS_OPEN";
              vm.disableCustomWorkingHours = true;
              break;
            case workingHoursDto.closedByMerchant:
              vm.workingHoursSelector = "WH_ALWAYS_CLOSE";
              vm.disableCustomWorkingHours = true;
              break;
            default:
              vm.workingHoursSelector = "WH_CUSTOM";
              vm.disableCustomWorkingHours = false;
              break;
          }
        });

      $scope.$on("$destroy", function () {});
    }

    init();

    function goToDetailsPage(deviceSerial) {
      $state.go("app.dashboardTechnology.facilityDetails", {
        id: deviceSerial
      });
    }
  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('VouchersViewModel', vouchersViewModelFactory);

    /** @ngInject */
    function vouchersViewModelFactory ($translate) {
        function VouchersViewModel() {
            this.email = '';
            this.amount = 1;

            this.amountOfTokens = 1;
            this.amountOfVouchers = 1;
            this.newVoucherPrefix = '';
            this.voucherValidityDays = '7';

            this.data = [];
            this.orderBy = 'id';
            this.order = 'desc';
            this.page = 1;
            this.total = 0;
            this.pageSize = 10;
            this.pageOptions = [5, 10, 15];
            this.selected = [];
            this.pagerTranslations = {
                page: $translate.instant('GRID_PAGER_PAGE'),
                rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
                of: $translate.instant('GRID_PAGER_PAGE_OF')
            };

            this.printVoucherPrefix = '';
            this.vouchersForPrint = [];

            this.voucherCodeFilter = '';
            this.expiresAt = null;  // ZonedDateTime from backend (ISO 8601 string)

        }

        VouchersViewModel.prototype.destroy = function () {

        };

        VouchersViewModel.prototype.onTokensCreatedSuccessHandler = function () {
          this.email = '';
        };

        VouchersViewModel.prototype.onVouchersCreatedSuccessHandler = function () {
            this.newVoucherPrefix = '';
        };

        VouchersViewModel.prototype.refreshVouchersHistory = function (data) {
            this.data = data.content;
            this.total = data.totalElements;
        };

        VouchersViewModel.prototype.sortChanged = function(order){
            var orderQuery = getOrderObject(order);
            this.orderBy = orderQuery.orderBy;
            this.order = orderQuery.order;
        };

        VouchersViewModel.prototype.paginationChanged = function(page, limit){
            this.page = page;
            this.pageSize = limit;
        };

        // helper function
        function getOrderObject(order) {
            var result = {
                order: 'asc',
                orderBy: order
            };

            if (order.indexOf('-') > -1) {
                result.order = 'desc';
                result.orderBy = order.substring(1);
            }
            return result;
        }

        return VouchersViewModel;
    }
})();
(function () {
    "use strict";

    angular.module("sempraWebapp").controller("VouchersController", VouchersController);

    /** @ngInject */
    function VouchersController($scope, $timeout, $translate, VouchersViewModel, voucherActions, dialogsService, userActions, sessionData) {
        var vm = this;

        vm.vouchers = new VouchersViewModel();
        vm.hasErrors = false;
        vm.hasNewVouchersErrors = false;
        vm.noFoundVouchersForPrint = false;
        vm.vouchersForPrint = [];
        vm.createLocalTokens = createLocalTokens;
        vm.createVouchers = createVouchers;
        vm.printVoucher = printVoucher;
        vm.printVouchers = printVouchers;
        vm.filterVouchers = filterVouchers;
        vm.createAndPrintVouchers = createAndPrintVouchers;
        vm.newVouchersBatch = {
            size: 1000
        };
        vm.issuedDateLabel = $translate.instant('ISSUED_DATE');
        vm.daysLabel = $translate.instant('VOUCHER_VALIDITY_DAYS');
        vm.expiryDateLabel = $translate.instant('EXPIRY_DATE');
        
        // Company voucher expiration days (loaded from backend)
        var companyVoucherExpirationDays; // Default vrednost
        var restrictedUsers = [
            'gsbistrica1@hellenic-petroleum.rs',
            'gsBistrica2@hellenic-petroleum.rs',
            'gsZrenjanin@hellenic-petroleum.rs'
        ];
        // Check if user is test@test.com to disable certain fields
        var userEmail = sessionData.getValue(sessionData.Keys.USERNAME_KEY);
        vm.isRestrictedUser = restrictedUsers.includes(userEmail);

        // news table sort
        vm.sortChanged = function (order) {
            vm.vouchers.sortChanged(order);
            getVouchersHistory();
        };

        // news pagination
        vm.pageChanged = function (page, limit) {
            vm.vouchers.paginationChanged(page, limit);
            getVouchersHistory();
        };

        //Download CSV with vouchers
        vm.downloadCSV = function (seriesPrefix) {
            voucherActions.vouchersToCSV(seriesPrefix).then(function (data) {
                var csv = data;
                /* eslint-disable */
                var hiddenElement = document.createElement("a");
                /* eslint-enable */
                hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
                hiddenElement.target = "_blank";
                hiddenElement.download = "vouchers.csv";
                hiddenElement.click();
            });
        };

        //After close print window, hidden qrCode list Div
        /* eslint-disable */
        // window.onafterprint = function() {
        //     location.reload();
        // };
        /* eslint-enable */

        init();

        function init() {
            $scope.$on("$destroy", onDestroyHandler);
            getVouchersHistory();
            
            // Load company details to get default voucherExpirationDays
            userActions.getCompanyDetails().then(function(companyData) {
                if (companyData.voucherExpirationDays) {
                    companyVoucherExpirationDays = companyData.voucherExpirationDays;
                    vm.vouchers.voucherValidityDays = companyData.voucherExpirationDays.toString();
                }
            });
        }

        function onDestroyHandler() {
            vm.vouchers.destroy();
        }

        function printVouchers(voucherSeries) {
            vm.vouchers.vouchersForPrint = [];
            vm.noFoundVouchersForPrint = false;
            voucherActions
                .getVouchersHistory(0, vm.newVouchersBatch.size, "issuedAt", "desc", voucherSeries)
                .then(function (data) {
                    vm.vouchers.vouchersForPrint = data;
                    vm.vouchersForPrint = [];
                    vm.vouchersForPrint = vm.vouchers.vouchersForPrint.content;
                    vm.noFoundVouchersForPrint = vm.vouchersForPrint.length > 0 ? false : true;
                    if (!vm.noFoundVouchersForPrint) {
                        print();
                    }
                });
        }

        function printVoucher(voucher) {
            vm.vouchersForPrint = [];
            vm.vouchersForPrint.push(voucher);
            print();
        }

        function print() {
            $timeout(function () {
                /* eslint-disable */
                window.print();
                /* eslint-enable */
            }, 0);
        }

        function createLocalTokens(form) {
            vm.form = form;
            vm.hasErrors = false;
            // To disable multiple pressed button issue
            vm.disableButton = true;
            // ========================================
            voucherActions.createLocalTokens(vm.vouchers.email.toLowerCase(), vm.vouchers.amount).then(
                function () {
                    vm.vouchers.onTokensCreatedSuccessHandler();
                    vm.form.$setUntouched();
                    vm.form.$setPristine();
                    vm.disableButton = false;
                    getVouchersHistory();
                },
                function () {
                    vm.hasErrors = true;
                }
            );
        }

        // Helper funkcija za kreiranje i štampanje vaučera
        function executeCreateAndPrintVouchers() {
            return voucherActions
                .createAndRetrieveVouchers(
                    vm.vouchers.amountOfTokens,
                    vm.vouchers.amountOfVouchers,
                    vm.vouchers.newVoucherPrefix,
                    parseInt(vm.vouchers.voucherValidityDays) || companyVoucherExpirationDays
                )
                .then(function (data) {
                    vm.vouchers.onVouchersCreatedSuccessHandler();
                    vm.form.$setUntouched();
                    vm.form.$setPristine();
                    vm.vouchersForPrint = [];
                    // Dodaj validityDays u svaki voucher za štampu
                    var expireDays = parseInt(vm.vouchers.voucherValidityDays) || companyVoucherExpirationDays;
                    vm.vouchersForPrint = data.map(function(voucher) {
                        voucher.validityDays = expireDays;
                        return voucher;
                    });
                    vm.noFoundVouchersForPrint = vm.vouchersForPrint.length > 0 ? false : true;
                    if (!vm.noFoundVouchersForPrint) {
                        print();
                    }
                })
                .then(function () {
                    getVouchersHistory();
                })
                .catch(function (error) {
                    // error handler
                    dialogsService.showOkDialog("API_ERROR", error.data.message).then();
                    console.error('API greška:', error.data.message);
                });
        }

        function createAndPrintVouchers(form) {
            vm.form = form;
            // Za restricted usere preskačemo dialog i odmah kreiramo vaučere
            if (vm.vouchers.newVoucherPrefix == "" && vm.vouchers.amountOfVouchers > 10 && !vm.isRestrictedUser) {
                dialogsService.showConfirmDialog("CODE_PREFIX_QUESTION", "CODE_PREFIX_QUESTION_TEXT", "PROCEED").then(function () {
                    executeCreateAndPrintVouchers();
                });
            } else if (vm.vouchers.newVoucherPrefix != "") {
                voucherActions
                    .getVouchersHistory(
                        vm.vouchers.page - 1,
                        vm.vouchers.pageSize,
                        vm.vouchers.orderBy,
                        vm.vouchers.order,
                        vm.vouchers.newVoucherPrefix
                    )
                    .then(function (res) {
                        var checkVoucherExistence = res.content.length > 0;
                        if (!checkVoucherExistence) {
                            // Ako ne postoje, kreiraj ih
                            return voucherActions.createAndRetrieveVouchers(
                                vm.vouchers.amountOfTokens,
                                vm.vouchers.amountOfVouchers,
                                vm.vouchers.newVoucherPrefix,
                                parseInt(vm.vouchers.voucherValidityDays) || companyVoucherExpirationDays
                            );
                        } else {
                            // Ako postoje, prikaži dijalog i prekini
                            return dialogsService.showOkDialog("CODE_PREFIX_EXIST", "CODE_PREFIX_EXIST_TEXT");
                        }
                    })
                    .then(function (data) {
                        vm.vouchers.onVouchersCreatedSuccessHandler();
                        vm.form.$setUntouched();
                        vm.form.$setPristine();
                        vm.vouchersForPrint = [];
                        // Dodaj validityDays u svaki voucher za štampu
                        var expireDays = parseInt(vm.vouchers.voucherValidityDays) || companyVoucherExpirationDays;
                        vm.vouchersForPrint = data.map(function(voucher) {
                            voucher.validityDays = expireDays;
                            return voucher;
                        });
                        vm.noFoundVouchersForPrint = vm.vouchersForPrint.length > 0 ? false : true;
                        if (!vm.noFoundVouchersForPrint) {
                            print();
                        }
                    })
                    .then(function () {
                        getVouchersHistory();
                    })
                    .catch(function (error) {
                        // error handler
                        dialogsService.showOkDialog("API_ERROR", error.data.message).then();
                        console.error('API greška:', error.data.message);
                    });
            } else {
                // Za restricted usere ili kada je prefix prazan i broj vaučera <= 10
                executeCreateAndPrintVouchers();
            }

        }

        function createVouchers(form) {
            voucherActions
                .getVouchersHistory(
                    vm.vouchers.page - 1,
                    vm.vouchers.pageSize,
                    vm.vouchers.orderBy,
                    vm.vouchers.order,
                    vm.vouchers.newVoucherPrefix
                )
                .then(function (res) {
                    var checkVoucherExistence = res.content.length > 0;
                    if (!checkVoucherExistence) {
                        createNewVoucher(form);
                    } else {
                        dialogsService.showOkDialog("CODE_PREFIX_EXIST", "CODE_PREFIX_EXIST_TEXT").then();
                    }
                });


        }

        function createNewVoucher(form) {
            vm.form = form;
            vm.hasNewVouchersErrors = false;
            voucherActions
                .createVouchers(
                    vm.vouchers.amountOfTokens,
                    vm.vouchers.amountOfVouchers,
                    vm.vouchers.newVoucherPrefix
                )
                .then(
                    function () {
                        vm.vouchers.onVouchersCreatedSuccessHandler();
                        vm.form.$setUntouched();
                        vm.form.$setPristine();
                        getVouchersHistory();
                    },
                    function (error) {
                        vm.errorMessage = error.data;
                        vm.hasNewVouchersErrors = true;
                    }
                );
        }

        function getVouchersHistory() {
            if (vm.vouchers.orderBy.indexOf("-") > -1) {
                vm.vouchers.orderBy = vm.vouchers.orderBy.substring(1);
            }

            vm.promise = voucherActions
                .getVouchersHistory(
                    vm.vouchers.page - 1,
                    vm.vouchers.pageSize,
                    vm.vouchers.orderBy,
                    vm.vouchers.order,
                    vm.vouchers.voucherCodeFilter
                )
                .then(refreshVouchersHistory);
        }

        function filterVouchers() {
            vm.vouchers.page = 1;
            getVouchersHistory();
        }

        function refreshVouchersHistory(data) {
            vm.vouchers.refreshVouchersHistory(data);
        }
    }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('UserGroupsViewModel', UserGroupsViewModelFactory);

  /** @ngInject */
  function UserGroupsViewModelFactory(userGroupActions, gridUtils, dialogsService, $translate, UserGroupItemViewModel) {
    function UserGroupsViewModel() {
      this.currentPage = 1;
      this.orderBy = 'name';
      this.hasErrorMessage = false;
      this.errorMessage = $translate.instant('DELETE_USER_GROUP_ERROR')

      init.call(this);
    }

    UserGroupsViewModel.prototype.destroy = function () {
      this.data.forEach(function (groupItemViewModel) {
        groupItemViewModel.destroy();
      });
    };

    UserGroupsViewModel.prototype.deleteSelectedGroup = function () {
      var that = this;
      dialogsService.showConfirmDialog('CONFIRM_DELETE_USER_GROUP', 'CONFIRM_DELETE_USER_GROUP_TEXT', 'DELETE')
        .then(function () {
          userGroupActions.deleteUserGroup(that.selected[0].id).then(function () {
            refresh.call(that);
          }, function () {
            that.hasErrorMessage = true;
          });
        });
    };

    return UserGroupsViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.limitPerPage = gridSettings.limitPerPage;
      this.pagerLabel = gridSettings.translations;

      refresh.call(this);
    }

    function refresh() {
      var that = this;

      this.data = [];
      this.selected = [];
      this.count = 0;
      this.emptyList = false;
      this.hasErrorMessage = false;
      userGroupActions.getUserGroups().then(function (groupsJson) {
        if (groupsJson && groupsJson.length > 0) {
          that.count = groupsJson.length;
          groupsJson.forEach(function (groupJson) {
            this.push(new UserGroupItemViewModel(groupJson));
          }, that.data);
        }else{
          that.emptyList = true;
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('userGroupsController', userGroupsController);

  /** @ngInject */
  function userGroupsController ($scope, $state, UserGroupsViewModel) {
    var vm = this;
    vm.groups = new UserGroupsViewModel();

    vm.createUserGroup = function () {
      $state.go('app.userGroups.new');
    };

    vm.updateUserGroup = function () {
      $state.go('app.userGroups.edit', {id: vm.groups.selected[0].id});
    };

    vm.onGroupSelected = function(){
      if(vm.groups.selected.length >= 2){
        vm.groups.selected.shift();
      }
    };

    init();

    function init () {
      $scope.$on('$destroy', destroy);
    }

    function destroy () {
      vm.groups.destroy();
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('UserGroupItemViewModel', UserGroupItemViewModelFactory);

  /** @ngInject */
  function UserGroupItemViewModelFactory() {
    function UserGroupItemViewModel(groupJson) {
      this.id = groupJson.id;
      this.name = groupJson.name;
      //this.userCount = groupJson.users.length;

      init.call(this);
    }

    UserGroupItemViewModel.prototype.destroy = function () {
    };

    return UserGroupItemViewModel;

    function init() {
      refresh.call(this);
    }

    function refresh() {
    }
  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').controller('TransactionsController', TransactionsController);

    /** @ngInject */
    function TransactionsController() {

        var vm = this;

        vm.isSelectedUser = false;

        vm.userSelected = function() {
            vm.isSelectedUser = true;
		};
        
    }
})();

(function () {

  'use strict';

  angular.module('sempraWebapp').service('subsystemService', subsystemService);

  /** @ngInject */
  function subsystemService() {
      this.check = function (json) {
        var data = [];
          json.points.forEach(function(item){
              data.push(item.pointType);  
          });
          return data.indexOf('SUBSYSTEM');
      };
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").service("sortArrayService", sortArrayService);

  /** @ngInject */
  function sortArrayService() {
    this.sortByTime = function (array) {
      return array.sort(compareByTime);
    };

    function compareByTime(a, b) {
      if (a.timestamp < b.timestamp) {
        return -1;
      }
      if (a.timestamp > b.timestamp) {
        return 1;
      }
      return 0;
    }

    this.sortByGroupValue = function (array) {
      return array.sort(compareByGroupValue);
    };

    function compareByGroupValue(a, b) {
      if (a.groupValue < b.groupValue) {
        return -1;
      }
      if (a.groupValue > b.groupValue) {
        return 1;
      }
      return 0;
    }

    this.sortArrayById = function (array) {
      return array.sort(function (a, b) {
        return parseFloat(a.id) - parseFloat(b.id);
      });
    };

  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").service("sessionData", sessionDataService);

  /** @ngInject */
  function sessionDataService() {
    var that = this,
      localStorageAvailable = storageAvailable(),
      data = {};

    this.Keys = {
      USERNAME_KEY: "username",
      PASSWORD_KEY: "password",
      LANGUAGE_KEY: "language",
      ACCESS_TOKEN_KEY: "accessToken",
      REFRESH_TOKEN_KEY: "refreshToken",
      USER_ID: "userId",
      USER_ROLE_KEY: "userRole",
      FIRST_NAME_KEY: "firstName",
      LAST_NAME_KEY: "lastName",
      DEFAULT_FACILITY_ID: "defaultFacilityId",
      COUNTRY_CODE: "countryIsoCode",
      RECEIVE_EMAIL: "receiveEmailNotifications",
      TOPICS_LIST: "topicList",
      SMALL_MENU: "smallMenu",
      CURRENCY: 'currency'
    };

    this.getAll = function () {
      return angular.copy(data);
    };

    this.getValue = function (key) {
      if (data.hasOwnProperty(key) && data[key] !== null) {
        return data[key];
      } else if (localStorageAvailable) {
        var value = localStorage.getItem(key);
        if (value !== null) {
          data[key] = value;
          return value;
        }
      }
      return null;
    };

    this.setValue = function (key, value) {
      data[key] = value;
      if (localStorageAvailable) {
        localStorage.setItem(key, value);
      }
    };

    this.clearAll = function () {
      if (localStorageAvailable) {
        localStorage.removeItem(that.Keys.USERNAME_KEY);
        localStorage.removeItem(that.Keys.PASSWORD_KEY);
        localStorage.removeItem(that.Keys.ACCESS_TOKEN_KEY);
        localStorage.removeItem(that.Keys.REFRESH_TOKEN_KEY);
        localStorage.removeItem(that.Keys.USER_ID);
        localStorage.removeItem(that.Keys.USER_ROLE_KEY);
        localStorage.removeItem(that.Keys.FIRST_NAME_KEY);
        localStorage.removeItem(that.Keys.LAST_NAME_KEY);
        localStorage.removeItem(that.Keys.DEFAULT_FACILITY_ID);
        localStorage.removeItem(that.Keys.RECEIVE_EMAIL);
        localStorage.removeItem(that.Keys.COUNTRY_CODE);
        localStorage.removeItem(that.Keys.TOPICS_LIST);
        localStorage.removeItem(that.Keys.CURRENCY);
      }
      data = {};
    };

    this.getTitle = function () {
      var data = {
        firstName: localStorage.getItem(that.Keys.FIRST_NAME_KEY),
        lastName: localStorage.getItem(that.Keys.LAST_NAME_KEY)
      };
      return data;
    };

    refresh();

    function refresh() {
      data[that.Keys.USERNAME_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.USERNAME_KEY)
        : null;
      data[that.Keys.LANGUAGE_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.LANGUAGE_KEY)
        : null;
      data[that.Keys.PASSWORD_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.PASSWORD_KEY)
        : null;
      data[that.Keys.ACCESS_TOKEN_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.ACCESS_TOKEN_KEY)
        : null;
      data[that.Keys.REFRESH_TOKEN_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.REFRESH_TOKEN_KEY)
        : null;
      data[that.Keys.USER_ID] = localStorageAvailable
        ? localStorage.getItem(that.Keys.USER_ID)
        : null;
      data[that.Keys.USER_ROLE_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.USER_ROLE_KEY)
        : null;
      data[that.Keys.FIRST_NAME_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.FIRST_NAME_KEY)
        : null;
      data[that.Keys.LAST_NAME_KEY] = localStorageAvailable
        ? localStorage.getItem(that.Keys.LAST_NAME_KEY)
        : null;
      data[that.Keys.DEFAULT_FACILITY_ID] = localStorageAvailable
        ? localStorage.getItem(that.Keys.DEFAULT_FACILITY_ID)
        : null;
      data[that.Keys.COUNTRY_CODE] = localStorageAvailable
        ? localStorage.getItem(that.Keys.COUNTRY_CODE)
        : null;
      data[that.Keys.RECEIVE_EMAIL] = localStorage.getItem(
        that.Keys.RECEIVE_EMAIL
      )
        ? localStorage.getItem(that.Keys.RECEIVE_EMAIL)
        : true;
      data[that.Keys.TOPICS_LIST] = localStorageAvailable
        ? localStorage.getItem(that.Keys.TOPICS_LIST)
        : null;
      data[that.Keys.SMALL_MENU] = localStorage.getItem(that.Keys.SMALL_MENU)
        ? localStorage.getItem(that.Keys.SMALL_MENU)
        : true;
    }

    function storageAvailable() {
      try {
        /* eslint-disable */
        var storage = window["localStorage"],
          /* eslint-enable */
          x = "__storage_test__";
        storage.setItem(x, x);
        storage.removeItem(x);
        return true;
      } catch (e) {
        return false;
      }
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("rolloverStatusCheck", rolloverStatusCheckService);

  /** @ngInject */
  function rolloverStatusCheckService() {
    // Rollover status codes (see Karcher documentation)
    var normalStatusLIst = [
      "2.0",
      "3.0",
      "4.0",
      "5.0",
      "6.0",
      "7.0",
      "9.0",
      "10.0",
      "12.0"
    ];
    var alarmStatusLIst = [
      "0.0",
      "1.0",
      "8.0",
      "11.0",
      "13.0",
      "14.0",
      "15.0",
      "16.0",
      "17.0",
      "18.0",
      "19.0",
      "20.0",
      "21.0",
      "22.0",
      "23.0",
      "24.0",
      "25.0",
      "98.0"
    ];

    this.normalStatus = function (status) {
      return normalStatusLIst.includes(status);
    };

    this.alertStatus = function (status) {
      return alarmStatusLIst.includes(status);
    };

    this.undefinedStatus = function (status) {
      return status === "99.0";
    };
  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("karcherServiceList", karcherServiceList);

  /** @ngInject */
  function karcherServiceList() {
    this.serviceList = function(data) {
      var filterData = counterList(data);
      var list = getValues(filterData);
      var serviceList = [];
      list.forEach(function(item) {
        var itemObj = {};
        for (var key in filterData) {
          switch (true) {
            case key.includes("OPERATION_COUNTER_SERVICE_NAME_" + item):
              itemObj.serviceName = filterData[key];
              break;
            case key.includes("OPERATION_COUNTER_SERVICE_SECONDS_" + item):
              itemObj.serviceSeconds = filterData[key];
              break;
            case key.includes("OPERATION_COUNTER_SERVICE_DUE_" + item):
              itemObj.serviceDue = filterData[key];
              break;
          }
        }
        serviceList.push(itemObj);
      });
      return serviceList;
    };

    this.operationList = function(data) {
      var filterData = data;
      var serviceList = [];
      for (var i = 1; i < 99; i++) {
        var itemObj = {};
        for (var key in filterData) {
          switch (true) {
            case key.includes("OPERATION_COUNTER_NAME_" + i):
              itemObj.name = filterData[key];
              break;
            case key.includes("OPERATION_COUNTER_SECONDS_" + i):
              itemObj.seconds = filterData[key];
              break;
          }
        }
        if (!angular.equals(itemObj, {})) {
          serviceList.push(itemObj);
        }
      }
      return serviceList;
    };

    this.pumpTypeList = function(data) {
      var filterData = pumpTypeList(data);
      var list = getValues(filterData);
      var serviceList = [];
      list.forEach(function(item) {
        var itemObj = {};
        for (var key in filterData) {
          switch (true) {
            case key.includes("PUMP_TYPE_PROGRAM_NAME_" + item):
              itemObj.pumpName = filterData[key];
              break;
            case key.includes("PUMP_TYPE_PROGRAM_RUNTIME_T1_" + item):
              itemObj.pumpRunTime = filterData[key];
              break;
            case key.includes("PUMP_TYPE_PROGRAM_RUNTIME_T2_" + item):
              itemObj.pumpRunTimeHoliday = filterData[key];
              break;
          }
        }
        serviceList.push(itemObj);
      });
      return serviceList;
    };

    this.programList = function(data) {
      var filterData = filterProgramList(data);
      var programList = [],
        list = [];
      for (var k = 0; k < 12; k++) {
        list.push(k); // Expected number of items
      }
      for (var i = 0; i < filterData.length; i++) {
        for (var j = 0; j < list.length; j++) {
          var itemObj = {};
          for (var key in filterData[i]) {
            switch (true) {
              case key.includes("PROGRAM_NAME_" + list[j]):
                itemObj.programName = filterData[i][key];
                break;
              case key.includes("PROGRAM_COUNTER_" + list[j]):
                itemObj.seconds = filterData[i][key];
                break;
              case key.includes("name"):
                itemObj.name = filterData[i][key];
                break;
            }
          }
          if (Object.keys(itemObj).length > 1) {
            programList.push(itemObj);
          }
        }
      }
      return {
        boxName: programList[0].name,
        list: programList
      };
    };

    this.currentList = function(data) {
      var filterData = filterCurrentList(data);
      var list = getSimpleValues(data);
      var currentList = [];
      list.forEach(function(item) {
        var itemObj = {};
        for (var key in filterData) {
          switch (true) {
            case key.includes("CURRENT_FAULT_NUMBER_" + item):
              itemObj.number = filterData[key];
              break;
            case key.includes("CURRENT_FAULT_" + item):
              itemObj.name = filterData[key];
              break;
          }
        }
        if (Object.keys(itemObj).length > 1) {
          currentList.push(itemObj);
        }
      });
      return currentList.slice(0, parseInt(data.CURRENT_FAULT_COUNT));
    };

    function counterList(data) {
      var serviceObj = {};
      for (var key in data) {
        if (key.includes("OPERATION_COUNTER_SERVICE_")) {
          serviceObj[key] = data[key];
        }
      }
      return serviceObj;
    }

    function pumpTypeList(data) {
      var serviceObj = {};
      for (var key in data) {
        if (key.includes("PUMP_TYPE_PROGRAM_")) {
          serviceObj[key] = data[key];
        }
      }
      return serviceObj;
    }

    function filterProgramList(data) {
      var washboxes = data.boxes,
        washBoxesArray = [];
      washboxes.forEach(function(washbox) {
        var washboxObj = {};
        washboxObj.name = washbox.name;
        for (var key in washbox) {
          if (key.includes("PROGRAM_NAME_")) {
            washboxObj[key] = washbox[key];
          } else if (key.includes("PROGRAM_COUNTER_")) {
            washboxObj[key] = washbox[key];
          }
        }
        washBoxesArray.push(washboxObj);
      });
      return washBoxesArray;
    }

    function filterCurrentList(data) {
      var currentObj = {};
      for (var key in data) {
        if (key.includes("CURRENT_FAULT_")) {
          currentObj[key] = data[key];
        }
      }
      return currentObj;
    }

    function getValues(data) {
      var values = [];
      var regex = /.*_(\d*_\d*)/g;

      for (var key in data) {
        var results = regex.exec(key);

        if (results !== null) {
          if (!values.includes(results[1])) {
            values.push(results[1]);
          }
        }
      }
      return values;
    }

    function getSimpleValues(data) {
      var values = [];
      var regex = /(\d)/g;

      for (var key in data) {
        var results = regex.exec(key);

        if (results !== null) {
          if (!values.includes(results[1])) {
            values.push(results[1]);
          }
        }
      }
      return values;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .service('karcherOperatingTimeDaysMapper', karcherOperatingTimeDaysMapper);

  /** @ngInject */
  function karcherOperatingTimeDaysMapper(helperService) {
    this.getDays = function (daysPoint) {
      var tempArray = [], tempObj = {};

      for (var i = 0; i < daysPoint.length; i++) {
        for (var j = 0; j < daysPoint[i].actuators.length; j++) {
          if (
            daysPoint[i].name === 'Mon' ||
            daysPoint[i].name === 'IlluminationMon' ||
            daysPoint[i].name === 'VacuumsMon'
          ) {
            tempObj.day = 'MON';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 1;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Tue' ||
            daysPoint[i].name === 'IlluminationTue' ||
            daysPoint[i].name === 'VacuumsTue'
          ) {
            tempObj.day = 'TUE';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 2;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Wed' ||
            daysPoint[i].name === 'IlluminationWed' ||
            daysPoint[i].name === 'VacuumsWed'
          ) {
            tempObj.day = 'WED';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 3;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Thu' ||
            daysPoint[i].name === 'IlluminationThu' ||
            daysPoint[i].name === 'VacuumsThu'
          ) {
            tempObj.day = 'THU';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 4;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Fri' ||
            daysPoint[i].name === 'IlluminationFri' ||
            daysPoint[i].name === 'VacuumsFri'
          ) {
            tempObj.day = 'FRI';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 5;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Sat' ||
            daysPoint[i].name === 'IlluminationSat' ||
            daysPoint[i].name === 'VacuumsSat'
          ) {
            tempObj.day = 'SAT';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 6;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Sun' ||
            daysPoint[i].name === 'IlluminationSun' ||
            daysPoint[i].name === 'VacuumsSun'
          ) {
            tempObj.day = 'SUN';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 7;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          } else if (
            daysPoint[i].name === 'Hol' ||
            daysPoint[i].name === 'IlluminationHol' ||
            daysPoint[i].name === 'VacuumsHol'
          ) {
            tempObj.day = 'HOLIDAY';
            tempObj.id = daysPoint[i].id;
            tempObj.groupValue = 8;
            tempObj.actuators = daysPoint[i].actuators;
            tempObj.pointPath =
              daysPoint.operatingTimeActivePath + '/' + daysPoint[i].id;
          }
          // Mapping actuators
          if (
            daysPoint[i].actuators[j].reference === 'START' ||
            daysPoint[i].actuators[j].reference === 'ILL_START' ||
            daysPoint[i].actuators[j].reference === 'VAC_START'
          ) {
            tempObj.from = daysPoint[i].actuators[j].value;
            tempObj.fromState = daysPoint[i].actuators[j].state;
            daysPoint[i].actuators[j].groupValue = 1;
          } else if (
            daysPoint[i].actuators[j].reference === 'STOP' ||
            daysPoint[i].actuators[j].reference === 'ILL_STOP' ||
            daysPoint[i].actuators[j].reference === 'VAC_STOP'
          ) {
            tempObj.to = daysPoint[i].actuators[j].value;
            tempObj.toState = daysPoint[i].actuators[j].state;
            daysPoint[i].actuators[j].groupValue = 2;
          } else if (
            daysPoint[i].actuators[j].reference === '24H' ||
            daysPoint[i].actuators[j].reference === 'ILL_24H' ||
            daysPoint[i].actuators[j].reference === 'VAC_24H'
          ) {
            tempObj.allDay = daysPoint[i].actuators[j].value;
            tempObj.allDayState = daysPoint[i].actuators[j].state;
            daysPoint[i].actuators[j].groupValue = 3;
          }
        }
        // Check if tempObj is empty
        if (!helperService.checkIfObjectIsEmpty(tempObj)) {
          tempArray.push(tempObj);
          tempObj = {};
        }
      }
      return tempArray;
    };
  }
})();

(function () {
	'use strict';

	angular.module('sempraWebapp').service('karcherOpenCloseHours', karcherOpenCloseHoursService);

	/** @ngInject */
	function karcherOpenCloseHoursService () {
		this.lightsOn = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('LIGHT_START')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.lightsOff = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('LIGHT_STOP')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.washBoxOn = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('OPERATING_TIME_START')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.washBoxOff = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('OPERATING_TIME_STOP')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.vacuumOn = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('OPERATING_TIME_VACUUM_START')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };
    this.vacuumOff = function(data) {
      var hours = {};
      for (var key in data) {
        if (key.includes('OPERATING_TIME_VACUUM_STOP')) {
          hours[key] = data[key];
        }
      }
      return Object.values(hours);
    };

	}
  })();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("karcherActiveAlarmsService", karcherActiveAlarmsService);

  /** @ngInject */
  function karcherActiveAlarmsService() {
    this.checkFacilityStatus = function(alarms, facilities) {
      for (var i = 0; i < facilities.length; i++) {
        for (var j = 0; j < alarms.length; j++) {
          if (facilities[i].pointId === alarms[j].facilityId) {
            facilities[i].facilityId = alarms[j].facilityId;
            facilities[i].facilityAlarm =
              alarms[j].karcherFault.washFacilityStatus === "ALARM";
            facilities[i].facilityWarning =
              alarms[j].karcherFault.washFacilityStatus === "WARNING";
            if (alarms[j].karcherFault.washFacilityStatus === "ALARM") {
              break;
            }
          }
        }
      }
      return facilities;
    };

    this.mapFacilityNameToActiveAlarmList = function(
      karcherFacilities,
      alarms
    ) {
      for (var i = 0; i < karcherFacilities.length; i++) {
        for (var j = 0; j < alarms.length; j++) {
          if (karcherFacilities[i].point.id === alarms[j].facilityId) {
            alarms[j].facilityName = karcherFacilities[i].point.name;
          }
        }
      }
      return alarms;
    };

    this.checkDeviceStatus = function(alarms, facilities) {
      for (var i = 0; i < alarms.length; i++) {
        for (var j = 0; j < facilities.boxes.length; j++) {
          for (var k = 0; k < facilities.vacuums.length; k++) {
            switch (alarms[i].boxIds.length) {
              case 1:
                if (alarms[i].boxIds[0] === facilities.boxes[j].pointId) {
                  facilities.boxes[j].alarmStatus =
                    alarms[i].karcherFault.washBayStatus;
                }
                break;
              case 0:
                break;
              default:
                if (
                    facilities.boxes[j].alarmStatus === "ALARM"
                ) {
                  break;
                }
                facilities.boxes[j].alarmStatus =
                  alarms[i].karcherFault.washBayStatus;
                break;
            }
            switch (alarms[i].vacuumIds.length) {
              case 1:
                if (alarms[i].vacuumIds[0] === facilities.vacuums[k].pointId) {
                  facilities.vacuums[k].alarmStatus =
                    alarms[i].karcherFault.vacuumStatus;
                }
                break;
              case 0:
                break;
              default:
                if (
                    facilities.vacuums[k].alarmStatus === "ALARM"
                ) {
                  break;
                }
                facilities.vacuums[k].alarmStatus =
                  alarms[i].karcherFault.vacuumStatus;
                break;
            }
          }
        }
      }
      return facilities;
    };
  }
})();

(function () {

  'use strict';

  angular.module('sempraWebapp').factory('invariant', invariantService);

  /** @ngInject */
  function invariantService() {

    var invariant = function (condition, format, a, b, c, d, e, f) {
      if (angular.isUndefined(format)) {
        throw new Error('invariant requires an error message argument');
      }

      if (!condition) {
        var error;
        if (angular.isUndefined(format)) {
          error = new Error(
            'Minified exception occurred; use the non-minified dev environment ' +
            'for the full error message and additional helpful warnings.'
          );
        } else {
          var args = [a, b, c, d, e, f];
          var argIndex = 0;
          error = new Error(
            'Invariant Violation: ' +
            format.replace(/%s/g, function () {
              return args[argIndex++];
            })
          );
        }

        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
      }
    };

    return invariant;
  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("inputValidationService", inputValidationService);

  /** @ngInject */
  function inputValidationService() {
    //Numbers from 1 to 32 are valid
    this.numberOnlyFromTo = function(number) {
      var isNumber = /^\d+$/.test(number),
        data;
      if (number < 1 || number > 32 || !isNumber) {
        data = true;
      } else {
        data = false;
      }
      return data;
    };
    //Max 30 characters
    this.maxLetters = function(letter) {
      var data;
      if (letter.length > 30) {
        data = true;
      } else {
        data = false;
      }
      return data;
    };
    //Decimals numbers are valid
    this.numberOnlyDecimal = function() {};
    //Only positive numbers are valid
    this.numberOnly = function(number, array) {
      var isNumber = /^\d+$/.test(number),
        data,
        check;
      array.forEach(function(item) {
        if (item.tokenWeight === "") return (check = true);
      });
      if (!isNumber) {
        data = true;
      } else {
        data = false;
      }
      return check ? check : data;
    };
    //Only single positive numbers is valid
    this.singleNumberOnly = function(number) {
      var isNumber = /^\d+$/.test(number);
      return !isNumber;
    };
    // Number between 1 and 99
    this.positiveNumberOnlyTo100 = function(number) {
      var isNumber = /^\d+$/.test(number),
        data;
      if (number < 1 || number > 99 || !isNumber) {
        data = true;
      } else {
        data = false;
      }
      return data;
    };

    // Validate IP addresses and ports
    this.validateInputs = function(list) {
      var reducedList = list.filter(function(item) {
        return item.checked;
      });

      var isValidated = function(data) {
        var ipAddressCheck = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/.test(
          data.ipAddress
        );

        var isNumber = /^\d+$/.test(data.port),
          portCheck;
        if (data.port < 1 || data.port > 65535 || !isNumber) {
          portCheck = false;
        } else {
          portCheck = true;
        }

        return ipAddressCheck && portCheck ? true : false;
      };

      return reducedList.every(isValidated);
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('helperService', helperService);

  /** @ngInject */
  function helperService(sessionData) {
    var currentUserId = sessionData.getValue('userId');

    this.checkIfObjectIsEmpty = function (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) return false;
      }
      return true;
    };

    this.createFileName = function (array) {
      return array.join('-');
    };

    this.setCurrentUserId = function (userId) {
      currentUserId = userId;
    };

    this.getCurrentUserId = function () {
      return currentUserId;
    };

    this.getDevelopAccess = function () {
      return ['68', '82', '84', '101', '111'].includes(this.getCurrentUserId().toString());
    };

    this.orderByRemover = function (orderBy) {
      if (orderBy.indexOf('-') > -1) {
        return orderBy.substring(1);
      } else {
        return orderBy;
      }
    };

    this.setUserDataToLocalStorageOnLogIn = function (userInfo, language) {
      sessionData.setValue(sessionData.Keys.USERNAME_KEY, userInfo.user.email);
      if(language) {
        sessionData.setValue(sessionData.Keys.LANGUAGE_KEY, language);
      }
      sessionData.setValue(
        sessionData.Keys.ACCESS_TOKEN_KEY,
        userInfo.accessToken
      );
      sessionData.setValue(
        sessionData.Keys.REFRESH_TOKEN_KEY,
        userInfo.refreshToken
      );
      sessionData.setValue(sessionData.Keys.USER_ID, userInfo.user.id);
      sessionData.setValue(sessionData.Keys.USER_ROLE_KEY, userInfo.roles);
      sessionData.setValue(
        sessionData.Keys.FIRST_NAME_KEY,
        userInfo.user.firstName
      );
      sessionData.setValue(
        sessionData.Keys.LAST_NAME_KEY,
        userInfo.user.lastName
      );
      sessionData.setValue(
        sessionData.Keys.COUNTRY_CODE,
        userInfo.countryIsoCode
      );
      sessionData.setValue(
        sessionData.Keys.RECEIVE_EMAIL,
        userInfo.receiveEmailNotificationsSelected
      );
    };

      this.showVouchersSideItemByUserId = function () {
          // HardCoded users in a production environment that can see voucher side item
          return [280, 281, 283, 284, 285, 286, 305, 315,317, 318,628,625,626,623].includes(parseInt(currentUserId));
      };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('gridUtils', gridUtilsService);

  /** @ngInject */
  function gridUtilsService($translate) {
    this.getDefaultGridSettings = function () {
      return {
        limitPerPage: 10,
        page : 1,
        order : 'id',
        translations: {
          page: $translate.instant('GRID_PAGER_PAGE'),
          rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
          of: $translate.instant('GRID_PAGER_PAGE_OF')
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('getUtcTimeService', getUtcTimeService);

  /** @ngInject */
  function getUtcTimeService () {
    this.getTime = function (date) {
      date.setHours(0, 0, 0, 0); //Midnight
      var timezoneOffeset = date.getTimezoneOffset();
      return date.getTime() - timezoneOffeset * 60000;
    };
  }
})();

(function () {
	'use strict';

	angular.module('sempraWebapp').service('getMonthsService', getMonths);

	/** @ngInject */
	function getMonths (moment) {
		this.getMonthList = function() {
			var curentLocales = moment.monthsShort();

			return curentLocales;
		};
	}
  })();

(function () {
	'use strict';

	angular.module('sempraWebapp').service('getDaysService', getDays);

	/** @ngInject */
	function getDays ($locale) {
		this.getDayList = function() {
			return $locale.DATETIME_FORMATS.DAY;
    };
    this.getShortDayList = function() {
			return $locale.DATETIME_FORMATS.SHORTDAY;
		};
	}
  })();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .service('fromArrayToPathParam', fromArrayToPathParamService);

  /** @ngInject */
  function fromArrayToPathParamService() {
    this.createPath = function (array, property) {
      if (!array || array.length === 0) {
        return '&' + property + '';
      } else if (array.length === 1) {
        return '&' + property + array[0];
      } else {
        return array
          .reduce(function (total, current) {
            total.push('&' + property + current);
            return total;
          }, [])
          .toString()
          .split(',')
          .join('');
      }
    };

    this.createOnlyPath = function (array, property) {
      if (!array || array.length === 0) {
        return '?' + property + '';
      } else if (array.length === 1) {
        return '?' + property + array[0];
      } else {
        return array
          .reduce(function (total, current, index) {
            if (index === 0) {
              total.push('?' + property + current);
            } else {
              total.push('&' + property + current);
            }
            return total;
          }, [])
          .toString()
          .split(',')
          .join('');
      }
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("feedVisibility", feedVisibilityService);

  /** @ngInject */
  function feedVisibilityService() {
    var itemsToRemoveList = ["CURRENT_TIMEOUT_SEC"];

    this.removeFeeds = function (array) {
      return array.filter(function (feed) {
        return !itemsToRemoveList.includes(feed.reference);
      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('exportToCsv', exportToCsvService);

  /** @ngInject */
  function exportToCsvService(brand, $filter) {
    /* eslint-disable */
    this.export = function (jsonDataArray, reportTitle, showLabel) {
      var csv = serializeJsonToCsv(jsonDataArray, reportTitle, showLabel);
      if (csv) {
        saveToFile(csv, reportTitle);
      }
    };

    this.exportBasicArrayToCsv = function (data, reportTitle) {
      if (!data || !data.length) {
        console.error('No data available for CSV export.');
        return;
      }

      // Filter out $$hashKey from headers
      var headers = Object.keys(data[0]).filter(function (key) {
        return key !== '$$hashKey';
      });

      var csvRows = [];
      csvRows.push(headers.join(','));

      data.forEach(function (row) {
        var values = headers.map(function (header) {
          var value = row[header] === undefined || row[header] === null ? '' : row[header];

          if (typeof value === 'number' && value.toString().length >= 10) {
            value = $filter('date')(value, 'dd/MM/yy - HH:mm');
          }

          return typeof value === 'string' &&
          (value.indexOf(',') !== -1 || value.indexOf('\n') !== -1)
            ? '"' + value.replace(/"/g, '""') + '"'
            : value;
        });
        csvRows.push(values.join(','));
      });

      var csvString = csvRows.join('\n');
      var blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      var downloadLink = document.createElement('a');
      var url = window.URL.createObjectURL(blob);
      downloadLink.href = url;
      downloadLink.download = reportTitle;
      downloadLink.style.display = 'none';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    };

    function serializeJsonToCsv(jsonData, reportTitle, showLabel) {
      if (!jsonData) {
        return null;
      }

      //If JSONData is not an object then JSON.parse will parse the JSON string in an Object
      var arrData =
        typeof jsonData != 'object' ? JSON.parse(jsonData) : jsonData;

      var CSV = '';

      //Set Report title in first row or line
      CSV += reportTitle + '\r\n\n';

      //This condition will generate the Label/Header
      if (showLabel) {
        var row = '';

        //This loop will extract the label from 1st index of on array
        for (var index in arrData[0]) {
          //Now convert each value to string and comma-separated
          row += index + ',';
        }

        row = row.slice(0, -1);

        //append Label row with line break
        CSV += row + '\r\n';
      }

      //1st loop is to extract each row
      for (var i = 0; i < arrData.length; i++) {
        var row = '';

        //2nd loop will extract each column and convert it in string comma-seprated
        for (var index in arrData[i]) {
          row += '"' + arrData[i][index] + '",';
        }

        row.slice(0, row.length - 1);

        //add a line break after each row
        CSV += row + '\r\n';
      }

      return CSV === '' ? null : CSV;
    }

    function saveToFile(csvData, reportTitle) {
      //Generate a file name (depending on color/company name)
      var fileName;
      switch (brand) {
        case 'karcher':
          fileName = '';
          break;
        default:
          fileName = 'R2W_';
          break;
      }
      //this will remove the blank-spaces from the title and replace it with an underscore
      fileName += reportTitle.replace(/ /g, '_');

      var link = document.createElement('a');

      if (navigator.msSaveBlob) {
        // IE 10+
        link.addEventListener(
          'click',
          function () {
            var blob = new Blob([csvData], {
              type: 'text/csv;charset=utf-8;'
            });
            navigator.msSaveBlob(blob, fileName + '.csv');
          },
          false
        );
      } else {
        var url = 'data:text/csv;charset=utf-8,' + escape(csvData);
        link.setAttribute('href', url);
        link.setAttribute('download', fileName + '.csv');
        link.setAttribute('target', '_blank');
        link.style.visibility = 'hidden';
      }

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
    /* eslint-enable */
  }
})();

(function () {
  'use strict';

  angular.module('eventBus', []).factory("eventBus", eventBusFactory);

  /** @ngInject */
  function eventBusFactory($rootScope) {
    var eventBus = {};

    eventBus.emitEvent = function (eventName, data) {
      data = data || {};
      $rootScope.$emit(eventName, data);
    };

    eventBus.onEvent = function (eventName, func, scope) {
      var unbind = $rootScope.$on(eventName, func);
      if (scope) {
        scope.$on('$destroy', unbind);
      }
      return unbind;
    };

    eventBus.topics = Object.freeze({
      RELOAD_POINT: 'reloadPoint',
      RELOAD_POINTS: 'reloadPoints',
      WEB_SOCKET_OPEN: 'webSocketOpen',
      WEB_SOCKET_CLOSED: 'webSocketClosed'
    });

    return eventBus;
  }
})();

(function () {

  'use strict';

  angular.module('sempraWebapp').service('dispatcher', DispatcherService);

  /** @ngInject */
  function DispatcherService(invariant, $log) {
    var lastId = 1,
      prefix = 'Id_';

    function Dispatcher() {
      this._callbacks = {};
      this._isPending = {};
      this._isHandled = {};
      this._isDispatching = false;
      this._pendingPayload = null;
    }

    Dispatcher.prototype = {
      register: function (callback) {
        var id = prefix + lastId++;
        this._callbacks[id] = callback;
        return id;
      },
      unregister: function (id) {
        invariant(
          this._callbacks[id],
          'Dispatcher.unregister(...): `%s` does not map to a registered callback.',
          id
        );
        delete this._callbacks[id];
      },
      waitFor: function (ids) {
        invariant(
          this._isDispatching,
          'Dispatcher.waitFor(...): Must be invoked while dispatching.'
        );

        for (var i = 0; i < ids.length; i++) {
          var id = ids[i];
          if (this._isPending[id]) {
            invariant(
              this._isHandled[id],
              'Dispatcher.waitFor(...): Circular dependency detected while ' +
              'waiting for `%s`.',
              id
            );

            continue;
          }

          invariant(
            this._callbacks[id],
            'Dispatcher.waitFor(...): `%s` does not map to a registered callback.',
            id
          );
          this._invokeCallback(id);
        }
      },
      dispatch: function (payload) {
        $log.log('Dispatcher#dispatch', payload);

        invariant(
          !this._isDispatching,
          'Dispatch.dispatch(...): Cannot dispatch in the middle of a dispatch.'
        );

        this._startDispatching(payload);

        try {
          for (var id in this._callbacks) {
            if (this._callbacks.hasOwnProperty(id)) {
              if (this._isPending[id]) {
                continue;
              }
              this._invokeCallback(id);
            }
          }
        } finally {
          this._stopDispatching();
        }
      },
      isDispatching: function () {
        return this._isDispatching;
      },
      _invokeCallback: function (id) {
        this._isPending[id] = true;
        this._callbacks[id].call(null, this._pendingPayload);
        this._isHandled[id] = true;
      },
      _startDispatching: function (payload) {
        for (var id in this._callbacks) {
          if (this._callbacks.hasOwnProperty(id)) {
            this._isPending[id] = false;
            this._isHandled[id] = false;
          }
        }

        this._pendingPayload = payload;
        this._isDispatching = true;
      },
      _stopDispatching: function () {
        this._pendingPayload = null;
        this._isDispatching = false;
      }
    };

    return new Dispatcher();
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('dialogsService', dialogsService);

  /** @ngInject */
  function dialogsService ($mdDialog, $translate) {
    this.showConfirmDialog = function (titleKey, textKey, actionKey) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant(titleKey))
        .textContent($translate.instant(textKey))
        .ariaLabel($translate.instant(actionKey))
        .ok($translate.instant(actionKey))
        .cancel($translate.instant('CANCEL'));

      return $mdDialog.show(confirm);
    };
    this.showConfirmTitleDialog = function (titleKey, actionKey) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant(titleKey))
        .ariaLabel($translate.instant(actionKey))
        .ok($translate.instant(actionKey))
        .cancel($translate.instant('CANCEL'));

      return $mdDialog.show(confirm);
    };
    this.showOkDialog = function (titleKey, textKey) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant(titleKey))
        .textContent($translate.instant(textKey))
        .ok($translate.instant('OK'));

      return $mdDialog.show(confirm);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('DayTranslationService', DayTranslationService);

  /** @ngInject */
  function DayTranslationService($translate) {
    var service = {
      translateDayNumber: translateDayNumber
    };

    return service;

    function translateDayNumber(dayNumber) {
      switch (dayNumber) {
        case 0:
          return $translate.instant('MON');
        case 1:
          return $translate.instant('TUE');
        case 2:
          return $translate.instant('WED');
        case 3:
          return $translate.instant('THU');
        case 4:
          return $translate.instant('FRI');
        case 5:
          return $translate.instant('SAT');
        case 6:
          return $translate.instant('SUN');
        default:
          return dayNumber;
      }
    }
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").factory("DateTime", DateTimeFactory);

  /** @ngInject */
  function DateTimeFactory() {
    function DateTime(timestamp) {
      this.timestamp = timestamp ? timestamp : moment().valueOf();
    }

    DateTime.units = {
      DAY: "day",
      MONTH: "month",
      YEAR: "year"
    };

    DateTime.prototype.set = function (year, month, day) {
      this.timestamp = moment({
        years: year,
        months: month,
        date: day
      }).valueOf();
    };

    DateTime.prototype.startOf = function (unit) {
      this.timestamp = moment(this.timestamp).startOf(unit).valueOf();
      return this;
    };

    DateTime.prototype.endOf = function (unit) {
      this.timestamp = moment(this.timestamp).endOf(unit).valueOf();
      return this;
    };

    DateTime.prototype.addDays = function (days) {
      this.timestamp = moment(this.timestamp).add(days, "days").valueOf();
      return this;
    };

    DateTime.prototype.addMonths = function (months) {
      this.timestamp = moment(this.timestamp).add(months, "months").valueOf();
      return this;
    };

    DateTime.prototype.addYears = function (years) {
      this.timestamp = moment(this.timestamp).add(years, "years").valueOf();
      return this;
    };

    DateTime.prototype.listAllMonths = function () {
      var months = moment.months();
      var data = [];
      for (var i = 0; i < months.length; i++) {
        var temp = {
          id: i + 1,
          name: months[i]
        };
        data.push(temp);
      }

      return data;
    };

    DateTime.prototype.listHours = function () {
      var data = [];
      for (var i = 0; i < 25; i++) {
        data.push(i);
      }

      return data;
    };

    DateTime.prototype.convertDateForKarcherReports = function (currentDate, timestamp) {
      // Convert minutes to milliseconds and return new value
      return timestamp - (currentDate.getTimezoneOffset() * 60000);
    };

    DateTime.prototype.listYears = function () {
      var limit = 10;
      var currentYear = moment().year();
      var data = [];
      // push last 10 years
      for (var i = currentYear - limit; i <= currentYear; i++) {
        data.push(i);
      }
      return data;
    };

    return DateTime;
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').service('checkUserRole', checkUserRoleService);

  /** @ngInject */
  function checkUserRoleService(
    sessionData,
    userRolesEnum,
    brand
  ) {
    var role = sessionData.getValue('userRole');

    this.setCurrentRoles = function (userRoles) {
      role = userRoles;
    };

    this.userRoleExist = function (userRoles) {
      var currentRoles = userRoles || role;

      if (brand === 'karcher') {
        return (
          currentRoles.includes(userRolesEnum.FACILITY_ADMIN) ||
          currentRoles.includes(userRolesEnum.MERCHANT_ADMIN) ||
          currentRoles.includes(userRolesEnum.CONTROLLER) ||
          currentRoles.includes(userRolesEnum.TECHNICAL_SUPPORT) ||
          currentRoles.includes(userRolesEnum.ADMINISTRATOR)
        );
      } else {
        return (
          currentRoles.includes(userRolesEnum.FACILITY_ADMIN) ||
          currentRoles.includes(userRolesEnum.MERCHANT_ADMIN)
        );
      }
    };


    this.hasAcceptNewTerms = function (array) {
      return array.includes('ACCEPT_TERMS_AND_CONDITIONS') && !this.userRoleExist(array);
    };

    this.isFacilityAdmin = function () {
      return role.includes(userRolesEnum.FACILITY_ADMIN);
    };

    this.isMerchantAdmin = function () {
      return role.includes(userRolesEnum.MERCHANT_ADMIN);
    };

    this.isControllerUser = function () {
      return role.includes(userRolesEnum.CONTROLLER);
    };

    this.isTechnicalSupportUser = function () {
      return role.includes(userRolesEnum.TECHNICAL_SUPPORT);
    };

    this.isAdministrator = function () {
      return role.includes(userRolesEnum.ADMINISTRATOR);
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .service(
      'checkAccessRefreshTokenValidity',
      checkAccessRefreshTokenValidityService
    );

  /** @ngInject */
  function checkAccessRefreshTokenValidityService(
    sessionData,
    jwtHelper,
    $http,
    hostDomain,
    hostProtocol,
    $log,
    $timeout,
    $state,
    checkUserRole,
    helperService
  ) {
    this.refreshToken = function () {
      var token = sessionData.getValue(sessionData.Keys.ACCESS_TOKEN_KEY),
        refreshToken = sessionData.getValue(sessionData.Keys.REFRESH_TOKEN_KEY);

      if (token && refreshToken) {
        var isTokenExpired = jwtHelper.isTokenExpired(token, 1),
          isRefreshTokenExpired = jwtHelper.isTokenExpired(refreshToken, 1);

        if (isTokenExpired && !isRefreshTokenExpired) {
          $http({
            method: 'PUT',
            cache: false,
            async: false,
            url: hostProtocol + '://' + hostDomain + '/api/refreshToken',
            headers: {
              Accept: 'text/plain, application/vnd.authentication.v2+json'
            },
            data: refreshToken
          }).then(
            function (successData) {
              helperService.setUserDataToLocalStorageOnLogIn(successData.data);
              if (checkUserRole.hasAcceptNewTerms(successData.data.roles)) {
                $state.go('app.termsAndService', {
                  marker: 'ready2wash-terms-of-service'
                });
              } else {
                sessionData.setValue(
                  sessionData.Keys.ACCESS_TOKEN_KEY,
                  successData.data.accessToken
                );
                $state.reload();
              }
            },
            function (errorData) {
              $log.error(errorData);
              sessionData.clearAll();
              $state.go('login');
            }
          );
        } else {
          $timeout(function () {
            sessionData.clearAll();
            $state.go('login');
          });
        }
      }
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('EventEmitter', eventEmitterFactory);

  /** @ngInject */
  function eventEmitterFactory() {

    function Emitter(obj) {
      if (obj) return mixin(obj);
    }

    function mixin(obj) {
      for (var key in Emitter.prototype) {
        obj[key] = Emitter.prototype[key];
      }
      return obj;
    }

    Emitter.prototype.on =
      Emitter.prototype.addEventListener = function (event, fn) {
        this._callbacks = this._callbacks || {};
        (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
          .push(fn);
        return this;
      };

    Emitter.prototype.once = function (event, fn) {
      function on() {
        this.off(event, on);
        fn.apply(this, arguments);
      }

      on.fn = fn;
      this.on(event, on);
      return this;
    };

    Emitter.prototype.off =
      Emitter.prototype.removeListener =
        Emitter.prototype.removeAllListeners =
          Emitter.prototype.removeEventListener = function (event, fn) {
            this._callbacks = this._callbacks || {};

            // all
            if (0 == arguments.length) {
              this._callbacks = {};
              return this;
            }

            // specific event
            var callbacks = this._callbacks['$' + event];
            if (!callbacks) return this;

            // remove all handlers
            if (1 == arguments.length) {
              delete this._callbacks['$' + event];
              return this;
            }

            // remove specific handler
            var cb;
            for (var i = 0; i < callbacks.length; i++) {
              cb = callbacks[i];
              if (cb === fn || cb.fn === fn) {
                callbacks.splice(i, 1);
                break;
              }
            }
            return this;
          };

    Emitter.prototype.emit = function (event) {
      this._callbacks = this._callbacks || {};
      var args = [].slice.call(arguments, 1)
        , callbacks = this._callbacks['$' + event];

      if (callbacks) {
        callbacks = callbacks.slice(0);
        for (var i = 0, len = callbacks.length; i < len; ++i) {
          callbacks[i].apply(this, args);
        }
      }

      return this;
    };

    Emitter.prototype.listeners = function (event) {
      this._callbacks = this._callbacks || {};
      return this._callbacks['$' + event] || [];
    };

    Emitter.prototype.hasListeners = function (event) {
      return !!this.listeners(event).length;
    };

    return Emitter;
  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("SettingsViewModel", settingsViewModelFactory);

  /** @ngInject */
  function settingsViewModelFactory(
    deviceActions,
    modelUtils,
    facilityUtils,
    washBoxUtils,
    tapWaterSubsystemUtils,
    reverseOsmosisSubsystemUtils,
    demiWaterSubsystemUtils,
    softenedWaterSubsystemUtils,
    doserSubsystemUtils,
    ModBusTypeEnum
  ) {
    function SettingsViewModel(deviceSerial) {
      this.deviceSerial = deviceSerial;
      this.lightsAuto = false;
      this.lightsOn = false;
      this.boxes = [];
      this.modbusType = "";
      this.noDecimals = '^[0-9]+[0-9]*$';

      init.call(this);
    }

    SettingsViewModel.prototype.destroy = function() {};

    SettingsViewModel.prototype.resetAllCashCount = function() {
      this.boxes.forEach(function(box) {
        box.cashCount.value = 0;
      });
    };

    SettingsViewModel.prototype.resetAllCoinsCount = function() {
      this.boxes.forEach(function(box) {
        box.coinsCount.value = 0;
      });
    };

    SettingsViewModel.prototype.resetAllEurokeyCount = function() {
      this.boxes.forEach(function(box) {
        box.euroKeyCount.value = 0;
      });
    };

    SettingsViewModel.prototype.getActuationData = function() {
      var result = {
        deviceSerial: this.deviceSerial,
        data: []
      };

      tryPushActuationData(result.data, this.lightsAuto, fromBool);
      tryPushActuationData(result.data, this.lightsOn, fromBool);
      tryPushActuationData(result.data, this.groupsOn, fromBool);
      tryPushActuationData(result.data, this.groupsAuto, fromBool);
      tryPushActuationData(result.data, this.antifreezeOn, fromBool);
      tryPushActuationData(result.data, this.antifreezeFrom);
      tryPushSpecialActuationData(result.data, this.lightsFrom);
      tryPushSpecialActuationData(result.data, this.lightsTo);
      tryPushActuationData(result.data, this.lightsFromTimeHour);
      tryPushActuationData(result.data, this.lightsFromTimeMinute);
      tryPushActuationData(result.data, this.lightsToTimeHour);
      tryPushActuationData(result.data, this.lightsToTimeMinute);
      tryPushSpecialActuationData(result.data, this.groupsFrom);
      tryPushSpecialActuationData(result.data, this.groupsTo);
      tryPushActuationData(result.data, this.groupsFromTimeHour);
      tryPushActuationData(result.data, this.groupsFromTimeMinute);
      tryPushActuationData(result.data, this.groupsToTimeHour);
      tryPushActuationData(result.data, this.groupsToTimeMinute);
      tryPushActuationData(result.data, this.tariffsFromTimeHour);
      tryPushActuationData(result.data, this.tariffsFromTimeMinute);
      tryPushActuationData(result.data, this.tariffsToTimeHour);
      tryPushActuationData(result.data, this.tariffsToTimeMinute);
      tryPushActuationDataArray(result.data, this.tariffs);
      tryPushActuationData(result.data, this.tariffsOn, fromBool);

      tryPushActuationData(result.data, this.doserWork);
      tryPushActuationData(result.data, this.doserPause);

      tryPushActuationData(result.data, this.reverseOsmosis, fromBool);
      tryPushActuationData(result.data, this.reverseOsmosisAndGroups, fromBool);

      this.boxes.forEach(function(box) {
        tryPushActuationData(this, box.boxState, fromBool);
        tryPushActuationData(this, box.cashCount, fromCurrency);
        tryPushActuationData(this, box.coinsCount, fromCurrency);
        tryPushActuationData(this, box.euroKeyCount, fromCurrency);
      }, result.data);

      tryPushActuationData(result.data, this.doserWork);
      tryPushActuationData(result.data, this.doserPause);
      tryPushActuationData(result.data, this.delay6M1);
      tryPushActuationData(result.data, this.delayBfv);
      tryPushActuationData(result.data, this.delayLps);

      return result;
    };

    SettingsViewModel.prototype.refresh = function(deviceJson, modbus) {
      var facilityPoint;

      this.modbusType = modbus;

      if (deviceJson === null) {
        return;
      }

      facilityPoint = facilityUtils.getFacilityPoint(deviceJson);

      //device refresh
      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();

      // FACILITY
      this.pointId = facilityPoint.id;
      this.name = facilityPoint.name;

      this.lightsAuto = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_RASVJETA_AUTO
      );
      this.lightsOn = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_RASVJETA_ON
      );
      this.groupsAuto = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_GRUPE_AUTO
      );
      this.groupsOn = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_GRUPE_ON
      );
      this.antifreezeOn = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_ANTISMRZ
      );
      this.antifreezeFrom = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_TEMPER_ANTISMRZ
      );
      // TURN ON/OFF REVERSE OSMOSIS
      this.reverseOsmosis = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_REV_OSMOZA
      );
      // TURN ON/OFF GROUPS AND REVERSE OSMOSIS (WHOLE TECHNOLOGY)
      this.reverseOsmosisAndGroups = getActuatorObject(
        facilityUtils.getActuator,
        facilityPoint,
        facilityUtils.ActuatorReferences.OP_BUTTON_TEHNOLOGIJA
      );
      // FOR ETHERNET AND SERIAL MODBUS TYPE
      if (modbus !== ModBusTypeEnum.ETHERNET_241) {
        this.lightsFrom = getSpecialActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJETA_START
        );
        this.lightsTo = getSpecialActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJETA_STOP
        );
        this.groupsFrom = getSpecialActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_SCHED_GRUPE_START
        );
        this.groupsTo = getSpecialActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_SCHED_GRUPE_STOP
        );
        // ===================================================
        this.lightsFromTimeHour = null;
        this.lightsFromTimeMinute = null;
        this.lightsToTimeHour = null;
        this.lightsToTimeMinute = null;
        this.groupsFromTimeHour = null;
        this.groupsFromTimeMinute = null;
        this.groupsToTimeHour = null;
        this.groupsToTimeMinute = null;
        this.tariffsFromTimeHour = null;
        this.tariffsFromTimeMinute = null;
        this.tariffsToTimeHour = null;
        this.tariffsToTimeMinute = null;
        this.activeTarrif = null;
        this.tariffsOn = null;
      }

      // FOR ETHERNET_241 MODBUS TYPE
      if (modbus === ModBusTypeEnum.ETHERNET_241) {
        this.lightsFromTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJ_SCHEDULE_START_HOUR
        );
        this.lightsFromTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJ_SCHEDULE_START_MINUTE
        );
        this.lightsToTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJ_SCHEDULE_STOP_HOUR
        );
        this.lightsToTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_RASVJ_SCHEDULE_STOP_MINUTE
        );
        this.groupsFromTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_NAPAJ_SCHEDULE_START_HOUR
        );
        this.groupsFromTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_NAPAJ_SCHEDULE_START_MINUTE
        );
        this.groupsToTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_NAPAJ_SCHEDULE_STOP_HOUR
        );
        this.groupsToTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_NAPAJ_SCHEDULE_STOP_MINUTE
        );
        this.tariffsFromTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_START_HOUR
        );
        this.tariffsFromTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_START_MINUTE
        );
        this.tariffsToTimeHour = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_STOP_HOUR
        );
        this.tariffsToTimeMinute = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_STOP_MINUTE
        );
        this.activeTarrif = facilityUtils.getFeedValue(
          facilityPoint,
          facilityUtils.FeedReferences.OP_TARIFE_SCHEDULE_ACTIVE_Q
        );
        this.tariffsOn = getActuatorObject(
          facilityUtils.getActuator,
          facilityPoint,
          facilityUtils.ActuatorReferences.OP_TARIFE_SCHEDULE_BUTTON_ENABLE
        );
        // ==============================================================
        this.lightsFrom = null;
        this.lightsTo = null;
        this.groupsFrom = null;
        this.groupsTo = null;
      }

      // BOXES
      this.boxes = [];
      washBoxUtils.getWashBoxPoints(facilityPoint).forEach(function(boxJson) {
        this.push({
          name: boxJson.name,
          // serviceHoursCount: {value:123},  //washBoxUtils.getActuatorValue(boxJson, washBoxUtils.ActuatorReferences.OP_CC_KOVANICE_RESET),
          cashCount: getActuatorObject(
            washBoxUtils.getActuator,
            boxJson,
            washBoxUtils.ActuatorReferences.OP_CC_KOVANICE_RESET
          ), //washBoxUtils.getActuatorValue(boxJson, washBoxUtils.ActuatorReferences.OP_CC_KOVANICE_RESET),
          coinsCount: getActuatorObject(
            washBoxUtils.getActuator,
            boxJson,
            washBoxUtils.ActuatorReferences.OP_CC_ZETONI_RESET
          ), //washBoxUtils.getActuatorValue(boxJson, washBoxUtils.ActuatorReferences.OP_CC_ZETONI_RESET),
          euroKeyCount: getActuatorObject(
            washBoxUtils.getActuator,
            boxJson,
            washBoxUtils.ActuatorReferences.OP_CC_KEY_KREDIT_RESET
          ), //washBoxUtils.getActuatorValue(boxJson, washBoxUtils.ActuatorReferences.OP_CC_KEY_KREDIT_RESET)
          boxState: getActuatorObject(
            washBoxUtils.getActuator,
            boxJson,
            washBoxUtils.ActuatorReferences.OP_BUTTON
          ),
          resetCash: function() {
            this.cashCount.value = 0;
          },
          resetCoins: function() {
            this.coinsCount.value = 0;
          },
          resetEurokey: function() {
            this.euroKeyCount.value = 0;
          }
        });
      }, this.boxes);

      // TARIFFS
      this.tariffs = getTariffObject(
        facilityUtils.getTariffs(facilityPoint)
      ).sort(function(a, b) {
        return a.name > b.name ? 1 : -1;
      });

      // DOSER
      var doserPoint = doserSubsystemUtils.getDoserSubsystemPoint(
        facilityPoint
      );
      this.doserWork = getActuatorObject(
        doserSubsystemUtils.getActuator,
        doserPoint,
        doserSubsystemUtils.ActuatorReferences.OP_PRASAK_VRIJEME_RADA
      );
      this.doserPause = getActuatorObject(
        doserSubsystemUtils.getActuator,
        doserPoint,
        doserSubsystemUtils.ActuatorReferences.OP_PRASAK_VRIJEME_PAUZE
      );

      // REVERSE OSMOSIS
      var roPoint = reverseOsmosisSubsystemUtils.getReverseOsmosisSubsystemPoint(
        facilityPoint
      );
      this.delay6M1 = getActuatorObject(
        reverseOsmosisSubsystemUtils.getActuator,
        roPoint,
        reverseOsmosisSubsystemUtils.ActuatorReferences.OP_ZADRSKA_CRPKA_OSMOZA
      );
      this.delayBfv = getActuatorObject(
        reverseOsmosisSubsystemUtils.getActuator,
        roPoint,
        reverseOsmosisSubsystemUtils.ActuatorReferences.OP_ZADRSKA_BFV_OSMOZA
      );
      this.delayLps = getActuatorObject(
        reverseOsmosisSubsystemUtils.getActuator,
        roPoint,
        reverseOsmosisSubsystemUtils.ActuatorReferences.OP_TON_TLAK_REV_OSM
      );
    };

    function tryPushActuationData(dataArray, actuator, valueFormatterCallback) {
      if (!actuator) {
        return;
      }
      if (actuator.value !== actuator.oldValue) {
        dataArray.push({
          id: actuator.id,
          value: valueFormatterCallback
            ? valueFormatterCallback(actuator.value)
            : actuator.value
        });
      }
    }

    function tryPushSpecialActuationData(
      dataArray,
      actuator,
      valueFormatterCallback
    ) {
      if (!actuator) {
        return;
      }
      var toStringHour = actuator.valueHour.toString();
      var toStringMinute = actuator.valueMinute.toString();
      toStringHour =
        toStringHour.length === 1 ? "0" + toStringHour : toStringHour;
      toStringMinute =
        toStringMinute.length === 1 ? "0" + toStringMinute : toStringMinute;
      actuator.value = toStringHour + toStringMinute;

      if (actuator.value !== actuator.oldValue) {
        dataArray.push({
          id: actuator.id,
          value: valueFormatterCallback
            ? valueFormatterCallback(actuator.value)
            : actuator.value
        });
      }
    }

    function tryPushActuationDataArray(dataArray, actuators) {
      actuators.forEach(function(actuator) {
        if (actuator.value !== actuator.oldValue) {
          dataArray.push({
            id: actuator.id,
            value: actuator.value
          });
        }
      });
    }

    return SettingsViewModel;

    function init() {}

    function getActuatorObject(
      getActuatorCallback,
      pointJson,
      reference,
      formatterCallback
    ) {
      var actuatorJson = getActuatorCallback(pointJson, reference),
        result = {};

      if(!actuatorJson) {
        return;
      }

      result["id"] = actuatorJson.id;
      result["value"] = result[
        "oldValue"
      ] = modelUtils.parseActuatorCurrentValue(
        actuatorJson.value,
        actuatorJson.actuatorType
      );

      return formatterCallback ? formatterCallback(result) : result;
    }

    function getSpecialActuatorObject(
      getActuatorCallback,
      pointJson,
      reference
    ) {
      var actuatorJson = getActuatorCallback(pointJson, reference),
        result = {};

      if(!actuatorJson) {
        return;
      }

      result["id"] = actuatorJson.id;
      result["value"] = result[
        "oldValue"
      ] = modelUtils.parseActuatorCurrentValue(
        actuatorJson.value,
        actuatorJson.actuatorType
      );
      result["valueHour"] = modelUtils.parseActuatorCurrentHourValue(
        actuatorJson.value
      );
      result["valueMinute"] = modelUtils.parseActuatorCurrentMinuteValue(
        actuatorJson.value
      );

      return result;
    }

    function getTariffObject(tariffsList) {
      return tariffsList.reduce(function(newList, tariff) {
        newList.push({
          id: tariff.id,
          name: tariff.reference.charAt(3) + tariff.reference.charAt(4),
          value: parseInt(tariff.value),
          oldValue: parseInt(tariff.value)
        });
        return newList;
      }, []);
    }

    function fromCurrency(value) {
      return value * 10;
    }

    function fromBool(value) {
      return value ? "1" : "0";
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("SettingsController", SettingsController);

  /** @ngInject */
  function SettingsController(
    deviceActions,
    $scope,
    $state,
    $stateParams,
    SettingsViewModel,
    broker,
    webSocketsStore,
    layoutActions
  ) {
    var vm = this;
    // _webSocketStoreConnectedChangeHandler = subscribeToSocket,
    // _onFeedChangedHandler = refreshDeviceFeed;

    vm.facility = new SettingsViewModel($stateParams.id);

    vm.cancelChanges = function() {
      goToDetailsPage(vm.facility.deviceSerial);
    };

    vm.saveChanges = function() {
      var actuationData = vm.facility.getActuationData();

      deviceActions
        .actuate(actuationData.deviceSerial, actuationData.data)
        .then(
          function() {
            goToDetailsPage(vm.facility.deviceSerial);
          },
          function() {
            //todo error handling
          }
        );
    };

    vm.disableInput = function(value) {
      return value === null || value === "";
    };

    function init() {
      layoutActions.showLoader();

      deviceActions
        .getDevice(vm.facility.deviceSerial)
        .then(function(deviceJson) {
          layoutActions.hideLoader();

          vm.facility.refresh(deviceJson, deviceJson.modbusType);

          // subscribeToSocket();
          // webSocketsStore.on(webSocketsStore.events.CONNECTED_CHANGE, _webSocketStoreConnectedChangeHandler);
          // webSocketsStore.on(webSocketsStore.events.DEVICE_FEED_CHANGE, _onFeedChangedHandler);
          // webSocketsStore.on(webSocketsStore.events.DEVICE_ACTUATOR_CHANGE, deviceActuatorChange);
        });

      $scope.$on("$destroy", function() {
        vm.facility.destroy();
        // webSocketsStore.off(webSocketsStore.events.CONNECTED_CHANGE, _webSocketStoreConnectedChangeHandler);
        // webSocketsStore.off(webSocketsStore.events.DEVICE_FEED_CHANGE, _onFeedChangedHandler);
        // webSocketsStore.off(webSocketsStore.events.DEVICE_ACTUATOR_CHANGE, deviceActuatorChange);
      });
    }

    // function subscribeToSocket () {
    //   if (webSocketsStore.isConnected()) {
    //     var serialArray = [];
    //     serialArray.push(vm.facility.deviceSerial);

    //     broker.subscribeToDeviceChanges(serialArray);
    //     broker.subscribeToFeedChanges(serialArray);
    //     broker.subscribeToActuatorChanges(serialArray);
    //   }
    // };

    // function deviceConectionChange () {
    //   $timeout(function () {
    //     console.log("device je konektovan");
    //   }, 50);
    // };

    // function refreshDeviceFeed () {
    //   $timeout(function () {
    //     console.log("feed podatak se promenio");
    //   }, 50);
    // };

    // function deviceActuatorChange(){
    //   $timeout(function () {
    //     console.log("aktuator podatak se promenio");
    //   }, 50);
    // };

    init();

    function goToDetailsPage(deviceSerial) {
      $state.go("app.dashboardTechnology.facilityDetails", {
        id: deviceSerial
      });
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ResetPasswordController', ResetPasswordController);

  /** @ngInject */
  function ResetPasswordController(
    $scope,
    ActivateAccountViewModel,
    userActions,
    $state,
    $stateParams,
    $log,
    brand,
    $translate,
    sessionData,
    $location,
    locales,
    dispatcher,
    ActionTypesEnum,
    applicationStore,
    $mdToast,
    $filter,
    checkUserRole,
    helperService
  ) {
    var vm = this;

    vm.account = new ActivateAccountViewModel();
    vm.inputType = 'password';
    vm.inputReType = 'password';

    init();

    vm.resetPassword = function () {
      var code = $stateParams.code;
      var data = {
        password: vm.account.password,
        code: code
      };

      userActions.resetPassword(data).then(function (response) {
        userActions
          .signIn(response.toLowerCase(), vm.account.password)
          .then(function (userInfo) {
            checkUserRole.setCurrentRoles(userInfo.roles);
            helperService.setCurrentUserId(userInfo.user.id);
            helperService.setUserDataToLocalStorageOnLogIn(userInfo, 'en');

            if (checkUserRole.userRoleExist()) {
              $state.go('app.dashboardTechnology');
            } else {
              sessionData.clearAll();
              vm.login.hasErrors = true;
              vm.login.errorMessage = $translate.instant('ERROR_LOGIN_ROLE');
            }
          });
      });
    };

    vm.checkPassword = function (form) {
      var password = form.password.$viewValue;
      var repeatPassword = form.passwordRepeat.$viewValue;

      vm.account.passwordIdentical =
        password === repeatPassword && password !== '' && repeatPassword !== '';
    };

    vm.showPassword = function () {
      vm.inputType = vm.inputType === 'text' ? 'password' : 'text';
    };

    vm.showReenterPassword = function () {
      vm.inputReType = vm.inputReType === 'text' ? 'password' : 'text';
    };

    function init() {
      applicationStore.on(
        applicationStore.events.TOAST_CHANGE,
        showSimpleToast
      );
      var setUserLanguage = $location.search().lang;
      locales.setLanguage(setUserLanguage);
      sessionData.setValue(sessionData.Keys.LANGUAGE_KEY, setUserLanguage);
      vm.welcomeTitle = brand === 'karcher';
      $scope.$on('destroy', function () {});
    }

    function showSimpleToast(data) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent($translate.instant($filter('replacews')(data)))
          .position('bottom right')
          .hideDelay(3000)
      );
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("KarcherReportsViewModel", karcherReportsViewModelFactory);

  /** @ngInject */
  function karcherReportsViewModelFactory(
    DateTime,
    $translate
  ) {
    function KarcherReportsViewModel() {
      var that = this;

      // Date for time zone of selected facility
      this.chartData = {
        data: null,
        x: {
          type: "timeseries",
          tick: {
            culling: { max: 15 },
            rotate: 60,
            multiline: true,
            format: function (item) {
              switch (that.selectedTimeFrame) {
                case "HOURLY":
                  return moment.tz(item, that.facilityTimeZone).format("DD/MM/YY HH:mm");
                case "DAILY":
                  return moment.tz(item, that.facilityTimeZone).format("DD/MM/YY");
                case "WEEKLY":
                  that.chartData.x.type = 'x';
                  return item;
                case "MONTHLY":
                  return moment.tz(item, that.facilityTimeZone).format("MM/YY");
                case "YEARLY":
                  return moment.tz(item, that.facilityTimeZone).format("YYYY");
              }
            }
          }
        },
        y: {
          tick: {
            rotate: 60
          }
        }
      };
      this.facilityTimeZone = "";
      this.reportFrom = null;
      this.reportTo = null;
      this.washFacilityList = [];
      this.selectedWashFacility = "";
      this.placeHolderText = $translate.instant("FACILITY_NAME");
      this.selectedReport = "";
      this.selectedTimeFrame = "HOURLY";
      this.isChartVisible = false;
      this.subPointList = [];
      this.timeFrameList = ["HOURLY", "DAILY", "WEEKLY", "MONTHLY", "YEARLY"];
      this.weatherHistoryData = [];
      this.weatherLocationData = [];
      this.reportNameList = [
        {
          id: 1,
          name: $translate.instant('KARCHER_REPORT_1')
        },
        {
          id: 2,
          name: $translate.instant('KARCHER_REPORT_2')
        },
        {
          id: 3,
          name: $translate.instant('KARCHER_REPORT_3')
        },
        {
          id: 4,
          name: $translate.instant('KARCHER_REPORT_4')
        },
        {
          id: 5,
          name: $translate.instant('KARCHER_REPORT_5')
        },
        {
          id: 6,
          name: $translate.instant('KARCHER_REPORT_6')
        },
        {
          id: 7,
          name: $translate.instant('KARCHER_REPORT_7')
        },
        {
          id: 8,
          name: $translate.instant('KARCHER_REPORT_8')
        },
        {
          id: 9,
          name: $translate.instant('KARCHER_REPORT_9')
        },
        {
          id: 10,
          name: $translate.instant('KARCHER_REPORT_10')
        }
      ];

      this.reportFrom = new Date(
        new DateTime().startOf(DateTime.units.MONTH).timestamp
      );
      this.reportTo = new Date(
        new DateTime().endOf(DateTime.units.DAY).timestamp
      );
    }

    KarcherReportsViewModel.prototype.destroy = function () {};

    KarcherReportsViewModel.prototype.refreshKarcherReportsData = function (
      data
    ) {
      this.chartData.data = data;
      this.isChartVisible = this.chartData.data.total !== 0;
    };

    KarcherReportsViewModel.prototype.refreshWeatherHistoryData = function (
        data
    ) {
      this.weatherHistoryData = data.forecast.forecastday;
      this.weatherLocationData = data.location;
    };

    KarcherReportsViewModel.prototype.refreshWashFacilityList = function (
      data
    ) {
      this.washFacilityList = data;
    };

    KarcherReportsViewModel.prototype.refreshSubPointList = function (data) {
      this.subPointList = data;
    };

    KarcherReportsViewModel.prototype.getTimezoneForSelectedFacility = function (selectedFacility) {
      this.facilityTimeZone = selectedFacility[0].timeZone;
    };

    return KarcherReportsViewModel;
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("ReportsKarcherController", reportsKarcherController);

  /** @ngInject */
  function reportsKarcherController(
    $scope,
    $state,
    KarcherReportsViewModel,
    layoutActions,
    organizationActions,
    localeFilters,
    $timeout,
    reportExportUtil,
    $translate,
    exportToCsv,
    karcherReportActions,
    weatherKarcherActions,
    $filter,
    DateTime,
    helperService
  ) {
    var vm = this,
      currentDate = new Date();

    vm.isChartVisible = false;
    vm.enableSubPointsInput = false;
    vm.karcherReports = new KarcherReportsViewModel();

    init();

    vm.searchData = function () {
      layoutActions.showLoader();
      vm.karcherReports.refreshKarcherReportsData({
        groupNames: [],
        groupTotal: [],
        groupDada: [],
        total: 0,
        unit: ""
      });

      // Try period is expired
      refreshWeatherHistoryData();

      var data = {
        facilityId: vm.karcherReports.selectedWashFacility,
        timeUnit: vm.karcherReports.selectedTimeFrame,
        since: new DateTime().convertDateForKarcherReports(
          currentDate,
          vm.karcherReports.reportFrom.getTime()
        ),
        to: new DateTime().convertDateForKarcherReports(
          currentDate,
          vm.karcherReports.reportTo.getTime()
        )
      };

      switch (vm.karcherReports.selectedReport) {
        case 1:
          karcherReportActions
            .getRolloverReportTurnover(data)
            .then(function (response) {
              vm.karcherReports.refreshKarcherReportsData(response);
              layoutActions.hideLoader();
            });
          break;
        case 2:
          data.type = "TOTAL";
          getRolloverReportData(data);
          break;
        case 3:
          data.type = "END_CORRECT";
          getRolloverReportData(data);
          break;
        case 4:
          data.type = "EXTERNAL";
          getRolloverReportData(data);
          break;
        case 5:
          data.type = "MANUAL";
          getRolloverReportData(data);
          break;
        case 6:
          data.type = "CANCELED";
          getRolloverReportData(data);
          break;
        case 7:
          data.type = "POWER_FAILURE";
          getRolloverReportData(data);
          break;
        case 8:
          data.bayId = vm.karcherReports.selectedSubPoint;
          karcherReportActions
            .getJetwashReportWorkingHoursPerProgram(data)
            .then(function (response) {
              vm.karcherReports.refreshKarcherReportsData(response);
              layoutActions.hideLoader();
            });
          break;
        case 9:
          karcherReportActions
            .getJetwashReportTurnoverPerBay(data)
            .then(function (response) {
              vm.karcherReports.refreshKarcherReportsData(response);
              layoutActions.hideLoader();
            });
          break;
        case 10:
          data.bayId = vm.karcherReports.selectedSubPoint;
          karcherReportActions
            .getJetwashReportTurnoverPerChannel(data)
            .then(function (response) {
              vm.karcherReports.refreshKarcherReportsData(response);
              layoutActions.hideLoader();
            });
          break;
      }
    };

    vm.changeReportName = function () {
      vm.karcherReports.selectedWashFacility = "";
      vm.karcherReports.selectedSubPoint = "";
    };

    vm.getAvailableBoxes = function (id) {
      vm.karcherReports.getTimezoneForSelectedFacility(vm.karcherReports.washFacilityList.filter(function(facility) {
        return facility.id === id;
      }));
      vm.enableSubPointsInput =
        vm.karcherReports.selectedReport === 8 ||
        vm.karcherReports.selectedReport === 10;
      layoutActions.showLoader();
      vm.karcherReports.selectedWashFacility = id;
      if (vm.enableSubPointsInput) {
        karcherReportActions
          .getWashFacilityBoxesByWashFacilityId(id)
          .then(function (response) {
            vm.karcherReports.refreshSubPointList(response);
            layoutActions.hideLoader();
          });
      } else {
        layoutActions.hideLoader();
      }
    };

    vm.clearWashFacilityInput = function () {
      vm.karcherReports.selectedWashFacility = "";
    };

    vm.exportToCsvReports = function () {
      var fileTitleData = [];
      fileTitleData.push(
        vm.karcherReports.reportNameList.filter(function (item) {
          return item.id === vm.karcherReports.selectedReport;
        })[0].name
      );
      fileTitleData.push(
        vm.karcherReports.washFacilityList.filter(function (item) {
          return item.id === vm.karcherReports.selectedWashFacility;
        })[0].name
      );
      if(vm.enableSubPointsInput) {
        fileTitleData.push(
            $translate.instant(
                vm.karcherReports.subPointList.filter(function (item) {
                  return item.id === vm.karcherReports.selectedSubPoint;
                })[0].name
            )
        );
      }
      fileTitleData.push(
        $filter("date")(vm.karcherReports.reportFrom, "dd-MM-yyyy")
      );
      fileTitleData.push(
        $filter("date")(vm.karcherReports.reportTo, "dd-MM-yyyy")
      );
      // Extend csv report with totals for Karcher brand. I don't want to update reportExportUtils because of R2W reporting
      vm.karcherReports.chartData.data.groupsData.unshift({
        groupValue: "Total",
        values: vm.karcherReports.chartData.data.groupTotal
      });
      var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
        $translate.instant("DATE"),
        vm.karcherReports.chartData.data,
        reportExportUtil.ValueFormattersEnum.DATE,
        reportExportUtil.ValueFormattersEnum.NUMBER
      );

      exportToCsv.export(
        jsonArrayForExport,
        helperService.createFileName(fileTitleData),
        true
      );
    };

    function init() {
      layoutActions.showLoader();
      $scope.$on("$destroy", destroy);
      karcherReportActions.getWashFacilityShortList().then(function (res) {
        vm.karcherReports.refreshWashFacilityList(res);
        layoutActions.hideLoader();
      });
    }

    function refreshWeatherHistoryData() {
      var selectedItem = vm.karcherReports.washFacilityList.filter(function (
          item
        ) {
          return item.id === vm.karcherReports.selectedWashFacility;
        }),
        selectedDateFrom = $filter("date")(
          vm.karcherReports.reportFrom,
          "yyyy-MM-dd"
        ),
        selectedDateTo = $filter("date")(
          vm.karcherReports.reportTo,
          "yyyy-MM-dd"
        );

      weatherKarcherActions
        .getHistoryWeather(
          selectedItem[0].location.latitude,
          selectedItem[0].location.longitude,
          selectedDateFrom,
          selectedDateTo
        )
        .then(function (weatherData) {
          vm.karcherReports.refreshWeatherHistoryData(weatherData);
        });
    }

    function getRolloverReportData(data) {
      karcherReportActions
        .getRolloverReportWashesPerProgram(data)
        .then(function (response) {
          vm.karcherReports.refreshKarcherReportsData(response);
          layoutActions.hideLoader();
        });
    }

    function destroy() {
      vm.karcherReports.destroy();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory(
      'KarcherBuilderReportsViewModel',
      karcherBuilderReportsViewModelFactory
    );

  /** @ngInject */
  function karcherBuilderReportsViewModelFactory(
    DateTime,
    $translate,
    $http,
    hostProtocol,
    hostDomain,
    layoutActions,
    $q,
    AppStateService,
    DayTranslationService
  ) {
    function KarcherBuilderReportsViewModel() {
      this.tableChartData = {};
      this.facilityTimeZone = '';
      this.washFacilityList = [];
      this.placeHolderText = $translate.instant('FACILITY_NAME');
      this.selectedReport = '';
      this.firstRowTableColumnTitle = '';
      this.isChartVisible = false;
      this.isTableVisible = false;
      this.isChartIncluded = false;
      this.subPointList = [];
      this.weatherHistoryData = [];
      this.weatherLocationData = [];
      this.reportNameList = [];
      this.reportBodyData = {};
      this.chartData = this.createChartDataConfig();
      this.dependsOnData = {};
      this.reportConfigurationData = null;
    }

    KarcherBuilderReportsViewModel.prototype.destroy = function () {};

    KarcherBuilderReportsViewModel.prototype.createChartDataConfig =
      function () {
        var that = this;
        return {
          data: null,
          x: {
            tick: {
              rotate: 60,
              multiline: true,
              format: function (item) {
                switch (that.reportBodyData.timeFrame) {
                  case 'HOURLY':
                    return moment
                      .tz(item, that.facilityTimeZone)
                      .format('DD/MM/YY HH:mm');
                  case 'DAILY':
                    return moment
                      .tz(item, that.facilityTimeZone)
                      .format('DD/MM/YY');
                  case 'WEEKLY':
                    that.chartData.x.type = 'x';
                    return item;
                  case 'MONTHLY':
                    return moment
                      .tz(item, that.facilityTimeZone)
                      .format('MM/YY');
                  case 'YEARLY':
                    return moment
                      .tz(item, that.facilityTimeZone)
                      .format('YYYY');
                  default:
                    that.chartData.x.type = 'category';
                    that.chartData.x.tick = {
                      rotate: 0,
                      multiline: false,
                      culling: false
                    };
                    return item;
                }
              }
            }
          },
          y: {
            tick: {
              rotate: 60
            }
          }
        };
      };

    KarcherBuilderReportsViewModel.prototype.refreshKarcherReportsList =
      function (data) {
        this.reportNameList = data;
      };

    KarcherBuilderReportsViewModel.prototype.getReportGrouping = function (
      report
    ) {
      switch (report) {
        case 3:
          this.firstRowTableColumnTitle = $translate.instant('HOURS');
          break;
        case 4:
          this.firstRowTableColumnTitle = $translate.instant('DAY');
          break;
        case 11:
          this.firstRowTableColumnTitle = '';
          break;
        case 14:
          this.firstRowTableColumnTitle = '';
          break;
        case 15:
          this.firstRowTableColumnTitle = '';
          break;
        case 16:
          this.firstRowTableColumnTitle = '';
          break;
        default:
          this.firstRowTableColumnTitle = $translate.instant('DATE');
          break;
      }

      this.chartData = this.createChartDataConfig();
    };

    KarcherBuilderReportsViewModel.prototype.refreshConfigurationData =
      function (data) {
        var that = this;
        this.reportBodyData.timeFrame = 'CUSTOM';
        var stateCheck = AppStateService.getState();
        data.forEach(function (item) {
          if (item.type === 'date-input') {
            // Save to state
            if (!stateCheck.fromModel) {
              AppStateService.setState(
                'fromModel',
                new Date(new DateTime().startOf(DateTime.units.MONTH).timestamp)
              );
            }
            if (!stateCheck.toModel) {
              AppStateService.setState(
                'toModel',
                new Date(new DateTime().endOf(DateTime.units.DAY).timestamp)
              );
            }
            item.model =
              item.label === 'To'
                ? AppStateService.getState().toModel
                : AppStateService.getState().fromModel;
            that.reportBodyData[item.inputName] = new Date(
              item.model
            ).getTime();
            if (item.inputName === 'from') {
              that.reportBodyData.offsetFrom =
                item.model.getTimezoneOffset() * 60000;
            } else {
              that.reportBodyData.offsetTo =
                item.model.getTimezoneOffset() * 60000;
            }
          } else if (
            (item.type === 'multiply-input' || item.type === 'select-input') &&
            item.dependsOn === null &&
            item.selectorPath !== ''
          ) {
            KarcherBuilderReportsViewModel.prototype
              .getDynamicList(item.selectorPath, item.selectorHeader)
              .then(function (data) {
                item.selectorList = data;
                that.washFacilityList = data;
              });
          } else if (
            (item.type === 'multiply-input' || item.type === 'select-input') &&
            item.dependsOn !== null &&
            item.selectorPath !== ''
          ) {
            that.dependsOnData.dependsOn = item.dependsOn;
            that.dependsOnData.inputName = item.inputName;
            that.dependsOnData.selectorPath = item.selectorPath;
          } else {
            item.model =
              (item.selectorList &&
                item.selectorList[0] &&
                item.selectorList[0].id) ||
              '';
            that.reportBodyData[item.inputName] = item.model;
          }
        });
        this.reportBuilderData = data;
      };

    KarcherBuilderReportsViewModel.prototype.refreshKarcherReportsData =
      function (data) {
        var temp = {},
          timeArray = [],
          valuePairsArray = [];
        valuePairsArray = [];
        temp.groupsData = [];
        temp.groupsTotal = [];
        temp.total = data.total;
        temp.unit = data.unit;

        // Create groupNames array as template array
        var tempArray = data.values.reduce(function (acc, value) {
          return acc.concat(value.groupName);
        }, []);
        // Remove duplicates from groupNames and sort values
        temp.groupNames = tempArray
          .filter(function (item, index) {
            return tempArray.indexOf(item) === index;
          })
          .sort();

        // Add missing group name in array with 0 value
        for (var i = 0; i < temp.groupNames.length; i++) {
          for (var j = 0; j < data.values.length; j++) {
            if (temp.groupNames[i] !== data.values[j].groupName) {
              if (!data.values[j].groupName.includes(temp.groupNames[i])) {
                data.values[j].value.push(0);
                data.values[j].groupName.push(temp.groupNames[i]);
              }
            }
          }
        }

        // Create group name values pair object
        data.values.forEach(function (item) {
          timeArray.push(item.group);
          var valuePairs = {};
          item.groupName.forEach(function (k, i) {
            valuePairs[k] = item.value[i];
          });
          valuePairs = sortObjectByKeys(valuePairs);
          valuePairsArray.push(valuePairs);
        });

        // Create groupsData
        var that = this;
        valuePairsArray.forEach(function (pairs, i) {
          var groupValue = timeArray[i];
          // Need to be updated with flag form SuperAdmin portal
          if (that.selectedReport === 4) {
            groupValue = DayTranslationService.translateDayNumber(
              parseInt(timeArray[i])
            );
          }
          temp.groupsData.push({
            groupValue: groupValue,
            values: Object.values(pairs)
          });
        });

        // Create groupTotal
        var tempForTotalArray = [];
        temp.groupsData.forEach(function (item) {
          tempForTotalArray.push(item.values);
        });

        temp.groupTotal = tempForTotalArray.reduce(function (r, a) {
          a.forEach(function (b, i) {
            r[i] = (r[i] || 0) + b;
          });
          return r;
        }, []);

        this.chartData.data = temp;
        layoutActions.hideLoader();
        this.isChartVisible = true;
      };

    KarcherBuilderReportsViewModel.prototype.refreshKarcherReportsTableData =
      function (data) {
        this.tableChartData = data;
        this.isTableVisible = true;
        layoutActions.hideLoader();
      };

    KarcherBuilderReportsViewModel.prototype.refreshWeatherHistoryData =
      function (data) {
        this.weatherHistoryData = data.forecast.forecastday;
        this.weatherLocationData = data.location;
      };

    KarcherBuilderReportsViewModel.prototype.refreshWashFacilityList =
      function (data) {
        this.washFacilityList = data;
      };

    KarcherBuilderReportsViewModel.prototype.getTimezoneForSelectedFacility =
      function (selectedFacility) {
        if (!selectedFacility || !selectedFacility[0] || !selectedFacility[0].timeZone) {
          return;
        }
        this.facilityTimeZone = selectedFacility[0].timeZone;
      };

    KarcherBuilderReportsViewModel.prototype.getDynamicList = function (
      path,
      header
    ) {
      var deferred = $q.defer();
      var acceptHeader =
        header !== '' ? header : 'text/plain, application/json';

      $http({
        method: 'GET',
        cache: false,
        headers: { Accept: acceptHeader },
        url: hostProtocol + '://' + hostDomain + path
      }).then(
        function (successData) {
          deferred.resolve(successData.data);
        },
        function (errorData) {
          deferred.reject(errorData.data, errorData.header, errorData.status);
        }
      );

      return deferred.promise;
    };

    return KarcherBuilderReportsViewModel;

    function sortObjectByKeys(object) {
      return Object.keys(object)
        .sort()
        .reduce(function (accumulator, key) {
          accumulator[key] = object[key];
          return accumulator;
        }, {});
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ReportsBuilderKarcherController', reportsBuilderKarcher);

  /** @ngInject */
  function reportsBuilderKarcher(
    KarcherBuilderReportsViewModel,
    $log,
    reportActions,
    layoutActions,
    $filter,
    weatherKarcherActions,
    $translate,
    exportToCsv,
    reportExportUtil,
    helperService,
    $scope,
    $timeout,
    AppStateService
  ) {
    var vm = this,
      tablePageSize = 10,
      tablePage = 1;
    vm.reportBuilderViewModel = new KarcherBuilderReportsViewModel();

    init();

    vm.itemSelected = function (item) {
      $timeout(function () {
        $scope.karcherReportsBuilderForm.$invalid = item;
      });
    };

    vm.getReport = function () {
      layoutActions.showLoader();
      if (!vm.reportBuilderViewModel.isChartIncluded) {
        vm.reportBuilderViewModel.reportBodyData.pageSize = tablePageSize;
        vm.reportBuilderViewModel.reportBodyData.page =
          (tablePage - 1) * tablePageSize;
      } else if (vm.reportBuilderViewModel.reportBodyData.facilityId) {
        refreshWeatherHistoryData();
      }
      var reportDataObject = angular.copy(
        vm.reportBuilderViewModel.reportBodyData
      );
      reportDataObject.from =
        reportDataObject.from - reportDataObject.offsetFrom;
      reportDataObject.to = reportDataObject.to - reportDataObject.offsetTo;
      reportActions
        .executeDynamicReport(
          vm.reportBuilderViewModel.selectedReport,
          reportDataObject
        )
        .then(function (reportResponse) {
          if (reportResponse.status === 204) {
            vm.reportBuilderViewModel.isChartVisible = false;
            layoutActions.hideLoader();
            return;
          }
          vm.reportBuilderViewModel.isChartIncluded
            ? vm.reportBuilderViewModel.refreshKarcherReportsData(
                reportResponse.data
              )
            : vm.reportBuilderViewModel.refreshKarcherReportsTableData(
                reportResponse.data
              );
        });
    };

    vm.exportToCsvReports = function () {
      var fileTitleData = [];
      fileTitleData.push(
        vm.reportBuilderViewModel.reportNameList.filter(function (item) {
          return item.id === vm.reportBuilderViewModel.selectedReport;
        })[0].name
      );
      fileTitleData.push(
        $filter('date')(
          vm.reportBuilderViewModel.reportBodyData.from,
          'dd-MM-yyyy'
        )
      );
      fileTitleData.push(
        $filter('date')(
          vm.reportBuilderViewModel.reportBodyData.to,
          'dd-MM-yyyy'
        )
      );
      // Extend csv report with totals for Karcher brand. I don't want to update reportExportUtils because of R2W reporting
      if (!vm.reportBuilderViewModel.isTableVisible) {
        vm.reportBuilderViewModel.chartData.data.groupsData.unshift({
          groupValue: 'Total',
          values: vm.reportBuilderViewModel.chartData.data.groupTotal
        });
        var jsonArrayForExport = reportExportUtil.getJsonArrayForExport(
          $translate.instant('DATE'),
          vm.reportBuilderViewModel.chartData.data,
          reportExportUtil.ValueFormattersEnum.DATE,
          reportExportUtil.ValueFormattersEnum.NUMBER
        );

        exportToCsv.export(
          jsonArrayForExport,
          helperService.createFileName(fileTitleData),
          true
        );
      } else {
        exportToCsv.exportBasicArrayToCsv(
          vm.reportBuilderViewModel.tableChartData.data,
          fileTitleData[0] + '.csv'
        );
      }
    };

    vm.changeReportName = function () {
      layoutActions.showLoader();
      vm.reportBuilderViewModel.reportBodyData = {};
      vm.reportBuilderViewModel.dependsOnData = {};
      vm.reportBuilderViewModel.getReportGrouping(
        vm.reportBuilderViewModel.selectedReport
      );
      reportActions
        .getSelectedReportConfiguration(
          vm.reportBuilderViewModel.selectedReport
        )
        .then(function (response) {
          /* eslint-disable */
          if (response.responseConfiguration) {
            vm.reportBuilderViewModel.chartData.chartType = JSON.parse(
              response.responseConfiguration
            ).chartType;
            vm.reportBuilderViewModel.chartData.x.type = JSON.parse(
              response.responseConfiguration
            ).chartXAxisType
              ? JSON.parse(response.responseConfiguration).chartXAxisType
              : 'timeseries';
            vm.reportBuilderViewModel.isChartIncluded = response.chart;
            vm.reportBuilderViewModel.isChartVisible = false;
            vm.reportBuilderViewModel.isTableVisible = false;
            vm.reportBuilderViewModel.refreshConfigurationData(
              JSON.parse(response.parameterConfiguration)
            );
            layoutActions.hideLoader();
          } else {
            layoutActions.hideLoader();
            console.log('No responseConfiguration');
          }
        });
    };

    vm.clearMultiplyInput = function (inputData) {
      inputData.model = '';
    };

    vm.getItems = function (ids, inputData) {
      inputData.model = ids;
      if (inputData.dependsOn === null) {
        parseSelectedPathAndReplaceIt(
          ids,
          vm.reportBuilderViewModel.dependsOnData,
          vm.reportBuilderViewModel.reportBuilderData
        );
      }
      vm.reportBuilderViewModel.getTimezoneForSelectedFacility(
        vm.reportBuilderViewModel.washFacilityList.filter(function (facility) {
          return facility.id === ids;
        })
      );
      if (inputData.inputName !== '') {
        vm.reportBuilderViewModel.reportBodyData[inputData.inputName] =
          inputData.model;
      }
    };

    vm.onChangeInputs = function (inputData) {
      $timeout(function () {
        $scope.karcherReportsBuilderForm.$invalid = false;
      });
      if (inputData.type === 'date-input') {
        vm.reportBuilderViewModel.reportBodyData[inputData.inputName] = isDate(
          inputData.model
        )
          ? new Date(inputData.model).getTime()
          : inputData.model;
        if (inputData.inputName === 'from') {
          AppStateService.setState('fromModel', inputData.model);
          vm.reportBuilderViewModel.reportBodyData.offsetFrom =
            inputData.model.getTimezoneOffset() * 60000;
        } else {
          AppStateService.setState('toModel', inputData.model);
          vm.reportBuilderViewModel.reportBodyData.offsetTo =
            inputData.model.getTimezoneOffset() * 60000;
        }
      } else {
        vm.reportBuilderViewModel.reportBodyData[inputData.inputName] =
          inputData.model;
      }
    };

    vm.updateTablePagination = function (page, limit) {
      tablePageSize = limit;
      tablePage = page;
      vm.getReport();
    };

    function init() {
      reportActions.getAllReportConfigurations().then(function (response) {
        vm.reportBuilderViewModel.refreshKarcherReportsList(response);
      });
    }

    function isDate(input) {
      return Object.prototype.toString.call(input) === '[object Date]';
    }
    /* eslint-enable */

    function refreshWeatherHistoryData() {
      var selectedItem = vm.reportBuilderViewModel.washFacilityList.filter(
          function (item) {
            return (
              item.id === vm.reportBuilderViewModel.reportBodyData.facilityId
            );
          }
        ),
        selectedDateFrom = $filter('date')(
          vm.reportBuilderViewModel.reportBodyData.from,
          'yyyy-MM-dd'
        ),
        selectedDateTo = $filter('date')(
          vm.reportBuilderViewModel.reportBodyData.to,
          'yyyy-MM-dd'
        );

      weatherKarcherActions
        .getHistoryWeather(
          selectedItem[0].location.latitude,
          selectedItem[0].location.longitude,
          selectedDateFrom,
          selectedDateTo
        )
        .then(function (weatherData) {
          vm.reportBuilderViewModel.refreshWeatherHistoryData(weatherData);
        });
    }

    function parseSelectedPathAndReplaceIt(
      parameter,
      dependsOnData,
      configurationData
    ) {
      if (dependsOnData.dependsOn && dependsOnData.dependsOn !== '') {
        var pathPattern = /\/api\/washFacilities\/[^\/]+\/washFacilityBoxes/;
        var newPath = '/api/washFacilities/' + parameter + '/washFacilityBoxes';

        if (pathPattern.test(dependsOnData.selectorPath)) {
          dependsOnData.selectorPath = newPath;
        } else {
          dependsOnData.selectorPath = dependsOnData.selectorPath.replace(
            '{parameter}',
            parameter
          );
        }

        configurationData.forEach(function (item) {
          if (item.inputName === dependsOnData.inputName) {
            item.selectorPath = dependsOnData.selectorPath;
            item.model = parameter + 111;
            vm.reportBuilderViewModel
              .getDynamicList(item.selectorPath, item.selectorHeader)
              .then(function (data) {
                console.log('data_for_depends_on_input: ', data);
                item.selectorList = data;
              });
          }
        });

        return configurationData;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('ReportViewModel', reportViewModelFactory);

  /** @ngInject */
  function reportViewModelFactory(
    reportsFilterStore,
    localeFilters,
    devicesStore,
    deviceActions,
    facilityUtils,
    washBoxUtils,
    ReportTypeEnum,
    reportActions,
    DateTime,
    getUtcTimeService,
    layoutActions,
    sessionData,
    $state
  ) {
    function ReportViewModel(reportType) {
      this._devicesStoreChangeHandler = null;

      this.facilitiesVisible = false;
      this.periodsVisible = false;
      this.hoursVisibility = false;
      this.onlyMoneyReportVisibility = false;
      this.devices = [];
      this.reportFilter = {};
      this.dateFormat = localeFilters.defaultDateFormat;
      this.monthsList = new DateTime(null).listAllMonths();
      this.yearsList = new DateTime(null).listYears();
      this.hoursList = new DateTime(null).listHours();
      this.croatiaRegionVisibility =
        sessionData.getValue(sessionData.Keys.COUNTRY_CODE) === 'HR';
      init.call(this, reportType);
    }

    ReportViewModel.prototype.destroy = function () {
      devicesStore.off(
        devicesStore.events.CHANGE,
        this._devicesStoreChangeHandler
      );
    };

    ReportViewModel.prototype.setReportType = function (reportType, reportList) {
      if (reportList) {
        this.selectedReportsState = reportList.find(function (report) {
          return report.type === reportType;
        });
      }
      this.selectedReportType = reportType;
      this.facilitiesVisible =
        this.selectedReportType === ReportTypeEnum.COMPARE_PERIODS_REPORT ||
        this.selectedReportType === ReportTypeEnum.AVG_MONEY_BY_BOX_REPORT ||
        this.selectedReportType === ReportTypeEnum.CHANGER_INCOME ||
        this.selectedReportType === ReportTypeEnum.POS_INCOME;
      this.periodsVisible =
        this.selectedReportType === ReportTypeEnum.COMPARE_PERIODS_REPORT;
      this.hoursVisibility =
        this.selectedReportType === ReportTypeEnum.CHANGER_INCOME;
      this.onlyMoneyReportVisibility =
        this.selectedReportType === ReportTypeEnum.CHANGER_INCOME ||
        this.selectedReportType === ReportTypeEnum.R2W_BY_DATE_REPORT ||
        this.selectedReportType ===
          ReportTypeEnum.AVG_MONEY_BY_DAY_OF_WEEK_REPORT ||
        this.selectedReportType === ReportTypeEnum.MONEY_BY_DATE_REPORT ||
        this.selectedReportType === ReportTypeEnum.AVG_MONEY_BY_HOUR_REPORT ||
        this.selectedReportType === ReportTypeEnum.AVG_MONEY_BY_BOX_REPORT;
    };

    ReportViewModel.prototype.updateFilter = function () {
      layoutActions.showLoader();
      if (this.selectedReportsState) {
        $state.go(this.selectedReportsState.state);
      } else {
        $state.go('app.reports.dailyTotal');
      }
      reportActions.updateReportFilter(
        getUtcTimeService.getTime(this.fromDate),
        getUtcTimeService.getTime(this.toDate),
        this.selectedFacilitySerial,
        this.selectedFrom1,
        this.selectedTo1,
        this.selectedFrom2,
        this.selectedTo2,
        this.selectedFrom3,
        this.selectedTo3,
        localStorage.getItem(sessionData.Keys.CURRENCY)
      );
    };

    ReportViewModel.prototype.onPeriodFromChanged = function () {
      this.toOptions.minDate = this.fromDate;
    };

    ReportViewModel.prototype.onPeriodToChanged = function () {
      this.fromOptions.maxDate = this.toDate;
    };

    ReportViewModel.prototype.refresh = function (data) {
      if (data) {
        this.devices = parseDevicesData(data);
        this.selectedFacilitySerial =
          this.devices.length > 0 ? this.devices[0].facilityPointId : null;

        this.reportFilter = reportsFilterStore.getFilterData();

        this.fromDate = new Date(this.reportFilter.fromTimestamp);
        this.toDate = new Date(this.reportFilter.toTimestamp);

        this.selectedTo1 = this.reportFilter.period1To;
        this.selectedFrom1 = this.reportFilter.period1From;
        this.selectedTo2 = this.reportFilter.period2To;
        this.selectedFrom2 = this.reportFilter.period2From;
        this.selectedTo3 = this.reportFilter.period3To;
        this.selectedFrom3 = this.reportFilter.period3From;
        this.selectedCurrency = this.reportFilter.currency;

        this.updateFilter();
      }
    };

    return ReportViewModel;

    function init(reportType) {
      var that = this;

      this.setReportType(
        reportType ? reportType.type : ReportTypeEnum.MONEY_BY_DATE_REPORT
      );

      this._devicesStoreChangeHandler = function () {
        that.refresh.call(that);
      };

      devicesStore.on(
        devicesStore.events.CHANGE,
        this._devicesStoreChangeHandler
      );
    }

    function parseDevicesData(devicesJson) {
      var devices = [];

      if (devicesJson !== null) {
        devicesJson.forEach(function (deviceJson) {
          var facility = facilityUtils.getFacilityPoint(deviceJson),
            boxes = washBoxUtils.getWashBoxPoints(facility);
          var newDevice = {
            facilityPointId: facility.id,
            deviceSerial: deviceJson.deviceKey,
            name: facility.name,
            boxes: boxes.map(function (box) {
              return {
                pointId: box.id,
                name: box.name
              };
            })
          };
          this.push(newDevice);
        }, devices);
      }

      return devices;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ReportsController', reportsController);

  /** @ngInject */
  function reportsController(
    $scope,
    $state,
    ReportViewModel,
    ReportTypeEnum,
    deviceActions,
    layoutActions,
    dailyFinancesActions,
    sessionData
  ) {
    var vm = this;
    vm.fromDateMax;
    vm.reportTypes = getReportTypes();

    vm.report = new ReportViewModel(
      vm.reportTypes.find(function (reportType) {
        return reportType.state === $state.current.name;
      })
    );

    vm.toDateSelected = function () {
      vm.fromDateMax = vm.report.toDate;
    };

    init();

    function init() {
      layoutActions.showLoader();
      $scope.$on('$destroy', destroy);
      deviceActions.getAllDevices().then(function (data) {
        layoutActions.hideLoader();
        vm.report.refresh(data);
      });

      dailyFinancesActions.getData().then(function (response) {
        localStorage.setItem(sessionData.Keys.CURRENCY, response.currency);
      });

      if ($state.current.name === 'app.reports') {
        $state.go('app.reports.dailyTotal');
      }
    }

    function destroy() {
      vm.report.destroy();
    }

    function getReportTypes() {
      var result = [];

      result.push({
        state: 'app.reports.dailyTotal',
        type: ReportTypeEnum.MONEY_BY_DATE_REPORT
      });
      result.push({
        state: 'app.reports.dailyCoinsTotal',
        type: ReportTypeEnum.COINS_BY_DATE_REPORT
      });
      result.push({
        state: 'app.reports.dailyR2WTotal',
        type: ReportTypeEnum.R2W_BY_DATE_REPORT
      });
      // result.push({
      //   state: 'app.reports.dailyEuroKeyTotal',
      //   type: ReportTypeEnum.EUROKEY_BY_DATE_REPORT
      // });
      result.push({
        state: 'app.reports.avgByHour',
        type: ReportTypeEnum.AVG_MONEY_BY_HOUR_REPORT
      });
      result.push({
        state: 'app.reports.avgByDay',
        type: ReportTypeEnum.AVG_MONEY_BY_DAY_OF_WEEK_REPORT
      });
      result.push({
        state: 'app.reports.avgByBox',
        type: ReportTypeEnum.AVG_MONEY_BY_BOX_REPORT
      });
      // result.push({
      //   state: 'app.reports.comparation',
      //   type: ReportTypeEnum.COMPARE_PERIODS_REPORT
      // });
      result.push({
        state: 'app.reports.totalUsers',
        type: ReportTypeEnum.TOTAL_USERS_BY_GROUP
      });
      result.push({
        state: 'app.reports.totalVisits',
        type: ReportTypeEnum.VISITS_COUNT_REPORT
      });
      result.push({
        state: 'app.reports.givenLoyalty',
        type: ReportTypeEnum.TOTAL_SPENT_LOCAL_TOKENS_PER_DAY
      });
      result.push({
        state: 'app.reports.getTotalPurchasedLocalTokensPerDay',
        type: ReportTypeEnum.TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY
      });
      result.push({
        state: 'app.reports.getTotalGivenLocalTokensPerDay',
        type: ReportTypeEnum.TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY
      });
      result.push({
        state: 'app.reports.changerIncome',
        type: ReportTypeEnum.CHANGER_INCOME
      });
      result.push({
        state: 'app.reports.posIncome',
        type: ReportTypeEnum.POS_INCOME
      });

      return result;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .service("reportExportUtil", reportExportUtilService);

  /** @ngInject */
  function reportExportUtilService(localeFilters, $translate, $filter) {
    this.getJsonArrayForExport = function (
      groupValueLabel,
      jsonGroupedData,
      groupValueFormatterEnum,
      valueFormatterEnum,
      nameReportConstant
    ) {
      var that = this,
        result = [];

      if (!jsonGroupedData) {
        return result;
      }

      if (!groupValueFormatterEnum) {
        groupValueFormatterEnum = this.ValueFormattersEnum.DEFAULT;
      }

      if (!valueFormatterEnum) {
        valueFormatterEnum = this.ValueFormattersEnum.DEFAULT;
      }

      if (jsonGroupedData.groupsData) {
        Array.from(jsonGroupedData.groupsData).forEach(function (
          groupDataItem
        ) {
          var newItem = {};

          newItem[groupValueLabel] = that.ValueFormattersEnum.properties[
            groupValueFormatterEnum
          ].format(groupDataItem.groupValue);

          Array.from(
            that.filterWhiteSpaceNames(jsonGroupedData.groupNames)
          ).forEach(function (groupName, index) {
            newItem[
              $translate.instant(groupName) +
                " ( " +
                jsonGroupedData.unit +
                " )"
            ] = that.ValueFormattersEnum.properties[valueFormatterEnum].format(
              groupDataItem.values[index]
            );
          });

          this.push(newItem);
        },
        result);
      } else {
        jsonGroupedData.forEach(function (groupDataItem) {
          var newItem = {};

          newItem[groupValueLabel] = that.ValueFormattersEnum.properties[
            groupValueFormatterEnum
          ].format(groupDataItem.date);

          newItem[
            $translate.instant(nameReportConstant) +
              " ( " +
              $translate.instant("LOCAL_TOKEN") +
              " )"
          ] = that.ValueFormattersEnum.properties[valueFormatterEnum].format(
            groupDataItem.count
          );

          this.push(newItem);
        }, result);
      }

      return result;
    };

    this.filterWhiteSpaceNames = function (array) {
      return array.map(function (item) {
        return $filter("removews")(item);
      });
    };

    this.ValueFormattersEnum = Object.freeze({
      CURRENCY: "CURRENCY",
      DATE: "DATE",
      NUMBER: "NUMBER",
      DEFAULT: "DEFAULT",
      DAY: "DAY",
      MONTH: "MONTH",
      properties: {
        CURRENCY: {
          format: function (value) {
            return localeFilters.currency(value, "", 2);
          }
        },
        DATE: {
          format: function (value) {
            return localeFilters.hourly(value);
          }
        },
        NUMBER: {
          format: function (value) {
            return localeFilters.number(value, 2);
          }
        },
        DEFAULT: {
          format: function (value) {
            return value;
          }
        },
        DAY: {
          format: function (value) {
            return localeFilters.getDayLocale(value);
          }
        },
        MONTH: {
          format: function (value) {
            return localeFilters.getMonthLocale(value);
          }
        }
      }
    });
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("ReleaseNotesController", ReleaseNotesController);

  /** @ngInject */
  function ReleaseNotesController($scope, userActions, layoutActions, $http) {
    var vm = this;
    var webAppReleaseNotesString = "";

    init();

    function init() {
      $scope.$on("destroy", function () {});
      fetchReleaseNotes();
      refreshNotes();
    }

    function refreshNotes() {
      layoutActions.showLoader();
      vm.promise = userActions.getReleaseNotes().then(function (data) {
        vm.releaseNotesData = data.split("\n");
        layoutActions.hideLoader();
      });
    }

    function fetchReleaseNotes(){
      $http.get('releaseNotesMerchant.txt')
        .then(function(response) {
          webAppReleaseNotesString = response.data;
          vm.merchantWebAppReleaseNotes = webAppReleaseNotesString.split("\n");
        })
        .catch(function() {
          webAppReleaseNotesString = 'Error loading release notes. Please try again later.';
        });
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("PricingController", pricingController);

  /** @ngInject */
  function pricingController($scope, userActions, pricingActions, $log) {
    var vm = this;

    vm.refreshTokenPackageList = function () {
      refreshTokenPackages();
    };

    vm.refreshSingleWashList = function() {
      refreshSingleWashes();
    }

    function refresh() {
      refreshTokenPackages();
      refreshSingleWashes();
    }

    function refreshTokenPackages() {
      pricingActions.getCompanyTokenPackage().then(
          function (data) {
            vm.tokenPackagesData = data;
          },
          function (errorData) {
            $log.log("An error occured" + errorData);
          }
      );
    }

    function refreshSingleWashes() {
      pricingActions.getSingeWashes().then(
          function (data) {
            vm.singleWashData = data;
          },
          function (errorData) {
            $log.log("An error occured" + errorData);
          }
      );
    }

    init();

    function init() {
      // This two calls were nested only to get currency for users region. Badly done, need to be fix (backend issue)
      userActions.getCompanyDetails().then(function (res) {
        userActions.getRegionById(res.regionId).then(function (response) {
          vm.regionCurrency = response.currencyCode;
        });
      });
      refresh();
      $scope.$on("$destroy", destroy);
    }

    function destroy() {}
  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('PeriodicSummaryViewModel', periodicSummaryViewModelFactory);

    /** @ngInject */
    function periodicSummaryViewModelFactory(DateTime, $filter, invoiceNamingEnumFactory, InvoiceStatusEnum, $translate) {
        function PeriodicSummaryViewModel() {

            this.currency = '';
            this.companyName = '';
            this.grossIncome = 0;
            this.commissionFee = 0;
            this.netIncome = 0;
            this.totalData = {};
            this.currentMonthData = {};
            this.invoiceNaming = {
                name: invoiceNamingEnumFactory.name,
                invoiceNumber: invoiceNamingEnumFactory.invoiceNumber,
                invoiceState: invoiceNamingEnumFactory.invoiceState
            }

            this.financialData = {
                currentPeriod : {},
                paymentsOnHold : {
                    collapsed : false,
                    description : invoiceNamingEnumFactory.paymentsOnHold,
                    total : {},
                    data : []
                },
                forInvoicing : {
                    collapsed : false,
                    description : invoiceNamingEnumFactory.forInvoicing,
                    total : {},
                    data : []
                }
            };

            this.downloadOptions = [];

            this.forSerbiaRegion = [{
                name: $translate.instant('DOWNLOAD_INVOICE'),
                type: 'invoice'
            }];

            this.allRegions = [
                {
                    name: $translate.instant('DOWNLOAD_PAYMENT_REQUEST'),
                    type: 'invoice'
                },
                {
                    name: $translate.instant('B2B_SPEC'),
                    type: 'b2b'
                },
                {
                    name: $translate.instant('B2C_SPEC'),
                    type: 'b2c'
                }
            ]

            // INVOICES
            this.selectedYear;
            this.invoiceFromYear = [];
            this.currentYear = new Date().getFullYear();
            this.selectedYear = this.currentYear;
            this.minYear = 2014;
            this.maxYear = this.currentYear + 1;
            this.searchRadioButton = {type: ''};
            this.selectedYear = this.currentYear;

            this.invoiceFrom = new Date(new DateTime().startOf(DateTime.units.MONTH).timestamp);
            this.invoiceTo  = new Date(new DateTime().endOf(DateTime.units.DAY).timestamp);
            this.invoiceStatuses = InvoiceStatusEnum;

            // GRID CONFIIG
            this.invoiceData = [];
            this.invoiceOrderBy = "-date";
            this.invoiceOrder = 'desc';
            this.invoicePage = 1;
            this.invoiceTotal = 0;
            this.invoicePageSize = 10;
            this.invoicePageOptions = [5, 10, 15];
            this.selectedInvoices = [];
            this.pagerTranslations = {
                page: $translate.instant('GRID_PAGER_PAGE'),
                rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
                of: $translate.instant('GRID_PAGER_PAGE_OF')
            };
        }

        PeriodicSummaryViewModel.prototype.destroy = function () {
        };

        PeriodicSummaryViewModel.prototype.refresh = function (data) {
            this.currency = data.currencyCode;
            this.companyName = data.companyName;

            this.totalData = data.total;
            this.currentMonthData = data.currentMonth;

            this.financialData.currentPeriod = data.currentPeriod;
            this.financialData.paymentsOnHold.data = data.paymentsOnHold.transactions;
            this.financialData.paymentsOnHold.total = data.paymentsOnHold.total;
            this.financialData.forInvoicing.data = data.forInvoicing.transactions;
            this.financialData.forInvoicing.total = data.forInvoicing.total;
        };

        PeriodicSummaryViewModel.prototype.refreshInvoiceData = function(data){

            this.images = [{src: "assets/icons/ic_arrow_back_red_24px.svg"},{src: "assets/icons/ic_arrow_forward_green_24px.svg"}];

            this.invoiceData = data.content;
            this.invoiceTotal = data.totalElements;

        };

        PeriodicSummaryViewModel.prototype.invoiceOrderingChange = function(order){
            var orderQuery = getOrderObject(order);
            this.invoiceOrderBy = orderQuery.orderBy;
            this.invoiceOrder = orderQuery.order;
        };

        PeriodicSummaryViewModel.prototype.invoicePaginationChange = function(page, limit){
            this.invoicePage = page;
            this.invoicePageSize = limit;
            this.invoiceOrderingChange(this.invoiceOrderBy);
        };

        return PeriodicSummaryViewModel;

        function getOrderObject(order) {
            var result = {
                order: 'asc',
                orderBy: order
            };

            if (order.indexOf('-') > -1) {
                result.order = 'desc';
                result.orderBy = order.substring(1);
            }
            return result;
        }
    }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').controller('periodicSummaryController', periodicSummaryController);

    /** @ngInject */
    function periodicSummaryController ($scope, PeriodicSummaryViewModel, periodicSummaryActions, dialogsService, $q, $translate, $mdToast, $log) {
        var vm = this;
        vm.fromDateMax;

        vm.summary = new PeriodicSummaryViewModel();

        vm.print = function () {
            /* eslint-disable */
            window.print();
            /* eslint-enable */
        };

        vm.toDateSelected = function(){
            vm.fromDateMax =  vm.summary.invoiceTo;
        };

        vm.sortChanged = function(order){
            vm.summary.invoiceOrderingChange(order);
            refreshInvoices();
        };

        vm.changeType = function (invoiceType) {
            vm.summary.searchRadioButton.type = invoiceType;
            vm.summary.invoicePage = 1;
            refreshInvoices();
        };

        vm.changeYear = function () {
            refreshInvoices();
        };

        vm.pageChanged = function(page, limit){
            vm.summary.invoicePaginationChange(page, limit);
            refreshInvoices();
        };

        vm.search = function(){
            refreshInvoices();
        };

        vm.sendInvoice = function(invoiceId, invoiceNumber){

            dialogsService.showConfirmDialog($translate.instant('INVOICE_NUMBER_HEADER') + ' - "' + invoiceNumber +'"'  , $translate.instant('INVOICING_NOTIFICATION_TEXT'), $translate.instant('YES')).then(function(){
                periodicSummaryActions.updateInvoice(invoiceId, invoiceNumber, 'approval').then(function(){
                    refreshPeriodicSummary();
                    refreshInvoices();
                    $mdToast.show(
                        $mdToast.simple()
                            .textContent($translate.instant('SENT_INVOICE_NOTIFICATION'))
                            .position('bottom right')
                            .hideDelay(3000)
                        );
                });
            });
        };

        vm.downloadInvoice = function(id){
            periodicSummaryActions.downloadInvoice(id).then(function(data){
                var invoiceTitle = data.headers().pdfname;
                getPdfFile(data.data, invoiceTitle);
            });
        };

        vm.openOptions = function($mdMenu, ev, data) {
            if(data.company.regionId === 2) {
               vm.summary.downloadOptions = vm.summary.forSerbiaRegion;
            } else {
                vm.summary.downloadOptions = vm.summary.allRegions;
            }
            $mdMenu.open(ev);
        }

        vm.downloadInvoices = function(id, type){

            switch (type) {
                case 'invoice':
                    periodicSummaryActions.downloadInvoice(id).then(function(data){
                        var invoiceTitle = data.headers().pdfname;
                        getPdfFile(data.data, invoiceTitle);
                    });
                    break;
                case 'b2b':
                    periodicSummaryActions.downloadB2bSpec(id).then(function(data){
                        var invoiceTitle = data.headers().pdfname;
                        getPdfFile(data.data, invoiceTitle);
                    });
                    break;
                case 'b2c':
                    periodicSummaryActions.downloadB2cSpec(id).then(function(data){
                        var invoiceTitle = data.headers().pdfname;
                        getPdfFile(data.data, invoiceTitle);
                    });
                    break;
            }

        };

        vm.toggleAccordian = function(invoiceType){
            vm.summary.financialData[invoiceType].collapsed = (vm.summary.financialData[invoiceType].collapsed) ? false : true;
        };

        init();

        function refreshPeriodicSummary(){
            periodicSummaryActions.getPeriodicSummary().then(function (data) {
                vm.currency = data.currencyCode;
                vm.summary.refresh(data);
            }, function () {
                //TODO error handling
            });
        }

        function refreshInvoices(){
            vm.promise = periodicSummaryActions.getInvoices(
                vm.summary.selectedYear,
                vm.summary.searchRadioButton.type,
                vm.summary.invoicePage - 1,
                vm.summary.invoicePageSize,
                vm.summary.invoiceOrderBy,
                vm.summary.invoiceOrder).then(function(data){
                    vm.summary.refreshInvoiceData(data);
                }, function (errorData) {
                    $log.log('an error occured' + errorData);
            });
        }

        function createYearList () {
            for (var i = vm.summary.minYear; i < vm.summary.maxYear; i++) {
                vm.summary.invoiceFromYear.push(i);
            }
            vm.summary.yearList = vm.summary.invoiceFromYear.reverse();
        }

        function getPdfFile(data, invoiceTitle){

            var file = new Blob([data], {type: 'application/pdf'});
            var fileURL = URL.createObjectURL(file);

            var file_path = fileURL;
            /* eslint-disable */
            var a = document.createElement('A');
            a.href = file_path;
            a.download = invoiceTitle;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            /* eslint-enable */

        }


        function init () {
            $scope.$on('$destroy', destroy);
            refreshPeriodicSummary();
            refreshInvoices();
            createYearList();
        }

        function destroy () {
            if (vm.summary !== null) {
                vm.summary.destroy();
            }
        }
    }
})();

(function () {
	'use strict';

	angular
		.module('sempraWebapp')
		.factory('OrganizationViewModel', organizationViewModelFactory);

	/** @ngInject */
	function organizationViewModelFactory() {
		function OrganizationViewModel() {
			this.organizationSearch = '';
			this.organizationTypeSearch = '';
			this.organizationTypes = [
				{
					name: 'All',
					value: ''
				},
				{
					name: 'Company',
					value: 'COMPANY'
				},
				{
					name: 'Region',
					value: 'REGION'
				},
				{
					name: 'Site',
					value: 'SITE'
				},
				{
					name: 'Self',
					value: 'SELF'
				}
			];
		}

		OrganizationViewModel.prototype.destroy = function () {};

		OrganizationViewModel.prototype.refresh = function (data) {
			this.organizationData = data;
		};

		return OrganizationViewModel;
	}
})();

(function () {
	'use strict';

	angular
		.module('sempraWebapp')
		.controller('ListOrganizationController', listOrganizationController);

	/** @ngInject */
	function listOrganizationController(
		OrganizationViewModel,
		$scope,
		organizationActions,
		layoutActions
	) {
		var vm = this;
		var collapseIndexesArray = [];

		vm.organization = new OrganizationViewModel();
		vm.showOrganizationBelow = false;
		vm.organizationChecker = null;
		vm.selectedOrganizationId = null;

		init();

		vm.searchOrganization = function () {
			refresh();
		};

		vm.openMenu = function ($mdMenu, ev) {
			$mdMenu(ev);
		};

		vm.deleteSelectedOrganization = function(organization) {
			organizationActions.deleteOrganization(organization.id).then(function() {
				refresh();
			});
		}

		vm.expendOrganization = function(organization) {
			var index = collapseIndexesArray.indexOf(organization.id);
			if(collapseIndexesArray.indexOf(organization.id) === -1) {
				collapseIndexesArray.push(organization.id);
			} else {
				collapseIndexesArray.splice(index, 1);
			}
		}

		vm.showOrganization = function (organization) {
			return organization.id === 1 || collapseIndexesArray.includes(organization.id);
		}

		vm.setOrganizationTypeIconIcon = function (organizationType) {
			switch (organizationType) {
				case "REGION":
					return "language";
				case "SELF":
					return "perm_identity";
				case "COMPANY":
					return "domain";
				case "SITE":
					return "reorder";
				default:
					return "location_on";
			}
		}

		function refresh() {
			layoutActions.showLoader();
			organizationActions
				.getOrganizationsListByType()
				.then(function (orgRes) {
					vm.organization.refresh(orgRes);
					layoutActions.hideLoader();
				});
		}

		function init() {
			$scope.$on('$destroy', destroy);
			refresh();
		}

		function destroy() {
			vm.organization.destroy();
		}
	}
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('NewsViewModel', NewsViewModelFactory);

  /** @ngInject */
  function NewsViewModelFactory (DateTime, $translate, sessionData) {
    function NewsViewModel () {
      init.call(this);

      this.companyId = 3;

      // FACILITIES
      this.facilities = [];
      this.selectedFacilities = [{name: $translate.instant('ALL_FACILITIES'), id:-1}];

      // NEWS
      this.newsCreated = new Date();

      this.newsText  = '';
      this.newsTitle = '';
      this.newsLanguage = sessionData.getValue(sessionData.Keys.LANGUAGE_KEY) || 'asd';

      // GRID CONFIG
      this.newsData = [];
      this.newsOrderBy = 'content';
      this.newsOrder = 'asc';
      this.newsPage = 1;
      this.newsTotal = 0;
      this.newsPageSize = 10;
      this.newsPageOptions = [5, 10, 15];
      this.selectedNews = [];
      this.pagerTranslations = {
          page: $translate.instant('GRID_PAGER_PAGE'),
          rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
          of: $translate.instant('GRID_PAGER_PAGE_OF')
      };
    }

    NewsViewModel.prototype.destroy = function () {

    };

    NewsViewModel.prototype.refreshData = function (data) {
      this.newsData = [];
      this.newsData = data.content;
      this.newsTotal = data.totalElements;
    };

    NewsViewModel.prototype.newsSortChanged = function(order){
      var orderQuery = getOrderObject(order);
      this.newsOrderBy = orderQuery.orderBy;
      this.newsOrder = orderQuery.order;
    };

    NewsViewModel.prototype.newsPaginationChanged = function(page, limit){
      this.newsPage = page;
      this.newsPageSize = limit;
    };

    // helper function
    function getOrderObject(order) {
        var result = {
            order: 'asc',
            orderBy: order
        };

        if (order.indexOf('-') > -1) {
            result.order = 'desc';
            result.orderBy = order.substring(1);
        }
        return result;
    }


    return NewsViewModel;

    function init () {

    }

  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('NewsController', NewsInject);

  /** @ngInject */
  function NewsInject(NewsViewModel, newsActions, deviceActions, sessionData, dialogsService, $mdToast, $translate) {
    var vm = this;

    vm.news = new NewsViewModel();
    vm.filterSelected = true;

    init();

    function init(){
      // get wash facilities
      getAllFacilities();

      // get news
      refreshNewsHistory();
    }

    // CHIPS
    vm.querySearch = function(criteria) {
      var cachedQuery = cachedQuery || criteria;
      return cachedQuery ? vm.news.facilities.filter(createFilterFor(cachedQuery)) : [];
    };

    // delete news function
    vm.deleteNews = function(news){
      dialogsService.showConfirmDialog($translate.instant('ARE_YOU_SURE'), $translate.instant('DELETE_NEWS_CONFIRMATION'), $translate.instant('DELETE')).then(function(){
        newsActions.deleteNews(news.id).then(function(){
          $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('NEWS_DELETE_NOTIFICATION'))
              .position('top right')
              .hideDelay(3000)
          );

          // remove deleted news from table
          var newsId = news.id;

          for(var i=0; i < vm.news.newsData.length; i++){
            if(vm.news.newsData[i].id === newsId){
              vm.news.newsData.splice(i, 1);
            }
          }

        });
      });
    };

    // save news function
    vm.saveNews = function(){
      var data = {
        content : vm.news.newsText,
        title   : vm.news.newsTitle,
        timestamp : vm.news.newsCreated.getTime(),
        language : vm.news.newsLanguage,
        washFacilityIds : parseSelectedFacilities(vm.news.selectedFacilities) || []
      };

      newsActions.saveNews(data).then(function(response){
        // update table data
        data.id = response;
        vm.news.newsData.push(data);

        $mdToast.show(
            $mdToast.simple()
              .textContent($translate.instant('NEWS_SAVE_NOTIFICATION'))
              .position('bottom right')
              .hideDelay(3000)
          );
      });
    };

    // news table sort
    vm.sortChanged = function(order){
      vm.news.newsSortChanged(order);
      refreshNewsHistory();
    };

    // news pagination
    vm.pageChanged = function(page, limit){
      vm.news.newsPaginationChanged(page, limit);
      refreshNewsHistory()
    };

    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(facility) {
        return (angular.lowercase(facility.name).indexOf(lowercaseQuery) != -1);
      };
    }

    function refreshNewsHistory(){
      // get news
      vm.promise = newsActions.getCompanyNews(
          vm.news.newsPage - 1,
          vm.news.newsPageSize,
          vm.news.newsOrderBy,
          vm.news.newsOrder,
          vm.news.companyId
          ).then(function (newsData) {
            vm.news.refreshData(newsData);
          }, function () {
          // todo error handling
      });
    }

    function parseSelectedFacilities(facilities){
      // function that find facility id based on name
      // returns : array of facility ids
      var facilityIds = [];

      for(var i=0; i < facilities.length; i++){
        if(facilities[i].id === -1 ){
          return [];
        }else{
          facilityIds.push(facilities[i].id);
        }
      }
      return facilityIds;
    }

    function getAllFacilities(){
      deviceActions.getAllDevices().then(function(data){
        for(var i=0; i < data.length; i++){
          vm.news.facilities.push({name: data[i].point.name, id: data[i].point.id});
        }
        vm.news.facilities.push({name: $translate.instant('ALL_FACILITIES'), id:-1});
      });
    }

  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("ManagingTokensViewModel", managingTokensViewModelFactory);

  /** @ngInject */
  function managingTokensViewModelFactory() {
    function ManagingTokensViewModel() {
      this.customError = "";
      this.hasError = false;
      this.isUserSelected = false;
      this.selectedUser = "";
      this.tokenList = [];
    }

    ManagingTokensViewModel.prototype.destroy = function() {};

    ManagingTokensViewModel.prototype.refresh = function(data) {
      this.tokenList = data;
    };

    return ManagingTokensViewModel;
  }
})();

(function() {
	"use strict";

	angular
		.module("sempraWebapp")
		.controller("ManagingTokensController", managingTokensController);

	/** @ngInject */
	function managingTokensController(
		ManagingTokensViewModel,
		$scope,
		$mdDialog,
		$document,
		managingTokensActions,
		$log,
		inputValidationService
	) {
		var vm = this;

		vm.managingTokens = new ManagingTokensViewModel();

		vm.refresh = function() {
			vm.promise = managingTokensActions
				.getManagingTokens(vm.managingTokens.selectedUser)
				.then(
					function(data) {
						vm.managingTokens.refresh(data);
					},
					function(errorData) {
						$log.log("An error occurred" + errorData);
					}
				);
		};

		vm.userSelected = function(email) {
			vm.managingTokens.selectedUser = email;
			vm.managingTokens.isUserSelected = true;
			vm.refresh();
		};

		vm.tokensDetails = function(ev, tokensData, edit) {
			$mdDialog.show({
				controller: deleteAndExtendTokenController,
				controllerAs: "vm",
				bindToController: true,
				templateUrl: "app/managingTokens/deleteAndExtendTokensModal.html",
				parent: angular.element($document.body),
				targetEvent: ev,
				locals: {
					tokenData: tokensData,
					edit: edit,
					vm: vm
				},
				clickOutsideToClose: true
			});
		};

		init();

		function init() {
			$scope.$on("$destroy", destroy);
		}

		function destroy() {
			vm.managingTokens.destroy();
		}

		// Delete and extend tokens controller
		function deleteAndExtendTokenController(tokenData, edit, vm, $translate) {
			/* eslint-disable */
			var that = this;
			/* eslint-enable */

			that.amount = 0;
			that.companyName = tokenData.companyDefaultCurrency;
			that.expirationDate = new Date(tokenData.expirationDate);
			that.edit = edit;
			that.amountNotValid = false;
      that.dialogTitle = edit ? $translate.instant('EXTEND_TOKEN_DATE') : $translate.instant('DELETE_TOKENS_FOR');

			that.saveChanges = function(form) {
				var dataToSave = {
					accountId: tokenData.accountId
				};
				if (edit) {
					dataToSave.timestamp = form.expirationDate.$modelValue.getTime();
					managingTokensActions.extendManagingTokens(dataToSave).then(
						function() {
							vm.refresh();
						}
					);
          that.closeDialog();
				} else {
          dataToSave.amount = form.amount.$modelValue;
					managingTokensActions.deleteManagingTokens(dataToSave).then(
						function() {
							vm.refresh();
						}
					);
          that.closeDialog();
				}
			};

			that.inputValidation = function(amount) {
				that.amountNotValid = inputValidationService.singleNumberOnly(amount);
			}

			that.closeDialog = function() {
				$mdDialog.hide();
			};
		}
	}
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('LoyaltyController', LoyaltyController);

  /** @ngInject */
  function LoyaltyController(
    $scope,
    $q,
    $state,
    dialogsService,
    campaignActions,
    userGroupActions,
    CampaignsViewModel,
    $mdDialog
  ) {
    var vm = this;
    vm.campaigns = new CampaignsViewModel();

    vm.createCampaign = function () {
      $state.go('app.loyalty.newCampaign');
    };

    vm.updateCampaign = function (campaign) {
      $state.go('app.loyalty.editCampaign', {
        id: campaign.id,
        facilityType: campaign.facilityType
      });
    };

    vm.deleteCampaign = function () {
      dialogsService
        .showConfirmDialog('CONFIRM_DELETE_CAMPAIGN', 'CONFIRM_DELETE_CAMPAIGN_TEXT', 'DELETE')
        .then(function () {
          campaignActions.deleteCampaign(vm.campaigns.selected[0].id).then(
            function () {
              init();
            },
            function () {
              vm.campaigns.hasErrorMessage = true;
            }
          );
        });
    };

    vm.onCampaignSelected = function () {
      if (vm.campaigns.selected.length >= 2) {
        vm.campaigns.selected.shift();
      }
      /* eslint-disable */
      if (this.model.tresholdEnabled) {
        vm.campaigns.from = new Date(this.model.from);
        vm.campaigns.to = new Date(this.model.to);
        vm.campaigns.onPeriodFromChanged();
        vm.campaigns.onPeriodToChanged();

        vm.campaigns.tresholdTypes = [];
        if (this.model.hasAmountOfMoneyRule) {
          vm.campaigns.tresholdTypes.push({
            id: 'MONEY',
            name: 'TOTAL_MONEY_SPENT'
          });
        }
        if (this.model.hasNumberOfVisitsRule) {
          vm.campaigns.tresholdTypes.push({
            id: 'VISITS',
            name: 'NUMBER_OF_VISITS'
          });
        }
        vm.campaigns.selectedTresholdType = vm.campaigns.tresholdTypes[0].id;
        // vm.campaigns.getTresholds();
      }
    };

    vm.showLoyaltyPreview = function (ev, data) {
      $mdDialog.show({
        controller: loyaltyPreviewController,
        controllerAs: 'vm',
        bindToController: true,
        templateUrl: 'app/loyalty/loyaltyPreview.dialog.html',
        parent: angular.element(document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: { data: data }
      });
    };

    // to-do implement this in a separate file (dialog to be separate component)
    function loyaltyPreviewController($mdDialog, data) {
      var that = this;
      // close add new dialog
      that.closeDialog = function () {
        $mdDialog.hide();
      };
      that.previewCampaign = function (campaign) {
        $mdDialog.hide();
        $state.go('app.loyalty.editCampaign', {
          id: campaign.id,
          facilityType: campaign.facilityType
        });
      };
    }
    /* eslint-enable */

    init();

    function init() {
      $q.all([
        campaignActions.getCampaigns(),
        userGroupActions.getUserGroups()
      ]).then(function (jsonResponses) {
        vm.campaigns.refresh(jsonResponses[0], jsonResponses[1]);
      });

      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      vm.campaigns.destroy();
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CampaignsViewModel', CampaignsViewModelFactory);

  /** @ngInject */
  function CampaignsViewModelFactory(gridUtils, $translate, campaignActions, localeFilters, CampaignItemViewModel, sessionData, dialogsService) {
    function CampaignsViewModel() {
      this.currentPage = 1;
      this.orderBy = '-from';
      this.hasErrorMessage = false;
      this.errorMessage = $translate.instant('DELETE_CAMPAIGN_ERROR');
      this.data = [];
      this.selected = [];
      this.count = 0;
      this.multiple = false;
      this.listEmpty = false;

      this.gridOptions = {
        multiple: false
      };
      this.treshold = 1;
      this.tresholdTypes = [{
        id: 'VISITS',
        name: 'NUMBER_OF_VISITS'
      }, {
        id: 'MONEY',
        name: 'TOTAL_MONEY_SPENT'
      }];
      this.selectedTresholdType = 'VISITS';

      this.dateFormat = localeFilters.defaultDateFormat;

      this.from = new Date();
      this.to = new Date();

      this.totalUsers = 0;
      this.chart = {
        data: null,
        x: {
          type: 'timeseries',
          tick: {
            centered: true,
            culling:{
              max : 7
            },
            format: function (item) {
              return localeFilters.date(item);
            },
            fit : true,
            rotate: 60
          }
        }
      };

      this.message = $translate.instant('CAMPAIGN_DEFAULT_SMS_MESSAGE');

      init.call(this);
    }

    CampaignsViewModel.prototype.destroy = function () {
      this.data.forEach(function (itemViewModel) {
        itemViewModel.destroy();
      });
    };

    CampaignsViewModel.prototype.refresh = refresh;

    CampaignsViewModel.prototype.onPeriodFromChanged = function () {
    };

    CampaignsViewModel.prototype.onPeriodToChanged = function () {
    };

    CampaignsViewModel.prototype.getTresholds = function () {
      var that = this,
          campaignId = this.selected[0].id,
          type = this.selectedTresholdType,
          tresholdValue = this.treshold,
          fromTimestamp = this.from.getTime(),
          toTimestamp = this.to.getTime();

      campaignActions.getLoyaltyTresholds(campaignId, type, tresholdValue, fromTimestamp, toTimestamp).then(function (data) {
        that.chart.data = data;
        that.totalUsers = data.total;
      });
    };

    CampaignsViewModel.prototype.sendMessage = function(){
      var that = this;
      dialogsService.showConfirmDialog($translate.instant('ARE_YOU_SURE'), $translate.instant('SEND_MESSAGE_NOTIFICATION'), $translate.instant('YES')).then(function(){
        campaignActions.sendCampaignUsersMessage(that.selected[0].id, that.treshold, that.selectedTresholdType, that.message);
      });
    };

    CampaignsViewModel.prototype.activateCampaign = function (campaign) {
      dialogsService.showConfirmDialog($translate.instant('ARE_YOU_SURE'), $translate.instant('ACTIVATE_CAMPAIGN_CONFIRMATION_MSG')+' '+campaign.name+' '+$translate.instant('CAMPAIGN'), $translate.instant('YES')).then(function(){
        campaignActions.activateCampaign(campaign.id).then(function () {
          campaign.activateCampaign();
        });
      });
    };

    return CampaignsViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      // this.limitPerPage = gridSettings.limitPerPage;
      this.limitPerPage = 10;
      this.pagerLabel = gridSettings.translations;
    }

    function refresh(campaignsArrayJson, userGroupsArrayJson) {
      var that = this;

      this.data = [];
      this.selected = [];
      this.count = 0;

      if(campaignsArrayJson.length === 0){
        this.listEmpty = true;
      }
      
      this.isSystemAdmin = (sessionData.getValue('userRole') === 'SYSTEM_ADMIN') ? true : false;
      this.hasErrorMessage = false;
      if (campaignsArrayJson) {
        that.count = campaignsArrayJson.length;
        campaignsArrayJson.forEach(function (campaignJson) {

          var fromDate = new Date(campaignJson.from);
          var toDate = new Date(campaignJson.to);
          var currentDate = new Date();

          if(fromDate < toDate && currentDate < fromDate){
            campaignJson.isInFuture = true;
          }else{
            campaignJson.isInFuture = false;
          }

          this.push(new CampaignItemViewModel(campaignJson, userGroupsArrayJson));
        }, this.data);
        
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CampaignTemplatesViewModel', CampaignTemplatesViewModelFactory);

  /** @ngInject */
  function CampaignTemplatesViewModelFactory(campaignTemplateActions, gridUtils, dialogsService, $translate, CampaignTemplateItemViewModel) {
    function CampaignTemplatesViewModel() {
      this.currentPage = 1;
      this.orderBy = 'name';
      this.hasErrorMessage = false;
      this.errorMessage = $translate.instant('DELETE_CAMPAIGN_TEMPLATE_ERROR');

      init.call(this);
    }

    CampaignTemplatesViewModel.prototype.destroy = function () {
      this.data.forEach(function (itemViewModel) {
        itemViewModel.destroy();
      });
    };

    CampaignTemplatesViewModel.prototype.deleteSelected = function () {
      var that = this;
      dialogsService.showConfirmDialog('CONFIRM_DELETE_CAMPAIGN_TEMPLATE', 'CONFIRM_DELETE_CAMPAIGN_TEMPLATE_TEXT', 'DELETE')
        .then(function () {
          campaignTemplateActions.deleteCampaignTemplate(that.selected[0].id).then(function () {
            refresh.call(that);
          }, function () {
            that.hasErrorMessage = true;
          });
        });
    };

    return CampaignTemplatesViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.limitPerPage = gridSettings.limitPerPage;
      this.pagerLabel = gridSettings.translations;

      refresh.call(this);
    }

    function refresh() {
      var that = this;

      this.data = [];
      this.selected = [];
      this.count = 0;
      this.hasErrorMessage = false;
      campaignTemplateActions.getCampaignTemplates().then(function (jsonArray) {
        if (jsonArray && jsonArray.length > 0) {
          that.count = jsonArray.length;
          jsonArray.forEach(function (json) {
            this.push(new CampaignTemplateItemViewModel(json));
          }, that.data);
        }
      });
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CampaignTemplateItemViewModel', CampaignTemplateItemViewModelFactory);

  /** @ngInject */
  function CampaignTemplateItemViewModelFactory(CampaignTemplateEnum) {
    function CampaignTemplateItemViewModel(templateJson) {
      this.id = templateJson.id;
      this.name = templateJson.name;
      this.rules = [];

      templateJson.numberOfVisits.forEach(function (rule) {
        rule.type = CampaignTemplateEnum.NUM_OF_VISITS;
        this.push(rule);
      }, this.rules);

      templateJson.amountOfMoney.forEach(function (rule) {
        rule.type = CampaignTemplateEnum.MONEY_SPENT;
        this.push(rule);
      }, this.rules);

      templateJson.dailyTemporal.forEach(function (rule) {
        rule.type = CampaignTemplateEnum.DAILY_TEMPORAL;
        this.push(rule);
      }, this.rules);

      this.rulesCount = this.rules.length;

      init.call(this);
    }

    CampaignTemplateItemViewModel.prototype.destroy = function () {
    };

    return CampaignTemplateItemViewModel;

    function init() {
      refresh.call(this);
    }

    function refresh() {
    }
  }
})();

(function() {
    "use strict";

    angular.module("sempraWebapp").factory("CampaignItemViewModel", CampaignItemViewModelFactory);

    /** @ngInject */
    function CampaignItemViewModelFactory(DateTime) {
        function CampaignItemViewModel(campaignJson, userGroupsArrayJson) {
            this.id = campaignJson.id;
            this.name = campaignJson.name;
            this.from = campaignJson.from;
            this.isInFuture = campaignJson.isInFuture;
            this.to = campaignJson.to;
            this.isInDateRange =
                new DateTime().timestamp < campaignJson.to && new DateTime().timestamp > campaignJson.from;
            this.isActive = campaignJson.active;
            this.activateEnabled = this.isInDateRange && !this.isActive;

            // money rule
            if (typeof campaignJson.moneyRule !== "undefined") {
                this.hasAmountOfMoneyRule = campaignJson.moneyRule.moneySpent.amount ? true : false;
            }

            // visit rule
            if (typeof campaignJson.visitsRule !== "undefined") {
                this.hasNumberOfVisitsRule = campaignJson.visitsRule.visits ? true : false;
            }

            // if is set one of those rules and campaign is active, set treshold to true
            if (typeof this.hasAmountOfMoneyRule !== "undefined" && typeof this.hasNumberOfVisitsRule !== "undefined") {
                this.tresholdEnabled = (this.hasAmountOfMoneyRule || this.hasNumberOfVisitsRule) && this.isActive;
            }

            if (campaignJson.temporalRule) {
                this.facilityType = campaignJson.temporalRule.deviceType;
            }

            this.userGroups = userGroupsArrayJson.filter(function(userGroupJson) {
                return campaignJson.userGroupIds.indexOf(userGroupJson.id) > -1;
            });

            init.call(this);
        }

        CampaignItemViewModel.prototype.destroy = function() {};

        CampaignItemViewModel.prototype.activateCampaign = function() {
            this.isActive = true;
            this.activateEnabled = false;
            this.tresholdEnabled = (this.hasAmountOfMoneyRule || this.hasNumberOfVisitsRule) && this.isActive;
        };

        return CampaignItemViewModel;

        function init() {
            refresh.call(this);
        }

        function refresh() {}
    }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('LoginViewModel', LoginViewModelFactory);

  /** @ngInject */
  function LoginViewModelFactory () {
    function LoginViewModel () {
      init.call(this);
    }

    LoginViewModel.prototype.destroy = function () {

    };

    return LoginViewModel;

    function init () {
      this.hasErrors = false;
      this.errorMessage = "";
      this.languages = [
        {
          id: 'en',
          name: 'English'
        },
        {
          id: 'sr',
          name: 'Srpski'
        },
        {
          id: 'de',
          name: 'Deutsch'
        },
        {
          id: 'fr',
          name: 'Français'
        },
        {
          id: 'hr',
          name: 'Hrvatski'
        },
        {
          id: 'pl',
          name: 'Polski'
        },
        {
          id: 'sl',
          name: 'Slovenščina'
        },
        {
          id: 'cs',
          name: 'Čeština'
        },
        {
          id: 'uk',
          name: 'Український'
        },
        {
          id: 'hu',
          name: 'Magyar'
        },
        {
          id: 'ru',
          name: 'Pусский'
        },
        {
          id: 'ro',
          name: 'Română'
        },
        {
          id: 'nl',
          name: 'Dutch'
        },
        {
          id: 'sv',
          name: 'Swedish'
        },
        {
          id: 'fi',
          name: 'Finnish'
        },
        {
          id: 'tw',
          name: 'Chinese (Traditional)'
        },
        {
          id: 'sk',
          name: 'Slovenský'
        }
      ];

      this.selectedLanguageId = localStorage.getItem('language') || 'en';
      this.email = '';
      this.password = '';
    }
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").controller("LoginController", LoginController);

  /** @ngInject */
  function LoginController(
    $state,
    locales,
    LoginViewModel,
    sessionData,
    userActions,
    version,
    applicationStore,
    userRolesEnum,
    checkUserRole,
    helperService,
    dispatcher,
    ActionTypesEnum,
    $translate
  ) {
    var vm = this;

    vm.login = new LoginViewModel();

    vm.version = version;
    vm.hasError = false;
    vm.buttonTitle = $translate.instant('LOGIN');
    vm.errorDescription = "";
    vm.inputType = "password";

    vm.doLogin = function () {
      vm.buttonTitle = $translate.instant('LOADING_DATA');

      userActions.signIn(vm.login.email.toLowerCase(), vm.login.password).then(
        function (userInfo) {
          checkUserRole.setCurrentRoles(userInfo.roles);
          helperService.setCurrentUserId(userInfo.user.id);
          helperService.setUserDataToLocalStorageOnLogIn(userInfo, vm.login.selectedLanguageId);

          if (checkUserRole.userRoleExist()) {
            $state.go("app.dashboardTechnology");
          } else {
            if (checkUserRole.hasAcceptNewTerms(userInfo.roles)) {
              $state.go("app.termsAndService", { marker: 'ready2wash-terms-of-service' });
            } else {
              sessionData.clearAll();
              vm.login.hasErrors = true;
              vm.login.errorMessage = $translate.instant("ERROR_LOGIN_ROLE");
            }
          }
        },
        function () {
          vm.login.hasErrors = true;
          vm.login.errorMessage = $translate.instant("ERROR_LOGIN");
          vm.buttonTitle = $translate.instant('LOGIN');
        }
      );
    };

    vm.showPassword = function() {
      vm.inputType = vm.inputType === "text" ? "password" : "text";
    }

    vm.onSelectedLanguageChange = function () {
      setLanguage(vm.login.selectedLanguageId);
      localStorage.setItem("language", vm.login.selectedLanguageId);
      vm.buttonTitle = $translate.instant('LOGIN');
    };

    // vm.goTermsAndServices = function (marker) {
    //   $state.go("app.termsAndService", { marker: marker });
    // };

    init();

    function init() {
      applicationStore.on(
        applicationStore.events.ERROR_STATE_CHANGE,
        showHideError
      );

      var session = sessionData.getAll();
      if (session[sessionData.Keys.LANGUAGE_KEY]) {
        vm.login.selectedLanguageId = session[sessionData.Keys.LANGUAGE_KEY];
      }
      if (session[sessionData.Keys.USERNAME_KEY]) {
        vm.login.email = session[sessionData.Keys.USERNAME_KEY];
      }
      setLanguage(vm.login.selectedLanguageId);

      if (session[sessionData.Keys.ACCESS_TOKEN_KEY]) {
        $state.go("app.dashboardTechnology");
      }
    }

    function showHideError(_hasError, _errMsgName, _errMsgDescription) {
      vm.hasError = _hasError;
      vm.errorDescription = _errMsgDescription;
    }

    function setLanguage(language) {
      locales.setLanguage(language);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('TermsAndServiceController', TermsAndService);

  /** @ngInject */
  function TermsAndService(
    $timeout,
    $sce,
    $location,
    $anchorScroll,
    userActions,
    sessionData,
    $stateParams,
    helperService,
    checkUserRole,
    $state,
    $window
  ) {
    var vm = this;
    var marker = $stateParams.marker;

    vm.termsOfService = null;
    vm.termsNeedToBeAccepted = false;

    vm.acceptTerms = function() {
      userActions
        .acceptTermsOfServiceDocument()
        .then(function (response) {
          helperService.setUserDataToLocalStorageOnLogIn(response.data);
          $state.go("app.dashboardTechnology", {}, {reload: true});
          $window.location.reload();
        });
    };

    activate();

    function activate() {
      setTermsAcceptanceStatus();
      loadTermsDocument();
    }

    function setTermsAcceptanceStatus() {
      var userRole = sessionData.getValue('userRole');
      vm.termsNeedToBeAccepted = checkUserRole.hasAcceptNewTerms(userRole);
    }

    function loadTermsDocument() {
      var countryCode = sessionData.getValue('countryIsoCode');
      var language = sessionData.getValue('language');

      userActions
        .getTermsOfServiceDocument(countryCode, language)
        .then(function (data) {
          vm.termsOfService = $sce.trustAsHtml(data || '<p>No data to display. Missing document.</p>');

          if (marker) {
            $timeout(function() {
              $location.hash(marker);
              $anchorScroll();
            });
          }
        });
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('KarcherServiceController', KarcherServiceController);

  /** @ngInject */
  function KarcherServiceController($stateParams, karcherServiceList, karcherOpenCloseHours, getDaysService) {
    var vm = this;

    var facility = $stateParams.facility;

    vm.serviceList = karcherServiceList.serviceList(facility.facility);
    vm.operationList = karcherServiceList.operationList(facility.facility);
    vm.pumpTypeList = karcherServiceList.pumpTypeList(facility.facility);
    vm.programList = karcherServiceList.programList(facility);
    vm.currentList = karcherServiceList.currentList(facility.facility);

    //Create working hour table
    vm.dayList = getDaysService.getShortDayList();

    vm.lightsOn = karcherOpenCloseHours.lightsOn(facility.facility);
    vm.lightsOff = karcherOpenCloseHours.lightsOff(facility.facility);
    vm.washBoxesOn = karcherOpenCloseHours.washBoxOn(facility.facility);
    vm.washBoxesOff = karcherOpenCloseHours.washBoxOff(facility.facility);
    vm.vacuumsOn = karcherOpenCloseHours.vacuumOn(facility.facility);
    vm.vacuumsOff = karcherOpenCloseHours.vacuumOff(facility.facility);
    vm.workingHoursTable = true;

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('LayoutViewModel', layoutViewModelFactory);

  /** @ngInject */
  function layoutViewModelFactory (applicationStore, $translate) {
    function LayoutViewModel () {
      this.hasError = false;
      this.isLoading = false;
      this.errorHeader = $translate.instant('SOMETHING_WENT_WRONG');
      this.errorName = $translate.instant('DEFAULT_ERROR_NAME');
      this.errorDescription  = $translate.instant('DEFAULT_ERROR_DESCRIPTION');
      init.call(this);
    }

    LayoutViewModel.prototype.destroy = function () {
      applicationStore.off(applicationStore.events.LOADER_CHANGE, this._showHideLoader);
    };

    return LayoutViewModel;

    function init () {
      // var that = this;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("LayoutController", LayoutController);

  /** @ngInject */
  function LayoutController(
    $scope,
    broker,
    LayoutViewModel,
    applicationStore,
    $mdToast,
    $timeout,
    refreshToken,
    sessionData
  ) {
    var vm = this;
    // Get token on app init and set to local storage (from router resolver)
    if (refreshToken) {
      sessionData.setValue(
        sessionData.Keys.ACCESS_TOKEN_KEY,
        refreshToken.accessToken
      );
    }

    vm.layout = new LayoutViewModel();
    vm.smallMenu = localStorage.getItem(sessionData.Keys.SMALL_MENU) === "true";

    init();

    function init() {
      $scope.$on("$destroy", destroy);
      broker.initWebSockets();

      applicationStore.on(
        applicationStore.events.LOADER_CHANGE,
        showHideLoader
      );
      applicationStore.on(
        applicationStore.events.ERROR_STATE_CHANGE,
        showHideError
      );
      applicationStore.on(
        applicationStore.events.TOAST_CHANGE,
        showSimpleToast
      );
    }

    function showHideLoader(_isLoading) {
      vm.layout.isLoading = _isLoading;
    }

    function showHideError(_hasError, _errMsgName, _errMsgDescription) {
      vm.layout.hasError = _hasError;
      vm.layout.errorName = _errMsgName;
      vm.layout.errorDescription = _errMsgDescription;
      $timeout(hideErrorMsg, 10000);
    }

    function hideErrorMsg() {
      vm.layout.hasError = false;
    }

    function showSimpleToast(data) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent(data)
          .position("bottom right")
          .hideDelay(3000)
      );
    }

    function destroy() {
      if (broker.isConnected()) {
        broker.unsubscribeSocket();
        broker.disconnectSockets();
      }
      vm.layout.destroy();
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ForgotPasswordViewModel', ForgotPasswordViewModelFactory);

  /** @ngInject */
  function ForgotPasswordViewModelFactory ($translate, applicationStore, $mdToast) {
    function ForgotPasswordViewModel () {
      init.call(this);
    }

    ForgotPasswordViewModel.prototype.destroy = function () {

    };

    return ForgotPasswordViewModel;

    function init () {
      this.hasErrors = false;
			this.errorMsg = $translate.instant('FORGOT_PASSWORD_ERROR_MSG');
      applicationStore.on(applicationStore.events.TOAST_CHANGE, showSimpleToast);
    }

    function showSimpleToast(data) {
      $mdToast.show(
        $mdToast.simple()
          .textContent(data)
          .position('bottom right')
          .hideDelay(3000)
      );
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ForgotPasswordController', ForgotPasswordInject);

  /** @ngInject */
  function ForgotPasswordInject($state, userActions, ForgotPasswordViewModel) {
    var vm = this;

    vm.password = new ForgotPasswordViewModel();

    vm.forgotPassword = function (form) {
      var email = form.email.$viewValue;
      var language = localStorage.getItem('language');
      userActions.forgotPassword(email, language).then(
        function () {
          $state.go('login');
        },
        function () {
          vm.password.hasErrors = true;
        }
      );
    };
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').filter('zeroPaddingFilter', zeroPadding);

  /** @ngInject */
  function zeroPadding() {
    return function (input, n) {
      if (!input) {
        return (input = '00');
      } else if (input.length >= n) {
        return input;
      }
      var zeros = '0'.repeat(n);
      return (zeros + input).slice(-1 * n);
    };
  }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .filter('weekDaysFacilityFilter', weekDaysFacilityFilter);

  /** @ngInject */
  function weekDaysFacilityFilter($translate) {
    return function(text) {
      if(!text) return;
      switch (text) {
        case "Mon":
          return $translate.instant("MON");
        case "IlluminationMon":
          return $translate.instant("MON");
        case "VacuumsMon":
          return $translate.instant("MON");
        case "Tue":
          return $translate.instant("TUE");
        case "IlluminationTue":
          return $translate.instant("TUE");
        case "VacuumsTue":
          return $translate.instant("TUE");
        case "Wed":
          return $translate.instant("WED");
        case "IlluminationWed":
          return $translate.instant("WED");
        case "VacuumsWed":
          return $translate.instant("WED");
        case "Thu":
          return $translate.instant("THU");
        case "IlluminationThu":
          return $translate.instant("THU");
        case "VacuumsThu":
          return $translate.instant("THU");
        case "Fri":
          return $translate.instant("FRI");
        case "IlluminationFri":
          return $translate.instant("FRI");
        case "VacuumsFri":
          return $translate.instant("FRI");
        case "Sat":
          return $translate.instant("SAT");
        case "IlluminationSat":
          return $translate.instant("SAT");
        case "VacuumsSat":
          return $translate.instant("SAT");
        case "Sun":
          return $translate.instant("SUN");
        case "IlluminationSun":
          return $translate.instant("SUN");
        case "VacuumsSun":
          return $translate.instant("SUN");
        case "Hol":
          return $translate.instant("HOLIDAY");
        case "IlluminationHol":
          return $translate.instant("HOLIDAY");
        case "VacuumsHol":
          return $translate.instant("HOLIDAY");
        default:
          return text;
      }
    };
  }
})();

(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('truncate', truncate);

    /** @ngInject */
    function truncate() {
        return function(text, length, end) {
            if (isNaN(length))
              length = 10;

            if (angular.isUndefined(end))
              end = "...";

            if (text.length <= length || text.length - end.length <= length) {
              return text;
            } else {
              return String(text).substring(0, length - end.length) + end;
            }

        };
    }

})();

(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('translateReferencesFilter', translateReferences);

    /** @ngInject */
    function translateReferences($translate) {
        return function(text) {
			switch (text) {
				case '24H':
					return $translate.instant("DAILY_TIME");
				case 'ILL_24H':
					return $translate.instant("DAILY_TIME");
				case 'VAC_24H':
					return $translate.instant("DAILY_TIME");
				case 'START':
					return $translate.instant("START");
				case 'STOP':
					return $translate.instant("STOP");
				case 'ILL_START':
					return $translate.instant("START");
				case 'ILL_STOP':
					return $translate.instant("STOP");
				case 'VAC_START':
					return $translate.instant("START");
				case 'VAC_STOP':
					return $translate.instant("STOP");
				default:
					return text;
			}
		};

    }

})();

(function () {
  "use strict";

  angular.module("sempraWebapp").filter("availableDeviceFilter", translateFlag);

  /** @ngInject */
  function translateFlag() {
    return function (input) {
      switch (input) {
        case "1.0":
          return "AVAILABLE_TITLE";
        case "0.0":
          return "UNAVAILABLE_TITLE";
        default:
          return "AVAILABLE_TITLE";
      }
    };
  }
})();

(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('tokensFilter', tokensFilter);

    /** @ngInject */
    function tokensFilter() {
        return function(text) {
			switch (text) {
				case 'R2W':
					return 'R2W';
				default:
					return 'LOCALE_TOKEN';
			}
        };
    }

})();

(function () {
  "use strict";

  angular.module("sempraWebapp").filter("stringToBoolean", stringToBoolean);

  /** @ngInject */
  function stringToBoolean() {
    return function (input) {
      switch (input) {
        case "vacuums%20not%20installed":
          return false;
        default:
          return true;
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .filter('secondsToHoursMinutesSeconds', secondsToHoursMinutesSeconds);

  /** @ngInject */
  function secondsToHoursMinutesSeconds($filter) {
    return function (seconds) {
      if (!seconds) {
        return '00:00:00:00';
      }

      seconds = Number(seconds);
      var d = Math.floor(seconds / (3600 * 24));
      var h = Math.floor((seconds % (3600 * 24)) / 3600);
      var m = Math.floor((seconds % 3600) / 60);
      var s = Math.floor(seconds % 60);
      return (
        $filter('zeroPaddingFilter')(d, 2) +
        ':' +
        $filter('zeroPaddingFilter')(h, 2) +
        ':' +
        $filter('zeroPaddingFilter')(m, 2) +
        ':' +
        $filter('zeroPaddingFilter')(s, 2)
      );
    };
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .filter("rolloverStatusCode", rolloverStatusCode);

  /** @ngInject */
  function rolloverStatusCode($translate) {
    return function (input) {
      for (var i = 0; i < 26; i++) {
        if (input === i + ".0") {
          return $translate.instant("ROLLOVER_STATUS_CODE_" + i);
        } else if (input === "98.0") {
          return $translate.instant("ROLLOVER_STATUS_CODE_98");
        } else if (input === "99.0") {
          return $translate.instant("ROLLOVER_STATUS_CODE_99");
        }
      }
    };
  }
})();

(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('replacews', replacews);

    /** @ngInject */
    function replacews() {
        return function(text) {

          if(!text) return;

          return text.replace(/ /g, "_");
        };
    }

})();

(function() {
  'use strict';

  angular.module('sempraWebapp').filter('removews', removews);

  /** @ngInject */
  function removews() {
    return function(text) {
      if (!text) return;

      var decoded = text;
      var decodedAgain = decodeURIComponent(decoded);
      while (decoded !== decodedAgain) {
        decoded = decodedAgain;
        decodedAgain = decodeURIComponent(decoded);
      }
      return decoded;
    };
  }
})();

(function() {
  "use strict";

  angular.module("sempraWebapp").filter("removeAfterDot", removeAfterDot);

  /** @ngInject */
  function removeAfterDot() {
    return function(text) {
      if (!text) {
        return 0.00
      }
      var splitedString = text.split(".");

      if (!text || splitedString[1] !== "0") return text;

      return splitedString[0];
    };
  }
})();

(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('operatingTimeFormat', operatingTimeFormat);

    /** @ngInject */
    function operatingTimeFormat() {
        return function(text) {

          if(!text) return;

          return text.replace(/-/g, ":");
        };
    }

})();

(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('operatingTimeFilter', operatingTime);

    /** @ngInject */
    function operatingTime($translate) {
        return function(text) {
			switch (text) {
				case 'true':
					return $translate.instant("OPENED_24");
				case 'false':
					return "";
				case '24hopen':
					return $translate.instant("OPENED_24");
				case '24hclose':
					return $translate.instant("CLOSED_24");
				case undefined:
					return " - ";
				default:
					return $translate.instant("CLOSED_24");
			}
		};

    }

})();

(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('monthToStringFilter', monthToString);

    /** @ngInject */
    function monthToString(getMonthsService) {
        return function(text) {
			return getMonthsService.getMonthList()[text-1];
		};

    }

})();

(function () {
  'use strict';
  angular
    .module('sempraWebapp')
    .filter('karcherPointTranslation', karcherPointTranslation);
  /** @ngInject */
  function karcherPointTranslation($translate) {
    return function (text) {
      if (!text) return;
      switch (text) {
        case 'Hol':
          return $translate.instant('KARCHER_POINT_NAME_1');
        case 'Mon':
          return $translate.instant('KARCHER_POINT_NAME_2');
        case 'Tue':
          return $translate.instant('KARCHER_POINT_NAME_3');
        case 'Wed':
          return $translate.instant('KARCHER_POINT_NAME_4');
        case 'Thu':
          return $translate.instant('KARCHER_POINT_NAME_5');
        case 'Fri':
          return $translate.instant('KARCHER_POINT_NAME_6');
        case 'Sat':
          return $translate.instant('KARCHER_POINT_NAME_7');
        case 'Sun':
          return $translate.instant('KARCHER_POINT_NAME_8');
        case 'VacuumsHol':
          return $translate.instant('KARCHER_POINT_NAME_9');
        case 'VacuumsMon':
          return $translate.instant('KARCHER_POINT_NAME_10');
        case 'VacuumsTue':
          return $translate.instant('KARCHER_POINT_NAME_11');
        case 'VacuumsWed':
          return $translate.instant('KARCHER_POINT_NAME_12');
        case 'VacuumsThu':
          return $translate.instant('KARCHER_POINT_NAME_13');
        case 'VacuumsFri':
          return $translate.instant('KARCHER_POINT_NAME_14');
        case 'VacuumsSat':
          return $translate.instant('KARCHER_POINT_NAME_15');
        case 'VacuumsSun':
          return $translate.instant('KARCHER_POINT_NAME_16');
        case 'IlluminationHol':
          return $translate.instant('KARCHER_POINT_NAME_17');
        case 'IlluminationMon':
          return $translate.instant('KARCHER_POINT_NAME_18');
        case 'IlluminationTue':
          return $translate.instant('KARCHER_POINT_NAME_19');
        case 'IlluminationWed':
          return $translate.instant('KARCHER_POINT_NAME_20');
        case 'IlluminationThu':
          return $translate.instant('KARCHER_POINT_NAME_21');
        case 'IlluminationFri':
          return $translate.instant('KARCHER_POINT_NAME_22');
        case 'IlluminationSat':
          return $translate.instant('KARCHER_POINT_NAME_23');
        case 'IlluminationSun':
          return $translate.instant('KARCHER_POINT_NAME_24');
        case 'Program_0':
          return $translate.instant('KARCHER_POINT_NAME_25');
        case 'Program_1':
          return $translate.instant('KARCHER_POINT_NAME_26');
        case 'Program_2':
          return $translate.instant('KARCHER_POINT_NAME_27');
        case 'Program_3':
          return $translate.instant('KARCHER_POINT_NAME_28');
        case 'Program_4':
          return $translate.instant('KARCHER_POINT_NAME_29');
        case 'Program_5':
          return $translate.instant('KARCHER_POINT_NAME_30');
        case 'Program_6':
          return $translate.instant('KARCHER_POINT_NAME_31');
        case 'Program_7':
          return $translate.instant('KARCHER_POINT_NAME_32');
        case 'Program_8':
          return $translate.instant('KARCHER_POINT_NAME_33');
        case 'Program_9':
          return $translate.instant('KARCHER_POINT_NAME_34');
        case 'Program_10':
          return $translate.instant('KARCHER_POINT_NAME_35');
        case 'Program_11':
          return $translate.instant('KARCHER_POINT_NAME_36');
        case 'Program_12':
          return $translate.instant('KARCHER_POINT_NAME_37');
        case 'Program_13':
          return $translate.instant('KARCHER_POINT_NAME_38');
        case 'Program_14':
          return $translate.instant('KARCHER_POINT_NAME_39');
        case 'Program_15':
          return $translate.instant('KARCHER_POINT_NAME_40');
        case 'Program_16':
          return $translate.instant('KARCHER_POINT_NAME_41');
        case 'Program_17':
          return $translate.instant('KARCHER_POINT_NAME_42');
        case 'Program_18':
          return $translate.instant('KARCHER_POINT_NAME_43');
        case 'Program_19':
          return $translate.instant('KARCHER_POINT_NAME_44');
        case 'Program_20':
          return $translate.instant('KARCHER_POINT_NAME_45');
        case 'Program_21':
          return $translate.instant('KARCHER_POINT_NAME_46');
        case 'Program_22':
          return $translate.instant('KARCHER_POINT_NAME_47');
        case 'Program_23':
          return $translate.instant('KARCHER_POINT_NAME_48');
        case 'Program_24':
          return $translate.instant('KARCHER_POINT_NAME_49');
        case 'Program_25':
          return $translate.instant('KARCHER_POINT_NAME_50');
        case 'Program_26':
          return $translate.instant('KARCHER_POINT_NAME_51');
        case 'Program_27':
          return $translate.instant('KARCHER_POINT_NAME_52');
        case 'Program_28':
          return $translate.instant('KARCHER_POINT_NAME_53');
        case 'Program_29':
          return $translate.instant('KARCHER_POINT_NAME_54');
        case 'Program_30':
          return $translate.instant('KARCHER_POINT_NAME_55');
        case 'Program_31':
          return $translate.instant('KARCHER_POINT_NAME_56');
        case 'Program_32':
          return $translate.instant('KARCHER_POINT_NAME_57');
        default:
          return $translate.instant(text);
      }
    };
  }
})();

(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('karcherOperationCountersTranslation', karcherOperationCountersTranslation);

    /** @ngInject */
    function karcherOperationCountersTranslation($translate) {
        return function(text) {
          if(!text) return;
          switch (text) {
            case "Washing%20station%201%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_1");
            case "Washing%20station%201%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_2");
            case "Washing%20station%201%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_3");
            case "Washing%20station%201%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_4");
            case "Washing%20station%201%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_5");
            case "Washing%20station%202%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_6");
            case "Washing%20station%202%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_7");
            case "Washing%20station%202%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_8");
            case "Washing%20station%202%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_9");
            case "Washing%20station%202%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_10");
            case "Washing%20station%203%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_11");
            case "Washing%20station%203%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_12");
            case "Washing%20station%203%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_13");
            case "Washing%20station%203%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_14");
            case "Washing%20station%203%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_15");
            case "Washing%20station%204%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_16");
            case "Washing%20station%204%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_17");
            case "Washing%20station%204%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_18");
            case "Washing%20station%204%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_19");
            case "Washing%20station%204%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_20");
            case "Washing%20station%205%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_21");
            case "Washing%20station%205%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_22");
            case "Washing%20station%205%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_23");
            case "Washing%20station%205%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_24");
            case "Washing%20station%205%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_25");
            case "Washing%20station%206%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_26");
            case "Washing%20station%206%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_27");
            case "Washing%20station%206%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_28");
            case "Washing%20station%206%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_29");
            case "Washing%20station%206%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_30");
            case "Washing%20station%207%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_31");
            case "Washing%20station%207%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_32");
            case "Washing%20station%207%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_33");
            case "Washing%20station%207%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_34");
            case "Washing%20station%207%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_35");
            case "Washing%20station%208%20HP%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_36");
            case "Washing%20station%208%20chemical%20pump%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_37");
            case "Washing%20station%208%20chemical%20pump%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_38");
            case "Washing%20station%208%20chemical%20pump%203":
              return $translate.instant("KARCHER_OPERATION_COUNTER_39");
            case "Washing%20station%208%20chemical%20pump%204":
              return $translate.instant("KARCHER_OPERATION_COUNTER_40");
            case "Osmosis%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_41");
            case "Hot%20water%20generator":
              return $translate.instant("KARCHER_OPERATION_COUNTER_42");
            case "Frost%20protection%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_43");
            case "WSO%20filter%20inlay":
              return $translate.instant("KARCHER_OPERATION_COUNTER_44");
            case "Washing%20station%20heater%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_45");
            case "Hot%20water%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_46");
            case "Foam%20hose%20heating":
              return $translate.instant("KARCHER_OPERATION_COUNTER_47");
            case "Wheel%20cleaning%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_48");
            case "Micro-emulsion%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_49");
            case "Intensive%20foam%20pump":
              return $translate.instant("KARCHER_OPERATION_COUNTER_50");
            case "Vacuum%20cleaner%201%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_51");
            case "Vacuum%20cleaner%201%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_52");
            case "Vacuum%20cleaner%201%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_53");
            case "Vacuum%20cleaner%201%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_54");
            case "Vacuum%20cleaner%202%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_55");
            case "Vacuum%20cleaner%202%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_56");
            case "Vacuum%20cleaner%202%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_57");
            case "Vacuum%20cleaner%202%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_58");
            case "Vacuum%20cleaner%203%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_59");
            case "Vacuum%20cleaner%203%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_60");
            case "Vacuum%20cleaner%203%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_61");
            case "Vacuum%20cleaner%203%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_62");
            case "Vacuum%20cleaner%204%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_63");
            case "Vacuum%20cleaner%204%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_64");
            case "Vacuum%20cleaner%204%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_65");
            case "Vacuum%20cleaner%204%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_66");
            case "Vacuum%20cleaner%205%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_67");
            case "Vacuum%20cleaner%205%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_68");
            case "Vacuum%20cleaner%205%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_69");
            case "Vacuum%20cleaner%205%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_70");
            case "Vacuum%20cleaner%206%20turbine%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_71");
            case "Vacuum%20cleaner%206%20filter%201":
              return $translate.instant("KARCHER_OPERATION_COUNTER_72");
            case "Vacuum%20cleaner%206%20turbine%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_73");
            case "Vacuum%20cleaner%206%20filter%202":
              return $translate.instant("KARCHER_OPERATION_COUNTER_74");
            case "Drain%20condensation%20water%20from%20the%20compressor":
              return $translate.instant("KARCHER_OPERATION_COUNTER_75");
            case "Check%20frost%20protection%20system":
              return $translate.instant("KARCHER_OPERATION_COUNTER_76");
            case "Burner%20fan":
              return $translate.instant("KARCHER_OPERATION_COUNTER_77");
            case "Booster%20pump%20foam":
              return $translate.instant("KARCHER_OPERATION_COUNTER_78");
            default:
              return text;
          }
        };
    }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .filter('karcherEventTranslation', karcherEventTranslation);

  /** @ngInject */
  function karcherEventTranslation($translate) {
    return function (text) {
      if (!text) return;
      switch (text) {
        case 'Base%20exchanger%20regenerated':
          return $translate.instant('KARCHER_EVENT_NAME_1');
        case 'Base%20exchanger%20regeneration%20ended':
          return $translate.instant('KARCHER_EVENT_NAME_2');
        case 'Material%20/%20serial%20number':
          return $translate.instant('KARCHER_EVENT_NAME_3');
        case 'The%20system%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_4');
        case 'HP%20pump%201%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_5');
        case 'HP%20pump%202%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_6');
        case 'HP%20pump%203%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_7');
        case 'HP%20pump%204%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_8');
        case 'HP%20pump%205%20has%20been%20disinfected':
          return $translate.instant('KARCHER_EVENT_NAME_9');
        case 'Washing%20station%201%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_10');
        case 'Washing%20station%202%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_11');
        case 'Washing%20station%203%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_12');
        case 'Washing%20station%204%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_13');
        case 'Washing%20station%205%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_14');
        case 'Washing%20station%206%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_15');
        case 'Washing%20station%207%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_16');
        case 'Washing%20station%208%20locked':
          return $translate.instant('KARCHER_EVENT_NAME_17');
        case 'Update%20started':
          return $translate.instant('KARCHER_EVENT_NAME_18');
        case 'Update%20finished':
          return $translate.instant('KARCHER_EVENT_NAME_19');
        case 'Start%20WS%20Reg':
          return $translate.instant('KARCHER_EVENT_NAME_20');
        case 'End%20WS%20Reg':
          return $translate.instant('KARCHER_EVENT_NAME_21');
        case 'WS%2075%%20sensor':
          return $translate.instant('KARCHER_EVENT_NAME_22');
        case 'Tech.%20defect':
          return $translate.instant('KARCHER_EVENT_NAME_23');
        case 'Oper.%20defect':
          return $translate.instant('KARCHER_EVENT_NAME_24');
        case 'Unit%20on':
          return $translate.instant('KARCHER_EVENT_NAME_25');
        case 'Unit%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_26');
        case 'Box%201%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_27');
        case 'Box%202%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_28');
        case 'Box%203%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_29');
        case 'Box%204%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_30');
        case 'Box%205%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_31');
        case 'Box%206%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_32');
        case 'Box%207%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_33');
        case 'Box%208%20closed':
          return $translate.instant('KARCHER_EVENT_NAME_34');
        case 'HP%20pump%20bay%201':
          return $translate.instant('KARCHER_EVENT_NAME_35');
        case 'HP%20pump%20bay%202':
          return $translate.instant('KARCHER_EVENT_NAME_36');
        case 'HP%20pump%20bay%203':
          return $translate.instant('KARCHER_EVENT_NAME_37');
        case 'HP%20pump%20bay%204':
          return $translate.instant('KARCHER_EVENT_NAME_38');
        case 'HP%20pump%20bay%205':
          return $translate.instant('KARCHER_EVENT_NAME_39');
        case 'HP%20pump%20bay%206':
          return $translate.instant('KARCHER_EVENT_NAME_40');
        case 'HP%20pump%20bay%207':
          return $translate.instant('KARCHER_EVENT_NAME_41');
        case 'HP%20pump%20bay%208':
          return $translate.instant('KARCHER_EVENT_NAME_42');
        case 'Burner':
          return $translate.instant('KARCHER_EVENT_NAME_43');
        case 'Burner%20fan':
          return $translate.instant('KARCHER_EVENT_NAME_44');
        case 'Warm%20water%20pump':
          return $translate.instant('KARCHER_EVENT_NAME_45');
        case 'Freeze%20prot.pump':
          return $translate.instant('KARCHER_EVENT_NAME_46');
        case 'Osmosis%20pump':
          return $translate.instant('KARCHER_EVENT_NAME_47');
        case 'Floor%20heating':
          return $translate.instant('KARCHER_EVENT_NAME_48');
        case 'Hose%20heating':
          return $translate.instant('KARCHER_EVENT_NAME_49');
        case 'Microe/rim%20clean':
          return $translate.instant('KARCHER_EVENT_NAME_50');
        case 'Underc.%20pump':
          return $translate.instant('KARCHER_EVENT_NAME_51');
        case 'Booster%20pumpFoam':
          return $translate.instant('KARCHER_EVENT_NAME_52');
        case 'Vacuum%20clean.%201':
          return $translate.instant('KARCHER_EVENT_NAME_53');
        case 'Vacuum%20clean.%202':
          return $translate.instant('KARCHER_EVENT_NAME_54');
        case 'Vacuum%20clean.%203':
          return $translate.instant('KARCHER_EVENT_NAME_55');
        case 'Vacuum%20clean.%204':
          return $translate.instant('KARCHER_EVENT_NAME_56');
        case 'Vacuum%20clean.%205':
          return $translate.instant('KARCHER_EVENT_NAME_57');
        case 'Vacuum%20clean.%206':
          return $translate.instant('KARCHER_EVENT_NAME_58');
        case 'Vacuum%20clean.%207':
          return $translate.instant('KARCHER_EVENT_NAME_59');
        case 'Vacuum%20clean.%208':
          return $translate.instant('KARCHER_EVENT_NAME_60');
        case 'Vacuum%20clean.%209':
          return $translate.instant('KARCHER_EVENT_NAME_61');
        case 'Vacuum%20clean.%2010':
          return $translate.instant('KARCHER_EVENT_NAME_62');
        case 'Vacuum%20clean.%2011':
          return $translate.instant('KARCHER_EVENT_NAME_63');
        case 'Vacuum%20clean.%2012':
          return $translate.instant('KARCHER_EVENT_NAME_64');
        case 'Pump%20rim%20clean':
          return $translate.instant('KARCHER_EVENT_NAME_65');
        case 'Pump%20Microe.':
          return $translate.instant('KARCHER_EVENT_NAME_66');
        case 'Pump%20Intensive':
          return $translate.instant('KARCHER_EVENT_NAME_67');
        case 'Vacuum1%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_68');
        case 'Vacuum1%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_69');
        case 'Vacuum2%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_70');
        case 'Vacuum2%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_71');
        case 'Vacuum3%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_72');
        case 'Vacuum3%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_73');
        case 'Vacuum4%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_74');
        case 'Vacuum4%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_75');
        case 'Vacuum5%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_76');
        case 'Vacuum5%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_77');
        case 'Vacuum6%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_78');
        case 'Vacuum6%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_79');
        case 'Vacuum7%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_80');
        case 'Vacuum7%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_81');
        case 'Vacuum8%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_82');
        case 'Vacuum8%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_83');
        case 'Vacuum9%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_84');
        case 'Vacuum9%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_85');
        case 'Vacuum10%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_86');
        case 'Vacuum10%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_87');
        case 'Vacuum11%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_88');
        case 'Vacuum11%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_89');
        case 'Vacuum12%20turbine':
          return $translate.instant('KARCHER_EVENT_NAME_90');
        case 'Vacuum12%20filter':
          return $translate.instant('KARCHER_EVENT_NAME_91');
        default:
          return text;
      }
    };
  }
})();

(function() {
    'use strict';

    angular
      .module('sempraWebapp')
      .filter('karcherCustomTranslation', karcherCustomTranslation);

    /** @ngInject */
    function karcherCustomTranslation($translate) {
        return function(text) {
          if(!text) return;
          switch (text) {
            case "Hei%C3%9Fwachs":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_1");
            case "Heißwachs":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_1");
            case "Hochdruckw%C3%A4sche":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_2");
            case "Hochdruckwäsche":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_2");
            case "Powerfelgenschaum":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_3");
            case "Powerschaum":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_4");
            case "STOP":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_5");
            case "Schaumw%C3%A4sche%20HD":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_6");
            case "Schaumwäsche HD":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_6");
            case "Sp%C3%BClen":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_7");
            case "Spülen":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_7");
            case "Top-Pflege":
              return $translate.instant("KARCHER_CUSTOM_PROGRAM_NAME_8");
            case "unit%20open":
              return $translate.instant("AVAILABILITY_STATUS_1");
            case "unit%20closed%20(holiday)":
              return $translate.instant("AVAILABILITY_STATUS_2");
            case "unit%20closed%20(operating time)":
              return $translate.instant("AVAILABILITY_STATUS_3");
            case "unit%20closed%20(fault)":
              return $translate.instant("AVAILABILITY_STATUS_4");
            case "unit%20closed%20(other)":
              return $translate.instant("AVAILABILITY_STATUS_5");
            case "vacuums%20not%20installed":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_1");
            case "vacuums%20open":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_2");
            case "vacuums%20closed%20(holiday)":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_3");
            case "vacuums%20closed%20(operating time)":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_4");
            case "vacuums%20closed%20(fault)":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_5");
            case "vacuums%20closed%20(other)":
              return $translate.instant("AVAILABILITY_VACUUMS_STATUS_6");
            default:
              return text;
          }
        };
    }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").filter("codeToDayName", codeToDayName);

  /** @ngInject */
  function codeToDayName($translate) {
    return function (input) {
      switch (input) {
        case 0:
          return $translate.instant('MON');
        case 1:
          return $translate.instant('TUE');
        case 2:
          return $translate.instant('WED');
        case 3:
          return $translate.instant('THU');
        case 4:
          return $translate.instant('FRI');
        case 5:
          return $translate.instant('SAT');
        case 6:
          return $translate.instant('SUN');
        case 7:
          return $translate.instant('HOLIDAY');
      }
    };
  }
})();

(function () {
  "use strict";

  angular.module("sempraWebapp").filter("chemicalIcon", chemicalIcon);

  /** @ngInject */
  function chemicalIcon() {
    return function (input) {
      switch (input) {
        case "CHEM_LEVEL_DRYING_AGENT":
          return "assets/images/rollover_drying.svg";
        case "CHEM_LEVEL_SHAMPOO":
          return "assets/images/rollover_shampoo.svg";
        case "CHEM_LEVEL_FOAM":
          return "assets/images/rollover_foam.svg"
        case "CHEM_LEVEL_WAX_1":
          return "assets/images/rollover_wax.svg";
        case "CHEM_LEVEL_POLISH_1":
          return "assets/images/rollover_polish.svg";
        case "CHEM_LEVEL_RIM_CLEANER":
          return "assets/images/rollover_rim_cleaner_11.svg";
        case "CHEM_LEVEL_WAX_2":
          return "assets/images/rollover_wax.svg";
        case "CHEM_LEVEL_TYRE_SHINE":
          return "assets/images/rollover_shampoo.svg";
        case "CHEM_LEVEL_INSECT_REMOVER":
          return "assets/images/rollover_insect_remover.svg";
        case "CHEM_LEVEL_POLISH_2":
          return "assets/images/rollover_polish.svg";
        case "CHEM_LEVEL_INTENSIVE":
          return "assets/images/rollover_shampoo.svg";
        case "CHEM_LEVEL_FOAM_RAIN":
          return "assets/images/rollover_foam_rain.svg";
        default:
          return "assets/images/rollover_shampoo.svg";
      }
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory(
      'FacilityKarcherDetailsViewModel',
      facilityKarcherDetailsViewModelFactory
    );

  /** @ngInject */
  function facilityKarcherDetailsViewModelFactory(
    invariant,
    modelUtils,
    moment,
    layoutActions,
    $translate,
    $timeout,
    feedVisibility,
    sessionData,
    $state
  ) {
    function FacilityKarcherDetailsViewModel() {
      // Global object that includes all component lists and activePath property
      // (important for actuator and feed via webSockets update)
      this.globalListObject = {};

      this.deviceSerial = '';
      this.status = '';
      this.lastReportTimestamp = null;
      this.facilityName = '';
      this.facilityId = null;
      this.facilityIdForQrCode = '';
      this.facilityType = '';
      this.weatherIcon = '';
      this.feedReferences = {};
      this.changeOfParametersData = {};
      this.facilityIcon = '';
      this.machineType = '';
      this.materialNumber = '';
      this.numberOfAlarms = { warnings: 0, alarms: 0 };
      this.siteAddress = '';
      this.siteLatitude = '';
      this.siteLongitude = '';
      this.currentWeatherData = {
        country: '',
        city: '',
        region: '',
        temperature: '',
        currentWeatherIcon: ''
      };
      this.speedsPointId = null;
      this.dosingPointId = null;
      this.programPointId = null;
      this.installationDateOfMachine = '';

      this.deviceList = [];
      this.alarmList = [];
      this.selectedDevice = null;
      this.operationCounterList = [];
      this.operationCounterObject = {};
      this.programList = [];
      this.pumpsList = [];
      this.activeProgramItem = null;
      this.dosingList = [];
      this.speedList = [];
      this.listOfExistingChemicals = [];
      this.rolloverOperationCounterList = [];
      this.rolloverServiceCounterList = [];
      // For mapping name of active program. Embedded need to add name in active program actuators
      this.activeProgramActuators = [];
      this.maintenanceDays = '';
      this.maintenanceWashes = '';
      this.serviceOnOperationCountersDeviceNeeded = false;

      // List of active actuator from components. Important for web socket data update
      this.rolloverSpeedsActuatorList = [];
      this.rolloverDosingActuatorList = [];
      this.rolloverParametersActuatorList = [];
      this.speedsPointPath = '';
      this.dosingPointPath = '';
      this.programPointPath = '';
      this.activeProgramUpdatedFeed = null;
      this.componentCollapseDefaultState = true;

      this.activePath = '';
      this.fromWebSocketsEventData = null;

      // Grid data
      this.alarmsOrderBy = 'timestamp';
      this.alarmsOrder = 'desc';
      this.alarmsPage = 1;
      this.alarmsTotal = 0;
      this.alarmsPageSize = 5;
      this.alarmsPageOptions = [5];
      this.pagerTranslations = {
        page: $translate.instant('GRID_PAGER_PAGE'),
        rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
        of: $translate.instant('GRID_PAGER_PAGE_OF')
      };
    }

    FacilityKarcherDetailsViewModel.prototype.destroy = function () {};

    FacilityKarcherDetailsViewModel.prototype.mapActiveProgramName = function (
      programId,
      programList
    ) {
      for (var i = 0; i < programList.length; i++) {
        for (var j = 0; j < programList[i].feeds.length; j++) {
          if (
            programList[i].feeds[j].reference === 'ID' &&
            programList[i].feeds[j].currentValue === programId + '.0'
          ) {
            this.activeProgramActuators = programList[i].actuators;
          }
        }
      }
    };

    FacilityKarcherDetailsViewModel.prototype.alarmsPaginationChanged =
      function (page, limit) {
        this.alarmsPage = page;
        this.alarmsPageSize = limit;
      };

    FacilityKarcherDetailsViewModel.prototype.alarmsOrderingChanged = function (
      order
    ) {
      var orderQuery = getOrderObject(order);
      this.alarmsOrderBy = orderQuery.orderBy;
      this.alarmsOrder = orderQuery.order;
    };

    FacilityKarcherDetailsViewModel.prototype.refreshAlarmList = function (
      data
    ) {
      if (data.content.length === 0) {
        this.alarmList = [];
        this.alarmList.push({
          timestamp: $translate.instant('NOTHING_TO_DISPLAY')
        });
        this.numberOfAlarms = countAlarmsType(data.content);
      } else {
        this.alarmList = this.setStateIcon(data.content, false);
        this.numberOfAlarms = countAlarmsType(data.content);
      }
      this.alarmsTotal = data.totalElements;
      layoutActions.hideLoader();
    };

    FacilityKarcherDetailsViewModel.prototype.setStateIcon = function (
      data,
      switcher
    ) {
      for (var i = 0; i < data.length; i++) {
        var caseItem = switcher
          ? data[i].status
          : data[i].karcherFault.washFacilityStatus;
        switch (caseItem) {
          case 'INFO':
            data[i].icon = 'assets/icons/ic_low_alarm.svg';
            break;
          case 'WARNING':
            data[i].icon = 'assets/icons/ic_medium_alarm.svg';
            break;
          case 'ALARM':
            data[i].icon = 'assets/icons/ic_high_alarm.svg';
            break;
          default:
            data[i].icon = 'assets/icons/ic_low_alarm.svg';
            break;
        }
      }
      return data;
    };

    FacilityKarcherDetailsViewModel.prototype.refreshFacilityData = function (
      data
    ) {
      // After update, need to empty listed arrays
      // TO-DO: Every list need to be a part of this.globalListObject
      this.rolloverOperationCounterList = [];
      this.rolloverServiceCounterList = [];
      this.operationCounterList = [];
      this.listOfExistingChemicals = [];
      this.activePath = data.deviceKey + '/' + data.point.id;
      // Resolve routing problem
      if (angular.isArray(data)) {
        layoutActions.hideLoader();
        $state.go('app.dashboardTechnology');
        return;
      }
      var that = this;
      // Remove deleted points
      data.point.points = data.point.points.filter(function (point) {
        return !point.name.includes(' ');
      });
      this.selectedDevice = data;
      // For wash bay details tab (development preview)
      this.copyOfSelectedDevice = angular.copy(data);
      // ==============================================
      this.deviceSerial = data.deviceKey;
      this.status = data.state;
      this.lastReportTimestamp = moment(data.lastReportTimestamp).fromNow();
      this.facilityName = data.point.name;
      this.facilityId = data.point.id;
      this.facilityIdForQrCode = data.point.id.toString();
      this.facilityType = data.facilityType;
      this.facilityIcon = this.setFacilityIcon(data);
      this.machineType = data.deviceType;

      // Map facility feeds
      data.point.feeds.forEach(function (feed) {
        that.feedReferences[feed.reference] = feed.currentValue;
        if (
          feed.reference === 'SETUP_UNIT_MATERIAL_NO' ||
          feed.reference === 'MATERIAL_NO'
        ) {
          that.materialNumber = feed;
        } else if (
          feed.reference === 'SETUP_UNIT_SERIAL_NO' ||
          feed.reference === 'SERIAL_NO'
        ) {
          that.serialNumber = feed;
        } else if (feed.reference === 'SOFTWARE_DATE') {
          that.softwareDate = feed;
        } else if (feed.reference === 'SOFTWARE_VERSION') {
          that.softwareVersion = feed;
        } else if (feed.reference.includes('CHEM_LEVEL_LOW')) {
          that.listOfExistingChemicals.push(
            feed.reference.split('CHEM_LEVEL_LOW_')[1]
          );
        } else if (feed.reference === 'STATUS_ID') {
          that.rolloverStatus = feed.currentValue;
        } else if (feed.reference.includes('OPERATION_COUNTER_')) {
          that.rolloverOperationCounterList.push(feed);
        } else if (feed.reference.includes('SERVICE_COUNTER_')) {
          that.rolloverServiceCounterList.push(feed);
        } else if (
          feed.reference === 'WEB_API_VERSION' ||
          feed.reference === 'WEBAPI_VERSION' ||
          feed.reference === 'SETUP_UNIT_WEBAPI_VERSION'
        ) {
          that.machineType =
            that.machineType + '_' + feed.currentValue.replaceAll('.', '_');
        } else if (feed.reference === 'MAINTENANCE_WASHES') {
          that.maintenanceWashes = feed.currentValue;
        } else if (feed.reference === 'MAINTENANCE_DAYS') {
          that.maintenanceDays = feed.currentValue;
        } else if (feed.reference === 'DATE_COMMISSIONING') {
          that.installationDateOfMachine = feed;
        }
      });

      this.chemicalLevelList = this.createChemicalLevelList(data.point.feeds);

      this.feedReferences.OP_TEMPERATURA_MJERENA = this.feedReferences
        .OP_TEMPERATURA_MJERENA
        ? this.feedReferences.OP_TEMPERATURA_MJERENA
        : this.feedReferences.TEMPERATURE;
      this.weatherIcon = setWeatherIcon(
        parseFloat(this.feedReferences.OP_TEMPERATURA_MJERENA)
      );
      this.deviceList = mapDeviceList(data.point.points);
      this.mapComponentLists();
      layoutActions.hideLoader();
    };

    FacilityKarcherDetailsViewModel.prototype.setFacilityIcon = function (
      data
    ) {
      switch (data.facilityType) {
        case 'JETWASH':
          return 'assets/images/self_service_new.svg';
        case 'ROLLOVER':
          return 'assets/images/rollover_new.svg';
      }
    };

    FacilityKarcherDetailsViewModel.prototype.mapComponentLists = function () {
      this.globalListObject = {};
      var that = this;
      var tempPumpList = [];
      for (var i = 0; i < this.selectedDevice.point.points.length; i++) {
        if (
          this.selectedDevice.point.points[i].name.includes('OperationCounter')
        ) {
          for (
            var j = 0;
            j < this.selectedDevice.point.points[i].feeds.length;
            j++
          ) {
            if (
              this.selectedDevice.point.points[i].feeds[j].reference === 'NAME'
            ) {
              this.operationCounterObject.name =
                this.selectedDevice.point.points[i].feeds[j].currentValue;
            } else if (
              this.selectedDevice.point.points[i].feeds[j].reference ===
              'SECONDS'
            ) {
              // Transform from seconds to hours
              this.operationCounterObject.time =
                this.selectedDevice.point.points[i].feeds[j].currentValue;
            }
          }
          this.operationCounterObject.points =
            this.selectedDevice.point.points[i].points;

          // Check for device service flag
          onDeviceLevelServiceAlert(this, this.operationCounterObject);
          this.operationCounterList.push(this.operationCounterObject);
          this.operationCounterObject = {};
        } else if (
          this.selectedDevice.point.points[i].name.includes('Programs')
        ) {
          this.programPointId = this.selectedDevice.point.points[i].id;
          this.programPointPath = this.activePath + '/' + this.programPointId;
          this.globalListObject.programList = {
            path: this.programPointPath,
            list: this.selectedDevice.point.points[i].points
          };
        } else if (this.selectedDevice.point.points[i].name.includes('Pump_')) {
          this.pumpPointId = this.selectedDevice.point.points[i].id;
          tempPumpList.push({
            pumpName: this.selectedDevice.point.points[i].name,
            programsList: this.selectedDevice.point.points[i].points,
            path: this.activePath + '/' + this.pumpPointId
          });
        } else if (
          this.selectedDevice.point.points[i].name.includes('ActiveProgram')
        ) {
          this.activeProgramItem = this.selectedDevice.point.points[i];
          $timeout(function () {
            that.mapActiveProgramName(
              that.activeProgramItem.actuators[0].value,
              that.globalListObject.programList.list
            );
          }, 50);
        } else if (
          this.selectedDevice.point.points[i].name.includes('Dosings')
        ) {
          this.dosingPointId = this.selectedDevice.point.points[i].id;
          this.dosingPointPath = this.activePath + '/' + this.dosingPointId;
          this.globalListObject.dosingList = {
            path: this.dosingPointPath,
            list: this.selectedDevice.point.points[i].actuators.map(function (
              item
            ) {
              that.rolloverDosingActuatorList.push(item.reference);
              return {
                id: item.id,
                value: parseInt(item.value),
                name: item.reference,
                state: item.state
              };
            })
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('Speeds')
        ) {
          this.speedsPointId = this.selectedDevice.point.points[i].id;
          this.speedsPointPath = this.activePath + '/' + this.speedsPointId;
          this.globalListObject.speedList = {
            path: this.speedsPointPath,
            list: this.selectedDevice.point.points[i].actuators.map(function (
              item
            ) {
              that.rolloverSpeedsActuatorList.push(item.reference);
              return {
                id: item.id,
                value: parseInt(item.value),
                name: item.reference,
                state: item.state
              };
            })
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('Parameters')
        ) {
          this.parametersPointId = this.selectedDevice.point.points[i].id;
          this.parametersList = this.selectedDevice.point.points[
            i
          ].actuators.map(function (item) {
            that.rolloverParametersActuatorList.push(item.reference);
            return {
              id: item.id,
              value: parseInt(item.value),
              name: item.reference,
              state: item.state
            };
          });
        } else if (
          this.selectedDevice.point.points[i].name.includes(
            'OperatingTimeVacuums'
          )
        ) {
          this.globalListObject.operatingTimeVacuumList = {
            path:
              this.activePath + '/' + this.selectedDevice.point.points[i].id,
            list: this.selectedDevice.point.points[i].points
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('IlluminationTime')
        ) {
          this.globalListObject.illuminationTimeList = {
            path:
              this.activePath + '/' + this.selectedDevice.point.points[i].id,
            list: this.selectedDevice.point.points[i].points,
            deviceType: this.selectedDevice.deviceType
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('OperatingTime')
        ) {
          this.globalListObject.operatingTimeList = {
            path:
              this.activePath + '/' + this.selectedDevice.point.points[i].id,
            list: this.selectedDevice.point.points[i].points
          };
        } else if (
          this.selectedDevice.point.points[i].name.includes('OpenDoors')
        ) {
          this.selectedDevice.point.points[i].actuators[0].value = Number(new Date().getTime());
          this.openDoorsActuator =
            this.selectedDevice.point.points[i].actuators;
          this.openDoorsId = this.selectedDevice.point.points[i].id;
        } else if (
          this.selectedDevice.point.points[i].name.includes('RemoteResetStart')
        ) {
          this.selectedDevice.point.points[i].actuators[0].value = Number(new Date().getTime());
          this.resetRolloverActuator =
            this.selectedDevice.point.points[i].actuators;
          this.resetRolloverId = this.selectedDevice.point.points[i].id;
        }
      }
      this.globalListObject.pumpsList = tempPumpList;
    };

    FacilityKarcherDetailsViewModel.prototype.updateFeedValues = function (
      newFeedData
    ) {
      var that = this;
      $timeout(function () {
        // On every feed update, update last synchronization
        that.lastReportTimestamp = moment(
          newFeedData.data.lastUpdate
        ).fromNow();
        if (newFeedData.data.reference === 'OP_TEMPERATURA_MJERENA') {
          that.feedReferences.OP_TEMPERATURA_MJERENA =
            newFeedData.data.currentValue;
          switch (true) {
            case that.feedReferences.OP_TEMPERATURA_MJERENA > 23:
              that.weatherIcon = 'assets/images/weather_sunny.png';
              break;
            case 7 < that.feedReferences.OP_TEMPERATURA_MJERENA &&
              that.feedReferences.OP_TEMPERATURA_MJERENA < 23:
              that.weatherIcon = 'assets/images/weather_cloud.png';
              break;
            case that.feedReferences.OP_TEMPERATURA_MJERENA < 7:
              that.weatherIcon = 'assets/images/weather_snow.png';
              break;
          }
        } else if (newFeedData.data.reference === 'STATE') {
          that.status = newFeedData.data.currentValue;
        } else if (newFeedData.data.reference === 'CURRENT_PROGRESS') {
          that.activeProgramUpdatedFeed = {
            value: newFeedData.data.currentValue,
            reference: 'CURRENT_PROGRESS'
          };
        } else if (newFeedData.data.reference === 'CURRENT_TIMEOUT_SEC') {
          that.activeProgramUpdatedFeed = {
            value: newFeedData.data.currentValue,
            reference: 'CURRENT_TIMEOUT_SEC'
          };
        } else if (newFeedData.data.reference.includes('CHEM_LEVEL_LOW_')) {
          that.chemicalLevelList.forEach(function (item) {
            if (item.levelName === newFeedData.data.reference) {
              item.levelValue = newFeedData.data.currentValue;
            }
          });
        } else if (newFeedData.data.reference.includes('CHEM_LEVEL_')) {
          that.chemicalLevelList.forEach(function (item) {
            if (item.name === newFeedData.data.reference) {
              item.value = newFeedData.data.currentValue;
            }
          });
        } else if (newFeedData.data.reference === 'STATUS_ID') {
          that.rolloverStatus = newFeedData.data.currentValue;
        }

        // Update devices value
        that.deviceList.forEach(function (point) {
          if (
            newFeedData.path.indexOf(
              that.deviceSerial + '/' + that.facilityId + '/' + point.pointId
            ) > -1
          ) {
            if (newFeedData.data.reference === 'OP_BUTTON') {
              point.OP_BUTTON = newFeedData.data.currentValue;
            } else if (
              newFeedData.data.reference === 'STATUS_BAY_ACTIVE_PROGRAM_NAME'
            ) {
              point.STATUS_BAY_ACTIVE_PROGRAM_NAME =
                newFeedData.data.currentValue;
            } else if (newFeedData.data.reference === 'STATUS_BAY_RUN_TIME') {
              point.STATUS_BAY_RUN_TIME = newFeedData.data.currentValue;
            } else if (newFeedData.data.reference === 'STATUS_BAY_CREDIT') {
              point.STATUS_BAY_CREDIT = newFeedData.data.currentValue;
            }
          }
        });

        // Update rollover active program data
        if (that.facilityType === 'JETWASH') {
          return;
        }
        if (
          newFeedData.path.indexOf(
            that.deviceSerial +
              '/' +
              that.facilityId +
              '/' +
              that.activeProgramItem.id
          ) > -1
        ) {
          that.activeProgramItem.feeds.forEach(function (item) {
            if (newFeedData.data.reference === 'CURRENT_PROGRESS') {
              item.currentValue = newFeedData.data.currentValue;
            }
            if (newFeedData.data.reference === 'CURRENT_TIMEOUT_SEC') {
              item.currentValue = newFeedData.data.currentValue;
            }
          });
        }
      }, 50);
    };

    FacilityKarcherDetailsViewModel.prototype.updateActuatorValues = function (
      newActuatorData
    ) {
      var that = this;
      $timeout(function () {
        // New global object approach for updating values from webSocket topics
        for (var key in that.globalListObject) {
          if (
            newActuatorData.path.indexOf(that.globalListObject[key].path) > -1
          ) {
            that.globalListObject[key].list.forEach(function (item) {
              if (
                that.globalListObject[key].path + '/' + item.id ===
                newActuatorData.path
              ) {
                item.actuators.forEach(function (actuator) {
                  if (actuator.id === newActuatorData.data.id) {
                    actuator.value = /^\d+$/.test(newActuatorData.data.value)
                      ? parseInt(newActuatorData.data.value)
                      : newActuatorData.data.value;
                    actuator.state = newActuatorData.data.state;
                  }
                });
              } else if (item.name === newActuatorData.data.reference) {
                item.value = parseInt(newActuatorData.data.value);
                item.state = newActuatorData.data.state;
              }
            });
          }
        }

        // For pump actuators only
        if (that.globalListObject.pumpsList) {
          that.globalListObject.pumpsList.forEach(function (pump) {
            if (newActuatorData.path.indexOf(pump.path) > -1) {
              pump.programsList.forEach(function (item) {
                if (pump.path + '/' + item.id === newActuatorData.path) {
                  item.actuators.forEach(function (actuator) {
                    if (actuator.id === newActuatorData.data.id) {
                      actuator.value = /^\d+$/.test(newActuatorData.data.value)
                        ? parseInt(newActuatorData.data.value)
                        : newActuatorData.data.value;
                      actuator.state = newActuatorData.data.state;
                    }
                  });
                }
              });
            }
          });
        }

        // IMPORTANT!!! ngChange in component works only if angular.copy exist
        that.globalListObject = angular.copy(that.globalListObject);

        // Update rollover active program data
        if (that.facilityType === 'JETWASH') {
          return;
        }
        if (
          newActuatorData.path.indexOf(
            that.deviceSerial +
              '/' +
              that.facilityId +
              '/' +
              that.activeProgramItem.id
          ) > -1
        ) {
          that.activeProgramItem.actuators.forEach(function (item) {
            if (item.reference === 'ID') {
              item.value = newActuatorData.data.value;
            }
          });
        }
      }, 50);
    };

    FacilityKarcherDetailsViewModel.prototype.updateEventValues = function(newEventData) {
      var that = this;
      $timeout(function () {
        newEventData.pullDate = new Date();
        that.fromWebSocketsEventData = newEventData;
        layoutActions.hideLoader();
      }, 50)
    }

    FacilityKarcherDetailsViewModel.prototype.createChemicalLevelList =
      function (data) {
        var tempArray = [],
          tempObj = {};
        for (var i = 0; i < this.listOfExistingChemicals.length; i++) {
          for (var j = 0; j < data.length; j++) {
            if (
              data[j].reference ===
              'CHEM_LEVEL_LOW_' + this.listOfExistingChemicals[i]
            ) {
              tempObj.levelName = data[j].reference;
              tempObj.levelValue = data[j].currentValue;
            } else if (
              data[j].reference ===
              'CHEM_LEVEL_' + this.listOfExistingChemicals[i]
            ) {
              tempObj.name = data[j].reference;
              tempObj.value = data[j].currentValue;
              tempArray.push(tempObj);
            }
          }
          tempObj = {};
        }
        return tempArray;
      };

    return FacilityKarcherDetailsViewModel;

    function setWeatherIcon(temp) {
      switch (true) {
        case temp > 23:
          return 'assets/images/weather_sunny.png';
        case 7 < temp && temp < 23:
          return 'assets/images/weather_cloud.png';
        case temp < 7:
          return 'assets/images/weather_snow.png';
        default:
          return 'assets/images/weather_sunny.png';
      }
    }

    function mapDeviceList(data) {
      var installedDeviceList = [],
        deviceObject = {},
        deletedPoint = null;
      for (var i = 0; i < data.length; i++) {
        deviceObject = {};
        // Avoid pushing point data if point includes white space in name. Example: "G0 1682088509559" (name with deleted timestamp)
        deletedPoint = data[i].name.includes(' ');
        for (var j = 0; j < data[i].feeds.length; j++) {
          if (
            data[i].feeds[j].reference === 'INSTALLED' &&
            data[i].feeds[j].currentValue === '1.0'
          ) {
            deviceObject.deviceName = data[i].name;
            deviceObject.deviceType = data[i].pointType;
            deviceObject.pointId = data[i].id;
            deviceObject.deviceLabel = data[i].label;
            data[i].feeds.forEach(function (feed) {
              switch (feed.reference) {
                case 'OP_BUTTON':
                  deviceObject.OP_BUTTON = feed.currentValue;
                  break;
                case 'STATUS_BAY_ACTIVE_PROGRAM_NAME':
                  deviceObject.STATUS_BAY_ACTIVE_PROGRAM_NAME =
                    feed.currentValue;
                  break;
                case 'STATUS_BAY_RUN_TIME':
                  deviceObject.STATUS_BAY_RUN_TIME = feed.currentValue;
                  break;
                case 'STATUS_BAY_CREDIT':
                  deviceObject.STATUS_BAY_CREDIT = feed.currentValue;
                  break;
              }
            });
            if (!deletedPoint) {
              installedDeviceList.push(deviceObject);
            }
          }
        }
      }
      return installedDeviceList.length !== 0
        ? installedDeviceList
        : [{ deviceName: $translate.instant('DEVICE_NOT_INSTALLED') }];
    }

    function countAlarmsType(data) {
      var alarmTypeList = data.map(function (item) {
          return item.karcherFault.washFacilityStatus;
        }),
        warningCount = 0,
        alarmCount = 0;

      for (var i = 0; i < alarmTypeList.length; i++) {
        if (alarmTypeList[i] === 'WARNING') {
          warningCount++;
        } else if (alarmTypeList[i] === 'ALARM') {
          alarmCount++;
        }
      }
      return { warnings: warningCount, alarms: alarmCount };
    }

    function onDeviceLevelServiceAlert(that, counter) {
      for (var i = 0; i < counter.points.length; i++) {
        if (counter.points[i].name.includes('Service')) {
          for (var j = 0; j < counter.points[i].feeds.length; j++) {
            if (counter.points[i].feeds[j].reference === 'DUE') {
              that.serviceOnOperationCountersDeviceNeeded =
                counter.points[i].feeds[j].currentValue === '1.0';
            }
          }
        }
      }
    }

    function getOrderObject(order) {
      var result = {
        order: 'asc',
        orderBy: order
      };

      if (order.indexOf('-') > -1) {
        result.order = 'desc';
        result.orderBy = order.substring(1);
      }
      return result;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'FacilityKarcherDetailsController',
      FacilityKarcherDetailsController
    );

  /** @ngInject */
  function FacilityKarcherDetailsController(
    $scope,
    $log,
    FacilityKarcherDetailsViewModel,
    deviceActions,
    $interval,
    layoutActions,
    messagesStore,
    $state,
    $stateParams,
    dashboardKarcherActions,
    weatherKarcherActions,
    webSocketsStore,
    broker,
    $mdDialog,
    $translate,
    rolloverStatusCheck,
    checkUserRole,
    dispatcher,
    ActionTypesEnum,
    helperService,
    $timeout,
    $window
  ) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onActuatorChangedHandler = refreshDeviceActuator,
      _onFeedChangedHandler = refreshDeviceFeed,
      _onEventChangedHandler = refreshDeviceEvent;

    vm.facility = null;
    vm.facilityVM = new FacilityKarcherDetailsViewModel();
    vm.alarmHistoryTabSelected = false;
    vm.enableRolloverButton = true;
    vm.checkBoxEnableRolloverReset = false;

    vm.pageChanged = function (page, limit) {
      vm.facilityVM.alarmsPaginationChanged(page, limit);
      getAlarmsForSelectedWashFacility();
    };

    vm.sortChanged = function (order) {
      vm.facilityVM.alarmsOrderingChanged(order);
      getAlarmsForSelectedWashFacility();
    };

    vm.enableResetRolloverButton = function () {
      vm.enableRolloverButton = !vm.enableRolloverButton;
      vm.checkBoxEnableRolloverReset = vm.enableRolloverButton;
    };

    vm.resetRollover = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant('RESET_ROLOVER_TITLE'))
        .textContent($translate.instant('RESET_ROLOVER_CONTENT'))
        .ariaLabel('Reset rollover')
        .targetEvent(ev)
        .ok($translate.instant('YES'))
        .cancel($translate.instant('CANCEL'));

      $mdDialog.show(confirm).then(
        function () {
          vm.activateNow(
            vm.facilityVM.resetRolloverActuator,
            'resetRollover',
            vm.facilityVM.resetRolloverId
          );
        },
        function () {
          vm.enableRolloverButton = true;
          vm.checkBoxEnableRolloverReset = false;
        }
      );
    };

    vm.openDoorRollover = function (ev) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant('OPEN_ROLOVER_DOOR_TITLE'))
        .textContent($translate.instant('OPEN_ROLOVER_DOOR_CONTENT'))
        .ariaLabel('Open the door')
        .targetEvent(ev)
        .ok($translate.instant('YES'))
        .cancel($translate.instant('CANCEL'));

      $mdDialog.show(confirm).then(
        function () {
          vm.activateNow(
            vm.facilityVM.openDoorsActuator,
            'openDoors',
            vm.facilityVM.openDoorsId
          );
        },
        function () {}
      );
    };

    vm.activateNow = function (data, type, parentPointId) {
      // Check user role
      if (
        checkUserRole.isMerchantAdmin() ||
        checkUserRole.isTechnicalSupportUser()
      ) {
        var pointId = null;
        switch (type) {
          case 'speed':
            pointId = vm.facilityVM.speedsPointId;
            break;
          case 'dosing':
            pointId = vm.facilityVM.dosingPointId;
            break;
          case 'parameters':
            pointId = vm.facilityVM.parametersPointId;
            break;
          default:
            pointId = parentPointId;
            break;
        }

        // Encode actuator values
        data.forEach(function (item) {
          item.value = encodeURIComponent(item.value);
        });

        deviceActions
          .groupActuate(vm.facilityVM.deviceSerial, pointId, data)
          .then(function () {
            if (
              type === 'operationTime' ||
              type === 'washingPrograms' ||
              type === 'pumps'
            ) {
              layoutActions.showLoader();
              getKarcherDevices();
            }
          });
        return;
      }
      dispatcher.dispatch({
        type: ActionTypesEnum.SHOW_TOASTER_MSG,
        payload: {
          type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
          message: $translate.instant('ACTUATION_NOT_ALLOWED')
        }
      });
    };

    vm.checkMachineTypeName = function () {
      return vm.facilityVM.machineType.includes('CB3');
    };

    vm.rolloverNormalStatus = function () {
      return rolloverStatusCheck.normalStatus(vm.facilityVM.rolloverStatus);
    };

    vm.rolloverAlertStatus = function () {
      return rolloverStatusCheck.alertStatus(vm.facilityVM.rolloverStatus);
    };

    vm.rolloverUndefinedStatus = function () {
      return rolloverStatusCheck.undefinedStatus(vm.facilityVM.rolloverStatus);
    };

    vm.refreshOperatingData = function () {
      getKarcherDevices();
    };

    vm.pullNewEventData = function () {
      getEventsList();
    };

    vm.startService = function (ev, box) {
      $mdDialog.show({
        templateUrl: 'app/facilityDetails/insert-token-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        controller: DialogInsertTokenController,
        controllerAs: 'vm',
        bindToController: true,
        locals: {
          box: box,
          facilityId: vm.facilityVM.facilityId
        }
      });

      function DialogInsertTokenController(
        $mdDialog,
        box,
        managingTokensActions,
        facilityId,
        dispatcher,
        ActionTypesEnum
      ) {
        var vm = this;
        vm.box = box;
        vm.dialogData = {};
        vm.buttonTitle = $translate.instant('IN_PROGRESS');
        vm.sessionStatus = '';

        managingTokensActions
          .createDeviceSession(box.pointId)
          .then(function (response) {
            vm.sessionStatus = response.data.status;
            vm.buttonTitle = $translate.instant('INSERT');
          });

        vm.closeDialog = function () {
          $mdDialog.cancel();
        };

        vm.saveToken = function (token) {
          if (token && vm.sessionStatus === 'PENDING') {
            managingTokensActions
              .startDeviceService(facilityId, box.pointId, token)
              .then(function () {
                $mdDialog.hide(token);
              });
          } else {
            $mdDialog.hide(token);
            dispatcher.dispatch({
              type: ActionTypesEnum.SHOW_TOASTER_MSG,
              payload: {
                type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                message: $translate.instant('EXPIRED_SESSION')
              }
            });
          }
        };
      }
    };

    vm.printQrCode = function () {
      var printWindow = $window.open('', '_blank');
      /* eslint-disable */
      $timeout(function () {
        var qrElement = angular.element(
          document.querySelector('.qr-code-wrapper')
        );
        /* eslint-enable */
        if (!qrElement.length) {
          return;
        }

        var qrCodeCanvas = qrElement[0].querySelector('canvas');
        var qrCodeImage = '';

        if (qrCodeCanvas) {
          qrCodeImage = qrCodeCanvas.toDataURL('image/png');
        }

        var content = [
          '<html>',
          '<head>',
          '<title>QR Code</title>',
          '<style>',
          'body { margin: 0; padding: 20px; }',
          '.print-container { text-align: center; }',
          '.qr-code { margin-bottom: 10px; }',
          '.facility-id { font-family: Arial, sans-serif; font-size: 14px; }',
          '@media print {',
          '    @page { margin: 0; }',
          '    body { margin: 1.6cm; }',
          '}',
          '</style>',
          '</head>',
          '<body>',
          '<div class="print-container">',
          qrCodeImage ? '<img src="' + qrCodeImage + '" alt="QR Code"/>' : '',
          '<p class="facility-id">' +
            vm.facilityVM.facilityIdForQrCode +
            '</p>',
          '</div>',
          '<script>',
          'window.onload = function() {',
          '    window.print();',
          '    window.onafterprint = function() { window.close(); };',
          '};',
          '</script>',
          '</body>',
          '</html>'
        ].join('');

        printWindow.document.write(content);
        printWindow.document.close();
      }, 500);
    };

    vm.editLabelName = function(ev, deviceData) {
      $mdDialog
        .show({
          controller: "ChangeDeviceLabelNameController",
          controllerAs: "vm",
          templateUrl:
            "app/karcherCustomDialogs/changeDeviceLabelName/changeDeviceLabelName.html",
          /* eslint-disable */
          parent: angular.element(document.body),
          /* eslint-enable */
          targetEvent: ev,
          locals: { data: deviceData },
          clickOutsideToClose: false
        })
        .then(
          function (data) {
            deviceActions.changeDeviceLabelName(data).then(function () {
              getKarcherDevices();
            })
          },
          function () {}
        );
    }

    init();

    function init() {
      vm.facilityVM.siteAddress = $stateParams.siteAddress;
      vm.facilityVM.siteLatitude = $stateParams.siteLatitude;
      vm.facilityVM.siteLongitude = $stateParams.siteLongitude;
      getWeather();
      if (!webSocketsStore.isConnected()) {
        broker.initWebSockets();
      }
      $scope.$on('$destroy', destroy);
      layoutActions.showLoader();
      getKarcherDevices();
    }

    // Temporary, delete when testing is done
    vm.displayDebugTab = helperService.getDevelopAccess();

    function getKarcherDevices() {
      dashboardKarcherActions
        .getKarcherDeviceDetailsById($stateParams.id, $stateParams.deviceId)
        .then(function (response) {
          vm.facilityVM.refreshFacilityData(response);
          getAlarmsForSelectedWashFacility();
          subscribeToSocket();
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_ACTUATOR_CHANGE,
            _onActuatorChangedHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_EVENT_CHANGE,
            _onEventChangedHandler
          );
          // getEventsList();
        });
    }

    function getAlarmsForSelectedWashFacility() {
      dashboardKarcherActions
        .getKarcherSiteAlarmList(
          '',
          '',
          vm.facilityVM.facilityId ? vm.facilityVM.facilityId : '',
          '&sitePointId=',
          '',
          '',
          vm.facilityVM.alarmsPage - 1,
          vm.facilityVM.alarmsPageSize,
          vm.facilityVM.alarmsOrderBy,
          vm.facilityVM.alarmsOrder
        )
        .then(function (response) {
          vm.facilityVM.refreshAlarmList(response);
        });
    }

    function getEventsList() {
      layoutActions.showLoader();
      dashboardKarcherActions
        .getEventsListForSelectedDevice(vm.facilityVM.deviceSerial)
        .then(function () {
          $log.log(
            $translate.instant('DEVICE_EVENTS_LOG_PULLED') +
              vm.facilityVM.deviceSerial
          );
          $timeout(function () {
            layoutActions.hideLoader();
          }, 10000);
        });
    }

    function subscribeToSocket() {
      if (webSocketsStore.isConnected()) {
        broker.subscribeToFeedChanges([vm.facilityVM.deviceSerial]);
        broker.subscribeToActuatorChanges([vm.facilityVM.deviceSerial]);
        broker.subscribeToEventChanges([vm.facilityVM.deviceSerial]);
      }
    }

    function refreshDeviceFeed(newFeedData) {
      if (newFeedData.data.reference === 'CURRENT_FAULTS') {
        getAlarmsForSelectedWashFacility();
      }
      vm.facilityVM.updateFeedValues(newFeedData);
    }

    function refreshDeviceActuator(newActuatorData) {
      vm.facilityVM.updateActuatorValues(newActuatorData);
    }

    function refreshDeviceEvent(newEventData) {
      vm.facilityVM.updateEventValues(newEventData);
    }

    function getWeather() {
      weatherKarcherActions
        .getCurrentWeather(
          vm.facilityVM.siteLatitude,
          vm.facilityVM.siteLongitude
        )
        .then(function (currentWeather) {
          vm.facilityVM.currentWeatherData = {
            country: currentWeather.location.country,
            city: currentWeather.location.name,
            region: currentWeather.location.region,
            temperature: currentWeather.current.temp_c,
            pressure: currentWeather.current.pressure_mb,
            currentWeatherIcon: currentWeather.current.condition.icon,
            currentWeatherTime: currentWeather.location.localtime
          };
        });
    }

    function destroy() {
      if (broker.isConnected()) {
        broker.unsubscribeSocket();
        webSocketsStore.off(
          webSocketsStore.events.CONNECTED_CHANGE,
          _webSocketStoreConnectedChangeHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_FEED_CHANGE,
          _onFeedChangedHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_ACTUATOR_CHANGE,
          _onActuatorChangedHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_EVENT_CHANGE,
          _onEventChangedHandler
        );
      }
      vm.facilityVM.deviceSerial = '';
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsWashFacilityViewModel', facilityDetailsWashFacilityViewModelFactory);

  /** @ngInject */
  function facilityDetailsWashFacilityViewModelFactory(facilityUtils, modelUtils) {
    function FacilityDetailsWashFacilityViewModel(facilityPoint) {
      this._propertyMappings = {};
      this._propertyMappings[facilityUtils.FeedReferences.OP_TEMPERATURA_MJERENA] = 'currentTemperature';
      this._propertyMappings[facilityUtils.ActuatorReferences.OP_FILTER_DANI_RADA] = 'filterDaysCount';
      this._propertyMappings[facilityUtils.ActuatorReferences.OP_BOJLER_DANI_RADA] = 'boilerDaysCount';

      if (typeof facilityPoint !== 'undefined') {
        this.refresh(facilityPoint);
      }
    }

    FacilityDetailsWashFacilityViewModel.prototype.destroy = function () {

    };

    FacilityDetailsWashFacilityViewModel.prototype.refresh = function (facilityPointJson) {
      this.pointId = facilityPointJson.id;
      this.name = facilityPointJson.name;
      this.pointType = facilityPointJson.pointType;
      //todo implement
      this.weatherIcon = 'assets/icons/ic_wb_sunny_black_24px.svg';

      setFeedValue.call(this, facilityUtils.getFeed(facilityPointJson, facilityUtils.FeedReferences.OP_TEMPERATURA_MJERENA));
      setActuatorValue.call(this, facilityUtils.getActuator(facilityPointJson, facilityUtils.ActuatorReferences.OP_FILTER_DANI_RADA));
      setActuatorValue.call(this, facilityUtils.getActuator(facilityPointJson, facilityUtils.ActuatorReferences.OP_BOJLER_DANI_RADA));
    };

    FacilityDetailsWashFacilityViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    FacilityDetailsWashFacilityViewModel.prototype.refreshActuator = function (actuator) {
      setActuatorValue.call(this, actuator);
    };

    return FacilityDetailsWashFacilityViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }

    function setActuatorValue(actuator) {
      if (actuator !== null && this._propertyMappings[actuator.reference]) {
        this[this._propertyMappings[actuator.reference]]
          = modelUtils.parseActuatorCurrentValue(actuator.value, actuator.actuatorType);
      }
    }

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsWasBoxViewModel', facilityDetailsWasBoxViewModelFactory);

  /** @ngInject */
  function facilityDetailsWasBoxViewModelFactory(washBoxUtils, modelUtils) {
    function FacilityDetailsWasBoxViewModel(washBoxPointJson) {
      this._propertyMappings = {};
      this._propertyMappings[washBoxUtils.FeedReferences.OP_CLEAN_BROJ_SATI_RADA] = 'cleanHours';
      this._propertyMappings[washBoxUtils.FeedReferences.OP_CLEAN_BROJ_MIN_RADA] = 'cleanMinutes';
      this._propertyMappings[washBoxUtils.FeedReferences.OP_VISKTL_BROJ_SATI_RADA] = 'totalWorkingHours';
      this._propertyMappings[washBoxUtils.FeedReferences.OP_VISKTL_RESET_SATI_RADA] = 'serviceWorkingHours';

      if (typeof washBoxPointJson !== 'undefined') {
        this.refresh(washBoxPointJson);
      }
    }

    FacilityDetailsWasBoxViewModel.prototype.destroy = function () {

    };

    FacilityDetailsWasBoxViewModel.prototype.refresh = function (washBoxPointJson) {
      this.pointId = washBoxPointJson.id;
      this.name = washBoxPointJson.name;
      setFeedValue.call(this, washBoxUtils.getFeed(washBoxPointJson, washBoxUtils.FeedReferences.OP_CLEAN_BROJ_SATI_RADA));
      setFeedValue.call(this, washBoxUtils.getFeed(washBoxPointJson, washBoxUtils.FeedReferences.OP_CLEAN_BROJ_MIN_RADA));
      setFeedValue.call(this, washBoxUtils.getFeed(washBoxPointJson, washBoxUtils.FeedReferences.OP_VISKTL_BROJ_SATI_RADA));
      setFeedValue.call(this, washBoxUtils.getFeed(washBoxPointJson, washBoxUtils.FeedReferences.OP_VISKTL_RESET_SATI_RADA));
    };

    FacilityDetailsWasBoxViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsWasBoxViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("FacilityDetailsViewModel", facilityDetailsViewModelFactory);

  /** @ngInject */
  function facilityDetailsViewModelFactory(
    invariant,
    modelUtils,
    moment,
    messagesStore,
    facilityUtils,
    washBoxUtils,
    FacilityDetailsWasBoxViewModel,
    FacilityDetailsListenerViewModel,
    FacilityDetailsListenerWashBoxViewModel,
    FacilityDetailsWashFacilityViewModel,
    FacilityDetailsTapWaterViewModel,
    FacilityDetailsSoftenedWaterViewModel,
    FacilityDetailsDemiWaterViewModel,
    FacilityDetailsReverseOsmosisViewModel,
    FacilityDetailsDoserViewModel
  ) {
    function FacilityDetailsViewModel(deviceJson) {
      this._devicesStoreChangeHandler = null;
      this._messagesStoreChangeHandler = null;

      this.deviceSerial = deviceJson.deviceKey;
      this.messages = [];
      this.alarmsCount = 0;
      this.warningsCount = 0;

      this.facility = {};
      this.tapWaterSubsystemData = {};
      this.softenedWaterSubsystemData = {};
      this.demiWaterSubsystemData = {};
      this.reverseOsmosisSubsystemData = {};
      this.doserSubsystemData = {};
      this.boxes = [];
      this.smallMachines = [];
      this.smallMachinesWashBoxes = [];

      init.call(this);
      refreshDeviceData.call(this, deviceJson);
    }

    FacilityDetailsViewModel.prototype.destroy = function() {
      messagesStore.off(
        messagesStore.events.CHANGE,
        this._messagesStoreChangeHandler
      );
    };

    FacilityDetailsViewModel.prototype.refreshFeed = function(payload) {
      var ids = payload.path.split("/");

      this.smallMachines = updateConnectionStatus(
        ids[2],
        payload.data,
        this.smallMachines
      );

      this.smallMachinesWashBoxes = updateConnectionStatus(
        ids[2],
        payload.data,
        this.smallMachinesWashBoxes
      );

      if (ids && ids.length > 0 && ids[0] === this.deviceSerial) {
        var feed = payload.data,
          subsystem = getSubsystem.call(this, ids);

        if (subsystem !== null && subsystem.refreshFeed) {
          subsystem.refreshFeed(feed);
        }
      }
    };

    FacilityDetailsViewModel.prototype.refreshState = function(payload) {
      this.status = payload.state;
      this.lastReportTimestamp = moment(payload.lastReportTimestamp).fromNow();
    };

    FacilityDetailsViewModel.prototype.refreshActuator = function(payload) {
      var ids = payload.path.split("/");

      this.smallMachines = updateConnectionStatus(
        ids[2],
        payload.data,
        this.smallMachines
      );

      this.smallMachinesWashBoxes = updateConnectionStatus(
        ids[2],
        payload.data,
        this.smallMachinesWashBoxes
      );

      if (ids && ids.length > 0 && ids[0] === this.deviceSerial) {
        var feed = payload.data,
          subsystem = getSubsystem.call(this, ids);

        if (subsystem !== null && subsystem.refreshActuator) {
          subsystem.refreshActuator(feed);
        }
      }
    };

    return FacilityDetailsViewModel;

    function init() {
      var that = this;

      refreshAlarms.call(that);
      this._messagesStoreChangeHandler = function() {
        refreshAlarms.call(that);
      };
      messagesStore.on(
        messagesStore.events.CHANGE,
        this._messagesStoreChangeHandler
      );
    }

    function refreshDeviceData(deviceJson) {
      var facilityPoint = null,
        washBoxPoints = null,
        smallMachinesPoints = null,
        smallMachinesWashBoxPoints = null;

      if (deviceJson === null) {
        return;
      }

      // ---------------------------------------------------------
      facilityPoint = facilityUtils.getFacilityPoint(deviceJson); // Return point (with actuators, feeds and points) from detail view
      washBoxPoints = washBoxUtils.getWashBoxPoints(facilityPoint);
      smallMachinesPoints = washBoxUtils.getListenerPoints(facilityPoint);
      smallMachinesWashBoxPoints = washBoxUtils.getListenerWashBoxPoints(
        facilityPoint
      );

      invariant(
        deviceJson && facilityPoint,
        "FacilityDetailsViewModel: could not fetch details data for device serial " +
          this.deviceSerial
      );

      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();

      this.facility = new FacilityDetailsWashFacilityViewModel(facilityPoint);

      if (
        facilityPoint.deviceType !== "SERIAL_485" &&
        facilityPoint.deviceType !== "HHANLE"
      ) {
        this.tapWaterSubsystemData = new FacilityDetailsTapWaterViewModel(
          facilityPoint
        );
        this.softenedWaterSubsystemData = new FacilityDetailsSoftenedWaterViewModel(
          facilityPoint
        );
        this.demiWaterSubsystemData = new FacilityDetailsDemiWaterViewModel(
          facilityPoint
        );
        this.reverseOsmosisSubsystemData = new FacilityDetailsReverseOsmosisViewModel(
          facilityPoint
        );
        this.doserSubsystemData = new FacilityDetailsDoserViewModel(
          facilityPoint
        );
      }

      washBoxPoints.forEach(function(washBoxJson) {
        this.push(new FacilityDetailsWasBoxViewModel(washBoxJson));
      }, this.boxes);

      smallMachinesPoints.forEach(function(listenerJson) {
        this.push(new FacilityDetailsListenerViewModel(listenerJson));
      }, this.smallMachines);

      smallMachinesWashBoxPoints.forEach(function(listenerJson) {
        this.push(new FacilityDetailsListenerWashBoxViewModel(listenerJson));
      }, this.smallMachinesWashBoxes);
    }

    function refreshAlarms() {
      var that = this,
        messages = messagesStore.getMessages();

      this.messages = [];
      this.alarmsCount = 0;
      this.warningsCount = 0;

      if (messages !== null && messages.length > 0) {
        messages.forEach(function(messageJson) {
          if (messageJson.device === that.deviceSerial) {
            that.messages.push({
              //feedId: messageJson.feedId,
              deviceSerial: messageJson.device,
              collapseKey: messageJson.collapseKey,
              enableAlarmDismiss: enableAlarmDismiss(messageJson),
              timestamp: messageJson.timestamp,
              timeFormatted: moment(messageJson.timestamp).fromNow(),
              message: messageJson.content,
              alarmId: messageJson.id,
              deviceMoreInfo: messageJson.details,
              icon:
                messageJson.collapseKey === "alarm"
                  ? "assets/icons/ic_warning_black_24px.svg"
                  : "assets/icons/ic_info_outline_black_24px.svg"
            });
            messageJson.collapseKey === "alarm"
              ? (that.alarmsCount += 1)
              : (that.warningsCount += 1);
          }
        });
      }
    }

    function enableAlarmDismiss(messageData) {
      var alarmMessagesIncludeList = [
        'UNKNOWN_RESET',
        'SOFTWARE_RESET',
        'EXTERNAL_PIN_RESET',
        'RESTART_OR_BROWNOUT_OCCURRED',
        'DEAD_RM5_CHANNEL_PIN_ERROR',
        'COULD_NOT_SIMULATE_COIN',
        'ERROR_SETTING_INHIBIT_MODE',
        'CONNECTION_ERROR'
      ];
      return alarmMessagesIncludeList.includes(messageData.content) && messageData.collapseKey === 'alarm';
    }

    function getSubsystem(idsArray) {
      // This object (this.tapWaterSubsystemData) is empty if device type is Listener or HHanle type. In that case this check is necessary.
      if (
        idsArray.length == 2 ||
        Object.keys(this.tapWaterSubsystemData).length === 0
      ) {
        return this.facility;
      } else if (idsArray.length === 3) {
        var id = idsArray[2];
        if (this.tapWaterSubsystemData.pointId.toString() === id.toString()) {
          return this.tapWaterSubsystemData;
        } else if (
          this.softenedWaterSubsystemData.pointId.toString() === id.toString()
        ) {
          return this.softenedWaterSubsystemData;
        } else if (
          this.demiWaterSubsystemData.pointId.toString() === id.toString()
        ) {
          return this.demiWaterSubsystemData;
        } else if (
          this.reverseOsmosisSubsystemData.pointId.toString() === id.toString()
        ) {
          return this.reverseOsmosisSubsystemData;
        } else if (
          this.doserSubsystemData.pointId.toString() === id.toString()
        ) {
          return this.doserSubsystemData;
        } else {
          var box = this.boxes.find(function(boxViewModel) {
            return boxViewModel.pointId.toString() === id.toString();
          });
          return box ? box : null;
        }
      } else {
        return null;
      }
    }

    function updateConnectionStatus(id, data, list) {
      if (data.reference === "CONNECTION_ERROR") {
        list.map(function(listener) {
          if (listener.pointId === parseInt(id)) {
            data.currentValue === "0"
              ? (listener.listenerStatus = "online")
              : (listener.listenerStatus = "offline");
          }
        });
      }
      if (data.reference === "OP_BUTTON") {
        list.map(function(listener) {
          if (listener.pointId === parseInt(id)) {
            listener.hhanleDeviceStatus = data.value;
          }
        });
      }
      return list;
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsTapWaterViewModel', facilityDetailsTapWaterViewModelFactory);

  /** @ngInject */
  function facilityDetailsTapWaterViewModelFactory(tapWaterSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsTapWaterViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);
      
      this._propertyMappings = {};
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_EMV_SPR_PITKA_VODA] = 'vent';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_PITKA_VODA] = 'highFloat';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_PITKA_VODA] = 'lowFloat';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_CRPKA_PITKE_VODE_RAD] = 'motor';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_CRPKA_PITKE_VODE_GRE_MZS] = 'motorError';
      this._propertyMappings[tapWaterSubsystemUtils.FeedReferences.OP_TLAK_PITKA_VODA] = 'pressure';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(tapWaterSubsystemUtils.getTapWaterSubsystemPoint(facilityPointJson));
      }
      
    }

    FacilityDetailsTapWaterViewModel.prototype.destroy = function () {

    };

    FacilityDetailsTapWaterViewModel.prototype.clone = function () {
      var clone = new FacilityDetailsTapWaterViewModel();
      clone.pointId = this.pointId;
      clone.pointType = this.pointType;
      clone.name = this.name;
      clone.vent = this.vent;
      clone.highFloat = this.highFloat;
      clone.lowFloat = this.lowFloat;
      clone.motor = this.motor;
      clone.motorError = this.motorError;
      clone.pressure = this.pressure;

      return clone;
    };

    FacilityDetailsTapWaterViewModel.prototype.refresh = function (tapWaterPointJson) {
      this.pointId = tapWaterPointJson.id;
      this.name = tapWaterPointJson.name;
      this.pointType = tapWaterPointJson.pointType;
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_EMV_SPR_PITKA_VODA));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_PITKA_VODA));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_PITKA_VODA));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_CRPKA_PITKE_VODE_RAD));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_CRPKA_PITKE_VODE_GRE_MZS));
      setFeedValue.call(this, tapWaterSubsystemUtils.getFeed(tapWaterPointJson, tapWaterSubsystemUtils.FeedReferences.OP_TLAK_PITKA_VODA));
    };

    FacilityDetailsTapWaterViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsTapWaterViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsSoftenedWaterViewModel', facilityDetailsSoftenedWaterViewModelFactory);

  /** @ngInject */
  function facilityDetailsSoftenedWaterViewModelFactory(softenedWaterSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsSoftenedWaterViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);

      this._propertyMappings = {};
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_EMV_SPR_OMEKSANA_VODA] = 'vent';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_OMEKS_VODE] = 'highFloat';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_OMEKS_VODE] = 'lowFloat';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_CRPKA_OMEKS_VODE_RAD] = 'motor';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_CRPKA_OMEKS_VODE_GRE_MZS] = 'motorError';
      this._propertyMappings[softenedWaterSubsystemUtils.FeedReferences.OP_TLAK_OMEKSANE_VODE] = 'pressure';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(softenedWaterSubsystemUtils.getSoftenedWaterSubsystemPoint(facilityPointJson));
      }
    }

    FacilityDetailsSoftenedWaterViewModel.prototype.destroy = function () {

    };

    FacilityDetailsSoftenedWaterViewModel.prototype.refresh = function (softenedWaterPointJson) {
      this.pointId = softenedWaterPointJson.id;
      this.name = softenedWaterPointJson.name;
      this.pointType = softenedWaterPointJson.pointType;
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_EMV_SPR_OMEKSANA_VODA));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_OMEKS_VODE));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_OMEKS_VODE));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_CRPKA_OMEKS_VODE_RAD));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_CRPKA_OMEKS_VODE_GRE_MZS));
      setFeedValue.call(this, softenedWaterSubsystemUtils.getFeed(softenedWaterPointJson, softenedWaterSubsystemUtils.FeedReferences.OP_TLAK_OMEKSANE_VODE));
    };

    FacilityDetailsSoftenedWaterViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsSoftenedWaterViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsReverseOsmosisViewModel', facilityDetailsReverseOsmosisViewModelFactory);

  /** @ngInject */
  function facilityDetailsReverseOsmosisViewModelFactory(reverseOsmosisSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsReverseOsmosisViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);

      this._propertyMappings = {};
      this._propertyMappings[reverseOsmosisSubsystemUtils.FeedReferences.OP_TLAK_REV_OSMOZA] = 'lps';
      this._propertyMappings[reverseOsmosisSubsystemUtils.FeedReferences.OP_FWV_REV_OSMOZA] = 'fwy';
      this._propertyMappings[reverseOsmosisSubsystemUtils.FeedReferences.OP_CRP_REV_OSMOZA_U_RADU] = 'motor';
      this._propertyMappings[reverseOsmosisSubsystemUtils.FeedReferences.OP_CRPKA_REV_OSMOZA_GRE_MZS] = 'motorError';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(reverseOsmosisSubsystemUtils.getReverseOsmosisSubsystemPoint(facilityPointJson));
      }
    }

    FacilityDetailsReverseOsmosisViewModel.prototype.destroy = function () {

    };

    FacilityDetailsReverseOsmosisViewModel.prototype.refresh = function (reverseOsmosisPointJson) {
      this.pointId = reverseOsmosisPointJson.id;
      this.name = reverseOsmosisPointJson.name;
      this.pointType = reverseOsmosisPointJson.pointType;
      setFeedValue.call(this, reverseOsmosisSubsystemUtils.getFeed(reverseOsmosisPointJson, reverseOsmosisSubsystemUtils.FeedReferences.OP_TLAK_REV_OSMOZA));
      setFeedValue.call(this, reverseOsmosisSubsystemUtils.getFeed(reverseOsmosisPointJson, reverseOsmosisSubsystemUtils.FeedReferences.OP_FWV_REV_OSMOZA));
      setFeedValue.call(this, reverseOsmosisSubsystemUtils.getFeed(reverseOsmosisPointJson, reverseOsmosisSubsystemUtils.FeedReferences.OP_CRP_REV_OSMOZA_U_RADU));
      setFeedValue.call(this, reverseOsmosisSubsystemUtils.getFeed(reverseOsmosisPointJson, reverseOsmosisSubsystemUtils.FeedReferences.OP_CRPKA_REV_OSMOZA_GRE_MZS));
    };

    FacilityDetailsReverseOsmosisViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsReverseOsmosisViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsListenerWashBoxViewModel', FacilityDetailsListenerWashBoxViewModelFactory);

  /** @ngInject */
  function FacilityDetailsListenerWashBoxViewModelFactory() {
    function FacilityDetailsListenerWashBoxViewModel(listenerJson) {

      if (typeof listenerJson !== 'undefined') {
        this.refresh(listenerJson);
      }
    }

    FacilityDetailsListenerWashBoxViewModel.prototype.destroy = function () {

    };

    FacilityDetailsListenerWashBoxViewModel.prototype.refresh = function (listenerJson) {
      this.pointId = listenerJson.id;
      this.name = listenerJson.name;
      this.listenerStatus = 'offline';
      this.hhanleDeviceStatus = "0";
      var that = this;
      listenerJson.feeds.forEach(function(status) {
            if (status.reference === "CONNECTION_ERROR" && status.currentValue === "0") {
                that.listenerStatus = 'online';
            }
      });
      listenerJson.actuators.forEach(function(status) {
        if (status.reference === 'OP_BUTTON') {
          that.hhanleDeviceStatus = status.value;
        }
      });
    };

    FacilityDetailsListenerWashBoxViewModel.prototype.refreshFeed = function () {

    };

    return FacilityDetailsListenerWashBoxViewModel;

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsListenerViewModel', facilityDetailsListenerViewModelFactory);

  /** @ngInject */
  function facilityDetailsListenerViewModelFactory() {
    function FacilityDetailsListenerViewModel(listenerJson) {

      if (typeof listenerJson !== 'undefined') {
        this.refresh(listenerJson);
      }
    }

    FacilityDetailsListenerViewModel.prototype.destroy = function () {

    };

    FacilityDetailsListenerViewModel.prototype.refresh = function (listenerJson) {
      this.pointId = listenerJson.id;
      this.name = listenerJson.name;
      this.listenerStatus = 'offline';
      var that = this;
      listenerJson.feeds.forEach(function(status) {
            if (status.reference === "CONNECTION_ERROR" && status.currentValue === "0") {
                that.listenerStatus = 'online';
            }
      });
    };

    FacilityDetailsListenerViewModel.prototype.refreshFeed = function () {

    };

    return FacilityDetailsListenerViewModel;

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsDoserViewModel', facilityDetailsDoserViewModelFactory);

  /** @ngInject */
  function facilityDetailsDoserViewModelFactory(doserSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsDoserViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);

      this._propertyMappings = {};
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_EMV_SPREMNIK_PRASKA] = 'vent';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_MAX_NIVO_PRASAK] = 'highFloat';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_MIN_NIVO_PRASAK] = 'lowFloat';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_CRPKA_PRASKA_RAD] = 'motor';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_CRPKA_PRASKA_GRE_MZS] = 'motorError';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_DOZATOR_PRASKA_RAD] = 'motorDoser';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_DOZATOR_PRASKA_GRE_MZS] = 'motorDoserError';
      this._propertyMappings[doserSubsystemUtils.FeedReferences.OP_VIBRATOR_PRASKA_GRE_MZS] = 'motorVibroError';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(doserSubsystemUtils.getDoserSubsystemPoint(facilityPointJson));
      }
    }

    FacilityDetailsDoserViewModel.prototype.destroy = function () {

    };

    FacilityDetailsDoserViewModel.prototype.refresh = function (doserPointJson) {
      this.pointId = doserPointJson.id;
      this.name = doserPointJson.name;
      this.pointType = doserPointJson.pointType;
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_EMV_SPREMNIK_PRASKA));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_MAX_NIVO_PRASAK));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_MIN_NIVO_PRASAK));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_CRPKA_PRASKA_RAD));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_CRPKA_PRASKA_GRE_MZS));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_DOZATOR_PRASKA_RAD));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_DOZATOR_PRASKA_GRE_MZS));
      setFeedValue.call(this, doserSubsystemUtils.getFeed(doserPointJson, doserSubsystemUtils.FeedReferences.OP_VIBRATOR_PRASKA_GRE_MZS));
    };

    FacilityDetailsDoserViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsDoserViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('FacilityDetailsDemiWaterViewModel', facilityDetailsDemiWaterViewModelFactory);

  /** @ngInject */
  function facilityDetailsDemiWaterViewModelFactory(demiWaterSubsystemUtils, modelUtils, subsystemService) {
    function FacilityDetailsDemiWaterViewModel(facilityPointJson) {

      var checkSubSystemStatus = -1;
      checkSubSystemStatus = subsystemService.check(facilityPointJson);

      this._propertyMappings = {};
      this._propertyMappings[demiWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_DEMIN_VODE] = 'highFloat';
      this._propertyMappings[demiWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_DEMIN_VODE] = 'lowFloat';
      this._propertyMappings[demiWaterSubsystemUtils.FeedReferences.OP_CRPKA_DEMIN_VODE_RAD] = 'motor';
      this._propertyMappings[demiWaterSubsystemUtils.FeedReferences.OP_CRPKA_DEMIN_VODE_GRE_MZS] = 'motorError';

      if (typeof facilityPointJson !== 'undefined' && checkSubSystemStatus > -1) {
        this.refresh(demiWaterSubsystemUtils.getDemiWaterSubsystemPoint(facilityPointJson));
      }
    }

    FacilityDetailsDemiWaterViewModel.prototype.destroy = function () {

    };

    FacilityDetailsDemiWaterViewModel.prototype.refresh = function (demiWaterPointJson) {
      this.pointId = demiWaterPointJson.id;
      this.name = demiWaterPointJson.name;
      this.pointType = demiWaterPointJson.pointType;
      setFeedValue.call(this, demiWaterSubsystemUtils.getFeed(demiWaterPointJson, demiWaterSubsystemUtils.FeedReferences.OP_MAX_NIVO_DEMIN_VODE));
      setFeedValue.call(this, demiWaterSubsystemUtils.getFeed(demiWaterPointJson, demiWaterSubsystemUtils.FeedReferences.OP_MIN_NIVO_DEMIN_VODE));
      setFeedValue.call(this, demiWaterSubsystemUtils.getFeed(demiWaterPointJson, demiWaterSubsystemUtils.FeedReferences.OP_CRPKA_DEMIN_VODE_RAD));
      setFeedValue.call(this, demiWaterSubsystemUtils.getFeed(demiWaterPointJson, demiWaterSubsystemUtils.FeedReferences.OP_CRPKA_DEMIN_VODE_GRE_MZS));
    };

    FacilityDetailsDemiWaterViewModel.prototype.refreshFeed = function (feed) {
      setFeedValue.call(this, feed);
    };

    return FacilityDetailsDemiWaterViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[this._propertyMappings[feed.reference]]
          = modelUtils.parseFeedCurrentValue(feed.currentValue, feed.readingType);
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('FacilityDetailsController', FacilityDetailsController);

  /** @ngInject */
  function FacilityDetailsController(
    $scope,
    $stateParams,
    FacilityDetailsViewModel,
    deviceActions,
    broker,
    webSocketsStore,
    $timeout,
    layoutActions,
    $mdDialog,
    $translate,
    messageActions,
    $log
  ) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onDeviceDataChangeHandler = refreshDevice,
      _onFeedChangedHandler = refreshDeviceFeed,
      _onActuatorChangedHandler = refreshDeviceActuator;

    vm.facility = null;
    vm.checkDeviceTypeListener = true;
    vm.checkDeviceTypeBridge = true;
    vm.checkDeviceTypeWashBoxListener = true;
    vm.checkDeviceTypeHHanle = true;
    vm.buttonTitle = $translate.instant("INSERT");

    init();

    function init() {
      layoutActions.showLoader();

      $scope.$on('$destroy', function () {
        if (vm.facility !== null) {
          vm.facility.destroy();
          webSocketsStore.off(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.off(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          webSocketsStore.off(
            webSocketsStore.events.DEVICE_STATE_CHANGE,
            _onDeviceDataChangeHandler
          );
          webSocketsStore.off(
            webSocketsStore.events.DEVICE_ACTUATOR_CHANGE,
            _onActuatorChangedHandler
          );
        }
      });

      deviceActions.getDevice($stateParams.id).then(
        function (deviceJson) {
          // Check deviceType
          switch (deviceJson.deviceType) {
            case 'SERIAL_485':
              vm.checkDeviceTypeBridge = false;
              break;
            case 'SEMPRA_BRIDGE':
              vm.checkDeviceTypeListener = false;
              vm.checkDeviceTypeWashBoxListener = false;
              break;
            case 'BRIDGE_WITH_LISTENER':
              vm.checkDeviceTypeWashBoxListener = false;
              break;
            case 'HHANLE':
              vm.checkDeviceTypeHHanle = false;
              break;
          }

          layoutActions.hideLoader();

          vm.facility = new FacilityDetailsViewModel(deviceJson);

          subscribeToSocket();
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_STATE_CHANGE,
            _onDeviceDataChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_ACTUATOR_CHANGE,
            _onActuatorChangedHandler
          );
        },
        function () {
          //todo error handling
        }
      );
    }

    vm.dismissAlarm = function (ev, message) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant('DISMISS_ALARM'))
        .ariaLabel('Dismiss alarm confirmation')
        .targetEvent(ev)
        .ok($translate.instant('YES'))
        .cancel($translate.instant('NO'));
      $mdDialog.show(confirm).then(
        function () {
          messageActions.dismissAlarm(message.alarmId).then(function () {
            $log.log('Alarm dismissed');
            messageActions.getAlarmMessages();
          });
        },
        function () {}
      );
    };

    vm.startService = function (ev, box) {
      $mdDialog.show({
        templateUrl: 'app/facilityDetails/insert-token-dialog.html',
        targetEvent: ev,
        clickOutsideToClose: true,
        escapeToClose: true,
        controller: DialogController,
        controllerAs: 'vm',
        bindToController: true,
        locals: {
          box: box,
          facilityId: vm.facility.facility.pointId
        }
      });

      function DialogController($mdDialog, box, managingTokensActions, facilityId, dispatcher, ActionTypesEnum) {
        var vm = this;
        vm.box = box;
        vm.dialogData = {};
        vm.buttonTitle = $translate.instant("IN_PROGRESS");
        vm.sessionStatus = "";

        managingTokensActions.createDeviceSession(box.pointId).then(function (response) {
          vm.sessionStatus = response.data.status;
          vm.buttonTitle = $translate.instant("INSERT");
        })

        vm.closeDialog = function () {
          $mdDialog.cancel();
        };

        vm.saveToken = function (token) {
          if (token && vm.sessionStatus === "PENDING") {
            managingTokensActions.startDeviceService(facilityId, box.pointId, token).then(function () {
              $mdDialog.hide(token);
            })
          } else {
            $mdDialog.hide(token);
            dispatcher.dispatch({
              type: ActionTypesEnum.SHOW_TOASTER_MSG,
              payload: {
                type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                message: $translate.instant('EXPIRED_SESSION')
              }
            });
          }
        };
      }
    };

    function subscribeToSocket() {
      if (webSocketsStore.isConnected()) {
        broker.subscribeToDeviceChanges([vm.facility.deviceSerial]);
        broker.subscribeToFeedChanges([vm.facility.deviceSerial]);
        broker.subscribeToActuatorChanges([vm.facility.deviceSerial]);
      }
    }

    function refreshDevice(newDeviceData) {
      $timeout(function () {
        vm.facility.refreshState(newDeviceData);
      }, 50);
    }

    function refreshDeviceFeed(newFeedData) {
      $timeout(function () {
        vm.facility.refreshFeed(newFeedData);
        $scope.$apply();
      }, 50);
    }

    function refreshDeviceActuator(newActuatorData) {
      $timeout(function () {
        vm.facility.refreshActuator(newActuatorData);
      }, 50);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('FacilitiesController', FacilitiesController);

  /** @ngInject */
  function FacilitiesController() {
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ErrorPageViewModel', errorPageViewModelFactory);

  /** @ngInject */
  function errorPageViewModelFactory($translate) {
    function ErrorPageViewModel() {
      this.errorMessage = $translate.instant('DEFAULT_ERROR_DESCRIPTION');
      init.call(this);
    }

    ErrorPageViewModel.prototype.destroy = function () {
    };

    return ErrorPageViewModel;

    function init() {
      // var that = this;

    }
  }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ErrorPageController', ErrorPageController);

  /** @ngInject */
  function ErrorPageController($scope, ErrorPageViewModel, errorActions, applicationStore) {
    var vm = this;

    vm.error = new ErrorPageViewModel();

    init ();

    function init () {
      // listen for message from dispatcher
      showErrorMsg(applicationStore.get().errorPageMsg);
      // applicationStore.on(applicationStore.events.ERROR_PAGE_STATE_CHANGE, showErrorMsg);

      $scope.$on('$destroy', function () {
        vm.error.destroy();
      });
    }

    function showErrorMsg(errText){
      vm.error.errorMessage = errText;
    }

    vm.goBack = function(){
      errorActions.acknowledgeAndGoBack();
    };

  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("FacilityTileViewModel", facilityTileViewModelFactory);

  /** @ngInject */
  function facilityTileViewModelFactory(
    invariant,
    facilityUtils,
    modelUtils,
    messagesStore,
    sortArrayService
  ) {
    function FacilityTileViewModel(deviceJson) {
      this._messagesStoreChangeHandler = null;
      this._propertyMappings = {};
      this._propertyMappings[
        facilityUtils.FeedReferences.OP_TEMPERATURA_MJERENA
      ] = "currentTemperature";

      if (typeof deviceJson !== "undefined") {
        this.refresh(deviceJson);
      }
    }

    FacilityTileViewModel.prototype.destroy = function() {
      if (this._messagesStoreChangeHandler) {
        messagesStore.off(
          messagesStore.events.CHANGE,
          this._messagesStoreChangeHandler
        );
      }
    };

    FacilityTileViewModel.prototype.refresh = function(deviceJson) {
      var facilityPoint = facilityUtils.getFacilityPoint(deviceJson);

      invariant(
        facilityPoint,
        "FacilityTileViewModel: device does not contain WASH_FACILITY point."
      );

      this.deviceSerial = deviceJson.deviceKey;
      this.deviceType = deviceJson.deviceType;
      this.pointId = facilityPoint.id;
      this.name = facilityPoint.name;
      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();

      setFeedValue.call(
        this,
        facilityUtils.getFeed(
          facilityPoint,
          facilityUtils.FeedReferences.OP_TEMPERATURA_MJERENA
        )
      );

      //todo weather feed read
      this.weatherIcon = "assets/icons/ic_wb_sunny_black_24px.svg";
      this.hasAlarms = false;
      this.hasWarnings = false;

      refreshAlarms.call(this);

      if (!this._messagesStoreChangeHandler) {
        var that = this;
        this._messagesStoreChangeHandler = function() {
          refreshAlarms.call(that);
        };
        messagesStore.on(
          messagesStore.events.CHANGE,
          this._messagesStoreChangeHandler
        );
      }
    };

    FacilityTileViewModel.prototype.refreshDevice = function(deviceJson) {
      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();
    };

    FacilityTileViewModel.prototype.refreshDeviceFeed = function(feedJson) {
      setFeedValue.call(this, feedJson);
    };

    return FacilityTileViewModel;

    function setFeedValue(feed) {
      if (feed !== null && this._propertyMappings[feed.reference]) {
        this[
          this._propertyMappings[feed.reference]
        ] = modelUtils.parseFeedCurrentValue(
          feed.currentValue,
          feed.readingType
        );
      }
    }

    function refreshAlarms() {
      var that = this,
        messages = messagesStore.getMessages(),
        hasMessages = false,
        hasAlarms = false,
        hasWarnings = false,
        excludedList = [
          "CONNECTION_ERROR",
          "ERROR_SETTING_INHIBIT_MODE",
          "COULD_NOT_SIMULATE_COIN",
          "DEAD_RM5_CHANNEL_PIN_ERROR",
          "RESTART_OR_BROWNOUT_OCCURRED",
          "EXTERNAL_PIN_RESET",
          "SOFTWARE_RESET",
          "UNKNOWN_RESET"
        ];

      // This is necessary because we want last state for facility
      messages = messages ? sortArrayService.sortByTime(messages) : messages;

      if (messages !== null && messages.length > 0) {
        hasMessages =
          messages.filter(function(message) {
            if (message.device === that.deviceSerial) {
              switch (true) {
                case message.collapseKey === "alarm" &&
                  !excludedList.includes(message.content):
                  hasAlarms = true;
                  return true;
                case message.collapseKey === "alarm" &&
                  excludedList.includes(message.content):
                  hasAlarms = false;
                  return true;
                case message.collapseKey === "info":
                  hasWarnings = true;
                  return true;
              }
            } else {
              return false;
            }
          }).length > 0;
      }

      this.hasAlarms = hasMessages && hasAlarms;
      this.hasWarnings = hasMessages && hasWarnings;
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('DashboardTechnologyViewModel', dashboardTechnologyViewModelFactory);

  /** @ngInject */
  function dashboardTechnologyViewModelFactory (FacilityTileViewModel) {
    function DashboardTechnologyViewModel (devicesJson) {
      this.devices = [];

      if (devicesJson) {
        refresh.call(this, devicesJson);
      }
    }

    DashboardTechnologyViewModel.prototype.destroy = function () {
      this.devices.forEach(function (facilityTileViewModel) {
        facilityTileViewModel.destroy();
      });
    };

    DashboardTechnologyViewModel.prototype.refreshTileDevice = function (newDeviceDataJson) {
      var tileViewModel = this.devices.find(function (deviceTileViewModel) {
        return newDeviceDataJson.path.indexOf(deviceTileViewModel.deviceSerial) > -1;
      });

      if (tileViewModel) {
        tileViewModel.refreshDevice(newDeviceDataJson);
      }
    };

    DashboardTechnologyViewModel.prototype.refreshTileDeviceFeed = function (newDeviceFeedJson) {
      var tileViewModel = this.devices.find(function (deviceTileViewModel) {
        return newDeviceFeedJson.path.indexOf(deviceTileViewModel.deviceSerial) > -1;
      });

      if (tileViewModel) {
        tileViewModel.refreshDeviceFeed(newDeviceFeedJson.data);
      }
    };

    DashboardTechnologyViewModel.prototype.refreshAlarms = function () {
      if (this.devices && this.devices.length > 0) {
        this.devices.forEach(function (tileVieWModel) {
          tileVieWModel.refreshAlarms();
        });
      }
    };

    return DashboardTechnologyViewModel;

    function refresh (devicesJson) {
      if (devicesJson) {
        devicesJson.forEach(function (deviceJson) {
          this.push(new FacilityTileViewModel(deviceJson));
        }, this.devices);
      }
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("dashboardTechnologyController", dashboardTechnologyController);

  /** @ngInject */
  function dashboardTechnologyController(
    $scope,
    deviceActions,
    messageActions,
    DashboardTechnologyViewModel,
    broker,
    webSocketsStore,
    messagesStore,
    $timeout,
    layoutActions,
    $mdDialog,
    hostProtocol,
    hostDomain,
    $log,
    $translate,
    sessionData,
    $state,
    brand,
    service,
    karcherActiveAlarmsService
  ) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onDeviceDataChangeHandler = refreshDevice,
      _onFeedChangedHandler = refreshDeviceFeed;
    //_onMessageAvailableHandler = refreshMessages;

    var brandSubTitle = brand === "karcher" ? "Kärcher Car Wash" : "R2W";

    vm.dashboard = null;

    vm.brand = brand;
    vm.service = service;

    vm.openCarWashDetails = function(ev, facility) {
      $mdDialog.show({
        controller: facilityDetailsController,
        controllerAs: "vm",
        bindToController: true,
        templateUrl: "app/dashboardTechnology/facilityDetailView.dialog.html",
        /* eslint-disable */
        parent: angular.element(document.body),
        /* eslint-enable */
        targetEvent: ev,
        locals: { facility: facility },
        clickOutsideToClose: true
      });
    };

    vm.details = function(id, status, deviceType) {
      $state.go("app.dashboardTechnology.facilityDetails", {
        id: id,
        deviceType: deviceType.toLowerCase()
      });
    };

    // to-do implement this in a separate file (dialog to be separate component)
    function facilityDetailsController($mdDialog, Upload, facility, $mdToast) {
      /* eslint-disable */
      var that = this;
      /* eslint-enable */

      var facilityId = that.facility.pointId;

      that.data = {};
      that.imageLink =
        hostProtocol +
        "://" +
        hostDomain +
        "/api/washFacilities/" +
        facilityId +
        "/image";

      deviceActions.getDeviceDetails(facilityId).then(function(data) {
        data.website =
          data.website === "" ? (data.website = "http://") : data.website;
        that.data = data;
      });

      that.submit = function() {
        if (that.scope.facilityDetailsForm.file.$valid && that.scope.file) {
          uploadImage(that.scope.file);
        }
      };

      that.saveChanges = function() {
        var request = {
          address: that.data.address,
          phone1: that.data.phone1,
          phone2: that.data.phone2,
          website: that.data.website,
          workingHours: that.data.workingHours,
          info: that.data.info
        };
        deviceActions.updateDeviceDetails(facilityId, request).then(function() {
          $mdToast.show(
            $mdToast
              .simple()
              .textContent(
                $translate.instant("FACILITY_UPDATE_DATA_NOTIFICATION")
              )
              .position("bottom right")
              .hideDelay(3000)
          );
          that.closeDialog();
        });
      };

      that.closeDialog = function() {
        $mdDialog.hide();
      };

      function uploadImage(file) {
        Upload.upload({
          url:
            hostProtocol +
            "://" +
            hostDomain +
            "/api/washFacilities/" +
            facilityId +
            "/image",
          data: { file: file }
        }).then(
          function(resp) {
            $log.info(
              "Success " +
                resp.config.data.file.name +
                "uploaded. Response: " +
                resp.data
            );

            $mdToast.show(
              $mdToast
                .simple()
                .textContent(
                  $translate.instant("FACILITY_UPLOAD_IMAGE_NOTIFICATION")
                )
                .position("bottom right")
                .hideDelay(3000)
            );
          },
          function(resp) {
            $log.info("Error status: " + resp.status);
          },
          function(evt) {
            var progressPercentage = parseInt((100.0 * evt.loaded) / evt.total);
            $log.info(
              "progress: " +
                progressPercentage +
                "% " +
                evt.config.data.file.name
            );
          }
        );
      }
    }

    init();

    function init() {
      //Load title =======================================
      /* eslint-disable */
      var title = document.getElementsByTagName("title");
      /* eslint-enable */
      var check = sessionData.getTitle().firstName;
      title[0].innerHTML = !check
        ? "Merchant - " + brandSubTitle
        : sessionData.getTitle().firstName +
          " " +
          sessionData.getTitle().lastName +
          " " +
          "- " +
          brandSubTitle;
      //==================================================

      layoutActions.showLoader();
      $scope.$on("$destroy", destroy);

      deviceActions.getAllDevices().then(
        function(devicesJson) {
          layoutActions.hideLoader();
          vm.dashboard = new DashboardTechnologyViewModel(devicesJson);

          subscribeToSocket();
          webSocketsStore.on(
            webSocketsStore.events.CONNECTED_CHANGE,
            _webSocketStoreConnectedChangeHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_FEED_CHANGE,
            _onFeedChangedHandler
          );
          webSocketsStore.on(
            webSocketsStore.events.DEVICE_STATE_CHANGE,
            _onDeviceDataChangeHandler
          );

          // If Karcher brand is define, get active alarms
          if (brand === "karcher") {
            messageActions.getKarcherAlarms().then(function(data) {
              vm.karcherActiveAlarms = data;
              vm.dashboard.devices = karcherActiveAlarmsService.checkFacilityStatus(data, vm.dashboard.devices);
            });
          }

        },
        function() {
          //todo error handling
        }
      );
      // showReleaseAlert();
    }

    function destroy() {
      if (vm.dashboard !== null) {
        vm.dashboard.destroy();
        webSocketsStore.off(
          webSocketsStore.events.CONNECTED_CHANGE,
          _webSocketStoreConnectedChangeHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_FEED_CHANGE,
          _onFeedChangedHandler
        );
        webSocketsStore.off(
          webSocketsStore.events.DEVICE_STATE_CHANGE,
          _onDeviceDataChangeHandler
        );
        // webSocketsStore.off(webSocketsStore.events.MESSAGES_UPDATE_AVAILABLE, _onMessageAvailableHandler);
      }
    }

    function subscribeToSocket() {
      if (webSocketsStore.isConnected()) {
        var deviceSerialArray = vm.dashboard.devices.map(function(
          deviceTileViewModel
        ) {
          return deviceTileViewModel.deviceSerial;
        });
        broker.subscribeToDeviceChanges(deviceSerialArray);
        broker.subscribeToFeedChanges(deviceSerialArray);
        broker.subscribeToNoticeChanges();
        // broker.subscribeToMessageChanges(deviceSerialArray);
      }
    }

    function refreshDevice(newDeviceData) {
      $timeout(function() {
        vm.dashboard.refreshTileDevice(newDeviceData);
      }, 50);
    }

    function refreshDeviceFeed(newFeedData) {
      $timeout(function() {
        vm.dashboard.refreshTileDeviceFeed(newFeedData);
      }, 50);
    }

    // function showReleaseAlert() {
    //   var alert = $mdDialog.alert({
    //     title: "Attention",
    //     textContent: "Update process on wash facilities is in progress. Thanks for your patience on this issue.",
    //     ok: "Close"
    //   });
    //
    //   $mdDialog.show(alert).finally(function() {
    //     alert = undefined;
    //   });
    // }

    // function refreshMessages () {
    //   vm.dashboard.refreshAlarms();
    // }
  }
})();

(function () {
	'use strict';

	angular.module('sempraWebapp').factory('DashboardKarcherTechnologyViewModel', DashboardKarcherTechnologyViewModelFactory);

	/** @ngInject */
	function DashboardKarcherTechnologyViewModelFactory($translate) {
		function DashboardKarcherTechnologyViewModel() {
			this.siteName = "";
			this.alarmStatusList = [
				{
					name: $translate.instant("LOW_ALARM"),
					value: "INFO"
				},
				{
					name: $translate.instant("MEDIUM_ALARM"),
					value: "WARNING"
				},
				{
					name: $translate.instant("HIGH_ALARM"),
					value: "ALARM"
				}
			];
			this.facilityAlarmStatuses = [];
			this.alarmStatus = "";
			this.alarmHigh = 0;
			this.alarmLow = 0;
			this.alarmMedium = 0;
			this.alarmTotal = 0;
			this.mapStyleSelector = false;
			this.buttonTitleOnMapModal = $translate.instant("BREAD_CRUMBS_DETAILS");
			this.mapStyles = [
				{
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"elementType": "labels.icon",
					"stylers": [
						{
							"visibility": "off"
						}
					]
				},
				{
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"elementType": "labels.text.stroke",
					"stylers": [
						{
							"color": "#f5f5f5"
						}
					]
				},
				{
					"featureType": "administrative.land_parcel",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#bdbdbd"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "poi",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "poi.park",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "road",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#ffffff"
						}
					]
				},
				{
					"featureType": "road.arterial",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#757575"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#dadada"
						}
					]
				},
				{
					"featureType": "road.highway",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#616161"
						}
					]
				},
				{
					"featureType": "road.local",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				},
				{
					"featureType": "transit.line",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#e5e5e5"
						}
					]
				},
				{
					"featureType": "transit.station",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#eeeeee"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "geometry",
					"stylers": [
						{
							"color": "#c9c9c9"
						}
					]
				},
				{
					"featureType": "water",
					"elementType": "labels.text.fill",
					"stylers": [
						{
							"color": "#9e9e9e"
						}
					]
				}
			]
			this.templateContentTranslate = {
				address: $translate.instant('ADDRESS'),
				info: $translate.instant('INFO_TITLE'),
				phone: $translate.instant('PHONE'),
				workingHours: $translate.instant('WORKING_HOURS')
			}
		}

		DashboardKarcherTechnologyViewModel.prototype.destroy = function () {

		};

		DashboardKarcherTechnologyViewModel.prototype.refreshAlarmsOnMapPage = function (data) {
			this.alarmHigh = data.high;
			this.alarmLow = data.low;
			this.alarmMedium = data.medium;
			this.alarmTotal = data.total;
		};

		DashboardKarcherTechnologyViewModel.prototype.refreshFacilityAlarmStatuses = function (data) {
			this.facilityAlarmStatuses = data.facilityAlarmStatuses;
		};

		return DashboardKarcherTechnologyViewModel;
	}
})();

/* eslint-disable */
(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'DashboardKarcherTechnologyController',
      dashboardKarcherTechnologyController
    );

  /** @ngInject */
  function dashboardKarcherTechnologyController(
    dashboardKarcherActions,
    $timeout,
    $state,
    DashboardKarcherTechnologyViewModel,
    dispatcher,
    ActionTypesEnum,
    $translate,
    $log
  ) {
    // alarmsStore need to be imported for init reasons (don't remove)
    var vm = this;
    var map = null;
    var prevInfoWindow = null;
    var listOfAvailableSites = [];

    vm.dashboardKarcherTechnologyVM = new DashboardKarcherTechnologyViewModel();

    vm.searchSites = function () {
      settingMap(
        vm.dashboardKarcherTechnologyVM.siteName,
        vm.dashboardKarcherTechnologyVM.alarmStatus
      );
    };

    vm.getAlarm = function (site, facility, faultStatus) {
      dispatcher.dispatch({
        type: ActionTypesEnum.GET_ALARM_FROM_DASHBOARD_MESSAGE,
        payload: {
          from: 1262304001000,
          site: '',
          facility: facility ? facility.facilityId : '',
          faultStatus: faultStatus ? faultStatus : ''
        }
      });
      $state.go('app.alarms');
    };

    vm.returnToInitMap = function () {
      initMap();
    };

    function initMap() {
      settingMap('', []);
    }
    window.initMap = initMap;

    function setMarkerIcon(statusOfMarker) {
      switch (statusOfMarker) {
        case 'INFO':
          return 'assets/icons/ic_pin_green.svg';
        case 'WARNING':
          return 'assets/icons/ic_pin_yellow.svg';
        case 'ALARM':
          return 'assets/icons/ic_pin_red.svg';
        default:
          return 'assets/icons/ic_pin_green.svg';
      }
    }

    function closeMarker() {
      $timeout(function () {
        vm.dashboardKarcherTechnologyVM.refreshFacilityAlarmStatuses({
          facilityAlarmStatuses: []
        });
      }, 0);
    }

    function loadScript(url, callback) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;

      script.onload = callback;
      script.onerror = function () {
        console.error('Failed to load script:', url);
      };

      document.head.appendChild(script);
    }

    function settingMap(siteName, alarmStatus) {
      loadScript(
        'https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js',
        function () {
          $log.log('MarkerClusterer loaded successfully!');
          var bounds = new google.maps.LatLngBounds();

          dashboardKarcherActions
            .getKarcherSitesData(siteName, alarmStatus)
            .then(function (response) {
              response.siteAlarmStatusDtos.forEach(function (site) {
                listOfAvailableSites.push(site.siteId);
              });
              vm.dashboardKarcherTechnologyVM.refreshAlarmsOnMapPage(response);
              if (response.siteAlarmStatusDtos.length === 0) {
                navigator.geolocation.getCurrentPosition(showPosition);
              } else {
                map = new google.maps.Map(document.getElementById('map'), {
                  center: {
                    lat: response.siteAlarmStatusDtos[0].latitude,
                    lng: response.siteAlarmStatusDtos[0].longitude
                  },
                  styles: vm.dashboardKarcherTechnologyVM.mapStyleSelector
                    ? vm.dashboardKarcherTechnologyVM.mapStyles
                    : null
                });

                // Map zoom options
                map.setOptions({
                  draggable: true,
                  zoomControl: true,
                  scrollwheel: true,
                  disableDoubleClickZoom: true
                });
              }

              function showPosition(position) {
                new google.maps.Map(document.getElementById('map'), {
                  zoom: 13,
                  center: {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                  }
                });
                // dispatch message
                dispatcher.dispatch({
                  type: ActionTypesEnum.SHOW_TOASTER_MSG,
                  payload: {
                    type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
                    message: $translate.instant('NO_FACILITIES_NEARBY')
                  }
                });
              }

              var markerArray = [];

              response.siteAlarmStatusDtos.forEach(function (marker) {
                if (marker.latitude === 0 || marker.longitude === 0) {
                  return;
                }

                var markerIn = new google.maps.Marker({
                  position: {
                    lat: marker.latitude,
                    lng: marker.longitude
                  },
                  map: map,
                  title: marker.siteName,
                  icon: setMarkerIcon(marker.status)
                });

                markerArray.push(markerIn);

                bounds.extend(markerIn.getPosition());

                var infowindow = new google.maps.InfoWindow();
                var content = '';

                google.maps.event.addListener(
                  infowindow,
                  'closeclick',
                  closeMarker
                );

                google.maps.event.addListener(
                  markerIn,
                  'click',
                  (function (markerIn, content, infowindow) {
                    return function () {
                      dashboardKarcherActions
                        .getKarcherSitesInfoWindowData(marker.siteId)
                        .then(function (siteData) {
                          if (prevInfoWindow) {
                            prevInfoWindow.close();
                          }
                          vm.dashboardKarcherTechnologyVM.refreshFacilityAlarmStatuses(
                            siteData
                          );
                          content =
                            "<div class='paddingAll10'>" +
                            "<div style='display: inline-flex; border-bottom: 1px solid #9E9E9E; padding: 0 0 10px 0; width: 100%;'>" +
                            "<img style='height: 30px; margin-top: 7px' src='" +
                            setMarkerIcon(marker.status) +
                            "'>" +
                            "<h3 style='padding-left: 10px'>" +
                            siteData.site.name +
                            '</h3></div>' +
                            "<p class='info-map-description' style='margin-top: 20px'><span class='info-window-title'>" +
                            vm.dashboardKarcherTechnologyVM
                              .templateContentTranslate.address +
                            ': </span>' +
                            siteData.site.address +
                            '</p>' +
                            "<p class='info-map-description' style='margin-top: 20px'><span class='info-window-title'>" +
                            vm.dashboardKarcherTechnologyVM
                              .templateContentTranslate.info +
                            ': </span>' +
                            siteData.site.info +
                            '</p>' +
                            "<p class='info-map-description marginTop20'><span class='info-window-title'>" +
                            vm.dashboardKarcherTechnologyVM
                              .templateContentTranslate.phone +
                            ': </span>' +
                            siteData.site.phone1 +
                            ', ' +
                            siteData.site.phone2 +
                            '</p>' +
                            "<p class='info-map-description marginBottom20 marginTop20'><span class='info-window-title'>" +
                            vm.dashboardKarcherTechnologyVM
                              .templateContentTranslate.workingHours +
                            ': </span>' +
                            siteData.workingDay.hoursFrom +
                            ' - ' +
                            siteData.workingDay.hoursTo +
                            '</p>' +
                            "<button id='infoButton-map-details' class='info-map-button'>" +
                            vm.dashboardKarcherTechnologyVM
                              .buttonTitleOnMapModal +
                            '</button>' +
                            '</div>';

                          prevInfoWindow = infowindow;
                          infowindow.setContent(content);
                          infowindow.open(map, markerIn);
                          $timeout(function () {
                            var mapDiv = document.getElementById(
                              'infoButton-map-details'
                            );
                            google.maps.event.addDomListener(
                              mapDiv,
                              'click',
                              function () {
                                infowindow.close();
                                $state.go(
                                  'app.dashboardTechnology.siteDetails',
                                  {
                                    id: siteData.site.pointId,
                                    siteAddress: decodeURIComponent(
                                      siteData.site.address
                                    ),
                                    siteLatitude:
                                      siteData.site.location.latitude,
                                    siteLongitude:
                                      siteData.site.location.longitude
                                  }
                                );
                              }
                            );
                          }, 0);
                        });
                    };
                  })(markerIn, content, infowindow)
                );
              });

              new markerClusterer.MarkerClusterer({
                map: map,
                markers: markerArray
              });

              map.fitBounds(bounds);
            });
        }
      );
    }
  }
})();
/* eslint-enable */

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .factory('FinancesTileViewModel', financesTileViewModelFactory);

  /** @ngInject */
  function financesTileViewModelFactory(deviceActions) {
    function FinancesTileViewModel(deviceDailyFinancesJson) {
      this.status = '';
      this.lastReportTimestamp = '';

      if (typeof deviceDailyFinancesJson !== 'undefined') {
        this.refresh(deviceDailyFinancesJson);
      }
    }

    FinancesTileViewModel.prototype.destroy = function () {};

    FinancesTileViewModel.prototype.refresh = function (
      deviceDailyFinancesJson
    ) {
      this.deviceSerial = deviceDailyFinancesJson.deviceSerial;
      getDevice.call(this);
      this.refreshFinances(deviceDailyFinancesJson);
    };

    FinancesTileViewModel.prototype.refreshFinances = function (
      deviceDailyFinancesJson
    ) {
      this.chartData = {
        facilityName: deviceDailyFinancesJson.facilityName,
        totalOnlinePayments: deviceDailyFinancesJson.online,
        totalCashPayments: deviceDailyFinancesJson.cash,
        totalChangerMoney: deviceDailyFinancesJson.changer,
        totalTokenPayments: deviceDailyFinancesJson.tokens,
        totalPosMoney: deviceDailyFinancesJson.pos
      };
      this.totalPayments = deviceDailyFinancesJson.total;
      this.tokensCount = deviceDailyFinancesJson.tokensCount;
      this.localTokensCount = deviceDailyFinancesJson.lwtTokenCount;
    };

    FinancesTileViewModel.prototype.refreshDevice = function (deviceJson) {
      this.status = deviceJson.state;
      this.lastReportTimestamp = moment(
        deviceJson.lastReportTimestamp
      ).fromNow();
    };

    return FinancesTileViewModel;

    function getDevice() {
      var that = this;
      deviceActions.getDevice(that.deviceSerial).then(
        function (deviceJson) {
          that.refreshDevice(deviceJson);
        },
        function () {
          //todo error handling
        }
      );
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('DashboardFinancesViewModel', dashboardFinancesViewModelFactory);

  /** @ngInject */
  function dashboardFinancesViewModelFactory (modelUtils, dailyFinancesStore, FinancesTileViewModel) {
    function DashboardFinancesViewModel (financesJson) {
      this.finances = [];
      this.totalMoney = 0;
      this.ecomAmount = 0;
      this.currencyCode = '';

      init.call(this, financesJson);
    }

    DashboardFinancesViewModel.prototype.destroy = function () {
      this.finances.forEach(function (financeTileViewModel) {
        financeTileViewModel.destroy();
      });
    };

    DashboardFinancesViewModel.prototype.refreshTileFinances = function (refreshData) {
      var that = this;
      var tileViewModel = this.finances.find(function (financesViewModel) {
        return financesViewModel.deviceSerial === refreshData.facility.deviceSerial;
      });

      if (tileViewModel) {
        tileViewModel.refreshFinances(refreshData.facility);
      }

      //this.totalMoney = refreshData.total;
      this.totalMoney = 0;
      this.finances.forEach(function (financesTileViewModel) {
        that.totalMoney += financesTileViewModel.totalPayments;
      });
    };

    DashboardFinancesViewModel.prototype.refreshTileDevice = function (refreshData) {
      var tileViewModel = this.finances.find(function (financesViewModel) {
        return financesViewModel.deviceSerial === refreshData.path;
      });

      if (tileViewModel) {
        tileViewModel.refreshDevice(refreshData);
      }
    };

    return DashboardFinancesViewModel;

    function init (dailyFinancesData) {
      if (dailyFinancesData === null) {
        return;
      }
      this.totalMoney = dailyFinancesData.total;
      this.ecomAmount = dailyFinancesData.ecomAmount;
      this.currencyCode = dailyFinancesData.currency;
      this.finances = [];
      dailyFinancesData.facilities.forEach(function (dailFinancesJson) {
        this.push(new FinancesTileViewModel(dailFinancesJson));
      }, this.finances);
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').controller('dashboardFinancesController', dashboardFinancesController);

  /** @ngInject */
  function dashboardFinancesController ($timeout, $translate, reportExportUtil, exportToCsv, dailyFinancesActions, $scope, DashboardFinancesViewModel, broker, webSocketsStore, layoutActions) {
    var vm = this,
      _webSocketStoreConnectedChangeHandler = subscribeToSocket,
      _onFinancesChangedHandler = refreshFinances,
      _onDeviceDataChangeHandler = refreshDevice;

    vm.dashboard = null;
    vm.exportToCsv = exportCsv;

    init();

    function init () {
      layoutActions.showLoader();
      dailyFinancesActions.getData().then(function (data) {
        layoutActions.hideLoader();
        vm.dashboard = new DashboardFinancesViewModel(data);

        subscribeToSocket();
        webSocketsStore.on(webSocketsStore.events.CONNECTED_CHANGE, _webSocketStoreConnectedChangeHandler);
        webSocketsStore.on(webSocketsStore.events.DAILY_FINANCES_CHANGE, _onFinancesChangedHandler);
        webSocketsStore.on(webSocketsStore.events.DEVICE_STATE_CHANGE, _onDeviceDataChangeHandler);
      }, function () {
        //todo error handling
      });
      $scope.$on('$destroy', destroy);
    }

    function destroy () {
      if (vm.dashboard !== null) {
        vm.dashboard.destroy();
        webSocketsStore.off(webSocketsStore.events.CONNECTED_CHANGE, _webSocketStoreConnectedChangeHandler);
        webSocketsStore.off(webSocketsStore.events.DAILY_FINANCES_CHANGE, _onFinancesChangedHandler);
        webSocketsStore.off(webSocketsStore.events.DEVICE_STATE_CHANGE, _onDeviceDataChangeHandler);
      }
    }

    function subscribeToSocket () {
      if (webSocketsStore.isConnected()) {
        var deviceSerialArray = vm.dashboard.finances.map(function (financesViewModel) {
          return financesViewModel.deviceSerial;
        });
        broker.subscribeToDeviceChanges(deviceSerialArray);
        broker.subscribeToFinanceChanges(deviceSerialArray);
      }
    }

    function refreshFinances (newFinancesJson) {
      $timeout(function () {
        vm.dashboard.refreshTileFinances(newFinancesJson);
      }, 50);
    }

    function refreshDevice (newDeviceDataJson) {
      $timeout(function () {
        vm.dashboard.refreshTileDevice(newDeviceDataJson);
      }, 50);
    }

    function exportCsv (financesJson) {
      var exportData = [getObjectForExport(financesJson)];
      exportToCsv.export(exportData,
          $translate.instant('ASIDE_MENU_DASHBOARD_FINANCIAL'),
          true);
    }

    function getObjectForExport (financesJson) {
      return {
        facility: financesJson.chartData.facilityName,
        totalPayments: financesJson.totalPayments,
        tokensCount: financesJson.tokensCount,
        localTokensCount: financesJson.localTokensCount,
        cashPayments: financesJson.chartData.totalCashPayments,
        onlinePayments: financesJson.chartData.totalOnlinePayments,
        tokenPayments: financesJson.chartData.totalTokenPayments
      };
    }


  }
})();

(function () {
    'use strict';

    angular.module('sempraWebapp').factory('CreateUpdateUserGroupViewModel', CreateUpdateUserGroupViewModelFactory);

    /** @ngInject */
    function CreateUpdateUserGroupViewModelFactory(sempraUsersActions, $translate) {
        function CreateUpdateUserGroupViewModel(id) {
            this.title = '';
            this.isEditMode = id ? true : false;

            //group fields
            this.id = id;
            this.groupName = '';

            //search users related fields
            this.searchUserText = '';
            this.selectedUser = null;
            this.addUserEnabled = false;

            //search users by telephone related fields
            this.searchByTelephoneText = '';
            this.selectedUserByTelephone = null;
            this.addUserByTelephoneEnabled = false;

            //users grid fields
            this.groupUsers = [];
            this.usersPage = 1;
            this.usersTotal = 0;
            this.usersPageSize = 10;
            this.usersPageOptions = [5, 10, 15];
            this.usersOrderBy = 'user.firstName';
            this.usersOrder = 'asc';
            this.pagerTranslations = {
                page: $translate.instant('GRID_PAGER_PAGE'),
                rowsPerPage: $translate.instant('GRID_PAGER_ROWS_PER_PAGE'),
                of: $translate.instant('GRID_PAGER_PAGE_OF')
            };
            this.selectedGroupUsers = [];

            init.call(this);
        }

        CreateUpdateUserGroupViewModel.prototype.destroy = function () {
        };

        CreateUpdateUserGroupViewModel.prototype.setGroupId = function (id) {
            this.id = id;
            this.isEditMode = this.id ? true : false;
        };

        CreateUpdateUserGroupViewModel.prototype.refreshGroup = function (groupJson) {
            this.groupName = groupJson.name;
        };

        CreateUpdateUserGroupViewModel.prototype.refreshUsersForGroup = function (usersJson) {
            this.groupUsers = usersJson.content;
            this.usersTotal = usersJson.totalElements;
        };

        CreateUpdateUserGroupViewModel.prototype.removeUser = function (index) {
            this.groupUsers.splice(index, 1);
        };

        CreateUpdateUserGroupViewModel.prototype.searchUser = function () {
            if (this.searchUserText !== '') {
                return sempraUsersActions.searchSempraUsers(this.searchUserText);
            }
        };

        CreateUpdateUserGroupViewModel.prototype.onSearchUserSelected = function () {
            this.addUserEnabled = this.selectedUser ? true : false;
        };

        CreateUpdateUserGroupViewModel.prototype.searchSempraUsersByTelephone = function () {
            if (this.searchByTelephoneText !== '') {
                return sempraUsersActions.searchSempraUsersByTelephone(this.searchByTelephoneText);
            }
        };

        CreateUpdateUserGroupViewModel.prototype.onSearchUserByTelephoneSelected = function () {
            this.addUserByTelephoneEnabled = this.selectedUserByTelephone ? true : false;
        };

        CreateUpdateUserGroupViewModel.prototype.onUserAddedToGroup = function () {
            this.selectedUser = null;
            this.searchUserText = '';
            this.addUserEnabled = false;
        };

        CreateUpdateUserGroupViewModel.prototype.onUserByTelephoneAddedToGroup = function () {
            this.selectedUserByTelephone = null;
            this.searchByTelephoneText = '';
            this.addUserByTelephoneEnabled = false;
        };

        CreateUpdateUserGroupViewModel.prototype.onUsersPaginationChange = function (page, limit) {
            this.usersPage = page;
            this.usersPageSize = limit;
            this.onUsersOrderingChange(this.usersOrderBy);
        };

        CreateUpdateUserGroupViewModel.prototype.onUsersOrderingChange = function (order) {
            var orderQuery = getOrderObject(order);
            this.usersOrderBy = orderQuery.orderBy;
            this.usersOrder = orderQuery.order;
        };

        return CreateUpdateUserGroupViewModel;

        function init() {
            if (this.isEditMode) {
                this.title = $translate.instant('BREAD_CRUMBS_EDIT_USER_GROUP');
            } else {
                this.title = $translate.instant('BREAD_CRUMBS_NEW_USER_GROUP');
            }
        }

        function getOrderObject(order) {
            var result = {
                order: 'asc',
                orderBy: order
            };

            if (order.indexOf('-') > -1) {
                result.order = 'desc';
                result.orderBy = order.substring(1);
            }

            return result;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('sempraWebapp')
        .controller('createUpdateUserGroupController', createUpdateUserGroupController);

    /** @ngInject */
    function createUpdateUserGroupController(   $scope, dialogsService, $stateParams, userGroupActions, CreateUpdateUserGroupViewModel,
                                                $timeout, sempraUsersActions, hostProtocol, hostDomain, Upload, $mdDialog) {
        var vm = this;
        var newGroupId;

        vm.usersPromise = null;
        vm.searchUserValidation = false;

        vm.createUpdateGroup = function ($event) {
            vm.group.groupName = vm.group.groupName.trim();
            if (vm.group.groupName !== '') {
                vm.group.isEditMode
                    ? userGroupActions.updateUserGroup(vm.group.id, vm.group.groupName).then(onGroupSaveUpdateSuccess)
                    : userGroupActions.createUserGroup(vm.group.groupName).then(onGroupSaveUpdateSuccess);
            }
            var target = $event.target;
            target.blur();
        };

        vm.addUserToGroup = function (text) {
            $scope.searchUserForm.userName.$setUntouched();
            checkUser(text).then(function(val){
                if(val.length > 0) {
                    // check if user is already in that group
                    if(!checkIfUserIsInGroup(val[0].id)){
                        userGroupActions.addUserToUserGroup(vm.group.id, val[0].id).then(function () {
                            vm.group.onUserAddedToGroup();
                            refreshGroupUsers();
                        });
                    }else{
                        // show error msg
                        showSearchUserValidation();
                        hideSearchUserValidation();
                    }
                } else {
                    dialogsService.showOkDialog('MISSING_USER', 'USER_NOT_ON_LIST').then();
                }
            });

        };

        vm.uploadFile = function(file, errFiles) {
            /* eslint-disable */
            $scope.f = file;
            $scope.errFile = errFiles && errFiles[0];
            var id = ($stateParams.id) ? $stateParams.id : newGroupId;
            if (file) {
                file.upload = Upload.upload({
                    url: hostProtocol + '://' + hostDomain + '/api/userGroups/' + id,
                    data: {file: file}
                });

                file.upload.then(function (response) {
                    if(response.data.length > 0) {
                        vm.uknownUserList = unknownUser(response.data);
                    }
                    // Refresh user group ================================================
                    userGroupActions.getUserGroupById(id).then(function (groupJson) {
                        vm.group.refreshGroup(groupJson);
                    });
                    refreshGroupUsers();
                    // ===================================================================
                    $timeout(function () {
                        file.result = response.data;
                    });
                }, function (response) {
                    if (response.status > 0)
                        $scope.errorMsg = response.status + ': ' + response.data;
                }, function (evt) {
                    file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
                });
            }
            /* eslint-enable */
        }

        function unknownUser (list) {
            var data = [];
            var user = {};
            list.forEach(function(item, index){
                if(item.length > 0) {
                    user = {
                        id: index + 1,
                        email: item
                    }
                    data.push(user);
                }
            });
            return data;
        }

        function checkUser (text) {
            return sempraUsersActions.searchSempraUsers(text);
        }

        vm.addUserByTelephoneToGroup = function () {
            userGroupActions.addUserToUserGroup(vm.group.id, vm.group.selectedUserByTelephone.id).then(function () {
                vm.group.onUserByTelephoneAddedToGroup();
                refreshGroupUsers();
            });
        };

        vm.removeUserFromGroup = function (groupUser) {
            dialogsService.showConfirmDialog('DELETE_USER', 'DELETE_USER_FROM_USER_GROUP_QUESTION', 'OK').then(function () {
                userGroupActions.removeUserFromUserGroup(groupUser.id).then(function () {
                    refreshGroupUsers();
                });
            });
        };

        vm.onUsersPageChange = function (page, limit) {
            vm.group.onUsersPaginationChange(page, limit);
            refreshGroupUsers();
        };

        vm.onUsersOrderChange = function (order) {
            vm.group.onUsersOrderingChange(order);
            refreshGroupUsers();
        };

        init();

        function init() {
            vm.group = new CreateUpdateUserGroupViewModel($stateParams.id);

            if ($stateParams.id) {
                vm.group.setGroupId($stateParams.id);
                userGroupActions.getUserGroupById(vm.group.id).then(function (groupJson) {
                    vm.group.refreshGroup(groupJson);
                });
                refreshGroupUsers();
            }

            $scope.$on('$destroy', destroy);
        }

        function refreshGroupUsers () {
            vm.usersPromise = userGroupActions.getActiveUsersForUserGroup(vm.group.id,
                vm.group.usersPage - 1,
                vm.group.usersPageSize,
                vm.group.usersOrderBy,
                vm.group.usersOrder).then(function (usersJson) {
                    vm.group.refreshUsersForGroup(usersJson);
                });
        }

        function onGroupSaveUpdateSuccess(responseId) {
            newGroupId = responseId;
            if (!vm.group.isEditMode) {
                vm.id = responseId;
                vm.group.id = responseId;
                vm.group.isEditMode = true;
            }
        }

        function checkIfUserIsInGroup(userId){
            for(var i=0; i < vm.group.groupUsers.length; i++){
                if(vm.group.groupUsers[i].user.id === userId){
                    return true;
                }
            }
            return false;
        }

        function showSearchUserValidation(){
            vm.searchUserValidation = true;
        }

        function hideSearchUserValidation(){
            $timeout(function(){
                vm.searchUserValidation = false
            }, 3000);
        }

        function destroy() {
            vm.group.destroy();
        }

        //List of uknown users (after *.csv import)

        vm.showListOfUknownUsers = function(ev) {
            $mdDialog.show({
              controller : uknownListOfUsersController,
              controllerAs : 'vm',
              bindToController : true,
              templateUrl: 'app/createUpdateUserGroup/uknownUserListModal.html',
              /* eslint-disable */
              parent: angular.element(document.body),
              /* eslint-enable */
              targetEvent: ev,
              locals : {userList : vm.uknownUserList},
              clickOutsideToClose:true
            });
        };

        function uknownListOfUsersController($mdDialog){
            /* eslint-disable */
            var that = this;
            /* eslint-enable */
            that.closeDialog = function(){
                $mdDialog.hide();
            }

        }

    }
})();

(function () {
    "use strict";

    angular.module("sempraWebapp").factory("CreateUpdateCampaignViewModel", CreateUpdateCampaignViewModelFactory);

    /** @ngInject */
    function CreateUpdateCampaignViewModelFactory(
        $q,
        $translate,
        userGroupActions,
        localeFilters,
        campaignActions,
        CampaignTemplateEnum
    ) {
        function CreateUpdateCampaignViewModel(id) {
            this.id = id ? id : 0;
            this.dateFormat = localeFilters.defaultDateFormat;
            this.currentDate = new Date();
            this.from = new Date();
            this.to = new Date();
            this.title = "";
            this.isEditMode = this.id ? true : false;
            this.name = "";
            this.active = false;
            this.temporalRulePercentageValue;
            this.facilityTypes = [
                {
                    id: "WASH_BOXES",
                    name: $translate.instant("BRIDGE")
                },
                {
                    id: "SMALL_MACHINES",
                    name: $translate.instant("SMALL_MACHINES")
                }
            ];

            this.numberOfVisitsRule = null;
            this.amountOfMoneyRule = null;
            this.dailyTemporalRule = null;

            init.call(this);
        }

        CreateUpdateCampaignViewModel.prototype.destroy = function () { };

        CreateUpdateCampaignViewModel.prototype.onPeriodFromChanged = function () { };

        CreateUpdateCampaignViewModel.prototype.onPeriodToChanged = function () { };

        CreateUpdateCampaignViewModel.prototype.removeRule = function (ruleType) {
            switch (ruleType) {
                case CampaignTemplateEnum.NUM_OF_VISITS:
                    this.numberOfVisitsRule = null;
                    break;
                case CampaignTemplateEnum.MONEY_SPENT:
                    this.amountOfMoneyRule = null;
                    break;
                case CampaignTemplateEnum.DAILY_TEMPORAL:
                    this.dailyTemporalRule = null;
                    break;
            }
        };

        CreateUpdateCampaignViewModel.prototype.addNewByVisits = function () {
            this.numberOfVisitsRule = {
                id: 0,
                type: CampaignTemplateEnum.NUM_OF_VISITS,
                reward: {
                    code: "" //todo pull default code for company instead hardcode
                }
            };
        };

        CreateUpdateCampaignViewModel.prototype.addNewByMoneySpent = function () {
            this.amountOfMoneyRule = {
                id: 0,
                type: CampaignTemplateEnum.MONEY_SPENT,
                moneySpent: {
                    code: "" //todo pull default code for company instead hardcode
                },
                reward: {
                    code: "" //todo pull default code for company instead hardcode
                }
            };
        };

        CreateUpdateCampaignViewModel.prototype.addNewByDay = function () {
            this.dailyTemporalRule = {
                id: 0,
                days: [],
                daysOfWeek: getDaysOfWeekArray(),
                type: CampaignTemplateEnum.DAILY_TEMPORAL,
                reward: {
                    code: "" //todo pull default code for company instead hardcode
                }
            };
        };

        CreateUpdateCampaignViewModel.prototype.getDtoForPersistence = function () {
            var resultDto = {
                id: this.id,
                name: this.name,
                active: this.active,
                activeFrom: this.from.getTime(),
                activeTo: this.to.getTime(),
                // activeFrom: new DateTime(this.from).startOf(DateTime.units.DAY).timestamp,
                // activeTo: new DateTime(this.to).endOf(DateTime.units.DAY).timestamp,
                userGroupIds: this.groups
                    .filter(function (group) {
                        return group.selected && group.id !== -100;
                    })
                    .map(function (group) {
                        return group.id;
                    }),
                visitsRule: null,
                moneyRule: null,
                temporalRule: null
            };

            if (this.numberOfVisitsRule) {
                resultDto.visitsRule = {
                    id: this.numberOfVisitsRule.id,
                    visits: this.numberOfVisitsRule.visits,
                    reward: this.numberOfVisitsRule.reward,
                    validityPeriod: this.numberOfVisitsRule.validityPeriod
                };
            }

            if (this.amountOfMoneyRule) {
                resultDto.moneyRule = {
                    id: this.amountOfMoneyRule.id,
                    moneySpent: this.amountOfMoneyRule.moneySpent,
                    reward: this.amountOfMoneyRule.reward,
                    validityPeriod: this.amountOfMoneyRule.validityPeriod
                };
            }

            if (this.dailyTemporalRule) {
                this.checkToHourInterval(this.dailyTemporalRule);
                resultDto.temporalRule = {
                    id: this.dailyTemporalRule.id,
                    hoursFrom: this.dailyTemporalRule.hoursFrom,
                    minutesFrom: this.dailyTemporalRule.minutesFrom,
                    hoursTo: this.dailyTemporalRule.hoursTo,
                    minutesTo: this.dailyTemporalRule.minutesTo,
                    reward: this.dailyTemporalRule.reward,
                    deviceType: this.selectedFacilityType,
                    days: this.dailyTemporalRule.daysOfWeek
                        .filter(function (dayOfWeek) {
                            return dayOfWeek.selected;
                        })
                        .map(function (dayOfWeek) {
                            return dayOfWeek.value;
                        })
                };
            }

            return resultDto;
        };

      CreateUpdateCampaignViewModel.prototype.checkToHourInterval = function(rule) {
        if(rule.hoursTo === 0) {
          rule.minutesTo = 59;
          rule.hoursTo = 23;
        }
      };

        CreateUpdateCampaignViewModel.prototype.onSelectGroupChanged = function (group) {
            if (group.id === -100) {
                this.groups[0].selected = true;
                this.groups.forEach(function (group, index) {
                    if (index > 0) {
                        group.selected = false;
                    }
                });
            } else {
                var selectedGroups = this.groups.filter(function (group) {
                    return group.selected === true;
                });
                this.groups[0].selected = selectedGroups.length === 0;
            }
        };

        CreateUpdateCampaignViewModel.prototype.onSelectTemporalDeviceType = function (temporalDeviceType) {
            var that = this;
            userGroupActions.getTemporalRulePercentage(temporalDeviceType).then(function (res) {
                that.temporalRulePercentageValue = res;
            });
        };

        return CreateUpdateCampaignViewModel;

        function init() {
            var that = this;

            $q.all([userGroupActions.getUserGroups()]).then(function (resultArray) {
                var groupsJson = resultArray[0];

                refreshGroups.call(that, groupsJson);

                if (that.isEditMode) {
                    that.title = $translate.instant("BREAD_CRUMBS_EDIT_CAMPAIGN");
                    refreshForExisting.call(that);
                } else {
                    that.title = $translate.instant("BREAD_CRUMBS_NEW_CAMPAIGN");
                    that.groups[0].selected = true;
                    that.rules = [];
                    // that.addNewByDay();
                    // that.addNewByMoneySpent();
                    // that.addNewByVisits();
                }
            });
        }

        function refreshGroups(groupsJson) {
            var that = this;
            this.groups = [];
            this.groups.push({
                id: -100,
                name: $translate.instant("ALL_USERS"),
                selected: false
            });

            groupsJson.forEach(function (group) {
                group.selected = false;
                that.groups.push(group);
            });
        }

        function refreshForExisting() {
            var that = this;

            campaignActions.getCampaignById(this.id).then(function (campaignJson) {
                that.name = campaignJson.name;
                that.from = new Date(campaignJson.from);
                that.to = new Date(campaignJson.to);
                that.active = campaignJson.active;
                that.isEditMode = campaignJson.active; //new DateTime().timestamp < campaignJson.toTimestamp && new DateTime().timestamp > campaignJson.fromTimestamp;

                if (campaignJson.userGroupIds.length === 0) {
                    that.groups[0].selected = true;
                } else {
                    that.groups.forEach(function (group) {
                        group.selected = campaignJson.userGroupIds.indexOf(group.id) > -1;
                    });
                }

                that.numberOfVisitsRule = campaignJson.visitsRule ? campaignJson.visitsRule : null;
                if (that.numberOfVisitsRule) {
                    that.numberOfVisitsRule.type = CampaignTemplateEnum.NUM_OF_VISITS;
                }

                that.amountOfMoneyRule = campaignJson.moneyRule ? campaignJson.moneyRule : null;
                if (that.amountOfMoneyRule) {
                    that.amountOfMoneyRule.type = CampaignTemplateEnum.MONEY_SPENT;
                }

                that.dailyTemporalRule = campaignJson.temporalRule ? campaignJson.temporalRule : null;
                if (that.dailyTemporalRule) {
                    that.dailyTemporalRule.type = CampaignTemplateEnum.DAILY_TEMPORAL;
                    that.dailyTemporalRule.daysOfWeek = getDaysOfWeekArrayEditMode();
                    campaignJson.temporalRule.days.forEach(function (dayIndex) {
                        this[dayIndex].selected = true;
                    }, that.dailyTemporalRule.daysOfWeek);
                }
                if (campaignJson.temporalRule) {
                    that.selectedFacilityType = campaignJson.temporalRule.deviceType;
                    that.onSelectTemporalDeviceType(campaignJson.temporalRule.deviceType);
                }
            });
        }

        function getDaysOfWeekArray() {
            var daysOfWeek = [];
            for (var i = 0; i < 7; i++) {
                var j = i === 0 ? 6 : i - 1;
                daysOfWeek.push({
                    value: j,
                    name: localeFilters.getDayLocale(i, true),
                    selected: false
                });
            }
            return daysOfWeek;
        }

        function getDaysOfWeekArrayEditMode() {
            var daysOfWeek = [];
            for (var i = 0; i < 7; i++) {
                var j = i === 6 ? 0 : i + 1;
                daysOfWeek.push({
                    value: i,
                    name: localeFilters.getDayLocale(j, true),
                    selected: false
                });
            }
            return daysOfWeek;
        }

    }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller(
      "createUpdateCampaignController",
      createUpdateCampaignController
    );

  /** @ngInject */
  function createUpdateCampaignController(
    $scope,
    $state,
    $stateParams,
    campaignActions,
    dialogsService,
    CreateUpdateCampaignViewModel,
    brand
  ) {
    var vm = this;
    vm.isEditMode = false;
    vm.brand = brand;

    vm.saveChanges = function() {
      vm.isEditMode
        ? campaignActions
            .updateCampaign(vm.campaign.getDtoForPersistence())
            .then(onSaveUpdateSuccess)
        : campaignActions
            .createCampaign(vm.campaign.getDtoForPersistence())
            .then(onSaveUpdateSuccess);
    };

    vm.cancelChanges = function() {
      $state.go("app.loyalty");
    };

    vm.removeCampaignRule = function(ruleType) {
      dialogsService
        .showConfirmDialog(
          "REMOVE_CAMPAIGN_RULE_TITLE",
          "REMOVE_CAMPAIGN_RULE_CONFIRMATION",
          "OK"
        )
        .then(function() {
          vm.campaign.selectedFacilityType = null;
          vm.campaign.removeRule(ruleType);
        });
    };

    vm.changeFacility = function(facility) {
      vm.campaign.onSelectTemporalDeviceType(facility);
    };

    vm.checktemporalRule = function(value) {
      value % vm.campaign.temporalRulePercentageValue === 0
        ? $scope.campaignForm.daysCreditValue.$setValidity(
            "validationError",
            true
          )
        : $scope.campaignForm.daysCreditValue.$setValidity(
            "validationError",
            false
          );
    };

    init();

    function init() {
      if ($stateParams.id) {
        vm.isEditMode = true;
        vm.id = $stateParams.id;
        vm.facilityType = $stateParams.facilityType;
      }
      vm.campaign = new CreateUpdateCampaignViewModel(vm.id);
      $scope.$watch(function() {
        vm.checkIfDayIsSelected = true;
        if (vm.campaign.dailyTemporalRule) {
          vm.campaign.dailyTemporalRule.daysOfWeek.filter(function(item) {
            if (item.selected) {
              vm.checkIfDayIsSelected = false;
            }
          });
        } else if (vm.campaign.numberOfVisitsRule || vm.campaign.amountOfMoneyRule) {
          vm.checkIfDayIsSelected = false;
        }
      });
      $scope.$on("$destroy", destroy);
    }

    function destroy() {
      vm.campaign.destroy();
    }

    function onSaveUpdateSuccess() {
      $state.go("app.loyalty");
    }
  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('CreateUpdateCampaignTemplateViewModel', CreateUpdateCampaignTemplateViewModelFactory);

  /** @ngInject */
  function CreateUpdateCampaignTemplateViewModelFactory($translate, localeFilters, campaignTemplateActions, CampaignTemplateEnum) {
    function CreateUpdateCampaignTemplateViewModel(id) {
      this.id = id ? id : 0;
      this.title = '';
      this.isEditMode = this.id ? true : false;

      init.call(this);
    }

    CreateUpdateCampaignTemplateViewModel.prototype.destroy = function () {
    };

    CreateUpdateCampaignTemplateViewModel.prototype.removeRule = function (index) {
      this.rules.splice(index, 1);
    };

    CreateUpdateCampaignTemplateViewModel.prototype.addNewByVisits = function () {
      var newRule = {
        id: 0,
        type: CampaignTemplateEnum.NUM_OF_VISITS
      };

      this.rules.splice(0, 0, newRule);
    };

    CreateUpdateCampaignTemplateViewModel.prototype.addNewByMoneySpent = function () {
      var newRule = {
        id: 0,
        type: CampaignTemplateEnum.MONEY_SPENT
      };

      this.rules.splice(0, 0, newRule);
    };

    CreateUpdateCampaignTemplateViewModel.prototype.addNewByDay = function () {
      var newRule = {
        id: 0,
        days: [],
        daysOfWeek: getDaysOfWeekArray(),
        type: CampaignTemplateEnum.DAILY_TEMPORAL
      };

      this.rules.splice(0, 0, newRule);
    };

    CreateUpdateCampaignTemplateViewModel.prototype.getDtoForPersistence = function () {
      var dtoResult = {
        id: this.id,
        name: this.name,
        numberOfVisits: [],
        amountOfMoney: [],
        dailyTemporal: []
      };

      this.rules.forEach(function (rule) {
        if (rule.type === CampaignTemplateEnum.NUM_OF_VISITS) {
          this.numberOfVisits.push({
            id: rule.id,
            visits: rule.visits,
            credits: rule.credits,
            validityPeriod: rule.validityPeriod
          });
        } else if (rule.type === CampaignTemplateEnum.MONEY_SPENT) {
          this.amountOfMoney.push({
            id: rule.id,
            money: rule.money,
            credits: rule.credits,
            validityPeriod: rule.validityPeriod
          });
        } else if (rule.type === CampaignTemplateEnum.DAILY_TEMPORAL) {
          this.dailyTemporal.push({
            id: rule.id,
            hoursFrom: rule.hoursFrom,
            minutesFrom: rule.minutesFrom,
            hoursTo: rule.hoursTo,
            minutesTo: rule.minutesTo,
            credits: rule.credits,
            days: rule.daysOfWeek.filter(function (dayOfWeek) {
              return dayOfWeek.selected;
            }).map(function (dayOfWeek) {
              return dayOfWeek.value;
            })
          });
        }
      }, dtoResult);

      return dtoResult;
    };

    return CreateUpdateCampaignTemplateViewModel;

    function init() {
      if (this.isEditMode) {
        this.title = $translate.instant('BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE');
        refreshForExisting.call(this);
      } else {
        this.title = $translate.instant('BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE');
        this.rules = [];
        this.addNewByDay();
        this.addNewByMoneySpent();
        this.addNewByVisits();
      }
    }

    function refreshForExisting() {
      var that = this;

      this.rules = [];

      campaignTemplateActions.getCampaignTemplateById(this.id).then(function (templateJson) {
        that.name = templateJson.name;

        templateJson.numberOfVisits.forEach(function (rule) {
          rule.type = CampaignTemplateEnum.NUM_OF_VISITS;
          this.push(rule);
        }, that.rules);

        templateJson.amountOfMoney.forEach(function (rule) {
          rule.type = CampaignTemplateEnum.MONEY_SPENT;
          this.push(rule);
        }, that.rules);

        templateJson.dailyTemporal.forEach(function (rule) {
          rule.type = CampaignTemplateEnum.DAILY_TEMPORAL;
          rule.daysOfWeek = getDaysOfWeekArray();
          rule.days.forEach(function (dayIndex) {
            this[dayIndex].selected = true;
          }, rule.daysOfWeek);
          this.push(rule);
        }, that.rules);
      });
    }

    function getDaysOfWeekArray() {
      var daysOfWeek = [];
      for (var i = 0; i < 7; i++) {
        daysOfWeek.push({
          value: i,
          name: localeFilters.getDayLocale(i, true),
          selected: false
        });
      }
      return daysOfWeek;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('createUpdateCampaignTemplateController', createUpdateCampaignTemplateController);

  /** @ngInject */
  function createUpdateCampaignTemplateController($scope, $state, $stateParams, campaignTemplateActions, CreateUpdateCampaignTemplateViewModel) {
    var vm = this;
    vm.isEditMode = false;

    vm.saveChanges = function () {
      vm.isEditMode
        ? campaignTemplateActions.updateCampaignTemplate(vm.template.getDtoForPersistence()).then(onSaveUpdateSuccess)
        : campaignTemplateActions.createCampaignTemplate(vm.template.getDtoForPersistence()).then(onSaveUpdateSuccess);
    };

    vm.cancelChanges = function () {
      $state.go('app.loyalty');
    };

    init();

    function init() {
      if ($stateParams.id) {
        vm.isEditMode = true;
        vm.id = $stateParams.id;
      }
      vm.template = new CreateUpdateCampaignTemplateViewModel(vm.id);
      $scope.$on('$destroy', destroy);
    }

    function destroy() {
      vm.template.destroy();
    }

    function onSaveUpdateSuccess () {
      $state.go('app.loyalty');
    }

  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory(
      "CashlessPaymentRefundViewModel",
      cashlessPaymentRefundViewModelFactory
    );

  /** @ngInject */
  function cashlessPaymentRefundViewModelFactory($translate, DateTime) {
    function CashlessPaymentRefundViewModel() {
      this.cashlessPaymentAndRefundList = [];
      this.filter = "";
      this.since = 0;
      this.until = 0;

      // GRID CONFIG
      this.orderBy = "timestamp";
      this.order = "desc";
      this.page = 1;
      this.total = 0;
      this.pageSize = 20;
      this.pageOptions = [5, 10, 20, 50];
      this.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };

      this.since = new Date(
          new DateTime().startOf(DateTime.units.MONTH).timestamp
      );
      this.until = new Date(
          new DateTime().endOf(DateTime.units.DAY).timestamp
      );
      this.totalAmount = 0;
      this.totalNetAmount = 0;
    }

    CashlessPaymentRefundViewModel.prototype.destroy = function () {};

    CashlessPaymentRefundViewModel.prototype.cashlessPaginationChanged = function(page, limit) {
      this.page = page;
      this.pageSize = limit;
    };

    CashlessPaymentRefundViewModel.prototype.cashlessOrderingChanged = function(order) {
      var orderQuery = getOrderObject(order);
      this.orderBy = orderQuery.orderBy;
      this.order = orderQuery.order;
    };

    CashlessPaymentRefundViewModel.prototype.refresh = function (data) {
      this.cashlessPaymentAndRefundList = [];
      if (data.content.length === 0) {
        this.cashlessPaymentAndRefundList.push({
          user: $translate.instant("NOTHING_TO_DISPLAY"),
          hideButton: true
        });
        return;
      }
      this.cashlessPaymentAndRefundList = data.content;
      this.total = data.totalElements;
    };

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    return CashlessPaymentRefundViewModel;
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller(
      'CashlessPaymentRefundController',
      cashlessPaymentRefundController
    );

  /** @ngInject */
  function cashlessPaymentRefundController(
    layoutActions,
    $scope,
    CashlessPaymentRefundViewModel,
    cashlessActions,
    $mdDialog,
    $translate,
    dispatcher,
    ActionTypesEnum
  ) {
    var vm = this;
    vm.cashlessPaymentRefundVM = new CashlessPaymentRefundViewModel();

    init();

    vm.pageChanged = function (page, limit) {
      vm.cashlessPaymentRefundVM.cashlessPaginationChanged(page, limit);
      refresh();
    };

    vm.sortChanged = function (order) {
      vm.cashlessPaymentRefundVM.cashlessOrderingChanged(order);
      refresh();
    };

    vm.searchCashlessPayments = function () {
      refresh();
    };

    vm.clearCashlessFilterInput = function () {
      vm.cashlessPaymentRefundVM.filter = '';
      refresh();
    };

    vm.refundPayment = function (ev, amount, paymentId) {
      var confirm = $mdDialog
        .prompt()
        .title($translate.instant('REFUND_DIALOG_TITLE'))
        .textContent($translate.instant('REFUND_DIALOG_SUBTITLE'))
        .placeholder($translate.instant('REFUND'))
        .ariaLabel($translate.instant('REFUND'))
        .initialValue(amount)
        .targetEvent(ev)
        .ok($translate.instant('REFUND'))
        .cancel($translate.instant('CANCEL'));

      $mdDialog.show(confirm).then(function (result) {
        if (result > amount || result < 0 || isNaN(result)) {
          dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type: ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message: $translate.instant('INPUT_NOT_VALID')
            }
          });
          return;
        }
        cashlessActions
          .refundCashlessPayment(paymentId, result)
          .then(function () {
            refresh();
          });
      });
    };

    vm.exportToCsvReports = function () {
      layoutActions.showLoader();
      cashlessActions
        .getCashlessSalesExportCSV(
          vm.cashlessPaymentRefundVM.filter,
          vm.cashlessPaymentRefundVM.since.getTime(),
          vm.cashlessPaymentRefundVM.until.getTime()
        )
        .then(function (response) {
          var blob = new Blob([response], { type: 'text/csv;charset=utf-8;' });

          var url = URL.createObjectURL(blob);
          /* eslint-disable */
          var link = document.createElement('a');
          /* eslint-enable */
          link.href = url;
          link.download = 'Cashless_sales_report.csv';
          link.click();

          URL.revokeObjectURL(url);
          layoutActions.hideLoader();
        });
    };

    function refresh() {
      layoutActions.showLoader();
      cashlessActions
        .getCashlessSales(
          vm.cashlessPaymentRefundVM.filter,
          vm.cashlessPaymentRefundVM.since.getTime(),
          vm.cashlessPaymentRefundVM.until.getTime(),
          vm.cashlessPaymentRefundVM.page - 1,
          vm.cashlessPaymentRefundVM.pageSize,
          vm.cashlessPaymentRefundVM.orderBy,
          vm.cashlessPaymentRefundVM.order
        )
        .then(function (response) {
          cashlessActions
            .getCashlessTotals(
              vm.cashlessPaymentRefundVM.since.getTime(),
              vm.cashlessPaymentRefundVM.until.getTime(),
              vm.cashlessPaymentRefundVM.filter
            )
            .then(function (response) {
              vm.cashlessPaymentRefundVM.totalAmount = response.totalAmount;
              vm.cashlessPaymentRefundVM.totalNetAmount = response.totalNetAmount;
            });
          vm.cashlessPaymentRefundVM.refresh(response);
          layoutActions.hideLoader();
        });
    }

    function init() {
      $scope.$on('$destroy', destroy);
      refresh();
    }

    function destroy() {
      vm.cashlessPaymentRefundVM.destroy();
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("AlarmsViewModel", alarmsViewModelFactory);

  /** @ngInject */
  function alarmsViewModelFactory(
    gridUtils,
    DateTime,
    facilityUtils,
    $translate
  ) {
    function AlarmsViewModel() {
      this.facilities = [];
      this.selectedFacilitySerial = "-1";
      this.paginationNumber = 0;
      this.activeAlarmsList = [];

      // GRID CONFIG
      this.alarmsData = [];
      this.alarmsOrderBy = "-timestamp";
      this.alarmsOrder = "desc";
      this.alarmsPage = 1;
      this.alarmsTotal = 0;
      this.alarmsPageSize = 10;
      this.alarmsPageOptions = [10];
      // this.selected = [];
      this.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };

      this.alarmsFrom = new Date(
        new DateTime().startOf(DateTime.units.MONTH).timestamp
      );
      this.alarmsTo = new Date(
        new DateTime().endOf(DateTime.units.DAY).timestamp
      );

      init.call(this);
    }

    AlarmsViewModel.prototype.destroy = function() {};

    AlarmsViewModel.prototype.alarmsFilterChanged = function() {
      //event handler hook
    };

    AlarmsViewModel.prototype.alarmsPaginationChanged = function(page, limit) {
      this.alarmsPage = page;
      this.alarmsPageSize = limit;
      this.alarmsFilterChanged();
    };

    AlarmsViewModel.prototype.alarmsOrderingChanged = function(order) {
      var orderQuery = getOrderObject(order);
      this.alarmsOrderBy = orderQuery.orderBy;
      this.alarmsOrder = orderQuery.order;
    };

    AlarmsViewModel.prototype.refreshMessages = function(messagesArrayJson) {
      this.alarmsData = messagesArrayJson.content;
      this.paginationNumber = messagesArrayJson.number;
      this.alarmsTotal = messagesArrayJson.totalElements;
    };

    AlarmsViewModel.prototype.refreshFacilities = function(devicesJson) {
      this.facilities = [];

      this.facilities.push({
        id: -1,
        name: "ALL_FACILITIES",
        deviceSerial: "-1"
      });

      devicesJson.forEach(function(deviceJson) {
        this.push({
          id: facilityUtils.getFacilityPoint(deviceJson).id,
          name: facilityUtils.getFacilityPoint(deviceJson).name,
          deviceSerial: deviceJson.deviceKey
        });
      }, this.facilities);
    };

    // helper function
    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    return AlarmsViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.pagerLabel = gridSettings.translations;
    }
  }
})();

(function() {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("AlarmsController", AlarmsController);

  /** @ngInject */
  function AlarmsController(
    $scope,
    messageActions,
    deviceActions,
    AlarmsViewModel,
    brand
  ) {
    var vm = this;

    vm.messagesPromise = null;
    vm.messages = new AlarmsViewModel();
    vm.getAllMessages = refresh;
    vm.brand = brand;

    // Convert time (time zone offset)
    // var offset = vm.messages.alarmsFrom.getTimezoneOffset() * (-60000);

    vm.pageChanged = function(page, limit) {
      vm.messages.alarmsPaginationChanged(page, limit);
      refresh();
    };

    vm.sortChanged = function(order) {
      vm.messages.alarmsOrderingChanged(order);
      refresh();
    };

    vm.itemNumbering = function(item) {
      if (vm.messages.alarmsPage === 1) {
        return item + 1;
      } else if (vm.messages.alarmsPage === 2) {
        return item + 11;
      } else {
        return (vm.messages.alarmsPage - 1) * 10 + (item + 1);
      }
    };

    vm.searchMessages = function() {
      vm.messages.alarmsPage = 1;
      refresh();
    };

    init();

    function init() {
      $scope.$on("destroy", function() {
        if (vm.messages !== null) {
          vm.messages.destroy();
        }
      });

      vm.messages.onMessagesFilterChanged = refresh;

      deviceActions.getAllDevices().then(function(devicesData) {
        vm.messages.refreshFacilities(devicesData);
        refresh();
      });

      refreshActiveAlarms();
    }

    function refresh() {
      var deviceSerial =
        vm.messages.selectedFacilitySerial !== "-1"
          ? vm.messages.selectedFacilitySerial
          : null;

      vm.promise = messageActions
        .getAllMessages(
          deviceSerial,
          vm.messages.alarmsFrom.getTime(),
          vm.messages.alarmsTo.getTime(),
          vm.messages.alarmsPage - 1,
          vm.messages.alarmsPageSize,
          vm.messages.alarmsOrderBy,
          vm.messages.alarmsOrder
        )
        .then(
          function(messagesData) {
            vm.messages.refreshMessages(messagesData);
          },
          function() {
            //todo error handling
          }
        );
    }

    function refreshActiveAlarms() {
      messageActions.getAlarmMessages().then(function(alarmList) {
        vm.messages.activeAlarmsList = alarmList;
      });
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("KarcherAlarmsViewModel", karcherAlarmsViewModelFactory);

  /** @ngInject */
  function karcherAlarmsViewModelFactory(
    gridUtils,
    DateTime,
    facilityUtils,
    $translate
  ) {
    function KarcherAlarmsViewModel() {
      this.paginationNumber = 0;
      this.activeAlarmsList = [];
      this.alarmsFrom = null;
      this.alarmsTo = null;
      this.siteList = [];
      this.selectedSite = "";
      this.filterBy = "";
      this.faultStatus = "";
      this.hideUnnecessary = true;
      this.placeHolderText = $translate.instant("SITE_NAME");
      this.noDataToDisplay = false;
      this.faultStatusList = [
        {
          name: "ALL",
          value: ""
        },
        {
          name: "INFO",
          value: "INFO"
        },
        {
          name: "WARNING",
          value: "WARNING"
        },
        {
          name: "ALARM",
          value: "ALARM"
        }
      ];

      // GRID CONFIG
      this.alarmsData = [];
      this.alarmsOrderBy = "timestamp";
      this.alarmsOrder = "desc";
      this.alarmsPage = 1;
      this.alarmsTotal = 0;
      this.alarmsPageSize = 10;
      this.alarmsPageOptions = [5, 10, 15];
      this.pagerTranslations = {
        page: $translate.instant("GRID_PAGER_PAGE"),
        rowsPerPage: $translate.instant("GRID_PAGER_ROWS_PER_PAGE"),
        of: $translate.instant("GRID_PAGER_PAGE_OF")
      };

      this.alarmsFrom = new Date(
        new DateTime().startOf(DateTime.units.MONTH).timestamp
      );
      this.alarmsTo = new Date(
        new DateTime().endOf(DateTime.units.DAY).timestamp
      );

      init.call(this);
    }

    KarcherAlarmsViewModel.prototype.destroy = function () {};

    KarcherAlarmsViewModel.prototype.alarmsPaginationChanged = function (
      page,
      limit
    ) {
      this.alarmsPage = page;
      this.alarmsPageSize = limit;
    };

    KarcherAlarmsViewModel.prototype.alarmsOrderingChanged = function (order) {
      var orderQuery = getOrderObject(order);
      this.alarmsOrderBy = orderQuery.orderBy;
      this.alarmsOrder = orderQuery.order;
    };

    KarcherAlarmsViewModel.prototype.refreshMessages = function (data) {
      this.noDataToDisplay = data.content.length === 0;
      if (data.content.length === 0) {
        this.hideUnnecessary = false;
        this.alarmsData = [];
        this.alarmsData.push({
          timestamp: $translate.instant("NOTHING_TO_DISPLAY")
        });
      } else {
        this.hideUnnecessary = true;
        this.alarmsData = this.setStateIcon(data.content);
      }
      this.alarmsTotal = data.totalElements;
    };

    KarcherAlarmsViewModel.prototype.refreshSiteList = function (data) {
      this.siteList = data;
    };

    KarcherAlarmsViewModel.prototype.setStateIcon = function (data) {
      data.forEach(function (item) {
        switch (item.karcherFault.washFacilityStatus) {
          case "INFO":
            item.icon = "assets/icons/ic_low_alarm.svg";
            break;
          case "WARNING":
            item.icon = "assets/icons/ic_medium_alarm.svg";
            break;
          case "ALARM":
            item.icon = "assets/icons/ic_high_alarm.svg";
            break;
          default:
            item.icon = "assets/icons/ic_low_alarm.svg";
            break;
        }
      });
      return data;
    };

    function getOrderObject(order) {
      var result = {
        order: "asc",
        orderBy: order
      };

      if (order.indexOf("-") > -1) {
        result.order = "desc";
        result.orderBy = order.substring(1);
      }
      return result;
    }

    return KarcherAlarmsViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.pagerLabel = gridSettings.translations;
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .controller("KarcherAlarmsController", KarcherAlarmsController);

  /** @ngInject */
  function KarcherAlarmsController(
    $scope,
    KarcherAlarmsViewModel,
    dashboardKarcherActions,
    organizationActions,
    layoutActions,
    $timeout,
    $state,
    exportToCsv,
    $translate,
    fromArrayToPathParam,
    alarmsStore
  ) {
    var vm = this;
    var facilityId = "";

    vm.exportToCsvSiteList = exportCsv;
    vm.alarmMessages = new KarcherAlarmsViewModel();
    vm.alarmPageTitle = $translate.instant("ALERT_CENTER_TITLE_BY_DEFAULT");

    vm.pageChanged = function (page, limit) {
      vm.alarmMessages.alarmsPaginationChanged(page, limit);
      refresh();
    };

    vm.sortChanged = function (order) {
      vm.alarmMessages.alarmsOrderingChanged(order);
      refresh();
    };

    vm.searchMessages = function (siteIds) {
      layoutActions.showLoader();
      facilityId = "";
      vm.alarmPageTitle = $translate.instant("ALERT_CENTER_TITLE_BY_DEFAULT");
      vm.alarmMessages.alarmsPage = 1;
      if (siteIds !== undefined && siteIds !== null) {
        vm.alarmMessages.selectedSite = siteIds;
      }
      refresh();
    };

    vm.subscriptions = function () {
      $state.go("app.alarms.subscriptions");
    };

    vm.clearSiteInput = function () {
      vm.alarmMessages.selectedSite = "";
      refresh();
    };

    init();

    function init() {
      layoutActions.showLoader();
      $scope.$on("$destroy", destroy);
      organizationActions.getAllSitesForExactUser().then(function (res) {
        vm.alarmMessages.refreshSiteList(res);
        if (alarmsStore.getAlarmsParams()) {
          vm.alarmPageTitle = $translate.instant("ALERT_CENTER_TITLE_BY_DEFAULT");
          vm.alarmPageTitle = setReportTitle(
            alarmsStore.getAlarmsParams()
          );
          vm.alarmMessages.selectedSite = alarmsStore.getAlarmsParams().site;
          facilityId = alarmsStore.getAlarmsParams().facility;
          vm.alarmMessages.alarmsFrom = new Date(
            alarmsStore.getAlarmsParams().from
          );
          vm.alarmMessages.faultStatus =
            alarmsStore.getAlarmsParams().faultStatus;
        }
        refresh();
      });
    }

    function exportCsv() {
      var exportData = prepareDataForCsvDownload(vm.alarmMessages.alarmsData);
      exportToCsv.export(exportData, $translate.instant("ALERTS"), true);
    }

    function setReportTitle(type) {
      switch (true) {
        case type.site !== "":
          return $translate.instant("ALERT_CENTER_TITLE_BY_SITE");
        case type.facility !== "":
          return $translate.instant("ALERT_CENTER_TITLE_BY_FACILITY");
        default:
          return $translate.instant("ALERT_CENTER_TITLE_BY_DEFAULT");
      }
    }

    function prepareDataForCsvDownload(data) {
      var tempArray = [];
      data.forEach(function (item) {
        tempArray.push({
          Code: item.karcherFault.number,
          Date: item.timestamp,
          Company_name: item.companyName,
          Facility_name: item.washFacilityName,
          Alert_name: item.karcherFault.name,
          Alert_description: item.karcherFault.description,
          Type: item.karcherFault.washFacilityStatus,
          Status: item.status
            ? $translate.instant("RESOLVED_STATUS")
            : $translate.instant("NOT_RESOLVED_STATUS")
        });
      });
      return tempArray;
    }

    function refresh() {
      dashboardKarcherActions
        .getKarcherSiteAlarmList(
          vm.alarmMessages.filterBy,
          vm.alarmMessages.faultStatus,
          facilityId,
          fromArrayToPathParam.createPath(
            vm.alarmMessages.selectedSite,
            "sitePointId="
          ),
          vm.alarmMessages.alarmsFrom.getTime(),
          vm.alarmMessages.alarmsTo.getTime(),
          vm.alarmMessages.alarmsPage - 1,
          vm.alarmMessages.alarmsPageSize,
          vm.alarmMessages.alarmsOrderBy,
          vm.alarmMessages.alarmsOrder
        )
        .then(function (response) {
          vm.alarmMessages.refreshMessages(response);
          layoutActions.hideLoader();
        });
    }

    function destroy() {
      alarmsStore.deleteStore();
    }
  }
})();

(function () {
  "use strict";

  angular
    .module("sempraWebapp")
    .factory("AccountManagementViewModel", accountManagementViewModelFactory);

  /** @ngInject */
  function accountManagementViewModelFactory(
    gridUtils,
    $mdMedia,
    userRolesEnum,
    sessionData
  ) {
    function AccountManagementViewModel() {
      this.currentUser = sessionData.getValue('username');
      this.data = [];
      this.totalElements = 0;
      this.groups = [];
      this.limitPerPage = 10;
      this.selected = [];
      this.userData = {};
      this.selectedRole = "";
      this.updateEnabled = false;
      this.promise = null;
      this.pagerLabel = {};
      this.myUsername = sessionData.getValue("username"); // for delete validation ( user cannot delete himself)
      this.myId = sessionData.getValue("userId"); // for updating user role (=adminId)
      this.userRoles = [
        userRolesEnum.CONSUMER,
        userRolesEnum.SYSTEM_ADMIN,
        userRolesEnum.MERCHANT_ADMIN,
        userRolesEnum.COMPANY_ADMIN,
        userRolesEnum.FACILITY_ADMIN
      ]; // get all user roles from userRolesEnum
      this.filterUsers = "";

      // Grid data
      this.pageOptions = [5, 10, 15];
      this.orderBy = "";
      this.order = "";

      // add new user model
      this.email = "";
      this.firstName = "";
      this.lastName = "";
      this.verified = false;

      init.call(this);
    }

    AccountManagementViewModel.prototype.destroy = function () {};

    AccountManagementViewModel.prototype.refresh = function (usersDataJson) {
      this.data = usersDataJson;
      this.totalElements = usersDataJson.totalElements;
    };

    AccountManagementViewModel.prototype.paginationChanged = function (
      page,
      limit
    ) {
      this.currentPage = page;
      this.limitPerPage = limit;
    };

    return AccountManagementViewModel;

    function init() {
      var gridSettings = gridUtils.getDefaultGridSettings();
      this.limitPerPage = gridSettings.limitPerPage;
      this.currentPage = gridSettings.page;

      // hide label on small screens (tested on iphone6) because table pagination isnt responsive
      if ($mdMedia("sm") || $mdMedia("xs")) {
        this.pagerLabel = {
          page: "",
          rowsPerPage: "",
          of: ""
        };
      } else {
        this.pagerLabel = gridSettings.translations;
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('AccountManagementController', AccountManagementController);

  /** @ngInject */
  function AccountManagementController(
    $scope,
    AccountManagementViewModel,
    userActions,
    $mdDialog,
    $translate,
    $state,
    $timeout,
    isValidUser,
    reportActions
  ) {
    var vm = this;
    var counter = 0;
    var companyId = null;

    vm.accountManagement = new AccountManagementViewModel();

    init();

    function init() {
      // If not valid user redirect to home page
      if (!isValidUser) {
        $state.go('app.dashboardTechnology');
      }
      $scope.$on('destroy', function () {});
      refreshUsers();
    }

    function refreshUsers() {
      vm.promise = userActions
        .getOrganizationUsers(
          vm.accountManagement.filterUsers,
          vm.accountManagement.currentPage - 1,
          vm.accountManagement.limitPerPage,
          vm.accountManagement.orderBy,
          vm.accountManagement.order
        )
        .then(function (data) {
          vm.accountManagement.refresh(data);
        });
    }

    vm.deleteUser = function (ev, userId, organizationId, email) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant('ARE_YOU_SURE'))
        .textContent(
          $translate.instant('ALL_INFORMATION_1') +
            ' ' +
            email +
            ' ' +
            $translate.instant('ALL_INFORMATION_2')
        )
        .ariaLabel('delete user')
        .targetEvent(ev)
        .ok($translate.instant('YES'))
        .cancel($translate.instant('CANCEL'));

      $mdDialog.show(confirm).then(function () {
        userActions
          .deleteOrganizationUser(userId, organizationId)
          .then(function () {
            refreshUsers();
          });
      });
    };

    vm.pageChanged = function (page, limit) {
      vm.accountManagement.paginationChanged(page, limit);
      refreshUsers();
    };

    vm.deleteHistory = function (ev) {
      userActions.getCompanyDetails().then(function (res) {
        companyId = res.id;

        var confirm = $mdDialog
          .confirm()
          .title($translate.instant('DELETE_COMPANY_HISTORY'))
          .content($translate.instant('DELETE_COMPANY_HISTORY_CONFIRMATION'))
          .ariaLabel('delete history confirmation dialog')
          .targetEvent(ev)
          .ok($translate.instant('DELETE'))
          .cancel($translate.instant('CANCEL'));

        $mdDialog.show(confirm).then(function () {
          reportActions.deleteReportsData(companyId).then(
            function () {
              vm.historyDeletedMsg = true;
            },
            function () {
              vm.historyDeletedErrorMsg = true;
            }
          );
        });
      });
    };

    vm.addNewUser = function () {
      $state.go('app.accountManagement.user');
    };

    vm.updateListOfUsers = function () {
      $timeout(function () {
        counter += 1;
        if (counter === 1) {
          refreshUsers();
        }
      }, 1200);
      counter = 0;
    };

    vm.resendVerificationMail = function (user) {
      userActions.resendVerificationMail(user.email).then(function () {});
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ActivationSuccessController', ActivationSuccessController);

  /** @ngInject */
  function ActivationSuccessController() {
    // var vm = this;

  }
})();

(function () {
  'use strict';

  angular.module('sempraWebapp').factory('ActivateAccountViewModel', activateAccountViewModelFactory);

  /** @ngInject */
  function activateAccountViewModelFactory () {
    function ActivateAccountViewModel () {
      this.password = '';
      this.repeatPassword = '';
      this.passwordIdentical = true;

      init.call(this);
    }

    return ActivateAccountViewModel;

    function init () {
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ActivateAccountController', ActivateAccountController);

  /** @ngInject */
  function ActivateAccountController(
    $scope,
    ActivateAccountViewModel,
    userActions,
    $state,
    $stateParams,
    $log,
    brand,
    $translate,
    sessionData,
    $location,
    locales,
    dispatcher,
    ActionTypesEnum,
    applicationStore,
    $mdToast,
    $filter,
    checkUserRole,
    helperService
  ) {
    var vm = this;

    vm.account = new ActivateAccountViewModel();
    vm.inputType = "password";
    vm.inputReType = "password";

    init();

    vm.activate = function () {
      var activationCode = $stateParams.code;
      var data = {
        password: vm.account.password,
        repeatPassword: vm.account.repeatPassword,
        activationCode: activationCode
      };
      userActions.activateAccount(data).then(
        function (response) {
          userActions.signIn(response.toLowerCase(),  vm.account.password).then(
            function (userInfo) {
              checkUserRole.setCurrentRoles(userInfo.roles);
              helperService.setCurrentUserId(userInfo.user.id);
              helperService.setUserDataToLocalStorageOnLogIn(userInfo, 'en');

              if(checkUserRole.userRoleExist()) {
                $state.go("app.dashboardTechnology")
              } else {
                sessionData.clearAll();
                vm.login.hasErrors = true;
                vm.login.errorMessage = $translate.instant("ERROR_LOGIN_ROLE");
              }
            }
          );
        }
      );
    };

    vm.checkPassword = function (form) {
      var password = form.password.$viewValue;
      var repeatPassword = form.passwordRepeat.$viewValue;

      vm.account.passwordIdentical =
        password === repeatPassword && password !== '' && repeatPassword !== '';
    };

    vm.showPassword = function() {
      vm.inputType = vm.inputType === "text" ? "password" : "text";
    }

    vm.showReenterPassword = function() {
      vm.inputReType = vm.inputReType === "text" ? "password" : "text";
    }

    function init() {
      applicationStore.on(
        applicationStore.events.TOAST_CHANGE,
        showSimpleToast
      );
      var setUserLanguage = $location.search().lang;
      locales.setLanguage(setUserLanguage);
      sessionData.setValue(sessionData.Keys.LANGUAGE_KEY, setUserLanguage);
      vm.welcomeTitle = brand === 'karcher';
      $scope.$on('destroy', function () {});
    }

    function showSimpleToast(data) {
      $mdToast.show(
        $mdToast
          .simple()
          .textContent($translate.instant($filter("replacews")(data)))
          .position("bottom right")
          .hideDelay(3000)
      );
    }

  }
})();

angular.module("appVersion", [])
.constant("version", "4.53.00");

(function() {
  "use strict";

  angular.module("sempraWebapp").config(translationsConfig);

  /** @ngInject */
  function translationsConfig(
    $translateProvider,
    srTranslations,
    enTranslations,
    deTranslations,
    frTranslations,
    hrTranslations,
    plTranslations,
    slTranslations,
    csTranslations,
    ukTranslations,
    huTranslations,
    roTranslations,
    ruTranslations,
    nlTranslations,
    svTranslations,
    fiTranslations,
    twTranslations,
    skTranslations
  ) {
    $translateProvider
      .translations("en", enTranslations)
      .translations("sr", srTranslations)
      .translations("de", deTranslations)
      .translations("pl", plTranslations)
      .translations("sl", slTranslations)
      .translations("cs", csTranslations)
      .translations("hr", hrTranslations)
      .translations("fr", frTranslations)
      .translations("uk", ukTranslations)
      .translations("hu", huTranslations)
      .translations("ro", roTranslations)
      .translations("ru", ruTranslations)
      .translations("nl", nlTranslations)
      .translations("sv", svTranslations)
      .translations("fi", fiTranslations)
      .translations("tw", twTranslations)
      .translations("sk", skTranslations);

    $translateProvider.preferredLanguage("sr");
    $translateProvider.useSanitizeValueStrategy("sanitizeParameters");
  }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .config(customThemingProvider);

  /** @ngInject */
  function customThemingProvider($mdThemingProvider, brand){

    $mdThemingProvider.definePalette('r2w', {
      '50': 'e1f5fe',
      '100': 'b3e5fc',
      '200': '81d4fa',
      '300': '4fc3f7',
      '400': '29b6f6',
      '500': '03a9f4',
      '600': '03a2f3',
      '700': '0298f1',
      '800': '028fef',
      '900': '017eec',
      'A100': 'ffffff',
      'A200': 'FF9800', // Orange
      'A400': 'add4ff',
      'A700': 'FF9800', // Orange on mouseover
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [
        '50',
        '100',
        '200',
        '300',
        '400',
        'A100',
        'A200',
        'A400',
        'A700'
      ],
      'contrastLightColors': [
        '500',
        '600',
        '700',
        '800',
        '900'
      ]
    });
    $mdThemingProvider.definePalette('karcher', {
      '50': 'ececec',
      '100': 'd1d1d1',
      '200': 'b2b2b2',
      '300': '939393',
      '400': '7b7b7b',
      '500': '646464',
      '600': '5c5c5c',
      '700': '525252',
      '800': '484848',
      '900': '363636',
      'A100': 'f49a9a',
      'A200': '646464', // Default theme color instead #ef6c6c
      'A400': 'ff2929',
      'A700': '646464', // Default theme color for mouseover instead #ff0f0f
      'contrastDefaultColor': 'light',
      'contrastDarkColors': [],
      'contrastLightColors': []
    });

    $mdThemingProvider.theme('default')
      .primaryPalette(brand)
      .warnPalette('red')
      .accentPalette(brand);
  }
})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $location, $rootScope, sessionData, locales, brand) {
    var session = sessionData.getAll();

    if (session[sessionData.Keys.LANGUAGE_KEY]) {
      locales.setLanguage(session[sessionData.Keys.LANGUAGE_KEY]);
    }

    // Dynamic favicon
    /* eslint-disable */
    (function changeFavicon() {
      var link;
        link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = (brand === 'r2w') ? 'favicon.ico' : 'favicon_karcher.ico';
        document.getElementsByTagName('head')[0].appendChild(link);
    })();
    /* eslint-enable */

    // $rootScope.$on('$stateChangeStart', function(e, toState, toParams, fromState, fromParams) {

    //     if (toState.name === 'app.userGroups.new') {
    //         // check if flag is set (if user is started creating new group)
    //         if(toState.data.changingFlag){
    //           e.preventDefault();
    //           return;
    //           // popup dialog
    //         }

    //         $state.go(toState.name);
    //     }
    // });

    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';

  angular.module('sempraWebapp').config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider
      .state('login', {
        url: '/login',
        templateUrl: 'app/login/login.html',
        controller: 'LoginController',
        controllerAs: 'vm'
      })
      .state('activateAccount', {
        url: '/accountActivation/:code',
        templateUrl: 'app/activateAccount/activateAccount.html',
        controller: 'ActivateAccountController',
        controllerAs: 'vm'
      })
      .state('resetPassword', {
        url: '/resetPassword/:code',
        templateUrl: 'app/resetPassword/resetPassword.html',
        controller: 'ResetPasswordController',
        controllerAs: 'vm'
      })
      .state('activationSuccess', {
        url: '/activationSuccess',
        templateUrl: 'app/activateAccount/activationSuccess.html',
        controller: 'ActivationSuccessController',
        controllerAs: 'vm'
      })
      .state('forgotPassword', {
        url: '/forgotPassword',
        templateUrl: 'app/forgotPassword/forgotPassword.html',
        controller: 'ForgotPasswordController',
        controllerAs: 'vm'
      })
      .state('app', {
        url: '',
        abstract: true,
        templateUrl: 'app/layout/layout.html',
        data: {
          displayName: '{{crumb.value}}'
          //breadcrumbProxy :'app.dashboardTechnology'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('ASIDE_MENU_DASHBOARD_TECHNOLOGY')
            };
          },
          refreshToken: function (
            $q,
            sessionData,
            jwtHelper,
            userActions,
            broker,
            mqttBrokerIp,
            mqttBrokerPort,
            useMqttBrokerSsl,
            $state,
            $timeout
          ) {
            var token = sessionData.getValue(sessionData.Keys.ACCESS_TOKEN_KEY);
            if (token === 'null' || token === null || !token) {
              $timeout(function () {
                sessionData.clearAll();
                $state.go('login');
              });
            }
            var refreshToken = sessionData.getValue(
              sessionData.Keys.REFRESH_TOKEN_KEY
            );

            if (token && refreshToken) {
              var isTokenExpired = jwtHelper.isTokenExpired(token, 1);
              var isRefreshTokenExpired = jwtHelper.isTokenExpired(
                refreshToken,
                1
              );

              if (isTokenExpired && !isRefreshTokenExpired) {
                userActions.refreshToken().then(function (data) {
                  // reconnect web sockets
                  broker.initWebSockets(
                    mqttBrokerIp,
                    mqttBrokerPort,
                    useMqttBrokerSsl
                  );
                  token = data.data.accessToken;
                });
              }

              if (isRefreshTokenExpired) {
                $timeout(function () {
                  sessionData.clearAll();
                  $state.go('login');
                });
              }
            }
            return {
              accessToken: token
            };
          }
        },
        controller: 'LayoutController',
        controllerAs: 'vm'
      })
      .state('app.dashboardTechnology', {
        url: '/facilities',
        views: {
          'layoutPageContainer@app': {
            templateProvider: [
              'brand',
              '$state',
              '$templateRequest',
              function (brand, $state, $templateRequest) {
                var page;
                switch (brand) {
                  case 'karcher':
                    page =
                      'app/dashboardKarcherTechnology/dashboardKarcherTechnology.html';
                    return $templateRequest(page);

                  case 'r2w':
                    page = 'app/dashboardTechnology/dashboardTechnology.html';
                    return $templateRequest(page);
                }
              }
            ],
            controllerProvider: [
              'brand',
              function (brand) {
                switch (brand) {
                  case 'karcher':
                    return 'DashboardKarcherTechnologyController';

                  case 'r2w':
                    return 'dashboardTechnologyController';
                }
              }
            ],
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('ASIDE_MENU_DASHBOARD_TECHNOLOGY')
            };
          }
        }
      })
      .state('app.dashboardTechnology.siteDetails', {
        url: '/site/:id/:siteAddress/:siteLatitude/:siteLongitude',
        views: {
          'layoutPageContainer@app': {
            templateProvider: [
              'brand',
              '$state',
              '$templateRequest',
              function (brand, $state, $templateRequest) {
                var page;
                switch (brand) {
                  case 'karcher':
                    page =
                      'app/dashboardKarcherTechnology/siteDetails/siteDetails.html';
                    return $templateRequest(page);
                  case 'r2w':
                    page = 'app/errorPage/errorPage.html';
                    return $templateRequest(page);
                }
              }
            ],
            controllerProvider: [
              'brand',
              function (brand) {
                switch (brand) {
                  case 'karcher':
                    return 'SiteDetailsController';
                  case 'r2w':
                    return 'ErrorPageController';
                }
              }
            ],
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('SITE_DETAILS') };
          }
        }
      })
      .state('app.dashboardTechnology.siteDetails.facilityDetails', {
        url: '/device/:deviceId',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/facilityKarcherDetails/facilityKarcherDetails.html',
            controller: 'FacilityKarcherDetailsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('FACILITY_DETAILS') };
          }
        }
      })
      .state('app.dashboardFinancial', {
        url: '/dailyFinances',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/dashboardFinances/dashboardFinances.html',
            controller: 'dashboardFinancesController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('ASIDE_MENU_DASHBOARD_FINANCIAL')
            };
          }
        }
      })
      .state('app.dashboardTechnology.facilityDetails', {
        url: '/:id',
        views: {
          'layoutPageContainer@app': {
            templateProvider: [
              'brand',
              '$state',
              '$templateRequest',
              function (brand, $state, $templateRequest) {
                var page;
                switch (brand) {
                  case 'r2w':
                    page = 'app/facilityDetails/facilityDetails.html';
                    return $templateRequest(page);
                  case 'karcher':
                    page = 'app/errorPage/errorPage.html';
                    return $templateRequest(page);
                }
              }
            ],
            controllerProvider: [
              'brand',
              function (brand) {
                switch (brand) {
                  case 'r2w':
                    return 'FacilityDetailsController';
                  case 'karcher':
                    return 'ErrorPageController';
                }
              }
            ],
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_DETAILS') };
          }
        }
      })
      .state('app.dashboardTechnology.facilityDetails.facilitySettings', {
        url: '/settings',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/settings/settings.html',
            controller: 'SettingsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_SETTINGS') };
          }
        }
      })
      .state('app.dashboardTechnology.facilityDetails.facilityWorkingHours', {
        url: '/:pointId/working-hours',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/workingHours/workingHours.html',
            controller: 'WorkingHoursController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_WORKING_HOURS') };
          }
        }
      })
      .state('app.dashboardTechnology.facilityDetails.servicePage', {
        url: '/service',
        params: {
          facility: null
        },
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/karcherService/karcherService.html',
            controller: 'KarcherServiceController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_SERVICE') };
          }
        }
      })
      .state('app.alarms', {
        url: '/alarms',
        views: {
          'layoutPageContainer@app': {
            templateProvider: [
              'brand',
              '$templateRequest',
              function (brand, $templateRequest) {
                var page;
                switch (brand) {
                  case 'karcher':
                    page = 'app/alarmsKarcher/alarmsKarcher.html';
                    return $templateRequest(page);
                  default:
                    page = 'app/alarms/alarms.html';
                    return $templateRequest(page);
                }
              }
            ],
            controllerProvider: [
              'brand',
              function (brand) {
                switch (brand) {
                  case 'karcher':
                    return 'KarcherAlarmsController';
                  default:
                    return 'AlarmsController';
                }
              }
            ],
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_ALARMS') };
          }
        }
      })
      .state('app.alarms.subscriptions', {
        url: '/subscriptions',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/alarmsKarcher/alarmSubscriptions/alarmSubscriptions.html',
            controller: 'KarcherAlarmSubscriptionsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('SUBSCRIPTIONS') };
          }
        }
      })
      .state('app.organization', {
        url: '/organization/list',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/organization/listOrganization.html',
            controller: 'ListOrganizationController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ORGANIZATION') };
          }
        }
      })
      .state('app.organization.details', {
        url: '/edit/:id/:create',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/organization/details/organizationDetails.html',
            controller: 'OrganizationDetailsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate, $stateParams) {
            return {
              value:
                $stateParams.create === 'false'
                  ? $translate.instant('EDIT_ORGANIZATION')
                  : $translate.instant('CREATE_ORGANIZATION')
            };
          }
        }
      })
      .state('app.workingSchedules', {
        url: '/working-schedules',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/workingSchedulesAndHolidays/workingSchedulesAndHolidays.html',
            controller: 'WorkingSchedulesController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('WORKING_SCHEDULES')
            };
          }
        }
      })
      // .state('app.news', {
      //   url: '/news',
      //   views: {
      //     'layoutPageContainer@app': {
      //       templateUrl: 'app/news/news.html',
      //       controller: 'NewsController',
      //       controllerAs: 'vm'
      //     }
      //   },
      //   data: {
      //     displayName: '{{crumb.value}}'
      //   },
      //   resolve: {
      //     crumb: function ($translate) {
      //       return { value: $translate.instant('ASIDE_MENU_NEWS') }
      //     }
      //   }
      // })
      // .state('app.reports', {
      //   url: '/reports',
      //   views: {
      //     'layoutPageContainer@app': {
      //       templateProvider: [
      //         'brand',
      //         '$templateRequest',
      //         function (brand, $templateRequest) {
      //           var page;
      //           switch (brand) {
      //             case 'karcher':
      //               page = 'app/reportsKarcher/reportsKarcher.html';
      //               return $templateRequest(page);
      //             default:
      //               page = 'app/reportsBuilderKarcher/reportsBuilderKarcher.html';
      //               return $templateRequest(page);
      //           }
      //         }
      //       ],
      //       controllerProvider: [
      //         'brand',
      //         function (brand) {
      //           switch (brand) {
      //             case 'karcher':
      //               return 'ReportsKarcherController';
      //             default:
      //               return 'ReportsBuilderKarcherController';
      //           }
      //         }
      //       ],
      //       controllerAs: 'vm'
      //     }
      //   },
      //   data: {
      //     displayName: '{{crumb.value}}'
      //   },
      //   resolve: {
      //     crumb: function ($translate) {
      //       return { value: $translate.instant('ASIDE_MENU_REPORTS') };
      //     }
      //   }
      // })
      .state('app.reports', {
        url: '/reports',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/reportsBuilderKarcher/reportsBuilderKarcher.html',
            controller: 'ReportsBuilderKarcherController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORTS') };
          }
        }
      })
      .state('app.cashlessSales', {
        url: '/cashless-sales',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/cashlessPaymentRefund/cashlessPaymentRefund.html',
            controller: 'CashlessPaymentRefundController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_CASHLESS_SALES') };
          }
        }
      })
      .state('app.reports.dailyTotal', {
        url: '/dailyTotal',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/dailyTotalReport/dailyTotalReport.html',
            controller: 'dailyTotalReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.dailyCoinsTotal', {
        url: '/dailyCoinsTotal',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/dailyCoinsReport/dailyCoinsReport.html',
            controller: 'dailyCoinsReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.dailyEuroKeyTotal', {
        url: '/dailyEuroKeyTotal',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/dailyEurokeyReport/dailyEurokeyReport.html',
            controller: 'dailyEuroKeyReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.dailyR2WTotal', {
        url: '/dailyR2WTotal',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/dailyR2WReport/dailyR2WReport.html',
            controller: 'dailyR2WReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.comparation', {
        url: '/comparationReport',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/comparationReport/comparationReport.html',
            controller: 'comparationReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.avgByHour', {
        url: '/avgByHour',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/avgByHourReport/avgByHourReport.html',
            controller: 'avgByHourReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.avgByDay', {
        url: '/avgByDay',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/avgByDayReport/avgByDayReport.html',
            controller: 'avgByDayReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.avgByBox', {
        url: '/avgByBox',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/avgByBoxReport/avgByBoxReport.html',
            controller: 'avgByBoxReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.totalUsers', {
        url: '/totalUsers',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/userGroupsByDate/userGroupsByDate.html',
            controller: 'userGroupsByDateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.totalVisits', {
        url: '/totalVisits',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/usersPerVisitReport/usersPerVisitReport.html',
            controller: 'usersPerVisitReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.givenLoyalty', {
        url: '/totalSpentLocalTokensPerDay',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/givenLoyaltyPerDayReport/givenLoyaltyPerDayReport.html',
            controller: 'givenLoyaltyPerDayReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.getTotalGivenLocalTokensPerDay', {
        url: '/totalGivenLocalTokensPerDay',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/totalGivenLocalTokensPerDay/totalGivenLocalTokensPerDay.html',
            controller: 'totalGivenLocalTokensPerDayReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.getTotalPurchasedLocalTokensPerDay', {
        url: '/totalPurchasedLocalTokensPerDay',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/totalPurchasedLocalTokensPerDay/totalPurchasedLocalTokensPerDay.html',
            controller: 'totalPurchasedLocalTokensPerDayReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.loyaltyPerPayment', {
        url: '/loyaltyPerPayment',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/loyaltyPerPaymentMethodReport/loyaltyPerPaymentMethodReport.html',
            controller: 'loyaltyPerPaymentMethodReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.changerIncome', {
        url: '/changerIncome',
        views: {
          'reportDetails@app.reports': {
            templateUrl:
              'app/reports/changerIncomeByDate/changerIncomeByDate.html',
            controller: 'changerIncomeByDateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.reports.posIncome', {
        url: '/posIncome',
        views: {
          'reportDetails@app.reports': {
            templateUrl: 'app/reports/totalIncomePos/totalIncomePos.html',
            controller: 'posIncomeReportController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_REPORT') };
          }
        }
      })
      .state('app.userGroups', {
        url: '/userGroups',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/userGroups/userGroups.html',
            controller: 'userGroupsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_USER_GROUPS') };
          }
        }
      })
      .state('app.userGroups.new', {
        url: '/new',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/createUpdateUserGroup/createUpdateUserGroup.html',
            controller: 'createUpdateUserGroupController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_NEW_USER_GROUP') };
          }
        }
      })
      .state('app.userGroups.edit', {
        url: '/:id',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/createUpdateUserGroup/createUpdateUserGroup.html',
            controller: 'createUpdateUserGroupController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('BREAD_CRUMBS_EDIT_USER_GROUP')
            };
          }
        }
      })
      .state('app.loyalty', {
        url: '/loyalty',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/loyalty/loyalty.html',
            controller: 'LoyaltyController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_LOYALTY') };
          }
        }
      })
      .state('app.loyalty.newCampaign', {
        url: '/campaigns/new',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/createUpdateCampaign/createUpdateCampaign.html',
            controller: 'createUpdateCampaignController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_NEW_CAMPAIGN') };
          }
        }
      })
      .state('app.loyalty.editCampaign', {
        url: '/campaigns/:id',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/createUpdateCampaign/createUpdateCampaign.html',
            controller: 'createUpdateCampaignController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        params: {
          facilityType: null
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('BREAD_CRUMBS_EDIT_CAMPAIGN') };
          }
        }
      })
      .state('app.loyalty.newTemplate', {
        url: '/template/new',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/createUpdateCampaignTemplate/createUpdateCampaignTemplate.html',
            controller: 'createUpdateCampaignTemplateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('BREAD_CRUMBS_NEW_CAMPAIGN_TEMPLATE')
            };
          }
        }
      })
      .state('app.loyalty.editTemplate', {
        url: '/template/:id',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/createUpdateCampaignTemplate/createUpdateCampaignTemplate.html',
            controller: 'createUpdateCampaignTemplateController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('BREAD_CRUMBS_EDIT_CAMPAIGN_TEMPLATE')
            };
          }
        }
      })
      // .state('app.periodicSummary', {
      //   url: '/periodicSummary',
      //   views: {
      //     'layoutPageContainer': {
      //       templateUrl: 'app/periodicSummary/periodicSummary.html',
      //       controller: 'periodicSummaryController',
      //       controllerAs: 'vm'
      //     }
      //   },
      //   data: {
      //     displayName: '{{crumb.value}}'
      //   },
      //   resolve: {
      //     crumb: function ($translate) {
      //       return { value: $translate.instant('BREAD_CRUMBS_PERIODIC_SUMMARY') }
      //     }
      //   }
      // })
      .state('app.errorPage', {
        url: '/errorPage',
        views: {
          errorPageContainer: {
            templateUrl: 'app/errorPage/errorPage.html',
            controller: 'ErrorPageController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ERROR_TITLE') };
          }
        }
      })
      .state('app.errorPageWithRedirectToDashboard', {
        url: '/errorPageBadRequest',
        views: {
          errorPageContainer: {
            templateUrl: 'app/errorPage/redirectToDashboard/redirectToDashboard.html',
            controller: 'errorPageWithRedirectToDashboardController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ERROR_TITLE') };
          }
        }
      })
      .state('app.accountManagement', {
        url: '/accountManagement',
        views: {
          layoutPageContainer: {
            templateUrl: 'app/accountManagement/accountManagement.html',
            controller: 'AccountManagementController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ACCOUNT_MANAGEMENT') };
          },
          isValidUser: function (checkUserRole) {
            return (
              checkUserRole.isAdministrator() || checkUserRole.isMerchantAdmin()
            );
          }
        }
      })
      .state('app.accountManagement.user', {
        url: '/user/:userId',
        views: {
          'layoutPageContainer@app': {
            templateUrl:
              'app/accountManagement/userOrganization/userOrganization.html',
            controller: 'UserOrganizationController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('USER_ORGANIZATION') };
          }
        }
      })
      .state('app.releaseNotes', {
        url: '/release-notes',
        views: {
          layoutPageContainer: {
            templateUrl: 'app/releaseNotes/releaseNotes.html',
            controller: 'ReleaseNotesController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('RELEASE_NOTES') };
          }
        }
      })
      .state('app.periodicSummary', {
        url: '/periodicSummary',
        views: {
          layoutPageContainer: {
            templateUrl: 'app/periodicSummary/periodicSummary.html',
            controller: 'periodicSummaryController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return {
              value: $translate.instant('BREAD_CRUMBS_PERIODIC_SUMMARY')
            };
          }
        }
      })
      .state('app.vouchers', {
        url: '/vouchers',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/vouchers/vouchers.html',
            controller: 'VouchersController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_VOUCHERS') };
          }
        }
      })
      .state('app.transactions', {
        url: '/transactions',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/transactions/transactions.html',
            controller: 'TransactionsController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('ASIDE_MENU_TRANSACTIONS') };
          }
        }
      })
      .state('app.tokens', {
        url: '/tokens',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/managingTokens/managingTokens.html',
            controller: 'ManagingTokensController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('MANAGING_TOKENS') };
          }
        }
      })
      .state('app.pricing', {
        url: '/pricing',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/pricing/pricing.html',
            controller: 'PricingController',
            controllerAs: 'vm'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('PRICING') };
          }
        }
      })
      .state('app.help', {
        url: '/help',
        views: {
          'layoutPageContainer@app': {
            templateUrl: 'app/knowledgeBase/knowledgeBase.html'
          }
        },
        data: {
          displayName: '{{crumb.value}}'
        },
        resolve: {
          crumb: function ($translate) {
            return { value: $translate.instant('HELP') };
          }
        }
      })
  .state('app.termsAndService', {
      url: '/terms-and-service/:marker',
      views: {
        'layoutPageContainer@app': {
          templateUrl: 'app/knowledgeBase/termsAndService.html',
          controller: 'TermsAndServiceController',
          controllerAs: 'vm'
        }
      },
      data: {
        displayName: '{{crumb.value}}'
      },
      resolve: {
        crumb: function ($translate) {
          return { value: $translate.instant('TERMS_AND_SERVICES') };
        }
      }
    });

    $urlRouterProvider.otherwise('/login');
    // $locationProvider.html5Mode(true);
  }
})();

/* global malarkey:false, moment:false */
(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $httpProvider, $mdDateLocaleProvider, moment) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Enable CORS
    $httpProvider.defaults.useXDomain = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    $httpProvider.interceptors.push('httpInterceptor');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    $mdDateLocaleProvider.formatDate = function(date) {
      // moment.locale('en');
      // var dateFormat = moment().localeData().longDateFormat('L');
      return moment(date).format('DD/MM/YYYY');
    };

    $mdDateLocaleProvider.parseDate = function(dateString) {
      if (!dateString) return null;
      var parts = dateString.split('/');
      if (parts.length !== 3) return null;
      return new Date(parts[2], parts[1] - 1, parts[0]);
    };

    $mdDateLocaleProvider.firstDayOfWeek = 1;

    $mdDateLocaleProvider.msgCalendar = 'Calendar view';
    $mdDateLocaleProvider.msgOpenCalendar = 'Open calendar';

  }

})();

angular.module("sempraWebapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/accountManagement/accountManagement.html","<md-content flex=\"\" layout-padding=\"\"><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"50\"><span class=\"md-title\">{{::\'COMPANY_ACCOUNTS\' | translate}}</span><md-button class=\"md-fab md-mini md-primary\" aria-label=\"Add new user\" ng-click=\"vm.addNewUser($event)\"><md-icon md-svg-src=\"assets/icons/ic_add_white_24px.svg\"></md-icon></md-button></div><div flex=\"\"><md-input-container class=\"md-block\"><label>{{ \'FILTER\' | translate}}</label> <input ng-model=\"vm.accountManagement.filterUsers\" type=\"text\" ng-change=\"vm.updateListOfUsers()\"></md-input-container></div></div><div id=\"accountManagementContainer\" class=\"md-whiteframe-z1\"><md-content flex=\"\" layout-fill=\"\"><md-table-container id=\"tableContainer\"><table md-table=\"\" md-row-select=\"false\" ng-model=\"vm.accountManagement.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.accountManagement.orderBy\"><tr md-row=\"\"><th md-column=\"\"><span>{{::\'EMAIL\' | translate}}</span></th><th md-column=\"\"><span>{{::\'FIRST_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{::\'LAST_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{::\'ORGANIZATION\' | translate}}</span></th><th md-column=\"\"><span>{{::\'VERIFIED\' | translate}}</span></th><th md-column=\"\"><span></span></th><th md-column=\"\"><span></span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"user\" md-select-id=\"{{user.user.id}}\" md-auto-select=\"\" ng-repeat=\"user in vm.accountManagement.data.content\"><td md-cell=\"\">{{user.email}}</td><td md-cell=\"\">{{user.firstName}}</td><td md-cell=\"\">{{user.lastName}}</td><td md-cell=\"\">{{user.organizations[0].name}}</td><td md-cell=\"\" ng-if=\"user.verified\"><span class=\"material-icons\">done</span></td><td md-cell=\"\" ng-if=\"!user.verified\" class=\"linkedText\" ng-click=\"vm.resendVerificationMail(user)\"><span class=\"material-icons\">close</span><md-tooltip>{{::\'RESEND_VERIFICATION_MAIL\' | translate}}</md-tooltip></td><td md-cell=\"\"><md-icon ng-if=\"user.email !== vm.accountManagement.currentUser\" md-svg-src=\"assets/icons/ic_edit_black_24px.svg\" ui-sref=\"app.accountManagement.user({userId: user.userId})\"><md-tooltip hide-xs=\"\">{{::\'EDIT_ORGANIZATION_USER\' | translate}}</md-tooltip></md-icon></td><td md-cell=\"\"><md-icon ng-if=\"user.email !== vm.accountManagement.currentUser\" md-svg-src=\"assets/icons/ic_delete_forever_black_24px.svg\" ng-click=\"vm.deleteUser(event, user.userId, user.organizations[0].id, user.email)\"><md-tooltip hide-xs=\"\">{{::\'DELETE_ORGANIZATION_USER\' | translate}}</md-tooltip></md-icon></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit=\"vm.accountManagement.limitPerPage\" md-limit-options=\"vm.accountManagement.pageOptions\" md-page=\"vm.accountManagement.currentPage\" md-total=\"{{vm.accountManagement.totalElements}}\" md-label=\"{{vm.accountManagement.pagerLabel}}\" md-on-paginate=\"vm.pageChanged\" md-page-select=\"true\" md-boundary-links=\"true\"></md-table-pagination></div><div class=\"title\" style=\"margin-top: 1rem\"><p class=\"md-title\" style=\"margin-bottom: 5px\">{{::\'DELETE_COMPANY_HISTORY\' | translate}}</p><p class=\"warning-message\">{{::\'DELETE_COMPANY_HISTORY_INFO\' | translate}}</p><md-button class=\"md-raised md-primary\" style=\"margin-left: 0\" aria-label=\"Delete company history\" ng-click=\"vm.deleteHistory($event)\"><md-icon md-svg-src=\"assets/icons/ic_delete_sweep_white_24px.svg\"></md-icon><md-tooltip>{{::\'DELETE_COMPANY_HISTORY\' | translate}}</md-tooltip></md-button><span ng-if=\"vm.historyDeletedMsg\">{{::\'HISTORY_SUCCESSFULY_DELETED\' | translate}}</span> <span ng-if=\"vm.historyDeletedErrorMsg\">{{::\'ERROR_MESSAGE\' | translate}}</span></div></md-content>");
$templateCache.put("app/activateAccount/activateAccount.html","<div style=\"height: 100vh\" id=\"activateAccountContainer\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><div flex=\"\"></div><div flex=\"40\" layout=\"column\" layout-align=\"\"><div class=\"logoContainer\"></div><div flex=\"\"><div flex=\"\"><h2 translate=\"ACTIVATING_ACCOUNT_WELCOME_KARCHER_MSG\" ng-if=\"vm.welcomeTitle\"></h2><h2 translate=\"ACTIVATING_ACCOUNT_WELCOME_MSG\" ng-if=\"!vm.welcomeTitle\"></h2><p>{{::\'ACTIVATING_ACCOUNT_WELCOME_MSG_2\' | translate}}</p><p>{{::\'ACTIVATING_ACCOUNT_WELCOME_MSG_3\' | translate}}</p></div><div flex=\"\" class=\"passwordWrapper\"><form name=\"activateAccForm\" novalidate=\"\" ng-submit=\"vm.activate()\" id=\"activateAccForm\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>{{::\'ENTER_NEW_PASSWORD\' | translate}}</label> <input type=\"{{vm.inputType}}\" name=\"password\" ng-model=\"vm.account.password\" md-minlength=\"8\" md-maxlength=\"32\" ng-minlength=\"8\" ng-maxlenght=\"32\" ng-change=\"vm.checkPassword(activateAccForm)\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$/\" required=\"\"> <i class=\"material-icons cursorPointer global-password-visibility-mark\" ng-click=\"vm.showPassword()\">visibility</i><div ng-messages=\"activateAccForm.password.$error\" layout=\"column\" layout-align=\"center start\" flex=\"\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'REQUIRED_FIELD\' | translate}}</div><div flex=\"\" ng-message=\"minlength\">- {{::\'PASSWORD_MIN_LENGTH\' | translate}}</div><div flex=\"\" ng-message=\"maxlength\">- {{::\'PASSWORD_MAX_LENGHT\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{::\'PASSWORD_VALIDATION_PATTERN_NEW\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>{{::\'REPEAT_NEW_PASSWORD \' | translate}}</label> <input type=\"{{vm.inputReType}}\" name=\"passwordRepeat\" ng-model=\"vm.account.repeatPassword\" required=\"\" md-minlength=\"8\" md-maxlength=\"32\" ng-minlength=\"8\" ng-maxlenght=\"32\" ng-change=\"vm.checkPassword(activateAccForm)\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$/\"> <i class=\"material-icons cursorPointer global-password-visibility-mark\" ng-click=\"vm.showReenterPassword()\">visibility</i><div ng-messages=\"activateAccForm.passwordRepeat.$error\" layout=\"column\" layout-align=\"center start\" flex=\"\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'REQUIRED_FIELD\' | translate}}</div><div flex=\"\" ng-message=\"minlength\">- {{::\'PASSWORD_MIN_LENGTH\' | translate}}</div><div flex=\"\" ng-message=\"maxlength\">- {{::\'PASSWORD_MAX_LENGHT\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{::\'PASSWORD_VALIDATION_PATTERN_NEW\' | translate}}</div><div flex=\"\" ng-if=\"!vm.account.passwordIdentical\" class=\"passwordMatchValidation\">- {{::\'PASSWORD_MATCH\' | translate}}</div></div></md-input-container><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ui-sref=\"login\">{{::\'CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"activateAccForm.$invalid || !vm.account.passwordIdentical\">{{::\'ACTIVATE\' | translate}}</md-button></div></form></div></div></div><div flex=\"\"></div></div>");
$templateCache.put("app/activateAccount/activationSuccess.html","<div layout=\"\" layout-align=\"center center\" flex=\"\"><md-content layout=\"column\" id=\"activationSuccessContainer\"><br><div class=\"logoContainer\"></div><br><div id=\"textContainer\">{{::\'ACTIVATION_ACCOUNT\' | translate}}</div><br><md-button class=\"md-primary md-raised\" id=\"continueButton\" ui-sref=\"login\">{{::\'CONTINUE\' | translate}}</md-button></md-content></div>");
$templateCache.put("app/alarmsKarcher/alarmsKarcher.html","<div class=\"fullWidth karcher-alarm-messages-container\" layout-margin=\"\"><div layout-padding=\"\"><form name=\"alarmsFilterForm\" class=\"filterForm md-inline-form\" layout=\"row\" layout-align-gt-md=\"start start\" layout-align=\"center center\" ng-submit=\"vm.searchMessages()\" no-validate=\"\"><div flex=\"90\" flex-gt-md=\"30\" layout=\"column\" layout-gt-md=\"row\" layout-align-gt-md=\"center center\" layout-align=\"space-around center\" class=\"fullWidth\" layout-margin=\"\"><md-input-container flex=\"\" class=\"no-margin-date-picker\"><label>{{::\'FROM\' | translate}}</label><md-datepicker ng-model=\"vm.alarmMessages.alarmsFrom\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-max-date=\"vm.alarmMessages.alarmsTo\" md-hide-icons=\"calendar\" required=\"\"></md-datepicker></md-input-container><md-input-container flex=\"\" class=\"no-margin-date-picker\"><label>{{::\'TO\' | translate}}</label><md-datepicker ng-model=\"vm.alarmMessages.alarmsTo\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-min-date=\"vm.alarmMessages.alarmsFrom\" md-hide-icons=\"calendar\" required=\"\"></md-datepicker></md-input-container></div><div flex=\"40\" layout=\"column\" layout-gt-md=\"row\" class=\"fullWidth\"><div layout=\"row\" flex=\"\"><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearSiteInput()\"></md-icon><multiply-items-selector list=\"vm.alarmMessages.siteList\" enable-selector=\"true\" place-holder-text=\"vm.alarmMessages.placeHolderText\" clear-site-text-input=\"vm.alarmMessages.selectedSite\" selected-list=\"vm.searchMessages(ids)\" class=\"marginRight1\" flex=\"\"></multiply-items-selector></div><md-input-container flex=\"\"><label>{{\'FILTER_BY_ALERT_CENTER\' | translate}}</label> <input name=\"filterBy\" ng-model=\"vm.alarmMessages.filterBy\" type=\"text\"></md-input-container></div><div flex=\"90\" flex-gt-md=\"30\" layout=\"column\" layout-gt-md=\"row\" layout-align-gt-md=\"center center\" layout-align=\"space-around center\" class=\"fullWidth inline-button-container\" layout-margin=\"\"><md-button class=\"md-raised black-karcher-button fullWidth\" ng-click=\"vm.searchMessages()\" ng-disabled=\"alarmsFilterForm.$invalid\" ng-class=\"{\'black-karcher-button-disabled\': alarmsFilterForm.$invalid}\" aria-label=\"Filter bu key word\">{{::\'SEARCH\' | translate}}</md-button><md-button class=\"md-raised primary-karcher-button fullWidth\" ng-click=\"vm.exportToCsvSiteList()\" ng-disabled=\"vm.alarmMessages.noDataToDisplay\" ng-class=\"{\'primary-karcher-button-disabled\': vm.alarmMessages.noDataToDisplay}\" aria-label=\"Download CSV\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></div></form></div><div layout=\"row\" layout-align=\"space-between center\"><div class=\"fault-status-selection-wrapper\"><md-radio-group ng-model=\"vm.alarmMessages.faultStatus\" aria-label=\"Selected fault status\" layout=\"row\" layout-align=\"start center\"><md-radio-button ng-repeat=\"fault in vm.alarmMessages.faultStatusList\" ng-value=\"fault.value\" class=\"md-primary\">{{ fault.name | translate }}</md-radio-button></md-radio-group></div><div flex=\"\" class=\"go-to-subscription-wrapper\"><md-icon md-svg-src=\"assets/icons/ic_content_paste_black_24px.svg\"></md-icon><span class=\"cursorPointer\" ng-click=\"vm.subscriptions()\">{{ \'SUBSCRIPTIONS\' | translate }}</span></div></div><div class=\"customCardTitle\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title customCardSubTitle\">{{ vm.alarmPageTitle }}</span></div><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"vm.alarmMessages.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.alarmMessages.orderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\"><span>{{::\'ALERT_CODE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"timestamp\"><span>{{::\'DATE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"companyName\"><span>{{::\'COMPANY_NAME\' | translate}}</span></th><th md-column=\"\" md-order-by=\"siteName\"><span>{{::\'SITE_NAME\' | translate}}</span></th><th md-column=\"\" md-order-by=\"washFacilityName\"><span>{{::\'FACILITY_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{::\'ALERT_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{::\'ALERT_DESCRIPTION\' | translate}}</span></th><th md-column=\"\"><span>{{::\'TYPE\' | translate}}</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"user\" md-select-id=\"{{alarm.id}}\" md-auto-select=\"\" ng-repeat=\"alarm in vm.alarmMessages.alarmsData\"><td md-cell=\"\">{{alarm.karcherFault.number}}</td><td md-cell=\"\">{{alarm.timestamp | date : \'dd/MMM/yy - HH:mm\'}}</td><td md-cell=\"\">{{alarm.companyName}}</td><td md-cell=\"\">{{alarm.siteName}}</td><td md-cell=\"\">{{alarm.washFacilityName}}</td><td md-cell=\"\">{{alarm.karcherFault.name}}</td><td md-cell=\"\">{{alarm.karcherFault.description}}</td><td md-cell=\"\"><md-icon flex=\"\" md-svg-src=\"{{ alarm.icon }}\"></md-icon></td><td md-cell=\"\" ng-if=\"!vm.alarmMessages.hideUnnecessary\"></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.alarmMessages.alarmsPageSize\" md-page=\"vm.alarmMessages.alarmsPage\" md-options=\"vm.alarmMessages.alarmsPageOptions\" md-total=\"{{vm.alarmMessages.alarmsTotal}}\" md-page-select=\"true\" md-boundary-links=\"true\" md-label=\"{{vm.alarmMessages.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\"></md-table-pagination></div>");
$templateCache.put("app/alarms/alarms.html","<div id=\"alarmSummaryWrapper\" flex=\"\" layout=\"\" layout-gt-md=\"column\"><div id=\"alarmSummaryContainer\" layout-padding=\"\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" ng-if=\"vm.brand !== \'karcher\'\"><md-tab label=\"{{::\'ALARM_ACTIVE\' | translate}}\"><div layout=\"\" layout-align=\"center space-between\" class=\"list-item-wrapper-title\"><p flex=\"10\" class=\"list-item-wrapper\">#</p><p flex=\"30\" class=\"list-item-wrapper\">{{ \'DATE\' | translate }}</p><p flex=\"20\" class=\"list-item-wrapper\">{{ \'LOCATION\' | translate }}</p><p flex=\"20\" class=\"list-item-wrapper\">{{ \'MESSAGE\' | translate }}</p><p flex=\"\" class=\"list-item-wrapper\">{{ \'TYPE\' | translate }}</p></div><div ng-repeat=\"activeAlarm in vm.messages.activeAlarmsList\" layout=\"\" layout-align=\"center space-between\"><p flex=\"10\" class=\"list-item-wrapper\">{{ $index + 1 }}.</p><p flex=\"30\" class=\"list-item-wrapper\">{{ activeAlarm.timestamp | date: \'medium\' }}</p><p flex=\"20\" class=\"list-item-wrapper\">{{ activeAlarm.details }}</p><p flex=\"20\" class=\"list-item-wrapper\">{{ activeAlarm.content |translate }}</p><p flex=\"\" class=\"list-item-wrapper\" ng-style=\"activeAlarm.collapseKey === \'alarm\' ? {\'color\':\'#F44336\', \'font-weight\': \'500\'} : {\'color\':\'rgb(255, 171, 64)\', \'font-weight\': \'500\'}\">{{ activeAlarm.collapseKey }}</p></div></md-tab><md-tab label=\"{{::\'ALARM_HISTORY\' | translate}}\"><md-content flex=\"\"><div layout=\"column\" layout-margin=\"\" id=\"alarmsContainer\" ng-cloak=\"\"><form name=\"filterForm\" class=\"filterForm md-inline-form\" layout=\"column\" layout-align=\"start start\" layout-align-xs=\"start center\" layout-gt-md=\"row\" layout-padding=\"\" no-validate=\"\"><div layout=\"\" flex-xs=\"\" flex-sm=\"\"><md-input-container class=\"md-block\"><label>{{::\'FROM\' | translate}}</label><md-datepicker ng-model=\"vm.messages.alarmsFrom\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-max-date=\"vm.messages.alarmsTo\"></md-datepicker></md-input-container><md-input-container class=\"md-block\"><label>{{::\'TO\' | translate}}</label><md-datepicker ng-model=\"vm.messages.alarmsTo\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-min-date=\"vm.messages.alarmsFrom\" ng-change=\"vm.toDateSelected()\"></md-datepicker></md-input-container></div><div layout=\"\" flex-xs=\"\" flex-sm=\"\"><md-input-container class=\"facilitySelect md-block\"><label>{{::\'FACILITY\' | translate}}</label><md-select ng-model=\"vm.messages.selectedFacilitySerial\"><md-option ng-repeat=\"facility in vm.messages.facilities\" value=\"{{facility.deviceSerial}}\">{{facility.name | translate}}</md-option></md-select></md-input-container><md-input-container><md-button class=\"md-button md-raised\" ng-disabled=\"filterForm.$invalid\" ng-click=\"vm.searchMessages()\">{{::\'APPLY\' | translate}}</md-button><md-tooltip>{{::\'APPLY\' | translate}}</md-tooltip></md-input-container></div></form><md-divider></md-divider><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'FILTERED_MESSAGES\' | translate}}</span></div><md-content flex=\"\" class=\"md-whiteframe-z1\"><md-table-container id=\"tableContainer\"><table md-table=\"\" md-row-select=\"false\" multiple=\"false\" ng-model=\"vm.messages.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.messages.alarmsOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\"><span>#</span></th><th md-column=\"\" md-order-by=\"timestamp\" md-desc=\"\"><span>{{::\'DATE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"location\">{{::\'LOCATION\' | translate}}</th><th md-column=\"\" md-order-by=\"message\">{{::\'MESSAGE\' | translate}}</th><th md-column=\"\" md-order-by=\"collapseKey\">{{::\'TYPE\' | translate}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"message in vm.messages.alarmsData\"><td md-cell=\"\"><span>{{vm.itemNumbering($index)}}</span></td><td md-cell=\"\">{{::message.timestamp | date : \'medium\'}}</td><td md-cell=\"\">{{::message.details}}</td><td md-cell=\"\">{{::message.content | translate}}</td><td md-cell=\"\" ng-if=\"message.collapseKey == \'alarm\'\"><div class=\"messageAlarmIcon\"></div></td><td md-cell=\"\" ng-if=\"message.collapseKey == \'info\'\"><div class=\"messageInfoIcon\"></div></td><td md-cell=\"\" ng-if=\"message.collapseKey == \'dismissed\'\"><div class=\"messageDismissIcon\"></div></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit=\"vm.messages.alarmsPageSize\" md-page=\"vm.messages.alarmsPage\" md-options=\"vm.messages.alarmsPageOptions\" md-total=\"{{vm.messages.alarmsTotal}}\" md-page-select=\"true\" md-boundary-links=\"true\" md-label=\"{{vm.messages.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\"></md-table-pagination></div></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/cashlessPaymentRefund/cashlessPaymentRefund.html","<div class=\"fullWidth overflow-vertical-wrapper\"><md-content flex=\"\"><div layout=\"column\" layout-margin=\"\" id=\"alarmsContainer\" ng-cloak=\"\"><form ng-submit=\"vm.searchCashlessPayments()\" name=\"cashlessFilterForm\" class=\"filterForm md-inline-form\" layout-lg=\"row\" layout-gt-lg=\"row\" layout=\"column\" layout-align-gt-lg=\"start start\" layout-align-lg=\"start start\" layout-align=\"start end\" layout-padding=\"\" no-validate=\"\"><div layout-lg=\"row\" layout-gt-lg=\"row\" layout=\"column\" flex=\"100\" flex-lg=\"80\" flex-gt-lg=\"60\" class=\"fullWidth\"><md-input-container class=\"md-block\" flex=\"100\" flex-lg=\"25\" flex-gt-lg=\"25\"><label>{{::\'FROM\' | translate}}</label><md-datepicker ng-model=\"vm.cashlessPaymentRefundVM.since\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-max-date=\"vm.cashlessPaymentRefundVM.until\"></md-datepicker></md-input-container><md-input-container class=\"md-block\" flex=\"100\" flex-lg=\"25\" flex-gt-lg=\"25\"><label>{{::\'TO\' | translate}}</label><md-datepicker ng-model=\"vm.cashlessPaymentRefundVM.until\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-min-date=\"vm.cashlessPaymentRefundVM.since\" ng-change=\"vm.toDateSelected()\"></md-datepicker></md-input-container><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearCashlessFilterInput()\"></md-icon><md-input-container class=\"md-block\" flex=\"\"><label>{{::\'FILTER\' | translate}}</label> <input name=\"cashlessFilter\" ng-model=\"vm.cashlessPaymentRefundVM.filter\" type=\"text\"></md-input-container></div><div><md-button type=\"submit\" class=\"md-raised md-primary\" ng-disabled=\"cashlessFilterForm.$invalid || !cashlessFilterForm.$dirty\">{{::\'APPLY\' | translate}}</md-button><md-tooltip>{{::\'APPLY\' | translate}}</md-tooltip></div><div><md-button class=\"md-raised md-primary paddingLeft20 paddingRight20\" ng-disabled=\"vm.cashlessPaymentRefundVM.cashlessPaymentAndRefundList[0].hideButton\" ng-click=\"vm.exportToCsvReports()\" aria-label=\"Download CSV\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button><md-tooltip>{{::\'DOWNLOAD_CSV\' | translate}}</md-tooltip></div></form><md-divider></md-divider><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'FILTERED_CASHLESS_PAYMENTS\' | translate}}</span></div><md-content flex=\"\" class=\"md-whiteframe-z1\"><md-table-container id=\"tableContainer\"><table md-table=\"\" md-row-select=\"false\" multiple=\"false\" ng-model=\"vm.cashlessPaymentRefundVM.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.cashlessPaymentRefundVM.orderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"user\"><span>{{::\'USER\' | translate}}</span></th><th md-column=\"\" md-order-by=\"pspReference\"><span>{{::\'TRANSACTION_ID\' | translate}}</span></th><th md-column=\"\" md-order-by=\"timestamp\">{{::\'CAPTURED\' | translate}}</th><th md-column=\"\" md-order-by=\"valueDate\">{{::\'VALUE_DATE\' | translate}}</th><th md-column=\"\" md-order-by=\"type\">{{::\'TYPE\' | translate}}</th><th md-column=\"\" md-order-by=\"pointName\">{{::\'DEVICE_ID\' | translate}}</th><th md-column=\"\" md-order-by=\"facilityName\">{{::\'FACILITY_NAME\' | translate}}</th><th md-column=\"\">{{::\'NET_AMOUNT\' | translate}}</th><th md-column=\"\">{{::\'AMOUNT\' | translate}}</th><th md-column=\"\"></th></tr><tr md-row=\"\"><th md-column=\"\">{{::\'LOYALTY_TOTAL\' | translate}}</th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\"></th><th md-column=\"\">{{vm.cashlessPaymentRefundVM.totalNetAmount}}</th><th md-column=\"\">{{vm.cashlessPaymentRefundVM.totalAmount}}</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"payment in vm.cashlessPaymentRefundVM.cashlessPaymentAndRefundList\"><td md-cell=\"\">{{ payment.user }}</td><td md-cell=\"\">{{ payment.pspReference }}</td><td md-cell=\"\">{{ payment.timestamp | date: \'medium\' }}</td><td md-cell=\"\">{{ payment.valueDate | date: \'medium\' }}</td><td md-cell=\"\">{{ payment.type }}</td><td md-cell=\"\">{{ payment.pointName }}</td><td md-cell=\"\">{{ payment.facilityName }}</td><td md-cell=\"\">{{ payment.netAmount }}</td><td md-cell=\"\">{{ payment.amount }}</td><td md-cell=\"\" class=\"centerText\"><md-button ng-if=\"payment.refundedAmount === 0 && !payment.hideButton\" class=\"md-button md-raised\" ng-click=\"vm.refundPayment($event, payment.amount, payment.pspReference)\">{{::\'REFUND\' | translate}}</md-button><span ng-if=\"payment.refundedAmount !== 0 && !payment.hideButton\" class=\"refund-item-wrapper\">{{ payment.refundedAmount }} {{ payment.code }}</span></td></tr></tbody></table></md-table-container></md-content><md-table-pagination md-limit=\"vm.cashlessPaymentRefundVM.pageSize\" md-page=\"vm.cashlessPaymentRefundVM.page\" md-options=\"vm.cashlessPaymentRefundVM.pageOptions\" md-total=\"{{vm.cashlessPaymentRefundVM.total}}\" md-page-select=\"true\" md-boundary-links=\"true\" md-label=\"{{vm.cashlessPaymentRefundVM.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\"></md-table-pagination></div></md-content></div>");
$templateCache.put("app/createUpdateCampaign/createUpdateCampaign.html","<div flex=\"\" id=\"createUpdateCampaign\" layout=\"column\" layout-margin=\"\" ng-cloak=\"\"><div class=\"md-title customCardTitle\">{{ vm.campaign.title }}</div><md-content flex=\"\"><form name=\"campaignForm\" no-validate=\"\" ng-cloak=\"\"><div id=\"campaignHeadContainer\" class=\"\"><div id=\"loyaltyNameContainer\" layout=\"\"><md-input-container flex-gt-md=\"50\" class=\"md-block\"><label>{{::\'CAMPAIGN_NAME\' | translate}}</label> <input ng-disabled=\"vm.campaign.isEditMode\" name=\"campaignName\" ng-model=\"vm.campaign.name\" placeholder=\"\" required=\"\"><div ng-messages=\"campaignForm.campaignName.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><md-button class=\"md-warn defaultButton\" ng-click=\"vm.cancelChanges()\" aria-label=\"Cancel updating campaign\">{{::\'CANCEL\' | translate}}</md-button><md-tooltip>{{::\'CANCEL\' | translate}}</md-tooltip></md-input-container><md-input-container><md-button class=\"md-primary defaultButton\" ng-click=\"vm.saveChanges()\" aria-label=\"Save changes\" ng-disabled=\"campaignForm.$invalid || vm.campaign.isEditMode || vm.checkIfDayIsSelected\">{{::\'SAVE_CHANGES\' | translate}}</md-button><md-tooltip>{{vm.campaign.isEditMode ? (\'UPDATE_CAMPAIGN\' | translate) : ( \'CREATE_CAMPAIGN\' | translate)}}</md-tooltip></md-input-container></div><div id=\"loyaltyDateContainer\" layout=\"\" layout-xs=\"column\"><md-input-container class=\"md-icon-float md-block datePicker\" flex=\"\" flex-xl=\"15\" flex-md=\"40\" flex-sm=\"30\" flex-xs=\"100\"><label>{{::\'FROM\' | translate}}</label><md-datepicker md-placeholder=\"Enter date\" ng-disabled=\"vm.campaign.isEditMode\" name=\"fromDatePicker\" md-open-on-focus=\"\" ng-model=\"vm.campaign.from\" md-max-date=\"vm.campaign.to\"></md-datepicker><div ng-messages=\"campaignForm.fromDatePicker.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div><div ng-message=\"valid\">{{::\'VALIDATION_NOT_A_DATE\' | translate}}</div><div ng-message=\"maxdate\">{{::\'VALIDATION_TO\' | translate}}</div></div></md-input-container><md-input-container class=\"md-icon-float md-block datePicker\" flex=\"\" flex-xl=\"15\" flex-md=\"40\" flex-sm=\"30\" flex-xs=\"100\"><label>{{::\'TO\' | translate}}</label><md-datepicker md-placeholder=\"Enter date\" ng-disabled=\"vm.campaign.isEditMode\" name=\"toDatePicker\" md-open-on-focus=\"\" ng-model=\"vm.campaign.to\" md-min-date=\"vm.campaign.from\"></md-datepicker><div ng-messages=\"campaignForm.toDatePicker.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div><div ng-message=\"valid\">{{::\'VALIDATION_NOT_A_DATE\' | translate}}</div><div ng-message=\"mindate\">{{::\'VALIDATION_TO\' | translate}}</div></div></md-input-container></div></div><div flex=\"\" id=\"campaignContainer\" layout=\"column\" layout-gt-md=\"row\" style=\"padding:0;\"><md-card class=\"rulesList\" flex-gt-md=\"70\" layout-padding=\"\"><md-card-content class=\"dialContainer\"><md-button ng-disabled=\"vm.campaign.isEditMode || vm.campaign.numberOfVisitsRule !== null\" aria-label=\"By number of visits\" class=\"md-fab md-primary md-raised md-mini\" ng-click=\"vm.campaign.addNewByVisits()\"><md-icon md-svg-src=\"assets/icons/ic_local_car_wash_white_24px.svg\" aria-label=\"By number of visits\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS\' | translate}}</md-tooltip></md-button><md-button ng-disabled=\"vm.campaign.isEditMode || vm.campaign.amountOfMoneyRule !== null\" aria-label=\"By money spent\" class=\"md-fab md-primary md-raised md-mini\" ng-click=\"vm.campaign.addNewByMoneySpent()\"><md-icon md-svg-src=\"assets/icons/ic_payment_white_24px.svg\" aria-label=\"By money spent\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT\' | translate}}</md-tooltip></md-button><md-button ng-disabled=\"vm.campaign.isEditMode || vm.campaign.dailyTemporalRule !== null\" aria-label=\"By day\" class=\"md-fab md-primary md-raised md-mini\" ng-click=\"vm.campaign.addNewByDay()\" ng-if=\"vm.brand !== \'karcher\'\"><md-icon md-svg-src=\"assets/icons/ic_today_white_24px.svg\" aria-label=\"By day\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS\' | translate}}</md-tooltip></md-button></md-card-content><div class=\"ruleTitle\" ng-if=\"vm.campaign.numberOfVisitsRule === null && vm.campaign.amountOfMoneyRule === null && vm.campaign.dailyTemporalRule === null\">{{::\'CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST\' | translate}}</div><div layout=\"column\"><div flex=\"\" ng-if=\"vm.campaign.numberOfVisitsRule\" class=\"ruleTitle\">{{::\'CAMPAIGN_TEMPLATE_NUMBER_OF_VISITS_RULE\' | translate}}</div><div class=\"ruleRow\" ng-if=\"vm.campaign.numberOfVisitsRule\" layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"vm.campaign.isEditMode\" class=\"md-fab md-mini md-warn\" ng-click=\"vm.removeCampaignRule(vm.campaign.numberOfVisitsRule.type)\"><md-icon md-svg-src=\"assets/icons/ic_remove_circle_white_24px.svg\" aria-label=\"Remove campaign\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_REMOVE_RULE\' | translate}}</md-tooltip></md-button><div layout-wrap=\"\"><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_1\' | translate}}</span><md-input-container class=\"ruleInput\"><input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"visitsValue\" ng-model=\"vm.campaign.numberOfVisitsRule.visits\" ng-pattern=\"/^[1-9]\\d{0,8}$/\" placeholder=\"\" required=\"\"><div ng-messages=\"campaignForm.visitsValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_2_VISITS\' | translate}}</span><md-input-container class=\"ruleInput\"><input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"visitsPeriodValue\" ng-model=\"vm.campaign.numberOfVisitsRule.validityPeriod\" ng-pattern=\"/^[1-9]\\d{0,8}$/\" placeholder=\"\" required=\"\"><div ng-messages=\"campaignForm.visitsPeriodValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_3\' | translate}}</span><md-input-container class=\"ruleInput\"><input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"visitsCreditValue\" ng-model=\"vm.campaign.numberOfVisitsRule.reward.amount\" ng-pattern=\"/^[1-9]\\d{0,8}$/\" placeholder=\"\" required=\"\"><div ng-messages=\"campaignForm.visitsCreditValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_4\' | translate}}</span></div></div><div flex=\"\" ng-if=\"vm.campaign.amountOfMoneyRule\" class=\"ruleTitle\">{{::\'CAMPAIGN_TEMPLATE_AMOUNT_OF_MONEY_RULE\' | translate}}</div><div class=\"ruleRow\" ng-if=\"vm.campaign.amountOfMoneyRule\" layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"vm.campaign.isEditMode\" class=\"md-fab md-mini md-warn\" ng-click=\"vm.removeCampaignRule(vm.campaign.amountOfMoneyRule.type)\"><md-icon md-svg-src=\"assets/icons/ic_remove_circle_white_24px.svg\" aria-label=\"Remove campaign\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_REMOVE_RULE\' | translate}}</md-tooltip></md-button><div layout-wrap=\"\"><span flex=\"none\">{{ vm.brand === \'karcher\' ? \'CAMPAIGN_TEMPLATE_RULE_1_KARCHER\' : \'CAMPAIGN_TEMPLATE_RULE_1\' | translate}}</span><md-input-container class=\"ruleInput\"><input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"moneyValue\" ng-model=\"vm.campaign.amountOfMoneyRule.moneySpent.amount\" ng-pattern=\"/^[1-9]\\d{0,8}$/\" placeholder=\"\" required=\"\"><div ng-messages=\"campaignForm.moneyValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_2_CREDITS\' | translate}}</span><md-input-container class=\"ruleInput\"><input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"moneyPeriodValue\" ng-model=\"vm.campaign.amountOfMoneyRule.validityPeriod\" ng-pattern=\"/^[1-9]\\d{0,8}$/\" placeholder=\"\" required=\"\"><div ng-messages=\"campaignForm.moneyPeriodValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_3\' | translate}}</span><md-input-container class=\"ruleInput\"><input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"moneyCreditValue\" ng-pattern=\"/^[1-9]\\d{0,8}$/\" ng-model=\"vm.campaign.amountOfMoneyRule.reward.amount\" placeholder=\"\" required=\"\"><div ng-messages=\"campaignForm.moneyCreditValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_4\' | translate}}</span></div></div><div flex=\"\" ng-if=\"vm.campaign.dailyTemporalRule\" class=\"ruleTitle specRadioButtonWrapper\" layout=\"\" layoutalign=\"space-between center\"><span flex=\"\">{{::\'CAMPAIGN_TEMPLATE_DAILY_TEMPORAL_RULE\' | translate}}</span><md-radio-group ng-model=\"vm.campaign.selectedFacilityType\" ng-disabled=\"vm.campaign.isEditMode\" layout=\"\" layoutalign=\"center center\" ng-repeat=\"facility in vm.campaign.facilityTypes\" ng-change=\"vm.changeFacility(vm.campaign.selectedFacilityType)\"><md-radio-button ng-value=\"facility.id\">{{ facility.name }}</md-radio-button></md-radio-group></div><div class=\"ruleRow\" ng-if=\"vm.campaign.dailyTemporalRule\" layout=\"row\" layout-align=\"start center\"><md-button ng-disabled=\"vm.campaign.isEditMode\" class=\"md-fab md-mini md-warn\" ng-click=\"vm.removeCampaignRule(vm.campaign.dailyTemporalRule.type)\"><md-icon md-svg-src=\"assets/icons/ic_remove_circle_white_24px.svg\" aria-label=\"Remove campaign\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_REMOVE_RULE\' | translate}}</md-tooltip></md-button><div layout=\"column\" layout-align=\"start start\"><div flex=\"\" flex-wrap=\"\"><md-checkbox ng-disabled=\"vm.campaign.isEditMode\" name=\"daysOfWeek\" ng-repeat=\"dayOfWeek in vm.campaign.dailyTemporalRule.daysOfWeek\" ng-model=\"dayOfWeek.selected\" aria-label=\"{{::dayOfWeek.name}}\">{{::dayOfWeek.name | translate}}</md-checkbox></div><div flex=\"\" flex-wrap=\"\"><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_FROM\' | translate}}</span><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate}}</label> <input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"daysFromHoursValue\" ng-model=\"vm.campaign.dailyTemporalRule.hoursFrom\" ng-pattern=\"/^[0-9]{1,2}$/\" placeholder=\"\" required=\"\" min=\"0\" max=\"23\"><div ng-messages=\"campaignForm.daysFromHoursValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div><div ng-message=\"min\">{{::\'VALIDATION_HOURS_VALUE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_HOURS_VALUE\' | translate}}</div></div></md-input-container><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate}}</label> <input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"daysFromMinutesValue\" ng-model=\"vm.campaign.dailyTemporalRule.minutesFrom\" ng-pattern=\"/^[0-9]{1,2}$/\" placeholder=\"\" required=\"\" min=\"0\" max=\"59\"><div ng-messages=\"campaignForm.daysFromMinutesValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div><div ng-message=\"min\">{{::\'VALIDATION_MINUTES_VALUE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_MINUTES_VALUE\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_TO\' | translate}}</span><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate}}</label> <input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"daysToHoursValue\" ng-model=\"vm.campaign.dailyTemporalRule.hoursTo\" ng-pattern=\"/^[0-9]{1,2}$/\" placeholder=\"\" required=\"\" min=\"0\" max=\"23\"><div ng-messages=\"campaignForm.daysToHoursValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div><div ng-message=\"min\">{{::\'VALIDATION_HOURS_VALUE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_HOURS_VALUE\' | translate}}</div></div></md-input-container><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate}}</label> <input ng-disabled=\"vm.campaign.isEditMode\" type=\"number\" name=\"daysToMinutesValue\" ng-model=\"vm.campaign.dailyTemporalRule.minutesTo\" ng-pattern=\"/^[0-9]{1,2}$/\" placeholder=\"\" required=\"\" min=\"0\" max=\"59\"><div ng-messages=\"campaignForm.daysToMinutesValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div><div ng-message=\"min\">{{::\'VALIDATION_MINUTES_VALUE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_MINUTES_VALUE\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_GIVE\' | translate}}</span><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_CREDITS\' | translate}}</label> <input ng-disabled=\"vm.campaign.isEditMode || !vm.campaign.selectedFacilityType\" type=\"number\" name=\"daysCreditValue\" ng-model=\"vm.campaign.dailyTemporalRule.reward.amount\" ng-change=\"vm.checktemporalRule(vm.campaign.dailyTemporalRule.reward.amount)\" min=\"1\" max=\"999\" placeholder=\"\" required=\"\"><md-tooltip md-direction=\"bottom\" ng-if=\"!vm.campaign.selectedFacilityType\">{{::\'CAMPAIGN_TEMPLATE_RULE_CREDITS_TOOLTIP\' | translate}}</md-tooltip><div ng-messages=\"campaignForm.daysCreditValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"validationError\">{{::\'DIVISIBLE_TO_NUMBER\' | translate}}: {{ vm.campaign.temporalRulePercentageValue }}</div><div ng-message=\"min\">{{::\'VALIDATION_PERCENT_VALUE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_PERCENT_VALUE\' | translate}}</div></div></md-input-container></div></div></div></div></md-card><md-card class=\"searchContainer\" flex-gt-md=\"30\"><md-input-container class=\"searchInput\"><label>{{::\'SEARCH\' | translate}}</label> <input ng-model=\"searchGroups\" type=\"text\"></md-input-container><md-card-content><md-list><md-subheader class=\"md-no-sticky\">{{::\'ASIDE_MENU_USER_GROUPS\' | translate}}</md-subheader><md-content class=\"userGroupsList\" style=\"overflow-x:hidden;\"><md-list-item ng-repeat=\"group in vm.campaign.groups | filter: searchGroups\"><p>{{ group.name }}</p><md-checkbox ng-disabled=\"vm.campaign.isEditMode\" class=\"md-secondary\" ng-model=\"group.selected\" ng-change=\"vm.campaign.onSelectGroupChanged(group)\"></md-checkbox><md-divider></md-divider></md-list-item></md-content></md-list></md-card-content></md-card></div></form></md-content></div>");
$templateCache.put("app/createUpdateCampaignTemplate/createUpdateCampaignTemplate.html","<div flex=\"\" layout=\"column\" id=\"createUpdateCampaignTemplate\" ng-cloak=\"\"><div class=\"md-title title\">{{::vm.template.title}}</div><md-content><form flex=\"\" layout-padding=\"\" name=\"templateForm\" no-validate=\"\"><md-input-container class=\"md-block\"><label>{{::\'CAMPAIGN_TEMPLATE_NAME\' | translate}}</label> <input name=\"templateName\" ng-model=\"vm.template.name\" placeholder=\"\" required=\"\"><div ng-messages=\"templateForm.templateName.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_NAME_REQUIRED\' | translate}}</div></div></md-input-container><div class=\"dialContainer\"><md-button aria-label=\"By number of visits\" class=\"md-fab md-primary md-raised md-mini\" ng-click=\"vm.template.addNewByVisits()\"><md-icon md-svg-src=\"assets/icons/ic_local_car_wash_white_24px.svg\" aria-label=\"By number of visits\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_BY_NUMBER_OF_VISITS\' | translate}}</md-tooltip></md-button><md-button aria-label=\"By money spent\" class=\"md-fab md-primary md-raised md-mini\" ng-click=\"vm.template.addNewByMoneySpent()\"><md-icon md-svg-src=\"assets/icons/ic_payment_white_24px.svg\" aria-label=\"By money spent\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_BY_AMOUNT_OF_MONEY_SPENT\' | translate}}</md-tooltip></md-button><md-button aria-label=\"By day\" class=\"md-fab md-primary md-raised md-mini\" ng-click=\"vm.template.addNewByDay()\"><md-icon md-svg-src=\"assets/icons/ic_today_white_24px.svg\" aria-label=\"By day\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_BY_DAILY_ACTIONS\' | translate}}</md-tooltip></md-button></div><div class=\"ruleTitle\" ng-if=\"vm.template.rules.length === 0\">{{::\'CAMPAIGN_TEMPLATE_EMPTY_RULES_LIST\' | translate}}</div><div ng-repeat=\"rule in vm.template.rules\"><div class=\"ruleTitle\">{{::\'CAMPAIGN_TEMPLATE_RULE\' | translate}}</div><div class=\"ruleRow\" ng-if=\"rule.type === \'NUM_OF_VISITS\'\" layout=\"row\" layout-align=\"start center\"><md-button flex=\"none\" class=\"md-fab md-mini md-warn\" ng-click=\"vm.template.removeRule($index)\"><md-icon md-svg-src=\"assets/icons/ic_remove_circle_white_24px.svg\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_REMOVE_RULE\' | translate}}</md-tooltip></md-button><div layout-wrap=\"\"><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_1\' | translate}}</span><md-input-container class=\"ruleInput\"><input type=\"number\" name=\"visitsValue\" ng-model=\"rule.visits\" ng-pattern=\"/^[0-9]{1,6}$/\" placeholder=\"\" required=\"\"><div ng-messages=\"templateForm.visitsValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_2_VISITS\' | translate}}</span><md-input-container class=\"ruleInput\"><input type=\"number\" name=\"visitsPeriodValue\" ng-model=\"rule.validityPeriod\" ng-pattern=\"/^[0-9]{1,6}$/\" placeholder=\"\" required=\"\"><div ng-messages=\"templateForm.visitsPeriodValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_3\' | translate}}</span><md-input-container class=\"ruleInput\"><input type=\"number\" name=\"visitsCreditValue\" ng-model=\"rule.credits\" placeholder=\"\" required=\"\"><div ng-messages=\"templateForm.visitsCreditValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_4\' | translate}}</span></div></div><div class=\"ruleRow\" ng-if=\"rule.type === \'MONEY_SPENT\'\" layout=\"row\" layout-align=\"start center\"><md-button flex=\"none\" class=\"md-fab md-mini md-warn\" ng-click=\"vm.template.removeRule($index)\"><md-icon md-svg-src=\"assets/icons/ic_remove_circle_white_24px.svg\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_REMOVE_RULE\' | translate}}</md-tooltip></md-button><div layout-wrap=\"\"><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_1\' | translate}}</span><md-input-container class=\"ruleInput\"><input type=\"number\" name=\"moneyValue\" ng-model=\"rule.money\" placeholder=\"\" required=\"\"><div ng-messages=\"templateForm.moneyValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_2_CREDITS\' | translate}}</span><md-input-container class=\"ruleInput\"><input type=\"number\" name=\"moneyPeriodValue\" ng-model=\"rule.validityPeriod\" ng-pattern=\"/^[0-9]{1,6}$/\" placeholder=\"\" required=\"\"><div ng-messages=\"templateForm.moneyPeriodValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_3\' | translate}}</span><md-input-container class=\"ruleInput\"><input type=\"number\" name=\"moneyCreditValue\" ng-model=\"rule.credits\" placeholder=\"\" required=\"\"><div ng-messages=\"templateForm.moneyCreditValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_4\' | translate}}</span></div></div><div class=\"ruleRow\" ng-if=\"rule.type === \'DAILY_TEMPORAL\'\" layout=\"row\" layout-align=\"start center\"><md-button flex=\"none\" class=\"md-fab md-mini md-warn\" ng-click=\"vm.template.removeRule($index)\"><md-icon md-svg-src=\"assets/icons/ic_remove_circle_white_24px.svg\"></md-icon><md-tooltip>{{::\'CAMPAIGN_TEMPLATE_REMOVE_RULE\' | translate}}</md-tooltip></md-button><div layout=\"column\" layout-align=\"start start\"><div flex=\"\" flex-wrap=\"\"><md-checkbox ng-repeat=\"dayOfWeek in rule.daysOfWeek\" ng-model=\"dayOfWeek.selected\" aria-label=\"{{::dayOfWeek.name}}\">{{::dayOfWeek.name | translate}}</md-checkbox></div><div flex=\"\" flex-wrap=\"\"><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_FROM\' | translate}}</span><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate}}</label> <input type=\"number\" name=\"daysFromHoursValue\" ng-model=\"rule.hoursFrom\" ng-pattern=\"/^[0-9]{1,2}$/\" placeholder=\"\" required=\"\" min=\"0\" max=\"23\"><div ng-messages=\"templateForm.daysFromHoursValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div><div ng-message=\"min\">{{::\'VALIDATION_HOURS_VALUE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_HOURS_VALUE\' | translate}}</div></div></md-input-container><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate}}</label> <input type=\"number\" name=\"daysFromMinutesValue\" ng-model=\"rule.minutesFrom\" ng-pattern=\"/^[0-9]{1,2}$/\" placeholder=\"\" required=\"\" min=\"0\" max=\"59\"><div ng-messages=\"templateForm.daysFromMinutesValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div><div ng-message=\"min\">{{::\'VALIDATION_MINUTES_VALUE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_MINUTES_VALUE\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_TO\' | translate}}</span><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate}}</label> <input type=\"number\" name=\"daysToHoursValue\" ng-model=\"rule.hoursTo\" ng-pattern=\"/^[0-9]{1,2}$/\" placeholder=\"\" required=\"\" min=\"0\" max=\"23\"><div ng-messages=\"templateForm.daysToHoursValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div><div ng-message=\"min\">{{::\'VALIDATION_HOURS_VALUE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_HOURS_VALUE\' | translate}}</div></div></md-input-container><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate}}</label> <input type=\"number\" name=\"daysToMinutesValue\" ng-model=\"rule.minutesTo\" ng-pattern=\"/^[0-9]{1,2}$/\" placeholder=\"\" required=\"\" min=\"0\" max=\"59\"><div ng-messages=\"templateForm.daysToMinutesValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'VALIDATION_INTEGER_NUMBER\' | translate}}</div><div ng-message=\"min\">{{::\'VALIDATION_MINUTES_VALUE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_MINUTES_VALUE\' | translate}}</div></div></md-input-container><span flex=\"none\">{{::\'CAMPAIGN_TEMPLATE_RULE_GIVE\' | translate}}</span><md-input-container class=\"ruleInput\"><label>{{::\'CAMPAIGN_TEMPLATE_RULE_CREDITS\' | translate}}</label> <input type=\"number\" name=\"daysCreditValue\" ng-model=\"rule.credits\" placeholder=\"\" required=\"\"><div ng-messages=\"templateForm.daysCreditValue.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'CAMPAIGN_TEMPLATE_RULE_REQUIRED\' | translate}}</div></div></md-input-container></div></div></div></div></form></md-content><div layout=\"\" layout-align=\"end center\" class=\"actions\"><md-button class=\"md-fab md-warn\" ng-click=\"vm.cancelChanges()\" aria-label=\"Cancel updating user group\"><md-icon md-svg-src=\"assets/icons/ic_close_white_24px.svg\"></md-icon><md-tooltip>{{::\'CANCEL\' | translate}}</md-tooltip></md-button><md-button ng-disabled=\"templateForm.$invalid\" class=\"md-fab md-primary\" aria-label=\"Update user group\" ng-click=\"vm.saveChanges()\"><md-icon md-svg-src=\"assets/icons/ic_check_white_24px.svg\"></md-icon><md-tooltip>{{::\'UPDATE_USER_GROUP\' | translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/createUpdateUserGroup/createUpdateUserGroup.html","<div flex=\"\" layout=\"column\" id=\"createUpdateUserGroup\"><div class=\"md-title customCardTitle\">{{::vm.group.title}}</div><p class=\"md-caption createGroupInfo\" ng-if=\"!vm.group.isEditMode\">{{::\'ENTER_USER_GROUP_NAME_TO_CONTINUE\' | translate}}</p><div id=\"createGroupCardContainer\" class=\"md-whiteframe-z1\"><form layout=\"\" layout-xs=\"column\" layout-padding=\"\" name=\"groupForm\" no-validate=\"\"><md-input-container class=\"md-block createGroupInput\" flex=\"\" flex-xl=\"50\" flex-lg=\"50\" flex-md=\"60\" flex-sm=\"60\"><label>{{::\'USER_GROUP_NAME\' | translate}}</label> <input name=\"groupName\" ng-model=\"vm.group.groupName\" placeholder=\"\" required=\"\" ng-maxlength=\"255\" md-maxlength=\"255\" ng-model-options=\"{ updateOn: \'default blur\', debounce: {\'default\': 50, \'blur\': 0 } }\" ng-keyup=\"$event.keyCode == 13 && vm.createUpdateGroup($event)\"><div ng-messages=\"groupForm.groupName.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'USER_GROUP_NAME_REQUIRED\' | translate}}</div><div ng-message=\"maxlength\">{{::\'GROUP_NAME_MAX_LENGTH\' | translate}}</div></div></md-input-container><div layout=\"\" layout-align=\"start center\" flex=\"\"><md-input-container><md-button class=\"md-warn defaultButton\" ui-sref=\"app.userGroups\" aria-label=\"Cancel updating campaign\">{{::\'CANCEL\' | translate}}<md-tooltip>{{::\'CANCEL\' | translate}}</md-tooltip></md-button></md-input-container><md-input-container><md-button class=\"md-primary defaultButton\" ng-disabled=\"!groupForm.$dirty\" ng-click=\"vm.createUpdateGroup($event)\">{{::\'SAVE_CHANGES\' | translate}}<md-tooltip>{{::\'BREAD_CRUMBS_NEW_USER_GROUP\' | translate}}</md-tooltip></md-button></md-input-container></div></form><div layout-padding=\"\" ng-show=\"vm.group.isEditMode\"><div layout=\"row\" layout-align=\"start center\"><form layout=\"\" layout-padding=\"\" name=\"searchUserForm\" no-validate=\"\" flex=\"\"><md-input-container class=\"md-block\" flex=\"30\"><label>{{::\'ADD_USER_TO_GROUP\' | translate}}</label> <input name=\"userName\" ng-model=\"vm.group.searchUserText\" ng-pattern=\"/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$/\" required=\"\"><div ng-messages=\"searchUserForm.userName.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div><div ng-message=\"pattern\">{{::\'EMAIL_NOT_VALID\' | translate}}</div></div></md-input-container><md-button class=\"md-fab md-mini md-primary createGroupAddUser\" ng-disabled=\"searchUserForm.$invalid\" aria-label=\"Add user to group\" ng-click=\"vm.addUserToGroup(vm.group.searchUserText)\"><md-icon md-svg-src=\"assets/icons/ic_add_circle_white_24px.svg\"></md-icon><md-tooltip>{{::\'ADD_USER_TO_GROUP\' | translate}}</md-tooltip></md-button><md-button class=\"md-fab md-mini md-primary\" type=\"file\" ngf-select=\"vm.uploadFile($file, $invalidFiles)\" accept=\".csv\" ngf-max-height=\"1000\" ngf-max-size=\"1MB\" aria-label=\"Upload user group\"><md-icon md-svg-src=\"assets/icons/ic_file_upload_white_24px.svg\"></md-icon><md-tooltip>{{::\'UPLOAD_USER_GROUP\' | translate}}</md-tooltip></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Add user to group\" ng-if=\"vm.uknownUserList.length >0\" ng-click=\"vm.showListOfUknownUsers()\"><md-icon md-svg-src=\"assets/icons/ic_info_outline_white_24px.svg\"></md-icon><md-tooltip>{{::\'UKNOWN_USERS\' | translate}}</md-tooltip></md-button><div id=\"searchUserValidation\" ng-if=\"vm.searchUserValidation\"><p>{{::\'USER_IS_ALREADY_IN_GROUP_NOTIFICATION\' | translate}}</p></div></form></div><md-table-container style=\"max-height:30em;\"><table md-table=\"\" ng-model=\"vm.group.groupUser\" md-progress=\"vm.usersPromise\"><thead md-head=\"\" md-order=\"vm.group.usersOrderBy\" md-on-reorder=\"vm.onUsersOrderChange\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"user.email\">{{::\'USERNAME\' | translate}}</th><th md-column=\"\" md-order-by=\"user.firstName\">{{::\'FIRST_NAME\' | translate}}</th><th md-column=\"\" md-order-by=\"user.lastName\">{{::\'LAST_NAME\' | translate}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"groupUser in vm.group.groupUsers\" md-select=\"groupUser\" ng-class=\"{\'deletedUserRow\' : groupUser.status !== \'ACTIVE\' }\"><td md-cell=\"\"><md-button class=\"md-fab md-mini md-warn\" ng-click=\"vm.removeUserFromGroup(groupUser)\" ng-show=\"{{groupUser.status === \'ACTIVE\'}}\"><md-icon md-svg-src=\"assets/icons/ic_remove_circle_white_24px.svg\"></md-icon><md-tooltip>{{::\'REMOVE_USER_FROM_GROUP\' | translate}}</md-tooltip></md-button><md-button class=\"md-fab md-mini md-primary\" ng-click=\"vm.removeUserFromGroup(groupUser)\" ng-show=\"{{groupUser.status === \'DISABLED\'}}\"><md-icon md-svg-src=\"assets/icons/ic_add_circle_white_24px.svg\"></md-icon><md-tooltip>{{::\'ADD_USER_TO_GROUP\' | translate}}</md-tooltip></md-button></td><td md-cell=\"\">{{groupUser.user.email}}</td><td md-cell=\"\" show-gt-sm=\"\">{{groupUser.user.firstName}}</td><td md-cell=\"\" show-gt-sm=\"\">{{groupUser.user.lastName}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.group.usersPageSize\" md-limit-options=\"{{vm.group.usersPageOptions}}\" md-page=\"vm.group.usersPage\" md-total=\"{{vm.group.usersTotal}}\" md-page-select=\"true\" md-boundary-links=\"true\" md-label=\"{{vm.group.pagerTranslations}}\" md-on-paginate=\"vm.onUsersPageChange\"></md-table-pagination></div></div></div>");
$templateCache.put("app/createUpdateUserGroup/uknownUserListModal.html","<md-dialog aria-label=\"Update user info modal\" flex-lg=\"50\" flex-xl=\"40\" flex-md=\"60\" flex-sm=\"80\" flex-xs=\"90\"><md-toolbar><div class=\"md-toolbar-tools\" style=\"color:white;text-transform:uppercase;font-size:15px;\"><h2>{{::\'UKNOWN_USERS\' | translate}}</h2></div></md-toolbar><md-dialog-content layout-padding=\"\"><div class=\"md-dialog-content\" layout=\"column\" ng-repeat=\"user in vm.userList\" style=\"padding: 0 24px;\"><p><span style=\"padding-right: 1rem; font-weight: 700;\">{{user.id}}.</span>{{user.email}}</p></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeDialog()\">{{::\'OK\' | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/dashboardFinances/dashboardFinances.html","<div flex=\"\" id=\"dashboardFinancesContainer\" layout=\"column\" layout-padding=\"\"><div class=\"totalInfoContainer\"><div class=\"md-caption\">{{::\'DAILY_FINANCES_TOTAL_MONEY_ALL\' | translate}}</div><div class=\"md-display-1\">{{vm.dashboard.totalMoney | currency: vm.dashboard.currencyCode}}</div><div class=\"md-caption\">{{::\'ECOM_AMOUNT\' | translate}}<p class=\"customCardSubTitle noMargin\">{{vm.dashboard.ecomAmount | currency: vm.dashboard.currencyCode}}</p></div></div><md-content layout=\"row\" layout-wrap=\"\"><md-card flex=\"\" flex-xs=\"100\" flex-sm=\"100\" flex-md=\"100\" flex-lg=\"30\" flex-gt-lg=\"30\" layout-margin=\"\" ng-repeat=\"facilityFinances in vm.dashboard.finances\" class=\"dallyFinanceCard\"><div class=\"locationContainer\"><md-icon md-svg-src=\"assets/icons/ic_location_on_black_24px.svg\" class=\"locationIcon\"></md-icon><span>{{facilityFinances.chartData.facilityName | truncate: 21}}<md-tooltip ng-if=\"facilityFinances.chartData.facilityName.length > 21\" md-direction=\"right\">{{facilityFinances.chartData.facilityName}}</md-tooltip></span></div><div layout=\"row\" layout-xs=\"column\" layout-wrap=\"\"><div flex=\"\" class=\"totalInfoContainer\" flex-xs=\"100\"><div class=\"md-caption\" flex=\"\">{{::\'DAILY_FINANCES_TOTAL_MONEY\' | translate}}</div><div class=\"currencyTitle\" flex=\"\">{{facilityFinances.totalPayments | currency: vm.dashboard.currencyCode}}</div></div><div flex=\"\" class=\"totalInfoContainer\" flex-xs=\"100\"><div class=\"md-caption\">{{::\'DAILY_FINANCES_TOTAL_COINS\' | translate}}</div><div class=\"currencyTitle\">{{facilityFinances.tokensCount}}</div></div><div flex=\"\" class=\"totalInfoContainer\" flex-xs=\"100\"><div class=\"md-caption\">{{::\'DAILY_FINANCES_TOTAL_LOCAL_TOKENS\' | translate}}</div><div class=\"currencyTitle\">{{facilityFinances.localTokensCount}}</div></div></div><md-divider></md-divider><daily-finances-chart data=\"facilityFinances.chartData\" chart-id=\"\'dailyChart\' + $index\" currency-code=\"vm.dashboard.currencyCode\"></daily-finances-chart><md-divider></md-divider><div layout=\"row\"><div layout=\"column\"><div flex=\"\" class=\"statusContainer\"><md-icon md-svg-src=\"assets/icons/ic_public_black_18px.svg\"></md-icon><span>{{facilityFinances.status | translate | uppercase}}</span></div><div flex=\"\" class=\"lastUpdateContainer\"><md-icon md-svg-src=\"assets/icons/ic_access_time_black_18px.svg\"></md-icon><span>{{facilityFinances.lastReportTimestamp}}</span></div></div><span flex=\"\"></span><div class=\"downloadCsv\"><md-button class=\"md-raised downloadCsvButton\" ng-click=\"vm.exportToCsv(facilityFinances)\">{{::\'DAILY_FINANCES_DOWNLOAD_CSV\' | translate}}</md-button></div></div></md-card></md-content></div>");
$templateCache.put("app/dashboardKarcherTechnology/dashboardKarcherTechnology.html","<div layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-wrap=\"\" class=\"fullWidth karcher-dashboard-wrapper\"><div layout=\"column\" flex=\"70\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><form novalidate=\"\" name=\"searchSiteForm\" ng-submit=\"vm.searchSites()\" flex=\"\" class=\"map-filter-inputs-wrapper\"><div layout=\"row\" class=\"marginLeft1 marginTop20\"><md-input-container flex=\"30\" class=\"noMargin\"><label>{{::\'SITE_NAME\' | translate}}</label> <input ng-model=\"vm.dashboardKarcherTechnologyVM.siteName\" name=\"siteName\"></md-input-container><md-input-container flex=\"30\" class=\"noMargin paddingLeft20\"><label>{{ \'ALARM_STATUS\' | translate }}</label><md-select ng-model=\"vm.dashboardKarcherTechnologyVM.alarmStatus\" name=\"alarmStatus\" multiple=\"\"><md-optgroup label=\"Status\"><md-option ng-value=\"alarmStatus.value\" ng-repeat=\"alarmStatus in vm.dashboardKarcherTechnologyVM.alarmStatusList\">{{ alarmStatus.name }}</md-option></md-optgroup></md-select></md-input-container><div layout=\"row\" layout-align=\"space-between center\" class=\"fullWidth\"><md-button class=\"marginLeft2\" type=\"submit\" ng-disabled=\"searchSiteForm.$invalid\">{{::\'SEARCH\' | translate}}</md-button><i class=\"material-icons cursorPointer refresh-maps-button\" ng-click=\"vm.returnToInitMap()\">settings_backup_restore<md-tooltip>{{::\'REFRESH_MAPS\' | translate}}</md-tooltip></i></div></div></form><md-content layout=\"column\" flex=\"\"><div flex=\"\" class=\"map-wrapper\"><div id=\"map\"><span class=\"marginLeft2 fade-in-info\">{{ \"LOADING_DATA\" | translate }}</span></div></div><script src=\"https://maps.googleapis.com/maps/api/js?key=AIzaSyATv14tUz1-xK7tY-6hoejr8dU67PbjG_U&loading=async&callback=initMap&v=weekly\" defer=\"\"></script></md-content></div><div layout=\"column\" flex=\"\"><div flex=\"\"><div class=\"alarms-sum-wrapper\"><h3>{{ \'ALERTS\' | translate }}</h3><div layout=\"row\" layout-align=\"space-between center\" class=\"alarms-sum-total cursorPointer\" ng-click=\"vm.getAlarm(true, null, null)\"><span>{{ \'TOTAL_ALARM\' | translate }}</span> <span>{{ vm.dashboardKarcherTechnologyVM.alarmTotal }}</span></div><div layout=\"row\" layout-align=\"space-between center\" class=\"alarms-item-sum-total cursorPointer\" ng-click=\"vm.getAlarm(true, null, \'INFO\')\"><div><md-icon md-svg-src=\"assets/icons/ic_low_alarm.svg\"></md-icon><span class=\"paddingLeft10\">{{ \'LOW_ALARM\' | translate }}</span></div><span>{{ vm.dashboardKarcherTechnologyVM.alarmLow }}</span></div><div layout=\"row\" layout-align=\"space-between center\" class=\"alarms-item-sum-total cursorPointer\" ng-click=\"vm.getAlarm(true, null, \'WARNING\')\"><div><md-icon md-svg-src=\"assets/icons/ic_medium_alarm.svg\"></md-icon><span class=\"paddingLeft10\">{{ \'MEDIUM_ALARM\' | translate }}</span></div><span>{{ vm.dashboardKarcherTechnologyVM.alarmMedium }}</span></div><div layout=\"row\" layout-align=\"space-between center\" class=\"alarms-item-sum-total cursorPointer\" ng-click=\"vm.getAlarm(true, null, \'ALARM\')\"><div><md-icon md-svg-src=\"assets/icons/ic_high_alarm.svg\"></md-icon><span class=\"paddingLeft10\">{{ \'HIGH_ALARM\' | translate }}</span></div><span>{{ vm.dashboardKarcherTechnologyVM.alarmHigh }}</span></div></div><div class=\"device-status-wrapper\" ng-if=\"vm.dashboardKarcherTechnologyVM.facilityAlarmStatuses.length > 0\"><h3>{{ \'DEVICE_STATUS\' | translate }}</h3><div layout=\"row\" layout-align=\"center center\" class=\"noMargin\"><p flex=\"40\" class=\"grayColor smallerText boldText500\">{{ \'TYPE\' | translate }}</p><p flex=\"20\" class=\"centerText grayColor smallerText boldText500 paddingAll10\">{{ \'LOW_ALARM\' | translate }}</p><p flex=\"20\" class=\"centerText grayColor smallerText boldText500 paddingAll10\">{{ \'MEDIUM_ALARM\' | translate }}</p><p flex=\"\" class=\"centerText grayColor smallerText boldText500 paddingAll10\">{{ \'HIGH_ALARM\' | translate }}</p></div><md-divider></md-divider><div layout=\"row\" layout-align=\"center center\" ng-repeat=\"deviceStatus in vm.dashboardKarcherTechnologyVM.facilityAlarmStatuses\"><div flex=\"40\" layout=\"column\" ng-click=\"vm.getAlarm(null, deviceStatus, null)\" class=\"cursorPointer\"><p class=\"noMargin facility-alarm-status-name-title\">{{ deviceStatus.facilityName }}</p><p class=\"noMargin facility-alarm-status-type-title\">{{ deviceStatus.facilityType }}</p></div><p flex=\"20\" class=\"boldText500 centerText\">{{ deviceStatus.lowCount }}</p><p flex=\"20\" class=\"boldText500 centerText\">{{ deviceStatus.mediumCount }}</p><p flex=\"\" class=\"boldText500 centerText\">{{ deviceStatus.alarmCount }}</p></div></div></div><div class=\"check-box-for-gray-map\"><md-checkbox ng-model=\"vm.dashboardKarcherTechnologyVM.mapStyleSelector\" aria-label=\"Map style selector\" ng-click=\"vm.searchSites()\">{{ \'GRAY_MAP\' | translate }}</md-checkbox></div></div></div>");
$templateCache.put("app/dashboardTechnology/dashboardTechnology.html","<md-content flex=\"\" id=\"dashboardContainer\"><div layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"row\" layout-sm=\"row\" layout-wrap=\"\"><md-card flex=\"45\" flex-xl=\"30\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" layout-padding=\"\" class=\"tile\" ng-repeat=\"facility in vm.dashboard.devices\" ng-class=\"{\'deviceAlarm\': vm.brand !== \'karcher\' ? facility.hasAlarms : facility.facilityId === facility.pointId && facility.facilityAlarm, \'offline\': facility.status === \'OFFLINE\', \'deviceInfo\': vm.brand !== \'karcher\' ? facility.hasWarnings : facility.facilityId === facility.pointId && facility.facilityWarning}\"><div flex=\"\" layout=\"column\" class=\"content\"><div id=\"carWashCardHeader\"><div layout=\"\" layout-align=\"start center\"><md-icon md-svg-src=\"assets/icons/ic_location_on_black_24px.svg\" class=\"icon\"></md-icon><span class=\"md-headline\">{{facility.name | truncate: 27}}<md-tooltip ng-if=\"facility.name.length > 27\" md-direction=\"right\">{{facility.name}}</md-tooltip></span></div></div><md-divider></md-divider><div id=\"carWashCardBody\" ng-click=\"vm.details(facility.deviceSerial, facility.status, facility.deviceType)\" flex=\"\" layout=\"column\"><div layout=\"\" layout-align=\"space-between center\" class=\"carWashCardBodyTop\"><div class=\"weather\" layout=\"\" layout-align=\"start end\"><md-icon ng-if=\"facility.deviceType !== \'HHANLE\'\" class=\"icon\" md-svg-src=\"{{facility.weatherIcon}}\"></md-icon><span layout-padding=\"\" ng-if=\"facility.deviceType !== \'SERIAL_485\' && facility.deviceType !== \'HHANLE\'\">{{facility.currentTemperature | number}}&degC</span> <span layout-padding=\"\" ng-if=\"facility.deviceType === \'SERIAL_485\' && facility.deviceType !== \'HHANLE\'\">- - &degC</span></div><div ng-show=\"facility.hasAlarms\"><md-icon class=\"warningIcon\" md-svg-src=\"assets/icons/ic_warning_white_48px.svg\"></md-icon></div><div ng-show=\"facility.hasWarnings && !facility.hasAlarms\"><md-icon class=\"warningIcon\" md-svg-icon=\"assets/icons/ic_info_outline_black_24px.svg\"></md-icon></div></div><div flex=\"\" layout=\"row\" layout-align=\"space-between end\" class=\"carWashCardBodyBottom\"><div><md-icon class=\"icon\" md-svg-src=\"assets/icons/ic_cloud_circle_white_24px.svg\"></md-icon><span>{{facility.status | translate | uppercase}}</span></div><div><md-icon class=\"icon\" md-svg-src=\"assets/icons/ic_access_time_black_18px.svg\"></md-icon><span>{{facility.lastReportTimestamp}}</span></div></div></div></div><div flex=\"\" class=\"overlay\"><md-icon md-svg-src=\"assets/icons/1461873878_service-65.svg\"></md-icon></div></md-card></div></md-content>");
$templateCache.put("app/dashboardTechnology/facilityDetailView.dialog.html","<md-dialog aria-label=\"add new user\" id=\"facilityDetailsDialogContainer\" flex-xs=\"90\" flex-sm=\"70\" flex-lg=\"40\" flex-xl=\"40\"><form name=\"facilityDetailsForm\" ng-submit=\"vm.saveChanges(facilityDetailsForm)\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white;\">{{::\'FACILITY_DETAILS\' | translate}}</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><div id=\"facilityImageContainer\" style=\"text-align:center;\"><div class=\"facilityImage\"><img ngf-thumbnail=\"file || vm.imageLink || \'/assets/images/noun_59149_cc.svg\'\" style=\"width:200px;\"></div><div layout=\"\"><div class=\"facilitySelectContainer\" flex=\"\"><div class=\"facilitySelect\" ngf-select=\"\" ng-model=\"file\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/png\'\" ngf-max-size=\"2MB\">{{::\'SELECT\' | translate}}</div></div><div flex=\"\" class=\"facilityUploadContainer\"><md-button ng-click=\"vm.submit()\" class=\"defaultButton md-primary facilityImageUploadBtn\">{{::\'UPLOAD\' | translate}}</md-button></div></div></div><md-input-container class=\"md-block\"><label>{{::\'FACILITY_NAME\' | translate}}</label> <input type=\"text\" ng-model=\"vm.data.name\" ng-disabled=\"true\" name=\'name\"\"\'></md-input-container><md-input-container class=\"md-block\"><label>{{::\'LOCATION\' | translate}}</label> <input ng-model=\"vm.data.address\" name=\"location\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>{{::\'PHONE\' | translate}} - 1</label> <input ng-model=\"vm.data.phone1\" name=\"phone\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>{{::\'PHONE\' | translate}} - 2</label> <input ng-model=\"vm.data.phone2\" name=\"phone\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>{{::\'WEBSITE\' | translate}}</label> <input ng-model=\"vm.data.website\" name=\"website\" type=\"text\"></md-input-container><md-input-container class=\"md-block\"><label>{{::\'WORKING_HOURS\' | translate}}</label> <textarea ng-model=\"vm.data.workingHours\" name=\"workingHours\" md-maxlength=\"255\" max=\"255\" rows=\"5\"></textarea><div ng-messages=\"facilityDetailsForm.workingHours.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"max\">{{\'MAX_LIMIT_EXCEEDED\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{::\'DESCRIPTION\' | translate}}</label> <textarea name=\"description\" ng-model=\"vm.data.info\" md-maxlength=\"255\" max=\"255\" rows=\"5\"></textarea><div ng-messages=\"facilityDetailsForm.description.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"max\">{{\'MAX_LIMIT_EXCEEDED\' | translate}}</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button type=\"submit\" ng-disabled=\"!facilityDetailsForm.$dirty || facilityDetailsForm.$invalid\">{{::\'SAVE_CHANGES\' | translate}}</md-button><md-button ng-click=\"vm.closeDialog()\">{{::\'CANCEL\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/errorPage/errorPage.html","<md-content class=\"errorPageContainer\" flex=\"\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><div class=\"textContainer md-whiteframe-2dp\"><p>{{vm.error.errorMessage ? vm.error.errorMessage : \"MISSING_PAGE\" | translate}}</p><div class=\"error-page-button-wrapper\"><md-button type=\"button\" ng-click=\"vm.goBack()\">{{::\'TRY_AGAIN\' | translate}}</md-button></div></div></md-content>");
$templateCache.put("app/facilities/facilities.html","<div flex=\"\" layout=\"\" ui-view=\"\"></div>");
$templateCache.put("app/facilityDetails/facilityDetails.html","<div id=\"facilityDetails\" flex=\"\" layout=\"column\" style=\"overflow-y: auto\" layout-margin=\"\" ng-cloak=\"\"><div flex=\"none\" layout=\"\" layout-align=\"start center\" id=\"header\"><span class=\"md-headline\">{{vm.facility.facility.name}}</span><md-button ng-disabled=\"vm.facility.status === \'OFFLINE\'\" class=\"md-fab md-mini\" aria-label=\"Update facility\" ui-sref=\"app.dashboardTechnology.facilityDetails.facilitySettings({id: vm.facility.deviceSerial})\" ng-if=\"vm.checkDeviceTypeBridge && vm.checkDeviceTypeHHanle\"><md-icon md-svg-src=\"assets/icons/ic_settings_white_24px.svg\"></md-icon><md-tooltip>{{::\'UPDATE_FACILITY_SETTINGS\' | translate}}</md-tooltip></md-button></div><div flex=\"none\" layout=\"column\" layout-gt-sm=\"row\" class=\"detailsPreviewDashboard\"><div flex=\"\" class=\"info\" style=\"min-height: 7.5em\"><div class=\"md-caption\">{{::\'STATUS\' | translate}}</div><md-icon class=\"icon\" md-svg-src=\"assets/icons/ic_cloud_circle_white_24px.svg\"></md-icon><span class=\"md-title\">{{vm.facility.status | translate | uppercase}}</span><md-divider layout-margin=\"\"></md-divider><div class=\"md-caption\">{{::\'LAST_SYNCHRONIZATION\' | translate}}</div><md-icon class=\"icon\" md-svg-src=\"assets/icons/ic_access_time_black_18px.svg\"></md-icon><span class=\"md-title\">{{vm.facility.lastReportTimestamp}}</span></div><div flex=\"\" class=\"info\" ng-class=\"{\'warning\': vm.facility.warningsCount > 0, \'error\': vm.facility.alarmsCount > 0}\" style=\"min-height: 7.5em\"><div class=\"md-caption\">{{::\'NO_OF_CURRENT_ALARMS\' | translate}}</div><md-icon class=\"icon\" md-svg-src=\"assets/icons/ic_warning_black_24px.svg\"></md-icon><span class=\"md-title\">{{vm.facility.alarmsCount}}</span><md-divider layout-margin=\"\"></md-divider><div class=\"md-caption\">{{::\'NO_OF_CURRENT_WARNINGS\' | translate}}</div><md-icon class=\"icon\" md-svg-src=\"assets/icons/ic_info_outline_black_24px.svg\"></md-icon><span class=\"md-title\">{{vm.facility.warningsCount}}</span></div><div flex=\"\" class=\"info\" ng-if=\"vm.checkDeviceTypeBridge && vm.checkDeviceTypeHHanle\"><div class=\"md-caption\">{{::\'WEATHER\' | translate}}</div><div layout=\"\" layout-align=\"start center\"><md-icon class=\"icon\" md-svg-src=\"{{vm.facility.facility.weatherIcon}}\"></md-icon><span class=\"md-display-1\">{{vm.facility.facility.currentTemperature | number}}&degC</span></div></div></div><div flex=\"none\" class=\"md-whiteframe-1dp\" id=\"schadaContainer\" ng-if=\"vm.checkDeviceTypeBridge && vm.checkDeviceTypeHHanle\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'TECHNOLOGY\' | translate}}</span></div><div flex=\"none\" layout=\"column\" layout-gt-md=\"row\" class=\"detailsTechnologyContainer\"><div flex=\"\" class=\"\"><p class=\"info md-caption\">{{::\'TAP_WATER\' | translate}}</p><top-left-schema value=\"vm.facility.tapWaterSubsystemData\" flex=\"\" layout-fill=\"\" class=\"schema\"></top-left-schema></div><div flex=\"\" class=\"\"><p class=\"info md-caption\">{{::\'REVERSE_OSMOSIS\' | translate}}</p><top-right-schema ro=\"vm.facility.reverseOsmosisSubsystemData\" demi=\"vm.facility.demiWaterSubsystemData\" flex=\"\" layout-fill=\"\" class=\"schema\"></top-right-schema></div></div><div flex=\"none\" layout=\"column\" layout-gt-md=\"row\" class=\"detailsTechnologyContainer\"><div flex=\"\" class=\"\"><p class=\"info md-caption\">{{::\'SOFTENED_WATER\' | translate}}</p><bottom-left-schema value=\"vm.facility.softenedWaterSubsystemData\" layout-fill=\"\" class=\"schema\"></bottom-left-schema></div><div flex=\"\" class=\"\"><p class=\"info md-caption\">{{::\'DOSER\' | translate}}</p><bottom-right-schema value=\"vm.facility.doserSubsystemData\" layout-fill=\"\" class=\"schema\"></bottom-right-schema></div></div></div><div layout=\"column\" layout-gt-sm=\"row\" id=\"filterAlarmContainer\"><div flex=\"50\" flex-sm=\"100\" style=\"min-height: 12em\" ng-if=\"vm.checkDeviceTypeHHanle && vm.checkDeviceTypeBridge\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'FILTER_AND_BOILER\' | translate}}</span></div><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\"><div class=\"md-caption\">{{::\'FILTER_TOTAL_DAYS\' | translate}}</div><span class=\"md-title\">{{vm.facility.facility.filterDaysCount}}<span class=\"daysUnit\">{{::\'DAYS_UNIT\' | translate}}</span></span><md-divider></md-divider><div class=\"md-caption\">{{::\'BOILER_TOTAL_DAYS\' | translate}}</div><span class=\"md-title\">{{vm.facility.facility.boilerDaysCount}}<span class=\"daysUnit\">{{::\'DAYS_UNIT\' | translate}}</span></span></div></div><div flex=\"50\" flex-sm=\"100\" ng-if=\"vm.checkDeviceTypeHHanle\"><div class=\"customCardTitle alarm-warnings-title\"><span class=\"md-title customCardSubTitle\">{{::\'ALARMS_AND_WARNINGS\' | translate}}</span></div><div class=\"messagesContainer\" flex=\"none\" layout=\"\"><md-content flex=\"\" class=\"alarm-warnings-card-wrapper\"><md-list flex=\"\" class=\"alarm-warnings-list-item\"><md-list-item class=\"md-2-line\" layout-align=\"start center\" ng-repeat=\"message in vm.facility.messages\"><md-icon ng-class=\"{\'icon-alarm\': message.collapseKey === \'alarm\', \'icon-warning\': message.collapseKey === \'info\'}\" md-svg-src=\"{{message.icon}}\"></md-icon><div class=\"md-list-item-text\"><h3>{{message.message | translate}}/{{message.deviceMoreInfo}}</h3><p>{{message.timeFormatted}}</p></div><md-icon ng-click=\"vm.dismissAlarm($event, message)\" ng-if=\"message.enableAlarmDismiss\" class=\"icon-dismiss-alarm\" md-svg-src=\"assets/icons/ic_close_white_24px.svg\"></md-icon><md-divider ng-if=\"$index !== vm.facility.messages.length - 1\"></md-divider></md-list-item></md-list></md-content></div></div></div><div flex=\"none\" layout=\"column\" layout-wrap=\"\" id=\"boxesHoursContainer\" ng-if=\"vm.checkDeviceTypeBridge\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'BOXES_WORK_HOURS_COUNTERS\' | translate}}</span></div><div class=\"boxContainer\" layout=\"row\" layout-wrap=\"\"><div class=\"boxCounterContainer md-whiteframe-1dp\" ng-repeat=\"box in vm.facility.boxes\" flex=\"20\" flex-order=\"1\" flex-grow=\"1\" style=\"max-height: 10em\"><p class=\"name layout-row layout-align-space-between-center\"><span>{{box.name}}</span> <span class=\"linkedText whiteColor\" ng-click=\"vm.startService($event, box)\">{{\'INSERT\' | translate}}</span></p><div class=\"md-caption\">{{::\'BOX_TOTAL_HOURS\' | translate}}</div><span class=\"md-title\">{{box.totalWorkingHours}} <span class=\"boxCounterUnit\">{{::\'BOX_COUNTER_HOURS\' | translate}}</span></span><div ng-if=\"vm.checkDeviceTypeHHanle\"><md-divider></md-divider><div class=\"md-caption\">{{::\'BOX_SERVICE_HOURS\' | translate}}</div><span class=\"md-title\">{{box.serviceWorkingHours}} <span class=\"boxCounterUnit\">{{::\'BOX_COUNTER_HOURS\' | translate}}</span></span></div></div></div></div><div flex=\"none\" layout=\"column\" layout-wrap=\"\" id=\"listenerContainer\" ng-if=\"vm.checkDeviceTypeWashBoxListener\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'WASH_BOX\' | translate}}</span></div><div class=\"boxContainer\" layout=\"row\" style=\"display: flex; flex-wrap: wrap; height: auto\"><div class=\"boxCounterContainer md-whiteframe-1dp\" ng-repeat=\"listener in vm.facility.smallMachinesWashBoxes\" style=\"min-width: 20em; flex: 1 0 20em; max-height: 6rem\"><p class=\"name layout-row layout-align-space-between-center\"><span>{{listener.name}}</span> <span class=\"linkedText whiteColor\" ng-click=\"vm.startService($event, listener)\">{{\'INSERT\' | translate}}</span></p><div class=\"md-caption\">{{ (vm.checkDeviceTypeHHanle ? \'R2W_Listener\' : \'HHANLE_DEVICE\') | translate}}</div><span class=\"listenerStatusError\" ng-class=\"{listenerStatusOk: listener.listenerStatus === \'online\'}\">{{listener.listenerStatus}}</span> <span class=\"listenerStatusError\" ng-if=\"!vm.checkDeviceTypeHHanle\" ng-class=\"{listenerStatusOk: listener.hhanleDeviceStatus === \'1\'}\">, {{(listener.hhanleDeviceStatus === \'1\' ? \'STATUS_READY\' : \'STATUS_ERROR\') | translate}}</span></div></div></div><div flex=\"none\" layout=\"column\" layout-wrap=\"\" id=\"smallMachinesContainer\" ng-if=\"vm.checkDeviceTypeListener\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'SMALL_MACHINES\' | translate}}</span></div><div class=\"boxContainer\" layout=\"row\" style=\"display: flex; flex-wrap: wrap; height: auto\"><div class=\"boxCounterContainer md-whiteframe-1dp\" ng-repeat=\"listener in vm.facility.smallMachines\" style=\"min-width: 20em; flex: 1 0 20em; max-height: 6rem\"><p class=\"name layout-row layout-align-space-between-center\"><span>{{listener.name}}</span> <span class=\"linkedText whiteColor\" ng-click=\"vm.startService($event, listener)\">{{\'INSERT\' | translate}}</span></p><div class=\"md-caption\">{{::\'R2W_Listener\' | translate}}</div><span class=\"listenerStatusError\" ng-class=\"{listenerStatusOk: listener.listenerStatus === \'online\'}\">{{listener.listenerStatus}}</span></div></div></div></div>");
$templateCache.put("app/facilityDetails/insert-token-dialog.html","<md-dialog aria-label=\"Insert Tokens\"><form name=\"dialogForm\" ng-cloak=\"\" novalidate=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ vm.box.name || vm.box.deviceName }}</h2><span flex=\"\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon aria-label=\"Close\" class=\"whiteColor\">close</md-icon></md-button></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><p>{{\'INSERT_TOKEN\' | translate}}</p><md-input-container class=\"md-block\"><label>{{\'AMOUNT_OF_TOKENS\' | translate}}</label> <input type=\"text\" ng-model=\"dialogData.token\" name=\"tokenInput\" required=\"\" ng-pattern=\"/^\\d{1,2}$/\"><div ng-messages=\"dialogForm.tokenInput.$error\" role=\"alert\"><div ng-message=\"required\">{{\'REQUIRED_FIELD\' | translate}}</div><div ng-message=\"pattern\">{{\'TWO_DIGIT_INTEGER_VALIDATION\' | translate}}</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button ng-click=\"vm.saveToken(dialogData.token)\" class=\"md-primary\" ng-disabled=\"dialogForm.tokenInput.$invalid\">{{vm.buttonTitle}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/facilityKarcherDetails/facilityKarcherDetails.html","<md-tabs class=\"md-primary fullWidth\" xmlns=\"http://www.w3.org/1999/html\"><md-tab label=\"{{ \'WASH_FACILITY_DETAILS\' | translate }}\"><div class=\"facility-karcher-details-wrapper\" flex=\"\" layout=\"column\" style=\"overflow-y: auto\" ng-cloak=\"\"><div layout=\"row\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle boldText\">{{ vm.facilityVM.facilityName }}</span></div></div><div flex=\"none\" layout=\"column\" layout-gt-md=\"row\" class=\"detailsPreviewDashboard\"><div layout-padding=\"\" ng-click=\"vm.testClick()\"><md-icon class=\"karcher-info-card-icon\" md-svg-src=\"{{ vm.facilityVM.facilityIcon }}\"></md-icon></div><div flex=\"\" class=\"karcher-facility-info-card\" layout-padding=\"\" layout=\"column\" layout-align=\"center start\"><p class=\"karcher-facility-details-info-wrapper\" ng-if=\"vm.facilityVM.machineType\">{{ \'MACHINE_NAME\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.machineType | translate }}</span></p><p class=\"karcher-facility-details-info-wrapper\" ng-if=\"vm.facilityVM.facilityType\">{{ \'FACILITY_TYPE\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.facilityType | translate }}</span></p><p class=\"karcher-facility-details-info-wrapper\" ng-if=\"vm.facilityVM.serialNumber\">{{ \'SETUP_UNIT_SERIAL_NO\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.serialNumber.currentValue }}</span></p><p class=\"karcher-facility-details-info-wrapper\" ng-if=\"vm.facilityVM.materialNumber\">{{ \'SETUP_UNIT_MATERIAL_NO\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.materialNumber.currentValue }}</span></p><p class=\"karcher-facility-details-info-wrapper\" ng-if=\"vm.facilityVM.softwareVersion\">{{ \'SOFTWARE_VERSION\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.softwareVersion.currentValue }}</span></p><p class=\"karcher-facility-details-info-wrapper\" ng-if=\"vm.facilityVM.softwareDate\">{{ \'SOFTWARE_DATE\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.softwareDate.currentValue }}</span></p><p class=\"karcher-facility-details-info-wrapper\" ng-if=\"vm.facilityVM.installationDateOfMachine\">{{ \'INSTALLATION_DATE\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.installationDateOfMachine.currentValue }}</span></p><p class=\"karcher-facility-details-info-wrapper\" ng-if=\"vm.facilityVM.siteAddress\">{{ \'SITE_ADDRESS\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.siteAddress }}</span></p></div><div flex=\"\" class=\"karcher-info-card\"><div class=\"md-caption\">{{::\'STATUS\' | translate}}</div><span class=\"md-title\">{{ vm.facilityVM.status | translate | uppercase }} <span class=\"smallerText warnColor\">{{ vm.facilityVM.serviceOnOperationCountersDeviceNeeded ? \"NEED_SERVICE\" : \"\" | translate }}</span></span><md-divider layout-margin=\"\"></md-divider><div class=\"md-caption\">{{::\'LAST_SYNCHRONIZATION\' | translate}}</div><md-icon class=\"icon\" md-svg-src=\"assets/icons/ic_access_time_black_18px.svg\"></md-icon><span class=\"md-title\">{{ vm.facilityVM.lastReportTimestamp }}</span><div ng-if=\"vm.facilityVM.maintenanceWashes\"><div class=\"md-caption\">{{::\'MAINTENANCE_WASHES\' | translate}}</div><span class=\"md-title\">{{ vm.facilityVM.maintenanceWashes | number: 0 }}</span></div><div ng-if=\"vm.facilityVM.maintenanceDays\"><div class=\"md-caption\">{{::\'MAINTENANCE_DAYS\' | translate}}</div><span class=\"md-title\">{{ vm.facilityVM.maintenanceDays | number: 0 }}</span></div></div><div flex=\"\" class=\"karcher-info-card\" layout=\"column\" layout-align=\"center start\" ng-class=\"{\'warning\': vm.facilityVM.warningsCount > 0, \'error\': vm.facilityVM.alarmsCount > 0}\"><div layout=\"column\" layout-align=\"center start\"><div class=\"md-caption fullWidth\">{{::\'NO_OF_CURRENT_ALARMS\' | translate}}</div><div layout=\"row\"><md-icon class=\"karcher-info-card-alarm-and-warning-icon\" md-svg-src=\"assets/icons/ic_high_alarm.svg\"></md-icon><p class=\"paddingLeft10\">{{ vm.facilityVM.numberOfAlarms.alarms }}</p></div></div><div layout=\"column\" layout-align=\"center start\"><div class=\"md-caption\">{{::\'NO_OF_CURRENT_WARNINGS\' | translate}}</div><div layout=\"row\"><md-icon class=\"karcher-info-card-alarm-and-warning-icon\" md-svg-src=\"assets/icons/ic_medium_alarm.svg\"></md-icon><p class=\"paddingLeft10\">{{ vm.facilityVM.numberOfAlarms.warnings }}</p></div></div></div><div flex=\"\" class=\"karcher-info-weather-card\"><div class=\"md-caption\">{{::\'WEATHER\' | translate}}</div><div layout=\"\" layout-align=\"start center\" class=\"temp-icon-wrapper\"><img class=\"weather-icon-tile-details marginRight1\" ng-src=\"{{ vm.facilityVM.currentWeatherData.currentWeatherIcon }}\"> <span class=\"temp-title\">{{ vm.facilityVM.currentWeatherData.temperature}}&degC</span></div><p class=\"karcher-facility-weather-details-info-wrapper marginTop10\">{{ \'PRESSURE_TITLE\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.currentWeatherData.pressure }} mb</span></p><p class=\"karcher-facility-weather-details-info-wrapper\">{{ \'TIME_TITLE\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.currentWeatherData.currentWeatherTime }}</span></p><p class=\"karcher-facility-weather-details-info-wrapper\">{{ \'COUNTRY_TITLE\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.currentWeatherData.country }}</span></p><p class=\"karcher-facility-weather-details-info-wrapper\">{{ \'CITY_TITLE\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.currentWeatherData.city }}</span></p><p class=\"karcher-facility-weather-details-info-wrapper\">{{ \'REGION_TITLE\' | translate }}:<span class=\"paddingLeft10 primaryColor\">{{ vm.facilityVM.currentWeatherData.region }}</span></p></div></div><div flex=\"none\" layout=\"column\" layout-gt-sm=\"row\" class=\"marginBottom20\" ng-if=\"vm.facilityVM.facilityType !== \'ROLLOVER\'\"><div flex=\"50\" flex-sm=\"100\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'AVAILABILITY_ALL\' | translate}}</span></div><div class=\"availabilityKarcherDetailsContainer md-whiteframe-1dp\"><div class=\"md-caption defaultTextSize\">{{::\'AVAILIBILITY\' | translate}}<span class=\"paddingLeft10 boldText500\">{{ vm.facilityVM.feedReferences.AVAILABILITY | karcherCustomTranslation }}</span></div><md-divider></md-divider><div class=\"md-caption defaultTextSize\">{{::\'AVAILABILITY_VACUUMS\' | translate}}<span class=\"paddingLeft10 boldText500\">{{ vm.facilityVM.feedReferences.AVAILABILITY_VACUUMS | karcherCustomTranslation }}</span></div></div></div></div><div flex=\"none\" layout=\"column\" id=\"alarmsHoursContainer\" class=\"marginBottom20\"><div class=\"customCardTitle\" layout=\"\" layout-align=\"space-between center\"><span class=\"md-title customCardSubTitle\">{{::\'ACTIVE_ALARMS\' | translate}}</span></div><div flex=\"\" class=\"noPadding\"><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"vm.facilityVM.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.facilityVM.alarmsOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\"><span>{{\'ALERT_CODE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"timestamp\"><span>{{\'DATE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"companyName\"><span>{{\'COMPANY_NAME\' | translate}}</span></th><th md-column=\"\" md-order-by=\"siteName\"><span>{{\'SITE_NAME\' | translate}}</span></th><th md-column=\"\" md-order-by=\"washFacilityName\"><span>{{\'FACILITY_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{\'ALERT_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{\'ALERT_DESCRIPTION\' | translate}}</span></th><th md-column=\"\"><span>{{\'TYPE\' | translate}}</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"user\" md-auto-select=\"\" ng-repeat=\"alarm in vm.facilityVM.alarmList\"><td md-cell=\"\">{{alarm.karcherFault.number}}</td><td md-cell=\"\">{{alarm.timestamp | date : \'dd/MMM/yy - HH:mm\'}}</td><td md-cell=\"\">{{alarm.companyName}}</td><td md-cell=\"\">{{alarm.siteName}}</td><td md-cell=\"\">{{alarm.washFacilityName}}</td><td md-cell=\"\">{{alarm.karcherFault.name}}</td><td md-cell=\"\">{{alarm.karcherFault.description}}</td><td md-cell=\"\"><md-icon flex=\"\" md-svg-src=\"{{ alarm.icon }}\"></md-icon></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.facilityVM.alarmsPageSize\" md-page=\"vm.facilityVM.alarmsPage\" md-options=\"vm.facilityVM.alarmsPageOptions\" md-total=\"{{vm.facilityVM.alarmsTotal}}\" md-page-select=\"true\" md-boundary-links=\"true\" md-label=\"{{vm.facilityVM.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\"></md-table-pagination></div></div><div class=\"customCardTitle\" layout=\"\" layout-align=\"start center\"><span class=\"md-title customCardSubTitle\">{{ vm.facilityVM.facilityType === \'ROLLOVER\' ? \'LAST_ACTIVE_PROGRAM\' : \'DEVICES_INFO\' | translate }}</span></div><div layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-align=\"start center\" layout-wrap=\"\" class=\"marginBottom20\"><div class=\"karcher-device-details-tile-container karcher-device-card fullWidth\" layout=\"column\" flex=\"30\" flex-xl=\"30\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" ng-if=\"vm.facilityVM.facilityType !== \'ROLLOVER\'\" ng-repeat=\"device in vm.facilityVM.deviceList\"><div layout=\"column\" layout-align=\"center center\" flex=\"\"><div class=\"fullWidth\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" class=\"fullWidth\"><span class=\"tile-device-point-item-wrapper\">{{ device.deviceLabel }}</span> <span class=\"tile-device-point-item-label-wrapper\">{{ device.deviceName | translate }}</span></div><div><md-icon aria-label=\"Edit value\" md-svg-src=\"assets/icons/ic_edit_black_24px.svg\" class=\"cursorPointer edit-actuators-icon\" ng-click=\"vm.editLabelName($event, device)\"><md-tooltip hide-xs=\"\">{{::\'UPDATE\' | translate}}</md-tooltip></md-icon></div></div><div class=\"tile-device-available-item-wrapper fullWidth\" ng-class=\"{\'set-unavailable-device-style\': device.OP_BUTTON === \'0.0\'}\">{{ device.OP_BUTTON | availableDeviceFilter | translate }}</div><div class=\"tile-device-item-wrapper fullWidth\" ng-if=\"device.deviceType !== \'U\'\">{{ \'CURRENT_PROGRAM\' | translate }}: {{ device.STATUS_BAY_ACTIVE_PROGRAM_NAME | removews }}</div><div class=\"tile-device-item-wrapper fullWidth\">{{ \'REMAINING_TIME\' | translate }}: {{ device.STATUS_BAY_RUN_TIME ? device.STATUS_BAY_RUN_TIME : \' 0 \' }} {{ \"REFERENCE_SECONDS\" | translate }}</div><div class=\"tile-device-item-wrapper fullWidth\">{{ \'STATUS_BAY_CREDIT\' | translate }}: {{ device.STATUS_BAY_CREDIT | number: 0 }}</div><div class=\"fullWidth centerText linkedText black-karcher-button paddingAll5\" ng-click=\"vm.startService($event, device)\">{{ \'INSERT\' | translate }}</div></div></div><div class=\"fullWidth paddingAll10\" ng-class=\"{\'active-program-info-wrapper\': vm.rolloverNormalStatus(), \'active-program-close-status-wrapper\': vm.rolloverAlertStatus(), \'active-program-undefined-status-wrapper\': vm.rolloverUndefinedStatus()}\" layout=\"column\" flex=\"30\" flex-xl=\"30\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" layout-align=\"center center\" ng-if=\"vm.facilityVM.facilityType === \'ROLLOVER\'\"><div ng-if=\"!vm.facilityVM.activeProgramItem\" class=\"paddingAll10 boldText\">{{ \'PROGRAM_NOT_STARTED\' | translate }}</div><div class=\"marginBottom20\" layout=\"column\" layout-align=\"center center\"><div>{{ \'ROLLOVER_STATUS\' | translate }}</div><div class=\"boldText\">{{ vm.facilityVM.rolloverStatus | rolloverStatusCode }}</div></div><div ng-repeat=\"actuator in vm.facilityVM.activeProgramActuators\" layout=\"row\" layout-align=\"center center\" class=\"active-alarm-item-wrapper fullWidth\" ng-if=\"actuator.reference === \'NAME\'\"><div class=\"active-program-id-wrapper\">{{ actuator.value | removews }}</div></div></div></div><div flex=\"none\" layout=\"column\" ng-if=\"vm.facilityVM.globalListObject.pumpsList.length !== 0\"><div layout=\"column\"><pumps pumps-list=\"vm.facilityVM.globalListObject.pumpsList\" activation=\"vm.activateNow(data, \'pumps\', parentPointId)\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></pumps></div></div><div flex=\"none\" layout=\"column\"><div layout=\"column\"><operating-time operating-time-list=\"vm.facilityVM.globalListObject.operatingTimeList.list\" device-key=\"vm.facilityVM.deviceSerial\" activation=\"vm.activateNow(data, \'operationTime\', parentPointId)\" refresh-data=\"vm.refreshOperatingData()\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></operating-time></div></div><div flex=\"none\" layout=\"column\" ng-if=\"(vm.facilityVM.feedReferences.AVAILABILITY_VACUUMS | stringToBoolean)\"><div layout=\"column\"><operating-time-vacuum operating-time-vacuum-list=\"vm.facilityVM.globalListObject.operatingTimeVacuumList.list\" activation=\"vm.activateNow(data, \'operationTime\', parentPointId)\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></operating-time-vacuum></div></div><div flex=\"none\" layout=\"column\" ng-if=\"vm.facilityVM.globalListObject.illuminationTimeList.deviceType === \'SB_MU_MB\'\"><div layout=\"column\"><operating-time-illumination operating-time-illumination-list=\"vm.facilityVM.globalListObject.illuminationTimeList.list\" activation=\"vm.activateNow(data, \'operationTime\', parentPointId)\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></operating-time-illumination></div></div><div flex=\"none\" layout=\"column\" ng-if=\"vm.facilityVM.facilityType !== \'ROLLOVER\' && vm.facilityVM.operationCounterList.length !== 0\"><div layout=\"column\"><operation-counters operation-counters-list=\"vm.facilityVM.operationCounterList\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></operation-counters></div></div><div flex=\"none\" layout=\"column\" ng-if=\"vm.facilityVM.facilityType === \'ROLLOVER\' || vm.facilityVM.rolloverOperationCounterList.length !== 0 || vm.facilityVM.rolloverServiceCounterList.length !== 0\"><div layout=\"column\"><operation-and-service-counters-rollover operation-counters-list=\"vm.facilityVM.rolloverOperationCounterList\" service-counters-list=\"vm.facilityVM.rolloverServiceCounterList\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></operation-and-service-counters-rollover></div></div><div flex=\"none\" layout=\"column\" ng-if=\"vm.facilityVM.facilityType === \'ROLLOVER\'\"><div layout=\"column\" ng-if=\"vm.facilityVM.globalListObject.programList.list.length !== 0\"><washing-programs program-list=\"vm.facilityVM.globalListObject.programList.list\" activation=\"vm.activateNow(data, \'washingPrograms\', parentPointId)\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></washing-programs></div><div layout=\"column\" ng-if=\"vm.facilityVM.globalListObject.dosingList.list.length !== 0\"><rollover-dosing dosing-list=\"vm.facilityVM.globalListObject.dosingList.list\" activation=\"vm.activateNow(data, \'dosing\')\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></rollover-dosing></div><div layout=\"column\" ng-if=\"vm.facilityVM.globalListObject.speedList.list.length !== 0\"><rollover-speed speed-list=\"vm.facilityVM.globalListObject.speedList.list\" activation=\"vm.activateNow(data, \'speed\')\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></rollover-speed></div><div layout=\"column\" ng-if=\"vm.facilityVM.chemicalLevelList.length !== 0\"><chemical-level chemical-level-data=\"vm.facilityVM.chemicalLevelList\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></chemical-level></div><div layout=\"column\" ng-if=\"vm.facilityVM.facilityType === \'ROLLOVER\' && !vm.checkMachineTypeName() && vm.facilityVM.parametersList\"><change-of-parameters change-of-parameters-data=\"vm.facilityVM.parametersList\" activation=\"vm.activateNow(data, \'parameters\')\" default-visibility-state=\"vm.facilityVM.componentCollapseDefaultState\"></change-of-parameters></div><div class=\"customCardTitle\" layout=\"column\" layout-align=\"space-between start\" ng-if=\"!vm.checkMachineTypeName()\"><span class=\"md-title customCardSubTitle\">{{::\'ROLLOVER_OPEN_DOOR\' | translate}}</span><div layout=\"row\" layout-align=\"space-between center\" class=\"fullWidth\"><div class=\"rollover-reset-info\">{{ \'ROLLOVER_OPEN_DOOR_INFO\' | translate }}</div><md-button class=\"md-raised black-karcher-button noMarginLeft noMarginRight rollover-reset-button\" ng-click=\"vm.openDoorRollover($event)\" aria-label=\"Reset\">{{::\'OPEN_DOOR_ROLLOVER\' | translate}}</md-button></div></div><div class=\"customCardTitle marginBottom20\" layout=\"column\" layout-align=\"space-between start\" ng-if=\"!vm.checkMachineTypeName()\"><span class=\"md-title customCardSubTitle\">{{::\'ROLLOVER_RESETS\' | translate}}</span><div layout=\"row\" layout-align=\"space-between center\" class=\"fullWidth\"><div class=\"rollover-reset-info marginTop10\"><div>{{ \'ROLLOVER_RESETS_INFO\' | translate }}</div><md-checkbox class=\"marginTop5\" ng-model=\"vm.checkBoxEnableRolloverReset\" ng-click=\"vm.enableResetRolloverButton()\" aria-label=\"Enable reset rollover button\"><span class=\"reset-rollover-checkbox\">{{ \'ENABLE_ROLLOVER_RESET\' | translate }}</span></md-checkbox></div><div><md-button class=\"md-raised noMarginLeft noMarginRight rollover-reset-button\" ng-class=\"{\'primary-karcher-button-disabled\': vm.enableRolloverButton, \'alert-karcher-button\': !vm.enableRolloverButton}\" ng-click=\"vm.resetRollover($event)\" ng-disabled=\"vm.enableRolloverButton\" aria-label=\"Reset\">{{::\'RESET_ROLLOVER\' | translate}}</md-button></div></div></div></div></div></md-tab><md-tab label=\"{{ \'ALARM_HISTORY\' | translate }}\"><alert-history facility-id=\"vm.facilityVM.facilityId\" facility-name=\"vm.facilityVM.facilityName\"></alert-history></md-tab><md-tab label=\"{{ \'LOGS_HISTORY\' | translate }}\"><logs-history device-key=\"vm.facilityVM.deviceSerial\"></logs-history></md-tab><md-tab label=\"{{ \'DEVICE_EVENTS\' | translate }}\"><logs-events pull-new-data=\"vm.pullNewEventData()\" event-data=\"vm.facilityVM.fromWebSocketsEventData\" device-serial=\"vm.facilityVM.deviceSerial\"></logs-events></md-tab><md-tab label=\"{{ \'QR_CODE\' | translate }}\" ng-if=\"vm.facilityVM.facilityType === \'ROLLOVER\'\"><div class=\"margin30 qr-code-container\"><div class=\"qr-code-wrapper\"><qr text=\"vm.facilityVM.facilityIdForQrCode\" type-number=\"4\" size=\"150\"></qr></div></div><div class=\"margin30 qr-code-container\"><md-button ng-disabled=\"!vm.facilityVM.facilityIdForQrCode\" type=\"button\" class=\"md-raised md-primary paddingLeft20 paddingRight20\" ng-click=\"vm.printQrCode()\" aria-label=\"Print QR code\">{{ \"PRINT\" | translate }}: {{ vm.facilityVM.facilityIdForQrCode }}</md-button></div></md-tab><md-tab label=\"{{ \'WASH_BAY_DETAILS\' | translate }}\" ng-if=\"vm.displayDebugTab\"><wash-bay-details wash-facility-data=\"vm.facilityVM.copyOfSelectedDevice\"></wash-bay-details></md-tab></md-tabs>");
$templateCache.put("app/forgotPassword/forgotPassword.html","<div layout=\"\" id=\"loginContainer\" layout-align=\"center center\" layout-padding=\"\"><div flex=\"20\" flex-lg=\"20\" flex-xl=\"20\" flex-sm=\"50\" flex-md=\"50\" flex-xs=\"100\" id=\"forgotPasswordContainer\"><form flex=\"\" layout=\"column\" id=\"loginBox\" name=\"forgotPasswordForm\" ng-submit=\"vm.forgotPassword(forgotPasswordForm)\"><div class=\"logoContainer\"></div><br><div flex=\"\"><h2>{{::\'FORGOT_PASSWORD\' | translate}}</h2></div><div><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{::\'EMAIL\' | translate}}</label> <input ng-model=\"vm.email\" type=\"email\" name=\"email\" ng-pattern=\"/[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$/\"></md-input-container><div ng-messages=\"forgotPasswordForm.email.$error\" layout=\"\" layout-align=\"center start\" flex=\"\"><div flex=\"\" ng-message=\"email\" class=\"validationMessage\">- {{::\'VALIDATION_EMAIL\' | translate}}</div><div flex=\"\" ng-message=\"pattern\" class=\"validationMessage\">- {{ \"VALIDATION_EMAIL\" | translate }}</div></div></div><div flex=\"\" layout=\"\" layout-align=\"end center\"><md-button class=\"md-raised\" ui-sref=\"login\" id=\"backButton\">{{::\'BACK\' | translate}}</md-button><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.email.$viewValue === undefined\" style=\"color: white\">{{::\'SUBMIT\' | translate}}</md-button></div><div flex=\"\"><div id=\"forgotPasswordErrorContainer\" ng-if=\"vm.password.hasErrors\"><p>{{ vm.password.errorMsg }}</p></div></div></form></div></div>");
$templateCache.put("app/karcherService/karcherService.html","<div id=\"facilityService\" flex=\"\" layout=\"\" style=\"overflow-y:auto;\" layout-margin=\"\" ng-cloak=\"\"><div flex=\"\" id=\"karcherServiceContainer\"><div flex=\"none\" layout=\"column\" layout-gt-sm=\"row\" id=\"workingHourContainer\" class=\"marginBottom50\"><div flex=\"100\" flex-sm=\"100\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle marginBottom0\">{{::\'WORKING_HOURS\' | translate}}</span><md-icon class=\"linkedText\" md-svg-src=\"assets/icons/ic_arrow_drop_down_black_24px.svg\" aria-label=\"open working hours table\" ng-click=\"vm.workingHoursTable = !vm.workingHoursTable\"><md-tooltip md-direction=\"right\">{{::\'SHOW_HIDE_TABLE\' | translate}}</md-tooltip></md-icon></div><div ng-if=\"vm.workingHoursTable\"><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"\" flex=\"\"><div flex=\"\"></div><div flex=\"\" ng-repeat=\"day in vm.dayList\"><div flex=\"\" class=\"centerText boldText\">{{ day }}</div></div><div flex=\"\" class=\"centerText boldText\">{{::\'HOLIDAYS\' | translate}}</div></div><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"\" flex=\"\"><div class=\"boldText\" flex=\"\">{{::\'LIGHTS_ON\' | translate}}</div><div flex=\"\" ng-repeat=\"lightOn in vm.lightsOn track by $index\"><div flex=\"\" class=\"centerText\">{{ lightOn }}</div></div></div><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"\" flex=\"\"><div class=\"boldText\" flex=\"\">{{::\'LIGHTS_OFF\' | translate}}</div><div flex=\"\" ng-repeat=\"lightOff in vm.lightsOff track by $index\"><div flex=\"\" class=\"centerText\">{{ lightOff }}</div></div></div><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"\" flex=\"\"><div class=\"boldText\" flex=\"\">{{::\'WASH_BOXES_ON\' | translate}}</div><div flex=\"\" ng-repeat=\"washBoxOn in vm.washBoxesOn track by $index\"><div flex=\"\" class=\"centerText\">{{ washBoxOn }}</div></div></div><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"\" flex=\"\"><div class=\"boldText\" flex=\"\">{{::\'WASH_BOXES_OFF\' | translate}}</div><div flex=\"\" ng-repeat=\"washBoxOff in vm.washBoxesOff track by $index\"><div flex=\"\" class=\"centerText\">{{ washBoxOff }}</div></div></div><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"\" flex=\"\"><div class=\"boldText\" flex=\"\">{{::\'VACUUMS_ON\' | translate}}</div><div flex=\"\" ng-repeat=\"vacuumOn in vm.vacuumsOn track by $index\"><div flex=\"\" class=\"centerText\">{{ vacuumOn }}</div></div></div><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"\" flex=\"\"><div class=\"boldText\" flex=\"\">{{::\'VACUUMS_OFF\' | translate}}</div><div flex=\"\" ng-repeat=\"vacuumOff in vm.vacuumsOff track by $index\"><div flex=\"\" class=\"centerText\">{{ vacuumOff }}</div></div></div></div></div></div><div class=\"marginBottom50\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'PROGRAM_DATA\' | translate}}</span></div><div flex=\"\"><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"column\" flex=\"\"><div flex=\"\" layout-padding=\"\" class=\"activeKarcherBoxVacuum marginBottom20\">{{vm.programList.boxName}}</div><div flex=\"\" layout=\"\" class=\"boldText\"><div flex=\"\" layout-padding=\"\">{{::\'PROGRAM_NAME\' | translate}}</div><div flex=\"\" layout-padding=\"\">{{::\'PROGRAM_COUNTER\' | translate}}</div></div><md-divider></md-divider><div flex=\"\" ng-repeat=\"item in vm.programList.list\" layout=\"\"><div flex=\"\" layout-padding=\"\">{{item.programName | removews}}</div><div flex=\"\" layout-padding=\"\">{{item.seconds | secondsToHoursMinutesSeconds}} {{::\'BOX_COUNTER_HOURS\' | translate}}</div></div></div></div></div><div class=\"marginBottom50\"><div class=\"customCardTitle\"><span class=\"md-title customCardSubTitle\">{{::\'FACILITY_DETAILS\' | translate}}</span></div><div flex=\"\"><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"column\" flex=\"\"><div flex=\"\" layout-padding=\"\" class=\"activeKarcherBoxVacuum marginBottom20\">{{\'COUNTER_SERVICE_DATA\' | translate}}</div><div flex=\"\" layout=\"\" class=\"boldText\"><div flex=\"\" layout-padding=\"\">{{::\'REFERENCE_NAME\' | translate}}</div><div flex=\"\" layout-padding=\"\">{{::\'NEED_SERVICE\' | translate}}</div><div flex=\"\" layout-padding=\"\">{{::\'WORKING_HOURS\' | translate}}</div></div><div flex=\"\" ng-repeat=\"item in vm.serviceList\" layout=\"\"><div flex=\"\" layout-padding=\"\" ng-style=\"item.serviceDue ? {\'color\':\'#F44336\', \'font-weight\': \'700\'} : null\">{{item.serviceName | removews}}</div><div flex=\"\" layout-padding=\"\" ng-style=\"item.serviceDue ? {\'color\':\'#F44336\', \'font-weight\': \'700\'} : null\">{{item.serviceDue ? \'YES\' : \'NO\' | translate}}</div><div flex=\"\" layout-padding=\"\" ng-style=\"item.serviceDue ? {\'color\':\'#F44336\', \'font-weight\': \'700\'} : null\">{{item.serviceSeconds | secondsToHoursMinutesSeconds}} {{::\'BOX_COUNTER_HOURS\' | translate}}</div></div></div></div><div flex=\"\"><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"column\" flex=\"\"><div flex=\"\" layout-padding=\"\" class=\"activeKarcherBoxVacuum marginBottom20\">{{\'OPERATION_DATA\' | translate}}</div><div flex=\"\" layout=\"\" class=\"boldText\"><div flex=\"\" layout-padding=\"\">{{::\'REFERENCE_NAME\' | translate}}</div><div flex=\"\" layout-padding=\"\">{{::\'WORKING_HOURS\' | translate}}</div></div><div flex=\"\" ng-repeat=\"item in vm.operationList\" layout=\"\"><div flex=\"\" layout-padding=\"\">{{item.name | removews}}</div><div flex=\"\" layout-padding=\"\">{{item.seconds | secondsToHoursMinutesSeconds}} {{::\'BOX_COUNTER_HOURS\' | translate}}</div></div></div></div><div flex=\"\"><div class=\"filterBoilerCounterContainer md-whiteframe-1dp\" layout=\"column\" flex=\"\"><div flex=\"\" layout-padding=\"\" class=\"activeKarcherBoxVacuum marginBottom20\">{{\'PUMP_DATA\' | translate}}</div><div flex=\"\" layout=\"\" class=\"boldText\"><div flex=\"\" layout-padding=\"\">{{::\'PUMP_NAME\' | translate}}</div><div flex=\"\" layout-padding=\"\">{{::\'WORKING_HOURS\' | translate}}</div></div><div flex=\"\" ng-repeat=\"item in vm.pumpTypeList\" layout=\"\"><div flex=\"\" layout-padding=\"\">{{item.pumpName | removews}}</div><div flex=\"\" layout-padding=\"\">{{item.pumpRunTime | secondsToHoursMinutesSeconds}} {{::\'BOX_COUNTER_HOURS\' | translate}}</div></div></div></div></div></div></div>");
$templateCache.put("app/layout/layout.html","<loader ng-show=\"vm.layout.isLoading\"></loader><div layout=\"column\" layout-fill=\"\"><md-content flex=\"\" layout=\"\" id=\"layoutContainer\"><layout-aside-menu menu=\"vm.smallMenu\" id=\"layoutAsideMenuContainer\"></layout-aside-menu><div flex=\"\" id=\"centerContainer\" layout=\"column\" ui-view=\"errorPageContainer\"><global-notice></global-notice><error-container ng-if=\"vm.layout.hasError\" class=\"errorContainer\" error-header=\"vm.layout.errorHeader\" error-name=\"vm.layout.errorName\" error-description=\"vm.layout.errorDescription\"></error-container><layout-header></layout-header><div ui-view=\"layoutPageContainer\" layout=\"\" flex=\"\"></div></div></md-content></div>");
$templateCache.put("app/knowledgeBase/knowledgeBase.html","<object data=\"../../assets/files/knowledgeBase.pdf\" type=\"application/pdf\" width=\"100%\" height=\"100%\"></object>");
$templateCache.put("app/knowledgeBase/termsAndService.html","<div layout=\"column\" flex=\"\"><div class=\"margin30 terms-and-service-wrapper\" ng-bind-html=\"vm.termsOfService\"></div><div flex=\"\"><md-button type=\"button\" class=\"md-raised md-primary marginLeft2\" ng-click=\"vm.acceptTerms()\" aria-label=\"Accept terms and conditions\" ng-if=\"vm.termsNeedToBeAccepted\">{{\'ACCEPT_TERMS_AND_CONDITIONS\'| translate}}</md-button></div></div>");
$templateCache.put("app/login/login.html","<div layout=\"\" id=\"loginContainer\" layout-align=\"center center\" layout-padding=\"\"><div id=\"loginBox\"><div class=\"logoContainer\"></div><div><h2>{{\'LOGIN\' | translate}}</h2></div><form name=\"loginForm\" novalidate=\"\" ng-submit=\"vm.doLogin()\"><div flex=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{\'EMAIL\' | translate}}</label> <input name=\"email\" ng-model=\"vm.login.email\" type=\"email\" ng-pattern=\'/^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\' required=\"\"><div ng-messages=\"loginForm.email.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{\'VALIDATION_EMAIL\' | translate}}</div></div></md-input-container></div><div flex=\"\" class=\"passwordWrapper\"><md-input-container class=\"md-block\" flex-gt-sm=\"\" required=\"\"><label>{{\'PASSWORD\' | translate}}</label> <input name=\"password\" ng-model=\"vm.login.password\" type=\"{{vm.inputType}}\" required=\"\" md-minlength=\"8\" ng-minlength=\"8\" ng-maxlength=\"32\" md-maxlength=\"32\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$/\"> <i class=\"material-icons cursorPointer global-password-visibility-mark\" ng-click=\"vm.showPassword()\">visibility</i><div ng-messages=\"loginForm.password.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"minlength\">- {{::\'PASSWORD_MIN_CHAR\' | translate}}</div><div flex=\"\" ng-message=\"maxlength\">- {{::\'PASSWORD_MAX_CHAR\' | translate}}></div><div flex=\"\" ng-message=\"pattern\">- {{::\'PASSWORD_VALIDATION_PATTERN_NEW\' | translate}}</div></div></md-input-container></div><div flex=\"\" id=\"loginErrorContainer\" ng-if=\"vm.hasError\">{{::vm.errorDescription}}</div><div layout=\"\"><div flex=\"\"><md-button ng-disabled=\"loginForm.$invalid\" type=\"submit\" id=\"loginButton\">{{vm.buttonTitle}}</md-button><p class=\"md-caption\" style=\"color: rgb(221, 44, 0)\" ng-show=\"vm.login.hasErrors\">{{vm.login.errorMessage}}</p></div></div><br><br><div layout=\"\"><md-input-container class=\"md-block\" flex=\"\"><label>{{\'LANGUAGE\' | translate}}</label><md-select ng-model=\"vm.login.selectedLanguageId\" ng-change=\"vm.onSelectedLanguageChange()\"><md-option ng-repeat=\"lang in vm.login.languages\" value=\"{{lang.id}}\">{{lang.name}}</md-option></md-select></md-input-container><div flex=\"\" style=\"position: relative\"><md-button md-no-ink=\"\" id=\"forgotPasswordButton\" ui-sref=\"forgotPassword\">{{\'FORGOT_PASSWORD\' | translate}}</md-button></div></div><p class=\"versionText\">v{{::vm.version}}</p></form></div></div>");
$templateCache.put("app/loyalty/loyalty.html","<md-content flex=\"\" layout=\"column\" id=\"loyaltyOverview\" ng-cloak=\"\"><div ng-if=\"vm.campaigns.hasErrorMessage\" class=\"errorMessage\">{{vm.campaigns.errorMessage}}</div><div ng-if=\"vm.templates.hasErrorMessage\" class=\"errorMessage\">{{vm.templates.errorMessage}}</div><div class=\"md-title customCardTitle\">{{::\'CAMPAIGNS_OVERVIEW\' | translate}}</div><div flex=\"\"><md-card flex=\"\"><md-card-actions layout=\"\" layout-align=\"start center\" class=\"actions\"><md-input-container class=\"searchInput\"><label>{{::\'SEARCH\' | translate}}</label> <input ng-model=\"searchCampaigns\" type=\"text\"></md-input-container><md-button class=\"md-fab md-mini md-primary\" aria-label=\"New campaign\" ng-click=\"vm.createCampaign()\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_white_24px.svg\" class=\"fillButton\"></md-icon><md-tooltip>{{::\'CREATE_CAMPAIGN\' | translate}}</md-tooltip></md-button><md-button ng-if=\"vm.campaigns.selected.length === 1 && !vm.campaigns.selected[0].isActive\" class=\"md-fab md-mini\" aria-label=\"Update campaign\" ng-click=\"vm.updateCampaign(vm.campaigns.selected[0])\"><md-icon md-svg-src=\"assets/icons/ic_settings_white_24px.svg\" class=\"fillButton\"></md-icon><md-tooltip>{{::\'UPDATE_CAMPAIGN\' | translate}}</md-tooltip></md-button><md-button class=\"md-fab md-warn md-mini\" ng-click=\"vm.deleteCampaign($event)\" aria-label=\"Delete campaign\" ng-disabled=\"vm.campaigns.selected.length !== 1\"><md-icon md-svg-src=\"assets/icons/ic_delete_forever_white_24px.svg\" class=\"fillButton\"></md-icon><md-tooltip>{{::\'DELETE_CAMPAIGN\' | translate}}</md-tooltip></md-button></md-card-actions><md-divider></md-divider><md-card-content layout-padding=\"\"><md-table-container><table md-table=\"\" md-row-select=\"true\" multiple=\"{{vm.campaigns.multiple}}\" ng-model=\"vm.campaigns.selected\"><thead md-head=\"\" md-order=\"vm.campaigns.orderBy\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"name\">{{::\'NAME\' | translate}}</th><th md-column=\"\" md-desc=\"{{true}}\" md-order-by=\"from\">{{::\'FROM\' | translate}}</th><th md-column=\"\" md-order-by=\"to\">{{::\'TO\' | translate}}</th><th md-column=\"\" md-order-by=\"isActive\">{{::\'CAMPAIGN_ACTIVE\' | translate}}</th><th md-column=\"\">{{::\'CAMPAIGN_GROUPS\' | translate}}</th><th md-column=\"\">{{::\'STATUS\' | translate}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"camp\" md-auto-select=\"false\" md-on-select=\"vm.onCampaignSelected\" ng-repeat=\"camp in vm.campaigns.data | filter: searchCampaigns | orderBy: vm.campaigns.orderBy | limitTo: vm.campaigns.limitPerPage : (vm.campaigns.currentPage - 1) * vm.campaigns.limitPerPage\"><td md-cell=\"\">{{camp.name}}</td><td md-cell=\"\">{{camp.from | date}}</td><td md-cell=\"\">{{camp.to | date}}</td><td md-cell=\"\">{{camp.isActive ? \'YES\' : \'NO\' | translate}}</td><td md-cell=\"\"><span ng-if=\"camp.userGroups.length > 0\" ng-repeat=\"group in camp.userGroups\">{{group.name}} <span ng-if=\"$index < camp.userGroups.length - 1\">,</span></span> <span ng-if=\"camp.userGroups.length === 0\">{{::\'CAMPAIGN_ALL_USERS\' | translate}}</span></td><td md-cell=\"\"><md-button ng-if=\"camp.activateEnabled\" class=\"md-primary md-raised\" ng-click=\"vm.campaigns.activateCampaign(camp)\" style=\"margin-left: 0\">{{::\'ACTIVATE\' | translate}}</md-button><span ng-if=\"camp.isActive && !camp.isInDateRange\">{{::\'FINISHED\' | translate}}</span> <span ng-if=\"camp.isActive && camp.isInDateRange\">{{::\'RUNNING\' | translate}}</span> <span ng-if=\"!camp.isActive && !camp.isInDateRange && !camp.isInFuture\">{{::\'DEPRECATED\' | translate}}</span> <span ng-if=\"!camp.isActive && !camp.isInDateRange && camp.isInFuture\">{{::\'UPCOMING\' | translate}}</span></td><td md-cell=\"\"><md-icon class=\"loyaltyPreviewButton fillButton\" aria-label=\"Preview button\" md-svg-src=\"assets/icons/ic_content_paste_black_24px.svg\" ng-click=\"vm.showLoyaltyPreview($event, camp)\"></md-icon></td><div>{{camp.name}}</div><div>{{camp.fromFormatted}}</div></tr><tr md-row=\"\" ng-if=\"vm.campaigns.listEmpty\"><td md-cell=\"\" class=\"campaignListEmpty\"><md-icon md-svg-src=\"assets/icons/ic_warning_black_24px.svg\" class=\"fillButton\"></md-icon>{{::\'LOYALTY_EMPTY_LIST_NOTIFICATION\' | translate}}</td></tr></tbody></table></md-table-container><md-card-actions><md-table-pagination md-limit=\"vm.campaigns.limitPerPage\" md-page=\"vm.campaigns.currentPage\" md-total=\"{{vm.campaigns.count}}\" md-page-select=\"options.pageSelect\" md-boundary-links=\"true\" md-label=\"{{vm.campaigns.pagerLabel}}\"></md-table-pagination></md-card-actions></md-card-content></md-card></div></md-content>");
$templateCache.put("app/loyalty/loyaltyPreview.dialog.html","<md-dialog aria-label=\"loyalty preview\" id=\"loyaltyPreviewDialogContainer\" flex-xs=\"90\" flex-sm=\"70\" flex-lg=\"30\" flex-xl=\"30\"><md-toolbar><div class=\"md-toolbar-tools\"><h2 style=\"color:white\">{{::\'LOYALTY_PREVIEW\' | translate}}</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><p>{{::\'NAME\' | translate}}: <span class=\"loyaltyPreviewTitles loyaltyName\">{{::vm.data.name}}</span></p><md-divider></md-divider><p>{{::\'CAMPAIGN_ACTIVE\' | translate}}: <span class=\"loyaltyPreviewTitles\" ng-if=\"vm.data.isActive\">{{::\'ACTIVATED\' | translate}}</span> <span class=\"loyaltyPreviewTitles\" ng-if=\"!vm.data.isActive\">{{::\'NOT_ACTIVATED\' | translate}}</span></p><md-divider></md-divider><p>{{::\'STATUS\' | translate}}: <span class=\"loyaltyPreviewTitles\" ng-if=\"vm.data.isInDateRange\">{{::\'RUNNING\' | translate}}</span> <span class=\"loyaltyPreviewTitles\" ng-if=\"!vm.data.isInDateRange && !vm.data.isInFuture && vm.data.isActive\">{{::\'FINISHED\' | translate}}</span> <span class=\"loyaltyPreviewTitles\" ng-if=\"!vm.data.isInDateRange && !vm.data.isInFuture && !vm.data.isActive\">{{::\'DEPRECATED\' | translate}}</span> <span class=\"loyaltyPreviewTitles\" ng-if=\"!vm.data.isInDateRange && vm.data.isInFuture\">{{::\'UPCOMING\' | translate}}</span></p><md-divider></md-divider><p>{{::\'STARTED\' | translate}} {{::vm.data.from | date:medium}}</p><p>{{::\'ENDS\' | translate}} {{::vm.data.to | date:medium}}</p><md-divider></md-divider><p>{{::\'DEDICATED\' | translate}} : <span class=\"loyaltyPreviewTitles\" ng-if=\"vm.data.userGroups.length > 0\" ng-repeat=\"group in vm.data.userGroups\">{{group.name}}<span ng-if=\"!$last\">,</span></span> <span class=\"loyaltyPreviewTitles\" ng-if=\"vm.data.userGroups.length == 0\">{{::\'CAMPAIGN_ALL_USERS\' | translate}}</span></p><md-divider></md-divider><p ng-if=\"vm.data.facilityType\">{{::\'DEVICE_TYPE\' | translate}} : <span class=\"loyaltyPreviewTitles\">{{vm.data.facilityType | translate}}</span></p><br><md-button class=\"md-raised md-primary\" aria-label=\"New campaign\" ng-click=\"vm.previewCampaign(vm.data)\">{{::\'CAMPAIGNS_OVERVIEW\' | translate}}<md-tooltip>{{::\'CAMPAIGNS_OVERVIEW\' | translate}}</md-tooltip></md-button></div></md-dialog-content></md-dialog>");
$templateCache.put("app/managingTokens/deleteAndExtendTokensModal.html","<md-dialog aria-label=\"create/update region\" flex-lg=\"40\" flex-xl=\"30\" flex-md=\"50\" flex-sm=\"70\" flex-xs=\"80\"><form name=\"deleteTokensForm\" ng-submit=\"vm.saveChanges(deleteTokensForm)\" novalidate=\"\"><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><p>{{vm.dialogTitle}}<span class=\"companyNameTitle\">{{ vm.companyName }}</span></p><md-input-container ng-if=\"!vm.edit\"><label>{{::\'AMOUNT\' | translate}}</label> <input ng-model=\"vm.amount\" name=\"amount\" ng-change=\"vm.inputValidation(vm.amount)\" required=\"\"><div ng-messages=\"deleteTokensForm.amount.$error\" layout=\"column\" layout-align=\"center start\" flex=\"\"><div ng-message=\"required\">- {{ \"VALIDATION_REQUIRED\" | translate }}</div><div flex=\"\" ng-if=\"vm.amountNotValid\" style=\"font-size:12px;margin-top:5px;\">- {{ \"ONLY_INTEGER\" | translate }}</div></div></md-input-container><md-container ng-if=\"vm.edit\" flex=\"\" class=\"datePickerContainer\" layout=\"column\" layout-align=\"center start\"><label class=\"datePickerLabel\">{{::\'EXPIRATION_DATE\' | translate}}</label><md-datepicker ng-model=\"vm.expirationDate\" name=\"expirationDate\" md-min-date=\"vm.expirationDate\"></md-datepicker></md-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-disabled=\"deleteTokensForm.$invalid || !deleteTokensForm.$dirty || vm.amountNotValid\" type=\"submit\" class=\"md-primary md-raised\">{{::\'SAVE_CHANGES\' | translate}}</md-button><md-button ng-click=\"vm.closeDialog()\">{{::\'CANCEL\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/managingTokens/managingTokens.html","<div id=\"managing-tokens-container\" layout=\"column\" flex=\"\"><div id=\"managing-tokens-header\" layout=\"\"><form name=\"managingTokensEmail\" ng-submit=\"vm.userSelected(vm.managingTokens.selectedUser)\" novalidate=\"\" flex=\"50\" layout=\"\"><md-input-container flex=\"100\" class=\"emailInput\"><label>{{::\'USER_EMAIL\' | translate}}</label> <input ng-model=\"vm.managingTokens.selectedUser\" type=\"email\" name=\"managingTokensEmail\" required=\"\"><div ng-messages=\"managingTokensEmail.managingTokensEmail.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"email\">- {{::\'VALIDATION_EMAIL\' | translate}}</div><div flex=\"\" ng-if=\"vm.managingTokens.hasError\">{{::vm.managingTokens.customError}}</div></div></md-input-container><md-input-container flex=\"\"><md-button class=\"md-primary md-button defaultButton\" type=\"submit\" ng-disabled=\"managingTokensEmail.$invalid\">{{::\'SELECT\' | translate}}</md-button></md-input-container></form></div><div id=\"managing-tokens-body\" layout=\"column\" flex=\"\" ng-if=\"vm.managingTokens.isUserSelected\"><md-list ng-cloak=\"\"><md-list-item class=\"noright\"><p class=\"tokens-company-title\">{{ vm.managingTokens.tokenList.companyDefaultCurrency }}<span class=\"tokens-amount-wrapper\"><span class=\"tokens-amount\">{{ vm.managingTokens.tokenList.amount }}</span></span><span class=\"tokens-expiration-date\">{{ vm.managingTokens.tokenList.currency | tokensFilter | translate }}, {{ \"EXPIRATION_DATE\" | translate }}: {{ vm.managingTokens.tokenList.expirationDate | date }}</span></p><md-icon md-svg-src=\"assets/icons/ic_edit_black_24px.svg\" ng-click=\"vm.tokensDetails($event, vm.managingTokens.tokenList, true)\" aria-label=\"Expand tokens\" class=\"md-secondary\"></md-icon><md-icon ng-if=\"token.currency !== \'R2W\'\" md-svg-src=\"assets/icons/ic_delete_forever_black_24px.svg\" class=\"md-secondary\" ng-click=\"vm.tokensDetails($event, vm.managingTokens.tokenList, false)\" aria-label=\"Delete tokens\"></md-icon></md-list-item></md-list></div></div>");
$templateCache.put("app/news/news.html","<div id=\"newsContainer\" layout-gt-md=\"\"><div flex=\"\" flex-gt-md=\"30\" layout-padding=\"\" id=\"newsFormContainer\"><md-content class=\"md-whiteframe-z2\"><div class=\"customCardTitle\">{{::\'CREATE_NEW_NEWS\' | translate}}</div><form novalidate=\"\" name=\"newsForm\" ng-submit=\"vm.saveNews()\"><md-contact-chips ng-model=\"vm.news.selectedFacilities\" md-contacts=\"vm.querySearch($query)\" md-contact-name=\"name\" md-require-match=\"true\" md-highlight-flags=\"i\" filter-selected=\"vm.filterSelected\" placeholder=\"{{::\'TYPE_FACILITY_NAME_PLACEHOLDER\' | translate}}\" secondary-placeholder=\"+{{::\'ADD_ANOTHER_FACILITY_PLACEHOLDER\' | translate}}\"></md-contact-chips><div layout=\"\"><md-input-container class=\"md-block newsDateContainer\"><md-datepicker ng-model=\"vm.news.newsCreated\" md-open-on-focus=\"\" md-placeholder=\"{{::\'NEWS_CREATION_DATE\' | translate}}\"></md-datepicker></md-input-container><md-input-container class=\"newsLangContainer\"><label>{{::\'LANGUAGE\' | translate}}</label><md-select ng-model=\"vm.news.newsLanguage\"><md-option value=\"en\">en</md-option><md-option value=\"sr\">sr</md-option></md-select></md-input-container></div><md-input-container class=\"md-block\"><label>{{::\'NEWS_TITLE\' | translate}}</label> <input name=\"newsTitle\" required=\"\" ng-model=\"vm.news.newsTitle\" type=\"text\"><div ng-messages=\"newsForm.newsTitle.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{\'NEWS_TITLE_REQUIRED_VALIDATION\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{::\'NEWS_TEXT\' | translate}}</label> <textarea name=\"newsText\" ng-model=\"vm.news.newsText\" required=\"\" md-maxlength=\"255\" maxlength=\"255\" rows=\"5\" md-select-on-focus=\"\">\n                    </textarea><div ng-messages=\"newsForm.newsText.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{\'NEWS_TEXT_REQUIRED_VALIDATION\' | translate}}</div><div ng-message=\"maxlength\">{{\'NEWS_TEXT_MAX_CHAR_VALIDATION\' | translate}}</div></div></md-input-container><md-button class=\"md-primary md-button defaultButton\" ng-disabled=\"newsForm.$invalid\" type=\"submit\">{{::\'SAVE\' | translate}}<md-tooltip>{{::\'SAVE_NEWS\' | translate}}</md-tooltip></md-button></form></md-content></div><div flex=\"\" layout-margin=\"\" id=\"newsHistoryContainer\"><div class=\"customCardTitle\">{{::\'HISTORY_OF_ALL_NEWS\' | translate}}</div><div id=\"newsTableContainer\"><md-table-container><table md-table=\"\" multiple=\"\" ng-model=\"vm.news.selectedInvoices\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.news.invoiceOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"title\" style=\"min-width: 200px\">{{::\'NEWS_TITLE\' | translate}}</th><th md-column=\"\" md-order-by=\"content\" style=\"min-width: 200px\">{{::\'NEWS_TEXT\' | translate}}</th><th md-column=\"\">{{::\'ASIDE_MENU_FACILITIES\' | translate}}</th><th md-column=\"\" md-order-by=\"timestamp\">{{::\'CREATED\' | translate}}</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"news in vm.news.newsData\"><td md-cell=\"\"><span ng-if=\"!news.title\" class=\"newsNoTitle\">{{::\'NO_TITLE\' | translate}}</span> <span ng-if=\"news.title\">{{::news.title}}</span></td><td md-cell=\"\" class=\"newsTableContentField\">{{::news.content}}</td><td md-cell=\"\"><span ng-repeat=\"facility in news.washFacilities\">{{::facility.name}}<span ng-if=\"!$last\">,</span></span></td><td md-cell=\"\">{{::news.timestamp | date : \'medium\'}}</td><td md-cell=\"\"><md-button class=\"md-warn md-button defaultButton\" ng-click=\"vm.deleteNews(news)\">{{::\'DEACTIVATE\' | translate}}</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.news.newsPageSize\" md-limit-options=\"vm.news.newsPageOptions\" md-page=\"vm.news.newsPage\" md-total=\"{{vm.news.newsTotal}}\" md-label=\"{{vm.news.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\" md-page-select=\"true\" md-boundary-links=\"true\"></md-table-pagination></div></div></div>");
$templateCache.put("app/organization/listOrganization.html","<div id=\"organizationContainer\" layout=\"column\" flex=\"\"><div id=\"organizationHeader\" layout=\"\" layout-xs=\"column\" layout-padding=\"\" layout-margin=\"\"></div><div id=\"organizationBody\"><script type=\"text/ng-template\" id=\"organizationChildTree\"><div class=\"list-item-wrapper\" layout=\"row\" layout-align=\"space-between center\"> <div ng-click=\"vm.expendOrganization(organization)\" class=\"cursorPointer\"> <span class=\"material-icons center-organization-type-icon\">{{ vm.setOrganizationTypeIconIcon(organization.type) }}</span> <span class=\"boldText grayBasicColor\">{{ organization.name }}</span> (<span class=\"warnColor boldText500\">{{ \"SUPPORTED_ORG_NAME\" | translate }}</span>) </div> <div> <md-icon aria-label=\"Create organization icon\" md-svg-src=\"assets/icons/ic_add_circle_primary_24px.svg\" class=\"cursorPointer\" ng-if=\"organization.type !== \'SITE\'\" ui-sref=\"app.organization.details({id: organization.id, create: true})\" > <md-tooltip hide-xs >{{::\'CREATE_ORGANIZATION\' | translate}}</md-tooltip > </md-icon> <md-icon aria-label=\"Edit organization icon\" md-svg-src=\"assets/icons/ic_edit_gray_24px.svg\" class=\"marginLeft1\" > > </md-icon> <md-icon aria-label=\"Delete organization icon\" md-svg-src=\"assets/icons/ic_delete_forever_gray_24px.svg\" class=\"marginLeft1 marginRight1\" > </md-icon> </div> </div> <ul ng-if=\"(organization.supportChildOrganizations || organization.childOrganizations) && vm.showOrganization(organization)\"> <li ng-repeat=\"organization in organization.childOrganizations\" ng-include=\"\'organizationTree\'\"> </li> <li ng-repeat=\"organization in organization.supportChildOrganizations\" ng-include=\"\'organizationChildTree\'\"> </li> </ul></script><script type=\"text/ng-template\" id=\"organizationTree\"><div class=\"list-item-wrapper\" layout=\"row\" layout-align=\"space-between center\"> <div ng-click=\"vm.expendOrganization(organization)\" class=\"cursorPointer\"> <span class=\"material-icons center-organization-type-icon\">{{ vm.setOrganizationTypeIconIcon(organization.type) }}</span> <span class=\"boldText grayBasicColor\">{{ organization.name }}</span> </div> <div> <md-icon aria-label=\"Create organization icon\" md-svg-src=\"assets/icons/ic_add_circle_primary_24px.svg\" class=\"cursorPointer\" ui-sref=\"app.organization.details({id: organization.id, create: true})\" ng-if=\"organization.type !== \'SITE\'\" > <md-tooltip hide-xs >{{::\'CREATE_ORGANIZATION\' | translate}}</md-tooltip > </md-icon> <md-icon aria-label=\"Edit organization icon\" md-svg-src=\"assets/icons/ic_edit_black_24px.svg\" class=\"cursorPointer marginLeft1\" ui-sref=\"app.organization.details({id: organization.id, create: false})\" > <md-tooltip hide-xs >{{::\'EDIT_ORGANIZATION\' | translate}}</md-tooltip > </md-icon> <md-menu md-position-mode=\"target-right target\"> <md-icon aria-label=\"Delete organization icon\" md-svg-src=\"assets/icons/ic_delete_forever_black_24px.svg\" class=\"cursorPointer marginLeft1 marginRight1\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\" > <md-tooltip hide-xs >{{::\'DELETE_ORGANIZATION\' | translate}}</md-tooltip > </md-icon> <md-menu-content width=\"4\"> <md-menu-item> <md-button ng-click=\"vm.deleteSelectedOrganization(organization)\"> {{ \'DELETE_ORGANIZATION\' | translate }} <span class=\"warnColor\">{{ organization.name }}</span> </md-button> </md-menu-item> </md-menu-content> </md-menu> </div> </div> <ul ng-if=\"(organization.childOrganizations || organization.supportChildOrganizations) && vm.showOrganization(organization)\"> <li ng-repeat=\"organization in organization.childOrganizations\" ng-include=\"\'organizationTree\'\"> </li> <li ng-repeat=\"organization in organization.supportChildOrganizations\" ng-include=\"\'organizationChildTree\'\"> </li> </ul></script><ul><li ng-repeat=\"organization in vm.organization.organizationData\" ng-include=\"\'organizationTree\'\"></li></ul></div></div>");
$templateCache.put("app/periodicSummary/periodicSummary.html","<div id=\"periodicSummaryWrapper\" flex=\"\" layout=\"\" layout-gt-md=\"column\"><div id=\"periodicSummaryContainer\" layout-padding=\"\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"{{::\'PERIODIC_SUMMARY_REPORTS\' | translate}}\"><div id=\"section-to-print\" class=\"periodicSummaryContainer\" flex=\"\" layout-padding=\"\"><div layout=\"row\" layout-align=\"start center\" class=\"header\"><div class=\"logoContainer\"></div><div flex=\"\"><p class=\"md-title\">{{::\'PERIODIC_SUMMARY_FOR\' | translate}} <span class=\"md-display-1 companyName\">{{vm.summary.companyName}}</span></p></div></div><md-divider></md-divider><div class=\"md-display-1 main-title\">{{::\'FINANCIAL_REPORT\' | translate}}</div><div id=\"accordionContainer\"><div class=\"listItem\" style=\"min-height:35px;\"><span class=\"listItemHeader\" style=\"padding-left:1.6em;\">{{::\'CURRENT_CHARGES\' | translate}}</span> <span class=\"listItemSum greenColor\">{{vm.summary.financialData.currentPeriod.amount | currency: vm.summary.currency}}</span></div><div class=\"listItem\" ng-click=\"vm.toggleAccordian(\'paymentsOnHold\')\"><span class=\"listItemHeader\"><span class=\"expandCollapse\" ng-class=\"{\'collapseActive\' : vm.summary.financialData.paymentsOnHold.collapsed}\"></span> {{::vm.summary.financialData.forInvoicing.description}}</span> <span class=\"listItemSum grayColor\">{{vm.summary.financialData.paymentsOnHold.total.amount | currency : vm.summary.currency}}</span><div class=\"listSubItemsContainer\" ng-class=\"{\'listSubItemsFullHeight\' : vm.summary.financialData.paymentsOnHold.collapsed}\"><div class=\"listSubItem\" ng-repeat=\"onHoldtransaction in vm.summary.financialData.paymentsOnHold.data\"><span class=\"listSubItemDate\">{{::onHoldtransaction.timestamp | date : \'mediumDate\'}}</span> <span class=\"listSubItemAmount\">{{::onHoldtransaction.money.amount | currency : vm.summary.currency}}</span> <span class=\"listSubItemDescription\">{{::onHoldtransaction.description | date : \'mediumDate\'}}</span></div></div></div><div class=\"listItem\" ng-click=\"vm.toggleAccordian(\'forInvoicing\')\"><span class=\"listItemHeader\"><span class=\"expandCollapse\" ng-class=\"{\'collapseActive\' : vm.summary.financialData.forInvoicing.collapsed}\"></span> {{::vm.summary.financialData.paymentsOnHold.description}}</span> <span class=\"listItemSum blueColor\">{{vm.summary.financialData.forInvoicing.total.amount | currency : vm.summary.currency}}</span><div class=\"listSubItemsContainer\" ng-class=\"{\'listSubItemsFullHeight\' : vm.summary.financialData.forInvoicing.collapsed}\"><div class=\"listSubItem\" ng-repeat=\"forInvoicingTransaction in vm.summary.financialData.forInvoicing.data\"><span class=\"listSubItemDate\">{{::forInvoicingTransaction.timestamp | date : \'mediumDate\'}}</span> <span class=\"listSubItemAmount\">{{::forInvoicingTransaction.money.amount | currency : vm.summary.currency}}</span> <span class=\"listSubItemDescription\">{{::forInvoicingTransaction.description}}</span></div></div></div></div><div class=\"md-caption commissionDetails\">*{{::\'COMMISSION_FEE_DETAILS\' | translate}}</div><md-divider></md-divider><div class=\"md-display-1 loyaltyCreditsReport\">{{::\'LOYALTY_CREDITS_REPORT\' | translate}}</div><div class=\"loyaltyTotalHeader\">{{::\'LOYALTY_TOTAL\' | translate}}</div><md-divider></md-divider><div layout=\"\" layout-align=\"space-between start\"><div>{{::\'LOYALTY_GIVEN\' | translate}}</div><div>{{vm.summary.totalData.given}} {{::\'TOKENS\' | translate}}</div></div><div layout=\"\" layout-align=\"space-between start\"><div>{{::\'LOYALTY_USED\' | translate}}</div><div>{{vm.summary.totalData.used}} {{::\'TOKENS\' | translate}}</div></div><div layout=\"\" layout-align=\"space-between start\"><div>{{::\'LOYALTY_SOLD\' | translate}}</div><div>{{vm.summary.totalData.sold}} {{::\'TOKENS\' | translate}}</div></div><br><div class=\"loyaltyTotalHeader\">{{::\'LOYALTY_CURRENT_MONTH\' | translate}}</div><md-divider></md-divider><div layout=\"\" layout-align=\"space-between start\"><div>{{::\'LOYALTY_GIVEN\' | translate}}</div><div>{{vm.summary.currentMonthData.given}} {{::\'TOKENS\' | translate}}</div></div><div layout=\"\" layout-align=\"space-between start\"><div>{{::\'LOYALTY_USED\' | translate}}</div><div>{{vm.summary.currentMonthData.used}} {{::\'TOKENS\' | translate}}</div></div><div layout=\"\" layout-align=\"space-between start\"><div>{{::\'LOYALTY_SOLD\' | translate}}</div><div>{{vm.summary.currentMonthData.sold}} {{::\'TOKENS\' | translate}}</div></div><md-divider></md-divider><div id=\"printContainer\" flex=\"\"></div></div></md-tab><md-tab label=\"{{vm.summary.invoiceNaming.name}}\"><div id=\"invoiceContainer\" flex=\"\" layout-padding=\"\"><div id=\"invoiceTableContainer\"><md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span>{{vm.summary.invoiceNaming.name}}</span></div></md-toolbar><div layout=\"\" layout-xs=\"column\" layout-gt-md=\"row\" layout-align-xs=\"center stretch\" flex=\"\" layout-align=\"start center\" id=\"periodicSumFilterContainer\" class=\"hideInPrintMode\"><div flex-xs=\"\" style=\"min-height:3.5em;\"><md-input-container style=\"min-width: 150px;\"><label>{{::\'SELECT_YEAR\' | translate}}</label><md-select name=\"year\" ng-model=\"vm.summary.selectedYear\" ng-change=\"vm.changeYear(vm.summary.selectedYear)\"><md-option ng-repeat=\"year in vm.summary.yearList\" value=\"{{year}}\">{{year}}</md-option></md-select></md-input-container></div><div layout=\"\" flex-xs=\"\" layout-xs=\"row\" layout-align-xs=\"center center\"><md-radio-group ng-model=\"vm.summary.searchRadioButton.type\" layout=\"\" ng-change=\"vm.changeType(vm.summary.searchRadioButton.type)\"><md-radio-button value=\"\" class=\"md-primary\">{{::\'INVOICE_ALL\' | translate}}</md-radio-button><md-radio-button value=\"INCOMING\" class=\"md-primary\">{{::\'INVOICE_TO_R2W\' | translate}}</md-radio-button><md-radio-button value=\"OUTGOING\" class=\"md-primary\">{{::\'INVOICE_FROM_R2W\' | translate}}</md-radio-button></md-radio-group></div></div><br><md-divider></md-divider><br><md-table-container><table md-table=\"\" multiple=\"\" ng-model=\"vm.summary.selectedInvoices\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.summary.invoiceOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\"></th><th md-column=\"\" md-order-by=\"date\">{{::\'DATE\' | translate}}</th><th md-column=\"\">{{::\'DOWNLOAD\' | translate}}</th><th md-column=\"\" md-order-by=\"number\">{{vm.summary.invoiceNaming.invoiceNumber}}</th><th md-column=\"\" md-order-by=\"state\">{{vm.summary.invoiceNaming.invoiceState}}</th><th md-column=\"\" md-order-by=\"transaction.amount.amount\">{{::\'INVOICE_TOTAL\' | translate}}</th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"invoice in vm.summary.invoiceData\" ng-class=\"{invoiceType: invoice.type === \'INCOMING\'}\"><td md-cell=\"\"><img ng-if=\"invoice.type === \'INCOMING\'\" ng-src=\"{{vm.summary.images[0].src}}\"><img ng-if=\"invoice.type === \'OUTGOING\'\" ng-src=\"{{vm.summary.images[1].src}}\"></td><td md-cell=\"\">{{invoice.date | date : \'shortDate\'}}</td><td md-cell=\"\" ng-if=\"invoice.type === \'INCOMING\'\"><md-menu md-offset=\"40 0\"><md-button aria-label=\"Open download invoices menu\" class=\"md-icon-button\" ng-show=\"invoice.state !== \'NEW\'\" ng-click=\"vm.openOptions($mdMenu, $event, invoice)\"><md-icon md-menu-origin=\"\" md-svg-icon=\"assets/icons/ic_file_download_black_24px.svg\"></md-icon><md-tooltip hide-xs=\"\">{{::\'CLICK_FOR_DOWNLOAD_OPTIONS\' | translate}}</md-tooltip></md-button><md-menu-content width=\"4\"><md-menu-item ng-repeat=\"item in vm.summary.downloadOptions\"><md-button ng-click=\"vm.downloadInvoices(invoice.id, item.type)\" \"=\"\">{{item.name}}</md-button></md-menu-item></md-menu-content></md-menu></td><td md-cell=\"\" ng-if=\"invoice.type === \'OUTGOING\'\"><md-button aria-label=\"Open download invoices menu\" class=\"md-icon-button\" ng-show=\"invoice.state !== \'NEW\'\" ng-click=\"vm.downloadInvoice(invoice.id)\"><md-icon md-menu-origin=\"\" md-svg-icon=\"assets/icons/ic_file_download_black_24px.svg\"></md-icon><md-tooltip hide-xs=\"\">{{::\'DOWNLOAD_INVOICE\' | translate}}</md-tooltip></md-button></td><td md-cell=\"\"><md-input-container style=\"margin: 10px 0 -10px 0;\" md-no-float=\"\"><input ng-model=\"invoice.number\" placeholder=\"{{::\'INSERT_INVOICE_NUMBER\' | translate}}\" onfocus=\"this.placeholder=\'\'\" ng-disabled=\"invoice.state !== \'NEW\'\"></md-input-container></td><td md-cell=\"\">{{invoice.state}}</td><td md-cell=\"\">{{invoice.total | currency: vm.currency}}{{}}</td><td md-cell=\"\" class=\"editInvoiceCell\" ng-click=\"vm.showEditInvoiceModal($event,invoice.id, invoice.description, invoice.state)\"><md-button ng-if=\"invoice.state === \'NEW\' && invoice.type === \'INCOMING\'\" class=\"md-raised\" ng-click=\"vm.sendInvoice(invoice.id, invoice.number)\" ng-disabled=\"invoice.number === null || invoice.number === \'\'\">{{::\'SEND_INVOICE\' | translate}}</md-button><i class=\"material-icons\" style=\"color: coral;\" ng-if=\"invoice.state === \'INVOICED\'\"><md-tooltip>{{::\'INVOICED_WARNING\' | translate}}</md-tooltip>warning</i></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.summary.invoicePageSize\" md-limit-options=\"vm.summary.invoicePageOptions\" md-page=\"vm.summary.invoicePage\" md-total=\"{{vm.summary.invoiceTotal}}\" md-label=\"{{vm.summary.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\" md-page-select=\"true\" md-boundary-links=\"true\"></md-table-pagination></div></div></md-tab><md-tab label=\"{{::\'BUSSINESS_INVOICES_LIST\' | translate}}\"><div flex=\"\" layout-padding=\"\"><div><business-transactions></business-transactions></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/pricing/pricing.html","<div id=\"pricing-container\" layout=\"column\" layout-padding=\"\" flex=\"\" class=\"overflow-vertical-wrapper\"><div class=\"pricing-body\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"{{ \'TOKEN_PACKAGES\' | translate }}\"><token-packages token-package-data=\"vm.tokenPackagesData\" region-currency=\"vm.regionCurrency\" on-create=\"vm.refreshTokenPackageList()\"></token-packages></md-tab><md-tab label=\"{{ \'SINGLE_WASH\' | translate }}\"><single-wash single-wash-data=\"vm.singleWashData\" region-currency=\"vm.regionCurrency\" on-create=\"vm.refreshSingleWashList()\"></single-wash></md-tab></md-tabs></div></div>");
$templateCache.put("app/releaseNotes/releaseNotes.html","<div class=\"margin30 release-notes-wrapper\"><div class=\"marginBottom20\"><h3>{{ \"BACKEND_RELEASE_NOTES\" | translate }}</h3><div ng-repeat=\"notes in vm.releaseNotesData track by $index\"><div layout=\"column\" flex=\"\" class=\"fullWidth\">{{ notes }}</div></div></div><div><h3>{{ \"FRONTEND_RELEASE_NOTES\" | translate }}</h3><div ng-repeat=\"merchantNotes in vm.merchantWebAppReleaseNotes track by $index\">{{ merchantNotes }}</div></div></div>");
$templateCache.put("app/reports/reports.html","<md-content flex=\"\" layout=\"column\" layout-gt-md=\"row\"><div flex=\"\" flex-order=\"1\" id=\"reportsContainer\"><div flex=\"\" layout-padding=\"\" ui-view=\"reportDetails\"><span layout-padding=\"\" layout-margin=\"\" class=\"md-headline\">{{::\'SELECT_TYPE_OF_REPORT\' | translate}}</span></div></div><div flex-order=\"0\" flex-order-gt-md=\"2\" id=\"reportsFilterContainer\"><form name=\"filterForm\" no-validate=\"\"><div layout=\"column\" layout-padding=\"\"><div class=\"reportTitle\">{{::\'REPORTS_FILTER\' | translate}}</div><div class=\"md-caption\">{{::\'REPORTS_TYPE_OF_REPORT\' | translate}}</div><md-select ng-model=\"vm.report.selectedReportType\" ng-change=\"vm.report.setReportType(vm.report.selectedReportType, vm.reportTypes)\" aria-label=\"set report type select box\"><md-option ng-repeat=\"reportType in vm.reportTypes track by $index\" value=\"{{reportType.type}}\">{{::reportType.type | translate}}</md-option></md-select><div ng-show=\"vm.report.facilitiesVisible\" class=\"md-caption\">{{::\'REPORTS_CHOOSE_FACILITY\' | translate}}</div><md-select name=\"facilitySelect\" ng-show=\"vm.report.facilitiesVisible\" ng-model=\"vm.report.selectedFacilitySerial\" aria-label=\"facility select filter\"><md-option ng-repeat=\"facility in vm.report.devices track by $index\" value=\"{{facility.facilityPointId}}\">{{facility.name}}</md-option></md-select><div ng-show=\"vm.report.croatiaRegionVisibility && vm.report.onlyMoneyReportVisibility\" class=\"md-caption\">{{::\'SELECT_CURRENCY\' | translate}}</div><md-select name=\"currencySelect\" ng-show=\"vm.report.croatiaRegionVisibility && vm.report.onlyMoneyReportVisibility\" ng-model=\"vm.report.selectedCurrency\" aria-label=\"currency select filter\"><md-option ng-repeat=\"currency in [\'HRK\', \'EUR\']\" value=\"{{currency}}\">{{currency}}</md-option></md-select><div ng-messages=\"filterForm.facilitySelect.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div><div ng-show=\"vm.report.periodsVisible === false\" layout-sm=\"row\" layout-md=\"row\"><div class=\"datePickerContainer\"><md-input-container class=\"md-block\"><label>{{::\'FROM\' | translate}}</label><md-datepicker ng-model=\"vm.report.fromDate\" md-open-on-focus=\"\" md-placeholder=\"Enter date\" md-max-date=\"vm.fromDateMax\"></md-datepicker></md-input-container></div><div class=\"datePickerContainer\"><md-input-container class=\"md-block\"><label>{{::\'TO\' | translate}}</label><md-datepicker ng-model=\"vm.report.toDate\" md-open-on-focus=\"\" md-placeholder=\"Enter date\" md-min-date=\"vm.report.fromDate\" ng-change=\"vm.toDateSelected()\"></md-datepicker></md-input-container></div></div><div ng-show=\"vm.report.periodsVisible\"><md-input-container class=\"md-icon-float md-block\"><label>{{::\'FROM\' | translate}} {{::\'MONTH\' | translate}}</label><md-icon md-svg-icon=\"assets/icons/ic_date_range_black_24px.svg\"></md-icon><md-select ng-model=\"vm.report.selectedFrom1\" name=\"period1From\" aria-label=\"From month filter\"><md-option ng-repeat=\"month in vm.report.monthsList track by $index\" ng-value=\"month.id\" ng-disabled=\"month.id >= vm.report.selectedTo1\">{{month.name}}</md-option></md-select><div ng-messages=\"filterForm.period1From.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"date\">{{::\'VALIDATION_NOT_A_DATE\' | translate}}</div><div ng-message=\"fromLessThanTo\">{{::\'VALIDATION_FROM\' | translate}}</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{::\'TO\' | translate}} {{::\'MONTH\' | translate}}</label><md-icon md-svg-icon=\"assets/icons/ic_date_range_black_24px.svg\"></md-icon><md-select ng-model=\"vm.report.selectedTo1\" name=\"period1To\" aria-label=\"To month filter\"><md-option ng-repeat=\"month in vm.report.monthsList track by $index\" ng-value=\"month.id\" ng-disabled=\"month.id <= vm.report.selectedFrom1\">{{month.name}}</md-option></md-select><div ng-messages=\"filterForm.period1To.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"date\">{{::\'VALIDATION_NOT_A_DATE\' | translate}}</div><div ng-message=\"fromLessThanTo\">{{::\'VALIDATION_FROM\' | translate}}</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{::\'YEAR\' | translate}} 1</label><md-icon md-svg-icon=\"assets/icons/ic_date_range_black_24px.svg\"></md-icon><md-select ng-model=\"vm.report.selectedFrom2\" name=\"period2From\" aria-label=\"from year filter\"><md-option ng-repeat=\"year in vm.report.yearsList track by $index\" ng-value=\"year\" ng-disabled=\"year === vm.report.selectedTo2\">{{year}}</md-option></md-select><div ng-messages=\"filterForm.period2From.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"date\">{{::\'VALIDATION_NOT_A_DATE\' | translate}}</div><div ng-message=\"fromLessThanTo\">{{::\'VALIDATION_FROM\' | translate}}</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{::\'YEAR\' | translate}} 2</label><md-icon md-svg-icon=\"assets/icons/ic_date_range_black_24px.svg\"></md-icon><md-select ng-model=\"vm.report.selectedTo2\" name=\"period2To\" aria-label=\"to year filter\"><md-option ng-repeat=\"year in vm.report.yearsList track by $index\" ng-value=\"year\" ng-disabled=\"year === vm.report.selectedFrom2\">{{year}}</md-option></md-select><div ng-messages=\"filterForm.period2To.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"date\">{{::\'VALIDATION_NOT_A_DATE\' | translate}}</div><div ng-message=\"fromLessThanTo\">{{::\'VALIDATION_FROM\' | translate}}</div></div></md-input-container></div><div ng-show=\"vm.report.hoursVisibility\"><md-input-container class=\"md-icon-float md-block\"><label>{{::\'FROM\' | translate}} {{::\'BOX_COUNTER_HOURS\' | translate}}</label><md-icon md-svg-icon=\"assets/icons/ic_date_range_black_24px.svg\"></md-icon><md-select ng-model=\"vm.report.selectedFrom3\" name=\"period3From\" aria-label=\"From month filter\"><md-option ng-repeat=\"hour in vm.report.hoursList track by $index\" ng-value=\"hour\" ng-disabled=\"hour >= vm.report.selectedTo3 && vm.report.fromDate.getTime() === vm.report.toDate.getTime()\">{{hour}}</md-option></md-select><div ng-messages=\"filterForm.period3From.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"date\">{{::\'VALIDATION_NOT_A_DATE\' | translate}}</div><div ng-message=\"fromLessThanTo\">{{::\'VALIDATION_FROM\' | translate}}</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label>{{::\'TO\' | translate}} {{::\'BOX_COUNTER_HOURS\' | translate}}</label><md-icon md-svg-icon=\"assets/icons/ic_date_range_black_24px.svg\"></md-icon><md-select ng-model=\"vm.report.selectedTo3\" name=\"period3To\" aria-label=\"To month filter\"><md-option ng-repeat=\"hour in vm.report.hoursList track by $index\" ng-value=\"hour\" ng-disabled=\"hour <= vm.report.selectedFrom3 && vm.report.fromDate.getTime() === vm.report.toDate.getTime()\">{{hour}}</md-option></md-select><div ng-messages=\"filterForm.period3To.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"date\">{{::\'VALIDATION_NOT_A_DATE\' | translate}}</div><div ng-message=\"fromLessThanTo\">{{::\'VALIDATION_FROM\' | translate}}</div></div></md-input-container></div><md-divider></md-divider><md-button ng-disabled=\"filterForm.$invalid\" class=\"md-raised\" ng-click=\"vm.report.updateFilter()\">{{::\'SEARCH\' | translate}}</md-button></div></form></div></md-content>");
$templateCache.put("app/reportsBuilderKarcher/reportsBuilderKarcher.html","<div class=\"fullWidth karcher-reports-wrapper\"><div layout-padding=\"\"><form class=\"marginLeft1\" name=\"karcherReportsBuilderForm\" ng-submit=\"vm.getReport()\"><div layout=\"column\"><div layout=\"row\"><div flex=\"50\"><md-input-container class=\"fullWidth\"><label>{{ \'REPORT_NAME\' | translate }}</label><md-select ng-model=\"vm.reportBuilderViewModel.selectedReport\" name=\"selectedReportItem\" required=\"\" ng-change=\"vm.changeReportName()\" aria-label=\"Report name\"><md-option ng-repeat=\"reportName in vm.reportBuilderViewModel.reportNameList\" ng-value=\"reportName.id\">{{ reportName.name }}</md-option></md-select></md-input-container></div><div flex=\"\" layout=\"row\" layout-align=\"end center\"><div></div><md-button class=\"md-raised black-karcher-button\" ng-class=\"{\'black-karcher-button-disabled\': karcherReportsBuilderForm.$invalid}\" type=\"submit\" ng-disabled=\"karcherReportsBuilderForm.$invalid\" aria-label=\"Get report data\">{{::\'SEARCH\' | translate}}</md-button><md-button class=\"md-raised primary-karcher-button\" ng-class=\"{\'primary-karcher-button-disabled\': !(vm.reportBuilderViewModel.isTableVisible || vm.reportBuilderViewModel.isChartVisible)}\" ng-disabled=\"!(vm.reportBuilderViewModel.isTableVisible || vm.reportBuilderViewModel.isChartVisible)\" ng-click=\"vm.exportToCsvReports()\" aria-label=\"Download CSV\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></div></div><div class=\"form-group-report-builder fullWidth\" layout=\"row\" layout-wrap=\"\"><div ng-repeat=\"inputItem in vm.reportBuilderViewModel.reportBuilderData\" layout=\"row\"><div flex=\"\" ng-if=\"inputItem.type === \'basic-input\'\" class=\"report-builder-input-wrapper\"><md-input-container class=\"fullWidth\"><label>{{inputItem.label}}</label> <input ng-model=\"inputItem.model\" name=\"{{inputItem.inputName}}\" aria-label=\"Basic input\"></md-input-container></div><div flex=\"\" ng-if=\"inputItem.type === \'select-input\'\" class=\"report-builder-input-wrapper\"><md-input-container class=\"fullWidth\"><label>{{ inputItem.label }}</label><md-select ng-model=\"inputItem.model\" ng-change=\"vm.onChangeInputs(inputItem)\" name=\"{{inputItem.inputName}}\" aria-label=\"Selected input\"><md-option ng-repeat=\"selectedItem in inputItem.selectorList\" ng-value=\"selectedItem.id\">{{ selectedItem.name }}</md-option></md-select></md-input-container></div><div flex=\"\" ng-if=\"inputItem.type === \'date-input\'\" class=\"report-builder-input-date-wrapper\"><md-input-container class=\"no-margin-date-picker fullWidth\"><label>{{inputItem.label}}</label><md-datepicker ng-model=\"inputItem.model\" ng-change=\"vm.onChangeInputs(inputItem)\" name=\"{{inputItem.inputName}}\" md-open-on-focus=\"\" md-placeholder=\"{{inputItem.placeholder}}\" md-hide-icons=\"calendar\"></md-datepicker></md-input-container></div><div flex=\"\" ng-if=\"inputItem.type === \'multiply-input\'\" class=\"report-builder-input-wrapper\"><div layout=\"row\" flex=\"\"><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearMultiplyInput(inputItem)\"></md-icon><multiply-items-selector list=\"inputItem.selectorList\" enable-selector=\"inputItem.enableSelector\" place-holder-text=\"inputItem.placeholder\" clear-site-text-input=\"inputItem.model\" selected-list=\"vm.getItems(ids, inputItem)\" validate-input=\"vm.itemSelected(valid)\" flex=\"\"></multiply-items-selector></div></div></div></div></div></form></div><div id=\"chartDataMissingContainer\" ng-if=\"!vm.reportBuilderViewModel.isChartVisible && !vm.reportBuilderViewModel.isTableVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div><div ng-if=\"vm.reportBuilderViewModel.isChartVisible && !vm.reportBuilderViewModel.isTableVisible\"><p class=\"time-zone-info-wrapper\">{{ \'SELECTED_FACILITY_TIMEZONE\' | translate }}<span class=\"paddingLeft10 boldText500\">{{ vm.reportBuilderViewModel.facilityTimeZone }}</span></p><line-chart options=\"vm.reportBuilderViewModel.chartData\" sub-chart=\"false\" chart-id=\"{{vm.reportBuilderViewModel.selectedReport}}\"></line-chart></div><div ng-show=\"vm.reportBuilderViewModel.isChartVisible\"><weather-history-chart weather-data=\"vm.reportBuilderViewModel.weatherHistoryData\" location-data=\"vm.reportBuilderViewModel.weatherLocationData\"></weather-history-chart></div><div ng-if=\"vm.reportBuilderViewModel.isChartVisible && !vm.reportBuilderViewModel.isTableVisible\" class=\"margin30\"><facilities-group-grid options=\"vm.reportBuilderViewModel.chartData\" group-label=\"{{vm.reportBuilderViewModel.firstRowTableColumnTitle}}\"></facilities-group-grid></div><div ng-if=\"!vm.reportBuilderViewModel.isChartVisible && vm.reportBuilderViewModel.isTableVisible\" class=\"margin30\"><report-builder-table-view report-builder-table-view-data=\"vm.reportBuilderViewModel.tableChartData\" report-body-data=\"vm.reportBuilderViewModel.reportBodyData\" pagination-params=\"vm.updateTablePagination(page, limit)\"></report-builder-table-view></div></div>");
$templateCache.put("app/reportsKarcher/reportsKarcher.html","<div class=\"fullWidth karcher-reports-wrapper\" layout-margin=\"\"><div layout-padding=\"\"><form name=\"karcherReportsFilterForm\" class=\"md-inline-form\" ng-submit=\"vm.searchData()\"><div layout-gt-md=\"row\" layout=\"column\" layout-align=\"center center\"><div flex-gt-md=\"70\" flex=\"90\" layout=\"column\" layout-align=\"center center\" class=\"fullWidth\"><md-input-container class=\"md-icon-float md-block noMarginRight fullWidth\"><label>{{ \'REPORT_NAME\' | translate }}</label><md-select ng-model=\"vm.karcherReports.selectedReport\" name=\"selectedReport\" required=\"\" ng-change=\"vm.changeReportName()\" aria-label=\"Report name\"><md-option ng-repeat=\"reportName in vm.karcherReports.reportNameList\" ng-value=\"reportName.id\">{{ reportName.name }}</md-option></md-select><div ng-messages=\"karcherReportsFilterForm.selectedReport.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div><div flex-gt-md=\"30\" flex=\"90\" layout=\"column\" layout-gt-md=\"row\" layout-align=\"center center\" class=\"fullWidth marginBottom20\"><md-button class=\"md-raised black-karcher-button fullWidth\" ng-class=\"{\'black-karcher-button-disabled\': karcherReportsFilterForm.selectedReport.$invalid || !vm.karcherReports.selectedWashFacility || karcherReportsFilterForm.selectedSubPoint.$invalid || karcherReportsFilterForm.selectedTimeFrame.$invalid}\" type=\"submit\" aria-label=\"Filter bu key word\" ng-disabled=\"karcherReportsFilterForm.selectedReport.$invalid || !vm.karcherReports.selectedWashFacility || karcherReportsFilterForm.selectedSubPoint.$invalid || karcherReportsFilterForm.selectedTimeFrame.$invalid\">{{::\'SEARCH\' | translate}}</md-button><md-button class=\"md-raised primary-karcher-button fullWidth\" ng-click=\"vm.exportToCsvReports()\" ng-disabled=\"!vm.karcherReports.isChartVisible\" ng-class=\"{\'primary-karcher-button-disabled\': !vm.karcherReports.isChartVisible}\" aria-label=\"Download CSV\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></div></div><div layout-gt-md=\"row\" layout=\"column\" layout-align-gt-md=\"start start\" layout-align=\"center center\"><div flex=\"90\" flex-gt-md=\"40\" layout=\"column\" layout-gt-md=\"row\" layout-align-gt-md=\"center center\" layout-align=\"space-around center\" class=\"fullWidth\"><md-input-container flex=\"\" class=\"no-margin-date-picker fullWidth\"><label>{{::\'FROM\' | translate}}</label><md-datepicker ng-model=\"vm.karcherReports.reportFrom\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-max-date=\"vm.karcherReports.reportTo\" md-hide-icons=\"calendar\"></md-datepicker><div ng-messages=\"karcherReportsFilterForm.reportFrom.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container flex=\"\" class=\"no-margin-date-picker fullWidth\"><label>{{::\'TO\' | translate}}</label><md-datepicker ng-model=\"vm.karcherReports.reportTo\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-min-date=\"vm.karcherReports.reportFrom\" md-hide-icons=\"calendar\"></md-datepicker><div ng-messages=\"karcherReportsFilterForm.reportTo.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div><div flex=\"20\" layout=\"column\" layout-gt-md=\"row\" class=\"fullWidth marginRight1 top-aline-search-component\"><div layout=\"row\" flex=\"\"><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearWashFacilityInput()\"></md-icon><multiply-items-selector list=\"vm.karcherReports.washFacilityList\" enable-selector=\"false\" place-holder-text=\"vm.karcherReports.placeHolderText\" clear-site-text-input=\"vm.karcherReports.selectedWashFacility\" selected-list=\"vm.getAvailableBoxes(ids)\" flex=\"\"></multiply-items-selector></div></div><div flex=\"90\" flex-gt-md=\"40\" layout=\"column\" layout-gt-md=\"row\" layout-align=\"center center\" class=\"fullWidth\"><md-input-container class=\"md-icon-float md-block fullWidth marginRight1\"><label>{{ \"SUB_POINT\" | translate }}</label><md-select ng-model=\"vm.karcherReports.selectedSubPoint\" name=\"selectedSubPoint\" ng-required=\"vm.enableSubPointsInput\" ng-disabled=\"!vm.enableSubPointsInput\" aria-label=\"Sub point\"><md-option ng-repeat=\"subPoint in vm.karcherReports.subPointList\" ng-value=\"subPoint.id\">{{ subPoint.name | translate }}</md-option></md-select><div ng-messages=\"karcherReportsFilterForm.selectedSubPoint.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container class=\"md-icon-float md-block fullWidth marginRight1\"><label>{{ \"TIME_FRAME\" | translate }}</label><md-select ng-model=\"vm.karcherReports.selectedTimeFrame\" name=\"selectedTimeFrame\" required=\"\" aria-label=\"Time frame\"><md-option ng-repeat=\"timeFrame in vm.karcherReports.timeFrameList\" ng-value=\"timeFrame\">{{ timeFrame | translate }}</md-option></md-select><div ng-messages=\"karcherReportsFilterForm.selectedTimeFrame.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div></div></form></div><div ng-if=\"vm.karcherReports.isChartVisible\"><p class=\"time-zone-info-wrapper\">{{ \'SELECTED_FACILITY_TIMEZONE\' | translate }}<span class=\"paddingLeft10 boldText500\">{{ vm.karcherReports.facilityTimeZone }}</span></p><line-chart options=\"vm.karcherReports.chartData\" sub-chart=\"false\" chart-id=\"REPORT_1\"></line-chart></div><div id=\"chartDataMissingContainer\" ng-if=\"!vm.karcherReports.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div><div ng-show=\"vm.karcherReports.isChartVisible\"><weather-history-chart weather-data=\"vm.karcherReports.weatherHistoryData\" location-data=\"vm.karcherReports.weatherLocationData\"></weather-history-chart></div><div ng-if=\"vm.karcherReports.isChartVisible\"><facilities-group-grid options=\"vm.karcherReports.chartData\" group-label=\"{{::\'DATE\' | translate}}\"></facilities-group-grid></div></div>");
$templateCache.put("app/resetPassword/resetPassword.html","<div style=\"height: 100vh\" id=\"activateAccountContainer\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><div flex=\"\"></div><div flex=\"40\" layout=\"column\" layout-align=\"\"><div class=\"logoContainer\"></div><div flex=\"\"><div flex=\"\"><h2 translate=\"RESET_PASSWORD_WELCOME_KARCHER_MSG\" ng-if=\"vm.welcomeTitle\"></h2><h2 translate=\"RESET_PASSWORD_WELCOME_MSG\" ng-if=\"!vm.welcomeTitle\"></h2><p>{{::\'RESET_PASSWORD_WELCOME_MSG_2\' | translate}}</p><p>{{::\'RESET_PASSWORD_WELCOME_MSG_3\' | translate}}</p></div><div flex=\"\" class=\"passwordWrapper\"><form name=\"activateAccForm\" novalidate=\"\" ng-submit=\"vm.resetPassword()\" id=\"activateAccForm\"><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>{{::\'ENTER_NEW_PASSWORD\' | translate}}</label> <input type=\"{{vm.inputType}}\" name=\"password\" ng-model=\"vm.account.password\" md-minlength=\"8\" md-maxlength=\"32\" ng-minlength=\"8\" ng-maxlenght=\"32\" ng-change=\"vm.checkPassword(activateAccForm)\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$/\" required=\"\"> <i class=\"material-icons cursorPointer global-password-visibility-mark\" ng-click=\"vm.showPassword()\">visibility</i><div ng-messages=\"activateAccForm.password.$error\" layout=\"column\" layout-align=\"center start\" flex=\"\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'REQUIRED_FIELD\' | translate}}</div><div flex=\"\" ng-message=\"minlength\">- {{::\'PASSWORD_MIN_LENGTH\' | translate}}</div><div flex=\"\" ng-message=\"maxlength\">- {{::\'PASSWORD_MAX_LENGHT\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{::\'PASSWORD_VALIDATION_PATTERN_NEW\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-xs=\"\"><label>{{::\'REPEAT_NEW_PASSWORD \' | translate}}</label> <input type=\"{{vm.inputReType}}\" name=\"passwordRepeat\" ng-model=\"vm.account.repeatPassword\" required=\"\" md-minlength=\"8\" md-maxlength=\"32\" ng-minlength=\"8\" ng-maxlenght=\"32\" ng-change=\"vm.checkPassword(activateAccForm)\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$/\"> <i class=\"material-icons cursorPointer global-password-visibility-mark\" ng-click=\"vm.showReenterPassword()\">visibility</i><div ng-messages=\"activateAccForm.passwordRepeat.$error\" layout=\"column\" layout-align=\"center start\" flex=\"\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'REQUIRED_FIELD\' | translate}}</div><div flex=\"\" ng-message=\"minlength\">- {{::\'PASSWORD_MIN_LENGTH\' | translate}}</div><div flex=\"\" ng-message=\"maxlength\">- {{::\'PASSWORD_MAX_LENGHT\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{::\'PASSWORD_VALIDATION_PATTERN_NEW\' | translate}}</div><div flex=\"\" ng-if=\"!vm.account.passwordIdentical\" class=\"passwordMatchValidation\">- {{::\'PASSWORD_MATCH\' | translate}}</div></div></md-input-container><div layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised\" ui-sref=\"login\">{{::\'CANCEL\' | translate}}</md-button><md-button class=\"md-raised md-primary\" type=\"submit\" ng-disabled=\"activateAccForm.$invalid || !vm.account.passwordIdentical\">{{::\'ACTIVATE\' | translate}}</md-button></div></form></div></div></div><div flex=\"\"></div></div>");
$templateCache.put("app/settings/settings.html","<div id=\"facilitySettings\" flex=\"\" layout=\"column\" style=\"overflow-y:auto;\" layout-margin=\"\"><div id=\"settingsCityContainer\" class=\"title\"><span class=\"md-headline\">{{ vm.facility.name }}</span></div><form id=\"settingsForm\" name=\"settingsForm\" novalidate=\"\" layout=\"column\"><div id=\"generalSettingsContainer\" flex=\"none\"><div class=\"customCardTitle boxHeader\"><span class=\"customCardSubTitle md-title\">{{::\'GENERAL_SETTINGS\' | translate}}</span></div><div id=\"settingsGeneralContainer\" class=\"boxBody\" layout=\"column\" layout-gt-xs=\"row\" layout-fill=\"\" layout-wrap=\"\"><div flex=\"\" class=\"generalEntries\"><p class=\"info md-caption settingsSubHeader\">{{::\'LIGHTS\' | translate}}</p><md-switch ng-init=\"vm.facility.lightsAuto.value = false\" ng-model=\"vm.facility.lightsAuto.value\" aria-label=\"Lights auto\" class=\"md-primary\">{{ vm.facility.lightsAuto.value ? \"AUTO\" : \"MANUAL\" | translate }}</md-switch><md-switch ng-disabled=\"vm.facility.lightsAuto.value\" ng-class=\"{\'switchDisabled\': vm.facility.lightsAuto.value}\" ng-init=\"vm.facility.lightsOn.value = false\" ng-model=\"vm.facility.lightsOn.value\" aria-label=\"Lights on\" class=\"md-primary\">{{ vm.facility.lightsOn.value ? \"ON\" : \"OFF\" | translate }}</md-switch><div class=\"settingsGeneralTimeContainer\" ng-if=\"vm.facility.lightsTo\"><md-input-container><label>{{::\'FROM\' | translate}} (H/minute)</label> <input name=\"lightsFrom\" aria-label=\"Light from time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.lightsFrom.valueHour\" required=\"\"><div ng-messages=\"settingsForm.lightsFrom.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"lightsFrom\" aria-label=\"Light from time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.lightsFrom.valueMinute\" required=\"\"><div ng-messages=\"settingsForm.lightsFrom.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><label>{{::\'TO\' | translate}} (H/minute)</label> <input name=\"lightsTo\" aria-label=\"Light to time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.lightsTo.valueHour\" required=\"\"><div ng-messages=\"settingsForm.lightsTo.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"lightsTo\" aria-label=\"Light to time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.lightsTo.valueMinute\" required=\"\"><div ng-messages=\"settingsForm.lightsTo.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div><div class=\"settingsGeneralTimeContainer\" ng-if=\"!vm.facility.lightsTo\"><md-input-container><label>{{::\'FROM\' | translate}} (H/min)</label> <input name=\"lightsFromTimeHour\" aria-label=\"Light from time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.lightsFromTimeHour.value\" required=\"\"><div ng-messages=\"settingsForm.lightsFromTimeHour.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"lightsFromTimeMinute\" aria-label=\"Light from time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.lightsFromTimeMinute.value\" required=\"\"><div ng-messages=\"settingsForm.lightsFromTimeMinute.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><label>{{::\'TO\' | translate}} (H/min)</label> <input name=\"lightsToTimeHour\" aria-label=\"Light to time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.lightsToTimeHour.value\" required=\"\"><div ng-messages=\"settingsForm.lightsToTimeHour.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"lightsToTimeMinute\" aria-label=\"Light to time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.lightsToTimeMinute.value\" required=\"\"><div ng-messages=\"settingsForm.lightsToTimeMinute.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div></div><div flex=\"\" class=\"generalEntries\"><p class=\"info md-caption settingsSubHeader\">{{::\'GROUPS\' | translate}}</p><md-switch ng-init=\"vm.facility.value = false\" ng-model=\"vm.facility.groupsAuto.value\" aria-label=\"Groups auto\" class=\"md-primary\">{{ vm.facility.groupsAuto.value ? \"AUTO\" : \"MANUAL\" | translate }}</md-switch><md-switch ng-disabled=\"vm.facility.groupsAuto.value\" ng-class=\"{\'switchDisabled\': vm.facility.groupsAuto.value}\" ng-init=\"vm.facility.groupsOn.value = false\" ng-model=\"vm.facility.groupsOn.value\" aria-label=\"Groups on\" class=\"md-primary\">{{ vm.facility.groupsOn.value ? \"ON\" : \"OFF\" | translate }}</md-switch><div class=\"settingsGeneralTimeContainer\" ng-if=\"vm.facility.groupsTo\"><md-input-container><label>{{::\'FROM\' | translate}} (H/minute)</label> <input name=\"groupsFrom\" aria-label=\"Groups from time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.groupsFrom.valueHour\" required=\"\"><div ng-messages=\"settingsForm.groupsFrom.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"groupsFrom\" aria-label=\"Groups from time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.groupsFrom.valueMinute\" required=\"\"><div ng-messages=\"settingsForm.groupsFrom.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><label>{{::\'TO\' | translate}} (H/minute)</label> <input name=\"groupsTo\" aria-label=\"Groups to time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.groupsTo.valueHour\" required=\"\"><div ng-messages=\"settingsForm.groupsTo.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"groupsTo\" aria-label=\"Groups to time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.groupsTo.valueMinute\" required=\"\"><div ng-messages=\"settingsForm.groupsTo.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div><div class=\"settingsGeneralTimeContainer\" ng-if=\"!vm.facility.groupsTo\"><md-input-container><label>{{::\'FROM\' | translate}} (H/min)</label> <input name=\"groupsFromTimeHour\" aria-label=\"Groups from time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.groupsFromTimeHour.value\" required=\"\"><div ng-messages=\"settingsForm.groupsFromTimeHour.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"groupsFromTimeMinute\" aria-label=\"Groups from time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.groupsFromTimeMinute.value\" required=\"\"><div ng-messages=\"settingsForm.groupsFromTimeMinute.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><label>{{::\'TO\' | translate}} (H/min)</label> <input name=\"groupsToTimeHour\" aria-label=\"Groups to time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.groupsToTimeHour.value\" required=\"\"><div ng-messages=\"settingsForm.groupsToTimeHour.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"groupsToTimeMinute\" aria-label=\"Groups to time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.groupsToTimeMinute.value\" required=\"\"><div ng-messages=\"settingsForm.groupsToTimeMinute.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div></div><div flex=\"\" class=\"generalEntries\"><p class=\"info md-caption settingsSubHeader\">{{::\'ANTI_FREEZE\' | translate}}</p><md-switch ng-init=\"vm.facility.antifreezeOn.value = false\" ng-model=\"vm.facility.antifreezeOn.value\" aria-label=\"Antifreeze on\" class=\"md-primary\">{{ vm.facility.antifreezeOn.value ? \"ON\" : \"OFF\" | translate }}</md-switch><md-input-container><label>{{::\'TEMPERATURE\' | translate}} (&degC)</label> <input name=\"antifreezeFrom\" type=\"number\" ng-model=\"vm.facility.antifreezeFrom.value\" placeholder=\"\" required=\"\"><div ng-messages=\"settingsForm.antifreezeFrom.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div><div flex=\"\" class=\"generalEntries\"><p class=\"info md-caption settingsSubHeader\">{{::\'TARIFFS\' | translate}} <span ng-if=\"vm.facility.activeTarrif !== null\">- {{ !vm.facility.activeTarrif ? \'DAY\' : \'NIGHT\' | translate }}</span></p><md-switch ng-model=\"vm.facility.tariffsOn.value\" ng-if=\"vm.facility.tariffsOn\" ng-true-value=\"1\" ng-false-value=\"0\" aria-label=\"Tariffs on\" class=\"md-primary\">{{ vm.facility.groupsOn.value ? \"ON\" : \"OFF\" | translate }}</md-switch><div layout=\"\" layout-align=\"center center\" layout-padding=\"\"><div flex=\"50\" layout=\"\" layout-align=\"center center\" ng-if=\"vm.facility.tariffsFromTimeHour\"><md-input-container><label>{{::\'FROM\' | translate}} (H/min)</label> <input name=\"tariffsFromTimeHour\" aria-label=\"Groups from time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.tariffsFromTimeHour.value\" required=\"\"><div ng-messages=\"settingsForm.tariffsFromTimeHour.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"tariffsFromTimeMinute\" aria-label=\"Groups from time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.tariffsFromTimeMinute.value\" required=\"\"><div ng-messages=\"settingsForm.tariffsFromTimeMinute.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><label>{{::\'TO\' | translate}} (H/min)</label> <input name=\"tariffsToTimeHour\" aria-label=\"Groups to time\" type=\"number\" min=\"0\" max=\"23\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.tariffsToTimeHour.value\" required=\"\"><div ng-messages=\"settingsForm.tariffsToTimeHour.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container><input name=\"tariffsToTimeMinute\" aria-label=\"Groups to time\" type=\"number\" min=\"0\" max=\"59\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"vm.facility.tariffsToTimeMinute.value\" required=\"\"><div ng-messages=\"settingsForm.tariffsToTimeMinute.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div></div><div layout=\"row\" layout-align=\"start center\" layout-wrap=\"\"><div ng-repeat=\"tariff in vm.facility.tariffs\" flex=\"20\"><md-input-container><label>{{tariff.name}} (sec)</label> <input name=\"tariff\" type=\"number\" min=\"0\" max=\"9999\" ng-pattern=\"vm.facility.noDecimals\" ng-model=\"tariff.value\" required=\"\"><div ng-messages=\"settingsForm[\'tariff\' + $index].$error\"><div ng-message=\"required\">{{\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container></div></div></div></div></div><div id=\"groupSettingsContainer\" flex=\"none\"><div class=\"customCardTitle boxHeader\"><span class=\"customCardSubTitle md-title\">{{::\'GROUP_COUNTERS\' | translate}}</span></div><div class=\"boxBody\"><div layout=\"column\" layout-gt-sm=\"row\"><md-button class=\"md-raised\" ng-click=\"vm.facility.resetAllCashCount()\">{{::\'RESET_CASH_COUNT_ALL\' | translate}}</md-button><md-button class=\"md-raised\" ng-click=\"vm.facility.resetAllCoinsCount()\">{{::\'RESET_COINS_COUNT_ALL\' | translate}}</md-button><md-button class=\"md-raised\" ng-click=\"vm.facility.resetAllEurokeyCount()\">{{::\'RESET_EUROKEY_COUNT_ALL\' | translate}}</md-button></div><div flex=\"\" layout=\"column\" layout-gt-sm=\"row\" layout-fill=\"\" layout-wrap=\"\"><div class=\"boxCounterContainer\" flex=\"none\" ng-repeat=\"box in vm.facility.boxes\"><p class=\"info md-caption settingsSubHeader\">{{ box.name }}</p><div layout=\"\" class=\"boxSwitch\"><md-switch ng-model=\"box.boxState.value\" class=\"md-primary\" aria-label=\"Switch 1\" style=\"margin-left:1.5em;\">{{ box.boxState.value ? \"ON\" : \"OFF\" | translate }}</md-switch></div><div layout-padding=\"\" layout=\"row\" layout-align=\"start center\"><div><md-button ng-click=\"box.resetCash()\" class=\"md-raised\">{{::\'RESET\' | translate}}</md-button></div><div><div class=\"md-caption\">{{::\'CASH_COUNT\' | translate}}</div><span class=\"md-title\">{{ box.cashCount.value | number }}</span></div></div><div layout-padding=\"\" layout=\"row\" layout-align=\"start center\"><div><md-button ng-click=\"box.resetCoins()\" class=\"md-raised\">{{::\'RESET\' | translate}}</md-button></div><div><div class=\"md-caption\">{{::\'COINS_COUNT\' | translate}}</div><span class=\"md-title\">{{ box.coinsCount.value | number }}</span></div></div><div layout-padding=\"\" layout=\"row\" layout-align=\"start center\"><div><md-button ng-click=\"box.resetEurokey()\" class=\"md-raised\">{{::\'RESET\' | translate}}</md-button></div><div><div class=\"md-caption\">{{::\'EUROKEY_COUNT\' | translate}}</div><span class=\"md-title\">{{ box.euroKeyCount.value | number }}</span></div></div></div></div></div></div><div id=\"technologySettingsContainer\" flex=\"none\"><div class=\"customCardTitle boxHeader\"><span class=\"customCardSubTitle md-title\">{{::\'TECHNOLOGY\' | translate}}</span></div><div class=\"boxBody\"><div flex=\"\" layout=\"column\" layout-gt-sm=\"row\" layout-fill=\"\" layout-wrap=\"\"><div class=\"smallBoxContainer\" flex=\"\"><p class=\"info md-caption settingsSubHeader\">{{::\'DOSER\' | translate}}</p><md-input-container class=\"md-block\"><label>{{::\'DOSER_WORK\' | translate}}</label> <input name=\"doserWork\" type=\"text\" ng-pattern=\"/^[0-9]+[0-9]*$/\" ng-model=\"vm.facility.doserWork.value\" ng-disabled=\"vm.disableInpu(vm.facility.doserWork.value)\" required=\"\"><div ng-messages=\"settingsForm.doserWork.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"POSITIVE_NUMBERS_ONLY\" | translate }}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{::\'DOSER_PAUSE\' | translate}}</label> <input name=\"doserPause\" type=\"text\" ng-pattern=\"/^[0-9]+[0-9]*$/\" ng-model=\"vm.facility.doserPause.value\" ng-disabled=\"vm.disableInpu(vm.facility.doserPause.value)\" required=\"\"><div ng-messages=\"settingsForm.doserPause.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"POSITIVE_NUMBERS_ONLY\" | translate }}</div></div></md-input-container></div><div class=\"smallBoxContainer\" flex=\"\"><p class=\"info md-caption settingsSubHeader\">{{::\'REVERSE_OSMOSIS\' | translate}}</p><md-switch ng-model=\"vm.facility.reverseOsmosis.value\" class=\"md-primary\" aria-label=\"turnOnOffReverseOsmosis\">{{ vm.facility.reverseOsmosis.value ? \"ON\" : \"OFF\" | translate }}</md-switch><md-input-container class=\"md-block\"><label>{{::\'DELAY_6M1\' | translate}}</label> <input name=\"delay6M1\" type=\"text\" ng-pattern=\"/^[0-9]+[0-9]*$/\" ng-model=\"vm.facility.delay6M1.value\" ng-disabled=\"vm.disableInpu(vm.facility.delay6M1.value)\" required=\"\"><div ng-messages=\"settingsForm.delay6M1.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"POSITIVE_NUMBERS_ONLY\" | translate }}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{::\'DELAY_BFV\' | translate}}</label> <input name=\"delayBfv\" type=\"text\" ng-pattern=\"/^[0-9]+[0-9]*$/\" ng-model=\"vm.facility.delayBfv.value\" ng-disabled=\"vm.disableInpu(vm.facility.delayBfv.value)\" required=\"\"><div ng-messages=\"settingsForm.delayBfv.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"POSITIVE_NUMBERS_ONLY\" | translate }}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{::\'DELAY_LPS\' | translate}}</label> <input name=\"delayLps\" type=\"text\" ng-pattern=\"/^[0-9]+[0-9]*$/\" ng-model=\"vm.facility.delayLps.value\" ng-disabled=\"vm.disableInpu(vm.facility.delayLps.value)\" required=\"\"><div ng-messages=\"settingsForm.delayLps.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"POSITIVE_NUMBERS_ONLY\" | translate }}</div></div></md-input-container></div><div class=\"smallBoxContainer\" flex=\"\"><p class=\"info md-caption settingsSubHeader\">{{::\'REVERSE_OSMOSIS\' | translate }} & {{::\'GROUPS\' | translate}}</p><md-switch ng-model=\"vm.facility.reverseOsmosisAndGroups.value\" class=\"md-primary\" aria-label=\"turnOnOffReverseOsmosisAndGroups\">{{ vm.facility.reverseOsmosisAndGroups.value ? \"ON\" : \"OFF\" | translate }}</md-switch></div></div></div></div></form><div class=\"actions\" id=\"buttonsContainer\" layout=\"\" layout-align=\"end center\"><md-button class=\"md-fab md-warn\" aria-label=\"cancel\" ng-click=\"vm.cancelChanges()\"><md-icon md-svg-src=\"assets/icons/ic_close_white_24px.svg\"></md-icon><md-tooltip>{{::\'CANCEL\' | translate}}</md-tooltip></md-button><md-button ng-disabled=\"settingsForm.$invalid\" class=\"md-fab md-primary\" aria-label=\"save settings\" ng-click=\"vm.saveChanges()\"><md-icon md-svg-src=\"assets/icons/ic_check_white_24px.svg\"></md-icon><md-tooltip>{{::\'UPDATE_DEVICE\' | translate}}</md-tooltip></md-button></div></div>");
$templateCache.put("app/transactions/transactions.html","<div id=\"transactionWrapper\" flex=\"\" layout=\"column\"><div layout=\"\" layout-margin=\"\" flex=\"\" id=\"transactionEmailContainer\"><form name=\"customerSupportEmail\" ng-submit=\"vm.userSelected()\" novalidate=\"\" flex=\"80\" flex-gt-sm=\"50\" layout=\"\" layout-margin=\"\"><md-input-container flex=\"100\" class=\"emailInput\"><label>{{::\'USER_EMAIL\' | translate}}</label> <input ng-model=\"vm.selectedUser\" type=\"email\" name=\"customerSupportEmail\" required=\"\"><div ng-messages=\"customerSupportEmail.customerSupportEmail.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"email\">- {{::\'VALIDATION_EMAIL\' | translate}}</div><div flex=\"\" ng-if=\"vm.hasError\">{{::vm.customError}}</div></div></md-input-container><md-input-container flex=\"\" ng-if=\"!vm.isSelectedUser\"><md-button class=\"md-primary md-button defaultButton\" type=\"submit\" ng-disabled=\"customerSupportEmail.$invalid\">{{::\'SELECT\' | translate}}</md-button></md-input-container></form></div><div layout-padding=\"\" ng-if=\"vm.isSelectedUser\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\"><md-tab label=\"{{::\'EXPENSES\' | translate}}\"><div flex=\"\" layout-padding=\"\"><div><expenses-transactions email=\"vm.selectedUser\"></expenses-transactions></div></div></md-tab><md-tab label=\"{{::\'TOPUPS\' | translate}}\"><div flex=\"\" layout-padding=\"\"><div><topups-transactions email=\"vm.selectedUser\"></topups-transactions></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/userGroups/userGroups.html","<div flex=\"\" layout=\"column\" id=\"userGroupsOverview\"><div class=\"md-title customCardTitle\">{{::\'USER_GROUPS_OVERVIEW\' | translate}}</div><br><div id=\"groupCardContainer\" class=\"md-whiteframe-z1\"><div layout=\"\" layout-align=\"start center\" class=\"actions\"><md-input-container class=\"searchInput\"><label>{{::\'SEARCH\' | translate}}</label> <input ng-model=\"searchGroups\" type=\"text\"></md-input-container><md-button class=\"md-fab md-primary md-mini\" aria-label=\"New user group\" ng-click=\"vm.createUserGroup()\"><md-icon md-svg-src=\"assets/icons/ic_account_box_white_24px.svg\" class=\"fillButton\"></md-icon><md-tooltip>{{::\'NEW_USER_GROUP\' | translate}}</md-tooltip></md-button><md-button ng-if=\"vm.groups.selected.length === 1\" class=\"md-fab md-accent md-mini\" aria-label=\"Update user group\" ng-click=\"vm.updateUserGroup()\"><md-icon md-svg-src=\"assets/icons/ic_settings_white_24px.svg\" class=\"fillButton\"></md-icon><md-tooltip>{{::\'UPDATE_USER_GROUP\' | translate}}</md-tooltip></md-button><md-button ng-if=\"vm.groups.selected.length === 1\" class=\"md-fab md-warn md-mini\" ng-click=\"vm.groups.deleteSelectedGroup()\" aria-label=\"Delete user group\"><md-icon md-svg-src=\"assets/icons/ic_delete_forever_white_24px.svg\" class=\"fillButton\"></md-icon><md-tooltip>{{::\'DELETE_USER_GROUP\' | translate}}</md-tooltip></md-button></div><md-divider></md-divider><div ng-if=\"vm.groups.hasErrorMessage\" class=\"errorMessage\">{{vm.groups.errorMessage}}</div><md-content><md-table-container flex=\"\"><table md-table=\"\" multiple=\"false\" md-row-select=\"true\" ng-model=\"vm.groups.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.groups.orderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"name\">{{::\'NAME\' | translate}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"group\" md-auto-select=\"false\" md-on-select=\"vm.onGroupSelected\" ng-repeat=\"group in vm.groups.data | filter: searchGroups | orderBy: vm.groups.orderBy | limitTo: vm.groups.limitPerPage : (vm.groups.currentPage - 1) * vm.groups.limitPerPage\"><td md-cell=\"\">{{group.name}}</td></tr><tr md-row=\"\" ng-if=\"vm.groups.emptyList\"><td md-cell=\"\" class=\"groupListEmpty\"><md-icon md-svg-src=\"assets/icons/ic_warning_black_24px.svg\"></md-icon>{{::\'EMPTY_GROUP_LIST_MSG\' | translate}}</td></tr></tbody></table></md-table-container><md-table-pagination flex=\"\" md-limit=\"vm.groups.limitPerPage\" md-page=\"vm.groups.currentPage\" md-total=\"{{vm.groups.count}}\" md-page-select=\"options.pageSelect\" md-boundary-links=\"true\" md-label=\"{{vm.groups.pagerLabel}}\"></md-table-pagination></md-content></div></div>");
$templateCache.put("app/vouchers/vouchers.html","<div id=\"localTokensPage\"><div layout=\"\" layout-xs=\"column\"><div flex=\"\" flex-gt-md=\"30\" layout-padding=\"\"><md-content class=\"md-whiteframe-z2\"><div class=\"customCardTitle\">{{::\'CREATE_NEW_VOUCHERS\' | translate}}</div><p class=\"md-caption\">{{::\'CREATE_NEW_VOUCHERS_DESCRIPTION\' | translate}}</p><form name=\"newVouchersForm\" novalidate=\"\"><div flex=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \"AMOUNT_OF_TOKENS_PER_VOUCHER\" | translate }}</label> <input name=\"amountOfTokens\" ng-model=\"vm.vouchers.amountOfTokens\" type=\"text\" ng-pattern=\"/^([1-9]|[1-9][0-9]|[1-][0-][0-])$/\" ng-disabled=\"vm.isRestrictedUser\" required=\"\"><div ng-messages=\"newVouchersForm.amountOfTokens.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"NUMBERS_ONLY_100\" | translate }}</div></div></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \"NUMBER_OF_NEW_VOUCHERS\" | translate }}</label> <input name=\"amountOfVouchers\" ng-model=\"vm.vouchers.amountOfVouchers\" type=\"text\" ng-pattern=\"/^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-][0-][0-][0-])$/\" required=\"\"><div ng-messages=\"newVouchersForm.amountOfVouchers.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"NUMBERS_ONLY_1000\" | translate }}</div></div></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \"VOUCHER_VALIDITY_DAYS\" | translate }}</label> <input name=\"voucherValidityDays\" ng-model=\"vm.vouchers.voucherValidityDays\" type=\"text\" ng-pattern=\"/^[0-9]+$/\" ng-disabled=\"vm.isRestrictedUser\"><div ng-messages=\"newVouchersForm.voucherValidityDays.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\">{{ \"VALIDATION_ONLY_NUMBERS\" | translate }}</div></div></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \"NEW_VOUCHERS_PREFIX\" | translate }}</label> <input name=\"newVouchersPrefix\" ng-model=\"vm.vouchers.newVoucherPrefix\" type=\"text\" ng-pattern=\"/^[A-Z0-9]{0,4}$/\" minlength=\"4\" ng-disabled=\"vm.isRestrictedUser\"></md-input-container></div></form><p class=\"md-caption errorMessage\" ng-if=\"vm.hasNewVouchersErrors\">{{::\'PROBLEM_CREATING_NEW_VOUCHERS\' | translate}} ( {{ vm.errorMessage }} )</p><md-button type=\"button\" class=\"md-raised\" id=\"createVouchersButton\" ng-click=\"vm.createVouchers(newVouchersForm)\">{{ \"CREATE_VOUCHERS\" | translate }}</md-button><md-button type=\"button\" class=\"md-raised\" id=\"createAndPrintVouchersButton\" ng-click=\"vm.createAndPrintVouchers(newVouchersForm)\" style=\"margin-left: 8px;\">{{ \"CREATE_AND_PRINT_VOUCHERS\" | translate }}</md-button></md-content></div><div flex=\"\" flex-gt-md=\"30\" layout-padding=\"\"><div class=\"md-whiteframe-z2\"><div class=\"customCardTitle\">{{::\'CREATE_NEW_LOCAL_TOKENS\' | translate}}</div><p class=\"md-caption\">{{::\'ISSUE_LOCAL_TOKENS_TO_A_CUSTOMER\' | translate}}</p><form name=\"localTokensForm\" novalidate=\"\"><div flex=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \"CUSTOMER_EMAIL\" | translate }}</label> <input name=\"email\" ng-model=\"vm.vouchers.email\" type=\"email\" ng-pattern=\'/^(([^<>()\\[\\]\\\\.,;:\\s@\"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@\"]+)*)|(\".+\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$/\' ng-disabled=\"vm.isRestrictedUser\" required=\"\"><div ng-messages=\"localTokensForm.email.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"VALIDATION_EMAIL\" | translate }}</div></div></md-input-container></div><div flex=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \"AMOUNT_OF_TOKENS\" | translate }}</label> <input name=\"amount\" ng-model=\"vm.vouchers.amount\" type=\"text\" ng-pattern=\"/^[1-9]+[0-9]*$/\" required=\"\"><div ng-messages=\"localTokensForm.amount.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"POSITIVE_NUMBERS_ONLY\" | translate }}</div></div></md-input-container></div></form><p class=\"md-caption errorMessage\" ng-if=\"vm.hasErrors\">{{::\'PROBLEM_ISSUING_LOCAL_TOKENS\' | translate}}</p><md-button ng-disabled=\"localTokensForm.$invalid || vm.disableButton\" type=\"button\" class=\"md-raised\" id=\"createTokensButton\" ng-click=\"vm.createLocalTokens(localTokensForm)\">{{ \"CREATE_TOKENS\" | translate }}</md-button></div></div><div flex=\"\" flex-gt-md=\"30\" layout-padding=\"\"><md-content class=\"md-whiteframe-z2\"><div class=\"customCardTitle\">{{:: (vm.isRestrictedUser ? \'REPRINT_VOUCHERS\' : \'PRINT_NEW_VOUCHERS\') | translate}}</div><p class=\"md-caption\">{{::\'PRINT_NEW_VOUCHERS_DESCRIPTION\' | translate}}</p><form name=\"printVouchersForm\" novalidate=\"\"><div flex=\"\"><md-input-container class=\"md-block\" flex-gt-sm=\"\"><label>{{ \"PRINT_VOUCHERS_PREFIX\" | translate }}</label> <input name=\"printVouchersPrefix\" ng-model=\"vm.vouchers.printVoucherPrefix\" type=\"text\" ng-pattern=\"/^[A-Z0-9]{0,16}$/\" minlength=\"4\"><div ng-messages=\"printVouchersForm.printVouchersPrefix.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"pattern\">{{ \"VALIDATION_VOUCHER_PREFIX\" | translate }}</div><div ng-message=\"minlength\">{{ \"MIN_FOUR_VALIDATION\" | translate }}</div></div></md-input-container></div></form><p class=\"md-caption errorMessage\" ng-if=\"vm.noFoundVouchersForPrint\">{{::\'NO_VOUCHERS_FOR_PRINT\' | translate}}</p><md-button ng-disabled=\"printVouchersForm.$invalid\" type=\"button\" class=\"md-raised\" id=\"printVouchersButton\" ng-click=\"vm.printVouchers(vm.vouchers.printVoucherPrefix)\">{{ \"PRINT_VOUCHERS\" | translate }}</md-button><md-button ng-disabled=\"printVouchersForm.$invalid\" type=\"button\" class=\"md-raised\" ng-click=\"vm.downloadCSV(vm.vouchers.printVoucherPrefix)\">{{ \"DOWNLOAD_CSV\" | translate }}</md-button></md-content></div></div><div flex=\"\" layout-margin=\"\" id=\"localTokensHistoryContainer\" class=\"md-whiteframe-z2\"><div class=\"customCardTitle\">{{::\'VOUCHERS_OVERVIEW\' | translate}}</div><div layout=\"\" layout-padding=\"\"><form flex=\"\" name=\"vouchersFilterForm\" novalidate=\"\" layout=\"\" ng-submit=\"vm.filterVouchers(vm.vouchers.voucherCodeFilter)\"><div flex=\"30\"><md-input-container style=\"margin-bottom: 0px\" class=\"md-block\" flex-gt-sm=\"\"><label>{{ \"FILTER_VOUCHERS_BY_CODE\" | translate }}</label> <input name=\"voucherCodeFilter\" ng-model=\"vm.vouchers.voucherCodeFilter\" type=\"text\" ng-pattern=\"/^[A-Z0-9]{0,16}$/\"><div ng-messages=\"vouchersFilterForm.voucherCodeFilter.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"pattern\">{{ \"VALIDATION_VOUCHER_CODE_FILTER\" | translate }}</div></div></md-input-container></div><div><md-button ng-disabled=\"vouchersFilterForm.$invalid\" type=\"submit\" class=\"md-raised\" id=\"filterVouchersButton\">{{ \"FILTER_VOUCHERS\" | translate }}</md-button></div></form></div><md-divider></md-divider><div id=\"localTokensTableContainer\"><md-table-container><table md-table=\"\" multiple=\"\" ng-model=\"vm.vouchers.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"id\">{{::\'ISSUED_AT\' | translate}}</th><th md-column=\"\">{{::\'ISSUED_BY\' | translate}}</th><th md-column=\"\" md-numeric=\"\" md-order-by=\"tokens.amount\">{{::\'AMOUNT_OF_TOKENS\' | translate}}</th><th md-column=\"\">{{::\'CODE\' | translate}}</th><th md-column=\"\" md-order-by=\"redeemedBy\">{{::\'REDEEMED_BY\' | translate}}</th><th md-column=\"\" md-order-by=\"redeemedAt\">{{::\'REDEEMED_AT\' | translate}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"item in vm.vouchers.data\"><td md-cell=\"\">{{ item.issuedAt | date: \"medium\" }}</td><td md-cell=\"\">{{ item.issuedBy }}</td><td md-cell=\"\">{{ item.tokens }}</td><td md-cell=\"\">{{ item.code }}</td><td md-cell=\"\">{{ item.redeemedBy }}</td><td md-cell=\"\">{{ item.redeemedAt | date: \"medium\" }}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.vouchers.pageSize\" md-limit-options=\"vm.vouchers.pageOptions\" md-page=\"vm.vouchers.page\" md-total=\"{{ vm.vouchers.total }}\" md-label=\"{{ vm.vouchers.pagerTranslations }}\" md-on-paginate=\"vm.pageChanged\" md-page-select=\"true\" md-boundary-links=\"true\"></md-table-pagination></div></div><div class=\"voucherPrint\" layout=\"\" layout-wrap=\"\" layout-padding=\"\"><div ng-repeat=\"voucherItem in vm.vouchersForPrint track by $index\"><div class=\"voucherItem\"><qr text=\"voucherItem.code\" type-number=\"4\" size=\"150\"></qr><p class=\"voucherParagraph\">{{ voucherItem.code }}</p><p class=\"voucherDate\">{{ vm.issuedDateLabel }}: {{ voucherItem.issuedAt | date: \"dd.MM.yyyy\" }}</p><p class=\"voucherExpiry\" ng-if=\"voucherItem.validityDays\">{{ vm.expiryDateLabel }}: {{ (voucherItem.expiresAt) | date: \"dd.MM.yyyy\" }}</p><p class=\"voucherValidity\" ng-if=\"voucherItem.validityDays\">{{ vm.daysLabel }}: {{ voucherItem.validityDays }}</p></div></div></div></div>");
$templateCache.put("app/workingHours/workingHours.html","<div id=\"facilityWorkingHours\" flex=\"\" layout=\"column\" style=\"overflow-y: auto\" layout-margin=\"\"><div class=\"md-title customCardTitle\">{{ \'FACILITY_WORKING_HOURS\' | translate }}</div><div layout=\"\" flex-xs=\"\" layout-xs=\"row\" layout-align-xs=\"center center\" class=\"working-hours-selector-wrapper\"><md-radio-group ng-model=\"vm.workingHoursSelector\" layout=\"\" ng-change=\"vm.changeType(vm.workingHoursSelector)\"><md-radio-button value=\"WH_ALWAYS_OPEN\" class=\"md-primary\">{{::\'WORKING_HOURS_ALWAYS_OPEN\' | translate}}</md-radio-button><md-radio-button value=\"WH_ALWAYS_CLOSE\" class=\"md-primary\">{{::\'WORKING_HOURS_ALWAYS_CLOSE\' | translate}}</md-radio-button><md-radio-button value=\"WH_CUSTOM\" class=\"md-primary\">{{::\'WORKING_HOURS_CUSTOM\' | translate}}</md-radio-button></md-radio-group></div><div class=\"working-hours-form-wrapper\"><form novalidate=\"\" name=\"workingHooursForm\"><div column=\"\" layout-margin=\"\"><fieldset ng-disabled=\"vm.disableCustomWorkingHours\" class=\"token-package-field-set-wrapper\" row=\"\" layout-margin=\"\"><div class=\"noMargin\"><span class=\"working-hours-day\" ng-style=\"{\'color\': vm.disableCustomWorkingHours ? \'lightGray\' :\'primary\'}\">{{ \'MON\' | translate }}:</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[0].hoursFrom\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[0].minutesFrom\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[0].hoursTo\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[0].minutesTo\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span></div><div class=\"noMargin\"><span class=\"working-hours-day\" ng-style=\"{\'color\': vm.disableCustomWorkingHours ? \'lightGray\' :\'primary\'}\">{{ \'TUE\' | translate }}:</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[1].hoursFrom\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[1].minutesFrom\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[1].hoursTo\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[1].minutesTo\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span></div><div class=\"noMargin\"><span class=\"working-hours-day\" ng-style=\"{\'color\': vm.disableCustomWorkingHours ? \'lightGray\' :\'primary\'}\">{{ \'WED\' | translate }}:</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[2].hoursFrom\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[2].minutesFrom\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[2].hoursTo\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[2].minutesTo\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span></div><div class=\"noMargin\"><span class=\"working-hours-day\" ng-style=\"{\'color\': vm.disableCustomWorkingHours ? \'lightGray\' :\'primary\'}\">{{ \'THU\' | translate }}:</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[3].hoursFrom\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[3].minutesFrom\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[3].hoursTo\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[3].minutesTo\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span></div><div class=\"noMargin\"><span class=\"working-hours-day\" ng-style=\"{\'color\': vm.disableCustomWorkingHours ? \'lightGray\' :\'primary\'}\">{{ \'FRI\' | translate }}:</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[4].hoursFrom\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[4].minutesFrom\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[4].hoursTo\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[4].minutesTo\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span></div><div class=\"noMargin\"><span class=\"working-hours-day\" ng-style=\"{\'color\': vm.disableCustomWorkingHours ? \'lightGray\' :\'primary\'}\">{{ \'SAT\' | translate }}:</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[5].hoursFrom\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[5].minutesFrom\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[5].hoursTo\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[5].minutesTo\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span></div><div class=\"noMargin\"><span class=\"working-hours-day\" ng-style=\"{\'color\': vm.disableCustomWorkingHours ? \'lightGray\' :\'primary\'}\">{{ \'SUN\' | translate }}:</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[6].hoursFrom\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'FROM\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[6].minutesFrom\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[6].hoursTo\" type=\"number\" min=\"0\" max=\"23\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_HOURS\' | translate }})</span><md-input-container flex=\"\"><label>{{::\'TO\' | translate}}</label> <input ng-model=\"vm.workingHoursData.days[6].minutesTo\" type=\"number\" min=\"0\" max=\"59\"></md-input-container><span class=\"time-wrapper\">({{ \'CAMPAIGN_TEMPLATE_RULE_MINUTES\' | translate }})</span></div></fieldset><md-button class=\"md-button md-primary md-raised\" type=\"button\" ng-click=\"vm.cancelChanges()\">{{ \"CANCEL\" | translate }}</md-button><md-button class=\"md-button md-primary md-raised\" type=\"button\" ng-disabled=\"workingHooursForm.$invalid\" ng-click=\"vm.saveChanges(vm.workingHoursData)\">{{ \'SAVE\' | translate }}</md-button></div></form></div></div>");
$templateCache.put("app/workingSchedulesAndHolidays/workingSchedulesAndHolidays.html","<div layout=\"column\" class=\"fullWidth working-schedules-main-wrapper\"><div class=\"paddingAll30\" layout=\"row\"><div layout=\"row\" flex=\"\" flex-gt-md=\"50\"><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearSiteInput()\"></md-icon><multiply-items-selector list=\"vm.siteList\" enable-selector=\"false\" place-holder-text=\"vm.placeHolderText\" clear-site-text-input=\"vm.siteId\" selected-list=\"vm.getSchedulesForSiteId(ids)\" class=\"marginRight1\" flex=\"\"></multiply-items-selector></div><div layout=\"row\" flex=\"\" flex-gt-md=\"50\"><div layout=\"row\" flex=\"\" ng-if=\"vm.siteId\"><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearDevicesInput()\"></md-icon><multiply-items-selector list=\"vm.devicesList\" enable-selector=\"true\" place-holder-text=\"vm.deviceListPlaceHolder\" clear-site-text-input=\"vm.deviceId\" selected-list=\"vm.getDevicesId(ids)\" class=\"marginRight1\" flex=\"\"></multiply-items-selector><div ng-if=\"vm.brand === \'karcher\'\"><md-button flex=\"\" type=\"button\" ng-disabled=\"vm.deviceId === \'\'\" ng-class=\"{\'black-karcher-button-disabled\': vm.deviceId === \'\'}\" class=\"md-raised black-karcher-button fullWidth\" aria-label=\"Update schedules\" ng-click=\"vm.propagate()\">{{::\'PROPAGATE\' | translate}}</md-button></div></div></div></div><div layout=\"column\" layout-gt-md=\"row\" class=\"fullWidth\" layout-padding=\"\"><md-tabs md-dynamic-height=\"\" md-border-bottom=\"\" class=\"fullWidth\"><md-tab label=\"{{ \'SITE_DETAILS\' | translate }}\"><site-details site-id=\"vm.siteId\" refresh=\"\"></site-details></md-tab><md-tab label=\"{{ \'WORKING_SCHEDULES\' | translate }}\"><working-schedules site-id=\"vm.siteId\" working-schedules-data=\"vm.scheduleList\" all-day-check-box-data=\"vm.allDayCheckBoxData\" refresh=\"vm.refreshSchedules()\"></working-schedules></md-tab><md-tab label=\"{{ \'HOLIDAY_SCHEDULES\' | translate }}\"><holidays site-id=\"vm.siteId\" holidays-data=\"vm.holidayList\" refresh=\"vm.refreshHolidayList()\"></holidays></md-tab></md-tabs></div></div>");
$templateCache.put("app/accountManagement/userOrganization/userOrganization.html","<div flex=\"\" class=\"margin30\"><span class=\"md-title\">{{ vm.editMode ? \'EDIT_USER_ORGANIZATION\' : \'ADD_USER_ORGANIZATION\' | translate}}</span><form name=\"addNewOrganizationUserForm\" ng-submit=\"vm.saveNewOrganizationUser()\" novalidate=\"\"><div layout=\"row\" layout-margin=\"\"><div flex=\"40\"><md-input-container flex=\"\" class=\"fullWidth\"><label>{{::\'USER_EMAIL\' | translate}}<span class=\"md-title smallerText\" ng-if=\"vm.verified\">- {{ \"VERIFIED\" | translate }}</span></label> <input ng-model=\"vm.selectedUser\" type=\"email\" name=\"selectedUser\" required=\"\" ng-disabled=\"vm.editMode\"><div ng-messages=\"addNewOrganizationUserForm.selectedUser.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"email\">- {{::\'VALIDATION_EMAIL\' | translate}}</div><div flex=\"\" ng-if=\"vm.hasError\">{{::vm.customError}}</div></div></md-input-container><md-input-container flex=\"\" class=\"fullWidth\"><label>{{::\'FIRST_NAME\' | translate}}</label> <input ng-model=\"vm.firstName\" name=\"firstName\" required=\"\"><div ng-messages=\"addNewOrganizationUserForm.firstName.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container flex=\"\" class=\"fullWidth\"><label>{{::\'LAST_NAME\' | translate}}</label> <input ng-model=\"vm.lastName\" name=\"lastName\" required=\"\"><div ng-messages=\"addNewOrganizationUserForm.lastName.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-checkbox ng-if=\"vm.editMode\" disabled=\"\" ng-model=\"vm.isSystemAdministrator\" aria-label=\"Is system admin\">{{ \'SYSTEM_ADMIN\' | translate }}</md-checkbox></div><div flex=\"40\" layout=\"column\"><md-input-container class=\"fullWidth\" flex=\"\"><label>{{ \'SELECT_REGION\' | translate }}</label><md-select aria-label=\"Selected region\" ng-model=\"vm.selectedRegion\" name=\"selectedRegion\" required=\"\"><md-option ng-repeat=\"region in vm.regionList\" value=\"{{ region.id }}\">{{ region.name }}</md-option></md-select><div ng-messages=\"addNewOrganizationUserForm.selectedRegion.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container class=\"fullWidth\" flex=\"\"><label>{{ \'SELECT_ORGANIZATION\' | translate }}</label><md-select aria-label=\"Selected organization\" ng-model=\"vm.selectedOrganization\" name=\"selectedOrganization\" required=\"\"><md-option ng-repeat=\"organization in vm.organizationListForAvailableUsers\" value=\"{{ organization.id }}\">{{ organization.name }}</md-option></md-select><div ng-messages=\"addNewOrganizationUserForm.selectedOrganization.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container class=\"fullWidth\" flex=\"\"><label>{{ \'SELECT_ROLE\' | translate }}</label><md-select aria-label=\"Selected role\" ng-model=\"vm.selectedRole\" name=\"selectedRole\" required=\"\"><md-option ng-repeat=\"role in vm.userRoles\" value=\"{{ role }}\">{{ role | translate }}</md-option></md-select><div ng-messages=\"addNewOrganizationUserForm.selectedRole.$error\" role=\"alert\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-checkbox ng-if=\"vm.editMode\" disabled=\"\" ng-model=\"vm.isSubscriber\" aria-label=\"Is subscriber\">{{ \'SUBSCRIBER\' | translate }}</md-checkbox></div><div flex=\"\"></div></div><div layout=\"row\"><span flex=\"\"></span><md-button class=\"md-raised md-primary marginTop20\" ng-disabled=\"addNewOrganizationUserForm.$invalid\" type=\"submit\">{{::\'SAVE_CHANGES\' | translate}}</md-button></div></form></div>");
$templateCache.put("app/alarmsKarcher/alarmSubscriptions/alarmSubscriptions.html","<div class=\"fullWidth karcher-alarm-subscriptions-container\" layout-margin=\"\"><div layout=\"row\" layout-align=\"space-between center\" layout-padding=\"\"><div flex=\"\"></div><md-button class=\"md-raised primary-karcher-button\" ng-click=\"vm.addNewSubscription($event)\" aria-label=\"Filter bu key word\">{{::\'SUBSCRIBE\' | translate}}</md-button></div><md-table-container><table md-table=\"\" md-row-select=\"false\" ng-model=\"vm.alarmSubscriptions.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.alarmSubscriptions.orderBy\"><tr md-row=\"\"><th md-column=\"\"><span>{{::\'SITE_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{::\'FAULT_CODE\' | translate}}</span></th><th md-column=\"\"><span class=\"alert-type-title-wrapper\">{{::\'ALERT_TYPE\' | translate}}</span></th><th md-column=\"\"></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-auto-select=\"\" ng-repeat=\"subscription in vm.alarmSubscriptions.subscriptionsData\"><td md-cell=\"\">{{subscription.siteName}}</td><td md-cell=\"\">{{subscription.faultNumber ? subscription.faultNumber : \'\'}}</td><td md-cell=\"\"><span ng-class=\"{\'low-alarm-chip\': subscription.low}\">{{ subscription.low ? \"LOW_ALARM\" : \'\' | translate }}</span> <span ng-class=\"{\'medium-alarm-chip\': subscription.medium}\">{{ subscription.medium ? \"MEDIUM_ALARM\" : \'\' | translate }}</span> <span ng-class=\"{\'high-alarm-chip\': subscription.high}\">{{ subscription.high ? \"HIGH_ALARM\" : \'\' | translate }}</span></td><td md-cell=\"\"><div ng-if=\"!subscription.hideButton\" class=\"centerText\"><md-menu md-position-mode=\"target-right target\"><md-button aria-label=\"Delete item\" ng-click=\"vm.openMenu($mdOpenMenu, $event)\">{{::\'UNSUBSCRIBE\' | translate}}</md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.unsubscribeAlarm(subscription.id)\">{{ \'UNSUBSCRIBED_CONFIRM\' | translate }}</md-button></md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table></md-table-container></div>");
$templateCache.put("app/alarms/karcherAlarmsComponent/karcherAlarms.html","<div id=\"karcherAlarmsWrapper\"><div ng-repeat=\"facility in vm.karcherAlarmList\"><div class=\"karcher-facility-name\" layout=\"row\" layout-align=\"space-between center\"><p>{{ facility.facilityName }}</p><p>{{ facility.timestamp }}</p></div><div layout=\"row\" layout-align=\"space-between center\"><div><p class=\"karcher-alarm-name\">{{facility.karcherFault.name}}</p><p class=\"karcher-alarm-description\">{{facility.karcherFault.description}}</p><p class=\"karcher-alarm-description\">{{facility.karcherFault.number}}</p></div><div><p class=\"karcher-alarm-name\">{{facility.karcherFault.washFacilityStatus}}</p></div></div></div></div>");
$templateCache.put("app/components/asideMenu/asideMenu.html","<div><md-sidenav class=\"md-sidenav-left\" md-component-id=\"left\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-whiteframe=\"4\" ng-class=\"{\'leftContainerForSmallMenu\': vm.smallMenu}\" id=\"leftContainer\"><div class=\"iconWrapper\" layout=\"column\"><md-icon class=\"noMargin cursorPointer\" ng-click=\"vm.setSmallMenu()\" md-svg-src=\"{{!vm.smallMenu ? \'assets/icons/ic_keyboard_arrow_left_white_24px.svg\' : \'assets/icons/ic_keyboard_arrow_right_white_24px.svg\'}}\"></md-icon><md-icon ng-class=\"{\'iconR2WStyling\': vm.brand === \'r2w\', \'iconKarcherStyling\': vm.brand === \'karcher\', \'iconStylingForSmallMenu\': vm.smallMenu}\" md-svg-src=\"{{vm.getBrandIcon()}}\"></md-icon><span class=\"versionInsideMenu\">v {{vm.version}}</span></div><md-content layout-padding=\"\"><md-list flex=\"\"><md-list-item class=\"md-3-line leftMenuListItem\" ui-sref=\"{{item.id}}\" ng-repeat=\"item in vm.asideMenu.items\" ui-sref-active=\"menuActive\" ng-click=\"vm.closeMenu()\"><md-icon md-svg-icon=\"{{item.icon}}\" class=\"md-avatar menuIcon\" ng-class=\"{\'mdContentForSmallMenu\': vm.smallMenu}\"></md-icon><p class=\"menuName\" ng-class=\"{\'menuNameSmallMenu\': vm.smallMenu}\">{{item.name | truncate: 24}}</p><md-divider inset=\"\"></md-divider></md-list-item></md-list></md-content></md-sidenav></div>");
$templateCache.put("app/components/averageMoneyByHourChart/averageMoneyByHourChart.html","<div id=\"averageMoneyByHourChart\"></div>");
$templateCache.put("app/components/averageMoneyPerBoxChart/averageMoneyPerBoxChart.html","<div id=\"averageMoneyPerBoxChart\"></div>");
$templateCache.put("app/components/barChart/barChart.html","<div class=\"barChartContainer\"></div>");
$templateCache.put("app/components/breadcrumbs/uiBreadcrumbs.tpl.html","<ol class=\"breadcrumb\"><li ng-repeat=\"crumb in breadcrumbs\" ng-class=\"{ active: $last }\"><a ui-sref=\"{{ crumb.route }}\" ng-if=\"!$last\">{{ crumb.displayName }}&nbsp;</a><span ng-show=\"$last\" class=\"smallerText\">{{ crumb.displayName }}</span></li></ol>");
$templateCache.put("app/components/dailyFinancesChart/dailyFinancesChart.html","<div class=\"chart\"></div>");
$templateCache.put("app/components/dateFacilityGrid/dateFacilityGrid.html","<md-table-container><table md-table=\"\" md-row-select=\"false\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-repeat=\"column in vm.columns\"><span>{{::column | translate}}</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-style=\"{\'background\': $index % 2 === 0 ? \'white\' :\'whitesmoke\'}\" ng-repeat=\"item in vm.rowsData | limitTo: vm.limitPerPage : (vm.currentPage - 1) * vm.limitPerPage\"><td md-cell=\"\">{{item.dateFormatted}}</td><td md-cell=\"\" ng-repeat=\"value in item.values\">{{value}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.limitPerPage\" md-page=\"vm.currentPage\" md-total=\"{{vm.count}}\" md-limit-options=\"[5, 10, 20]\" md-label=\"{{vm.pagerLabel}}\" md-boundary-links=\"true\"></md-table-pagination>");
$templateCache.put("app/components/dateTimePicker/day.html","<table role=\"grid\" class=\"calender\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\"><thead><tr><th class=\"controls\" colspan=\"{{::7 + showWeeks}}\"><button type=\"button\" class=\"btn btn-default btn-sm btn-block\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"material-icons\">expand_less</i></button></th></tr><tr><th class=\"month-year-heading\" colspan=\"{{::7 + showWeeks}}\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th></tr><tr><th ng-if=\"showWeeks\" class=\"text-center\"></th><th ng-repeat=\"label in ::labels track by $index\" class=\"text-center\"><small aria-label=\"{{::label.full}}\">{{::label.abbr}}</small></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-if=\"showWeeks\" class=\"text-center h6\"><em>{{ weekNumbers[$index] }}</em></td><td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\"><button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default btn-sm\" ng-class=\"{\'btn-primary\': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{\'text-muted\': dt.secondary, \'text-info\': dt.current}\">{{::dt.label}}</span></button></td></tr><tr><th class=\"controls\" colspan=\"{{::7 + showWeeks}}\"><button type=\"button\" class=\"btn btn-default btn-sm btn-block\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"material-icons\">expand_more</i></button></th></tr></tbody></table>");
$templateCache.put("app/components/dateTimePicker/month.html","<table role=\"grid\" class=\"calender\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\"><thead><tr><th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"material-icons\">chevron_left</i></button></th><th><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th><th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"material-icons\">chevron_right</i></button></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\"><button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{\'btn-info\': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{\'text-info\': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>");
$templateCache.put("app/components/dateTimePicker/year.html","<table role=\"grid\" class=\"calender\" aria-labelledby=\"{{::uniqueId}}-title\" aria-activedescendant=\"{{activeDateId}}\"><thead><tr><th><button type=\"button\" class=\"btn btn-default btn-sm pull-left\" ng-click=\"move(-1)\" tabindex=\"-1\"><i class=\"material-icons\">chevron_left</i></button></th><th colspan=\"3\"><button id=\"{{::uniqueId}}-title\" role=\"heading\" aria-live=\"assertive\" aria-atomic=\"true\" type=\"button\" class=\"btn btn-default btn-sm\" ng-click=\"toggleMode()\" ng-disabled=\"datepickerMode === maxMode\" tabindex=\"-1\" style=\"width:100%;\"><strong>{{title}}</strong></button></th><th><button type=\"button\" class=\"btn btn-default btn-sm pull-right\" ng-click=\"move(1)\" tabindex=\"-1\"><i class=\"material-icons\">chevron_right</i></button></th></tr></thead><tbody><tr ng-repeat=\"row in rows track by $index\"><td ng-repeat=\"dt in row track by dt.date\" class=\"text-center\" role=\"gridcell\" id=\"{{::dt.uid}}\" ng-class=\"::dt.customClass\"><button type=\"button\" style=\"min-width:100%;\" class=\"btn btn-default\" ng-class=\"{\'btn-info\': dt.selected, active: isActive(dt)}\" ng-click=\"select(dt.date)\" ng-disabled=\"dt.disabled\" tabindex=\"-1\"><span ng-class=\"::{\'text-info\': dt.current}\">{{::dt.label}}</span></button></td></tr></tbody></table>");
$templateCache.put("app/components/errorContainer/errorContainer.html","<div id=\"errorContainer\" ng-animate=\"{enter : \'error-show\', leave : \'error-hide\'}\"><div id=\"infoIcon\"><md-icon md-svg-src=\"assets/icons/ic_error_outline_white_24px.svg\"></md-icon></div><div id=\"errorText\"><h3>{{::vm.errorHeader}}</h3><span class=\"errorName\">{{::vm.errorName}}</span> | <span class=\"errorDescription\">{{::vm.errorDescription}}</span></div><div id=\"closeButton\" ng-click=\"vm.closeErrorBox()\"><md-icon md-svg-src=\"assets/icons/ic_close_white_24px.svg\"></md-icon></div></div>");
$templateCache.put("app/components/facilitiesGroupGrid/facilitiesGroupGrid.html","<md-table-container><table md-table=\"\" md-row-select=\"false\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-attr-md-numeric=\"$index > 0\" ng-repeat=\"column in vm.columns track by $index\" ng-style=\"vm.setColor($last)\"><span>{{ column | translate : {brand: vm.brand} | removews | karcherCustomTranslation}}</span></th></tr><tr md-row=\"\"><th style=\"color: #000000; font-weight: 900\" md-column=\"\" ng-attr-md-numeric=\"$index > 0\" ng-repeat=\"total in vm.totals track by $index\"><span>{{total | number : 2}}</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-style=\"{\'background\': $index % 2 === 0 ? \'white\' :\'whitesmoke\'}\" ng-repeat=\"item in vm.rowsData | limitTo: vm.limitPerPage : (vm.currentPage - 1) * vm.limitPerPage\"><td md-cell=\"\">{{item.groupFormatted}}</td><td md-cell=\"\" ng-if=\"vm.listFirstType\" ng-repeat=\"value in item.values track by $index\" ng-style=\"vm.setColor($last)\">{{value | number : 2}}</td><td md-cell=\"\" ng-if=\"vm.listSecondType\">{{item.values}}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.limitPerPage\" md-page=\"vm.currentPage\" md-total=\"{{vm.count}}\" md-limit-options=\"[5, 10, 20]\" md-label=\"{{vm.pagerLabel}}\" ng-if=\"!showPagination\" md-boundary-links=\"true\"></md-table-pagination>");
$templateCache.put("app/components/globalNotice/globalNotice.component.html","<div ng-if=\"vm.showContent\" layout=\"row\" layout-align=\"space-between center\"><p flex=\"80\" layout-padding=\"\" layout-margin=\"\">{{vm.content}}</p><md-icon md-svg-src=\"assets/icons/ic_close_white_24px.svg\" class=\"close-icon\" ng-click=\"vm.close()\"></md-icon></div>");
$templateCache.put("app/components/header/header.html","<md-toolbar id=\"layoutToolbar\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" aria-label=\"Favorite\" ng-click=\"vm.openMobileMenu()\" hide-gt-sm=\"\" id=\"mobileHamburger\" style=\"margin-right:0;\"><md-icon md-svg-icon=\"assets/icons/ic_menu_black_24px.svg\"></md-icon></md-button><ui-breadcrumbs displayname-property=\"data.displayName\" id=\"layoutBreadcrumbs\" abstract-proxy-property=\"data.breadcrumbProxy\" template-url=\"../app/components/breadcrumbs/uiBreadcrumbs.tpl.html\"></ui-breadcrumbs><span flex=\"\"></span><md-menu md-position-mode=\"right bottom\" md-offset=\"0 20\" ng-if=\"vm.brand !== \'karcher\'\"><md-button ng-click=\"vm.openMenu($mdMenu, $event)\" aria-label=\"notifications box\"><span ng-if=\"vm.alarmsViewModel.alarms.length > 0\" id=\"notificationsCounter\">{{vm.alarmsViewModel.alarms.length}}</span><md-icon md-svg-src=\"assets/icons/ic_notifications_{{(vm.alarmsViewModel.alarms.length > 0) ? \'active\' : \'none\'}}_black_24px.svg\"></md-icon></md-button><md-menu-content width=\"5\" id=\"notificationContainer\"><md-menu-item id=\"notificationHeader\"><p layout-padding=\"\"><md-icon md-svg-icon=\"assets/icons/ic_info_outline_black_24px.svg\" md-menu-align-target=\"\"></md-icon>{{\'HEADER_NUMBER_OF_PENDING_ALARMS\' | translate}} {{vm.alarmsViewModel.alarms.length}}</p></md-menu-item><md-menu-item ng-repeat=\"alarmItem in vm.alarmsViewModel.alarms\" class=\"notificationBodyItem\"><md-button ng-click=\"vm.goToFacilityDetails(alarmItem.deviceSerial)\" class=\"alarmButtonContainer\"><md-icon md-svg-icon=\"assets/icons/ic_warning_black_24px.svg\"></md-icon><div class=\"alarmName\">{{alarmItem.message | translate}}</div><div class=\"alarmLocation tooltip\">{{alarmItem.location | truncate: 21}} <span class=\"tooltiptext\">{{alarmItem.location}}</span></div><div class=\"alarmTimer\">{{alarmItem.time}}</div></md-button></md-menu-item><md-menu-item id=\"notificationFooter\"><md-button ng-click=\"vm.goToMessagesPage()\"><md-icon md-svg-icon=\"assets/icons/ic_view_list_black_24px.svg\"></md-icon>{{\'HEADER_VIEW_ALL_ALARMS\' | translate}}</md-button></md-menu-item></md-menu-content></md-menu><md-menu md-position-mode=\"right bottom\" md-offset=\"0 20\" class=\"headerInfoMenu\"><md-button ng-click=\"vm.openMenu($mdMenu, $event)\" aria-label=\"profile box\"><span hide-xs=\"\">{{vm.myAccount.firstName}} <span hide-sm=\"\">{{vm.myAccount.lastName}}</span></span><md-icon md-svg-src=\"assets/icons/ic_person_black_24px.svg\" hide-gt-xs=\"\"></md-icon><md-icon md-svg-src=\"assets/icons/ic_arrow_drop_down_black_24px.svg\"></md-icon></md-button><md-menu-content width=\"4\"><md-menu-item><md-button ng-click=\"vm.showAdvanced()\"><md-icon md-svg-icon=\"assets/icons/ic-user-black.svg\" md-menu-align-target=\"\"></md-icon>{{\'HEADER_MY_ACCOUNT\' | translate}}</md-button></md-menu-item><md-menu-item ng-if=\"vm.checkUserForUserAccountManagement()\"><md-button ui-sref=\"app.accountManagement\"><md-icon md-svg-icon=\"assets/icons/ic-user-groups-black.svg\"></md-icon>{{\'HEADER_ACCOUNT_MANAGEMENT\' | translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.gotoReleaseNotesPage()\"><md-icon md-svg-icon=\"assets/icons/ic_release_notes_black.svg\"></md-icon>{{\'RELEASE_NOTES\' | translate}}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.gotoHelp()\"><md-icon md-svg-icon=\"assets/icons/ic-help-black.svg\"></md-icon>{{\'HELP\' | translate}}</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button ng-click=\"vm.doLogout($event)\"><md-icon md-svg-icon=\"assets/icons/ic_power_settings_new_black_24px.svg\"></md-icon>{{\'SIGN_OUT\' | translate}}</md-button></md-menu-item></md-menu-content></md-menu><md-menu md-position-mode=\"right bottom\" md-offset=\"0 20\"><md-button ng-click=\"vm.openMenu($mdMenu, $event)\" aria-label=\"notifications box\"><md-icon md-svg-src=\"assets/icons/ic_release_notes_black.svg\"></md-icon></md-button><md-menu-content width=\"5\" id=\"notificationContainer\"><md-menu-item><md-button ng-click=\"vm.goTermsAndServices(\'ready2wash-terms-of-service\')\">{{ \"TERMS_OF_SERVICE_R2W\" | translate }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.goTermsAndServices(\'data-processing\')\">{{ \"DATA_PROCESSING_TITLE\" | translate }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.goTermsAndServices(\'privacy-policy\')\">{{ \"PRIVACY_POLICY_TITLE\" | translate }}</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.goTermsAndServices(\'ready2pay-terms-of-service\')\">{{ \"READY_TO_PAY_TERMS_OF_SERVICE\" | translate }}</md-button></md-menu-item></md-menu-content></md-menu><md-button aria-label=\"logout box\" ng-click=\"vm.doLogout($event)\"><md-icon md-svg-src=\"assets/icons/ic_power_settings_new_black_24px.svg\"></md-icon></md-button></div></md-toolbar>");
$templateCache.put("app/components/header/headerMyAccountModalView.html","<md-dialog aria-label=\"Update user info modal\" flex-lg=\"50\" flex-xl=\"40\" flex-md=\"60\" flex-sm=\"80\" flex-xs=\"90\"><form name=\"myAccountForm\" ng-submit=\"vm.saveChanges(myAccountForm)\" novalidate=\"\" autocomplete=\"off\"><md-toolbar><div class=\"md-toolbar-tools\" style=\"color: white; text-transform: uppercase; font-size: 15px\"><h2>{{::\'MY_ACCOUNT_DETAILS\' | translate}}</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" layout=\"column\"><md-input-container><label>{{::\'USERNAME\' | translate}}</label> <input ng-model=\"vm.username\" name=\"username\" readonly=\"\"></md-input-container><input id=\"password_fake\" type=\"password\" style=\"display: none\" value=\"\" name=\"password_fake\"><md-input-container class=\"md-block\"><label>{{::\'OLD_PASSWORD\' | translate}}</label> <input ng-model=\"vm.oldPassword\" name=\"oldPassword\" type=\"password\" md-minlength=\"8\" ng-minlength=\"8\" ng-maxlength=\"32\" md-maxlength=\"32\" autocomplete=\"off\" ng-change=\"vm.updateInfo(\'old_password\', myAccountForm)\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$/\"><div ng-messages=\"myAccountForm.oldPassword.$error\" layout=\"column\" layout-align=\"center start\" flex=\"\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"minlength\">- {{::\'PASSWORD_MIN_CHAR\' | translate}}</div><div flex=\"\" ng-message=\"maxlength\">- {{::\'PASSWORD_MAX_CHAR\' | translate}}</div><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{::\'PASSWORD_VALIDATION_PATTERN_NEW\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{::\'NEW_PASSWORD\' | translate}}</label> <input ng-model=\"vm.newPassword\" name=\"newPassword\" type=\"password\" md-minlength=\"8\" md-maxlength=\"32\" ng-minlength=\"8\" ng-maxlength=\"32\" ng-required=\"myAccountForm.oldPassword.$viewValue !== \'\'\" ng-change=\"vm.updateInfo(\'new_password\', myAccountForm)\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$/\" ng-disabled=\"myAccountForm.oldPassword.$invalid || myAccountForm.oldPassword.$viewValue === \'\'\"><div ng-messages=\"myAccountForm.newPassword.$error\" layout=\"column\" layout-align=\"center start\" flex=\"\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"minlength\">- {{::\'PASSWORD_MIN_CHAR\' | translate}}</div><div flex=\"\" ng-message=\"maxlength\">- {{::\'PASSWORD_MAX_CHAR\' | translate}}</div><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{::\'PASSWORD_VALIDATION_PATTERN_NEW\' | translate}}</div><div flex=\"\" ng-if=\"vm.passwordIdentical\" style=\"font-size: 12px; margin-top: 5px\">- {{::\'PASSWORD_DIFFERENT_VALIDATION\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{::\'REPEAT_NEW_PASSWORD\' | translate}}</label> <input ng-model=\"vm.newPasswordRepeat\" name=\"repeatNewPassword\" type=\"password\" md-minlength=\"8\" md-maxlength=\"32\" ng-minlength=\"8\" ng-maxlength=\"32\" ng-required=\"myAccountForm.newPassword.$viewValue !== \'\'\" ng-change=\"vm.updateInfo(\'repeat_new_password\', myAccountForm)\" ng-pattern=\"/^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$/\" ng-disabled=\"myAccountForm.oldPassword.$invalid || myAccountForm.newPassword.$invalid || myAccountForm.oldPassword.$viewValue === \'\' || myAccountForm.newPassword.$viewValue === \'\'\"><div ng-messages=\"myAccountForm.repeatNewPassword.$error\" layout=\"column\" layout-align=\"center start\" flex=\"\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"minlength\">- {{::\'PASSWORD_MIN_CHAR\' | translate}}</div><div flex=\"\" ng-message=\"maxlength\">- {{::\'PASSWORD_MAX_CHAR\' | translate}}</div><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{::\'PASSWORD_PATTERN_VALIDATION\' | translate}}</div><div flex=\"\" ng-if=\"vm.passwordNotMatch\" style=\"font-size: 12px; margin-top: 5px\">- {{::\'PASSWORD_MATCH\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{::\'FIRST_NAME\' | translate}}</label> <input ng-model=\"vm.firstName\" name=\"firstName\" type=\"text\" ng-change=\"vm.updateInfo(\'first_name\')\"><div ng-messages=\"myAccountForm.firstName.$error\" layout=\"\" layout-align=\"center start\" flex=\"\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block\"><label>{{::\'LAST_NAME\' | translate}}</label> <input ng-model=\"vm.lastName\" name=\"lastName\" type=\"text\" ng-change=\"vm.updateInfo(\'last_name\')\"><div ng-messages=\"myAccountForm.lastName.$error\" layout=\"\" layout-align=\"center start\" flex=\"\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">{{::\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><p style=\"color: rgba(0, 0, 0, 0.56); font-size: 13px; margin-bottom: 3px;\">{{::\'USER_ROLE\' | translate}}</p><div ng-repeat=\"role in vm.userRole\"><span>{{role | translate}}</span></div><md-divider style=\"margin: 5px 0 2rem 0\"></md-divider><md-checkbox ng-model=\"vm.newsLetter\" name=\"newsLetter\" aria-label=\"Newsletter checkbox\">{{::\'NEWSLETTER_CONFIRMATION\' | translate}}</md-checkbox></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.closeDialog()\">{{::\'CANCEL\' | translate}}</md-button><md-button ng-disabled=\"myAccountForm.$invalid\" type=\"submit\">{{::\'SAVE_CHANGES\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/components/lineChart/lineChart.html","<div class=\"lineChartContainer\"></div>");
$templateCache.put("app/components/loader/loader.html","<div id=\"loader-wrapper\"><div id=\"loader\"></div></div>");
$templateCache.put("app/components/multiplyItemsSelector/multiplyItemsSelector.html","<div ng-show=\"vm.enableSelector\"><md-input-container class=\"noMargin fullWidth\" flex=\"\"><div layout=\"row\" layout-align=\"left center\"><md-input-container flex=\"\"><md-select ng-model=\"vm.selectedItem\" ng-change=\"vm.selectedList({ids: vm.selectedItem})\" placeholder=\"{{vm.placeHolderText}}\" ng-disabled=\"vm.disableSelector\" multiple=\"\"><md-select-header layout=\"column\" class=\"paddingAll10\"><md-input-container class=\"search-site-input\"><label>{{ \'SEARCH\' | translate }}</label> <input ng-model=\"vm.searchTerm\" aria-label=\"Search term\" type=\"search\" ng-model-options=\"{debounce: {\'default\': 100, \'blur\': 0}}\"></md-input-container></md-select-header><md-optgroup class=\"options-group-site-list\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.datas | filter:vm.searchTerm\">{{item.name | karcherPointTranslation}}</md-option></md-optgroup></md-select></md-input-container></div></md-input-container></div><div ng-show=\"!vm.enableSelector\"><md-input-container class=\"noMargin fullWidth\" flex=\"\"><div layout=\"row\" layout-align=\"left center\"><md-input-container flex=\"\"><md-select ng-model=\"vm.selectedItem\" ng-change=\"vm.selectedList({ids: vm.selectedItem})\" ng-disabled=\"vm.disableSelector\" placeholder=\"{{vm.placeHolderText}}\"><md-select-header layout=\"column\" class=\"paddingAll10\"><label>{{ \'SEARCH\' | translate }}</label><md-input-container flex=\"\" class=\"search-site-input\"><input ng-model=\"vm.searchTerm\" aria-label=\"Search term\" type=\"search\" ng-model-options=\"{debounce: {\'default\': 100, \'blur\': 0}}\"></md-input-container></md-select-header><md-optgroup class=\"options-group-site-list\"><md-option ng-value=\"item.id\" ng-repeat=\"item in vm.datas | filter:vm.searchTerm\">{{item.name}}</md-option></md-optgroup></md-select></md-input-container></div></md-input-container></div>");
$templateCache.put("app/components/totalMoneyByDaysChart/totalMoneyByDaysChart.html","<div id=\"totalMoneyByDaysChart\"></div>");
$templateCache.put("app/components/weatherHistoryChart/weatherHistoryChart.html","<div class=\"history-weather-component-wrapper\" layout=\"row\"><div ng-repeat=\"condition in vm.weatherData\" class=\"fullWidth\" layout=\"row\" layout-align=\"space-between center\"><div class=\"fullWidth\" layout=\"column\"><img class=\"weather-chart-icon-wrapper centerText\" ng-src=\"{{ ::condition.day.condition.icon }}\"><p class=\"weather-chart-temperature-wrapper centerText\">{{ ::condition.day.avgtemp_c }}&degC</p></div></div><md-tooltip>{{ vm.locationData.country }} - {{ vm.locationData.name }} - {{ vm.locationData.region }}</md-tooltip></div>");
$templateCache.put("app/dashboardKarcherTechnology/siteDetails/siteDetails.html","<div class=\"fullWidth site-details-container\" flex=\"\"><div class=\"md-padding site-details-facility-list-wrapper\" layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-align=\"start center\" layout-wrap=\"\"><md-card layout-padding=\"\" class=\"facility-tile fullWidth cursorPointer\" layout=\"column\" flex=\"45\" flex-xl=\"30\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" ng-click=\"vm.facilityDetails(facility)\" ng-repeat=\"facility in vm.siteDetailsVM.washFacilityList\"><div layout=\"row\" layout-align=\"space-between center\" class=\"fullWidth\" flex=\"30\"><p flex=\"\" class=\"boldText\">{{ facility.pointName }}</p><md-icon class=\"alarm-icon-tile-details\" md-svg-src=\"{{ facility.icon }}\"></md-icon></div><div layout=\"row\" layout-align=\"space-between center\" class=\"fullWidth\" flex=\"40\"><div flex=\"30\"><img class=\"facility-icon-tile-details\" ng-src=\"{{facility.washFacilityIcon}}\"></div><div flex=\"40\" layout=\"row\" layout-align=\"center center\"><img class=\"weather-icon-tile-details\" ng-src=\"{{ facility.currentFacilityTempIcon }}\"> <span class=\"paddingLeft10 tile-temperature-wrapper\">{{ facility.temperature ? facility.temperature : \' - \' }} &degC</span></div><div flex=\"\"></div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"fullWidth\" flex=\"\"><p flex=\"\" ng-class=\"{\'resolved-text\': facility.deviceState !== \'OFFLINE\', \'not-resolved-text\': facility.deviceState === \'OFFLINE\'}\" class=\"boldText grayColor\"><span class=\"material-icons center-organization-type-icon\">{{ facility.deviceState === \'OFFLINE\' ? \'cloud_off\' : \'cloud_queue\' }}</span> {{ facility.deviceState === \'OFFLINE\' ? \'DISCONNECTED\' : \'CONNECTED\' | translate }}</p><p class=\"smallerText boldText500\">{{ facility.lastReportedTime }}</p></div></md-card></div><div flex=\"\"><md-table-container id=\"tableContainer\"><table md-table=\"\" md-row-select=\"false\" ng-model=\"vm.siteDetailsVM.selected\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.siteDetailsVM.alarmsOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\"><span>{{\'ALERT_CODE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"timestamp\"><span>{{\'DATE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"companyName\"><span>{{\'COMPANY_NAME\' | translate}}</span></th><th md-column=\"\" md-order-by=\"siteName\"><span>{{\'SITE_NAME\' | translate}}</span></th><th md-column=\"\" md-order-by=\"washFacilityName\"><span>{{\'FACILITY_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{\'ALERT_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{\'ALERT_DESCRIPTION\' | translate}}</span></th><th md-column=\"\"><span>{{\'TYPE\' | translate}}</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"user\" md-auto-select=\"\" ng-repeat=\"alarm in vm.siteDetailsVM.alarmList\"><td md-cell=\"\">{{alarm.karcherFault.number}}</td><td md-cell=\"\">{{alarm.timestamp | date : \'dd/MMM/yy - HH:mm\'}}</td><td md-cell=\"\">{{alarm.companyName}}</td><td md-cell=\"\">{{alarm.siteName}}</td><td md-cell=\"\">{{alarm.washFacilityName}}</td><td md-cell=\"\">{{alarm.karcherFault.name}}</td><td md-cell=\"\">{{alarm.karcherFault.description}}</td><td md-cell=\"\"><md-icon flex=\"\" md-svg-src=\"{{ alarm.icon }}\"></md-icon></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.siteDetailsVM.alarmsPageSize\" md-page=\"vm.siteDetailsVM.alarmsPage\" md-options=\"vm.siteDetailsVM.alarmsPageOptions\" md-total=\"{{vm.siteDetailsVM.alarmsTotal}}\" md-page-select=\"true\" md-boundary-links=\"true\" md-label=\"{{vm.siteDetailsVM.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\"></md-table-pagination></div></div>");
$templateCache.put("app/errorPage/redirectToDashboard/redirectToDashboard.html","<md-content class=\"errorPageContainer\" flex=\"\" layout=\"column\" layout-align=\"center center\" layout-padding=\"\"><div class=\"textContainerReturnToDashboard\"><p>{{\"ERROR_PAGE_BAD_REQUEST\" | translate}}</p><span>{{vm.error.errorMessage}}</span><div layout=\"row\" layout-align=\"space-between center\" class=\"error-page-button-wrapper\"><md-button type=\"button\" ng-click=\"vm.goBack()\">{{::\'TRY_AGAIN\' | translate}}</md-button><md-button type=\"button\" ng-click=\"vm.goToDashboard()\">{{::\'RETURN_TO_DASHBOARD\' | translate}}</md-button></div></div></md-content>");
$templateCache.put("app/facilityKarcherDetails/alertHistory/alertHistory.html","<div flex=\"\" layout-padding=\"\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"\"></div><div><md-button class=\"md-raised primary-karcher-button\" type=\"button\" ng-click=\"vm.downloadCsv()\" aria-label=\"Download CSV\">{{::\'DAILY_FINANCES_DOWNLOAD_CSV\' | translate}}</md-button><md-button class=\"md-raised\" type=\"button\" ng-click=\"vm.refreshAlertPage()\" aria-label=\"Refresh table list\">{{::\'REFRESH_PAGE\' | translate}}</md-button></div></div><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"vm.alarmsOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\"><span>{{\'ALERT_CODE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"timestamp\"><span>{{\'DATE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"companyName\"><span>{{\'COMPANY_NAME\' | translate}}</span></th><th md-column=\"\" md-order-by=\"siteName\"><span>{{\'SITE_NAME\' | translate}}</span></th><th md-column=\"\" md-order-by=\"washFacilityName\"><span>{{\'FACILITY_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{\'ALERT_NAME\' | translate}}</span></th><th md-column=\"\"><span>{{\'ALERT_DESCRIPTION\' | translate}}</span></th><th md-column=\"\"><span>{{\'TYPE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"status\"><span>{{\'STATUS\' | translate}}</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"user\" md-auto-select=\"\" ng-repeat=\"alarm in vm.alarmList\"><td md-cell=\"\">{{alarm.karcherFault.number}}</td><td md-cell=\"\">{{alarm.timestamp | date : \'dd/MMM/yy - HH:mm\'}}</td><td md-cell=\"\">{{alarm.companyName}}</td><td md-cell=\"\">{{alarm.siteName}}</td><td md-cell=\"\">{{alarm.washFacilityName}}</td><td md-cell=\"\">{{alarm.karcherFault.name}}</td><td md-cell=\"\">{{alarm.karcherFault.description}}</td><td md-cell=\"\"><md-icon flex=\"\" md-svg-src=\"{{ alarm.icon }}\"></md-icon></td><td md-cell=\"\" ng-class=\"{\'resolved-text\': alarm.status, \'not-resolved-text\': !alarm.status}\"><span ng-if=\"!alarm.displayNotResolve\">{{alarm.status ? \"RESOLVED_STATUS\" : \"NOT_RESOLVED_STATUS\" | translate}}</span></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.alarmsPageSize\" md-page=\"vm.alarmsPage\" md-options=\"vm.alarmsPageOptions\" md-total=\"{{vm.alarmsTotal}}\" md-page-select=\"true\" md-boundary-links=\"true\" md-label=\"{{vm.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\"></md-table-pagination></div>");
$templateCache.put("app/facilityKarcherDetails/changeOfParameters/changeOfParameters.html","<div class=\"marginBottom10\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'CHANGE_OF_PARAMETERS\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div ng-if=\"vm.visibilityState\"><div layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-wrap=\"\" layout-align=\"center start\" class=\"fullWidth\"><div class=\"karcher-program-card fullWidth marginTop20 marginRight1\" layout=\"column\" flex=\"60\" flex-xl=\"60\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div layout=\"column\" layout-align=\"start center\" flex=\"\" class=\"fullWidth\"><div class=\"programs-subtitle-wrapper fullWidth\" layout=\"\" layout-align=\"center center\"><div>{{ \'SELECT_OPTIONS\' | translate }}</div></div><div layout=\"column\" layout-align=\"center center\" class=\"programs-content-wrapper fullWidth marginTop10\"><div class=\"fullWidth\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"vm.parametersState.saltExpulsion !== \'OK\'\" class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': vm.parametersState.saltExpulsion === \'ERROR\', \'infoColorBackground\': vm.parametersState.saltExpulsion === \'PENDING\'}\"></div><md-input-container flex=\"\" class=\"fullWidth\"><label>{{ \'DESALTING\' | translate }}</label><md-select ng-model=\"vm.desalting\" name=\"desalting\"><md-option ng-value=\"desalting.value\" ng-repeat=\"desalting in vm.desaltingList\">{{ desalting.name }}</md-option></md-select></md-input-container></div><div class=\"fullWidth\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"vm.parametersState.season !== \'OK\'\" class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': vm.parametersState.season === \'ERROR\', \'infoColorBackground\': vm.parametersState.season === \'PENDING\'}\"></div><md-input-container flex=\"\" class=\"fullWidth\"><label>{{ \'SEASON_WASH\' | translate }}</label><md-select ng-model=\"vm.season\" name=\"season\"><md-option ng-value=\"season.value\" ng-repeat=\"season in vm.seasonList\">{{ season.name }}</md-option></md-select></md-input-container></div><div class=\"fullWidth\" layout=\"row\" layout-align=\"start center\"><div class=\"actuator-state-wrapper\" ng-if=\"vm.parametersState.doorControl !== \'OK\'\" ng-class=\"{\'warnColorBackground\': vm.parametersState.doorControl === \'ERROR\', \'infoColorBackground\': vm.parametersState.doorControl === \'PENDING\'}\"></div><md-input-container flex=\"\" class=\"fullWidth\"><label>{{ \'DOOR_CONTROL\' | translate }}</label><md-select ng-model=\"vm.doorControl\" name=\"doorControl\"><md-option ng-value=\"doorControl.value\" ng-repeat=\"doorControl in vm.doorControlList\">{{ doorControl.name }}</md-option></md-select></md-input-container></div></div></div><div layout=\"row\" layout-align=\"space-between center\" layout-margin=\"\"><div></div><md-button class=\"md-raised primary-karcher-button noMarginLeft noMarginRight rollover-reset-button\" ng-click=\"vm.updateParameters()\" aria-label=\"Update parameters\">{{::\'APPLY_PARAMETERS_CHANGES\' | translate}}</md-button></div></div></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/chemicalLevel/chemicalLevel.html","<div class=\"marginBottom10\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'CHEMICAL_LEVEL\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div ng-if=\"vm.visibilityState\"><div layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-wrap=\"\" layout-align=\"center start\" class=\"fullWidth marginTop20\"><div class=\"karcher-program-card fullWidth marginTop20 marginRight1\" layout=\"column\" flex=\"30\" flex-xl=\"30\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" ng-repeat=\"item in vm.chemicalLevelData\"><div layout=\"column\" layout-align=\"start center\" flex=\"\" class=\"fullWidth\"><div class=\"programs-subtitle-wrapper fullWidth\" layout=\"column\" layout-align=\"center center\"><div class=\"chemical-name-wrapper\">{{ item.name | translate }}</div><div class=\"chemical-value-wrapper\">{{ item.value }}</div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"programs-content-wrapper fullWidth marginTop10\"><div><md-icon aria-label=\"Edit actuator value\" md-svg-src=\"{{ item.name | chemicalIcon }}\" class=\"rollover-chemical-icon\"></md-icon></div><div class=\"chemical-level-normal-state\" ng-class=\"vm.mapServiceInfo(item.value, false)\">{{ vm.mapServiceInfo(item.value, true) }}</div></div></div></div></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/logsEvents/logsEvents.html","<div class=\"margin30\"><div layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\"><p class=\"noMarginBottom\">{{ \"EVENTS_PULL_DATE\" | translate }} <span class=\"boldText smallerText\">{{ vm.deviceEventDataList.pullDate | date: \"short\" }}</span></p><md-button ng-if=\"!vm.deviceEventDataList\" class=\"md-raised primary-karcher-button\" ng-click=\"vm.refreshLogPage()\" aria-label=\"Get event data\">{{::\'DEVICE_EVENTS_REFRESH\' | translate}}</md-button><i ng-if=\"vm.deviceEventDataList\" class=\"material-icons cursorPointer refresh-maps-button\" ng-click=\"vm.refreshLogPage()\">refresh<md-tooltip>{{::\'DEVICE_EVENTS_REFRESH\' | translate}}</md-tooltip></i></div><p class=\"noMarginTop\">{{ \"DEVICE_ID\" | translate }}: <span class=\"boldText smallerText\">{{ vm.deviceSerial }}</span> <span class=\"smallerText\">({{ vm.deviceEventDataList.path }})</span></p></div><div layout=\"row\" class=\"fullWidth event-table-title-wrapper\"><div flex=\"20\">{{ \"ID\" | translate }}</div><div flex=\"40\">{{ \"NAME\" | translate }}</div><div flex=\"\">{{ \"TIME\" | translate }}</div></div><div ng-if=\"!vm.deviceEventDataList\" class=\"marginLeft1\">{{ \'DEVICE_EVENTS_REFRESH\' | translate }}</div><div ng-repeat=\"event in vm.deviceEventDataList.data\"><div layout=\"row\" class=\"fullWidth marginBottom10\"><div flex=\"20\">{{ event.id }}</div><div flex=\"40\">{{ event.name ? (event.name | karcherEventTranslation) : \"-\" }}</div><div flex=\"\">{{ event.newTimestamp }}</div></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/logsHistory/logsHistory.html","<div layout=\"row\" layout-align=\"space-between center\" layout-padding=\"\" class=\"noPaddingTop\"><div flex=\"\" layout=\"row\" layout-align=\"start center\" class=\"fullWidth noPaddingTop\"><div layout=\"row\" flex=\"\"><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearPointsInput()\"></md-icon><multiply-items-selector list=\"vm.pointList\" enable-selector=\"true\" place-holder-text=\"vm.placeHolderText\" clear-site-text-input=\"vm.selectedPoints\" selected-list=\"vm.selectedLogs(ids)\" class=\"marginRight1\" flex=\"\"></multiply-items-selector></div><md-button class=\"md-raised black-karcher-button\" type=\"button\" ng-click=\"vm.searchLogs()\" aria-label=\"Filter by point list\">{{::\'SEARCH\' | translate}}</md-button><md-button class=\"md-raised\" type=\"button\" ng-click=\"vm.refreshLogPage()\" aria-label=\"Refresh table list\">{{::\'REFRESH_PAGE\' | translate}}</md-button></div></div><div flex=\"\" layout-padding=\"\"><md-table-container><table md-table=\"\"><thead md-head=\"\" md-order=\"vm.logsOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"dateTime\"><span>{{\'DATE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"reference\"><span>{{\'ACTUATOR_REFERENCE\' | translate}}</span></th><th md-column=\"\"><span>{{\'ACTUATOR_VALUE\' | translate}}</span></th><th md-column=\"\" md-order-by=\"pointId\"><span>{{\'POINT_NAME\' | translate}}</span></th><th md-column=\"\" md-order-by=\"changerReference\"><span>{{\'USER\' | translate}}</span></th><th md-column=\"\" md-order-by=\"state\"><span>{{\'STATE\' | translate}}</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" md-select=\"user\" md-auto-select=\"\" ng-repeat=\"log in vm.logsList\"><td md-cell=\"\">{{ log.dateTime | date: \"short\" }}</td><td md-cell=\"\">{{ log.reference | translateReferencesFilter }}</td><td md-cell=\"\">{{ log.value | operatingTimeFilter }}</td><td md-cell=\"\">{{ log.pointName | weekDaysFacilityFilter }}</td><td md-cell=\"\">{{ log.changerReference }}</td><td md-cell=\"\">{{ log.state }}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.logsPageSize\" md-page=\"vm.logsPage\" md-options=\"vm.logsPageOptions\" md-total=\"{{vm.logsTotal}}\" md-page-select=\"true\" md-boundary-links=\"true\" md-label=\"{{vm.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\"></md-table-pagination></div>");
$templateCache.put("app/facilityKarcherDetails/operatingTime/operatingTime.html","<div class=\"marginBottom10\" ng-if=\"vm.operatingTimeList\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'OPERATION_TIME_INFO\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div ng-if=\"vm.visibilityState\"><div layout=\"row\" layout-align=\"space-between end\" layout-padding=\"\" class=\"refresh-operation-time-from-site-wrapper\"><div></div><div ng-if=\"vm.displayDepelopersOnly\"><md-icon aria-label=\"Sync with site operation time\" md-svg-src=\"assets/icons/ic_refresh.svg\" class=\"cursorPointer edit-actuators-icon\" ng-click=\"vm.getSiteWorkingSchedules()\"><md-tooltip hide-xs=\"\">{{::\'GET_OPERATING_TIME_FROM_SITE\' | translate}}</md-tooltip></md-icon></div></div><div layout-padding=\"\" flex=\"100\" class=\"fullWidth content-operation-time-wrapper\"><div class=\"boldText\">{{ vm.facilityType === \'JETWASH\' ? \'JETWASH\' : \'\' | translate }}</div><div layout=\"row\" class=\"operating-time-title-wrapper boldText\"><div flex=\"25\">{{ \'DAY\' | translate }}</div><div flex=\"25\" class=\"centerText\">{{ \'FROM\' | translate }} (h)</div><div flex=\"25\" class=\"centerText\">{{ \'TO\' | translate }} (h)</div><div flex=\"\" class=\"centerText\" layout=\"row\"><div flex=\"90\">{{ \'ALL_DAY\' | translate }}</div><div flex=\"\"></div></div></div><div ng-repeat=\"times in vm.operatingTimeList\" layout=\"row\" class=\"noPadding\"><div flex=\"25\" class=\"operating-time-item-wrapper\">{{ times.day | translate }}</div><div flex=\"25\" class=\"operating-time-item-wrapper centerText\">{{ times.allDay === \'false\' ? times.from : \'\' | removews | operatingTimeFormat }}<div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': times.fromState === \'ERROR\', \'infoColorBackground\': times.fromState === \'PENDING\'}\"></div></div><div flex=\"25\" class=\"operating-time-item-wrapper centerText\">{{ times.allDay === \'false\' ? times.to : \'\' | removews | operatingTimeFormat }}<div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': times.toState === \'ERROR\', \'infoColorBackground\': times.toState === \'PENDING\'}\"></div></div><div flex=\"\" class=\"operating-time-item-wrapper centerText\" layout=\"row\"><div flex=\"90\">{{ times.allDay | operatingTimeFilter }}<div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': times.allDayState === \'ERROR\', \'infoColorBackground\': times.allDayState === \'PENDING\'}\"></div></div><div flex=\"\"><md-icon aria-label=\"Edit actuator value\" md-svg-src=\"assets/icons/ic_edit_black_24px.svg\" class=\"cursorPointer edit-actuators-icon\" ng-if=\"times.allDay !== undefined\" ng-click=\"vm.updateOperationTime($event, times)\"><md-tooltip hide-xs=\"\">{{::\'EDIT\' | translate}} {{ times.day | translate }}</md-tooltip></md-icon></div></div></div></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/operatingTimeIllumination/operatingTimeIllumination.html","<div class=\"marginBottom10\" ng-if=\"vm.operatingTimeIlluminationList\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'OPERATION_TIME_ILLUMINATION_INFO\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div layout-padding=\"\" flex=\"100\" class=\"fullWidth content-operation-time-wrapper\" ng-if=\"vm.visibilityState\"><div layout=\"row\" class=\"operating-time-title-wrapper boldText marginTop30\"><div flex=\"25\">{{ \'DAY\' | translate }}</div><div flex=\"25\" class=\"centerText\">{{ \'FROM\' | translate }} (h)</div><div flex=\"25\" class=\"centerText\">{{ \'TO\' | translate }} (h)</div><div flex=\"\" class=\"centerText\" layout=\"row\"><div flex=\"90\">{{ \'ALL_DAY\' | translate }}</div><div flex=\"\"></div></div></div><div ng-repeat=\"times in vm.operatingTimeIlluminationList\" layout=\"row\" class=\"noPadding\"><div flex=\"25\" class=\"operating-time-item-wrapper\">{{ times.day | translate }}</div><div flex=\"25\" class=\"operating-time-item-wrapper centerText\">{{ times.allDay === \'false\' ? times.from : \'\' | removews | operatingTimeFormat }}<div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': times.fromState === \'ERROR\', \'infoColorBackground\': times.fromState === \'PENDING\'}\"></div></div><div flex=\"25\" class=\"operating-time-item-wrapper centerText\">{{ times.allDay === \'false\' ? times.to : \'\' | removews | operatingTimeFormat }}<div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': times.toState === \'ERROR\', \'infoColorBackground\': times.toState === \'PENDING\'}\"></div></div><div flex=\"\" class=\"operating-time-item-wrapper centerText\" layout=\"row\"><div flex=\"90\">{{ times.allDay | operatingTimeFilter }}<div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': times.allDayState === \'ERROR\', \'infoColorBackground\': times.allDayState === \'PENDING\'}\"></div></div><div flex=\"\"><md-icon aria-label=\"Edit actuator value\" md-svg-src=\"assets/icons/ic_edit_black_24px.svg\" class=\"cursorPointer edit-actuators-icon\" ng-if=\"times.allDay !== undefined\" ng-click=\"vm.updateOperationIlluminationTime($event, times)\"><md-tooltip hide-xs=\"\">{{::\'EDIT\' | translate}} {{ times.day | translate }}</md-tooltip></md-icon></div></div></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/operatingTimeVacuum/operatingTimeVacuum.html","<div class=\"marginBottom10\" ng-if=\"vm.operatingTimeVacuumList\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'OPERATION_TIME_VACUUM_INFO\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div layout-padding=\"\" flex=\"100\" class=\"fullWidth content-operation-time-wrapper\" ng-if=\"vm.visibilityState\"><div layout=\"row\" class=\"operating-time-title-wrapper boldText marginTop30\"><div flex=\"25\">{{ \'DAY\' | translate }}</div><div flex=\"25\" class=\"centerText\">{{ \'FROM\' | translate }} (h)</div><div flex=\"25\" class=\"centerText\">{{ \'TO\' | translate }} (h)</div><div flex=\"\" class=\"centerText\" layout=\"row\"><div flex=\"90\">{{ \'ALL_DAY\' | translate }}</div><div flex=\"\"></div></div></div><div ng-repeat=\"times in vm.operatingTimeVacuumList\" layout=\"row\" class=\"noPadding\"><div flex=\"25\" class=\"operating-time-item-wrapper\">{{ times.day | translate }}</div><div flex=\"25\" class=\"operating-time-item-wrapper centerText\">{{ times.allDay === \'false\' ? times.from : \'\' | removews | operatingTimeFormat }}<div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': times.fromState === \'ERROR\', \'infoColorBackground\': times.fromState === \'PENDING\'}\"></div></div><div flex=\"25\" class=\"operating-time-item-wrapper centerText\">{{ times.allDay === \'false\' ? times.to : \'\' | removews | operatingTimeFormat }}<div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': times.toState === \'ERROR\', \'infoColorBackground\': times.toState === \'PENDING\'}\"></div></div><div flex=\"\" class=\"operating-time-item-wrapper centerText\" layout=\"row\"><div flex=\"90\">{{ times.allDay | operatingTimeFilter }}<div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': times.allDayState === \'ERROR\', \'infoColorBackground\': times.allDayState === \'PENDING\'}\"></div></div><div flex=\"\"><md-icon aria-label=\"Edit actuator value\" md-svg-src=\"assets/icons/ic_edit_black_24px.svg\" class=\"cursorPointer edit-actuators-icon\" ng-if=\"times.allDay !== undefined\" ng-click=\"vm.updateOperationVacuumTime($event, times)\"><md-tooltip hide-xs=\"\">{{::\'EDIT\' | translate}} {{ times.day | translate }}</md-tooltip></md-icon></div></div></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/operationAndServiceCountersRollover/operationAndServiceCountersRollover.html","<div class=\"marginBottom10\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'OPERATION_SERVICE_COUNTER_ROLLOVER\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div ng-if=\"vm.visibilityState\"><div layout-gt-md=\"row\" layout=\"column\" layout-align=\"space-between start\" layout-wrap=\"\"><div layout-padding=\"\" flex=\"100\" class=\"fullWidth\" ng-if=\"vm.operationCountersList.length !== 0\"><div layout=\"row\" class=\"operating-time-title-wrapper boldText\"><div flex=\"70\">{{ \'OPERATION_COUNTER\' | translate }}</div><div flex=\"\">{{ \'TIME\' | translate }} (dd:hh:mm:ss)</div></div><div layout=\"column\"><div ng-repeat=\"operationCounter in vm.operationCountersList\" layout=\"column\" class=\"noPadding\"><div layout=\"row\"><div flex=\"70\" class=\"operating-counter-item-wrapper\">{{ operationCounter.reference | translate }}</div><div flex=\"\" class=\"operating-counter-item-wrapper\">{{ operationCounter.currentValue | secondsToHoursMinutesSeconds }}</div></div></div></div></div><div layout-padding=\"\" flex=\"100\" class=\"fullWidth\" ng-if=\"vm.serviceCountersList.length !== 0\"><div layout=\"row\" class=\"operating-time-title-wrapper boldText\"><div flex=\"70\">{{ \'SERVICE_COUNTER\' | translate }}</div><div flex=\"\">{{ \'WASHES\' | translate }}</div></div><div layout=\"column\"><div ng-repeat=\"serviceCounter in vm.serviceCountersList\" layout=\"column\" class=\"noPadding\" ng-class=\"{\'rollover-service-counter-item-wrapper\': vm.convertToInt(serviceCounter.currentValue) < 0}\"><div layout=\"row\"><div flex=\"70\" class=\"operating-counter-item-wrapper\">{{ serviceCounter.reference | translate }}</div><div flex=\"\" class=\"operating-counter-item-wrapper\">{{ serviceCounter.currentValue | number: 0 }}</div></div></div></div></div></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/operationCounters/operationCounters.html","<div class=\"marginBottom10\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'OPERATION_COUNTERS\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div ng-if=\"vm.visibilityState\"><div layout-gt-md=\"row\" layout=\"column\" layout-align=\"space-between start\" layout-wrap=\"\"><div layout-padding=\"\" flex=\"100\" class=\"fullWidth\"><div layout=\"row\" class=\"operating-time-title-wrapper boldText\"><div flex=\"70\">{{ \'NAME\' | translate }}</div><div flex=\"\">{{ \'TIME\' | translate }} (dd:hh:mm:ss)</div></div><div layout=\"column\"><div ng-repeat=\"counter in vm.operationCountersList\" layout=\"column\" class=\"noPadding\"><div layout=\"row\"><div flex=\"70\" class=\"operating-counter-item-wrapper\">{{ counter.name | karcherOperationCountersTranslation }}</div><div flex=\"\" class=\"operating-counter-item-wrapper\">{{ counter.time | secondsToHoursMinutesSeconds }}</div></div><div ng-repeat=\"serviceCounter in counter.points\" class=\"jetwash-service-counter-wrapper\"><div ng-repeat=\"feedCounter in serviceCounter.feeds\"><div ng-if=\"feedCounter.reference === \'DUE\'\" class=\"service-counter-name-item-wrapper\"><div layout=\"row\"><div flex=\"70\" ng-class=\"{\'jetwash-service-counter-wrapper-error\': feedCounter.currentValue === \'1.0\'}\">{{ \'SERVICE_PART_NAME\' | translate }} {{ serviceCounter.name }}</div><div flex=\"\"></div></div></div><div ng-if=\"feedCounter.reference === \'SECONDS\'\" class=\"service-counter-item-wrapper\" ng-class=\"{\'service-counter-alert-item-wrapper\': vm.convertToInt(feedCounter.currentValue) < 0}\"><div layout=\"row\"><div flex=\"70\">{{ \"TIME_TO_SERVICE\" | translate }}</div><div flex=\"\">{{ feedCounter.currentValue | secondsToHoursMinutesSeconds }}</div></div></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/pumps/pumps.html","<div class=\"marginBottom10\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between start\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'PUMPS\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div ng-if=\"vm.visibilityState\"><div ng-repeat=\"pump in vm.pumpsList\"><p class=\"marginLeft1 boldText smallerText noMarginBottom\">{{ pump.pumpName | removews }}</p><div layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-wrap=\"\" layout-align=\"center start\" class=\"fullWidth\"><div class=\"karcher-program-card fullWidth marginTop20 marginRight1\" layout=\"column\" flex=\"30\" flex-xl=\"30\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" ng-repeat=\"pumpProgram in pump.programsList\" ng-if=\"pumpProgram.RUN_TIME || pumpProgram.RUN_TIME1 || pumpProgram.RUN_TIME2\"><div layout=\"column\" layout-align=\"start center\" flex=\"\" class=\"fullWidth\"><div class=\"programs-subtitle-wrapper fullWidth\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start start\"><div>{{ pumpProgram.programName ? pumpProgram.programName : \'-\' | removews }}</div></div><div><md-icon aria-label=\"Edit actuator value\" md-svg-src=\"assets/icons/ic_edit_white_24px.svg\" class=\"cursorPointer edit-actuators-icon\" ng-click=\"vm.actuatePumpProgram($event, pumpProgram.actuators, pumpProgram.id)\"><md-tooltip hide-xs=\"\">{{::\'UPDATE\' | translate}} {{ pumpProgram.programName ? pumpProgram.programName : \'-\' | removews }}</md-tooltip></md-icon></div></div><div class=\"fullWidth\"><div layout=\"row\" layout-align=\"space-between center\" class=\"programs-content-wrapper fullWidth marginTop10 cursorPointer\" ng-if=\"pumpProgram.RUN_TIME\"><div layout=\"row\"><div>{{ \'PROGRAM_RUNTIME_ACTUATOR\' | translate }}</div><div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': pumpProgram.RUN_TIME_STATE === \'ERROR\', \'infoColorBackground\': pumpProgram.RUN_TIME_STATE === \'PENDING\'}\"></div></div><div>{{ pumpProgram.RUN_TIME }}</div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"programs-content-wrapper fullWidth marginTop10\" ng-if=\"pumpProgram.RUN_TIME1\"><div layout=\"row\"><div>{{ \'PROGRAM_RUNTIME_ACTUATOR_1\' | translate }}</div><div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': pumpProgram.RUN_TIME1_STATE === \'ERROR\', \'infoColorBackground\': pumpProgram.RUN_TIME1_STATE === \'PENDING\'}\"></div></div><div>{{ pumpProgram.RUN_TIME1 }}</div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"programs-content-wrapper fullWidth marginTop10\" ng-if=\"pumpProgram.RUN_TIME2\"><div layout=\"row\"><div>{{ \'PROGRAM_RUNTIME_ACTUATOR_2\' | translate }}</div><div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': pumpProgram.RUN_TIME2_STATE === \'ERROR\', \'infoColorBackground\': pumpProgram.RUN_TIME2_STATE === \'PENDING\'}\"></div></div><div>{{ pumpProgram.RUN_TIME2 }}</div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/rolloverDosing/rolloverDosing.html","<div class=\"marginBottom10\" ng-if=\"vm.dosingList\"><form name=\"rolloverDosingForm\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'ROLLOVER_DOSING\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div ng-if=\"vm.visibilityState\"><div layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-wrap=\"\" class=\"fullWidth\" layout-margin=\"\"><div layout=\"column\" layout-align=\"start start\" flex=\"30\" flex-xl=\"30\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" ng-repeat=\"dosing in vm.dosingList track by $index\"><div layout=\"column\" flex=\"\" class=\"fullWidth\"><div layout=\"row\" layout-align=\"start start\"><div class=\"slider-name-wrapper\">{{ dosing.name | translate }}</div><div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': dosing.state === \'ERROR\', \'infoColorBackground\': dosing.state === \'PENDING\'}\"></div></div><md-slider-container layout=\"row\" class=\"fullWidth\"><md-slider flex=\"80\" ng-model=\"dosing.value\" name=\"rolloverDosingSlider\" min=\"0\" max=\"120\" aria-label=\"Dosing value\" class=\"md-accent\"></md-slider><md-input-container flex=\"20\"><input type=\"number\" ng-model=\"dosing.value\" name=\"rolloverDosingInput{{$index}}\" aria-label=\"Dosing\" required=\"\" min=\"0\" max=\"120\"><div ng-messages=\"rolloverDosingForm[\'rolloverDosingInput\' + $index].$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"min\">{{::\'VALIDATION_NOT_VALID_RANGE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_NOT_VALID_RANGE\' | translate}}</div></div></md-input-container></md-slider-container></div></div></div><div layout=\"row\" layout-align=\"space-between center\" layout-margin=\"\"><div></div><md-button class=\"md-raised primary-karcher-button noMarginLeft noMarginRight rollover-reset-button\" ng-click=\"vm.updateDosing(vm.dosingList)\" ng-disabled=\"rolloverDosingForm.$invalid\" ng-class=\"{\'primary-karcher-button-disabled\': rolloverDosingForm.$invalid}\" aria-label=\"Update dosing\">{{::\'APPLY_DOSING_CHANGES\' | translate}}</md-button></div></div></form></div>");
$templateCache.put("app/facilityKarcherDetails/rolloverSpeed/rolloverSpeed.html","<div class=\"marginBottom10\" ng-if=\"vm.speedList\"><form name=\"rolloverSpeedForm\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'ROLLOVER_SPEED\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div ng-if=\"vm.visibilityState\"><div layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-wrap=\"\" class=\"fullWidth\" layout-margin=\"\"><div layout=\"column\" layout-align=\"start start\" flex=\"30\" flex-xl=\"30\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" ng-repeat=\"speed in vm.speedList track by $index\"><div layout=\"column\" flex=\"\" class=\"fullWidth\"><div layout=\"row\" layout-align=\"start start\"><div class=\"slider-name-wrapper\">{{ speed.name | translate }}</div><div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': speed.state === \'ERROR\', \'infoColorBackground\': speed.state === \'PENDING\'}\"></div></div><md-slider-container layout=\"row\" class=\"fullWidth\"><md-slider flex=\"80\" name=\"rolloverSpeedSlider\" ng-model=\"speed.value\" min=\"{{speed.sliderMin}}\" max=\"{{speed.sliderMax}}\" aria-label=\"Dosing value\" class=\"md-accent\"></md-slider><md-input-container flex=\"20\"><input type=\"number\" name=\"rolloverSpeedInput{{$index}}\" ng-model=\"speed.value\" aria-label=\"Speed\" required=\"\" min=\"{{speed.sliderMin}}\" max=\"{{speed.sliderMax}}\"><div ng-messages=\"rolloverSpeedForm[\'rolloverSpeedInput\' + $index].$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div ng-message=\"min\">{{::\'VALIDATION_NOT_VALID_RANGE\' | translate}}</div><div ng-message=\"max\">{{::\'VALIDATION_NOT_VALID_RANGE\' | translate}}</div></div></md-input-container></md-slider-container></div></div></div><div layout=\"row\" layout-align=\"space-between center\" layout-margin=\"\"><div></div><md-button class=\"md-raised primary-karcher-button noMarginLeft noMarginRight rollover-reset-button\" ng-click=\"vm.updateSpeed(vm.speedList)\" ng-disabled=\"rolloverSpeedForm.$invalid\" ng-class=\"{\'primary-karcher-button-disabled\': rolloverSpeedForm.$invalid}\" aria-label=\"Update speeds\">{{::\'APPLY_SPEED_CHANGES\' | translate}}</md-button></div></div></form></div>");
$templateCache.put("app/facilityKarcherDetails/washBayDetails/washBayDetails.html","<div layout=\"column\" flex=\"\" class=\"bay-wrapper\"><h1 class=\"infoColor boldText\">POINT</h1><md-card class=\"paddingAll10\" layout=\"column\" layout-align=\"space-between start\"><span class=\"main-point-title\">{{ vm.washFacilityData.point.name }}</span><div class=\"boldText\">FEEDS</div><div ng-repeat=\"facilityFeed in vm.washFacilityData.point.feeds\" class=\"successColor\">{{ facilityFeed.reference }} - <span class=\"boldText grayBasicColor\">{{ facilityFeed.currentValue }}</span></div><div class=\"boldText\">ACTUATORS</div><div ng-repeat=\"facilityActuator in vm.washFacilityData.point.actuators\" class=\"warnColor\">{{ facilityActuator.reference }} - <span class=\"boldText grayBasicColor\">{{ facilityActuator.value }}</span></div></md-card><h1 class=\"infoColor boldText\">SUB_POINTS</h1><div><script type=\"text/ng-template\" id=\"bayTreeParent\"><md-card class=\"paddingAll10\" layout=\"row\" layout-align=\"space-between center\"> <div class=\"cursorPointer\"> <span class=\"main-point-title\">{{ bay.name }}</span> <div class=\"boldText\">FEEDS</div> <div ng-repeat=\"feed in bay.feeds\"> {{ feed.reference }} - {{ feed.currentValue }} </div> <div class=\"boldText\">ACTUATORS</div> <div ng-repeat=\"actuator in bay.actuators\"> {{ actuator.reference }} - {{ actuator.value }} <span class=\"infoColor\">(STATE) - {{ actuator.state }}</span> </div> </div> <div> </div> </md-card> <div ng-repeat=\"bay in bay.points\" ng-include=\"\'bayTree\'\"> </div></script><script type=\"text/ng-template\" id=\"bayTree\"><div class=\"list-item-wrapper fullWidth\" layout=\"row\" layout-align=\"space-between center\"> <div class=\"cursorPointer\"> <div class=\"boldText grayBasicColor point-details-name-wrapper\" ng-class=\"{\'first-point-details-name-wrapper\': $first}\"> {{ bay.name }} </div> <div ng-repeat=\"feed in bay.feeds\" class=\"successColor boldText paddingLeft20\"> {{ feed.reference }} - {{ feed.currentValue }} </div> <div ng-repeat=\"actuator in bay.actuators\" class=\"warnColor boldText paddingLeft20\"> {{ actuator.reference }} - {{ actuator.value }} <span class=\"infoColor\">(STATE) - {{ actuator.state }}</span> </div> </div> </div> <div ng-repeat=\"bay in bay.points\" ng-include=\"\'bayTree\'\" ng-class=\"{\'last-item\': $last}\"> </div></script><div ng-repeat=\"bay in vm.washFacilityData.point.points\" ng-include=\"\'bayTreeParent\'\"></div></div></div>");
$templateCache.put("app/facilityKarcherDetails/washingPrograms/washingPrograms.html","<div class=\"marginBottom10\" ng-if=\"vm.programList\"><div class=\"customCardTitle cursorPointer\" layout=\"\" layout-align=\"space-between center\" ng-click=\"vm.hideContent()\"><span class=\"md-title customCardSubTitle\">{{::\'WASHING_PROGRAMS\' | translate}}</span> <span class=\"material-icons\">{{vm.iconSource}}</span></div><div ng-if=\"vm.visibilityState\"><div layout-lg=\"row\" layout-xl=\"row\" layout-xs=\"column\" layout-md=\"column\" layout-sm=\"column\" layout-wrap=\"\" layout-align=\"center start\" class=\"fullWidth\"><div class=\"karcher-program-card fullWidth marginTop20 marginRight1\" ng-if=\"item.availability && item.id\" layout=\"column\" flex=\"30\" flex-xl=\"30\" flex-md=\"100\" flex-sm=\"100\" flex-xs=\"100\" ng-repeat=\"item in vm.newList\"><div layout=\"column\" layout-align=\"start center\" flex=\"\" class=\"fullWidth\"><div class=\"programs-subtitle-wrapper fullWidth\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start start\"><div layout=\"column\" layout-align=\"start start\"><div>{{ item.name | removews }}</div><div class=\"smallestText boldText500\">{{ item.description | removews }}</div></div><div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': item.nameState === \'ERROR\', \'infoColorBackground\': item.nameState === \'PENDING\'}\"></div></div><div><md-icon aria-label=\"Edit actuator value\" md-svg-src=\"assets/icons/ic_edit_white_24px.svg\" class=\"cursorPointer edit-actuators-icon\" ng-click=\"vm.updateProgramInfo($event, item.actuators, item.parentId)\"><md-tooltip hide-xs=\"\">{{::\'EDIT\' | translate}} {{ item.name }}</md-tooltip></md-icon></div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"programs-content-wrapper fullWidth marginTop10\"><div>{{ \'PROGRAM_ID\' | translate }}</div><div>{{ item.id }}</div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"programs-content-wrapper fullWidth\"><div layout=\"row\" layout-align=\"start center\"><div>{{ \'PROGRAM_PRICE\' | translate }}</div><div class=\"actuator-state-wrapper\" ng-class=\"{\'warnColorBackground\': item.priceState === \'ERROR\', \'infoColorBackground\': item.priceState === \'PENDING\'}\"></div></div><div>{{ item.price | number: 2 }}</div></div></div></div></div></div></div>");
$templateCache.put("app/karcherCustomDialogs/actuateOperationTime/actuateOperationTime.html","<div class=\"karcher-custom-model-wrapper\"><md-dialog aria-label=\"Actuate operation time\"><form novalidate=\"\" name=\"actuateOperationTimeForm\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'UPDATE\' | translate }} - {{ vm.currentDay | translate }}</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" ng-repeat=\"ot in vm.data track by $index\"><md-input-container class=\"md-block\" ng-if=\"ot.reference !== \'24H\'\"><label>{{ ot.reference | translateReferencesFilter }}</label> <input name=\"operationTimeInput{{$index}}\" ng-model=\"ot.value\" ng-disabled=\"vm.disableInputs\" ng-pattern=\"vm.patternForHourInputs\" ng-required=\"!vm.disableInputs\" type=\"text\"><div ng-messages=\"actuateOperationTimeForm[\'operationTimeInput\' + $index].$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"pattern\">- {{\'VALIDATION_OPERATION_TIME\' | translate}}</div><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"ot.reference === \'24H\'\"><label>{{ ot.reference | translateReferencesFilter }}</label><md-select ng-model=\"ot.value\" ng-change=\"vm.change24hValue(actuateOperationTimeForm)\" required=\"\"><md-option value=\"false\">{{ \'INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE\' | translate }}</md-option><md-option value=\"24hopen\">{{ \'OPEN_24H\' | translate }}</md-option><md-option value=\"24hclose\">{{ \'CLOSE_24H\' | translate }}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.cancel()\">{{ \'CANCEL\' | translate }}</md-button><md-button ng-click=\"vm.actuate()\" ng-disabled=\"actuateOperationTimeForm.$invalid\">{{ \'UPDATE\' | translate }}</md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/karcherCustomDialogs/actuateOperationTimeIllumination/actuateOperationTimeIllumination.html","<div class=\"karcher-custom-model-wrapper\"><md-dialog aria-label=\"Actuate operation time\"><form novalidate=\"\" name=\"actuateOperationTimeForm\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'UPDATE\' | translate }} - {{ vm.currentDay | translate }}</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" ng-repeat=\"ot in vm.data track by $index\"><md-input-container class=\"md-block\" ng-if=\"ot.reference !== \'ILL_24H\'\"><label>{{ ot.reference | translateReferencesFilter }}</label> <input name=\"operationTimeInput{{$index}}\" ng-model=\"ot.value\" ng-disabled=\"vm.disableInputs\" ng-pattern=\"vm.patternForHourInputs\" ng-required=\"!vm.disableInputs\" type=\"text\"><div ng-messages=\"actuateOperationTimeForm[\'operationTimeInput\' + $index].$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"pattern\">- {{\'VALIDATION_OPERATION_TIME\' | translate}}</div><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"ot.reference === \'ILL_24H\'\"><label>{{ ot.reference | translateReferencesFilter }}</label><md-select ng-model=\"ot.value\" ng-change=\"vm.change24hValue(actuateOperationTimeForm)\" required=\"\"><md-option value=\"false\">{{ \'INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE\' | translate }}</md-option><md-option value=\"24hopen\">{{ \'OPEN_24H\' | translate }}</md-option><md-option value=\"24hclose\">{{ \'CLOSE_24H\' | translate }}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.cancel()\">{{ \'CANCEL\' | translate }}</md-button><md-button ng-click=\"vm.actuate()\" ng-disabled=\"actuateOperationTimeForm.$invalid\">{{ \'UPDATE\' | translate }}</md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/karcherCustomDialogs/actuateOperationTimeVacuum/actuateOperationTimeVacuum.html","<div class=\"karcher-custom-model-wrapper\"><md-dialog aria-label=\"Actuate operation time\"><form novalidate=\"\" name=\"actuateOperationTimeForm\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'UPDATE\' | translate }} - {{ vm.currentDay | translate }}</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" ng-repeat=\"ot in vm.data track by $index\"><md-input-container class=\"md-block\" ng-if=\"ot.reference !== \'VAC_24H\'\"><label>{{ ot.reference | translateReferencesFilter }}</label> <input name=\"operationTimeInput{{$index}}\" ng-model=\"ot.value\" ng-disabled=\"vm.disableInputs\" ng-pattern=\"vm.patternForHourInputs\" ng-required=\"!vm.disableInputs\" type=\"text\"><div ng-messages=\"actuateOperationTimeForm[\'operationTimeInput\' + $index].$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"pattern\">- {{\'VALIDATION_OPERATION_TIME\' | translate}}</div><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><md-input-container class=\"md-block\" ng-if=\"ot.reference === \'VAC_24H\'\"><label>{{ ot.reference | translateReferencesFilter }}</label><md-select ng-model=\"ot.value\" ng-change=\"vm.change24hValue(actuateOperationTimeForm)\" required=\"\"><md-option value=\"false\">{{ \'INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE\' | translate }}</md-option><md-option value=\"24hopen\">{{ \'OPEN_24H\' | translate }}</md-option><md-option value=\"24hclose\">{{ \'CLOSE_24H\' | translate }}</md-option></md-select></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.cancel()\">{{ \'CANCEL\' | translate }}</md-button><md-button ng-click=\"vm.actuate()\" ng-disabled=\"actuateOperationTimeForm.$invalid\">{{ \'UPDATE\' | translate }}</md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/karcherCustomDialogs/actuatePumpPrograms/actuatePumpPrograms.html","<div class=\"karcher-custom-model-wrapper\"><md-dialog aria-label=\"Actuate operation time\"><form novalidate=\"\" name=\"actuatePumpProgramForm\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'UPDATE_ACTUATORS\' | translate }}</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" ng-repeat=\"wp in vm.data\"><md-input-container class=\"md-block\"><label>{{ wp.reference | translate }}</label> <input name=\"pumpProgramInput{{ $index }}\" ng-model=\"wp.value\" required=\"\" min=\"1\" max=\"255\" type=\"number\"><div ng-messages=\"actuatePumpProgramForm[\'pumpProgramInput\' + $index].$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"min\">- {{::\'PUMP_RUN_TIME_MIN_VALIDATION\' | translate}}</div><div flex=\"\" ng-message=\"max\">- {{::\'PUMP_RUN_TIME_MAX_VALIDATION\' | translate}}</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.cancel()\">{{ \'CANCEL\' | translate }}</md-button><md-button ng-click=\"vm.actuate()\" ng-disabled=\"actuatePumpProgramForm.$invalid\">{{ \'UPDATE\' | translate }}</md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/karcherCustomDialogs/actuateWashingPrograms/actuateWashingPrograms.html","<div class=\"karcher-custom-model-wrapper\"><md-dialog aria-label=\"Actuate operation time\"><form novalidate=\"\" name=\"actuateWashingProgramForm\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'UPDATE_ACTUATORS\' | translate }}</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\" ng-repeat=\"wp in vm.data\"><md-input-container class=\"md-block\"><label>{{ wp.reference | translate }} {{ wp.toValidateCheck }}</label> <input name=\"washingProgramInput{{ $index }}\" ng-model=\"wp.value\" required=\"\" ng-pattern=\"wp.regexCheck\" type=\"text\"><div ng-messages=\"actuateWashingProgramForm[\'washingProgramInput\' + $index].$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{::\'WASH_PROGRAM_MIN_MAX_VALIDATION\' | translate}}</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.cancel()\">{{ \'CANCEL\' | translate }}</md-button><md-button ng-click=\"vm.actuate()\" ng-disabled=\"actuateWashingProgramForm.$invalid\">{{ \'UPDATE\' | translate }}</md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/karcherCustomDialogs/changeDeviceLabelName/changeDeviceLabelName.html","<div class=\"karcher-custom-model-wrapper\"><md-dialog aria-label=\"Actuate operation time\"><form novalidate=\"\" name=\"changeDeviceLabelNameForm\" ng-cloak=\"\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>{{ \'UPDATE\' | translate }}</h2></div></md-toolbar><md-dialog-content><div class=\"md-dialog-content\"><md-input-container class=\"md-block\"><label>{{ vm.data.deviceName | translate }}</label> <input name=\"label\" ng-model=\"vm.labelToEdit\" required=\"\" min=\"1\" max=\"255\" type=\"text\"><div ng-messages=\"changeDeviceLabelNameForm.label.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"min\">- {{::\'PUMP_RUN_TIME_MIN_VALIDATION\' | translate}}</div><div flex=\"\" ng-message=\"max\">- {{::\'PUMP_RUN_TIME_MAX_VALIDATION\' | translate}}</div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex=\"\"></span><md-button ng-click=\"vm.cancel()\">{{ \'CANCEL\' | translate }}</md-button><md-button ng-click=\"vm.actuate()\" ng-disabled=\"changeDeviceLabelNameForm.$invalid\">{{ \'UPDATE\' | translate }}</md-button></md-dialog-actions></form></md-dialog></div>");
$templateCache.put("app/organization/details/organizationDetails.html","<div class=\"md-padding\" flex=\"\"><form novalidate=\"\" name=\"createOrganizationForm\" ng-submit=\"vm.createOrganization()\"><h4 class=\"md-display-1 md-padding noMarginBottom noPaddingBottom noMarginTop\">{{vm.isEditMode ? \'EDIT_ORGANIZATION\' : \'CREATE_ORGANIZATION_AS\' | translate}} <span class=\"warnColor\">{{ vm.organizationDetails.parentOrganizationName }}</span></h4><div class=\"create-organization-wrapper\" layout=\"row\" layout-padding=\"\" layout-xs=\"column\"><div layout=\"column\" flex=\"\"><div layout=\"row\"><div flex=\"20\"></div><md-input-container flex=\"60\"><label>{{::\'NAME\' | translate}}</label> <input ng-model=\"vm.organizationDetails.organizationName\" name=\"organizationName\" required=\"\"><div ng-messages=\"createOrganizationForm.organizationName.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><div flex=\"\"></div></div><div layout=\"row\"><div flex=\"20\"></div><md-input-container flex=\"60\"><label>{{::\'ADDRESS\' | translate}}</label> <input ng-model=\"vm.organizationDetails.organizationAddress\" name=\"organizationAddress\"></md-input-container><div flex=\"\"></div></div><div layout=\"row\" ng-if=\"vm.organizationDetails.organizationType === \'COMPANY\'\"><div flex=\"20\"></div><md-input-container flex=\"60\"><label>{{::\'VOUCHER_VALIDITY_DAYS\' | translate}}</label> <input ng-model=\"vm.organizationDetails.voucherExpirationDays\" name=\"voucherExpirationDays\" type=\"text\" ng-pattern=\"/^[0-9]+$/\"><div ng-messages=\"createOrganizationForm.voucherExpirationDays.$error\" role=\"alert\"><div ng-message=\"pattern\">{{ \"VALIDATION_ONLY_NUMBERS\" | translate }}</div></div></md-input-container><div flex=\"\"></div></div><div layout=\"row\"><div flex=\"20\"></div><md-input-container flex=\"60\"><md-select ng-model=\"vm.organizationDetails.organizationType\" placeholder=\"{{\'SELECT_ORGANIZATION_TYPE\' | translate}}\" class=\"md-no-underline\" ng-change=\"vm.selectOrganizationType()\" required=\"\" name=\"organizationType\" ng-disabled=\"vm.isEditMode\"><md-option ng-repeat=\"type in vm.organizationDetails.organizationTypes\" ng-value=\"type.value\">{{ type.name }}</md-option></md-select><div ng-messages=\"createOrganizationForm.organizationType.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><div flex=\"\"></div></div><div layout=\"row\"><div flex=\"20\"></div><div layout=\"row\" flex=\"60\" ng-if=\"vm.organizationDetails.hideSelectorList && !vm.isEditMode\"><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearSelectorInput()\"></md-icon><multiply-items-selector list=\"vm.organizationDetails.typeSelectorList\" enable-selector=\"false\" place-holder-text=\"vm.organizationDetails.placeHolderText\" clear-site-text-input=\"vm.organizationDetails.typeSelector\" selected-item=\"vm.organizationDetails.typeSelector\" disable-selector=\"vm.isEditMode\" selected-list=\"vm.getSelectedValue(ids)\" flex=\"\"></multiply-items-selector></div><div layout=\"row\" flex=\"60\" ng-if=\"vm.isEditMode && vm.organizationDetails.organizationTypeSelectorInEditMode\"><p class=\"grayColor fullWidth organization-type-title\">{{ vm.organizationDetails.organizationTypeSelectorInEditMode }}</p></div><div flex=\"\"></div></div></div><div layout=\"column\" flex=\"\" ng-if=\"vm.brand === \'karcher\'\"><div layout=\"row\"><div flex=\"20\"></div><md-input-container flex=\"60\"><md-select ng-model=\"vm.organizationDetails.supportedOrganization\" placeholder=\"{{\'SELECT_SUPPORTED_ORGANIZATION\' | translate}}\" class=\"md-no-underline\" ng-change=\"vm.selectSupportedOrganization()\" name=\"supportedOrganization\"><md-option ng-repeat=\"organization in vm.organizationDetails.organizationList\" ng-value=\"organization.id\">{{ organization.name }}</md-option></md-select></md-input-container><div flex=\"\" layout=\"\" layout-align=\"center center\"><md-icon md-svg-src=\"assets/icons/ic_close_primary_24px.svg\" class=\"cursorPointer\" ng-click=\"vm.clearInput()\"><md-tooltip hide-xs=\"\">{{::\'CLEAR_SEARCH\' | translate}}</md-tooltip></md-icon></div></div><div layout=\"row\"><div flex=\"20\"></div><md-input-container flex=\"60\"><label>{{::\'SUPPORTED_ORG_TYPE\' | translate}}</label> <input ng-model=\"vm.organizationDetails.supportedOrganizationType\" name=\"supportedOrganizationType\" disabled=\"\"></md-input-container><div flex=\"\"></div></div></div></div><div layout=\"\" layout-align=\"end center\"><md-button class=\"md-primary md-raised\" type=\"submit\" ng-disabled=\"createOrganizationForm.organizationType.$invalid || createOrganizationForm.organizationName.$invalid || !vm.organizationDetails.typeSelector\">{{::\'SAVE\' | translate}}</md-button></div></form></div>");
$templateCache.put("app/periodicSummary/businessTransactions/businessTransactions.html","<md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span>{{::\'BUSSINESS_INVOICES_LIST\' | translate}}</span></div></md-toolbar><div layout=\"\" flex=\"\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\" layout-margin=\"\" class=\"businessTransactionInputs\"><md-input-container class=\"md-block minWidth100\"><label>{{\'START_MONTH\' | translate}}</label><md-select required=\"\" name=\"startMonth\" ng-model=\"vm.selectFromMonth\" aria-label=\"Selected month\" ng-change=\"vm.createToMonthList(vm.selectFromMonth, vm.selectToMonth)\"><md-option ng-repeat=\"month in vm.monthList\" ng-value=\"$index\">{{month}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-align=\"start start\" layout-margin=\"\" class=\"businessTransactionInputs\"><md-input-container class=\"md-block minWidth100\"><label>{{\'END_MONTH\' | translate}}</label><md-select required=\"\" name=\"endMonth\" ng-model=\"vm.selectToMonth\" aria-label=\"Selected month\" ng-change=\"vm.checkSearchCriteria(vm.selectFromMonth, vm.selectToMonth)\"><md-option ng-repeat=\"month in vm.monthToList\" ng-value=\"$index + vm.selectToMonthIndex\">{{month}}</md-option></md-select></md-input-container></div><div layout=\"column\" layout-align=\"start start\" layout-margin=\"\" class=\"businessTransactionInputs\"><md-input-container class=\"md-block minWidth100\"><label>{{\'YEAR\' | translate}}</label><md-select required=\"\" name=\"year\" ng-model=\"vm.selectYear\" aria-label=\"Selected year\"><md-option ng-repeat=\"year in vm.yearList\" ng-value=\"year\">{{year}}</md-option></md-select></md-input-container></div><md-button class=\"md-raised\" ng-click=\"vm.search()\" ng-disabled=\"vm.disableSearch\">{{\'SEARCH\' | translate}}</md-button></div><br><md-divider></md-divider><br><md-table-container><table md-table=\"\" multiple=\"\" ng-model=\"vm.selectedbusinessTransaction\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.businessTransactionOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\">{{::\'NAME\' | translate}}</th><th md-column=\"\">{{::\'TOKEN_TYPE\' | translate}}</th><th md-column=\"\" md-order-by=\"\">{{::\'TOKEN_NUMBER\' | translate}}</th><th md-column=\"\" md-order-by=\"\">{{::\'MONTH\' | translate}}</th><th md-column=\"\" md-order-by=\"\">{{::\'DOWNLOAD\' | translate}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"invoice in vm.businessInvoices track by $index\"><p ng-if=\"vm.businessInvoices.length < 1\">{{::\'NOTHING_TO_DISPLAY\' | translate}}</p><td md-cell=\"\">{{invoice.name}}</td><td md-cell=\"\">{{invoice.code | tokensFilter | translate}}</td><td md-cell=\"\">{{invoice.tokens}}</td><td md-cell=\"\">{{invoice.month | monthToStringFilter}}</td><td md-cell=\"\"><md-button class=\"md-raised\" ng-if=\"invoice.code === \'R2W\'\" ng-disabled=\"invoice.disableSearch\" ng-click=\"vm.downloadBusinessInvoice(invoice.id, invoice.month)\">{{\'INVOICE\' | translate}}</md-button></td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.businessTransactionPageSize\" md-options=\"vm.businessTransactionPageOptions\" md-page=\"vm.businessTransactionPage\" md-total=\"{{vm.businessTransactionTotal}}\" md-label=\"{{vm.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\" md-page-select=\"true\" md-boundary-links=\"true\"></md-table-pagination>");
$templateCache.put("app/pricing/singleWash/singleWash.component.html","<div class=\"single-wash-wrapper\"><div class=\"single-wash-form\"><form novalidate=\"\" name=\"singleWashForm\"><div row=\"\" layout-margin=\"\"><fieldset ng-disabled=\"vm.deleteSingleWash\" class=\"Single-wash-field-set-wrapper\"><md-input-container flex=\"\"><label>{{::\'PRICE\' | translate}}</label> <input ng-model=\"vm.singleWashData.price\" name=\"singleWashPrice\" required=\"\"><div ng-messages=\"singleWashForm.singleWashPrice.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><span class=\"currency-wrapper\">({{ vm.regionCurrency }})</span></fieldset><md-button ng-if=\"vm.editSingleWash || vm.deleteSingleWash\" class=\"md-button md-primary md-raised\" type=\"button\" ng-click=\"vm.cancel()\">{{ \"CANCEL\" | translate }}</md-button><md-button class=\"md-button md-raised\" ng-class=\"saveButtonClass\" type=\"button\" ng-disabled=\"singleWashForm.$invalid\" ng-click=\"vm.save(vm.singleWashData)\">{{ vm.buttonTitle }}</md-button></div></form></div><md-divider class=\"token-package-divider\"></md-divider><div layout=\"\" layout-align=\"center space-between\" class=\"list-item-wrapper-title\"><p flex=\"10\" class=\"list-item-wrapper\">#</p><p flex=\"30\" class=\"list-item-wrapper\">{{ \"PRICE\" | translate }}</p><p flex=\"30\" class=\"list-item-wrapper\"></p><p flex=\"\" class=\"list-item-wrapper\"></p></div><div ng-repeat=\"singleWash in vm.singleWashList\" layout=\"\" layout-align=\"center space-between\"><p flex=\"10\" class=\"list-item-wrapper\">{{ $index + 1 }}.</p><p flex=\"30\" class=\"list-item-wrapper\">{{ singleWash.price.amount }} {{ singleWash.price.code }}</p><p flex=\"30\" class=\"list-item-wrapper centerText linkedText\"><md-icon md-svg-src=\"assets/icons/ic_edit_black_24px.svg\" ng-click=\"vm.editingSingleWash(singleWash)\"></md-icon></p><p flex=\"\" class=\"list-item-wrapper centerText linkedText\"><md-icon md-svg-src=\"assets/icons/ic_delete_forever_black_24px.svg\" ng-click=\"vm.deletingSingleWash(singleWash)\"></md-icon></p></div></div>");
$templateCache.put("app/pricing/tokenPackages/tokenPackages.component.html","<div class=\"token-package-wrapper\"><div class=\"token-package-form\"><form novalidate=\"\" name=\"tokenPackageForm\"><div row=\"\" layout-margin=\"\"><fieldset ng-disabled=\"vm.deleteTokenPackages\" class=\"token-package-field-set-wrapper\"><md-input-container flex=\"\"><label>{{::\'NAME\' | translate}}</label> <input ng-model=\"vm.tokenPackagesData.name\" name=\"packageName\" required=\"\"><div ng-messages=\"tokenPackageForm.packageName.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><md-input-container flex=\"\"><label>{{::\'AMOUNT\' | translate}}</label> <input ng-model=\"vm.tokenPackagesData.tokenAmount\" name=\"tokenAmount\" required=\"\"><div ng-messages=\"tokenPackageForm.tokenAmount.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><md-input-container flex=\"\"><label>{{::\'PRICE\' | translate}}</label> <input ng-model=\"vm.tokenPackagesData.priceAmount\" name=\"priceAmount\" required=\"\"><div ng-messages=\"tokenPackageForm.priceAmount.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><span class=\"currency-wrapper\">({{ vm.regionCurrency }})</span><md-input-container flex=\"\"><label>{{::\'VALIDITY\' | translate}}</label> <input aria-label=\"validity\" ng-model=\"vm.tokenPackagesData.validity\" name=\"validity\" required=\"\"><div ng-messages=\"tokenPackageForm.validity.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><span class=\"currency-wrapper\">({{ \'DAYS\' | translate }})</span></fieldset><md-button ng-if=\"vm.editTokenPackages || vm.deleteTokenPackages\" class=\"md-button md-primary md-raised\" type=\"button\" ng-click=\"vm.cancel()\">{{ \"CANCEL\" | translate }}</md-button><md-button class=\"md-button md-raised\" ng-class=\"saveButtonClass\" type=\"button\" ng-disabled=\"tokenPackageForm.$invalid\" ng-click=\"vm.save(vm.tokenPackagesData)\">{{ vm.buttonTitle }}</md-button></div></form></div><md-divider class=\"token-package-divider\"></md-divider><div layout=\"\" layout-align=\"center space-between\" class=\"list-item-wrapper-title\"><p flex=\"10\" class=\"list-item-wrapper\">#</p><p flex=\"30\" class=\"list-item-wrapper\">{{ \"NAME\" | translate }}</p><p flex=\"10\" class=\"list-item-wrapper\">{{ \"AMOUNT\" | translate }}</p><p flex=\"10\" class=\"list-item-wrapper\">{{ \"PRICE\" | translate }}</p><p flex=\"10\" class=\"list-item-wrapper\">{{ \"VALIDITY\" | translate }}</p><p flex=\"15\" class=\"list-item-wrapper\"></p><p flex=\"\" class=\"list-item-wrapper\"></p></div><div ng-repeat=\"tokenPackage in vm.tokenPackageList\" layout=\"\" layout-align=\"center space-between\"><p flex=\"10\" class=\"list-item-wrapper\">{{ $index + 1 }}.</p><p flex=\"30\" class=\"list-item-wrapper\">{{ tokenPackage.name }}</p><p flex=\"10\" class=\"list-item-wrapper\">{{ tokenPackage.tokens.amount }}</p><p flex=\"10\" class=\"list-item-wrapper\">{{ tokenPackage.price.amount }} {{ tokenPackage.price.code }}</p><p flex=\"10\" class=\"list-item-wrapper\">{{ tokenPackage.validity }}</p><p flex=\"15\" class=\"list-item-wrapper centerText linkedText\"><md-icon md-svg-src=\"assets/icons/ic_edit_black_24px.svg\" ng-click=\"vm.editPackage(tokenPackage)\"></md-icon></p><p flex=\"\" class=\"list-item-wrapper centerText linkedText\"><md-icon md-svg-src=\"assets/icons/ic_delete_forever_black_24px.svg\" ng-click=\"vm.deletePackage(tokenPackage)\"></md-icon></p></div></div>");
$templateCache.put("app/reports/avgByBoxReport/avgByBoxReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'AVG_MONEY_BY_BOX_REPORT\' | translate}}</span></div><report-by-box data=\"vm.report.chartRegionCurrency\"></report-by-box><report-by-box data=\"vm.report.chartTokens\"></report-by-box>");
$templateCache.put("app/reports/avgByDayReport/avgByDayReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'AVG_MONEY_BY_DAY_OF_WEEK_REPORT\' | translate}}</span></div><md-card><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"byHour\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DAYS\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/avgByHourReport/avgByHourReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'AVG_MONEY_BY_HOUR_REPORT\' | translate}}</span></div><md-card><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"byHour\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'HOURS\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/changerIncomeByDate/changerIncomeByDate.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'CHANGER_INCOME\' | translate}}</span></div><md-card><md-card-title layout=\"\" layout-wrap=\"\" class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text flex=\"33\"><div class=\"md-caption\">{{::\'CHANGER_INCOME\' | translate}}</div><div class=\"md-headline\">{{vm.report.unit}}<span class=\"paddingLeft10\">{{vm.report.total}}</span></div></md-card-title-text><md-card-title-text flex=\"33\" ng-repeat=\"totalByGroup in vm.report.totalByGroupName\"><div class=\"md-caption\">{{totalByGroup.name}}</div><div class=\"md-headline\">{{vm.report.unit}}{{totalByGroup.total}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"givenLoyalty\" chart-data-name=\"vm.namingData\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DATE\' | translate}}\" chart-data-name=\"vm.namingData\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/comparationReport/comparationReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'COMPARE_PERIODS_REPORT\' | translate}}</span></div><md-card><md-card-title class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text><div class=\"md-caption\">{{::\'TOTAL_SPENT_MONEY_FOR_PERIOD\' | translate}} {{vm.report.period1}}</div><div class=\"md-headline\">{{vm.report.chart.data.groupTotal[0] | currency:vm.report.chart.data.unit}}</div><div class=\"md-caption\">{{::\'TOTAL_SPENT_MONEY_FOR_PERIOD\' | translate}} {{vm.report.period2}}</div><div class=\"md-headline\">{{vm.report.chart.data.groupTotal[1] | currency:vm.report.chart.data.unit}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"comparative\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'MONTHS\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/dailyCoinsReport/dailyCoinsReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'COINS_BY_DATE_REPORT\' | translate}}</span></div><md-card><md-card-title class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text><div class=\"md-caption\">{{::\'TOTAL_SPENT_COINS\' | translate}}</div><div class=\"md-headline\">{{vm.report.chart.data.unit}} {{vm.report.chart.data.total}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"true\" chart-id=\"totalCoins\" chart-data-name=\"vm.report.chartType\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DATE\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/dailyEurokeyReport/dailyEurokeyReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'EUROKEY_BY_DATE_REPORT\' | translate}}</span></div><md-card><md-card-title class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text><div class=\"md-caption\">{{::\'TOTAL_SPENT_EUROKEY\' | translate}}</div><div class=\"md-headline\">{{vm.report.chart.data.total | currency:vm.report.chart.data.unit}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"true\" chart-id=\"totalEurokey\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DATE\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/dailyR2WReport/dailyR2WReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'R2W_BY_DATE_REPORT\' | translate}}</span></div><md-card><md-card-title class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text><div class=\"md-caption\">{{::\'TOTAL_SPENT_MONEY\' | translate}}</div><div class=\"md-headline\">{{vm.report.chart.data.total | currency:vm.report.chart.data.unit}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"true\" chart-id=\"totalCoins\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DATE\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/dailyTotalReport/dailyTotalReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'MONEY_BY_DATE_REPORT\' | translate}}</span></div><md-card><md-card-title class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text><div class=\"\">{{::\'TOTAL_SPENT_MONEY\' | translate}}</div><div class=\"\">{{vm.report.chart.data.total | currency:vm.report.chart.data.unit}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"true\" chart-id=\"totalMoneyDaily\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DATE\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/givenLoyaltyPerDayReport/givenLoyaltyPerDayReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'TOTAL_SPENT_LOCAL_TOKENS_PER_DAY\' | translate}}</span></div><md-card><md-card-title layout=\"\" layout-wrap=\"\" class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text flex=\"50\"><div class=\"md-caption\">{{::\'TOTAL_SPENT_LOCAL_TOKENS_PER_DAY\' | translate}}</div><div class=\"md-headline\">{{vm.report.unit}}{{vm.report.total}}</div></md-card-title-text><md-card-title-text flex=\"50\" ng-repeat=\"totalByGroup in vm.report.totalByGroupName\"><div class=\"md-caption\">{{totalByGroup.name}}</div><div class=\"md-headline\">{{vm.report.unit}}{{totalByGroup.total}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"givenLoyalty\" chart-data-name=\"vm.namingData\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DATE\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/loyaltyPerPaymentMethodReport/loyaltyPerPaymentMethodReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'LOYALTY_PER_PAYMENT_METHOD\' | translate}}</span></div><md-card><md-card-title layout=\"\" layout-wrap=\"\" class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text flex=\"33\" ng-repeat=\"totalByGroup in vm.report.totalByGroupName\"><div class=\"md-caption\">{{totalByGroup.name}}</div><div class=\"md-headline\">{{totalByGroup.total | currency:vm.report.chart.data.unit}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"true\" chart-id=\"loyaltyPerPayment\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DATE\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/totalGivenLocalTokensPerDay/totalGivenLocalTokensPerDay.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY\' | translate}}</span></div><md-card><md-card-title layout=\"\" layout-wrap=\"\" class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text flex=\"50\"><div class=\"md-caption\">{{::\'TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY\' | translate}}</div><div class=\"md-headline\">{{vm.report.unit}}{{vm.report.total}}</div></md-card-title-text><md-card-title-text flex=\"50\" ng-repeat=\"totalByGroup in vm.report.totalByGroupName\"><div class=\"md-caption\">{{totalByGroup.name}}</div><div class=\"md-headline\">{{vm.report.unit}}{{totalByGroup.total}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"givenLoyalty\" chart-data-name=\"vm.namingData\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DATE\' | translate}}\" chart-data-name=\"vm.namingData\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/totalIncomePos/totalIncomePos.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'POS_INCOME\' | translate}}</span></div><md-card><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"byHour\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DAYS\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/totalPurchasedLocalTokensPerDay/totalPurchasedLocalTokensPerDay.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY\' | translate}}</span></div><md-card><md-card-title layout=\"\" layout-wrap=\"\" class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text flex=\"33\"><div class=\"md-caption\">{{::\'TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY\' | translate}}</div><div class=\"md-headline\">{{vm.report.unit}}{{vm.report.total}}</div></md-card-title-text><md-card-title-text flex=\"33\" ng-repeat=\"totalByGroup in vm.report.totalByGroupName\"><div class=\"md-caption\">{{totalByGroup.name}}</div><div class=\"md-headline\">{{vm.report.unit}}{{totalByGroup.total}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"givenLoyalty\" chart-data-name=\"vm.namingData\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'DATE\' | translate}}\" chart-data-name=\"vm.namingData\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/userGroupsByDate/userGroupsByDate.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'TOTAL_USERS_BY_GROUP\' | translate}}</span></div><md-card><md-card-title layout=\"\" layout-wrap=\"\" class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text flex=\"33\"><div class=\"md-caption\">{{::\'TOTAL_VISITS\' | translate}}</div><div class=\"md-headline\">{{vm.report.total | number}} {{::\'TOTAL_USERS_BY_GROUP_VISITS_UNIT\' | translate}}</div></md-card-title-text><md-card-title-text flex=\"33\" ng-repeat=\"totalByGroup in vm.report.totalByGroupName\"><div class=\"md-caption\">{{totalByGroup.name}}</div><div class=\"md-headline\">{{totalByGroup.total | number}} {{::\'TOTAL_USERS_BY_GROUP_VISITS_UNIT\' | translate}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"totalUsers\" chart-data-name=\"vm.report.chartType\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"DATE\"></facilities-group-grid></md-card>");
$templateCache.put("app/reports/usersPerVisitReport/usersPerVisitReport.html","<div class=\"reportTitle\"><span class=\"md-headline\">{{::\'VISITS_COUNT_REPORT\' | translate}}</span></div><md-card><md-card-title class=\"reportTitle\" ng-if=\"vm.report.isChartVisible\"><md-card-title-text><div class=\"md-caption\">{{::\'TOTAL_USERS\' | translate}}</div><div class=\"md-headline\">{{vm.report.chart.data.total | number}} {{::\'TOTAL_USERS_BY_GROUP_USERS_UNIT\' | translate}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report.chart\" sub-chart=\"false\" chart-id=\"usersPerVisit\" chart-data-name=\"vm.report.chartType\" ng-if=\"vm.report.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.isChartVisible\"><facilities-group-grid options=\"vm.report.chart\" group-label=\"{{::\'NUMBER_OF_VISITS_TITLE\' | translate}}\"></facilities-group-grid></md-card>");
$templateCache.put("app/reportsBuilderKarcher/reportBuilderTableView/reportBuilderTableView.html","<md-table-container><table md-table=\"\" md-row-select=\"false\"><thead md-head=\"\"><tr md-row=\"\"><th md-column=\"\" ng-attr-md-numeric=\"$index > 0\" ng-repeat=\"column in vm.tableData.columnNames track by $index\"><span>{{ column }}</span></th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-style=\"{\'background\': $index % 2 === 0 ? \'white\' :\'whitesmoke\'}\" ng-repeat=\"item in vm.tableData.data\"><td md-cell=\"\" ng-repeat=\"(key, value) in item track by $index\">{{ value }}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.tablePageSize\" md-page=\"vm.tablePage\" md-options=\"vm.tablePageOptions\" md-label=\"{{vm.pagerTranslations}}\" md-total=\"{{vm.tableData.totalElements}}\" md-page-select=\"true\" md-boundary-links=\"true\" md-on-paginate=\"vm.pageChanged\"></md-table-pagination>");
$templateCache.put("app/transactions/expenses/expensesTransactions.html","<md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span>{{::\'EXPENSES_LIST\' | translate}}</span></div></md-toolbar><form name=\"expensesTransactionsForm\" ng-submit=\"vm.search()\" novalidate=\"\" layout=\"\" flex=\"\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\" layout-margin=\"\"><md-input-container class=\"md-block\"><label>{{::\'FROM\' | translate}}</label><md-datepicker ng-model=\"vm.expensesFrom\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-max-date=\"vm.expensesTo\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-align=\"start start\" layout-margin=\"\"><md-input-container class=\"md-block\"><label>{{::\'TO\' | translate}}</label><md-datepicker ng-model=\"vm.expensesTo\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-min-date=\"vm.expensesFrom\" ng-change=\"vm.toDateSelected()\"></md-datepicker></md-input-container></div><md-button class=\"md-raised searchButton\" type=\"submit\" ng-disabled=\"vm.disableSearch\">{{ \"SEARCH\" | translate }}</md-button></form><br><md-divider></md-divider><br><md-table-container><table md-table=\"\" multiple=\"\" ng-model=\"vm.selectedExpensesTransaction\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.expensesTransactionOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"companyName\">{{::\'COMPANY_NAME\' | translate}}</th><th md-column=\"\" md-order-by=\"facilityName\">{{::\'FACILITY_NAME\' | translate}}</th><th md-column=\"\" md-order-by=\"amount\">{{::\'TOKEN_NUMBER\' | translate}}</th><th md-column=\"\">{{::\'TOKEN_TYPE\' | translate}}</th><th md-column=\"\" md-order-by=\"timestamp\">{{::\'DATE\' | translate}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"expense in vm.expenses track by $index\"><td md-cell=\"\">{{ expense.companyName }}</td><td md-cell=\"\">{{ expense.facilityName }}</td><td md-cell=\"\">{{ expense.money.amount }}</td><td md-cell=\"\">{{ expense.money.code | tokensFilter | translate }}</td><td md-cell=\"\">{{ expense.timeStamp | date: shortDate }}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.expensesTransactionPageSize\" md-options=\"vm.expensesTransactionPageOptions\" md-page=\"vm.expensesTransactionPage\" md-total=\"{{vm.expensesTransactionTotal}}\" md-label=\"{{vm.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\" md-page-select=\"true\" md-boundary-links=\"true\"></md-table-pagination>");
$templateCache.put("app/transactions/topups/topupsTransactions.html","<md-toolbar class=\"md-table-toolbar md-default\"><div class=\"md-toolbar-tools\"><span>{{::\'TOPUPS_LIST\' | translate}}</span></div></md-toolbar><form name=\"topupsTransactionsForm\" ng-submit=\"vm.search()\" novalidate=\"\" layout=\"\" flex=\"\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\" layout-margin=\"\"><md-input-container class=\"md-block\"><label>{{::\'FROM\' | translate}}</label><md-datepicker ng-model=\"vm.topupsFrom\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-max-date=\"vm.topupsTo\"></md-datepicker></md-input-container></div><div layout=\"column\" layout-align=\"start start\" layout-margin=\"\"><md-input-container class=\"md-block\"><label>{{::\'TO\' | translate}}</label><md-datepicker ng-model=\"vm.topupsTo\" md-open-on-focus=\"\" md-placeholder=\"{{::\'ENTER_DATE_PLACEHOLDER\' | translate}}\" md-min-date=\"vm.topupsFrom\" ng-change=\"vm.toDateSelected()\"></md-datepicker></md-input-container></div><md-button class=\"md-raised searchButton\" type=\"submit\" ng-disabled=\"vm.disableSearch\">{{ \"SEARCH\" | translate }}</md-button></form><br><md-divider></md-divider><br><md-table-container><table md-table=\"\" multiple=\"\" ng-model=\"vm.selectedTopupsTransaction\" md-progress=\"vm.promise\"><thead md-head=\"\" md-order=\"vm.topupsTransactionOrderBy\" md-on-reorder=\"vm.sortChanged\"><tr md-row=\"\"><th md-column=\"\" md-order-by=\"companyName\">{{::\'COMPANY_NAME\' | translate}}</th><th md-column=\"\" md-order-by=\"description\">{{::\'DESCRIPTION\' | translate}}</th><th md-column=\"\" md-order-by=\"voucherCode\">{{::\'VOUCHER_CODE\' | translate}}</th><th md-column=\"\">{{::\'TOKEN_NUMBER\' | translate}}</th><th md-column=\"\">{{::\'TOKEN_TYPE\' | translate}}</th><th md-column=\"\" md-order-by=\"timestamp\">{{::\'DATE\' | translate}}</th></tr></thead><tbody md-body=\"\"><tr md-row=\"\" ng-repeat=\"topup in vm.topups track by $index\"><p ng-if=\"vm.topups.length < 1\">{{::\'NOTHING_TO_DISPLAY\' | translate}}</p><td md-cell=\"\">{{ topup.companyName }}</td><td md-cell=\"\">{{ topup.description }}</td><td md-cell=\"\">{{ topup.voucherCode }}</td><td md-cell=\"\">{{ topup.money.amount }}</td><td md-cell=\"\">{{ topup.money.code | tokensFilter | translate }}</td><td md-cell=\"\">{{ topup.timeStamp | date: shortDate }}</td></tr></tbody></table></md-table-container><md-table-pagination md-limit=\"vm.topupsTransactionPageSize\" md-options=\"vm.topupsTransactionPageOptions\" md-page=\"vm.topupsTransactionPage\" md-total=\"{{vm.topupsTransactionTotal}}\" md-label=\"{{vm.pagerTranslations}}\" md-on-paginate=\"vm.pageChanged\" md-page-select=\"true\" md-boundary-links=\"true\"></md-table-pagination>");
$templateCache.put("app/workingSchedulesAndHolidays/holidays/holidays.html","<div class=\"paddingAll30\" ng-if=\"vm.holidayList.length === 0 || !vm.holidayList\">{{ \'NOTHING_TO_DISPLAY\' | translate }}</div><div flex=\"\" class=\"paddingAll30 noPaddingTop\" ng-if=\"vm.holidayList.length !== 0 && vm.holidayList\"><form novalidate=\"\" name=\"siteHolidaysForm\" ng-submit=\"vm.saveHolidays()\" ng-cloak=\"\"><div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" class=\"fullWidth marginTop20\"><div flex=\"90\"></div><md-icon flex=\"5\" aria-label=\"Reset holiday inputs\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" class=\"cursorPointer\" ng-click=\"vm.resetHolidayInputs(siteHolidaysForm)\"><md-tooltip hide-xs=\"\">{{::\'RESET_INPUTS\' | translate}}</md-tooltip></md-icon><md-icon flex=\"\" aria-label=\"Delete all holidays for selected site\" md-svg-src=\"assets/icons/ic_delete_forever_black_24px.svg\" class=\"cursorPointer\" ng-click=\"vm.deleteAllHolidays($event)\"><md-tooltip hide-xs=\"\">{{::\'DELETE_ALL_HOLIDAYS\' | translate}}</md-tooltip></md-icon></div></div><div class=\"paddingAll10 noPaddingRight\"><p class=\"holidays-subtitle-wrapper\">{{ \'ADD_NEW_HOLIDAY\' | translate }}</p><div layout=\"row\" layout-align=\"start center\" class=\"marginLeft1\"><md-input-container flex=\"20\"><label>{{\'DATE\' | translate}}</label> <input ng-model=\"vm.holidatDate\" name=\"holidayDate\" type=\"text\" required=\"\" ng-pattern=\"/^(0[1-9]|[12]\\d|3[01])-(0[1-9]|1[0-2])$/\"><div ng-messages=\"siteHolidaysForm.holidayDate.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{\'VALIDATION_HOLIDAY_DATE\' | translate}}</div></div></md-input-container><md-input-container flex=\"20\" class=\"marginLeft1\"><label>{{\'YEAR\' | translate}}</label> <input ng-model=\"vm.holidayYear\" name=\"holidayYear\" type=\"text\" ng-required=\"!vm.holidayFixed\" ng-pattern=\"/^\\d{4}$/\"><div ng-messages=\"siteHolidaysForm.holidayYear.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"pattern\">- {{\'VALIDATION_HOLIDAY_YEAR\' | translate}}</div></div></md-input-container><md-input-container class=\"md-block marginLeft1\" flex=\"50\"><label>{{ \"DESCRIPTION\" | translate}}</label> <textarea ng-model=\"vm.holidayDescription\" name=\"holidayDescription\" md-maxlength=\"150\" rows=\"1\" md-select-on-focus=\"\"></textarea></md-input-container><div class=\"marginLeft1\"><md-checkbox flex=\"\" ng-model=\"vm.holidayFixed\" ng-change=\"vm.resetYearInput()\" name=\"holidayFixed\" aria-label=\"Apply to every year in future\"><span>{{ \'EVERY_YEAR\' | translate }}</span></md-checkbox></div></div><div layout=\"row\" layout-align=\"center center\"><div flex=\"70\"></div><md-button type=\"submit\" flex=\"\" class=\"md-raised md-primary standard-button-advanced-styling\" ng-disabled=\"siteHolidaysForm.$invalid\" aria-label=\"Save holidays\">{{::\'SAVE\' | translate}}</md-button></div></div><div class=\"paddingAll10 noPaddingRight\"><p class=\"holidays-subtitle-wrapper\">{{ \'HOLIDAYS_LIST\' | translate }}</p><div ng-repeat=\"holiday in vm.holidayList.siteHolidayDtoList\" layout=\"column\" layout-align=\"start center\" class=\"holiday-list-wrapper\"><div layout=\"row\" layout-align=\"start center\" class=\"fullWidth cursorPointer\" ng-click=\"vm.updateHoliday(holiday)\"><div class=\"holiday-list-description-wrapper\" flex=\"10\"><p class=\"smallerText\"><span class=\"boldText paddingRight10\">{{ \"DAY\" | translate }}:</span> {{ holiday.date }}</p></div><div class=\"holiday-list-description-wrapper\" flex=\"10\"><p class=\"smallerText\"><span class=\"boldText paddingRight10\">{{ \"YEAR\" | translate }}:</span> {{ !holiday.fixed ? holiday.year : \'EVERY_YEAR\' | translate }}</p></div><div class=\"holiday-list-description-wrapper\" flex=\"70\"><p class=\"smallerText\"><span class=\"boldText paddingRight10\">{{ \"DESCRIPTION\" | translate }}:</span> <span class=\"holiday-description-wrapper\">{{ holiday.description }}</span></p></div><md-icon aria-label=\"Delete holiday\" md-svg-src=\"assets/icons/ic_delete_forever_black_24px.svg\" class=\"cursorPointer edit-actuators-icon delete-holiday-item-wrapper\" ng-click=\"vm.deleteHoliday($event, holiday)\"><md-tooltip hide-xs=\"\">{{::\'DELETE_HOLIDAY\' | translate}}</md-tooltip></md-icon></div></div></div></form></div>");
$templateCache.put("app/workingSchedulesAndHolidays/siteDetails/siteDetails.html","<div class=\"md-padding\" flex=\"\"><div layout=\"column\" layout-align=\"center center\"><div><img ngf-thumbnail=\"vm.file || vm.imageLink || \'/assets/images/noun_59149_cc.svg\'\" style=\"width: 200px\"></div><div layout=\"row\" ng-if=\"vm.siteId\"><md-button ngf-select=\"\" ng-model=\"vm.file\" name=\"file\" ngf-pattern=\"\'image/*\'\" ngf-accept=\"\'image/png\'\" ngf-max-size=\"2MB\">{{::\'SELECT\' | translate}}</md-button><md-button ng-click=\"vm.submitImage()\" class=\"md-primary\">{{::\'UPLOAD\' | translate}}</md-button></div></div><form novalidate=\"\" name=\"siteForm\" ng-submit=\"vm.siteSaveDetails()\"><div id=\"facilityInfoContainer\" layout=\"\" layout-padding=\"\" layout-xs=\"column\"><div layout=\"column\" flex=\"\"><md-input-container><label>{{::\'COMPANY\' | translate}}</label> <input ng-model=\"vm.companyId\" name=\"companyId\" disabled=\"\"></md-input-container><md-input-container style=\"margin-top: 42px\"><label>{{::\'NAME\' | translate}}</label> <input ng-model=\"vm.name\" name=\"siteName\" disabled=\"\"><div ng-messages=\"siteForm.siteName.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div></div></md-input-container><div layout=\"\"><md-input-container flex=\"\"><label>{{\'LOCATION\' | translate}} (lat)</label> <input ng-model=\"vm.siteLocationLat\" ng-pattern=\"/^-?([0-8]?[0-9]|90)(\\.[0-9]{1,10})$/\" name=\"siteLati\" required=\"\"><div ng-messages=\"siteForm.siteLati.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div flex=\"\" ng-message=\"pattern\">- {{\'LOCATION_VALIDATION\' | translate}}</div></div></md-input-container><md-input-container flex=\"\"><label>{{\'LOCATION\' | translate}} (long)</label> <input ng-model=\"vm.siteLocationLong\" ng-pattern=\"/^-?([0-9]{1,2}|1[0-7][0-9]|180)(\\.[0-9]{1,10})$/\" name=\"siteLongi\" required=\"\"><div ng-messages=\"siteForm.siteLongi.$error\" role=\"alert\"><div ng-message=\"required\">{{ \"VALIDATION_REQUIRED\" | translate }}</div><div flex=\"\" ng-message=\"pattern\">- {{\'LOCATION_VALIDATION\' | translate}}</div></div></md-input-container></div><md-input-container><label>{{::\'ADDRESS\' | translate}}</label> <input ng-model=\"vm.siteAddress\" name=\"siteAddress\"></md-input-container></div><div layout=\"column\" flex=\"\"><md-input-container><label>{{\'PHONE\' | translate}} 1</label> <input ng-model=\"vm.sitePhone1\" name=\"sitePhone1\"></md-input-container><md-input-container><label>{{\'PHONE\' | translate}} 2</label> <input ng-model=\"vm.sitePhone2\" name=\"sitePhone2\" disabled=\"\"></md-input-container><md-input-container><label>{{\'WEBSITE\' | translate}}</label> <input ng-model=\"vm.siteWebsite\" name=\"siteWebsite\"></md-input-container><div layout=\"\"><md-input-container class=\"md-block\"><md-checkbox ng-model=\"vm.hasChanger\" name=\"siteHasChanger\" disabled=\"\" aria-label=\"Has changer\">{{\'FACILITY_HAS_CHANGER\' | translate}}</md-checkbox></md-input-container><md-input-container class=\"md-block paddingLeft10\"><md-checkbox ng-model=\"vm.offlineAlarmsStatus\" name=\"siteOfflineAlarmStatus\" disabled=\"\" aria-label=\"Disable offline alarms\">{{\'DISABLE_OFFLINE_ALARM\' | translate}}</md-checkbox><md-tooltip hide-xs=\"\">{{\'DISABLE_OFFLINE_ALARM_TOOLTIP\' | translate}}</md-tooltip></md-input-container></div></div><div layout=\"column\" flex=\"\"><md-input-container><label>{{\'DESCRIPTION\' | translate}}</label> <textarea ng-model=\"vm.siteDescription\" name=\"siteDescription\" md-maxlength=\"512\" maxlength=\"512\" rows=\"5\" md-select-on-focus=\"\" style=\"height: 7.8em\">\n          </textarea></md-input-container><md-input-container><label>{{\'WORKING_HOURS\' | translate}}</label> <input ng-model=\"vm.siteWorkingHours\" disabled=\"\" name=\"siteWorkingHours\"></md-input-container></div></div><div layout=\"row\" layout-align=\"space-between center\"><div></div><md-button type=\"submit\" flex=\"\" class=\"md-raised md-primary standard-button-advanced-styling\" ng-disabled=\"siteForm.$invalid\" aria-label=\"Save site details\">{{::\'SAVE\' | translate}}</md-button></div></form></div>");
$templateCache.put("app/workingSchedulesAndHolidays/workingSchedules/workingSchedules.html","<div ng-if=\"vm.scheduleList.length === 0 || !vm.scheduleList\" class=\"paddingAll30\">{{ \'NOTHING_TO_DISPLAY\' | translate }}</div><div flex=\"\" class=\"paddingAll30 noPaddingTop\" ng-if=\"vm.scheduleList.length !== 0 && vm.scheduleList\"><form novalidate=\"\" name=\"siteWorkingScheduleForm\" ng-submit=\"vm.updateSchedules()\" ng-cloak=\"\"><div ng-repeat=\"day in vm.scheduleList\" layout=\"row\" layout-align=\"start center\" class=\"paddingLeft20 marginTop20\"><md-input-container flex=\"\"><label>{{\'DAY\' | translate }}</label> <input ng-model=\"day.dayString\" type=\"text\" disabled=\"\"></md-input-container><md-input-container flex=\"\" class=\"marginLeft1\"><label>{{\'FROM_HOURS\' | translate}}</label> <input ng-model=\"day.hoursFrom\" type=\"number\" name=\"fromHours\" required=\"\" min=\"0\" max=\"23\" ng-disabled=\"vm.allDayCheckBoxData !== \'NONE\'\"><div ng-messages=\"siteWorkingScheduleForm.fromHours.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"min\">- {{\'NOT_MATCH\' | translate}}</div><div flex=\"\" ng-message=\"max\">- {{\'NOT_MATCH\' | translate}}</div></div></md-input-container><md-input-container flex=\"\" class=\"marginLeft1\"><label>{{\'FROM_MINUTES\' | translate}}</label> <input ng-model=\"day.minutesFrom\" type=\"number\" name=\"fromMinutes\" min=\"0\" max=\"59\" required=\"\" ng-disabled=\"vm.allDayCheckBoxData !== \'NONE\'\"><div ng-messages=\"siteWorkingScheduleForm.fromMinutes.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"min\">- {{\'NOT_MATCH\' | translate}}</div><div flex=\"\" ng-message=\"max\">- {{\'NOT_MATCH\' | translate}}</div></div></md-input-container><md-input-container flex=\"\" class=\"marginLeft1\"><label>{{\'TO_HOURS\' | translate}}</label> <input ng-model=\"day.hoursTo\" type=\"number\" name=\"toHours\" min=\"0\" max=\"23\" required=\"\" ng-disabled=\"vm.allDayCheckBoxData !== \'NONE\'\"><div ng-messages=\"siteWorkingScheduleForm.toHours.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"min\">- {{\'NOT_MATCH\' | translate}}</div><div flex=\"\" ng-message=\"max\">- {{\'NOT_MATCH\' | translate}}</div></div></md-input-container><md-input-container flex=\"\" class=\"marginLeft1\"><label>{{\'TO_MINUTES\' | translate}}</label> <input ng-model=\"day.minutesTo\" type=\"number\" name=\"toMinutes\" min=\"0\" max=\"59\" required=\"\" ng-disabled=\"vm.allDayCheckBoxData !== \'NONE\'\"><div ng-messages=\"siteWorkingScheduleForm.toMinutes.$error\" role=\"alert\" layout=\"column\" layout-align=\"center start\" ng-messages-multiple=\"\"><div flex=\"\" ng-message=\"required\">- {{::\'VALIDATION_REQUIRED\' | translate}}</div><div flex=\"\" ng-message=\"min\">- {{\'NOT_MATCH\' | translate}}</div><div flex=\"\" ng-message=\"max\">- {{\'NOT_MATCH\' | translate}}</div></div></md-input-container></div><div layout=\"row\" layout-align=\"center center\"><div flex-gt-md=\"40\" flex=\"30\"><md-input-container class=\"md-block\"><label>{{ \"ALL_DAY_HOURS_SELECTOR\" | translate }}</label><md-select ng-model=\"vm.allDayCheckBoxData\" required=\"\"><md-option value=\"NONE\">{{ \'INDIVIDUAL_TIME_SETTINGS_FOR_ACTUATE\' | translate }}</md-option><md-option value=\"OPEN\">{{ \'OPEN_24H\' | translate }}</md-option><md-option value=\"CLOSE\">{{ \'CLOSE_24H\' | translate }}</md-option></md-select></md-input-container></div><div flex=\"50\"></div><md-button flex-gt-md=\"10\" flex=\"20\" type=\"submit\" ng-disabled=\"siteWorkingScheduleForm.$invalid\" class=\"md-raised md-primary standard-button-advanced-styling\" aria-label=\"Update schedules\">{{::\'SAVE\' | translate}}</md-button></div></form></div>");
$templateCache.put("app/alarmsKarcher/alarmSubscriptions/createSubscriptionDialog/createSubscription.html","<div class=\"alarm-subscribe-dialog-wrapper\"><div class=\"alarm-subscribe-input-wrapper\"><div layout=\"row\" layout-align=\"space-between center\"><p flex=\"\">{{ \'SUBSCRIBE\' | translate }}</p><md-icon class=\"cursorPointer\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.closeSubscribeDialog()\"></md-icon></div><form name=\"subscribeToAlarmForm\" class=\"filterForm md-inline-form\" layout=\"column\" no-validate=\"\"><div flex=\"\"><md-input-container class=\"fullWidth\" flex=\"\"><label>{{::\'SITE_NAME\' | translate}}</label><md-select name=\"selectedSite\" ng-model=\"vm.selectedSite\" required=\"\" ng-change=\"vm.onSelectSite()\"><md-option ng-repeat=\"site in vm.siteList\" ng-value=\"site\">{{site.name | translate}}</md-option></md-select><div ng-messages=\"subscribeToAlarmForm.selectedSite.$error\" role=\"alert\" multiple=\"\"><div ng-message=\"required\">{{\'VALIDATION_REQUIRED\' | translate}}</div></div></md-input-container><div layout=\"row\" flex=\"\"><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearDeviceInput()\"></md-icon><md-input-container class=\"fullWidth\" flex=\"\"><label>{{::\'DEVICE_NAME\' | translate}}</label><md-select name=\"selectedDevice\" ng-model=\"vm.selectedDevice\" ng-change=\"vm.onSelectDevice()\" ng-disabled=\"vm.deviceListForSelectedSite.length === 0\"><md-option ng-repeat=\"device in vm.deviceListForSelectedSite\" ng-value=\"device.deviceId\">{{device.pointName}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex=\"\"><md-icon class=\"cursorPointer clear-site-button\" md-svg-src=\"assets/icons/ic_close_black_24px.svg\" ng-click=\"vm.clearFaultInput()\"></md-icon><multiply-items-selector list=\"vm.faultListForSelectedDevice\" enable-selector=\"false\" clear-site-text-input=\"vm.faultCode\" selected-list=\"vm.getFault(ids)\" validate-input=\"vm.validateMultiplyItemsInput(valid)\" flex=\"\"></multiply-items-selector></div><div layout=\"column\" layout-align=\"start start\"><md-checkbox ng-model=\"vm.lowAlarm\" ng-change=\"vm.onSelectCheckBox()\" name=\"lowAlarm\" aria-label=\"Checkbox 1\" ng-disabled=\"vm.faultCode\" class=\"successColor boldText500\">{{ \"LOW_ALARM\" | translate }}</md-checkbox><md-checkbox ng-model=\"vm.mediumAlarm\" ng-change=\"vm.onSelectCheckBox()\" name=\"mediumAlarm\" aria-label=\"Checkbox 1\" ng-disabled=\"vm.faultCode\" class=\"infoColor boldText500\">{{ \"MEDIUM_ALARM\" | translate }}</md-checkbox><md-checkbox ng-model=\"vm.highAlarm\" ng-change=\"vm.onSelectCheckBox()\" name=\"highAlarm\" aria-label=\"Checkbox 1\" ng-disabled=\"vm.faultCode\" class=\"warnColor boldText500\">{{ \"HIGH_ALARM\" | translate }}</md-checkbox></div></div><div layout=\"row\" layout-align=\"space-between center\"><div flex=\"60\"></div><md-button flex=\"\" class=\"md-raised primary-karcher-button\" ng-click=\"vm.subscribeData()\" aria-label=\"Subscribe\" ng-disabled=\"subscribeToAlarmForm.selectedSite.$invalid || vm.validateMultiplyItem\" ng-class=\"{\'primary-karcher-button-disabled\': subscribeToAlarmForm.selectedSite.$invalid || vm.validateMultiplyItem}\">{{::\'SUBSCRIBE\' | translate}}</md-button></div></form></div></div>");
$templateCache.put("app/reports/avgByBoxReport/byBoxComponent/byBox.html","<md-card><md-card-title class=\"reportTitle\" ng-if=\"vm.report.data.isChartVisible\"><md-card-title-text><div class=\"md-caption\">{{ vm.report.data.title | translate }}</div><div class=\"md-headline\">{{vm.report.data.unit}} {{ vm.report.data.total}}</div></md-card-title-text></md-card-title><md-card-content><line-chart options=\"vm.report\" left-padding=\"120\" sub-chart=\"false\" chart-id=\"{{vm.report.chartName}}\" ng-if=\"vm.report.data.isChartVisible\"></line-chart><div id=\"chartDataMissingContainer\" ng-if=\"!vm.report.data.isChartVisible\"><md-icon md-svg-src=\"assets/icons/ic_sentiment_very_satisfied_black_24px.svg\"></md-icon><span>{{::\'DATA_NOT_AVAILABLE\' | translate}}</span></div></md-card-content><md-divider ng-if=\"vm.report.data.isChartVisible\"></md-divider><md-card-actions layout=\"row\" layout-align=\"end center\" ng-if=\"vm.report.data.isChartVisible\"><md-button class=\"md-raised\" ng-click=\"vm.exportToCsv()\">{{::\'DOWNLOAD_CSV\' | translate}}</md-button></md-card-actions></md-card><md-card ng-if=\"vm.report.data.isChartVisible\"><facilities-group-grid options=\"vm.report\" show-pagination=\"true\" group-label=\"{{::\'BOX\' | translate}}\"></facilities-group-grid></md-card>");}]);